/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/vk-apps-tensorflow-example/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 124);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(3)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    Buffer = __webpack_require__(206).Buffer;
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
    }

    if (base === 16) {
      this._parseHex(number, start);
    } else {
      this._parseBase(number, base, start);
    }

    if (number[0] === '-') {
      this.negative = 1;
    }

    this.strip();

    if (endian !== 'le') return;

    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex (str, start, end) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r <<= 4;

      // 'a' - 'f'
      if (c >= 49 && c <= 54) {
        r |= c - 49 + 0xa;

      // 'A' - 'F'
      } else if (c >= 17 && c <= 22) {
        r |= c - 17 + 0xa;

      // '0' - '9'
      } else {
        r |= c & 0xf;
      }
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    // Scan 24-bit chunks and add them to the number
    var off = 0;
    for (i = number.length - 6, j = 0; i >= start; i -= 6) {
      w = parseHex(number, i, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      off += 24;
      if (off >= 26) {
        off -= 26;
        j++;
      }
    }
    if (i + 6 !== start) {
      w = parseHex(number, start, i + 6);
      this.words[j] |= (w << off) & 0x3ffffff;
      this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
    }
    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      r.strip();
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(205)(module)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(168)
var ieee754 = __webpack_require__(169)
var isArray = __webpack_require__(87)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = exports;

elliptic.version = __webpack_require__(212).version;
elliptic.utils = __webpack_require__(213);
elliptic.rand = __webpack_require__(109);
elliptic.curve = __webpack_require__(39);
elliptic.curves = __webpack_require__(218);

// Protocols
elliptic.ec = __webpack_require__(226);
elliptic.eddsa = __webpack_require__(230);


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(66)('wks');
var uid = __webpack_require__(30);
var Symbol = __webpack_require__(9).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(6);
var inherits = __webpack_require__(0);

exports.inherits = inherits;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi)
          res.push(hi, lo);
        else
          res.push(lo);
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;


/***/ }),
/* 9 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 10 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(1).Buffer
var Transform = __webpack_require__(50).Transform
var StringDecoder = __webpack_require__(54).StringDecoder
var inherits = __webpack_require__(0)

function CipherBase (hashMode) {
  Transform.call(this)
  this.hashMode = typeof hashMode === 'string'
  if (this.hashMode) {
    this[hashMode] = this._finalOrDigest
  } else {
    this.final = this._finalOrDigest
  }
  if (this._final) {
    this.__final = this._final
    this._final = null
  }
  this._decoder = null
  this._encoding = null
}
inherits(CipherBase, Transform)

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
  if (typeof data === 'string') {
    data = Buffer.from(data, inputEnc)
  }

  var outData = this._update(data)
  if (this.hashMode) return this

  if (outputEnc) {
    outData = this._toString(outData, outputEnc)
  }

  return outData
}

CipherBase.prototype.setAutoPadding = function () {}
CipherBase.prototype.getAuthTag = function () {
  throw new Error('trying to get auth tag in unsupported state')
}

CipherBase.prototype.setAuthTag = function () {
  throw new Error('trying to set auth tag in unsupported state')
}

CipherBase.prototype.setAAD = function () {
  throw new Error('trying to set aad in unsupported state')
}

CipherBase.prototype._transform = function (data, _, next) {
  var err
  try {
    if (this.hashMode) {
      this._update(data)
    } else {
      this.push(this._update(data))
    }
  } catch (e) {
    err = e
  } finally {
    next(err)
  }
}
CipherBase.prototype._flush = function (done) {
  var err
  try {
    this.push(this.__final())
  } catch (e) {
    err = e
  }

  done(err)
}
CipherBase.prototype._finalOrDigest = function (outputEnc) {
  var outData = this.__final() || Buffer.alloc(0)
  if (outputEnc) {
    outData = this._toString(outData, outputEnc, true)
  }
  return outData
}

CipherBase.prototype._toString = function (value, enc, fin) {
  if (!this._decoder) {
    this._decoder = new StringDecoder(enc)
    this._encoding = enc
  }

  if (this._encoding !== enc) throw new Error('can\'t switch encodings')

  var out = this._decoder.write(value)
  if (fin) {
    out += this._decoder.end()
  }

  return out
}

module.exports = CipherBase


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(31)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(36);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__(25);
util.inherits = __webpack_require__(0);
/*</replacement>*/

var Readable = __webpack_require__(89);
var Writable = __webpack_require__(53);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var hide = __webpack_require__(17);
var has = __webpack_require__(20);
var SRC = __webpack_require__(30)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(15).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(18);
var createDesc = __webpack_require__(42);
module.exports = __webpack_require__(13) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(19);
var IE8_DOM_DEFINE = __webpack_require__(68);
var toPrimitive = __webpack_require__(70);
var dP = Object.defineProperty;

exports.f = __webpack_require__(13) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 20 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = __webpack_require__(1).Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > 65536) throw new Error('requested too many random bytes')
  // in case browserify  isn't using the Uint8Array version
  var rawBytes = new global.Uint8Array(size)

  // This will not work in older browsers.
  // See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
  if (size > 0) {  // getRandomValues fails on IE if size == 0
    crypto.getRandomValues(rawBytes)
  }

  // XXX: phantomjs doesn't like a buffer being passed here
  var bytes = Buffer.from(rawBytes.buffer)

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(10)))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(1).Buffer

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(0)
var MD5 = __webpack_require__(49)
var RIPEMD160 = __webpack_require__(55)
var sha = __webpack_require__(56)
var Base = __webpack_require__(12)

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var assert = __webpack_require__(6);

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = exports;

asn1.bignum = __webpack_require__(2);

asn1.define = __webpack_require__(234).define;
asn1.base = __webpack_require__(29);
asn1.constants = __webpack_require__(115);
asn1.decoders = __webpack_require__(240);
asn1.encoders = __webpack_require__(242);


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var base = exports;

base.Reporter = __webpack_require__(237).Reporter;
base.DecoderBuffer = __webpack_require__(114).DecoderBuffer;
base.EncoderBuffer = __webpack_require__(114).EncoderBuffer;
base.Node = __webpack_require__(238);


/***/ }),
/* 30 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(133);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(137);
var defined = __webpack_require__(44);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(157);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, global, setImmediate, Buffer) {/* unused harmony export setBackend */
/* unused harmony export getBackend */
/* unused harmony export disposeVariables */
/* unused harmony export memory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return nextFrame; });
/* unused harmony export environment */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return io; });
/* unused harmony export math */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return serialization; });
/* unused harmony export test_util */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return util; });
/* unused harmony export webgl */
/* unused harmony export AdadeltaOptimizer */
/* unused harmony export AdagradOptimizer */
/* unused harmony export AdamOptimizer */
/* unused harmony export AdamaxOptimizer */
/* unused harmony export MomentumOptimizer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Optimizer; });
/* unused harmony export RMSPropOptimizer */
/* unused harmony export SGDOptimizer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Tensor; });
/* unused harmony export TensorBuffer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return variable; });
/* unused harmony export Variable */
/* unused harmony export Rank */
/* unused harmony export Reduction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENV; });
/* unused harmony export Environment */
/* unused harmony export KernelBackend */
/* unused harmony export DataStorage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return image_ops; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return linalg_ops; });
/* unused harmony export losses */
/* unused harmony export spectral */
/* unused harmony export op */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return batchNormalization2d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return batchNormalization3d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return batchNormalization4d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return batchNormalization; });
/* unused harmony export complex */
/* unused harmony export real */
/* unused harmony export imag */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return concat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return concat1d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return concat2d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return concat3d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return concat4d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return split$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return conv1d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return conv2d; });
/* unused harmony export conv2dDerFilter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return depthwiseConv2d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return separableConv2d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return conv2dTranspose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return matMul; });
/* unused harmony export dot */
/* unused harmony export outerProduct */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return reverse; });
/* unused harmony export reverse1d */
/* unused harmony export reverse2d */
/* unused harmony export reverse3d */
/* unused harmony export reverse4d */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return maxPool; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return avgPool; });
/* unused harmony export pool */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return slice1d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return slice2d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return slice3d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return slice4d; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return acos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return acosh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return asin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return asinh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return atan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return atanh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return ceil; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return clipByValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return cosh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return erf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return exp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return expm1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return floor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return log$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return log1p; });
/* unused harmony export logSigmoid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return neg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return reciprocal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return round; });
/* unused harmony export rsqrt */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return sigmoid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return sign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return sinh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return softplus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return square; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return step; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return tan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return tanh$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return all; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return any; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return argMax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return argMin; });
/* unused harmony export logSumExp */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return mean; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return moments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return sum$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return prod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return equal; });
/* unused harmony export equalStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return greater; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return greaterEqual; });
/* unused harmony export greaterEqualStrict */
/* unused harmony export greaterStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return less; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return lessEqual; });
/* unused harmony export lessEqualStrict */
/* unused harmony export lessStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return notEqual; });
/* unused harmony export notEqualStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return add; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return addN; });
/* unused harmony export addStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return div; });
/* unused harmony export divStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return floorDiv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return maximum; });
/* unused harmony export maximumStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return minimum; });
/* unused harmony export minimumStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return mod; });
/* unused harmony export modStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return mul; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return mulStrict; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return pow; });
/* unused harmony export powStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return squaredDifference; });
/* unused harmony export squaredDifferenceStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return sub; });
/* unused harmony export subStrict */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return elu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return leakyRelu; });
/* unused harmony export prelu */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return relu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return selu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return logicalAnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return logicalNot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return logicalOr; });
/* unused harmony export logicalXor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return where; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return whereAsync; });
/* unused harmony export buffer */
/* unused harmony export toPixels */
/* unused harmony export print */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return batchToSpaceND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return cast; });
/* unused harmony export clone */
/* unused harmony export cumsum */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return depthToSpace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return expandDims; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return eye; });
/* unused harmony export fromPixels */
/* unused harmony export multinomial */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return oneHot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return pad; });
/* unused harmony export pad1d */
/* unused harmony export pad2d */
/* unused harmony export pad3d */
/* unused harmony export pad4d */
/* unused harmony export rand */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return randomNormal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return randomUniform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return reshape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return spaceToBatchND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return squeeze; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return stack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return tile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return truncatedNormal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return unstack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return setdiff1dAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return fill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return linspace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return ones$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return range; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return scalar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return tensor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return tensor1d; });
/* unused harmony export tensor2d */
/* unused harmony export tensor3d */
/* unused harmony export tensor4d */
/* unused harmony export tensor5d */
/* unused harmony export tensor6d */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return zeros; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return onesLike; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return zerosLike; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return transpose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return softmax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return logSoftmax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return localResponseNormalization; });
/* unused harmony export norm */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return gather; });
/* unused harmony export unsortedSegmentSum */
/* unused harmony export basicLSTMCell */
/* unused harmony export multiRNNCell */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return movingAverage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return stridedSlice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return topk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return scatterND; });
/* unused harmony export fft */
/* unused harmony export ifft */
/* unused harmony export rfft */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return sparseToDense; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return gatherND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return train; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return tidy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return keep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return dispose; });
/* unused harmony export time */
/* unused harmony export profile */
/* unused harmony export customGrad */
/* unused harmony export grad */
/* unused harmony export grads */
/* unused harmony export valueAndGrad */
/* unused harmony export valueAndGrads */
/* unused harmony export variableGrads */
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
var extendStatics=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])};function __extends(e,t){function r(){this.constructor=e}extendStatics(e,t),e.prototype=null===t?Object.create(t):(r.prototype=t.prototype,new r)}var __assign=Object.assign||function(e){for(var t,r=1,n=arguments.length;r<n;r++)for(var o in t=arguments[r])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e};function __awaiter(e,t,r,n){return new(r||(r=Promise))(function(o,a){function i(e){try{u(n.next(e))}catch(e){a(e)}}function s(e){try{u(n.throw(e))}catch(e){a(e)}}function u(e){e.done?o(e.value):new r(function(t){t(e.value)}).then(i,s)}u((n=n.apply(e,t||[])).next())})}function __generator(e,t){var r,n,o,a,i={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return a={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(a[Symbol.iterator]=function(){return this}),a;function s(a){return function(s){return function(a){if(r)throw new TypeError("Generator is already executing.");for(;i;)try{if(r=1,n&&(o=2&a[0]?n.return:a[0]?n.throw||((o=n.return)&&o.call(n),0):n.next)&&!(o=o.call(n,a[1])).done)return o;switch(n=0,o&&(a=[2&a[0],o.value]),a[0]){case 0:case 1:o=a;break;case 4:return i.label++,{value:a[1],done:!1};case 5:i.label++,n=a[1],a=[0];continue;case 7:a=i.ops.pop(),i.trys.pop();continue;default:if(!(o=(o=i.trys).length>0&&o[o.length-1])&&(6===a[0]||2===a[0])){i=0;continue}if(3===a[0]&&(!o||a[1]>o[0]&&a[1]<o[3])){i.label=a[1];break}if(6===a[0]&&i.label<o[1]){i.label=o[1],o=a;break}if(o&&i.label<o[2]){i.label=o[2],i.ops.push(a);break}o[2]&&i.ops.pop(),i.trys.pop();continue}a=t.call(e,i)}catch(e){a=[6,e],n=0}finally{r=o=0}if(5&a[0])throw a[1];return{value:a[0]?a[1]:void 0,done:!0}}([a,s])}}}var contexts={},WEBGL_ATTRIBUTES={alpha:!1,antialias:!1,premultipliedAlpha:!1,preserveDrawingBuffer:!1,depth:!1,stencil:!1,failIfMajorPerformanceCaveat:!0};function getWebGLContext(e){e in contexts||(document.createElement("canvas").addEventListener("webglcontextlost",function(t){t.preventDefault(),delete contexts[e]},!1),contexts[e]=getWebGLRenderingContext(e));var t=contexts[e];return t.isContextLost()?(delete contexts[e],getWebGLContext(e)):(t.disable(t.DEPTH_TEST),t.disable(t.STENCIL_TEST),t.disable(t.BLEND),t.disable(t.DITHER),t.disable(t.POLYGON_OFFSET_FILL),t.disable(t.SAMPLE_COVERAGE),t.enable(t.SCISSOR_TEST),t.enable(t.CULL_FACE),t.cullFace(t.BACK),contexts[e])}function getWebGLRenderingContext(e){if(1!==e&&2!==e)throw new Error("Cannot get WebGL rendering context, WebGL is disabled.");var t=document.createElement("canvas");return 1===e?t.getContext("webgl",WEBGL_ATTRIBUTES)||t.getContext("experimental-webgl",WEBGL_ATTRIBUTES):t.getContext("webgl2",WEBGL_ATTRIBUTES)}function isMobile(){var e=navigator.userAgent||navigator.vendor||window.opera;return/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(e)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(e.substr(0,4))}function shuffle(e){for(var t=e.length,r=0,n=0;t>0;)n=Math.random()*t|0,r=e[--t],e[t]=e[n],e[n]=r}function clamp(e,t,r){return Math.max(e,Math.min(t,r))}function nearestLargerEven(e){return e%2==0?e:e+1}function sum(e){for(var t=0,r=0;r<e.length;r++)t+=e[r];return t}function randUniform(e,t){var r=Math.random();return t*r+(1-r)*e}function distSquared(e,t){for(var r=0,n=0;n<e.length;n++){var o=Number(e[n])-Number(t[n]);r+=o*o}return r}function assert(e,t){if(!e)throw new Error("string"==typeof t?t:t())}function assertShapesMatch(e,t,r){void 0===r&&(r=""),assert(arraysEqual(e,t),r+" Shapes "+e+" and "+t+" must match")}function assertNonNull(e){assert(null!=e,"The input to the tensor constructor must be a non-null value.")}function flatten(e,t){if(void 0===t&&(t=[]),Array.isArray(e))for(var r=0;r<e.length;++r)flatten(e[r],t);else t.push(e);return t}function sizeFromShape(e){if(0===e.length)return 1;for(var t=e[0],r=1;r<e.length;r++)t*=e[r];return t}function isScalarShape(e){return 0===e.length}function arraysEqual(e,t){if(e===t)return!0;if(null==e||null==t)return!1;if(e.length!==t.length)return!1;for(var r=0;r<e.length;r++)if(e[r]!==t[r])return!1;return!0}function isInt(e){return e%1==0}function tanh(e){if(null!=Math.tanh)return Math.tanh(e);if(e===1/0)return 1;if(e===-1/0)return-1;var t=Math.exp(2*e);return(t-1)/(t+1)}function sizeToSquarishShape(e){for(var t=Math.floor(Math.sqrt(e));t>1;--t)if(e%t==0)return[t,e/t];return[1,e]}function createShuffledIndices(e){for(var t=new Uint32Array(e),r=0;r<e;++r)t[r]=r;return shuffle(t),t}function rightPad(e,t){return t<=e.length?e:e+" ".repeat(t-e.length)}function repeatedTry(e,t,r){return void 0===t&&(t=function(e){return 0}),new Promise(function(n,o){var a=0,i=function(){if(e())n();else{var s=t(++a);null!=r&&a>=r?o():setTimeout(i,s)}};i()})}function inferFromImplicitShape(e,t){for(var r=1,n=-1,o=0;o<e.length;++o)if(e[o]>=0)r*=e[o];else if(-1===e[o]){if(-1!==n)throw Error("Shapes can only have 1 implicit size. Found -1 at dim "+n+" and dim "+o);n=o}else if(e[o]<0)throw Error("Shapes can not be < 0. Found "+e[o]+" at dim "+o);if(-1===n){if(t>0&&t!==r)throw Error("Size("+t+") must match the product of shape "+e);return e}if(0===r)throw Error("Cannot infer the missing size in ["+e+"] when there are 0 elements");if(t%r!=0)throw Error("The implicit shape can't be a fractional number. Got "+t+" / "+r);var a=e.slice();return a[n]=t/r,a}function squeezeShape(e,t){for(var r=[],n=[],o=0,a=0;a<e.length;++a){if(null!=t){if(t[o]===a&&1!==e[a])throw new Error("Can't squeeze axis "+a+" since its dim '"+e[a]+"' is not 1");(null==t[o]||t[o]>a)&&1===e[a]&&(r.push(e[a]),n.push(a)),t[o]<=a&&o++}1!==e[a]&&(r.push(e[a]),n.push(a))}return{newShape:r,keptDims:n}}function getTypedArrayFromDType(e,t){var r=null;if(null==e||"float32"===e)r=new Float32Array(t);else if("int32"===e)r=new Int32Array(t);else{if("bool"!==e)throw new Error("Unknown data type "+e);r=new Uint8Array(t)}return r}function checkComputationForNaN(e,t,r){if("float32"===t)for(var n=0;n<e.length;n++)if(isNaN(e[n]))throw Error("The result of the '"+r+"' has NaNs.")}function checkConversionForNaN(e,t){if("float32"!==t)for(var r=0;r<e.length;r++)if(isNaN(e[r]))throw Error("NaN is not a valid value for dtype: '"+t+"'.")}function hasEncodingLoss(e,t){return"complex64"!==t&&(("float32"!==t||"complex64"===e)&&(("int32"!==t||"float32"===e||"complex64"===e)&&("bool"!==t||"bool"!==e)))}function copyTypedArray(e,t,r){if(null==t||"float32"===t||"complex64"===t)return new Float32Array(e);if("int32"===t)return r&&checkConversionForNaN(e,t),new Int32Array(e);if("bool"===t){for(var n=new Uint8Array(e.length),o=0;o<n.length;++o)0!==Math.round(e[o])&&(n[o]=1);return n}throw new Error("Unknown data type "+t)}function isTypedArray(e){return e instanceof Float32Array||e instanceof Int32Array||e instanceof Uint8Array}function bytesPerElement(e){if("float32"===e||"int32"===e)return 4;if("complex64"===e)return 8;if("bool"===e)return 1;throw new Error("Unknown dtype "+e)}function isFunction(e){return!!(e&&e.constructor&&e.call&&e.apply)}function nearestDivisor(e,t){for(var r=t;r<e;++r)if(e%r==0)return r;return e}function computeStrides(e){var t=e.length;if(t<2)return[];var r=new Array(t-1);r[t-2]=e[t-1];for(var n=t-3;n>=0;--n)r[n]=r[n+1]*e[n+1];return r}function toTypedArray(e,t,r){return noConversionNeeded(e,t)?e:(Array.isArray(e)&&(e=flatten(e)),copyTypedArray(e,t,r))}function noConversionNeeded(e,t){return e instanceof Float32Array&&"float32"===t||e instanceof Int32Array&&"int32"===t||e instanceof Uint8Array&&"bool"===t}function makeOnesTypedArray(e,t){for(var r=makeZerosTypedArray(e,t),n=0;n<r.length;n++)r[n]=1;return r}function makeZerosTypedArray(e,t){if(null==t||"float32"===t||"complex64"===t)return new Float32Array(e);if("int32"===t)return new Int32Array(e);if("bool"===t)return new Uint8Array(e);throw new Error("Unknown data type "+t)}function now(){if("undefined"!=typeof performance)return performance.now();if("undefined"!=typeof process){var e=process.hrtime();return 1e3*e[0]+e[1]/1e6}throw new Error("Cannot measure time in this environment. You should run tf.js in the browser or in Node.js")}var util=Object.freeze({shuffle:shuffle,clamp:clamp,nearestLargerEven:nearestLargerEven,sum:sum,randUniform:randUniform,distSquared:distSquared,assert:assert,assertShapesMatch:assertShapesMatch,assertNonNull:assertNonNull,flatten:flatten,sizeFromShape:sizeFromShape,isScalarShape:isScalarShape,arraysEqual:arraysEqual,isInt:isInt,tanh:tanh,sizeToSquarishShape:sizeToSquarishShape,createShuffledIndices:createShuffledIndices,rightPad:rightPad,repeatedTry:repeatedTry,inferFromImplicitShape:inferFromImplicitShape,squeezeShape:squeezeShape,getTypedArrayFromDType:getTypedArrayFromDType,checkComputationForNaN:checkComputationForNaN,checkConversionForNaN:checkConversionForNaN,hasEncodingLoss:hasEncodingLoss,isTypedArray:isTypedArray,bytesPerElement:bytesPerElement,isFunction:isFunction,nearestDivisor:nearestDivisor,computeStrides:computeStrides,toTypedArray:toTypedArray,makeOnesTypedArray:makeOnesTypedArray,makeZerosTypedArray:makeZerosTypedArray,now:now}),Profiler=function(){function e(e,t){this.backendTimer=e,this.logger=t,null==t&&(this.logger=new Logger)}return e.prototype.profileKernel=function(e,t){var r,n=this,o=this.backendTimer.time(function(){r=t()});return(Array.isArray(r)?r:[r]).forEach(function(t){var r=t.dataSync();checkComputationForNaN(r,t.dtype,e),o.then(function(o){var a="";null!=o.getExtraProfileInfo&&(a=o.getExtraProfileInfo()),n.logger.logKernelProfile(e,t,r,o.kernelMs,a)})}),r},e}(),Logger=function(){function e(){}return e.prototype.logKernelProfile=function(e,t,r,n,o){var a=rightPad(n+"ms",9),i=rightPad(e,25),s=t.rank,u=t.size,l=rightPad(t.shape.toString(),14);console.log("%c"+i+"\t%c"+a+"\t%c"+s+"D "+l+"\t%c"+u+"\t%c"+o,"font-weight:bold","color:red","color:blue","color: orange","color: green")},e}(),FORMAT_LIMIT_NUM_VALS=20,FORMAT_NUM_FIRST_LAST_VALS=3,FORMAT_NUM_SIG_DIGITS=7;function tensorToString(e,t,r,n){var o=computeStrides(t),a=computeMaxSizePerColumn(e,t,r,o),i=t.length,s=subTensorToString(e,t,r,o,a),u=["Tensor"];return n&&(u.push("  dtype: "+r),u.push("  rank: "+i),u.push("  shape: ["+t+"]"),u.push("  values:")),u.push(s.map(function(e){return"    "+e}).join("\n")),u.join("\n")}function computeMaxSizePerColumn(e,t,r,n){var o=sizeFromShape(t),a=n[n.length-1],i=new Array(a).fill(0),s=t.length,u="complex64"===r?createComplexTuples(e):e;if(s>1)for(var l=0;l<o/a;l++)for(var c=l*a,p=0;p<a;p++)i[p]=Math.max(i[p],valToString(u[c+p],0).length);return i}function valToString(e,t){return rightPad(Array.isArray(e)?parseFloat(e[0].toFixed(FORMAT_NUM_SIG_DIGITS))+" + "+parseFloat(e[1].toFixed(FORMAT_NUM_SIG_DIGITS))+"j":parseFloat(e.toFixed(FORMAT_NUM_SIG_DIGITS)).toString(),t)}function subTensorToString(e,t,r,n,o,a){void 0===a&&(a=!0);var i="complex64"===r?2:1,s=t[0],u=t.length;if(0===u)return"complex64"===r?[valToString(createComplexTuples(e)[0],0)]:[e[0].toString()];if(1===u){if(s>FORMAT_LIMIT_NUM_VALS){var l=FORMAT_NUM_FIRST_LAST_VALS*i,c=Array.from(e.subarray(0,l)),p=Array.from(e.subarray(s-FORMAT_NUM_FIRST_LAST_VALS*i,s));return"complex64"===r&&(c=createComplexTuples(c),p=createComplexTuples(p)),["["+c.map(function(e,t){return valToString(e,o[t])}).join(", ")+", ..., "+p.map(function(e,t){return valToString(e,o[s-FORMAT_NUM_FIRST_LAST_VALS+t])}).join(", ")+"]"]}return["["+("complex64"===r?createComplexTuples(e):Array.from(e)).map(function(e,t){return valToString(e,o[t])}).join(", ")+"]"]}var d=t.slice(1),h=n.slice(1),f=n[0]*i,m=[];if(s>FORMAT_LIMIT_NUM_VALS){for(var g=0;g<FORMAT_NUM_FIRST_LAST_VALS;g++){var v=(y=g*f)+f;m.push.apply(m,subTensorToString(e.subarray(y,v),d,r,h,o,!1))}m.push("...");for(g=s-FORMAT_NUM_FIRST_LAST_VALS;g<s;g++){v=(y=g*f)+f;m.push.apply(m,subTensorToString(e.subarray(y,v),d,r,h,o,g===s-1))}}else for(g=0;g<s;g++){var y;v=(y=g*f)+f;m.push.apply(m,subTensorToString(e.subarray(y,v),d,r,h,o,g===s-1))}var x=2===u?",":"";m[0]="["+m[0]+x;for(g=1;g<m.length-1;g++)m[g]=" "+m[g]+x;var T=",\n";for(g=2;g<u;g++)T+="\n";return m[m.length-1]=" "+m[m.length-1]+"]"+(a?"":T),m}function createComplexTuples(e){for(var t=[],r=0;r<e.length;r+=2)t.push([e[r],e[r+1]]);return t}var TensorBuffer=function(){function e(e,t,r){if(this.dtype=t,this.shape=e.slice(),this.size=sizeFromShape(e),null!=r){var n=r.length;assert(n===this.size,"Length of values '"+n+"' does not match the size inferred by the shape '"+this.size+"'.")}if("complex64"===t)throw new Error("complex64 dtype TensorBuffers are not supported. Please create a TensorBuffer for the real and imaginary parts separately and call tf.complex(real, imag).");this.values=r||getTypedArrayFromDType(t,sizeFromShape(this.shape)),this.strides=computeStrides(e)}return e.prototype.set=function(e){for(var t=[],r=1;r<arguments.length;r++)t[r-1]=arguments[r];0===t.length&&(t=[0]),assert(t.length===this.rank,"The number of provided coordinates ("+t.length+") must match the rank ("+this.rank+")");var n=this.locToIndex(t);this.values[n]=e},e.prototype.get=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];0===e.length&&(e=[0]);for(var r=e[e.length-1],n=0;n<e.length-1;++n)r+=this.strides[n]*e[n];return this.values[r]},e.prototype.locToIndex=function(e){if(0===this.rank)return 0;if(1===this.rank)return e[0];for(var t=e[e.length-1],r=0;r<e.length-1;++r)t+=this.strides[r]*e[r];return t},e.prototype.indexToLoc=function(e){if(0===this.rank)return[];if(1===this.rank)return[e];for(var t=new Array(this.shape.length),r=0;r<t.length-1;++r)t[r]=Math.floor(e/this.strides[r]),e-=t[r]*this.strides[r];return t[t.length-1]=e,t},Object.defineProperty(e.prototype,"rank",{get:function(){return this.shape.length},enumerable:!0,configurable:!0}),e.prototype.toTensor=function(){return Tensor.make(this.shape,{values:this.values},this.dtype)},e}(),trackerFn=null,opHandler=null;function setTensorTracker(e){trackerFn=e}function setOpHandler(e){opHandler=e}var Tensor=function(){function e(e,t,r,n){this.isDisposedInternal=!1,this.shape=e.slice(),this.dtype=t||"float32",this.size=sizeFromShape(e),null!=r&&assert(this.size===r.length,"Based on the provided shape, ["+e+"], and dtype "+this.dtype+", the tensor should have "+this.size+" values but has "+r.length),this.strides=computeStrides(e),this.dataId=null!=n?n:{},this.id=trackerFn().nextTensorId(),this.rankType=this.rank<5?this.rank.toString():"higher",trackerFn().registerTensor(this),null!=r&&trackerFn().write(this.dataId,r)}return e.make=function(t,r,n){return new e(t,n,r.values,r.dataId)},e.prototype.flatten=function(){return this.throwIfDisposed(),this.as1D()},e.prototype.asScalar=function(){return this.throwIfDisposed(),assert(1===this.size,"The array must have only 1 element."),this.reshape([])},e.prototype.as1D=function(){return this.throwIfDisposed(),this.reshape([this.size])},e.prototype.as2D=function(e,t){return this.throwIfDisposed(),this.reshape([e,t])},e.prototype.as3D=function(e,t,r){return this.throwIfDisposed(),this.reshape([e,t,r])},e.prototype.as4D=function(e,t,r,n){return this.throwIfDisposed(),this.reshape([e,t,r,n])},e.prototype.asType=function(e){return this.throwIfDisposed(),opHandler.cast(this,e)},Object.defineProperty(e.prototype,"rank",{get:function(){return this.shape.length},enumerable:!0,configurable:!0}),e.prototype.get=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];assert(e.length===this.rank,"Number of coordinates in get() must match the rank of the tensor"),assert("complex64"!==this.dtype,"Tensor.get() is not supported for complex64 tensors yet."),this.throwIfDisposed(),0===e.length&&(e=[0]);for(var r=e[e.length-1],n=0;n<e.length-1;++n)r+=this.strides[n]*e[n];return this.dataSync()[r]},e.prototype.buffer=function(){return opHandler.buffer(this.shape,this.dtype,this.dataSync())},e.prototype.data=function(){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(e){return this.throwIfDisposed(),[2,trackerFn().read(this.dataId)]})})},e.prototype.dataSync=function(){return this.throwIfDisposed(),trackerFn().readSync(this.dataId)},e.prototype.dispose=function(){this.isDisposed||(trackerFn().disposeTensor(this),this.isDisposedInternal=!0)},Object.defineProperty(e.prototype,"isDisposed",{get:function(){return this.isDisposedInternal},enumerable:!0,configurable:!0}),e.prototype.throwIfDisposed=function(){if(this.isDisposed)throw new Error("Tensor is disposed.")},e.prototype.toFloat=function(){return this.asType("float32")},e.prototype.toInt=function(){return this.asType("int32")},e.prototype.toBool=function(){return this.asType("bool")},e.prototype.print=function(e){return void 0===e&&(e=!1),opHandler.print(this,e)},e.prototype.reshape=function(e){return this.throwIfDisposed(),opHandler.reshape(this,e)},e.prototype.reshapeAs=function(e){return this.throwIfDisposed(),this.reshape(e.shape)},e.prototype.expandDims=function(e){return void 0===e&&(e=0),opHandler.expandDims(this,e)},e.prototype.cumsum=function(e,t,r){return void 0===e&&(e=0),void 0===t&&(t=!1),void 0===r&&(r=!1),opHandler.cumsum(this,e,t,r)},e.prototype.squeeze=function(e){return this.throwIfDisposed(),opHandler.squeeze(this,e)},e.prototype.clone=function(){return this.throwIfDisposed(),opHandler.clone(this)},e.prototype.toString=function(e){return void 0===e&&(e=!1),tensorToString(this.dataSync(),this.shape,this.dtype,e)},e.prototype.tile=function(e){return this.throwIfDisposed(),opHandler.tile(this,e)},e.prototype.gather=function(e,t){return void 0===t&&(t=0),this.throwIfDisposed(),opHandler.gather(this,e,t)},e.prototype.matMul=function(e,t,r){return void 0===t&&(t=!1),void 0===r&&(r=!1),this.throwIfDisposed(),opHandler.matMul(this,e,t,r)},e.prototype.dot=function(e){return this.throwIfDisposed(),opHandler.dot(this,e)},e.prototype.norm=function(e,t,r){return void 0===e&&(e="euclidean"),void 0===t&&(t=null),void 0===r&&(r=!1),this.throwIfDisposed(),opHandler.norm(this,e,t,r)},e.prototype.slice=function(e,t){return this.throwIfDisposed(),opHandler.slice(this,e,t)},e.prototype.reverse=function(e){return this.throwIfDisposed(),opHandler.reverse(this,e)},e.prototype.concat=function(e,t){return void 0===t&&(t=0),this.throwIfDisposed(),opHandler.concat([this,e],t)},e.prototype.split=function(e,t){return void 0===t&&(t=0),this.throwIfDisposed(),opHandler.split(this,e,t)},e.prototype.stack=function(e,t){return void 0===t&&(t=0),opHandler.stack([this,e],t)},e.prototype.unstack=function(e,t){return void 0===t&&(t=0),opHandler.unstack(this,t)},e.prototype.pad=function(e,t){return void 0===t&&(t=0),opHandler.pad(this,e,t)},e.prototype.batchNormalization=function(e,t,r,n,o){return void 0===r&&(r=.001),this.throwIfDisposed(),opHandler.batchNormalization(this,e,t,r,n,o)},e.prototype.all=function(e,t){return void 0===e&&(e=null),void 0===t&&(t=!1),this.throwIfDisposed(),opHandler.all(this,e,t)},e.prototype.any=function(e,t){return void 0===e&&(e=null),void 0===t&&(t=!1),this.throwIfDisposed(),opHandler.any(this,e,t)},e.prototype.logSumExp=function(e,t){return void 0===e&&(e=null),void 0===t&&(t=!1),this.throwIfDisposed(),opHandler.logSumExp(this,e,t)},e.prototype.sum=function(e,t){return void 0===e&&(e=null),void 0===t&&(t=!1),this.throwIfDisposed(),opHandler.sum(this,e,t)},e.prototype.prod=function(e,t){return void 0===e&&(e=null),void 0===t&&(t=!1),this.throwIfDisposed(),opHandler.prod(this,e,t)},e.prototype.mean=function(e,t){return void 0===e&&(e=null),void 0===t&&(t=!1),this.throwIfDisposed(),opHandler.mean(this,e,t)},e.prototype.min=function(e,t){return void 0===e&&(e=null),void 0===t&&(t=!1),this.throwIfDisposed(),opHandler.min(this,e,t)},e.prototype.max=function(e,t){return void 0===e&&(e=null),void 0===t&&(t=!1),this.throwIfDisposed(),opHandler.max(this,e,t)},e.prototype.argMin=function(e){return void 0===e&&(e=null),this.throwIfDisposed(),opHandler.argMin(this,e)},e.prototype.argMax=function(e){return void 0===e&&(e=null),this.throwIfDisposed(),opHandler.argMax(this,e)},e.prototype.cast=function(e){return this.throwIfDisposed(),opHandler.cast(this,e)},e.prototype.add=function(e){return this.throwIfDisposed(),opHandler.add(this,e)},e.prototype.addStrict=function(e){return this.throwIfDisposed(),opHandler.addStrict(this,e)},e.prototype.atan2=function(e){return this.throwIfDisposed(),opHandler.atan2(this,e)},e.prototype.sub=function(e){return this.throwIfDisposed(),opHandler.sub(this,e)},e.prototype.subStrict=function(e){return this.throwIfDisposed(),opHandler.subStrict(this,e)},e.prototype.pow=function(e){return this.throwIfDisposed(),opHandler.pow(this,e)},e.prototype.powStrict=function(e){return this.throwIfDisposed(),opHandler.powStrict(this,e)},e.prototype.mul=function(e){return this.throwIfDisposed(),opHandler.mul(this,e)},e.prototype.mulStrict=function(e){return this.throwIfDisposed(),opHandler.mulStrict(this,e)},e.prototype.div=function(e){return this.throwIfDisposed(),opHandler.div(this,e)},e.prototype.floorDiv=function(e){return this.throwIfDisposed(),opHandler.floorDiv(this,e)},e.prototype.divStrict=function(e){return this.throwIfDisposed(),opHandler.divStrict(this,e)},e.prototype.minimum=function(e){return this.throwIfDisposed(),opHandler.minimum(this,e)},e.prototype.minimumStrict=function(e){return this.throwIfDisposed(),opHandler.minimumStrict(this,e)},e.prototype.maximum=function(e){return this.throwIfDisposed(),opHandler.maximum(this,e)},e.prototype.maximumStrict=function(e){return this.throwIfDisposed(),opHandler.maximumStrict(this,e)},e.prototype.mod=function(e){return this.throwIfDisposed(),opHandler.mod(this,e)},e.prototype.modStrict=function(e){return this.throwIfDisposed(),opHandler.modStrict(this,e)},e.prototype.squaredDifference=function(e){return this.throwIfDisposed(),opHandler.squaredDifference(this,e)},e.prototype.squaredDifferenceStrict=function(e){return this.throwIfDisposed(),opHandler.squaredDifferenceStrict(this,e)},e.prototype.transpose=function(e){return this.throwIfDisposed(),opHandler.transpose(this,e)},e.prototype.notEqual=function(e){return this.throwIfDisposed(),opHandler.notEqual(this,e)},e.prototype.notEqualStrict=function(e){return this.throwIfDisposed(),opHandler.notEqualStrict(this,e)},e.prototype.less=function(e){return this.throwIfDisposed(),opHandler.less(this,e)},e.prototype.lessStrict=function(e){return this.throwIfDisposed(),opHandler.lessStrict(this,e)},e.prototype.equal=function(e){return this.throwIfDisposed(),opHandler.equal(this,e)},e.prototype.equalStrict=function(e){return this.throwIfDisposed(),opHandler.equalStrict(this,e)},e.prototype.lessEqual=function(e){return this.throwIfDisposed(),opHandler.lessEqual(this,e)},e.prototype.lessEqualStrict=function(e){return this.throwIfDisposed(),opHandler.lessEqualStrict(this,e)},e.prototype.greater=function(e){return this.throwIfDisposed(),opHandler.greater(this,e)},e.prototype.greaterStrict=function(e){return this.throwIfDisposed(),opHandler.greaterStrict(this,e)},e.prototype.greaterEqual=function(e){return this.throwIfDisposed(),opHandler.greaterEqual(this,e)},e.prototype.greaterEqualStrict=function(e){return this.throwIfDisposed(),opHandler.greaterEqualStrict(this,e)},e.prototype.logicalAnd=function(e){return this.throwIfDisposed(),opHandler.logicalAnd(this,e)},e.prototype.logicalOr=function(e){return this.throwIfDisposed(),opHandler.logicalOr(this,e)},e.prototype.logicalNot=function(){return this.throwIfDisposed(),opHandler.logicalNot(this)},e.prototype.logicalXor=function(e){return this.throwIfDisposed(),opHandler.logicalXor(this,e)},e.prototype.where=function(e,t){return this.throwIfDisposed(),opHandler.where(e,this,t)},e.prototype.neg=function(){return this.throwIfDisposed(),opHandler.neg(this)},e.prototype.ceil=function(){return this.throwIfDisposed(),opHandler.ceil(this)},e.prototype.floor=function(){return this.throwIfDisposed(),opHandler.floor(this)},e.prototype.sign=function(){return this.throwIfDisposed(),opHandler.sign(this)},e.prototype.exp=function(){return this.throwIfDisposed(),opHandler.exp(this)},e.prototype.expm1=function(){return this.throwIfDisposed(),opHandler.expm1(this)},e.prototype.log=function(){return this.throwIfDisposed(),opHandler.log(this)},e.prototype.log1p=function(){return this.throwIfDisposed(),opHandler.log1p(this)},e.prototype.sqrt=function(){return this.throwIfDisposed(),opHandler.sqrt(this)},e.prototype.rsqrt=function(){return this.throwIfDisposed(),opHandler.rsqrt(this)},e.prototype.square=function(){return this.throwIfDisposed(),opHandler.square(this)},e.prototype.reciprocal=function(){return this.throwIfDisposed(),opHandler.reciprocal(this)},e.prototype.abs=function(){return this.throwIfDisposed(),opHandler.abs(this)},e.prototype.clipByValue=function(e,t){return this.throwIfDisposed(),opHandler.clipByValue(this,e,t)},e.prototype.relu=function(){return this.throwIfDisposed(),opHandler.relu(this)},e.prototype.elu=function(){return this.throwIfDisposed(),opHandler.elu(this)},e.prototype.selu=function(){return this.throwIfDisposed(),opHandler.selu(this)},e.prototype.leakyRelu=function(e){return void 0===e&&(e=.2),this.throwIfDisposed(),opHandler.leakyRelu(this,e)},e.prototype.prelu=function(e){return this.throwIfDisposed(),opHandler.prelu(this,e)},e.prototype.sigmoid=function(){return this.throwIfDisposed(),opHandler.sigmoid(this)},e.prototype.logSigmoid=function(){return this.throwIfDisposed(),opHandler.logSigmoid(this)},e.prototype.softplus=function(){return this.throwIfDisposed(),opHandler.softplus(this)},e.prototype.zerosLike=function(){return this.throwIfDisposed(),opHandler.zerosLike(this)},e.prototype.onesLike=function(){return this.throwIfDisposed(),opHandler.onesLike(this)},e.prototype.sin=function(){return this.throwIfDisposed(),opHandler.sin(this)},e.prototype.cos=function(){return this.throwIfDisposed(),opHandler.cos(this)},e.prototype.tan=function(){return this.throwIfDisposed(),opHandler.tan(this)},e.prototype.asin=function(){return this.throwIfDisposed(),opHandler.asin(this)},e.prototype.acos=function(){return this.throwIfDisposed(),opHandler.acos(this)},e.prototype.atan=function(){return this.throwIfDisposed(),opHandler.atan(this)},e.prototype.sinh=function(){return this.throwIfDisposed(),opHandler.sinh(this)},e.prototype.cosh=function(){return this.throwIfDisposed(),opHandler.cosh(this)},e.prototype.tanh=function(){return this.throwIfDisposed(),opHandler.tanh(this)},e.prototype.asinh=function(){return this.throwIfDisposed(),opHandler.asinh(this)},e.prototype.acosh=function(){return this.throwIfDisposed(),opHandler.acosh(this)},e.prototype.atanh=function(){return this.throwIfDisposed(),opHandler.atanh(this)},e.prototype.erf=function(){return this.throwIfDisposed(),opHandler.erf(this)},e.prototype.round=function(){return this.throwIfDisposed(),opHandler.round(this)},e.prototype.step=function(e){return void 0===e&&(e=0),this.throwIfDisposed(),opHandler.step(this,e)},e.prototype.softmax=function(e){return void 0===e&&(e=-1),this.throwIfDisposed(),opHandler.softmax(this,e)},e.prototype.logSoftmax=function(e){return void 0===e&&(e=-1),this.throwIfDisposed(),opHandler.logSoftmax(this,e)},e.prototype.resizeBilinear=function(e,t){return void 0===t&&(t=!1),this.throwIfDisposed(),opHandler.image.resizeBilinear(this,e,t)},e.prototype.resizeNearestNeighbor=function(e,t){return void 0===t&&(t=!1),this.throwIfDisposed(),opHandler.image.resizeNearestNeighbor(this,e,t)},e.prototype.conv1d=function(e,t,r,n,o,a){return void 0===n&&(n="NWC"),void 0===o&&(o=1),this.throwIfDisposed(),opHandler.conv1d(this,e,t,r,n,o,a)},e.prototype.conv2d=function(e,t,r,n,o,a){return void 0===n&&(n="NHWC"),void 0===o&&(o=[1,1]),this.throwIfDisposed(),opHandler.conv2d(this,e,t,r,n,o,a)},e.prototype.conv2dTranspose=function(e,t,r,n,o){return this.throwIfDisposed(),opHandler.conv2dTranspose(this,e,t,r,n,o)},e.prototype.depthwiseConv2D=function(e,t,r,n,o,a){return void 0===n&&(n="NHWC"),void 0===o&&(o=[1,1]),this.throwIfDisposed(),opHandler.depthwiseConv2d(this,e,t,r,n,o,a)},e.prototype.separableConv2d=function(e,t,r,n,o,a){return void 0===o&&(o=[1,1]),void 0===a&&(a="NHWC"),this.throwIfDisposed(),opHandler.separableConv2d(this,e,t,r,n,o,a)},e.prototype.avgPool=function(e,t,r,n){return this.throwIfDisposed(),opHandler.avgPool(this,e,t,r,n)},e.prototype.maxPool=function(e,t,r,n){return this.throwIfDisposed(),opHandler.maxPool(this,e,t,r,n)},e.prototype.localResponseNormalization=function(e,t,r,n){return void 0===e&&(e=5),void 0===t&&(t=1),void 0===r&&(r=1),void 0===n&&(n=.5),opHandler.localResponseNormalization(this,e,t,r,n)},e.prototype.pool=function(e,t,r,n,o){return this.throwIfDisposed(),opHandler.pool(this,e,t,r,n,o)},e.prototype.variable=function(e,t,r){return void 0===e&&(e=!0),this.throwIfDisposed(),Variable.variable(this,e,t,r)},e.prototype.unsortedSegmentSum=function(e,t){return this.throwIfDisposed(),opHandler.unsortedSegmentSum(this,e,t)},e.prototype.batchToSpaceND=function(e,t){return this.throwIfDisposed(),opHandler.batchToSpaceND(this,e,t)},e.prototype.spaceToBatchND=function(e,t){return this.throwIfDisposed(),opHandler.spaceToBatchND(this,e,t)},e.prototype.topk=function(e,t){return void 0===e&&(e=1),void 0===t&&(t=!0),this.throwIfDisposed(),opHandler.topk(this,e,t)},e.prototype.stridedSlice=function(e,t,r,n,o){return void 0===n&&(n=0),void 0===o&&(o=0),this.throwIfDisposed(),opHandler.stridedSlice(this,e,t,r,n,o)},e.prototype.depthToSpace=function(e,t){return this.throwIfDisposed(),opHandler.depthToSpace(this,e,t)},e.prototype.fft=function(){return this.throwIfDisposed(),opHandler.spectral.fft(this)},e.prototype.ifft=function(){return this.throwIfDisposed(),opHandler.spectral.ifft(this)},e}();Object.defineProperty(Tensor,Symbol.hasInstance,{value:function(e){return!!e&&null!=e.shape&&null!=e.dtype}});var Variable=function(e){function t(t,r,n){void 0===r&&(r=!0);var o=e.call(this,t.shape,t.dtype,null,t.dataId)||this;o.trainable=r,o.name=n,null==o.name&&(o.name=trackerFn().nextVariableId().toString());try{trackerFn().registerVariable(o)}catch(e){throw trackerFn().disposeTensor(o),e}return o}return __extends(t,e),t.variable=function(e,r,n,o){return void 0===r&&(r=!0),null!=o&&o!==e.dtype&&(e=e.asType(o)),new t(e,r,n)},t.prototype.assign=function(e){if(e.dtype!==this.dtype)throw new Error("dtype of the new value ("+e.dtype+") and previous value ("+this.dtype+") must match");if(!arraysEqual(e.shape,this.shape))throw new Error("shape of the new value ("+e.shape+") and previous value ("+this.shape+") must match");trackerFn().disposeTensor(this),this.dataId=e.dataId,trackerFn().registerTensor(this)},t}(Tensor);Object.defineProperty(Variable,Symbol.hasInstance,{value:function(e){return e instanceof Tensor&&null!=e.assign&&e.assign instanceof Function}});var variable=Variable.variable;function getFilteredNodesXToY(e,t,r){for(var n={},o={},a=0;a<t.length;a++)n[t[a].id]=!0;for(a=0;a<e.length;a++){var i=(f=e[a]).inputs;for(var s in i){for(var u=i[s],l=!1,c=0;c<t.length;c++)if(n[u.id]){f.outputs.forEach(function(e){return n[e.id]=!0}),l=!0,o[f.id]=!0;break}if(l)break}}var p={};p[r.id]=!0;var d={};for(a=e.length-1;a>=0;a--)for(i=(f=e[a]).inputs,c=0;c<f.outputs.length;c++)if(p[f.outputs[c].id]){for(var s in i)p[i[s].id]=!0,d[f.id]=!0;break}var h=[];for(a=0;a<e.length;a++){var f;if(o[(f=e[a]).id]&&d[f.id]){var m={};for(var s in f.inputs){var g=f.inputs[s];n[g.id]&&(m[s]=g)}var v=Object.assign({},f);v.inputs=m,v.outputs=f.outputs,h.push(v)}}return h}function backpropagateGradients(e,t){for(var r=function(r){var n=t[r],o=[];if(n.outputs.forEach(function(t){var r=e[t.id];if(null!=r)o.push(r);else{var n=Tensor.make(t.shape,{values:makeZerosTypedArray(t.size,t.dtype)},t.dtype);o.push(n)}}),null==n.gradient)throw new Error("Cannot compute gradient: gradient function not found for "+n.name+".");var a=n.gradient(1===n.outputs.length?o[0]:o);for(var i in n.inputs){if(!(i in a))throw new Error("Cannot backprop through input "+i+". Available gradients found: "+Object.keys(a)+".");var s=a[i](),u=n.inputs[i];if(!arraysEqual(s.shape,u.shape))throw new Error("Error in gradient for op "+n.name+". The gradient of input '"+i+"' has shape '"+s.shape+"', which does not match the shape of the input '"+u.shape+"'");if(null==e[u.id])e[u.id]=s;else{var l=e[u.id];e[u.id]=l.add(s),l.dispose()}}},n=t.length-1;n>=0;n--)r(n)}function assertTypesMatch(e,t){assert(e.dtype===t.dtype,"The dtypes of the first("+e.dtype+") and second("+t.dtype+") input must match")}function isTensorInList(e,t){for(var r=0;r<t.length;r++)if(t[r].id===e.id)return!0;return!1}function getTensorsInContainer(e){var t=[];return walkTensorContainer(e,t,new Set),t}function walkTensorContainer(e,t,r){if(null!=e)if(e instanceof Tensor)t.push(e);else if(isIterable(e)){var n=e;for(var o in n){var a=n[o];r.has(a)||(r.add(a),walkTensorContainer(a,t,r))}}}function isIterable(e){return Array.isArray(e)||"object"==typeof e}var Type,Engine=function(){function e(e,t,r){this.backend=e,this.safeMode=t,this.debugMode=r,this.registeredVariables={},this.nextTapeNodeId=0,this.numBytes=0,this.numTensors=0,this.numDataBuffers=0,this.profiling=!1,this.gradientScopeCount=0,this.customGradientDepth=0,this.keepTensors=new Set,this.tensorInfo=new WeakMap,this.activeScope={track:[],name:"default scope"},this.scopeStack=[this.activeScope],this.profiler=new Profiler(e),this.activeProfile={newBytes:0,newTensors:0,peakBytes:0,kernels:[],result:null}}return e.prototype.moveData=function(e){this.write(e,this.readSync(e))},e.prototype.tidy=function(e,t,r){var n=this;void 0===r&&(r=!1);var o,a=null;if(null==t){if("function"!=typeof e)throw new Error("Please provide a function to tidy()");t=e}else{if("string"!=typeof e&&!(e instanceof String))throw new Error("When calling with two arguments, the first argument to tidy() must be a string");if("function"!=typeof t)throw new Error("When calling with two arguments, the 2nd argument to tidy() must be a function");a=e}return this.scopedRun(function(){return n.startScope(a,r)},function(){return n.endScope(o,r)},function(){return(o=t())instanceof Promise&&console.error("Cannot return a Promise inside of tidy."),o})},e.prototype.scopedRun=function(e,t,r){e();try{var n=r();return t(),n}catch(e){throw t(),e}},e.prototype.nextTensorId=function(){return e.nextTensorId++},e.prototype.nextVariableId=function(){return e.nextVariableId++},e.prototype.runKernel=function(e,t,r){var n,o=this,a=[],i=function(e){return a.push(e),e},s=this.activeScope.name,u=this.numBytes,l=this.numTensors;if(this.scopedRun(function(){return o.customGradientDepth++},function(){return o.customGradientDepth--},function(){n=o.debugMode()?o.profiler.profileKernel(s,function(){return e(o.backend,i)}):e(o.backend,i)}),this.shouldRecord()){var c={id:this.nextTapeNodeId++,name:s,inputs:t,outputs:Array.isArray(n)?n:[n]};null!=r&&(c.gradient=function(e){return r(e,a)}),this.activeTape.push(c)}return this.profiling&&this.activeProfile.kernels.push({name:s,bytesAdded:this.numBytes-u,totalBytesSnapshot:this.numBytes,tensorsAdded:this.numTensors-l,totalTensorsSnapshot:this.numTensors,inputShapes:Object.keys(t).map(function(e){return t[e].shape}),outputShape:Array.isArray(n)?n.map(function(e){return e.shape}):n.shape}),n},e.prototype.registerTensor=function(e){var t=this.tensorInfo.has(e.dataId)?this.tensorInfo.get(e.dataId).refCount:0;this.numTensors++,0===t&&(this.numDataBuffers++,"complex64"!==e.dtype&&(this.numBytes+=sizeFromShape(e.shape)*bytesPerElement(e.dtype)),this.tensorInfo.set(e.dataId,{backend:this.backend,dtype:e.dtype,shape:e.shape,refCount:0}),this.backend.register(e.dataId,e.shape,e.dtype)),this.tensorInfo.get(e.dataId).refCount++,e instanceof Variable||this.track(e)},e.prototype.registerVariable=function(e){if(null!=this.registeredVariables[e.name])throw new Error("Variable with name "+e.name+" was already registered");this.registeredVariables[e.name]=e},e.prototype.disposeTensor=function(e){this.tensorInfo.has(e.dataId)&&(this.keepTensors.has(e.id)&&this.keepTensors.delete(e.id),this.numTensors--,this.tensorInfo.get(e.dataId).refCount<=1?(this.tensorInfo.get(e.dataId).backend.disposeData(e.dataId),this.numDataBuffers--,"complex64"!==e.dtype&&(this.numBytes-=sizeFromShape(e.shape)*bytesPerElement(e.dtype)),this.tensorInfo.delete(e.dataId)):this.tensorInfo.get(e.dataId).refCount--)},e.prototype.disposeVariables=function(){for(var e in this.registeredVariables){var t=this.registeredVariables[e];this.disposeTensor(t),delete this.registeredVariables[e]}},e.prototype.memory=function(){var e=this.backend.memory();return e.numTensors=this.numTensors,e.numDataBuffers=this.numDataBuffers,e.numBytes=this.numBytes,e},e.prototype.profile=function(e){return __awaiter(this,void 0,void 0,function(){var t,r;return __generator(this,function(n){return this.profiling=!0,t=this.numBytes,r=this.numTensors,this.activeProfile.kernels=[],this.activeProfile.result=e(),this.profiling=!1,this.activeProfile.peakBytes=Math.max.apply(Math,this.activeProfile.kernels.map(function(e){return e.totalBytesSnapshot})),this.activeProfile.newBytes=this.numBytes-t,this.activeProfile.newTensors=this.numTensors-r,[2,this.activeProfile]})})},e.prototype.shouldRecord=function(){return null!=this.activeTape&&0===this.customGradientDepth},e.prototype.addTapeNode=function(e,t,r){var n={};e.forEach(function(e,t){n[t]=e});var o={id:this.nextTapeNodeId++,name:this.activeScope.name,inputs:n,outputs:[t],gradient:function(e){var t={};return r(e).forEach(function(e,r){t[r]=function(){return e}}),t}};this.activeTape.push(o)},e.prototype.keep=function(e){if(1===this.scopeStack.length&&this.safeMode)throw new Error("Safe mode is ON. Enclose all tensor operations inside tf.tidy(): tf.tidy(() => {...}) to avoid memory leaks.");return this.keepTensors.add(e.id),e},e.prototype.startScope=function(e,t){void 0===t&&(t=!1),t&&0===this.gradientScopeCount&&(this.activeTape=[]),t&&this.gradientScopeCount++;var r={track:[],name:"unnamed scope"};e&&(r.name=e),this.scopeStack.push(r),this.activeScope=r},e.prototype.endScope=function(e,t){var r=this;void 0===t&&(t=!1),t&&(this.gradientScopeCount--,0===this.gradientScopeCount&&(this.activeTape=null));var n=new Set(this.keepTensors),o=getTensorsInContainer(e);o.forEach(function(e){return n.add(e.id)});for(var a=0;a<this.activeScope.track.length;a++){var i=this.activeScope.track[a];n.has(i.id)||(null!=this.activeTape?o.push(i):i.dispose())}var s=this.scopeStack.pop();this.activeScope=0===this.scopeStack.length?{track:[],name:"default scope"}:this.scopeStack[this.scopeStack.length-1],o.forEach(function(e){!r.keepTensors.has(e.id)&&isTensorInList(e,s.track)&&r.track(e)})},e.prototype.gradients=function(e,t,r,n){var o=this;return void 0===n&&(n=!1),assert(t.length>0,"gradients() received an empty list of xs."),this.tidy("gradients",function(){var a=e();assert(a instanceof Tensor,"The result y returned by f() must be a tensor.");var i=getFilteredNodesXToY(o.activeTape,t,a);if(!n&&0===i.length&&t.length>0)throw new Error("Cannot compute gradient of y=f(x) with respect to x. Make sure that the f you passed encloses all operations that lead from x to y.");var s={};return s[a.id]=null==r?ones(a.shape):r,backpropagateGradients(s,i),{value:a,grads:t.map(function(e){return s[e.id]})}},!0)},e.prototype.customGrad=function(e){var t=this;return assert(isFunction(e),"The f passed in customGrad(f) must be a function."),function(){for(var r,n,o=[],a=0;a<arguments.length;a++)o[a]=arguments[a];if(assert(o.every(function(e){return e instanceof Tensor}),"The args passed in customGrad(f)(x1, x2,...) must all be tensors"),t.scopedRun(function(){return t.customGradientDepth++},function(){return t.customGradientDepth--},function(){n=t.tidy(e.name,function(){var t=e.apply(void 0,o),n=t.value,a=t.gradFunc;return assert(n instanceof Tensor,"The function f passed in customGrad(f) must return an object where `obj.value` is a tensor"),assert(isFunction(a),"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function."),r=a,n},!0)}),t.shouldRecord()){t.addTapeNode(o,n,function(e){var t=r(e),n=Array.isArray(t)?t:[t];return assert(n.length===o.length,"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns the same number of tensors as inputs passed to f(...)."),assert(n.every(function(e){return e instanceof Tensor}),"The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns a list of only tensors."),n})}return n}},e.prototype.write=function(e,t){var r=this.tensorInfo.get(e);this.backend!==r.backend&&(r.backend.disposeData(e),r.backend=this.backend,this.backend.register(e,r.shape,r.dtype)),this.backend.write(e,t)},e.prototype.readSync=function(e){return this.tensorInfo.get(e).backend.readSync(e)},e.prototype.read=function(e){return this.tensorInfo.get(e).backend.read(e)},e.prototype.fromPixels=function(e,t){return this.backend.fromPixels(e,t)},e.prototype.time=function(e){return __awaiter(this,void 0,void 0,function(){var t,r;return __generator(this,function(n){switch(n.label){case 0:return t=now(),[4,this.backend.time(e)];case 1:return(r=n.sent()).wallMs=now()-t,[2,r]}})})},e.prototype.track=function(e){if(1===this.scopeStack.length&&this.safeMode)throw new Error("Safe mode is ON. Enclose all tensor operations inside tf.tidy(): tf.tidy(() => {op();...}); to avoid memory leaks.");return this.activeScope.track.push(e),e},e.nextTensorId=0,e.nextVariableId=0,e}();function ones(e){var t=makeOnesTypedArray(sizeFromShape(e),"float32");return Tensor.make(e,{values:t})}!function(e){e[e.NUMBER=0]="NUMBER",e[e.BOOLEAN=1]="BOOLEAN",e[e.STRING=2]="STRING"}(Type||(Type={}));var MAX_TEXTURE_SIZE,URL_PROPERTIES=[{name:"DEBUG",type:Type.BOOLEAN},{name:"IS_BROWSER",type:Type.BOOLEAN},{name:"WEBGL_LAZILY_UNPACK",type:Type.BOOLEAN},{name:"WEBGL_CPU_FORWARD",type:Type.BOOLEAN},{name:"WEBGL_PACK_BATCHNORMALIZATION",type:Type.BOOLEAN},{name:"WEBGL_CONV_IM2COL",type:Type.BOOLEAN},{name:"WEBGL_MAX_TEXTURE_SIZE",type:Type.NUMBER},{name:"WEBGL_PAGING_ENABLED",type:Type.BOOLEAN},{name:"WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION",type:Type.NUMBER},{name:"WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE",type:Type.BOOLEAN},{name:"WEBGL_VERSION",type:Type.NUMBER},{name:"WEBGL_RENDER_FLOAT32_ENABLED",type:Type.BOOLEAN},{name:"WEBGL_DOWNLOAD_FLOAT_ENABLED",type:Type.BOOLEAN},{name:"WEBGL_FENCE_API_ENABLED",type:Type.BOOLEAN},{name:"WEBGL_SIZE_UPLOAD_UNIFORM",type:Type.NUMBER},{name:"BACKEND",type:Type.STRING},{name:"EPSILON",type:Type.NUMBER},{name:"PROD",type:Type.BOOLEAN},{name:"TENSORLIKE_CHECK_SHAPE_CONSISTENCY",type:Type.BOOLEAN}];function isWebGLVersionEnabled(e){try{if(null!=getWebGLContext(e))return!0}catch(e){return!1}return!1}function getWebGLMaxTextureSize(e){if(null==MAX_TEXTURE_SIZE){var t=getWebGLContext(e);MAX_TEXTURE_SIZE=t.getParameter(t.MAX_TEXTURE_SIZE)}return MAX_TEXTURE_SIZE}function getWebGLDisjointQueryTimerVersion(e){if(0===e)return 0;var t=getWebGLContext(e);return hasExtension(t,"EXT_disjoint_timer_query_webgl2")&&2===e?2:hasExtension(t,"EXT_disjoint_timer_query")?1:0}function isRenderToFloatTextureEnabled(e){if(0===e)return!1;var t=getWebGLContext(e);if(1===e){if(!hasExtension(t,"OES_texture_float"))return!1}else if(!hasExtension(t,"EXT_color_buffer_float"))return!1;return createFloatTextureAndBindToFramebuffer(t,e)}function isDownloadFloatTextureEnabled(e){if(0===e)return!1;var t=getWebGLContext(e);if(1===e){if(!hasExtension(t,"OES_texture_float"))return!1;if(!hasExtension(t,"WEBGL_color_buffer_float"))return!1}else if(!hasExtension(t,"EXT_color_buffer_float"))return!1;return createFloatTextureAndBindToFramebuffer(t,e)}function isWebGLFenceEnabled(e){return 2===e&&null!=getWebGLContext(e).fenceSync}function isChrome(){return"undefined"!=typeof navigator&&null!=navigator&&null!=navigator.userAgent&&/Chrome/.test(navigator.userAgent)&&/Google Inc/.test(navigator.vendor)}var TENSORFLOWJS_FLAGS_PREFIX="tfjsflags";function getFeaturesFromURL(){var e={};if("undefined"==typeof window||void 0===window.location||void 0===window.location.search)return e;var t=getQueryParams(window.location.search);if(TENSORFLOWJS_FLAGS_PREFIX in t){var r={};t[TENSORFLOWJS_FLAGS_PREFIX].split(",").forEach(function(e){var t=e.split(":"),n=t[0],o=t[1];r[n]=o}),URL_PROPERTIES.forEach(function(t){t.name in r&&(console.log("Setting feature override from URL "+t.name+": "+r[t.name]),t.type===Type.NUMBER?e[t.name]=+r[t.name]:t.type===Type.BOOLEAN?e[t.name]="true"===r[t.name]:t.type===Type.STRING?e[t.name]=r[t.name]:console.warn("Unknown URL param: "+t.name+"."))})}return e}function hasExtension(e,t){return null!=e.getExtension(t)}function createFloatTextureAndBindToFramebuffer(e,t){var r=e.createFramebuffer(),n=e.createTexture();e.bindTexture(e.TEXTURE_2D,n);var o=2===t?e.RGBA32F:e.RGBA;e.texImage2D(e.TEXTURE_2D,0,o,1,1,0,e.RGBA,e.FLOAT,null),e.bindFramebuffer(e.FRAMEBUFFER,r),e.framebufferTexture2D(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,n,0);var a=e.checkFramebufferStatus(e.FRAMEBUFFER)===e.FRAMEBUFFER_COMPLETE;return e.bindTexture(e.TEXTURE_2D,null),e.bindFramebuffer(e.FRAMEBUFFER,null),e.deleteTexture(n),e.deleteFramebuffer(r),a}function getQueryParams(e){var t={};return e.replace(/[?&]([^=?&]+)(?:=([^&]*))?/g,function(e){for(var r=[],n=1;n<arguments.length;n++)r[n-1]=arguments[n];return decodeParam(t,r[0],r[1]),r.join("=")}),t}function decodeParam(e,t,r){e[decodeURIComponent(t)]=decodeURIComponent(r||"")}var EPSILON_FLOAT16=.001,TEST_EPSILON_FLOAT16=.1,EPSILON_FLOAT32=1e-7,TEST_EPSILON_FLOAT32=.001,Environment=function(){function e(e){this.features={},this.registry={},null!=e&&(this.features=e),this.get("DEBUG")&&console.warn("Debugging mode is ON. The output of every math call will be downloaded to CPU and checked for NaNs. This significantly impacts performance.")}return e.setBackend=function(e,t){if(void 0===t&&(t=!1),!(e in ENV.registry))throw new Error("Backend name '"+e+"' not found in registry");ENV.engine.backend=ENV.findBackend(e),ENV.backendName=e},e.getBackend=function(){return ENV.initEngine(),ENV.backendName},e.disposeVariables=function(){ENV.engine.disposeVariables()},e.memory=function(){return ENV.engine.memory()},e.profile=function(e){return ENV.engine.profile(e)},e.tidy=function(e,t,r){return void 0===r&&(r=!1),ENV.engine.tidy(e,t,r)},e.dispose=function(e){getTensorsInContainer(e).forEach(function(e){return e.dispose()})},e.keep=function(e){return ENV.engine.keep(e)},e.time=function(e){return ENV.engine.time(e)},e.prototype.get=function(e){return e in this.features?this.features[e]:(this.features[e]=this.evaluateFeature(e),this.features[e])},e.prototype.getFeatures=function(){return this.features},e.prototype.set=function(e,t){this.features[e]=t},e.prototype.getBestBackendName=function(){var e=this;if(0===Object.keys(this.registry).length)throw new Error("No backend found in registry.");return Object.keys(this.registry).map(function(t){return{name:t,entry:e.registry[t]}}).sort(function(e,t){return t.entry.priority-e.entry.priority})[0].name},e.prototype.evaluateFeature=function(e){if("DEBUG"===e)return!1;if("IS_BROWSER"===e)return"undefined"!=typeof window;if("IS_NODE"===e)return"undefined"!=typeof process&&void 0!==process.versions.node;if("IS_CHROME"===e)return isChrome();if("WEBGL_CPU_FORWARD"===e)return!0;if("WEBGL_PACK_BATCHNORMALIZATION"===e)return!1;if("WEBGL_LAZILY_UNPACK"===e)return!1;if("WEBGL_CONV_IM2COL"===e)return!1;if("WEBGL_PAGING_ENABLED"===e)return this.get("IS_BROWSER")&&!this.get("PROD");if("WEBGL_MAX_TEXTURE_SIZE"===e)return getWebGLMaxTextureSize(this.get("WEBGL_VERSION"));if("IS_TEST"===e)return!1;if("BACKEND"===e)return this.getBestBackendName();if("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION"===e){var t=this.get("WEBGL_VERSION");return 0===t?0:getWebGLDisjointQueryTimerVersion(t)}if("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE"===e)return this.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION")>0&&!isMobile();if("HAS_WEBGL"===e)return this.get("WEBGL_VERSION")>0;if("WEBGL_VERSION"===e)return isWebGLVersionEnabled(2)?2:isWebGLVersionEnabled(1)?1:0;if("WEBGL_RENDER_FLOAT32_ENABLED"===e)return isRenderToFloatTextureEnabled(this.get("WEBGL_VERSION"));if("WEBGL_DOWNLOAD_FLOAT_ENABLED"===e)return isDownloadFloatTextureEnabled(this.get("WEBGL_VERSION"));if("WEBGL_FENCE_API_ENABLED"===e)return isWebGLFenceEnabled(this.get("WEBGL_VERSION"));if("WEBGL_SIZE_UPLOAD_UNIFORM"===e)return this.get("WEBGL_RENDER_FLOAT32_ENABLED")?4:0;if("TEST_EPSILON"===e)return 32===this.backend.floatPrecision()?TEST_EPSILON_FLOAT32:TEST_EPSILON_FLOAT16;if("EPSILON"===e)return 32===this.backend.floatPrecision()?EPSILON_FLOAT32:EPSILON_FLOAT16;if("PROD"===e)return!1;if("TENSORLIKE_CHECK_SHAPE_CONSISTENCY"===e)return!this.get("PROD");throw new Error("Unknown feature "+e+".")},e.prototype.setFeatures=function(e){this.features=Object.assign({},e)},e.prototype.reset=function(){this.features=getFeaturesFromURL(),null!=this.globalEngine&&(this.globalEngine=null)},Object.defineProperty(e.prototype,"backend",{get:function(){return this.engine.backend},enumerable:!0,configurable:!0}),e.prototype.findBackend=function(e){return e in this.registry?this.registry[e].backend:null},e.prototype.registerBackend=function(e,t,r,n){var o=this;if(void 0===r&&(r=1),e in this.registry)return console.warn(e+" backend was already registered. Reusing existing backend"),null!=n&&n(function(){return o.engine}),!1;try{var a=t();return a.setDataMover({moveData:function(e){return o.engine.moveData(e)}}),this.registry[e]={backend:a,priority:r},!0}catch(t){return console.warn("Registration of backend "+e+" failed"),console.warn(t.stack||t.message),!1}},e.prototype.removeBackend=function(e){if(!(e in this.registry))throw new Error(e+" backend not found in registry");this.registry[e].backend.dispose(),delete this.registry[e]},Object.defineProperty(e.prototype,"engine",{get:function(){return this.initEngine(),this.globalEngine},enumerable:!0,configurable:!0}),e.prototype.initEngine=function(){var e=this;if(null==this.globalEngine){this.backendName=this.get("BACKEND");var t=this.findBackend(this.backendName);this.globalEngine=new Engine(t,!1,function(){return e.get("DEBUG")})}},e}();function getGlobalNamespace(){var e;if("undefined"!=typeof window)e=window;else{if("undefined"==typeof process)throw new Error("Could not find a global object");e=process}return e}function getOrMakeEnvironment(){var e=getGlobalNamespace();return null==e.ENV&&(e.ENV=new Environment(getFeaturesFromURL()),setTensorTracker(function(){return e.ENV.engine})),e.ENV}var ENV=getOrMakeEnvironment(),environment=Object.freeze({Environment:Environment,ENV:ENV});function grad(e){return assert(isFunction(e),"The f passed in grad(f) must be a function"),function(t,r){return assert(t instanceof Tensor,"The x passed in grad(f)(x) must be a tensor"),assert(null==r||r instanceof Tensor,"The dy passed in grad(f)(x, dy) must be a tensor"),ENV.engine.tidy(function(){var n=ENV.engine.gradients(function(){return e(t)},[t],r),o=n.value,a=n.grads;return null!=r&&assertShapesMatch(o.shape,r.shape,"The shape of dy passed in grad(f)(x, dy) must match the shape returned by f(x)"),checkGrads(a),a[0]})}}function grads(e){return assert(isFunction(e),"The f passed in grads(f) must be a function"),function(t,r){return assert(Array.isArray(t)&&t.every(function(e){return e instanceof Tensor}),"The args passed in grads(f)(args) must be an array of tensors"),assert(null==r||r instanceof Tensor,"The dy passed in grads(f)(args, dy) must be a tensor"),ENV.engine.tidy(function(){var n=ENV.engine.gradients(function(){return e.apply(void 0,t)},t,r),o=n.value,a=n.grads;return null!=r&&assertShapesMatch(o.shape,r.shape,"The shape of dy passed in grads(f)([x1,...], dy) must match the shape returned by f([x1,...])"),checkGrads(a),a})}}function valueAndGrad(e){return assert(isFunction(e),"The f passed in valueAndGrad(f) must be a function"),function(t,r){assert(t instanceof Tensor,"The x passed in valueAndGrad(f)(x) must be a tensor"),assert(null==r||r instanceof Tensor,"The dy passed in valueAndGrad(f)(x, dy) must be a tensor");var n=ENV.engine.gradients(function(){return e(t)},[t],r),o=n.grads,a=n.value;return checkGrads(o),{grad:o[0],value:a}}}function valueAndGrads(e){return assert(isFunction(e),"The f passed in valueAndGrads(f) must be a function"),function(t,r){assert(Array.isArray(t)&&t.every(function(e){return e instanceof Tensor}),"The args passed in valueAndGrads(f)(args) must be array of tensors"),assert(null==r||r instanceof Tensor,"The dy passed in valueAndGrads(f)(args, dy) must be a tensor");var n=ENV.engine.gradients(function(){return e.apply(void 0,t)},t,r);return null!=r&&assertShapesMatch(n.value.shape,r.shape,"The shape of dy passed in valueAndGrads(f)([x1,...], dy) must match the shape returned by f([x1,...])"),checkGrads(n.grads),n}}function variableGrads(e,t){if(assert(isFunction(e),"The f passed in variableGrads(f) must be a function"),assert(null==t||Array.isArray(t)&&t.every(function(e){return e instanceof Variable}),"The varList passed in variableGrads(f, varList) must be an array of variables"),null==t)for(var r in t=[],ENV.engine.registeredVariables)t.push(ENV.engine.registeredVariables[r]);var n=t.length;assert((t=t.filter(function(e){return e.trainable})).length>0,"variableGrads() expects at least one of the input variables to be trainable, but none of the "+n+" variables is trainable.");var o=ENV.engine.gradients(e,t,null,!0),a=o.value,i=o.grads;assert(i.some(function(e){return null!=e}),"Cannot find a connection between any variable and the result of the loss function y=f(x). Please make sure the operations that use variables are inside the function f passed to minimize()."),assert(0===a.rank,"The f passed in variableGrads(f) must return a scalar, but it returned a rank-"+a.rank+" tensor");var s={};return t.forEach(function(e,t){null!=i[t]&&(s[e.name]=i[t])}),{value:a,grads:s}}function customGrad(e){return ENV.engine.customGrad(e)}function checkGrads(e){if(e.filter(function(e){return null==e}).length>0)throw new Error("Cannot compute gradient of y=f(x) with respect to x. Make sure that\n    the f you passed encloses all operations that lead from x to y.")}var tidy=Environment.tidy,keep=Environment.keep,dispose=Environment.dispose,time=Environment.time,profile=Environment.profile;function warn(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];ENV.get("IS_TEST")||console.warn.apply(console,e)}function getReshaped(e,t,r,n){void 0===n&&(n=!0);var o=[];if(n)(o=o.concat(t.slice(0))).push(e[0]/r),o=o.concat(e.slice(1));else{o=o.concat(e[0]);for(var a=t.length,i=0;i<a;++i)o=o.concat([e[i+1]/t[i],t[i]]);o=o.concat(e.slice(a+1))}return o}function getPermuted(e,t,r){void 0===r&&(r=!0);var n=[];if(r){n.push(t);for(var o=t+1;o<e;++o)o<=2*t?(n.push(o),n.push(o-(t+1))):n.push(o)}else{var a=[],i=[];for(o=1;o<e;++o)o>=2*t+1||o%2==1?i.push(o):a.push(o);n.push.apply(n,a),n.push(0),n.push.apply(n,i)}return n}function getReshapedPermuted(e,t,r,n){void 0===n&&(n=!0);var o=[];n?o.push(e[0]/r):o.push(e[0]*r);for(var a=1;a<e.length;++a)a<=t.length?n?o.push(t[a-1]*e[a]):o.push(e[a]/t[a-1]):o.push(e[a]);return o}function getSliceBeginCoords(e,t){for(var r=[0],n=0;n<t;++n)r.push(e[n][0]);return r}function getSliceSize(e,t,r){for(var n=e.slice(0,1),o=0;o<r;++o)n.push(e[o+1]-t[o][0]-t[o][1]);return n}function axesAreInnerMostDims(e,t){for(var r=0;r<e.length;++r)if(e[e.length-r-1]!==t-1-r)return!1;return!0}function combineLocations(e,t,r){for(var n=e.length+t.length,o=[],a=0,i=0,s=0;s<n;s++)-1===r.indexOf(s)?o.push(e[a++]):o.push(t[i++]);return o}function computeOutAndReduceShapes(e,t){for(var r=[],n=e.length,o=0;o<n;o++)-1===t.indexOf(o)&&r.push(e[o]);return[r,t.map(function(t){return e[t]})]}function expandShapeToKeepDim(e,t){return combineLocations(e,t.map(function(e){return 1}),t)}function parseAxisParam(e,t){var r=t.length;return assert((e=null==e?t.map(function(e,t){return t}):[].concat(e)).every(function(e){return e>=-r&&e<r}),"All values in axis param must be in range [-"+r+", "+r+") but got axis "+e),assert(e.every(function(e){return isInt(e)}),"All values in axis param must be integers but got axis "+e),e.map(function(e){return e<0?r+e:e})}function assertAxesAreInnerMostDims(e,t,r){assert(axesAreInnerMostDims(t,r),e+" supports only inner-most axes for now. Got axes "+t+" and rank-"+r+" input.")}function getAxesPermutation(e,t){if(axesAreInnerMostDims(e,t))return null;for(var r=[],n=0;n<t;++n)-1===e.indexOf(n)&&r.push(n);return e.forEach(function(e){return r.push(e)}),r}function getUndoAxesPermutation(e){return e.map(function(e,t){return[t,e]}).sort(function(e,t){return e[1]-t[1]}).map(function(e){return e[0]})}function getInnerMostAxes(e,t){for(var r=[],n=t-e;n<t;++n)r.push(n);return r}function assertParamsConsistent(e,t){var r=e[0].length;e.forEach(function(e,t){assert(e.length===r,"Error in concat"+r+"D: rank of tensors["+t+"] must be the same as the rank of the rest ("+r+")")}),assert(t>=0&&t<r,"Error in concat"+r+"D: axis must be between 0 and "+(r-1)+".");var n=e[0];e.forEach(function(e,o){for(var a=0;a<r;a++)assert(a===t||e[a]===n[a],"Error in concat"+r+"D: Shape of tensors["+o+"] ("+e+") does not match the shape of the rest ("+n+") along the non-concatenated axis "+o+".")})}function computeOutShape(e,t){for(var r=e[0].slice(),n=1;n<e.length;n++)r[t]+=e[n][t];return r}function prepareAndValidate(e,t){if(e.rank<1)throw new Error("tf.gatherND() expects the input to be rank 1 or higher, but the rank was "+e.rank+".");if(t.rank<1)throw new Error("tf.gatherND() expects the indices to be rank 1 or higher, but the rank was "+t.rank+".");if("int32"!==t.dtype)throw new Error("tf.gatherND() expects the indices to be int32 type, but the dtype was "+t.dtype+".");if(t.shape[t.rank-1]>e.rank)throw new Error("index innermost dimension length must be <= tensor rank; saw: "+t.shape[t.rank-1]+" vs. "+e.rank);if(0===e.size)throw new Error("Requested more than 0 entries, but input is empty. Input shape: "+e.shape+".");for(var r=t.shape,n=r[r.length-1],o=1,a=0;a<r.length-1;++a)o*=r[a];var i=e.shape,s=r.slice();s.pop();var u=1;for(a=n;a<e.rank;++a)u*=i[a],s.push(i[a]);var l=computeStrides(e.shape).map(function(e){return e/u}).concat([1]).slice(0,n);return[s,o,u,l]}var PARALLELIZE_THRESHOLD=30;function computeOptimalWindowSize(e){return e<=PARALLELIZE_THRESHOLD?e:nearestDivisor(e,Math.floor(Math.sqrt(e)))}function validateUpdateShape(e,t,r){var n=t.rank>1?t.shape[t.rank-1]:1,o=t.rank>1?t.rank-1:1,a="Must have updates.shape = indices.shape[:batchDim] + shape[sliceDim:], got updates.shape: "+r.shape+", indices.shape: "+t.shape+", shape: "+e+", sliceDim: "+n+", and batchDim: "+o+".";if(r.rank<o)throw new Error(a+" update.rank < "+o+". ");if(e.length<n+(r.rank-o))throw new Error(a+" Output shape length < "+(n+(r.rank-o)));if(r.rank!==o+e.length-n)throw new Error(a+" update.rank != "+(o+e.length-n));for(var i=0;i<o;++i)if(r.shape[i]!==t.shape[i])throw new Error(a+" updates.shape["+i+"] ("+r.shape[i]+") != indices.shape["+i+"] ("+t.shape[i]+").");for(i=0;i<r.rank-o;++i)if(r.shape[i+o]!==e[i+n])throw new Error(a+" updates.shape["+(i+o)+"] ("+r.shape[i+o]+") != shape["+(i+o)+"] ("+e[i+o]+")")}function validateInput(e,t,r){if(t.rank<1)throw new Error("tf.scatterND() expects the indices to be rank 1 or higher, but the rank was "+t.rank+".");if(e.rank<1)throw new Error("tf.scatterND() expects the updates to be rank 1 or higher, but the rank was "+e.rank+".");if("int32"!==t.dtype)throw new Error("The dtype of 'indices' should be int32, but got dtype: "+t.dtype);if(r.length<1)throw new Error("Output rank must be greater or equal to 1, but got shape: "+r);if(0===r.length){if(0===t.size)throw new Error("Indices specified for empty output. indices shape: "+t.shape);if(0===e.size)throw new Error("Updates specified for empty output. updates shape: "+e.shape)}validateUpdateShape(r,t,e)}function calculateShapes(e,t,r){for(var n=t.rank>1?t.shape[t.rank-1]:1,o=r.length,a=1,i=n;i<o;++i)a*=r[i];var s=n<1?1:n,u=t.size/s,l=computeStrides(r).concat([1]);return{sliceRank:n,numUpdates:u,sliceSize:a,strides:l.slice(l.length-n,l.length),outputSize:sizeFromShape(r)}}function segOpComputeOptimalWindowSize(e,t){var r,n=!1;for(e<=PARALLELIZE_THRESHOLD?(r=e,n=!0):r=nearestDivisor(e,Math.floor(Math.sqrt(e)));!n;){if(r>t||r===e){n=!0;break}r=nearestDivisor(e,r+1)}return r}function computeOutShape$1(e,t,r){for(var n=[],o=e.length,a=0;a<o;a++)a!==t?n.push(e[a]):n.push(r);return n}function assertParamsValid(e,t,r){assert(e.rank===t.length,"Error in slice"+e.rank+"D: Length of begin "+t+" must match the rank of the array ("+e.rank+")."),assert(e.rank===r.length,"Error in slice"+e.rank+"D: Length of size "+r+" must match the rank of the array ("+e.rank+").");for(var n=0;n<e.rank;++n)assert(t[n]+r[n]<=e.shape[n],"Error in slice"+e.rank+"D: begin["+n+"] + size["+n+"] ("+(t[n]+r[n])+") would overflow input.shape["+n+"] ("+e.shape[n]+")")}function getStridedSlicedInfo(e,t,r,n,o,a,i,s,u){if(void 0===o&&(o=0),void 0===a&&(a=0),void 0===i&&(i=0),void 0===s&&(s=0),void 0===u&&(u=0),0!==i)throw new Error("ellipsis mask is not yet supported");if(0!==s)throw new Error("new axis mask is not yet supported");for(var l=[],c=[],p=[],d=0;d<e.length;d++)l[d]=startForAxis(o,t,n,e,d),c[d]=stopForAxis(a,r,n,e,d),u&1<<d&&(c[d]=l[d]+1,p.push(d));var h=new Array(e.length).fill(0);return h=h.map(function(e,t){for(var r=0,o=l[t];!(n[t]>0?o>=c[t]:o<=c[t]);o+=n[t])r+=1;return r}),[l,h,p]}function startForAxis(e,t,r,n,o){var a=t[o];e&1<<o&&(a=r[o]>0?Number.MIN_SAFE_INTEGER:Number.MAX_SAFE_INTEGER);var i=n[o];return a<0&&(a+=i),a=clamp(0,a,i-1)}function stopForAxis(e,t,r,n,o){var a=t[o];e&1<<o&&(a=r[o]>0?Number.MAX_SAFE_INTEGER:Number.MIN_SAFE_INTEGER);var i=n[o];return a<0&&(a+=i),a=r[o]>0?clamp(0,a,i):clamp(-1,a,i-1)}function inferShape(e){var t=e;if(isTypedArray(e))return[e.length];if(!Array.isArray(e))return[];for(var r=[];t instanceof Array;)r.push(t.length),t=t[0];return e instanceof Array&&ENV.get("TENSORLIKE_CHECK_SHAPE_CONSISTENCY")&&deepAssertShapeConsistency(e,r,[]),r}function deepAssertShapeConsistency(e,t,r){if(r=r||[],e instanceof Array){assert(t.length>0,function(){return"Element arr["+r.join("][")+"] should be a primitive, but is an array of "+e.length+" elements"}),assert(e.length===t[0],function(){return"Element arr["+r.join("][")+"] should have "+t[0]+" elements, but has "+e.length+" elements"});for(var n=t.slice(1),o=0;o<e.length;++o)deepAssertShapeConsistency(e[o],n,r.concat(o))}else assert(0===t.length,function(){return"Element arr["+r.join("][")+"] is a primitive, but should be an array of "+t[0]+" elements"})}function convertToTensor(e,t,r,n){if(void 0===n&&(n="float32"),n=n||"float32",e instanceof Tensor)return e;if(!isTypedArray(e)&&!Array.isArray(e)&&"number"!=typeof e&&"boolean"!=typeof e)throw new Error("Argument '"+t+"' passed to '"+r+"' must be a Tensor or TensorLike, but got "+e.constructor.name);var o=inferShape(e);return isTypedArray(e)||Array.isArray(e)||(e=[e]),Tensor.make(o,{values:toTypedArray(e,n,ENV.get("DEBUG"))},n)}function convertToTensorArray(e,t,r){if(!Array.isArray(e))throw new Error("Argument "+t+" passed to "+r+" must be a `Tensor[]` or `TensorLike[]`");return e.map(function(e,n){return convertToTensor(e,t+"["+n+"]",r)})}function op(e){var t=Object.keys(e);if(1!==t.length)throw new Error("Please provide an object with a single key (operation name) mapping to a function. Got an object with "+t.length+" keys.");var r=t[0],n=e[r];r.endsWith("_")&&(r=r.substring(0,r.length-1));var o=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];ENV.engine.startScope(r);try{var o=n.apply(void 0,e);return o instanceof Promise&&console.error("Cannot return a Promise inside of tidy."),ENV.engine.endScope(o),o}catch(e){throw ENV.engine.endScope(null),e}};return Object.defineProperty(o,"name",{value:r,configurable:!0}),o}function softmax_(e,t){void 0===t&&(t=-1);var r=convertToTensor(e,"logits","softmax");if(-1===t&&(t=r.rank-1),t!==r.rank-1)throw Error("Softmax along a non-last dimension is not yet supported. Logits was rank "+r.rank+" and dim was "+t);return customGrad(function(e){var r=e.logSumExp([t],!0),n=e.toFloat().sub(r).exp();return{value:n,gradFunc:function(e){var r=e.mul(n);return r.sub(r.sum([t],!0).mul(n))}}})(r)}function logSoftmax_(e,t){void 0===t&&(t=-1);var r=convertToTensor(e,"logits","logSoftmax");if(-1===t&&(t=r.rank-1),t!==r.rank-1)throw Error("Log Softmax along a non-last dimension is not yet supported. Logits was rank "+r.rank+" and axis was "+t);return customGrad(function(e){var r=e.max(t,!0),n=e.sub(r),o=n.toFloat().sub(n.exp().sum(t,!0).log());return{value:o,gradFunc:function(e){var r=o.exp();return e.sub(e.sum(t,!0).mul(r))}}})(r)}var softmax=op({softmax_:softmax_}),logSoftmax=op({logSoftmax_:logSoftmax_});function complex_(e,t){var r=convertToTensor(e,"real","complex"),n=convertToTensor(t,"imag","complex");return assertShapesMatch(r.shape,n.shape,"real and imag shapes, "+r.shape+" and "+n.shape+", must match in call to tf.complex()."),ENV.engine.runKernel(function(e){return e.complex(r,n)},{$real:r,$imag:n})}function real_(e){var t=convertToTensor(e,"input","real");return ENV.engine.runKernel(function(e){return e.real(t)},{$input:t})}function imag_(e){var t=convertToTensor(e,"input","imag");return ENV.engine.runKernel(function(e){return e.imag(t)},{$input:t})}var complex=op({complex_:complex_}),real=op({real_:real_}),imag=op({imag_:imag_});function tensor(e,t,r){if(void 0===r&&(r="float32"),"complex64"===r)throw new Error("Cannot construct a complex64 tensor directly. Please use tf.complex(real, imag).");if(!isTypedArray(e)&&!Array.isArray(e)&&"number"!=typeof e&&"boolean"!=typeof e)throw new Error("values passed to tensor(values) must be an array of numbers or booleans, or a TypedArray");var n=inferShape(e);return null!=t&&1!==n.length&&assertShapesMatch(t,n,"Error creating a new Tensor. Inferred shape ("+n+") does not match the provided shape ("+t+"). "),isTypedArray(e)||Array.isArray(e)||(e=[e]),t=t||n,Tensor.make(t,{values:toTypedArray(e,r,ENV.get("DEBUG"))},r)}function scalar(e,t){if(void 0===t&&(t="float32"),(isTypedArray(e)||Array.isArray(e))&&"complex64"!==t)throw new Error("Error creating a new Scalar: value must be a primitive (number|boolean)");return tensor(e,[],t)}function tensor1d(e,t){void 0===t&&(t="float32"),assertNonNull(e);var r=inferShape(e);if(1!==r.length)throw new Error("tensor1d() requires values to be a flat/TypedArray");return tensor(e,r,t)}function tensor2d(e,t,r){if(void 0===r&&(r="float32"),assertNonNull(e),null!=t&&2!==t.length)throw new Error("tensor2d() requires shape to have two numbers");var n=inferShape(e);if(2!==n.length&&1!==n.length)throw new Error("tensor2d() requires values to be number[][] or flat/TypedArray");if(1===n.length&&null==t)throw new Error("tensor2d() requires shape to be provided when `values` are a flat/TypedArray");return tensor(e,t=t||n,r)}function tensor3d(e,t,r){if(void 0===r&&(r="float32"),assertNonNull(e),null!=t&&3!==t.length)throw new Error("tensor3d() requires shape to have three numbers");var n=inferShape(e);if(3!==n.length&&1!==n.length)throw new Error("tensor3d() requires values to be number[][][] or flat/TypedArray");if(1===n.length&&null==t)throw new Error("tensor3d() requires shape to be provided when `values` are a flat array");return tensor(e,t=t||n,r)}function tensor4d(e,t,r){if(void 0===r&&(r="float32"),assertNonNull(e),null!=t&&4!==t.length)throw new Error("tensor4d() requires shape to have four numbers");var n=inferShape(e);if(4!==n.length&&1!==n.length)throw new Error("tensor4d() requires values to be number[][][][] or flat/TypedArray");if(1===n.length&&null==t)throw new Error("tensor4d() requires shape to be provided when `values` are a flat array");return tensor(e,t=t||n,r)}function tensor5d(e,t,r){if(void 0===r&&(r="float32"),assertNonNull(e),null!=t&&5!==t.length)throw new Error("tensor5d() requires shape to have five numbers");var n=inferShape(e);if(5!==n.length&&1!==n.length)throw new Error("tensor5d() requires values to be number[][][][][] or flat/TypedArray");if(1===n.length&&null==t)throw new Error("tensor5d() requires shape to be provided when `values` are a flat array");return tensor(e,t=t||n,r)}function tensor6d(e,t,r){if(void 0===r&&(r="float32"),assertNonNull(e),null!=t&&6!==t.length)throw new Error("tensor6d() requires shape to have six numbers");var n=inferShape(e);if(6!==n.length&&1!==n.length)throw new Error("tensor6d() requires values to be number[][][][] or flat/TypedArray");if(1===n.length&&null==t)throw new Error("tensor6d() requires shape to be provided when `values` are a flat array");return tensor(e,t=t||n,r)}function ones$1(e,t){if(void 0===t&&(t="float32"),"complex64"===t){var r=ones$1(e,"float32"),n=ones$1(e,"float32");return complex(r,n)}var o=makeOnesTypedArray(sizeFromShape(e),t);return Tensor.make(e,{values:o},t)}function zeros(e,t){if(void 0===t&&(t="float32"),"complex64"===t){var r=zeros(e,"float32"),n=zeros(e,"float32");return complex(r,n)}var o=makeZerosTypedArray(sizeFromShape(e),t);return Tensor.make(e,{values:o},t)}function fill(e,t,r){void 0===r&&(r="float32");var n=getTypedArrayFromDType(r,sizeFromShape(e));return n.fill(t),Tensor.make(e,{values:n},r)}function onesLike_(e){var t=convertToTensor(e,"x","onesLike");return ones$1(t.shape,t.dtype)}function zerosLike_(e){var t=convertToTensor(e,"x","zerosLike");return zeros(t.shape,t.dtype)}function linspace(e,t,r){if(0===r)throw new Error("Cannot request zero samples");var n=(t-e)/(r-1),o=makeZerosTypedArray(r,"float32");o[0]=e;for(var a=1;a<o.length;a++)o[a]=o[a-1]+n;return tensor1d(o,"float32")}function range(e,t,r,n){if(void 0===r&&(r=1),void 0===n&&(n="float32"),0===r)throw new Error("Cannot have a step of zero");if(e===t||e<t&&r<0||t<e&&r>1)return zeros([0],n);var o=makeZerosTypedArray(Math.abs(Math.ceil((t-e)/r)),n);t<e&&1===r&&(r=-1),o[0]=e;for(var a=1;a<o.length;a++)o[a]=o[a-1]+r;return tensor1d(o,n)}var DType,Rank,UpcastInt32AndMap,UpcastBoolAndMap,UpcastFloat32AndMap,UpcastComplex64AndMap,onesLike=op({onesLike_:onesLike_}),zerosLike=op({zerosLike_:zerosLike_});!function(e){e.float32="float32",e.int32="int32",e.bool="bool"}(DType||(DType={})),function(e){e.R0="R0",e.R1="R1",e.R2="R2",e.R3="R3",e.R4="R4",e.R5="R5",e.R6="R6"}(Rank||(Rank={})),function(e){e.float32="float32",e.int32="int32",e.bool="int32",e.complex64="complex64"}(UpcastInt32AndMap||(UpcastInt32AndMap={})),function(e){e.float32="float32",e.int32="int32",e.bool="bool",e.complex64="complex64"}(UpcastBoolAndMap||(UpcastBoolAndMap={})),function(e){e.float32="float32",e.int32="float32",e.bool="float32",e.complex64="complex64"}(UpcastFloat32AndMap||(UpcastFloat32AndMap={})),function(e){e.float32="complex64",e.int32="complex64",e.bool="complex64",e.complex64="complex64"}(UpcastComplex64AndMap||(UpcastComplex64AndMap={}));var upcastTypeMap={float32:UpcastFloat32AndMap,int32:UpcastInt32AndMap,bool:UpcastBoolAndMap,complex64:UpcastComplex64AndMap};function upcastType(e,t){return upcastTypeMap[e][t]}function sumOutType(e){return upcastType(e,"int32")}var DataStorage=function(){function e(e){this.dataMover=e,this.data=new WeakMap}return e.prototype.get=function(e){return this.data.has(e)||this.dataMover.moveData(e),this.data.get(e)},e.prototype.set=function(e,t){this.data.set(e,t)},e.prototype.has=function(e){return this.data.has(e)},e.prototype.delete=function(e){return this.data.delete(e)},e}(),KernelBackend=function(){function e(){}return e.prototype.time=function(e){throw new Error("Not yet implemented.")},e.prototype.read=function(e){throw new Error("Not yet implemented.")},e.prototype.readSync=function(e){throw new Error("Not yet implemented.")},e.prototype.disposeData=function(e){throw new Error("Not yet implemented.")},e.prototype.write=function(e,t){throw new Error("Not yet implemented.")},e.prototype.fromPixels=function(e,t){throw new Error("Not yet implemented.")},e.prototype.register=function(e,t,r){throw new Error("Not yet implemented.")},e.prototype.memory=function(){throw new Error("Not yet implemented.")},e.prototype.floatPrecision=function(){throw new Error("Not yet implemented")},e.prototype.batchMatMul=function(e,t,r,n){throw new Error("Not yet implemented")},e.prototype.slice=function(e,t,r){throw new Error("Not yet implemented")},e.prototype.stridedSlice=function(e,t,r,n,o,a,i,s,u){throw new Error("Not yet implemented")},e.prototype.reverse=function(e,t){throw new Error("Not yet implemented")},e.prototype.concat=function(e,t){throw new Error("Not yet implemented")},e.prototype.neg=function(e){throw new Error("Not yet implemented")},e.prototype.add=function(e,t){throw new Error("Not yet implemented")},e.prototype.addN=function(e){throw new Error("Not yet implemented")},e.prototype.subtract=function(e,t){throw new Error("Not yet implemented")},e.prototype.multiply=function(e,t){throw new Error("Not yet implemented")},e.prototype.realDivide=function(e,t){throw new Error("Not yet implemented")},e.prototype.floorDiv=function(e,t){throw new Error("Not yet implemented")},e.prototype.sum=function(e,t){throw new Error("Not yet implemented")},e.prototype.prod=function(e,t){throw new Error("Not yet implemented")},e.prototype.unsortedSegmentSum=function(e,t,r){throw new Error("Not yet implemented")},e.prototype.argMin=function(e,t){throw new Error("Not yet implemented")},e.prototype.argMax=function(e,t){throw new Error("Not yet implemented")},e.prototype.equal=function(e,t){throw new Error("Not yet implemented")},e.prototype.notEqual=function(e,t){throw new Error("Not yet implemented")},e.prototype.less=function(e,t){throw new Error("Not yet implemented")},e.prototype.lessEqual=function(e,t){throw new Error("Not yet implemented")},e.prototype.greater=function(e,t){throw new Error("Not yet implemented")},e.prototype.greaterEqual=function(e,t){throw new Error("Not yet implemented")},e.prototype.logicalNot=function(e){throw new Error("Not yet implemented")},e.prototype.logicalAnd=function(e,t){throw new Error("Not yet implemented")},e.prototype.logicalOr=function(e,t){throw new Error("Not yet implemented")},e.prototype.where=function(e){throw new Error("Not yet implemented")},e.prototype.select=function(e,t,r){throw new Error("Not yet implemented")},e.prototype.topk=function(e,t,r){throw new Error("Not yet implemented")},e.prototype.min=function(e,t){throw new Error("Not yet implemented")},e.prototype.minimum=function(e,t){throw new Error("Not yet implemented")},e.prototype.mod=function(e,t){throw new Error("Not yet implemented")},e.prototype.max=function(e,t){throw new Error("Not yet implemented")},e.prototype.maximum=function(e,t){throw new Error("Not yet implemented")},e.prototype.all=function(e,t){throw new Error("Not yet implemented")},e.prototype.any=function(e,t){throw new Error("Not yet implemented")},e.prototype.squaredDifference=function(e,t){throw new Error("Not yet implemented")},e.prototype.ceil=function(e){throw new Error("Not yet implemented")},e.prototype.floor=function(e){throw new Error("Not yet implemented")},e.prototype.round=function(e){throw new Error("Not yet implemented")},e.prototype.sign=function(e){throw new Error("Not yet implemented")},e.prototype.pow=function(e,t){throw new Error("Not yet implemented")},e.prototype.exp=function(e){throw new Error("Not yet implemented")},e.prototype.expm1=function(e){throw new Error("Not yet implemented")},e.prototype.log=function(e){throw new Error("Not yet implemented")},e.prototype.log1p=function(e){throw new Error("Not yet implemented")},e.prototype.sqrt=function(e){throw new Error("Not yet implemented")},e.prototype.rsqrt=function(e){throw new Error("Not yet implemented")},e.prototype.square=function(e){throw new Error("Not yet implemented")},e.prototype.reciprocal=function(e){throw new Error("Not yet implemented")},e.prototype.relu=function(e){throw new Error("Not yet implemented")},e.prototype.elu=function(e){throw new Error("Not yet implemented")},e.prototype.eluDer=function(e,t){throw new Error("Not yet implemented")},e.prototype.selu=function(e){throw new Error("Not yet implemented")},e.prototype.int=function(e){throw new Error("Not yet implemented")},e.prototype.clip=function(e,t,r){throw new Error("Not yet implemented")},e.prototype.abs=function(e){throw new Error("Not yet implemented")},e.prototype.complexAbs=function(e){throw new Error("Not yet implemented")},e.prototype.sigmoid=function(e){throw new Error("Not yet implemented")},e.prototype.softplus=function(e){throw new Error("Not yet implemented")},e.prototype.sin=function(e){throw new Error("Not yet implemented")},e.prototype.cos=function(e){throw new Error("Not yet implemented")},e.prototype.tan=function(e){throw new Error("Not yet implemented")},e.prototype.asin=function(e){throw new Error("Not yet implemented")},e.prototype.acos=function(e){throw new Error("Not yet implemented")},e.prototype.atan=function(e){throw new Error("Not yet implemented")},e.prototype.atan2=function(e,t){throw new Error("Not yet implemented")},e.prototype.sinh=function(e){throw new Error("Not yet implemented")},e.prototype.cosh=function(e){throw new Error("Not yet implemented")},e.prototype.tanh=function(e){throw new Error("Not yet implemented")},e.prototype.asinh=function(e){throw new Error("Not yet implemented")},e.prototype.acosh=function(e){throw new Error("Not yet implemented")},e.prototype.atanh=function(e){throw new Error("Not yet implemented")},e.prototype.erf=function(e){throw new Error("Not yet implemented")},e.prototype.step=function(e,t){throw new Error("Not yet implemented")},e.prototype.conv2d=function(e,t,r){throw new Error("Not yet implemented")},e.prototype.conv2dDerInput=function(e,t,r){throw new Error("Not yet implemented")},e.prototype.conv2dDerFilter=function(e,t,r){throw new Error("Not yet implemented")},e.prototype.depthwiseConv2D=function(e,t,r){throw new Error("Not yet implemented")},e.prototype.depthwiseConv2DDerInput=function(e,t,r){throw new Error("Not yet implemented")},e.prototype.depthwiseConv2DDerFilter=function(e,t,r){throw new Error("Not yet implemented")},e.prototype.maxPool=function(e,t){throw new Error("Not yet implemented")},e.prototype.maxPoolBackprop=function(e,t,r,n){throw new Error("Not yet implemented")},e.prototype.avgPool=function(e,t){throw new Error("Not yet implemented")},e.prototype.avgPoolBackprop=function(e,t,r){throw new Error("Not yet implemented")},e.prototype.reshape=function(e,t){throw new Error("Not yet implemented")},e.prototype.cast=function(e,t){throw new Error("Not yet implemented")},e.prototype.tile=function(e,t){throw new Error("Not yet implemented")},e.prototype.pad=function(e,t,r){throw new Error("Not yet implemented")},e.prototype.transpose=function(e,t){throw new Error("Not yet implemented")},e.prototype.gather=function(e,t,r){throw new Error("Not yet implemented")},e.prototype.gatherND=function(e,t){throw new Error("Not yet implemented")},e.prototype.scatterND=function(e,t,r){throw new Error("Not yet implemented")},e.prototype.batchToSpaceND=function(e,t,r){throw new Error("Not yet implemented")},e.prototype.spaceToBatchND=function(e,t,r){throw new Error("Not yet implemented")},e.prototype.resizeBilinear=function(e,t,r,n){throw new Error("Not yet implemented")},e.prototype.resizeBilinearBackprop=function(e,t,r){throw new Error("Not yet implemented")},e.prototype.resizeNearestNeighbor=function(e,t,r,n){throw new Error("Not yet implemented")},e.prototype.resizeNearestNeighborBackprop=function(e,t,r){throw new Error("Not yet implemented")},e.prototype.batchNormalization=function(e,t,r,n,o,a){throw new Error("Not yet implemented")},e.prototype.localResponseNormalization4D=function(e,t,r,n,o){throw new Error("Not yet implemented")},e.prototype.LRNGrad=function(e,t,r,n,o,a,i){throw new Error("Not yet implemented")},e.prototype.multinomial=function(e,t,r,n){throw new Error("Not yet implemented")},e.prototype.oneHot=function(e,t,r,n){throw new Error("Not yet implemented")},e.prototype.cumsum=function(e,t,r,n){throw new Error("Not yet implemented")},e.prototype.nonMaxSuppression=function(e,t,r,n,o){throw new Error("Not yet implemented")},e.prototype.fft=function(e){throw new Error("Not yet implemented")},e.prototype.ifft=function(e){throw new Error("Not yet implemented")},e.prototype.complex=function(e,t){throw new Error("Not yet implemented")},e.prototype.real=function(e){throw new Error("Not yet implemented")},e.prototype.imag=function(e){throw new Error("Not yet implemented")},e.prototype.cropAndResize=function(e,t,r,n,o,a){throw new Error("Not yet implemented")},e.prototype.depthToSpace=function(e,t,r){throw new Error("Not yet implemented")},e.prototype.split=function(e,t,r){throw new Error("Not yet implemented")},e.prototype.sparseToDense=function(e,t,r,n){throw new Error("Not yet implemented")},e.prototype.setDataMover=function(e){throw new Error("Not yet implemented")},e.prototype.dispose=function(){throw new Error("Not yet implemented")},e}();function castTensor(e,t,r){if("complex64"===t){if("complex64"===e.dtype)return e.clone();var n=zeros(e.shape),o=e.toFloat(),a=r.complex(o,n);return n.dispose(),o.dispose(),a}if(!hasEncodingLoss(e.dtype,t))return Tensor.make(e.shape,{dataId:e.dataId},t);if("complex64"===e.dtype){var i=r.real(e);a=i.cast(t);return i.dispose(),a}if("int32"===t)return r.int(e);if("bool"===t){var s=scalar(0,e.dtype);a=r.notEqual(e,s);return s.dispose(),a}throw new Error("Error in Cast: unknown dtype argument ("+t+")")}function reshapeTensor(e,t){return Tensor.make(t,{dataId:e.dataId},e.dtype)}function mergeRealAndImagArrays(e,t){if(e.length!==t.length)throw new Error("Cannot merge real and imag arrays of different lengths. real:"+e.length+", imag: "+t.length+".");for(var r=new Float32Array(2*e.length),n=0;n<r.length;n+=2)r[n]=e[n/2],r[n+1]=t[n/2];return r}function splitRealAndImagArrays(e){for(var t=new Float32Array(e.length/2),r=new Float32Array(e.length/2),n=0;n<e.length;n+=2)t[n/2]=e[n],r[n/2]=e[n+1];return{real:t,imag:r}}function complexWithEvenIndex(e){for(var t=Math.ceil(e.length/4),r=new Float32Array(t),n=new Float32Array(t),o=0;o<e.length;o+=4)r[Math.floor(o/4)]=e[o],n[Math.floor(o/4)]=e[o+1];return{real:r,imag:n}}function complexWithOddIndex(e){for(var t=Math.floor(e.length/4),r=new Float32Array(t),n=new Float32Array(t),o=2;o<e.length;o+=4)r[Math.floor(o/4)]=e[o],n[Math.floor(o/4)]=e[o+1];return{real:r,imag:n}}function getComplexWithIndex(e,t){return{real:e[2*t],imag:e[2*t+1]}}function assignToTypedArray(e,t,r,n){e[2*n]=t,e[2*n+1]=r}function exponents(e,t){for(var r=new Float32Array(e/2),n=new Float32Array(e/2),o=0;o<Math.ceil(e/2);o++){var a=(t?2:-2)*Math.PI*(o/e);r[o]=Math.cos(a),n[o]=Math.sin(a)}return{real:r,imag:n}}function exponent(e,t,r){var n=(r?2:-2)*Math.PI*(e/t);return{real:Math.cos(n),imag:Math.sin(n)}}function nonMaxSuppressionImpl(e,t,r,n,o){for(var a=Array.from(t).map(function(e,t){return{score:e,boxIndex:t}}).filter(function(e){return e.score>o}).sort(function(e,t){return t.score-e.score}),i=[],s=0;s<a.length;s++){var u=a[s],l=u.score,c=u.boxIndex;if(l<o)break;for(var p=!1,d=i.length-1;d>=0;--d){if(intersectionOverUnion(e,c,i[d])>=n){p=!0;break}}if(!p&&(i.push(c),i.length>=r))break}return tensor1d(i,"int32")}function intersectionOverUnion(e,t,r){var n=e.subarray(4*t,4*t+4),o=e.subarray(4*r,4*r+4),a=Math.min(n[0],n[2]),i=Math.min(n[1],n[3]),s=Math.max(n[0],n[2]),u=Math.max(n[1],n[3]),l=Math.min(o[0],o[2]),c=Math.min(o[1],o[3]),p=Math.max(o[0],o[2]),d=Math.max(o[1],o[3]),h=(s-a)*(u-i),f=(p-l)*(d-c);if(h<=0||f<=0)return 0;var m=Math.max(a,l),g=Math.max(i,c),v=Math.min(s,p),y=Math.min(u,d),x=Math.max(v-m,0)*Math.max(y-g,0);return x/(h+f-x)}function split(e,t,r){var n=Array(e.rank).fill(0),o=e.shape.slice();return t.map(function(t){o[r]=t;var a=e.slice(n,o);return n[r]+=t,a})}function topkImpl(e,t,r,n,o){for(var a=t[t.length-1],i=[e.length/a,a],s=i[0],u=i[1],l=getTypedArrayFromDType(r,s*n),c=getTypedArrayFromDType("int32",s*n),p=0;p<s;p++){for(var d=p*u,h=e.subarray(d,d+u),f=[],m=0;m<h.length;m++)f.push({value:h[m],index:m});f.sort(function(e,t){return t.value-e.value});var g=p*n,v=l.subarray(g,g+n),y=c.subarray(g,g+n);for(m=0;m<n;m++)v[m]=f[m].value,y[m]=f[m].index}var x=t.slice();return x[x.length-1]=n,[tensor(l,x,r),tensor(c,x,"int32")]}var ArgMinMaxProgram=function(){return function(e,t,r){this.variableNames=["A"];var n=e.windowSize,o=e.batchSize,a=e.inSize,i=Math.ceil(a/n);r||this.variableNames.push("bestIndicesA"),this.outputShape=[o,i];var s="max"===t?">":"<",u=r?"inOffset + i;":"round(getBestIndicesA(batch, inOffset + i));";this.userCode="\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n        int outIdx = coords[1];\n        int inOffset = outIdx * "+n+";\n\n        int bestIndex = inOffset;\n        float bestValue = getA(batch, bestIndex);\n\n        for (int i = 0; i < "+n+"; i++) {\n          int inIdx = "+u+";\n          float candidate = getA(batch, inIdx);\n          if (candidate "+s+" bestValue) {\n            bestValue = candidate;\n            bestIndex = inIdx;\n          }\n        }\n        setOutput(float(bestIndex));\n      }\n    "}}(),AvgPool2DBackpropProgram=function(){return function(e){this.variableNames=["dy"],this.outputShape=e.inShape;var t=e.filterHeight,r=e.filterWidth,n=e.strideHeight,o=e.strideWidth,a=e.dilationHeight,i=e.dilationWidth,s=e.effectiveFilterHeight,u=e.effectiveFilterWidth,l=s-1-e.padInfo.top,c=u-1-e.padInfo.left,p=1/(t*r);this.userCode="\n      const ivec2 pads = ivec2("+l+", "+c+");\n      const float avgMultiplier = float("+p+");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n\n        ivec2 dyRCCorner = coords.yz - pads;\n        int dyRCorner = dyRCCorner.x;\n        int dyCCorner = dyRCCorner.y;\n\n        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < "+s+";\n            wR += "+a+") {\n          float dyR = float(dyRCorner + wR) / "+n+".0;\n\n          if (dyR < 0.0 || dyR >= "+e.outHeight+".0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          for (int wC = 0; wC < "+u+";\n            wC+= "+i+") {\n            float dyC = float(dyCCorner + wC) / "+o+".0;\n\n            if (dyC < 0.0 || dyC >= "+e.outWidth+".0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            float dyValue = getDy(b, idyR, idyC, d);\n\n            dotProd += dyValue * avgMultiplier;\n          }\n        }\n        setOutput(dotProd);\n      }\n    "}}();function getBroadcastDims(e,t){for(var r=e.length,n=[],o=0;o<r;o++){var a=r-1-o,i=e[a]||1;(t[t.length-1-o]||1)>1&&1===i&&n.unshift(a)}return n}function getReductionAxes(e,t){for(var r=[],n=0;n<t.length;n++){var o=e[e.length-n-1],a=t.length-n-1,i=t[a];(null==o||1===o&&i>1)&&r.unshift(a)}return r}function broadcastDimsAreOuter(e){for(var t=0;t<e.length;t++)if(e[t]!==t)return!1;return!0}function assertAndGetBroadcastShape(e,t){for(var r=[],n=Math.max(e.length,t.length),o=0;o<n;o++){var a=e[e.length-o-1];null==a&&(a=1);var i=t[t.length-o-1];if(null==i&&(i=1),1===a)r.unshift(i);else if(1===i)r.unshift(a);else{if(a!==i)throw Error("Operands could not be broadcast together with shapes "+e+" and "+t+".");r.unshift(a)}}return r}var BatchNormProgram=function(){return function(e,t,r,n,o,a){this.outputShape=[],this.supportsBroadcasting=!0,this.variableNames=["x","mean","variance"],assertAndGetBroadcastShape(e,t),assertAndGetBroadcastShape(e,r);var i="0.0";null!=n&&(assertAndGetBroadcastShape(e,n),this.variableNames.push("offset"),i="getOffsetAtOutCoords()");var s="1.0";null!=o&&(assertAndGetBroadcastShape(e,o),this.variableNames.push("scale"),s="getScaleAtOutCoords()"),this.outputShape=e,this.userCode="\n      void main() {\n        float x = getXAtOutCoords();\n        float mean = getMeanAtOutCoords();\n        float variance = getVarianceAtOutCoords();\n        float offset = "+i+";\n        float scale = "+s+";\n        float inv = scale * inversesqrt(variance + float("+a+"));\n        setOutput(dot(vec3(x, -mean, offset), vec3(inv, inv, 1)));\n      }\n    "}}(),BatchNormPackedProgram=function(){return function(e,t,r,n,o,a){this.supportsBroadcasting=!0,this.usesPackedTextures=!0,this.variableNames=["x","mean","variance"],assertAndGetBroadcastShape(e,t),assertAndGetBroadcastShape(e,r);var i=broadcastSample("mean",t.length),s=broadcastSample("variance",r.length),u="vec4 offset = vec4(0.0)";null!=n&&(assertAndGetBroadcastShape(e,n),this.variableNames.push("offset"),u=broadcastSample("offset",n.length));var l="vec4 scale = vec4(1.0)";null!=o&&(assertAndGetBroadcastShape(e,o),this.variableNames.push("scale"),l=broadcastSample("scale",o.length)),this.outputShape=e,this.userCode="\n      void main() {\n        ivec4 rc = getOutputCoords();\n\n        "+u+";\n        "+l+";\n\n        vec4 x = getX(rc.x, rc.y, rc.z, rc.w);\n        "+i+";\n        "+s+";\n\n        vec4 inv = scale * inversesqrt(variance + vec4("+a+"));\n\n        setOutput((x - mean) * inv + offset);\n      }\n    "}}();function broadcastSample(e,t){var r="get"+e.charAt(0).toUpperCase()+e.slice(1);return 1===t?"\n      vec4 "+e+"Sample = "+r+"(rc.w);\n      vec4 "+e+" = vec4("+e+"Sample.xy, "+e+"Sample.xy);\n    ":"vec4 "+e+" = "+r+"(rc.x, rc.y, rc.z, rc.w)"}var COMPLEX_MULTIPLY={REAL:"return areal * breal - aimag * bimag;",IMAG:"return areal * bimag + aimag * breal;"},BinaryOpComplexProgram=function(){return function(e,t,r){this.variableNames=["AReal","AImag","BReal","BImag"],this.supportsBroadcasting=!0,this.outputShape=assertAndGetBroadcastShape(t,r),this.userCode="\n      float binaryOpComplex(\n          float areal, float aimag, float breal, float bimag) {\n        "+e+"\n      }\n\n      void main() {\n        float areal = getARealAtOutCoords();\n        float aimag = getAImagAtOutCoords();\n        float breal = getBRealAtOutCoords();\n        float bimag = getBImagAtOutCoords();\n        setOutput(binaryOpComplex(areal, aimag, breal, bimag));\n      }\n    "}}(),CHECK_NAN_SNIPPET="\n  if (isNaN(a)) return a;\n  if (isNaN(b)) return b;\n",ADD="return a + b;",SUB="return a - b;",MUL="return a * b;",DIV="if (a == b) return 1.0;\n  return a / b;",INT_DIV="\n  float resultSign = sign(a) * sign(b);\n  int ia = round(a);\n  int ib = round(b);\n  int result = ia / ib;\n  int amodb = ia - ib * result;\n\n  if (resultSign < 0.0 && amodb != 0) {\n    result -= 1;\n  }\n  return float(result);\n",POW="\nif(a < 0.0 && floor(b) < b){\n  return NAN;\n}\nreturn (round(mod(b, 2.0)) == 0 || round(mod(b, 2.0)) == 2) ?\n    pow(abs(a), b) : sign(a) * pow(abs(a), b);\n",SQUARED_DIFFERENCE="return (a - b) * (a - b);",EQUAL="return float(a == b);",NOT_EQUAL="return float(a != b);",LESS="return float(a < b);",LESS_EQUAL="return float(a <= b);",GREATER="return float(a > b);",GREATER_EQUAL="return float(a >= b);",LOGICAL_AND="return float(a >= 1.0 && b >= 1.0);",LOGICAL_OR="return float(a >= 1.0 || b >= 1.0);",MAX=CHECK_NAN_SNIPPET+"\n  return max(a, b);\n",MIN=CHECK_NAN_SNIPPET+"\n  return min(a, b);\n",MOD="if (b == 0.0) return NAN;\n  return mod(a, b);",ATAN2=CHECK_NAN_SNIPPET+"\n  return atan(a, b);\n",ELU_DER="return (b >= 1.0) ? a : a * (b + 1.0);",BinaryOpProgram=function(){function e(e,t,r){this.variableNames=["A","B"],this.supportsBroadcasting=!0,this.outputShape=assertAndGetBroadcastShape(t,r),this.userCode="\n      uniform float NAN;\n      float binaryOperation(float a, float b) {\n        "+e+"\n      }\n\n      void main() {\n        float a = getAAtOutCoords();\n        float b = getBAtOutCoords();\n        setOutput(binaryOperation(a, b));\n      }\n    "}return e.prototype.getCustomSetupFunc=function(){var e=this;return function(t,r){null==e.startLoc&&(e.startLoc=t.getUniformLocationNoThrow(r,"NAN"),null==e.startLoc)||t.gl.uniform1f(e.startLoc,NaN)}},e}(),ClipProgram=function(){return function(e,t,r){this.variableNames=["A"],this.outputShape=e,this.userCode="\n      void main() {\n        float value = getAAtOutCoords();\n        if (isNaN(value)) {\n          setOutput(value);\n          return;\n        }\n\n        setOutput(clamp(value, float("+t+"), float("+r+")));\n      }\n    "}}(),ComplexAbsProgram=function(){return function(e){this.variableNames=["real","imag"],this.outputShape=e,this.userCode="\n      void main() {\n        float real = getRealAtOutCoords();\n        float imag = getImagAtOutCoords();\n        vec2 v = vec2(real, imag);\n\n        setOutput(sqrt(dot(v, v)));\n      }\n    "}}(),ConcatProgram=function(){return function(e,t){this.variableNames=["A","B"],this.outputShape=[],this.outputShape=computeOutShape([e,t],1),this.userCode="\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int yR = coords.x;\n        int yC = coords.y;\n\n        float value = 0.0;\n        if (yC < "+e[1]+") {\n          value = getA(yR, yC);\n        } else {\n          yC -= "+e[1]+";\n          value = getB(yR, yC);\n        }\n\n        setOutput(value);\n      }\n    "}}(),Conv2DDerFilterProgram=function(){return function(e){this.variableNames=["x","dy"],this.outputShape=e.filterShape;var t=e.strideHeight,r=e.strideWidth,n=e.padInfo.top,o=e.padInfo.left;this.userCode="\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int wR = coords.x;\n        int wC = coords.y;\n        int d1 = coords.z;\n        int d2 = coords.w;\n\n        // Convolve x(?, ?, d1) with dy(:, :, d2) to get dw(wR, wC, d1, d2).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n\n        for (int b = 0; b < "+e.batchSize+"; b++) {\n          for (int yR = 0; yR < "+e.outHeight+"; yR++) {\n            int xR = wR + yR * "+t+" - "+n+";\n\n            if (xR < 0 || xR >= "+e.inHeight+") {\n              continue;\n            }\n\n            for (int yC = 0; yC < "+e.outWidth+"; yC++) {\n              int xC = wC + yC * "+r+" - "+o+";\n\n              if (xC < 0 || xC >= "+e.inWidth+") {\n                continue;\n              }\n\n              float dyValue = getDy(b, yR, yC, d2);\n              float xValue = getX(b, xR, xC, d1);\n              dotProd += (xValue * dyValue);\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    "}}(),Conv2DDerInputProgram=function(){return function(e){this.variableNames=["dy","W"],this.outputShape=e.inShape;var t=e.filterHeight,r=e.filterWidth,n=e.strideHeight,o=e.strideWidth,a=t-1-e.padInfo.top,i=r-1-e.padInfo.left;this.userCode="\n      const ivec2 pads = ivec2("+a+", "+i+");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d1 = coords[3];\n\n        ivec2 dyCorner = coords.yz - pads;\n        int dyRCorner = dyCorner.x;\n        int dyCCorner = dyCorner.y;\n\n        // Convolve dy(?, ?, d2) with w(:, :, d1, d2) to compute dx(xR, xC, d1).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < "+t+"; wR++) {\n          float dyR = float(dyRCorner + wR) / "+n+".0;\n\n          if (dyR < 0.0 || dyR >= "+e.outHeight+".0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          int wRPerm = "+t+" - 1 - wR;\n\n          for (int wC = 0; wC < "+r+"; wC++) {\n            float dyC = float(dyCCorner + wC) / "+o+".0;\n\n            if (dyC < 0.0 || dyC >= "+e.outWidth+".0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            int wCPerm = "+r+" - 1 - wC;\n\n            for (int d2 = 0; d2 < "+e.outChannels+"; d2++) {\n              float xValue = getDy(batch, idyR, idyC, d2);\n              float wValue = getW(wRPerm, wCPerm, d1, d2);\n              dotProd += xValue * wValue;\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    "}}(),DepthwiseConv2DDerFilterProgram=function(){return function(e){this.variableNames=["x","dy"],this.outputShape=e.filterShape;var t=e.strideHeight,r=e.strideWidth,n=e.padInfo.top,o=e.padInfo.left,a=e.outChannels/e.inChannels;this.userCode="\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int wR = coords.x;\n        int wC = coords.y;\n        int d1 = coords.z;\n        int dm = coords.w;\n        int d2 = d1 * "+a+" + dm;\n\n        float dotProd = 0.0;\n\n        // TODO: Vec4 over the batch size\n        for (int b = 0; b < "+e.batchSize+"; b++) {\n          for (int yR = 0; yR < "+e.outHeight+"; yR++) {\n            int xR = wR + yR * "+t+" - "+n+";\n\n            if (xR < 0 || xR >= "+e.inHeight+") {\n              continue;\n            }\n\n            for (int yC = 0; yC < "+e.outWidth+"; yC++) {\n              int xC = wC + yC * "+r+" - "+o+";\n\n              if (xC < 0 || xC >= "+e.inWidth+") {\n                continue;\n              }\n\n              float dyValue = getDy(b, yR, yC, d2);\n              float xValue = getX(b, xR, xC, d1);\n              dotProd += (xValue * dyValue);\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    "}}(),DepthwiseConv2DDerInputProgram=function(){return function(e){this.variableNames=["dy","W"],this.outputShape=e.inShape;var t=e.filterHeight,r=e.filterWidth,n=e.strideHeight,o=e.strideWidth,a=t-1-e.padInfo.top,i=r-1-e.padInfo.left,s=e.outChannels/e.inChannels;this.userCode="\n      const ivec2 pads = ivec2("+a+", "+i+");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d1 = coords[3];\n        ivec2 dyCorner = coords.yz - pads;\n        int dyRCorner = dyCorner.x;\n        int dyCCorner = dyCorner.y;\n\n        float dotProd = 0.0;\n\n        for (int wR = 0; wR < "+t+"; wR++) {\n          float dyR = float(dyRCorner + wR) / "+n+".0;\n\n          if (dyR < 0.0 || dyR >= "+e.outHeight+".0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          int wRPerm = "+t+" - 1 - wR;\n\n          for (int wC = 0; wC < "+r+"; wC++) {\n            float dyC = float(dyCCorner + wC) / "+o+".0;\n\n            if (dyC < 0.0 || dyC >= "+e.outWidth+".0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            int wCPerm = "+r+" - 1 - wC;\n\n            // TODO: Vec4 over the channelMul\n            for (int dm = 0; dm < "+s+"; dm++) {\n              int d2 = d1 * "+s+" + dm;\n              float xValue = getDy(batch, idyR, idyC, d2);\n              float wValue = getW(wRPerm, wCPerm, d1, dm);\n              dotProd += xValue * wValue;\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    "}}(),Conv2DProgram=function(){return function(e){this.variableNames=["x","W"],this.outputShape=e.outShape;var t=e.padInfo.top,r=e.padInfo.left,n=e.strideHeight,o=e.strideWidth,a=e.dilationHeight,i=e.dilationWidth,s=e.filterHeight,u=e.filterWidth,l=4*Math.floor(e.inChannels/4),c=e.inChannels%4;this.userCode="\n      const ivec2 strides = ivec2("+n+", "+o+");\n      const ivec2 pads = ivec2("+t+", "+r+");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d2 = coords[3];\n\n        ivec2 xRCCorner = coords.yz * strides - pads;\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        // Convolve x(?, ?, d1) with w(:, :, d1, d2) to get y(yR, yC, d2).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < "+s+"; wR++) {\n          int xR = xRCorner + wR * "+a+";\n\n          if (xR < 0 || xR >= "+e.inHeight+") {\n            continue;\n          }\n\n          for (int wC = 0; wC < "+u+"; wC++) {\n            int xC = xCCorner + wC * "+i+";\n\n            if (xC < 0 || xC >= "+e.inWidth+") {\n              continue;\n            }\n\n            for (int d1 = 0; d1 < "+l+"; d1 += 4) {\n              vec4 xValues = vec4(\n                getX(batch, xR, xC, d1),\n                getX(batch, xR, xC, d1 + 1),\n                getX(batch, xR, xC, d1 + 2),\n                getX(batch, xR, xC, d1 + 3)\n              );\n              vec4 wValues = vec4(\n                getW(wR, wC, d1, d2),\n                getW(wR, wC, d1 + 1, d2),\n                getW(wR, wC, d1 + 2, d2),\n                getW(wR, wC, d1 + 3, d2)\n              );\n\n              dotProd += dot(xValues, wValues);\n            }\n\n            if ("+(1===c)+") {\n              dotProd +=\n                getX(batch, xR, xC, "+l+") *\n                getW(wR, wC, "+l+", d2);\n            } else if ("+(2===c)+") {\n              vec2 xValues = vec2(\n                getX(batch, xR, xC, "+l+"),\n                getX(batch, xR, xC, "+l+" + 1)\n              );\n              vec2 wValues = vec2(\n                getW(wR, wC, "+l+", d2),\n                getW(wR, wC, "+l+" + 1, d2)\n              );\n              dotProd += dot(xValues, wValues);\n            } else if ("+(3===c)+") {\n              vec3 xValues = vec3(\n                getX(batch, xR, xC, "+l+"),\n                getX(batch, xR, xC, "+l+" + 1),\n                getX(batch, xR, xC, "+l+" + 2)\n              );\n              vec3 wValues = vec3(\n                getW(wR, wC, "+l+", d2),\n                getW(wR, wC, "+l+" + 1, d2),\n                getW(wR, wC, "+l+" + 2, d2)\n              );\n              dotProd += dot(xValues, wValues);\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    "}}(),DepthwiseConv2DProgram=function(){return function(e){this.variableNames=["x","W"],this.outputShape=e.outShape;var t=e.inHeight,r=e.inWidth,n=e.padInfo.top,o=e.padInfo.left,a=e.strideHeight,i=e.strideWidth,s=e.dilationHeight,u=e.dilationWidth,l=e.filterHeight,c=e.filterWidth,p=e.outChannels/e.inChannels;this.userCode="\n      const ivec2 strides = ivec2("+a+", "+i+");\n      const ivec2 pads = ivec2("+n+", "+o+");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords.x;\n        ivec2 xRCCorner = coords.yz * strides - pads;\n        int d2 = coords.w;\n        int d1 = d2 / "+p+";\n        int q = d2 - d1 * "+p+";\n\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        // Convolve x(?, ?, d1) with w(:, :, d1, q) to get y(yR, yC, d2).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        // TODO(dsmilkov): Flatten the two for loops and vec4 the operations.\n        for (int wR = 0; wR < "+l+"; wR++) {\n          int xR = xRCorner + wR * "+s+";\n\n          if (xR < 0 || xR >= "+t+") {\n            continue;\n          }\n\n          for (int wC = 0; wC < "+c+"; wC++) {\n            int xC = xCCorner + wC * "+u+";\n\n            if (xC < 0 || xC >= "+r+") {\n              continue;\n            }\n\n            float xVal = getX(batch, xR, xC, d1);\n            float wVal = getW(wR, wC, d1, q);\n            dotProd += xVal * wVal;\n          }\n        }\n        setOutput(dotProd);\n      }\n    "}}(),CropAndResizeProgram=function(){return function(e,t,r,n,o){this.variableNames=["Image","Boxes","BoxInd"],this.outputShape=[];var a=e[0],i=e[1],s=e[2],u=e[3],l=t[0],c=r[0],p=r[1];this.outputShape=[l,c,p,u];var d="bilinear"===n?1:0,h=[i-1+".0",s-1+".0"],f=h[0],m=h[1],g=c>1?[""+(i-1)/(c-1),"(y2-y1) * height_ratio","y1*"+f+" + float(y)*(height_scale)"]:["0.0","0.0","0.5 * (y1+y2) * "+f],v=g[0],y=g[1],x=g[2],T=p>1?[""+(s-1)/(p-1),"(x2-x1) * width_ratio","x1*"+m+" + float(x)*(width_scale)"]:["0.0","0.0","0.5 * (x1+x2) * "+m],E=T[0],w=T[1],S=T[2];this.userCode="\n      const float height_ratio = float("+v+");\n      const float width_ratio = float("+E+");\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int y = coords[1];\n        int x = coords[2];\n        int d = coords[3];\n\n        // get box vals\n        float y1 = getBoxes(b,0);\n        float x1 = getBoxes(b,1);\n        float y2 = getBoxes(b,2);\n        float x2 = getBoxes(b,3);\n\n        // get image in batch index\n        int bInd = round(getBoxInd(b));\n        if(bInd < 0 || bInd >= "+a+") {\n          return;\n        }\n\n        float height_scale = "+y+";\n        float width_scale = "+w+";\n\n        float in_y = "+x+";\n        if( in_y < 0.0 || in_y > "+f+" ) {\n          setOutput(float("+o+"));\n          return;\n        }\n        float in_x = "+S+";\n        if( in_x < 0.0 || in_x > "+m+" ) {\n          setOutput(float("+o+"));\n          return;\n        }\n\n        vec2 sourceFracIndexRC = vec2(in_y,in_x);\n        if("+d+" == 1) {\n          // Compute the four integer indices.\n          ivec2 sourceFloorRC = ivec2(sourceFracIndexRC);\n          ivec2 sourceCeilRC = ivec2(ceil(sourceFracIndexRC));\n\n          float topLeft = getImage(b, sourceFloorRC.x, sourceFloorRC.y, d);\n          float bottomLeft = getImage(b, sourceCeilRC.x, sourceFloorRC.y, d);\n          float topRight = getImage(b, sourceFloorRC.x, sourceCeilRC.y, d);\n          float bottomRight = getImage(b, sourceCeilRC.x, sourceCeilRC.y, d);\n\n          vec2 fracRC = sourceFracIndexRC - vec2(sourceFloorRC);\n\n          float top = topLeft + (topRight - topLeft) * fracRC.y;\n          float bottom = bottomLeft + (bottomRight - bottomLeft) * fracRC.y;\n          float newValue = top + (bottom - top) * fracRC.x;\n          setOutput(newValue);\n        } else {\n          // Compute the coordinators of nearest neighbor point.\n          ivec2 sourceNearestRC = ivec2(floor(\n            sourceFracIndexRC + vec2(0.5,0.5)));\n          float newValue = getImage(b, sourceNearestRC.x, sourceNearestRC.y, d);\n          setOutput(newValue);\n        }\n      }\n    "}}();function getLogicalCoordinatesFromFlatIndex(e,t,r){void 0===r&&(r="index");var n=computeStrides(t);return n.map(function(t,o){return"int "+e[o]+" = "+r+" / "+t+"; "+(o===n.length-1?"int "+e[o+1]+" = "+r+" - "+e[o]+" * "+t:"index -= "+e[o]+" * "+t)+";"}).join("")}function buildVec(e){return 1===e.length?""+e[0]:"vec"+e.length+"("+e.join(",")+")"}function dotify(e,t){if(e.length!==t.length)throw new Error("Vectors to be dotted must be of the same length -got "+e.length+" and "+t.length);for(var r=[],n=Math.floor(e.length/4),o=e.length%4,a=0;a<n;a++){var i=e.slice(4*a,4*a+4),s=t.slice(4*a,4*a+4);r.push(buildVec(i)+", "+buildVec(s))}if(0!==o){i=e.slice(4*n),s=t.slice(4*n);1===i.length&&(i=i.map(function(e){return"float("+e+")"}),s=s.map(function(e){return"float("+e+")"})),r.push(buildVec(i)+", "+buildVec(s))}return r.map(function(e,t){return"dot("+e+")"}).join("+")}function makeShader(e,t,r,n,o){var a=e.map(function(e){var t=sizeFromShape(e.shapeInfo.logicalShape);return e.shapeInfo.isUniform?"uniform float "+e.name+(t>1?"["+t+"]":"")+";":"uniform sampler2D "+e.name+";"});a=a.join("\n");var i,s,u=e.map(function(e){return getInputSamplingSnippet(e,t,n)}).join("\n"),l=t.texShape,c=SHADER_PREFIX;return t.isPacked?(i=getPackedOutputSamplingSnippet(t.logicalShape,l),s=FLOAT_TEXTURE_SET_RGBA_SNIPPET):(i=getOutputSamplingSnippet(t.logicalShape,l),s=FLOAT_TEXTURE_SET_R_SNIPPET),o&&(c+=SHADER_PACKED_PREFIX),[c,FLOAT_TEXTURE_SAMPLE_SNIPPET,s,a,i,u,r].join("\n")}function getSamplerFromInInfo(e){var t=e.shapeInfo.logicalShape;switch(t.length){case 0:return getSamplerScalar(e);case 1:return getSampler1D(e);case 2:return getSampler2D(e);case 3:return getSampler3D(e);case 4:return getSampler4D(e);case 5:return getSampler5D(e);case 6:return getSampler6D(e);default:throw new Error(t.length+"-D input sampling is not yet supported")}}function getPackedSamplerFromInInfo(e){var t=e.shapeInfo.logicalShape;switch(t.length){case 1:return getPackedSampler1D(e);case 2:return getPackedSampler2D(e);case 3:return getPackedSampler3D(e);case 4:return getPackedSampler4D(e);default:throw new Error("Packed "+t.length+"-D input sampling is not yet supported")}}function getInputSamplingSnippet(e,t,r){var n=getSamplerFlat(e);return e.shapeInfo.isPacked?n+=getPackedSamplerFromInInfo(e):n+=getSamplerFromInInfo(e),(r||arraysEqual(e.shapeInfo.logicalShape,t.logicalShape))&&(n+=getSamplerAtOutputCoords(e,t,r)),n}function getPackedOutputSamplingSnippet(e,t){switch(e.length){case 0:return getOutputScalarCoords();case 1:return getOutputPacked1DCoords(e,t);case 2:return getOutputPacked2DCoords(e,t);case 3:return getOutputPacked3DCoords(e,t);case 4:return getOutputPacked4DCoords(e,t);default:throw new Error(e.length+"-D packed output coordinate fetching is not yet supported")}}function getOutputSamplingSnippet(e,t){switch(e.length){case 0:return getOutputScalarCoords();case 1:return getOutput1DCoords(e,t);case 2:return getOutput2DCoords(e,t);case 3:return getOutput3DCoords(e,t);case 4:return getOutput4DCoords(e,t);case 5:return getOutput5DCoords(e,t);case 6:return getOutput6DCoords(e,t);default:throw new Error(e.length+"-D output sampling is not yet supported")}}var SAMPLE_1D_SNIPPET="\nvec2 UVfrom1D(int texNumR, int texNumC, int index) {\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\nvec2 packedUVfrom1D(int texNumR, int texNumC, int index) {\n  int texelIndex = index / 2;\n  int texR = texelIndex / texNumC;\n  int texC = texelIndex - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n",SAMPLE_2D_SNIPPET="\nvec2 UVfrom2D(int texNumR, int texNumC, int numC, int row, int col) {\n  int index = row * numC + col;\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\nvec2 packedUVfrom2D(int texelsInLogicalRow, int texNumR,\n  int texNumC, int row, int col) {\n  int texelIndex = (row / 2) * texelsInLogicalRow + (col / 2);\n  int texR = texelIndex / texNumC;\n  int texC = texelIndex - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n",SAMPLE_3D_SNIPPET="\nvec2 UVfrom3D(int texNumR, int texNumC, int stride0,\n    int stride1, int row, int col, int depth) {\n  // Explicitly use integer operations as dot() only works on floats.\n  int index = row * stride0 + col * stride1 + depth;\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\nvec2 packedUVfrom3D(int texNumR, int texNumC,\n    int texelsInBatch, int texelsInLogicalRow, int b,\n    int row, int col) {\n  int index = b * texelsInBatch + (row / 2) * texelsInLogicalRow + (col / 2);\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n",SAMPLE_4D_SNIPPET="\nvec2 UVfrom4D(int texNumR, int texNumC, int stride0,\n    int stride1, int stride2, int row, int col, int depth,\n    int depth2) {\n  // Explicitly use integer operations as dot() only works on floats.\n  int index = row * stride0 + col * stride1 + depth * stride2 + depth2;\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\nvec2 packedUVfrom4D(int texNumR, int texNumC, int texelsInBatch2,\n    int texelsInBatch, int texelsInLogicalRow, int b2, int b,\n    int row, int col) {\n  int index = b2 * texelsInBatch2 + b * texelsInBatch +\n    (row / 2) * texelsInLogicalRow + (col / 2);\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n",SAMPLE_5D_SNIPPET="\nvec2 UVfrom5D(int texNumR, int texNumC, int stride0,\n    int stride1, int stride2, int stride3, int row, int col, int depth,\n    int depth2, int depth3) {\n  // Explicitly use integer operations as dot() only works on floats.\n  int index = row * stride0 + col * stride1 +\n              depth * stride2 + depth2 * stride3 + depth3;\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n",SAMPLE_6D_SNIPPET="\nvec2 UVfrom6D(int texNumR, int texNumC, int stride0,\n    int stride1, int stride2, int stride3, int stride4,\n    int row, int col, int depth, int depth2, int depth3, int depth4) {\n  // Explicitly use integer operations as dot() only works on floats.\n  int index = row * stride0 + col * stride1 + depth * stride2 + depth2 *\n    stride3 + depth3 * stride4 + depth4;\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n",FLOAT_TEXTURE_SAMPLE_SNIPPET="\n  float sampleTexture(sampler2D textureSampler, vec2 uv) {\n    return texture2D(textureSampler, uv).r;\n  }\n",FLOAT_TEXTURE_SET_R_SNIPPET="\n  void setOutput(float val) {\n    gl_FragColor = vec4(val, 0, 0, 0);\n  }\n",FLOAT_TEXTURE_SET_RGBA_SNIPPET="\n  void setOutput(vec4 val) {\n    gl_FragColor = val;\n  }\n",SHADER_PREFIX="\n  precision highp float;\n  precision highp int;\n  varying vec2 resultUV;\n  const vec2 halfCR = vec2(0.5, 0.5);\n\n  struct ivec5\n  {\n    int x;\n    int y;\n    int z;\n    int w;\n    int u;\n  };\n\n  struct ivec6\n  {\n    int x;\n    int y;\n    int z;\n    int w;\n    int u;\n    int v;\n  };\n\n  bool isNaN(float val) {\n    return (val < 1.0 || 0.0 < val || val == 0.0) ? false : true;\n  }\n\n  bool hasNaN(vec4 values) {\n    vec4 v1 = values * values;\n    vec4 v2 = values * values;\n    return any(notEqual(v1, v2));\n  }\n\n  float getNaN(vec4 values) {\n    return dot(vec4(1), values);\n  }\n\n  int round(float value) {\n    return int(floor(value + 0.5));\n  }\n\n  int imod(int x, int y) {\n    return x - y * (x / y);\n  }\n\n  //Based on the work of Dave Hoskins\n  //https://www.shadertoy.com/view/4djSRW\n  #define HASHSCALE1 443.8975\n  float random(float seed){\n    vec2 p = resultUV * seed;\n    vec3 p3  = fract(vec3(p.xyx) * HASHSCALE1);\n    p3 += dot(p3, p3.yzx + 19.19);\n    return fract((p3.x + p3.y) * p3.z);\n  }\n\n  "+SAMPLE_1D_SNIPPET+"\n  "+SAMPLE_2D_SNIPPET+"\n  "+SAMPLE_3D_SNIPPET+"\n  "+SAMPLE_4D_SNIPPET+"\n  "+SAMPLE_5D_SNIPPET+"\n  "+SAMPLE_6D_SNIPPET+"\n",SHADER_PACKED_PREFIX="\n  float getChannel(vec4 frag, vec2 innerDims) {\n    vec2 modCoord = mod(innerDims, 2.);\n    return modCoord.x == 0. ?\n      (modCoord.y == 0. ? frag.r : frag.g) :\n      (modCoord.y == 0. ? frag.b : frag.a);\n  }\n  float getChannel(vec4 frag, int dim) {\n    float modCoord = mod(float(dim), 2.);\n    return modCoord == 0. ? frag.r : frag.g;\n  }\n";function getOutputScalarCoords(){return"\n    int getOutputCoords() {\n      return 0;\n    }\n  "}function getOutputPacked1DCoords(e,t){var r=[Math.ceil(t[0]/2),Math.ceil(t[1]/2)];return 1===t[0]?"\n      int getOutputCoords() {\n        return 2 * int(resultUV.x * "+r[1]+".0);\n      }\n    ":1===t[1]?"\n      int getOutputCoords() {\n        return 2 * int(resultUV.y * "+r[0]+".0);\n      }\n    ":"\n    int getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2("+r[0]+", "+r[1]+"));\n      return resTexRC.x * "+r[1]+" + resTexRC.y;\n    }\n  "}function getOutput1DCoords(e,t){return 1===t[0]?"\n      int getOutputCoords() {\n        return int(resultUV.x * "+t[1]+".0);\n      }\n    ":1===t[1]?"\n      int getOutputCoords() {\n        return int(resultUV.y * "+t[0]+".0);\n      }\n    ":"\n    int getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2("+t[0]+", "+t[1]+"));\n      return resTexRC.x * "+t[1]+" + resTexRC.y;\n    }\n  "}function getOutputPacked3DCoords(e,t){var r=[Math.ceil(t[0]/2),Math.ceil(t[1]/2)],n=Math.ceil(e[2]/2),o=n*Math.ceil(e[1]/2);return"\n    ivec3 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2("+r[0]+", "+r[1]+"));\n      int index = resTexRC.x * "+r[1]+" + resTexRC.y;\n\n      int b = index / "+o+";\n      index -= b * "+o+";\n\n      int r = 2 * (index / "+n+");\n      int c = imod(index, "+n+") * 2;\n\n      return ivec3(b, r, c);\n    }\n  "}function getOutput3DCoords(e,t){var r=getLogicalCoordinatesFromFlatIndex(["r","c","d"],e);return"\n    ivec3 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2("+t[0]+", "+t[1]+"));\n      int index = resTexRC.x * "+t[1]+" + resTexRC.y;\n      "+r+"\n      return ivec3(r, c, d);\n    }\n  "}function getOutputPacked4DCoords(e,t){var r=[Math.ceil(t[0]/2),Math.ceil(t[1]/2)],n=Math.ceil(e[3]/2),o=n*Math.ceil(e[2]/2),a=o*e[1];return"\n    ivec4 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2("+r[0]+", "+r[1]+"));\n      int index = resTexRC.x * "+r[1]+" + resTexRC.y;\n\n      int b2 = index / "+a+";\n      index -= b2 * "+a+";\n\n      int b = index / "+o+";\n      index -= b * "+o+";\n\n      int r = 2 * (index / "+n+");\n      int c = imod(index, "+n+") * 2;\n\n      return ivec4(b2, b, r, c);\n    }\n  "}function getOutput4DCoords(e,t){var r=getLogicalCoordinatesFromFlatIndex(["r","c","d","d2"],e);return"\n    ivec4 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n        vec2("+t[0]+", "+t[1]+"));\n      int index = resTexRC.x * "+t[1]+" + resTexRC.y;\n      "+r+"\n      return ivec4(r, c, d, d2);\n    }\n  "}function getOutput5DCoords(e,t){var r=getLogicalCoordinatesFromFlatIndex(["r","c","d","d2","d3"],e);return"\n    ivec5 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx * vec2("+t[0]+",\n                             "+t[1]+"));\n\n      int index = resTexRC.x * "+t[1]+" + resTexRC.y;\n\n      "+r+"\n\n      ivec5 outShape = ivec5(r, c, d, d2, d3);\n      return outShape;\n    }\n  "}function getOutput6DCoords(e,t){var r=getLogicalCoordinatesFromFlatIndex(["r","c","d","d2","d3","d4"],e);return"\n    ivec6 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n        vec2("+t[0]+", "+t[1]+"));\n      int index = resTexRC.x * "+t[1]+" + resTexRC.y;\n\n      "+r+"\n\n      ivec6 result = ivec6(r, c, d, d2, d3, d4);\n      return result;\n    }\n  "}function getOutputPacked2DCoords(e,t){var r=[Math.ceil(t[0]/2),Math.ceil(t[1]/2)];if(arraysEqual(e,t))return"\n      ivec2 getOutputCoords() {\n        return 2 * ivec2(resultUV.yx * vec2("+r[0]+", "+r[1]+"));\n      }\n    ";var n=Math.ceil(e[1]/2);return"\n    ivec2 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2("+r[0]+", "+r[1]+"));\n\n      int index = resTexRC.x * "+r[1]+" + resTexRC.y;\n      int r = 2 * (index / "+n+");\n      int c = imod(index, "+n+") * 2;\n\n      return ivec2(r, c);\n    }\n  "}function getOutput2DCoords(e,t){return arraysEqual(e,t)?"\n      ivec2 getOutputCoords() {\n        return ivec2(resultUV.yx * vec2("+t[0]+", "+t[1]+"));\n      }\n    ":1===e[1]?"\n      ivec2 getOutputCoords() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n                               vec2("+t[0]+", "+t[1]+"));\n        int index = resTexRC.x * "+t[1]+" + resTexRC.y;\n        return ivec2(index, 0);\n      }\n    ":1===e[0]?"\n      ivec2 getOutputCoords() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n                               vec2("+t[0]+", "+t[1]+"));\n        int index = resTexRC.x * "+t[1]+" + resTexRC.y;\n        return ivec2(0, index);\n      }\n    ":"\n    ivec2 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2("+t[0]+", "+t[1]+"));\n      int index = resTexRC.x * "+t[1]+" + resTexRC.y;\n      int r = index / "+e[1]+";\n      int c = index - r * "+e[1]+";\n      return ivec2(r, c);\n    }\n  "}function getSamplerScalar(e){var t=e.name,r="get"+t.charAt(0).toUpperCase()+t.slice(1);return e.shapeInfo.isUniform?"float "+r+"() {return "+t+";}":"\n    float "+r+"() {\n      return sampleTexture("+t+", halfCR);\n    }\n  "}function getPackedSampler1D(e){var t=e.name,r="get"+t.charAt(0).toUpperCase()+t.slice(1),n=e.shapeInfo.texShape,o=[Math.ceil(n[0]/2),Math.ceil(n[1]/2)];return"\n    vec4 "+r+"(int index) {\n      vec2 uv = packedUVfrom1D(\n        "+o[0]+", "+o[1]+", index);\n      return texture2D("+t+", uv);\n    }\n  "}function getSampler1D(e){var t=e.name,r="get"+t.charAt(0).toUpperCase()+t.slice(1);return"\n    float "+r+"(int index) {\n      return "+r+"Flat(index);\n    }\n  "}function getPackedSampler2D(e){var t=e.shapeInfo.logicalShape,r=e.name,n="get"+r.charAt(0).toUpperCase()+r.slice(1),o=e.shapeInfo.texShape,a=o[0],i=o[1];if(null!=o&&arraysEqual(t,o))return"\n      vec4 "+n+"(int row, int col) {\n        vec2 uv = (vec2(col, row) + halfCR) / vec2("+i+".0, "+a+".0);\n\n        return texture2D("+r+", uv);\n      }\n    ";var s=[Math.ceil(o[0]/2),Math.ceil(o[1]/2)];return"\n    vec4 "+n+"(int row, int col) {\n      vec2 uv = packedUVfrom2D("+Math.ceil(t[1]/2)+", "+s[0]+", "+s[1]+", row, col);\n      return texture2D("+r+", uv);\n    }\n  "}function getSampler2D(e){var t=e.shapeInfo.logicalShape,r=e.name,n="get"+r.charAt(0).toUpperCase()+r.slice(1),o=e.shapeInfo.texShape;if(null!=o&&arraysEqual(t,o)){var a=o[0];return"\n    float "+n+"(int row, int col) {\n      vec2 uv = (vec2(col, row) + halfCR) / vec2("+o[1]+".0, "+a+".0);\n      return sampleTexture("+r+", uv);\n    }\n  "}var i=squeezeShape(t),s=i.newShape,u=i.keptDims,l=s;if(l.length<t.length){return"\n      "+getSamplerFromInInfo(squeezeInputInfo(e,l))+"\n      float "+n+"(int row, int col) {\n        return "+n+"("+getSqueezedParams(["row","col"],u)+");\n      }\n    "}if(e.shapeInfo.isUniform)return"\n      float "+n+"(int row, int col) {\n        float index = dot(vec2(row, col), vec2("+t[1]+", 1));\n        return "+n+"Flat(round(index));\n      }\n    ";var c=o[0],p=o[1];return 1===p?"\n    float "+n+"(int row, int col) {\n      float index = dot(vec2(row, col), vec2("+t[1]+", 1));\n      vec2 uv = vec2(0.5, (index + 0.5) / "+c+".0);\n      return sampleTexture("+r+", uv);\n    }\n  ":1===c?"\n    float "+n+"(int row, int col) {\n      float index = dot(vec2(row, col), vec2("+t[1]+", 1));\n      vec2 uv = vec2((index + 0.5) / "+p+".0, 0.5);\n      return sampleTexture("+r+", uv);\n    }\n  ":"\n  float "+n+"(int row, int col) {\n    vec2 uv = UVfrom2D("+c+", "+p+", "+t[1]+", row, col);\n    return sampleTexture("+r+", uv);\n  }\n"}function getPackedSampler3D(e){var t=e.shapeInfo.logicalShape,r=e.name,n="get"+r.charAt(0).toUpperCase()+r.slice(1),o=e.shapeInfo.texShape,a=[Math.ceil(o[0]/2),Math.ceil(o[1]/2)];if(1===t[0]){return"\n        "+getPackedSamplerFromInInfo(squeezeInputInfo(e,t.slice(1)))+"\n        vec4 "+n+"(int b, int row, int col) {\n          return "+n+"("+getSqueezedParams(["b","row","col"],[1,2])+");\n        }\n      "}var i=a[0],s=a[1],u=Math.ceil(t[2]/2);return"\n    vec4 "+n+"(int b, int row, int col) {\n      vec2 uv = packedUVfrom3D(\n        "+i+", "+s+", "+u*Math.ceil(t[1]/2)+", "+u+", b, row, col);\n      return texture2D("+r+", uv);\n    }\n  "}function getSampler3D(e){var t=e.shapeInfo.logicalShape,r=e.name,n="get"+r.charAt(0).toUpperCase()+r.slice(1),o=t[1]*t[2],a=t[2],i=squeezeShape(t),s=i.newShape,u=i.keptDims,l=s;if(l.length<t.length){return"\n        "+getSamplerFromInInfo(squeezeInputInfo(e,l))+"\n        float "+n+"(int row, int col, int depth) {\n          return "+n+"("+getSqueezedParams(["row","col","depth"],u)+");\n        }\n      "}if(e.shapeInfo.isUniform)return"\n      float "+n+"(int row, int col, int depth) {\n        float index = dot(vec3(row, col, depth),\n                          vec3("+o+", "+a+", 1));\n        return "+n+"Flat(round(index));\n      }\n    ";var c=e.shapeInfo.texShape,p=c[0],d=c[1];return d===o?"\n        float "+n+"(int row, int col, int depth) {\n          float texR = float(row);\n          float texC = dot(vec2(col, depth), vec2("+a+", 1));\n          vec2 uv = (vec2(texC, texR) + halfCR) /\n                     vec2("+d+".0, "+p+".0);\n          return sampleTexture("+r+", uv);\n        }\n      ":d===a?"\n    float "+n+"(int row, int col, int depth) {\n      float texR = dot(vec2(row, col), vec2("+t[1]+", 1));\n      float texC = float(depth);\n      vec2 uv = (vec2(texC, texR) + halfCR) / vec2("+d+".0, "+p+".0);\n      return sampleTexture("+r+", uv);\n    }\n  ":"\n      float "+n+"(int row, int col, int depth) {\n        vec2 uv = UVfrom3D(\n            "+p+", "+d+", "+o+", "+a+", row, col, depth);\n        return sampleTexture("+r+", uv);\n      }\n  "}function getPackedSampler4D(e){var t=e.shapeInfo.logicalShape,r=e.name,n="get"+r.charAt(0).toUpperCase()+r.slice(1),o=e.shapeInfo.texShape,a=[Math.ceil(o[0]/2),Math.ceil(o[1]/2)],i=a[0],s=a[1],u=Math.ceil(t[3]/2),l=u*Math.ceil(t[2]/2);return"\n    vec4 "+n+"(int b2, int b, int row, int col) {\n      vec2 uv = packedUVfrom4D(\n        "+i+", "+s+", "+l*t[1]+",\n        "+l+", "+u+", b2, b, row, col);\n      return texture2D("+r+", uv);\n    }\n  "}function getSampler4D(e){var t=e.shapeInfo.logicalShape,r=e.name,n="get"+r.charAt(0).toUpperCase()+r.slice(1),o=t[3],a=t[2]*o,i=t[1]*a,s=squeezeShape(t),u=s.newShape,l=s.keptDims;if(u.length<t.length){return"\n      "+getSamplerFromInInfo(squeezeInputInfo(e,u))+"\n      float "+n+"(int row, int col, int depth, int depth2) {\n        return "+n+"("+getSqueezedParams(["row","col","depth","depth2"],l)+");\n      }\n    "}if(e.shapeInfo.isUniform)return"\n      float "+n+"(int row, int col, int depth, int depth2) {\n        float index = dot(vec4(row, col, depth, depth2),\n                          vec4("+i+", "+a+", "+o+", 1));\n        return "+n+"Flat(round(index));\n      }\n    ";var c=e.shapeInfo.texShape,p=c[0],d=c[1];return d===i?"\n      float "+n+"(int row, int col, int depth, int depth2) {\n        float texR = float(row);\n        float texC =\n            dot(vec3(col, depth, depth2), vec3("+a+", "+o+", 1));\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                   vec2("+d+".0, "+p+".0);\n        return sampleTexture("+r+", uv);\n      }\n    ":d===o?"\n      float "+n+"(int row, int col, int depth, int depth2) {\n        float texR = dot(vec3(row, col, depth),\n                         vec3("+t[1]*t[2]+", "+t[2]+", 1));\n        float texC = float(depth2);\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                  vec2("+d+".0, "+p+".0);\n        return sampleTexture("+r+", uv);\n      }\n    ":"\n    float "+n+"(int row, int col, int depth, int depth2) {\n      vec2 uv = UVfrom4D("+p+", "+d+", "+i+", "+a+",\n          "+o+", row, col, depth, depth2);\n      return sampleTexture("+r+", uv);\n    }\n  "}function getSampler5D(e){var t=e.shapeInfo.logicalShape,r=e.name,n="get"+r.charAt(0).toUpperCase()+r.slice(1),o=t[4],a=t[3]*o,i=t[2]*a,s=t[1]*i,u=squeezeShape(t),l=u.newShape,c=u.keptDims;if(l.length<t.length){return"\n      "+getSamplerFromInInfo(squeezeInputInfo(e,l))+"\n      float "+n+"(int row, int col, int depth, int depth2, int depth3) {\n        return "+n+"("+getSqueezedParams(["row","col","depth","depth2","depth3"],c)+");\n      }\n    "}if(e.shapeInfo.isUniform)return"\n      float "+n+"(int row, int col, int depth, int depth2, int depth3) {\n        float index = dot(\n          vec4(row, col, depth, depth2),\n          vec4("+s+", "+i+", "+a+", "+o+")) +\n          depth3;\n        return "+n+"Flat(index);\n      }\n    ";var p=e.shapeInfo.texShape,d=p[0],h=p[1];return h===s?"\n      float "+n+"(int row, int col, int depth, int depth2, int depth3) {\n        int texR = row;\n        float texC = dot(\n          vec4(col, depth, depth2, depth3),\n          vec4("+i+", "+a+", "+o+", 1));\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                   vec2("+h+".0, "+d+".0);\n        return sampleTexture("+r+", uv);\n      }\n    ":h===o?"\n      float "+n+"(int row, int col, int depth, int depth2, int depth3) {\n        float texR = dot(\n          vec4(row, col, depth, depth2),\n          vec4("+t[1]*t[2]*t[3]+", "+t[2]*t[3]+",\n            "+t[3]+", 1));\n        int texC = depth3;\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                  vec2("+h+".0, "+d+".0);\n        return sampleTexture("+r+", uv);\n      }\n    ":"\n    float "+n+"(int row, int col, int depth, int depth2, int depth3) {\n      vec2 uv = UVfrom5D("+d+", "+h+", "+s+", "+i+",\n          "+a+", "+o+", row, col, depth, depth2, depth3);\n      return sampleTexture("+r+", uv);\n    }\n  "}function getSampler6D(e){var t=e.shapeInfo.logicalShape,r=e.name,n="get"+r.charAt(0).toUpperCase()+r.slice(1),o=t[5],a=t[4]*o,i=t[3]*a,s=t[2]*i,u=t[1]*s,l=squeezeShape(t),c=l.newShape,p=l.keptDims;if(c.length<t.length){return"\n      "+getSamplerFromInInfo(squeezeInputInfo(e,c))+"\n      float "+n+"(int row, int col, int depth,\n                    int depth2, int depth3, int depth4) {\n        return "+n+"("+getSqueezedParams(["row","col","depth","depth2","depth3","depth4"],p)+");\n      }\n    "}if(e.shapeInfo.isUniform)return"\n      float "+n+"(int row, int col, int depth,\n                  int depth2, int depth3, int depth4) {\n        float index = dot(\n          vec4(row, col, depth, depth2),\n          vec4("+u+", "+s+", "+i+", "+a+")) +\n          dot(\n            vec2(depth3, depth4),\n            vec2("+o+", 1));\n        return "+n+"Flat(index);\n      }\n    ";var d=e.shapeInfo.texShape,h=d[0],f=d[1];return f===u?"\n      float "+n+"(int row, int col, int depth,\n                    int depth2, int depth3, int depth4) {\n        int texR = row;\n        float texC = dot(\n          vec4(col, depth, depth2, depth3),\n          vec4("+s+", "+i+", "+a+", "+o+")) + depth4;\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                   vec2("+f+".0, "+h+".0);\n        return sampleTexture("+r+", uv);\n      }\n    ":f===o?"\n      float "+n+"(int row, int col, int depth,\n                    int depth2, int depth3, int depth4) {\n        float texR = dot(\n          vec4(row, col, depth, depth2),\n          vec4("+t[1]*t[2]*t[3]*t[4]+",\n               "+t[2]*t[3]*t[4]+",\n               "+t[3]*t[4]+",\n               "+t[4]+")) + depth3;\n        int texC = depth4;\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                  vec2("+f+".0, "+h+".0);\n        return sampleTexture("+r+", uv);\n      }\n    ":"\n    float "+n+"(int row, int col, int depth,\n                  int depth2, int depth3, int depth4) {\n      vec2 uv = UVfrom6D("+h+", "+f+", "+u+", "+s+",\n          "+i+", "+a+", "+o+"\n          ,row, col, depth, depth2, depth3, depth4);\n      return sampleTexture("+r+", uv);\n    }\n  "}function getSamplerFlat(e){var t=e.name,r="get"+t.charAt(0).toUpperCase()+t.slice(1)+"Flat",n=sizeFromShape(e.shapeInfo.logicalShape);if(e.shapeInfo.isUniform)return 1===n?"float "+r+"(int index) {return "+t+";}":"\n      float "+r+"(int index) {\n        for (int i = 0; i < "+n+"; i++) {\n          if (i == index) {\n            return "+t+"[i];\n          }\n        }\n      }\n    ";var o=e.shapeInfo.texShape,a=o[0],i=o[1];return 1===i&&1===a?"\n      float "+r+"(int index) {\n        return sampleTexture("+t+", halfCR);\n      }\n    ":1===i?"\n      float "+r+"(int index) {\n        vec2 uv = vec2(0.5, (float(index) + 0.5) / "+a+".0);\n        return sampleTexture("+t+", uv);\n      }\n    ":1===a?"\n      float "+r+"(int index) {\n        vec2 uv = vec2((float(index) + 0.5) / "+i+".0, 0.5);\n        return sampleTexture("+t+", uv);\n      }\n    ":"\n    float "+r+"(int index) {\n      vec2 uv = UVfrom1D("+a+", "+i+", index);\n      return sampleTexture("+t+", uv);\n    }\n  "}function getBroadcastOutputCoordsSampler(e,t,r,n){var o=e.shapeInfo.logicalShape.length,a=t.logicalShape.length,i="int";2===a?i="ivec2":3===a?i="ivec3":4===a&&(i="ivec4");var s=getBroadcastDims(e.shapeInfo.logicalShape,t.logicalShape),u=a-o;return"\n    float "+n+"() {\n      "+i+" coords = getOutputCoords();\n      "+(0===o?"":a<2&&s.length>=1?"coords = 0;":s.map(function(e){return"coords["+(e+u)+"] = 0;"}).join("\n"))+"\n      return get"+r+"("+(a<2&&o>0?"coords":e.shapeInfo.logicalShape.map(function(e,t){return"coords["+(t+u)+"]"}).join(", "))+");\n    }\n  "}function getSamplerAtOutputCoords(e,t,r){var n=e.name,o=n.charAt(0).toUpperCase()+n.slice(1),a="get"+o+"AtOutCoords",i=getBroadcastDims(e.shapeInfo.logicalShape,t.logicalShape),s=e.shapeInfo.logicalShape.length,u=t.logicalShape.length,l=r&&(u>s||i.length>0),c=broadcastDimsAreOuter(i),p=e.shapeInfo.isUniform;if(l&&!c)return getBroadcastOutputCoordsSampler(e,t,o,a);var d=sizeFromShape(e.shapeInfo.logicalShape),h="";l&&c&&(h="\n        int mainPart = index / "+d+";\n        index -= mainPart * "+d+";\n      ");var f=t.texShape;if(p)return 1===d?"float "+a+"() {return "+n+";}":"\n      float "+a+"() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n                              vec2("+f[0]+", "+f[1]+"));\n        int index = resTexRC.x * "+f[1]+" + resTexRC.y;\n        "+h+"\n        return get"+o+"Flat(index);\n      }\n    ";var m=e.shapeInfo.texShape;return arraysEqual(m,f)?"\n      float "+a+"() {\n        return sampleTexture("+n+", resultUV);\n      }\n    ":"\n    float "+a+"() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2("+f[0]+", "+f[1]+"));\n      int index = resTexRC.x * "+f[1]+" + resTexRC.y;\n      "+h+"\n      int texR = index / "+m[1]+";\n      int texC = index - texR * "+m[1]+";\n      vec2 uv = (vec2(texC, texR) + halfCR) /\n                 vec2("+m[1]+".0, "+m[0]+".0);\n\n      return sampleTexture("+n+", uv);\n    }\n  "}function getCoordsDataType(e){if(e<=1)return"int";if(2===e)return"ivec2";if(3===e)return"ivec3";if(4===e)return"ivec4";if(5===e)return"ivec5";if(6===e)return"ivec6";throw Error("GPU for rank "+e+" is not yet supported")}function squeezeInputInfo(e,t){var r=JSON.parse(JSON.stringify(e));return r.shapeInfo.logicalShape=t,r}function getSqueezedParams(e,t){return t.map(function(t){return e[t]}).join(", ")}var CumSumProgram=function(){return function(e,t,r){this.variableNames=["x"],this.outputShape=e;var n=e.length,o=e[e.length-1],a=r?"<":">";this.userCode="\n      int getIndex(int i) {\n        "+(r?"return "+o+" -i - 1;":"return i;")+"\n      }\n\n      void main() {\n        "+getCoordsDataType(n)+" coords = getOutputCoords();\n        int end = "+getFinalCoord(n,"coords")+";\n        float val = 0.0;\n        for (int i = "+o+" - 1; i >= 0; i -= 1) {\n          int idx = getIndex(i);\n          if (idx "+a+" end) {\n            continue;\n          }\n          if (idx == end && "+t+") {\n            continue;\n          }\n          "+getFinalCoord(n,"coords")+" = idx;\n          val += getX("+getCoords(n,"coords")+");\n        }\n        setOutput(val);\n      }\n    "}}();function getCoords(e,t){if(1===e)return""+t;if(2===e)return t+".x, "+t+".y";if(3===e)return t+".x, "+t+".y, "+t+".z";if(4===e)return t+".x, "+t+".y, "+t+".z, "+t+".w";throw Error("Cumulative sum for rank "+e+" is not yet supported")}function getFinalCoord(e,t){if(1===e)return""+t;if(2===e)return t+".y";if(3===e)return t+".z";if(4===e)return t+".w";throw Error("Cumulative sum for rank "+e+" is not yet supported")}var DepthToSpaceProgram=function(){function e(e,t,r){this.variableNames=["x"],this.outputShape=[],this.outputShape=e,this.blockSize=t,this.dataFormat=r,this.userCode="\n    void main() {\n      ivec4 coords = getOutputCoords();\n      int b = coords[0];\n      int h = "+this.getHeightCoordString()+";\n      int w = "+this.getWidthCoordString()+";\n      int d = "+this.getDepthCoordString()+";\n\n      int in_h = h / "+t+";\n      int offset_h = imod(h, "+t+");\n      int in_w = w / "+t+";\n      int offset_w = imod(w, "+t+");\n      int offset_d = (offset_h * "+t+" + offset_w) *\n        "+this.getOutputDepthSize()+";\n      int in_d = d + offset_d;\n\n      float result = "+this.getInputSamplingString()+";\n      setOutput(result);\n    }\n  "}return e.prototype.getHeightCoordString=function(){return"NHWC"===this.dataFormat?"coords[1]":"coords[2]"},e.prototype.getWidthCoordString=function(){return"NHWC"===this.dataFormat?"coords[2]":"coords[3]"},e.prototype.getDepthCoordString=function(){return"NHWC"===this.dataFormat?"coords[3]":"coords[1]"},e.prototype.getOutputDepthSize=function(){return"NHWC"===this.dataFormat?this.outputShape[3]:this.outputShape[1]},e.prototype.getInputSamplingString=function(){return"NHWC"===this.dataFormat?"getX(b, in_h, in_w, in_d)":"getX(b, in_d, in_h, in_w)"},e}(),EncodeFloatProgram=function(){return function(e){this.variableNames=["A"],this.outputShape=e,this.userCode="\n      const float FLOAT_MAX = 1.70141184e38;\n      const float FLOAT_MIN = 1.17549435e-38;\n\n      lowp vec4 encode_float(highp float v) {\n        if (isNaN(v)) {\n          return vec4(255, 255, 255, 255);\n        }\n\n        highp float av = abs(v);\n\n        if(av < FLOAT_MIN) {\n          return vec4(0.0, 0.0, 0.0, 0.0);\n        } else if(v > FLOAT_MAX) {\n          return vec4(0.0, 0.0, 128.0, 127.0) / 255.0;\n        } else if(v < -FLOAT_MAX) {\n          return vec4(0.0, 0.0,  128.0, 255.0) / 255.0;\n        }\n\n        highp vec4 c = vec4(0,0,0,0);\n\n        highp float e = floor(log2(av));\n        highp float m = exp2(fract(log2(av))) - 1.0;\n\n        c[2] = floor(128.0 * m);\n        m -= c[2] / 128.0;\n        c[1] = floor(32768.0 * m);\n        m -= c[1] / 32768.0;\n        c[0] = floor(8388608.0 * m);\n\n        highp float ebias = e + 127.0;\n        c[3] = floor(ebias / 2.0);\n        ebias -= c[3] * 2.0;\n        c[2] += floor(ebias) * 128.0;\n\n        c[3] += 128.0 * step(0.0, -v);\n\n        return c / 255.0;\n      }\n\n      void main() {\n        float x = getAAtOutCoords();\n        gl_FragColor = encode_float(x);\n      }\n    "}}(),COMPLEX_FFT={REAL:"return real * expR - imag * expI;",IMAG:"return real * expI + imag * expR;"},FFTProgram=function(){return function(e,t,r){this.variableNames=["real","imag"];var n=t[1];this.outputShape=t;var o=r?"2.0 * "+Math.PI:"-2.0 * "+Math.PI,a=r?n+".0":"1.0";this.userCode="\n      const float exponentMultiplier = "+o+";\n\n      float unaryOpComplex(float real, float expR, float imag, float expI) {\n        "+e+"\n      }\n\n      float mulMatDFT(int batch, int index) {\n        float indexRatio = float(index) / float("+n+");\n        float exponentMultiplierTimesIndexRatio =\n            exponentMultiplier * indexRatio;\n\n        float result = 0.0;\n\n        for (int i = 0; i < "+n+"; i++) {\n          // x = (-2|2 * PI / N) * index * i;\n          float x = exponentMultiplierTimesIndexRatio * float(i);\n          float expR = cos(x);\n          float expI = sin(x);\n          float real = getReal(batch, i);\n          float imag = getImag(batch, i);\n\n          result +=\n              unaryOpComplex(real, expR, imag, expI) / "+a+";\n        }\n\n        return result;\n      }\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        setOutput(mulMatDFT(coords[0], coords[1]));\n      }\n    "}}(),FromPixelsProgram=function(){return function(e){this.variableNames=["A"];var t=e[0],r=e[1];this.outputShape=e,this.userCode="\n      void main() {\n        ivec3 coords = getOutputCoords();\n        int texR = coords[0];\n        int texC = coords[1];\n        int depth = coords[2];\n        vec2 uv = (vec2(texC, texR) + halfCR) / vec2("+r+".0, "+t+".0);\n\n        vec4 values = texture2D(A, uv);\n        float value;\n        if (depth == 0) {\n          value = values.r;\n        } else if (depth == 1) {\n          value = values.g;\n        } else if (depth == 2) {\n          value = values.b;\n        } else if (depth == 3) {\n          value = values.a;\n        }\n\n        setOutput(floor(value * 255.0 + 0.5));\n      }\n    "}}(),GatherProgram=function(){return function(e,t,r){this.variableNames=["A","indices"];var n=e.slice();n[r]=t,this.outputShape=n,this.rank=n.length;var o=getCoordsDataType(this.rank),a=getSourceCoords(e,r);this.userCode="\n      void main() {\n        "+o+" resRC = getOutputCoords();\n        setOutput(getA("+a+"));\n      }\n    "}}();function getSourceCoords(e,t){var r=e.length;if(r>4)throw Error("Gather for rank "+r+" is not yet supported");if(1===r)return"int(getIndices(resRC))";for(var n=["resRC.x","resRC.y","resRC.z","resRC.w"],o=[],a=0;a<e.length;a++)a===t?o.push("int(getIndices("+n[a]+"))"):o.push(""+n[a]);return o.join()}var TextureUsage,PhysicalTextureType,GatherNDProgram=function(){return function(e,t,r){this.sliceDim=e,this.strides=t,this.variableNames=["x","indices"],this.outputShape=r;var n=getCoordsDataType(t.length),o=getCoordsDataType(r.length),a=this.sliceDim>1?"strides[j]":"strides";this.userCode="\n        "+n+" strides = "+n+"("+this.strides+");\n         void main() {\n          "+o+" coords = getOutputCoords();\n          int flattenIndex = 0;\n          for (int j = 0; j < "+this.sliceDim+"; j++) {\n            int index = round(getIndices(coords[0], j));\n            flattenIndex += index * "+a+";\n          }\n          setOutput(getX(flattenIndex, coords[1]));\n        }\n      "}}();function getUnpackedMatrixTextureShapeWidthHeight(e,t){return[t,e]}function getUnpackedArraySizeFromMatrixSize(e,t){return e*t}function getMatrixSizeFromUnpackedArraySize(e,t){if(e%t!=0)throw new Error("unpackedSize ("+e+") must be a multiple of "+t);return e/t}function encodeMatrixToUnpackedArray(e,t,r){var n=getUnpackedArraySizeFromMatrixSize(e.length,r);if(t.length<n)throw new Error("unpackedArray length ("+t.length+") must be >= "+n);for(var o=0,a=0;a<e.length;++a)t[o]=e[a],o+=r}function decodeMatrixFromUnpackedArray(e,t,r){var n=getMatrixSizeFromUnpackedArraySize(e.length,r);if(t.length<n)throw new Error("matrix length ("+t.length+") must be >= "+n);for(var o=0,a=0;a<e.length;a+=r)t[o++]=e[a]}function getPackedMatrixTextureShapeWidthHeight(e,t){return[Math.ceil(t/2),Math.ceil(e/2)]}function getPackedRGBAArraySizeFromMatrixShape(e,t){var r=getPackedMatrixTextureShapeWidthHeight(e,t);return r[0]*r[1]*4}function encodeMatrixToPackedRGBA(e,t,r,n,o){var a=getPackedRGBAArraySizeFromMatrixShape(r,n);if(o.length<a)throw new Error("packedRGBA length ("+o.length+") must be >=\n        "+a);for(var i=n%2==1,s=r%2==1,u=Math.floor(n/2),l=Math.floor(r/2),c=Math.ceil(n/2),p=c*Math.ceil(r/2),d=nearestLargerEven(r)*nearestLargerEven(n),h=0;h<t;h++){for(var f=h*r*n,m=h*d,g=i?4:0,v=n,y=m,x=0;x<l;++x){for(var T=2*x*n,E=0;E<u;++E){var w=f+T+2*E;o[y]=e[w],o[y+1]=e[w+1],o[y+2]=e[w+v],o[y+3]=e[w+v+1],y+=4}y+=g}if(i){w=f+n-1,y=m+4*(c-1);var S=2*n;for(g=4*c,x=0;x<l;++x)o[y]=e[w],o[y+2]=e[w+n],w+=S,y+=g}if(s){for(w=f+(r-1)*n,y=m+4*(p-c),E=0;E<u;++E)o[y++]=e[w++],o[y++]=e[w++],y+=2;i&&s&&(o[m+d-4]=e[w])}}return o}function decodeMatrixFromPackedRGBA(e,t,r,n,o){var a=r*n;if(o.length<a)throw new Error("matrix length ("+o.length+") must be >= "+a);for(var i=n%2==1,s=r%2==1,u=Math.floor(n/2),l=Math.floor(r/2),c=Math.ceil(n/2),p=c*Math.ceil(r/2),d=nearestLargerEven(r)*nearestLargerEven(n),h=0;h<t;h++){for(var f=h*r*n,m=h*d,g=i?4:0,v=n+(i?1:0),y=m,x=f,T=f+n,E=0;E<l;++E){for(var w=0;w<u;++w)o[x++]=e[y++],o[x++]=e[y++],o[T++]=e[y++],o[T++]=e[y++];y+=g,x+=v,T+=v}if(i){y=m+4*(c-1);var S=f+n-1;for(g=4*c,v=2*n,E=0;E<l;++E)o[S]=e[y],o[S+n]=e[y+2],y+=g,S+=v}if(s){for(y=m+4*(p-c),S=f+(r-1)*n,w=0;w<u;++w)o[S++]=e[y++],o[S++]=e[y++],y+=2;i&&(o[f+r*n-1]=e[y])}}return o}function callAndCheck(e,t){var r=t();return checkWebGLError(e),r}!function(e){e[e.RENDER=0]="RENDER",e[e.UPLOAD=1]="UPLOAD",e[e.PIXELS=2]="PIXELS",e[e.DOWNLOAD=3]="DOWNLOAD"}(TextureUsage||(TextureUsage={})),function(e){e[e.UNPACKED_FLOAT16=0]="UNPACKED_FLOAT16",e[e.UNPACKED_FLOAT32=1]="UNPACKED_FLOAT32",e[e.PACKED_4X1_UNSIGNED_BYTE=2]="PACKED_4X1_UNSIGNED_BYTE",e[e.PACKED_2X2_FLOAT32=3]="PACKED_2X2_FLOAT32",e[e.PACKED_2X2_FLOAT16=4]="PACKED_2X2_FLOAT16"}(PhysicalTextureType||(PhysicalTextureType={}));var webGLDebugErrorCheckingEnabled=!1;function enableDebugWebGLErrorChecking(e){webGLDebugErrorCheckingEnabled=e}function checkWebGLError(e){if(webGLDebugErrorCheckingEnabled){var t=e.getError();if(t!==e.NO_ERROR)throw new Error("WebGL Error: "+getWebGLErrorMessage(e,t))}}function getWebGLErrorMessage(e,t){switch(t){case e.NO_ERROR:return"NO_ERROR";case e.INVALID_ENUM:return"INVALID_ENUM";case e.INVALID_VALUE:return"INVALID_VALUE";case e.INVALID_OPERATION:return"INVALID_OPERATION";case e.INVALID_FRAMEBUFFER_OPERATION:return"INVALID_FRAMEBUFFER_OPERATION";case e.OUT_OF_MEMORY:return"OUT_OF_MEMORY";case e.CONTEXT_LOST_WEBGL:return"CONTEXT_LOST_WEBGL";default:return"Unknown error code "+t}}function getExtensionOrThrow(e,t){return throwIfNull(e,function(){return e.getExtension(t)},'Extension "'+t+'" not supported on this browser.')}function createVertexShader(e,t){var r=throwIfNull(e,function(){return e.createShader(e.VERTEX_SHADER)},"Unable to create vertex WebGLShader.");if(callAndCheck(e,function(){return e.shaderSource(r,t)}),callAndCheck(e,function(){return e.compileShader(r)}),!1===e.getShaderParameter(r,e.COMPILE_STATUS))throw console.log(e.getShaderInfoLog(r)),new Error("Failed to compile vertex shader.");return r}function createFragmentShader(e,t){var r=throwIfNull(e,function(){return e.createShader(e.FRAGMENT_SHADER)},"Unable to create fragment WebGLShader.");if(callAndCheck(e,function(){return e.shaderSource(r,t)}),callAndCheck(e,function(){return e.compileShader(r)}),!1===e.getShaderParameter(r,e.COMPILE_STATUS))throw logShaderSourceAndInfoLog(t,e.getShaderInfoLog(r)),new Error("Failed to compile fragment shader.");return r}var lineNumberRegex=/ERROR: [0-9]+:([0-9]+):/g;function logShaderSourceAndInfoLog(e,t){var r=lineNumberRegex.exec(t);if(null==r)return console.log("Couldn't parse line number in error: "+t),void console.log(e);for(var n=+r[1],o=e.split("\n"),a=o.length.toString().length+2,i=o.map(function(e,t){return rightPad((t+1).toString(),a)+e}),s=0,u=0;u<i.length;u++)s=Math.max(i[u].length,s);var l=i.slice(0,n-1),c=i.slice(n-1,n),p=i.slice(n);console.log(l.join("\n")),console.log(t.split("\n")[0]),console.log("%c "+rightPad(c[0],s),"border:1px solid red; background-color:#e3d2d2; color:#a61717"),console.log(p.join("\n"))}function createProgram(e){return throwIfNull(e,function(){return e.createProgram()},"Unable to create WebGLProgram.")}function linkProgram(e,t){if(callAndCheck(e,function(){return e.linkProgram(t)}),!1===e.getProgramParameter(t,e.LINK_STATUS))throw console.log(e.getProgramInfoLog(t)),new Error("Failed to link vertex and fragment shaders.")}function validateProgram(e,t){if(callAndCheck(e,function(){return e.validateProgram(t)}),!1===e.getProgramParameter(t,e.VALIDATE_STATUS))throw console.log(e.getProgramInfoLog(t)),new Error("Shader program validation failed.")}function createStaticVertexBuffer(e,t){var r=throwIfNull(e,function(){return e.createBuffer()},"Unable to create WebGLBuffer");return callAndCheck(e,function(){return e.bindBuffer(e.ARRAY_BUFFER,r)}),callAndCheck(e,function(){return e.bufferData(e.ARRAY_BUFFER,t,e.STATIC_DRAW)}),r}function createStaticIndexBuffer(e,t){var r=throwIfNull(e,function(){return e.createBuffer()},"Unable to create WebGLBuffer");return callAndCheck(e,function(){return e.bindBuffer(e.ELEMENT_ARRAY_BUFFER,r)}),callAndCheck(e,function(){return e.bufferData(e.ELEMENT_ARRAY_BUFFER,t,e.STATIC_DRAW)}),r}function getNumChannels(){return 2===ENV.get("WEBGL_VERSION")?1:4}function createTexture(e){return throwIfNull(e,function(){return e.createTexture()},"Unable to create WebGLTexture.")}function validateTextureSize(e,t){var r=ENV.get("WEBGL_MAX_TEXTURE_SIZE");if(e<=0||t<=0){var n="["+e+"x"+t+"]";throw new Error("Requested texture size "+n+" is invalid.")}if(e>r||t>r){n="["+e+"x"+t+"]";throw new Error("Requested texture size "+n+" greater than WebGL maximum on this browser / GPU "+("["+r+"x"+r+"]")+".")}}function createFramebuffer(e){return throwIfNull(e,function(){return e.createFramebuffer()},"Unable to create WebGLFramebuffer.")}function bindVertexBufferToProgramAttribute(e,t,r,n,o,a,i){var s=e.getAttribLocation(t,r);return-1!==s&&(callAndCheck(e,function(){return e.bindBuffer(e.ARRAY_BUFFER,n)}),callAndCheck(e,function(){return e.vertexAttribPointer(s,o,e.FLOAT,!1,a,i)}),callAndCheck(e,function(){return e.enableVertexAttribArray(s)}),!0)}function bindTextureUnit(e,t,r){validateTextureUnit(e,r),callAndCheck(e,function(){return e.activeTexture(e.TEXTURE0+r)}),callAndCheck(e,function(){return e.bindTexture(e.TEXTURE_2D,t)})}function unbindTextureUnit(e,t){validateTextureUnit(e,t),callAndCheck(e,function(){return e.activeTexture(e.TEXTURE0+t)}),callAndCheck(e,function(){return e.bindTexture(e.TEXTURE_2D,null)})}function getProgramUniformLocationOrThrow(e,t,r){return throwIfNull(e,function(){return e.getUniformLocation(t,r)},'uniform "'+r+'" not present in program.')}function getProgramUniformLocation(e,t,r){return e.getUniformLocation(t,r)}function bindTextureToProgramUniformSampler(e,t,r,n,o){callAndCheck(e,function(){return bindTextureUnit(e,r,o)}),callAndCheck(e,function(){return e.uniform1i(n,o)})}function bindCanvasToFramebuffer(e){callAndCheck(e,function(){return e.bindFramebuffer(e.FRAMEBUFFER,null)}),callAndCheck(e,function(){return e.viewport(0,0,e.canvas.width,e.canvas.height)}),callAndCheck(e,function(){return e.scissor(0,0,e.canvas.width,e.canvas.height)})}function bindColorTextureToFramebuffer(e,t,r){callAndCheck(e,function(){return e.bindFramebuffer(e.FRAMEBUFFER,r)}),callAndCheck(e,function(){return e.framebufferTexture2D(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,t,0)})}function unbindColorTextureFromFramebuffer(e,t){callAndCheck(e,function(){return e.bindFramebuffer(e.FRAMEBUFFER,t)}),callAndCheck(e,function(){return e.framebufferTexture2D(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,null,0)})}function validateFramebuffer(e){var t=e.checkFramebufferStatus(e.FRAMEBUFFER);if(t!==e.FRAMEBUFFER_COMPLETE)throw new Error("Error binding framebuffer: "+getFramebufferErrorMessage(e,t))}function getFramebufferErrorMessage(e,t){switch(t){case e.FRAMEBUFFER_INCOMPLETE_ATTACHMENT:return"FRAMEBUFFER_INCOMPLETE_ATTACHMENT";case e.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT:return"FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT";case e.FRAMEBUFFER_INCOMPLETE_DIMENSIONS:return"FRAMEBUFFER_INCOMPLETE_DIMENSIONS";case e.FRAMEBUFFER_UNSUPPORTED:return"FRAMEBUFFER_UNSUPPORTED";default:return"unknown error "+t}}function throwIfNull(e,t,r){var n=callAndCheck(e,function(){return t()});if(null==n)throw new Error(r);return n}function validateTextureUnit(e,t){var r=e.MAX_COMBINED_TEXTURE_IMAGE_UNITS-1,n=t+e.TEXTURE0;if(n<e.TEXTURE0||n>r)throw new Error("textureUnit must be in "+("[gl.TEXTURE0, gl.TEXTURE"+r+"]")+".")}function getTextureShapeFromLogicalShape(e,t){void 0===t&&(t=!1);var r=ENV.get("WEBGL_MAX_TEXTURE_SIZE");if(t&&(r*=2,e=e.map(function(t,r){return r>=e.length-2?nearestLargerEven(e[r]):e[r]})),2!==e.length){var n=squeezeShape(e);e=n.newShape}var o=sizeFromShape(e);return e.length<=1&&o<=r?[o,1]:2===e.length&&e[0]<=r&&e[1]<=r?e:3===e.length&&e[0]*e[1]<=r&&e[2]<=r?[e[0]*e[1],e[2]]:3===e.length&&e[0]<=r&&e[1]*e[2]<=r?[e[0],e[1]*e[2]]:4===e.length&&e[0]*e[1]*e[2]<=r&&e[3]<=r?[e[0]*e[1]*e[2],e[3]]:4===e.length&&e[0]<=r&&e[1]*e[2]*e[3]<=r?[e[0],e[1]*e[2]*e[3]]:sizeToSquarishShape(o)}function isEven(e){return e%2==0}function isReshapeFree(e,t){if(arraysEqual(e=e.slice(-2),t=t.slice(-2)))return!0;if(!e.length||!t.length)return!0;if(0===e[0]||0===e[1]||0===t[0]||0===t[1])return!0;if(e.length!==t.length){if(arraysEqual(squeezeShape(e).newShape,squeezeShape(t).newShape))return!0}else if(isEven(e[0])&&isEven(t[0])){if(isEven(e[1])&&isEven(t[1]))return!0;if(e[1]===t[1])return!0}return!1}var webgl_util=Object.freeze({callAndCheck:callAndCheck,enableDebugWebGLErrorChecking:enableDebugWebGLErrorChecking,checkWebGLError:checkWebGLError,getWebGLErrorMessage:getWebGLErrorMessage,getExtensionOrThrow:getExtensionOrThrow,createVertexShader:createVertexShader,createFragmentShader:createFragmentShader,createProgram:createProgram,linkProgram:linkProgram,validateProgram:validateProgram,createStaticVertexBuffer:createStaticVertexBuffer,createStaticIndexBuffer:createStaticIndexBuffer,getNumChannels:getNumChannels,createTexture:createTexture,validateTextureSize:validateTextureSize,createFramebuffer:createFramebuffer,bindVertexBufferToProgramAttribute:bindVertexBufferToProgramAttribute,bindTextureUnit:bindTextureUnit,unbindTextureUnit:unbindTextureUnit,getProgramUniformLocationOrThrow:getProgramUniformLocationOrThrow,getProgramUniformLocation:getProgramUniformLocation,bindTextureToProgramUniformSampler:bindTextureToProgramUniformSampler,bindCanvasToFramebuffer:bindCanvasToFramebuffer,bindColorTextureToFramebuffer:bindColorTextureToFramebuffer,unbindColorTextureFromFramebuffer:unbindColorTextureFromFramebuffer,validateFramebuffer:validateFramebuffer,getFramebufferErrorMessage:getFramebufferErrorMessage,getTextureShapeFromLogicalShape:getTextureShapeFromLogicalShape,isReshapeFree:isReshapeFree});function createVertexShader$1(e){return createVertexShader(e,"\n    precision highp float;\n    attribute vec3 clipSpacePos;\n    attribute vec2 uv;\n    varying vec2 resultUV;\n\n    void main() {\n      gl_Position = vec4(clipSpacePos, 1);\n      resultUV = uv;\n    }")}function createVertexBuffer(e){return createStaticVertexBuffer(e,new Float32Array([-1,1,0,0,1,-1,-1,0,0,0,1,1,0,1,1,1,-1,0,1,0]))}function createIndexBuffer(e){return createStaticIndexBuffer(e,new Uint16Array([0,1,2,2,1,3]))}function getTextureConfig(e,t){var r,n,o,a,i,s,u,l=e;return 2===ENV.get("WEBGL_VERSION")?(r=l.R32F,n=l.R16F,o=l.RGBA32F,a=l.RED,i=4,s=1,u=l.HALF_FLOAT):(r=e.RGBA,n=e.RGBA,o=l.RGBA,a=e.RGBA,i=4,s=4,u=null!=t?t.HALF_FLOAT_OES:null),{internalFormatFloat:r,internalFormatHalfFloat:n,internalFormatPackedFloat:o,textureFormatFloat:a,downloadTextureFormat:e.RGBA,downloadUnpackNumChannels:i,defaultNumChannels:s,textureTypeHalfFloat:u}}function createAndConfigureTexture(e,t,r,n,o,a){validateTextureSize(t,r);var i=createTexture(e),s=e.TEXTURE_2D;return callAndCheck(e,function(){return e.bindTexture(s,i)}),callAndCheck(e,function(){return e.texParameteri(s,e.TEXTURE_WRAP_S,e.CLAMP_TO_EDGE)}),callAndCheck(e,function(){return e.texParameteri(s,e.TEXTURE_WRAP_T,e.CLAMP_TO_EDGE)}),callAndCheck(e,function(){return e.texParameteri(s,e.TEXTURE_MIN_FILTER,e.NEAREST)}),callAndCheck(e,function(){return e.texParameteri(s,e.TEXTURE_MAG_FILTER,e.NEAREST)}),callAndCheck(e,function(){return e.texImage2D(s,0,n,t,r,0,o,a,null)}),callAndCheck(e,function(){return e.bindTexture(e.TEXTURE_2D,null)}),i}function createFloat32MatrixTexture(e,t,r,n){var o=getUnpackedMatrixTextureShapeWidthHeight(t,r);return createAndConfigureTexture(e,o[0],o[1],n.internalFormatFloat,n.textureFormatFloat,e.FLOAT)}function createFloat16MatrixTexture(e,t,r,n){var o=getUnpackedMatrixTextureShapeWidthHeight(t,r);return createAndConfigureTexture(e,o[0],o[1],n.internalFormatFloat,n.textureFormatFloat,n.textureTypeHalfFloat)}function createUnsignedBytesMatrixTexture(e,t,r,n){var o=getUnpackedMatrixTextureShapeWidthHeight(t,r);return createAndConfigureTexture(e,o[0],o[1],e.RGBA,e.RGBA,e.UNSIGNED_BYTE)}function createPackedMatrixTexture(e,t,r,n){var o=getPackedMatrixTextureShapeWidthHeight(t,r);return createAndConfigureTexture(e,o[0],o[1],n.internalFormatPackedFloat,e.RGBA,e.FLOAT)}function createFloat16PackedMatrixTexture(e,t,r,n){var o=getPackedMatrixTextureShapeWidthHeight(t,r);return createAndConfigureTexture(e,o[0],o[1],n.internalFormatHalfFloat,e.RGBA,n.textureTypeHalfFloat)}function bindVertexProgramAttributeStreams(e,t,r){return callAndCheck(e,function(){return e.bindBuffer(e.ARRAY_BUFFER,r)}),bindVertexBufferToProgramAttribute(e,t,"clipSpacePos",r,3,20,0)&&bindVertexBufferToProgramAttribute(e,t,"uv",r,2,20,12)}function uploadPixelDataToTexture(e,t,r){callAndCheck(e,function(){return e.bindTexture(e.TEXTURE_2D,t)}),callAndCheck(e,function(){return e.texImage2D(e.TEXTURE_2D,0,e.RGBA,e.RGBA,e.UNSIGNED_BYTE,r)}),callAndCheck(e,function(){return e.bindTexture(e.TEXTURE_2D,null)})}function uploadDataToTexture(e,t,r,n,o,a){validateTextureSize(r,n),callAndCheck(e,function(){return e.bindTexture(e.TEXTURE_2D,t)}),callAndCheck(e,function(){return e.texSubImage2D(e.TEXTURE_2D,0,0,0,r,n,a,e.FLOAT,o)}),callAndCheck(e,function(){return e.bindTexture(e.TEXTURE_2D,null)})}function uploadMatrixToTexture(e,t,r,n,o,a,i){var s,u=getUnpackedMatrixTextureShapeWidthHeight(r,n),l=u[0],c=u[1];1===i.defaultNumChannels?s=o:encodeMatrixToUnpackedArray(o,s=new Float32Array(getUnpackedArraySizeFromMatrixSize(o.length,a)),a),uploadDataToTexture(e,t,l,c,s,i.textureFormatFloat)}function uploadMatrixToPackedTexture(e,t,r,n,o,a,i){var s=getPackedMatrixTextureShapeWidthHeight(n,o),u=s[0],l=s[1],c=new Float32Array(getPackedRGBAArraySizeFromMatrixShape(n,o));encodeMatrixToPackedRGBA(a,r,n,o,c),uploadDataToTexture(e,t,u,l,c,e.RGBA)}function maybeCreateBufferFromOutputTexture(e,t,r,n,o){var a=t;if(2===ENV.get("WEBGL_VERSION")){var i=e,s=i.createBuffer();callAndCheck(e,function(){return e.bindBuffer(i.PIXEL_PACK_BUFFER,s)});var u=4*getUnpackedArraySizeFromMatrixSize(r*n,o.downloadUnpackNumChannels);callAndCheck(e,function(){return e.bufferData(i.PIXEL_PACK_BUFFER,u,e.STATIC_DRAW)}),callAndCheck(e,function(){return i.readPixels(0,0,n,r,e.RGBA,e.FLOAT,0)}),callAndCheck(e,function(){return e.bindBuffer(i.PIXEL_PACK_BUFFER,null)}),a=s}return a}function downloadFloat32MatrixFromBuffer(e,t,r,n,o){var a=e,i=new Float32Array(getUnpackedArraySizeFromMatrixSize(r*n,o.downloadUnpackNumChannels));a.bindBuffer(e.ARRAY_BUFFER,t),a.getBufferSubData(e.ARRAY_BUFFER,0,i),a.bindBuffer(e.ARRAY_BUFFER,null);var s=new Float32Array(r*n);return decodeMatrixFromUnpackedArray(i,s,o.downloadUnpackNumChannels),s}function downloadFloat32MatrixFromOutputTexture(e,t,r,n){var o=getUnpackedMatrixTextureShapeWidthHeight(t,r),a=o[0],i=o[1],s=new Float32Array(getUnpackedArraySizeFromMatrixSize(t*r,n.downloadUnpackNumChannels));callAndCheck(e,function(){return e.readPixels(0,0,a,i,n.downloadTextureFormat,e.FLOAT,s)});var u=new Float32Array(t*r);return decodeMatrixFromUnpackedArray(s,u,n.downloadUnpackNumChannels),u}function downloadByteEncodedFloatMatrixFromOutputTexture(e,t,r,n){var o=getUnpackedMatrixTextureShapeWidthHeight(t,r),a=o[0],i=o[1],s=new Uint8Array(getUnpackedArraySizeFromMatrixSize(t*r,4));return callAndCheck(e,function(){return e.readPixels(0,0,a,i,n.downloadTextureFormat,e.UNSIGNED_BYTE,s)}),new Float32Array(s.buffer)}function downloadMatrixFromPackedOutputTexture(e,t,r,n,o,a,i){var s=getPackedMatrixTextureShapeWidthHeight(o,a),u=s[0],l=s[1],c=new Float32Array(getPackedRGBAArraySizeFromMatrixShape(o,a));callAndCheck(e,function(){return e.readPixels(0,0,u,l,e.RGBA,e.FLOAT,c)});var p=new Float32Array(sizeFromShape([t,r,n]));return decodeMatrixFromPackedRGBA(c,t,r,n,p)}var gpgpu_util=Object.freeze({createVertexShader:createVertexShader$1,createVertexBuffer:createVertexBuffer,createIndexBuffer:createIndexBuffer,getTextureConfig:getTextureConfig,createFloat32MatrixTexture:createFloat32MatrixTexture,createFloat16MatrixTexture:createFloat16MatrixTexture,createUnsignedBytesMatrixTexture:createUnsignedBytesMatrixTexture,createPackedMatrixTexture:createPackedMatrixTexture,createFloat16PackedMatrixTexture:createFloat16PackedMatrixTexture,bindVertexProgramAttributeStreams:bindVertexProgramAttributeStreams,uploadPixelDataToTexture:uploadPixelDataToTexture,uploadMatrixToTexture:uploadMatrixToTexture,uploadMatrixToPackedTexture:uploadMatrixToPackedTexture,maybeCreateBufferFromOutputTexture:maybeCreateBufferFromOutputTexture,downloadFloat32MatrixFromBuffer:downloadFloat32MatrixFromBuffer,downloadFloat32MatrixFromOutputTexture:downloadFloat32MatrixFromOutputTexture,downloadByteEncodedFloatMatrixFromOutputTexture:downloadByteEncodedFloatMatrixFromOutputTexture,downloadMatrixFromPackedOutputTexture:downloadMatrixFromPackedOutputTexture}),GPGPUContext=function(){function e(e){this.outputTexture=null,this.program=null,this.disposed=!1,this.autoDebugValidate=!1,this.vertexAttrsAreBound=!1,this.itemsToPoll=[],this.gl=null!=e?e:getWebGLContext(ENV.get("WEBGL_VERSION")),1===ENV.get("WEBGL_VERSION")?(this.textureFloatExtension=getExtensionOrThrow(this.gl,"OES_texture_float"),this.colorBufferFloatExtension=this.gl.getExtension("WEBGL_color_buffer_float"),ENV.get("WEBGL_RENDER_FLOAT32_ENABLED")||(this.textureHalfFloatExtension=getExtensionOrThrow(this.gl,"OES_texture_half_float"),this.colorBufferHalfFloatExtension=this.gl.getExtension("EXT_color_buffer_half_float"))):this.colorBufferFloatExtension=getExtensionOrThrow(this.gl,"EXT_color_buffer_float"),this.vertexBuffer=createVertexBuffer(this.gl),this.indexBuffer=createIndexBuffer(this.gl),this.framebuffer=createFramebuffer(this.gl),this.textureConfig=getTextureConfig(this.gl,this.textureHalfFloatExtension)}return e.prototype.dispose=function(){var e=this;if(!this.disposed){null!=this.program&&console.warn("Disposing a GPGPUContext that still has a bound WebGLProgram. This is probably a resource leak, delete the program with GPGPUContext.deleteProgram before disposing."),null!=this.outputTexture&&console.warn("Disposing a GPGPUContext that still has a bound output matrix texture.  This is probably a resource leak, delete the output matrix texture with GPGPUContext.deleteMatrixTexture before disposing.");var t=this.gl;callAndCheck(t,function(){return t.finish()}),callAndCheck(t,function(){return t.bindFramebuffer(t.FRAMEBUFFER,null)}),callAndCheck(t,function(){return t.deleteFramebuffer(e.framebuffer)}),callAndCheck(t,function(){return t.bindBuffer(t.ARRAY_BUFFER,null)}),callAndCheck(t,function(){return t.bindBuffer(t.ELEMENT_ARRAY_BUFFER,null)}),callAndCheck(t,function(){return t.deleteBuffer(e.indexBuffer)}),this.disposed=!0}},e.prototype.enableAutomaticDebugValidation=function(e){this.autoDebugValidate=e,enableDebugWebGLErrorChecking(e)},e.prototype.createFloat32MatrixTexture=function(e,t){return this.throwIfDisposed(),createFloat32MatrixTexture(this.gl,e,t,this.textureConfig)},e.prototype.createFloat16MatrixTexture=function(e,t){return this.throwIfDisposed(),createFloat16MatrixTexture(this.gl,e,t,this.textureConfig)},e.prototype.createUnsignedBytesMatrixTexture=function(e,t){return this.throwIfDisposed(),createUnsignedBytesMatrixTexture(this.gl,e,t,this.textureConfig)},e.prototype.uploadPixelDataToTexture=function(e,t){this.throwIfDisposed(),uploadPixelDataToTexture(this.gl,e,t)},e.prototype.createFloat16PackedMatrixTexture=function(e,t){return this.throwIfDisposed(),createFloat16PackedMatrixTexture(this.gl,e,t,this.textureConfig)},e.prototype.createPackedMatrixTexture=function(e,t){return this.throwIfDisposed(),createPackedMatrixTexture(this.gl,e,t,this.textureConfig)},e.prototype.deleteMatrixTexture=function(e){var t=this;this.throwIfDisposed(),this.outputTexture===e&&(unbindColorTextureFromFramebuffer(this.gl,this.framebuffer),this.outputTexture=null),callAndCheck(this.gl,function(){return t.gl.deleteTexture(e)})},e.prototype.uploadMatrixToTexture=function(e,t,r,n){this.throwIfDisposed();var o=getNumChannels();return uploadMatrixToTexture(this.gl,e,t,r,n,o,this.textureConfig)},e.prototype.uploadMatrixToPackedTexture=function(e,t,r,n,o){return this.throwIfDisposed(),uploadMatrixToPackedTexture(this.gl,e,t,r,n,o,this.textureConfig)},e.prototype.downloadFloat32MatrixFromOutputTexture=function(e,t,r){var n=this;return this.downloadMatrixDriver(e,function(){return downloadFloat32MatrixFromOutputTexture(n.gl,t,r,n.textureConfig)})},e.prototype.downloadByteEncodedFloatMatrixFromOutputTexture=function(e,t,r){var n=this;return this.downloadMatrixDriver(e,function(){return downloadByteEncodedFloatMatrixFromOutputTexture(n.gl,t,r,n.textureConfig)})},e.prototype.downloadFloat32MatrixFromBuffer=function(e,t,r){return downloadFloat32MatrixFromBuffer(this.gl,e,t,r,this.textureConfig)},e.prototype.maybeCreateBufferFromTexture=function(e,t,r){this.bindTextureToFrameBuffer(e);var n=maybeCreateBufferFromOutputTexture(this.gl,e,t,r,this.textureConfig);return this.unbindTextureToFrameBuffer(),n},e.prototype.createAndWaitForFence=function(){var e=this.createFence(this.gl);return this.pollFence(e)},e.prototype.createFence=function(e){var t,r,n=this;if(ENV.get("WEBGL_FENCE_API_ENABLED")){var o=e,a=o.fenceSync(o.SYNC_GPU_COMMANDS_COMPLETE,0);e.flush(),r=function(){var e=o.clientWaitSync(a,0,0);return e===o.ALREADY_SIGNALED||e===o.CONDITION_SATISFIED},t=a}else ENV.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION")>0?(t=this.beginQuery(),this.endQuery(),r=function(){return n.isQueryAvailable(t,ENV.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION"))}):r=function(){return!0};return{query:t,isFencePassed:r}},e.prototype.downloadMatrixFromPackedTexture=function(e,t,r,n,o,a){var i=this;return this.downloadMatrixDriver(e,function(){return downloadMatrixFromPackedOutputTexture(i.gl,t,r,n,o,a,i.textureConfig)})},e.prototype.createProgram=function(e){this.throwIfDisposed();var t=this.gl,r=createFragmentShader(t,e),n=createVertexShader$1(t),o=createProgram(t);return callAndCheck(t,function(){return t.attachShader(o,n)}),callAndCheck(t,function(){return t.attachShader(o,r)}),linkProgram(t,o),this.autoDebugValidate&&validateProgram(t,o),this.vertexAttrsAreBound||(this.setProgram(o),this.vertexAttrsAreBound=bindVertexProgramAttributeStreams(t,this.program,this.vertexBuffer)),o},e.prototype.deleteProgram=function(e){var t=this;this.throwIfDisposed(),e===this.program&&(this.program=null),null!=e&&callAndCheck(this.gl,function(){return t.gl.deleteProgram(e)})},e.prototype.setProgram=function(e){var t=this;this.throwIfDisposed(),this.program=e,null!=this.program&&this.autoDebugValidate&&validateProgram(this.gl,this.program),callAndCheck(this.gl,function(){return t.gl.useProgram(e)})},e.prototype.getUniformLocation=function(e,t,r){return void 0===r&&(r=!0),this.throwIfDisposed(),r?getProgramUniformLocationOrThrow(this.gl,e,t):getProgramUniformLocation(this.gl,e,t)},e.prototype.getAttributeLocation=function(e,t){var r=this;return this.throwIfDisposed(),callAndCheck(this.gl,function(){return r.gl.getAttribLocation(e,t)})},e.prototype.getUniformLocationNoThrow=function(e,t){return this.throwIfDisposed(),this.gl.getUniformLocation(e,t)},e.prototype.setInputMatrixTexture=function(e,t,r){this.throwIfDisposed(),this.throwIfNoProgram(),bindTextureToProgramUniformSampler(this.gl,this.program,e,t,r)},e.prototype.setOutputMatrixTexture=function(e,t,r){this.setOutputMatrixTextureDriver(e,r,t)},e.prototype.setOutputPackedMatrixTexture=function(e,t,r){this.throwIfDisposed();var n=getPackedMatrixTextureShapeWidthHeight(t,r),o=n[0],a=n[1];this.setOutputMatrixTextureDriver(e,o,a)},e.prototype.setOutputMatrixWriteRegion=function(e,t,r,n){this.setOutputMatrixWriteRegionDriver(r,e,n,t)},e.prototype.setOutputPackedMatrixWriteRegion=function(e,t,r,n){throw new Error("setOutputPackedMatrixWriteRegion not implemented.")},e.prototype.debugValidate=function(){null!=this.program&&validateProgram(this.gl,this.program),validateFramebuffer(this.gl)},e.prototype.executeProgram=function(){this.throwIfDisposed(),this.throwIfNoProgram();var e=this.gl;this.autoDebugValidate&&this.debugValidate(),callAndCheck(e,function(){return e.drawElements(e.TRIANGLES,6,e.UNSIGNED_SHORT,0)})},e.prototype.blockUntilAllProgramsCompleted=function(){var e=this;this.throwIfDisposed(),callAndCheck(this.gl,function(){return e.gl.finish()})},e.prototype.getQueryTimerExtension=function(){return null==this.disjointQueryTimerExtension&&(this.disjointQueryTimerExtension=getExtensionOrThrow(this.gl,2===ENV.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION")?"EXT_disjoint_timer_query_webgl2":"EXT_disjoint_timer_query")),this.disjointQueryTimerExtension},e.prototype.getQueryTimerExtensionWebGL2=function(){return this.getQueryTimerExtension()},e.prototype.getQueryTimerExtensionWebGL1=function(){return this.getQueryTimerExtension()},e.prototype.beginQuery=function(){if(2===ENV.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION")){var e=this.gl,t=this.getQueryTimerExtensionWebGL2(),r=e.createQuery();return e.beginQuery(t.TIME_ELAPSED_EXT,r),r}var n=this.getQueryTimerExtensionWebGL1(),o=n.createQueryEXT();return n.beginQueryEXT(n.TIME_ELAPSED_EXT,o),o},e.prototype.endQuery=function(){if(2!==ENV.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION")){var e=this.getQueryTimerExtensionWebGL1();e.endQueryEXT(e.TIME_ELAPSED_EXT)}else{var t=this.gl,r=this.getQueryTimerExtensionWebGL2();t.endQuery(r.TIME_ELAPSED_EXT)}},e.prototype.waitForQueryAndGetTime=function(e){return __awaiter(this,void 0,void 0,function(){var t=this;return __generator(this,function(r){switch(r.label){case 0:return[4,repeatedTry(function(){return t.disposed||t.isQueryAvailable(e,ENV.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION"))})];case 1:return r.sent(),[2,this.getQueryTime(e,ENV.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION"))]}})})},e.prototype.getQueryTime=function(e,t){if(0===t)return null;if(2===t){var r=this.gl;return r.getQueryParameter(e,r.QUERY_RESULT)/1e6}var n=this.getQueryTimerExtensionWebGL1();return n.getQueryObjectEXT(e,n.QUERY_RESULT_EXT)/1e6},e.prototype.isQueryAvailable=function(e,t){if(0===t)return!0;if(2===t){var r=this.gl,n=this.getQueryTimerExtensionWebGL2(),o=r.getQueryParameter(e,r.QUERY_RESULT_AVAILABLE);return null==this.disjoint&&(this.disjoint=this.gl.getParameter(n.GPU_DISJOINT_EXT)),o&&!this.disjoint}o=(n=this.getQueryTimerExtensionWebGL1()).getQueryObjectEXT(e,n.QUERY_RESULT_AVAILABLE_EXT);return null==this.disjoint&&(this.disjoint=this.gl.getParameter(n.GPU_DISJOINT_EXT)),o&&!this.disjoint},e.prototype.pollFence=function(e){var t=this;return new Promise(function(r){t.addItemToPoll(function(){return e.isFencePassed()},function(){return r()})})},e.prototype.pollItems=function(){for(var e=binSearchLastTrue(this.itemsToPoll.map(function(e){return e.isDoneFn})),t=0;t<=e;++t){(0,this.itemsToPoll[t].resolveFn)()}this.itemsToPoll=this.itemsToPoll.slice(e+1)},e.prototype.addItemToPoll=function(e,t){var r=this;this.itemsToPoll.push({isDoneFn:e,resolveFn:t}),this.itemsToPoll.length>1||repeatedTry(function(){return r.pollItems(),0===r.itemsToPoll.length})},e.prototype.bindTextureToFrameBuffer=function(e){this.throwIfDisposed(),bindColorTextureToFramebuffer(this.gl,e,this.framebuffer),this.autoDebugValidate&&validateFramebuffer(this.gl)},e.prototype.unbindTextureToFrameBuffer=function(){null!=this.outputTexture?(bindColorTextureToFramebuffer(this.gl,this.outputTexture,this.framebuffer),this.autoDebugValidate&&validateFramebuffer(this.gl)):unbindColorTextureFromFramebuffer(this.gl,this.framebuffer)},e.prototype.downloadMatrixDriver=function(e,t){this.bindTextureToFrameBuffer(e);var r=t();return this.unbindTextureToFrameBuffer(),r},e.prototype.setOutputMatrixTextureDriver=function(e,t,r){this.throwIfDisposed();var n=this.gl;bindColorTextureToFramebuffer(n,e,this.framebuffer),this.autoDebugValidate&&validateFramebuffer(n),this.outputTexture=e,callAndCheck(n,function(){return n.viewport(0,0,t,r)}),callAndCheck(n,function(){return n.scissor(0,0,t,r)})},e.prototype.setOutputMatrixWriteRegionDriver=function(e,t,r,n){var o=this;this.throwIfDisposed(),callAndCheck(this.gl,function(){return o.gl.scissor(e,t,r,n)})},e.prototype.throwIfDisposed=function(){if(this.disposed)throw new Error("Attempted to use disposed GPGPUContext.")},e.prototype.throwIfNoProgram=function(){if(null==this.program)throw new Error("No GPU program is currently set.")},e}();function binSearchLastTrue(e){for(var t=0,r=e.length-1,n=-1;t<=r;){var o=t+r>>1;e[o]()?(n=o,t=o+1):r=o-1}return n}function compileProgram(e,t,r,n){for(var o=t.userCode,a=r.map(function(e,r){var n={logicalShape:e.shape,texShape:e.isUniform?null:e.texData.texShape,isUniform:e.isUniform,isPacked:!e.isUniform&&e.texData.isPacked};return{name:t.variableNames[r],shapeInfo:n}}),i=a.map(function(e){return e.shapeInfo}),s={logicalShape:n.shape,texShape:n.texData.texShape,isUniform:!1,isPacked:n.texData.isPacked},u=makeShader(a,s,o,!0===t.supportsBroadcasting,t.usesPackedTextures),l=e.createProgram(u),c={},p=0;p<t.variableNames.length;p++){var d=t.variableNames[p];c[d]=e.getUniformLocation(l,d,!1)}return{program:t,source:u,webGLProgram:l,uniformLocations:c,gpgpu:e,inShapeInfos:i,outShapeInfo:s}}function validateBinaryAndProgram(e,t){if(e.length!==t.length)throw Error("Binary was compiled with "+e.length+" inputs, but was executed with "+t.length+" inputs");e.forEach(function(e,r){var n=e.logicalShape,o=t[r],a=o.shape;if(!arraysEqual(n,a))throw Error("Binary was compiled with different shapes than the current args. Shapes "+n+" and "+a+" must match");if(!e.isUniform||!o.isUniform){var i=e.texShape,s=o.isUniform?null:o.texData.texShape;if(!arraysEqual(i,s))throw Error("Binary was compiled with different texture shapes than the current args. Shape "+i+" and "+s+" must match")}})}function runProgram(e,t,r,n){validateBinaryAndProgram(e.inShapeInfos,t),validateBinaryAndProgram([e.outShapeInfo],[r]);var o=r.texData.texture,a=r.texData.texShape,i=e.gpgpu;r.texData.isPacked?i.setOutputPackedMatrixTexture(o,a[0],a[1]):i.setOutputMatrixTexture(o,a[0],a[1]),i.setProgram(e.webGLProgram),t.forEach(function(t,r){var n=e.program.variableNames[r],o=e.uniformLocations[n];if(null!=o){if(t.isUniform){if(1===sizeFromShape(t.shape))i.gl.uniform1f(o,t.uniformValues[0]);else{var a=t.uniformValues;a instanceof Float32Array||(a=new Float32Array(a)),i.gl.uniform1fv(o,a)}return}var s=t.texData.texture;i.setInputMatrixTexture(s,o,r)}}),null!=n&&n(i,e.webGLProgram),i.executeProgram()}function makeShaderKey(e,t,r){var n="";t.concat(r).forEach(function(e){n+=e.shape+"_"+(e.isUniform?"uniform":e.texData.texShape)});var o=e.userCode,a=(!0===e.supportsBroadcasting).toString(),i=e.constructor.name;return i+="_"+a+"_"+n+"_"+o}var Im2ColProgram=function(){return function(e,t,r){this.variableNames=["A"],this.outputShape=e;var n=r.filterWidth,o=r.inChannels,a=r.strideWidth,i=r.strideHeight,s=r.padInfo,u=r.outWidth,l=r.dilationWidth,c=r.dilationHeight,p=s.left,d=s.top,h=o*n;this.userCode="\n      void main() {\n        ivec2 rc = getOutputCoords();\n\n        vec4 result = vec4(0);\n\n        for(int row=0; row<=1; row++) {\n          for(int col=0; col<=1; col++) {\n            int blockIndex = rc.y + col;\n            int pos = rc.x + row;\n\n            if(blockIndex >= "+e[1]+" || pos >= "+e[0]+") continue;\n\n            int offsetY = int(blockIndex / ("+u+")) * "+i+" - "+d+";\n            int d0 = offsetY + "+c+" * (pos / "+h+");\n\n            if(d0 >= "+t[0]+" || d0 < 0) continue;\n\n            int offsetX = int(mod(float(blockIndex), "+u+".) * "+a+". - "+p+".);\n            int d1 = offsetX + "+l+" * (int(mod(float(pos), "+h+".) / "+o+".));\n\n            if(d1 >= "+t[1]+" || d1 < 0) continue;\n\n            result[row * 2 + col] = getA(d0, d1, int(mod(float(pos), "+o+".)));\n          }\n        }\n\n        gl_FragColor = result;\n      }\n    "}}(),LRNProgram=function(){return function(e,t,r,n,o){this.variableNames=["x"],this.outputShape=[];var a,i=t,s=e[3]-1;this.outputShape=e;var u="float("+r+") + float("+n+") * sum";a=.5===o?"inversesqrt("+u+")":1===o?"1.0/("+u+")":"exp(log("+u+") * float(-"+o+"));",this.userCode="\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int r = coords[1];\n        int c = coords[2];\n        int d = coords[3];\n        float x = getX(b, r, c, d);\n        float sum = 0.0;\n        for (int j = -"+i+"; j <= "+i+"; j++) {\n          int idx = d + j;\n          if (idx >= 0 && idx <=  "+s+") {\n            float z = getX(b, r, c, idx);\n            sum += z * z;\n          }\n        }\n        float val = x * "+a+";\n        setOutput(val);\n      }\n    "}}(),LRNGradProgram=function(){return function(e,t,r,n,o){this.variableNames=["inputImage","outputImage","dy"],this.outputShape=[],this.outputShape=e,this.depth=e[3],this.depthRadius=t,this.bias=r,this.alpha=n,this.beta=o,this.userCode="\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int r = coords[1];\n        int c = coords[2];\n\n        float result = 0.0;\n        for (int d = 0; d < "+this.depth+"; ++d) {\n          int depthBegin = int(max(0.0, float(d - "+t+")));\n          int depthEnd = int(min(float("+this.depth+"),\n              float(d + "+t+" + 1)));\n\n          const int MIN_DEPTH_BEGIN = 0;\n          const int MAX_DEPTH_END = "+this.depth+";\n\n          float norm = 0.0;\n          for (int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k) {\n            if (k < depthBegin){\n              continue;\n            }\n            else if (k >= depthBegin && k < depthEnd) {\n              norm += getInputImage(b, r, c, k) * getInputImage(b, r, c, k);\n            }\n            else {\n              break;\n            }\n          }\n\n          norm = float("+n+") * norm + float("+r+");\n\n          for(int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k){\n            if (k < depthBegin){\n              continue;\n            }\n            else if (k >= depthBegin && k < depthEnd){\n              float dyi = -2.0 * float("+n+")\n                * float("+o+")\n                * getInputImage(b ,r ,c, k) * getOutputImage(b, r, c, d)\n                / norm;\n              if (k == d) {\n                dyi += pow(norm, -1.0 * "+o+");\n              }\n              if (k == coords[3]) {\n                dyi *= getDy(b, r, c, d);\n                result += dyi;\n              }\n            }\n            else {\n              break;\n            }\n          }\n      }\n      setOutput(result);\n      }\n    "}}(),MaxPool2DBackpropProgram=function(){return function(e){this.variableNames=["dy","maxPos"],this.outputShape=e.inShape;var t=e.strideHeight,r=e.strideWidth,n=e.dilationHeight,o=e.effectiveFilterHeight,a=e.effectiveFilterWidth,i=o-1-e.padInfo.top,s=a-1-e.padInfo.left,u=o*a-1;this.userCode="\n      const ivec2 pads = ivec2("+i+", "+s+");\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n\n        ivec2 dyRCCorner = coords.yz - pads;\n        int dyRCorner = dyRCCorner.x;\n        int dyCCorner = dyRCCorner.y;\n\n        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < "+o+";\n          wR += "+n+") {\n          float dyR = float(dyRCorner + wR) / "+t+".0;\n\n          if (dyR < 0.0 || dyR >= "+e.outHeight+".0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          for (int wC = 0; wC < "+a+"; wC++) {\n            float dyC = float(dyCCorner + wC) / "+r+".0;\n\n            if (dyC < 0.0 || dyC >= "+e.outWidth+".0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            float dyValue = getDy(b, idyR, idyC, d);\n            int maxPosValue = "+u+" - int(getMaxPos(b, idyR, idyC, d));\n\n            // Get the current value, check it against the value from the\n            // position matrix.\n            int curPosValue = wR * "+a+" + wC;\n            float mask = float(maxPosValue == curPosValue ? 1.0 : 0.0);\n\n            dotProd += dyValue * mask;\n          }\n        }\n        setOutput(dotProd);\n      }\n    "}}(),MatMulProgram=function(){return function(e,t,r,n){void 0===r&&(r=!1),void 0===n&&(n=!1),this.variableNames=["matrixA","matrixB"];var o=e[0],a=r?e[2]:e[1],i=n?t[1]:t[2],s=r?e[1]:e[2];this.outputShape=[o,a,i];var u=function(e,t){return r?"batch, "+t+" + "+e+", aRow":"batch, aRow, "+t+" + "+e},l=function(e,t){return n?"batch, bCol, "+t+" + "+e:"batch, "+t+" + "+e+", bCol"},c=4*Math.floor(s/4),p=s%4;this.userCode=" float dotARowBCol(int batch, int aRow, int bCol) {\n      float result = 0.0;\n      for (int i = 0; i < "+c+"; i += 4) {\n        vec4 a = vec4(\n          getMatrixA("+u(0,"i")+"),\n          getMatrixA("+u(1,"i")+"),\n          getMatrixA("+u(2,"i")+"),\n          getMatrixA("+u(3,"i")+")\n        );\n        vec4 b = vec4(\n          getMatrixB("+l(0,"i")+"),\n          getMatrixB("+l(1,"i")+"),\n          getMatrixB("+l(2,"i")+"),\n          getMatrixB("+l(3,"i")+")\n        );\n\n        result += dot(a, b);\n      }\n\n      if ("+(1===p)+") {\n        result += getMatrixA("+u(0,c)+") *\n          getMatrixB("+l(0,c)+");\n      } else if ("+(2===p)+") {\n        vec2 a = vec2(\n          getMatrixA("+u(0,c)+"),\n          getMatrixA("+u(1,c)+")\n        );\n        vec2 b = vec2(\n          getMatrixB("+l(0,c)+"),\n          getMatrixB("+l(1,c)+")\n        );\n        result += dot(a, b);\n      } else if ("+(3===p)+") {\n        vec3 a = vec3(\n          getMatrixA("+u(0,c)+"),\n          getMatrixA("+u(1,c)+"),\n          getMatrixA("+u(2,c)+")\n        );\n        vec3 b = vec3(\n          getMatrixB("+l(0,c)+"),\n          getMatrixB("+l(1,c)+"),\n          getMatrixB("+l(2,c)+")\n        );\n        result += dot(a, b);\n      }\n\n      return result;\n    }\n\n    void main() {\n      ivec3 resBRC = getOutputCoords();\n      setOutput(dotARowBCol(resBRC.x, resBRC.y, resBRC.z));\n    }\n    "}}(),MatMulPackedProgram=function(){return function(e,t,r,n,o){void 0===n&&(n=!1),void 0===o&&(o=!1),this.variableNames=["matrixA","matrixB"],this.usesPackedTextures=!0,this.outputShape=r;var a=n?e[0]:e[1],i=Math.ceil(a/2),s=n?"i * 2, rc.x":"rc.x, i * 2",u=o?"rc.y, i * 2":"i * 2, rc.y",l=n?["a.xxyy","a.zzww"]:["a.xxzz","a.yyww"],c=o?["b.xzxz","b.ywyw"]:["b.xyxy","b.zwzw"];this.userCode="\n      const float sharedDimension = "+i+".0;\n\n      vec4 dot2x2ARowBCol(ivec2 rc) {\n        vec4 result = vec4(0);\n        for (int i = 0; i < "+i+"; i++) {\n          vec4 a = getMatrixA("+s+");\n          vec4 b = getMatrixB("+u+");\n\n          result += ("+l[0]+" * "+c[0]+") + ("+l[1]+" * "+c[1]+");\n        }\n        return result;\n      }\n\n      void main() {\n        ivec2 rc = getOutputCoords();\n        setOutput(dot2x2ARowBCol(rc));\n      }\n    "}}(),MultinomialProgram=function(){function e(e,t,r){this.variableNames=["probs"],this.outputShape=[e,r],this.userCode="\n      uniform float seed;\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n\n        float r = random(seed);\n        float cdf = 0.0;\n\n        for (int i = 0; i < "+(t-1)+"; i++) {\n          cdf += getProbs(batch, i);\n\n          if (r < cdf) {\n            setOutput(float(i));\n            return;\n          }\n        }\n\n        // If no other event happened, last event happened.\n        setOutput(float("+(t-1)+"));\n      }\n    "}return e.prototype.getCustomSetupFunc=function(e){var t=this;return function(r,n){null==t.seedLoc&&(t.seedLoc=r.getUniformLocation(n,"seed")),r.gl.uniform1f(t.seedLoc,e)}},e}(),OneHotProgram=function(){return function(e,t,r,n){this.variableNames=["indices"],this.outputShape=[e,t],this.userCode="\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int index = round(getIndices(coords.x));\n        setOutput(mix(float("+n+"), float("+r+"),\n                      float(index == coords.y)));\n      }\n    "}}();function getVecChannels(e,t){return["x","y","z","w","u","v"].slice(0,t).map(function(t){return e+"."+t})}function getChannels(e,t){return 1===t?[e]:getVecChannels(e,t)}function getSourceCoords$1(e,t){if(1===e)return"rc";for(var r="",n=0;n<e;n++)r+=t[n],n<e-1&&(r+=",");return r}var PackProgram=function(){return function(e){this.variableNames=["A"],this.outputShape=e;var t=e.length,r=getChannels("rc",t),n=getCoordsDataType(t),o=getOutOfBoundsCondition(t,e,r),a=getSetup(t,e[e.length-1],e[e.length-2],r),i=getOutput(e,r);this.userCode="\n      void main() {\n        "+n+" rc = getOutputCoords();\n\n        if("+o+") {\n          gl_FragColor = vec4(0);\n        } else {\n          "+a+"\n\n          setOutput(vec4("+i+"));\n        }\n      }\n    "}}();function getSourceCoordsArr(e,t){for(var r=[],n=0;n<=1;n++)for(var o=0;o<=1;o++){for(var a=(0===n?"r":"rp1")+", "+(0===o?"c":"cp1"),i=2;i<e;i++)a=t[t.length-1-i]+","+a;r.push(a)}return r}function getOutOfBoundsCondition(e,t,r){if(1===e)return"rc > "+t[0];for(var n="",o=e-2;o<e;o++)n+=r[o]+" >= "+t[o],o<e-1&&(n+="||");return n}function getSetup(e,t,r,n){if(1===e)return"";var o=n.slice(-2);return"\n    int r = "+o[0]+";\n    int c = "+o[1]+";\n    int rp1 = r + 1;\n    int cp1 = c + 1;\n\n    bool cEdge = cp1 >= "+t+";\n    bool rEdge = rp1 >= "+r+";\n  "}function getOutput(e,t){var r=e.length,n=getSourceCoordsArr(r,t);return 1===r?"getA(rc),\n            rc + 1 >= "+e[0]+" ? 0. : getA(rc + 1),\n            0, 0":"getA("+n[0]+"),\n          cEdge ? 0. : getA("+n[1]+"),\n          rEdge ? 0. : getA("+n[2]+"),\n          rEdge || cEdge ? 0. : getA("+n[3]+")"}var PadProgram=function(){return function(e,t,r){this.variableNames=["x"],this.outputShape=t.map(function(t,r){return t[0]+e[r]+t[1]});var n=e.length,o=getCoordsDataType(n),a=t.map(function(e){return e[0]}).join(","),i=t.map(function(t,r){return t[0]+e[r]}).join(","),s=["coords[0]","coords[1]","coords[2]","coords[3]"].slice(0,n);this.userCode=1!==n?"\n      "+o+" start = "+o+"("+a+");\n      "+o+" end = "+o+"("+i+");\n\n      void main() {\n        "+o+" outC = getOutputCoords();\n        if (any(lessThan(outC, start)) || any(greaterThanEqual(outC, end))) {\n          setOutput(float("+r+"));\n        } else {\n          "+o+" coords = outC - start;\n          setOutput(getX("+s+"));\n        }\n      }\n    ":"\n        int start = "+a+";\n        int end = "+i+";\n\n        void main() {\n          int outC = getOutputCoords();\n          if (outC < start || outC >= end) {\n            setOutput(float("+r+"));\n          } else {\n            setOutput(getX(outC - start));\n          }\n        }\n      "}}(),Pool2DProgram=function(){return function(e,t,r){if(this.variableNames=["x"],"avg"===t&&r)throw new Error("Cannot compute positions for average pool.");var n=e.filterWidth,o=e.strideHeight,a=e.strideWidth,i=e.dilationHeight,s=e.dilationWidth,u=e.effectiveFilterHeight,l=e.effectiveFilterWidth,c=e.padInfo.top,p=e.padInfo.left;this.outputShape=e.outShape;var d="avg"===t,h="0.0";if(d||(h="-1.0 / 0.0"),r)this.userCode="\n        const ivec2 strides = ivec2("+o+", "+a+");\n        const ivec2 pads = ivec2("+c+", "+p+");\n\n        void main() {\n          ivec4 coords = getOutputCoords();\n          int batch = coords[0];\n          int d = coords[3];\n\n          ivec2 xRCCorner = coords.yz * strides - pads;\n          int xRCorner = xRCCorner.x;\n          int xCCorner = xRCCorner.y;\n\n          // max/min x(?, ?, d) to get y(yR, yC, d).\n          // ? = to be determined\n          float minMaxValue = 0.0;\n          float minMaxValueFound = 0.0;\n          int minMaxPosition = 0;\n          float avgValue = 0.0;\n\n          for (int wR = 0; wR < "+u+";\n              wR += "+i+") {\n            int xR = xRCorner + wR;\n\n            if (xR < 0 || xR >= "+e.inHeight+") {\n              continue;\n            }\n\n            for (int wC = 0; wC < "+l+";\n                wC += "+s+") {\n              int xC = xCCorner + wC;\n\n              if (xC < 0 || xC >= "+e.inWidth+") {\n                continue;\n              }\n\n              float value = getX(batch, xR, xC, d);\n\n              // If a min / max value has already been found, use it. If not,\n              // use the current value.\n              float currMinMaxValue = mix(\n                  value, minMaxValue, minMaxValueFound);\n              if (value >= currMinMaxValue) {\n                minMaxValue = value;\n                minMaxValueFound = 1.0;\n                minMaxPosition = wR * "+l+" + wC;\n              }\n            }\n          }\n          setOutput(float(minMaxPosition));\n        }\n      ";else{var f=t+"("+t+"("+t+"(minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])";"avg"===t&&(f="avgValue / count");var m=4*Math.floor(n/4),g=n%4,v="\n      if ("+d+") {\n        avgValue += dot(values, ones);\n      } else {\n        minMaxValue = max(values, minMaxValue);\n      }\n    ";this.userCode="\n      const ivec2 strides = ivec2("+o+", "+a+");\n      const ivec2 pads = ivec2("+c+", "+p+");\n      const float initializationValue = "+h+";\n      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);\n\n      float count = 0.0;\n\n      float getValue(int batch, int xR, int xC, int d) {\n        if (xC < 0 || xC >= "+e.inWidth+") {\n          return initializationValue;\n        }\n        count += 1.0;\n        return getX(batch, xR, xC, d);\n      }\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d = coords[3];\n\n        ivec2 xRCCorner = coords.yz * strides - pads;\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        // max/min x(?, ?, d) to get y(yR, yC, d).\n        // ? = to be determined\n        vec4 minMaxValue = vec4("+h+");\n        float avgValue = 0.0;\n        count = 0.0;\n\n        for (int wR = 0; wR < "+u+";\n            wR += "+i+") {\n          int xR = xRCorner + wR;\n\n          if (xR < 0 || xR >= "+e.inHeight+") {\n            continue;\n          }\n\n          for (int wC = 0; wC < "+m+"; wC += 4) {\n            int xC = xCCorner + wC * "+s+";\n\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              getValue(batch, xR, xC + "+s+", d),\n              getValue(batch, xR, xC + 2 * "+s+", d),\n              getValue(batch, xR, xC + 3 * "+s+", d)\n            );\n\n            "+v+"\n          }\n\n          int xC = xCCorner + "+m+";\n          if ("+(1===g)+") {\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              initializationValue,\n              initializationValue,\n              initializationValue\n            );\n\n            "+v+"\n          } else if ("+(2===g)+") {\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              getValue(batch, xR, xC + "+s+", d),\n              initializationValue,\n              initializationValue\n            );\n\n            "+v+"\n          } else if ("+(3===g)+") {\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              getValue(batch, xR, xC + "+s+", d),\n              getValue(batch, xR, xC + 2 * "+s+", d),\n              initializationValue\n            );\n\n            "+v+"\n          }\n        }\n        setOutput("+f+");\n      }\n    "}}}(),ReduceProgram=function(){return function(e,t){this.variableNames=["x"];var r=e.windowSize,n=e.batchSize,o=e.inSize,a=Math.ceil(o/r);this.outputShape=[n,a];var i="0.0",s="";"prod"===t?i="1.0":"min"===t?(i="1.0 / 0.0",s="min"):"max"===t&&(i="-1.0 / 0.0",s="max");var u=t+"("+t+"("+t+"(minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])";"sum"===t?u="sumValue":"prod"===t?u="prodValue":"all"===t?u="allValue":"any"===t&&(u="anyValue");var l=4*Math.floor(r/4),c=r%4,p="\n      if ("+("sum"===t)+") {\n        sumValue += dot(values, ones);\n      } else if ("+("prod"===t)+") {\n        vec2 tmp = vec2(values[0], values[1]) * vec2(values[2], values[3]);\n        prodValue *= tmp[0] * tmp[1];\n      } else {\n        minMaxValue = "+s+"(values, minMaxValue);\n      }\n    ",d="vec4";"all"===t?(i="1.0",p="\n        bool reducedAllValue = all(values);\n        float floatedReducedAllValue = float(reducedAllValue);\n        allValue = float(allValue >= 1.0 && floatedReducedAllValue >= 1.0);\n      ",d="bvec4"):"any"===t&&(i="0.0",p="\n        bool reducedAnyValue = any(values);\n        float floatedReducedAnyValue = float(reducedAnyValue);\n        anyValue = float(anyValue >= 1.0 || floatedReducedAnyValue >= 1.0);\n      ",d="bvec4");var h="";o%r>0&&(h="\n        if (inIdx < 0 || inIdx >= "+o+") {\n          return initializationValue;\n        }\n      "),this.userCode="\n      const float initializationValue = "+i+";\n      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);\n\n      float getValue(int batch, int inIdx) {\n        "+h+"\n        return getX(batch, inIdx);\n      }\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n        int outIdx = coords[1];\n        int inOffset = outIdx * "+r+";\n\n        vec4 minMaxValue = vec4("+i+");\n        float prodValue = 1.0;\n        float sumValue = 0.0;\n        float allValue = 1.0;\n        float anyValue = 0.0;\n\n        for (int i = 0; i < "+l+"; i += 4) {\n          int inIdx = inOffset + i;\n          "+d+" values = "+d+"(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            getValue(batch, inIdx + 3)\n          );\n\n          "+p+"\n        }\n\n        int inIdx = inOffset + "+l+";\n        if ("+(1===c)+") {\n          "+d+" values = "+d+"(\n            getValue(batch, inIdx),\n            initializationValue,\n            initializationValue,\n            initializationValue\n          );\n\n          "+p+"\n        } else if ("+(2===c)+") {\n          "+d+" values = "+d+"(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            initializationValue,\n            initializationValue\n          );\n\n          "+p+"\n        } else if ("+(3===c)+") {\n          "+d+" values = "+d+"(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            initializationValue\n          );\n\n          "+p+"\n        }\n        setOutput("+u+");\n      }\n    "}}(),ReshapePackedProgram=function(){return function(e,t){this.variableNames=["A"],this.usesPackedTextures=!0,this.outputShape=e;for(var r="",n=0;n<4;n++){var o="thisRC = rc;";n%2==1&&(o+="thisRC.z += 1;"),n>1&&(o+="thisRC.y += 1;"),r+="\n        "+o+"\n        "+(n>0?"if(thisRC.y < rows && thisRC.z < cols){":"")+"\n          int flatIndex = getFlatIndex(thisRC);\n\n          ivec3 inputRC = inputCoordsFromReshapedOutCoords(flatIndex);\n          vec2 inputRCInnerDims = vec2(float(inputRC.y),float(inputRC.z));\n\n          result["+n+"] =\n            getChannel(getA(inputRC.x, inputRC.y, inputRC.z), inputRCInnerDims);\n        "+(n>0?"}":"")+"\n      "}this.userCode="\n      "+getReshapedInputCoords(t)+"\n      "+getFlatIndex(e)+"\n\n      void main() {\n        ivec3 rc = getOutputCoords();\n\n        vec4 result = vec4(0.);\n\n        ivec3 thisRC;\n        int rows = "+e[1]+";\n        int cols = "+e[2]+";\n\n        "+r+"\n\n        setOutput(result);\n      }\n    "}}();function getFlatIndex(e){return"\n    int getFlatIndex(ivec3 coords) {\n      return round("+dotify(["coords.x","coords.y","coords.z"],computeStrides(e).map(function(e){return e.toString()}).concat(["1."]))+");\n    }\n  "}function getReshapedInputCoords(e){return"\n    ivec3 inputCoordsFromReshapedOutCoords(int index) {\n      "+getLogicalCoordinatesFromFlatIndex(["r","c","d"],e)+"\n      return ivec3(r, c, d);\n    }\n  "}var ResizeBilinearBackpropProgram=function(){return function(e,t,r){this.variableNames=["dy"],this.outputShape=[],this.outputShape=t.shape;var n=t.shape,o=n[1],a=n[2],i=e.shape,s=i[1],u=i[2],l=[r&&s>1?o-1:o,r&&u>1?a-1:a],c=[r&&s>1?s-1:s,r&&u>1?u-1:u],p=l[0]/c[0],d=l[1]/c[1],h=1/p,f=1/d,m=2*Math.ceil(h)+2,g=2*Math.ceil(f)+2;this.userCode="\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        int r = coords[1];\n        int c = coords[2];\n\n        float accumulator = 0.0;\n\n        const float heightScale = float("+p+");\n        const float widthScale = float("+d+");\n\n        const float invHeightScale = float("+h+");\n        const float invWidthScale = float("+f+");\n\n        const int winHeight = int("+m+");\n        const int winWidth = int("+g+");\n\n        // Compute bounds for where in dy we will look\n        float startRLerp = floor(float(r) * invHeightScale);\n        int startDyR = int(startRLerp - float(winHeight / 2));\n\n        float startCLerp = floor(float(c) * invWidthScale);\n        int startDyC = int(startCLerp - float(winWidth / 2));\n\n        // Loop over dy\n        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {\n          int dyR = dyROffset + startDyR;\n\n          // Guard against the window exceeding the bounds of dy\n          if (dyR < 0 || dyR >= "+s+") {\n            continue;\n          }\n\n          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {\n            int dyC = dyCOffset + startDyC;\n\n            // Guard against the window exceeding the bounds of dy\n            if (dyC < 0 || dyC >= "+u+") {\n              continue;\n            }\n\n            float dxR = float(dyR) * heightScale;\n            int topDxRIndex = int(floor(dxR));\n            int bottomDxRIndex = int(min(ceil(dxR), "+(o-1)+".0));\n            float dxRLerp = dxR - float(topDxRIndex);\n            float inverseDxRLerp = 1.0 - dxRLerp;\n\n            float dxC = float(dyC) * widthScale;\n            int leftDxCIndex = int(floor(dxC));\n            int rightDxCIndex = int(min(ceil(dxC), "+(a-1)+".0));\n            float dxCLerp = dxC - float(leftDxCIndex);\n            float inverseDxCLerp = 1.0 - dxCLerp;\n\n            if (r == topDxRIndex && c == leftDxCIndex) {\n              // topLeft\n              accumulator +=\n                getDy(b, dyR, dyC, d) * inverseDxRLerp * inverseDxCLerp;\n            }\n\n            if (r == topDxRIndex && c == rightDxCIndex) {\n              // topRight\n              accumulator += getDy(b, dyR, dyC, d) * inverseDxRLerp * dxCLerp;\n            }\n\n            if (r == bottomDxRIndex && c == leftDxCIndex) {\n              // bottomLeft\n              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * inverseDxCLerp;\n            }\n\n            if (r == bottomDxRIndex && c == rightDxCIndex) {\n              // bottomRight\n              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * dxCLerp;\n            }\n          }\n        }\n        // End loop over dy\n\n        setOutput(accumulator);\n      }\n    "}}(),ResizeBilinearProgram=function(){return function(e,t,r,n){this.variableNames=["A"],this.outputShape=[];var o=e[0],a=e[1],i=e[2],s=e[3];this.outputShape=[o,t,r,s];var u=[n&&t>1?a-1:a,n&&r>1?i-1:i],l=[n&&t>1?t-1:t,n&&r>1?r-1:r];this.userCode="\n      const vec2 effectiveInputOverOutputRatioRC = vec2(\n          "+u[0]/l[0]+",\n          "+u[1]/l[1]+");\n      const vec2 inputShapeRC = vec2("+a+".0, "+i+".0);\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        ivec2 yRC = coords.yz;\n\n        // Fractional source index.\n        vec2 sourceFracIndexRC = vec2(yRC) * effectiveInputOverOutputRatioRC;\n\n        // Compute the four integer indices.\n        ivec2 sourceFloorRC = ivec2(sourceFracIndexRC);\n        ivec2 sourceCeilRC = ivec2(\n          min(inputShapeRC - 1.0, ceil(sourceFracIndexRC)));\n\n        float topLeft = getA(b, sourceFloorRC.x, sourceFloorRC.y, d);\n        float bottomLeft = getA(b, sourceCeilRC.x, sourceFloorRC.y, d);\n        float topRight = getA(b, sourceFloorRC.x, sourceCeilRC.y, d);\n        float bottomRight = getA(b, sourceCeilRC.x, sourceCeilRC.y, d);\n\n        vec2 fracRC = sourceFracIndexRC - vec2(sourceFloorRC);\n\n        float top = topLeft + (topRight - topLeft) * fracRC.y;\n        float bottom = bottomLeft + (bottomRight - bottomLeft) * fracRC.y;\n        float newValue = top + (bottom - top) * fracRC.x;\n\n        setOutput(newValue);\n      }\n    "}}(),ResizeNearestNeigborBackpropProgram=function(){return function(e,t,r){this.variableNames=["dy"],this.outputShape=[],this.outputShape=t.shape;var n=t.shape,o=n[1],a=n[2],i=e.shape,s=i[1],u=i[2],l=[r&&s>1?o-1:o,r&&u>1?a-1:a],c=[r&&s>1?s-1:s,r&&u>1?u-1:u],p=l[0]/c[0],d=l[1]/c[1],h=1/p,f=1/d,m=2*Math.ceil(h)+2,g=2*Math.ceil(f)+2;this.userCode="\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        int r = coords[1];\n        int c = coords[2];\n\n        float accumulator = 0.0;\n\n        const float heightScale = float("+p+");\n        const float widthScale = float("+d+");\n\n        const float invHeightScale = float("+h+");\n        const float invWidthScale = float("+f+");\n\n        const int winHeight = int("+m+");\n        const int winWidth = int("+g+");\n\n        // Compute bounds for where in dy we will look\n        float startRLerp = floor(float(r) * invHeightScale);\n        int startDyR = int(floor(startRLerp - float(winHeight / 2)));\n\n        float startCLerp = floor(float(c) * invWidthScale);\n        int startDyC = int(floor(startCLerp - float(winWidth / 2)));\n\n        // Loop over dy\n        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {\n          int dyR = dyROffset + startDyR;\n\n          // Guard against the window exceeding the bounds of dy\n          if (dyR < 0 || dyR >= "+s+") {\n            continue;\n          }\n\n          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {\n            int dyC = dyCOffset + startDyC;\n\n            // Guard against the window exceeding the bounds of dy\n            if (dyC < 0 || dyC >= "+u+") {\n              continue;\n            }\n\n            float sourceFracRow =\n              float("+l[0]+") *\n                (float(dyR) / float("+c[0]+"));\n\n            float sourceFracCol =\n                float("+l[1]+") *\n                  (float(dyC) / float("+c[1]+"));\n\n            int sourceNearestRow = int(min(\n                float(int("+o+") - 1),\n                "+r+" ? float(round(sourceFracRow)) :\n                                  float(floor(sourceFracRow))));\n\n            int sourceNearestCol = int(min(\n                float(int("+a+") - 1),\n                "+r+" ? float(round(sourceFracCol)) :\n                                  float(floor(sourceFracCol))));\n\n            if (r == sourceNearestRow && c == sourceNearestCol) {\n              accumulator += getDy(b, dyR, dyC, d);\n            }\n          }\n        }\n        // End loop over dy\n\n        setOutput(accumulator);\n      }\n    "}}(),ResizeNearestNeighborProgram=function(){return function(e,t,r,n){this.variableNames=["A"],this.outputShape=[];var o=e[0],a=e[1],i=e[2],s=e[3];this.outputShape=[o,t,r,s];var u=[n&&t>1?a-1:a,n&&r>1?i-1:i],l=[n&&t>1?t-1:t,n&&r>1?r-1:r],c=n?"0.5":"0.0";this.userCode="\n      const vec2 effectiveInputOverOutputRatioRC = vec2(\n          "+u[0]/l[0]+",\n          "+u[1]/l[1]+");\n      const vec2 inputShapeRC = vec2("+a+".0, "+i+".0);\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        ivec2 yRC = coords.yz;\n\n        // Fractional source index.\n        vec2 sourceFracIndexRC = vec2(yRC) * effectiveInputOverOutputRatioRC;\n\n        // Compute the coordinators of nearest neighbor point.\n        ivec2 sourceNearestRC = ivec2(\n          min(inputShapeRC - 1.0, floor(sourceFracIndexRC + "+c+")));\n\n        float newValue = getA(b, sourceNearestRC.x, sourceNearestRC.y, d);\n\n        setOutput(newValue);\n      }\n    "}}(),ReverseProgram=function(){return function(e,t){this.variableNames=["x"];var r=e.length;if(r>4)throw new Error("WebGL backend: Reverse of rank-"+r+" tensor is not yet supported");if(this.outputShape=e,1!==r){var n=e.map(function(r,n){return function(r){return-1!==t.indexOf(r)&&1!==e[r]?e[r]+" - coords["+r+"] - 1":"coords["+r+"]"}(n)}).join(","),o=getCoordsDataType(r);this.userCode="\n      void main() {\n        "+o+" coords = getOutputCoords();\n        setOutput(getX("+n+"));\n      }\n    "}else this.userCode="\n        void main() {\n          int coord = getOutputCoords();\n          setOutput(getX("+e[0]+" - coord - 1));\n        }\n      "}}(),ScatterProgram=function(){return function(e,t,r,n,o,a,i){void 0===i&&(i=!0),this.variableNames=["updates","indices","defaultValue"],this.outputShape=a;var s=getCoordsDataType(o.length),u=getCoordsDataType(a.length),l="";1===r?l="i":2===r&&(l="i, j");var c="getIndices("+l+")",p="";1===n?p="i":2===n&&(p="i, coords[1]");var d="getUpdates("+p+")",h=t>1?"strides[j]":"strides";this.userCode="\n        "+s+" strides = "+s+"("+o+");\n\n        void main() {\n          "+u+" coords = getOutputCoords();\n          float sum = 0.0;\n          bool found = false;\n          for (int i = 0; i < "+e+"; i++) {\n            int flattenedIndex = 0;\n            for (int j = 0; j < "+t+"; j++) {\n              int index = round("+c+");\n              flattenedIndex += index * "+h+";\n            }\n            if (flattenedIndex == coords[0]) {\n              sum += "+d+";\n              found = true;\n            }\n          }\n          setOutput(mix(getDefaultValue(), sum, float(found)));\n        }\n      "}}(),SegmentOpProgram=function(){return function(e,t){this.variableNames=["x","segmentIds"];var r=e.windowSize,n=e.batchSize,o=e.inSize,a=e.numSegments,i=a*Math.ceil(o/r);this.outputShape=[n,i];var s=4*Math.floor(r/4),u=r%4,l="\n        sumValue += dot(values, filter);\n    ",c="";o%r>0&&(c="\n        if (inIdx < 0 || inIdx >= "+o+") {\n          return initializationValue;\n        }\n      ");var p="";o%r>0&&(p="\n        if (inIdx < 0 || inIdx >= "+o+") {\n          return -1.0;\n        }\n      "),this.userCode="\n      const float initializationValue = 0.0;\n\n      float getValue(int batch, int inIdx) {\n        "+c+"\n        return getX(batch, inIdx);\n      }\n\n      float getSegmentIdAtIndex(int inIdx) {\n        "+p+"\n        return getSegmentIds(inIdx);\n      }\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n        int outIdx = coords[1];\n        int inOffset = int(floor(float(outIdx) / float(\n          "+a+")) * float("+r+"));\n        int currentSeg = int(mod(float(outIdx), float("+a+")));\n\n        float sumValue = 0.0;\n\n        for (int i = 0; i < "+s+"; i += 4) {\n          int inIdx = inOffset + i;\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            getValue(batch, inIdx + 3)\n          );\n\n          vec4 filter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 3)) == currentSeg ? 1 : 0\n          );\n\n          "+l+"\n        }\n\n        int inIdx = inOffset + "+s+";\n        if ("+(1===u)+") {\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            initializationValue,\n            initializationValue,\n            initializationValue\n          );\n\n          int inIdxSeg = int(getSegmentIdAtIndex(inIdx));\n\n          vec4 filter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            0,\n            0,\n            0\n          );\n\n          "+l+"\n        } else if ("+(2===u)+") {\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            initializationValue,\n            initializationValue\n          );\n\n          vec4 filter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,\n              0,\n              0\n          );\n\n          "+l+"\n        } else if ("+(3===u)+") {\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            initializationValue\n          );\n\n          vec4 filter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,\n            0\n          );\n\n          "+l+"\n        }\n        setOutput(sumValue);\n      }\n    "}}(),SelectProgram=function(){return function(e,t,r){var n,o;if(this.variableNames=["c","a","b"],this.outputShape=t,r>4)throw Error("Where for rank "+r+" is not yet supported");if(1===r)o="resRC",n="resRC";else{for(var a=["resRC.x","resRC.y","resRC.z","resRC.w"],i=[],s=[],u=0;u<t.length;u++)s.push(""+a[u]),u<e&&i.push(""+a[u]);n=i.join(),o=s.join()}var l=getCoordsDataType(r);this.userCode="\n      void main() {\n        "+l+" resRC = getOutputCoords();\n        float cVal = getC("+n+");\n        if (cVal >= 1.0) {\n          setOutput(getA("+o+"));\n        } else {\n          setOutput(getB("+o+"));\n        }\n      }\n    "}}(),SliceProgram=function(){function e(e){this.variableNames=["source"],this.outputShape=e,this.rank=e.length;var t=getCoordsDataType(this.rank),r=getCoords$1(this.rank);this.userCode="\n      uniform "+t+" start;\n\n      void main() {\n        "+t+" sourceLoc = start + getOutputCoords();\n        setOutput(getSource("+r+"));\n      }\n    "}return e.prototype.getCustomSetupFunc=function(e){var t=this;if(e.length!==this.rank)throw Error("The rank ("+this.rank+") of the program must match the length of start ("+e.length+")");return function(r,n){if(null!=t.startLoc||(t.startLoc=r.getUniformLocationNoThrow(n,"start"),null!=t.startLoc))if(1===t.rank)r.gl.uniform1i(t.startLoc,e[0]);else if(2===t.rank)r.gl.uniform2i(t.startLoc,e[0],e[1]);else if(3===t.rank)r.gl.uniform3i(t.startLoc,e[0],e[1],e[2]);else{if(4!==t.rank)throw Error("Slicing for rank "+t.rank+" is not yet supported");r.gl.uniform4i(t.startLoc,e[0],e[1],e[2],e[3])}}},e}();function getCoords$1(e){if(1===e)return"sourceLoc";if(2===e)return"sourceLoc.x, sourceLoc.y";if(3===e)return"sourceLoc.x, sourceLoc.y, sourceLoc.z";if(4===e)return"sourceLoc.x, sourceLoc.y, sourceLoc.z, sourceLoc.w";throw Error("Slicing for rank "+e+" is not yet supported")}var StridedSliceProgram=function(){return function(e,t,r,n){this.variableNames=["x"];var o=r.filter(function(e,t){return-1===n.indexOf(t)});this.outputShape=o;var a=r.length,i=getCoordsDataType(r.length),s=getCoordsDataType(o.length),u="";if(1===a)u="coords * strides + begin";else{var l=0;u=r.map(function(e,t){return-1===n.indexOf(t)?(l++,1===o.length?"coords * strides["+t+"] + begin["+t+"]":"coords["+(l-1)+"] * strides["+t+"] + begin["+t+"]"):"begin["+t+"]"}).join(",")}this.userCode="\n      "+i+" begin = "+i+"("+e+");\n      "+i+" strides = "+i+"("+t+");\n\n      void main() {\n        "+s+" coords = getOutputCoords();\n        setOutput(getX("+u+"));\n      }\n    "}}(),TextureManager=function(){function e(e){this.gpgpu=e,this.numUsedTextures=0,this.numFreeTextures=0,this.freeTextures={},this.logEnabled=!1,this.usedTextures={}}return e.prototype.acquireTexture=function(e,t,r){var n,o=getPhysicalFromLogicalTextureType(t,r),a=getKeyFromTextureShape(e,o,r);if(a in this.freeTextures||(this.freeTextures[a]=[]),a in this.usedTextures||(this.usedTextures[a]=[]),this.freeTextures[a].length>0){this.numFreeTextures--,this.numUsedTextures++,this.log();var i=this.freeTextures[a].shift();return this.usedTextures[a].push(i),i}return this.numUsedTextures++,this.log(),o===PhysicalTextureType.PACKED_2X2_FLOAT32?n=this.gpgpu.createPackedMatrixTexture(e[0],e[1]):o===PhysicalTextureType.PACKED_2X2_FLOAT16?n=this.gpgpu.createFloat16PackedMatrixTexture(e[0],e[1]):o===PhysicalTextureType.UNPACKED_FLOAT32?n=this.gpgpu.createFloat32MatrixTexture(e[0],e[1]):o===PhysicalTextureType.UNPACKED_FLOAT16?n=this.gpgpu.createFloat16MatrixTexture(e[0],e[1]):o===PhysicalTextureType.PACKED_4X1_UNSIGNED_BYTE&&(n=this.gpgpu.createUnsignedBytesMatrixTexture(e[0],e[1])),this.usedTextures[a].push(n),n},e.prototype.releaseTexture=function(e,t,r,n){if(null!=this.freeTextures){var o=getKeyFromTextureShape(t,getPhysicalFromLogicalTextureType(r,n),n);o in this.freeTextures||(this.freeTextures[o]=[]),this.freeTextures[o].push(e),this.numFreeTextures++,this.numUsedTextures--;var a=this.usedTextures[o],i=a.indexOf(e);if(i<0)throw new Error("Cannot release a texture that was never provided by this texture manager");a.splice(i,1),this.log()}},e.prototype.log=function(){if(this.logEnabled){var e=this.numFreeTextures+this.numUsedTextures;console.log("Free/Used",this.numFreeTextures+" / "+this.numUsedTextures,"("+e+")")}},e.prototype.getNumUsedTextures=function(){return this.numUsedTextures},e.prototype.getNumFreeTextures=function(){return this.numFreeTextures},e.prototype.dispose=function(){var e=this;if(null!=this.freeTextures){for(var t in this.freeTextures)this.freeTextures[t].forEach(function(t){e.gpgpu.deleteMatrixTexture(t)});for(var t in this.usedTextures)this.usedTextures[t].forEach(function(t){e.gpgpu.deleteMatrixTexture(t)});this.freeTextures=null,this.usedTextures=null,this.numUsedTextures=0,this.numFreeTextures=0}},e}();function getPhysicalFromLogicalTextureType(e,t){if(t)return ENV.get("WEBGL_RENDER_FLOAT32_ENABLED")?PhysicalTextureType.PACKED_2X2_FLOAT32:PhysicalTextureType.PACKED_2X2_FLOAT16;if(e===TextureUsage.DOWNLOAD||e===TextureUsage.PIXELS)return PhysicalTextureType.PACKED_4X1_UNSIGNED_BYTE;if(e===TextureUsage.UPLOAD)return PhysicalTextureType.UNPACKED_FLOAT32;if(e===TextureUsage.RENDER)return ENV.get("WEBGL_RENDER_FLOAT32_ENABLED")?PhysicalTextureType.UNPACKED_FLOAT32:PhysicalTextureType.UNPACKED_FLOAT16;throw new Error("Unknown logical texture type "+e)}function getKeyFromTextureShape(e,t,r){return e[0]+"_"+e[1]+"_"+t+"_"+r}var TileProgram=function(){return function(e,t){this.variableNames=["A"];for(var r=new Array(e.length),n=0;n<r.length;n++)r[n]=e[n]*t[n];this.outputShape=r,this.rank=r.length;var o=getCoordsDataType(this.rank),a=getSourceCoords$2(e);this.userCode="\n      void main() {\n        "+o+" resRC = getOutputCoords();\n        setOutput(getA("+a+"));\n      }\n    "}}();function getSourceCoords$2(e){var t=e.length;if(t>5)throw Error("Tile for rank "+t+" is not yet supported");if(1===t)return"imod(resRC, "+e[0]+")";for(var r=["resRC.x","resRC.y","resRC.z","resRC.w","resRC.u"],n=[],o=0;o<e.length;o++)n.push("imod("+r[o]+", "+e[o]+")");return n.join()}var TransposeProgram=function(){return function(e,t){this.variableNames=["A"];for(var r=new Array(e.length),n=0;n<r.length;n++)r[n]=e[t[n]];this.outputShape=r,this.rank=r.length;var o=getCoordsDataType(this.rank),a=getSwitchedCoords(t);this.userCode="\n    void main() {\n      "+o+" resRC = getOutputCoords();\n      setOutput(getA("+a+"));\n    }\n    "}}();function getSwitchedCoords(e){var t=e.length;if(t>6)throw Error("Transpose for rank "+t+" is not yet supported");for(var r=["resRC.x","resRC.y","resRC.z","resRC.w","resRC.u","resRC.v"],n=new Array(t),o=0;o<e.length;o++)n[e[o]]=r[o];return n.join()}var ERF_P=.3275911,ERF_A1=.254829592,ERF_A2=-.284496736,ERF_A3=1.421413741,ERF_A4=-1.453152027,ERF_A5=1.061405429,SELU_SCALEALPHA=1.7580993408473768,SELU_SCALE=1.0507009873554805,UnaryOpProgram=function(){function e(e,t){this.variableNames=["A"],this.outputShape=e,this.userCode="\n      uniform float NAN;\n      float unaryOperation(float x) {\n        "+t+"\n      }\n\n      void main() {\n        float x = getAAtOutCoords();\n        float y = unaryOperation(x);\n\n        setOutput(y);\n      }\n    "}return e.prototype.getCustomSetupFunc=function(){var e=this;return function(t,r){null==e.startLoc&&(e.startLoc=t.getUniformLocationNoThrow(r,"NAN"),null==e.startLoc)||t.gl.uniform1f(e.startLoc,NaN)}},e}(),CHECK_NAN_SNIPPET$1="if (isNaN(x)) return x;",ABS="return abs(x);",RELU=CHECK_NAN_SNIPPET$1+"\n  return (x < 0.0) ? 0.0 : x;\n",ELU="return (x >= 0.0) ? x : (exp(x) - 1.0);",SELU="\n  // Stable and Attracting Fixed Point (0, 1) for Normalized Weights.\n  // see: https://arxiv.org/abs/1706.02515\n  float scaleAlpha = "+SELU_SCALEALPHA+";\n  float scale = "+SELU_SCALE+";\n  return (x >= 0.0) ? scale * x : scaleAlpha * (exp(x) - 1.0);\n";function STEP(e){return void 0===e&&(e=0),CHECK_NAN_SNIPPET$1+"\n    return x > 0.0 ? 1.0 : float("+e+");\n  "}var NEG="return -x;",CEIL="return ceil(x);",FLOOR="return floor(x);",SIGN="\n  if (isNaN(x)) { return 0.0; }\n  return sign(x);\n",ROUND="\n  // OpenGL ES does not support round function.\n  // The algorithm is based on banker's rounding.\n  float base = floor(x);\n  if ((x - base) < 0.5) {\n    return floor(x);\n  } else if ((x - base) > 0.5) {\n    return ceil(x);\n  } else {\n    if (mod(base, 2.0) == 0.0) {\n      return base;\n    } else {\n      return base + 1.0;\n    }\n  }\n",EXP="return exp(x);",EXPM1="return exp(x) - 1.0;",LOG="if (x < 0.0) return NAN;\n  return log(x);",LOG1P="return log(1.0 + x);",SQRT="return sqrt(x);",RSQRT="return inversesqrt(x);",SIGMOID="return 1.0 / (1.0 + exp(-1.0 * x));",SOFTPLUS="\n  float epsilon = 1.1920928955078125e-7;\n  float threshold = log(epsilon) + 2.0;\n\n  bool too_large = x > -threshold;\n  bool too_small = x < threshold;\n\n  float result;\n  float exp_x = exp(x);\n\n  if (too_large){\n    result = x;\n  }\n  else if (too_small){\n    result = exp_x;\n  }\n  else{\n    result = log(exp_x + 1.0);\n  }\n  return result;\n",SIN=CHECK_NAN_SNIPPET$1+"\n  return sin(x);\n",COS=CHECK_NAN_SNIPPET$1+"\n  return cos(x);\n",TAN="return tan(x);",ASIN="return asin(x);",ACOS="return acos(x);",ATAN=CHECK_NAN_SNIPPET$1+"\n  return atan(x);\n",SINH="\n  float e2x = exp(x);\n  return (e2x - 1.0 / e2x) / 2.0;\n",COSH="\n  float e2x = exp(-x);\n  return (e2x + 1.0 / e2x) / 2.0;\n",TANH="\n  float e2x = exp(-2.0 * abs(x));\n  return sign(x) * (1.0 - e2x) / (1.0 + e2x);\n",ASINH="return log(x + sqrt(x * x + 1.0));",ACOSH=CHECK_NAN_SNIPPET$1+"\n  if (x < 1.0) return NAN;\n  return log(x + sqrt(x * x - 1.0));",ATANH=CHECK_NAN_SNIPPET$1+"\n  if ((x < -1.0) || (x > 1.0)) return NAN;\n  return (log(1.0 + x) - log(1.0 - x)) / 2.0;",ERF='\n  // Error function is calculated approximately with elementary function.\n  // See "Handbook of Mathematical Functions with Formulas,\n  // Graphs, and Mathematical Tables", Abramowitz and Stegun.\n  float p = '+ERF_P+";\n  float a1 = "+ERF_A1+";\n  float a2 = "+ERF_A2+";\n  float a3 = "+ERF_A3+";\n  float a4 = "+ERF_A4+";\n  float a5 = "+ERF_A5+";\n\n  float t = 1.0 / (1.0 + p * x);\n  return 1.0 - (((((a5*t + a4)*t) + a3)*t + a2)*t + a1)*t*exp(-x*x);\n",SQUARE="return x * x;",RECIPROCAL="return 1.0 / x;",LOGICAL_NOT="return float(!(x >= 1.0));",TO_INT="return float(int(x));",UnpackProgram=function(){return function(e){this.variableNames=["A"],this.usesPackedTextures=!0,this.outputShape=e;var t=e.length,r=getChannels("rc",t),n=getCoordsDataType(t),o=getSourceCoords$1(t,r),a=r.slice(-2),i=1===t?"rc":"vec2("+a.join(",")+")";this.userCode="\n      void main() {\n        "+n+" rc = getOutputCoords();\n        vec4 packedInput = getA("+o+");\n\n        setOutput(getChannel(packedInput, "+i+"));\n      }\n    "}}();function concat1d_(e){return concat(e,0)}function concat2d_(e,t){return concat(e,t)}function concat3d_(e,t){return concat(e,t)}function concat4d_(e,t){return concat(e,t)}function concat_(e,t){void 0===t&&(t=0),assert(e.length>=1,"Pass at least one tensor to concat");var r=convertToTensorArray(e,"tensors","concat");t=parseAxisParam(t,r[0].shape)[0];var n=computeOutShape(r.map(function(e){return e.shape}),t);if(0===sizeFromShape(n))return tensor([],n);if(1===(r=r.filter(function(e){return e.size>0})).length)return r[0];var o=r.map(function(e){return e.shape});assertParamsConsistent(o,t);var a=r;return ENV.engine.runKernel(function(e){return e.concat(r,t)},a,function(e){var r=o.map(function(e){return e[t]});return split$1(e,r,t).map(function(e){return function(){return e}})})}function split_(e,t,r){void 0===r&&(r=0);var n,o=convertToTensor(e,"x","split");r=parseAxisParam(r,o.shape)[0],"number"==typeof t?(assert(o.shape[r]%t==0,"Number of splits must evenly divide the axis."),n=Array(t).fill(o.shape[r]/t)):(assert(o.shape[r]===t.reduce(function(e,t){return e+t}),"The sum of sizes must match the size of the axis dimension."),n=t);return ENV.engine.runKernel(function(e){return e.split(o,n,r)},{$x:o},function(e){return{$x:function(){return concat(e,r)}}})}var concat=op({concat_:concat_}),concat1d=op({concat1d_:concat1d_}),concat2d=op({concat2d_:concat2d_}),concat3d=op({concat3d_:concat3d_}),concat4d=op({concat4d_:concat4d_}),split$1=op({split_:split_}),commonjsGlobal="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function createCommonjsModule(e,t){return e(t={exports:{}},t.exports),t.exports}var alea=createCommonjsModule(function(e){!function(e,t,r){function n(e,t){return t.c=e.c,t.s0=e.s0,t.s1=e.s1,t.s2=e.s2,t}function o(e,t){var r=new function(e){var t,r=this,n=(t=4022871197,function(e){e=e.toString();for(var r=0;r<e.length;r++){var n=.02519603282416938*(t+=e.charCodeAt(r));n-=t=n>>>0,t=(n*=t)>>>0,t+=4294967296*(n-=t)}return 2.3283064365386963e-10*(t>>>0)});r.next=function(){var e=2091639*r.s0+2.3283064365386963e-10*r.c;return r.s0=r.s1,r.s1=r.s2,r.s2=e-(r.c=0|e)},r.c=1,r.s0=n(" "),r.s1=n(" "),r.s2=n(" "),r.s0-=n(e),r.s0<0&&(r.s0+=1),r.s1-=n(e),r.s1<0&&(r.s1+=1),r.s2-=n(e),r.s2<0&&(r.s2+=1),n=null}(e),o=t&&t.state,a=r.next;return a.int32=function(){return 4294967296*r.next()|0},a.double=function(){return a()+1.1102230246251565e-16*(2097152*a()|0)},a.quick=a,o&&("object"==typeof o&&n(o,r),a.state=function(){return n(r,{})}),a}t&&t.exports?t.exports=o:r&&r.amd?r(function(){return o}):this.alea=o}(0,e,!1)}),xor128=createCommonjsModule(function(e){!function(e,t,r){function n(e,t){return t.x=e.x,t.y=e.y,t.z=e.z,t.w=e.w,t}function o(e,t){var r=new function(e){var t=this,r="";t.x=0,t.y=0,t.z=0,t.w=0,t.next=function(){var e=t.x^t.x<<11;return t.x=t.y,t.y=t.z,t.z=t.w,t.w^=t.w>>>19^e^e>>>8},e===(0|e)?t.x=e:r+=e;for(var n=0;n<r.length+64;n++)t.x^=0|r.charCodeAt(n),t.next()}(e),o=t&&t.state,a=function(){return(r.next()>>>0)/4294967296};return a.double=function(){do{var e=((r.next()>>>11)+(r.next()>>>0)/4294967296)/(1<<21)}while(0===e);return e},a.int32=r.next,a.quick=a,o&&("object"==typeof o&&n(o,r),a.state=function(){return n(r,{})}),a}t&&t.exports?t.exports=o:r&&r.amd?r(function(){return o}):this.xor128=o}(0,e,!1)}),xorwow=createCommonjsModule(function(e){!function(e,t,r){function n(e,t){return t.x=e.x,t.y=e.y,t.z=e.z,t.w=e.w,t.v=e.v,t.d=e.d,t}function o(e,t){var r=new function(e){var t=this,r="";t.next=function(){var e=t.x^t.x>>>2;return t.x=t.y,t.y=t.z,t.z=t.w,t.w=t.v,(t.d=t.d+362437|0)+(t.v=t.v^t.v<<4^e^e<<1)|0},t.x=0,t.y=0,t.z=0,t.w=0,t.v=0,e===(0|e)?t.x=e:r+=e;for(var n=0;n<r.length+64;n++)t.x^=0|r.charCodeAt(n),n==r.length&&(t.d=t.x<<10^t.x>>>4),t.next()}(e),o=t&&t.state,a=function(){return(r.next()>>>0)/4294967296};return a.double=function(){do{var e=((r.next()>>>11)+(r.next()>>>0)/4294967296)/(1<<21)}while(0===e);return e},a.int32=r.next,a.quick=a,o&&("object"==typeof o&&n(o,r),a.state=function(){return n(r,{})}),a}t&&t.exports?t.exports=o:r&&r.amd?r(function(){return o}):this.xorwow=o}(0,e,!1)}),xorshift7=createCommonjsModule(function(e){!function(e,t,r){function n(e,t){return t.x=e.x.slice(),t.i=e.i,t}function o(e,t){null==e&&(e=+new Date);var r=new function(e){var t=this;t.next=function(){var e,r,n=t.x,o=t.i;return e=n[o],r=(e^=e>>>7)^e<<24,r^=(e=n[o+1&7])^e>>>10,r^=(e=n[o+3&7])^e>>>3,r^=(e=n[o+4&7])^e<<7,e=n[o+7&7],r^=(e^=e<<13)^e<<9,n[o]=r,t.i=o+1&7,r},function(e,t){var r,n=[];if(t===(0|t))n[0]=t;else for(t=""+t,r=0;r<t.length;++r)n[7&r]=n[7&r]<<15^t.charCodeAt(r)+n[r+1&7]<<13;for(;n.length<8;)n.push(0);for(r=0;r<8&&0===n[r];++r);for(8==r?n[7]=-1:n[r],e.x=n,e.i=0,r=256;r>0;--r)e.next()}(t,e)}(e),o=t&&t.state,a=function(){return(r.next()>>>0)/4294967296};return a.double=function(){do{var e=((r.next()>>>11)+(r.next()>>>0)/4294967296)/(1<<21)}while(0===e);return e},a.int32=r.next,a.quick=a,o&&(o.x&&n(o,r),a.state=function(){return n(r,{})}),a}t&&t.exports?t.exports=o:r&&r.amd?r(function(){return o}):this.xorshift7=o}(0,e,!1)}),xor4096=createCommonjsModule(function(e){!function(e,t,r){function n(e,t){return t.i=e.i,t.w=e.w,t.X=e.X.slice(),t}function o(e,t){null==e&&(e=+new Date);var r=new function(e){var t=this;t.next=function(){var e,r,n=t.w,o=t.X,a=t.i;return t.w=n=n+1640531527|0,r=o[a+34&127],e=o[a=a+1&127],r^=r<<13,e^=e<<17,r^=r>>>15,e^=e>>>12,r=o[a]=r^e,t.i=a,r+(n^n>>>16)|0},function(e,t){var r,n,o,a,i,s=[],u=128;for(t===(0|t)?(n=t,t=null):(t+="\0",n=0,u=Math.max(u,t.length)),o=0,a=-32;a<u;++a)t&&(n^=t.charCodeAt((a+32)%t.length)),0===a&&(i=n),n^=n<<10,n^=n>>>15,n^=n<<4,n^=n>>>13,a>=0&&(i=i+1640531527|0,o=0==(r=s[127&a]^=n+i)?o+1:0);for(o>=128&&(s[127&(t&&t.length||0)]=-1),o=127,a=512;a>0;--a)n=s[o+34&127],r=s[o=o+1&127],n^=n<<13,r^=r<<17,n^=n>>>15,r^=r>>>12,s[o]=n^r;e.w=i,e.X=s,e.i=o}(t,e)}(e),o=t&&t.state,a=function(){return(r.next()>>>0)/4294967296};return a.double=function(){do{var e=((r.next()>>>11)+(r.next()>>>0)/4294967296)/(1<<21)}while(0===e);return e},a.int32=r.next,a.quick=a,o&&(o.X&&n(o,r),a.state=function(){return n(r,{})}),a}t&&t.exports?t.exports=o:r&&r.amd?r(function(){return o}):this.xor4096=o}(0,e,!1)}),tychei=createCommonjsModule(function(e){!function(e,t,r){function n(e,t){return t.a=e.a,t.b=e.b,t.c=e.c,t.d=e.d,t}function o(e,t){var r=new function(e){var t=this,r="";t.next=function(){var e=t.b,r=t.c,n=t.d,o=t.a;return e=e<<25^e>>>7^r,r=r-n|0,n=n<<24^n>>>8^o,o=o-e|0,t.b=e=e<<20^e>>>12^r,t.c=r=r-n|0,t.d=n<<16^r>>>16^o,t.a=o-e|0},t.a=0,t.b=0,t.c=-1640531527,t.d=1367130551,e===Math.floor(e)?(t.a=e/4294967296|0,t.b=0|e):r+=e;for(var n=0;n<r.length+20;n++)t.b^=0|r.charCodeAt(n),t.next()}(e),o=t&&t.state,a=function(){return(r.next()>>>0)/4294967296};return a.double=function(){do{var e=((r.next()>>>11)+(r.next()>>>0)/4294967296)/(1<<21)}while(0===e);return e},a.int32=r.next,a.quick=a,o&&("object"==typeof o&&n(o,r),a.state=function(){return n(r,{})}),a}t&&t.exports?t.exports=o:r&&r.amd?r(function(){return o}):this.tychei=o}(0,e,!1)}),seedrandom=createCommonjsModule(function(e){!function(t,r){var n,o=this,a=256,i=6,s="random",u=r.pow(a,i),l=r.pow(2,52),c=2*l,p=a-1;function d(e,d,g){var v=[],y=f(function e(t,r){var n,o=[],a=typeof t;if(r&&"object"==a)for(n in t)try{o.push(e(t[n],r-1))}catch(e){}return o.length?o:"string"==a?t:t+"\0"}((d=1==d?{entropy:!0}:d||{}).entropy?[e,m(t)]:null==e?function(){try{var e;return n&&(e=n.randomBytes)?e=e(a):(e=new Uint8Array(a),(o.crypto||o.msCrypto).getRandomValues(e)),m(e)}catch(e){var r=o.navigator,i=r&&r.plugins;return[+new Date,o,i,o.screen,m(t)]}}():e,3),v),x=new function(e){var t,r=e.length,n=this,o=0,i=n.i=n.j=0,s=n.S=[];r||(e=[r++]);for(;o<a;)s[o]=o++;for(o=0;o<a;o++)s[o]=s[i=p&i+e[o%r]+(t=s[o])],s[i]=t;(n.g=function(e){for(var t,r=0,o=n.i,i=n.j,s=n.S;e--;)t=s[o=p&o+1],r=r*a+s[p&(s[o]=s[i=p&i+t])+(s[i]=t)];return n.i=o,n.j=i,r})(a)}(v),T=function(){for(var e=x.g(i),t=u,r=0;e<l;)e=(e+r)*a,t*=a,r=x.g(1);for(;e>=c;)e/=2,t/=2,r>>>=1;return(e+r)/t};return T.int32=function(){return 0|x.g(4)},T.quick=function(){return x.g(4)/4294967296},T.double=T,f(m(x.S),t),(d.pass||g||function(e,t,n,o){return o&&(o.S&&h(o,x),e.state=function(){return h(x,{})}),n?(r[s]=e,t):e})(T,y,"global"in d?d.global:this==r,d.state)}function h(e,t){return t.i=e.i,t.j=e.j,t.S=e.S.slice(),t}function f(e,t){for(var r,n=e+"",o=0;o<n.length;)t[p&o]=p&(r^=19*t[p&o])+n.charCodeAt(o++);return m(t)}function m(e){return String.fromCharCode.apply(0,e)}if(r["seed"+s]=d,f(r.random(),t),e.exports){e.exports=d;try{n=__webpack_require__(170)}catch(e){}}else 0}([],Math)});seedrandom.alea=alea,seedrandom.xor128=xor128,seedrandom.xorwow=xorwow,seedrandom.xorshift7=xorshift7,seedrandom.xor4096=xor4096,seedrandom.tychei=tychei;var seedrandom$1=seedrandom,seedrandom_1=seedrandom$1.alea,MPRandGauss=function(){function e(e,t,r,n,o){this.mean=e,this.stdDev=t,this.dtype=r,this.nextVal=NaN,this.truncated=n,this.truncated&&(this.upper=this.mean+2*this.stdDev,this.lower=this.mean-2*this.stdDev);var a=o||Math.random();this.random=seedrandom_1(a.toString())}return e.prototype.nextValue=function(){if(!isNaN(this.nextVal)){var e=this.nextVal;return this.nextVal=NaN,e}for(var t,r,n=!1;!n;){var o=void 0,a=void 0,i=void 0;do{i=(o=2*this.random()-1)*o+(a=2*this.random()-1)*a}while(i>=1||0===i);var s=Math.sqrt(-2*Math.log(i)/i);t=this.mean+this.stdDev*o*s,r=this.mean+this.stdDev*a*s,this.truncated&&!this.isValidTruncated(t)||(n=!0)}return this.truncated&&!this.isValidTruncated(r)||(this.nextVal=this.convertValue(r)),this.convertValue(t)},e.prototype.convertValue=function(e){return null==this.dtype||"float32"===this.dtype?e:Math.round(e)},e.prototype.isValidTruncated=function(e){return e<=this.upper&&e>=this.lower},e}();function clone_(e){var t=convertToTensor(e,"x","clone");return ENV.engine.runKernel(function(e){return Tensor.make(t.shape,{dataId:t.dataId},t.dtype)},{$x:t},function(e){return{$x:function(){return e.toFloat()}}})}function eye_(e,t,r,n){void 0===n&&(n="float32"),null==t&&(t=e);for(var o=buffer([e,t],n),a=e<=t?e:t,i=0;i<a;++i)o.set(1,i,i);var s=o.toTensor().as2D(e,t);if(null==r)return s;if(1===r.length)return tile(expandDims(s,0),[r[0],1,1]);if(2===r.length)return tile(expandDims(expandDims(s,0),0),[r[0],r[1],1,1]);if(3===r.length)return tile(expandDims(expandDims(expandDims(s,0),0),0),[r[0],r[1],r[2],1,1]);throw new Error("eye() currently supports only 1D and 2D batchShapes, but received "+r.length+"D.")}function randomNormal_(e,t,r,n,o){if(void 0===t&&(t=0),void 0===r&&(r=1),null!=n&&"bool"===n)throw new Error("Unsupported data type "+n);for(var a=new MPRandGauss(t,r,n,!1,o),i=buffer(e,n),s=0;s<i.values.length;s++)i.values[s]=a.nextValue();return i.toTensor()}function truncatedNormal_(e,t,r,n,o){if(void 0===t&&(t=0),void 0===r&&(r=1),null!=n&&"bool"===n)throw new Error("Unsupported data type "+n);for(var a=new MPRandGauss(t,r,n,!0,o),i=buffer(e,n),s=0;s<i.values.length;s++)i.values[s]=a.nextValue();return i.toTensor()}function randomUniform_(e,t,r,n){void 0===t&&(t=0),void 0===r&&(r=1),void 0===n&&(n="float32");for(var o=buffer(e,n),a=0;a<o.values.length;a++)o.values[a]=randUniform(t,r);return o.toTensor()}function rand_(e,t,r){var n=sizeFromShape(e),o=null;if(null==r||"float32"===r)o=new Float32Array(n);else if("int32"===r)o=new Int32Array(n);else{if("bool"!==r)throw new Error("Unknown data type "+r);o=new Uint8Array(n)}for(var a=0;a<n;a++)o[a]=t();return Tensor.make(e,{values:o},r)}function multinomial_(e,t,r,n){void 0===n&&(n=!1);var o=convertToTensor(e,"logits","multinomial"),a=o.size,i=o.rank;if(a<2)throw new Error("Error in multinomial: you need at least 2 outcomes, but got "+a+".");if(i>2)throw new Error("Rank of probabilities must be 1 or 2, but is "+i);r=r||Math.random();var s=1===i?o.as2D(1,-1):o,u=ENV.engine.runKernel(function(e){return e.multinomial(s,n,t,r)},{logits2D:s});return 1===i?u.as1D():u}function oneHot_(e,t,r,n){void 0===r&&(r=1),void 0===n&&(n=0);var o=convertToTensor(e,"indices","oneHot","int32");if(assert("int32"===o.dtype,"Indices must be of dtype `int32`"),t<2)throw new Error("Error in oneHot: depth must be >=2, but it is "+t);return ENV.engine.runKernel(function(e){return e.oneHot(o,t,r,n)},{$indices:o},function(e){return{$indices:function(){return zerosLike(o)}}})}function fromPixels_(e,t){if(void 0===t&&(t=3),t>4)throw new Error("Cannot construct Tensor with more than 4 channels from pixels.");return ENV.engine.fromPixels(e,t)}function toPixels(e,t){return __awaiter(this,void 0,void 0,function(){var r,n,o,a,i,s,u,l,c,p,d,h,f,m,g,v,y,x,T,E;return __generator(this,function(w){switch(w.label){case 0:if(2!==(r=convertToTensor(e,"img","toPixels","int32")).rank&&3!==r.rank)throw new Error("toPixels only supports rank 2 or 3 tensors, got rank "+r.rank+".");if(n=r.shape.slice(0,2),o=n[0],a=n[1],(i=2===r.rank?1:r.shape[2])>4||2===i)throw new Error("toPixels only supports depth of size 1, 3 or 4 but got "+i);return s=r.min(),u=r.max(),[4,s.data()];case 1:return l=w.sent()[0],[4,u.data()];case 2:if(c=w.sent()[0],s.dispose(),u.dispose(),"float32"===r.dtype){if(l<0||c>1)throw new Error("Tensor values for a float32 Tensor must be in the range [0 - 1] but got range ["+l+" - "+c+"].")}else{if("int32"!==r.dtype)throw new Error("Unsupported type for toPixels: "+r.dtype+". Please use float32 or int32 tensors.");if(l<0||c>255)throw new Error("Tensor values for a int32 Tensor must be in the range [0 - 255] but got range ["+l+" - "+c+"].")}return[4,r.data()];case 3:for(p=w.sent(),d="float32"===r.dtype?255:1,h=new Uint8ClampedArray(a*o*4),f=0;f<o*a;++f)m=void 0,g=void 0,v=void 0,y=void 0,1===i?(m=p[f]*d,g=p[f]*d,v=p[f]*d,y=255):3===i?(m=p[3*f]*d,g=p[3*f+1]*d,v=p[3*f+2]*d,y=255):4===i&&(m=p[4*f]*d,g=p[4*f+1]*d,v=p[4*f+2]*d,y=p[4*f+3]*d),h[(x=4*f)+0]=Math.round(m),h[x+1]=Math.round(g),h[x+2]=Math.round(v),h[x+3]=Math.round(y);return null!=t&&(t.width=a,t.height=o,T=t.getContext("2d"),E=new ImageData(h,a,o),T.putImageData(E,0,0)),r!==e&&r.dispose(),[2,h]}})})}function reshape_(e,t){var r=convertToTensor(e,"x","reshape");t=inferFromImplicitShape(t,r.size),assert(r.size===sizeFromShape(t),"new shape and old shape must have the same number of elements.");return ENV.engine.runKernel(function(e){return e.reshape(r,t)},{$x:r},function(e){return{$x:function(){return e.reshape(r.shape)}}})}function squeeze_(e,t){var r=convertToTensor(e,"x","squeeze");return reshape(r,squeezeShape(r.shape,t).newShape)}function cast_(e,t){var r=convertToTensor(e,"x","cast");return ENV.engine.runKernel(function(e){return e.cast(r,t)},{$x:r},function(e){return{$x:function(){return e.clone()}}})}function tile_(e,t){var r=convertToTensor(e,"x","tile");assert(r.rank===t.length,"Error in transpose: rank of input "+r.rank+" must match length of reps "+t+".");return ENV.engine.runKernel(function(e){return e.tile(r,t)},{$x:r},function(e){return{$x:function(){var n=zerosLike(r);if(1===r.rank)for(var o=0;o<t[0];++o)n=n.add(e.slice([o*r.shape[0]],[r.shape[0]]));else if(2===r.rank)for(o=0;o<t[0];++o)for(var a=0;a<t[1];++a)n=n.add(e.slice([o*r.shape[0],a*r.shape[1]],[r.shape[0],r.shape[1]]));else if(3===r.rank)for(o=0;o<t[0];++o)for(a=0;a<t[1];++a)for(var i=0;i<t[2];++i)n=n.add(e.slice([o*r.shape[0],a*r.shape[1],i*r.shape[2]],[r.shape[0],r.shape[1],r.shape[2]]));else{if(4!==r.rank)throw new Error("Gradient for tile operation is not implemented for rank-"+r.rank+" tensors yet.");for(o=0;o<t[0];++o)for(a=0;a<t[1];++a)for(i=0;i<t[2];++i)for(var s=0;s<t[3];++s)n=n.add(e.slice([o*r.shape[0],a*r.shape[1],i*r.shape[2],s*r.shape[3]],[r.shape[0],r.shape[1],r.shape[2],r.shape[3]]))}return n}}})}function pad1d_(e,t,r){return void 0===r&&(r=0),assert(2===t.length,"Invalid number of paddings. Must be length of 2."),pad(e,[t],r)}function pad2d_(e,t,r){return void 0===r&&(r=0),assert(2===t.length&&2===t[0].length&&2===t[1].length,"Invalid number of paddings. Must be length of 2 each."),pad(e,t,r)}function pad3d_(e,t,r){return void 0===r&&(r=0),assert(3===t.length&&2===t[0].length&&2===t[1].length&&2===t[2].length,"Invalid number of paddings. Must be length of 2 each."),pad(e,t,r)}function pad4d_(e,t,r){return void 0===r&&(r=0),assert(4===t.length&&2===t[0].length&&2===t[1].length&&2===t[2].length&&2===t[3].length,"Invalid number of paddings. Must be length of 2 each."),pad(e,t,r)}function pad_(e,t,r){void 0===r&&(r=0);var n=convertToTensor(e,"x","pad");if(0===n.rank)throw new Error("pad(scalar) is not defined. Pass non-scalar to pad");var o=t.map(function(e){return e[0]});return ENV.engine.runKernel(function(e){return e.pad(n,t,r)},{$x:n},function(e){return{$x:function(){return e.slice(o,n.shape)}}})}function stack_(e,t){void 0===t&&(t=0);var r=convertToTensorArray(e,"tensors","stack");if(assert(r.length>=1,"Pass at least one tensor to tf.stack"),1===r.length)return r[0].expandDims(t);var n=r[0].rank,o=r[0].shape,a=r[0].dtype;assert(t<=n,"Axis must be <= rank of the tensor"),r.forEach(function(e){assertShapesMatch(o,e.shape,"All tensors passed to stack must have matching shapes")}),r.forEach(function(e){assert(a===e.dtype,"All tensors passed to stack must have matching dtypes")});var i=r.map(function(e){return e.expandDims(t)});return concat(i,t)}function batchToSpaceND_(e,t,r){var n=convertToTensor(e,"x","batchToSpaceND"),o=t.reduce(function(e,t){return e*t});assert(n.rank>=1+t.length,"input rank is "+n.rank+" but should be > than blockShape.length "+t.length),assert(r.length===t.length,"crops.length is "+r.length+" but should be equal to blockShape.length  "+t.length),assert(n.shape[0]%o==0,"input tensor batch is "+n.shape[0]+" but is not divisible by the product of the elements of blockShape "+t.join(" * ")+" === "+o);return ENV.engine.runKernel(function(e){return e.batchToSpaceND(n,t,r)},{$x:n},function(e){return{$x:function(){return e.spaceToBatchND(t,r)}}})}function spaceToBatchND_(e,t,r){var n=convertToTensor(e,"x","spaceToBatchND");assert(n.rank>=1+t.length,"input rank "+n.rank+" should be > than [blockShape] "+t.length),assert(r.length===t.length,"paddings.shape[0] "+r.length+" must be equal to [blockShape] "+t.length),assert(n.shape.reduce(function(e,n,o){return o>0&&o<=t.length?e&&(n+r[o-1][0]+r[o-1][1])%t[o-1]==0:e},!0),"input spatial dimensions "+n.shape.slice(1)+" with paddings "+r.toString()+" must be divisible by blockShapes "+t.toString());return ENV.engine.runKernel(function(e){return e.spaceToBatchND(n,t,r)},{$x:n},function(e){return{$x:function(){return e.batchToSpaceND(t,r)}}})}function unstack_(e,t){void 0===t&&(t=0);for(var r,n=convertToTensor(e,"x","unstack"),o=n.shape[t],a=Array(n.rank-1).fill(0),i=0,s=0;s<n.rank;s++)s!==t&&(a[i]=n.shape[s],i++);r=Array(o).fill(1);var u=Array(n.rank).fill(0),l=n.shape.slice();return r.map(function(e){l[t]=e;var r=n.slice(u,l);return u[t]+=e,r.reshape(a)})}function cumsum_(e,t,r,n){void 0===t&&(t=0),void 0===r&&(r=!1),void 0===n&&(n=!1);var o=convertToTensor(e,"x","cumsum"),a=getAxesPermutation([t|=0],o.rank),i=o;null!=a&&(i=o.transpose(a));var s=getInnerMostAxes(1,o.rank)[0],u=ENV.engine.runKernel(function(e){return e.cumsum(i,s,r,n)},{permutedX:i},function(e){return{permutedX:function(){return e.cumsum(t,r,!n)}}});return null!=a&&(u=u.transpose(a)),u}function expandDims_(e,t){void 0===t&&(t=0);var r=convertToTensor(e,"x","expandDims");assert(t<=r.rank,"Axis must be <= rank of the tensor");var n=r.shape.slice();return t<0&&(assert(-(r.rank+1)<=t,"Axis must be in the interval ["+-(r.rank+1)+", "+r.rank+"]"),t=r.rank+t+1),n.splice(t,0,1),reshape(r,n)}function depthToSpace_(e,t,r){void 0===r&&(r="NHWC");var n=convertToTensor(e,"x","depthToSpace"),o="NHWC"===r?n.shape[1]:n.shape[2],a="NHWC"===r?n.shape[2]:n.shape[3],i="NHWC"===r?n.shape[3]:n.shape[1];return assert(o*t>=0,"Negative dimension size caused by overflow when multiplying\n      "+o+" and "+t+"  for depthToSpace with input shape\n      "+n.shape),assert(a*t>=0,"Negative dimension size caused by overflow when multiplying\n      "+a+" and "+t+" for depthToSpace with input shape\n          "+n.shape),assert(i%(t*t)==0,"Dimension size must be evenly divisible by "+t*t+" but is "+i+" for depthToSpace with input shape "+n.shape),ENV.engine.runKernel(function(e){return e.depthToSpace(n,t,r)},{$x:n})}function setdiff1dAsync_(e,t){return __awaiter(this,void 0,void 0,function(){var r,n,o,a,i,s,u,l,c,p;return __generator(this,function(d){switch(d.label){case 0:return r=convertToTensor(e,"x","setdiff1d"),n=convertToTensor(t,"y","setdiff1d"),assert(r.dtype===n.dtype,"x and y should have the same dtype, but got x ("+r.dtype+") and y ("+n.dtype+")."),assert(1===r.rank,"x should be 1D tensor, but got x ("+r.shape+")."),assert(1===n.rank,"y should be 1D tensor, but got y ("+n.shape+")."),[4,r.data()];case 1:return o=d.sent(),[4,n.data()];case 2:for(a=d.sent(),i=new Set(a),s=0,c=0;c<o.length;c++)i.has(o[c])||s++;for(u=new TensorBuffer([s],r.dtype),l=new TensorBuffer([s],"int32"),c=0,p=0;c<o.length;c++)i.has(o[c])||(u.values[p]=o[c],l.values[p]=c,p++);return[2,[u.toTensor(),l.toTensor()]]}})})}function buffer(e,t,r){return void 0===t&&(t="float32"),new TensorBuffer(e,t,r)}function print(e,t){void 0===t&&(t=!1),console.log(e.toString(t))}var batchToSpaceND=op({batchToSpaceND_:batchToSpaceND_}),cast=op({cast_:cast_}),clone=op({clone_:clone_}),cumsum=op({cumsum_:cumsum_}),depthToSpace=op({depthToSpace_:depthToSpace_}),expandDims=op({expandDims_:expandDims_}),eye=op({eye_:eye_}),fromPixels=op({fromPixels_:fromPixels_}),multinomial=op({multinomial_:multinomial_}),oneHot=op({oneHot_:oneHot_}),pad=op({pad_:pad_}),pad1d=op({pad1d_:pad1d_}),pad2d=op({pad2d_:pad2d_}),pad3d=op({pad3d_:pad3d_}),pad4d=op({pad4d_:pad4d_}),rand=op({rand_:rand_}),randomNormal=op({randomNormal_:randomNormal_}),randomUniform=op({randomUniform_:randomUniform_}),reshape=op({reshape_:reshape_}),spaceToBatchND=op({spaceToBatchND_:spaceToBatchND_}),squeeze=op({squeeze_:squeeze_}),stack=op({stack_:stack_}),tile=op({tile_:tile_}),truncatedNormal=op({truncatedNormal_:truncatedNormal_}),unstack=op({unstack_:unstack_}),setdiff1dAsync=setdiff1dAsync_;function whereImpl(e,t){for(var r=[],n=0;n<t.length;n++)t[n]&&r.push(n);var o=buffer(e,"int32"),a=buffer([r.length,e.length],"int32");for(n=0;n<r.length;n++){var i=o.indexToLoc(r[n]),s=n*e.length;a.values.set(i,s)}return a.toTensor()}var CPU_HANDOFF_SIZE_THRESHOLD=10,BEFORE_PAGING_CONSTANT=300,MATMUL_SHARED_DIM_THRESHOLD=1e3,MathBackendWebGL=function(){function e(e,t){if(void 0===t&&(t=!0),this.gpgpu=e,this.delayedStorage=t,this.pendingRead=new WeakMap,this.pendingDisposal=new WeakSet,this.lruDataGPU=[],this.numBytesInGPU=0,this.uploadWaitMs=0,this.downloadWaitMs=0,this.binaryCache={},this.disposed=!1,ENV.get("WEBGL_VERSION")<1)throw new Error("WebGL is not supported on this device");if(null==e){var r=getWebGLContext(ENV.get("WEBGL_VERSION"));this.gpgpu=new GPGPUContext(r),this.canvas=r.canvas,this.gpgpuCreatedLocally=!0}else this.gpgpuCreatedLocally=!1,this.canvas=e.gl.canvas;ENV.get("WEBGL_PAGING_ENABLED")&&(this.NUM_BYTES_BEFORE_PAGING=window.screen.height*window.screen.width*window.devicePixelRatio*BEFORE_PAGING_CONSTANT),this.textureManager=new TextureManager(this.gpgpu)}return e.prototype.register=function(e,t,r){if(this.texData.has(e))throw new Error("Data buffer is already registered");this.texData.set(e,{shape:t,dtype:r,values:null,texture:null,complexTensors:null,texShape:null,usage:TextureUsage.RENDER,isPacked:!1})},e.prototype.setDataMover=function(e){this.texData=new DataStorage(e)},e.prototype.fromPixels=function(e,t){if(null==e)throw new Error("pixels passed to tf.fromPixels() can not be null");var r=[e.height,e.width],n=[e.height,e.width,t];if(!(e instanceof HTMLVideoElement||e instanceof HTMLImageElement||e instanceof HTMLCanvasElement||e instanceof ImageData))throw new Error("pixels passed to tf.fromPixels() must be either an HTMLVideoElement, HTMLImageElement, HTMLCanvasElement or ImageData, but was "+e.constructor.name);if(e instanceof HTMLVideoElement){if(null==this.fromPixels2DContext){if(!ENV.get("IS_BROWSER"))throw new Error("Can't read pixels from HTMLImageElement outside the browser.");if("complete"!==document.readyState)throw new Error("The DOM is not ready yet. Please call tf.fromPixels() once the DOM is ready. One way to do that is to add an event listener for `DOMContentLoaded` on the document object");this.fromPixels2DContext=document.createElement("canvas").getContext("2d")}this.fromPixels2DContext.canvas.width=e.width,this.fromPixels2DContext.canvas.height=e.height,this.fromPixels2DContext.drawImage(e,0,0,e.width,e.height),e=this.fromPixels2DContext.canvas}var o=this.makeTensorHandle(r,"int32");this.texData.get(o.dataId).usage=TextureUsage.PIXELS,this.gpgpu.uploadPixelDataToTexture(this.getTexture(o.dataId),e);var a=new FromPixelsProgram(n),i=this.compileAndRun(a,[o]);return this.disposeData(o.dataId),i},e.prototype.makeTensorHandle=function(e,t){var r={};return this.register(r,e,t),{dataId:r,shape:e,dtype:t}},e.prototype.write=function(e,t){if(null==t)throw new Error("MathBackendWebGL.write(): values can not be null");var r=this.texData.get(e),n=r.texture,o=r.texShape,a=r.usage,i=r.dtype,s=r.isPacked;if("complex64"===i)throw new Error("Cannot write to a complex64 dtype. Please use tf.complex(real, imag).");null!=n&&(this.releaseTexture(e,n,o,a,s),r.texture=null,r.texShape=null),r.usage=TextureUsage.UPLOAD,r.values=t,this.delayedStorage||this.uploadToGPU(e)},e.prototype.readSync=function(e){var t=this.texData.get(e),r=t.values,n=t.dtype,o=t.complexTensors;if(null!=r)return this.convertAndCacheOnCPU(e);var a,i,s=null!=this.activeTimers;(s&&(a=performance.now()),"complex64"===n)?i=mergeRealAndImagArrays(o.real.dataSync(),o.imag.dataSync()):i=this.getValuesFromTexture(e);return s&&(this.downloadWaitMs+=performance.now()-a),this.convertAndCacheOnCPU(e,i)},e.prototype.read=function(e){return __awaiter(this,void 0,void 0,function(){var t,r,n,o,a,i,s,u,l;return __generator(this,function(c){switch(c.label){case 0:if(this.pendingRead.has(e))return t=this.pendingRead.get(e),[2,new Promise(function(e){return t.push(e)})];if(r=this.texData.get(e),n=r.texture,o=r.values,a=r.texShape,null!=o)return[2,this.convertAndCacheOnCPU(e)];if(this.pendingRead.set(e,[]),!ENV.get("WEBGL_DOWNLOAD_FLOAT_ENABLED")&&2===ENV.get("WEBGL_VERSION"))throw new Error("tensor.data() with WEBGL_DOWNLOAD_FLOAT_ENABLED=false and WEBGL_VERSION=2 not yet supported.");return i=this.gpgpu.maybeCreateBufferFromTexture(n,a[0],a[1]),[4,this.gpgpu.createAndWaitForFence()];case 1:return c.sent(),s=i instanceof WebGLTexture?this.getValuesFromTexture(e):this.gpgpu.downloadFloat32MatrixFromBuffer(i,a[0],a[1]),u=this.convertAndCacheOnCPU(e,s),l=this.pendingRead.get(e),this.pendingRead.delete(e),l.forEach(function(e){return e(u)}),this.pendingDisposal.has(e)&&(this.pendingDisposal.delete(e),this.disposeData(e)),[2,u]}})})},e.prototype.getValuesFromTexture=function(e){var t=this.texData.get(e),r=t.shape,n=t.dtype,o=t.texture,a=t.texShape;if(ENV.get("WEBGL_DOWNLOAD_FLOAT_ENABLED")){if(this.texData.get(e).isPacked){var i=sizeFromShape(r.slice(0,r.length-2)),s=r.length>1?r[r.length-2]:1,u=r[r.length-1];return this.gpgpu.downloadMatrixFromPackedTexture(o,i,s,u,a[0],a[1])}return this.gpgpu.downloadFloat32MatrixFromOutputTexture(o,a[0],a[1])}var l=this.makeTensorHandle(r,"float32");l.size=sizeFromShape(r),this.texData.get(l.dataId).usage=TextureUsage.DOWNLOAD;var c=new EncodeFloatProgram(r);this.compileAndRun(c,[{shape:r,dtype:n,dataId:e}],l,null,!1);var p=this.texData.get(l.dataId),d=this.gpgpu.downloadByteEncodedFloatMatrixFromOutputTexture(p.texture,p.texShape[0],p.texShape[1]);return this.disposeData(l.dataId),d},e.prototype.time=function(e){return __awaiter(this,void 0,void 0,function(){var t,r,n,o,a,i,s;return __generator(this,function(u){switch(u.label){case 0:return t=this.activeTimers,r=[],n=!1,null==this.programTimersStack?(this.programTimersStack=r,n=!0):this.activeTimers.push(r),this.activeTimers=r,e(),o=flatten(this.activeTimers.map(function(e){return e.query})).filter(function(e){return null!=e}),a=flatten(this.activeTimers.map(function(e){return e.name})).filter(function(e){return null!=e}),this.activeTimers=t,n&&(this.programTimersStack=null),[4,Promise.all(o)];case 1:return i=u.sent(),s={uploadWaitMs:this.uploadWaitMs,downloadWaitMs:this.downloadWaitMs,kernelMs:sum(i),getExtraProfileInfo:function(){return i.map(function(e,t){return{name:a[t],ms:e}}).map(function(e){return e.name+": "+e.ms}).join(", ")},wallMs:null},this.uploadWaitMs=0,this.downloadWaitMs=0,[2,s]}})})},e.prototype.memory=function(){return{unreliable:!1,numBytesInGPU:this.numBytesInGPU}},e.prototype.startTimer=function(){return ENV.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION")>0?this.gpgpu.beginQuery():{startMs:performance.now(),endMs:null}},e.prototype.endTimer=function(e){return ENV.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION")>0?(this.gpgpu.endQuery(),e):(e.endMs=performance.now(),e)},e.prototype.getQueryTime=function(e){return __awaiter(this,void 0,void 0,function(){var t;return __generator(this,function(r){return ENV.get("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION")>0?[2,this.gpgpu.waitForQueryAndGetTime(e)]:[2,(t=e).endMs-t.startMs]})})},e.prototype.disposeData=function(e){if(!this.pendingDisposal.has(e))if(this.pendingRead.has(e))this.pendingDisposal.add(e);else if(this.texData.has(e)){var t=this.texData.get(e),r=t.texture,n=t.texShape,o=t.usage,a=t.complexTensors,i=t.isPacked;null!=r&&this.releaseTexture(e,r,n,o,i),null!=a&&(a.real.dispose(),a.imag.dispose()),this.texData.delete(e)}},e.prototype.getTexture=function(e){return this.uploadToGPU(e),this.texData.get(e).texture},e.prototype.getCPUBackend=function(){return ENV.get("WEBGL_CPU_FORWARD")?(null==this.cpuBackend&&(this.cpuBackend=ENV.findBackend("cpu")),this.cpuBackend):null},e.prototype.shouldExecuteOnCPU=function(e,t){var r=this;return void 0===t&&(t=CPU_HANDOFF_SIZE_THRESHOLD),null!=this.getCPUBackend()&&e.every(function(e){return null==r.texData.get(e.dataId).texture&&e.size<t})},e.prototype.getGPGPUContext=function(){return this.gpgpu},e.prototype.getCanvas=function(){return this.canvas},e.prototype.complex=function(e,t){var r=this.makeOutputArray(e.shape,"complex64");return this.texData.get(r.dataId).complexTensors={real:ENV.engine.keep(e.clone()),imag:ENV.engine.keep(t.clone())},r},e.prototype.real=function(e){return this.texData.get(e.dataId).complexTensors.real.clone()},e.prototype.imag=function(e){return this.texData.get(e.dataId).complexTensors.imag.clone()},e.prototype.slice=function(e,t,r){if(this.shouldExecuteOnCPU([e]))return this.cpuBackend.slice(e,t,r);var n=new SliceProgram(r),o=n.getCustomSetupFunc(t);return this.compileAndRun(n,[e],null,o)},e.prototype.stridedSlice=function(e,t,r,n,o,a,i,s,u){if(this.shouldExecuteOnCPU([e]))return this.cpuBackend.stridedSlice(e,t,r,n,o,a,i,s,u);var l=getStridedSlicedInfo(e.shape,t,r,n,o,a,i,s,u),c=l[0],p=l[1],d=l[2],h=p.filter(function(e,t){return-1===d.indexOf(t)});if(h.some(function(e){return 0===e}))return tensor([],h);var f=new StridedSliceProgram(c,n,p,d);return this.compileAndRun(f,[e])},e.prototype.reverse=function(e,t){var r=new ReverseProgram(e.shape,t);return this.compileAndRun(r,[e])},e.prototype.concat2Tensors=function(e,t,r){var n=computeOutShape([e.shape,t.shape],r),o=e.as2D(-1,sizeFromShape(e.shape.slice(r))),a=t.as2D(-1,sizeFromShape(t.shape.slice(r))),i=new ConcatProgram(o.shape,a.shape);return this.compileAndRun(i,[o,a]).reshape(n)},e.prototype.concat=function(e,t){if(this.shouldExecuteOnCPU(e))return this.cpuBackend.concat(e,t);if(1===e.length)return e[0];for(var r=e[0],n=1;n<e.length;++n)r=this.concat2Tensors(r,e[n],t);return r},e.prototype.neg=function(e){var t=new UnaryOpProgram(e.shape,NEG);return this.compileAndRun(t,[e])},e.prototype.batchMatMul=function(e,t,r,n){var o=r?e.shape[2]:e.shape[1],a=n?t.shape[1]:t.shape[2],i=r?e.shape[1]:e.shape[2],s=e.shape[0];if((1===o||1===a)&&i>MATMUL_SHARED_DIM_THRESHOLD){r&&(e=e.transpose([0,2,1])),n&&(t=t.transpose([0,2,1]));var u=1===a?e:e.as3D(s,i,1),l=1===a?2:1,c=1===a?t.as3D(s,1,i):t;return this.multiply(u,c).sum(l,!0)}if(1===s){var p=e.as2D(e.shape[1],e.shape[2]),d=t.as2D(t.shape[1],t.shape[2]),h=new MatMulPackedProgram(p.shape,d.shape,[o,a],r,n),f=this.compileAndRun(h,[p,d],this.makePackedTensor(h.outputShape));return!1===ENV.get("WEBGL_LAZILY_UNPACK")&&(f=this.unpackTensor(f)),f.reshape([1,f.shape[0],f.shape[1]])}return this.compileAndRun(new MatMulProgram(e.shape,t.shape,r,n),[e,t])},e.prototype.multiply=function(e,t){if("complex64"===e.dtype){var r=this.texData.get(e.dataId),n=this.texData.get(t.dataId),o=new BinaryOpComplexProgram(COMPLEX_MULTIPLY.REAL,e.shape,t.shape),a=new BinaryOpComplexProgram(COMPLEX_MULTIPLY.IMAG,e.shape,t.shape),i=[this.makeComplexComponentTensorHandle(e,r.complexTensors.real),this.makeComplexComponentTensorHandle(e,r.complexTensors.imag),this.makeComplexComponentTensorHandle(t,n.complexTensors.real),this.makeComplexComponentTensorHandle(t,n.complexTensors.imag)],s=this.compileAndRun(o,i),u=this.compileAndRun(a,i),l=this.complex(s,u);return s.dispose(),u.dispose(),l}if(this.shouldExecuteOnCPU([e,t]))return this.cpuBackend.multiply(e,t);var c=new BinaryOpProgram(MUL,e.shape,t.shape),p=this.makeOutputArray(c.outputShape,e.dtype);return this.compileAndRun(c,[e,t],p)},e.prototype.batchNormalization=function(e,t,r,n,o,a){var i=[e,t,r],s=null;null!=a&&(s=a.shape,i.push(a));var u=null;null!=o&&(u=o.shape,i.push(o));var l=null,c=BatchNormProgram;ENV.get("WEBGL_PACK_BATCHNORMALIZATION")&&(l=this.makePackedTensor(e.shape),c=BatchNormPackedProgram);var p=new c(e.shape,t.shape,r.shape,s,u,n);return this.compileAndRun(p,i,l)},e.prototype.localResponseNormalization4D=function(e,t,r,n,o){var a=new LRNProgram(e.shape,t,r,n,o);return this.compileAndRun(a,[e])},e.prototype.LRNGrad=function(e,t,r,n,o,a,i){var s=new LRNGradProgram(t.shape,n,o,a,i);return this.compileAndRun(s,[t,r,e])},e.prototype.tile=function(e,t){var r=new TileProgram(e.shape,t);return this.compileAndRun(r,[e])},e.prototype.pad=function(e,t,r){var n=new PadProgram(e.shape,t,r);return this.compileAndRun(n,[e])},e.prototype.transpose=function(e,t){var r=new TransposeProgram(e.shape,t);return this.compileAndRun(r,[e])},e.prototype.gather=function(e,t,r){var n=new GatherProgram(e.shape,t.size,r);return this.compileAndRun(n,[e,t])},e.prototype.batchToSpaceND=function(e,t,r){assert(e.rank<=4,"batchToSpaceND for rank > 4 with a WebGL backend not implemented yet");var n=t.reduce(function(e,t){return e*t}),o=getReshaped(e.shape,t,n),a=getPermuted(o.length,t.length),i=getReshapedPermuted(e.shape,t,n),s=getSliceBeginCoords(r,t.length),u=getSliceSize(i,r,t.length);return e.reshape(o).transpose(a).reshape(i).slice(s,u)},e.prototype.spaceToBatchND=function(e,t,r){assert(e.rank<=4,"spaceToBatchND for rank > 4 with a WebGL backend not implemented yet");var n=t.reduce(function(e,t){return e*t}),o=[[0,0]];o.push.apply(o,r);for(var a=1+t.length;a<e.shape.length;++a)o.push([0,0]);var i=e.pad(o),s=getReshaped(i.shape,t,n,!1),u=getPermuted(s.length,t.length,!1),l=getReshapedPermuted(i.shape,t,n,!1);return i.reshape(s).transpose(u).reshape(l)},e.prototype.reduce=function(e,t,r){var n=e.shape[0],o=e.shape[1],a=computeOptimalWindowSize(o),i=new ReduceProgram({windowSize:a,inSize:o,batchSize:n},t),s=i.outputShape,u=s[0],l=s[1],c=this.makeOutputArray([u,l],r);return this.compileAndRun(i,[e],c),1===c.shape[1]?c:this.reduce(c,t,r)},e.prototype.argReduce=function(e,t,r){void 0===r&&(r=null);var n=e.shape[0],o=e.shape[1];null!=r&&(n=r.shape[0],o=r.shape[1]);var a=computeOptimalWindowSize(o),i=new ArgMinMaxProgram({windowSize:a,inSize:o,batchSize:n},t,null==r),s=i.outputShape,u=s[0],l=s[1],c=this.makeOutputArray([u,l],"int32"),p=[e];return null!=r&&p.push(r),this.compileAndRun(i,p,c),1===c.shape[1]?c:this.argReduce(e,t,c)},e.prototype.sum=function(e,t){assertAxesAreInnerMostDims("sum",t,e.rank);var r=computeOutAndReduceShapes(e.shape,t),n=r[0],o=sizeFromShape(r[1]),a=e.as2D(-1,o),i=sumOutType(e.dtype);return this.reduce(a,"sum",i).reshape(n)},e.prototype.prod=function(e,t){var r=computeOutAndReduceShapes(e.shape,t),n=r[0],o=sizeFromShape(r[1]),a=e.as2D(-1,o),i=sumOutType(e.dtype);return this.reduce(a,"prod",i).reshape(n)},e.prototype.unsortedSegmentSum=function(e,t,r){var n=0,o=getAxesPermutation([n],e.rank),a=e;null!=o&&(a=e.transpose(o),n=getInnerMostAxes(1,e.rank)[0]);var i=computeOutShape$1(a.shape,n,r),s=sizeFromShape([a.shape[n]]),u=a.as2D(-1,s),l=sumOutType(e.dtype),c=this.segOpCompute(u,"unsortedSegmentSum",t,l,r).reshape(i);return null!=o&&(c=c.transpose(getUndoAxesPermutation(o))),c},e.prototype.segOpCompute=function(e,t,r,n,o){var a=e.shape[0],i=e.shape[1],s=segOpComputeOptimalWindowSize(i,o),u=new SegmentOpProgram({windowSize:s,inSize:i,batchSize:a,numSegments:o},t),l=u.outputShape,c=l[0],p=l[1],d=this.makeOutputArray([c,p],n);return this.compileAndRun(u,[e,r],d),d.shape[1]===o?d:(r=range(0,o).tile([i/s]),this.segOpCompute(d,t,r,n,o))},e.prototype.argMin=function(e,t){var r=[t];assertAxesAreInnerMostDims("argMin",r,e.rank);var n=computeOutAndReduceShapes(e.shape,r),o=n[0],a=sizeFromShape(n[1]),i=e.as2D(-1,a);return this.argReduce(i,"min").reshape(o)},e.prototype.argMax=function(e,t){var r=[t];assertAxesAreInnerMostDims("argMax",r,e.rank);var n=computeOutAndReduceShapes(e.shape,r),o=n[0],a=sizeFromShape(n[1]),i=e.as2D(-1,a);return this.argReduce(i,"max").reshape(o)},e.prototype.cumsum=function(e,t,r,n){if(t!==e.rank-1)throw new Error("WebGL cumsum shader expects an inner-most axis="+(e.rank-1)+" but got axis="+t);var o=new CumSumProgram(e.shape,r,n);return this.compileAndRun(o,[e])},e.prototype.equal=function(e,t){var r=new BinaryOpProgram(EQUAL,e.shape,t.shape),n=this.makeOutputArray(r.outputShape,"bool");return this.compileAndRun(r,[e,t],n)},e.prototype.notEqual=function(e,t){var r=new BinaryOpProgram(NOT_EQUAL,e.shape,t.shape),n=this.makeOutputArray(r.outputShape,"bool");return this.compileAndRun(r,[e,t],n)},e.prototype.less=function(e,t){if(this.shouldExecuteOnCPU([e,t]))return this.cpuBackend.less(e,t);var r=new BinaryOpProgram(LESS,e.shape,t.shape),n=this.makeOutputArray(r.outputShape,"bool");return this.compileAndRun(r,[e,t],n)},e.prototype.lessEqual=function(e,t){var r=new BinaryOpProgram(LESS_EQUAL,e.shape,t.shape),n=this.makeOutputArray(r.outputShape,"bool");return this.compileAndRun(r,[e,t],n)},e.prototype.greater=function(e,t){if(this.shouldExecuteOnCPU([e,t]))return this.cpuBackend.greater(e,t);var r=new BinaryOpProgram(GREATER,e.shape,t.shape),n=this.makeOutputArray(r.outputShape,"bool");return this.compileAndRun(r,[e,t],n)},e.prototype.greaterEqual=function(e,t){var r=new BinaryOpProgram(GREATER_EQUAL,e.shape,t.shape),n=this.makeOutputArray(r.outputShape,"bool");return this.compileAndRun(r,[e,t],n)},e.prototype.logicalNot=function(e){var t=new UnaryOpProgram(e.shape,LOGICAL_NOT);return this.compileAndRun(t,[e])},e.prototype.logicalAnd=function(e,t){var r=new BinaryOpProgram(LOGICAL_AND,e.shape,t.shape),n=this.makeOutputArray(r.outputShape,"bool");return this.compileAndRun(r,[e,t],n)},e.prototype.logicalOr=function(e,t){var r=new BinaryOpProgram(LOGICAL_OR,e.shape,t.shape),n=this.makeOutputArray(r.outputShape,"bool");return this.compileAndRun(r,[e,t],n)},e.prototype.select=function(e,t,r){var n=new SelectProgram(e.rank,t.shape,t.rank),o=this.makeOutputArray(n.outputShape,upcastType(t.dtype,r.dtype));return this.compileAndRun(n,[e,t,r],o)},e.prototype.where=function(e){warn("tf.where() in webgl locks the UI thread. Call tf.whereAsync() instead");var t=e.dataSync();return whereImpl(e.shape,t)},e.prototype.topk=function(e,t,r){return topkImpl(e.dataSync(),e.shape,e.dtype,t,r)},e.prototype.min=function(e,t){assertAxesAreInnerMostDims("min",t,e.rank);var r=computeOutAndReduceShapes(e.shape,t),n=r[0],o=sizeFromShape(r[1]),a=e.as2D(-1,o);return this.reduce(a,"min",a.dtype).reshape(n)},e.prototype.minimum=function(e,t){if(this.shouldExecuteOnCPU([e,t]))return this.cpuBackend.minimum(e,t);var r=new BinaryOpProgram(MIN,e.shape,t.shape);return this.compileAndRun(r,[e,t])},e.prototype.mod=function(e,t){var r=new BinaryOpProgram(MOD,e.shape,t.shape),n=r.getCustomSetupFunc();return this.compileAndRun(r,[e,t],null,n)},e.prototype.max=function(e,t){assertAxesAreInnerMostDims("max",t,e.rank);var r=computeOutAndReduceShapes(e.shape,t),n=r[0],o=sizeFromShape(r[1]),a=e.as2D(-1,o);return this.reduce(a,"max",a.dtype).reshape(n)},e.prototype.maximum=function(e,t){if(this.shouldExecuteOnCPU([e,t]))return this.cpuBackend.maximum(e,t);var r=new BinaryOpProgram(MAX,e.shape,t.shape);return this.compileAndRun(r,[e,t])},e.prototype.all=function(e,t){assertAxesAreInnerMostDims("all",t,e.rank);var r=computeOutAndReduceShapes(e.shape,t),n=r[0],o=sizeFromShape(r[1]),a=e.as2D(-1,o);return this.reduce(a,"all",a.dtype).reshape(n)},e.prototype.any=function(e,t){assertAxesAreInnerMostDims("any",t,e.rank);var r=computeOutAndReduceShapes(e.shape,t),n=r[0],o=sizeFromShape(r[1]),a=e.as2D(-1,o);return this.reduce(a,"any",a.dtype).reshape(n)},e.prototype.squaredDifference=function(e,t){var r=new BinaryOpProgram(SQUARED_DIFFERENCE,e.shape,t.shape);return this.compileAndRun(r,[e,t])},e.prototype.realDivide=function(e,t){var r=new BinaryOpProgram(DIV,e.shape,t.shape),n=this.makeOutputArray(r.outputShape,"float32");return this.compileAndRun(r,[e,t],n)},e.prototype.floorDiv=function(e,t){var r=new BinaryOpProgram(INT_DIV,e.shape,t.shape),n=this.makeOutputArray(r.outputShape,"int32");return this.compileAndRun(r,[e,t],n)},e.prototype.add=function(e,t){if("complex64"===e.dtype&&"complex64"===t.dtype)return this.complexSeparableBinaryOp(e,t,ADD);var r=new BinaryOpProgram(ADD,e.shape,t.shape),n=this.makeOutputArray(r.outputShape,upcastType(e.dtype,t.dtype));return this.compileAndRun(r,[e,t],n)},e.prototype.complexSeparableBinaryOp=function(e,t,r){var n=this,o=this.texData.get(e.dataId),a=this.texData.get(t.dataId),i=[[o.complexTensors.real,a.complexTensors.real],[o.complexTensors.imag,a.complexTensors.imag]].map(function(o){var a=o[0],i=o[1],s=new BinaryOpProgram(r,e.shape,t.shape),u=n.makeOutputArray(s.outputShape,upcastType(a.dtype,i.dtype)),l=n.makeComplexComponentTensorHandle(e,a),c=n.makeComplexComponentTensorHandle(t,i);return n.compileAndRun(s,[l,c],u)}),s=i[0],u=i[1],l=this.complex(s,u);return s.dispose(),u.dispose(),l},e.prototype.makeComplexComponentTensorHandle=function(e,t){return{dataId:t.dataId,dtype:t.dtype,shape:e.shape}},e.prototype.addN=function(e){for(var t=e[0],r=1;r<e.length;r++)t=this.add(t,e[r]);return t},e.prototype.subtract=function(e,t){if("complex64"===e.dtype&&"complex64"===t.dtype)return this.complexSeparableBinaryOp(e,t,SUB);if(this.shouldExecuteOnCPU([e,t]))return this.cpuBackend.subtract(e,t);var r=new BinaryOpProgram(SUB,e.shape,t.shape),n=this.makeOutputArray(r.outputShape,upcastType(e.dtype,t.dtype));return this.compileAndRun(r,[e,t],n)},e.prototype.pow=function(e,t){var r=new BinaryOpProgram(POW,e.shape,t.shape),n=r.getCustomSetupFunc(),o=this.makeOutputArray(r.outputShape,upcastType(e.dtype,t.dtype));return this.compileAndRun(r,[e,t],o,n)},e.prototype.ceil=function(e){var t=new UnaryOpProgram(e.shape,CEIL);return this.compileAndRun(t,[e])},e.prototype.floor=function(e){var t=new UnaryOpProgram(e.shape,FLOOR);return this.compileAndRun(t,[e])},e.prototype.sign=function(e){var t=new UnaryOpProgram(e.shape,SIGN);return this.compileAndRun(t,[e])},e.prototype.round=function(e){var t=new UnaryOpProgram(e.shape,ROUND);return this.compileAndRun(t,[e])},e.prototype.exp=function(e){var t=new UnaryOpProgram(e.shape,EXP);return this.compileAndRun(t,[e])},e.prototype.expm1=function(e){var t=new UnaryOpProgram(e.shape,EXPM1);return this.compileAndRun(t,[e])},e.prototype.log=function(e){var t=new UnaryOpProgram(e.shape,LOG),r=t.getCustomSetupFunc();return this.compileAndRun(t,[e],null,r)},e.prototype.log1p=function(e){var t=new UnaryOpProgram(e.shape,LOG1P);return this.compileAndRun(t,[e])},e.prototype.sqrt=function(e){var t=new UnaryOpProgram(e.shape,SQRT);return this.compileAndRun(t,[e])},e.prototype.rsqrt=function(e){var t=new UnaryOpProgram(e.shape,RSQRT);return this.compileAndRun(t,[e])},e.prototype.square=function(e){var t=new UnaryOpProgram(e.shape,SQUARE);return this.compileAndRun(t,[e])},e.prototype.reciprocal=function(e){var t=new UnaryOpProgram(e.shape,RECIPROCAL);return this.compileAndRun(t,[e])},e.prototype.relu=function(e){var t=new UnaryOpProgram(e.shape,RELU);return this.compileAndRun(t,[e])},e.prototype.elu=function(e){var t=new UnaryOpProgram(e.shape,ELU);return this.compileAndRun(t,[e])},e.prototype.eluDer=function(e,t){var r=new BinaryOpProgram(ELU_DER,e.shape,t.shape);return this.compileAndRun(r,[e,t])},e.prototype.selu=function(e){var t=new UnaryOpProgram(e.shape,SELU);return this.compileAndRun(t,[e])},e.prototype.int=function(e){var t=new UnaryOpProgram(e.shape,TO_INT),r=this.makeOutputArray(t.outputShape,"int32");return this.compileAndRun(t,[e],r)},e.prototype.clip=function(e,t,r){var n=new ClipProgram(e.shape,t,r);return this.compileAndRun(n,[e])},e.prototype.abs=function(e){var t=new UnaryOpProgram(e.shape,ABS);return this.compileAndRun(t,[e])},e.prototype.complexAbs=function(e){var t=this.texData.get(e.dataId),r=new ComplexAbsProgram(e.shape),n=[this.makeComplexComponentTensorHandle(e,t.complexTensors.real),this.makeComplexComponentTensorHandle(e,t.complexTensors.imag)];return this.compileAndRun(r,n)},e.prototype.sigmoid=function(e){var t=new UnaryOpProgram(e.shape,SIGMOID);return this.compileAndRun(t,[e])},e.prototype.softplus=function(e){var t=new UnaryOpProgram(e.shape,SOFTPLUS);return this.compileAndRun(t,[e])},e.prototype.sin=function(e){var t=new UnaryOpProgram(e.shape,SIN);return this.compileAndRun(t,[e])},e.prototype.cos=function(e){var t=new UnaryOpProgram(e.shape,COS);return this.compileAndRun(t,[e])},e.prototype.tan=function(e){var t=new UnaryOpProgram(e.shape,TAN);return this.compileAndRun(t,[e])},e.prototype.asin=function(e){var t=new UnaryOpProgram(e.shape,ASIN);return this.compileAndRun(t,[e])},e.prototype.acos=function(e){var t=new UnaryOpProgram(e.shape,ACOS);return this.compileAndRun(t,[e])},e.prototype.atan=function(e){var t=new UnaryOpProgram(e.shape,ATAN);return this.compileAndRun(t,[e])},e.prototype.atan2=function(e,t){var r=new BinaryOpProgram(ATAN2,e.shape,t.shape);return this.compileAndRun(r,[e,t])},e.prototype.sinh=function(e){var t=new UnaryOpProgram(e.shape,SINH);return this.compileAndRun(t,[e])},e.prototype.cosh=function(e){var t=new UnaryOpProgram(e.shape,COSH);return this.compileAndRun(t,[e])},e.prototype.tanh=function(e){var t=new UnaryOpProgram(e.shape,TANH);return this.compileAndRun(t,[e])},e.prototype.asinh=function(e){var t=new UnaryOpProgram(e.shape,ASINH);return this.compileAndRun(t,[e])},e.prototype.acosh=function(e){var t=new UnaryOpProgram(e.shape,ACOSH),r=t.getCustomSetupFunc();return this.compileAndRun(t,[e],null,r)},e.prototype.atanh=function(e){var t=new UnaryOpProgram(e.shape,ATANH),r=t.getCustomSetupFunc();return this.compileAndRun(t,[e],null,r)},e.prototype.erf=function(e){var t=new UnaryOpProgram(e.shape,ERF);return this.compileAndRun(t,[e])},e.prototype.step=function(e,t){var r=new UnaryOpProgram(e.shape,STEP(t));return this.compileAndRun(r,[e])},e.prototype.conv2dWithIm2Row=function(e,t,r){var n=r.filterWidth,o=r.filterHeight,a=r.inChannels,i=r.outWidth,s=r.outHeight,u=n*o*a,l=s*i,c=[u,l],p=e.squeeze([0]),d=t.reshape([u,-1]),h=new Im2ColProgram(c,p.shape,r),f=this.compileAndRun(h,[p],this.makePackedTensor(c)),m=new MatMulPackedProgram(f.shape,d.shape,[l,r.outChannels],!0,!1),g=this.compileAndRun(m,[f,d],this.makePackedTensor(m.outputShape));return!1===ENV.get("WEBGL_LAZILY_UNPACK")&&(g=this.unpackTensor(g)),g.reshape([1,s,i,r.outChannels])},e.prototype.conv2d=function(e,t,r){if(ENV.get("WEBGL_CONV_IM2COL")&&1===e.shape[0])return this.conv2dWithIm2Row(e,t,r);var n=new Conv2DProgram(r);return this.compileAndRun(n,[e,t])},e.prototype.conv2dDerInput=function(e,t,r){var n=new Conv2DDerInputProgram(r);return this.compileAndRun(n,[e,t])},e.prototype.conv2dDerFilter=function(e,t,r){var n=new Conv2DDerFilterProgram(r);return this.compileAndRun(n,[e,t])},e.prototype.depthwiseConv2D=function(e,t,r){var n=new DepthwiseConv2DProgram(r);return this.compileAndRun(n,[e,t])},e.prototype.depthwiseConv2DDerInput=function(e,t,r){var n=new DepthwiseConv2DDerInputProgram(r);return this.compileAndRun(n,[e,t])},e.prototype.depthwiseConv2DDerFilter=function(e,t,r){var n=new DepthwiseConv2DDerFilterProgram(r);return this.compileAndRun(n,[e,t])},e.prototype.maxPool=function(e,t){var r=new Pool2DProgram(t,"max",!1),n=this.makeOutputArray(r.outputShape,e.dtype);return this.compileAndRun(r,[e],n)},e.prototype.avgPool=function(e,t){var r=new Pool2DProgram(t,"avg",!1),n=this.makeOutputArray(r.outputShape,"float32");return this.compileAndRun(r,[e],n)},e.prototype.maxPoolBackprop=function(e,t,r,n){var o=new Pool2DProgram(n,"max",!0),a=this.compileAndRun(o,[t]),i=new MaxPool2DBackpropProgram(n),s=this.makeOutputArray(i.outputShape,t.dtype),u=this.compileAndRun(i,[e,a],s);return a.dispose(),u},e.prototype.avgPoolBackprop=function(e,t,r){var n=new AvgPool2DBackpropProgram(r),o=this.makeOutputArray(n.outputShape,t.dtype);return this.compileAndRun(n,[e],o)},e.prototype.cast=function(e,t){return castTensor(e,t,this)},e.prototype.reshape=function(e,t){return this.texData.get(e.dataId).isPacked&&!isReshapeFree(e.shape,t)?this.packedReshape(e,t):reshapeTensor(e,t)},e.prototype.resizeBilinear=function(e,t,r,n){var o=new ResizeBilinearProgram(e.shape,t,r,n);return this.compileAndRun(o,[e])},e.prototype.resizeBilinearBackprop=function(e,t,r){var n=new ResizeBilinearBackpropProgram(e,t,r);return this.compileAndRun(n,[e])},e.prototype.resizeNearestNeighbor=function(e,t,r,n){var o=new ResizeNearestNeighborProgram(e.shape,t,r,n);return this.compileAndRun(o,[e])},e.prototype.resizeNearestNeighborBackprop=function(e,t,r){var n=new ResizeNearestNeigborBackpropProgram(e,t,r);return this.compileAndRun(n,[e])},e.prototype.multinomial=function(e,t,r,n){var o=t?e:softmax(e),a=o.shape[0],i=o.shape[1],s=new MultinomialProgram(a,i,r),u=this.makeOutputArray(s.outputShape,"int32"),l=s.getCustomSetupFunc(n);return this.compileAndRun(s,[o],u,l)},e.prototype.oneHot=function(e,t,r,n){var o=new OneHotProgram(e.size,t,r,n);return this.compileAndRun(o,[e])},e.prototype.nonMaxSuppression=function(e,t,r,n,o){return warn("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead"),nonMaxSuppressionImpl(e.dataSync(),t.dataSync(),r,n,o)},e.prototype.cropAndResize=function(e,t,r,n,o,a){var i=new CropAndResizeProgram(e.shape,t.shape,n,o,a);return this.compileAndRun(i,[e,t,r])},e.prototype.depthToSpace=function(e,t,r){assert(t>1,"blockSize should be > 1 for depthToSpace, but was: "+t);var n=e.shape[0],o=("NHWC"===r?e.shape[1]:e.shape[2])*t,a=("NHWC"===r?e.shape[2]:e.shape[3])*t,i=("NHWC"===r?e.shape[3]:e.shape[1])/(t*t),s=new DepthToSpaceProgram("NHWC"===r?[n,o,a,i]:[n,i,o,a],t,r);return this.compileAndRun(s,[e])},e.prototype.split=function(e,t,r){return split(e,t,r)},e.prototype.scatterND=function(e,t,r){var n=calculateShapes(t,e,r),o=n.sliceRank,a=n.numUpdates,i=n.sliceSize,s=n.strides,u=n.outputSize,l=[u/i,i],c=e.reshape([a,o]),p=t.reshape([a,i]);if(0===u)return reshapeTensor(tensor([]),r);var d=scalar(0),h=new ScatterProgram(a,o,c.rank,p.rank,s,l);return this.compileAndRun(h,[p,c,d]).reshape(r)},e.prototype.sparseToDense=function(e,t,r,n){var o=calculateShapes(t,e,r),a=o.sliceRank,i=o.numUpdates,s=o.strides,u=o.outputSize,l=new ScatterProgram(i,a,e.rank,t.rank,s,[u,1],!1);return this.compileAndRun(l,[t,e,n]).reshape(r)},e.prototype.fft=function(e){return this.fftImpl(e,!1)},e.prototype.ifft=function(e){return this.fftImpl(e,!0)},e.prototype.fftImpl=function(e,t){var r=this.texData.get(e.dataId),n=new FFTProgram(COMPLEX_FFT.REAL,e.shape,t),o=new FFTProgram(COMPLEX_FFT.IMAG,e.shape,t),a=[this.makeComplexComponentTensorHandle(e,r.complexTensors.real),this.makeComplexComponentTensorHandle(e,r.complexTensors.imag)],i=this.compileAndRun(n,a),s=this.compileAndRun(o,a),u=this.complex(i,s).as2D(e.shape[0],e.shape[1]);return i.dispose(),s.dispose(),u},e.prototype.gatherND=function(e,t){var r=t.shape,n=r[r.length-1],o=prepareAndValidate(e,t),a=o[0],i=o[1],s=o[2],u=o[3],l=t.reshape([i,n]),c=e.reshape([e.size/s,s]),p=new GatherNDProgram(n,u,[i,s]);return this.compileAndRun(p,[c,l]).reshape(a)},e.prototype.makeOutputArray=function(e,t){return Tensor.make(e,{},t)},e.prototype.makePackedTensor=function(e){var t=Tensor.make(e,{});return this.texData.get(t.dataId).isPacked=!0,t},e.prototype.unpackTensor=function(e){var t=new UnpackProgram(e.shape);return this.compileAndRun(t,[e])},e.prototype.getBatchDim=function(e,t){return void 0===t&&(t=2),sizeFromShape(e.slice(0,e.length-t))},e.prototype.getRowsCols=function(e){if(0===e.length)throw Error("Cannot get rows and columns of an empty shape array.");return[e.length>1?e[e.length-2]:1,e[e.length-1]]},e.prototype.packedReshape=function(e,t){var r=e.reshape([this.getBatchDim(e.shape)].concat(this.getRowsCols(e.shape))),n=[this.getBatchDim(t)].concat(this.getRowsCols(t)),o=new ReshapePackedProgram(n,r.shape);return this.compileAndRun(o,[r],this.makePackedTensor(n)).reshape(t)},e.prototype.compileAndRun=function(e,t,r,n,o){var a=this;if(void 0===o&&(o=!0),null==r&&(r=this.makeOutputArray(e.outputShape,t[0].dtype)),0===r.size)return this.texData.get(r.dataId).values=getTypedArrayFromDType(r.dtype,0),r;var i=t.map(function(t){if("complex64"===t.dtype)throw new Error("GPGPUProgram does not support complex64 input. For complex64 dtypes, please separate the program into real and imaginary parts.");var r=a.texData.get(t.dataId);if(null==r.texture&&(r.isPacked||!e.usesPackedTextures)&&sizeFromShape(t.shape)<=ENV.get("WEBGL_SIZE_UPLOAD_UNIFORM"))return{shape:t.shape,texData:null,isUniform:!0,uniformValues:a.readSync(t.dataId)};if(r.isPacked!==!!e.usesPackedTextures){var n=void 0,o=void 0;r.isPacked?(n=new UnpackProgram(t.shape),o=a.compileAndRun(n,[t])):(n=new PackProgram(t.shape),o=a.compileAndRun(n,[t],a.makePackedTensor(t.shape))),r=a.texData.get(o.dataId),t=o}return a.uploadToGPU(t.dataId),{shape:t.shape,texData:r,isUniform:!1}});this.uploadToGPU(r.dataId);var s,u={shape:r.shape,texData:this.texData.get(r.dataId),isUniform:!1},l=makeShaderKey(e,i,u),c=this.getAndSaveBinary(l,function(){return compileProgram(a.gpgpu,e,i,u)}),p=null!=this.activeTimers;if(p&&(s=this.startTimer()),runProgram(c,i,u,n),ENV.get("WEBGL_PAGING_ENABLED")&&o&&this.numBytesInGPU>this.NUM_BYTES_BEFORE_PAGING)for(var d=this.numBytesInGPU-this.NUM_BYTES_BEFORE_PAGING;d>0&&this.lruDataGPU.length>0;){var h=this.lruDataGPU.shift(),f=this.texData.get(h),m=f.shape,g=f.dtype;d-=this.computeBytes(m,g),this.read(h)}return p&&(s=this.endTimer(s),this.activeTimers.push({name:e.constructor.name,query:this.getQueryTime(s)})),r},e.prototype.getAndSaveBinary=function(e,t){return e in this.binaryCache||(this.binaryCache[e]=t()),this.binaryCache[e]},e.prototype.getTextureManager=function(){return this.textureManager},e.prototype.dispose=function(){if(!this.disposed){for(var e in this.binaryCache)this.gpgpu.deleteProgram(this.binaryCache[e].webGLProgram);this.textureManager.dispose(),this.canvas.remove(),null!=this.fromPixels2DContext&&this.fromPixels2DContext.canvas.remove(),this.gpgpuCreatedLocally&&this.gpgpu.dispose(),this.disposed=!0}},e.prototype.floatPrecision=function(){var e=this;return tidy(function(){return e.abs(scalar(1e-8)).get()>0?32:16})},e.prototype.uploadToGPU=function(e){var t=this.texData.get(e),r=t.shape,n=t.values,o=t.texture,a=t.dtype,i=t.usage,s=t.isPacked;if(null==o){var u,l=null!=this.activeTimers;l&&(u=performance.now());var c=getTextureShapeFromLogicalShape(r,s);t.texShape=c;var p=this.acquireTexture(e,c,i,s);if(t.texture=p,null!=n){if(s){var d=sizeFromShape(r.slice(0,r.length-2)),h=r.length>1?r[r.length-2]:1,f=r[r.length-1];this.gpgpu.uploadMatrixToPackedTexture(p,d,h,f,typedArrayToFloat32(n,a))}else this.gpgpu.uploadMatrixToTexture(p,c[0],c[1],typedArrayToFloat32(n,a));t.values=null,l&&(this.uploadWaitMs+=performance.now()-u)}}else{ENV.get("WEBGL_PAGING_ENABLED")&&this.lruDataGPU.indexOf(e)>=0&&(this.lruDataGPU.splice(this.lruDataGPU.indexOf(e),1),this.lruDataGPU.push(e))}},e.prototype.convertAndCacheOnCPU=function(e,t){var r=this.delayedStorage,n=this.texData.get(e),o=n.texture,a=n.texShape,i=n.dtype,s=n.usage,u=n.isPacked;return r&&null!=o&&(this.releaseTexture(e,o,a,s,u),n.texture=null,n.texShape=null),n.usage=TextureUsage.UPLOAD,null!=t&&(n.values=float32ToTypedArray(t,i)),n.values},e.prototype.releaseTexture=function(e,t,r,n,o){var a=this.texData.get(e),i=a.shape,s=a.dtype;if(ENV.get("WEBGL_PAGING_ENABLED")){var u=this.lruDataGPU.indexOf(e);u>=0&&this.lruDataGPU.splice(u,1)}this.numBytesInGPU-=this.computeBytes(i,s),this.textureManager.releaseTexture(t,r,n,o)},e.prototype.acquireTexture=function(e,t,r,n){var o=this.texData.get(e),a=o.shape,i=o.dtype;return ENV.get("WEBGL_PAGING_ENABLED")&&this.lruDataGPU.push(e),this.numBytesInGPU+=this.computeBytes(a,i),this.textureManager.acquireTexture(t,r,n)},e.prototype.computeBytes=function(e,t){return sizeFromShape(e)*bytesPerElement(t)},e}();function float32ToTypedArray(e,t){if("float32"===t||"complex64"===t)return e;if("int32"===t||"bool"===t){for(var r="int32"===t?new Int32Array(e.length):new Uint8Array(e.length),n=0;n<r.length;++n)r[n]=Math.round(e[n]);return r}throw new Error("Unknown dtype "+t)}function typedArrayToFloat32(e,t){return e instanceof Float32Array?e:new Float32Array(e)}function neg_(e){var t=convertToTensor(e,"x","neg");return ENV.engine.runKernel(function(e){return e.neg(t)},{$x:t},function(e){return{$x:function(){return e.neg()}}})}function ceil_(e){var t=convertToTensor(e,"x","ceil");return ENV.engine.runKernel(function(e){return e.ceil(t)},{$x:t},function(e){return{$x:function(){return zerosLike(e)}}})}function floor_(e){var t=convertToTensor(e,"x","floor");return ENV.engine.runKernel(function(e){return e.floor(t)},{$x:t},function(e){return{$x:function(){return zerosLike(e)}}})}function sign_(e){var t=convertToTensor(e,"x","sign");return ENV.engine.runKernel(function(e){return e.sign(t)},{$x:t},function(e){return{$x:function(){return zerosLike(e)}}})}function round_(e){var t=convertToTensor(e,"x","round");return ENV.engine.runKernel(function(e){return e.round(t)},{$x:t},function(e){return{$x:function(){return zerosLike(e)}}})}function exp_(e){var t=convertToTensor(e,"x","exp");return ENV.engine.runKernel(function(e,r){return r(e.exp(t))},{$x:t},function(e,t){var r=t[0];return{$x:function(){return e.mulStrict(r)}}})}function expm1_(e){var t=convertToTensor(e,"x","expm1");return ENV.engine.runKernel(function(e){return e.expm1(t)},{$x:t},function(e){return{$x:function(){return e.mulStrict(t.exp())}}})}function log_(e){var t=convertToTensor(e,"x","log");return ENV.engine.runKernel(function(e){return e.log(t)},{$x:t},function(e){return{$x:function(){return e.divStrict(t.toFloat())}}})}function log1p_(e){var t=convertToTensor(e,"x","log1p");return ENV.engine.runKernel(function(e){return e.log1p(t)},{$x:t},function(e){return{$x:function(){return e.divStrict(t.add(scalar(1)))}}})}function sqrt_(e){var t=convertToTensor(e,"x","sqrt");return ENV.engine.runKernel(function(e){return e.sqrt(t)},{$x:t},function(e){return{$x:function(){return e.divStrict(t.toFloat().sqrt().mul(scalar(2)))}}})}function rsqrt_(e){var t=convertToTensor(e,"x","rsqrt");return ENV.engine.runKernel(function(e){return e.rsqrt(t)},{$x:t},function(e){return{$x:function(){return e.divStrict(t.pow(scalar(1.5)).mul(scalar(2))).neg()}}})}function square_(e){var t=convertToTensor(e,"x","square");return ENV.engine.runKernel(function(e){return e.square(t)},{$x:t},function(e){return{$x:function(){return e.mulStrict(t.toFloat().mul(scalar(2)))}}})}function reciprocal_(e){var t=convertToTensor(e,"x","reciprocal");return ENV.engine.runKernel(function(e){return e.reciprocal(t)},{$x:t},function(e){return{$x:function(){return e.divStrict(t.square().neg())}}})}function abs_(e){var t=convertToTensor(e,"x","abs");if("complex64"===t.dtype)return ENV.engine.runKernel(function(e){return e.complexAbs(t)},{$x:t});return ENV.engine.runKernel(function(e){return e.abs(t)},{$x:t},function(e){return{$x:function(){return e.mulStrict(t.toFloat().step(-1))}}})}function clipByValue_(e,t,r){var n=convertToTensor(e,"x","clipByValue");assert(t<=r,"Error in clip: min ("+t+") must be less than or equal to max ("+r+").");return ENV.engine.runKernel(function(e){return e.clip(n,t,r)},{$x:n},function(e){return{$x:function(){return e.where(n.greaterEqual(scalar(t)).logicalAnd(n.lessEqual(scalar(r))),zerosLike(e))}}})}function sigmoid_(e){var t=convertToTensor(e,"x","sigmoid");return ENV.engine.runKernel(function(e,r){return r(e.sigmoid(t))},{$x:t},function(e,t){var r=t[0];return{$x:function(){return e.mulStrict(r.mul(scalar(1).sub(r)))}}})}function logSigmoid_(e){var t=convertToTensor(e,"x","logSigmoid");return ENV.engine.runKernel(function(e){return e.softplus(t.neg()).neg()},{$x:t},function(e){return{$x:function(){return e.mulStrict(t.neg().sigmoid())}}})}function softplus_(e){var t=convertToTensor(e,"x","softplus");return ENV.engine.runKernel(function(e){return e.softplus(t)},{$x:t},function(e){return{$x:function(){return e.mulStrict(t.sigmoid())}}})}function sin_(e){var t=convertToTensor(e,"x","sin");return ENV.engine.runKernel(function(e){return e.sin(t)},{$x:t},function(e){return{$x:function(){return t.toFloat().cos().mulStrict(e)}}})}function cos_(e){var t=convertToTensor(e,"x","cos");return ENV.engine.runKernel(function(e){return e.cos(t)},{$x:t},function(e){return{$x:function(){return t.toFloat().sin().neg().mulStrict(e)}}})}function tan_(e){var t=convertToTensor(e,"x","tan");return ENV.engine.runKernel(function(e){return e.tan(t)},{$x:t},function(e){return{$x:function(){return e.divStrict(t.cos().square())}}})}function asin_(e){var t=convertToTensor(e,"x","asin");return ENV.engine.runKernel(function(e){return e.asin(t)},{$x:t},function(e){return{$x:function(){return e.divStrict(scalar(1).sub(t.toFloat().square()).sqrt())}}})}function acos_(e){var t=convertToTensor(e,"x","acos");return ENV.engine.runKernel(function(e){return e.acos(t)},{$x:t},function(e){return{$x:function(){return e.divStrict(scalar(1).sub(t.toFloat().square()).sqrt()).neg()}}})}function atan_(e){var t=convertToTensor(e,"x","atan");return ENV.engine.runKernel(function(e){return e.atan(t)},{$x:t},function(e){return{$x:function(){return e.divStrict(scalar(1).add(t.toFloat().square()))}}})}function sinh_(e){var t=convertToTensor(e,"x","sinh");return ENV.engine.runKernel(function(e){return e.sinh(t)},{$x:t},function(e){return{$x:function(){return t.toFloat().cosh().mulStrict(e)}}})}function cosh_(e){var t=convertToTensor(e,"x","cosh");return ENV.engine.runKernel(function(e){return e.cosh(t)},{$x:t},function(e){return{$x:function(){return t.toFloat().sinh().mulStrict(e)}}})}function tanh_(e){var t=convertToTensor(e,"x","tanh");return ENV.engine.runKernel(function(e,r){return r(e.tanh(t))},{$x:t},function(e,t){var r=t[0];return{$x:function(){return scalar(1).sub(r.square()).mulStrict(e)}}})}function asinh_(e){var t=convertToTensor(e,"x","asinh");return ENV.engine.runKernel(function(e){return e.asinh(t)},{$x:t},function(e){return{$x:function(){return e.divStrict(scalar(1).add(t.toFloat().square()).sqrt())}}})}function acosh_(e){var t=convertToTensor(e,"x","acosh");return ENV.engine.runKernel(function(e){return e.acosh(t)},{$x:t},function(e){return{$x:function(){return e.divStrict(t.toFloat().square().sub(scalar(1)).sqrt())}}})}function atanh_(e){var t=convertToTensor(e,"x","atanh");return ENV.engine.runKernel(function(e){return e.atanh(t)},{$x:t},function(e){return{$x:function(){return e.divStrict(scalar(1).sub(t.toFloat().square()))}}})}function erf_(e){var t=convertToTensor(e,"x","erf");assert("int32"===t.dtype||"float32"===t.dtype,"Input dtype must be `int32` or `float32`."),"int32"===t.dtype&&(t=t.toFloat());return ENV.engine.runKernel(function(e){return e.erf(t)},{$x:t},function(e){return{$x:function(){return e.mulStrict(scalar(2/Math.sqrt(Math.PI)).mul(t.square().neg().exp()))}}})}function step_(e,t){void 0===t&&(t=0);var r=convertToTensor(e,"x","step");return ENV.engine.runKernel(function(e){return e.step(r,t)},{$x:r},function(e){return{$x:function(){return zerosLike(e)}}})}ENV.get("IS_BROWSER")&&ENV.registerBackend("webgl",function(){return new MathBackendWebGL},2,setTensorTracker);var abs=op({abs_:abs_}),acos=op({acos_:acos_}),acosh=op({acosh_:acosh_}),asin=op({asin_:asin_}),asinh=op({asinh_:asinh_}),atan=op({atan_:atan_}),atanh=op({atanh_:atanh_}),ceil=op({ceil_:ceil_}),clipByValue=op({clipByValue_:clipByValue_}),cos=op({cos_:cos_}),cosh=op({cosh_:cosh_}),erf=op({erf_:erf_}),exp=op({exp_:exp_}),expm1=op({expm1_:expm1_}),floor=op({floor_:floor_}),log$1=op({log_:log_}),log1p=op({log1p_:log1p_}),logSigmoid=op({logSigmoid_:logSigmoid_}),neg=op({neg_:neg_}),reciprocal=op({reciprocal_:reciprocal_}),round=op({round_:round_}),rsqrt=op({rsqrt_:rsqrt_}),sigmoid=op({sigmoid_:sigmoid_}),sign=op({sign_:sign_}),sin=op({sin_:sin_}),sinh=op({sinh_:sinh_}),softplus=op({softplus_:softplus_}),sqrt=op({sqrt_:sqrt_}),square=op({square_:square_}),step=op({step_:step_}),tan=op({tan_:tan_}),tanh$1=op({tanh_:tanh_});function batchNormalization2d_(e,t,r,n,o,a){void 0===n&&(n=.001);var i,s,u=convertToTensor(e,"x","batchNormalization"),l=convertToTensor(t,"mean","batchNormalization"),c=convertToTensor(r,"variance","batchNormalization");return null!=o&&(i=convertToTensor(o,"scale","batchNormalization")),null!=a&&(s=convertToTensor(a,"offset","batchNormalization")),assert(2===u.rank,"Error in batchNormalization3D: x must be rank 3 but got rank "+u.rank+"."),assert(2===l.rank||1===l.rank,"Error in batchNormalization2D: mean must be rank 2 or rank 1 but got rank "+l.rank+"."),assert(2===c.rank||1===c.rank,"Error in batchNormalization2D: variance must be rank 2 or rank 1 but got rank "+c.rank+"."),null!=i&&assert(2===i.rank||1===i.rank,"Error in batchNormalization2D: scale must be rank 2 or rank 1 but got rank "+i.rank+"."),null!=s&&assert(2===s.rank||1===s.rank,"Error in batchNormalization2D: offset must be rank 2 or rank 1 but got rank "+s.rank+"."),batchNormalization(u,l,c,n,i,s)}function batchNormalization3d_(e,t,r,n,o,a){void 0===n&&(n=.001);var i,s,u=convertToTensor(e,"x","batchNormalization"),l=convertToTensor(t,"mean","batchNormalization"),c=convertToTensor(r,"variance","batchNormalization");return null!=o&&(i=convertToTensor(o,"scale","batchNormalization")),null!=a&&(s=convertToTensor(a,"offset","batchNormalization")),assert(3===u.rank,"Error in batchNormalization3D: x must be rank 3 but got rank "+u.rank+"."),assert(3===l.rank||1===l.rank,"Error in batchNormalization3D: mean must be rank 3 or rank 1 but got rank "+l.rank+"."),assert(3===c.rank||1===c.rank,"Error in batchNormalization3D: variance must be rank 3 or rank 1 but got rank "+c.rank+"."),null!=i&&assert(3===i.rank||1===i.rank,"Error in batchNormalization3D: scale must be rank 3 or rank 1 but got rank "+i.rank+"."),null!=s&&assert(3===s.rank||1===s.rank,"Error in batchNormalization3D: offset must be rank 3 or rank 1 but got rank "+s.rank+"."),batchNormalization(u,l,c,n,i,s)}function batchNormalization4d_(e,t,r,n,o,a){void 0===n&&(n=.001);var i,s,u=convertToTensor(e,"x","batchNormalization"),l=convertToTensor(t,"mean","batchNormalization"),c=convertToTensor(r,"variance","batchNormalization");return null!=o&&(i=convertToTensor(o,"scale","batchNormalization")),null!=a&&(s=convertToTensor(a,"offset","batchNormalization")),assert(4===u.rank,"Error in batchNormalization4D: x must be rank 4 but got rank "+u.rank+"."),assert(4===l.rank||1===l.rank,"Error in batchNormalization4D: mean must be rank 4 or rank 1 but got rank "+l.rank+"."),assert(4===c.rank||1===c.rank,"Error in batchNormalization4D: variance must be rank 4 or rank 1 but got rank "+c.rank+"."),null!=i&&assert(4===i.rank||1===i.rank,"Error in batchNormalization4D: scale must be rank 4 or rank 1 but got rank "+i.rank+"."),null!=s&&assert(4===s.rank||1===s.rank,"Error in batchNormalization4D: offset must be rank 4 or rank 1 but got rank "+s.rank+"."),batchNormalization(u,l,c,n,i,s)}function batchNormalization_(e,t,r,n,o,a){void 0===n&&(n=.001);var i,s,u,l=convertToTensor(e,"x","batchNormalization"),c=convertToTensor(t,"mean","batchNormalization"),p=convertToTensor(r,"variance","batchNormalization");null!=o&&(i=convertToTensor(o,"scale","batchNormalization")),null!=a&&(s=convertToTensor(a,"offset","batchNormalization")),assert(c.rank===p.rank,"Batch normalization gradient requires mean and variance to have equal ranks."),assert(null==s||c.rank===s.rank,"Batch normalization gradient requires mean and offset to have equal ranks."),assert(null==i||c.rank===i.rank,"Batch normalization gradient requires mean and scale to have equal ranks."),u=0===l.rank||1===l.rank?l.as4D(1,1,1,l.size):2===l.rank?l.as4D(1,1,l.shape[0],l.shape[1]):3===l.rank?l.as4D(1,l.shape[0],l.shape[1],l.shape[2]):l;return ENV.engine.runKernel(function(e){return e.batchNormalization(u,batchnormReshape4D(c),batchnormReshape4D(p),n,batchnormReshape4D(i),batchnormReshape4D(s))},{$x:l,$mean:c,$variance:p,$scale:i,$offset:s},function(e){var t=null==i?scalar(1):i,r=getReductionAxes(c.shape,u.shape),o=[];if(1===c.rank){for(var a=0;a<u.shape.length-1;++a)o.push(u.shape[a]);o.push(1)}var s=l.sub(c),d=e.mul(t),h=rsqrt(p.add(scalar(n))),f=h.mul(h).mul(h).mul(scalar(-.5));return{$x:function(){return 1===c.rank?e.mul(tile(h.as4D(1,1,1,c.shape[0]),o)).mul(t).reshape(l.shape):e.mul(h).mul(t).reshape(l.shape)},$mean:function(){var e=h.mul(scalar(-1)).mul(d);return 1===c.rank&&(e=e.sum(r)),e.reshape(c.shape)},$variance:function(){var e=f.mul(s).mul(d);return 1===c.rank&&(e=e.sum(r)),e.reshape(c.shape)},$scale:function(){var t=s.mul(h),n=e.mul(t);return 1===c.rank&&(n=n.sum(r)),n.reshape(c.shape)},$offset:function(){var t=e;return 1===c.rank&&(t=t.sum(r)),t.reshape(c.shape)}}}).reshape(l.shape)}function batchnormReshape4D(e){return null==e?null:0===e.rank?e.as1D():1===e.rank?e:2===e.rank?e.as4D(1,1,e.shape[0],e.shape[1]):3===e.rank?e.as4D(1,e.shape[0],e.shape[1],e.shape[2]):e}var batchNormalization2d=op({batchNormalization2d_:batchNormalization2d_}),batchNormalization3d=op({batchNormalization3d_:batchNormalization3d_}),batchNormalization4d=op({batchNormalization4d_:batchNormalization4d_}),batchNormalization=op({batchNormalization_:batchNormalization_});function computePool2DInfo(e,t,r,n,o,a,i){void 0===i&&(i="channelsLast");var s,u=parseTupleParam(t),l=u[0],c=u[1];if("channelsLast"===i)s=[l,c,e[3],e[3]];else{if("channelsFirst"!==i)throw new Error("Unknown dataFormat "+i);s=[l,c,e[1],e[1]]}return computeConv2DInfo(e,s,r,n,o,a,!1,i)}function computeConv2DInfo(e,t,r,n,o,a,i,s){void 0===i&&(i=!1),void 0===s&&(s="channelsLast");var u=[-1,-1,-1,-1],l=u[0],c=u[1],p=u[2],d=u[3];if("channelsLast"===s)l=e[0],c=e[1],p=e[2],d=e[3];else{if("channelsFirst"!==s)throw new Error("Unknown dataFormat "+s);l=e[0],d=e[1],c=e[2],p=e[3]}var h,f=t[0],m=t[1],g=t[3],v=parseTupleParam(r),y=v[0],x=v[1],T=parseTupleParam(n),E=T[0],w=T[1],S=getEffectiveFilterSize(f,E),b=getEffectiveFilterSize(m,w),C=getPadAndOutInfo(o,c,p,y,x,S,b,a),_=C.padInfo,A=C.outHeight,N=C.outWidth,R=i?g*d:g;return"channelsFirst"===s?h=[l,R,A,N]:"channelsLast"===s&&(h=[l,A,N,R]),{batchSize:l,dataFormat:s,inHeight:c,inWidth:p,inChannels:d,outHeight:A,outWidth:N,outChannels:R,padInfo:_,strideHeight:y,strideWidth:x,filterHeight:f,filterWidth:m,effectiveFilterHeight:S,effectiveFilterWidth:b,dilationHeight:E,dilationWidth:w,inShape:e,outShape:h,filterShape:t}}function computeOutputShape3D(e,t,r,n,o,a){null==o&&(o=computeDefaultPad(e,t,n));var i=e[0],s=e[1],u=conditionalRound((i-t+2*o)/n+1,a);assert(isInt(u),"The output # of rows ("+u+") must be an integer. Change the stride and/or zero pad parameters");var l=conditionalRound((s-t+2*o)/n+1,a);return assert(isInt(l),"The output # of columns ("+l+") must be an integer. Change the stride and/or zero pad parameters"),[u,l,r]}function computeDefaultPad(e,t,r,n){void 0===n&&(n=1);var o=getEffectiveFilterSize(t,n);return Math.floor((e[0]*(r-1)-r+o)/2)}function parseTupleParam(e){return"number"==typeof e?[e,e]:e}function getEffectiveFilterSize(e,t){return t<=1?e:e+(e-1)*(t-1)}function getPadAndOutInfo(e,t,r,n,o,a,i,s){var u,l,c;if("number"==typeof e){u={top:e,bottom:e,left:e,right:e,type:0===e?"VALID":"NUMBER"};var p=computeOutputShape3D([t,r,1],a,1,n,e,s);l=p[0],c=p[1]}else if("same"===e){var d=((l=Math.ceil(t/n))-1)*n+a-t,h=((c=Math.ceil(r/o))-1)*o+i-r,f=Math.floor(d/2),m=d-f,g=Math.floor(h/2);u={top:f,bottom:m,left:g,right:h-g,type:"SAME"}}else{if("valid"!==e)throw Error("Unknown padding parameter: "+e);u={top:0,bottom:0,left:0,right:0,type:"VALID"},l=Math.ceil((t-a+1)/n),c=Math.ceil((r-i+1)/o)}return{padInfo:u,outHeight:l,outWidth:c}}function conditionalRound(e,t){if(!t)return e;switch(t){case"round":return Math.round(e);case"ceil":return Math.ceil(e);case"floor":return Math.floor(e);default:throw new Error("Unknown roundingMode "+t)}}function tupleValuesAreOne(e){var t=parseTupleParam(e),r=t[0],n=t[1];return 1===r&&1===n}function eitherStridesOrDilationsAreOne(e,t){return tupleValuesAreOne(e)||tupleValuesAreOne(t)}function matMul_(e,t,r,n){void 0===r&&(r=!1),void 0===n&&(n=!1);var o=convertToTensor(e,"a","matMul"),a=convertToTensor(t,"b","matMul"),i=r?o.shape[o.rank-2]:o.shape[o.rank-1],s=n?a.shape[a.rank-1]:a.shape[a.rank-2],u=r?o.shape[o.rank-1]:o.shape[o.rank-2],l=n?a.shape[a.rank-2]:a.shape[a.rank-1],c=o.shape.slice(0,-2),p=a.shape.slice(0,-2),d=sizeFromShape(c),h=sizeFromShape(p);assert(o.rank>=2&&a.rank>=2&&o.rank===a.rank,"Error in matMul: inputs must have the same rank of at least 2, got ranks "+o.rank+" and "+a.rank+"."),assert(arraysEqual(c,p),"Error in matMul: outer dimensions ("+c+") and ("+p+") of Tensors with shapes "+o.shape+" and "+a.shape+" must match."),assert(i===s,"Error in matMul: inner shapes ("+i+") and ("+s+") of Tensors with shapes "+o.shape+" and "+a.shape+" and transposeA="+r+" and transposeB="+n+" must match.");var f=o.shape.slice(0,-2).concat([u,l]),m=r?o.as3D(d,i,u):o.as3D(d,u,i),g=n?a.as3D(h,l,s):a.as3D(h,s,l);return ENV.engine.runKernel(function(e){return e.batchMatMul(m,g,r,n)},{$a:m,$b:g},function(e){return r||n?!r&&n?{$a:function(){return e.matMul(g.toFloat(),!1,!1)},$b:function(){return e.matMul(m.toFloat(),!0,!1)}}:r&&!n?{$a:function(){return g.toFloat().matMul(e,!1,!0)},$b:function(){return m.toFloat().matMul(e,!1,!1)}}:{$a:function(){return g.toFloat().matMul(e,!0,!0)},$b:function(){return e.matMul(m.toFloat(),!0,!0)}}:{$a:function(){return e.matMul(g.toFloat(),!1,!0)},$b:function(){return m.toFloat().matMul(e,!0,!1)}}}).reshape(f)}function outerProduct_(e,t){var r=convertToTensor(e,"v1","outerProduct"),n=convertToTensor(t,"v2","outerProduct");return assert(1===r.rank&&1===n.rank,"Error in outerProduct: inputs must be rank 1, but got ranks "+r.rank+" and "+n.rank+"."),r.as2D(-1,1).matMul(n.as2D(1,-1))}function dot_(e,t){var r=convertToTensor(e,"t1","dot"),n=convertToTensor(t,"t2","dot");assert(!(1!==r.rank&&2!==r.rank||1!==n.rank&&2!==n.rank),"Error in dot: inputs must all be rank 1 or 2, but got ranks "+r.rank+" and "+n.rank+".");var o=1===r.rank?r.size:r.shape[1],a=1===n.rank?n.size:n.shape[0];return assert(o===a,"Error in dot: inner dimensions of inputs must match, but got "+o+" and "+a+"."),1===r.rank&&1===n.rank?r.as2D(1,-1).matMul(n.as2D(-1,1)).asScalar():1===r.rank&&2===n.rank?r.as2D(1,-1).matMul(n.as2D(n.shape[0],n.shape[1])).as1D():2===r.rank&&1===n.rank?r.matMul(n.as2D(-1,1)).as1D():r.matMul(n.as2D(n.shape[0],n.shape[1]))}var matMul=op({matMul_:matMul_}),dot=op({dot_:dot_}),outerProduct=op({outerProduct_:outerProduct_});function conv1d_(e,t,r,n,o,a,i){void 0===o&&(o="NWC"),void 0===a&&(a=1);var s=convertToTensor(e,"x","conv1d"),u=convertToTensor(t,"filter","conv1d"),l=s,c=!1;2===s.rank&&(c=!0,l=s.as3D(1,s.shape[0],s.shape[1])),assert(3===l.rank,"Error in conv1d: input must be rank 3, but got rank "+l.rank+"."),assert(3===u.rank,"Error in conv1d: filter must be rank 3, but got rank "+u.rank+"."),null!=i&&assert(isInt(n),"Error in conv1d: pad must be an integer when using, dimRoundingMode "+i+" but got pad "+n+"."),assert(l.shape[2]===u.shape[1],"Error in conv1d: depth of input ("+l.shape[2]+") must match input depth for filter "+u.shape[1]+"."),assert(eitherStridesOrDilationsAreOne(r,a),"Error in conv1D: Either stride or dilation must be 1. Got stride "+r+" and dilation '"+a+"'"),assert("NWC"===o,"Error in conv1d: got dataFormat of "+o+" but only NWC is currently supported.");var p=u.as4D(1,u.shape[0],u.shape[1],u.shape[2]),d=l.as4D(l.shape[0],1,l.shape[1],l.shape[2]),h=conv2d(d,p,[1,r],n,"NHWC",[1,a],i);return c?h.as2D(h.shape[2],h.shape[3]):h.as3D(h.shape[0],h.shape[2],h.shape[3])}function conv2d_(e,t,r,n,o,a,i){void 0===o&&(o="NHWC"),void 0===a&&(a=[1,1]);var s=convertToTensor(e,"x","conv2d"),u=convertToTensor(t,"filter","conv2d"),l=s,c=!1;3===s.rank&&(c=!0,l=s.as4D(1,s.shape[0],s.shape[1],s.shape[2])),assert(4===l.rank,"Error in conv2d: input must be rank 4, but got rank "+l.rank+"."),assert(4===u.rank,"Error in conv2d: filter must be rank 4, but got rank "+u.rank+"."),null!=i&&assert(isInt(n),"Error in conv2d: pad must be an integer when using, dimRoundingMode "+i+" but got pad "+n+"."),assert(l.shape[3]===u.shape[2],"Error in conv2d: depth of input ("+l.shape[3]+") must match input depth for filter "+u.shape[2]+"."),assert(eitherStridesOrDilationsAreOne(r,a),"Error in conv2D: Either strides or dilations must be 1. Got strides "+r+" and dilations '"+a+"'"),assert("NHWC"===o,"Error in conv2d: got dataFormat of "+o+" but only NHWC is currently supported.");var p,d=computeConv2DInfo(l.shape,u.shape,r,a,n,i);if(1!==d.filterHeight||1!==d.filterWidth||1!==d.dilationHeight||1!==d.dilationWidth||1!==d.strideHeight||1!==d.strideWidth||"SAME"!==d.padInfo.type&&"VALID"!==d.padInfo.type){p=ENV.engine.runKernel(function(e){return e.conv2d(l,u,d)},{x:l,$filter:u},function(e){return assert(tupleValuesAreOne(a),"Error in gradient of conv2D: dilation rates greater than 1 are notyet supported in gradients. Got dilations '"+a+"'"),{x:function(){return conv2dDerInput_(l.shape,e,u,r,n)},$filter:function(){return conv2dDerFilter_(l,e,u.shape,r,n)}}})}else{var h=l.reshape([-1,d.inChannels]),f=u.reshape([d.inChannels,d.outChannels]);p=matMul(h,f).reshape(d.outShape)}return c?p.as3D(p.shape[1],p.shape[2],p.shape[3]):p}function conv2dDerInput_(e,t,r,n,o,a){assert(e.length===t.rank,"Length of inShape ("+e.length+") and rank of dy ("+t.rank+") must match");var i=e,s=t,u=!1;3===t.rank&&(u=!0,s=t.as4D(1,t.shape[0],t.shape[1],t.shape[2]),i=[1,e[0],e[1],e[2]]);var l=i[3],c=s.shape[3];assert(4===i.length,"Error in conv2dDerInput: inShape must be length 4, but got length "+i.length+"."),assert(4===s.rank,"Error in conv2dDerInput: dy must be rank 4, but got rank "+s.rank),assert(4===r.rank,"Error in conv2dDerInput: filter must be rank 4, but got rank "+r.rank),assert(l===r.shape[2],"Error in conv2dDerInput: depth of input ("+l+") must match input depth for filter "+r.shape[2]+"."),assert(c===r.shape[3],"Error in conv2dDerInput: depth of output ("+c+") must match output depth for filter "+r.shape[3]+"."),null!=a&&assert(isInt(o),"Error in conv2dDerInput: pad must be an integer when using, dimRoundingMode "+a+" but got pad "+o+".");var p=computeConv2DInfo(i,r.shape,n,1,o,a),d=ENV.engine.runKernel(function(e){return e.conv2dDerInput(s,r,p)},{dy4D:s,filter:r},function(e){return{dy4D:function(){return conv2d(e,r,n,o,"NHWC",1,a)},filter:function(){return conv2dDerFilter(e,s,r.shape,n,o,a)}}});return u?d.as3D(d.shape[1],d.shape[2],d.shape[3]):d}function conv2dDerFilter_(e,t,r,n,o,a){var i=e;3===e.rank&&(i=e.as4D(1,e.shape[0],e.shape[1],e.shape[2]));var s=t;3===s.rank&&(s=t.as4D(1,t.shape[0],t.shape[1],t.shape[2])),assert(4===i.rank,"Error in conv2dDerFilter: input must be rank 4, but got shape "+i.shape+"."),assert(4===s.rank,"Error in conv2dDerFilter: dy must be rank 4, but got shape "+s.shape+"."),assert(4===r.length,"Error in conv2dDerFilter: filterShape must be length 4, but got "+r+"."),assert(i.shape[3]===r[2],"Error in conv2dDerFilter: depth of input "+i.shape[3]+") must match input depth in filter ("+r[2]+"."),assert(s.shape[3]===r[3],"Error in conv2dDerFilter: depth of dy ("+s.shape[3]+") must match output depth for filter ("+r[3]+")."),null!=a&&assert(isInt(o),"Error in conv2dDerFilter: pad must be an integer when using, dimRoundingMode "+a+" but got pad "+o+".");var u=computeConv2DInfo(i.shape,r,n,1,o,a);return ENV.engine.runKernel(function(e){return e.conv2dDerFilter(i,s,u)},{x4D:i,dy4D:s})}function conv2dTranspose_(e,t,r,n,o,a){return conv2dDerInput_(r,convertToTensor(e,"x","conv2dTranspose"),convertToTensor(t,"filter","conv2dTranspose"),n,o,a)}function depthwiseConv2d_(e,t,r,n,o,a,i){void 0===o&&(o="NHWC"),void 0===a&&(a=[1,1]);var s=convertToTensor(e,"x","depthwiseConv2d"),u=convertToTensor(t,"filter","depthwiseConv2d"),l=s,c=!1;3===s.rank&&(c=!0,l=s.as4D(1,s.shape[0],s.shape[1],s.shape[2])),assert(4===l.rank,"Error in depthwiseConv2d: input must be rank 4, but got rank "+l.rank+"."),assert(4===u.rank,"Error in depthwiseConv2d: filter must be rank 4, but got rank "+u.rank+"."),assert(l.shape[3]===u.shape[2],"Error in depthwiseConv2d: number of input channels ("+l.shape[3]+") must match the inChannels dimension in filter "+u.shape[2]+"."),null==a&&(a=[1,1]),assert(eitherStridesOrDilationsAreOne(r,a),"Error in depthwiseConv2d: Either strides or dilations must be 1. Got strides "+r+" and dilations '"+a+"'"),null!=i&&assert(isInt(n),"Error in depthwiseConv2d: pad must be an integer when using, dimRoundingMode "+i+" but got pad "+n+".");var p=computeConv2DInfo(l.shape,u.shape,r,a,n,i,!0),d=ENV.engine.runKernel(function(e){return e.depthwiseConv2D(l,u,p)},{x:l,$filter:u},function(e){return assert(tupleValuesAreOne(a),"Error in gradient of depthwiseConv2d: dilation rates greater than 1 are not yet supported. Got dilations '"+a+"'"),{x:function(){return depthwiseConv2dDerInput(l.shape,e,u,p)},$filter:function(){return depthwiseConv2dDerFilter(l,e,u.shape,p)}}});return c?d.as3D(d.shape[1],d.shape[2],d.shape[3]):d}function separableConv2d_(e,t,r,n,o,a,i){void 0===a&&(a=[1,1]),void 0===i&&(i="NHWC");var s=convertToTensor(e,"x","separableConv2d"),u=convertToTensor(t,"depthwiseFilter","separableConv2d"),l=convertToTensor(r,"pointwiseFilter","separableConv2d"),c=s,p=!1;if(3===s.rank&&(p=!0,c=s.as4D(1,s.shape[0],s.shape[1],s.shape[2])),"NCHW"===i)throw new Error("separableConv2d currently does not support dataFormat NCHW; only NHWC is supported");assert(4===c.rank,"Error in separableConv2d: input must be rank 4, but got rank "+c.rank+"."),assert(4===u.rank,"Error in separableConv2d: depthwise filter must be rank 4, but got rank "+u.rank+"."),assert(4===l.rank,"Error in separableConv2d: pointwise filter must be rank 4, but got rank "+u.rank+"."),assert(1===l.shape[0],"Error in separableConv2d: the first dimension of pointwise filter  must be 1, but got "+l.shape[0]+"."),assert(1===l.shape[1],"Error in separableConv2d: the second dimension of pointwise filter  must be 1, but got "+l.shape[1]+".");var d=u.shape[2],h=u.shape[3];assert(l.shape[2]===d*h,"Error in separableConv2d: the third dimension of pointwise filter must be "+d*h+", but got "+l.shape[2]+".");var f=depthwiseConv2d(c,u,n,o,i,a),m=conv2d(f,l,1,"valid",i);return p?m.as3D(m.shape[1],m.shape[2],m.shape[3]):m}function depthwiseConv2dDerInput(e,t,r,n){var o=t,a=!1;3===t.rank&&(a=!0,o=t.as4D(1,t.shape[0],t.shape[1],t.shape[2]));var i=ENV.engine.runKernel(function(e){return e.depthwiseConv2DDerInput(o,r,n)},{dy4D:o});return a?i.as3D(i.shape[1],i.shape[2],i.shape[3]):i}function depthwiseConv2dDerFilter(e,t,r,n){var o=e;3===e.rank&&(o=e.as4D(1,e.shape[0],e.shape[1],e.shape[2]));var a=t;return 3===a.rank&&(a=t.as4D(1,t.shape[0],t.shape[1],t.shape[2])),ENV.engine.runKernel(function(e){return e.depthwiseConv2DDerFilter(o,a,n)},{x4D:o,dy4D:a})}var conv1d=op({conv1d_:conv1d_}),conv2d=op({conv2d_:conv2d_}),conv2dDerFilter=op({conv2dDerFilter_:conv2dDerFilter_}),depthwiseConv2d=op({depthwiseConv2d_:depthwiseConv2d_}),separableConv2d=op({separableConv2d_:separableConv2d_}),conv2dTranspose=op({conv2dTranspose_:conv2dTranspose_});function reverse1d_(e){var t=convertToTensor(e,"x","reverse");return assert(1===t.rank,"Error in reverse1D: x must be rank 1 but got\n             rank "+t.rank+"."),reverse(t,0)}function reverse2d_(e,t){var r=convertToTensor(e,"x","reverse");return assert(2===r.rank,"Error in reverse2D: x must be rank 2 but got\n             rank "+r.rank+"."),reverse(r,t)}function reverse3d_(e,t){var r=convertToTensor(e,"x","reverse");return assert(3===r.rank,"Error in reverse3D: x must be rank 3 but got\n             rank "+r.rank+"."),reverse(r,t)}function reverse4d_(e,t){var r=convertToTensor(e,"x","reverse");return assert(4===r.rank,"Error in reverse4D: x must be rank 4 but got\n             rank "+r.rank+"."),reverse(r,t)}function reverse_(e,t){var r=convertToTensor(e,"x","reverse");if(0===r.rank)return r.clone();var n=parseAxisParam(t,r.shape);return ENV.engine.runKernel(function(e){return e.reverse(r,n)},{$x:r},function(e){return{$x:function(){return e.reverse(n)}}}).reshapeAs(r)}var reverse=op({reverse_:reverse_}),reverse1d=op({reverse1d_:reverse1d_}),reverse2d=op({reverse2d_:reverse2d_}),reverse3d=op({reverse3d_:reverse3d_}),reverse4d=op({reverse4d_:reverse4d_});function maxPoolImpl_(e,t,r,n,o,a){var i=convertToTensor(e,"x","maxPool"),s=i,u=!1;3===i.rank&&(u=!0,s=i.as4D(1,i.shape[0],i.shape[1],i.shape[2])),null==n&&(n=[1,1]),assert(4===s.rank,"Error in maxPool: input must be rank 4 but got rank "+s.rank+"."),assert(eitherStridesOrDilationsAreOne(r,n),"Error in maxPool: Either strides or dilations must be 1. Got strides "+r+" and dilations '"+n+"'"),null!=a&&assert(isInt(o),"Error in maxPool: pad must be an integer when using, dimRoundingMode "+a+" but got pad "+o+".");var l=computePool2DInfo(s.shape,t,r,n,o,a),c=ENV.engine.runKernel(function(e,t){return t(e.maxPool(s,l))},{x:s},function(e,a){var i=a[0];return{x:function(){return maxPoolBackprop(e,s,i,t,r,n,o)}}});return u?c.as3D(c.shape[1],c.shape[2],c.shape[3]):c}function maxPool_(e,t,r,n,o){return maxPoolImpl_(e,t,r,1,n,o)}function avgPoolImpl_(e,t,r,n,o,a){var i=convertToTensor(e,"x","avgPool");assert("float32"===i.dtype,"The input dtype to avgPool must be float32"),null==n&&(n=[1,1]),assert(eitherStridesOrDilationsAreOne(r,n),"Error in avgPool: Either strides or dilations must be 1. Got strides "+r+" and dilations '"+n+"'");var s=i,u=!1;3===i.rank&&(u=!0,s=i.as4D(1,i.shape[0],i.shape[1],i.shape[2])),assert(4===s.rank,"Error in avgPool: x must be rank 4 but got rank "+s.rank+"."),null!=a&&assert(isInt(o),"Error in avgPool: pad must be an integer when using, dimRoundingMode "+a+" but got pad "+o+".");var l=computePool2DInfo(s.shape,t,r,n,o),c=ENV.engine.runKernel(function(e){return e.avgPool(s,l)},{x:s},function(e){return{x:function(){return avgPoolBackprop(e,s,t,r,n,o)}}});return c=c.cast(i.dtype),u?c.as3D(c.shape[1],c.shape[2],c.shape[3]):c}function avgPool_(e,t,r,n,o){return avgPoolImpl_(e,t,r,1,n,o)}function pool_(e,t,r,n,o,a){null==o&&(o=[1,1]),null==a&&(a=1),0===n&&(n="valid");var i=convertToTensor(e,"x","maxPool"),s=i,u=!1;3===i.rank&&(u=!0,s=i.as4D(1,i.shape[0],i.shape[1],i.shape[2])),assert(eitherStridesOrDilationsAreOne(a,o),"Error in pool: Either strides or dilations must be 1. Got strides "+a+" and dilations '"+o+"'");var l,c=computePool2DInfo(s.shape,t,a,o,n),p=[c.dilationHeight,c.dilationWidth];l="same"===n?withSpaceToBatchBasePaddings([c.filterHeight,c.filterWidth],p):[[0,0],[0,0]];var d=1===p[0]&&1===p[1],h=requiredSpaceToBatchPaddings([c.inHeight,c.inWidth],p,l),f=h[0],m=h[1],g=d?n:"valid",v=d?s:spaceToBatchND(s,p,f),y=("avg"===r?function(){return avgPoolImpl_(v,t,a,1,g)}:function(){return maxPoolImpl_(v,t,a,1,g)})(),x=d?y:batchToSpaceND(y,p,m);return u?x.as3D(x.shape[1],x.shape[2],x.shape[3]):x}function maxPoolBackprop(e,t,r,n,o,a,i,s){var u=convertToTensor(e,"dy","maxPoolBackprop"),l=convertToTensor(t,"input","maxPoolBackprop"),c=convertToTensor(r,"output","maxPoolBackprop");assert(l.rank===u.rank,"Rank of input ("+l.rank+") does not match rank of dy ("+u.rank+")"),null==a&&(a=[1,1]),assert(eitherStridesOrDilationsAreOne(o,a),"Error in maxPoolBackProp: Either strides or dilations must be 1. Got strides "+o+" and dilations '"+a+"'"),assert(4===u.rank,"Error in maxPoolBackprop: dy must be rank 4 but got rank "+u.rank+"."),assert(4===l.rank,"Error in maxPoolBackprop: input must be rank 4 but got rank "+l.rank+"."),null!=s&&assert(isInt(i),"Error in maxPoolBackprop: pad must be an integer when using, dimRoundingMode "+s+" but got pad "+i+".");var p=computePool2DInfo(l.shape,n,o,a,i,s);return ENV.engine.runKernel(function(e){return e.maxPoolBackprop(u,l,c,p)},{$dy:u,$input:l})}function avgPoolBackprop(e,t,r,n,o,a){var i=convertToTensor(e,"dy","avgPoolBackprop"),s=convertToTensor(t,"input","avgPoolBackprop");assert(s.rank===i.rank,"Rank of input ("+s.rank+") does not match rank of dy ("+i.rank+")"),null==o&&(o=[1,1]),assert(eitherStridesOrDilationsAreOne(n,o),"Error in avgPoolBackprop: Either strides or dilations must be 1. Got strides "+n+" and dilations '"+o+"'");var u=s,l=i,c=!1;3===s.rank&&(c=!0,u=s.as4D(1,s.shape[0],s.shape[1],s.shape[2]),l=i.as4D(1,i.shape[0],i.shape[1],i.shape[2])),assert(4===l.rank,"Error in avgPoolBackprop: dy must be rank 4 but got rank "+l.rank+"."),assert(4===u.rank,"Error in avgPoolBackprop: input must be rank 4 but got rank "+u.rank+".");var p=computePool2DInfo(u.shape,r,n,o,a),d=ENV.engine.runKernel(function(e){return e.avgPoolBackprop(l,u,p)},{dy4D:l,input4D:u});return c?d.as3D(d.shape[1],d.shape[2],d.shape[3]):d}function requiredSpaceToBatchPaddings(e,t,r){var n=r.map(function(e){return e[0]}),o=r.map(function(e){return e[1]}),a=e.concat(n,o),i=t.map(function(e,t){return(e-a[t]%e)%e}),s=o.map(function(e,t){return e+i[t]});return[t.map(function(e,t){return[n[t],s[t]]}),t.map(function(e,t){return[0,i[t]]})]}function withSpaceToBatchBasePaddings(e,t){var r=e.map(function(e,r){return e+(e-1)*(t[r]-1)}).map(function(e){return e-1}),n=r.map(function(e){return Math.floor(e/2)}),o=r.map(function(e,t){return e-n[t]});return r.map(function(e,t){return[n[t],o[t]]})}var maxPool=op({maxPool_:maxPool_}),avgPool=op({avgPool_:avgPool_}),pool=op({pool_:pool_});function slice1d_(e,t,r){var n=convertToTensor(e,"x","slice1d");return assert(1===n.rank,"slice1d expects a rank-1 tensor, but got a rank-"+n.rank+" tensor"),slice(n,[t],[r])}function slice2d_(e,t,r){var n=convertToTensor(e,"x","slice2d");return assert(2===n.rank,"slice2d expects a rank-2 tensor, but got a rank-"+n.rank+" tensor"),slice(n,t,r)}function slice3d_(e,t,r){var n=convertToTensor(e,"x","slice3d");return assert(3===n.rank,"slice3d expects a rank-3 tensor, but got a rank-"+n.rank+" tensor"),slice(n,t,r)}function slice4d_(e,t,r){var n=convertToTensor(e,"x","slice4d");return assert(4===n.rank,"slice4d expects a rank-4 tensor, but got a rank-"+n.rank+" tensor"),slice(n,t,r)}function slice_(e,t,r){var n,o,a=convertToTensor(e,"x","slice");if(0===a.rank)throw new Error("Slicing scalar is not possible");n="number"==typeof t?[t].concat(new Array(a.rank-1).fill(0)):t.length<a.rank?t.concat(new Array(a.rank-t.length).fill(0)):t.slice(),o=(o=null==r?new Array(a.rank).fill(-1):"number"==typeof r?[r].concat(new Array(a.rank-1).fill(-1)):r.length<a.rank?r.concat(new Array(a.rank-r.length).fill(-1)):r).map(function(e,t){return e>=0?e:(assert(-1===e,"Bad value in size"),a.shape[t]-n[t])}),assertParamsValid(a,n,o);var i=a.shape;return ENV.engine.runKernel(function(e){return e.slice(a,n,o)},{$x:a},function(e){for(var t=[],r=0;r<e.rank;r++)t.push([n[r],i[r]-n[r]-o[r]]);return{$x:function(){return e.pad(t)}}})}var slice=op({slice_:slice_}),slice1d=op({slice1d_:slice1d_}),slice2d=op({slice2d_:slice2d_}),slice3d=op({slice3d_:slice3d_}),slice4d=op({slice4d_:slice4d_});function logSumExp_(e,t,r){void 0===t&&(t=null),void 0===r&&(r=!1);var n=convertToTensor(e,"x","logSumExp"),o=parseAxisParam(t,n.shape),a=n.max(o,!0),i=n.sub(a).exp().sum(o).log(),s=a.reshape(i.shape).add(i);if(r){var u=expandShapeToKeepDim(s.shape,o);return s.reshape(u)}return s}function sum_(e,t,r){void 0===t&&(t=null),void 0===r&&(r=!1);var n=convertToTensor(e,"x","sum");"bool"===n.dtype&&(n=n.toInt());var o=parseAxisParam(t,n.shape);return customGrad(function(e){var t=getAxesPermutation(o,e.rank),n=o,a=e;null!=t&&(a=e.transpose(t),n=getInnerMostAxes(n.length,e.rank));var i=ENV.engine.runKernel(function(e){return e.sum(a,n)},{permutedX:a});if(r){var s=expandShapeToKeepDim(i.shape,o);i=i.reshape(s)}return{value:i,gradFunc:function(t){var r=e.shape.slice();return o.forEach(function(e){r[e]=1}),t.reshape(r).mul(ones$1(e.shape,"float32"))}}})(n)}function prod_(e,t,r){void 0===t&&(t=null),void 0===r&&(r=!1);var n=convertToTensor(e,"x","prod");"bool"===n.dtype&&(n=n.toInt());var o=parseAxisParam(t,n.shape),a=getAxesPermutation(o,n.rank),i=o,s=n;null!=a&&(s=n.transpose(a),i=getInnerMostAxes(i.length,n.rank));var u=ENV.engine.runKernel(function(e){return e.prod(s,i)},{permutedX:s});if(r){var l=expandShapeToKeepDim(u.shape,o);u=u.reshape(l)}return u}function mean_(e,t,r){void 0===t&&(t=null),void 0===r&&(r=!1);var n=convertToTensor(e,"x","mean"),o=parseAxisParam(t,n.shape),a=sizeFromShape(computeOutAndReduceShapes(n.shape,o)[1]);return customGrad(function(e){var n=scalar(a);return{value:(n.dtype===e.dtype?e:e.cast(n.dtype)).div(n).sum(t,r),gradFunc:function(t){var r=e.shape.slice();return o.forEach(function(e){r[e]=1}),t.reshape(r).mul(ones$1(e.shape,"float32")).div(n)}}})(n)}function gradForMinAndMax(e,t,r,n,o){var a=t[0];return a.rank<r.rank&&(a=a.reshape(expandShapeToKeepDim(a.shape,n))),e.rank<r.rank&&(e=e.reshape(expandShapeToKeepDim(e.shape,n))),{$x:function(){var t=e.mul(r.equal(a).cast(e.dtype));return null==o?t:t.transpose(o)}}}function min_(e,t,r){void 0===t&&(t=null),void 0===r&&(r=!1);var n=convertToTensor(e,"x","min"),o=n,a=parseAxisParam(t,n.shape),i=a,s=getAxesPermutation(i,n.rank);null!=s&&(n=n.transpose(s),i=getInnerMostAxes(i.length,n.rank));var u=ENV.engine.runKernel(function(e,t){return t(e.min(n,i))},{$x:n},function(e,t){return gradForMinAndMax(e,t,o,a,s)});if(r){var l=expandShapeToKeepDim(u.shape,a);u=u.reshape(l)}return u}function max_(e,t,r){void 0===t&&(t=null),void 0===r&&(r=!1);var n=convertToTensor(e,"x","max"),o=n,a=parseAxisParam(t,n.shape),i=a,s=getAxesPermutation(i,n.rank);null!=s&&(n=n.transpose(s),i=getInnerMostAxes(i.length,n.rank));var u=ENV.engine.runKernel(function(e,t){return t(e.max(n,i))},{$x:n},function(e,t){return gradForMinAndMax(e,t,o,a,s)});if(r){var l=expandShapeToKeepDim(u.shape,a);u=u.reshape(l)}return u}function argMin_(e,t){void 0===t&&(t=0);var r=convertToTensor(e,"x","argMin");null==t&&(t=0);var n=parseAxisParam(t,r.shape),o=getAxesPermutation(n,r.rank);null!=o&&(r=r.transpose(o),n=getInnerMostAxes(n.length,r.rank));return ENV.engine.runKernel(function(e){return e.argMin(r,n[0])},{$x:r},function(e){return{$x:function(){return zerosLike(r)}}})}function argMax_(e,t){void 0===t&&(t=0);var r=convertToTensor(e,"x","argMax");null==t&&(t=0);var n=parseAxisParam(t,r.shape),o=getAxesPermutation(n,r.rank);null!=o&&(r=r.transpose(o),n=getInnerMostAxes(n.length,r.rank));return ENV.engine.runKernel(function(e){return e.argMax(r,n[0])},{$x:r},function(e){return{$x:function(){return zerosLike(r)}}})}function all_(e,t,r){void 0===t&&(t=null),void 0===r&&(r=!1);var n=convertToTensor(e,"x","all","bool");assert("bool"===n.dtype,"Error Tensor must be of type bool. Got: "+n.dtype);var o=parseAxisParam(t,n.shape),a=o,i=getAxesPermutation(a,n.rank);null!=i&&(n=n.transpose(i),a=getInnerMostAxes(a.length,n.rank));var s=ENV.engine.runKernel(function(e){return e.all(n,a)},{$x:n});if(r){var u=expandShapeToKeepDim(s.shape,o);return s.reshape(u)}return s}function any_(e,t,r){void 0===t&&(t=null),void 0===r&&(r=!1);var n=convertToTensor(e,"x","any","bool");assert("bool"===n.dtype,"Error Tensor must be of type bool. Got: "+n.dtype);var o=parseAxisParam(t,n.shape),a=o,i=getAxesPermutation(a,n.rank);null!=i&&(n=n.transpose(i),a=getInnerMostAxes(a.length,n.rank));var s=ENV.engine.runKernel(function(e){return e.any(n,a)},{$x:n});if(r){var u=expandShapeToKeepDim(s.shape,o);return s.reshape(u)}return s}function moments_(e,t,r){void 0===t&&(t=null),void 0===r&&(r=!1);var n=parseAxisParam(t,(e=convertToTensor(e,"x","moments")).shape),o=e.mean(n,r),a=o.shape;return r||(a=expandShapeToKeepDim(o.shape,n)),{mean:o,variance:e.toFloat().sub(o.reshape(a)).square().mean(n,r)}}var all=op({all_:all_}),any=op({any_:any_}),argMax=op({argMax_:argMax_}),argMin=op({argMin_:argMin_}),logSumExp=op({logSumExp_:logSumExp_}),max=op({max_:max_}),mean=op({mean_:mean_}),min=op({min_:min_}),moments=op({moments_:moments_}),sum$1=op({sum_:sum_}),prod=op({prod_:prod_});function notEqual_(e,t){var r=convertToTensor(e,"a","notEqual"),n=convertToTensor(t,"b","notEqual");return assertTypesMatch(r,n),assertAndGetBroadcastShape(r.shape,n.shape),ENV.engine.runKernel(function(e){return e.notEqual(r,n)},{$a:r,$b:n})}function notEqualStrict_(e,t){var r=convertToTensor(e,"a","notEqualStrict"),n=convertToTensor(t,"b","notEqualStrict");return assertShapesMatch(r.shape,n.shape,"Error in notEqualStrict: "),r.notEqual(n)}function less_(e,t){var r=convertToTensor(e,"a","less"),n=convertToTensor(t,"b","less");return assertTypesMatch(r,n),assertAndGetBroadcastShape(r.shape,n.shape),ENV.engine.runKernel(function(e){return e.less(r,n)},{$a:r,$b:n})}function lessStrict_(e,t){var r=convertToTensor(e,"a","lessStrict"),n=convertToTensor(t,"b","lessStrict");return assertShapesMatch(r.shape,n.shape,"Error in lessStrict: "),r.less(n)}function equal_(e,t){var r=convertToTensor(e,"a","equal"),n=convertToTensor(t,"b","equal");return assertTypesMatch(r,n),assertAndGetBroadcastShape(r.shape,n.shape),ENV.engine.runKernel(function(e){return e.equal(r,n)},{$a:r,$b:n})}function equalStrict_(e,t){var r=convertToTensor(e,"a","equalStrict"),n=convertToTensor(t,"b","equalStrict");return assertShapesMatch(r.shape,n.shape,"Error in equalStrict: "),r.equal(n)}function lessEqual_(e,t){var r=convertToTensor(e,"a","lessEqual"),n=convertToTensor(t,"b","lessEqual");return assertTypesMatch(r,n),assertAndGetBroadcastShape(r.shape,n.shape),ENV.engine.runKernel(function(e){return e.lessEqual(r,n)},{$a:r,$b:n})}function lessEqualStrict_(e,t){var r=convertToTensor(e,"a","lessEqualStrict"),n=convertToTensor(t,"b","lessEqualStrict");return assertShapesMatch(r.shape,n.shape,"Error in lessEqualStrict: "),r.lessEqual(n)}function greater_(e,t){var r=convertToTensor(e,"a","greater"),n=convertToTensor(t,"b","greater");return assertTypesMatch(r,n),assertAndGetBroadcastShape(r.shape,n.shape),ENV.engine.runKernel(function(e){return e.greater(r,n)},{$a:r,$b:n})}function greaterStrict_(e,t){var r=convertToTensor(e,"a","greaterStrict"),n=convertToTensor(t,"b","greaterStrict");return assertShapesMatch(r.shape,n.shape,"Error in greaterStrict: "),r.greater(n)}function greaterEqual_(e,t){var r=convertToTensor(e,"a","greaterEqual"),n=convertToTensor(t,"b","greaterEqual");assertTypesMatch(r,n),assertAndGetBroadcastShape(r.shape,n.shape);return ENV.engine.runKernel(function(e){return e.greaterEqual(r,n)},{$a:r,$b:n},function(e){return{$a:function(){return zerosLike(r)},$b:function(){return zerosLike(n)}}})}function greaterEqualStrict_(e,t){var r=convertToTensor(e,"a","greaterEqualStrict"),n=convertToTensor(t,"b","greaterEqualStrict");return assertShapesMatch(r.shape,n.shape,"Error in greaterEqualStrict: "),r.greaterEqual(n)}var equal=op({equal_:equal_}),equalStrict=op({equalStrict_:equalStrict_}),greater=op({greater_:greater_}),greaterEqual=op({greaterEqual_:greaterEqual_}),greaterEqualStrict=op({greaterEqualStrict_:greaterEqualStrict_}),greaterStrict=op({greaterStrict_:greaterStrict_}),less=op({less_:less_}),lessEqual=op({lessEqual_:lessEqual_}),lessEqualStrict=op({lessEqualStrict_:lessEqualStrict_}),lessStrict=op({lessStrict_:lessStrict_}),notEqual=op({notEqual_:notEqual_}),notEqualStrict=op({notEqualStrict_:notEqualStrict_});function add_(e,t){var r=convertToTensor(e,"a","add"),n=convertToTensor(t,"b","add");assertTypesMatch(r,n);var o=assertAndGetBroadcastShape(r.shape,n.shape);return ENV.engine.runKernel(function(e){return e.add(r,n)},{$a:r,$b:n},function(e){return{$a:function(){var t=e,n=getReductionAxes(r.shape,o);return n.length>0&&(t=t.sum(n)),t.reshape(r.shape)},$b:function(){var t=e,r=getReductionAxes(n.shape,o);return r.length>0&&(t=t.sum(r)),t.reshape(n.shape)}}})}function addN_(e){assert(Array.isArray(e),function(){return"The argument passed to tf.addN() must be a list of tensors"}),assert(e.length>=1,function(){return"Must pass at least one tensor to tf.addN(), but got "+e.length});var t=e.map(function(e,t){return convertToTensor(e,"tensors"+t,"addN")}),r=t[0];t.forEach(function(e){if(e.dtype!==r.dtype)throw new Error("All tensors passed to tf.addN() must have the same dtype")}),t.forEach(function(e){if(!arraysEqual(e.shape,r.shape))throw new Error("All tensors passed to tf.addN() must have the same shape")});var n=t;return ENV.engine.runKernel(function(e){return e.addN(t)},n,function(e){var r={};return t.forEach(function(t,n){r[n]=function(){return e.clone()}}),r})}function addStrict_(e,t){return assertShapesMatch(e.shape,t.shape,"Error in addStrict: "),e.add(t)}function sub_(e,t){var r=convertToTensor(e,"a","sub"),n=convertToTensor(t,"b","sub");assertTypesMatch(r,n);var o=assertAndGetBroadcastShape(r.shape,n.shape);return ENV.engine.runKernel(function(e){return e.subtract(r,n)},{$a:r,$b:n},function(e){return{$a:function(){var t=e,n=getReductionAxes(r.shape,o);return n.length>0&&(t=t.sum(n)),t.reshape(r.shape)},$b:function(){var t=e,r=getReductionAxes(n.shape,o);return r.length>0&&(t=t.sum(r)),t.neg().reshape(n.shape)}}})}function subStrict_(e,t){return assertShapesMatch(e.shape,t.shape,"Error in subStrict: "),e.sub(t)}function pow_(e,t){var r=convertToTensor(e,"base","pow"),n=convertToTensor(t,"exp","pow"),o=assertAndGetBroadcastShape(r.shape,n.shape);e=r.cast(upcastType(r.dtype,n.dtype)),t=n.cast(upcastType(r.dtype,n.dtype));return ENV.engine.runKernel(function(e,t){return t(e.pow(r,n))},{$base:r,$exp:n},function(e,t){var a=t[0];return{$base:function(){var t=n.toFloat(),a=e.mul(t.mul(r.pow(t.sub(scalar(1))))),i=getReductionAxes(r.shape,o);return i.length>0&&(a=a.sum(i)),a.reshape(r.shape)},$exp:function(){var t=e.mul(a.mul(r.log()).toFloat()),i=getReductionAxes(n.shape,o);return i.length>0&&(t=t.sum(i)),t.reshape(n.shape)}}})}function powStrict_(e,t){return assertShapesMatch(e.shape,t.shape,"Error in powStrict: "),e.pow(t)}function mul_(e,t){var r=convertToTensor(e,"a","mul"),n=convertToTensor(t,"b","mul");assertTypesMatch(r,n);var o=assertAndGetBroadcastShape(r.shape,n.shape);return ENV.engine.runKernel(function(e){return e.multiply(r,n)},{$a:r,$b:n},function(e){return{$a:function(){var t=e.mul(n.toFloat()),a=getReductionAxes(r.shape,o);return a.length>0?t.sum(a).reshape(r.shape):t},$b:function(){var t=e.mul(r.toFloat()),a=getReductionAxes(n.shape,o);return a.length>0?t.sum(a).reshape(n.shape):t}}})}function mulStrict_(e,t){return assertShapesMatch(e.shape,t.shape,"Error in multiplyStrict: "),e.mul(t)}function div_(e,t){var r,n=convertToTensor(e,"a","div"),o=convertToTensor(t,"b","div");if(assertTypesMatch(n,o),"int32"===n.dtype&&"int32"===o.dtype)return floorDiv(n,o);r=function(e){return e.realDivide(n,o)};var a=assertAndGetBroadcastShape(n.shape,o.shape);return ENV.engine.runKernel(r,{$a:n,$b:o},function(e){return{$a:function(){var t=e.div(o.toFloat()),r=getReductionAxes(n.shape,a);return r.length>0?t.sum(r).reshape(n.shape):t},$b:function(){var t=e.mul(n.toFloat()),r=getReductionAxes(o.shape,a);r.length>0&&(t=t.sum(r).reshape(o.shape));var i=o.square();return t.div(i.toFloat()).neg()}}})}function floorDiv_(e,t){var r=convertToTensor(e,"a","floorDiv"),n=convertToTensor(t,"b","floorDiv");assertTypesMatch(r,n);var o=assertAndGetBroadcastShape(r.shape,n.shape);return ENV.engine.runKernel(function(e){return e.floorDiv(r,n)},{$a:r,$b:n},function(e){return{$a:function(){var t=e.div(n.toFloat()),a=getReductionAxes(r.shape,o);return a.length>0?t.sum(a).reshape(r.shape):t},$b:function(){var t=e.mul(r.toFloat()),a=getReductionAxes(n.shape,o);a.length>0&&(t=t.sum(a).reshape(n.shape));var i=n.square();return t.div(i.toFloat()).neg()}}})}function divStrict_(e,t){return assertShapesMatch(e.shape,t.shape,"Error in divideStrict: "),e.div(t)}function mod_(e,t){var r=convertToTensor(e,"a","mod"),n=convertToTensor(t,"b","mod");assertTypesMatch(r,n);var o=assertAndGetBroadcastShape(r.shape,n.shape);return ENV.engine.runKernel(function(e){return e.mod(r,n)},{$a:r,$b:n},function(e){return{$a:function(){var t=getReductionAxes(r.shape,o);return t.length>0?e.sum(t).reshape(r.shape):e},$b:function(){var t=e.mul(r.div(n).floor().neg()),a=getReductionAxes(n.shape,o);return a.length>0?t.sum(a).reshape(n.shape):t}}})}function modStrict_(e,t){return assertShapesMatch(e.shape,t.shape,"Error in modStrict: "),e.mod(t)}function minimum_(e,t){var r=convertToTensor(e,"a","minimum"),n=convertToTensor(t,"b","minimum");assertTypesMatch(r,n),"bool"===r.dtype&&(r=r.toInt()),"bool"===n.dtype&&(n=n.toInt()),assertAndGetBroadcastShape(r.shape,n.shape);return ENV.engine.runKernel(function(e){return e.minimum(r,n)},{$a:r,$b:n},function(e){return{$a:function(){return e.mul(r.lessEqual(n).toFloat())},$b:function(){return e.mul(r.greater(n).toFloat())}}})}function minimumStrict_(e,t){return assertShapesMatch(e.shape,t.shape,"Error in minimumStrict: "),e.minimum(t)}function maximum_(e,t){var r=convertToTensor(e,"a","maximum"),n=convertToTensor(t,"b","maximum");assertTypesMatch(r,n),"bool"===r.dtype&&(r=r.toInt()),"bool"===n.dtype&&(n=n.toInt()),assertAndGetBroadcastShape(r.shape,n.shape);return ENV.engine.runKernel(function(e){return e.maximum(r,n)},{$a:r,$b:n},function(e){return{$a:function(){return e.mul(r.greaterEqual(n).toFloat())},$b:function(){return e.mul(r.less(n).toFloat())}}})}function maximumStrict_(e,t){return assertShapesMatch(e.shape,t.shape,"Error in maximumStrict: "),e.maximum(t)}function squaredDifference_(e,t){var r=convertToTensor(e,"a","squaredDifference"),n=convertToTensor(t,"b","squaredDifference");assertTypesMatch(r,n),assertAndGetBroadcastShape(r.shape,n.shape);return ENV.engine.runKernel(function(e){return e.squaredDifference(r,n)},{$a:r,$b:n},function(e){var t=scalar(2);return{$a:function(){return e.mul(r.sub(n).mul(t))},$b:function(){return e.mul(n.sub(r).mul(t))}}})}function squaredDifferenceStrict_(e,t){return assertShapesMatch(e.shape,t.shape,"Error in squaredDifferenceStrict: "),e.squaredDifference(t)}function atan2_(e,t){var r=convertToTensor(e,"a","atan2"),n=convertToTensor(t,"b","atan2");assertTypesMatch(r,n);var o=assertAndGetBroadcastShape(r.shape,n.shape);return ENV.engine.runKernel(function(e){return e.atan2(r,n)},{$a:r,$b:n},function(e){return{$a:function(){var t=add(r.square(),n.square()),a=e.mul(n.div(t)),i=getReductionAxes(r.shape,o);return i.length>0&&(a=a.sum(i)),a.reshape(r.shape)},$b:function(){var t=add(r.square(),n.square()),a=neg(e.mul(r.div(t))),i=getReductionAxes(n.shape,o);return i.length>0&&(a=a.sum(i)),a.reshape(n.shape)}}})}var add=op({add_:add_}),addN=op({addN_:addN_}),addStrict=op({addStrict_:addStrict_}),atan2=op({atan2_:atan2_}),div=op({div_:div_}),divStrict=op({divStrict_:divStrict_}),floorDiv=op({floorDiv_:floorDiv_}),maximum=op({maximum_:maximum_}),maximumStrict=op({maximumStrict_:maximumStrict_}),minimum=op({minimum_:minimum_}),minimumStrict=op({minimumStrict_:minimumStrict_}),mod=op({mod_:mod_}),modStrict=op({modStrict_:modStrict_}),mul=op({mul_:mul_}),mulStrict=op({mulStrict_:mulStrict_}),pow=op({pow_:pow_}),powStrict=op({powStrict_:powStrict_}),squaredDifference=op({squaredDifference_:squaredDifference_}),squaredDifferenceStrict=op({squaredDifferenceStrict_:squaredDifferenceStrict_}),sub=op({sub_:sub_}),subStrict=op({subStrict_:subStrict_});function logicalNot_(e){var t=convertToTensor(e,"x","logicalNot","bool");return assert("bool"===t.dtype,"Error Array must be of type bool."),ENV.engine.runKernel(function(e){return e.logicalNot(t)},{$x:t})}function logicalAnd_(e,t){var r=convertToTensor(e,"a","logicalAnd","bool"),n=convertToTensor(t,"b","logicalAnd","bool");return assert("bool"===r.dtype&&"bool"===n.dtype,"Error Array must be of type bool."),assertAndGetBroadcastShape(r.shape,n.shape),ENV.engine.runKernel(function(e){return e.logicalAnd(r,n)},{$a:r,$b:n})}function logicalOr_(e,t){var r=convertToTensor(e,"a","logicalOr","bool"),n=convertToTensor(t,"b","logicalOr","bool");return assert("bool"===r.dtype&&"bool"===n.dtype,"Error Array must be of type bool."),assertAndGetBroadcastShape(r.shape,n.shape),ENV.engine.runKernel(function(e){return e.logicalOr(r,n)},{$a:r,$b:n})}function logicalXor_(e,t){var r=convertToTensor(e,"a","logicalXor","bool"),n=convertToTensor(t,"b","logicalXor","bool");return assert("bool"===r.dtype&&"bool"===n.dtype,"Error Array must be of type bool."),assertAndGetBroadcastShape(r.shape,n.shape),logicalOr(e,t).logicalAnd(logicalAnd(e,t).logicalNot())}function where_(e,t,r){var n=convertToTensor(t,"a","where"),o=convertToTensor(r,"b","where"),a=convertToTensor(e,"condition","where","bool");assert("bool"===a.dtype,"Error Condition must be of type bool."),assertShapesMatch(n.shape,o.shape,"Error in where: "),1===a.rank?assert(a.shape[0]===n.shape[0],"The first dimension of `a` must match the size of `condition`."):assertShapesMatch(a.shape,o.shape,"Error in where: ");return ENV.engine.runKernel(function(e){return e.select(a,n,o)},{$condition:a,$a:n,$b:o},function(e){return{$condition:function(){return zerosLike(a)},$a:function(){return e.mul(a.cast(n.dtype))},$b:function(){return e.mul(a.logicalNot().cast(o.dtype))}}})}function whereAsync_(e){return __awaiter(this,void 0,void 0,function(){var t,r,n;return __generator(this,function(o){switch(o.label){case 0:return assert("bool"===(t=convertToTensor(e,"condition","where","bool")).dtype,"Condition must be of type bool."),[4,t.data()];case 1:return r=o.sent(),n=whereImpl(t.shape,r),e!==t&&t.dispose(),[2,n]}})})}var logicalAnd=op({logicalAnd_:logicalAnd_}),logicalNot=op({logicalNot_:logicalNot_}),logicalOr=op({logicalOr_:logicalOr_}),logicalXor=op({logicalXor_:logicalXor_}),where=op({where_:where_}),whereAsync=whereAsync_;function relu_(e){var t=convertToTensor(e,"x","relu");if("bool"===t.dtype)return t.toInt();return ENV.engine.runKernel(function(e){return e.relu(t)},{$x:t},function(e){var r=t.step();return{$x:function(){return e.mulStrict(r.toFloat())}}})}function elu_(e){var t=convertToTensor(e,"x","elu");return ENV.engine.runKernel(function(e,r){return r(e.elu(t))},{$x:t},function(e,t){var r=t[0];return{$x:function(){return ENV.engine.runKernel(function(t){return t.eluDer(e,r)},{dy:e,y:r})}}})}function selu_(e){var t=convertToTensor(e,"x","selu");return ENV.engine.runKernel(function(e){return e.selu(t)},{$x:t},function(e){return{$x:function(){var r=t.greater(scalar(0)),n=scalar(SELU_SCALEALPHA),o=scalar(SELU_SCALE),a=e.mul(o),i=e.mul(n).mul(t.toFloat().exp());return where(r,a,i)}}})}function leakyRelu_(e,t){void 0===t&&(t=.2);var r=convertToTensor(e,"x","leakyRelu");return maximum(scalar(t).mul(r),r)}function prelu_(e,t){var r=convertToTensor(e,"x","prelu"),n=convertToTensor(t,"alpha","prelu"),o=scalar(0);return maximum(o,r).add(n.mul(minimum(o,r)))}var elu=op({elu_:elu_}),leakyRelu=op({leakyRelu_:leakyRelu_}),prelu=op({prelu_:prelu_}),relu=op({relu_:relu_}),selu=op({selu_:selu_});function transpose_(e,t){var r=convertToTensor(e,"x","transpose");if(null==t&&(t=r.shape.map(function(e,t){return t}).reverse()),assert(r.rank===t.length,"Error in transpose: rank of input "+r.rank+" must match length of perm "+t+"."),t.forEach(function(e){assert(e>=0&&e<r.rank,"All entries in 'perm' must be between 0 and "+(r.rank-1)+" but got "+t)}),r.rank<=1)return r.clone();return ENV.engine.runKernel(function(e){return e.transpose(r,t)},{$x:r},function(e){var r=getUndoAxesPermutation(t);return{$x:function(){return e.transpose(r)}}})}var transpose=op({transpose_:transpose_});function localResponseNormalization_(e,t,r,n,o){void 0===t&&(t=5),void 0===r&&(r=1),void 0===n&&(n=1),void 0===o&&(o=.5);var a=convertToTensor(e,"x","localResponseNormalization");assert(4===a.rank||3===a.rank,"Error in localResponseNormalization: x must be rank 3 or 4 but got\n               rank "+a.rank+"."),assert(isInt(t),"Error in localResponseNormalization: depthRadius must be an integer\n                     but got depthRadius "+t+".");var i=a,s=!1;3===a.rank&&(s=!0,i=a.as4D(1,a.shape[0],a.shape[1],a.shape[2]));var u=ENV.engine.runKernel(function(e,a){return a(e.localResponseNormalization4D(i,t,r,n,o))},{x4D:i},function(e,a){var s=a[0];return{x4D:function(){return ENV.engine.runKernel(function(a){return a.LRNGrad(e,i,s,t,r,n,o)},{})}}});return s?u.as3D(u.shape[1],u.shape[2],u.shape[3]):u}var localResponseNormalization=op({localResponseNormalization_:localResponseNormalization_});function norm_(e,t,r,n){void 0===t&&(t="euclidean"),void 0===r&&(r=null),void 0===n&&(n=!1);var o=normImpl(e=convertToTensor(e,"x","norm"),t,r),a=o.shape;if(n){var i=parseAxisParam(r,e.shape);a=expandShapeToKeepDim(o.shape,i)}return o.reshape(a)}function normImpl(e,t,r){if(void 0===r&&(r=null),0===e.rank)return e.abs();if(1!==e.rank&&null===r)return normImpl(e.reshape([-1]),t,r);if(1===e.rank||"number"==typeof r||r instanceof Array&&1===r.length){if(1===t)return e.abs().sum(r);if(t===1/0)return e.abs().max(r);if(t===-1/0)return e.abs().min(r);if("euclidean"===t||2===t)return e.abs().pow(scalar(2,"int32")).sum(r).sqrt();throw new Error("Error in norm: invalid ord value: "+t)}if(r instanceof Array&&2===r.length){if(1===t)return e.abs().sum(r[0]).max(r[1]-1);if(t===1/0)return e.abs().sum(r[1]).max(r[0]);if(t===-1/0)return e.abs().sum(r[1]).min(r[0]);if("fro"===t||"euclidean"===t)return e.square().sum(r).sqrt();throw new Error("Error in norm: invalid ord value: "+t)}throw new Error("Error in norm: invalid axis: "+r)}var norm=op({norm_:norm_});function unsortedSegmentSum_(e,t,r){var n=convertToTensor(e,"x","unsortedSegmentSum"),o=convertToTensor(t,"segmentIds","unsortedSegmentSum","int32");assert("int32"===o.dtype,"segmentIds must be of dtype `int32`"),assert(isInt(r),"numSegments must be of dtype int");return ENV.engine.runKernel(function(e){return e.unsortedSegmentSum(n,o,r)},{$x:n},function(e){return{$x:function(){return gatherDropNegatives(e,o)}}})}function gather_(e,t,r){void 0===r&&(r=0);var n=convertToTensor(e,"x","gather"),o=convertToTensor(t,"indices","gather","int32");assert("int32"===o.dtype,"Indices must be of dtype `int32`"),r=parseAxisParam(r,n.shape)[0];return ENV.engine.runKernel(function(e){return e.gather(n,o,r)},{$x:n},function(e){return{$x:function(){if(0===r)return unsortedSegmentSum(e,o,n.shape[r]);var t=n.shape,a=o.size,i=t.slice(0,r),s=i.length,u=t.slice(r,t.length).slice(1),l=u.length,c=arrayRange(0,s),p=arrayRange(s+1,s+1+l),d=arrayConcat([i,[a],u]),h=e.reshape(d),f=o.reshape([a]),m=arrayConcat([[s],c,p]),g=h.transpose(m),v=unsortedSegmentSum(g,f,n.shape[r]),y=getUndoAxesPermutation(m);return v=v.transpose(y)}}})}function arrayRange(e,t){for(var r=[],n=e;n<t;++n)r.push(n);return r}function arrayConcat(e){for(var t=[],r=0;r<e.length;++r)for(var n=0;n<e[r].length;++n)t.push(e[r][n]);return t}function gatherDropNegatives(e,t){for(var r=maximum(t,zerosLike(t)),n=gather(e,r),o=greaterEqual(t,scalar(0,"int32")),a=n.rank-o.rank,i=0;i<a;++i)o=expandDims(o,i+1);o=logicalAnd(o,ones$1(n.shape,"bool"));var s=zerosLike(n);return where(o,n,s)}var gather=op({gather_:gather_}),unsortedSegmentSum=op({unsortedSegmentSum_:unsortedSegmentSum_});function multiRNNCell_(e,t,r,n){for(var o=convertToTensor(t,"data","multiRNNCell"),a=convertToTensorArray(r,"c","multiRNNCell"),i=convertToTensorArray(n,"h","multiRNNCell"),s=o,u=[],l=0;l<e.length;l++){var c=e[l](s,a[l],i[l]);u.push(c[0]),u.push(c[1]),s=c[1]}var p=[],d=[];for(l=0;l<u.length;l+=2)p.push(u[l]),d.push(u[l+1]);return[p,d]}function basicLSTMCell_(e,t,r,n,o,a){var i=convertToTensor(e,"forgetBias","basicLSTMCell"),s=convertToTensor(t,"lstmKernel","basicLSTMCell"),u=convertToTensor(r,"lstmBias","basicLSTMCell"),l=convertToTensor(n,"data","basicLSTMCell"),c=convertToTensor(o,"c","basicLSTMCell"),p=convertToTensor(a,"h","basicLSTMCell"),d=l.concat(p,1).matMul(s).add(u),h=d.shape[0],f=d.shape[1]/4,m=[h,f],g=d.slice([0,0],m),v=d.slice([0,f],m),y=d.slice([0,2*f],m),x=d.slice([0,3*f],m),T=g.sigmoid().mulStrict(v.tanh()).addStrict(c.mulStrict(i.add(y).sigmoid()));return[T,T.tanh().mulStrict(x.sigmoid())]}var basicLSTMCell=op({basicLSTMCell_:basicLSTMCell_}),multiRNNCell=op({multiRNNCell_:multiRNNCell_});function movingAverage_(e,t,r,n,o){void 0===o&&(o=!0);var a=convertToTensor(e,"v","movingAverage"),i=convertToTensor(t,"x","movingAverage"),s=convertToTensor(r,"decay","movingAverage");assertTypesMatch(a,i),assert(arraysEqual(a.shape,i.shape),"Shape mismatch in v and x");var u=scalar(1),l=u.sub(s),c=i.sub(a).mul(l);if(o){assert(null!=n,"When using zeroDebias: true, step is required.");var p=convertToTensor(n,"step","movingAverage");c=c.div(u.sub(pow(s,p)))}return a.add(c)}var movingAverage=op({movingAverage_:movingAverage_});function stridedSlice_(e,t,r,n,o,a,i,s,u){if(void 0===o&&(o=0),void 0===a&&(a=0),void 0===i&&(i=0),void 0===s&&(s=0),void 0===u&&(u=0),0!==i)throw new Error("ellipsis mask is not yet supported");if(0!==s)throw new Error("new axis mask is not yet supported");var l=convertToTensor(e,"x","stridedSlice");return ENV.engine.runKernel(function(e){return e.stridedSlice(l,t,r,n,o,a,i,s,u)},{$x:l})}var stridedSlice=op({stridedSlice_:stridedSlice_});function topk_(e,t,r){void 0===t&&(t=1),void 0===r&&(r=!0);var n=convertToTensor(e,"x","topk");if(0===n.rank)throw new Error("topk() expects the input to be of rank 1 or higher");var o=n.shape[n.shape.length-1];if(t>o)throw new Error("'k' passed to topk() must be <= the last dimension ("+o+") but got "+t);var a=ENV.engine.runKernel(function(e){return e.topk(n,t,r)},{$x:n});return{values:a[0],indices:a[1]}}var topk=op({topk_:topk_});function scatterND_(e,t,r){var n=convertToTensor(e,"indices","scatterND","int32"),o=convertToTensor(t,"updates","scatterND");return validateInput(o,n,r),ENV.engine.runKernel(function(e){return e.scatterND(n,o,r)},{$indices:n,$updates:o})}var scatterND=op({scatterND_:scatterND_});function fft_(e){assert("complex64"===e.dtype,"The dtype for tf.spectral.fft() must be complex64 but got "+e.dtype+".");var t=e.shape[e.shape.length-1],r=e.size/t,n=e.as2D(r,t);return ENV.engine.runKernel(function(e){return e.fft(n)},{input:e}).reshape(e.shape)}function ifft_(e){assert("complex64"===e.dtype,"The dtype for tf.spectral.ifft() must be complex64 but got "+e.dtype+".");var t=e.shape[e.shape.length-1],r=e.size/t,n=e.as2D(r,t);return ENV.engine.runKernel(function(e){return e.ifft(n)},{input:e}).reshape(e.shape)}function rfft_(e){assert("float32"===e.dtype,"The dtype for rfft() must be real value but\n    got "+e.dtype);var t=e.shape[e.shape.length-1],r=e.size/t,n=e.zerosLike(),o=complex(e,n).as2D(r,t),a=ENV.engine.runKernel(function(e){return e.fft(o)},{complexInput:o}),i=Math.floor(t/2)+1,s=real(a),u=imag(a),l=s.split([i,t-i],s.shape.length-1),c=u.split([i,t-i],u.shape.length-1),p=e.shape.slice();return p[e.shape.length-1]=i,complex(l[0],c[0]).reshape(p)}var fft=op({fft_:fft_}),ifft=op({ifft_:ifft_}),rfft=op({rfft_:rfft_}),spectral_ops=Object.freeze({fft:fft,ifft:ifft,rfft:rfft});function validateInput$1(e,t,r,n){if("int32"!==e.dtype)throw new Error("tf.sparseToDense() expects the indices to be int32 type, but the dtype was "+e.dtype+".");if(e.rank>2)throw new Error("sparseIndices should be a scalar, vector, or matrix, but got shape "+e.shape+".");var o=e.rank>0?e.shape[0]:1,a=e.rank>1?e.shape[1]:1;if(r.length!==a)throw new Error("outputShape has incorrect number of elements:, "+r.length+", should be: "+a+".");var i=t.size;if(0!==t.rank&&(1!==t.rank||i!==o))throw new Error("sparseValues has incorrect shape "+t.shape+", should be [] or ["+o+"]");if(t.dtype!==n.dtype)throw new Error("sparseValues.dtype must match defaultValues.dtype")}function sparseToDense_(e,t,r,n){var o=convertToTensor(e,"sparseIndices","sparseToDense","int32"),a=convertToTensor(t,"sparseValues","sparseToDense"),i=convertToTensor(n,"defaultValue","sparseToDense",a.dtype);return validateInput$1(o,a,r,i),ENV.engine.runKernel(function(e){return e.sparseToDense(o,a,r,i)},{$sparseIndices:o,$sparseValues:a,$defaultValue:i})}var sparseToDense=op({sparseToDense_:sparseToDense_});function gatherND_(e,t){var r=convertToTensor(t,"indices","gatherND","int32"),n=convertToTensor(e,"x","gatherND");return ENV.engine.runKernel(function(e){return e.gatherND(n,r)},{$x:n,$indices:r})}var Reduction,gatherND=op({gatherND_:gatherND_});function computeWeightedLoss_(e,t,r){void 0===r&&(r=Reduction.SUM_BY_NONZERO_WEIGHTS);var n=convertToTensor(e,"losses","computeWeightedLoss"),o=null;null!=t&&(o=convertToTensor(t,"weights","computeWeightedLoss"));var a=null==o?n:n.mul(o);if(r===Reduction.NONE)return a;if(r===Reduction.SUM)return a.sum();if(r===Reduction.MEAN){if(null==o)return a.mean();var i=sizeFromShape(n.shape)/sizeFromShape(o.shape),s=a.sum().div(o.sum());return i>1?s.div(scalar(i)):s}if(r===Reduction.SUM_BY_NONZERO_WEIGHTS){if(null==o)return a.sum().div(scalar(n.size));var u=o.mul(ones$1(n.shape)).notEqual(scalar(0)).sum().toFloat();return a.sum().div(u)}throw Error("Unknown reduction: "+r)}function absoluteDifference_(e,t,r,n){void 0===n&&(n=Reduction.SUM_BY_NONZERO_WEIGHTS);var o=convertToTensor(e,"labels","absoluteDifference"),a=convertToTensor(t,"predictions","absoluteDifference"),i=null;null!=r&&(i=convertToTensor(r,"weights","absoluteDifference")),assertShapesMatch(o.shape,a.shape,"Error in absoluteDifference: ");var s=o.sub(a).abs();return computeWeightedLoss(s,i,n)}function meanSquaredError_(e,t,r,n){void 0===n&&(n=Reduction.SUM_BY_NONZERO_WEIGHTS);var o=convertToTensor(e,"labels","meanSquaredError"),a=convertToTensor(t,"predictions","meanSquaredError"),i=null;null!=r&&(i=convertToTensor(r,"weights","meanSquaredError")),assertShapesMatch(o.shape,a.shape,"Error in meanSquaredError: ");var s=o.squaredDifference(a);return computeWeightedLoss(s,i,n)}function cosineDistance_(e,t,r,n,o){void 0===o&&(o=Reduction.SUM_BY_NONZERO_WEIGHTS);var a=convertToTensor(e,"labels","cosineDistance"),i=convertToTensor(t,"predictions","cosineDistance"),s=null;null!=n&&(s=convertToTensor(n,"weights","cosineDistance")),assertShapesMatch(a.shape,i.shape,"Error in cosineDistance: ");var u=scalar(1).sub(a.mul(i).sum(r,!0));return computeWeightedLoss(u,s,o)}function hingeLoss_(e,t,r,n){void 0===n&&(n=Reduction.SUM_BY_NONZERO_WEIGHTS);var o=convertToTensor(e,"labels","hingeLoss"),a=convertToTensor(t,"predictions","hingeLoss"),i=null;null!=r&&(i=convertToTensor(r,"weights","hingeLoss")),assertShapesMatch(o.shape,a.shape,"Error in hingeLoss: ");var s=scalar(1);o=scalar(2).mul(o).sub(s);var u=s.sub(o.mul(a)).relu();return computeWeightedLoss(u,i,n)}function logLoss_(e,t,r,n,o){void 0===n&&(n=1e-7),void 0===o&&(o=Reduction.SUM_BY_NONZERO_WEIGHTS);var a=convertToTensor(e,"labels","logLoss"),i=convertToTensor(t,"predictions","logLoss"),s=null;null!=r&&(s=convertToTensor(r,"weights","logLoss")),assertShapesMatch(a.shape,i.shape,"Error in logLoss: ");var u=scalar(1),l=scalar(n),c=a.mul(i.add(l).log()).neg().sub(u.sub(a).mul(u.sub(i).add(l).log()));return computeWeightedLoss(c,s,o)}function sigmoidCrossEntropyWithLogits_(e,t){var r=convertToTensor(e,"labels","sigmoidCrossEntropyWithLogits"),n=convertToTensor(t,"logits","sigmoidCrossEntropyWithLogits");assertShapesMatch(r.shape,n.shape,"Error in sigmoidCrossEntropyWithLogits: ");var o=n.relu(),a=n.mul(r),i=n.abs().neg().exp().log1p();return o.sub(a).add(i)}function sigmoidCrossEntropy_(e,t,r,n,o){void 0===n&&(n=0),void 0===o&&(o=Reduction.SUM_BY_NONZERO_WEIGHTS);var a=convertToTensor(e,"multiClassLabels","sigmoidCrossEntropy"),i=convertToTensor(t,"logits","sigmoidCrossEntropy"),s=null;if(null!=r&&(s=convertToTensor(r,"weights","sigmoidCrossEntropy")),assertShapesMatch(a.shape,i.shape,"Error in sigmoidCrossEntropy: "),n>0){var u=scalar(n),l=scalar(1),c=scalar(.5);a=a.mul(l.sub(u)).add(c.mul(u))}var p=sigmoidCrossEntropyWithLogits_(a,i);return computeWeightedLoss(p,s,o)}function huberLoss_(e,t,r,n,o){void 0===n&&(n=1),void 0===o&&(o=Reduction.SUM_BY_NONZERO_WEIGHTS);var a=convertToTensor(e,"labels","huberLoss"),i=convertToTensor(t,"predictions","huberLoss"),s=null;null!=r&&(s=convertToTensor(r,"weights","huberLoss")),assertShapesMatch(a.shape,i.shape,"Error in huberLoss: ");var u=scalar(n),l=i.sub(a).abs(),c=minimum(l,u),p=l.sub(c),d=scalar(.5).mul(c.square()).add(u.mul(p));return computeWeightedLoss(d,s,o)}function softmaxCrossEntropyWithLogits_(e,t,r){if(void 0===r&&(r=-1),-1===r&&(r=t.rank-1),r!==t.rank-1)throw Error("Softmax cross entropy along a non-last dimension is not yet supported. Labels / logits was rank "+t.rank+" and dim was "+r);return customGrad(function(e,t){var n=t.logSumExp([r],!0),o=t.toFloat().sub(n);return{value:o.mul(e).neg().sum([r]),gradFunc:function(t){var n=expandShapeToKeepDim(t.shape,[r]);return[t.reshape(n).mul(e.toFloat().sub(o.exp())),t.reshape(n).mul(o.exp().sub(e.toFloat()))]}}})(e,t)}function softmaxCrossEntropy_(e,t,r,n,o){void 0===n&&(n=0),void 0===o&&(o=Reduction.SUM_BY_NONZERO_WEIGHTS);var a=convertToTensor(e,"onehotLabels","softmaxCrossEntropy"),i=convertToTensor(t,"logits","softmaxCrossEntropy"),s=null;if(null!=r&&(s=convertToTensor(r,"weights","softmaxCrossEntropy")),assertShapesMatch(a.shape,i.shape,"Error in softmaxCrossEntropy: "),n>0){var u=scalar(n),l=scalar(1),c=scalar(a.shape[1]);a=a.mul(l.sub(u)).add(u.div(c))}var p=softmaxCrossEntropyWithLogits_(a,i);return computeWeightedLoss(p,s,o)}!function(e){e[e.NONE=0]="NONE",e[e.MEAN=1]="MEAN",e[e.SUM=2]="SUM",e[e.SUM_BY_NONZERO_WEIGHTS=3]="SUM_BY_NONZERO_WEIGHTS"}(Reduction||(Reduction={}));var absoluteDifference=op({absoluteDifference_:absoluteDifference_}),computeWeightedLoss=op({computeWeightedLoss_:computeWeightedLoss_}),cosineDistance=op({cosineDistance_:cosineDistance_}),hingeLoss=op({hingeLoss_:hingeLoss_}),huberLoss=op({huberLoss_:huberLoss_}),logLoss=op({logLoss_:logLoss_}),meanSquaredError=op({meanSquaredError_:meanSquaredError_}),sigmoidCrossEntropy=op({sigmoidCrossEntropy_:sigmoidCrossEntropy_}),softmaxCrossEntropy=op({softmaxCrossEntropy_:softmaxCrossEntropy_}),loss_ops=Object.freeze({get Reduction(){return Reduction},absoluteDifference:absoluteDifference,computeWeightedLoss:computeWeightedLoss,cosineDistance:cosineDistance,hingeLoss:hingeLoss,huberLoss:huberLoss,logLoss:logLoss,meanSquaredError:meanSquaredError,sigmoidCrossEntropy:sigmoidCrossEntropy,softmaxCrossEntropy:softmaxCrossEntropy});function gramSchmidt_(e){var t;if(Array.isArray(e)){t=!1,assert(null!=e&&e.length>0,"Gram-Schmidt process: input must not be null, undefined, or empty");for(var r=e[0].shape[0],n=1;n<e.length;++n)assert(e[n].shape[0]===r,"Gram-Schmidt: Non-unique lengths found in the input vectors: ("+e[n].shape[0]+" vs. "+r+")")}else t=!0,e=split$1(e,e.shape[0],0).map(function(e){return squeeze(e,[0])});assert(e.length<=e[0].shape[0],"Gram-Schmidt: Number of vectors ("+e.length+") exceeds number of dimensions ("+e[0].shape[0]+").");var o=[],a=e,i=function(e){o.push(ENV.engine.tidy(function(){var t=a[e];if(e>0)for(var r=0;r<e;++r){var n=sum$1(o[r].mulStrict(t)).mul(o[r]);t=t.sub(n)}return t.div(norm(t,"euclidean"))}))};for(n=0;n<e.length;++n)i(n);return t?stack(o,0):o}function qr_(e,t){if(void 0===t&&(t=!1),e.rank<2)throw new Error("qr() requires input tensor to have a rank >= 2, but got rank "+e.rank);if(2===e.rank)return qr2d(e,t);var r=e.shape.slice(0,e.shape.length-2).reduce(function(e,t){return e*t}),n=[],o=[];return unstack(e.reshape([r,e.shape[e.shape.length-2],e.shape[e.shape.length-1]]),0).forEach(function(e){var r=qr2d(e,t),a=r[0],i=r[1];n.push(a),o.push(i)}),[stack(n,0).reshape(e.shape),stack(o,0).reshape(e.shape)]}function qr2d(e,t){return void 0===t&&(t=!1),ENV.engine.tidy(function(){if(2!==e.shape.length)throw new Error("qr2d() requires a 2D Tensor, but got a "+e.shape.length+"D Tensor.");for(var r=e.shape[0],n=e.shape[1],o=eye(r),a=e.clone(),i=tensor2d([[1]],[1,1]),s=i.clone(),u=r>=n?n:r,l=function(e){var t,u=a,l=s,c=o;t=ENV.engine.tidy(function(){var t=a.slice([e,e],[r-e,1]),u=t.norm(),l=a.slice([e,e],[1,1]),c=l.sign().neg(),p=l.sub(c.mul(u)),d=t.div(p);s=1===d.shape[0]?i.clone():i.concat(d.slice([1,0],[d.shape[0]-1,d.shape[1]]),0);var h=c.matMul(p).div(u).neg(),f=a.slice([e,0],[r-e,n]),m=h.mul(s);a=0===e?f.sub(m.matMul(s.transpose().matMul(f))):a.slice([0,0],[e,n]).concat(f.sub(m.matMul(s.transpose().matMul(f))),0);var g=o.slice([0,e],[r,o.shape[1]-e]);return o=0===e?g.sub(g.matMul(s).matMul(m.transpose())):o.slice([0,0],[r,e]).concat(g.sub(g.matMul(s).matMul(m.transpose())),1),[s,a,o]}),s=t[0],a=t[1],o=t[2],dispose([u,l,c])},c=0;c<u;++c)l(c);return!t&&r>n&&(o=o.slice([0,0],[r,n]),a=a.slice([0,0],[n,n])),[o,a]})}var gramSchmidt=op({gramSchmidt_:gramSchmidt_}),qr=op({qr_:qr_}),linalg_ops=Object.freeze({gramSchmidt:gramSchmidt,qr:qr});function resizeBilinear_(e,t,r){void 0===r&&(r=!1);var n=convertToTensor(e,"images","resizeBilinear");assert(3===n.rank||4===n.rank,"Error in resizeBilinear: x must be rank 3 or 4, but got rank "+n.rank+"."),assert(2===t.length,"Error in resizeBilinear: new shape must 2D, but got shape "+t+".");var o=n,a=!1;3===n.rank&&(a=!0,o=n.as4D(1,n.shape[0],n.shape[1],n.shape[2]));var i=t[0],s=t[1],u=ENV.engine.runKernel(function(e,t){return e.resizeBilinear(o,i,s,r)},{batchImages:o},function(e,t){return{batchImages:function(){return ENV.engine.runKernel(function(t){return t.resizeBilinearBackprop(e,o,r)},{})}}});return a?u.as3D(u.shape[1],u.shape[2],u.shape[3]):u}function resizeNearestNeighbor_(e,t,r){void 0===r&&(r=!1);var n=convertToTensor(e,"images","resizeNearestNeighbor");assert(3===n.rank||4===n.rank,"Error in resizeNearestNeighbor: x must be rank 3 or 4, but got rank "+n.rank+"."),assert(2===t.length,"Error in resizeNearestNeighbor: new shape must 2D, but got shape "+t+"."),assert("float32"===n.dtype||"int32"===n.dtype,"`images` must have `int32` or `float32` as dtype");var o=n,a=!1;3===n.rank&&(a=!0,o=n.as4D(1,n.shape[0],n.shape[1],n.shape[2]));var i=t[0],s=t[1],u=ENV.engine.runKernel(function(e,t){return e.resizeNearestNeighbor(o,i,s,r)},{batchImages:o},function(e,t){return{batchImages:function(){return ENV.engine.runKernel(function(t){return t.resizeNearestNeighborBackprop(e,o,r)},{})}}});return a?u.as3D(u.shape[1],u.shape[2],u.shape[3]):u}function nonMaxSuppression_(e,t,r,n,o){void 0===n&&(n=.5),void 0===o&&(o=Number.NEGATIVE_INFINITY);var a=convertToTensor(e,"boxes","nonMaxSuppression"),i=convertToTensor(t,"scores","nonMaxSuppression"),s=nonMaxSuppSanityCheck(a,i,r,n,o);return r=s.maxOutputSize,n=s.iouThreshold,o=s.scoreThreshold,ENV.engine.runKernel(function(e){return e.nonMaxSuppression(a,i,r,n,o)},{$boxes:a})}function nonMaxSuppressionAsync_(e,t,r,n,o){return void 0===n&&(n=.5),void 0===o&&(o=Number.NEGATIVE_INFINITY),__awaiter(this,void 0,void 0,function(){var a,i,s,u,l,c;return __generator(this,function(p){switch(p.label){case 0:return a=convertToTensor(e,"boxes","nonMaxSuppressionAsync"),i=convertToTensor(t,"scores","nonMaxSuppressionAsync"),s=nonMaxSuppSanityCheck(a,i,r,n,o),r=s.maxOutputSize,n=s.iouThreshold,o=s.scoreThreshold,[4,a.data()];case 1:return u=p.sent(),[4,i.data()];case 2:return l=p.sent(),c=nonMaxSuppressionImpl(u,l,r,n,o),a!==e&&a.dispose(),i!==t&&i.dispose(),[2,c]}})})}function nonMaxSuppSanityCheck(e,t,r,n,o){null==n&&(n=.5),null==o&&(o=Number.NEGATIVE_INFINITY);var a=e.shape[0];return r=Math.min(r,a),assert(0<=n&&n<=1,"iouThreshold must be in [0, 1], but was '"+n+"'"),assert(2===e.rank,"boxes must be a 2D tensor, but was of rank '"+e.rank+"'"),assert(4===e.shape[1],"boxes must have 4 columns, but 2nd dimension was "+e.shape[1]),assert(1===t.rank,"scores must be a 1D tensor"),assert(t.shape[0]===a,"scores has incompatible shape with boxes. Expected "+a+", but was "+t.shape[0]),{maxOutputSize:r,iouThreshold:n,scoreThreshold:o}}function cropAndResize_(e,t,r,n,o,a){var i=convertToTensor(e,"image","cropAndResize","float32"),s=convertToTensor(t,"boxes","cropAndResize","float32"),u=convertToTensor(r,"boxInd","cropAndResize","int32");o=o||"bilinear",a=a||0;var l=s.shape[0];assert(4===i.rank,"Error in cropAndResize: image must be rank 4,but got rank "+i.rank+"."),assert(2===s.rank&&4===s.shape[1],"Error in cropAndResize: boxes must be have size ["+l+",4] but had shape "+s.shape+"."),assert(1===u.rank&&u.shape[0]===l,"Error in cropAndResize: boxInd must be have size ["+l+"] but had shape "+s.shape+"."),assert("int32"===u.dtype,"Error in cropAndResize: boxInd must be of dtype int32, but got dtype "+u.dtype+"."),assert(2===n.length,"Error in cropAndResize: cropSize must be of length 2, but got length "+n.length+"."),assert(n[0]>=1&&n[1]>=1,"cropSize must be atleast [1,1], but was "+n),assert("bilinear"===o||"nearest"===o,"method must be bilinear or nearest, but was "+o);return ENV.engine.runKernel(function(e,t){return e.cropAndResize(i,s,u,n,o,a)},{$image:i,$boxes:s})}var resizeBilinear=op({resizeBilinear_:resizeBilinear_}),resizeNearestNeighbor=op({resizeNearestNeighbor_:resizeNearestNeighbor_}),nonMaxSuppression=op({nonMaxSuppression_:nonMaxSuppression_}),nonMaxSuppressionAsync=nonMaxSuppressionAsync_,cropAndResize=cropAndResize_,image_ops=Object.freeze({resizeBilinear:resizeBilinear,resizeNearestNeighbor:resizeNearestNeighbor,nonMaxSuppression:nonMaxSuppression,nonMaxSuppressionAsync:nonMaxSuppressionAsync,cropAndResize:cropAndResize}),ops=Object.freeze({image:image_ops,linalg:linalg_ops,losses:loss_ops,spectral:spectral_ops,op:op,batchNormalization2d:batchNormalization2d,batchNormalization3d:batchNormalization3d,batchNormalization4d:batchNormalization4d,batchNormalization:batchNormalization,complex:complex,real:real,imag:imag,concat:concat,concat1d:concat1d,concat2d:concat2d,concat3d:concat3d,concat4d:concat4d,split:split$1,conv1d:conv1d,conv2d:conv2d,conv2dDerFilter:conv2dDerFilter,depthwiseConv2d:depthwiseConv2d,separableConv2d:separableConv2d,conv2dTranspose:conv2dTranspose,matMul:matMul,dot:dot,outerProduct:outerProduct,reverse:reverse,reverse1d:reverse1d,reverse2d:reverse2d,reverse3d:reverse3d,reverse4d:reverse4d,maxPool:maxPool,avgPool:avgPool,pool:pool,slice:slice,slice1d:slice1d,slice2d:slice2d,slice3d:slice3d,slice4d:slice4d,abs:abs,acos:acos,acosh:acosh,asin:asin,asinh:asinh,atan:atan,atanh:atanh,ceil:ceil,clipByValue:clipByValue,cos:cos,cosh:cosh,erf:erf,exp:exp,expm1:expm1,floor:floor,log:log$1,log1p:log1p,logSigmoid:logSigmoid,neg:neg,reciprocal:reciprocal,round:round,rsqrt:rsqrt,sigmoid:sigmoid,sign:sign,sin:sin,sinh:sinh,softplus:softplus,sqrt:sqrt,square:square,step:step,tan:tan,tanh:tanh$1,all:all,any:any,argMax:argMax,argMin:argMin,logSumExp:logSumExp,max:max,mean:mean,min:min,moments:moments,sum:sum$1,prod:prod,equal:equal,equalStrict:equalStrict,greater:greater,greaterEqual:greaterEqual,greaterEqualStrict:greaterEqualStrict,greaterStrict:greaterStrict,less:less,lessEqual:lessEqual,lessEqualStrict:lessEqualStrict,lessStrict:lessStrict,notEqual:notEqual,notEqualStrict:notEqualStrict,add:add,addN:addN,addStrict:addStrict,atan2:atan2,div:div,divStrict:divStrict,floorDiv:floorDiv,maximum:maximum,maximumStrict:maximumStrict,minimum:minimum,minimumStrict:minimumStrict,mod:mod,modStrict:modStrict,mul:mul,mulStrict:mulStrict,pow:pow,powStrict:powStrict,squaredDifference:squaredDifference,squaredDifferenceStrict:squaredDifferenceStrict,sub:sub,subStrict:subStrict,elu:elu,leakyRelu:leakyRelu,prelu:prelu,relu:relu,selu:selu,logicalAnd:logicalAnd,logicalNot:logicalNot,logicalOr:logicalOr,logicalXor:logicalXor,where:where,whereAsync:whereAsync,buffer:buffer,toPixels:toPixels,print:print,batchToSpaceND:batchToSpaceND,cast:cast,clone:clone,cumsum:cumsum,depthToSpace:depthToSpace,expandDims:expandDims,eye:eye,fromPixels:fromPixels,multinomial:multinomial,oneHot:oneHot,pad:pad,pad1d:pad1d,pad2d:pad2d,pad3d:pad3d,pad4d:pad4d,rand:rand,randomNormal:randomNormal,randomUniform:randomUniform,reshape:reshape,spaceToBatchND:spaceToBatchND,squeeze:squeeze,stack:stack,tile:tile,truncatedNormal:truncatedNormal,unstack:unstack,setdiff1dAsync:setdiff1dAsync,fill:fill,linspace:linspace,ones:ones$1,range:range,scalar:scalar,tensor:tensor,tensor1d:tensor1d,tensor2d:tensor2d,tensor3d:tensor3d,tensor4d:tensor4d,tensor5d:tensor5d,tensor6d:tensor6d,zeros:zeros,onesLike:onesLike,zerosLike:zerosLike,transpose:transpose,softmax:softmax,logSoftmax:logSoftmax,localResponseNormalization:localResponseNormalization,norm:norm,gather:gather,unsortedSegmentSum:unsortedSegmentSum,basicLSTMCell:basicLSTMCell,multiRNNCell:multiRNNCell,movingAverage:movingAverage,stridedSlice:stridedSlice,topk:topk,scatterND:scatterND,fft:fft,ifft:ifft,rfft:rfft,sparseToDense:sparseToDense,gatherND:gatherND}),MathBackendCPU=function(){function e(){this.blockSize=48,this.firstUse=!0,ENV.get("IS_BROWSER")&&(this.fromPixels2DContext=document.createElement("canvas").getContext("2d"))}return e.prototype.setDataMover=function(e){this.data=new DataStorage(e)},e.prototype.register=function(e,t,r){if(this.firstUse&&(this.firstUse=!1,ENV.get("IS_NODE")&&warn("\n============================\nHi there 👋. Looks like you are running TensorFlow.js in Node.js. To speed things up dramatically, install our node backend, which binds to TensorFlow C++, by running npm i @tensorflow/tfjs-node, or npm i @tensorflow/tfjs-node-gpu if you have CUDA. Then call require('@tensorflow/tfjs-node'); (-gpu suffix for CUDA) at the start of your program. Visit https://github.com/tensorflow/tfjs-node for more details.\n============================\n")),this.data.has(e))throw new Error("Data buffer is already registered");this.data.set(e,{dtype:r})},e.prototype.write=function(e,t){if(null==t)throw new Error("MathBackendCPU.write(): values can not be null");this.data.get(e).values=t},e.prototype.fromPixels=function(e,t){if(null==e)throw new Error("pixels passed to tf.fromPixels() can not be null");var r,n;if(ENV.get("IS_NODE")&&null==e.getContext)throw new Error("When running in node, pixels must be an HTMLCanvasElement like the one returned by the `canvas` npm package");if(null!=e.getContext)r=e.getContext("2d").getImageData(0,0,e.width,e.height).data;else if(e instanceof ImageData)r=e.data;else{if(!(e instanceof HTMLImageElement||e instanceof HTMLVideoElement))throw new Error("pixels passed to tf.fromPixels() must be either an HTMLVideoElement, HTMLImageElement, HTMLCanvasElement or ImageData, but was "+e.constructor.name);if(null==this.fromPixels2DContext)throw new Error("Can't read pixels from HTMLImageElement outside the browser.");this.fromPixels2DContext.canvas.width=e.width,this.fromPixels2DContext.canvas.height=e.height,this.fromPixels2DContext.drawImage(e,0,0,e.width,e.height),r=this.fromPixels2DContext.getImageData(0,0,e.width,e.height).data}if(4===t)n=new Int32Array(r);else{var o=e.width*e.height;n=new Int32Array(o*t);for(var a=0;a<o;a++)for(var i=0;i<t;++i)n[a*t+i]=r[4*a+i]}return tensor3d(n,[e.height,e.width,t],"int32")},e.prototype.read=function(e){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(t){return[2,this.readSync(e)]})})},e.prototype.readSync=function(e){var t=this.data.get(e),r=t.dtype,n=t.complexTensors;return"complex64"===r?mergeRealAndImagArrays(n.real.dataSync(),n.imag.dataSync()):this.data.get(e).values},e.prototype.disposeData=function(e){if(this.data.has(e)){var t=this.data.get(e).complexTensors;null!=t&&(t.real.dispose(),t.imag.dispose()),this.data.delete(e)}},e.prototype.time=function(e){return __awaiter(this,void 0,void 0,function(){var t;return __generator(this,function(r){return t=now(),e(),[2,{kernelMs:now()-t}]})})},e.prototype.memory=function(){return{unreliable:!0}},e.prototype.complex=function(e,t){var r=Tensor.make(e.shape,{},"complex64");return this.data.get(r.dataId).complexTensors={real:ENV.engine.keep(e.clone()),imag:ENV.engine.keep(t.clone())},r},e.prototype.real=function(e){return this.data.get(e.dataId).complexTensors.real.clone()},e.prototype.imag=function(e){return this.data.get(e.dataId).complexTensors.imag.clone()},e.prototype.assertNotComplex=function(e,t){Array.isArray(e)||(e=[e]),e.forEach(function(e){null!=e&&assert("complex64"!==e.dtype,t+" does not support complex64 tensors.")})},e.prototype.slice=function(e,t,r){this.assertNotComplex(e,"slice");for(var n=buffer(r,e.dtype),o=0;o<n.size;++o){var a=n.indexToLoc(o),i=a.map(function(e,r){return e+t[r]});n.set.apply(n,[e.get.apply(e,i)].concat(a))}return n.toTensor()},e.prototype.stridedSlice=function(e,t,r,n,o,a,i,s,u){this.assertNotComplex(e,"stridedSlice");var l=getStridedSlicedInfo(e.shape,t,r,n,o,a,i,s,u),c=l[0],p=l[1],d=l[2],h=p.filter(function(e,t){return-1===d.indexOf(t)});if(h.some(function(e){return 0===e}))return tensor([],h);for(var f=buffer(p,e.dtype),m=0;m<f.size;m++){for(var g=f.indexToLoc(m),v=new Array(g.length),y=0;y<v.length;y++)v[y]=g[y]*n[y]+c[y];f.set.apply(f,[e.get.apply(e,v)].concat(g))}return f.toTensor().reshape(h)},e.prototype.reverse=function(e,t){this.assertNotComplex(e,"reverse");for(var r=buffer(e.shape,e.dtype),n=e.buffer(),o=function(o){var a=r.indexToLoc(o),i=a.slice();t.forEach(function(t){return i[t]=e.shape[t]-1-i[t]}),r.set.apply(r,[n.get.apply(n,i)].concat(a))},a=0;a<r.size;a++)o(a);return r.toTensor()},e.prototype.concat=function(e,t){this.assertNotComplex(e,"concat");var r=e.map(function(e){var r=sizeFromShape(e.shape.slice(t));return e.as2D(-1,r)}),n=computeOutShape(r.map(function(e){return e.shape}),1),o=buffer(n,e[0].dtype).values;if(1===r[0].shape[0]){var a=0;r.forEach(function(e){o.set(e.dataSync(),a),a+=e.size})}else{var i=0;r.forEach(function(e){for(var t=e.dataSync(),r=0,a=0;a<e.shape[0];++a)for(var s=a*n[1]+i,u=0;u<e.shape[1];++u)o[s+u]=t[r++];i+=e.shape[1]})}var s=computeOutShape(e.map(function(e){return e.shape}),t);return tensor(o,s,e[0].dtype)},e.prototype.neg=function(e){return this.assertNotComplex(e,"neg"),this.multiply(scalar(-1),e)},e.prototype.add=function(e,t){return"complex64"===e.dtype||"complex64"===t.dtype?this.broadcastedBinaryComplexOp(e.cast("complex64"),t.cast("complex64"),function(e,t,r,n){return{real:e+r,imag:t+n}}):this.broadcastedBinaryOp(e,t,upcastType(e.dtype,t.dtype),function(e,t){return e+t})},e.prototype.addN=function(e){this.assertNotComplex(e,"addN");for(var t=e.map(function(e){return e.dataSync()}),r=buffer(e[0].shape,e[0].dtype),n=r.values,o=0;o<e.length;o++)for(var a=t[o],i=0;i<n.length;i++)n[i]+=a[i];return r.toTensor()},e.prototype.subtract=function(e,t){return"complex64"===e.dtype||"complex64"===t.dtype?this.broadcastedBinaryComplexOp(e.cast("complex64"),t.cast("complex64"),function(e,t,r,n){return{real:e-r,imag:t-n}}):this.broadcastedBinaryOp(e,t,upcastType(e.dtype,t.dtype),function(e,t){return e-t})},e.prototype.pow=function(e,t){return this.assertNotComplex([e,t],"pow"),this.broadcastedBinaryOp(e,t,e.dtype,function(e,t){return Math.pow(e,t)})},e.prototype.batchMatMul=function(e,t,r,n){this.assertNotComplex([e,t],"matMul");for(var o=r?e.shape[1]:e.shape[2],a=r?e.shape[2]:e.shape[1],i=n?t.shape[1]:t.shape[2],s=e.shape[0],u=e.dataSync(),l=t.dataSync(),c=r?[e.strides[0],1,e.strides[1]]:[e.strides[0],e.strides[1],1],p=c[0],d=c[1],h=c[2],f=n?[1,t.strides[1],t.strides[0]]:[t.strides[1],1,t.strides[0]],m=f[0],g=f[1],v=f[2],y=a*i,x=new Float32Array(s*y),T=this.blockSize,E=0;E<s;E++)for(var w=0;w<a;w+=T)for(var S=0;S<i;S+=T)for(var b=0;b<o;b+=T)for(var C=Math.min(w+T,a),_=Math.min(S+T,i),A=Math.min(b+T,o),N=w;N<C;N++)for(var R=S;R<_;R++){for(var I=0,k=b;k<A;k++)I+=u[E*p+N*d+k*h]*l[k*m+R*g+E*v];x[E*y+(N*i+R)]+=I}return tensor3d(x,[s,a,i])},e.prototype.multiply=function(e,t){return"complex64"===e.dtype||"complex64"===t.dtype?this.broadcastedBinaryComplexOp(e.cast("complex64"),t.cast("complex64"),function(e,t,r,n){return{real:e*r-t*n,imag:e*n+t*r}}):this.broadcastedBinaryOp(e,t,upcastType(e.dtype,t.dtype),function(e,t){return e*t})},e.prototype.realDivide=function(e,t){this.assertNotComplex([e,t],"realDivide");return this.broadcastedBinaryOp(e,t,"float32",function(e,t){return e/t})},e.prototype.floorDiv=function(e,t){this.assertNotComplex([e,t],"floorDiv");return this.broadcastedBinaryOp(e,t,"int32",function(e,t){return Math.floor(e/t)})},e.prototype.sum=function(e,t){this.assertNotComplex(e,"sum"),assertAxesAreInnerMostDims("sum",t,e.rank);for(var r=computeOutAndReduceShapes(e.shape,t),n=r[0],o=r[1],a=zeros(n,upcastType(e.dtype,"int32")),i=sizeFromShape(o),s=a.dataSync(),u=e.dataSync(),l=0;l<s.length;++l){for(var c=l*i,p=0,d=0;d<i;++d)p+=u[c+d];s[l]=p}return a},e.prototype.prod=function(e,t){this.assertNotComplex(e,"sum");for(var r=computeOutAndReduceShapes(e.shape,t),n=r[0],o=r[1],a=zeros(n,upcastType(e.dtype,"int32")),i=sizeFromShape(o),s=a.dataSync(),u=e.dataSync(),l=0;l<s.length;++l){for(var c=l*i,p=1,d=0;d<i;++d)p*=u[c+d];s[l]=p}return a},e.prototype.unsortedSegmentSum=function(e,t,r){this.assertNotComplex(e,"unsortedSegmentSum");for(var n=[],o=e.rank-t.rank,a=0;a<o;++a)t=t.expandDims(a+1);for(a=0;a<r;++a){var i=scalar(a,"int32"),s=equal(i,t).asType("float32").mul(e).sum(0);n.push(s)}return stack(n)},e.prototype.argMin=function(e,t){this.assertNotComplex(e,"argMin");var r=[t];assertAxesAreInnerMostDims("argMin",r,e.rank);for(var n=computeOutAndReduceShapes(e.shape,r),o=n[0],a=n[1],i=zeros(o,"int32"),s=sizeFromShape(a),u=i.dataSync(),l=e.dataSync(),c=0;c<u.length;++c){for(var p=c*s,d=l[p],h=0,f=0;f<s;++f){var m=l[p+f];m<d&&(d=m,h=f)}u[c]=h}return i},e.prototype.argMax=function(e,t){this.assertNotComplex(e,"argMax");var r=[t];assertAxesAreInnerMostDims("argMax",r,e.rank);for(var n=computeOutAndReduceShapes(e.shape,r),o=n[0],a=n[1],i=zeros(o,"int32"),s=sizeFromShape(a),u=i.dataSync(),l=e.dataSync(),c=0;c<u.length;++c){for(var p=c*s,d=l[p],h=0,f=0;f<s;++f){var m=l[p+f];m>d&&(d=m,h=f)}u[c]=h}return i},e.prototype.cumsum=function(e,t,r,n){if(this.assertNotComplex(e,"cumsum"),t!==e.rank-1)throw new Error("backend.cumsum in CPU expects an inner-most axis="+(e.rank-1)+" but got axis="+t);for(var o=upcastType(e.dtype,"int32"),a=zeros(e.shape,o),i=a.dataSync(),s=e.dataSync(),u=e.shape[e.rank-1],l=n?function(e,t){return e+u-t-1}:function(e,t){return e+t},c=0;c<s.length;c+=u)for(var p=0;p<u;p++){var d=l(c,p);if(0===p)i[d]=r?0:s[d];else{var h=l(c,p-1);i[d]=r?s[h]+i[h]:s[d]+i[h]}}return a},e.prototype.equal=function(e,t){return this.assertNotComplex([e,t],"equal"),this.broadcastedBinaryOp(e,t,"bool",function(e,t){return e===t?1:0})},e.prototype.notEqual=function(e,t){return this.assertNotComplex([e,t],"notEqual"),this.broadcastedBinaryOp(e,t,"bool",function(e,t){return e!==t?1:0})},e.prototype.less=function(e,t){return this.assertNotComplex([e,t],"less"),this.broadcastedBinaryOp(e,t,"bool",function(e,t){return e<t?1:0})},e.prototype.lessEqual=function(e,t){return this.assertNotComplex([e,t],"lessEqual"),this.broadcastedBinaryOp(e,t,"bool",function(e,t){return e<=t?1:0})},e.prototype.greater=function(e,t){return this.assertNotComplex([e,t],"greater"),this.broadcastedBinaryOp(e,t,"bool",function(e,t){return e>t?1:0})},e.prototype.greaterEqual=function(e,t){return this.assertNotComplex([e,t],"greaterEqual"),this.broadcastedBinaryOp(e,t,"bool",function(e,t){return e>=t?1:0})},e.prototype.logicalNot=function(e){this.assertNotComplex(e,"logicalNot");for(var t=e.dataSync(),r=new Int32Array(t.length),n=0;n<t.length;++n)r[n]=t[n]?0:1;return Tensor.make(e.shape,{values:r},"bool")},e.prototype.logicalAnd=function(e,t){return this.assertNotComplex([e,t],"logicalAnd"),this.broadcastedBinaryOp(e,t,"bool",function(e,t){return e&&t})},e.prototype.logicalOr=function(e,t){return this.assertNotComplex([e,t],"logicalOr"),this.broadcastedBinaryOp(e,t,"bool",function(e,t){return e||t})},e.prototype.select=function(e,t,r){this.assertNotComplex([e,t,r],"select");for(var n=e.dataSync(),o=t.dataSync(),a=r.dataSync(),i=zeros(t.shape,upcastType(t.dtype,r.dtype)),s=i.dataSync(),u=0,l=0===e.rank||e.rank>1||1===t.rank?1:t.shape[1],c=0;c<n.length;c++)for(var p=0;p<l;p++)1===n[c]?s[u++]=o[c]:s[u++]=a[c];return i},e.prototype.where=function(e){this.assertNotComplex([e],"where");var t=e.dataSync();return whereImpl(e.shape,t)},e.prototype.topk=function(e,t,r){return this.assertNotComplex(e,"topk"),topkImpl(e.dataSync(),e.shape,e.dtype,t,r)},e.prototype.min=function(e,t){this.assertNotComplex(e,"min"),assertAxesAreInnerMostDims("min",t,e.rank);for(var r=computeOutAndReduceShapes(e.shape,t),n=r[0],o=r[1],a=zeros(n,e.dtype),i=sizeFromShape(o),s=a.dataSync(),u=e.dataSync(),l=0;l<s.length;++l){for(var c=l*i,p=u[c],d=0;d<i;++d){var h=u[c+d];h<p&&(p=h)}s[l]=p}return a},e.prototype.minimum=function(e,t){return this.assertNotComplex([e,t],"minimum"),this.broadcastedBinaryOp(e,t,e.dtype,function(e,t){return Math.min(e,t)})},e.prototype.mod=function(e,t){return this.assertNotComplex([e,t],"mod"),this.broadcastedBinaryOp(e,t,e.dtype,function(e,t){var r=e%t;return e<0&&t<0||e>=0&&t>=0?r:(r+t)%t})},e.prototype.max=function(e,t){this.assertNotComplex(e,"max"),assertAxesAreInnerMostDims("max",t,e.rank);for(var r=computeOutAndReduceShapes(e.shape,t),n=r[0],o=r[1],a=zeros(n,e.dtype),i=sizeFromShape(o),s=a.dataSync(),u=e.dataSync(),l=0;l<s.length;++l){for(var c=l*i,p=u[c],d=0;d<i;++d){var h=u[c+d];h>p&&(p=h)}s[l]=p}return a},e.prototype.maximum=function(e,t){return this.assertNotComplex([e,t],"maximum"),this.broadcastedBinaryOp(e,t,e.dtype,function(e,t){return Math.max(e,t)})},e.prototype.all=function(e,t){this.assertNotComplex(e,"all"),assertAxesAreInnerMostDims("all",t,e.rank);for(var r=computeOutAndReduceShapes(e.shape,t),n=r[0],o=r[1],a=zeros(n,e.dtype),i=sizeFromShape(o),s=a.dataSync(),u=e.dataSync(),l=0;l<s.length;++l){for(var c=l*i,p=u[c],d=0;d<i;++d){var h=u[c+d];p=p&&h}s[l]=p}return a},e.prototype.any=function(e,t){this.assertNotComplex(e,"any"),assertAxesAreInnerMostDims("any",t,e.rank);for(var r=computeOutAndReduceShapes(e.shape,t),n=r[0],o=r[1],a=zeros(n,e.dtype),i=sizeFromShape(o),s=a.dataSync(),u=e.dataSync(),l=0;l<s.length;++l){for(var c=l*i,p=u[c],d=0;d<i;++d){var h=u[c+d];p=p||h}s[l]=p}return a},e.prototype.squaredDifference=function(e,t){return this.assertNotComplex([e,t],"squaredDifference"),this.broadcastedBinaryOp(e,t,e.dtype,function(e,t){var r=e-t;return r*r})},e.prototype.ceil=function(e){this.assertNotComplex(e,"ceil");for(var t=e.dataSync(),r=new Float32Array(t.length),n=0;n<t.length;++n)r[n]=Math.ceil(t[n]);return Tensor.make(e.shape,{values:r})},e.prototype.floor=function(e){this.assertNotComplex(e,"floor");for(var t=e.dataSync(),r=new Float32Array(t.length),n=0;n<t.length;++n)r[n]=Math.floor(t[n]);return Tensor.make(e.shape,{values:r})},e.prototype.sign=function(e){this.assertNotComplex(e,"x");for(var t=e.dataSync(),r=new Float32Array(t.length),n=0;n<t.length;++n)t[n]<0?r[n]=-1:t[n]>0?r[n]=1:r[n]=0;return Tensor.make(e.shape,{values:r})},e.prototype.round=function(e){this.assertNotComplex(e,"round");for(var t=e.dataSync(),r=new Float32Array(t.length),n=0;n<t.length;++n){var o=Math.floor(t[n]);t[n]-o<.5?r[n]=Math.floor(t[n]):t[n]-o>.5?r[n]=Math.ceil(t[n]):r[n]=o%2==0?o:o+1}return Tensor.make(e.shape,{values:r})},e.prototype.exp=function(e){this.assertNotComplex(e,"exp");for(var t=e.dataSync(),r=new Float32Array(t.length),n=0;n<t.length;++n)r[n]=Math.exp(t[n]);return Tensor.make(e.shape,{values:r})},e.prototype.expm1=function(e){this.assertNotComplex(e,"expm1");for(var t=e.dataSync(),r=new Float32Array(t.length),n=0;n<t.length;++n)r[n]=Math.expm1(t[n]);return Tensor.make(e.shape,{values:r})},e.prototype.log=function(e){this.assertNotComplex(e,"log");for(var t=e.dataSync(),r=new Float32Array(t.length),n=0;n<t.length;++n){var o=t[n];r[n]=Math.log(o)}return Tensor.make(e.shape,{values:r})},e.prototype.log1p=function(e){this.assertNotComplex(e,"log1p");for(var t=e.dataSync(),r=new Float32Array(t.length),n=0;n<t.length;++n){var o=t[n];r[n]=Math.log1p(o)}return Tensor.make(e.shape,{values:r})},e.prototype.sqrt=function(e){this.assertNotComplex(e,"sqrt");for(var t=e.dataSync(),r=new Float32Array(t.length),n=0;n<t.length;++n){var o=t[n];r[n]=Math.sqrt(o)}return Tensor.make(e.shape,{values:r})},e.prototype.rsqrt=function(e){this.assertNotComplex(e,"rsqrt");for(var t=e.dataSync(),r=new Float32Array(t.length),n=0;n<t.length;++n){var o=t[n];r[n]=1/Math.sqrt(o)}return Tensor.make(e.shape,{values:r})},e.prototype.square=function(e){this.assertNotComplex(e,"square");for(var t=e.dataSync(),r=new Float32Array(t.length),n=0;n<t.length;++n){var o=t[n];r[n]=o*o}return Tensor.make(e.shape,{values:r})},e.prototype.reciprocal=function(e){this.assertNotComplex(e,"reciprocal");for(var t=e.dataSync(),r=new Float32Array(t.length),n=0;n<t.length;++n)r[n]=1/t[n];return Tensor.make(e.shape,{values:r})},e.prototype.relu=function(e){this.assertNotComplex(e,"relu");for(var t=zeros(e.shape,e.dtype),r=t.dataSync(),n=e.dataSync(),o=0;o<n.length;++o)r[o]=Math.max(0,n[o]);return t},e.prototype.elu=function(e){this.assertNotComplex(e,"elu");for(var t=new Float32Array(e.size),r=e.dataSync(),n=0;n<r.length;++n){var o=r[n];t[n]=o>=0?o:Math.exp(o)-1}return Tensor.make(e.shape,{values:t})},e.prototype.eluDer=function(e,t){this.assertNotComplex([e,t],"eluDer");for(var r=new Float32Array(t.size),n=t.dataSync(),o=e.dataSync(),a=0;a<n.length;++a){var i=n[a];r[a]=i>=1?o[a]:o[a]*(i+1)}return Tensor.make(t.shape,{values:r})},e.prototype.selu=function(e){this.assertNotComplex(e,"selu");for(var t=SELU_SCALEALPHA,r=SELU_SCALE,n=new Float32Array(e.size),o=e.dataSync(),a=0;a<o.length;++a){var i=o[a];n[a]=i>=0?r*i:t*(Math.exp(i)-1)}return Tensor.make(e.shape,{values:n})},e.prototype.clip=function(e,t,r){this.assertNotComplex(e,"clip");for(var n=new Float32Array(e.size),o=e.dataSync(),a=0;a<o.length;++a){var i=o[a];n[a]=i>r?r:i<t?t:i}return Tensor.make(e.shape,{values:n})},e.prototype.abs=function(e){for(var t=new Float32Array(e.size),r=e.dataSync(),n=0;n<r.length;++n)t[n]=Math.abs(r[n]);return Tensor.make(e.shape,{values:t})},e.prototype.complexAbs=function(e){for(var t=new Float32Array(e.size),r=e.dataSync(),n=0;n<e.size;++n){var o=r[2*n],a=r[2*n+1];t[n]=Math.sqrt(o*o+a*a)}return Tensor.make(e.shape,{values:t})},e.prototype.int=function(e){this.assertNotComplex(e,"int");for(var t=new Int32Array(e.size),r=e.dataSync(),n=0;n<r.length;++n)t[n]=r[n];return Tensor.make(e.shape,{values:t},"int32")},e.prototype.sigmoid=function(e){this.assertNotComplex(e,"sigmoid");for(var t=new Float32Array(e.size),r=e.dataSync(),n=0;n<r.length;++n)t[n]=1/(1+Math.exp(-r[n]));return Tensor.make(e.shape,{values:t})},e.prototype.softplus=function(e){this.assertNotComplex(e,"softplus");for(var t=Math.log(1.1920928955078125e-7)+2,r=new Float32Array(e.size),n=e.dataSync(),o=0;o<n.length;++o){var a=n[o]>-t,i=n[o]<t,s=Math.exp(n[o]),u=void 0;u=i?s:a?n[o]:Math.log(1+s),r[o]=u}return Tensor.make(e.shape,{values:r})},e.prototype.sin=function(e){this.assertNotComplex(e,"sin");for(var t=new Float32Array(e.size),r=e.dataSync(),n=0;n<r.length;++n)t[n]=Math.sin(r[n]);return Tensor.make(e.shape,{values:t})},e.prototype.cos=function(e){this.assertNotComplex(e,"cos");for(var t=new Float32Array(e.size),r=e.dataSync(),n=0;n<r.length;++n)t[n]=Math.cos(r[n]);return Tensor.make(e.shape,{values:t})},e.prototype.tan=function(e){this.assertNotComplex(e,"tan");for(var t=new Float32Array(e.size),r=e.dataSync(),n=0;n<r.length;++n)t[n]=Math.tan(r[n]);return Tensor.make(e.shape,{values:t})},e.prototype.asin=function(e){this.assertNotComplex(e,"asin");for(var t=new Float32Array(e.size),r=e.dataSync(),n=0;n<r.length;++n)t[n]=Math.asin(r[n]);return Tensor.make(e.shape,{values:t})},e.prototype.acos=function(e){this.assertNotComplex(e,"acos");for(var t=new Float32Array(e.size),r=e.dataSync(),n=0;n<r.length;++n)t[n]=Math.acos(r[n]);return Tensor.make(e.shape,{values:t})},e.prototype.atan=function(e){this.assertNotComplex(e,"atan");for(var t=new Float32Array(e.size),r=e.dataSync(),n=0;n<r.length;++n)t[n]=Math.atan(r[n]);return Tensor.make(e.shape,{values:t})},e.prototype.atan2=function(e,t){return this.assertNotComplex([e,t],"atan2"),this.broadcastedBinaryOp(e,t,e.dtype,function(e,t){return Math.atan2(e,t)})},e.prototype.sinh=function(e){this.assertNotComplex(e,"sinh");for(var t=new Float32Array(e.size),r=e.dataSync(),n=0;n<r.length;++n)t[n]=Math.sinh(r[n]);return Tensor.make(e.shape,{values:t})},e.prototype.cosh=function(e){this.assertNotComplex(e,"cosh");for(var t=new Float32Array(e.size),r=e.dataSync(),n=0;n<r.length;++n)t[n]=Math.cosh(r[n]);return Tensor.make(e.shape,{values:t})},e.prototype.tanh=function(e){this.assertNotComplex(e,"tanh");for(var t=new Float32Array(e.size),r=e.dataSync(),n=0;n<r.length;++n)t[n]=tanh(r[n]);return Tensor.make(e.shape,{values:t})},e.prototype.asinh=function(e){this.assertNotComplex(e,"asinh");for(var t=new Float32Array(e.size),r=e.dataSync(),n=0;n<r.length;++n)t[n]=Math.asinh(r[n]);return Tensor.make(e.shape,{values:t})},e.prototype.acosh=function(e){this.assertNotComplex(e,"acosh");for(var t=new Float32Array(e.size),r=e.dataSync(),n=0;n<r.length;++n)t[n]=Math.acosh(r[n]);return Tensor.make(e.shape,{values:t})},e.prototype.atanh=function(e){this.assertNotComplex(e,"atanh");for(var t=new Float32Array(e.size),r=e.dataSync(),n=0;n<r.length;++n)t[n]=Math.atanh(r[n]);return Tensor.make(e.shape,{values:t})},e.prototype.erf=function(e){this.assertNotComplex(e,"erf");for(var t=new Float32Array(e.size),r=e.dataSync(),n=ERF_P,o=ERF_A1,a=ERF_A2,i=ERF_A3,s=ERF_A4,u=ERF_A5,l=0;l<r.length;++l){var c=r[l],p=1/(1+n*c);t[l]=1-((((u*p+s)*p+i)*p+a)*p+o)*p*Math.exp(-c*c)}return Tensor.make(e.shape,{values:t})},e.prototype.step=function(e,t){void 0===t&&(t=0),this.assertNotComplex(e,"step");for(var r=new Float32Array(e.size),n=e.dataSync(),o=0;o<n.length;++o){var a=n[o];isNaN(a)?r[o]=NaN:r[o]=a>0?1:t}return Tensor.make(e.shape,{values:r})},e.prototype.conv2d=function(e,t,r){this.assertNotComplex([e,t],"conv2d");for(var n=r.filterHeight,o=r.filterWidth,a=r.dilationHeight,i=r.dilationWidth,s=r.padInfo.left,u=r.padInfo.top,l=buffer(r.outShape,e.dtype),c=e.dataSync(),p=t.dataSync(),d=l.values,h=0;h<r.batchSize;++h)for(var f=h*e.strides[0],m=h*l.strides[0],g=0;g<r.outHeight;++g)for(var v=m+g*l.strides[1],y=g*r.strideHeight-s,x=0;x<n;x++){var T=y+x*a;if(!(T<0||T>=r.inHeight))for(var E=x*t.strides[0],w=f+T*e.strides[1],S=0;S<r.outWidth;++S)for(var b=v+S*r.outChannels,C=S*r.strideWidth-u,_=0;_<o;_++){var A=C+_*i;if(!(A<0||A>=r.inWidth))for(var N=E+_*t.strides[1],R=w+A*r.inChannels,I=N,k=0;k<r.inChannels;++k){for(var D=c[R+k],M=0;M<r.outChannels;++M)d[b+M]+=D*p[I+M];I+=r.outChannels}}}return l.toTensor()},e.prototype.conv2dDerInput=function(e,t,r){this.assertNotComplex([e,t],"conv2dDerInput");for(var n=buffer(r.inShape,"float32"),o=n.values,a=n.strides,i=a[0],s=a[1],u=a[2],l=e.dataSync(),c=e.strides,p=c[0],d=c[1],h=c[2],f=t.dataSync(),m=t.strides,g=m[0],v=m[1],y=m[2],x=r.batchSize,T=r.filterHeight,E=r.filterWidth,w=r.inChannels,S=r.inHeight,b=r.inWidth,C=r.outChannels,_=r.outHeight,A=r.outWidth,N=r.strideHeight,R=r.strideWidth,I=T-1-r.padInfo.top,k=E-1-r.padInfo.left,D=0;D<x;++D)for(var M=0;M<w;++M)for(var O=0;O<S;++O)for(var P=O-I,F=Math.max(0,Math.ceil(P/N)),L=Math.min(_,(T+P)/N),B=0;B<b;++B){for(var U=B-k,z=Math.max(0,Math.ceil(U/R)),V=Math.min(A,(E+U)/R),H=0,G=F;G<L;++G)for(var W=G*N-P,q=z;q<V;++q)for(var $=p*D+d*G+h*q,X=g*(T-1-W)+v*(E-1-(q*R-U))+y*M,K=0;K<C;++K){H+=l[$+K]*f[X+K]}o[i*D+s*O+u*B+M]=H}return n.toTensor()},e.prototype.conv2dDerFilter=function(e,t,r){this.assertNotComplex([e,t],"conv2dDerFilter");for(var n=r.strideHeight,o=r.strideWidth,a=r.filterHeight,i=r.filterWidth,s=buffer(r.filterShape,"float32"),u=r.padInfo.left,l=r.padInfo.top,c=0;c<a;++c)for(var p=Math.max(0,Math.ceil((l-c)/n)),d=Math.min(r.outHeight,(r.inHeight+l-c)/n),h=0;h<i;++h)for(var f=Math.max(0,Math.ceil((u-h)/o)),m=Math.min(r.outWidth,(r.inWidth+u-h)/o),g=0;g<r.inChannels;++g)for(var v=0;v<r.outChannels;++v){for(var y=0,x=0;x<r.batchSize;++x)for(var T=p;T<d;++T)for(var E=c+T*n-l,w=f;w<m;++w){var S=h+w*o-u;y+=e.get(x,E,S,g)*t.get(x,T,w,v)}s.set(y,c,h,g,v)}return s.toTensor()},e.prototype.depthwiseConv2D=function(e,t,r){this.assertNotComplex([e,t],"depthwiseConv2D");for(var n=r.filterHeight,o=r.filterWidth,a=r.dilationHeight,i=r.dilationWidth,s=r.padInfo.left,u=r.padInfo.top,l=r.outChannels/r.inChannels,c=buffer(r.outShape,e.dtype),p=e.dataSync(),d=t.dataSync(),h=c.values,f=0;f<r.batchSize;++f)for(var m=f*e.strides[0],g=f*c.strides[0],v=0;v<r.outHeight;++v)for(var y=g+v*c.strides[1],x=v*r.strideHeight-s,T=0;T<n;++T){var E=x+T*a;if(!(E<0||E>=r.inHeight))for(var w=T*t.strides[0],S=m+E*e.strides[1],b=0;b<r.outWidth;++b)for(var C=y+b*c.strides[2],_=b*r.strideWidth-u,A=0;A<o;++A){var N=_+A*i;if(!(N<0||N>=r.inWidth))for(var R=w+A*t.strides[1],I=S+N*r.inChannels,k=C,D=R,M=0;M<r.inChannels;++M){for(var O=p[I+M],P=0;P<l;++P)h[k+P]+=O*d[D+P];k+=l,D+=l}}}return c.toTensor()},e.prototype.depthwiseConv2DDerInput=function(e,t,r){this.assertNotComplex([e,t],"depthwiseConv2DDerInput");for(var n=buffer(r.inShape,"float32"),o=n.values,a=n.strides,i=a[0],s=a[1],u=a[2],l=e.dataSync(),c=e.strides,p=c[0],d=c[1],h=c[2],f=t.dataSync(),m=t.strides,g=m[0],v=m[1],y=m[2],x=r.batchSize,T=r.filterHeight,E=r.filterWidth,w=r.inChannels,S=r.inHeight,b=r.inWidth,C=r.outChannels,_=r.outHeight,A=r.outWidth,N=r.strideHeight,R=r.strideWidth,I=T-1-r.padInfo.top,k=E-1-r.padInfo.left,D=C/w,M=0;M<x;++M)for(var O=0;O<w;++O)for(var P=0;P<S;++P)for(var F=P-I,L=Math.max(0,Math.ceil(F/N)),B=Math.min(_,(T+F)/N),U=0;U<b;++U){for(var z=U-k,V=Math.max(0,Math.ceil(z/R)),H=Math.min(A,(E+z)/R),G=0,W=L;W<B;++W)for(var q=W*N-F,$=V;$<H;++$)for(var X=p*M+d*W+h*$,K=g*(T-1-q)+v*(E-1-($*R-z))+y*O,j=0;j<D;++j){G+=l[X+(O*D+j)]*f[K+j]}o[i*M+s*P+u*U+O]=G}return n.toTensor()},e.prototype.depthwiseConv2DDerFilter=function(e,t,r){this.assertNotComplex([e,t],"depthwiseConv2DDerFilter");for(var n=r.strideHeight,o=r.strideWidth,a=r.filterHeight,i=r.filterWidth,s=buffer(r.filterShape,"float32"),u=r.padInfo.left,l=r.padInfo.top,c=r.outChannels/r.inChannels,p=0;p<a;++p)for(var d=Math.max(0,Math.ceil((l-p)/n)),h=Math.min(r.outHeight,(r.inHeight+l-p)/n),f=0;f<i;++f)for(var m=Math.max(0,Math.ceil((u-f)/o)),g=Math.min(r.outWidth,(r.inWidth+u-f)/o),v=0;v<r.outChannels;++v){for(var y=Math.trunc(v/c),x=v%c,T=0,E=0;E<r.batchSize;++E)for(var w=d;w<h;++w)for(var S=p+w*n-l,b=m;b<g;++b){var C=f+b*o-u;T+=e.get(E,S,C,y)*t.get(E,w,b,v)}s.set(T,p,f,y,x)}return s.toTensor()},e.prototype.tile=function(e,t){this.assertNotComplex(e,"tile");for(var r=new Array(e.rank),n=0;n<r.length;n++)r[n]=e.shape[n]*t[n];var o=buffer(r,e.dtype),a=e.buffer();for(n=0;n<o.values.length;++n){for(var i=o.indexToLoc(n),s=new Array(e.rank),u=0;u<s.length;u++)s[u]=i[u]%e.shape[u];var l=a.locToIndex(s);o.values[n]=a.values[l]}return o.toTensor()},e.prototype.pad=function(e,t,r){this.assertNotComplex(e,"pad");var n=t.map(function(t,r){return t[0]+e.shape[r]+t[1]}),o=t.map(function(e){return e[0]}),a=e.buffer(),i=buffer(n,e.dtype);0!==r&&i.values.fill(r);for(var s=0;s<e.size;s++){var u=a.indexToLoc(s),l=u.map(function(e,t){return e+o[t]});i.set.apply(i,[e.get.apply(e,u)].concat(l))}return i.toTensor()},e.prototype.transpose=function(e,t){this.assertNotComplex(e,"transpose");for(var r=new Array(e.rank),n=0;n<r.length;n++)r[n]=e.shape[t[n]];var o=e.dataSync(),a=buffer(r,e.dtype),i=e.buffer();for(n=0;n<e.size;++n){for(var s=i.indexToLoc(n),u=new Array(s.length),l=0;l<u.length;l++)u[l]=s[t[l]];var c=a.locToIndex(u);a.values[c]=o[n]}return a.toTensor()},e.prototype.gather=function(e,t,r){this.assertNotComplex([e,t],"gather");var n=e.shape.slice(),o=t.dataSync();n[r]=o.length;for(var a=buffer(n,e.dtype),i=e.buffer(),s=0;s<a.size;++s){var u=a.indexToLoc(s),l=u.slice();l[r]=o[u[r]];var c=i.locToIndex(l);a.values[s]=i.values[c]}return a.toTensor()},e.prototype.batchToSpaceND=function(e,t,r){this.assertNotComplex([e],"batchToSpaceND");var n=t.reduce(function(e,t){return e*t}),o=getReshaped(e.shape,t,n),a=getPermuted(o.length,t.length),i=getReshapedPermuted(e.shape,t,n),s=getSliceBeginCoords(r,t.length),u=getSliceSize(i,r,t.length);return e.reshape(o).transpose(a).reshape(i).slice(s,u)},e.prototype.spaceToBatchND=function(e,t,r){this.assertNotComplex([e],"spaceToBatchND");var n=t.reduce(function(e,t){return e*t}),o=[[0,0]];o.push.apply(o,r);for(var a=1+t.length;a<e.shape.length;++a)o.push([0,0]);var i=e.pad(o),s=getReshaped(i.shape,t,n,!1),u=getPermuted(s.length,t.length,!1),l=getReshapedPermuted(i.shape,t,n,!1);return i.reshape(s).transpose(u).reshape(l)},e.prototype.pool=function(e,t,r){this.assertNotComplex(e,"pool");for(var n=t.strideHeight,o=t.strideWidth,a=t.dilationHeight,i=t.dilationWidth,s=t.effectiveFilterHeight,u=t.effectiveFilterWidth,l=t.padInfo.top,c=t.padInfo.left,p="max"===r?Number.NEGATIVE_INFINITY:Number.POSITIVE_INFINITY,d=e.dataSync(),h=buffer(t.outShape,e.dtype),f=h.values,m=t.outShape[1]*t.outShape[2]*t.outShape[3],g=t.outShape[2]*t.outShape[3],v=t.outShape[3],y=0;y<t.batchSize;++y)for(var x=y*m,T=y*e.strides[0],E=0;E<t.inChannels;++E)for(var w=0;w<t.outHeight;++w)for(var S=w*n-l,b=Math.max(0,S),C=Math.min(t.inHeight,s+S),_=x+w*g,A=0;A<t.outWidth;++A){for(var N=A*o-c,R=Math.max(0,N),I=Math.min(t.inWidth,u+N),k=p,D=0,M=0,O=b;O<C;O+=a){for(var P=T+O*e.strides[1],F=R;F<I;F+=i){var L=d[P+F*e.strides[2]+E];"max"===r&&L>k?k=L:"avg"===r&&(D+=L,M++)}if(isNaN(k))break}f[_+A*v+E]="avg"===r?D/M:k}return h.toTensor()},e.prototype.maxPool=function(e,t){return this.pool(e,t,"max")},e.prototype.maxPoolPositions=function(e,t){for(var r=buffer(t.outShape,"int32"),n=t.strideHeight,o=t.strideWidth,a=t.dilationHeight,i=t.dilationWidth,s=t.effectiveFilterHeight,u=t.effectiveFilterWidth,l=t.padInfo.top,c=t.padInfo.left,p=0;p<t.batchSize;++p)for(var d=0;d<t.inChannels;++d)for(var h=0;h<t.outHeight;++h){for(var f=h*n-l,m=f;m<0;)m+=a;for(var g=Math.min(t.inHeight,s+f),v=0;v<t.outWidth;++v){for(var y=v*o-c,x=y;x<0;)x+=i;for(var T=Math.min(t.inWidth,u+y),E=Number.NEGATIVE_INFINITY,w=-1,S=m;S<g;S+=a)for(var b=S-f,C=x;C<T;C+=i){var _=C-y,A=e.get(p,S,C,d);A>E&&(E=A,w=b*u+_)}r.set(w,p,h,v,d)}}return r.toTensor()},e.prototype.maxPoolBackprop=function(e,t,r,n){this.assertNotComplex([t,r],"maxPoolBackprop");for(var o=this.maxPoolPositions(t,n),a=n.strideHeight,i=n.strideWidth,s=n.dilationHeight,u=n.dilationWidth,l=n.effectiveFilterHeight,c=n.effectiveFilterWidth,p=c-1-n.padInfo.left,d=l-1-n.padInfo.top,h=buffer(t.shape,"float32"),f=0;f<n.batchSize;++f)for(var m=0;m<n.inChannels;++m)for(var g=0;g<n.inHeight;++g)for(var v=0;v<n.inWidth;++v){for(var y=g-d,x=v-p,T=0,E=0;E<l;E+=s){var w=(y+E)/a;if(!(w<0||w>=n.outHeight||Math.floor(w)!==w))for(var S=0;S<c;S+=u){var b=(x+S)/i;if(!(b<0||b>=n.outWidth||Math.floor(b)!==b)){var C=l*c-1-o.get(f,w,b,m)===E*c+S?1:0;if(0!==C)T+=e.get(f,w,b,m)*C}}}h.set(T,f,g,v,m)}return h.toTensor()},e.prototype.avgPoolBackprop=function(e,t,r){this.assertNotComplex([e,t],"avgPoolBackprop");for(var n=r.strideHeight,o=r.strideWidth,a=r.filterHeight,i=r.filterWidth,s=r.dilationHeight,u=r.dilationWidth,l=r.effectiveFilterHeight,c=r.effectiveFilterWidth,p=c-1-r.padInfo.left,d=l-1-r.padInfo.top,h=buffer(t.shape,"float32"),f=1/(a*i),m=0;m<r.batchSize;++m)for(var g=0;g<r.inChannels;++g)for(var v=0;v<r.inHeight;++v)for(var y=0;y<r.inWidth;++y){for(var x=v-d,T=y-p,E=0,w=0;w<l;w+=s){var S=(x+w)/n;if(!(S<0||S>=r.outHeight||Math.floor(S)!==S))for(var b=0;b<c;b+=u){var C=(T+b)/o;if(!(C<0||C>=r.outWidth||Math.floor(C)!==C))E+=e.get(m,S,C,g)}}h.set(E*f,m,v,y,g)}return h.toTensor()},e.prototype.cast=function(e,t){return castTensor(e,t,this)},e.prototype.reshape=function(e,t){return reshapeTensor(e,t)},e.prototype.avgPool=function(e,t){return this.assertNotComplex(e,"avgPool"),this.pool(e,t,"avg").toFloat()},e.prototype.resizeBilinear=function(e,t,r,n){this.assertNotComplex(e,"resizeBilinear");for(var o=e.shape,a=o[0],i=o[1],s=o[2],u=o[3],l=e.dataSync(),c=new Float32Array(sizeFromShape([a,t,r,u])),p=[n&&t>1?i-1:i,n&&r>1?s-1:s],d=[n&&t>1?t-1:t,n&&r>1?r-1:r],h=0,f=p[0]/d[0],m=p[1]/d[1],g=0;g<a;g++)for(var v=0;v<t;v++)for(var y=f*v,x=Math.floor(y),T=y-x,E=Math.min(i-1,Math.ceil(y)),w=g*e.strides[0]+x*e.strides[1],S=g*e.strides[0]+E*e.strides[1],b=0;b<r;b++)for(var C=m*b,_=Math.floor(C),A=C-_,N=Math.min(s-1,Math.ceil(C)),R=w+_*e.strides[2],I=S+_*e.strides[2],k=w+ +N*e.strides[2],D=S+N*e.strides[2],M=0;M<u;M++){var O=l[R+M],P=l[I+M],F=O+(l[k+M]-O)*A,L=F+(P+(l[D+M]-P)*A-F)*T;c[h++]=L}return tensor(c,[a,t,r,u])},e.prototype.resizeBilinearBackprop=function(e,t,r){this.assertNotComplex([e,t],"resizeBilinearBackprop");for(var n=t.shape,o=n[0],a=n[1],i=n[2],s=n[3],u=e.shape,l=u[1],c=u[2],p=new Float32Array(o*a*i*s),d=[r&&l>1?a-1:a,r&&c>1?i-1:i],h=[r&&l>1?l-1:l,r&&c>1?c-1:c],f=d[0]/h[0],m=d[1]/h[1],g=e.dataSync(),v=0,y=0;y<o;y++)for(var x=y*t.strides[0],T=0;T<l;T++)for(var E=T*f,w=Math.floor(E),S=Math.min(Math.ceil(E),a-1),b=x+w*t.strides[1],C=x+S*t.strides[1],_=E-w,A=1-_,N=0;N<c;N++)for(var R=N*m,I=Math.floor(R),k=Math.min(Math.ceil(R),i-1),D=R-I,M=1-D,O=b+I*t.strides[2],P=b+k*t.strides[2],F=C+I*t.strides[2],L=C+k*t.strides[2],B=A*M,U=A*D,z=_*M,V=_*D,H=0;H<s;H++){var G=g[v++];p[O+H]+=G*B,p[P+H]+=G*U,p[F+H]+=G*z,p[L+H]+=G*V}return tensor4d(p,[o,i,a,s],t.dtype)},e.prototype.resizeNearestNeighbor=function(e,t,r,n){this.assertNotComplex(e,"resizeNearestNeighbor");for(var o=e.shape,a=o[0],i=o[1],s=o[2],u=o[3],l=e.dataSync(),c=new Float32Array(a*t*r*u),p=[n&&t>1?i-1:i,n&&r>1?s-1:s],d=[n&&t>1?t-1:t,n&&r>1?r-1:r],h=p[0]/d[0],f=p[1]/d[1],m=0,g=0;g<a;g++)for(var v=g*e.strides[0],y=0;y<t;y++)for(var x=h*y,T=v+Math.min(i-1,n?Math.round(x):Math.floor(x))*e.strides[1],E=0;E<r;E++)for(var w=f*E,S=T+Math.min(s-1,n?Math.round(w):Math.floor(w))*e.strides[2],b=0;b<u;b++){var C=l[S+b];c[m++]=C}return tensor(c,[a,t,r,u],e.dtype)},e.prototype.resizeNearestNeighborBackprop=function(e,t,r){this.assertNotComplex([e,t],"resizeNearestNeighborBackprop");for(var n=t.shape,o=n[0],a=n[1],i=n[2],s=n[3],u=e.shape,l=u[1],c=u[2],p=new Float32Array(o*a*i*s),d=e.dataSync(),h=[r&&l>1?a-1:a,r&&c>1?i-1:i],f=[r&&l>1?l-1:l,r&&c>1?c-1:c],m=h[0]/f[0],g=h[1]/f[1],v=1/m,y=1/g,x=2*Math.ceil(v)+2,T=2*Math.ceil(y)+2,E=0;E<o;E++)for(var w=E*t.strides[0],S=0;S<a;S++)for(var b=w+S*t.strides[1],C=Math.floor(S*v),_=Math.floor(C-x/2),A=0;A<i;A++)for(var N=b+A*t.strides[2],R=Math.floor(A*y),I=Math.floor(R-T/2),k=0;k<s;k++){for(var D=0,M=0;M<x;M++){var O=M+_;if(!(O<0||O>=l)){var P=w+O*e.strides[1],F=O*m;if(S===Math.min(a-1,r?Math.round(F):Math.floor(F)))for(var L=0;L<T;L++){var B=L+I;if(!(B<0||B>=c)){var U=P+B*e.strides[2],z=B*g;A===Math.min(i-1,r?Math.round(z):Math.floor(z))&&(D+=d[U+k])}}}}p[N+k]=D}return tensor4d(p,t.shape,t.dtype)},e.prototype.batchNormalization=function(e,t,r,n,o,a){this.assertNotComplex([e,t,r,o,a],"batchNormalization");for(var i=e.dataSync(),s=t.dataSync(),u=r.dataSync(),l=o?o.dataSync():new Float32Array([1]),c=a?a.dataSync():new Float32Array([0]),p=new Float32Array(i.length),d=c.length,h=l.length,f=u.length,m=s.length,g=0,v=0,y=0,x=0,T=0;T<i.length;++T)p[T]=c[g++]+(i[T]-s[v++])*l[y++]/Math.sqrt(u[x++]+n),g>=d&&(g=0),v>=m&&(v=0),y>=h&&(y=0),x>=f&&(x=0);return tensor4d(p,e.shape)},e.prototype.localResponseNormalization4D=function(e,t,r,n,o){this.assertNotComplex(e,"localResponseNormalization4D");var a=e.shape[3],i=a-1,s=e.dataSync(),u=sizeFromShape(e.shape),l=new Float32Array(u);function c(e){for(var r=e%a,n=e-r+Math.max(0,r-t),o=e-r+Math.min(r+t,i),u=0;n<=o;n++){var l=s[n];u+=l*l}return u}for(var p=0;p<u;p++){var d=c(p),h=s[p]*Math.pow(r+n*d,-o);l[p]=h}return tensor4d(l,e.shape)},e.prototype.LRNGrad=function(e,t,r,n,o,a,i){this.assertNotComplex(e,"LRNGrad");for(var s=e.shape[3],u=e.dataSync(),l=t.dataSync(),c=r.dataSync(),p=new Float32Array(sizeFromShape(e.shape)),d=sizeFromShape(e.shape),h=0;h<d;h++){for(var f=h%s,m=h-f+Math.max(0,f-n),g=h-f+Math.min(s,f+n+1),v=0,y=m;y<g;y++)v+=Math.pow(l[y],2);v=a*v+o;for(y=m;y<g;y++){var x=-2*a*i*l[y]*c[h]/v;h===y&&(x+=Math.pow(v,-i)),x*=u[h],p[y]+=x}}return tensor4d(p,e.shape)},e.prototype.multinomial=function(e,t,r,n){this.assertNotComplex(e,"multinomial");for(var o=t?e:softmax(e),a=o.shape[0],i=o.shape[1],s=zeros([a,r],"int32"),u=s.dataSync(),l=o.dataSync(),c=0;c<a;++c){var p=c*i,d=new Float32Array(i-1);d[0]=l[p];for(var h=1;h<d.length;++h)d[h]=d[h-1]+l[p+h];for(var f=seedrandom_1(n.toString()),m=c*r,g=0;g<r;++g){var v=f();u[m+g]=d.length;for(var y=0;y<d.length;y++)if(v<d[y]){u[m+g]=y;break}}}return s},e.prototype.oneHot=function(e,t,r,n){this.assertNotComplex(e,"oneHot");var o=new Float32Array(e.size*t);o.fill(n);for(var a=0;a<e.size;++a)e.get(a)>=0&&e.get(a)<t&&(o[a*t+e.get(a)]=r);return tensor2d(o,[e.size,t],"int32")},e.prototype.nonMaxSuppression=function(e,t,r,n,o){return this.assertNotComplex(e,"nonMaxSuppression"),nonMaxSuppressionImpl(e.dataSync(),t.dataSync(),r,n,o)},e.prototype.fft=function(e){if(1!==e.shape[0])throw new Error("tf.fft() on CPU only supports vectors.");return this.fftImpl(e,!1)},e.prototype.ifft=function(e){if(1!==e.shape[0])throw new Error("tf.ifft() on CPU only supports vectors.");return this.fftImpl(e,!0)},e.prototype.fftImpl=function(e,t){var r=e.as1D(),n=r.size;if(this.isExponentOf2(n)){var o=this.fftRadix2(r,n,t).as2D(e.shape[0],e.shape[1]);return t&&(o=complex(real(o).div(scalar(n)),imag(o).div(scalar(n)))),o}var a=e.dataSync(),i=splitRealAndImagArrays(this.fourierTransformByMatmul(a,n,t));return complex(i.real,i.imag).as2D(e.shape[0],e.shape[1])},e.prototype.isExponentOf2=function(e){return 0==(e&e-1)},e.prototype.fftRadix2=function(e,t,r){if(1===t)return e;var n=e.dataSync(),o=t/2,a=complexWithEvenIndex(n),i=complex(a.real,a.imag).as1D(),s=complexWithOddIndex(n),u=complex(s.real,s.imag).as1D();i=this.fftRadix2(i,o,r),u=this.fftRadix2(u,o,r);var l=exponents(t,r),c=complex(l.real,l.imag).mul(u),p=i.add(c),d=i.sub(c),h=real(p).concat(real(d)),f=imag(p).concat(imag(d));return complex(h,f).as1D()},e.prototype.fourierTransformByMatmul=function(e,t,r){for(var n=new Float32Array(2*t),o=0;o<t;o++){for(var a=0,i=0,s=0;s<t;s++){var u=exponent(o*s,t,r),l=getComplexWithIndex(e,s);a+=l.real*u.real-l.imag*u.imag,i+=l.real*u.imag+l.imag*u.real}r&&(a/=t,i/=t),assignToTypedArray(n,a,i,o)}return n},e.prototype.depthToSpace=function(e,t,r){assert("NHWC"===r,"Only NHWC dataFormat supported on CPU for depthToSpace. Got "+r),assert(t>1,"blockSize should be > 1 for depthToSpace, but was: "+t);for(var n=e.shape[0],o=e.shape[1],a=e.shape[2],i=e.shape[3],s=o*t,u=a*t,l=i/(t*t),c=e.dataSync(),p=new Float32Array(n*s*u*l),d=0,h=0;h<n;++h)for(var f=0;f<s;++f)for(var m=Math.floor(f/t),g=f%t,v=0;v<u;++v)for(var y=Math.floor(v/t),x=(g*t+v%t)*l,T=0;T<l;++T){var E=T+x+i*(y+a*(m+o*h));p[d++]=c[E]}return tensor4d(p,[n,s,u,l])},e.prototype.broadcastedBinaryOp=function(e,t,r,n){var o=assertAndGetBroadcastShape(e.shape,t.shape),a=buffer(o,r),i=e.dataSync(),s=t.dataSync(),u=getBroadcastDims(e.shape,o),l=getBroadcastDims(t.shape,o),c=a.values;if(u.length+l.length===0)for(var p=0;p<c.length;++p)c[p]=n(i[p%i.length],s[p%s.length]);else{var d=e.buffer(),h=t.buffer(),f=function(r){var o=a.indexToLoc(r),p=o.slice(-e.rank);u.forEach(function(e){return p[e]=0});var f=d.locToIndex(p),m=o.slice(-t.rank);l.forEach(function(e){return m[e]=0});var g=h.locToIndex(m);c[r]=n(i[f],s[g])};for(p=0;p<c.length;++p)f(p)}return a.toTensor()},e.prototype.broadcastedBinaryComplexOp=function(e,t,r){var n=assertAndGetBroadcastShape(e.shape,t.shape),o=buffer(n,"float32"),a=buffer(n,"float32"),i=e.dataSync(),s=t.dataSync(),u=getBroadcastDims(e.shape,n),l=getBroadcastDims(t.shape,n),c=o.values,p=a.values;if(u.length+l.length===0)for(var d=0;d<c.length;d++){var h=d%i.length,f=d%s.length,m=r(i[2*h],i[2*h+1],s[2*f],s[2*f+1]);c[d]=m.real,p[d]=m.imag}else{var g=this.data.get(e.dataId).complexTensors.real.buffer(),v=this.data.get(t.dataId).complexTensors.real.buffer(),y=function(n){var a=o.indexToLoc(n),d=a.slice(-e.rank);u.forEach(function(e){return d[e]=0});var h=g.locToIndex(d),f=a.slice(-t.rank);l.forEach(function(e){return f[e]=0});var m=v.locToIndex(f),y=r(i[2*h],i[2*h+1],s[2*m],s[2*m+1]);c[n]=y.real,p[n]=y.imag};for(d=0;d<c.length;d++)y(d)}return this.complex(o.toTensor(),a.toTensor())},e.prototype.split=function(e,t,r){return split(e,t,r)},e.prototype.dispose=function(){},e.prototype.floatPrecision=function(){return 32},e.prototype.cropAndResize=function(e,t,r,n,o,a){for(var i=e.shape,s=i[0],u=i[1],l=i[2],c=i[3],p=t.shape[0],d=n[0],h=n[1],f=buffer([p,d,h,c]),m=t.dataSync(),g=r.dataSync(),v=e.dataSync(),y=e.strides,x=f.strides,T=0;T<p;T++){var E=4*T,w=m[E],S=m[E+1],b=m[E+2],C=m[E+3],_=g[T];if(!(_>=s))for(var A=d>1?(b-w)*(u-1)/(d-1):0,N=h>1?(C-S)*(l-1)/(h-1):0,R=0;R<d;R++){var I=d>1?w*(u-1)+R*A:.5*(w+b)*(u-1);if(I<0||I>u-1)for(var k=0;k<h;k++)for(var D=0;D<c;D++){var M=D+k*x[2]+R*x[1]+T*x[0];f.values[M]=a}else if("bilinear"===o){var O=Math.floor(I),P=Math.ceil(I),F=I-O;for(k=0;k<h;k++){if((q=h>1?S*(l-1)+k*N:.5*(S+C)*(l-1))<0||q>l-1)for(D=0;D<c;D++){M=D+k*x[2]+R*x[1]+T*x[0];f.values[M]=a}else{var L=Math.floor(q),B=Math.ceil(q),U=q-L;for(D=0;D<c;D++){var z=v[M=D+L*y[2]+O*y[1]+_*y[0]],V=v[M=D+B*y[2]+O*y[1]+_*y[0]],H=v[M=D+L*y[2]+P*y[1]+_*y[0]],G=z+(V-z)*U,W=H+(v[M=D+B*y[2]+P*y[1]+_*y[0]]-H)*U;M=D+k*x[2]+R*x[1]+T*x[0],f.values[M]=G+(W-G)*F}}}}else for(k=0;k<h;++k){var q;if((q=h>1?S*(l-1)+k*N:.5*(S+C)*(l-1))<0||q>l-1)for(D=0;D<c;D++){M=D+k*x[2]+R*x[1]+T*x[0];f.values[M]=a}else{var $=Math.round(q),X=Math.round(I);for(D=0;D<c;D++){var K=D+$*y[2]+X*y[1]+_*y[0],j=D+k*x[2]+R*x[1]+T*x[0];f.values[j]=v[K]}}}}}return f.toTensor()},e.prototype.sparseToDense=function(e,t,r,n){var o=calculateShapes(t,e,r),a=o.sliceRank,i=o.numUpdates,s=o.sliceSize,u=o.strides,l=o.outputSize;return this.scatter(e,t,r,l,s,i,a,u,n,!1)},e.prototype.gatherND=function(e,t){var r=t.shape,n=r[r.length-1],o=prepareAndValidate(e,t),a=o[0],i=o[1],s=o[2],u=o[3];if(0===i)return tensor([],a,e.dtype);for(var l=new TensorBuffer([i,s],e.dtype),c=t.dataSync(),p=e.dataSync(),d=0;d<i;d++){for(var h=[],f=0,m=0;m<n;m++){var g=c[d*n+m];f+=g*u[m],h.push(g)}if(f<0||f>=e.size/s)throw new Error("Invalid indices: "+h+" does not index into "+e.shape);for(var v=0;v<s;v++)l.values[d*s+v]=p[f*s+v]}return l.toTensor().reshape(a)},e.prototype.scatterND=function(e,t,r){var n=calculateShapes(t,e,r),o=n.sliceRank,a=n.numUpdates,i=n.sliceSize,s=n.strides,u=n.outputSize,l=scalar(0);return this.scatter(e,t,r,u,i,a,o,s,l,!0)},e.prototype.scatter=function(e,t,r,n,o,a,i,s,u,l){var c=[n/o,o],p=e.dataSync(),d=t.dataSync();if(0===n)return tensor([],r,t.dtype);var h=new TensorBuffer(c,t.dtype);h.values.fill(u.dataSync()[0]);for(var f=0;f<a;f++){for(var m=[],g=0,v=0;v<i;v++){var y=p[f*i+v];m.push(y),g+=y*s[v]}if(g<0||g>=n/o)throw new Error("Invalid indices: "+m+" does not index into "+r);for(var x=0;x<o;x++)l?h.values[g*o+x]+=d[f*o+x]:h.values[g*o+x]=0===t.rank?d[0]:d[f*o+x]}return h.toTensor().reshape(r)},e}();ENV.registerBackend("cpu",function(){return new MathBackendCPU},1,setTensorTracker);var delayCallback="undefined"!=typeof requestAnimationFrame?requestAnimationFrame:setImmediate;function nextFrame(){return new Promise(function(e){return delayCallback(function(){return e()})})}var DTYPE_VALUE_SIZE_MAP={float32:4,int32:4,uint16:2,uint8:1,bool:1};function encodeWeights(e){return __awaiter(this,void 0,void 0,function(){var t,r,n,o;return __generator(this,function(a){switch(a.label){case 0:for(n in t=[],r=[],e){if("float32"!==(o=e[n]).dtype&&"int32"!==o.dtype&&"bool"!==o.dtype)throw new Error("Unsupported dtype in weight '"+n+"': "+o.dtype);t.push({name:n,shape:o.shape,dtype:o.dtype}),r.push(o.data())}return[4,Promise.all(r)];case 1:return[2,{data:concatenateTypedArrays(a.sent()),specs:t}]}})})}function decodeWeights(e,t){for(var r={},n=0,o=function(t){var o=t.name,a=t.dtype,i=t.shape,s=sizeFromShape(i),u=void 0;if("quantization"in t){var l=t.quantization;if("uint8"!==l.dtype&&"uint16"!==l.dtype)throw new Error("Weight "+t.name+" has unknown quantization dtype "+l.dtype+". Supported quantization dtypes are: 'uint8' and 'uint16'.");var c=DTYPE_VALUE_SIZE_MAP[l.dtype],p=e.slice(n,n+s*c),d="uint8"===l.dtype?new Uint8Array(p):new Uint16Array(p);if("float32"===a)u=Float32Array.from(d,function(e){return e*l.scale+l.min});else{if("int32"!==a)throw new Error("Unsupported dtype in weight '"+o+"': "+a);u=Int32Array.from(d,function(e){return Math.round(e*l.scale+l.min)})}n+=s*c}else{var h=DTYPE_VALUE_SIZE_MAP[a];p=e.slice(n,n+s*h);if("float32"===a)u=new Float32Array(p);else if("int32"===a)u=new Int32Array(p);else{if("bool"!==a)throw new Error("Unsupported dtype in weight '"+o+"': "+a);u=new Uint8Array(p)}n+=s*h}var f=void 0;if("float32"===a)f=tensor(u,i,"float32");else if("int32"===a)f=tensor(u,i,"int32");else{if("bool"!==a)throw new Error("Unsupported dtype in weight '"+o+"': "+a);f=tensor(u,i,"bool")}r[o]=f},a=0,i=t;a<i.length;a++){o(i[a])}return r}function concatenateTypedArrays(e){if(null===e)throw new Error("Invalid input value: "+JSON.stringify(e));var t=0,r=[];e.forEach(function(e){if(t+=e.byteLength,r.push(e.byteLength===e.buffer.byteLength?e:new e.constructor(e)),!(e instanceof Float32Array||e instanceof Int32Array||e instanceof Uint8Array))throw new Error("Unsupported TypedArray subtype: "+e.constructor.name)});var n=new Uint8Array(t),o=0;return r.forEach(function(e){n.set(new Uint8Array(e.buffer),o),o+=e.byteLength}),n.buffer}var useNodeBuffer="undefined"!=typeof Buffer&&("undefined"==typeof Blob||"undefined"==typeof atob||"undefined"==typeof btoa);function stringByteLength(e){return useNodeBuffer?Buffer.byteLength(e):new Blob([e]).size}function arrayBufferToBase64String(e){return useNodeBuffer?Buffer.from(e).toString("base64"):btoa(String.fromCharCode.apply(null,new Uint8Array(e)))}function base64StringToArrayBuffer(e){if(useNodeBuffer){var t=Buffer.from(e,"base64");return t.buffer.slice(t.byteOffset,t.byteOffset+t.byteLength)}for(var r=atob(e),n=new Uint8Array(r.length),o=0;o<r.length;++o)n.set([r.charCodeAt(o)],o);return n.buffer}function concatenateArrayBuffers(e){var t=0;e.forEach(function(e){t+=e.byteLength});var r=new Uint8Array(t),n=0;return e.forEach(function(e){r.set(new Uint8Array(e),n),n+=e.byteLength}),r.buffer}function basename(e){for(e=e.trim();e.endsWith("/");)e=e.slice(0,e.length-1);var t=e.split("/");return t[t.length-1]}function getModelArtifactsInfoForJSON(e){if(e.modelTopology instanceof ArrayBuffer)throw new Error("Expected JSON model topology, received ArrayBuffer.");return{dateSaved:new Date,modelTopologyType:"JSON",modelTopologyBytes:null==e.modelTopology?0:stringByteLength(JSON.stringify(e.modelTopology)),weightSpecsBytes:null==e.weightSpecs?0:stringByteLength(JSON.stringify(e.weightSpecs)),weightDataBytes:null==e.weightData?0:e.weightData.byteLength}}var IORouterRegistry=function(){function e(){this.saveRouters=[],this.loadRouters=[]}return e.getInstance=function(){return null==e.instance&&(e.instance=new e),e.instance},e.registerSaveRouter=function(t){e.getInstance().saveRouters.push(t)},e.registerLoadRouter=function(t){e.getInstance().loadRouters.push(t)},e.getSaveHandlers=function(t){return e.getHandlers(t,"save")},e.getLoadHandlers=function(t){return e.getHandlers(t,"load")},e.getHandlers=function(e,t){var r=[];return("load"===t?this.getInstance().loadRouters:this.getInstance().saveRouters).forEach(function(t){var n=t(e);null!==n&&r.push(n)}),r},e}(),URL_SCHEME_SUFFIX="://",ModelStoreManagerRegistry=function(){function e(){this.managers={}}return e.getInstance=function(){return null==e.instance&&(e.instance=new e),e.instance},e.registerManager=function(t,r){assert(null!=t,"scheme must not be undefined or null."),t.endsWith(URL_SCHEME_SUFFIX)&&(t=t.slice(0,t.indexOf(URL_SCHEME_SUFFIX))),assert(t.length>0,"scheme must not be an empty string.");var n=e.getInstance();assert(null==n.managers[t],"A model store manager is already registered for scheme '"+t+"'."),n.managers[t]=r},e.getManager=function(e){var t=this.getInstance().managers[e];if(null==t)throw new Error("Cannot find model manager for scheme '"+e+"'");return t},e.getSchemes=function(){return Object.keys(this.getInstance().managers)},e}();function parseURL(e){if(-1===e.indexOf(URL_SCHEME_SUFFIX))throw new Error("The url string provided does not contain a scheme. Supported schemes are: "+ModelStoreManagerRegistry.getSchemes().join(","));return{scheme:e.split(URL_SCHEME_SUFFIX)[0],path:e.split(URL_SCHEME_SUFFIX)[1]}}function cloneModelInternal(e,t,r){return void 0===r&&(r=!1),__awaiter(this,void 0,void 0,function(){var n,o,a,i,s,u,l,c,p;return __generator(this,function(d){switch(d.label){case 0:return assert(e!==t,"Old path and new path are the same: '"+e+"'"),assert((n=IORouterRegistry.getLoadHandlers(e)).length>0,"Copying failed because no load handler is found for source URL "+e+"."),assert(n.length<2,"Copying failed because more than one ("+n.length+") load handlers for source URL "+e+"."),o=n[0],assert((a=IORouterRegistry.getSaveHandlers(t)).length>0,"Copying failed because no save handler is found for destination URL "+t+"."),assert(a.length<2,"Copying failed because more than one ("+n.length+") save handlers for destination URL "+t+"."),i=a[0],s=parseURL(e).scheme,u=parseURL(e).path,l=s===parseURL(e).scheme,[4,o.load()];case 1:return c=d.sent(),r&&l?[4,ModelStoreManagerRegistry.getManager(s).removeModel(u)]:[3,3];case 2:d.sent(),d.label=3;case 3:return[4,i.save(c)];case 4:return p=d.sent(),!r||l?[3,6]:[4,ModelStoreManagerRegistry.getManager(s).removeModel(u)];case 5:d.sent(),d.label=6;case 6:return[2,p.modelArtifactsInfo]}})})}function listModels(){return __awaiter(this,void 0,void 0,function(){var e,t,r,n,o,a,i;return __generator(this,function(s){switch(s.label){case 0:e=ModelStoreManagerRegistry.getSchemes(),t={},r=0,n=e,s.label=1;case 1:return r<n.length?(o=n[r],[4,ModelStoreManagerRegistry.getManager(o).listModels()]):[3,4];case 2:for(i in a=s.sent())t[o+URL_SCHEME_SUFFIX+i]=a[i];s.label=3;case 3:return r++,[3,1];case 4:return[2,t]}})})}function removeModel(e){return __awaiter(this,void 0,void 0,function(){var t;return __generator(this,function(r){switch(r.label){case 0:return t=parseURL(e),[4,ModelStoreManagerRegistry.getManager(t.scheme).removeModel(t.path)];case 1:return[2,r.sent()]}})})}function copyModel(e,t){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(r){switch(r.label){case 0:return[4,cloneModelInternal(e,t,!1)];case 1:return[2,r.sent()]}})})}function moveModel(e,t){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(r){switch(r.label){case 0:return[4,cloneModelInternal(e,t,!0)];case 1:return[2,r.sent()]}})})}var DATABASE_NAME="tensorflowjs",DATABASE_VERSION=1,MODEL_STORE_NAME="models_store",INFO_STORE_NAME="model_info_store";function getIndexedDBFactory(){if(!ENV.get("IS_BROWSER"))throw new Error("Failed to obtain IndexedDB factory because the current environmentis not a web browser.");var e=window,t=e.indexedDB||e.mozIndexedDB||e.webkitIndexedDB||e.msIndexedDB||e.shimIndexedDB;if(null==t)throw new Error("The current browser does not appear to support IndexedDB.");return t}function setUpDatabase(e){var t=e.result;t.createObjectStore(MODEL_STORE_NAME,{keyPath:"modelPath"}),t.createObjectStore(INFO_STORE_NAME,{keyPath:"modelPath"})}var BrowserIndexedDB=function(){function e(e){if(this.indexedDB=getIndexedDBFactory(),null==e||!e)throw new Error("For IndexedDB, modelPath must not be null, undefined or empty.");this.modelPath=e}return e.prototype.save=function(e){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(t){if(e.modelTopology instanceof ArrayBuffer)throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");return[2,this.databaseAction(this.modelPath,e)]})})},e.prototype.load=function(){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(e){return[2,this.databaseAction(this.modelPath)]})})},e.prototype.databaseAction=function(e,t){var r=this;return new Promise(function(e,n){var o=r.indexedDB.open(DATABASE_NAME,DATABASE_VERSION);o.onupgradeneeded=function(){return setUpDatabase(o)},o.onsuccess=function(){var a=o.result;if(null==t){var i=a.transaction(MODEL_STORE_NAME,"readonly"),s=i.objectStore(MODEL_STORE_NAME).get(r.modelPath);s.onsuccess=function(){if(null==s.result)return a.close(),n(new Error("Cannot find model with path '"+r.modelPath+"' in IndexedDB."));e(s.result.modelArtifacts)},s.onerror=function(e){return a.close(),n(s.error)},i.oncomplete=function(){return a.close()}}else{var u,l=getModelArtifactsInfoForJSON(t),c=a.transaction(INFO_STORE_NAME,"readwrite"),p=c.objectStore(INFO_STORE_NAME),d=p.put({modelPath:r.modelPath,modelArtifactsInfo:l});d.onsuccess=function(){var o=(u=a.transaction(MODEL_STORE_NAME,"readwrite")).objectStore(MODEL_STORE_NAME).put({modelPath:r.modelPath,modelArtifacts:t,modelArtifactsInfo:l});o.onsuccess=function(){return e({modelArtifactsInfo:l})},o.onerror=function(e){var t=(p=c.objectStore(INFO_STORE_NAME)).delete(r.modelPath);t.onsuccess=function(){return a.close(),n(o.error)},t.onerror=function(e){return a.close(),n(o.error)}}},d.onerror=function(e){return a.close(),n(d.error)},c.oncomplete=function(){null==u?a.close():u.oncomplete=function(){return a.close()}}}},o.onerror=function(e){return n(o.error)}})},e.URL_SCHEME="indexeddb://",e}(),indexedDBRouter=function(e){return ENV.get("IS_BROWSER")&&!Array.isArray(e)&&e.startsWith(BrowserIndexedDB.URL_SCHEME)?browserIndexedDB(e.slice(BrowserIndexedDB.URL_SCHEME.length)):null};function browserIndexedDB(e){return new BrowserIndexedDB(e)}function maybeStripScheme(e){return e.startsWith(BrowserIndexedDB.URL_SCHEME)?e.slice(BrowserIndexedDB.URL_SCHEME.length):e}IORouterRegistry.registerSaveRouter(indexedDBRouter),IORouterRegistry.registerLoadRouter(indexedDBRouter);var BrowserIndexedDBManager=function(){function e(){this.indexedDB=getIndexedDBFactory()}return e.prototype.listModels=function(){return __awaiter(this,void 0,void 0,function(){var e=this;return __generator(this,function(t){return[2,new Promise(function(t,r){var n=e.indexedDB.open(DATABASE_NAME,DATABASE_VERSION);n.onupgradeneeded=function(){return setUpDatabase(n)},n.onsuccess=function(){var e=n.result,o=e.transaction(INFO_STORE_NAME,"readonly"),a=o.objectStore(INFO_STORE_NAME).getAll();a.onsuccess=function(){for(var e={},r=0,n=a.result;r<n.length;r++){var o=n[r];e[o.modelPath]=o.modelArtifactsInfo}t(e)},a.onerror=function(t){return e.close(),r(a.error)},o.oncomplete=function(){return e.close()}},n.onerror=function(e){return r(n.error)}})]})})},e.prototype.removeModel=function(e){return __awaiter(this,void 0,void 0,function(){var t=this;return __generator(this,function(r){return e=maybeStripScheme(e),[2,new Promise(function(r,n){var o=t.indexedDB.open(DATABASE_NAME,DATABASE_VERSION);o.onupgradeneeded=function(){return setUpDatabase(o)},o.onsuccess=function(){var t,a=o.result,i=a.transaction(INFO_STORE_NAME,"readwrite"),s=i.objectStore(INFO_STORE_NAME),u=s.get(e);u.onsuccess=function(){if(null==u.result)return a.close(),n(new Error("Cannot find model with path '"+e+"' in IndexedDB."));var o=s.delete(e),i=function(){var o=(t=a.transaction(MODEL_STORE_NAME,"readwrite")).objectStore(MODEL_STORE_NAME).delete(e);o.onsuccess=function(){return r(u.result.modelArtifactsInfo)},o.onerror=function(e){return n(u.error)}};o.onsuccess=i,o.onerror=function(e){return i(),a.close(),n(u.error)}},u.onerror=function(e){return a.close(),n(u.error)},i.oncomplete=function(){null==t?a.close():t.oncomplete=function(){return a.close()}}},o.onerror=function(e){return n(o.error)}})]})})},e}();if(ENV.get("IS_BROWSER"))try{ModelStoreManagerRegistry.registerManager(BrowserIndexedDB.URL_SCHEME,new BrowserIndexedDBManager)}catch(e){}var PATH_SEPARATOR="/",PATH_PREFIX="tensorflowjs_models",INFO_SUFFIX="info",MODEL_TOPOLOGY_SUFFIX="model_topology",WEIGHT_SPECS_SUFFIX="weight_specs",WEIGHT_DATA_SUFFIX="weight_data";function getModelKeys(e){return{info:[PATH_PREFIX,e,INFO_SUFFIX].join(PATH_SEPARATOR),topology:[PATH_PREFIX,e,MODEL_TOPOLOGY_SUFFIX].join(PATH_SEPARATOR),weightSpecs:[PATH_PREFIX,e,WEIGHT_SPECS_SUFFIX].join(PATH_SEPARATOR),weightData:[PATH_PREFIX,e,WEIGHT_DATA_SUFFIX].join(PATH_SEPARATOR)}}function getModelPathFromKey(e){var t=e.split(PATH_SEPARATOR);if(t.length<3)throw new Error("Invalid key format: "+e);return t.slice(1,t.length-1).join(PATH_SEPARATOR)}function maybeStripScheme$1(e){return e.startsWith(BrowserLocalStorage.URL_SCHEME)?e.slice(BrowserLocalStorage.URL_SCHEME.length):e}var BrowserLocalStorage=function(){function e(e){if(!ENV.get("IS_BROWSER")||void 0===window.localStorage)throw new Error("The current environment does not support local storage.");if(this.LS=window.localStorage,null==e||!e)throw new Error("For local storage, modelPath must not be null, undefined or empty.");this.modelPath=e,this.keys=getModelKeys(this.modelPath)}return e.prototype.save=function(e){return __awaiter(this,void 0,void 0,function(){var t,r,n,o;return __generator(this,function(a){if(e.modelTopology instanceof ArrayBuffer)throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");t=JSON.stringify(e.modelTopology),r=JSON.stringify(e.weightSpecs),n=getModelArtifactsInfoForJSON(e);try{return this.LS.setItem(this.keys.info,JSON.stringify(n)),this.LS.setItem(this.keys.topology,t),this.LS.setItem(this.keys.weightSpecs,r),this.LS.setItem(this.keys.weightData,arrayBufferToBase64String(e.weightData)),[2,{modelArtifactsInfo:n}]}catch(e){for(o in this.keys)this.LS.removeItem(this.keys[o]);throw new Error("Failed to save model '"+this.modelPath+"' to local storage: size quota being exceeded is a possible cause of this failure: modelTopologyBytes="+n.modelTopologyBytes+", weightSpecsBytes="+n.weightSpecsBytes+", weightDataBytes="+n.weightDataBytes+".")}return[2]})})},e.prototype.load=function(){return __awaiter(this,void 0,void 0,function(){var e,t,r,n,o;return __generator(this,function(a){if(null==(e=JSON.parse(this.LS.getItem(this.keys.info))))throw new Error("In local storage, there is no model with name '"+this.modelPath+"'");if("JSON"!==e.modelTopologyType)throw new Error("BrowserLocalStorage does not support loading non-JSON model topology yet.");if(t={},null==(r=JSON.parse(this.LS.getItem(this.keys.topology))))throw new Error("In local storage, the topology of model '"+this.modelPath+"' is missing.");if(t.modelTopology=r,null==(n=JSON.parse(this.LS.getItem(this.keys.weightSpecs))))throw new Error("In local storage, the weight specs of model '"+this.modelPath+"' are missing.");if(t.weightSpecs=n,null==(o=this.LS.getItem(this.keys.weightData)))throw new Error("In local storage, the binary weight values of model '"+this.modelPath+"' are missing.");return t.weightData=base64StringToArrayBuffer(o),[2,t]})})},e.URL_SCHEME="localstorage://",e}(),localStorageRouter=function(e){return ENV.get("IS_BROWSER")&&!Array.isArray(e)&&e.startsWith(BrowserLocalStorage.URL_SCHEME)?browserLocalStorage(e.slice(BrowserLocalStorage.URL_SCHEME.length)):null};function browserLocalStorage(e){return new BrowserLocalStorage(e)}IORouterRegistry.registerSaveRouter(localStorageRouter),IORouterRegistry.registerLoadRouter(localStorageRouter);var BrowserLocalStorageManager=function(){function e(){assert(ENV.get("IS_BROWSER"),"Current environment is not a web browser"),assert(void 0!==window.localStorage,"Current browser does not appear to support localStorage"),this.LS=window.localStorage}return e.prototype.listModels=function(){return __awaiter(this,void 0,void 0,function(){var e,t,r,n,o,a;return __generator(this,function(i){for(e={},t=PATH_PREFIX+PATH_SEPARATOR,r=PATH_SEPARATOR+INFO_SUFFIX,n=0;n<this.LS.length;++n)(o=this.LS.key(n)).startsWith(t)&&o.endsWith(r)&&(a=getModelPathFromKey(o),e[a]=JSON.parse(this.LS.getItem(o)));return[2,e]})})},e.prototype.removeModel=function(e){return __awaiter(this,void 0,void 0,function(){var t,r;return __generator(this,function(n){if(e=maybeStripScheme$1(e),t=getModelKeys(e),null==this.LS.getItem(t.info))throw new Error("Cannot find model at path '"+e+"'");return r=JSON.parse(this.LS.getItem(t.info)),this.LS.removeItem(t.info),this.LS.removeItem(t.topology),this.LS.removeItem(t.weightSpecs),this.LS.removeItem(t.weightData),[2,r]})})},e}();if(ENV.get("IS_BROWSER"))try{ModelStoreManagerRegistry.registerManager(BrowserLocalStorage.URL_SCHEME,new BrowserLocalStorageManager)}catch(e){}var DEFAULT_FILE_NAME_PREFIX="model",DEFAULT_JSON_EXTENSION_NAME=".json",DEFAULT_WEIGHT_DATA_EXTENSION_NAME=".weights.bin",BrowserDownloads=function(){function e(t){if(!ENV.get("IS_BROWSER"))throw new Error("triggerDownloads() cannot proceed because the current environment is not a browser.");t.startsWith(e.URL_SCHEME)&&(t=t.slice(e.URL_SCHEME.length)),null!=t&&0!==t.length||(t=DEFAULT_FILE_NAME_PREFIX),this.modelTopologyFileName=t+DEFAULT_JSON_EXTENSION_NAME,this.weightDataFileName=t+DEFAULT_WEIGHT_DATA_EXTENSION_NAME}return e.prototype.save=function(e){return __awaiter(this,void 0,void 0,function(){var t,r,n,o,a,i;return __generator(this,function(s){if(t=window.URL.createObjectURL(new Blob([e.weightData],{type:"application/octet-stream"})),e.modelTopology instanceof ArrayBuffer)throw new Error("DownloadTrigger.save() does not support saving model topology in binary formats yet.");return r=[{paths:["./"+this.weightDataFileName],weights:e.weightSpecs}],n={modelTopology:e.modelTopology,weightsManifest:r},o=window.URL.createObjectURL(new Blob([JSON.stringify(n)],{type:"application/json"})),(a=null==this.jsonAnchor?document.createElement("a"):this.jsonAnchor).download=this.modelTopologyFileName,a.href=o,a.click(),null!=e.weightData&&((i=null==this.weightDataAnchor?document.createElement("a"):this.weightDataAnchor).download=this.weightDataFileName,i.href=t,i.click()),[2,{modelArtifactsInfo:getModelArtifactsInfoForJSON(e)}]})})},e.URL_SCHEME="downloads://",e}(),BrowserFiles=function(){function e(e){if(null==e||e.length<1)throw new Error("When calling browserFiles, at least 1 file is required, but received "+e);this.files=e}return e.prototype.load=function(){return __awaiter(this,void 0,void 0,function(){var e,t,r=this;return __generator(this,function(n){return e=this.files[0],t=this.files.slice(1),[2,new Promise(function(n,o){var a=new FileReader;a.onload=function(a){var i=JSON.parse(a.target.result),s=i.modelTopology;if(null!=s){0===t.length&&n({modelTopology:s});var u=i.weightsManifest;if(null!=u){var l;try{l=r.checkManifestAndWeightFiles(u,t)}catch(e){return void o(e)}var c=[],p=[],d=[];u.forEach(function(e){e.paths.forEach(function(e){p.push(e),d.push(null)}),c.push.apply(c,e.weights)}),u.forEach(function(e){e.paths.forEach(function(e){var t=new FileReader;t.onload=function(t){var r=t.target.result,o=p.indexOf(e);d[o]=r,-1===d.indexOf(null)&&n({modelTopology:s,weightSpecs:c,weightData:concatenateArrayBuffers(d)})},t.onerror=function(t){o("Failed to weights data from file of path '"+e+"'.")},t.readAsArrayBuffer(l[e])})})}else o(new Error("weightManifest field is missing from file "+e.name))}else o(new Error("modelTopology field is missing from file "+e.name))},a.onerror=function(t){o("Failed to read model topology and weights manifest JSON from file '"+e.name+"'. BrowserFiles supports loading Keras-style tf.Model artifacts only.")},a.readAsText(e)})]})})},e.prototype.checkManifestAndWeightFiles=function(e,t){for(var r=[],n=t.map(function(e){return basename(e.name)}),o={},a=0,i=e;a<i.length;a++){i[a].paths.forEach(function(e){var a=basename(e);if(-1!==r.indexOf(a))throw new Error("Duplicate file basename found in weights manifest: '"+a+"'");if(r.push(a),-1===n.indexOf(a))throw new Error("Weight file with basename '"+a+"' is not provided.");o[e]=t[n.indexOf(a)]})}if(r.length!==t.length)throw new Error("Mismatch in the number of files in weights manifest ("+r.length+") and the number of weight files provided ("+t.length+").");return o},e}(),browserDownloadsRouter=function(e){return ENV.get("IS_BROWSER")&&!Array.isArray(e)&&e.startsWith(BrowserDownloads.URL_SCHEME)?browserDownloads(e.slice(BrowserDownloads.URL_SCHEME.length)):null};function browserDownloads(e){return void 0===e&&(e="model"),new BrowserDownloads(e)}function browserFiles(e){return new BrowserFiles(e)}function loadWeightsAsArrayBuffer(e,t){return __awaiter(this,void 0,void 0,function(){var r,n;return __generator(this,function(o){switch(o.label){case 0:return r=e.map(function(e){return fetch(e,t)}),[4,Promise.all(r)];case 1:return n=o.sent(),[4,Promise.all(n.map(function(e){return e.arrayBuffer()}))];case 2:return[2,o.sent()]}})})}function loadWeights(e,t,r,n){return void 0===t&&(t=""),__awaiter(this,void 0,void 0,function(){var o,a,i,s,u,l,c,p,d,h;return __generator(this,function(f){switch(f.label){case 0:if(o=e.map(function(){return!1}),a={},i=null!=r?r.map(function(){return!1}):[],s=[],e.forEach(function(e,t){var n=0;e.weights.forEach(function(e){var u="quantization"in e?e.quantization.dtype:e.dtype,l=DTYPE_VALUE_SIZE_MAP[u]*sizeFromShape(e.shape),c=function(){o[t]=!0,null==a[t]&&(a[t]=[]),a[t].push({manifestEntry:e,groupOffset:n,sizeBytes:l})};null!=r?r.forEach(function(t,r){t===e.name&&(c(),i[r]=!0)}):c(),s.push(e.name),n+=l})}),!i.every(function(e){return e}))throw u=r.filter(function(e,t){return!i[t]}),new Error("Could not find weights in manifest with names: "+u.join(", ")+". \nManifest JSON has weights with names: "+s.join(", ")+".");return l=o.reduce(function(e,t,r){return t&&e.push(r),e},[]),c=[],l.forEach(function(r){e[r].paths.forEach(function(e){var r=t+(t.endsWith("/")?"":"/")+e;c.push(r)})}),[4,loadWeightsAsArrayBuffer(c,n)];case 1:return p=f.sent(),d={},h=0,l.forEach(function(t){for(var r=e[t].paths.length,n=0,o=0;o<r;o++)n+=p[h+o].byteLength;for(var i=new ArrayBuffer(n),s=new Uint8Array(i),u=0,l=0;l<r;l++){var c=new Uint8Array(p[h+l]);s.set(c,u),u+=c.byteLength}a[t].forEach(function(e){var t=decodeWeights(i.slice(e.groupOffset,e.groupOffset+e.sizeBytes),[e.manifestEntry]);for(var r in t)d[r]=t[r]}),h+=r}),[2,d]}})})}IORouterRegistry.registerSaveRouter(browserDownloadsRouter);var BrowserHTTPRequest=function(){function e(e,t,r){if(this.weightPathPrefix=r,this.DEFAULT_METHOD="POST","undefined"==typeof fetch)throw new Error("browserHTTPRequest is not supported outside the web browser without a fetch polyfill.");if(assert(null!=e&&e.length>0,"URL path for browserHTTPRequest must not be null, undefined or empty."),Array.isArray(e)&&assert(2===e.length,"URL paths for browserHTTPRequest must have a length of 2, (actual length is "+e.length+")."),this.path=e,null!=t&&null!=t.body)throw new Error("requestInit is expected to have no pre-existing body, but has one.");this.requestInit=t||{}}return e.prototype.save=function(e){return __awaiter(this,void 0,void 0,function(){var t,r,n,o;return __generator(this,function(a){switch(a.label){case 0:if(e.modelTopology instanceof ArrayBuffer)throw new Error("BrowserHTTPRequest.save() does not support saving model topology in binary formats yet.");return(t=Object.assign({method:this.DEFAULT_METHOD},this.requestInit)).body=new FormData,r=[{paths:["./model.weights.bin"],weights:e.weightSpecs}],n={modelTopology:e.modelTopology,weightsManifest:r},t.body.append("model.json",new Blob([JSON.stringify(n)],{type:"application/json"}),"model.json"),null!=e.weightData&&t.body.append("model.weights.bin",new Blob([e.weightData],{type:"application/octet-stream"}),"model.weights.bin"),[4,fetch(this.path,t)];case 1:if((o=a.sent()).ok)return[2,{modelArtifactsInfo:getModelArtifactsInfoForJSON(e),responses:[o]}];throw new Error("BrowserHTTPRequest.save() failed due to HTTP response status "+o.status+".")}})})},e.prototype.load=function(){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(e){return[2,Array.isArray(this.path)?this.loadBinaryModel():this.loadJSONModel()]})})},e.prototype.loadBinaryTopology=function(){return __awaiter(this,void 0,void 0,function(){var e,t;return __generator(this,function(r){switch(r.label){case 0:return r.trys.push([0,3,,4]),[4,fetch(this.path[0],this.requestInit)];case 1:if(!(e=r.sent()).ok)throw new Error("BrowserHTTPRequest.load() failed due to HTTP response: "+e.statusText);return[4,e.arrayBuffer()];case 2:return[2,r.sent()];case 3:throw t=r.sent(),new Error(this.path[0]+" not found. "+t);case 4:return[2]}})})},e.prototype.loadBinaryModel=function(){return __awaiter(this,void 0,void 0,function(){var e,t,r,n,o,a,i,s;return __generator(this,function(u){switch(u.label){case 0:return e=this.loadBinaryTopology(),[4,fetch(this.path[1],this.requestInit)];case 1:if(!(t=u.sent()).ok)throw new Error("BrowserHTTPRequest.load() failed due to HTTP response: "+t.statusText);return[4,Promise.all([e,t])];case 2:return r=u.sent(),n=r[0],[4,r[1].json()];case 3:return null==(o=u.sent())?[3,5]:[4,this.loadWeights(o)];case 4:s=u.sent(),a=s[0],i=s[1],u.label=5;case 5:return[2,{modelTopology:n,weightSpecs:a,weightData:i}]}})})},e.prototype.loadJSONModel=function(){return __awaiter(this,void 0,void 0,function(){var e,t,r,n,o,a,i,s;return __generator(this,function(u){switch(u.label){case 0:return[4,fetch(this.path,this.requestInit)];case 1:if(!(e=u.sent()).ok)throw new Error("BrowserHTTPRequest.load() failed due to HTTP response: "+e.statusText);return[4,e.json()];case 2:if(t=u.sent(),r=t.modelTopology,n=t.weightsManifest,null==r&&null==n)throw new Error("The JSON from HTTP path "+this.path+" contains neither model topology or manifest for weights.");return null==n?[3,4]:(i=t.weightsManifest,[4,this.loadWeights(i)]);case 3:s=u.sent(),o=s[0],a=s[1],u.label=4;case 4:return[2,{modelTopology:r,weightSpecs:o,weightData:a}]}})})},e.prototype.loadWeights=function(e){return __awaiter(this,void 0,void 0,function(){var t,r,n,o,a,i,s,u,l,c,p,d;return __generator(this,function(h){switch(h.label){case 0:for(t=Array.isArray(this.path)?this.path[1]:this.path,r=parseUrl(t),n=r[0],o=r[1],a=this.weightPathPrefix||n,i=[],s=0,u=e;s<u.length;s++)l=u[s],i.push.apply(i,l.weights);return c=[],e.forEach(function(e){e.paths.forEach(function(e){c.push(a+e+o)})}),p=[i],d=concatenateArrayBuffers,[4,loadWeightsAsArrayBuffer(c,this.requestInit)];case 1:return[2,p.concat([d.apply(void 0,[h.sent()])])]}})})},e.URL_SCHEME_REGEX=/^https?:\/\//,e}();function parseUrl(e){var t=e.lastIndexOf("/"),r=e.lastIndexOf("?");return[e.substring(0,t)+"/",r>t?e.substring(r):""]}function isHTTPScheme(e){return null!=e.match(BrowserHTTPRequest.URL_SCHEME_REGEX)}var httpRequestRouter=function(e){if("undefined"==typeof fetch)return null;return(Array.isArray(e)?e.every(function(e){return isHTTPScheme(e)}):isHTTPScheme(e))?browserHTTPRequest(e):null};function browserHTTPRequest(e,t,r){return new BrowserHTTPRequest(e,t,r)}IORouterRegistry.registerSaveRouter(httpRequestRouter),IORouterRegistry.registerLoadRouter(httpRequestRouter);var PassthroughLoader=function(){function e(e,t,r){this.modelTopology=e,this.weightSpecs=t,this.weightData=r}return e.prototype.load=function(){return __awaiter(this,void 0,void 0,function(){var e;return __generator(this,function(t){return e={},null!=this.modelTopology&&(e=__assign({modelTopology:this.modelTopology},e)),null!=this.weightSpecs&&this.weightSpecs.length>0&&(e=__assign({weightSpecs:this.weightSpecs},e)),null!=this.weightData&&this.weightData.byteLength>0&&(e=__assign({weightData:this.weightData},e)),[2,e]})})},e}(),PassthroughSaver=function(){function e(e){this.saveHandler=e}return e.prototype.save=function(e){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(t){return[2,this.saveHandler(e)]})})},e}();function fromMemory(e,t,r){return new PassthroughLoader(e,t,r)}function withSaveHandler(e){return new PassthroughSaver(e)}var registerSaveRouter=IORouterRegistry.registerSaveRouter,registerLoadRouter=IORouterRegistry.registerLoadRouter,getSaveHandlers=IORouterRegistry.getSaveHandlers,getLoadHandlers=IORouterRegistry.getLoadHandlers,io=Object.freeze({browserFiles:browserFiles,browserHTTPRequest:browserHTTPRequest,concatenateArrayBuffers:concatenateArrayBuffers,decodeWeights:decodeWeights,encodeWeights:encodeWeights,fromMemory:fromMemory,getLoadHandlers:getLoadHandlers,getModelArtifactsInfoForJSON:getModelArtifactsInfoForJSON,getSaveHandlers:getSaveHandlers,loadWeights:loadWeights,registerLoadRouter:registerLoadRouter,registerSaveRouter:registerSaveRouter,withSaveHandler:withSaveHandler,copyModel:copyModel,listModels:listModels,moveModel:moveModel,removeModel:removeModel});function confusionMatrix_(e,t,r){var n=convertToTensor(e,"label","confusionMatrix","int32"),o=convertToTensor(t,"label","confusionMatrix","int32");assert(null==r||r>0&&Number.isInteger(r),"If provided, numClasses must be a positive integer, but got "+r),assert(1===n.rank,"Expected the rank of labels to be 1, but got "+n.rank),assert(1===o.rank,"Expected the rank of predictions to be 1, but got "+o.rank),assert(n.shape[0]===o.shape[0],"Mismatch in the number of examples: "+n.shape[0]+" vs. "+o.shape[0]+". Labels and predictions should have the same number of elements."),assert(r>0&&Number.isInteger(r),"numClasses is required to be a positive integer, but got "+r);var a=oneHot(n.asType("int32"),r),i=oneHot(o.asType("int32"),r);return a.transpose().matMul(i).asType("int32")}var confusionMatrix=op({confusionMatrix_:confusionMatrix_}),math=Object.freeze({confusionMatrix:confusionMatrix}),Serializable=function(){function e(){}return e.prototype.getClassName=function(){return this.constructor.className},e.fromConfig=function(e,t){return new e(t)},e}(),SerializationMap=function(){function e(){this.classNameMap={}}return e.getMap=function(){return null==e.instance&&(e.instance=new e),e.instance},e.register=function(t){e.getMap().classNameMap[t.className]=[t,t.fromConfig]},e}();function registerClass(e){assert(null!=e.className,"Class being registered does not have the static className property defined."),assert("string"==typeof e.className,"className is required to be a string, but got type "+typeof e.className),assert(e.className.length>0,"Class being registered has an empty-string as its className, which is disallowed."),SerializationMap.register(e)}var serialization=Object.freeze({Serializable:Serializable,SerializationMap:SerializationMap,registerClass:registerClass}),WEBGL_ENVS={HAS_WEBGL:!0},NODE_ENVS={IS_NODE:!0},CHROME_ENVS={IS_CHROME:!0},BROWSER_ENVS={IS_BROWSER:!0},CPU_ENVS={HAS_WEBGL:!1},BROWSER_CPU_ENVS={BACKEND:"test-cpu"},ALL_ENVS={};function expectArraysClose(e,t,r){if(null==r&&(r=ENV.get("TEST_EPSILON")),e instanceof Tensor||t instanceof Tensor){if(e instanceof Tensor&&t instanceof Tensor){if(e.dtype!==t.dtype)throw new Error("Arrays are of different type actual: "+e.dtype+" vs expected: "+t.dtype+".");if(!arraysEqual(e.shape,t.shape))throw new Error("Arrays are of different shape actual: "+e.shape+" vs expected: "+t.shape+".")}}else{var n=e.constructor.name,o=t.constructor.name;if(n!==o)throw new Error("Arrays are of different type actual: "+n+" vs expected: "+o)}var a,i;if(a=e instanceof Tensor?e.dataSync():e,i=t instanceof Tensor?t.dataSync():t,a.length!==i.length)throw new Error("Arrays have different lengths actual: "+a.length+" vs expected: "+i.length+".\nActual:   "+a+".\nExpected: "+i+".");for(var s=0;s<i.length;++s){var u=a[s],l=i[s];if(!areClose(u,Number(l),r))throw new Error("Arrays differ: actual["+s+"] = "+u+", expected["+s+"] = "+l+".\nActual:   "+a+".\nExpected: "+i+".")}}function expectPromiseToFail(e,t){e().then(function(){return t.fail()},function(){return t()})}function expectArraysEqual(e,t){return expectArraysClose(e,t,0)}function expectNumbersClose(e,t,r){if(null==r&&(r=ENV.get("TEST_EPSILON")),!areClose(e,t,r))throw new Error("Numbers differ: actual === "+e+", expected === "+t)}function areClose(e,t,r){return!(!isNaN(e)||!isNaN(t))||!(isNaN(e)||isNaN(t)||Math.abs(e-t)>r)}function expectValuesInRange(e,t,r){var n;n=e instanceof Tensor?e.dataSync():e;for(var o=0;o<n.length;o++)if(n[o]<t||n[o]>r)throw new Error("Value out of range:"+n[o]+" low: "+t+", high: "+r)}function expectArrayBuffersEqual(e,t){expect(new Float32Array(e)).toEqual(new Float32Array(t))}var test_util=Object.freeze({WEBGL_ENVS:WEBGL_ENVS,NODE_ENVS:NODE_ENVS,CHROME_ENVS:CHROME_ENVS,BROWSER_ENVS:BROWSER_ENVS,CPU_ENVS:CPU_ENVS,BROWSER_CPU_ENVS:BROWSER_CPU_ENVS,ALL_ENVS:ALL_ENVS,expectArraysClose:expectArraysClose,expectPromiseToFail:expectPromiseToFail,expectArraysEqual:expectArraysEqual,expectNumbersClose:expectNumbersClose,expectValuesInRange:expectValuesInRange,expectArrayBuffersEqual:expectArrayBuffersEqual}),version="0.13.11",webgl=Object.freeze({gpgpu_util:gpgpu_util,webgl_util:webgl_util,MathBackendWebGL:MathBackendWebGL,GPGPUContext:GPGPUContext}),Optimizer=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.minimize=function(e,t,r){void 0===t&&(t=!1);var n=this.computeGradients(e,r),o=n.value,a=n.grads;return this.applyGradients(a),Object.keys(a).forEach(function(e){return a[e].dispose()}),t?o:(o.dispose(),null)},t.prototype.computeGradients=function(e,t){return variableGrads(e,t)},t}(Serializable),AdadeltaOptimizer=function(e){function t(t,r,n){void 0===n&&(n=null);var o=e.call(this)||this;return o.learningRate=t,o.rho=r,o.epsilon=n,o.accumulatedGrads={},o.accumulatedUpdates={},o.c=keep(scalar(-t)),o.rhoScalar=keep(scalar(r)),o.oneMinusRho=keep(scalar(1-r)),null===n&&(n=ENV.get("EPSILON")),o.epsilonScalar=keep(scalar(n)),o}return __extends(t,e),t.prototype.applyGradients=function(e){var t=this,r=function(r){var o=ENV.engine.registeredVariables[r];if(null==n.accumulatedGrads[r]){tidy(function(){t.accumulatedGrads[r]=zerosLike(o).variable(!1)})}if(null==n.accumulatedUpdates[r]){tidy(function(){t.accumulatedUpdates[r]=zerosLike(o).variable(!1)})}var a=e[r],i=n.accumulatedGrads[r],s=n.accumulatedUpdates[r];tidy(function(){var e=t.rhoScalar.mul(i).add(t.oneMinusRho.mul(a.square())),n=s.add(t.epsilonScalar).sqrt().div(i.add(t.epsilonScalar).sqrt()).mul(a),u=t.rhoScalar.mul(s).add(t.oneMinusRho.mul(n.square()));t.accumulatedGrads[r].assign(e),t.accumulatedUpdates[r].assign(u);var l=t.c.mul(n).add(o);o.assign(l)})},n=this;for(var o in e)r(o)},t.prototype.dispose=function(){var e=this;this.c.dispose(),this.epsilonScalar.dispose(),this.rhoScalar.dispose(),this.oneMinusRho.dispose(),null!=this.accumulatedUpdates&&(Object.keys(this.accumulatedUpdates).forEach(function(t){return e.accumulatedUpdates[t].dispose()}),Object.keys(this.accumulatedGrads).forEach(function(t){return e.accumulatedGrads[t].dispose()}))},t.prototype.getConfig=function(){return{learningRate:this.learningRate,rho:this.rho,epsilon:this.epsilon}},t.fromConfig=function(e,t){return new e(t.learningRate,t.rho,t.epsilon)},t.className="AdadeltaOptimizer",t}(Optimizer);registerClass(AdadeltaOptimizer);var AdagradOptimizer=function(e){function t(t,r){void 0===r&&(r=.1);var n=e.call(this)||this;return n.learningRate=t,n.initialAccumulatorValue=r,n.accumulatedGrads={},n.c=keep(scalar(-t)),n.epsilon=keep(scalar(ENV.get("EPSILON"))),n}return __extends(t,e),t.prototype.applyGradients=function(e){var t=this,r=function(r){var o=ENV.engine.registeredVariables[r];if(null==n.accumulatedGrads[r]){tidy(function(){t.accumulatedGrads[r]=fill(o.shape,t.initialAccumulatorValue).variable(!1)})}var a=e[r],i=n.accumulatedGrads[r];tidy(function(){var e=i.add(a.square());t.accumulatedGrads[r].assign(e);var n=t.c.mul(a.div(e.add(t.epsilon).sqrt())).add(o);o.assign(n)})},n=this;for(var o in e)r(o)},t.prototype.dispose=function(){var e=this;this.epsilon.dispose(),this.c.dispose(),null!=this.accumulatedGrads&&Object.keys(this.accumulatedGrads).forEach(function(t){return e.accumulatedGrads[t].dispose()})},t.prototype.getConfig=function(){return{learningRate:this.learningRate,initialAccumulatorValue:this.initialAccumulatorValue}},t.fromConfig=function(e,t){return new e(t.learningRate,t.initialAccumulatorValue)},t.className="AdagradOptimizer",t}(Optimizer);registerClass(AdagradOptimizer);var AdamOptimizer=function(e){function t(t,r,n,o){void 0===o&&(o=null);var a=e.call(this)||this;return a.learningRate=t,a.beta1=r,a.beta2=n,a.epsilon=o,a.accumulatedFirstMoment={},a.accumulatedSecondMoment={},a.c=keep(scalar(-t)),a.beta1Scalar=keep(scalar(r)),a.beta2Scalar=keep(scalar(n)),tidy(function(){a.accBeta1=scalar(r).variable(),a.accBeta2=scalar(n).variable()}),a.oneMinusBeta1=keep(scalar(1-r)),a.oneMinusBeta2=keep(scalar(1-n)),a.one=keep(scalar(1)),null===o&&(o=ENV.get("EPSILON")),a.epsScalar=keep(scalar(o)),a}return __extends(t,e),t.prototype.applyGradients=function(e){var t=this;tidy(function(){var r=t.one.sub(t.accBeta1),n=t.one.sub(t.accBeta2);for(var o in e){var a=ENV.engine.registeredVariables[o];if(null==t.accumulatedFirstMoment[o]){var i=!1;t.accumulatedFirstMoment[o]=zerosLike(a).variable(i)}if(null==t.accumulatedSecondMoment[o]){i=!1;t.accumulatedSecondMoment[o]=zerosLike(a).variable(i)}var s=e[o],u=t.accumulatedFirstMoment[o],l=t.accumulatedSecondMoment[o],c=t.beta1Scalar.mul(u).add(t.oneMinusBeta1.mul(s)),p=t.beta2Scalar.mul(l).add(t.oneMinusBeta2.mul(s.square())),d=c.div(r),h=p.div(n);t.accumulatedFirstMoment[o].assign(c),t.accumulatedSecondMoment[o].assign(p);var f=t.c.mul(d.div(t.epsScalar.add(h.sqrt()))).add(a);a.assign(f)}t.accBeta1.assign(t.accBeta1.mul(t.beta1Scalar)),t.accBeta2.assign(t.accBeta2.mul(t.beta2Scalar))})},t.prototype.dispose=function(){var e=this;this.c.dispose(),this.epsScalar.dispose(),this.beta1Scalar.dispose(),this.beta2Scalar.dispose(),this.accBeta1.dispose(),this.accBeta2.dispose(),this.oneMinusBeta1.dispose(),this.oneMinusBeta2.dispose(),this.one.dispose(),null!=this.accumulatedFirstMoment&&Object.keys(this.accumulatedFirstMoment).forEach(function(t){return e.accumulatedFirstMoment[t].dispose()}),null!=this.accumulatedSecondMoment&&Object.keys(this.accumulatedSecondMoment).forEach(function(t){return e.accumulatedSecondMoment[t].dispose()})},t.prototype.getConfig=function(){return{learningRate:this.learningRate,beta1:this.beta1,beta2:this.beta2,epsilon:this.epsilon}},t.fromConfig=function(e,t){return new e(t.learningRate,t.beta1,t.beta2,t.epsilon)},t.className="AdamOptimizer",t}(Optimizer);registerClass(AdamOptimizer);var AdamaxOptimizer=function(e){function t(t,r,n,o,a){void 0===o&&(o=null),void 0===a&&(a=0);var i=e.call(this)||this;return i.learningRate=t,i.beta1=r,i.beta2=n,i.epsilon=o,i.decay=a,i.accumulatedFirstMoment={},i.accumulatedWeightedInfNorm={},i.c=keep(scalar(-t)),i.beta1Scalar=keep(scalar(r)),i.beta2Scalar=keep(scalar(n)),i.decayScalar=keep(scalar(a)),tidy(function(){i.iteration=scalar(0).variable(),i.accBeta1=scalar(r).variable()}),i.oneMinusBeta1=keep(scalar(1-r)),i.one=keep(scalar(1)),null===o&&(o=ENV.get("EPSILON")),i.epsScalar=keep(scalar(o)),i}return __extends(t,e),t.prototype.applyGradients=function(e){var t=this;tidy(function(){var r=t.one.sub(t.accBeta1),n=t.c.div(t.one.add(t.decayScalar.mul(t.iteration)));for(var o in e){var a=ENV.engine.registeredVariables[o];if(null==t.accumulatedFirstMoment[o]){var i=!1;t.accumulatedFirstMoment[o]=zerosLike(a).variable(i)}if(null==t.accumulatedWeightedInfNorm[o]){i=!1;t.accumulatedWeightedInfNorm[o]=zerosLike(a).variable(i)}var s=e[o],u=t.accumulatedFirstMoment[o],l=t.accumulatedWeightedInfNorm[o],c=t.beta1Scalar.mul(u).add(t.oneMinusBeta1.mul(s)),p=t.beta2Scalar.mul(l),d=s.abs(),h=p.maximum(d);t.accumulatedFirstMoment[o].assign(c),t.accumulatedWeightedInfNorm[o].assign(h);var f=n.div(r).mul(c.div(t.epsScalar.add(h))).add(a);a.assign(f)}t.iteration.assign(t.iteration.add(t.one)),t.accBeta1.assign(t.accBeta1.mul(t.beta1Scalar))})},t.prototype.dispose=function(){var e=this;this.c.dispose(),this.epsScalar.dispose(),this.accBeta1.dispose(),this.beta1Scalar.dispose(),this.beta2Scalar.dispose(),this.oneMinusBeta1.dispose(),this.decayScalar.dispose(),this.iteration.dispose(),this.one.dispose(),null!=this.accumulatedFirstMoment&&Object.keys(this.accumulatedFirstMoment).forEach(function(t){return e.accumulatedFirstMoment[t].dispose()}),null!=this.accumulatedWeightedInfNorm&&Object.keys(this.accumulatedWeightedInfNorm).forEach(function(t){return e.accumulatedWeightedInfNorm[t].dispose()})},t.prototype.getConfig=function(){return{learningRate:this.learningRate,beta1:this.beta1,beta2:this.beta2,epsilon:this.epsilon,decay:this.decay}},t.fromConfig=function(e,t){return new e(t.learningRate,t.beta1,t.beta2,t.epsilon,t.decay)},t.className="AdamaxOptimizer",t}(Optimizer);registerClass(AdamaxOptimizer);var SGDOptimizer=function(e){function t(t){var r=e.call(this)||this;return r.learningRate=t,r.setLearningRate(t),r}return __extends(t,e),t.prototype.applyGradients=function(e){var t=this;Object.keys(e).forEach(function(r){var n=e[r],o=ENV.engine.registeredVariables[r];tidy(function(){var e=t.c.mul(n).add(o);o.assign(e)})})},t.prototype.setLearningRate=function(e){this.learningRate=e,null!=this.c&&this.c.dispose(),this.c=keep(scalar(-e))},t.prototype.dispose=function(){this.c.dispose()},t.prototype.getConfig=function(){return{learningRate:this.learningRate}},t.fromConfig=function(e,t){return new e(t.learningRate)},t.className="SGDOptimizer",t}(Optimizer);registerClass(SGDOptimizer);var MomentumOptimizer=function(e){function t(t,r,n){void 0===n&&(n=!1);var o=e.call(this,t)||this;return o.learningRate=t,o.momentum=r,o.useNesterov=n,o.m=scalar(o.momentum),o.accumulations={},o}return __extends(t,e),t.prototype.applyGradients=function(e){var t=this,r=function(r){var o=ENV.engine.registeredVariables[r];if(null==n.accumulations[r]){tidy(function(){t.accumulations[r]=zerosLike(o).variable(!1)})}var a=n.accumulations[r],i=e[r];tidy(function(){var e,n=t.m.mul(a).add(i);e=t.useNesterov?t.c.mul(i.add(n.mul(t.m))).add(o):t.c.mul(n).add(o),t.accumulations[r].assign(n),o.assign(e)})},n=this;for(var o in e)r(o)},t.prototype.dispose=function(){if(e.prototype.dispose.call(this),this.m.dispose(),null!=this.accumulations)for(var t in this.accumulations)this.accumulations[t].dispose()},t.prototype.setMomentum=function(e){this.momentum=e},t.prototype.getConfig=function(){return{learningRate:this.learningRate,momentum:this.momentum,useNesterov:this.useNesterov}},t.fromConfig=function(e,t){return new e(t.learningRate,t.momentum,t.useNesterov)},t.className="MomentumOptimizer",t}(SGDOptimizer);registerClass(MomentumOptimizer);var RMSPropOptimizer=function(e){function t(t,r,n,o,a){void 0===r&&(r=.9),void 0===n&&(n=0),void 0===o&&(o=null),void 0===a&&(a=!1);var i=e.call(this)||this;return i.learningRate=t,i.decay=r,i.momentum=n,i.epsilon=o,i.accumulatedMeanSquares={},i.accumulatedMeanGrads={},i.accumulatedMoments={},i.c=keep(scalar(t)),i.decayScalar=keep(scalar(r)),i.momentumScalar=keep(scalar(n)),i.oneMinusDecay=keep(scalar(1-r)),i.centered=a,null===o&&(o=ENV.get("EPSILON")),i.epsilonScalar=keep(scalar(o)),i}return __extends(t,e),t.prototype.applyGradients=function(e){var t=this,r=function(r){var o=ENV.engine.registeredVariables[r];if(null==n.accumulatedMeanSquares[r]){tidy(function(){t.accumulatedMeanSquares[r]=zerosLike(o).variable(!1)})}if(null==n.accumulatedMeanGrads[r]&&n.centered){tidy(function(){t.accumulatedMeanGrads[r]=zerosLike(o).variable(!1)})}if(null==n.accumulatedMoments[r]){tidy(function(){t.accumulatedMoments[r]=zerosLike(o).variable(!1)})}var a=n.accumulatedMeanSquares[r],i=n.accumulatedMeanGrads[r],s=n.accumulatedMoments[r],u=e[r];tidy(function(){var e=t.decayScalar.mul(a).add(t.oneMinusDecay.mul(u.square()));if(t.centered){var n=t.decayScalar.mul(i).add(t.oneMinusDecay.mul(u)),l=t.momentumScalar.mul(s).add(t.c.mul(u).div(e.sub(n.square().add(t.epsilonScalar)).sqrt()));t.accumulatedMeanSquares[r].assign(e),t.accumulatedMeanGrads[r].assign(n),t.accumulatedMoments[r].assign(l);var c=o.sub(l);o.assign(c)}else{var p=t.decayScalar.mul(a).add(t.oneMinusDecay.mul(u.square()));l=t.momentumScalar.mul(s).add(t.c.mul(u).div(p.add(t.epsilonScalar).sqrt()));t.accumulatedMeanSquares[r].assign(p),t.accumulatedMoments[r].assign(l);c=o.sub(l);o.assign(c)}})},n=this;for(var o in e)r(o)},t.prototype.dispose=function(){var e=this;this.c.dispose(),this.epsilonScalar.dispose(),this.decayScalar.dispose(),this.momentumScalar.dispose(),this.oneMinusDecay.dispose(),null!=this.accumulatedMeanSquares&&Object.keys(this.accumulatedMeanSquares).forEach(function(t){return e.accumulatedMeanSquares[t].dispose()}),null!=this.accumulatedMeanGrads&&this.centered&&Object.keys(this.accumulatedMeanGrads).forEach(function(t){return e.accumulatedMeanGrads[t].dispose()}),null!=this.accumulatedMoments&&Object.keys(this.accumulatedMoments).forEach(function(t){return e.accumulatedMoments[t].dispose()})},t.prototype.getConfig=function(){return{learningRate:this.learningRate,decay:this.decay,momentum:this.momentum,epsilon:this.epsilon,centered:this.centered}},t.fromConfig=function(e,t){return new e(t.learningRate,t.decay,t.momentum,t.epsilon,t.centered)},t.className="RMSPropOptimizer",t}(Optimizer);registerClass(RMSPropOptimizer);var OptimizerConstructors=function(){function e(){}return e.sgd=function(e){return new SGDOptimizer(e)},e.momentum=function(e,t,r){return void 0===r&&(r=!1),new MomentumOptimizer(e,t,r)},e.rmsprop=function(e,t,r,n,o){return void 0===t&&(t=.9),void 0===r&&(r=0),void 0===n&&(n=null),void 0===o&&(o=!1),new RMSPropOptimizer(e,t,r,n,o)},e.adam=function(e,t,r,n){return void 0===e&&(e=.001),void 0===t&&(t=.9),void 0===r&&(r=.999),void 0===n&&(n=null),new AdamOptimizer(e,t,r,n)},e.adadelta=function(e,t,r){return void 0===e&&(e=.001),void 0===t&&(t=.95),void 0===r&&(r=null),new AdadeltaOptimizer(e,t,r)},e.adamax=function(e,t,r,n,o){return void 0===e&&(e=.002),void 0===t&&(t=.9),void 0===r&&(r=.999),void 0===n&&(n=null),void 0===o&&(o=0),new AdamaxOptimizer(e,t,r,n,o)},e.adagrad=function(e,t){return void 0===t&&(t=.1),new AdagradOptimizer(e,t)},e}(),train={sgd:OptimizerConstructors.sgd,momentum:OptimizerConstructors.momentum,adadelta:OptimizerConstructors.adadelta,adagrad:OptimizerConstructors.adagrad,rmsprop:OptimizerConstructors.rmsprop,adamax:OptimizerConstructors.adamax,adam:OptimizerConstructors.adam},setBackend=Environment.setBackend,getBackend=Environment.getBackend,disposeVariables=Environment.disposeVariables,memory=Environment.memory;setOpHandler(ops);
//# sourceMappingURL=tf-core.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10), __webpack_require__(4), __webpack_require__(86).setImmediate, __webpack_require__(3).Buffer))

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = __webpack_require__(1).Buffer

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(1).Buffer
var MD5 = __webpack_require__(49)

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = exports;

curve.base = __webpack_require__(214);
curve.short = __webpack_require__(215);
curve.mont = __webpack_require__(216);
curve.edwards = __webpack_require__(217);


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var asn1 = __webpack_require__(233)
var aesid = __webpack_require__(245)
var fixProc = __webpack_require__(246)
var ciphers = __webpack_require__(58)
var compat = __webpack_require__(98)
module.exports = parseKeys

function parseKeys (buffer) {
  var password
  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
    password = buffer.passphrase
    buffer = buffer.key
  }
  if (typeof buffer === 'string') {
    buffer = new Buffer(buffer)
  }

  var stripped = fixProc(buffer, password)

  var type = stripped.tag
  var data = stripped.data
  var subtype, ndata
  switch (type) {
    case 'CERTIFICATE':
      ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo
      // falls through
    case 'PUBLIC KEY':
      if (!ndata) {
        ndata = asn1.PublicKey.decode(data, 'der')
      }
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
        case '1.2.840.10045.2.1':
          ndata.subjectPrivateKey = ndata.subjectPublicKey
          return {
            type: 'ec',
            data: ndata
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
          return {
            type: 'dsa',
            data: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'ENCRYPTED PRIVATE KEY':
      data = asn1.EncryptedPrivateKey.decode(data, 'der')
      data = decrypt(data, password)
      // falls through
    case 'PRIVATE KEY':
      ndata = asn1.PrivateKey.decode(data, 'der')
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
        case '1.2.840.10045.2.1':
          return {
            curve: ndata.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
          return {
            type: 'dsa',
            params: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'RSA PUBLIC KEY':
      return asn1.RSAPublicKey.decode(data, 'der')
    case 'RSA PRIVATE KEY':
      return asn1.RSAPrivateKey.decode(data, 'der')
    case 'DSA PRIVATE KEY':
      return {
        type: 'dsa',
        params: asn1.DSAPrivateKey.decode(data, 'der')
      }
    case 'EC PRIVATE KEY':
      data = asn1.ECPrivateKey.decode(data, 'der')
      return {
        curve: data.parameters.value,
        privateKey: data.privateKey
      }
    default: throw new Error('unknown key type ' + type)
  }
}
parseKeys.signature = asn1.signature
function decrypt (data, password) {
  var salt = data.algorithm.decrypt.kde.kdeparams.salt
  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
  var iv = data.algorithm.decrypt.cipher.iv
  var cipherText = data.subjectPrivateKey
  var keylen = parseInt(algo.split('-')[1], 10) / 8
  var key = compat.pbkdf2Sync(password, salt, iters, keylen)
  var cipher = ciphers.createDecipheriv(algo, key, iv)
  var out = []
  out.push(cipher.update(cipherText))
  out.push(cipher.final())
  return Buffer.concat(out)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 43 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 44 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(67);
var $export = __webpack_require__(72);
var redefine = __webpack_require__(16);
var hide = __webpack_require__(17);
var Iterators = __webpack_require__(23);
var $iterCreate = __webpack_require__(134);
var setToStringTag = __webpack_require__(47);
var getPrototypeOf = __webpack_require__(141);
var ITERATOR = __webpack_require__(7)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(66)('keys');
var uid = __webpack_require__(30);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(18).f;
var has = __webpack_require__(20);
var TAG = __webpack_require__(7)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(0)
var HashBase = __webpack_require__(88)
var Buffer = __webpack_require__(1).Buffer

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.allocUnsafe(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(51).EventEmitter;
var inherits = __webpack_require__(0);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(52);
Stream.Writable = __webpack_require__(176);
Stream.Duplex = __webpack_require__(177);
Stream.Transform = __webpack_require__(178);
Stream.PassThrough = __webpack_require__(179);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(89);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(53);
exports.Duplex = __webpack_require__(14);
exports.Transform = __webpack_require__(92);
exports.PassThrough = __webpack_require__(175);


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(36);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(25);
util.inherits = __webpack_require__(0);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(174)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(90);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(1).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(91);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(14);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(14);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(86).setImmediate, __webpack_require__(4)))

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(1).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(3).Buffer
var inherits = __webpack_require__(0)
var HashBase = __webpack_require__(88)

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = __webpack_require__(180)
exports.sha1 = __webpack_require__(181)
exports.sha224 = __webpack_require__(182)
exports.sha256 = __webpack_require__(93)
exports.sha384 = __webpack_require__(183)
exports.sha512 = __webpack_require__(94)


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.utils = __webpack_require__(189);
exports.Cipher = __webpack_require__(190);
exports.DES = __webpack_require__(191);
exports.CBC = __webpack_require__(192);
exports.EDE = __webpack_require__(193);


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var ciphers = __webpack_require__(194)
var deciphers = __webpack_require__(202)
var modes = __webpack_require__(104)

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var modeModules = {
  ECB: __webpack_require__(195),
  CBC: __webpack_require__(196),
  CFB: __webpack_require__(197),
  CFB8: __webpack_require__(198),
  CFB1: __webpack_require__(199),
  OFB: __webpack_require__(200),
  CTR: __webpack_require__(102),
  GCM: __webpack_require__(102)
}

var modes = __webpack_require__(104)

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var bn = __webpack_require__(2);
var randomBytes = __webpack_require__(21);
module.exports = crt;
function blind(priv) {
  var r = getr(priv);
  var blinder = r.toRed(bn.mont(priv.modulus))
  .redPow(new bn(priv.publicExponent)).fromRed();
  return {
    blinder: blinder,
    unblinder:r.invm(priv.modulus)
  };
}
function crt(msg, priv) {
  var blinds = blind(priv);
  var len = priv.modulus.byteLength();
  var mod = bn.mont(priv.modulus);
  var blinded = new bn(msg).mul(blinds.blinder).umod(priv.modulus);
  var c1 = blinded.toRed(bn.mont(priv.prime1));
  var c2 = blinded.toRed(bn.mont(priv.prime2));
  var qinv = priv.coefficient;
  var p = priv.prime1;
  var q = priv.prime2;
  var m1 = c1.redPow(priv.exponent1);
  var m2 = c2.redPow(priv.exponent2);
  m1 = m1.fromRed();
  m2 = m2.fromRed();
  var h = m1.isub(m2).imul(qinv).umod(p);
  h.imul(q);
  m2.iadd(h);
  return new Buffer(m2.imul(blinds.unblinder).umod(priv.modulus).toArray(false, len));
}
crt.getr = getr;
function getr(priv) {
  var len = priv.modulus.byteLength();
  var r = new bn(randomBytes(len));
  while (r.cmp(priv.modulus) >=  0 || !r.umod(priv.prime1) || !r.umod(priv.prime2)) {
    r = new bn(randomBytes(len));
  }
  return r;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var hash = exports;

hash.utils = __webpack_require__(8);
hash.common = __webpack_require__(27);
hash.sha = __webpack_require__(219);
hash.ripemd = __webpack_require__(223);
hash.hmac = __webpack_require__(224);

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(127);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(64);
var test = {};
test[__webpack_require__(7)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(16)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(65);
var TAG = __webpack_require__(7)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 65 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(15);
var global = __webpack_require__(9);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(67) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(13) && !__webpack_require__(31)(function () {
  return Object.defineProperty(__webpack_require__(69)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
var document = __webpack_require__(9).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(11);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(132)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(45)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9);
var core = __webpack_require__(15);
var hide = __webpack_require__(17);
var redefine = __webpack_require__(16);
var ctx = __webpack_require__(32);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(19);
var dPs = __webpack_require__(135);
var enumBugKeys = __webpack_require__(76);
var IE_PROTO = __webpack_require__(46)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(69)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(140).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(136);
var enumBugKeys = __webpack_require__(76);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(43);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(143);
var getKeys = __webpack_require__(74);
var redefine = __webpack_require__(16);
var global = __webpack_require__(9);
var hide = __webpack_require__(17);
var Iterators = __webpack_require__(23);
var wks = __webpack_require__(7);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(18).f;
var create = __webpack_require__(73);
var redefineAll = __webpack_require__(80);
var ctx = __webpack_require__(32);
var anInstance = __webpack_require__(81);
var forOf = __webpack_require__(82);
var $iterDefine = __webpack_require__(45);
var step = __webpack_require__(78);
var setSpecies = __webpack_require__(149);
var DESCRIPTORS = __webpack_require__(13);
var fastKey = __webpack_require__(83).fastKey;
var validate = __webpack_require__(48);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(16);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(32);
var call = __webpack_require__(146);
var isArrayIter = __webpack_require__(147);
var anObject = __webpack_require__(19);
var toLength = __webpack_require__(75);
var getIterFn = __webpack_require__(148);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(30)('meta');
var isObject = __webpack_require__(11);
var has = __webpack_require__(20);
var setDesc = __webpack_require__(18).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(31)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9);
var $export = __webpack_require__(72);
var redefine = __webpack_require__(16);
var redefineAll = __webpack_require__(80);
var meta = __webpack_require__(83);
var forOf = __webpack_require__(82);
var anInstance = __webpack_require__(81);
var isObject = __webpack_require__(11);
var fails = __webpack_require__(31);
var $iterDetect = __webpack_require__(150);
var setToStringTag = __webpack_require__(47);
var inheritIfRequired = __webpack_require__(151);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(158);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(167);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 87 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(1).Buffer
var Transform = __webpack_require__(50).Transform
var inherits = __webpack_require__(0)

function throwIfNotStringOrBuffer (val, prefix) {
  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
    throw new TypeError(prefix + ' must be a string or a buffer')
  }
}

function HashBase (blockSize) {
  Transform.call(this)

  this._block = Buffer.allocUnsafe(blockSize)
  this._blockSize = blockSize
  this._blockOffset = 0
  this._length = [0, 0, 0, 0]

  this._finalized = false
}

inherits(HashBase, Transform)

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null
  try {
    this.update(chunk, encoding)
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype._flush = function (callback) {
  var error = null
  try {
    this.push(this.digest())
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype.update = function (data, encoding) {
  throwIfNotStringOrBuffer(data, 'Data')
  if (this._finalized) throw new Error('Digest already called')
  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding)

  // consume data
  var block = this._block
  var offset = 0
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
    this._update()
    this._blockOffset = 0
  }
  while (offset < data.length) block[this._blockOffset++] = data[offset++]

  // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry
    carry = (this._length[j] / 0x0100000000) | 0
    if (carry > 0) this._length[j] -= 0x0100000000 * carry
  }

  return this
}

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented')
}

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called')
  this._finalized = true

  var digest = this._digest()
  if (encoding !== undefined) digest = digest.toString(encoding)

  // reset state
  this._block.fill(0)
  this._blockOffset = 0
  for (var i = 0; i < 4; ++i) this._length[i] = 0

  return digest
}

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented')
}

module.exports = HashBase


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(36);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(87);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(51).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(90);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(1).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(25);
util.inherits = __webpack_require__(0);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(171);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(172);
var destroyImpl = __webpack_require__(91);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(14);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(54).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(14);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(54).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(10)))

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(51).EventEmitter;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(36);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(14);

/*<replacement>*/
var util = __webpack_require__(25);
util.inherits = __webpack_require__(0);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(0)
var Hash = __webpack_require__(22)
var Buffer = __webpack_require__(1).Buffer

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(0)
var Hash = __webpack_require__(22)
var Buffer = __webpack_require__(1).Buffer

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(0)
var Legacy = __webpack_require__(184)
var Base = __webpack_require__(12)
var Buffer = __webpack_require__(1).Buffer
var md5 = __webpack_require__(96)
var RIPEMD160 = __webpack_require__(55)

var sha = __webpack_require__(56)

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var MD5 = __webpack_require__(49)

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}


/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

exports.pbkdf2 = __webpack_require__(186)
exports.pbkdf2Sync = __webpack_require__(101)


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

function checkBuffer (buf, name) {
  if (typeof buf !== 'string' && !Buffer.isBuffer(buf)) {
    throw new TypeError(name + ' must be a buffer or string')
  }
}

module.exports = function (password, salt, iterations, keylen) {
  checkBuffer(password, 'Password')
  checkBuffer(salt, 'Salt')

  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length')
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var defaultEncoding
/* istanbul ignore next */
if (process.browser) {
  defaultEncoding = 'utf-8'
} else {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
}
module.exports = defaultEncoding

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10)))

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var md5 = __webpack_require__(96)
var RIPEMD160 = __webpack_require__(55)
var sha = __webpack_require__(56)

var checkParameters = __webpack_require__(99)
var defaultEncoding = __webpack_require__(100)
var Buffer = __webpack_require__(1).Buffer
var ZEROS = Buffer.alloc(128)
var sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
}

function Hmac (alg, key, saltLen) {
  var hash = getDigest(alg)
  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  if (key.length > blocksize) {
    key = hash(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
  var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
  ipad.copy(ipad1, 0, 0, blocksize)
  this.ipad1 = ipad1
  this.ipad2 = ipad
  this.opad = opad
  this.alg = alg
  this.blocksize = blocksize
  this.hash = hash
  this.size = sizes[alg]
}

Hmac.prototype.run = function (data, ipad) {
  data.copy(ipad, this.blocksize)
  var h = this.hash(ipad)
  h.copy(this.opad, this.blocksize)
  return this.hash(this.opad)
}

function getDigest (alg) {
  function shaFunc (data) {
    return sha(alg).update(data).digest()
  }
  function rmd160Func (data) {
    return new RIPEMD160().update(data).digest()
  }

  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
  if (alg === 'md5') return md5
  return shaFunc
}

function pbkdf2 (password, salt, iterations, keylen, digest) {
  checkParameters(password, salt, iterations, keylen)

  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  digest = digest || 'sha1'

  var hmac = new Hmac(digest, password, salt.length)

  var DK = Buffer.allocUnsafe(keylen)
  var block1 = Buffer.allocUnsafe(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var destPos = 0
  var hLen = sizes[digest]
  var l = Math.ceil(keylen / hLen)

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)

    var T = hmac.run(block1, hmac.ipad1)
    var U = T

    for (var j = 1; j < iterations; j++) {
      U = hmac.run(U, hmac.ipad2)
      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
    }

    T.copy(DK, destPos)
    destPos += hLen
  }

  return DK
}

module.exports = pbkdf2


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(26)
var Buffer = __webpack_require__(1).Buffer
var incr32 = __webpack_require__(103)

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}


/***/ }),
/* 103 */
/***/ (function(module, exports) {

function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32


/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(37)
var Buffer = __webpack_require__(1).Buffer
var Transform = __webpack_require__(12)
var inherits = __webpack_require__(0)
var GHASH = __webpack_require__(201)
var xor = __webpack_require__(26)
var incr32 = __webpack_require__(103)

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(37)
var Buffer = __webpack_require__(1).Buffer
var Transform = __webpack_require__(12)
var inherits = __webpack_require__(0)

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var randomBytes = __webpack_require__(21);
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = __webpack_require__(2);
var TWENTYFOUR = new BN(24);
var MillerRabin = __webpack_require__(108);
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var bn = __webpack_require__(2);
var brorand = __webpack_require__(109);

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = __webpack_require__(207);
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var common = __webpack_require__(27);
var shaCommon = __webpack_require__(111);
var assert = __webpack_require__(6);

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var common = __webpack_require__(27);
var assert = __webpack_require__(6);

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(0);
var Reporter = __webpack_require__(29).Reporter;
var Buffer = __webpack_require__(3).Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  var res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
}

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  var res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
}

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
}

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!(item instanceof EncoderBuffer))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = new Buffer(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = __webpack_require__(239);


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(0);

var asn1 = __webpack_require__(28);
var base = asn1.base;
var bignum = asn1.bignum;

// Import DER constants
var der = asn1.constants.der;

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!(data instanceof base.DecoderBuffer))
    data = new base.DecoderBuffer(data, options);

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  var state = buffer.save();
  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  var decodedTag = derDecodeTag(buffer,
                                'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  var len = derDecodeLen(buffer,
                         decodedTag.primitive,
                         'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  var state = buffer.save();
  var res = this._skipUntilEnd(
      buffer,
      'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  while (true) {
    var tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    var len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    var res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len)
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
                                                    options) {
  var result = [];
  while (!buffer.isEmpty()) {
    var possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    var res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    var unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    var raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    var str = '';
    for (var i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    var numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    var printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  var result;
  var identifiers = [];
  var ident = 0;
  while (!buffer.isEmpty()) {
    var subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  var first = (identifiers[0] / 40) | 0;
  var second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    var tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  var str = buffer.raw().toString();
  if (tag === 'gentime') {
    var year = str.slice(0, 4) | 0;
    var mon = str.slice(4, 6) | 0;
    var day = str.slice(6, 8) | 0;
    var hour = str.slice(8, 10) | 0;
    var min = str.slice(10, 12) | 0;
    var sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    var year = str.slice(0, 2) | 0;
    var mon = str.slice(2, 4) | 0;
    var day = str.slice(4, 6) | 0;
    var hour = str.slice(6, 8) | 0;
    var min = str.slice(8, 10) | 0;
    var sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull(buffer) {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  var res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  var raw = buffer.raw();
  var res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  var tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  var cls = der.tagClass[tag >> 6];
  var primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    var oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  var tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  var len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  var num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (var i = 0; i < num; i++) {
    len <<= 8;
    var j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(0);
var Buffer = __webpack_require__(3).Buffer;

var asn1 = __webpack_require__(28);
var base = asn1.base;

// Import DER constants
var der = asn1.constants.der;

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
                                                              primitive,
                                                              cls,
                                                              content) {
  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    var header = new Buffer(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  var lenOctets = 1;
  for (var i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  var header = new Buffer(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    var buf = new Buffer(str.length * 2);
    for (var i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s\.]+/g);
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  var size = 0;
  for (var i = 0; i < id.length; i++) {
    var ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  var objid = new Buffer(size);
  var offset = objid.length - 1;
  for (var i = id.length - 1; i >= 0; i--) {
    var ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  var str;
  var date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    var numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = new Buffer(numArray);
  }

  if (Buffer.isBuffer(num)) {
    var size = num.length;
    if (num.length === 0)
      size++;

    var out = new Buffer(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  var size = 1;
  for (var i = num; i >= 0x100; i >>= 8)
    size++;

  var out = new Array(size);
  for (var i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(new Buffer(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  var state = this._baseState;
  var i;
  if (state['default'] === null)
    return false;

  var data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  var res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}


/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var createHash = __webpack_require__(24)
var Buffer = __webpack_require__(1).Buffer

module.exports = function (seed, len) {
  var t = Buffer.alloc(0)
  var i = 0
  var c
  while (t.length < len) {
    c = i2ops(i++)
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
  }
  return t.slice(0, len)
}

function i2ops (c) {
  var out = Buffer.allocUnsafe(4)
  out.writeUInt32BE(c, 0)
  return out
}


/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var BN = __webpack_require__(2)
var Buffer = __webpack_require__(1).Buffer

function withPublic (paddedMsg, key) {
  return Buffer.from(paddedMsg
    .toRed(BN.mont(key.modulus))
    .redPow(new BN(key.publicExponent))
    .fromRed()
    .toArray())
}

module.exports = withPublic


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export constraints */
/* unused harmony export initializers */
/* unused harmony export layers */
/* unused harmony export models */
/* unused harmony export metrics */
/* unused harmony export regularizers */
/* unused harmony export CallbackList */
/* unused harmony export CustomCallback */
/* unused harmony export History */
/* unused harmony export Callback */
/* unused harmony export InputSpec */
/* unused harmony export SymbolicTensor */
/* unused harmony export Model */
/* unused harmony export input */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadModel; });
/* unused harmony export model */
/* unused harmony export registerCallbackConstructor */
/* unused harmony export sequential */
/* unused harmony export RNN */
/* unused harmony export Sequential */
/* unused harmony export LayerVariable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return version; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__ = __webpack_require__(35);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
var extendStatics=function(e,t){return(extendStatics=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])})(e,t)};function __extends(e,t){function n(){this.constructor=e}extendStatics(e,t),e.prototype=null===t?Object.create(t):(n.prototype=t.prototype,new n)}var __assign=function(){return(__assign=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var i in t=arguments[n])Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i]);return e}).apply(this,arguments)};function __awaiter(e,t,n,r){return new(n||(n=Promise))(function(i,a){function o(e){try{l(r.next(e))}catch(e){a(e)}}function s(e){try{l(r.throw(e))}catch(e){a(e)}}function l(e){e.done?i(e.value):new n(function(t){t(e.value)}).then(o,s)}l((r=r.apply(e,t||[])).next())})}function __generator(e,t){var n,r,i,a,o={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return a={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(a[Symbol.iterator]=function(){return this}),a;function s(a){return function(s){return function(a){if(n)throw new TypeError("Generator is already executing.");for(;o;)try{if(n=1,r&&(i=2&a[0]?r.return:a[0]?r.throw||((i=r.return)&&i.call(r),0):r.next)&&!(i=i.call(r,a[1])).done)return i;switch(r=0,i&&(a=[2&a[0],i.value]),a[0]){case 0:case 1:i=a;break;case 4:return o.label++,{value:a[1],done:!1};case 5:o.label++,r=a[1],a=[0];continue;case 7:a=o.ops.pop(),o.trys.pop();continue;default:if(!(i=(i=o.trys).length>0&&i[i.length-1])&&(6===a[0]||2===a[0])){o=0;continue}if(3===a[0]&&(!i||a[1]>i[0]&&a[1]<i[3])){o.label=a[1];break}if(6===a[0]&&o.label<i[1]){o.label=i[1],i=a;break}if(i&&o.label<i[2]){o.label=i[2],o.ops.push(a);break}i[2]&&o.ops.pop(),o.trys.pop();continue}a=t.call(e,o)}catch(e){a=[6,e],r=0}finally{n=i=0}if(5&a[0])throw a[1];return{value:a[0]?a[1]:void 0,done:!0}}([a,s])}}}var _epsilon=__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["a" /* ENV */].get("EPSILON");function epsilon(){return _epsilon}function imageDataFormat(){return"channelsLast"}var _nextUniqueTensorId=0;function getNextUniqueTensorId(){return _nextUniqueTensorId++}var _uidPrefixes={};function getUid(e){return void 0===e&&(e=""),e in _uidPrefixes||(_uidPrefixes[e]=0),_uidPrefixes[e]+=1,e+_uidPrefixes[e].toString()}var scalarCache={float32:{},int32:{}},DEFAULT_DTYPE="float32";function getScalar(e,t){return void 0===t&&(t=DEFAULT_DTYPE),null==scalarCache[t][e]&&(scalarCache[t][e]=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_46" /* scalar */])(e,t),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_4" /* keep */])(scalarCache[t][e])),scalarCache[t][e]}var AttributeError=function(e){function t(n){var r=e.call(this,n)||this;return Object.setPrototypeOf(r,t.prototype),r}return __extends(t,e),t}(Error),RuntimeError=function(e){function t(n){var r=e.call(this,n)||this;return Object.setPrototypeOf(r,t.prototype),r}return __extends(t,e),t}(Error),ValueError=function(e){function t(n){var r=e.call(this,n)||this;return Object.setPrototypeOf(r,t.prototype),r}return __extends(t,e),t}(Error),NotImplementedError=function(e){function t(n){var r=e.call(this,n)||this;return Object.setPrototypeOf(r,t.prototype),r}return __extends(t,e),t}(Error),AssertionError=function(e){function t(n){var r=e.call(this,n)||this;return Object.setPrototypeOf(r,t.prototype),r}return __extends(t,e),t}(Error),IndexError=function(e){function t(n){var r=e.call(this,n)||this;return Object.setPrototypeOf(r,t.prototype),r}return __extends(t,e),t}(Error);function pyListRepeat(e,t){if(Array.isArray(e)){for(var n=[],r=0;r<t;r++)n=n.concat(e);return n}return(n=new Array(t)).fill(e),n}function assert(e,t){if(!e)throw new AssertionError(t)}function count(e,t){for(var n=0,r=0,i=e;r<i.length;r++){i[r]===t&&n++}return n}function singletonOrArray(e){return 1===e.length?e[0]:e}function toList(e){return Array.isArray(e)?e:[e]}function toSnakeCase(e){var t=e.replace(/(.)([A-Z][a-z0-9]+)/g,"$1_$2").replace(/([a-z])([A-Z])/g,"$1_$2").toLowerCase();return"_"!==t[0]?t:"private"+t}function toCamelCase(e){return e.length<=1?e:-1===e.indexOf("_")?e:e.replace(/[_]+(\w|$)/g,function(e,t){return t.toUpperCase()})}var _GLOBAL_CUSTOM_OBJECTS={};function serializeKerasObject(e){return null===e||void 0===e?null:{className:e.getClassName(),config:e.getConfig()}}function deserializeKerasObject(e,t,n,r){if(void 0===t&&(t={}),void 0===n&&(n={}),void 0===r&&(r="object"),"string"==typeof e){var i=e,a=void 0;if(i in n)a=n[i];else if(i in _GLOBAL_CUSTOM_OBJECTS)a=_GLOBAL_CUSTOM_OBJECTS[i];else if(null==(a=t[i]))throw new ValueError("Unknown "+r+": "+e+". This may be due to one of the following reasons:\n1. The "+r+" is defined in Python, in which case it needs to be ported to TensorFlow.js or your JavaScript code.\n2. The custom "+r+" is defined in JavaScript, but is not registered properly with tf.serialization.registerClass().");return a}var o=e;if(null==o.className||null==o.config)throw new ValueError(r+": Improper config format: "+JSON.stringify(o)+".\n'className' and 'config' must set.");var s=o.className,l=void 0,u=void 0;if(s in n?(l=(S=n.get(s))[0],u=S[1]):s in _GLOBAL_CUSTOM_OBJECTS?(l=(I=_GLOBAL_CUSTOM_OBJECTS.className)[0],u=I[1]):s in t&&(l=(N=t[s])[0],u=N[1]),null==l)throw new ValueError("Unknown "+r+": "+s+". This may be due to one of the following reasons:\n1. The "+r+" is defined in Python, in which case it needs to be ported to TensorFlow.js or your JavaScript code.\n2. The custom "+r+" is defined in JavaScript, but is not registered properly with tf.serialization.registerClass().");if(null!=u){for(var c={},p=0,h=Object.keys(_GLOBAL_CUSTOM_OBJECTS);p<h.length;p++){c[v=h[p]]=_GLOBAL_CUSTOM_OBJECTS[v]}for(var d=0,f=Object.keys(n);d<f.length;d++){c[v=f[d]]=n[v]}o.config.customObjects=c;for(var g=__assign({},_GLOBAL_CUSTOM_OBJECTS),m=0,y=Object.keys(n);m<y.length;m++){var v=y[m];_GLOBAL_CUSTOM_OBJECTS[v]=n[v]}var b=u(l,o.config);return _GLOBAL_CUSTOM_OBJECTS=__assign({},g),b}g=__assign({},_GLOBAL_CUSTOM_OBJECTS);for(var w=0,z=Object.keys(n);w<z.length;w++){v=z[w];_GLOBAL_CUSTOM_OBJECTS[v]=n[v]}var S,I,N;b=new l(o.config);return _GLOBAL_CUSTOM_OBJECTS=__assign({},g),b}function numberCompare(e,t){return e<t?-1:e>t?1:0}function reverseNumberCompare(e,t){return-1*numberCompare(e,t)}function stringToDType(e){switch(e){case"float32":return"float32";default:throw new ValueError("Invalid dtype: "+e)}}function unique(e){if(null==e)return e;for(var t=[],n=0,r=e;n<r.length;n++){var i=r[n];-1===t.indexOf(i)&&t.push(i)}return t}function isObjectEmpty(e){if(null==e)throw new ValueError("Invalid value in obj: "+JSON.stringify(e));for(var t in e)if(e.hasOwnProperty(t))return!1;return!0}function checkStringTypeUnionValue(e,t,n){if(null!=n&&e.indexOf(n)<0)throw new ValueError(n+" is not a valid "+t+".  Valid values are "+e+" or null/undefined.")}function checkArrayTypeAndLength(e,t,n,r){return void 0===n&&(n=0),void 0===r&&(r=1/0),assert(n>=0),assert(r>=n),Array.isArray(e)&&e.length>=n&&e.length<=r&&e.every(function(e){return typeof e===t})}function calcL2Norms(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_66" /* sqrt */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_74" /* sum */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_28" /* mulStrict */])(e,e),t,!0))})}var Constraint=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.getConfig=function(){return{}},t}(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].Serializable),MaxNorm=function(e){function t(t){var n=e.call(this)||this;return n.defaultMaxValue=2,n.defaultAxis=0,n.maxValue=null!=t.maxValue?t.maxValue:n.defaultMaxValue,n.axis=null!=t.axis?t.axis:n.defaultAxis,n}return __extends(t,e),t.prototype.apply=function(e){var t=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n=calcL2Norms(e,t.axis),r=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["z" /* clipByValue */])(n,0,t.maxValue);return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(e,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["N" /* div */])(r,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(getScalar(epsilon()),n)))})},t.prototype.getConfig=function(){return{maxValue:this.maxValue,axis:this.axis}},t.className="MaxNorm",t}(Constraint);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(MaxNorm);var UnitNorm=function(e){function t(t){var n=e.call(this)||this;return n.defaultAxis=0,n.axis=null!=t.axis?t.axis:n.defaultAxis,n}return __extends(t,e),t.prototype.apply=function(e){var t=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["N" /* div */])(e,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(getScalar(epsilon()),calcL2Norms(e,t.axis)))})},t.prototype.getConfig=function(){return{axis:this.axis}},t.className="UnitNorm",t}(Constraint);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(UnitNorm);var NonNeg=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.apply=function(e){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_42" /* relu */])(e)},t.className="NonNeg",t}(Constraint);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(NonNeg);var MinMaxNorm=function(e){function t(t){var n=e.call(this)||this;return n.defaultMinValue=0,n.defaultMaxValue=1,n.defaultRate=1,n.defaultAxis=0,n.minValue=null!=t.minValue?t.minValue:n.defaultMinValue,n.maxValue=null!=t.maxValue?t.maxValue:n.defaultMaxValue,n.rate=null!=t.rate?t.rate:n.defaultRate,n.axis=null!=t.axis?t.axis:n.defaultAxis,n}return __extends(t,e),t.prototype.apply=function(e){var t=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n=calcL2Norms(e,t.axis),r=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(getScalar(t.rate),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["z" /* clipByValue */])(n,t.minValue,t.maxValue)),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(getScalar(1-t.rate),n));return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(e,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["N" /* div */])(r,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(getScalar(epsilon()),n)))})},t.prototype.getConfig=function(){return{minValue:this.minValue,maxValue:this.maxValue,rate:this.rate,axis:this.axis}},t.className="MinMaxNorm",t}(Constraint);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(MinMaxNorm);var CONSTRAINT_IDENTIFIER_REGISTRY_SYMBOL_MAP={maxNorm:"MaxNorm",minMaxNorm:"MinMaxNorm",nonNeg:"NonNeg",unitNorm:"UnitNorm"};function serializeConstraint(e){return serializeKerasObject(e)}function deserializeConstraint(e,t){return void 0===t&&(t={}),deserializeKerasObject(e,__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].SerializationMap.getMap().classNameMap,t,"constraint")}function getConstraint(e){return null==e?null:"string"==typeof e?deserializeConstraint({className:e in CONSTRAINT_IDENTIFIER_REGISTRY_SYMBOL_MAP?CONSTRAINT_IDENTIFIER_REGISTRY_SYMBOL_MAP[e]:e,config:{}}):e instanceof Constraint?e:deserializeConstraint(e)}function maxNorm(e){return new MaxNorm(e)}function unitNorm(e){return new UnitNorm(e)}function nonNeg(){return new NonNeg}function minMaxNorm(e){return new MinMaxNorm(e)}var exports_constraints=Object.freeze({maxNorm:maxNorm,unitNorm:unitNorm,nonNeg:nonNeg,minMaxNorm:minMaxNorm}),nameMap=new Map,VALID_DATA_FORMAT_VALUES=["channelsFirst","channelsLast"];function checkDataFormat(e){checkStringTypeUnionValue(VALID_DATA_FORMAT_VALUES,"DataFormat",e)}var VALID_PADDING_MODE_VALUES=["valid","same","causal"];function checkPaddingMode(e){checkStringTypeUnionValue(VALID_PADDING_MODE_VALUES,"PaddingMode",e)}var VALID_POOL_MODE_VALUES=["max","avg"];function checkPoolMode(e){checkStringTypeUnionValue(VALID_POOL_MODE_VALUES,"PoolMode",e)}var _nameScopeStack=[],_nameScopeDivider="/";function nameScope(e,t){_nameScopeStack.push(e);try{var n=t();return _nameScopeStack.pop(),n}catch(e){throw _nameScopeStack.pop(),e}}function currentNameScopePrefix(){return 0===_nameScopeStack.length?"":_nameScopeStack.join(_nameScopeDivider)+_nameScopeDivider}function getScopedTensorName(e){if(!isValidTensorName(e))throw new Error("Not a valid tensor name: '"+e+"'");return currentNameScopePrefix()+e}function getUniqueTensorName(e){if(!isValidTensorName(e))throw new Error("Not a valid tensor name: '"+e+"'");nameMap.has(e)||nameMap.set(e,0);var t=nameMap.get(e);if(nameMap.set(e,nameMap.get(e)+1),t>0){var n=e+"_"+t;return nameMap.set(n,1),n}return e}var tensorNameRegex=new RegExp(/^[A-Za-z][-A-Za-z0-9\._\/]*$/);function isValidTensorName(e){return!!e.match(tensorNameRegex)}function isInteger(e){return e===parseInt(e.toString(),10)}function arrayProd(e,t,n){null==t&&(t=0),null==n&&(n=e.length);for(var r=1,i=t;i<n;++i)r*=e[i];return r}function toArray1D(e){return e=Array.isArray(e)?new Float32Array(e):e,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_78" /* tensor1d */])(e)}function min$1(e){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_22" /* min */])(toArray1D(e)).dataSync()[0]}function max$1(e){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_18" /* max */])(toArray1D(e)).dataSync()[0]}function range(e,t){if(t<e)throw new ValueError("end ("+t+") < begin ("+e+") is forbidden.");for(var n=[],r=e;r<t;++r)n.push(r);return n}function cast$1(e,t){return e.asType(t)}function expandDims(e,t){void 0===t&&(t=-1);var n=e.shape.slice();return t<0&&(t=n.length+t+1),n.splice(t,0,1),e.reshape(n)}function repeat(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){if(2!==e.shape.length)throw new ValueError("repeat() expects a rank-2 tensor, but received a rank-"+e.shape.length+" tensor.");return tile$1(expandDims(e,1),[1,t,1])})}function flatten(e){var t=[arrayProd(e.shape)];return e.reshape(t)}function batchFlatten(e){if(e.rank<=1)throw new ValueError("batchFlatten requires a minimum rank of 2. Got rank: "+e.rank+".");var t=[e.shape[0],arrayProd(e.shape,1)];return e.reshape(t)}function sliceAlongFirstAxis(e,t,n){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){switch(e.rank){case 1:return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_57" /* slice1d */])(e,t,n);case 2:return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_58" /* slice2d */])(e,[t,0],[n,e.shape[1]]);case 3:return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_59" /* slice3d */])(e,[t,0,0],[n,e.shape[1],e.shape[2]]);case 4:return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_60" /* slice4d */])(e,[t,0,0,0],[n,e.shape[1],e.shape[2],e.shape[3]]);default:throw new ValueError("sliceAlongFirstAxis() received an unsupported tensor rank: "+e.rank)}})}function sliceAlongLastAxis(e,t,n){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){switch(e.rank){case 1:return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_57" /* slice1d */])(e,t,n);case 2:return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_58" /* slice2d */])(e,[0,t],[e.shape[0],n]);case 3:return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_59" /* slice3d */])(e,[0,0,t],[e.shape[0],e.shape[1],n]);case 4:return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_60" /* slice4d */])(e,[0,0,0,t],[e.shape[0],e.shape[1],e.shape[2],n]);default:throw new ValueError("sliceAlongLastAxis() received an unsupported tensor rank: "+e.rank)}})}function sliceAlongAxis(e,t,n,r){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){switch(e.rank){case 1:return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_57" /* slice1d */])(e,t,n);case 2:switch(r){case 1:return sliceAlongFirstAxis(e,t,n);case 2:return sliceAlongLastAxis(e,t,n);default:throw new ValueError("The axis is not within the rank of the tensor "+r)}case 3:switch(r){case 1:return sliceAlongFirstAxis(e,t,n);case 2:return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_59" /* slice3d */])(e,[0,t,0],[e.shape[0],n,e.shape[2]]);case 3:return sliceAlongLastAxis(e,t,n);default:throw new ValueError("The axis is not within the rank of the tensor "+r)}case 4:switch(r){case 1:return sliceAlongFirstAxis(e,t,n);case 2:return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_60" /* slice4d */])(e,[0,t,0,0],[e.shape[0],n,e.shape[2],e.shape[3]]);case 3:return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_60" /* slice4d */])(e,[0,0,t,0],[e.shape[0],e.shape[1],n,e.shape[3]]);case 4:return sliceAlongLastAxis(e,t,n);default:throw new ValueError("The axis is not within the rank of the tensor "+r)}default:throw new ValueError("sliceAlongLastAxis() received an unsupported tensor rank: "+e.rank)}})}function concatenate(e,t){var n;return void 0===t&&(t=-1),t<0&&(t=0!==(n=e[0].rank)?n:0),t===e[0].rank&&(t=-1),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["A" /* concat */])(e,t)}function concatAlongFirstAxis(e,t){switch(e.rank){case 1:return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["B" /* concat1d */])([e,t]);case 2:return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["C" /* concat2d */])([e,t],0);case 3:return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["D" /* concat3d */])([e,t],0);case 4:return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["E" /* concat4d */])([e,t],0);default:throw new ValueError("concatAlongFirstAxis() received an unsupported tensor rank: "+e.rank)}}function tile$1(e,t){if(Array.isArray(t)||(t=[t]),e.rank!==t.length)throw new ValueError("The length of input n ("+t.length+") does not match the number of dimensions in input x ("+e.rank+")");return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_80" /* tile */])(e,t)}function randomNormal$1(e,t,n,r,i){return void 0===t&&(t=0),void 0===n&&(n=1),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_38" /* randomNormal */])(e,t,n,r,i)}function dot(e,t){if(e.rank<2||t.rank<2)throw new NotImplementedError("dot requires both inputs to be rank >= 2 but got x shape = "+e.shape+" and y shape = "+t.shape);if(t.rank>=3&&(r=e.shape.slice(-1)[0])!==(o=t.shape.slice(-2)[0]))throw new NotImplementedError("If rank y >= 3, then the second last dim of y must equal the last dim of x but got x shape = "+e.shape+" and  y shape = "+t.shape);if(2===e.rank&&2===t.rank)return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_17" /* matMul */])(e,t);var n=e.shape.slice(),r=n.pop();e=e.reshape([-1,r]);var i=t.shape.slice(),a=i.pop(),o=i.pop(),s=i.concat([a]),l=Array.from({length:t.rank},function(e,n){return 0===n?t.rank-2:n<=t.rank-2?n-1:n});t=t.transpose(l).reshape([o,-1]);var u=n.concat(s);return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_17" /* matMul */])(e,t).reshape(u)}function gather$1(e,t,n){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){return t=Array.isArray(t)?Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_78" /* tensor1d */])(t,"int32"):t.toInt(),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["Y" /* gather */])(e,t,n)})}function square(e){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_28" /* mulStrict */])(e,e)}function biasAdd(e,t,n){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){if(null==n&&(n=imageDataFormat()),checkDataFormat(n),1!==t.rank&&t.rank!==e.rank)throw new ValueError("Unexpected bias dimensions: "+t.rank+"; expected it to be 1 or "+e.rank);var r,i=t.shape;if(5===e.rank)"channelsFirst"===n?r=1===i.length?e.add(t.reshape([1,i[0],1,1,1])):e.add(t.reshape([1,i[3],i[0],i[1],i[2]])):"channelsLast"===n&&(r=1===i.length?e.add(t.reshape([1,1,1,1,i[0]])):e.add(t.reshape([1].concat(i))));else if(4===e.rank)"channelsFirst"===n?r=1===i.length?e.add(t.reshape([1,i[0],1,1])):e.add(t.reshape([1,i[2],i[0],i[1]])):"channelsLast"===n&&(r=1===i.length?e.add(t.reshape([1,1,1,i[0]])):e.add(t.reshape([1].concat(i))));else if(3===e.rank)"channelsFirst"===n?r=1===i.length?e.add(t.reshape([1,i[0],1])):e.add(t.reshape([1,i[1],i[0]])):"channelsLast"===n&&(r=1===i.length?e.add(t.reshape([1,1,i[0]])):e.add(t.reshape([1].concat(i))));else{if(!(e.rank<3))throw new ValueError("Unsupported input rank by biasAdd: "+e.rank);r=e.add(t)}return r})}function elu$1(e,t){if(void 0===t&&(t=1),1!==t)throw new NotImplementedError("Support for alpha values other than 1 ("+t+") is not implemented yet.");return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["O" /* elu */])(e)}function softsign(e){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["N" /* div */])(e,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(getScalar(1),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["d" /* abs */])(e)))})}function dropout(e,t,n,r){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){if(null!=n&&!__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].arraysEqual(e.shape,n))throw new NotImplementedError("Non-default noise shape is not implemented yet: "+JSON.stringify(n));if(null!=r)throw new NotImplementedError("seed is not implemented for dropout yet.");var i=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_71" /* step */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_29" /* neg */])(t),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_39" /* randomUniform */])(e.shape,0,1,"float32")));return i=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["N" /* div */])(getScalar(1),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_73" /* sub */])(getScalar(1),t)),i),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(e,i)})}function hardSigmoid(e){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var t=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(getScalar(.5),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(getScalar(.2),e));return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["z" /* clipByValue */])(t,0,1)})}function inTrainPhase(e,t,n){return void 0===n&&(n=!1),n?e():t()}var VALID_FAN_MODE_VALUES=["fanIn","fanOut","fanAvg"];function checkFanMode(e){checkStringTypeUnionValue(VALID_FAN_MODE_VALUES,"FanMode",e)}var VALID_DISTRIBUTION_VALUES=["normal","uniform"];function checkDistribution(e){checkStringTypeUnionValue(VALID_DISTRIBUTION_VALUES,"Distribution",e)}var Initializer=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.fromConfigUsesCustomObjects=function(){return!1},t.prototype.getConfig=function(){return{}},t}(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].Serializable),Zeros=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.apply=function(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_91" /* zeros */])(e,t)},t.className="Zeros",t}(Initializer);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Zeros);var Ones=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.apply=function(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_33" /* ones */])(e,t)},t.className="Ones",t}(Initializer);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Ones);var Constant=function(e){function t(t){var n=e.call(this)||this;if("object"!=typeof t)throw new ValueError("Expected argument of type ConstantConfig but got "+t);if(void 0===t.value)throw new ValueError("config must have value set but got "+t);return n.value=t.value,n}return __extends(t,e),t.prototype.apply=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_46" /* scalar */])(n.value),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_33" /* ones */])(e,t))})},t.prototype.getConfig=function(){return{value:this.value}},t.className="Constant",t}(Initializer);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Constant);var RandomUniform=function(e){function t(t){var n=e.call(this)||this;return n.DEFAULT_MINVAL=-.05,n.DEFAULT_MAXVAL=.05,n.minval=t.minval||n.DEFAULT_MINVAL,n.maxval=t.maxval||n.DEFAULT_MAXVAL,n.seed=t.seed,n}return __extends(t,e),t.prototype.apply=function(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_39" /* randomUniform */])(e,this.minval,this.maxval,t)},t.prototype.getConfig=function(){return{minval:this.minval,maxval:this.maxval,seed:this.seed}},t.className="RandomUniform",t}(Initializer);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(RandomUniform);var RandomNormal=function(e){function t(t){var n=e.call(this)||this;return n.DEFAULT_MEAN=0,n.DEFAULT_STDDEV=.05,n.mean=t.mean||n.DEFAULT_MEAN,n.stddev=t.stddev||n.DEFAULT_STDDEV,n.seed=t.seed,n}return __extends(t,e),t.prototype.apply=function(e,t){if("float32"!==(t=t||"float32")&&"int32"!==t)throw new NotImplementedError("randomNormal does not support dType "+t+".");return randomNormal$1(e,this.mean,this.stddev,t,this.seed)},t.prototype.getConfig=function(){return{mean:this.mean,stddev:this.stddev,seed:this.seed}},t.className="RandomNormal",t}(Initializer);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(RandomNormal);var TruncatedNormal=function(e){function t(t){var n=e.call(this)||this;return n.DEFAULT_MEAN=0,n.DEFAULT_STDDEV=.05,n.mean=t.mean||n.DEFAULT_MEAN,n.stddev=t.stddev||n.DEFAULT_STDDEV,n.seed=t.seed,n}return __extends(t,e),t.prototype.apply=function(e,t){if("float32"!==(t=t||"float32")&&"int32"!==t)throw new NotImplementedError("truncatedNormal does not support dType "+t+".");return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_84" /* truncatedNormal */])(e,this.mean,this.stddev,t,this.seed)},t.prototype.getConfig=function(){return{mean:this.mean,stddev:this.stddev,seed:this.seed}},t.className="TruncatedNormal",t}(Initializer);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(TruncatedNormal);var Identity=function(e){function t(t){var n=e.call(this)||this;return n.gain=null!=t.gain?Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_46" /* scalar */])(t.gain):getScalar(1),n}return __extends(t,e),t.prototype.apply=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){if(2!==e.length||e[0]!==e[1])throw new ValueError("Identity matrix initializer can only be used for 2D square matrices.");return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(n.gain,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["U" /* eye */])(e[0]))})},t.prototype.getConfig=function(){return{gain:this.gain.get()}},t.className="Identity",t}(Initializer);function computeFans(e,t){var n,r;if(void 0===t&&(t="channelsLast"),checkDataFormat(t),2===e.length)n=e[0],r=e[1];else if(-1!==[3,4,5].indexOf(e.length)){if("channelsFirst"===t){var i=arrayProd(e,2);n=e[1]*i,r=e[0]*i}else if("channelsLast"===t){i=arrayProd(e,0,e.length-2);n=e[e.length-2]*i,r=e[e.length-1]*i}}else{var a=arrayProd(e);n=Math.sqrt(a),r=Math.sqrt(a)}return[n,r]}__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Identity);var VarianceScaling=function(e){function t(t){var n=e.call(this)||this;if(t.scale<0)throw new ValueError("scale must be a positive float. Got: "+t.scale);return n.scale=null==t.scale?1:t.scale,n.mode=t.mode,checkFanMode(n.mode),n.distribution=t.distribution,checkDistribution(n.distribution),n.seed=t.seed,n}return __extends(t,e),t.prototype.apply=function(e,t){var n=computeFans(e),r=n[0],i=n[1],a=this.scale;if("fanIn"===this.mode?a/=Math.max(1,r):"fanOut"===this.mode?a/=Math.max(1,i):a/=Math.max(1,(r+i)/2),"normal"===this.distribution){var o=Math.sqrt(a);if("float32"!==(t=t||"float32")&&"int32"!==t)throw new NotImplementedError(this.getClassName()+" does not support dType "+t+".");return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_84" /* truncatedNormal */])(e,0,o,t,this.seed)}var s=Math.sqrt(3*a);return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_39" /* randomUniform */])(e,-s,s,t)},t.prototype.getConfig=function(){return{scale:this.scale,mode:this.mode,distribution:this.distribution,seed:this.seed}},t.className="VarianceScaling",t}(Initializer);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(VarianceScaling);var GlorotUniform=function(e){function t(t){return e.call(this,{scale:1,mode:"fanAvg",distribution:"uniform",seed:null==t?null:t.seed})||this}return __extends(t,e),t.prototype.getClassName=function(){return VarianceScaling.className},t.className="GlorotUniform",t}(VarianceScaling);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(GlorotUniform);var GlorotNormal=function(e){function t(t){return e.call(this,{scale:1,mode:"fanAvg",distribution:"normal",seed:null==t?null:t.seed})||this}return __extends(t,e),t.prototype.getClassName=function(){return VarianceScaling.className},t.className="GlorotNormal",t}(VarianceScaling);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(GlorotNormal);var HeNormal=function(e){function t(t){return e.call(this,{scale:2,mode:"fanIn",distribution:"normal",seed:null==t?null:t.seed})||this}return __extends(t,e),t.prototype.getClassName=function(){return VarianceScaling.className},t.className="HeNormal",t}(VarianceScaling);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(HeNormal);var LeCunNormal=function(e){function t(t){return e.call(this,{scale:1,mode:"fanIn",distribution:"normal",seed:null==t?null:t.seed})||this}return __extends(t,e),t.prototype.getClassName=function(){return VarianceScaling.className},t.className="LeCunNormal",t}(VarianceScaling);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(LeCunNormal);var Orthogonal=function(e){function t(t){var n=e.call(this)||this;if(n.DEFAULT_GAIN=1,n.gain=null==t.gain?n.DEFAULT_GAIN:t.gain,n.seed=t.seed,null!=n.seed)throw new NotImplementedError("Random seed is not implemented for Orthogonal Initializer yet.");return n}return __extends(t,e),t.prototype.apply=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){if(2!==e.length)throw new NotImplementedError("The Orthogonal Initializer does not support non-2D shapes yet.");e[0]*e[1]>2e3&&console.warn("Orthogonal initializer is being called on a matrix with more than 2000 ("+e[0]*e[1]+") elements: Slowness may result.");var t=randomNormal$1(e[0]>e[1]?[e[1],e[0]]:e,0,1,"float32"),r=__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_8" /* linalg */].gramSchmidt(t);return e[0]>e[1]&&(r=r.transpose()),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(getScalar(n.gain),r)})},t.prototype.getConfig=function(){return{gain:this.gain,seed:this.seed}},t.className="Orthogonal",t}(Initializer);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Orthogonal);var INITIALIZER_IDENTIFIER_REGISTRY_SYMBOL_MAP={constant:"Constant",glorotNormal:"GlorotNormal",glorotUniform:"GlorotUniform",heNormal:"HeNormal",identity:"Identity",leCunNormal:"LeCunNormal",ones:"Ones",orthogonal:"Orthogonal",randomNormal:"RandomNormal",randomUniform:"RandomUniform",truncatedNormal:"TruncatedNormal",varianceScaling:"VarianceScaling",zeros:"Zeros"};function deserializeInitializer(e,t){return void 0===t&&(t={}),deserializeKerasObject(e,__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].SerializationMap.getMap().classNameMap,t,"initializer")}function serializeInitializer(e){return serializeKerasObject(e)}function getInitializer(e){if("string"==typeof e){var t=e in INITIALIZER_IDENTIFIER_REGISTRY_SYMBOL_MAP?INITIALIZER_IDENTIFIER_REGISTRY_SYMBOL_MAP[e]:e;return"GlorotUniform"===t?new GlorotUniform:"GlorotNormal"===t?new GlorotNormal:"HeNormal"===t?new HeNormal:"LeCunNormal"===t?new LeCunNormal:deserializeInitializer({className:t,config:{}})}return e instanceof Initializer?e:deserializeInitializer(e)}function zeros$1(){return new Zeros}function ones$1(){return new Ones}function constant(e){return new Constant(e)}function randomUniform$1(e){return new RandomUniform(e)}function randomNormal$2(e){return new RandomNormal(e)}function truncatedNormal$1(e){return new TruncatedNormal(e)}function identity(e){return new Identity(e)}function varianceScaling(e){return new VarianceScaling(e)}function glorotUniform(e){return new GlorotUniform(e)}function glorotNormal(e){return new GlorotNormal(e)}function heNormal(e){return new HeNormal(e)}function leCunNormal(e){return new LeCunNormal(e)}function orthogonal(e){return new Orthogonal(e)}var exports_initializers=Object.freeze({zeros:zeros$1,ones:ones$1,constant:constant,randomUniform:randomUniform$1,randomNormal:randomNormal$2,truncatedNormal:truncatedNormal$1,identity:identity,varianceScaling:varianceScaling,glorotUniform:glorotUniform,glorotNormal:glorotNormal,heNormal:heNormal,leCunNormal:leCunNormal,orthogonal:orthogonal});function isArrayOfShapes(e){return Array.isArray(e)&&Array.isArray(e[0])}function normalizeShapeList(e){return 0===e.length?[]:Array.isArray(e[0])?e:[e]}function getExactlyOneTensor(e){var t;if(Array.isArray(e)){if(1!==e.length)throw new ValueError("Expected Tensor length to be 1; got "+e.length);t=e[0]}else t=e;return t}function getExactlyOneShape(e){if(Array.isArray(e)&&Array.isArray(e[0])){if(1===e.length)return(e=e)[0];throw new ValueError("Expected exactly 1 Shape; got "+e.length)}return e}function countParamsInWeights(e){for(var t=0,n=0,r=e;n<r.length;n++){var i=r[n];0===i.shape.length?t+=1:t+=i.shape.reduce(function(e,t){return e*t})}return t}var DEFAULT_VARIABLE_NAME_PREFIX="Variable",LayerVariable=function(){function e(e,t,n,r,i){void 0===t&&(t="float32"),void 0===n&&(n=DEFAULT_VARIABLE_NAME_PREFIX),void 0===r&&(r=!0),void 0===i&&(i=null),this.dtype=null==t?"float32":t,this.shape=e.shape,this.id=getNextUniqueTensorId(),n=null==n?DEFAULT_VARIABLE_NAME_PREFIX:n,this.originalName=getScopedTensorName(n),this.name=getUniqueTensorName(this.originalName),this.trainable=r,this.constraint=i,this.val=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_87" /* variable */])(e,this.trainable,this.name,this.dtype)}return e.prototype.read=function(){return this.assertNotDisposed(),this.val},e.prototype.write=function(e){return this.assertNotDisposed(),checkShapesMatch(this.val,e),this.val.id!==e.id&&(this.val.assign(e),null!=this.constraint&&this.val.assign(this.constraint.apply(this.val))),this},e.prototype.dispose=function(){this.assertNotDisposed(),this.val.dispose()},e.prototype.assertNotDisposed=function(){if(this.val.isDisposed)throw new Error("LayersVariable "+this.name+" is already disposed.")},e}();function checkShapesMatch(e,t){if(e.shape.toString()!==t.shape.toString())throw new Error("Shape mismatch: "+JSON.stringify(e.shape)+" vs. "+JSON.stringify(t.shape))}function batchGetValue(e){return e.map(function(e){return e.read()})}function batchSetValue(e){e.map(function(e){e[0].write(e[1])})}var InputSpec=function(){return function(e){this.dtype=e.dtype,this.shape=e.shape,null!=e.shape?this.ndim=e.shape.length:this.ndim=e.ndim,this.maxNDim=e.maxNDim,this.minNDim=e.minNDim,this.axes=e.axes||{}}}(),SymbolicTensor=function(){return function(e,t,n,r,i,a,o){this.dtype=e,this.shape=t,this.sourceLayer=n,this.inputs=r,this.callArgs=i,this.outputTensorIndex=o,this.id=getNextUniqueTensorId(),null!=a&&(this.originalName=getScopedTensorName(a),this.name=getUniqueTensorName(this.originalName)),this.rank=t.length}}(),_nextNodeID=0,Node=function(){function e(e,t){this.callArgs=t,this.id=_nextNodeID++,this.outboundLayer=e.outboundLayer,this.inboundLayers=e.inboundLayers,this.nodeIndices=e.nodeIndices,this.tensorIndices=e.tensorIndices,this.inputTensors=e.inputTensors,this.outputTensors=e.outputTensors,this.inputMasks=e.inputMasks,this.outputMasks=e.outputMasks,this.inputShapes=e.inputShapes,this.outputShapes=e.outputShapes;for(var n=0,r=e.inboundLayers;n<r.length;n++){var i=r[n];null!=i&&i.outboundNodes.push(this)}e.outboundLayer.inboundNodes.push(this)}return e.prototype.getConfig=function(){for(var e=[],t=0,n=this.inboundLayers;t<n.length;t++){var r=n[t];null!=r?e.push(r.name):e.push(null)}return{outboundLayer:this.outboundLayer?this.outboundLayer.name:null,inboundLayers:e,nodeIndices:this.nodeIndices,tensorIndices:this.tensorIndices}},e}(),_nextLayerID=0,Layer=function(e){function t(t){var n=e.call(this)||this;n._callHook=null,n._addedWeightNames=[],n._stateful=!1,n.id=_nextLayerID++,n.activityRegularizer=null,n.inputSpec=null,n.supportsMasking=!1,n._trainableWeights=[],n._nonTrainableWeights=[],n._losses=[],n._updates=[],n._built=!1,n.inboundNodes=[],n.outboundNodes=[];var r=t.name;if(!r){var i=n.getClassName();r=toSnakeCase(i)+"_"+getUid(i)}if(n.name=r,n.trainable=null==t.trainable||t.trainable,n.updatable=null==t.updatable||t.updatable,null!=t.inputShape||null!=t.batchInputShape){var a=void 0;if(null!=t.batchInputShape)a=t.batchInputShape;else if(null!=t.inputShape){var o=null;null!=t.batchSize&&(o=t.batchSize),a=[o].concat(t.inputShape)}n.batchInputShape=a;var s=t.dtype;null==s&&(s=t.inputDType),null==s&&(s="float32"),n.dtype=s}return null!=t.weights?n.initialWeights=t.weights:n.initialWeights=null,n._refCount=null,n}return __extends(t,e),t.nodeKey=function(e,t){return e.name+"_ib-"+t.toString()},t.prototype.getNodeAtIndex=function(e,t){if(0===this.inboundNodes.length)throw new RuntimeError("The layer has never been called and thus has no defined "+t+".");if(this.inboundNodes.length<=e)throw new ValueError("Asked to get "+t+" at node "+e+", but the layer has only "+this.inboundNodes.length+" inbound nodes.");return this.inboundNodes[e]},t.prototype.getInputAt=function(e){return singletonOrArray(this.getNodeAtIndex(e,"input").inputTensors)},t.prototype.getOutputAt=function(e){return singletonOrArray(this.getNodeAtIndex(e,"output").outputTensors)},Object.defineProperty(t.prototype,"input",{get:function(){if(this.inboundNodes.length>1)throw new AttributeError("Layer "+this.name+' has multiple inbound nodes, hence the notion of "layer input" is ill-defined. Use `getInputAt(nodeIndex)` instead.');if(0===this.inboundNodes.length)throw new AttributeError("Layer "+this.name+" is not connected, no input to return.");return singletonOrArray(this.getNodeAtIndex(0,"input").inputTensors)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"output",{get:function(){if(0===this.inboundNodes.length)throw new AttributeError("Layer "+this.name+" has no inbound nodes.");if(this.inboundNodes.length>1)throw new AttributeError("Layer "+this.name+' has multiple inbound nodes, hence the notion of "layer output" is ill-defined. Use `getOutputAt(nodeIndex)` instead.');return singletonOrArray(this.getNodeAtIndex(0,"output").outputTensors)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"losses",{get:function(){return this._losses},enumerable:!0,configurable:!0}),t.prototype.calculateLosses=function(){return this.losses.map(function(e){return e()})},Object.defineProperty(t.prototype,"updates",{get:function(){return this._updates},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"built",{get:function(){return this._built},set:function(e){this._built=e},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"trainableWeights",{get:function(){return this.trainable?this._trainableWeights:[]},set:function(e){this._trainableWeights=e},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"nonTrainableWeights",{get:function(){return this.trainable?this._nonTrainableWeights:this._trainableWeights.concat(this._nonTrainableWeights)},set:function(e){this._nonTrainableWeights=e},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"weights",{get:function(){return this.trainableWeights.concat(this.nonTrainableWeights)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"stateful",{get:function(){return this._stateful},enumerable:!0,configurable:!0}),t.prototype.resetStates=function(){if(!this.stateful)throw new Error("Cannot call the resetStates() method of a non-stateful Layer object.")},t.prototype.assertInputCompatibility=function(e){if(e=toList(e),null!=this.inputSpec&&0!==this.inputSpec.length){var t=toList(this.inputSpec);if(e.length!==t.length)throw new ValueError("Layer "+this.name+" expects "+t.length+" inputs, but it received "+e.length+" input tensors. Input received: "+e);for(var n=0;n<e.length;n++){var r=e[n],i=t[n];if(null!=i){var a=r.rank;if(null!=i.ndim&&a!==i.ndim)throw new ValueError("Input "+n+" is incompatible with layer "+this.name+": expected ndim="+i.ndim+", found ndim="+a);if(null!=i.maxNDim&&a>i.maxNDim)throw new ValueError("Input "+n+" is incompatible with layer "+this.name+": expected max_ndim="+i.maxNDim+", found ndim="+a);if(null!=i.minNDim&&a<i.minNDim)throw new ValueError("Input "+n+" is incompatible with layer "+this.name+": expected min_ndim="+i.minNDim+", found ndim="+a+".");if(null!=i.dtype&&r.dtype!==i.dtype)throw new ValueError("Input "+n+" is incompatible with layer "+this.name+" : expected dtype="+i.dtype+", found dtype="+r.dtype+".");if(i.axes){var o=r.shape;for(var s in i.axes){var l=Number(s),u=i.axes[s],c=l>=0?o[l]:o[o.length+l];if(null!=u&&-1===[u,null].indexOf(c))throw new ValueError("Input "+n+" is incompatible with layer "+this.name+": expected axis "+l+" of input shape to have value "+u+" but got shape "+o+".")}}if(null!=i.shape)for(var p=0;p<i.shape.length;++p){var h=i.shape[p],d=r.shape[p];if(null!=h&&null!=d&&h!==d)throw new ValueError("Input "+n+" is incompatible with layer "+this.name+": expected shape="+i.shape+", found shape=${xShape}.")}}}}},t.prototype.call=function(e,t){return e},t.prototype.invokeCallHook=function(e,t){null!=this._callHook&&this._callHook(e,t)},t.prototype.setCallHook=function(e){this._callHook=e},t.prototype.clearCallHook=function(){this._callHook=null},t.prototype.apply=function(e,t){var n=this;t=t||{},this.assertNotDisposed();for(var r=toList(e),i=!0,a=0,o=r;a<o.length;a++){if(!(o[a]instanceof SymbolicTensor)){i=!1;break}}for(var s=!0,l=0,u=r;l<u.length;l++){if(u[l]instanceof SymbolicTensor){s=!1;break}}if(i===s)throw new ValueError("Arguments to apply() must be all SymbolicTensors or all Tensors");return nameScope(this.name,function(){if(!n.built){n.assertInputCompatibility(e);for(var i=[],a=0,o=toList(e);a<o.length;a++){var l=o[a];i.push(l.shape)}n.build(singletonOrArray(i)),n.built=!0,n.initialWeights&&n.setWeights(n.initialWeights),null===n._refCount&&s&&(n._refCount=1)}if(n.assertInputCompatibility(e),s){for(var u=[],c=0,p=toList(g=n.call(e,t));c<p.length;c++){var h=p[c];-1!==r.indexOf(h)&&(h=h.clone()),u.push(h)}if(g=singletonOrArray(u),null!=n.activityRegularizer)throw new NotImplementedError("Layer invocation in the presence of activity regularizer(s) is not supported yet.");return g}var d=collectInputShape(e),f=n.computeOutputShape(d),g=void 0,m=guessOutputDType(e);if(n.warnOnIncompatibleInputShape(Array.isArray(e)?d[0]:d),g=null!=f&&f.length>0&&Array.isArray(f[0])?f.map(function(r,i){return new SymbolicTensor(m,r,n,toList(e),t,n.name,i)}):new SymbolicTensor(m,f,n,toList(e),t,n.name),n.addInboundNode(e,g,null,null,d,f,t),n._refCount++,null!=n.activityRegularizer)throw new NotImplementedError("Layer invocation in the presence of activity regularizer(s) is not supported yet.");return g})},t.prototype.warnOnIncompatibleInputShape=function(e){if(null!=this.batchInputShape)if(e.length!==this.batchInputShape.length)console.warn("The rank of the input tensor provided (shape: "+JSON.stringify(e)+") does not match that of the batchInputShape ("+JSON.stringify(this.batchInputShape)+") of the layer "+this.name);else{var t=!1;this.batchInputShape.forEach(function(n,r){null!=n&&null!=e[r]&&e[r]!==n&&(t=!0)}),t&&console.warn("The shape of the input tensor ("+JSON.stringify(e)+") does not match the expectation of layer "+this.name+": "+JSON.stringify(this.batchInputShape))}},Object.defineProperty(t.prototype,"outputShape",{get:function(){if(null==this.inboundNodes||0===this.inboundNodes.length)throw new AttributeError("The layer "+this.name+" has never been called and thus has no defined output shape.");for(var e=[],t=0,n=this.inboundNodes;t<n.length;t++){var r=n[t],i=JSON.stringify(r.outputShapes);-1===e.indexOf(i)&&e.push(i)}if(1===e.length){var a=this.inboundNodes[0].outputShapes;return Array.isArray(a)&&Array.isArray(a[0])&&1===a.length?a[0]:a}throw new AttributeError("The layer "+this.name+' has multiple inbound nodes with different output shapes. Hence the notion of "outut shape" is ill-defined for the layer.')},enumerable:!0,configurable:!0}),t.prototype.countParams=function(){if(!this.built)throw new RuntimeError("You tried to call countParams() on "+this.name+", but the layer is not built yet. Build it first by calling build(batchInputShape).");return countParamsInWeights(this.weights)},t.prototype.build=function(e){this.built=!0},t.prototype.getWeights=function(e){return void 0===e&&(e=!1),batchGetValue(e?this.trainableWeights:this.weights)},t.prototype.setWeights=function(e){var t=this;Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n=t.weights;if(n.length!==e.length)throw new ValueError('You called setWeights(weights) on layer "'+t.name+'" with a weight list of length '+e.length+", but the layer was expecting "+n.length+" weights. Provided weights: "+e+"...");if(0!==n.length){for(var r=[],i=batchGetValue(n),a=0;a<i.length;++a){var o=i[a],s=n[a],l=e[a];if(!__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].arraysEqual(o.shape,l.shape))throw new ValueError("Layer weight shape "+o.shape+" not compatible with provided weight shape "+l.shape);r.push([s,l])}batchSetValue(r)}})},t.prototype.addWeight=function(e,t,n,r,i,a,o){if(-1!==this._addedWeightNames.indexOf(e))throw new ValueError("Duplicate weight name "+e+" for layer "+this.name);this._addedWeightNames.push(e),null==n&&(n="float32");var s=new LayerVariable(r.apply(t,n),n,e,a,o);return null!=i&&this.addLoss(function(){return i.apply(s.read())}),null==a&&(a=!0),a?this._trainableWeights.push(s):this._nonTrainableWeights.push(s),s},t.prototype.addLoss=function(e){var t;null==e||Array.isArray(e)&&0===e.length||(e=toList(e),void 0!==this._losses&&null!==this._losses&&(t=this.losses).push.apply(t,e))},t.prototype.computeOutputShape=function(e){return e},t.prototype.computeMask=function(e,t){var n=this;if(!this.supportsMasking){if(null!=t){if(!Array.isArray(t))throw new TypeError("Layer "+this.name+" does not support masking,but was passed an inputMask.");t.forEach(function(e){if(null!=e)throw new TypeError("Layer "+n.name+" does not support masking,but was passed an inputMask.")})}return null}return t},t.prototype.addInboundNode=function(e,t,n,r,i,a,o){void 0===o&&(o=null);var s=toList(e);t=toList(t),n=toList(n),r=toList(r),i=normalizeShapeList(i),a=normalizeShapeList(a);for(var l=[],u=[],c=[],p=0,h=s;p<h.length;p++){var d=h[p];l.push(d.sourceLayer),u.push(d.nodeIndex),c.push(d.tensorIndex)}new Node({outboundLayer:this,inboundLayers:l,nodeIndices:u,tensorIndices:c,inputTensors:s,outputTensors:t,inputMasks:n,outputMasks:r,inputShapes:i,outputShapes:a},o);for(var f=0;f<t.length;f++)t[f].sourceLayer=this,t[f].nodeIndex=this.inboundNodes.length-1,t[f].tensorIndex=f},t.prototype.getConfig=function(){var e={name:this.name,trainable:this.trainable};return null!=this.batchInputShape&&(e.batchInputShape=this.batchInputShape),null!=this.dtype&&(e.dtype=this.dtype),e},t.prototype.disposeWeights=function(){return this.weights.forEach(function(e){return e.dispose()}),this.weights.length},t.prototype.assertNotDisposed=function(){if(0===this._refCount)throw new Error("Layer '"+this.name+"' is already disposed.")},t.prototype.dispose=function(){if(!this.built)throw new Error("Cannot dispose Layer "+this.name+" because it has not been built yet.");if(null===this._refCount)throw new Error("Cannot dispose Layer "+this.name+" because it has not been used yet.");this.assertNotDisposed();var e=0;return 0==--this._refCount&&(e=this.disposeWeights()),{refCountAfterDispose:this._refCount,numDisposedVariables:e}},t}(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].Serializable);function collectInputShape(e){for(var t=[],n=0,r=e=toList(e);n<r.length;n++){var i=r[n];t.push(i.shape)}return singletonOrArray(t)}function guessOutputDType(e){return"float32"}function getSourceInputs(e,t,n){if((null==t||null!=n&&n>0)&&(t=e.sourceLayer,n=e.nodeIndex),0===t.inboundNodes.length)return[e];var r=t.inboundNodes[n];if(0===r.inboundLayers.length)return r.inputTensors;for(var i=[],a=0;a<r.inboundLayers.length;a++)for(var o=0,s=getSourceInputs(r.inputTensors[a],r.inboundLayers[a],r.nodeIndices[a]);o<s.length;o++){var l=s[o];-1===i.indexOf(l)&&i.push(l)}return i}var ModelLoggingVerbosity,InputLayer=function(e){function t(t){var n=e.call(this,{dtype:t.dtype,name:null!=t.name?t.name:getUid("input").toString()})||this;if(null==t.batchSize&&(t.batchSize=null),null==t.sparse&&(t.sparse=!1),n.trainable=!1,n.built=!0,n.sparse=t.sparse,null!=t.inputShape&&null!=t.batchInputShape)throw new ValueError("Only provide the inputShape OR batchInputShape argument to inputLayer, not both at the same time.");var r=t.batchInputShape;if(null==r){if(null==t.inputShape)throw new ValueError("An InputLayer should be passed either a `batchInputShape` or an `inputShape`.");r=[t.batchSize].concat(t.inputShape)}else if(null!=t.batchSize)throw new ValueError("Cannot specify batchSize if batchInputShape isspecified when creating an InputLayer.");var i=t.dtype||"float32";n.batchInputShape=r,n.dtype=i,n.inputSpec=[{shape:r}];var a=new SymbolicTensor(n.dtype,n.batchInputShape,n,[],{},n.name);return a.nodeIndex=0,a.tensorIndex=0,new Node({outboundLayer:n,inboundLayers:[],nodeIndices:[],tensorIndices:[],inputTensors:[a],outputTensors:[a],inputMasks:[null],outputMasks:[null],inputShapes:[r],outputShapes:[r]}),n}return __extends(t,e),t.prototype.apply=function(e,t){throw new ValueError("Cannot pass any input to an InputLayer's apply() method. InputLayer name: "+this.name)},t.prototype.dispose=function(){return{refCountAfterDispose:this._refCount,numDisposedVariables:0}},t.prototype.getConfig=function(){return{batchInputShape:this.batchInputShape,dtype:this.dtype,sparse:this.sparse,name:this.name}},t.className="InputLayer",t}(Layer);function Input(e){if(null==e.batchShape&&null==e.shape)throw new Error("Please provide to Input either a `shape` or a `batchShape` argument. Note that `shape` does not include the batch dimension.");if(null!=e.batchShape&&null!=e.shape)throw new ValueError("Please provide either a `shape` or `batchShape` argument to Input, but not both.");var t=e.batchShape;null!=e.shape&&null==t&&(t=[null].concat(e.shape));var n=e.dtype;return null==n&&(n="float32"),new InputLayer({batchInputShape:t,name:e.name,dtype:n,sparse:e.sparse}).inboundNodes[0].outputTensors[0]}function resolveScalarsInLogs(e){return __awaiter(this,void 0,void 0,function(){var t,n,r,i,a,o,s,l;return __generator(this,function(u){switch(u.label){case 0:if(null==e)return[2];for(i in t=[],n=[],r=[],e)"number"!=typeof(a=e[i])&&(o=a,t.push(o.data()),n.push(i),r.push(o));return[4,Promise.all(t)];case 1:for(s=u.sent(),l=0;l<s.length;++l)e[n[l]]=s[l][0];return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["M" /* dispose */])(r),[2]}})})}function disposeTensorsInLogs(e){if(null!=e)for(var t in e){var n=e[t];"number"!=typeof n&&n.dispose()}}__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(InputLayer),function(e){e[e.SILENT=0]="SILENT",e[e.VERBOSE=1]="VERBOSE"}(ModelLoggingVerbosity||(ModelLoggingVerbosity={}));var BaseCallback=function(){function e(){this.validationData=null}return e.prototype.setParams=function(e){this.params=e},e.prototype.onEpochBegin=function(e,t){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(e){return[2]})})},e.prototype.onEpochEnd=function(e,t){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(e){return[2]})})},e.prototype.onBatchBegin=function(e,t){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(e){return[2]})})},e.prototype.onBatchEnd=function(e,t){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(e){return[2]})})},e.prototype.onTrainBegin=function(e){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(e){return[2]})})},e.prototype.onTrainEnd=function(e){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(e){return[2]})})},e.prototype.setModel=function(e){},e}(),CallbackList=function(){function e(e,t){void 0===t&&(t=10),null==e&&(e=[]),this.callbacks=e,this.queueLength=t}return e.prototype.append=function(e){this.callbacks.push(e)},e.prototype.setParams=function(e){for(var t=0,n=this.callbacks;t<n.length;t++){n[t].setParams(e)}},e.prototype.setModel=function(e){for(var t=0,n=this.callbacks;t<n.length;t++){n[t].setModel(e)}},e.prototype.onEpochBegin=function(e,t){return __awaiter(this,void 0,void 0,function(){var n,r;return __generator(this,function(i){switch(i.label){case 0:null==t&&(t={}),n=0,r=this.callbacks,i.label=1;case 1:return n<r.length?[4,r[n].onEpochBegin(e,t)]:[3,4];case 2:i.sent(),i.label=3;case 3:return n++,[3,1];case 4:return[2]}})})},e.prototype.onEpochEnd=function(e,t){return __awaiter(this,void 0,void 0,function(){var n,r;return __generator(this,function(i){switch(i.label){case 0:null==t&&(t={}),n=0,r=this.callbacks,i.label=1;case 1:return n<r.length?[4,r[n].onEpochEnd(e,t)]:[3,4];case 2:i.sent(),i.label=3;case 3:return n++,[3,1];case 4:return[2]}})})},e.prototype.onBatchBegin=function(e,t){return __awaiter(this,void 0,void 0,function(){var n,r;return __generator(this,function(i){switch(i.label){case 0:null==t&&(t={}),n=0,r=this.callbacks,i.label=1;case 1:return n<r.length?[4,r[n].onBatchBegin(e,t)]:[3,4];case 2:i.sent(),i.label=3;case 3:return n++,[3,1];case 4:return[2]}})})},e.prototype.onBatchEnd=function(e,t){return __awaiter(this,void 0,void 0,function(){var n,r;return __generator(this,function(i){switch(i.label){case 0:return null==t&&(t={}),[4,resolveScalarsInLogs(t)];case 1:i.sent(),n=0,r=this.callbacks,i.label=2;case 2:return n<r.length?[4,r[n].onBatchEnd(e,t)]:[3,5];case 3:i.sent(),i.label=4;case 4:return n++,[3,2];case 5:return[2]}})})},e.prototype.onTrainBegin=function(e){return __awaiter(this,void 0,void 0,function(){var t,n;return __generator(this,function(r){switch(r.label){case 0:null==e&&(e={}),t=0,n=this.callbacks,r.label=1;case 1:return t<n.length?[4,n[t].onTrainBegin(e)]:[3,4];case 2:r.sent(),r.label=3;case 3:return t++,[3,1];case 4:return[2]}})})},e.prototype.onTrainEnd=function(e){return __awaiter(this,void 0,void 0,function(){var t,n;return __generator(this,function(r){switch(r.label){case 0:null==e&&(e={}),t=0,n=this.callbacks,r.label=1;case 1:return t<n.length?[4,n[t].onTrainEnd(e)]:[3,4];case 2:r.sent(),r.label=3;case 3:return t++,[3,1];case 4:return[2]}})})},e}(),ModelTrainingYielder=function(){function e(e){this.yieldEvery=e,this.batchCount=0,this.batchDurationsMillis=[],this.autoYieldEveryBatches=null,this.batchStartMillis=__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].now()}return e.prototype.resolveOneTensorInLogs=function(e){return __awaiter(this,void 0,void 0,function(){var t,n,r,i,a;return __generator(this,function(o){switch(o.label){case 0:for(n in t=[],e)t.push(n);r=0,o.label=1;case 1:return r<t.length?(i=t[r],"number"==typeof(a=e[i])?[3,3]:[4,a.data()]):[3,4];case 2:return o.sent(),[3,4];case 3:return r++,[3,1];case 4:return[2]}})})},e.prototype.maybeYieldOnBatch=function(t){return __awaiter(this,void 0,void 0,function(){var n,r;return __generator(this,function(i){switch(i.label){case 0:return"auto"!==this.yieldEvery?[3,7]:(this.batchCount++,null!=this.autoYieldEveryBatches?[3,3]:[4,this.resolveOneTensorInLogs(t)]);case 1:return i.sent(),n=__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].now(),[4,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_30" /* nextFrame */])()];case 2:return i.sent(),this.batchCount>e.SKIP_FIRST_BATCHES&&(this.batchDurationsMillis.push(n-this.batchStartMillis),this.batchDurationsMillis.length>=e.DECISION_BATCH_COUNT&&(r=this.batchDurationsMillis.reduce(function(e,t){return e+t})/this.batchDurationsMillis.length,this.autoYieldEveryBatches=Math.round(e.THRESHOLD_MILLIS/r),this.autoYieldEveryBatches<1&&(this.autoYieldEveryBatches=1))),this.batchStartMillis=__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].now(),this.lastYieldBatchCount=this.batchCount,[3,6];case 3:return this.batchCount-this.lastYieldBatchCount>=this.autoYieldEveryBatches?[4,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_30" /* nextFrame */])()]:[3,6];case 4:return i.sent(),[4,this.resolveOneTensorInLogs(t)];case 5:i.sent(),this.lastYieldBatchCount=this.batchCount,i.label=6;case 6:return[3,9];case 7:return"batch"!==this.yieldEvery?[3,9]:[4,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_30" /* nextFrame */])()];case 8:i.sent(),i.label=9;case 9:return[2]}})})},e.prototype.maybeYieldOnEpoch=function(){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(e){switch(e.label){case 0:return"epoch"!==this.yieldEvery?[3,2]:[4,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_30" /* nextFrame */])()];case 1:e.sent(),e.label=2;case 2:return[2]}})})},e.SKIP_FIRST_BATCHES=1,e.DECISION_BATCH_COUNT=2,e.THRESHOLD_MILLIS=16,e}(),BaseLogger=function(e){function t(t){var n=e.call(this)||this;return n.yieldEvery=t||"auto",n}return __extends(t,e),t.prototype.onTrainBegin=function(e){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(e){return this.autoYielder=new ModelTrainingYielder(this.yieldEvery),[2]})})},t.prototype.onEpochBegin=function(e){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(e){return this.seen=0,this.totals={},[2]})})},t.prototype.onBatchEnd=function(e,t){return __awaiter(this,void 0,void 0,function(){var e,n,r,i,a=this;return __generator(this,function(o){switch(o.label){case 0:return[4,this.autoYielder.maybeYieldOnBatch(t)];case 1:for(i in o.sent(),null==t&&(t={}),e=null==t.size?0:t.size,this.seen+=e,n=function(n){var i=t[n];if("number"==typeof i)r.totals.hasOwnProperty(n)||(r.totals[n]=0),r.totals[n]=r.totals[n]+i*e;else{var o=void 0;n in r.totals?o=r.totals[n]:r.totals[n]=getScalar(0),r.totals[n]=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(a.totals[n],Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(i,getScalar(e)))}),null!=o&&o.dispose()}},r=this,t)n(i);return[2]}})})},t.prototype.onEpochEnd=function(e,t){return __awaiter(this,void 0,void 0,function(){var e,n,r,i,a,o=this;return __generator(this,function(s){switch(s.label){case 0:return[4,this.autoYielder.maybeYieldOnEpoch()];case 1:if(s.sent(),null!=t)for(e=function(e){if(null==n.totals[e])return"continue";"number"==typeof n.totals[e]?t[e]=n.totals[e]/n.seen:Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){t[e]=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["N" /* div */])(getScalar(1),getScalar(o.seen)),o.totals[e]),o.totals[e].dispose(),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_4" /* keep */])(t[e])})},n=this,r=0,i=this.params.metrics;r<i.length;r++)a=i[r],e(a);return[2]}})})},t}(BaseCallback),History=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.onTrainBegin=function(e){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(e){return this.epoch=[],this.history={},[2]})})},t.prototype.onEpochEnd=function(e,t){return __awaiter(this,void 0,void 0,function(){var n;return __generator(this,function(r){for(n in null==t&&(t={}),this.epoch.push(e),t)null==this.history[n]&&(this.history[n]=[]),this.history[n].push(t[n]);return[2]})})},t.prototype.syncData=function(){return __awaiter(this,void 0,void 0,function(){var e,t,n,r,i,a,o,s,l;return __generator(this,function(u){switch(u.label){case 0:for(r in e=[],t=[],n=[],this.history)for(i=this.history[r],a=0;a<i.length;++a)"number"!=typeof i[a]&&(o=i[a],e.push(o.data()),t.push(r),n.push(a));return[4,Promise.all(e)];case 1:for(s=u.sent(),l=0;l<s.length;++l)this.history[t[l]][n[l]].dispose(),this.history[t[l]][n[l]]=s[l][0];return[2]}})})},t}(BaseCallback),CustomCallback=function(e){function t(t){var n=e.call(this)||this;return n.trainBegin=t.onTrainBegin,n.trainEnd=t.onTrainEnd,n.epochBegin=t.onEpochBegin,n.epochEnd=t.onEpochEnd,n.batchBegin=t.onBatchBegin,n.batchEnd=t.onBatchEnd,n}return __extends(t,e),t.prototype.onEpochBegin=function(e,t){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(n){switch(n.label){case 0:return null==this.epochBegin?[3,3]:[4,resolveScalarsInLogs(t)];case 1:return n.sent(),[4,this.epochBegin(e,t)];case 2:n.sent(),n.label=3;case 3:return[2]}})})},t.prototype.onEpochEnd=function(e,t){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(n){switch(n.label){case 0:return null==this.epochEnd?[3,3]:[4,resolveScalarsInLogs(t)];case 1:return n.sent(),[4,this.epochEnd(e,t)];case 2:n.sent(),n.label=3;case 3:return[2]}})})},t.prototype.onBatchBegin=function(e,t){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(n){switch(n.label){case 0:return null==this.batchBegin?[3,3]:[4,resolveScalarsInLogs(t)];case 1:return n.sent(),[4,this.batchBegin(e,t)];case 2:n.sent(),n.label=3;case 3:return[2]}})})},t.prototype.onBatchEnd=function(e,t){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(n){switch(n.label){case 0:return null==this.batchEnd?[3,3]:[4,resolveScalarsInLogs(t)];case 1:return n.sent(),[4,this.batchEnd(e,t)];case 2:n.sent(),n.label=3;case 3:return[2]}})})},t.prototype.onTrainBegin=function(e){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(t){switch(t.label){case 0:return null==this.trainBegin?[3,3]:[4,resolveScalarsInLogs(e)];case 1:return t.sent(),[4,this.trainBegin(e)];case 2:t.sent(),t.label=3;case 3:return[2]}})})},t.prototype.onTrainEnd=function(e){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(t){switch(t.label){case 0:return null==this.trainEnd?[3,3]:[4,resolveScalarsInLogs(e)];case 1:return t.sent(),[4,this.trainEnd(e)];case 2:t.sent(),t.label=3;case 3:return[2]}})})},t}(BaseCallback);function standardizeCallbacks(e){return null==e?null:e instanceof BaseCallback?[e]:Array.isArray(e)&&e[0]instanceof BaseCallback?e:toList(e).map(function(e){return new CustomCallback(e)})}var CallbackConstructorRegistry=function(){function e(){}return e.registerCallbackConstructor=function(t,n){__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].assert(t>=0&&Number.isInteger(t),"Verbosity level is expected to be an integer >= 0, but got "+t),e.checkForDuplicate(n),null==e.constructors[t]&&(e.constructors[t]=[]),e.constructors[t].push(n)},e.checkForDuplicate=function(t){for(var n in e.constructors){e.constructors[+n].forEach(function(e){if(e===t)throw new ValueError("Duplicate callback constructor.")})}},e.clear=function(){e.constructors={}},e.createCallbacks=function(t){var n=[];for(var r in e.constructors){var i=+r;t>=i&&n.push.apply(n,e.constructors[i])}return n.map(function(e){return new e})},e.constructors={},e}();function configureCallbacks(e,t,n,r,i,a,o,s,l,u){var c=new History,p=[new BaseLogger(t)].concat(CallbackConstructorRegistry.createCallbacks(n));null!=e&&p.push.apply(p,e),p.push(c);var h=new CallbackList(p);return h.setParams({epochs:r,initialEpoch:i,samples:a,steps:o,batchSize:s,verbose:n,doValidation:l,metrics:u}),{callbackList:h,history:c}}function l2Normalize(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_74" /* sum */])(square(e),t,!0),r=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_46" /* scalar */])(epsilon()),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_34" /* onesLike */])(e)),i=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_66" /* sqrt */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_20" /* maximum */])(n,r));return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["N" /* div */])(e,i)})}function meanSquaredError(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_21" /* mean */])(square(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_73" /* sub */])(t,e)),-1)})}function meanAbsoluteError(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_21" /* mean */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["d" /* abs */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_73" /* sub */])(t,e)),-1)})}function meanAbsolutePercentageError(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_73" /* sub */])(e,t),r=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["z" /* clipByValue */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["d" /* abs */])(e),epsilon(),Number.MAX_VALUE),i=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["d" /* abs */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["N" /* div */])(n,r));return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(getScalar(100),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_21" /* mean */])(i,-1))})}function meanSquaredLogarithmicError(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n=getScalar(1),r=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["z" /* clipByValue */])(t,epsilon(),Number.MAX_VALUE),i=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_11" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(n,r)),a=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["z" /* clipByValue */])(e,epsilon(),Number.MAX_VALUE),o=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_11" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(n,a));return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_21" /* mean */])(square(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_73" /* sub */])(i,o)),-1)})}function squaredHinge(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n=getScalar(0),r=getScalar(1),i=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_20" /* maximum */])(n,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_73" /* sub */])(r,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(e,t)));return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_21" /* mean */])(square(i),-1)})}function hinge(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n=getScalar(0),r=getScalar(1),i=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_20" /* maximum */])(n,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_73" /* sub */])(r,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(e,t)));return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_21" /* mean */])(i,-1)})}function categoricalHinge(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n=getScalar(0),r=getScalar(1),i=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_74" /* sum */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(e,t),-1),a=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_18" /* max */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_73" /* sub */])(r,e),t),-1);return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_20" /* maximum */])(n,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(r,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_73" /* sub */])(a,i)))})}function logcosh(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n=getScalar(Math.log(2)),r=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_73" /* sub */])(t,e),i=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_73" /* sub */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(r,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_62" /* softplus */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(getScalar(-2),r))),n);return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_21" /* mean */])(i,-1)})}function categoricalCrossentropy(e,t,n){return void 0===n&&(n=!1),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){if(n)t=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_61" /* softmax */])(t);else{var r=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_74" /* sum */])(t,t.shape.length-1,!0);t=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["N" /* div */])(t,r)}return t=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["z" /* clipByValue */])(t,epsilon(),1-epsilon()),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_29" /* neg */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_74" /* sum */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(e.toFloat(),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_11" /* log */])(t)),t.shape.length-1))})}function sparseCategoricalCrossentropy(e,t,n){return void 0===n&&(n=!1),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var r=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["W" /* floor */])(flatten(e)).toInt(),i=t.shape;return categoricalCrossentropy(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_32" /* oneHot */])(r,i[i.length-1]).reshape(i),t,n)})}function sigmoidCrossEntropyWithLogits(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_20" /* maximum */])(t,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_92" /* zerosLike */])(t)),r=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(t,e),i=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_11" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(getScalar(1),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["R" /* exp */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_29" /* neg */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["d" /* abs */])(t)))));return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_73" /* sub */])(n,r),i)})}function binaryCrossentropy(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n;return n=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["z" /* clipByValue */])(t,epsilon(),1-epsilon()),n=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_11" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["N" /* div */])(n,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_73" /* sub */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_34" /* onesLike */])(n),n))),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_21" /* mean */])(sigmoidCrossEntropyWithLogits(e,n),-1)})}function kullbackLeiblerDivergence(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["z" /* clipByValue */])(e,epsilon(),1),r=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["z" /* clipByValue */])(t,epsilon(),1);return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_74" /* sum */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(e,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_11" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["N" /* div */])(n,r))),-1)})}function poisson(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_11" /* log */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(getScalar(epsilon()),t));return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_21" /* mean */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_73" /* sub */])(t,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(e,n)),-1)})}function cosineProximity(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n=l2Normalize(e,-1),r=l2Normalize(t,-1),i=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(n,r);return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_29" /* neg */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_74" /* sum */])(i,-1))})}function get(e){var t={meanSquaredError:meanSquaredError,meanAbsoluteError:meanAbsoluteError,meanAbsolutePercentageError:meanAbsolutePercentageError,meanSquaredLogarithmicError:meanSquaredLogarithmicError,squaredHinge:squaredHinge,hinge:hinge,categoricalHinge:categoricalHinge,logcosh:logcosh,categoricalCrossentropy:categoricalCrossentropy,sparseCategoricalCrossentropy:sparseCategoricalCrossentropy,binaryCrossentropy:binaryCrossentropy,kullbackLeiblerDivergence:kullbackLeiblerDivergence,poisson:poisson,cosineProximity:cosineProximity};if("string"==typeof e){if(e in t)return t[e];var n="Unknown loss "+e;throw e.toLowerCase().includes("softmaxcrossentropy")&&(n="Unknown loss "+e+'. Use "categoricalCrossentropy" as the string name for tf.losses.softmaxCrossEntropy'),new ValueError(n)}return e}function binaryAccuracy(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(getScalar(.5),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_34" /* onesLike */])(t)),r=cast$1(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_0" /* greater */])(t,n),e.dtype);return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_21" /* mean */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["P" /* equal */])(e,r),-1)})}function categoricalAccuracy(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){return cast$1(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["P" /* equal */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["k" /* argMax */])(e,-1),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["k" /* argMax */])(t,-1)),"float32")})}function truePositives(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n=getScalar(1);return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_14" /* logicalAnd */])(e.equal(n),t.equal(n)).sum().cast("float32")})}function falseNegatives(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n=getScalar(1),r=getScalar(0);return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_14" /* logicalAnd */])(e.equal(n),t.equal(r)).sum().cast("float32")})}function falsePositives(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n=getScalar(1),r=getScalar(0);return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_14" /* logicalAnd */])(e.equal(r),t.equal(n)).sum().cast("float32")})}function precision(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n=getScalar(0),r=truePositives(e,t),i=falsePositives(e,t),a=r.add(i);return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_89" /* where */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_0" /* greater */])(a,n),r.div(a),n).cast("float32")})}function recall(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n=getScalar(0),r=truePositives(e,t),i=falseNegatives(e,t),a=r.add(i);return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_89" /* where */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_0" /* greater */])(a,n),r.div(a),n).cast("float32")})}function binaryCrossentropy$1(e,t){return binaryCrossentropy(e,t)}function sparseCategoricalAccuracy(e,t){throw new NotImplementedError}var mse$1=meanSquaredError,MSE$1=meanSquaredError,mae$1=meanAbsoluteError,MAE$1=meanAbsoluteError,mape$1=meanAbsolutePercentageError,MAPE$1=meanAbsolutePercentageError,categoricalCrossentropy$1=categoricalCrossentropy,cosine$1=cosineProximity,sparseCategoricalCrossentropy$1=sparseCategoricalCrossentropy;function get$1(e){var t={binaryAccuracy:binaryAccuracy,categoricalAccuracy:categoricalAccuracy,precision:precision,categoricalCrossentropy:categoricalCrossentropy$1,sparseCategoricalCrossentropy:sparseCategoricalCrossentropy$1,mse:mse$1,MSE:MSE$1,mae:mae$1,MAE:MAE$1,mape:mape$1,MAPE:MAPE$1,cosine:cosine$1};if("string"==typeof e&&e in t)return t[e];if("string"!=typeof e&&null!=e)return e;throw new ValueError("Unknown metric "+e)}function getOptimizer(e){var t={Adagrad:function(){return __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_82" /* train */].adagrad(.01)},Adadelta:function(){return __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_82" /* train */].adadelta(1,.95,epsilon())},Adam:function(){return __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_82" /* train */].adam(.001,.9,.999,epsilon())},Adamax:function(){return __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_82" /* train */].adamax(.002,.9,.999,epsilon(),0)},RMSProp:function(){return __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_82" /* train */].rmsprop(.001,.9,0,epsilon())},SGD:function(){return __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_82" /* train */].sgd(.01)}};if(t.adagrad=t.Adagrad,t.adadelta=t.Adadelta,t.adam=t.Adam,t.adamax=t.Adamax,t.rmsprop=t.RMSProp,t.sgd=t.SGD,e in t)return t[e]();throw new ValueError("Unknown Optimizer "+e)}function printSummary(e,t,n,r){void 0===r&&(r=console.log);var i,a=isModelSequentialLike(e),o=["Layer (type)","Output shape","Param #"];if(a?(t=t||65,n=n||[.45,.85,1]):(t=t||98,n=n||[.33,.55,.67,1]),n[n.length-1]<=1&&(n=n.map(function(e){return Math.floor(t*e)})),!a)for(var s in o.push("Receives inputs"),i=[],e.nodesByDepth)i.push.apply(i,e.nodesByDepth[s]);r("_".repeat(t)),printRow(o,n,r),r("=".repeat(t));for(var l=e.layers,u=0;u<l.length;++u)a?printLayerSummary(l[u],n,r):printLayerSummaryWithConnections(l[u],n,i,r),r((u===l.length-1?"=":"_").repeat(t));e.checkTrainableWeightsConsistency();var c=countTrainableParams(e),p=countParamsInWeights(e.nonTrainableWeights);r("Total params: "+(c+p)),r("Trainable params: "+c),r("Non-trainable params: "+p),r("_".repeat(t))}function countTrainableParams(e){return null!=e.collectedTrainableWeights?countParamsInWeights(e.collectedTrainableWeights):countParamsInWeights(e.trainableWeights)}function isModelSequentialLike(e){var t=!0,n=[],r=[];for(var i in e.nodesByDepth)n.push(e.nodesByDepth[i]);for(var a=0,o=n;a<o.length;a++){var s=o[a];if(s.length>1||1===s.length&&s[0].inboundLayers.length>1){t=!1;break}r.push.apply(r,s)}if(t)for(var l=0,u=e.layers;l<u.length;l++){for(var c=!1,p=0,h=u[l].inboundNodes;p<h.length;p++){var d=h[p];if(-1!==r.indexOf(d)){if(c){t=!1;break}c=!0}}if(!t)break}return t}function printRow(e,t,n){void 0===n&&(n=console.log);for(var r="",i=0;i<e.length;++i)i>0&&(r=r.slice(0,r.length-1)+" "),r=(r+=e[i]).slice(0,t[i]),r+=" ".repeat(t[i]-r.length);n(r)}function printLayerSummary(e,t,n){var r;try{r=JSON.stringify(e.outputShape)}catch(e){r="multiple"}printRow([e.name+" ("+e.getClassName()+")",r,e.countParams().toString()],t,n)}function printLayerSummaryWithConnections(e,t,n,r){var i;try{i=JSON.stringify(e.outputShape)}catch(e){i="multiple"}for(var a=[],o=0,s=e.inboundNodes;o<s.length;o++){var l=s[o];if(!(null!=n&&n.length>0&&-1===n.indexOf(l)))for(var u=0;u<l.inboundLayers.length;++u){var c=l.inboundLayers[u].name,p=l.nodeIndices[u],h=l.tensorIndices[u];a.push(c+"["+p+"]["+h+"]")}}var d=e.name,f=e.getClassName(),g=0===a.length?"":a[0];printRow([d+" ("+f+")",i,e.countParams().toString(),g],t,r);for(u=1;u<a.length;++u)printRow(["","","",a[u]],t,r)}function deserialize(e,t){return void 0===t&&(t={}),deserializeKerasObject(e,__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].SerializationMap.getMap().classNameMap,t,"layer")}function isArrayItemInputOrOutputName(e,t,n){return("inboundNodes"===e||"outputLayers"===e||"inputLayers"===e)&&0===t&&"string"==typeof n}function convertPythonicToTs(e,t){if(null===e)return null;if("string"==typeof e)return toCamelCase(e);if("number"==typeof e||"boolean"==typeof e)return e;if(e instanceof Array){for(var n=[],r=e.length,i=0;i<r;++i){var a=e[i];isArrayItemInputOrOutputName(t,i,a)?n.push(a):n.push(convertPythonicToTs(a,t))}return n}for(var o={},s=0,l=Object.keys(e);s<l.length;s++){var u=l[s],c=e[u];if("name"===u&&"string"==typeof c)o[u]=c;else{var p=toCamelCase(u);o[p]=convertPythonicToTs(c,p)}}return o}function convertTsToPythonic(e,t){if(null===e||void 0===e)return null;if("string"==typeof e)return toSnakeCase(e);if("number"==typeof e||"boolean"==typeof e)return e;if(e instanceof Array){for(var n=[],r=e.length,i=0;i<r;++i){var a=e[i];isArrayItemInputOrOutputName(t,i,a)?n.push(a):n.push(convertTsToPythonic(a,t))}return n}for(var o={},s=0,l=Object.keys(e);s<l.length;s++){var u=l[s],c=e[u],p=toSnakeCase(u);o[p]="name"!==u&&"className"!==u||"string"!=typeof c?convertTsToPythonic(c,u):c}return o}var version="0.8.5";function preprocessWeightsForLoading(e,t,n,r){if(!n.startsWith("2."))throw new ValueError("Unsupported Keras version in weights being loaded: "+n);return t}function loadTensor(e,t,n){var r=stringToDType(e);return __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["c" /* Tensor */].make(t,{values:0===t.length?n:__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].flatten(n)},r)}function loadWeightsFromJson(e,t,n){void 0===n&&(n=!1);for(var r=e.keras_version,i=e.backend,a=t.map(function(e){return e.name}),o={},s=0,l=t;s<l.length;s++){null!=(b=l[s]).name&&(null==o[b.name]&&(o[b.name]=[]),o[b.name].push(b))}for(var u=e.weights,c=[],p=0;p<a.length;++p){var h=a[p],d=u[h];null==d&&(d=[]);for(var f=[],g=0;g<d.length;++g){var m=d[g];f.push(new LayerVariable(loadTensor(m.dtype,m.shape,m.value)))}for(var y=0,v=o[h];y<v.length;y++){var b,w=(b=v[y]).weights;if((f=preprocessWeightsForLoading(b,f,r,i)).length!==w.length){if(!n)throw new ValueError("Layer #"+p+' (named "'+b.name+'") expects '+w.length+" weight(s), but the saved weights have "+f.length+" element(s).");console.warn("Skipping loading of weights of layer "+b.name+" due to mismatch in number of weights: ("+f.length+" vs "+w.length+").")}for(var z=0;z<f.length;++z)!n||__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].arraysEqual(w[z].shape,f[z].shape)?c.push([w[z],f[z].read()]):console.warn("Skipping loading of weights for layer "+b.name+" due to mismatch in shape ("+w[z].shape+" vs "+f[z].shape+")")}}batchSetValue(c)}function loadWeightsFromNamedTensorMap(e,t,n){void 0===n&&(n=!0);for(var r={},i=0,a=0,o=t;a<o.length;a++)for(var s=0,l=o[a].weights;s<l.length;s++){var u=l[s];if(null!=r[u.originalName])throw new ValueError("Duplicate weight name: "+u.originalName);r[u.originalName]=u,i++}var c=[];for(var p in e){if(null!=r[p])c.push([r[p],e[p]]);else if(n)throw new ValueError("Provided weight data has no target variable: "+p);delete r[p]}if(n){var h=[];for(var d in r)h.push(d);if(h.length>0)throw new ValueError(h.length+" of "+i+" weights are not set: "+h)}batchSetValue(c)}var Container=function(e){function t(n){var r=e.call(this,{})||this;if(r.containerNodes=new Set,r.name=n.name,null==r.name){var i=r.getClassName().toLowerCase();r.name=getUid(i)}if(r.supportsMasking=!1,r.trainable=!0,r.updatable=!0,Array.isArray(n.inputs)?r.inputs=n.inputs.slice():r.inputs=[n.inputs],Array.isArray(n.outputs)?r.outputs=n.outputs.slice():r.outputs=[n.outputs],unique(r.inputs).length!==r.inputs.length)throw new ValueError("The list of inputs passed to the model is redundant. All inputs should only appear once. Found: "+r.inputs.map(function(e){return e.name}));unique(r.outputs).length!==r.outputs.length&&console.warn("The list of outputs passed to the model is redundant. All outputs should only appear once. Found: "+r.outputs.map(function(e){return e.name})),r.inputLayers=[],r.inputLayersNodeIndices=[],r.inputLayersTensorIndices=[],r.outputLayers=[],r.outputLayersNodeIndices=[],r.outputLayersTensorIndices=[],r.layers=[];for(var a=0,o=r.outputs;a<o.length;a++){var s=(A=o[a]).sourceLayer,l=A.nodeIndex,u=A.tensorIndex;r.outputLayers.push(s),r.outputLayersNodeIndices.push(l),r.outputLayersTensorIndices.push(u)}for(var c=0,p=r.inputs;c<p.length;c++){s=(A=p[c]).sourceLayer,l=A.nodeIndex,u=A.tensorIndex;assert(0===l,"input layer has >1 nodes"),assert(0===u,"input layer has >1 tensors"),r.inputLayers.push(s),r.inputLayersNodeIndices.push(l),r.inputLayersTensorIndices.push(u)}r.inputNames=[],r.outputNames=[],r.feedInputShapes=[],r.feedInputNames=[],r.feedOutputNames=[];for(var h=0;h<r.inputLayers.length;h++){if(!((s=r.inputLayers[h])instanceof InputLayer))throw new TypeError("Input layers to a Model must be InputLayer objects. Received inputs: "+n.inputs+". Input "+h+" (0-based) originates from layer type "+s.getClassName()+".");r.inputNames.push(s.name),r.feedInputShapes.push(s.batchInputShape),r.feedInputNames.push(s.name)}for(var d=0,f=r.outputLayers;d<f.length;d++){s=f[d];r.outputNames.push(s.name)}r.internalInputShapes=r.inputs.map(function(e){return e.shape}),r.internalOutputShapes=r.outputs.map(function(e){return e.shape});for(var g={},m={},y={},v={},b={},w=[],z=function(e,n,i,a,o,s){null!=a&&null!=o&&null!=s||(a=e.sourceLayer,o=e.nodeIndex,s=e.tensorIndex);var l=a.inboundNodes[o];if(-1!==i.indexOf(l))throw new RuntimeError("The tensor "+e.name+' at layer "'+a.name+'" is part of a cycle.');if(-1===n.indexOf(l)){r.containerNodes.add(t.nodeKey(a,o)),a.id in b||(b[a.id]=Object.keys(b).length),-1===i.indexOf(l)&&i.push(l);for(var u=l.inboundLayers.length,c=0;c<u;c++){var p=l.inputTensors[c],h=l.inboundLayers[c],d=l.nodeIndices[c],f=l.tensorIndices[c];z(p,n,i,h,d,f)}for(n.push(l);i.indexOf(l)>=0;)i.splice(i.indexOf(l),1);w.push(l)}},S=[],I=[],N=0,C=r.outputs;N<C.length;N++){var A=C[N];z(A,S,I)}for(var _=0,E=w.slice().reverse();_<E.length;_++){m[(K=E[_]).id]=K,K.id in g||(g[K.id]=0);var k=g[K.id],L=null==y[K.outboundLayer.id]?0:y[K.outboundLayer.id];k=Math.max(k,L),y[K.outboundLayer.id]=k,v[K.outboundLayer.id]=K.outboundLayer,g[K.id]=k;for(h=0;h<K.inboundLayers.length;h++){var x=K.inboundLayers[h],T=(l=K.nodeIndices[h],x.inboundNodes[l]),D=null==g[T.id]?0:g[T.id];g[T.id]=Math.max(k+1,D),m[T.id]=T}}var O={};for(var R in g){(k=g[R])in O||(O[k]=[]),O[k].push(m[R])}var M={};for(var P in y){(k=y[P])in M||(M[k]=[]),M[k].push(v[P])}var V=Object.keys(M).map(function(e){return parseInt(e,10)}).sort(reverseNumberCompare);r.layers=[];for(var F=0,B=V;F<B.length;F++){var U=M[k=B[F]];U.sort(function(e,t){var n=b[e.id],r=b[t.id];return n<r?-1:n>r?1:0});for(var j=0,W=U;j<W.length;j++){s=W[j];r.layers.push(s)}}r.layersByDepth=M,V=Object.keys(O).map(function(e){return parseInt(e,10)}).sort(reverseNumberCompare);for(var $=r.inputs.slice(),q=[],G=0,J=V;G<J.length;G++)for(var H=0,Z=O[k=J[G]];H<Z.length;H++){var K;if(null!=(s=(K=Z[H]).outboundLayer)){for(var Y=0,X=K.inputTensors;Y<X.length;Y++){A=X[Y];if(-1===$.indexOf(A))throw new RuntimeError("Graph disconnected: cannot obtain value for tensor "+A+' at layer "'+s.name+'". The following previous layers were accessed without issue: '+q)}for(var Q=0,ee=K.outputTensors;Q<ee.length;Q++){A=ee[Q];$.push(A)}q.push(s.name)}}r.nodesByDepth=O;for(var te=r.layers.map(function(e){return e.name}),ne=function(e){var t=te.filter(function(t){return t===e}).length;if(1!==t)throw new RuntimeError('The name "'+e+'" is used '+t+" times in the model. All layer names should be unique. Layer names: "+JSON.stringify(te))},re=0,ie=te;re<ie.length;re++){ne(ie[re])}return r.outboundNodes=[],r.inboundNodes=[],new Node({outboundLayer:r,inboundLayers:[],nodeIndices:[],tensorIndices:[],inputTensors:r.inputs,outputTensors:r.outputs,inputMasks:r.inputs.map(function(e){return null}),outputMasks:r.outputs.map(function(e){return null}),inputShapes:r.inputs.map(function(e){return e.shape}),outputShapes:r.outputs.map(function(e){return e.shape})}),r.built=!0,r._refCount=1,r}return __extends(t,e),t.prototype.assertNotDisposed=function(){if(0===this._refCount)throw new Error("Container '"+this.name+"' is already disposed.")},t.prototype.dispose=function(){this.assertNotDisposed();var e={refCountAfterDispose:null,numDisposedVariables:0};if(0==--this._refCount)for(var t=0,n=this.layers;t<n.length;t++){var r=n[t];e.numDisposedVariables+=r.dispose().numDisposedVariables}return e.refCountAfterDispose=this._refCount,e},Object.defineProperty(t.prototype,"trainableWeights",{get:function(){if(this._trainableWeights.length>0)throw new ValueError("Container instance unexpectedly contains _trainableWeights.The trainable weights of a Container are a union of the trainable weights of its consituent Layers. Its own _trainableWeights must remain an empty Array.");if(!this.trainable)return[];for(var e=[],t=0,n=this.layers;t<n.length;t++){var r=n[t];e=e.concat(r.trainableWeights)}return e},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"nonTrainableWeights",{get:function(){for(var e=[],t=0,n=this.layers;t<n.length;t++){var r=n[t];e.push.apply(e,r.nonTrainableWeights)}if(!this.trainable){for(var i=[],a=0,o=this.layers;a<o.length;a++){r=o[a];i.push.apply(i,r.trainableWeights)}return i.concat(e)}return e},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"weights",{get:function(){return this.trainableWeights.concat(this.nonTrainableWeights)},enumerable:!0,configurable:!0}),t.prototype.loadWeights=function(e,t,n,r){void 0===t&&(t=!1),void 0===n&&(n=!1),void 0===r&&(r=!0),n?loadWeightsFromNamedTensorMap(e,this.layers,r):loadWeightsFromJson(e,this.layers,t)},t.prototype.updatedConfig=function(){var e=this.getConfig();return{className:this.getClassName(),config:e,kerasVersion:"tfjs-layers "+version,backend:"TensorFlow.js"}},t.prototype.toJSON=function(e,t){void 0===t&&(t=!0);var n=convertTsToPythonic(this.updatedConfig());return t?JSON.stringify(n):n},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var r;return e=toList(e),r="mask"in t?toList(t.mask):pyListRepeat(null,e.length),n.runInternalGraph(e,r)[0]})},t.prototype.computeMask=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var r;return e=toList(e),r=null==t?pyListRepeat(null,e.length):toList(t),n.runInternalGraph(e,r)[1]})},t.prototype.computeOutputShape=function(e){var t=normalizeShapeList(e);if(t.length!==this.inputLayers.length)throw new ValueError("Invalid inputShape argument "+e+": model has "+this.inputLayers.length+" tensor inputs.");for(var n={},r=0;r<t.length;r++){var i=this.inputLayers[r],a=t[r];n[I=i.name+"_0_0"]=a}var o=Object.keys(this.nodesByDepth).map(function(e){return parseInt(e,10)}).sort(reverseNumberCompare);if(o.length>1)for(var s=0,l=o;s<l.length;s++)for(var u=l[s],c=0,p=this.nodesByDepth[u];c<p.length;c++){var h=p[c];i=h.outboundLayer;if(-1===this.inputLayers.map(function(e){return e.id}).indexOf(i.id)){for(var d=[],f=0;f<h.inboundLayers.length;f++){var g=h.inboundLayers[f],m=h.nodeIndices[f],y=h.tensorIndices[f],v=n[I=g.name+"_"+m+"_"+y];d.push(v)}var b=normalizeShapeList(i.computeOutputShape(singletonOrArray(d))),w=i.inboundNodes.indexOf(h);for(f=0;f<b.length;f++){n[I=i.name+"_"+w+"_"+f]=b[f]}}}var z=[],S=[];for(r=0;r<this.outputLayers.length;r++){i=this.outputLayers[r],w=this.outputLayersNodeIndices[r],y=this.outputLayersTensorIndices[r];var I=i.name+"_"+w+"_"+y;S.push(I)}for(r=0;r<S.length;r++){var N=S[r];assert(N in n),z.push(n[N])}return singletonOrArray(z)},t.prototype.runInternalGraph=function(e,t){null==t&&(t=pyListRepeat(null,e.length));for(var n={},r=0;r<this.inputs.length;++r){var i=this.inputs[r],a=e[r],o=t[r];n[i.id]=[a,o]}for(var s=0,l=Object.keys(this.nodesByDepth).map(function(e){return parseInt(e,10)}).sort(reverseNumberCompare);s<l.length;s++)for(var u=l[s],c=0,p=this.nodesByDepth[u];c<p.length;c++){for(var h=p[c],d=h.outboundLayer,f=h.inputTensors,g=h.outputTensors,m=new Array,y=0,v=f;y<v.length;y++){(i=v[y]).id in n&&m.push(n[i.id])}if(m.length===f.length){var b={},w=void 0,z=void 0,S=void 0,I=void 0;if(null!=h.callArgs&&(b=h.callArgs),1===m.length){var N=m[0],C=N[0],A=N[1];null==b.mask&&(b.mask=A),S=toList(d.call(C,b)),I=toList(d.computeMask(C,A)),w=[C],z=[A]}else w=m.map(function(e){return e[0]}),z=m.map(function(e){return e[1]}),null==b.mask&&(b.mask=z),S=toList(d.call(w,b)),I=toList(d.computeMask(w,z));if(d.activityRegularizer)throw new NotImplementedError("Model invocation with concrete Tensor value(s) in the presence of activity regularizer(s) is not supported yet.");for(r=0;r<g.length;++r){i=g[r],a=S[r],o=I[r];n[i.id]=[a,o]}}}for(var _=[],E=[],k=[],L=0,x=this.outputs;L<x.length;L++){assert((i=x[L]).id in n,"Could not compute output "+i.name+" : "+i.id);var T=n[i.id],D=T[0];o=T[1];k.push(D.shape),_.push(D),E.push(o)}return[_,E,k]},t.prototype.buildNodeConversionMap=function(e){for(var n,r={},i=0,a=this.layers;i<a.length;i++){var o=a[i];n=o instanceof t?1:0;for(var s=0;s<o.inboundNodes.length;s++){var l=t.nodeKey(o,s);this.containerNodes.has(l)&&(r[l]=n,n+=1)}}return r},t.prototype.getLayer=function(e,t){if(null!=t){if(this.layers.length<=t)throw new ValueError("Was asked to retrieve layer at index "+t+", but model only has "+this.layers.length+" layer(s).");return this.layers[t]}if(null==e)throw new ValueError("Provide either a layer name or layer index");for(var n=0,r=this.layers;n<r.length;n++){var i=r[n];if(i.name===e)return i}throw new ValueError("No such layer: "+e)},t.prototype.calculateLosses=function(){var e=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){for(var n=[],r=0,i=e.layers;r<i.length;r++)for(var a=i[r],o=0;o<a.inboundNodes.length;++o){var s=t.nodeKey(a,o);e.containerNodes.has(s)&&n.push.apply(n,a.calculateLosses())}return n})},t.prototype.getConfig=function(){for(var e={name:this.name},n=this.buildNodeConversionMap(this.layers),r=[],i=0,a=this.layers;i<a.length;i++){for(var o=(b=a[i]).getClassName(),s=b.getConfig(),l=[],u=0;u<b.inboundNodes.length;u++){var c=b.inboundNodes[u],p=t.nodeKey(b,u),h={};if(this.containerNodes.has(p)){if(c.callArgs)try{JSON.stringify(c.callArgs),h=c.callArgs}catch(e){console.warn("Layer "+b.name+" was passed non-serializable keyword arguments: "+c.callArgs+". They will not be included in the serialized model (and thus will be missing at deserialization time)."),h={}}if(c.inboundLayers.length>0){for(var d=[],f=0;f<c.inboundLayers.length;f++){var g=c.inboundLayers[f],m=c.nodeIndices[f],y=c.tensorIndices[f];null==(z=n[t.nodeKey(g,m)])&&(z=0),d.push([g.name,z,y,h])}l.push(d)}}}r.push({name:b.name,className:o,config:s,inboundNodes:l})}e.layers=r;var v=[];for(f=0;f<this.inputLayers.length;f++){var b=this.inputLayers[f];m=this.inputLayersNodeIndices[f],p=t.nodeKey(b,m);if(this.containerNodes.has(p)){null!==(z=n[p])&&void 0!==z||(z=0);y=this.inputLayersTensorIndices[f];v.push([b.name,z,y])}}e.inputLayers=v;var w=[];for(f=0;f<this.outputLayers.length;f++){b=this.outputLayers[f],m=this.outputLayersNodeIndices[f],p=t.nodeKey(b,m);if(this.containerNodes.has(p)){var z;null!==(z=n[p])&&void 0!==z||(z=0);y=this.outputLayersTensorIndices[f];w.push([b.name,z,y])}}return e.outputLayers=w,e},t.fromConfig=function(e,t){var n={},r={};function i(e,t){e.name in r?r[e.name].push(t):r[e.name]=[t]}function a(e,t){for(var r,a=[],o=0,s=t;o<s.length;o++){var l=s[o],u=l[0],c=l[1],p=l[2];if(3===l.length)r={};else{if(4!==l.length)throw new ValueError("Improperly formatted model config for layer "+JSON.stringify(e)+": "+JSON.stringify(l));r=l[3]}if(!(u in n))return void i(e,t);var h=n[u];if(h.inboundNodes.length<=c)return void i(e,t);var d=h.inboundNodes[c];a.push(d.outputTensors[p])}a.length>0&&e.apply(singletonOrArray(a),r)}function o(e){var r=e.name,a=deserialize(e,null!=t.customObjects?t.customObjects:{});n[r]=a;for(var o=0,s=e.inboundNodes;o<s.length;o++){var l=s[o];if(!(l instanceof Array))throw new ValueError("Corrupted configuration, expected array for nodeData: "+l);i(a,l)}}for(var s=t.name,l=t.layers,u=0,c=l;u<c.length;u++){o(d=c[u])}for(;!isObjectEmpty(r);)for(var p=0,h=l;p<h.length;p++){var d=h[p];if((_=n[d.name]).name in r){var f=r[_.name];delete r[_.name];for(var g=0,m=f;g<m.length;g++){a(_,m[g])}}}for(var y=[],v=[],b=0,w=t.inputLayers;b<w.length;b++){var z=(d=w[b])[0],S=d[1],I=d[2];assert(z in n);var N=(_=n[z]).inboundNodes[S].outputTensors;y.push(N[I])}for(var C=0,A=t.outputLayers;C<A.length;C++){z=(d=A[C])[0],S=d[1],I=d[2];assert(z in n);var _;N=(_=n[z]).inboundNodes[S].outputTensors;v.push(N[I])}return new e({inputs:y,outputs:v,name:s})},Object.defineProperty(t.prototype,"stateful",{get:function(){if(this._stateful)throw new ValueError("Container instance unexpectedly has _stateful = true. The statefulness of a Container is determined by the Layers it contains. Its _stateful property must remain the default false.");for(var e=0,t=this.layers;e<t.length;e++){if(t[e].stateful)return!0}return!1},enumerable:!0,configurable:!0}),t.prototype.resetStates=function(){var e=this;Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){e.layers.forEach(function(e){e.stateful&&e.resetStates()})})},t}(Layer);function assertFeedCompatibility(e,t){if(null!=e.shape){if(e.shape.length!==t.shape.length)throw new ValueError("The rank of feed ("+t.shape.length+") does not match the rank of the key ("+e.shape.length+").");for(var n=0;n<e.shape.length;++n)if(null!=e.shape[n]&&e.shape[n]!==t.shape[n])throw new ValueError("The "+n+"-th dimension of the feed ("+t.shape[n]+") is incompatible with that of the key ("+e.shape[n]+").")}if(null==e.dtype||e.dtype===t.dtype)return t;try{return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["x" /* cast */])(t,e.dtype)}catch(n){throw new ValueError("The dtype of the feed ("+t.dtype+") can not be cast to the dtype of the key '"+e.name+"' ("+e.dtype+").")}}var FeedDict=function(){function e(t){if(this.id2Value={},t instanceof e)for(var n in t.id2Value)this.id2Value[n]=t.id2Value[n];else{if(null==t)return;for(var r=0,i=t;r<i.length;r++){var a=i[r];this.add(a.key,a.value)}}}return e.prototype.add=function(e,t){if(null!=this.id2Value[e.id])throw new ValueError("Duplicate key: name="+e.name+", id="+e.id);return this.id2Value[e.id]=assertFeedCompatibility(e,t),this},e.prototype.addFeed=function(e){this.add(e.key,e.value)},e.prototype.hasKey=function(e){return null!=this.id2Value[e.id]},e.prototype.getValue=function(e){if(null==this.id2Value[e.id])throw new ValueError("Nonexistent key: "+JSON.stringify(e));return this.id2Value[e.id]},e}();function execute(e,t,n){for(var r=Array.isArray(e),i=r?e:[e],a=[],o=new FeedDict(t),s=0,l=i;s<l.length;s++){var u=l[s];a.push(executeInternal(u,o,n))}return r?a:a[0]}function executeInternal(e,t,n){if(t.hasKey(e))return t.getValue(e);if(e.sourceLayer instanceof InputLayer)throw new ValueError("Missing a feed value for SymbolicTensor from InputLayer '"+InputLayer.name+"'");for(var r=[],i=0,a=e.inputs;i<a.length;i++){var o=executeInternal(a[i],t,n);r.push(o)}var s=e.sourceLayer.apply(r,n);Array.isArray(s)||(s=[s]);for(var l=getNodeOutputs(e),u=Array.isArray(l)?l:[l],c=0;c<u.length;++c)t.add(u[c],s[c]);return 1===s.length?s[0]:s[e.outputTensorIndex]}function getNodeOutputs(e){var t;if(1===e.sourceLayer.inboundNodes.length)t=e.sourceLayer.output;else{for(var n=null,r=0;r<e.sourceLayer.inboundNodes.length;++r)for(var i=0,a=e.sourceLayer.inboundNodes[r].outputTensors;i<a.length;i++){if(a[i].id===e.id){n=r;break}}t=e.sourceLayer.getOutputAt(n)}return t}var DEFAULT_VALIDATION_BATCH_SIZE=32;function standardizeDataIteratorOutput(e,t){if(e.outputs.length>1)throw new NotImplementedError("Support for training a model with multiple output tensors with a dataset object is not implemented yet.");__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].assert(Array.isArray(t)&&2===t.length,"Dataset iterator for fitDataset() is expected to generate an Array of length 2: `[xs, ys]`, but instead generates "+t);var n=(t=t)[1],r=t[0];if(r instanceof __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["c" /* Tensor */])return __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].assert(1===e.inputs.length,"Model has multiple "+e.inputs.length+" inputs, hence it expects the input dataset to generate a dictionary of tensors  (with keys "+JSON.stringify(e.inputNames)+", but received a single tensor."),__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].assert(r.shape[0]===n.shape[0],"Mismatch in batch size between x and y tensors ("+r.shape[0]+" vs. "+n.shape[0]+")"),[r,n];var i=void 0;r=r;for(var a=[],o=0,s=e.inputNames;o<s.length;o++){var l=s[o];if(null==r[l])throw new ValueError("The feature data generated by the dataset lacks the required input key '"+l+"'.");a.push(r[l]),null==i?i=r[l].shape[0]:__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].assert(r[l].shape[0]===i,"Mismatch in batch size between x and y tensors ("+r[l].shape[0]+" vs. "+n.shape[0]+")")}return a.concat(n)}function standardizeTensorValidationData(e){if(3===e.length)throw new NotImplementedError("Validation with sample weights is not implemented yet.");return{xs:e[0],ys:e[1]}}function fitDataset(e,t,n){return __awaiter(this,void 0,void 0,function(){var r,i,a,o,s,l,u,c,p,h,d,f,g,m,y,v,b,w,z,S,I,N,C,A,_,E;return __generator(this,function(k){switch(k.label){case 0:if(r=null!=n.batchesPerEpoch,__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].assert(null!=e.optimizer,"You must compile a model before training/testing. Use Model.compile(modelCompileConfig)."),__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].assert(null!=n,"For fitDataset(), the 2nd argument (config) is required, but it is not provided in this call."),__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].assert(null!=n.epochs&&n.epochs>0&&Number.isInteger(n.epochs),"For fitDataset(), config.epochs is expected to be a positive integer, but got "+n.epochs),__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].assert(!r||n.batchesPerEpoch>0&&Number.isInteger(n.batchesPerEpoch),"For fitDataset(), config.batchesPerEpoch is expected to be a positive integer if specified, but got "+n.batchesPerEpoch),__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].assert(null==n.validationSplit,"`validationSplit` is not supported by `fitDataset()`. Use validationData instead."),e.isTraining)throw new Error("Cannot start training because another fit() call is ongoing.");e.isTraining=!0,k.label=1;case 1:return k.trys.push([1,,21,22]),i=null!=n.validationData,a=void 0,o=void 0,i&&(isDatasetObject(n.validationData)?__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].assert(null==n.validationBatches||n.validationBatches>0&&Number.isInteger(n.validationBatches),"For fitDataset() with dataset-based validation, config.validationBatches is expected not to be provided, or to be a positive integer, but got "+n.validationBatches):(s=standardizeTensorValidationData(n.validationData),a=s.xs,o=s.ys)),l=e.makeTrainFunction(),u=e.getDedupedMetricsNames(),c=void 0,c=i?u.slice().concat(u.map(function(e){return"val_"+e})):u.slice(),p=standardizeCallbacks(n.callbacks),h=configureCallbacks(p,n.yieldEvery,n.verbose,n.epochs,null,null,n.batchesPerEpoch,null,i,c),d=h.callbackList,f=h.history,e.history=f,[4,d.onTrainBegin()];case 2:return k.sent(),g=null==n.initialEpoch?0:n.initialEpoch,m={},[4,t.iterator()];case 3:y=k.sent(),k.label=4;case 4:return g<n.epochs?[4,d.onEpochBegin(g)]:[3,18];case 5:return k.sent(),v=0,b=0,r?[3,7]:[4,t.iterator()];case 6:y=k.sent(),k.label=7;case 7:return!r||v<n.batchesPerEpoch?[4,y.next()]:[3,16];case 8:if(w=k.sent(),r&&w.done)return console.warn("You provided `batchesPerEpoch` as "+n.batchesPerEpoch+", but your dataset iterator ran out of data after "+v+" batches; interrupting training. Make sure that your dataset can generate at least `batchesPerEpoch * epochs` batches (in this case, "+n.batchesPerEpoch*n.epochs+" batches). You may need to use the repeat() function when building your dataset."),[3,16];if(null==w.value)return[3,10];for(z=standardizeDataIteratorOutput(e,w.value),(S={}).batch=b,S.size=z[0].shape[0],d.onBatchBegin(b,S),I=l(z),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["M" /* dispose */])(z),E=0;E<u.length;++E)N=u[E],C=I[E],S[N]=C,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_4" /* keep */])(C);return[4,d.onBatchEnd(b,S)];case 9:k.sent(),disposeTensorsInLogs(S),b++,v++,k.label=10;case 10:return(r?v>=n.batchesPerEpoch:w.done)?i?(A=void 0,isDatasetObject(n.validationData)?(_=toList,[4,e.evaluateDataset(n.validationData,{batches:n.validationBatches})]):[3,12]):[3,14]:[3,15];case 11:return A=_.apply(void 0,[k.sent()]),[3,13];case 12:A=toList(e.evaluate(a,o,{batchSize:null==n.validationBatchSize?DEFAULT_VALIDATION_BATCH_SIZE:n.validationBatchSize,verbose:0})),k.label=13;case 13:for(E=0;E<e.metricsNames.length;++E)m["val_"+e.metricsNames[E]]=A[E];k.label=14;case 14:return[3,16];case 15:return e.stopTraining_?[3,16]:[3,7];case 16:return[4,d.onEpochEnd(g,m)];case 17:return k.sent(),g++,e.stopTraining_?[3,18]:[3,4];case 18:return[4,d.onTrainEnd()];case 19:return k.sent(),[4,e.history.syncData()];case 20:return k.sent(),[2,e.history];case 21:return e.isTraining=!1,[7];case 22:return[2]}})})}function isDatasetObject(e){return"function"==typeof e.iterator}function isLazyIteratorObject(e){return"function"==typeof e.next}function evaluateDataset(e,t,n){return __awaiter(this,void 0,void 0,function(){var r,i,a,o,s,l,u,c,p,h;return __generator(this,function(d){switch(d.label){case 0:if(r=null!=n.batches,i=e.testFunction,a=[],n.verbose>0)throw new NotImplementedError("Verbose mode is not implemented yet.");return __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].assert(!r||n.batches>0&&Number.isInteger(n.batches),"Test loop expects `batches` to be a positive integer, but received "+JSON.stringify(n.batches)),isLazyIteratorObject(t)?(s=t,[3,3]):[3,1];case 1:return[4,t.iterator()];case 2:s=d.sent(),d.label=3;case 3:o=s,l=0,u=0,c=function(){var t,s,c,p,h,d;return __generator(this,function(f){switch(f.label){case 0:return[4,o.next()];case 1:if((t=f.sent()).value){if(s=standardizeDataIteratorOutput(e,t.value),c=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){return i(s)}),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["M" /* dispose */])(s),0===u)for(d=0;d<c.length;++d)a.push(getScalar(0));for(p=s[0].shape[0],h=function(e){var t=c[e],n=a[e];a[e]=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(a[e],Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(getScalar(p),t))}),u>0&&Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["M" /* dispose */])(n)},d=0;d<c.length;++d)h(d);Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["M" /* dispose */])(c),l+=p,++u}return t.done?(r&&console.warn("Your dataset iterator ran out of data during evaluateDataset(). Interrupting evalution. Make sure that your dataset can generate at least `batches` batches (in this case, "+n.batches+" batches). You may need to use the repeat() function when building your dataset."),[2,"break"]):[2]}})},d.label=4;case 4:return!r||u<n.batches?[5,c()]:[3,6];case 5:return"break"===d.sent()?[3,6]:[3,4];case 6:for(p=function(e){var t=a[e];a[e]=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["N" /* div */])(a[e],getScalar(l))}),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["M" /* dispose */])(t)},h=0;h<a.length;++h)p(h);return[2,singletonOrArray(a)]}})})}function checkBatchSize(e){__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].assert(e>0&&Number.isInteger(e),"batchSize is required to be a positive integer, but got "+e)}function sliceArrays(e,t,n){return null==e?[null]:Array.isArray(e)?e.map(function(e){return sliceAlongFirstAxis(e,t,n-t)}):sliceAlongFirstAxis(e,t,n-t)}function sliceArraysByIndices(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){return null==e?null:Array.isArray(e)?e.map(function(e){return sliceArraysByIndices(e,t)}):gather$1(e,"int32"===t.dtype?t:t.toInt())})}function makeBatches(e,t){for(var n=[],r=0,i=null;r<e;)(i=r+t)>=e&&(i=e),n.push([r,i]),r=i;return n}function fitLoop(e,t,n,r,i,a,o,s,l,u,c,p,h,d,f,g){return __awaiter(this,void 0,void 0,function(){var m,y,v,b,w,z,S,I;return __generator(this,function(N){switch(N.label){case 0:if(null==i&&(i=32),null==a&&(a=1),null==c&&(c=!0),null==h&&(h=0),m=!1,null!=l&&null!=u&&(m=!0),null!=f&&(m=!0,null==d))throw new ValueError("Can only use `validationSteps` when doing step-wise training, i.e., `stepsPerEpoch` must be set.");return null!=(y=e.checkNumSamples(n,i,d,"steps_per_epoch"))&&(v=range(0,y)),null==o&&(o=1),b=configureCallbacks(s,g,o,a,h,y,d,i,m,p),w=b.callbackList,z=b.history,w.setModel(e),e.history=z,[4,w.onTrainBegin()];case 1:N.sent(),e.stopTraining_=!1,S=function(a){var o,s,p,h,f;return __generator(this,function(g){switch(g.label){case 0:return[4,w.onEpochBegin(a)];case 1:if(g.sent(),o={},null==d)return[3,2];throw new NotImplementedError("stepsPerEpoch mode is not implemented yet.");case 2:if("batch"===c)throw new NotImplementedError("batch shuffling is not implemneted yet");c&&__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].shuffle(v),s=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_78" /* tensor1d */])(v),p=makeBatches(y,i),h=function(a){var c;return __generator(this,function(h){switch(h.label){case 0:return c={},[4,w.onBatchBegin(a,c)];case 1:return h.sent(),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var h=p[a][0],d=p[a][1],f=sliceAlongFirstAxis(s,h,d-h);c.batch=a,c.size=d-h;for(var g=sliceArraysByIndices(n,f),y=t(g),v=0;v<r.length;++v){var b=r[v],w=y[v];c[b]=w,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_4" /* keep */])(w)}if(a===p.length-1&&m){var z=e.testLoop(l,u,i);for(v=0;v<r.length;++v){b=r[v],w=z[v];Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_4" /* keep */])(w),o["val_"+b]=w}}}),[4,w.onBatchEnd(a,c)];case 2:return h.sent(),disposeTensorsInLogs(c),e.stopTraining_?[2,"break"]:[2]}})},f=0,g.label=3;case 3:return f<p.length?[5,h(f)]:[3,6];case 4:if("break"===g.sent())return[3,6];g.label=5;case 5:return++f,[3,3];case 6:s.dispose(),g.label=7;case 7:return[4,w.onEpochEnd(a,o)];case 8:return g.sent(),e.stopTraining_?[2,"break"]:[2]}})},I=h,N.label=2;case 2:return I<a?[5,S(I)]:[3,5];case 3:if("break"===N.sent())return[3,5];N.label=4;case 4:return++I,[3,2];case 5:return[4,w.onTrainEnd()];case 6:return N.sent(),[4,e.history.syncData()];case 7:return N.sent(),[2,e.history]}})})}function fitTensors(e,t,n,r){return void 0===r&&(r={}),__awaiter(this,void 0,void 0,function(){var i,a,o,s,l,u,c,p,h,d,f,g,m,y,v,b,w,z,S,I;return __generator(this,function(N){switch(N.label){case 0:if(e.isTraining)throw new Error("Cannot start training because another fit() call is ongoing.");e.isTraining=!0,N.label=1;case 1:if(N.trys.push([1,,3,4]),checkBatchSize(c=null==r.batchSize?32:r.batchSize),p=e.standardizeUserData(t,n,!1,c),i=p[0],a=p[1],h=!1,d=void 0,null!=r.validationData&&r.validationData.length>0){if(h=!0,2!==r.validationData.length)throw 3===r.validationData.length?new NotImplementedError("validationData including sample weights is not supported yet."):new ValueError("When passing validation data, it must contain 2 (valX, valY) or 3 (valX, valY, valSampleWeight) items; "+r.validationData+" is invalid.");o=r.validationData[0],s=r.validationData[1],f=e.standardizeUserData(o,s,!0,c),l=f[0],u=f[1],d=l.concat(u)}else null!=r.validationSplit&&r.validationSplit>0&&r.validationSplit<1?(h=!0,g=Math.floor(i[0].shape[0]*(1-r.validationSplit)),m=i[0].shape[0],l=sliceArrays(i,g,m),i=sliceArrays(i,0,g),u=sliceArrays(a,g,m),a=sliceArrays(a,0,g),d=l.concat(u)):null!=r.validationSteps&&(h=!0);return y=i.concat(a),e.checkTrainableWeightsConsistency(),v=e.makeTrainFunction(),b=e.getDedupedMetricsNames(),w=void 0,z=void 0,h?(e.makeTestFunction(),w=e.testFunction,z=b.slice().concat(b.map(function(e){return"val_"+e}))):(w=null,d=[],z=b.slice()),S=standardizeCallbacks(r.callbacks),[4,fitLoop(e,v,y,b,c,r.epochs,r.verbose,S,w,d,r.shuffle,z,r.initialEpoch,null,null,r.yieldEvery)];case 2:return I=N.sent(),e.isTraining=!1,[2,I];case 3:return e.isTraining=!1,disposeNewTensors(i,t),disposeNewTensors(a,n),disposeNewTensors(l,o),disposeNewTensors(u,s),[7];case 4:return[2]}})})}function ensureTensorsRank2OrHigher(e){var t=[];e instanceof __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["c" /* Tensor */]&&(e=[e]);for(var n=0;n<e.length;++n){var r=e[n];if(1===r.rank)t.push(expandDims(r,1));else{if(0===r.rank)throw new Error("Expected tensor to be at least 1D, but received a 0D tensor (scalar).");t.push(r)}}return t}function disposeNewTensors(e,t){if(null!=e){var n=[];if(t instanceof __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["c" /* Tensor */])n.push(t.id);else if(Array.isArray(t))t.forEach(function(e){return n.push(e.id)});else if(null!=t)for(var r in t){var i=t[r];n.push(i.id)}var a=[];if(e instanceof __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["c" /* Tensor */])-1===n.indexOf(e.id)&&a.push(e);else if(Array.isArray(e))e.forEach(function(e){-1===n.indexOf(e.id)&&a.push(e)});else if(null!=e)for(var o in e){var s=e[o];-1===n.indexOf(s.id)&&a.push(s)}a.forEach(function(e){e.isDisposed||e.dispose()})}}function isDataTensor(e){return e instanceof __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["c" /* Tensor */]}function isDataArray(e){return Array.isArray(e)}function isDataDict(e){return!isDataTensor(e)&&!isDataArray(e)}function standardizeInputData(e,t,n,r,i){if(void 0===r&&(r=!0),void 0===i&&(i=""),null==t||0===t.length){if(null!=e){var a=!1;if(isDataArray(e)&&e.length>0)a=!0;else if(isDataDict(e)){for(var o in e)if(e.hasOwnProperty(o)){a=!0;break}}else a=!0;if(a)throw new ValueError("Error when checking model "+i+" expected no data, but got "+e)}return[]}if(null==e)return t.map(function(e){return null});var s;if(isDataDict(e)){e=e,s=[];for(var l=0,u=t;l<u.length;l++){var c=u[l];if(null==e[c])throw new ValueError('No data provided for "'+c+'". Need data for each key in: '+t);s.push(e[c])}}else if(isDataArray(e)){if((e=e).length!==t.length)throw new ValueError("Error when checking model "+i+": the Array of Tensors that you are passing to your model is not the size the model expected. Expected to see "+t.length+" Tensor(s), but instead got the following list of Tensor(s): "+e);s=e}else{if(e=e,t.length>1)throw new ValueError("The model "+i+" expects "+t.length+" Tensor(s), but only received one Tensor. Found: Tensor with shape "+e.shape);s=[e]}if(s=ensureTensorsRank2OrHigher(s),null!=n)for(var p=0;p<t.length;++p)if(null!=n[p]){var h=s[p];if(h.shape.length!==n[p].length)throw new ValueError("Error when checking "+i+": expected "+t[p]+" to have "+n[p].length+" dimension(s). but got array with shape "+h.shape);for(var d=0;d<n[p].length;++d)if(0!==d||r){var f=h.shape[d],g=n[p][d];if(null!=g&&g>=0&&f!==g)throw new ValueError("Error when checking "+i+": expected "+t[p]+" to have shape ["+n[p]+"], but got array with shape ["+h.shape+"].")}}return s}function checkArrayLengths(e,t,n){var r=unique(e.map(function(e){return e.shape[0]}));r.sort();var i=unique(t.map(function(e){return e.shape[0]}));if(i.sort(),r.length>1)throw new ValueError("All input Tensors (x) should have the same number of samples. Got array shapes: "+JSON.stringify(e.map(function(e){return e.shape})));if(i.length>1)throw new ValueError("All target Tensors (y) should have the same number of samples. Got array shapes: "+JSON.stringify(t.map(function(e){return e.shape})));if(r.length>0&&i.length>0&&!__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].arraysEqual(r,i))throw new ValueError("Input Tensors should have the same number of samples as target Tensors. Found "+r[0]+" input sample(s) and "+i[0]+" target sample(s).")}function checkLossAndTargetCompatibility(e,t,n){for(var r=[meanSquaredError,binaryCrossentropy,categoricalCrossentropy],i=0;i<e.length;++i){var a=e[i],o=t[i],s=n[i];if(null!=o){if(o===categoricalCrossentropy&&1===a.shape[a.shape.length-1])throw new ValueError("You are passing a target array of shape "+a.shape+" while using a loss 'categorical_crossentropy'. 'categorical_crossentropy'expects targets to be binary matrices (1s and 0s) of shape [samples, classes].");if(-1!==r.indexOf(o))for(var l=a.shape.slice(1),u=s.slice(1),c=0;c<l.length;++c){var p=l[c],h=u[c];if(null!=h&&p!==h)throw new ValueError("A target Tensor with shape "+a.shape+" was passed for an output of shape "+s+", while using a loss function that expects targets to have the same shape as the output.")}}}}function checkInputData(e,t,n,r,i){var a;if(void 0===r&&(r=!0),void 0===i&&(i=""),Array.isArray(e)){if(e.length!==t.length)throw new ValueError("Error when checking model "+i+": the Array of Tensors that you are passing to your model is not the size the the model expected. Expected to see "+t.length+" Tensor(s), but instead got "+e.length+" Tensors(s).");a=e}else{if(t.length>1)throw new ValueError("The model expects "+t.length+" "+i+" Tensors, but only received one Tensor. Found: array with shape "+JSON.stringify(e.shape)+".");a=[e]}if(null!=n)for(var o=0;o<t.length;++o)if(null!=n[o]){var s=a[o];if(s.shape.length!==n[o].length)throw new ValueError("Error when checking "+i+": expected "+t[o]+" to have "+n[o].length+" dimension(s), but got array with shape "+JSON.stringify(s.shape));for(var l=0;l<n[o].length;++l)if(0!==l||r){var u=s.shape[l],c=n[o][l];if(null!=c&&c!==u)throw new ValueError("Error when checking "+i+": expected "+t[o]+" to have shape "+JSON.stringify(n[o])+" but got array with shape "+JSON.stringify(s.shape)+".")}}}function collectMetrics(e,t){if(null==e||Array.isArray(e)&&0===e.length)return t.map(function(e){return[]});if(Array.isArray(e))return t.map(function(t){return e});if(null!=e){for(var n=[],r=0,i=t;r<i.length;r++){var a=i[r],o=e.hasOwnProperty(a)?e[a]:[];Array.isArray(o)||(o=[o]),n.push(o)}return n}throw new TypeError("Type of metrics argument not understood. Expected an Array or Object, found: "+e)}var Model=function(e){function t(t){var n=e.call(this,t)||this;return n.isTraining=!1,n}return __extends(t,e),t.prototype.summary=function(e,t,n){if(void 0===n&&(n=console.log),!this.built)throw new ValueError("This model has never been called, thus its weights have not been created yet. So no summary can be displayed. Build the model first (e.g., by calling it on some test data).");printSummary(this,e,t,n)},t.prototype.compile=function(e){var t=this;if(null==e.loss&&(e.loss=[]),this.loss=e.loss,"string"==typeof e.optimizer)this.optimizer=getOptimizer(e.optimizer);else{if(!(e.optimizer instanceof __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["b" /* Optimizer */]))throw new ValueError("User-defined optimizer must be an instance of tf.Optimizer.");this.optimizer=e.optimizer}var n=[];if(Array.isArray(e.loss)||"string"==typeof e.loss||"function"==typeof e.loss)if(Array.isArray(e.loss)){if(e.loss.length!==this.outputs.length)throw new ValueError("When passing an Array as loss, it should have one entry per model output. The model has "+this.outputs.length+" output(s), but you passed loss="+e.loss+".");var r=e.loss;n=r.map(function(e){return get(e)})}else{var i=get(e.loss);this.outputs.map(function(e){n.push(i)})}else{for(var a in e.loss=e.loss,e.loss)if(-1===this.outputNames.indexOf(a))throw new ValueError('Unknown entry in loss dictionary: "'+a+'". Only expect the following keys: '+this.outputNames);for(var o in this.outputNames)null==e.loss[o]&&console.warn('Output "'+o+'" is missing from loss dictionary. We assume this was done on purpose, and we will not be expecting data to be passed to '+o+" during training"),n.push(get(e.loss[o]))}this.lossFunctions=n,this.feedOutputNames=[],this.feedOutputShapes=[],this.feedLossFns=[];for(var s=0;s<this.outputs.length;++s){var l=this.internalOutputShapes[s],u=this.outputNames[s];this.feedOutputNames.push(u),this.feedOutputShapes.push(l),this.feedLossFns.push(this.lossFunctions[s])}var c=[];this.metrics=e.metrics,this.metricsNames=["loss"],this.metricsTensors=[],nameScope("loss",function(){for(var e=0;e<t.outputs.length;++e)if(-1===c.indexOf(e)){var n=t.lossFunctions[e];t.outputs.length>1&&(t.metricsTensors.push([n,e]),t.metricsNames.push(t.outputNames[e]+"_loss"))}});var p=collectMetrics(e.metrics,this.outputNames);nameScope("metric",function(){for(var e=function(e){if(-1!==c.indexOf(e))return"continue";!function(n){for(var r,i,a,o=function(n){if(-1!==["accuracy","acc","crossentropy","ce"].indexOf(n)){var o=t.internalOutputShapes[e];1===o[o.length-1]||t.lossFunctions[e]===binaryCrossentropy?-1!==["accuracy","acc"].indexOf(n)?i=binaryAccuracy:-1!==["crossentropy","ce"].indexOf(n)&&(i=binaryCrossentropy$1):t.lossFunctions[e]===sparseCategoricalCrossentropy?-1!==["accuracy","acc"].indexOf(n)?i=sparseCategoricalAccuracy:-1!==["crossentropy","ce"].indexOf(n)&&(i=sparseCategoricalCrossentropy$1):-1!==["accuracy","acc"].indexOf(n)?i=categoricalAccuracy:-1!==["crossentropy","ce"].indexOf(n)&&(i=categoricalCrossentropy$1);var s=void 0;-1!==["accuracy","acc"].indexOf(n)?s="acc":-1!==["crossentropy","ce"].indexOf(n)&&(s="ce"),a=i,r=""+s}else{var l=get$1(n);a=l,r=""+n}var u;nameScope(r,function(){u=a}),function(e,n,r){t.outputNames.length>1&&(n=t.outputNames[e]+"_"+n),t.metricsNames.push(n),t.metricsTensors.push([r,e])}(e,r,u)},s=0,l=n;s<l.length;s++)o(l[s])}(p[e])},n=0;n<t.outputs.length;++n)e(n)}),this.collectedTrainableWeights=this.trainableWeights},t.prototype.checkTrainableWeightsConsistency=function(){null!=this.collectedTrainableWeights&&this.trainableWeights.length!==this.collectedTrainableWeights.length&&console.warn("Discrepancy between trainableweights and collected trainable weights. Did you set `model.trainable` without calling `model.compile()` afterwards?")},t.prototype.evaluate=function(e,t,n){void 0===n&&(n={});var r=null==n.batchSize?32:n.batchSize;checkBatchSize(r);var i=this.standardizeUserData(e,t,!0,r);try{var a=i[0].concat(i[1]);this.makeTestFunction();var o=this.testFunction;return singletonOrArray(this.testLoop(o,a,r,n.verbose,n.steps))}finally{disposeNewTensors(i[0],e),disposeNewTensors(i[1],t)}},t.prototype.evaluateDataset=function(e,t){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(n){return this.makeTestFunction(),[2,evaluateDataset(this,e,t)]})})},t.prototype.checkNumSamples=function(e,t,n,r){var i;if(void 0===r&&(r="steps"),null!=n){if(i=null,null!=t)throw new ValueError("If "+r+" is set, batchSize must be null or undefined.Got batchSize = "+t)}else{if(null==e)throw new ValueError("Either the input data should have a defined shape, or "+r+" shoud be specified.");i=Array.isArray(e)?e[0].shape[0]:e.shape[0]}return i},t.prototype.execute=function(e,t){if(Array.isArray(t)&&0===t.length)throw new ValueError("`outputs` is an empty Array, which is not allowed.");var n=Array.isArray(t),r=n?t:[t],i=this.retrieveSymbolicTensors(r),a=new FeedDict;if(e instanceof __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["c" /* Tensor */]&&(e=[e]),Array.isArray(e)){if(e.length!==this.inputs.length)throw new ValueError("The number of inputs provided ("+e.length+") does not match the number of inputs of this model ("+this.inputs.length+").");for(var o=0;o<this.inputs.length;++o)a.add(this.inputs[o],e[o])}else for(var s=0,l=this.inputs;s<l.length;s++){var u=l[s],c=e[u.name];if(null==c)throw new ValueError("No value is provided for the model's input "+u.name);a.add(u,c)}var p=execute(i,a);return n?p:p[0]},t.prototype.retrieveSymbolicTensors=function(e){for(var t=pyListRepeat(null,e.length),n=e.length,r=0,i=this.layers;r<i.length;r++){for(var a=i[r],o=Array.isArray(a.output)?a.output:[a.output],s=o.map(function(e){return e.name}),l=0;l<e.length;++l){var u=s.indexOf(e[l]);if(-1!==u&&(t[l]=o[u],n--),0===n)break}if(0===n)break}if(n>0){var c=[];throw t.forEach(function(t,n){null==t&&c.push(e[n])}),new ValueError("Cannot find SymbolicTensors for output name(s): "+JSON.stringify(c))}return t},t.prototype.predictLoop=function(e,t,n){var r=this;return void 0===t&&(t=32),void 0===n&&(n=!1),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var i=r.checkNumSamples(e);if(n)throw new NotImplementedError("Verbose predictLoop() is not implemented yet.");for(var a=makeBatches(i,t),o=[],s=function(t){var n=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n=a[t][0],i=a[t][1],o=sliceArrays(e,n,i),s=[];if(Array.isArray(o))for(var l=0;l<o.length;++l)s.push({key:r.inputs[l],value:o[l]});else s.push({key:r.inputs[0],value:o});var u=new FeedDict(s);return execute(r.outputs,u)});if(0===t)for(var i=0,s=n;i<s.length;i++){var l=s[i];o.push(l)}else for(var u=0;u<n.length;++u)o[u]=concatAlongFirstAxis(o[u],n[u])},l=0;l<a.length;++l)s(l);return singletonOrArray(o)})},t.prototype.predict=function(e,t){void 0===t&&(t={});var n=ensureTensorsRank2OrHigher(e);checkInputData(n,this.inputNames,this.feedInputShapes,!1);try{var r=null==t.batchSize?32:t.batchSize;return checkBatchSize(r),this.predictLoop(n,r)}finally{disposeNewTensors(n,e)}},t.prototype.predictOnBatch=function(e){return checkInputData(e,this.inputNames,this.feedInputShapes,!0),this.predictLoop(e,e.shape[0])},t.prototype.standardizeUserData=function(e,t,n,r){if(void 0===n&&(n=!0),null==this.optimizer)throw new RuntimeError("You must compile a model before training/testing. Use Model.compile(modelCompileConfig).");for(var i=[],a=0;a<this.feedOutputShapes.length;++a){var o=this.feedOutputShapes[a];this.feedLossFns[a]===sparseCategoricalCrossentropy?i.push(o.slice(0,o.length-1).concat([1])):i.push(o)}if(checkArrayLengths(e=standardizeInputData(e,this.feedInputNames,this.feedInputShapes,!1,"input"),t=standardizeInputData(t,this.feedOutputNames,i,!1,"target"),null),checkLossAndTargetCompatibility(t,this.feedLossFns,this.feedOutputShapes),this.stateful&&null!=r&&r>0&&e[0].shape[0]%r!=0)throw new ValueError("In a stateful network, you should only pass inputs with a number of samples that is divisible by the batch size "+r+". Found: "+e[0].shape[0]+" sample(s).");return[e,t,null]},t.prototype.testLoop=function(e,t,n,r,i){var a=this;return void 0===r&&(r=0),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var o=a.checkNumSamples(t,n,i,"steps"),s=[];if(r>0)throw new NotImplementedError("Verbose mode is not implemented yet.");if(null!=i)throw new NotImplementedError("steps mode in testLoop() is not implemented yet");for(var l=makeBatches(o,n),u=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_78" /* tensor1d */])(range(0,o)),c=0;c<l.length;++c){var p=l[c][0],h=l[c][1],d=sliceAlongFirstAxis(u,p,h-p),f=sliceArraysByIndices(t,d),g=e(f);if(0===c)for(var m=0;m<g.length;++m)s.push(getScalar(0));for(m=0;m<g.length;++m){var y=g[m];s[m]=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(s[m],Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(getScalar(h-p),y))}}for(m=0;m<s.length;++m)s[m]=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["N" /* div */])(s[m],getScalar(o));return s})},t.prototype.getDedupedMetricsNames=function(){for(var e=this.metricsNames,t=[],n=0;n<e.length;++n){var r=e[n],i=r;if(count(e,r)>1)i+="_"+count(e.slice(0,n),r);t.push(i)}return t},t.prototype.makeTrainFunction=function(){var e=this;return function(t){var n=t.slice(0,e.inputs.length),r=t.slice(e.inputs.length,e.inputs.length+e.outputs.length),i=[],a=e.collectedTrainableWeights.map(function(e){return e.read()});return[e.optimizer.minimize(function(){for(var t=[],a=0;a<e.inputs.length;++a)t.push({key:e.inputs[a],value:n[a]});var o,s=new FeedDict(t),l=execute(e.outputs,s,{training:!0});for(a=0;a<e.lossFunctions.length;++a){var u=(0,e.lossFunctions[a])(r[a],l[a]);Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_21" /* mean */])(u),o=0===a?u:Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(o,u)}for(a=0;a<e.metricsTensors.length;++a){var c=e.metricsTensors[a][0],p=e.metricsTensors[a][1],h=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_21" /* mean */])(c(r[p],l[p]));Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_4" /* keep */])(h),i.push(h)}return o=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_21" /* mean */])(o),e.calculateLosses().forEach(function(e){o=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(o,e)}),o},!0,a)].concat(i)}},t.prototype.makeTestFunction=function(){var e=this;this.testFunction=function(t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){for(var n,r=[],i=t.slice(0,e.inputs.length),a=t.slice(e.inputs.length,e.inputs.length+e.outputs.length),o=[],s=0;s<e.inputs.length;++s)o.push({key:e.inputs[s],value:i[s]});var l=new FeedDict(o),u=execute(e.outputs,l);for(s=0;s<e.lossFunctions.length;++s){var c=e.lossFunctions[s],p=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_21" /* mean */])(c(a[s],u[s]));n=0===s?p:Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(n,p),r.push(n)}for(s=0;s<e.metricsTensors.length;++s){var h=e.metricsTensors[s][0],d=e.metricsTensors[s][1],f=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_21" /* mean */])(h(a[d],u[d]));r.push(f)}return r})}},t.prototype.fit=function(e,t,n){return void 0===n&&(n={}),__awaiter(this,void 0,void 0,function(){return __generator(this,function(r){return[2,fitTensors(this,e,t,n)]})})},t.prototype.fitDataset=function(e,t){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(n){return[2,fitDataset(this,e,t)]})})},t.prototype.getNamedWeights=function(e){for(var t={},n=null!=e&&e.trainableOnly,r=n?this.trainableWeights:this.weights,i=this.getWeights(n),a=0;a<r.length;++a)n&&!r[a].trainable||(t[r[a].originalName]=i[a]);return t},Object.defineProperty(t.prototype,"stopTraining",{set:function(e){this.stopTraining_=e},enumerable:!0,configurable:!0}),t.prototype.save=function(e,t){return __awaiter(this,void 0,void 0,function(){var n,r,i,a,o;return __generator(this,function(s){switch(s.label){case 0:if("string"==typeof e){if(0===(n=__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_3" /* io */].getSaveHandlers(e)).length)throw new ValueError("Cannot find any save handlers for URL '"+e+"'");if(n.length>1)throw new ValueError("Found more than one ("+n.length+") save handlers for URL '"+e+"'");e=n[0]}if(null==e.save)throw new ValueError("Model.save() cannot proceed because the IOHandler provided does not have the `save` attribute defined.");return[4,__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_3" /* io */].encodeWeights(this.getNamedWeights(t))];case 1:return r=s.sent(),i=!1,a=null,o=this.toJSON(a,i),[2,e.save({modelTopology:o,weightData:r.data,weightSpecs:r.specs})]}})})},t.className="Model",t}(Container);function modelFromJSON(e,t){return __awaiter(this,void 0,void 0,function(){var n,r,i,a,o,s,l,u,c,p;return __generator(this,function(h){switch(h.label){case 0:return"modelTopology"in e||(e={modelTopology:e}),null!=(n=(e=e).modelTopology).model_config&&(n=n.model_config),r=convertPythonicToTs(n),i=deserialize(r,t),null==e.weightsManifest?[3,2]:[4,__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_3" /* io */].loadWeights(e.weightsManifest,e.pathPrefix,i.weights.map(function(e){return e.originalName}))];case 1:for(a=h.sent(),o={},s=0,l=i.weights;s<l.length;s++)u=l[s],o[u.originalName]=a[u.originalName];c=null,p=!0,i.loadWeights(o,c,p),h.label=2;case 2:return[2,i]}})})}function loadModelInternal(e,t){return void 0===t&&(t=!0),__awaiter(this,void 0,void 0,function(){var n;return __generator(this,function(r){if("string"==typeof e){if(0===(n=__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_3" /* io */].getLoadHandlers(e)).length)n.push(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_3" /* io */].browserHTTPRequest(e));else if(n.length>1)throw new ValueError("Found more than one ("+n.length+") load handlers for URL '"+e+"'");e=n[0]}return[2,loadModelFromIOHandler(e,void 0,t)]})})}function loadModelFromIOHandler(e,t,n){return void 0===n&&(n=!0),__awaiter(this,void 0,void 0,function(){var r,i,a,o,s;return __generator(this,function(l){switch(l.label){case 0:if(null==e.load)throw new ValueError("Cannot proceed with model loading because the IOHandler provided does not have the `load` method implemented.");return[4,e.load()];case 1:if(r=l.sent(),null!=(i=r.modelTopology).model_config&&(i=i.model_config),a=deserialize(convertPythonicToTs(i),t),null!=r.weightData){if(null==r.weightSpecs)throw new ValueError("Model artifacts contains weight data, but not weight specs. Therefore loading of weights cannot proceed.");o=!1,s=!0,a.loadWeights(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_3" /* io */].decodeWeights(r.weightData,r.weightSpecs),o,s,n)}return[2,a]}})})}__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Model);var Sequential=function(e){function t(t){var n=e.call(this,{inputs:[],outputs:[]})||this;if(t=t||{},n.trainable=!0,n._updatable=!0,n.built=!1,n.name=null!=t.name?t.name:getUid("sequential_"),null!=t.layers)for(var r=0,i=t.layers;r<i.length;r++){var a=i[r];n.add(a)}return n}return __extends(t,e),t.prototype.checkShape=function(e){if(e.inboundNodes[0].outputTensors[0].shape.some(function(e){return e<0}))throw new ValueError("Negative dimension size caused by adding layer "+e.name+" with input shape ["+e.inboundNodes[0].inputTensors[0].shape+"]")},t.prototype.add=function(e){var n,r=e instanceof t||e instanceof Model;if(r){if(1!==(n=e).outputs.length)throw new ValueError("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");if(1!==n.inputs.length)throw new ValueError("All layers in a Sequential model should have a single input tensor. For multi-input layers, use the functional API.")}if(0===this.outputs.length){if(0===e.inboundNodes.length){if(null==e.batchInputShape)throw new ValueError("The first layer in a Sequential model must get an `inputShape` or `batchInputShape` argument.");var i=Input({batchShape:e.batchInputShape,dtype:e.dtype,name:e.name+"_input"});e.apply(i)}if(r)this.outputs=n.outputs,this.inputs=n.inputs;else{if(1!==e.inboundNodes.length)throw new ValueError("A layer added to a Sequential model must not already be connected somewhere else. Model received layer "+e.name+" which has "+e.inboundNodes.length+" pre-existing inbound connections.");if(1!==e.inboundNodes[0].outputTensors.length)throw new ValueError("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");this.checkShape(e),this.outputs=[e.inboundNodes[0].outputTensors[0]],this.inputs=getSourceInputs(this.outputs[0])}this.inboundNodes=[],new Node({outboundLayer:this,inboundLayers:[],nodeIndices:[],tensorIndices:[],inputTensors:this.inputs,outputTensors:this.outputs,inputMasks:pyListRepeat(null,this.inputs.length),outputMasks:[null],inputShapes:this.inputs.map(function(e){return e.shape}),outputShapes:this.outputs[0].shape})}else{var a=e.apply(this.outputs[0]);if(Array.isArray(a))throw new TypeError("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");this.checkShape(e),this.outputs=[a],this.inboundNodes[0].outputTensors=this.outputs,this.inboundNodes[0].outputShapes=[this.outputs[0].shape]}this.layers.push(e),this.built=!1},t.prototype.pop=function(){if(0===this.layers.length)throw new TypeError("There are no layers in the model.");if(this.layers.pop(),0===this.layers.length)this.outputs=[],this.inboundNodes=[],this.outboundNodes=[];else{var e=this.layers.length-1;this.layers[e].outboundNodes=[],this.outputs=[this.layers[e].output],this.inboundNodes[0].outputTensors=this.outputs,this.inboundNodes[0].outputShapes=[this.outputs[0].shape]}},t.prototype.call=function(e,t){return null==this.model&&this.build(),this.model.call(e,t)},t.prototype.build=function(e){if(getExactlyOneShape(e),0===this.inputs.length||0===this.outputs.length)throw new TypeError("Sequential model cannot be built: model is empty. Add some layers first.");this.model=new Model({inputs:this.inputs,outputs:this.outputs[0],name:this.name+"_model"}),this.model.trainable=this.trainable,this.model.updatable=this.updatable,this.supportsMasking=this.model.supportsMasking,this.inputLayers=this.model.inputLayers,this.inputLayersNodeIndices=this.model.inputLayersNodeIndices,this.inputLayersTensorIndices=this.model.inputLayersTensorIndices,this.outputLayers=this.model.outputLayers,this.outputLayersNodeIndices=this.model.outputLayersNodeIndices,this.outputLayersTensorIndices=this.model.outputLayersTensorIndices,this.nodesByDepth=this.model.nodesByDepth,this.containerNodes=this.model.containerNodes,this.outputNames=this.model.outputNames,this.inputNames=this.model.inputNames,this.built=!0},t.prototype.countParams=function(){return this.built||this.build(),e.prototype.countParams.call(this)},t.prototype.summary=function(t,n,r){void 0===r&&(r=console.log),this.built||this.build(),e.prototype.summary.call(this,t,n,r)},t.prototype.setWeights=function(e){null==this.model&&this.build(),this.model.setWeights(e)},Object.defineProperty(t.prototype,"updatable",{get:function(){return this._updatable},set:function(e){this.built&&(this.model.updatable=e),this._updatable=e},enumerable:!0,configurable:!0}),t.prototype.evaluate=function(e,t,n){if(void 0===n&&(n={}),!this.built)throw new RuntimeError("The model needs to be compiled before being used.");return this.model.evaluate(e,t,n)},t.prototype.evaluateDataset=function(e,t){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(n){if(!this.built)throw new RuntimeError("The model needs to be compiled before being used.");return[2,this.model.evaluateDataset(e,t)]})})},t.prototype.predict=function(e,t){return void 0===t&&(t={}),null==this.model&&this.build(),this.model.predict(e,t)},t.prototype.predictOnBatch=function(e){return null==this.model&&this.build(),this.model.predictOnBatch(e)},t.prototype.compile=function(e){this.build(),this.model.compile(e),this.optimizer=this.model.optimizer,this.loss=this.model.loss,this.metrics=this.model.metrics,this.metricsTensors=this.model.metricsTensors,this.metricsNames=this.model.metricsNames},t.prototype.fit=function(e,t,n){return void 0===n&&(n={}),__awaiter(this,void 0,void 0,function(){return __generator(this,function(r){if(!this.built)throw new RuntimeError("The model needs to be compiled before being used.");return[2,this.model.fit(e,t,n)]})})},t.prototype.fitDataset=function(e,t){return __awaiter(this,void 0,void 0,function(){return __generator(this,function(n){if(!this.built)throw new RuntimeError("The model needs to be compiled before being used.");return[2,this.model.fitDataset(e,t)]})})},t.fromConfig=function(e,n){var r,i={};if(n instanceof Array){if(null==n[0].className||"Merge"===n[0].className)throw new ValueError("Legacy serialization format not supported yet.");r=n}else __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].assert(null!=n.layers,"When the config data for a Sequential model is not an Array, it must be an Object that contains the 'layers' field."),r=n.layers,delete n.layers,i=n;var a=new e(i);if(!(a instanceof t))throw new NotImplementedError("Sequential.fromConfig called on non-Sequential input: "+a);for(var o=0,s=r;o<s.length;o++){var l=deserialize(s[o]);a.add(l)}return a},Object.defineProperty(t.prototype,"stopTraining",{set:function(e){this.model.stopTraining=e},enumerable:!0,configurable:!0}),t.prototype.getConfig=function(){for(var e=[],t=0,n=this.layers;t<n.length;t++){var r=n[t];e.push({className:r.getClassName(),config:r.getConfig()})}return e},t.className="Sequential",t}(Model);function model(e){return new Model(e)}function sequential(e){return new Sequential(e)}function loadModel(e,t){return void 0===t&&(t=!0),loadModelInternal(e,t)}function input(e){return Input(e)}function registerCallbackConstructor(e,t){CallbackConstructorRegistry.registerCallbackConstructor(e,t)}__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Sequential);var Activation=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.getConfig=function(){return{}},t}(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].Serializable),Elu=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.apply=function(e,t){return void 0===t&&(t=1),elu$1(e,t)},t.className="elu",t}(Activation);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Elu);var Selu=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.apply=function(e){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_48" /* selu */])(e)},t.className="selu",t}(Activation);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Selu);var Relu=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.apply=function(e){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_42" /* relu */])(e)},t.className="relu",t}(Activation);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Relu);var Relu6=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.apply=function(e){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_23" /* minimum */])(getScalar(6),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_42" /* relu */])(e))})},t.className="relu6",t}(Activation);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Relu6);var Linear=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.apply=function(e){return e},t.className="linear",t}(Activation);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Linear);var Sigmoid=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.apply=function(e){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_52" /* sigmoid */])(e)},t.className="sigmoid",t}(Activation);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Sigmoid);var HardSigmoid=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.apply=function(e){return hardSigmoid(e)},t.className="hardSigmoid",t}(Activation);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(HardSigmoid);var Softplus=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.apply=function(e){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_62" /* softplus */])(e)},t.className="softplus",t}(Activation);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Softplus);var Softsign=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.apply=function(e){return softsign(e)},t.className="softsign",t}(Activation);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Softsign);var Tanh=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.apply=function(e){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_76" /* tanh */])(e)},t.className="tanh",t}(Activation);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Tanh);var Softmax=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.apply=function(e,t){return void 0===t&&(t=-1),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_61" /* softmax */])(e,t)},t.className="softmax",t}(Activation);function serializeActivation(e){return e.getClassName()}function deserializeActivation(e,t){return void 0===t&&(t={}),deserializeKerasObject(e,__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].SerializationMap.getMap().classNameMap,t,"activation")}function getActivation(e){return null==e?deserializeActivation({className:"linear",config:{}}):"string"==typeof e?deserializeActivation({className:e,config:{}}):e instanceof Activation?e:deserializeActivation(e)}__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Softmax);var ReLU=function(e){function t(t){var n=e.call(this,null==t?{}:t)||this;return n.supportsMasking=!0,null!=t&&(n.maxValue=t.maxValue),n}return __extends(t,e),t.prototype.call=function(e,t){e=getExactlyOneTensor(e);var n=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_42" /* relu */])(e);return null!=this.maxValue&&(n=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["z" /* clipByValue */])(n,0,this.maxValue)),n},t.prototype.computeOutputShape=function(e){return e},t.prototype.getConfig=function(){var t={maxValue:this.maxValue},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.className="ReLU",t}(Layer);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(ReLU);var LeakyReLU=function(e){function t(t){var n=e.call(this,null==t?{}:t)||this;return n.DEFAULT_ALPHA=.3,null==t&&(t={}),n.alpha=null==t.alpha?n.DEFAULT_ALPHA:t.alpha,n}return __extends(t,e),t.prototype.call=function(e,t){var n=getExactlyOneTensor(e);return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_5" /* leakyRelu */])(n,this.alpha)},t.prototype.computeOutputShape=function(e){return e},t.prototype.getConfig=function(){var t={alpha:this.alpha},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.className="LeakyReLU",t}(Layer);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(LeakyReLU);var ELU=function(e){function t(t){var n=e.call(this,null==t?{}:t)||this;if(n.DEFAULT_ALPHA=1,null==t&&(t={}),null!=t.alpha&&t.alpha!==n.DEFAULT_ALPHA)throw new NotImplementedError("Non-default alpha value ("+t.alpha+") is not supported by the ELU layer yet.");return n.alpha=null==t.alpha?n.DEFAULT_ALPHA:t.alpha,n}return __extends(t,e),t.prototype.call=function(e,t){var n=getExactlyOneTensor(e);return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["O" /* elu */])(n)},t.prototype.computeOutputShape=function(e){return e},t.prototype.getConfig=function(){var t={alpha:this.alpha},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.className="ELU",t}(Layer);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(ELU);var ThresholdedReLU=function(e){function t(t){var n=e.call(this,null==t?{}:t)||this;return n.DEFAULT_THETA=1,null==t&&(t={}),n.theta=null==t.theta?n.DEFAULT_THETA:t.theta,n.thetaTensor=getScalar(n.theta),n}return __extends(t,e),t.prototype.call=function(e,t){var n=getExactlyOneTensor(e);return n.mul(cast$1(n.greater(this.thetaTensor),"float32"))},t.prototype.computeOutputShape=function(e){return e},t.prototype.getConfig=function(){var t={theta:this.theta},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.className="ThresholdedReLU",t}(Layer);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(ThresholdedReLU);var Softmax$1=function(e){function t(t){var n=e.call(this,null==t?{}:t)||this;return n.DEFAULT_AXIS=1,null==t&&(t={}),n.softmax=(new Softmax).apply,n.axis=null==t.axis?n.DEFAULT_AXIS:t.axis,n}return __extends(t,e),t.prototype.call=function(e,t){var n=getExactlyOneTensor(e);return this.softmax(n,this.axis)},t.prototype.computeOutputShape=function(e){return e},t.prototype.getConfig=function(){var t={axis:this.axis},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.className="Softmax",t}(Layer);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Softmax$1);var Regularizer=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t}(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].Serializable),L1L2=function(e){function t(t){var n=e.call(this)||this,r=null==t||null==t.l1?.01:t.l1,i=null==t||null==t.l2?.01:t.l2;return n.hasL1=0!==r,n.hasL2=0!==i,n.l1=getScalar(r),n.l2=getScalar(i),n}return __extends(t,e),t.prototype.apply=function(e){var t=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_91" /* zeros */])([1]);return t.hasL1&&(n=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(n,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_74" /* sum */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(t.l1,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["d" /* abs */])(e))))),t.hasL2&&(n=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(n,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_74" /* sum */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(t.l2,square(e))))),n.asScalar()})},t.prototype.getConfig=function(){return{l1:this.l1.dataSync()[0],l2:this.l2.dataSync()[0]}},t.fromConfig=function(e,t){return new e({l1:t.l1,l2:t.l2})},t.className="L1L2",t}(Regularizer);function l1(e){return new L1L2({l1:null!=e?e.l1:null,l2:0})}function l2(e){return new L1L2({l2:null!=e?e.l2:null,l1:0})}__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(L1L2);var REGULARIZER_IDENTIFIER_REGISTRY_SYMBOL_MAP={l1l2:"L1L2"};function serializeRegularizer(e){return serializeKerasObject(e)}function deserializeRegularizer(e,t){return void 0===t&&(t={}),deserializeKerasObject(e,__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].SerializationMap.getMap().classNameMap,t,"regularizer")}function getRegularizer(e){return null==e?null:"string"==typeof e?deserializeRegularizer({className:e in REGULARIZER_IDENTIFIER_REGISTRY_SYMBOL_MAP?REGULARIZER_IDENTIFIER_REGISTRY_SYMBOL_MAP[e]:e,config:{}}):e instanceof Regularizer?e:deserializeRegularizer(e)}function normalizeArray(e,t,n){if("number"==typeof e)return pyListRepeat(e,t);if(e.length!==t)throw new ValueError("The "+n+" argument must be a tuple of "+t+" integers. Received: "+e.length+" elements.");for(var r=0;r<t;++r){var i=e[r];if(!isInteger(i))throw new ValueError("The "+n+" argument must be a tuple of "+t+" integers. Received: "+JSON.stringify(e)+" including a non-integer number "+i)}return e}function convOutputLength(e,t,n,r,i){return void 0===i&&(i=1),null==e?e:(a="same"===n?e:e-(t+(t-1)*(i-1))+1,Math.floor((a+r-1)/r));var a}function deconvLength(e,t,n,r){if(null==e)return null;if("valid"===r)e=e*t+max$1([n-t,0]);else{if("same"!==r)throw new ValueError("Unsupport padding mode: "+r+".");e*=t}return e}function preprocessConv2DInput(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){return checkDataFormat(t),"channelsFirst"===t?Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_83" /* transpose */])(e,[0,2,3,1]):e})}function conv1dWithBias(e,t,n,r,i,a,o){return void 0===r&&(r=1),void 0===i&&(i="valid"),void 0===o&&(o=1),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){if(null==a&&(a=imageDataFormat()),checkDataFormat(a),3!==e.shape.length)throw new ValueError("The input of a conv1dWithBias operation should be 3, but is "+e.shape.length+" instead.");if(3!==t.shape.length)throw new ValueError("The kernel for a conv1dWithBias operation should be 3, but is "+t.shape.length+" instead");if(null!=n&&1!==n.shape.length)throw new ValueError("The bias for a conv1dWithBias operation should be 1, but is "+t.shape.length+" instead");if("channelsFirst"===a&&(e=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_83" /* transpose */])(e,[0,2,1])),"causal"===i)throw new NotImplementedError("The support for CAUSAL padding mode in conv1dWithBias is not implemented yet.");var s=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["F" /* conv1d */])(e,t,r,"same"===i?"same":"valid","NWC",o);return null!=n&&(s=biasAdd(s,n)),s})}function conv2dWithBias(e,t,n,r,i,a,o){return void 0===r&&(r=[1,1]),void 0===i&&(i="valid"),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){if(null==a&&(a=imageDataFormat()),checkDataFormat(a),3!==e.rank&&4!==e.rank)throw new ValueError("conv2dWithBias expects input to be of rank 3 or 4, but received "+e.rank+".");if(3!==t.rank&&4!==t.rank)throw new ValueError("conv2dWithBias expects kernel to be of rank 3 or 4, but received "+e.rank+".");var s=preprocessConv2DInput(e,a);if("causal"===i)throw new NotImplementedError("The support for CAUSAL padding mode in conv1dWithBias is not implemented yet.");return s=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["G" /* conv2d */])(s,t,r,"same"===i?"same":"valid","NHWC",o),null!=n&&(s=biasAdd(s,n)),"channelsFirst"===a&&(s=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_83" /* transpose */])(s,[0,3,1,2])),s})}var BaseConv=function(e){function t(n,r){var i=e.call(this,r)||this;if(i.bias=null,i.DEFAULT_KERNEL_INITIALIZER="glorotNormal",i.DEFAULT_BIAS_INITIALIZER="zeros",t.verifyConfig(r),i.rank=n,1!==i.rank&&2!==i.rank)throw new NotImplementedError("Convolution layer for rank other than 1 or 2 ("+i.rank+") is not implemented yet.");if(i.kernelSize=normalizeArray(r.kernelSize,n,"kernelSize"),i.strides=normalizeArray(null==r.strides?1:r.strides,n,"strides"),i.padding=null==r.padding?"valid":r.padding,checkPaddingMode(i.padding),i.dataFormat=null==r.dataFormat?"channelsLast":r.dataFormat,checkDataFormat(i.dataFormat),i.activation=getActivation(r.activation),i.useBias=null==r.useBias||r.useBias,i.biasInitializer=getInitializer(r.biasInitializer||i.DEFAULT_BIAS_INITIALIZER),i.biasConstraint=getConstraint(r.biasConstraint),i.biasRegularizer=getRegularizer(r.biasRegularizer),i.activityRegularizer=getRegularizer(r.activityRegularizer),i.dilationRate=normalizeArray(null==r.dilationRate?1:r.dilationRate,n,"dilationRate"),1===i.rank&&Array.isArray(i.dilationRate)&&1!==i.dilationRate.length)throw new ValueError("dilationRate must be a number or an array of a single number for 1D convolution, but received "+JSON.stringify(i.dilationRate));if(2===i.rank)if("number"==typeof i.dilationRate)i.dilationRate=[i.dilationRate,i.dilationRate];else if(2!==i.dilationRate.length)throw new ValueError("dilationRate must be a number or array of two numbers for 2D convolution, but received "+JSON.stringify(i.dilationRate));return i}return __extends(t,e),t.verifyConfig=function(e){if(assert("kernelSize"in e,"required key 'kernelSize' not in config"),"number"!=typeof e.kernelSize&&!checkArrayTypeAndLength(e.kernelSize,"number",1,2))throw new ValueError("BaseConv expects config.kernelSize to be number or number[] with length 1 or 2, but received "+JSON.stringify(e.kernelSize)+".")},t.prototype.getConfig=function(){var t={kernelSize:this.kernelSize,strides:this.strides,padding:this.padding,dataFormat:this.dataFormat,dilationRate:this.dilationRate,activation:serializeActivation(this.activation),useBias:this.useBias,biasInitializer:serializeInitializer(this.biasInitializer),biasRegularizer:serializeRegularizer(this.biasRegularizer),activityRegularizer:serializeRegularizer(this.activityRegularizer),biasConstraint:serializeConstraint(this.biasConstraint)},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t}(Layer),Conv=function(e){function t(n,r){var i=e.call(this,n,r)||this;return i.kernel=null,t.verifyConfig(r),i.filters=r.filters,i.kernelInitializer=getInitializer(r.kernelInitializer||i.DEFAULT_KERNEL_INITIALIZER),i.kernelConstraint=getConstraint(r.kernelConstraint),i.kernelRegularizer=getRegularizer(r.kernelRegularizer),i}return __extends(t,e),t.prototype.build=function(e){e=getExactlyOneShape(e);var t="channelsFirst"===this.dataFormat?1:e.length-1;if(null==e[t])throw new ValueError("The channel dimension of the input should be defined. Found "+e[t]);var n,r=e[t],i=this.kernelSize.concat([r,this.filters]);this.kernel=this.addWeight("kernel",i,null,this.kernelInitializer,this.kernelRegularizer,!0,this.kernelConstraint),this.useBias&&(this.bias=this.addWeight("bias",[this.filters],null,this.biasInitializer,this.biasRegularizer,!0,this.biasConstraint)),this.inputSpec=[{ndim:this.rank+2,axes:(n={},n[t]=r,n)}],this.built=!0},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var t;e=getExactlyOneTensor(e);var r=null==n.bias?null:n.bias.read();if(1===n.rank)t=conv1dWithBias(e,n.kernel.read(),r,n.strides[0],n.padding,n.dataFormat,n.dilationRate[0]);else if(2===n.rank)t=conv2dWithBias(e,n.kernel.read(),r,n.strides,n.padding,n.dataFormat,n.dilationRate);else if(3===n.rank)throw new NotImplementedError("3D convolution is not implemented yet.");return null!=n.activation&&(t=n.activation.apply(t)),t})},t.prototype.computeOutputShape=function(e){e=getExactlyOneShape(e);for(var t=[],n="channelsLast"===this.dataFormat?e.slice(1,e.length-1):e.slice(2),r=0;r<n.length;++r){var i=convOutputLength(n[r],this.kernelSize[r],this.padding,this.strides[r],"number"==typeof this.dilationRate?this.dilationRate:this.dilationRate[r]);t.push(i)}var a=[e[0]];return"channelsLast"===this.dataFormat?(a=a.concat(t)).push(this.filters):(a.push(this.filters),a=a.concat(t)),a},t.prototype.getConfig=function(){var t={filters:this.filters,kernelInitializer:serializeInitializer(this.kernelInitializer),kernelRegularizer:serializeRegularizer(this.kernelRegularizer),kernelConstraint:serializeConstraint(this.kernelConstraint)},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.verifyConfig=function(e){if(!("filters"in e)||"number"!=typeof e.filters||e.filters<1)throw new ValueError("Convolution layer expected config.filters to be a 'number' > 0 but got "+JSON.stringify(e.filters))},t}(BaseConv),Conv2D=function(e){function t(n){var r=e.call(this,2,n)||this;return t.verifyConfig(n),r}return __extends(t,e),t.prototype.getConfig=function(){var t=e.prototype.getConfig.call(this);return delete t.rank,t},t.verifyConfig=function(e){if("number"!=typeof e.kernelSize&&!checkArrayTypeAndLength(e.kernelSize,"number",1,2))throw new ValueError("Conv2D expects config.kernelSize to be number or number[] with length 1 or 2, but received "+JSON.stringify(e.kernelSize)+".")},t.className="Conv2D",t}(Conv);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Conv2D);var Conv2DTranspose=function(e){function t(t){var n=e.call(this,t)||this;if(n.inputSpec=[new InputSpec({ndim:4})],"same"!==n.padding&&"valid"!==n.padding)throw new ValueError("Conv2DTranspose currently supports only padding modes 'same' and 'valid', but received padding mode "+n.padding);return n}return __extends(t,e),t.prototype.build=function(e){if(4!==(e=getExactlyOneShape(e)).length)throw new ValueError("Input should have rank 4; Received input shape: "+JSON.stringify(e));var t="channelsFirst"===this.dataFormat?1:e.length-1;if(null==e[t])throw new ValueError("The channel dimension of the inputs should be defined. Found `None`.");var n,r=e[t],i=this.kernelSize.concat([this.filters,r]);this.kernel=this.addWeight("kernel",i,"float32",this.kernelInitializer,this.kernelRegularizer,!0,this.kernelConstraint),this.useBias&&(this.bias=this.addWeight("bias",[this.filters],"float32",this.biasInitializer,this.biasRegularizer,!0,this.biasConstraint)),this.inputSpec=[new InputSpec({ndim:4,axes:(n={},n[t]=r,n)})],this.built=!0},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var t=getExactlyOneTensor(e);if(4!==t.shape.length)throw new ValueError("Conv2DTranspose.call() expects input tensor to be rank-4, but received a tensor of rank-"+t.shape.length);var r,i,a=t.shape,o=a[0];"channelsFirst"===n.dataFormat?(r=2,i=3):(r=1,i=2);var s=a[r],l=a[i],u=n.kernelSize[0],c=n.kernelSize[1],p=n.strides[0],h=n.strides[1],d=[o,deconvLength(s,p,u,n.padding),deconvLength(l,h,c,n.padding),n.filters];"channelsLast"!==n.dataFormat&&(t=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_83" /* transpose */])(t,[0,2,3,1]));var f=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["H" /* conv2dTranspose */])(t,n.kernel.read(),d,n.strides,n.padding);return"channelsLast"!==n.dataFormat&&(f=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_83" /* transpose */])(f,[0,3,1,2])),null!=n.bias&&(f=biasAdd(f,n.bias.read(),n.dataFormat)),null!=n.activation&&(f=n.activation.apply(f)),f})},t.prototype.computeOutputShape=function(e){var t,n,r,i=(e=getExactlyOneShape(e)).slice();"channelsFirst"===this.dataFormat?(t=1,n=2,r=3):(t=3,n=1,r=2);var a=this.kernelSize[0],o=this.kernelSize[1],s=this.strides[0],l=this.strides[1];return i[t]=this.filters,i[n]=deconvLength(i[n],s,a,this.padding),i[r]=deconvLength(i[r],l,o,this.padding),i},t.prototype.getConfig=function(){var t=e.prototype.getConfig.call(this);return delete t.dilationRate,t},t.className="Conv2DTranspose",t}(Conv2D);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Conv2DTranspose);var SeparableConv=function(e){function t(t,n){var r=e.call(this,t,n)||this;if(r.DEFAULT_DEPTHWISE_INITIALIZER="glorotUniform",r.DEFAULT_POINTWISE_INITIALIZER="glorotUniform",r.depthwiseKernel=null,r.pointwiseKernel=null,null==n.filters)throw new ValueError("The `filters` configuration field is required by SeparableConv, but is unspecified.");if(null!=n.kernelInitializer||null!=n.kernelRegularizer||null!=n.kernelConstraint)throw new ValueError("Fields kernelInitializer, kernelRegularizer and kernelConstraint are invalid for SeparableConv2D. Use depthwiseInitializer, depthwiseRegularizer, depthwiseConstraint, pointwiseInitializer, pointwiseRegularizer and pointwiseConstraint instead.");if(null!=n.padding&&"same"!==n.padding&&"valid"!==n.padding)throw new ValueError("SeparableConv"+r.rank+"D supports only padding modes: 'same' and 'valid', but received "+JSON.stringify(n.padding));return r.depthMultiplier=null==n.depthMultiplier?1:n.depthMultiplier,r.depthwiseInitializer=getInitializer(n.depthwiseInitializer||r.DEFAULT_DEPTHWISE_INITIALIZER),r.depthwiseRegularizer=getRegularizer(n.depthwiseRegularizer),r.depthwiseConstraint=getConstraint(n.depthwiseConstraint),r.pointwiseInitializer=getInitializer(n.depthwiseInitializer||r.DEFAULT_POINTWISE_INITIALIZER),r.pointwiseRegularizer=getRegularizer(n.pointwiseRegularizer),r.pointwiseConstraint=getConstraint(n.pointwiseConstraint),r}return __extends(t,e),t.prototype.build=function(e){if((e=getExactlyOneShape(e)).length<this.rank+2)throw new ValueError("Inputs to SeparableConv"+this.rank+"D should have rank "+(this.rank+2)+", but received input shape: "+JSON.stringify(e));var t="channelsFirst"===this.dataFormat?1:e.length-1;if(null==e[t]||e[t]<0)throw new ValueError("The channel dimension of the inputs should be defined, but found "+JSON.stringify(e[t]));for(var n=e[t],r=this.kernelSize.concat([n,this.depthMultiplier]),i=[],a=0;a<this.rank;++a)i.push(1);i.push(n*this.depthMultiplier,this.filters);var o;this.depthwiseKernel=this.addWeight("depthwise_kernel",r,"float32",this.depthwiseInitializer,this.depthwiseRegularizer,!0,this.depthwiseConstraint),this.pointwiseKernel=this.addWeight("pointwise_kernel",i,"float32",this.pointwiseInitializer,this.pointwiseRegularizer,!0,this.pointwiseConstraint),this.useBias?this.bias=this.addWeight("bias",[this.filters],"float32",this.biasInitializer,this.biasRegularizer,!0,this.biasConstraint):this.bias=null,this.inputSpec=[new InputSpec({ndim:this.rank+2,axes:(o={},o[t]=n,o)})],this.built=!0},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var t;if(e=getExactlyOneTensor(e),1===n.rank)throw new NotImplementedError("1D separable convolution is not implemented yet.");return 2===n.rank&&("channelsFirst"===n.dataFormat&&(e=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_83" /* transpose */])(e,[0,2,3,1])),t=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_49" /* separableConv2d */])(e,n.depthwiseKernel.read(),n.pointwiseKernel.read(),n.strides,n.padding,n.dilationRate,"NHWC")),n.useBias&&(t=biasAdd(t,n.bias.read(),n.dataFormat)),null!=n.activation&&(t=n.activation.apply(t)),"channelsFirst"===n.dataFormat&&(t=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_83" /* transpose */])(t,[0,3,1,2])),t})},t.prototype.getConfig=function(){var t=e.prototype.getConfig.call(this);return delete t.rank,delete t.kernelInitializer,delete t.kernelRegularizer,delete t.kernelConstraint,t.depthwiseInitializer=serializeInitializer(this.depthwiseInitializer),t.pointwiseInitializer=serializeInitializer(this.pointwiseInitializer),t.depthwiseRegularizer=serializeRegularizer(this.depthwiseRegularizer),t.pointwiseRegularizer=serializeRegularizer(this.pointwiseRegularizer),t.depthwiseConstraint=serializeConstraint(this.depthwiseConstraint),t.pointwiseConstraint=serializeConstraint(this.pointwiseConstraint),t},t.className="SeparableConv",t}(Conv),SeparableConv2D=function(e){function t(t){return e.call(this,2,t)||this}return __extends(t,e),t.className="SeparableConv2D",t}(SeparableConv);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(SeparableConv2D);var Conv1D=function(e){function t(n){var r=e.call(this,1,n)||this;return t.verifyConfig(n),r.inputSpec=[{ndim:3}],r}return __extends(t,e),t.prototype.getConfig=function(){var t=e.prototype.getConfig.call(this);return delete t.rank,delete t.dataFormat,t},t.verifyConfig=function(e){if("number"!=typeof e.kernelSize&&!checkArrayTypeAndLength(e.kernelSize,"number",1,1))throw new ValueError("Conv1D expects config.kernelSize to be number or number[] with length 1, but received "+JSON.stringify(e.kernelSize)+".")},t.className="Conv1D",t}(Conv);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Conv1D);var Cropping2D=function(e){function t(t){var n=e.call(this,t)||this;return"number"==typeof t.cropping?n.cropping=[[t.cropping,t.cropping],[t.cropping,t.cropping]]:"number"==typeof t.cropping[0]?n.cropping=[[t.cropping[0],t.cropping[0]],[t.cropping[1],t.cropping[1]]]:n.cropping=t.cropping,n.dataFormat=void 0===t.dataFormat?"channelsLast":t.dataFormat,n.inputSpec=[{ndim:4}],n}return __extends(t,e),t.prototype.computeOutputShape=function(e){return"channelsFirst"===this.dataFormat?[e[0],e[1],e[2]-this.cropping[0][0]-this.cropping[0][1],e[3]-this.cropping[1][0]-this.cropping[1][1]]:[e[0],e[1]-this.cropping[0][0]-this.cropping[0][1],e[2]-this.cropping[1][0]-this.cropping[1][1],e[3]]},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){return e=getExactlyOneTensor(e),"channelsLast"===n.dataFormat?sliceAlongAxis(sliceAlongAxis(e,n.cropping[0][0],e.shape[1]-n.cropping[0][0]-n.cropping[0][1],2),n.cropping[1][0],e.shape[2]-n.cropping[1][1]-n.cropping[1][0],3):sliceAlongAxis(sliceAlongAxis(e,n.cropping[0][0],e.shape[2]-n.cropping[0][0]-n.cropping[0][1],3),n.cropping[1][0],e.shape[3]-n.cropping[1][1]-n.cropping[1][0],4)})},t.prototype.getConfig=function(){var t={cropping:this.cropping,dataFormat:this.dataFormat},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.className="Cropping2D",t}(Layer);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Cropping2D);var UpSampling2D=function(e){function t(t){var n=e.call(this,t)||this;return n.DEFAULT_SIZE=[2,2],n.inputSpec=[{ndim:4}],n.size=null==t.size?n.DEFAULT_SIZE:t.size,n.dataFormat=null==t.dataFormat?"channelsLast":t.dataFormat,n}return __extends(t,e),t.prototype.computeOutputShape=function(e){if("channelsFirst"===this.dataFormat){var t=null==e[2]?null:this.size[0]*e[2],n=null==e[3]?null:this.size[1]*e[3];return[e[0],e[1],t,n]}t=null==e[1]?null:this.size[0]*e[1],n=null==e[2]?null:this.size[1]*e[2];return[e[0],t,n,e[3]]},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var t=getExactlyOneTensor(e),r=t.shape;if("channelsFirst"===n.dataFormat){t=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_83" /* transpose */])(t,[0,2,3,1]);var i=n.size[0]*r[2],a=n.size[1]*r[3],o=t.resizeNearestNeighbor([i,a]);return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_83" /* transpose */])(o,[0,3,1,2])}i=n.size[0]*r[1],a=n.size[1]*r[2];return t.resizeNearestNeighbor([i,a])})},t.prototype.getConfig=function(){var t={size:this.size,dataFormat:this.dataFormat},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.className="UpSampling2D",t}(Layer);function depthwiseConv2d$1(e,t,n,r,i,a){return void 0===n&&(n=[1,1]),void 0===r&&(r="valid"),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){null==i&&(i=imageDataFormat()),checkDataFormat(i);var o=preprocessConv2DInput(e,i);if(4!==e.rank)throw new ValueError("Input for depthwiseConv2d is required to be 4-D, but is instead "+e.rank+"-D");if(4!==t.rank)throw new ValueError("depthwiseKernel is required to be 4-D, but is instead "+t.rank+"-D");return o=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["L" /* depthwiseConv2d */])(o,t,n,"same"===r?"same":"valid","NHWC",a),"channelsFirst"===i&&(o=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_83" /* transpose */])(o,[0,3,1,2])),o})}__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(UpSampling2D);var DepthwiseConv2D=function(e){function t(t){var n=e.call(this,2,t)||this;return n.depthwiseKernel=null,n.depthMultiplier=null==t.depthMultiplier?1:t.depthMultiplier,n.depthwiseInitializer=getInitializer(t.depthwiseInitializer||n.DEFAULT_KERNEL_INITIALIZER),n.depthwiseConstraint=getConstraint(t.depthwiseConstraint),n.depthwiseRegularizer=getRegularizer(t.depthwiseRegularizer),n}return __extends(t,e),t.prototype.build=function(e){if((e=getExactlyOneShape(e)).length<4)throw new ValueError("Inputs to DepthwiseConv2D should have rank 4. Received input shape: "+JSON.stringify(e)+".");var t="channelsFirst"===this.dataFormat?1:3;if(null==e[t]||e[t]<0)throw new ValueError("The channel dimension of the inputs to DepthwiseConv2D should be defined, but is not ("+e[t]+").");var n=e[t],r=[this.kernelSize[0],this.kernelSize[1],n,this.depthMultiplier];this.depthwiseKernel=this.addWeight("depthwise_kernel",r,null,this.depthwiseInitializer,this.depthwiseRegularizer,!0,this.depthwiseConstraint),this.useBias?this.bias=this.addWeight("bias",[n*this.depthMultiplier],null,this.biasInitializer,this.biasRegularizer,!0,this.biasConstraint):this.bias=null,this.built=!0},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var t=depthwiseConv2d$1(e=getExactlyOneTensor(e),n.depthwiseKernel.read(),n.strides,n.padding,n.dataFormat,null);return n.useBias&&(t=biasAdd(t,n.bias.read(),n.dataFormat)),null!=n.activation&&(t=n.activation.apply(t)),t})},t.prototype.computeOutputShape=function(e){e=getExactlyOneShape(e);var t="channelsFirst"===this.dataFormat?e[2]:e[1],n="channelsFirst"===this.dataFormat?e[3]:e[2],r="channelsFirst"===this.dataFormat?e[1]*this.depthMultiplier:e[3]*this.depthMultiplier,i=convOutputLength(t,this.kernelSize[0],this.padding,this.strides[0]),a=convOutputLength(n,this.kernelSize[1],this.padding,this.strides[1]);return"channelsFirst"===this.dataFormat?[e[0],r,i,a]:[e[0],i,a,r]},t.prototype.getConfig=function(){var t=e.prototype.getConfig.call(this);return t.depthMultiplier=this.depthMultiplier,t.depthwiseInitializer=serializeInitializer(this.depthwiseInitializer),t.depthwiseRegularizer=serializeRegularizer(this.depthwiseRegularizer),t.depthwiseConstraint=serializeConstraint(this.depthwiseRegularizer),t},t.className="DepthwiseConv2D",t}(BaseConv);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(DepthwiseConv2D);var Dropout=function(e){function t(t){var n=e.call(this,t)||this;if(n.rate=Math.max(Math.min(t.rate,1),0),n.rateScalar=getScalar(n.rate),n.noiseShape=t.noiseShape,n.seed=t.seed,null!=n.seed)throw new NotImplementedError("Non-default seed is not implemented in Dropout layer yet: "+n.seed);return n.supportsMasking=!0,n}return __extends(t,e),t.prototype.getNoiseShape=function(e){if(null==this.noiseShape)return this.noiseShape;for(var t=e.shape,n=[],r=0;r<this.noiseShape.length;++r)n.push(null==this.noiseShape[r]?t[r]:this.noiseShape[r]);return n},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){n.invokeCallHook(e,t);var r=getExactlyOneTensor(e);if(null!=n.noiseShape&&!__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].arraysEqual(r.shape,n.noiseShape))throw new NotImplementedError("Non-default noise shape is not implemented in Dropout layer yet: "+JSON.stringify(n.noiseShape));if(0<n.rate&&n.rate<1){var i=null!=t.training&&t.training,a=n.getNoiseShape(r);return inTrainPhase(function(){return dropout(r,n.rateScalar,a,n.seed)},function(){return r},i)}return e})},t.prototype.getConfig=function(){var t={rate:this.rate,noiseShape:this.noiseShape,seed:this.seed},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.className="Dropout",t}(Layer);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Dropout);var Dense=function(e){function t(t){var n=e.call(this,t)||this;if(n.activation=null,n.useBias=!0,n.kernel=null,n.bias=null,n.DEFAULT_KERNEL_INITIALIZER="glorotNormal",n.DEFAULT_BIAS_INITIALIZER="zeros",null==t.batchInputShape&&null==t.inputShape&&null!=t.inputDim){var r=null;null!=t.batchSize&&(r=t.batchSize),n.batchInputShape=[r,t.inputDim]}return n.units=t.units,n.activation=getActivation(t.activation),null!=t.useBias&&(n.useBias=t.useBias),n.kernelInitializer=getInitializer(t.kernelInitializer||n.DEFAULT_KERNEL_INITIALIZER),n.biasInitializer=getInitializer(t.biasInitializer||n.DEFAULT_BIAS_INITIALIZER),n.kernelConstraint=getConstraint(t.kernelConstraint),n.biasConstraint=getConstraint(t.biasConstraint),n.kernelRegularizer=getRegularizer(t.kernelRegularizer),n.biasRegularizer=getRegularizer(t.biasRegularizer),n.activityRegularizer=getRegularizer(t.activityRegularizer),n.inputSpec=[{minNDim:2}],n}return __extends(t,e),t.prototype.build=function(e){var t,n=(e=getExactlyOneShape(e))[e.length-1];null==this.kernel&&(this.kernel=this.addWeight("kernel",[n,this.units],null,this.kernelInitializer,this.kernelRegularizer,!0,this.kernelConstraint),this.useBias&&(this.bias=this.addWeight("bias",[this.units],null,this.biasInitializer,this.biasRegularizer,!0,this.biasConstraint))),this.inputSpec=[{minNDim:2,axes:(t={},t[-1]=n,t)}],this.built=!0},t.prototype.computeOutputShape=function(e){var t=(e=getExactlyOneShape(e)).slice();return t[t.length-1]=this.units,t},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){n.invokeCallHook(e,t);var r=dot(getExactlyOneTensor(e),n.kernel.read());return null!=n.bias&&(r=biasAdd(r,n.bias.read())),null!=n.activation&&(r=n.activation.apply(r)),r})},t.prototype.getConfig=function(){var t={units:this.units,activation:serializeActivation(this.activation),useBias:this.useBias,kernelInitializer:serializeInitializer(this.kernelInitializer),biasInitializer:serializeInitializer(this.biasInitializer),kernelRegularizer:serializeRegularizer(this.kernelRegularizer),biasRegularizer:serializeRegularizer(this.biasRegularizer),activityRegularizer:serializeRegularizer(this.activityRegularizer),kernelConstraint:serializeConstraint(this.kernelConstraint),biasConstraint:serializeConstraint(this.biasConstraint)},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.className="Dense",t}(Layer);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Dense);var Flatten=function(e){function t(t){var n=e.call(this,t||{})||this;return n.inputSpec=[{minNDim:3}],n}return __extends(t,e),t.prototype.computeOutputShape=function(e){for(var t=0,n=(e=getExactlyOneShape(e)).slice(1);t<n.length;t++){if(null==n[t])throw new ValueError('The shape of the input to "Flatten" is not fully defined (got '+e.slice(1)+'). Make sure to pass a complete "input_shape" or "batch_input_shape" argument to the first layer in your model.')}return[e[0],arrayProd(e,1)]},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){return n.invokeCallHook(e,t),batchFlatten(getExactlyOneTensor(e))})},t.className="Flatten",t}(Layer);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Flatten);var Activation$1=function(e){function t(t){var n=e.call(this,t)||this;return n.supportsMasking=!0,n.activation=getActivation(t.activation),n}return __extends(t,e),t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){n.invokeCallHook(e,t);var r=getExactlyOneTensor(e);return n.activation.apply(r)})},t.prototype.getConfig=function(){var t={activation:serializeActivation(this.activation)},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.className="Activation",t}(Layer);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Activation$1);var RepeatVector=function(e){function t(t){var n=e.call(this,t)||this;return n.n=t.n,n.inputSpec=[{ndim:2}],n}return __extends(t,e),t.prototype.computeOutputShape=function(e){return[e[0],this.n,e[1]]},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){return repeat(e=getExactlyOneTensor(e),n.n)})},t.prototype.getConfig=function(){var t={n:this.n},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.className="RepeatVector",t}(Layer);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(RepeatVector);var Reshape=function(e){function t(t){var n=e.call(this,t)||this;n.targetShape=t.targetShape;for(var r=0;r<n.targetShape.length;++r)n.isUnknown(n.targetShape[r])&&(n.targetShape[r]=null);return n}return __extends(t,e),t.prototype.isUnknown=function(e){return e<0||null==e},t.prototype.fixUnknownDimension=function(e,t){for(var n="Total size of new array must be unchanged.",r=t.slice(),i=1,a=null,o=0;o<r.length;++o){var s=r[o];if(this.isUnknown(s)){if(null!==a)throw new ValueError("Can only specifiy one unknown dimension.");a=o}else i*=s}var l=arrayProd(e);if(null!==a){if(0===i||l%i!=0)throw new ValueError(n);r[a]=l/i}else if(l!==i)throw new ValueError(n);return r},t.prototype.computeOutputShape=function(e){for(var t=!1,n=0;n<e.length;++n)if(this.isUnknown(e[n])){t=!0;break}return t?e.slice(0,1).concat(this.targetShape):e.slice(0,1).concat(this.fixUnknownDimension(e.slice(1),this.targetShape))},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){n.invokeCallHook(e,t);var r=getExactlyOneTensor(e),i=r.shape,a=i.slice(0,1).concat(n.fixUnknownDimension(i.slice(1),n.targetShape));return r.reshape(a)})},t.prototype.getConfig=function(){var t={targetShape:this.targetShape},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.className="Reshape",t}(Layer);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Reshape);var Permute=function(e){function t(t){var n=e.call(this,t)||this;if(null==t.dims)throw new Error("Required configuration field `dims` is missing during Permute constructor call.");if(!Array.isArray(t.dims))throw new Error("Permute constructor requires `dims` to be an Array, but received "+t.dims+" instead.");var r=range(1,t.dims.length+1);if(!__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].arraysEqual(t.dims.slice().sort(),r))throw new Error("Invalid permutation `dims`: "+JSON.stringify(t.dims)+" `dims` must contain consecutive integers starting from 1.");return n.dims=t.dims,n.dimsIncludingBatch=[0].concat(n.dims),n.inputSpec=[new InputSpec({ndim:n.dims.length+1})],n}return __extends(t,e),t.prototype.computeOutputShape=function(e){var t=(e=getExactlyOneShape(e)).slice();return this.dims.forEach(function(n,r){t[r+1]=e[n]}),t},t.prototype.call=function(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_83" /* transpose */])(getExactlyOneTensor(e),this.dimsIncludingBatch)},t.prototype.getConfig=function(){var t={dims:this.dims},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.className="Permute",t}(Layer);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Permute);var Embedding=function(e){function t(t){var n=e.call(this,t)||this;if(n.embeddings=null,n.DEFAULT_EMBEDDINGS_INITIALIZER="randomUniform",null==t.batchInputShape&&null==t.inputShape){var r=null;null!=t.batchSize&&(r=t.batchSize),null==t.inputLength?n.batchInputShape=[r,null]:n.batchInputShape=[r].concat(toList(t.inputLength))}return n.inputDim=t.inputDim,n.outputDim=t.outputDim,n.embeddingsInitializer=getInitializer(t.embeddingsInitializer||n.DEFAULT_EMBEDDINGS_INITIALIZER),n.embeddingsRegularizer=getRegularizer(t.embeddingsRegularizer),n.activityRegularizer=getRegularizer(t.activityRegularizer),n.embeddingsConstraint=getConstraint(t.embeddingsConstraint),n.maskZero=t.maskZero,n.inputLength=t.inputLength,n}return __extends(t,e),t.prototype.build=function(e){this.embeddings=this.addWeight("embeddings",[this.inputDim,this.outputDim],this.dtype,this.embeddingsInitializer,this.embeddingsRegularizer,!0,this.embeddingsConstraint),this.built=!0},t.prototype.warnOnIncompatibleInputShape=function(e){},t.prototype.computeMask=function(e,t){throw new NotImplementedError("computeMask has not been implemented for Embedding yet")},t.prototype.computeOutputShape=function(e){if(e=getExactlyOneShape(e),null==this.inputLength)return e.concat([this.outputDim]);var t=toList(this.inputLength);if(t.length!==e.length-1)throw new ValueError('"inputLength" is '+this.inputLength+", but received input shape has shape "+e);for(var n=0,r=0;r<t.length;++r){var i=t[r],a=e[r+1];if(null!=i&&null!=a&&i!==a)throw new ValueError('"inputLength" is '+this.inputLength+", but received input shape has shape "+e);null==i&&(t[n]=a),n++}return[e[0]].concat(t,[this.outputDim])},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){n.invokeCallHook(e,t);var r=getExactlyOneTensor(e);return"int32"!==r.dtype&&(r=cast$1(r,"int32")),gather$1(n.embeddings.read(),r.as1D()).reshape(getExactlyOneShape(n.computeOutputShape(r.shape)))})},t.prototype.getConfig=function(){var t={inputDim:this.inputDim,outputDim:this.outputDim,embeddingsInitializer:serializeInitializer(this.embeddingsInitializer),embeddingsRegularizer:serializeRegularizer(this.embeddingsRegularizer),activityRegularizer:serializeRegularizer(this.activityRegularizer),embeddingsConstraint:serializeConstraint(this.embeddingsConstraint),maskZero:this.maskZero,inputLength:this.inputLength},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.className="Embedding",t}(Layer);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Embedding);var Merge=function(e){function t(t){var n=e.call(this,t||{})||this;return n.supportsMasking=!0,n}return __extends(t,e),t.prototype.mergeFunction=function(e){throw new NotImplementedError},t.prototype.computeElementwiseOpOutputShape=function(e,t){if(null==e||null==t)return null;if(e.length<t.length)return this.computeElementwiseOpOutputShape(t,e);if(0===t.length)return e;for(var n=e.slice(0,e.length-t.length),r=0;r<t.length;++r){var i=e[e.length-t.length+r],a=t[r];if(null==i||null==a||i<0||a<0)n.push(null);else if(1===i)n.push(a);else if(1===a)n.push(i);else{if(i!==a)throw new ValueError("Operands could not be broadcast together with shapes "+JSON.stringify(e)+" "+JSON.stringify(t));n.push(i)}}return n},t.prototype.build=function(e){if(Array.isArray(e)&&!Array.isArray(e[0])&&(e=[getExactlyOneShape(e)]),(e=e).length<2)throw new ValueError("A merge layer should be called on an Array of at least 2 inputs. Got "+e.length+" input(s).");for(var t=[],n=0,r=e;n<r.length;n++){null!=(o=r[n])&&null!==o[0]&&t.push(o[0])}if((t=unique(t)).length>1)throw new ValueError("Can not merge tensors with different batch sizes. Got tensors with shapes: "+JSON.stringify(e)+".");for(var i=null==e[0]?null:e[0].slice(1),a=1;a<e.length;++a){var o=null==e[a]?null:e[a].slice(1);i=this.computeElementwiseOpOutputShape(i,o)}var s=e.map(function(e){return e.length});-1===e.indexOf(null)&&1===unique(s).length?this.reshapeRequired=!1:this.reshapeRequired=!0},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){if(e=e,n.reshapeRequired){var t=[],r=e.map(function(e){return e.rank});if(-1===r.indexOf(null)){for(var i=max$1(r),a=0,o=e;a<o.length;a++){for(var s=(h=o[a]).rank,l=0;l<i-s;++l)h=expandDims(h,1);t.push(h)}return n.mergeFunction(t)}for(var u=!1,c=0,p=e;c<p.length;c++){var h;if(null==(s=(h=p[c]).rank)){var d=h.shape,f=d[0],g=d.slice(1).concat([f]),m=h.reshape([f].concat(arrayProd(d.slice(1))));m=(m=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_83" /* transpose */])(m,[1,0])).reshape(g),t.push(m),u=!0}else if(s>1){var y=range(1,s).concat([0]);t.push(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_83" /* transpose */])(h,y)),u=!0}else t.push(h)}var v=n.mergeFunction(t),b=v.rank;if(u)if(null==b){var w=v.shape;g=[f=w[w.length-1]].concat(w.slice(0,w.length-1));v=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_83" /* transpose */])(v.reshape([-1,f]),[1,0]).reshape(g)}else if(b>1){y=[b-1].concat(range(0,b-1));v=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_83" /* transpose */])(v,y)}return v}return n.mergeFunction(e)})},t.prototype.computeOutputShape=function(e){var t;t=null==(e=e)[0]?null:e[0].slice(1);for(var n=1;n<e.length;++n){var r=null==e[n]?null:e[n].slice(1);t=this.computeElementwiseOpOutputShape(t,r)}for(var i=[],a=0,o=e;a<o.length;a++){null!=(r=o[a])&&null!==r[0]&&i.push(r[0])}return t=1===(i=unique(i)).length?i.concat(t):[null].concat(t)},t.prototype.computeMask=function(e,t){throw new NotImplementedError("computeMask has not been implemented for Merge yet")},t}(Layer),Add=function(e){function t(t){return e.call(this,t)||this}return __extends(t,e),t.prototype.mergeFunction=function(e){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){for(var t=e[0].clone(),n=1;n<e.length;++n)t=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(t,e[n]);return t})},t.className="Add",t}(Merge);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Add);var Multiply=function(e){function t(t){return e.call(this,t)||this}return __extends(t,e),t.prototype.mergeFunction=function(e){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){for(var t=e[0].clone(),n=1;n<e.length;++n)t=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(t,e[n]);return t})},t.className="Multiply",t}(Merge);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Multiply);var Average=function(e){function t(t){return e.call(this,t)||this}return __extends(t,e),t.prototype.mergeFunction=function(e){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){for(var t=e[0].clone(),n=1;n<e.length;++n)t=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(t,e[n]);return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(getScalar(1/e.length),t)})},t.className="Average",t}(Merge);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Average);var Maximum=function(e){function t(t){return e.call(this,t)||this}return __extends(t,e),t.prototype.mergeFunction=function(e){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){for(var t=e[0],n=1;n<e.length;++n)t=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_20" /* maximum */])(t,e[n]);return t})},t.className="Maximum",t}(Merge);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Maximum);var Minimum=function(e){function t(t){return e.call(this,t)||this}return __extends(t,e),t.prototype.mergeFunction=function(e){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){for(var t=e[0],n=1;n<e.length;++n)t=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_23" /* minimum */])(t,e[n]);return t})},t.className="Minimum",t}(Merge);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Minimum);var Concatenate=function(e){function t(t){var n=e.call(this,t)||this;return n.DEFAULT_AXIS=-1,null==t&&(t={}),n.axis=null==t.axis?n.DEFAULT_AXIS:t.axis,n.supportsMasking=!0,n.reshapeRequired=!1,n}return __extends(t,e),t.prototype.build=function(e){if(!Array.isArray(e)||!Array.isArray(e[0])||1===e.length)throw new ValueError("A `Concatenate` layer should be called on a list of at least 2 inputs");for(var t=!0,n=0,r=e=e;n<r.length;n++){if(null!=(c=r[n])){t=!1;break}}if(!t){for(var i=[],a=0;a<e.length;++a){var o=e[a].slice();o.splice(this.axis,1);for(var s=!1,l=0,u=i;l<u.length;l++){var c=u[l];if(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].arraysEqual(c,o)){s=!0;break}}s||i.push(o)}if(i.length>1)throw new ValueError("A `Concatenate` layer requires inputs with matching shapes except for the concat axis. Got input shapes: "+JSON.stringify(e))}},t.prototype.mergeFunction=function(e){var t=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){return concatenate(e,t.axis)})},t.prototype.computeOutputShape=function(e){if(!Array.isArray(e)||!Array.isArray(e[0]))throw new ValueError("A `Concatenate` layer should be called on a list of inputs.");for(var t=e,n=t[0].slice(),r=this.axis<0?n.length+this.axis:this.axis,i=0,a=t.slice(1);i<a.length;i++){var o=a[i];if(null==n[r]||null==o[r]){n[r]=null;break}n[r]+=o[r]}return n},t.prototype.computeMask=function(e,t){throw new NotImplementedError("computeMask has not been implemented for Concatenate yet")},t.prototype.getConfig=function(){var t={axis:this.axis},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.className="Concatenate",t}(Merge);function interpretAxis(e,t){for(;e<0;)e+=t;return e}function batchDot(e,t,n){if(e.shape.length>3||t.shape.length>3)throw new NotImplementedError("batchDot is not implemented for tensors of 4D or higher rank yet");if(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].assert(e.shape.length>=2,"batchDot requires the rank of x to be >= 2, but got "+e.shape.length),__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].assert(e.shape.length>=2,"batchDot requires the rank of y to be >= 2, but got "+t.shape.length),"number"==typeof n&&(n=[n,n]),"complex64"===e.dtype||"complex64"===t.dtype)throw new NotImplementedError("batchDot is not implemented for complex64-type Tensors yet.");var r=e.shape.length,i=t.shape.length;null==n&&(n=[r-1,i-2]);var a=n;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n,o;if(r>i){n=r-i;for(var s=[],l=0;l<n;++l)s.push(1);t=t.reshape(t.shape.concat(s))}else if(i>r){n=i-r;for(s=[],l=0;l<n;++l)s.push(1);e=e.reshape(e.shape.concat(s))}else n=0;if(2===e.shape.length&&2===t.shape.length)o=a[0]===a[1]?e.mulStrict(t).sum(a[0]):e.transpose([1,0]).mulStrict(t).sum(a[1]);else{var u=a[0]!==e.shape.length-1||null,c=a[1]===t.shape.length-1||null;o=e.matMul(t,u,c)}if(n>0){var p=void 0,h=[];for(l=p=r>i?r+i-3:r-1;l<p+n;++l)h.push(l);o=o.squeeze(h)}return 1===o.shape.length&&(o=o.expandDims(1)),o})}__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Concatenate);var Dot=function(e){function t(t){var n=e.call(this,t)||this;return n.axes=t.axes,n.normalize=null!=t.normalize&&t.normalize,n.supportsMasking=!0,n.reshapeRequired=!1,n}return __extends(t,e),t.prototype.build=function(e){__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].assert(Array.isArray(e)&&2===e.length&&Array.isArray(e[0])&&Array.isArray(e[1]),"A `Dot` layer should be called on a list of exactly 2 inputs.");var t=e[0],n=e[1];if(t.length>3||n.length>3)throw new NotImplementedError("Dot layer does not support tensors of 4D or higher rank yet.");var r=this.interpretAxes(t,n);if(t[r[0]]!==n[r[1]])throw new ValueError("Dimension incompatibility: "+t[r[0]]+" !== "+n[r[1]])},t.prototype.mergeFunction=function(e){if(2!==e.length)throw new ValueError("A `Dot` layer must be called on exactly 2 inputs, but received "+e.length+" input(s).");var t,n=e[0],r=e[1];return t=Array.isArray(this.axes)?this.axes.map(function(t,n){return interpretAxis(t,e[n].shape.length)}):[interpretAxis(this.axes,n.shape.length),interpretAxis(this.axes,r.shape.length)],this.normalize&&(n=l2Normalize(n,t[0]),r=l2Normalize(r,t[1])),batchDot(n,r,t)},t.prototype.interpretAxes=function(e,t){return Array.isArray(this.axes)?this.axes:[interpretAxis(this.axes,e.length),interpretAxis(this.axes,t.length)]},t.prototype.computeOutputShape=function(e){__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].assert(Array.isArray(e)&&2===e.length&&Array.isArray(e[0])&&Array.isArray(e[1]),"A `Dot` layer should be called on a list of exactly 2 inputs.");var t=e[0].slice(),n=e[1].slice();if(t.length>3||n.length>3)throw new NotImplementedError("Dot layer does not support tensors of 4D or higher rank yet.");var r=this.interpretAxes(t,n);t.splice(r[0],1),n.splice(r[1],1),n.splice(0,1);var i=t.concat(n);return 1===i.length&&i.push(1),i},t.prototype.computeMask=function(e,t){throw new NotImplementedError("computeMask has not been implemented for Dot yet")},t.prototype.getConfig=function(){var t={axes:this.axes,normalize:this.normalize},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.className="Dot",t}(Merge);function batchNormalization(e,t,n,r,i,a){var o;if(void 0===a&&(a=.001),2===e.rank)o=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["t" /* batchNormalization2d */])(e,t,n,a,i,r);else if(3===e.rank)o=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["u" /* batchNormalization3d */])(e,t,n,a,i,r);else{if(4!==e.rank)throw new NotImplementedError("batchNormalization is not implemented for array of rank "+e.rank+" yet");o=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["v" /* batchNormalization4d */])(e,t,n,a,i,r)}return o}function regularNormalizeBatchInTraining(e,t,n,r,i){return void 0===i&&(i=.001),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var a=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_25" /* moments */])(e,r),o=a.mean,s=a.variance;return[batchNormalization(e,o,s,n,t,i),o,s]})}function broadcastNormalizeBatchInTraining(e,t,n,r,i){return void 0===i&&(i=.001),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){for(var a=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_25" /* moments */])(e,r),o=a.mean,s=a.variance,l=[],u=0,c=range(0,e.rank);u<c.length;u++){var p=c[u];-1!==r.indexOf(p)?l.push(1):l.push(e.shape[p])}var h=o.reshape(l),d=s.reshape(l),f=null==t?null:t.reshape(l),g=null==n?null:n.reshape(l);return[batchNormalization(e,h,d,g,f,i),o,s]})}function normalizeBatchInTraining(e,t,n,r,i){return void 0===i&&(i=.001),__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].arraysEqual(r.slice().sort(),range(0,e.rank-1))?regularNormalizeBatchInTraining(e,t,n,r,i):broadcastNormalizeBatchInTraining(e,t,n,r,i)}__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Dot);var BatchNormalization=function(e){function t(t){var n=this;return null==t&&(t={}),(n=e.call(this,t)||this).supportsMasking=!0,n.axis=null==t.axis?-1:t.axis,n.momentum=null==t.momentum?.99:t.momentum,n.epsilon=null==t.epsilon?.001:t.epsilon,n.center=null==t.center||t.center,n.scale=null==t.scale||t.scale,n.betaInitializer=getInitializer(t.betaInitializer||"zeros"),n.gammaInitializer=getInitializer(t.gammaInitializer||"ones"),n.movingMeanInitializer=getInitializer(t.movingMeanInitializer||"zeros"),n.movingVarianceInitializer=getInitializer(t.movingVarianceInitializer||"ones"),n.betaConstraint=getConstraint(t.betaConstraint),n.gammaConstraint=getConstraint(t.gammaConstraint),n.betaRegularizer=getRegularizer(t.betaRegularizer),n.gammaRegularizer=getRegularizer(t.gammaRegularizer),n.stepCount=0,n}return __extends(t,e),t.prototype.build=function(e){e=getExactlyOneShape(e);var t=this.axis>=0?this.axis:this.axis+e.length,n=e[t];if(null==n)throw new ValueError("Axis "+t+" of input tensor should have a defined dimension but the layer received an input with shape "+JSON.stringify(e)+".");this.inputSpec=[new InputSpec({ndim:e.length,axes:(r={},r[t]=n,r)})];var r,i=[n];this.scale&&(this.gamma=this.addWeight("gamma",i,null,this.gammaInitializer,this.gammaRegularizer,!0,this.gammaConstraint)),this.center&&(this.beta=this.addWeight("beta",i,null,this.betaInitializer,this.betaRegularizer,!0,this.betaConstraint)),this.movingMean=this.addWeight("moving_mean",i,null,this.movingMeanInitializer,null,!1),this.movingVariance=this.addWeight("moving_variance",i,null,this.movingVarianceInitializer,null,!1),this.built=!0},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var r=null!=t.training&&t.training,i=getExactlyOneTensor(e),a=i.shape,o=a.length,s=range(0,o),l=n.axis>=0?n.axis:n.axis+o;s.splice(l,1);var u=pyListRepeat(1,o);u[l]=a[l];var c=s.slice();c.sort();var p=!__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].arraysEqual(c,range(0,o).slice(0,o-1));if(!r)return function(){if(p){var e=n.movingMean.read().reshape(u),t=n.movingVariance.read().reshape(u),r=n.center?n.beta.read().reshape(u):null,a=n.scale?n.gamma.read().reshape(u):null;return batchNormalization(i,e,t,r,a,n.epsilon)}return batchNormalization(i,n.movingMean.read(),n.movingVariance.read(),null==n.beta?null:n.beta.read(),null==n.gamma?null:n.gamma.read(),n.epsilon)}();var h=normalizeBatchInTraining(i,n.gamma.read(),n.beta.read(),s,n.epsilon),d=h[0],f=h[1],g=h[2],m=arrayProd(s.map(function(e){return i.shape[e]})),y=g.mul(getScalar(m/(m-(1+n.epsilon))));return function(){n.stepCount++;var e=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_26" /* movingAverage */])(n.movingMean.read(),f,n.momentum,n.stepCount);n.movingMean.write(e);var t=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_26" /* movingAverage */])(n.movingVariance.read(),y,n.momentum,n.stepCount);n.movingVariance.write(t)}(),d})},t.prototype.getConfig=function(){var t={axis:this.axis,momentum:this.momentum,epsilon:this.epsilon,center:this.center,scale:this.scale,betaInitializer:serializeInitializer(this.betaInitializer),gammaInitializer:serializeInitializer(this.gammaInitializer),movingMeanInitializer:serializeInitializer(this.movingMeanInitializer),movingVarianceInitializer:serializeInitializer(this.movingVarianceInitializer),betaRegularizer:serializeRegularizer(this.betaRegularizer),gammaRegularizer:serializeRegularizer(this.gammaRegularizer),betaConstraint:serializeConstraint(this.betaConstraint),gammaConstraint:serializeConstraint(this.gammaConstraint)},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.className="BatchNormalization",t}(Layer);function spatial2dPadding(e,t,n){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){if(4!==e.rank)throw new ValueError("temporalPadding expects input tensor to be 4-D, but received a "+e.rank+"-D tensor.");if(null==t&&(t=[[1,1],[1,1]]),2!==t.length||2!==t[0].length||2!==t[1].length)throw new ValueError("spatial2dPadding expects `padding` to be an Array of two Arrays, each of which is an Array of two integers.");if(null==n&&(n=imageDataFormat()),"channelsLast"!==n&&"channelsFirst"!==n)throw new ValueError("Unknown data format: "+n+". Supported data formats are 'channelsLast' and 'channelsFirst.");var r;return r="channelsFirst"===n?[[0,0],[0,0],t[0],t[1]]:[[0,0],t[0],t[1],[0,0]],Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_35" /* pad */])(e,r)})}__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(BatchNormalization);var ZeroPadding2D=function(e){function t(t){var n=this;if(null==t&&(t={}),(n=e.call(this,t)||this).dataFormat=null==t.dataFormat?imageDataFormat():t.dataFormat,null==t.padding)n.padding=[[1,1],[1,1]];else if("number"==typeof t.padding)n.padding=[[t.padding,t.padding],[t.padding,t.padding]];else{if(t.padding=t.padding,2!==t.padding.length)throw new ValueError("ZeroPadding2D expects padding to be a length-2 array, but received a length-"+t.padding.length+" array.");var r=void 0,i=void 0;if("number"==typeof t.padding[0])r=[t.padding[0],t.padding[0]],i=[t.padding[1],t.padding[1]];else{if(t.padding=t.padding,2!==t.padding[0].length)throw new ValueError("ZeroPadding2D expects height padding to be a length-2 array, but received a length-"+t.padding[0].length+" array.");if(r=t.padding[0],2!==t.padding[1].length)throw new ValueError("ZeroPadding2D expects width padding to be a length-2 array, but received a length-"+t.padding[1].length+" array.");i=t.padding[1]}n.padding=[r,i]}return n.inputSpec=[new InputSpec({ndim:4})],n}return __extends(t,e),t.prototype.computeOutputShape=function(e){var t,n;return e=getExactlyOneShape(e),"channelsFirst"===this.dataFormat?(t=null!=e[2]&&e[2]>=0?e[2]+this.padding[0][0]+this.padding[0][1]:null,n=null!=e[3]&&e[3]>=0?e[3]+this.padding[1][0]+this.padding[1][1]:null,[e[0],e[1],t,n]):(t=null!=e[1]&&e[1]>=0?e[1]+this.padding[0][0]+this.padding[0][1]:null,n=null!=e[2]&&e[2]>=0?e[2]+this.padding[1][0]+this.padding[1][1]:null,[e[0],t,n,e[3]])},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){return spatial2dPadding(getExactlyOneTensor(e),n.padding,n.dataFormat)})},t.prototype.getConfig=function(){var t={padding:this.padding,dataFormat:this.dataFormat},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.className="ZeroPadding2D",t}(Layer);function pool2d(e,t,n,r,i,a){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var o;checkDataFormat(i),checkPoolMode(a),checkPaddingMode(r),null==n&&(n=[1,1]),null==r&&(r="valid"),null==i&&(i=imageDataFormat()),null==a&&(a="max"),e=preprocessConv2DInput(e,i);var s="same"===r?"same":"valid";return o="max"===a?Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_19" /* maxPool */])(e,t,n,s):Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["r" /* avgPool */])(e,t,n,s),"channelsFirst"===i&&(o=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_83" /* transpose */])(o,[0,3,1,2])),o})}__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(ZeroPadding2D);var Pooling1D=function(e){function t(t){var n=this;if(null==t.poolSize&&(t.poolSize=2),n=e.call(this,t)||this,"number"==typeof t.poolSize)n.poolSize=[t.poolSize];else{if(!Array.isArray(t.poolSize)||1!==t.poolSize.length||"number"!=typeof t.poolSize[0])throw new ValueError("poolSize for 1D convolutional layer must be a number or an Array of a single number, but received "+JSON.stringify(t.poolSize));n.poolSize=t.poolSize}if(null==t.strides)n.strides=n.poolSize;else if("number"==typeof t.strides)n.strides=[t.strides];else{if(!Array.isArray(t.strides)||1!==t.strides.length||"number"!=typeof t.strides[0])throw new ValueError("strides for 1D convolutional layer must be a number or an Array of a single number, but received "+JSON.stringify(t.strides));n.strides=t.strides}return n.padding=null==t.padding?"valid":t.padding,checkPaddingMode(n.padding),n.inputSpec=[new InputSpec({ndim:3})],n}return __extends(t,e),t.prototype.computeOutputShape=function(e){var t=convOutputLength((e=getExactlyOneShape(e))[1],this.poolSize[0],this.padding,this.strides[0]);return[e[0],t,e[2]]},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){n.invokeCallHook(e,t),e=expandDims(getExactlyOneTensor(e),2);var r=n.poolingFunction(getExactlyOneTensor(e),[n.poolSize[0],1],[n.strides[0],1],n.padding,"channelsLast");return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_69" /* squeeze */])(r,[2])})},t.prototype.getConfig=function(){var t={poolSize:this.poolSize,padding:this.padding,strides:this.strides},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t}(Layer),MaxPooling1D=function(e){function t(t){return e.call(this,t)||this}return __extends(t,e),t.prototype.poolingFunction=function(e,t,n,r,i){return checkDataFormat(i),checkPaddingMode(r),pool2d(e,t,n,r,i,"max")},t.className="MaxPooling1D",t}(Pooling1D);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(MaxPooling1D);var AveragePooling1D=function(e){function t(t){return e.call(this,t)||this}return __extends(t,e),t.prototype.poolingFunction=function(e,t,n,r,i){return checkDataFormat(i),checkPaddingMode(r),pool2d(e,t,n,r,i,"avg")},t.className="AveragePooling1D",t}(Pooling1D);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(AveragePooling1D);var Pooling2D=function(e){function t(t){var n=this;if(null==t.poolSize&&(t.poolSize=[2,2]),(n=e.call(this,t)||this).poolSize=Array.isArray(t.poolSize)?t.poolSize:[t.poolSize,t.poolSize],null==t.strides)n.strides=n.poolSize;else if(Array.isArray(t.strides)){if(2!==t.strides.length)throw new ValueError("If the strides property of a 2D pooling layer is an Array, it is expected to have a length of 2, but received length "+t.strides.length+".");n.strides=t.strides}else n.strides=[t.strides,t.strides];return n.padding=null==t.padding?"valid":t.padding,n.dataFormat=null==t.dataFormat?"channelsLast":t.dataFormat,checkDataFormat(n.dataFormat),checkPaddingMode(n.padding),n.inputSpec=[new InputSpec({ndim:4})],n}return __extends(t,e),t.prototype.computeOutputShape=function(e){e=getExactlyOneShape(e);var t="channelsFirst"===this.dataFormat?e[2]:e[1],n="channelsFirst"===this.dataFormat?e[3]:e[2];return t=convOutputLength(t,this.poolSize[0],this.padding,this.strides[0]),n=convOutputLength(n,this.poolSize[1],this.padding,this.strides[1]),"channelsFirst"===this.dataFormat?[e[0],e[1],t,n]:[e[0],t,n,e[3]]},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){return n.invokeCallHook(e,t),n.poolingFunction(getExactlyOneTensor(e),n.poolSize,n.strides,n.padding,n.dataFormat)})},t.prototype.getConfig=function(){var t={poolSize:this.poolSize,padding:this.padding,strides:this.strides,dataFormat:this.dataFormat},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t}(Layer),MaxPooling2D=function(e){function t(t){return e.call(this,t)||this}return __extends(t,e),t.prototype.poolingFunction=function(e,t,n,r,i){return checkDataFormat(i),checkPaddingMode(r),pool2d(e,t,n,r,i,"max")},t.className="MaxPooling2D",t}(Pooling2D);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(MaxPooling2D);var AveragePooling2D=function(e){function t(t){return e.call(this,t)||this}return __extends(t,e),t.prototype.poolingFunction=function(e,t,n,r,i){return checkDataFormat(i),checkPaddingMode(r),pool2d(e,t,n,r,i,"avg")},t.className="AveragePooling2D",t}(Pooling2D);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(AveragePooling2D);var GlobalPooling1D=function(e){function t(t){var n=e.call(this,t)||this;return n.inputSpec=[new InputSpec({ndim:3})],n}return __extends(t,e),t.prototype.computeOutputShape=function(e){return[e[0],e[2]]},t.prototype.call=function(e,t){throw new NotImplementedError},t}(Layer),GlobalAveragePooling1D=function(e){function t(t){return e.call(this,t)||this}return __extends(t,e),t.prototype.call=function(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var t=getExactlyOneTensor(e);return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_21" /* mean */])(t,1)})},t.className="GlobalAveragePooling1D",t}(GlobalPooling1D);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(GlobalAveragePooling1D);var GlobalMaxPooling1D=function(e){function t(t){return e.call(this,t)||this}return __extends(t,e),t.prototype.call=function(e,t){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var t=getExactlyOneTensor(e);return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_18" /* max */])(t,1)})},t.className="GlobalMaxPooling1D",t}(GlobalPooling1D);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(GlobalMaxPooling1D);var GlobalPooling2D=function(e){function t(t){var n=e.call(this,t)||this;return n.dataFormat=null==t.dataFormat?"channelsLast":t.dataFormat,checkDataFormat(n.dataFormat),n.inputSpec=[new InputSpec({ndim:4})],n}return __extends(t,e),t.prototype.computeOutputShape=function(e){return e=e,"channelsLast"===this.dataFormat?[e[0],e[3]]:[e[0],e[1]]},t.prototype.call=function(e,t){throw new NotImplementedError},t.prototype.getConfig=function(){var t={dataFormat:this.dataFormat},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t}(Layer),GlobalAveragePooling2D=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var t=getExactlyOneTensor(e);return"channelsLast"===n.dataFormat?Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_21" /* mean */])(t,[1,2]):Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_21" /* mean */])(t,[2,3])})},t.className="GlobalAveragePooling2D",t}(GlobalPooling2D);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(GlobalAveragePooling2D);var GlobalMaxPooling2D=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var t=getExactlyOneTensor(e);return"channelsLast"===n.dataFormat?Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_18" /* max */])(t,[1,2]):Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_18" /* max */])(t,[2,3])})},t.className="GlobalMaxPooling2D",t}(GlobalPooling2D);function standardizeArgs(e,t,n,r){if(Array.isArray(e)){if(null!=t||null!=n)throw new ValueError("When inputs is an array, neither initialState or constants should be provided");null!=r&&(n=e.slice(e.length-r,e.length),e=e.slice(0,e.length-r)),e.length>1&&(t=e.slice(1,e.length)),e=e[0]}function i(e){return null==e||Array.isArray(e)?e:[e]}return{inputs:e,initialState:t=i(t),constants:n=i(n)}}function rnn(e,t,n,r,i,a,o,s){void 0===r&&(r=!1),void 0===o&&(o=!1),void 0===s&&(s=!1);var l=t.shape.length;if(l<3)throw new ValueError("Input should be at least 3D, but is "+l+"D.");var u,c,p=[1,0].concat(range(2,l));if(t=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_83" /* transpose */])(t,p),null!=i)throw new NotImplementedError("The rnn() function of the deeplearn.js backend does not support masking yet.");if(null!=a)throw new NotImplementedError("The rnn() functoin of the deeplearn.js backend does not support constants yet.");o&&console.warn("Backend rnn(): the unroll = true option is not applicable to the imperative deeplearn.js backend."),r&&(t=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_44" /* reverse */])(t,0));for(var h=n,d=t.shape[0],f=function(n){var r=sliceAlongFirstAxis(t,n,1);r=r.reshape(r.shape.slice(1));var i=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){return e(r,h)});if(c=i[0],s)if(0===n)u=c.expandDims(1);else{var a=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["A" /* concat */])([u,c.expandDims(1)],1);u.dispose(),u=a}h=i[1]},g=0;g<d;++g)f(g);return[c,u,h]}__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(GlobalMaxPooling2D);var RNN=function(e){function t(t){var n,r=e.call(this,t)||this;if(null==t.cell)throw new ValueError("cell property is missing for the constructor of RNN.");if(null==(n=Array.isArray(t.cell)?new StackedRNNCells({cells:t.cell}):t.cell).stateSize)throw new ValueError("The RNN cell should have an attribute `stateSize` (tuple of integers, one integer per RNN state).");return r.cell=n,r.returnSequences=null!=t.returnSequences&&t.returnSequences,r.returnState=null!=t.returnState&&t.returnState,r.goBackwards=null!=t.goBackwards&&t.goBackwards,r._stateful=null!=t.stateful&&t.stateful,r.unroll=null!=t.unroll&&t.unroll,r.supportsMasking=!0,r.inputSpec=[new InputSpec({ndim:3})],r.stateSpec=null,r.states=null,r.numConstants=null,r.keptStates=[],r}return __extends(t,e),t.prototype.getStates=function(){return null==this.states?range(0,Array.isArray(this.cell.stateSize)?this.cell.stateSize.length:1).map(function(e){return null}):this.states},t.prototype.setStates=function(e){this.states=e},t.prototype.computeOutputShape=function(e){isArrayOfShapes(e)&&(e=e[0]),e=e;var t=this.cell.stateSize;Array.isArray(t)||(t=[t]);var n,r=t[0];if(n=this.returnSequences?[e[0],e[1],r]:[e[0],r],this.returnState){for(var i=[],a=0,o=t;a<o.length;a++){var s=o[a];i.push([e[0],s])}return[n].concat(i)}return n},t.prototype.computeMask=function(e,t){throw new NotImplementedError("computeMask has not been implemented for RNN yet")},t.prototype.build=function(e){if(null!=this.numConstants)throw new NotImplementedError("Constants support is not implemented in RNN yet.");isArrayOfShapes(e)&&(e=e[0]),e=e;var t=this.stateful?e[0]:null,n=e[e.length-1];this.inputSpec[0]=new InputSpec({shape:[t,null,n]});var r,i=[e[0]].concat(e.slice(2));if(this.cell.build(i),r=Array.isArray(this.cell.stateSize)?this.cell.stateSize:[this.cell.stateSize],null!=this.stateSpec){if(!__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].arraysEqual(this.stateSpec.map(function(e){return e.shape[e.shape.length-1]}),r))throw new ValueError("An initialState was passed that is not compatible with cell.stateSize. Received stateSpec="+this.stateSpec+"; However cell.stateSize is "+this.cell.stateSize)}else this.stateSpec=r.map(function(e){return new InputSpec({shape:[null,e]})});this.stateful&&this.resetStates()},t.prototype.resetStates=function(e,t){var n=this;void 0===t&&(t=!1),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){if(!n.stateful)throw new AttributeError("Cannot call resetStates() on an RNN Layer that is not stateful.");var r=n.inputSpec[0].shape[0];if(null==r)throw new ValueError("If an RNN is stateful, it needs to know its batch size. Specify the batch size of your input tensors: \n- If using a Sequential model, specify the batch size by passing a `batchInputShape` option to your first layer.\n- If using the functional API, specify the batch size by passing a `batchShape` option to your Input layer.");if(null==n.states)Array.isArray(n.cell.stateSize)?n.states=n.cell.stateSize.map(function(e){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_91" /* zeros */])([r,e])}):n.states=[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_91" /* zeros */])([r,n.cell.stateSize])];else if(null==e)Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["M" /* dispose */])(n.states),null!=n.keptStates&&(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["M" /* dispose */])(n.keptStates),n.keptStates=[]),Array.isArray(n.cell.stateSize)?n.states=n.cell.stateSize.map(function(e){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_91" /* zeros */])([r,e])}):n.states[0]=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_91" /* zeros */])([r,n.cell.stateSize]);else{if(Array.isArray(e)||(e=[e]),e.length!==n.states.length)throw new ValueError("Layer "+n.name+" expects "+n.states.length+" state(s), but it received "+e.length+" state value(s). Input received: "+e);!0===t?n.keptStates.push(n.states.slice()):Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["M" /* dispose */])(n.states);for(var i=0;i<n.states.length;++i){var a=e[i],o=Array.isArray(n.cell.stateSize)?n.cell.stateSize[i]:n.cell.stateSize,s=[r,o];if(!__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].arraysEqual(a.shape,s))throw new ValueError("State "+i+" is incompatible with layer "+n.name+": expected shape="+s+", received shape="+a.shape);n.states[i]=a}}n.states.forEach(function(e){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_4" /* keep */])(e)})})},t.prototype.apply=function(t,n){var r=null==n?null:n.initialState,i=null==n?null:n.constants;null==n&&(n={});var a=standardizeArgs(t,r,i,this.numConstants);t=a.inputs,r=a.initialState,i=a.constants;var o=[],s=[];if(null!=r){n.initialState=r,o=o.concat(r),this.stateSpec=[];for(var l=0,u=r;l<u.length;l++){var c=u[l];this.stateSpec.push(new InputSpec({shape:c.shape}))}s=s.concat(this.stateSpec)}if(null!=i&&(n.constants=i,o=o.concat(i),this.numConstants=i.length),o[0]instanceof SymbolicTensor){var p=[t].concat(o),h=this.inputSpec.concat(s),d=this.inputSpec;this.inputSpec=h;var f=e.prototype.apply.call(this,p,n);return this.inputSpec=d,f}return e.prototype.apply.call(this,t,n)},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var r=null==t?null:t.mask,i=null==t?null:t.training,a=null==t?null:t.initialState;if(e=getExactlyOneTensor(e),null==a&&(a=n.stateful?n.states:n.getInitialState(e)),null!=r)throw new NotImplementedError("Masking is not implemented for RNN yet");var o=Array.isArray(n.cell.stateSize)?n.cell.stateSize.length:1;if(a.length!==o)throw new ValueError("RNN Layer has "+o+" state(s) but was passed "+a.length+" initial state(s).");n.unroll&&console.warn("Ignoring unroll = true for RNN layer, due to imperative backend.");var s={training:i},l=rnn(function(e,t){var r=n.cell.call([e].concat(t),s);return[r[0],r.slice(1)]},e,a,n.goBackwards,null,null,n.unroll,n.returnSequences),u=l[0],c=l[1],p=l[2];n.stateful&&n.resetStates(p,i);var h=n.returnSequences?c:u;return n.returnState?[h].concat(p):h})},t.prototype.getInitialState=function(e){var t=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var n=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_91" /* zeros */])(e.shape);return n=expandDims(n=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_74" /* sum */])(n,[1,2])),Array.isArray(t.cell.stateSize)?t.cell.stateSize.map(function(e){return e>1?tile$1(n,[1,e]):n}):t.cell.stateSize>1?[tile$1(n,[1,t.cell.stateSize])]:[n]})},Object.defineProperty(t.prototype,"trainableWeights",{get:function(){return this.trainable?this.cell.trainableWeights:[]},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"nonTrainableWeights",{get:function(){return this.trainable?this.cell.nonTrainableWeights:this.cell.weights},enumerable:!0,configurable:!0}),t.prototype.getConfig=function(){var t={returnSequences:this.returnSequences,returnState:this.returnState,goBackwards:this.goBackwards,stateful:this.stateful,unroll:this.unroll};null!=this.numConstants&&(t.numConstants=this.numConstants);var n=this.cell.getConfig();t.cell={className:this.cell.getClassName(),config:n};var r=e.prototype.getConfig.call(this);return Object.assign(t,r),t},t.className="RNN",t}(Layer);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(RNN);var RNNCell=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t}(Layer),SimpleRNNCell=function(e){function t(t){var n=e.call(this,t)||this;return n.DEFAULT_ACTIVATION="tanh",n.DEFAULT_KERNEL_INITIALIZER="glorotNormal",n.DEFAULT_RECURRENT_INITIALIZER="orthogonal",n.DEFAULT_BIAS_INITIALIZER="zeros",n.units=t.units,n.activation=getActivation(null==t.activation?n.DEFAULT_ACTIVATION:t.activation),n.useBias=null==t.useBias||t.useBias,n.kernelInitializer=getInitializer(t.kernelInitializer||n.DEFAULT_KERNEL_INITIALIZER),n.recurrentInitializer=getInitializer(t.recurrentInitializer||n.DEFAULT_RECURRENT_INITIALIZER),n.biasInitializer=getInitializer(t.biasInitializer||n.DEFAULT_BIAS_INITIALIZER),n.kernelRegularizer=getRegularizer(t.kernelRegularizer),n.recurrentRegularizer=getRegularizer(t.recurrentRegularizer),n.biasRegularizer=getRegularizer(t.biasRegularizer),n.kernelConstraint=getConstraint(t.kernelConstraint),n.recurrentConstraint=getConstraint(t.recurrentConstraint),n.biasConstraint=getConstraint(t.biasConstraint),n.dropout=min$1([1,max$1([0,null==t.dropout?0:t.dropout])]),n.recurrentDropout=min$1([1,max$1([0,null==t.recurrentDropout?0:t.recurrentDropout])]),n.stateSize=n.units,n.dropoutMask=null,n.recurrentDropoutMask=null,n}return __extends(t,e),t.prototype.build=function(e){e=getExactlyOneShape(e),this.kernel=this.addWeight("kernel",[e[e.length-1],this.units],null,this.kernelInitializer,this.kernelRegularizer,!0,this.kernelConstraint),this.recurrentKernel=this.addWeight("recurrent_kernel",[this.units,this.units],null,this.recurrentInitializer,this.recurrentRegularizer,!0,this.recurrentConstraint),this.useBias?this.bias=this.addWeight("bias",[this.units],null,this.biasInitializer,this.biasRegularizer,!0,this.biasConstraint):this.bias=null,this.built=!0},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){if(2!==(e=e).length)throw new ValueError("SimpleRNNCell expects 2 input Tensors, got "+e.length+".");var r=e[1];e=e[0];var i,a=null!=t.training&&t.training;0<n.dropout&&n.dropout<1&&null==n.dropoutMask&&(n.dropoutMask=generateDropoutMask(function(){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_34" /* onesLike */])(e)},n.dropout,a)),0<n.recurrentDropout&&n.recurrentDropout<1&&null==n.recurrentDropoutMask&&(n.recurrentDropoutMask=generateDropoutMask(function(){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_34" /* onesLike */])(r)},n.recurrentDropout,a));var o=n.dropoutMask,s=n.recurrentDropoutMask;i=dot(null!=o?Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(e,o):e,n.kernel.read()),null!=n.bias&&(i=biasAdd(i,n.bias.read())),null!=s&&(r=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(r,s));var l=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(i,dot(r,n.recurrentKernel.read()));return null!=n.activation&&(l=n.activation.apply(l)),[l,l]})},t.prototype.getConfig=function(){var t={units:this.units,activation:serializeActivation(this.activation),useBias:this.useBias,kernelInitializer:serializeInitializer(this.kernelInitializer),recurrentInitializer:serializeInitializer(this.recurrentInitializer),biasInitializer:serializeInitializer(this.biasInitializer),kernelRegularizer:serializeRegularizer(this.kernelRegularizer),recurrentRegularizer:serializeRegularizer(this.recurrentRegularizer),biasRegularizer:serializeRegularizer(this.biasRegularizer),activityRegularizer:serializeRegularizer(this.activityRegularizer),kernelConstraint:serializeConstraint(this.kernelConstraint),recurrentConstraint:serializeConstraint(this.recurrentConstraint),biasConstraint:serializeConstraint(this.biasConstraint),dropout:this.dropout,recurrentDropout:this.recurrentDropout},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.className="SimpleRNNCell",t}(RNNCell);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(SimpleRNNCell);var SimpleRNN=function(e){function t(t){return t.cell=new SimpleRNNCell(t),e.call(this,t)||this}return __extends(t,e),t.prototype.call=function(t,n){var r=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){null!=r.cell.dropoutMask&&(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["M" /* dispose */])(r.cell.dropoutMask),r.cell.dropoutMask=null),null!=r.cell.recurrentDropoutMask&&(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["M" /* dispose */])(r.cell.recurrentDropoutMask),r.cell.recurrentDropoutMask=null);var i=null==n?null:n.mask,a=null==n?null:n.training,o=null==n?null:n.initialState;return e.prototype.call.call(r,t,{mask:i,training:a,initialState:o})})},Object.defineProperty(t.prototype,"units",{get:function(){return this.cell.units},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"activation",{get:function(){return this.cell.activation},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"useBias",{get:function(){return this.cell.useBias},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"kernelInitializer",{get:function(){return this.cell.kernelInitializer},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"recurrentInitializer",{get:function(){return this.cell.recurrentInitializer},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"biasInitializer",{get:function(){return this.cell.biasInitializer},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"kernelRegularizer",{get:function(){return this.cell.kernelRegularizer},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"recurrentRegularizer",{get:function(){return this.cell.recurrentRegularizer},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"biasRegularizer",{get:function(){return this.cell.biasRegularizer},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"kernelConstraint",{get:function(){return this.cell.kernelConstraint},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"recurrentConstraint",{get:function(){return this.cell.recurrentConstraint},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"biasConstraint",{get:function(){return this.cell.biasConstraint},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"dropout",{get:function(){return this.cell.dropout},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"recurrentDropout",{get:function(){return this.cell.recurrentDropout},enumerable:!0,configurable:!0}),t.prototype.getConfig=function(){var t={units:this.units,activation:serializeActivation(this.activation),useBias:this.useBias,kernelInitializer:serializeInitializer(this.kernelInitializer),recurrentInitializer:serializeInitializer(this.recurrentInitializer),biasInitializer:serializeInitializer(this.biasInitializer),kernelRegularizer:serializeRegularizer(this.kernelRegularizer),recurrentRegularizer:serializeRegularizer(this.recurrentRegularizer),biasRegularizer:serializeRegularizer(this.biasRegularizer),activityRegularizer:serializeRegularizer(this.activityRegularizer),kernelConstraint:serializeConstraint(this.kernelConstraint),recurrentConstraint:serializeConstraint(this.recurrentConstraint),biasConstraint:serializeConstraint(this.biasConstraint),dropout:this.dropout,recurrentDropout:this.recurrentDropout},n=e.prototype.getConfig.call(this);return delete n.cell,Object.assign(t,n),t},t.className="SimpleRNN",t}(RNN);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(SimpleRNN);var GRUCell=function(e){function t(t){var n=e.call(this,t)||this;return n.DEFAULT_ACTIVATION="tanh",n.DEFAULT_RECURRENT_ACTIVATION="hardSigmoid",n.DEFAULT_KERNEL_INITIALIZER="glorotNormal",n.DEFAULT_RECURRENT_INITIALIZER="orthogonal",n.DEFAULT_BIAS_INITIALIZER="zeros",n.units=t.units,n.activation=getActivation(void 0===t.activation?n.DEFAULT_ACTIVATION:t.activation),n.recurrentActivation=getActivation(void 0===t.recurrentActivation?n.DEFAULT_RECURRENT_ACTIVATION:t.recurrentActivation),n.useBias=null==t.useBias||t.useBias,n.kernelInitializer=getInitializer(t.kernelInitializer||n.DEFAULT_KERNEL_INITIALIZER),n.recurrentInitializer=getInitializer(t.recurrentInitializer||n.DEFAULT_RECURRENT_INITIALIZER),n.biasInitializer=getInitializer(t.biasInitializer||n.DEFAULT_BIAS_INITIALIZER),n.kernelRegularizer=getRegularizer(t.kernelRegularizer),n.recurrentRegularizer=getRegularizer(t.recurrentRegularizer),n.biasRegularizer=getRegularizer(t.biasRegularizer),n.kernelConstraint=getConstraint(t.kernelConstraint),n.recurrentConstraint=getConstraint(t.recurrentConstraint),n.biasConstraint=getConstraint(t.biasConstraint),n.dropout=min$1([1,max$1([0,null==t.dropout?0:t.dropout])]),n.recurrentDropout=min$1([1,max$1([0,null==t.recurrentDropout?0:t.recurrentDropout])]),n.implementation=t.implementation,n.stateSize=n.units,n.dropoutMask=null,n.recurrentDropoutMask=null,n}return __extends(t,e),t.prototype.build=function(e){var t=(e=getExactlyOneShape(e))[e.length-1];this.kernel=this.addWeight("kernel",[t,3*this.units],null,this.kernelInitializer,this.kernelRegularizer,!0,this.kernelConstraint),this.recurrentKernel=this.addWeight("recurrent_kernel",[this.units,3*this.units],null,this.recurrentInitializer,this.recurrentRegularizer,!0,this.recurrentConstraint),this.useBias?this.bias=this.addWeight("bias",[3*this.units],null,this.biasInitializer,this.biasRegularizer,!0,this.biasConstraint):this.bias=null,this.built=!0},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){if(2!==(e=e).length)throw new ValueError("GRUCell expects 2 input Tensors (inputs, h, c), got "+e.length+".");var r=null!=t.training&&t.training,i=e[1];e=e[0],0<n.dropout&&n.dropout<1&&null==n.dropoutMask&&(n.dropoutMask=generateDropoutMask(function(){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_34" /* onesLike */])(e)},n.dropout,r,3)),0<n.recurrentDropout&&n.recurrentDropout<1&&null==n.recurrentDropoutMask&&(n.recurrentDropoutMask=generateDropoutMask(function(){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_34" /* onesLike */])(i)},n.recurrentDropout,r,3));var a,o,s,l=n.dropoutMask,u=n.recurrentDropoutMask;0<n.dropout&&n.dropout<1&&(e=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(e,l[0]));var c=dot(e,n.kernel.read());n.useBias&&(c=biasAdd(c,n.bias.read())),0<n.recurrentDropout&&n.recurrentDropout<1&&(i=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(i,u[0]));var p=n.recurrentKernel.read(),h=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_65" /* split */])(p,[2*n.units,n.units],p.rank-1),d=h[0],f=h[1],g=dot(i,d),m=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_65" /* split */])(c,3,c.rank-1),y=m[0],v=m[1],b=m[2],w=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_65" /* split */])(g,2,g.rank-1),z=w[0],S=w[1];a=n.recurrentActivation.apply(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(y,z)),o=n.recurrentActivation.apply(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(v,S));var I=dot(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(o,i),f);s=n.activation.apply(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(b,I));var N=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(a,i),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(getScalar(1),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_29" /* neg */])(a)),s));return[N,N]})},t.prototype.getConfig=function(){var t={units:this.units,activation:serializeActivation(this.activation),recurrentActivation:serializeActivation(this.recurrentActivation),useBias:this.useBias,kernelInitializer:serializeInitializer(this.kernelInitializer),recurrentInitializer:serializeInitializer(this.recurrentInitializer),biasInitializer:serializeInitializer(this.biasInitializer),kernelRegularizer:serializeRegularizer(this.kernelRegularizer),recurrentRegularizer:serializeRegularizer(this.recurrentRegularizer),biasRegularizer:serializeRegularizer(this.biasRegularizer),activityRegularizer:serializeRegularizer(this.activityRegularizer),kernelConstraint:serializeConstraint(this.kernelConstraint),recurrentConstraint:serializeConstraint(this.recurrentConstraint),biasConstraint:serializeConstraint(this.biasConstraint),dropout:this.dropout,recurrentDropout:this.recurrentDropout,implementation:this.implementation},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.className="GRUCell",t}(RNNCell);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(GRUCell);var GRU=function(e){function t(t){return 0===t.implementation&&console.warn("`implementation=0` has been deprecated, and now defaults to `implementation=1`. Please update your layer call."),t.cell=new GRUCell(t),e.call(this,t)||this}return __extends(t,e),t.prototype.call=function(t,n){var r=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){null!=r.cell.dropoutMask&&(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["M" /* dispose */])(r.cell.dropoutMask),r.cell.dropoutMask=null),null!=r.cell.recurrentDropoutMask&&(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["M" /* dispose */])(r.cell.recurrentDropoutMask),r.cell.recurrentDropoutMask=null);var i=null==n?null:n.mask,a=null==n?null:n.training,o=null==n?null:n.initialState;return e.prototype.call.call(r,t,{mask:i,training:a,initialState:o})})},Object.defineProperty(t.prototype,"units",{get:function(){return this.cell.units},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"activation",{get:function(){return this.cell.activation},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"recurrentActivation",{get:function(){return this.cell.recurrentActivation},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"useBias",{get:function(){return this.cell.useBias},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"kernelInitializer",{get:function(){return this.cell.kernelInitializer},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"recurrentInitializer",{get:function(){return this.cell.recurrentInitializer},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"biasInitializer",{get:function(){return this.cell.biasInitializer},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"kernelRegularizer",{get:function(){return this.cell.kernelRegularizer},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"recurrentRegularizer",{get:function(){return this.cell.recurrentRegularizer},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"biasRegularizer",{get:function(){return this.cell.biasRegularizer},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"kernelConstraint",{get:function(){return this.cell.kernelConstraint},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"recurrentConstraint",{get:function(){return this.cell.recurrentConstraint},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"biasConstraint",{get:function(){return this.cell.biasConstraint},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"dropout",{get:function(){return this.cell.dropout},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"recurrentDropout",{get:function(){return this.cell.recurrentDropout},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"implementation",{get:function(){return this.cell.implementation},enumerable:!0,configurable:!0}),t.prototype.getConfig=function(){var t={units:this.units,activation:serializeActivation(this.activation),recurrentActivation:serializeActivation(this.recurrentActivation),useBias:this.useBias,kernelInitializer:serializeInitializer(this.kernelInitializer),recurrentInitializer:serializeInitializer(this.recurrentInitializer),biasInitializer:serializeInitializer(this.biasInitializer),kernelRegularizer:serializeRegularizer(this.kernelRegularizer),recurrentRegularizer:serializeRegularizer(this.recurrentRegularizer),biasRegularizer:serializeRegularizer(this.biasRegularizer),activityRegularizer:serializeRegularizer(this.activityRegularizer),kernelConstraint:serializeConstraint(this.kernelConstraint),recurrentConstraint:serializeConstraint(this.recurrentConstraint),biasConstraint:serializeConstraint(this.biasConstraint),dropout:this.dropout,recurrentDropout:this.recurrentDropout,implementation:this.implementation},n=e.prototype.getConfig.call(this);return delete n.cell,Object.assign(t,n),t},t.fromConfig=function(e,t){return 0===t.implmentation&&(t.implementation=1),new e(t)},t.className="GRU",t}(RNN);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(GRU);var LSTMCell=function(e){function t(t){var n=e.call(this,t)||this;return n.DEFAULT_ACTIVATION="tanh",n.DEFAULT_RECURRENT_ACTIVATION="hardSigmoid",n.DEFAULT_KERNEL_INITIALIZER="glorotNormal",n.DEFAULT_RECURRENT_INITIALIZER="orthogonal",n.DEFAULT_BIAS_INITIALIZER="zeros",n.units=t.units,n.activation=getActivation(void 0===t.activation?n.DEFAULT_ACTIVATION:t.activation),n.recurrentActivation=getActivation(void 0===t.recurrentActivation?n.DEFAULT_RECURRENT_ACTIVATION:t.recurrentActivation),n.useBias=null==t.useBias||t.useBias,n.kernelInitializer=getInitializer(t.kernelInitializer||n.DEFAULT_KERNEL_INITIALIZER),n.recurrentInitializer=getInitializer(t.recurrentInitializer||n.DEFAULT_RECURRENT_INITIALIZER),n.biasInitializer=getInitializer(t.biasInitializer||n.DEFAULT_BIAS_INITIALIZER),n.unitForgetBias=t.unitForgetBias,n.kernelRegularizer=getRegularizer(t.kernelRegularizer),n.recurrentRegularizer=getRegularizer(t.recurrentRegularizer),n.biasRegularizer=getRegularizer(t.biasRegularizer),n.kernelConstraint=getConstraint(t.kernelConstraint),n.recurrentConstraint=getConstraint(t.recurrentConstraint),n.biasConstraint=getConstraint(t.biasConstraint),n.dropout=min$1([1,max$1([0,null==t.dropout?0:t.dropout])]),n.recurrentDropout=min$1([1,max$1([0,null==t.recurrentDropout?0:t.recurrentDropout])]),n.implementation=t.implementation,n.stateSize=[n.units,n.units],n.dropoutMask=null,n.recurrentDropoutMask=null,n}return __extends(t,e),t.prototype.build=function(e){var t,n,r=(e=getExactlyOneShape(e))[e.length-1];if(this.kernel=this.addWeight("kernel",[r,4*this.units],null,this.kernelInitializer,this.kernelRegularizer,!0,this.kernelConstraint),this.recurrentKernel=this.addWeight("recurrent_kernel",[this.units,4*this.units],null,this.recurrentInitializer,this.recurrentRegularizer,!0,this.recurrentConstraint),this.useBias){if(this.unitForgetBias){var i=this.biasInitializer,a=this.units;t=new((n=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return __extends(t,e),t.prototype.apply=function(e,t){var n=i.apply([a]),r=(new Ones).apply([a]),o=i.apply([2*a]);return concatAlongFirstAxis(concatAlongFirstAxis(n,r),o)},t}(Initializer)).className="CustomInit",n)}else t=this.biasInitializer;this.bias=this.addWeight("bias",[4*this.units],null,t,this.biasRegularizer,!0,this.biasConstraint)}else this.bias=null;this.built=!0},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var r=null!=t.training&&t.training;if(3!==(e=e).length)throw new ValueError("LSTMCell expects 3 input Tensors (inputs, h, c), got "+e.length+".");var i=e[1],a=e[2];e=e[0],0<n.dropout&&n.dropout<1&&null==n.dropoutMask&&(n.dropoutMask=generateDropoutMask(function(){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_34" /* onesLike */])(e)},n.dropout,r,4)),0<n.recurrentDropout&&n.recurrentDropout<1&&null==n.recurrentDropoutMask&&(n.recurrentDropoutMask=generateDropoutMask(function(){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_34" /* onesLike */])(i)},n.recurrentDropout,r,4));var o,s,l,u,c=n.dropoutMask,p=n.recurrentDropoutMask;0<n.dropout&&n.dropout<1&&(e=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(e,c[0]));var h=dot(e,n.kernel.read());0<n.recurrentDropout&&n.recurrentDropout<1&&(i=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(i,p[0])),h=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(h,dot(i,n.recurrentKernel.read())),n.useBias&&(h=biasAdd(h,n.bias.read()));var d=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_65" /* split */])(h,4,h.rank-1),f=d[0],g=d[1],m=d[2],y=d[3];o=n.recurrentActivation.apply(f),s=n.recurrentActivation.apply(g),l=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(s,a),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(o,n.activation.apply(m))),u=n.recurrentActivation.apply(y);var v=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(u,n.activation.apply(l));return[v,v,l]})},t.prototype.getConfig=function(){var t={units:this.units,activation:serializeActivation(this.activation),recurrentActivation:serializeActivation(this.recurrentActivation),useBias:this.useBias,kernelInitializer:serializeInitializer(this.kernelInitializer),recurrentInitializer:serializeInitializer(this.recurrentInitializer),biasInitializer:serializeInitializer(this.biasInitializer),unitForgetBias:this.unitForgetBias,kernelRegularizer:serializeRegularizer(this.kernelRegularizer),recurrentRegularizer:serializeRegularizer(this.recurrentRegularizer),biasRegularizer:serializeRegularizer(this.biasRegularizer),activityRegularizer:serializeRegularizer(this.activityRegularizer),kernelConstraint:serializeConstraint(this.kernelConstraint),recurrentConstraint:serializeConstraint(this.recurrentConstraint),biasConstraint:serializeConstraint(this.biasConstraint),dropout:this.dropout,recurrentDropout:this.recurrentDropout,implementation:this.implementation},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.className="LSTMCell",t}(RNNCell);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(LSTMCell);var LSTM=function(e){function t(t){return 0===t.implementation&&console.warn("`implementation=0` has been deprecated, and now defaults to `implementation=1`. Please update your layer call."),t.cell=new LSTMCell(t),e.call(this,t)||this}return __extends(t,e),t.prototype.call=function(t,n){var r=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){null!=r.cell.dropoutMask&&(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["M" /* dispose */])(r.cell.dropoutMask),r.cell.dropoutMask=null),null!=r.cell.recurrentDropoutMask&&(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["M" /* dispose */])(r.cell.recurrentDropoutMask),r.cell.recurrentDropoutMask=null);var i=null==n?null:n.mask,a=null==n?null:n.training,o=null==n?null:n.initialState;return e.prototype.call.call(r,t,{mask:i,training:a,initialState:o})})},Object.defineProperty(t.prototype,"units",{get:function(){return this.cell.units},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"activation",{get:function(){return this.cell.activation},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"recurrentActivation",{get:function(){return this.cell.recurrentActivation},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"useBias",{get:function(){return this.cell.useBias},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"kernelInitializer",{get:function(){return this.cell.kernelInitializer},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"recurrentInitializer",{get:function(){return this.cell.recurrentInitializer},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"biasInitializer",{get:function(){return this.cell.biasInitializer},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"unitForgetBias",{get:function(){return this.cell.unitForgetBias},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"kernelRegularizer",{get:function(){return this.cell.kernelRegularizer},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"recurrentRegularizer",{get:function(){return this.cell.recurrentRegularizer},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"biasRegularizer",{get:function(){return this.cell.biasRegularizer},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"kernelConstraint",{get:function(){return this.cell.kernelConstraint},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"recurrentConstraint",{get:function(){return this.cell.recurrentConstraint},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"biasConstraint",{get:function(){return this.cell.biasConstraint},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"dropout",{get:function(){return this.cell.dropout},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"recurrentDropout",{get:function(){return this.cell.recurrentDropout},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"implementation",{get:function(){return this.cell.implementation},enumerable:!0,configurable:!0}),t.prototype.getConfig=function(){var t={units:this.units,activation:serializeActivation(this.activation),recurrentActivation:serializeActivation(this.recurrentActivation),useBias:this.useBias,kernelInitializer:serializeInitializer(this.kernelInitializer),recurrentInitializer:serializeInitializer(this.recurrentInitializer),biasInitializer:serializeInitializer(this.biasInitializer),unitForgetBias:this.unitForgetBias,kernelRegularizer:serializeRegularizer(this.kernelRegularizer),recurrentRegularizer:serializeRegularizer(this.recurrentRegularizer),biasRegularizer:serializeRegularizer(this.biasRegularizer),activityRegularizer:serializeRegularizer(this.activityRegularizer),kernelConstraint:serializeConstraint(this.kernelConstraint),recurrentConstraint:serializeConstraint(this.recurrentConstraint),biasConstraint:serializeConstraint(this.biasConstraint),dropout:this.dropout,recurrentDropout:this.recurrentDropout,implementation:this.implementation},n=e.prototype.getConfig.call(this);return delete n.cell,Object.assign(t,n),t},t.fromConfig=function(e,t){return 0===t.implmentation&&(t.implementation=1),new e(t)},t.className="LSTM",t}(RNN);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(LSTM);var StackedRNNCells=function(e){function t(t){var n=e.call(this,t)||this;return n.cells=t.cells,n}return __extends(t,e),Object.defineProperty(t.prototype,"stateSize",{get:function(){for(var e=[],t=0,n=this.cells.slice().reverse();t<n.length;t++){var r=n[t];Array.isArray(r.stateSize)?e.push.apply(e,r.stateSize):e.push(r.stateSize)}return e},enumerable:!0,configurable:!0}),t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){for(var r=(e=e).slice(1),i=[],a=0,o=n.cells.slice().reverse();a<o.length;a++){var s=o[a];Array.isArray(s.stateSize)?i.push(r.splice(0,s.stateSize.length)):i.push(r.splice(0,1))}i.reverse();for(var l,u=[],c=0;c<n.cells.length;++c){s=n.cells[c];r=i[c],l=0===c?[e[0]].concat(r):[l[0]].concat(r),l=s.call(l,t),u.push(l.slice(1))}r=[];for(var p=0,h=u.slice().reverse();p<h.length;p++){var d=h[p];r.push.apply(r,d)}return[l[0]].concat(r)})},t.prototype.build=function(e){var t;isArrayOfShapes(e)&&(e=e[0]),e=e;for(var n=0,r=this.cells;n<r.length;n++){var i=r[n];i.build(e),t=Array.isArray(i.stateSize)?i.stateSize[0]:i.stateSize,e=[e[0],t]}this.built=!0},t.prototype.getConfig=function(){for(var t=[],n=0,r=this.cells;n<r.length;n++){var i=r[n];t.push({className:this.getClassName(),config:i.getConfig()})}var a={cells:t},o=e.prototype.getConfig.call(this);return Object.assign(a,o),a},t.fromConfig=function(e,t,n){void 0===n&&(n={});for(var r=[],i=0,a=t.cells;i<a.length;i++){var o=a[i];r.push(deserialize(o,n))}return new e({cells:r})},Object.defineProperty(t.prototype,"trainableWeights",{get:function(){if(!this.trainable)return[];for(var e=[],t=0,n=this.cells;t<n.length;t++){var r=n[t];e.push.apply(e,r.trainableWeights)}return e},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"nonTrainableWeights",{get:function(){for(var e=[],t=0,n=this.cells;t<n.length;t++){var r=n[t];e.push.apply(e,r.nonTrainableWeights)}if(!this.trainable){for(var i=[],a=0,o=this.cells;a<o.length;a++){r=o[a];i.push.apply(i,r.trainableWeights)}return i.concat(e)}return e},enumerable:!0,configurable:!0}),t.prototype.getWeights=function(){for(var e=[],t=0,n=this.cells;t<n.length;t++){var r=n[t];e.push.apply(e,r.weights)}return batchGetValue(e)},t.prototype.setWeights=function(e){for(var t=[],n=0,r=this.cells;n<r.length;n++)for(var i=r[n],a=i.weights.length,o=e.splice(a),s=0;s<i.weights.length;++s)t.push([i.weights[s],o[s]]);batchSetValue(t)},t.className="StackedRNNCells",t}(RNNCell);function generateDropoutMask(e,t,n,r){function i(){return dropout(e(),getScalar(t))}if(void 0===n&&(n=null),void 0===r&&(r=1),r>1){for(var a=[],o=0;o<r;o++)a.push(inTrainPhase(i,e,n));return a.forEach(function(e){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_4" /* keep */])(e)}),a}return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_4" /* keep */])(inTrainPhase(i,e,n))}__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(StackedRNNCells);var Wrapper=function(e){function t(t){var n=e.call(this,t)||this;return n.layer=t.layer,n}return __extends(t,e),t.prototype.build=function(e){this.built=!0},Object.defineProperty(t.prototype,"trainable",{get:function(){return null!=this.layer&&this.layer.trainable},set:function(e){null!=this.layer&&(this.layer.trainable=e)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"trainableWeights",{get:function(){return this.layer.trainableWeights},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"nonTrainableWeights",{get:function(){return this.layer.nonTrainableWeights},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"updates",{get:function(){return this.layer._updates},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"losses",{get:function(){return this.layer.losses},enumerable:!0,configurable:!0}),t.prototype.getWeights=function(){return this.layer.getWeights()},t.prototype.setWeights=function(e){this.layer.setWeights(e)},t.prototype.getConfig=function(){var t={layer:{className:this.layer.getClassName(),config:this.layer.getConfig()}},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.fromConfig=function(e,t,n){void 0===n&&(n={});var r=deserialize(t.layer,n);delete t.layer;var i={layer:r};return Object.assign(i,t),new e(i)},t}(Layer),TimeDistributed=function(e){function t(t){var n=e.call(this,t)||this;return n.supportsMasking=!0,n}return __extends(t,e),t.prototype.build=function(t){if((t=getExactlyOneShape(t)).length<3)throw new ValueError("TimeDistributed layer expects an input shape >= 3D, but received input shape "+JSON.stringify(t));this.inputSpec=[{shape:t}];var n=[t[0]].concat(t.slice(2));this.layer.built||(this.layer.build(n),this.layer.built=!0),e.prototype.build.call(this,t)},t.prototype.computeOutputShape=function(e){var t=[(e=getExactlyOneShape(e))[0]].concat(e.slice(2)),n=this.layer.computeOutputShape(t),r=e[1];return[n[0],r].concat(n.slice(1))},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){return rnn(function(e,r){return[getExactlyOneTensor(n.layer.call(e,t)),[]]},e=getExactlyOneTensor(e),[],!1,null,null,!1,!0)[1]})},t.className="TimeDistributed",t}(Wrapper);__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(TimeDistributed);var VALID_BIDIRECTIONAL_MERGE_MODES=["sum","mul","concat","ave"];function checkBidirectionalMergeMode(e){checkStringTypeUnionValue(VALID_BIDIRECTIONAL_MERGE_MODES,"BidirectionalMergeMode",e)}var Bidirectional=function(e){function t(t){var n=e.call(this,t)||this,r=t.layer.getConfig();if(n.forwardLayer=deserialize({className:t.layer.getClassName(),config:r}),r.goBackwards=!0!==r.goBackwards,n.backwardLayer=deserialize({className:t.layer.getClassName(),config:r}),n.forwardLayer.name="forward_"+n.forwardLayer.name,n.backwardLayer.name="backward_"+n.backwardLayer.name,checkBidirectionalMergeMode(t.mergeMode),n.mergeMode=t.mergeMode,t.weights)throw new NotImplementedError("weights support is not implemented for Bidirectional layer yet.");return n._stateful=t.layer.stateful,n.returnSequences=t.layer.returnSequences,n.returnState=t.layer.returnState,n.supportsMasking=!0,n._trainable=!0,n.inputSpec=t.layer.inputSpec,n.numConstants=null,n}return __extends(t,e),Object.defineProperty(t.prototype,"trainable",{get:function(){return this._trainable},set:function(e){this._trainable=e,null!=this.forwardLayer&&(this.forwardLayer.trainable=e),null!=this.backwardLayer&&(this.backwardLayer.trainable=e)},enumerable:!0,configurable:!0}),t.prototype.getWeights=function(){return this.forwardLayer.getWeights().concat(this.backwardLayer.getWeights())},t.prototype.setWeights=function(e){var t=e.length,n=Math.floor(t/2);this.forwardLayer.setWeights(e.slice(0,n)),this.backwardLayer.setWeights(e.slice(n))},t.prototype.computeOutputShape=function(e){var t,n,r,i=this.forwardLayer.computeOutputShape(e);return Array.isArray(i)&&Array.isArray(i[0])||(i=[i]),i=i,this.returnState?(r=i.slice(1),t=i[0]):t=i[0],t=t,"concat"===this.mergeMode?(t[t.length-1]*=2,n=[t]):n=null==this.mergeMode?[t,t.slice()]:[t],this.returnState?null==this.mergeMode?n.concat(r).concat(r.slice()):[t].concat(r).concat(r.slice()):singletonOrArray(n)},t.prototype.apply=function(t,n){var r=null==n?null:n.initialState,i=null==n?null:n.constants;null==n&&(n={});var a=standardizeArgs(t,r,i,this.numConstants);if(t=a.inputs,r=a.initialState,i=a.constants,Array.isArray(t)&&(r=t.slice(1),t=t[0]),(null==r||0===r.length)&&null==i)return e.prototype.apply.call(this,t,n);var o=[],s=[];if(null!=r){var l=r.length;if(l%2>0)throw new ValueError("When passing `initialState` to a Bidrectional RNN, the state should be an Array containing the states of the underlying RNNs.");n.initialState=r,o.push.apply(o,r);var u=r.map(function(e){return new InputSpec({shape:e.shape})});this.forwardLayer.stateSpec=u.slice(0,l/2),this.backwardLayer.stateSpec=u.slice(l/2),s.push.apply(s,u)}if(null!=i)throw new NotImplementedError("Support for constants in Bidirectional layers is not implemented yet.");for(var c=o[0]instanceof SymbolicTensor,p=0,h=o;p<h.length;p++){if(h[p]instanceof SymbolicTensor!==c)throw new ValueError("The initial state of a Bidirectional layer cannot be specified as a mix of symbolic and non-symbolic tensors")}if(c){var d=[t].concat(o),f=this.inputSpec.concat(s),g=this.inputSpec;this.inputSpec=f;var m=e.prototype.apply.call(this,d,n);return this.inputSpec=g,m}return e.prototype.apply.call(this,t,n)},t.prototype.call=function(e,t){var n=this;return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){if(null!=t.mask)throw new NotImplementedError("The support for masking is not implemented for Bidirectional layers yet.");var r,i,a,o,s=t.initialState;if(null==s)r=n.forwardLayer.call(e,t),i=n.backwardLayer.call(e,t);else{var l=s.slice(0,s.length/2),u=s.slice(s.length/2);r=n.forwardLayer.call(e,Object.assign(t,{initialState:l})),i=n.backwardLayer.call(e,Object.assign(t,{initialState:u}))}return n.returnState&&(Array.isArray(r)&&(a=r.slice(1).concat(i.slice(1))),r=r[0],i=i[0]),n.returnSequences&&(i=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_44" /* reverse */])(i,1)),"concat"===n.mergeMode?o=concatenate([r,i]):"sum"===n.mergeMode?o=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(r,i):"ave"===n.mergeMode?o=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(getScalar(.5),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(r,i)):"mul"===n.mergeMode?o=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(r,i):null==n.mergeMode&&(o=[r,i]),n.returnState?null==n.mergeMode?o.concat(a):[o].concat(a):o})},t.prototype.resetStates=function(e){this.forwardLayer.resetStates(),this.backwardLayer.resetStates()},t.prototype.build=function(e){var t=this;nameScope(this.forwardLayer.name,function(){t.forwardLayer.build(e)}),nameScope(this.backwardLayer.name,function(){t.backwardLayer.build(e)}),this.built=!0},Object.defineProperty(t.prototype,"trainableWeights",{get:function(){return this.forwardLayer.trainableWeights.concat(this.backwardLayer.trainableWeights)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"nonTrainableWeights",{get:function(){return this.forwardLayer.nonTrainableWeights.concat(this.backwardLayer.nonTrainableWeights)},enumerable:!0,configurable:!0}),t.prototype.getConfig=function(){var t={mergeMode:this.mergeMode},n=e.prototype.getConfig.call(this);return Object.assign(t,n),t},t.fromConfig=function(e,t){var n=deserialize(t.layer);if(delete t.layer,null!=t.numConstants)throw new NotImplementedError("Deserialization of a Bidirectional layer with numConstants present is not supported yet.");var r=t;return r.layer=n,new e(r)},t.className="Bidirectional",t}(Wrapper);function inputLayer(e){return new InputLayer(e)}function elu$2(e){return new ELU(e)}function reLU(e){return new ReLU(e)}function leakyReLU(e){return new LeakyReLU(e)}function softmax$1(e){return new Softmax$1(e)}function thresholdedReLU(e){return new ThresholdedReLU(e)}function conv1d$2(e){return new Conv1D(e)}function conv2d$2(e){return new Conv2D(e)}function conv2dTranspose$1(e){return new Conv2DTranspose(e)}function separableConv2d$1(e){return new SeparableConv2D(e)}function cropping2D(e){return new Cropping2D(e)}function upSampling2d(e){return new UpSampling2D(e)}function depthwiseConv2d$2(e){return new DepthwiseConv2D(e)}function activation(e){return new Activation$1(e)}function dense(e){return new Dense(e)}function dropout$1(e){return new Dropout(e)}function flatten$1(e){return new Flatten(e)}function repeatVector(e){return new RepeatVector(e)}function reshape(e){return new Reshape(e)}function permute(e){return new Permute(e)}function embedding(e){return new Embedding(e)}function add$2(e){return new Add(e)}function average$1(e){return new Average(e)}function concatenate$2(e){return new Concatenate(e)}function maximum$2(e){return new Maximum(e)}function minimum$2(e){return new Minimum(e)}function multiply$1(e){return new Multiply(e)}function dot$1(e){return new Dot(e)}function batchNormalization$1(e){return new BatchNormalization(e)}function zeroPadding2d(e){return new ZeroPadding2D(e)}function averagePooling1d(e){return new AveragePooling1D(e)}function avgPool1d(e){return averagePooling1d(e)}function avgPooling1d(e){return averagePooling1d(e)}function averagePooling2d(e){return new AveragePooling2D(e)}function avgPool2d(e){return averagePooling2d(e)}function avgPooling2d(e){return averagePooling2d(e)}function globalAveragePooling1d(e){return new GlobalAveragePooling1D(e)}function globalAveragePooling2d(e){return new GlobalAveragePooling2D(e)}function globalMaxPooling1d(e){return new GlobalMaxPooling1D(e)}function globalMaxPooling2d(e){return new GlobalMaxPooling2D(e)}function maxPooling1d(e){return new MaxPooling1D(e)}function maxPooling2d(e){return new MaxPooling2D(e)}function gru(e){return new GRU(e)}function gruCell(e){return new GRUCell(e)}function lstm(e){return new LSTM(e)}function lstmCell(e){return new LSTMCell(e)}function simpleRNN(e){return new SimpleRNN(e)}function simpleRNNCell(e){return new SimpleRNNCell(e)}function rnn$1(e){return new RNN(e)}function stackedRNNCells(e){return new StackedRNNCells(e)}function bidirectional(e){return new Bidirectional(e)}function timeDistributed(e){return new TimeDistributed(e)}__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_50" /* serialization */].registerClass(Bidirectional);var globalMaxPool1d=globalMaxPooling1d,globalMaxPool2d=globalMaxPooling2d,maxPool1d=maxPooling1d,maxPool2d=maxPooling2d,exports_layers=Object.freeze({inputLayer:inputLayer,elu:elu$2,reLU:reLU,leakyReLU:leakyReLU,softmax:softmax$1,thresholdedReLU:thresholdedReLU,conv1d:conv1d$2,conv2d:conv2d$2,conv2dTranspose:conv2dTranspose$1,separableConv2d:separableConv2d$1,cropping2D:cropping2D,upSampling2d:upSampling2d,depthwiseConv2d:depthwiseConv2d$2,activation:activation,dense:dense,dropout:dropout$1,flatten:flatten$1,repeatVector:repeatVector,reshape:reshape,permute:permute,embedding:embedding,add:add$2,average:average$1,concatenate:concatenate$2,maximum:maximum$2,minimum:minimum$2,multiply:multiply$1,dot:dot$1,batchNormalization:batchNormalization$1,zeroPadding2d:zeroPadding2d,averagePooling1d:averagePooling1d,avgPool1d:avgPool1d,avgPooling1d:avgPooling1d,averagePooling2d:averagePooling2d,avgPool2d:avgPool2d,avgPooling2d:avgPooling2d,globalAveragePooling1d:globalAveragePooling1d,globalAveragePooling2d:globalAveragePooling2d,globalMaxPooling1d:globalMaxPooling1d,globalMaxPooling2d:globalMaxPooling2d,maxPooling1d:maxPooling1d,maxPooling2d:maxPooling2d,gru:gru,gruCell:gruCell,lstm:lstm,lstmCell:lstmCell,simpleRNN:simpleRNN,simpleRNNCell:simpleRNNCell,rnn:rnn$1,stackedRNNCells:stackedRNNCells,bidirectional:bidirectional,timeDistributed:timeDistributed,globalMaxPool1d:globalMaxPool1d,globalMaxPool2d:globalMaxPool2d,maxPool1d:maxPool1d,maxPool2d:maxPool2d,Layer:Layer,RNN:RNN,RNNCell:RNNCell,input:input}),exports_models=Object.freeze({modelFromJSON:modelFromJSON});function binaryAccuracy$1(e,t){return binaryAccuracy(e,t)}function binaryCrossentropy$2(e,t){return binaryCrossentropy$1(e,t)}function categoricalAccuracy$1(e,t){return categoricalAccuracy(e,t)}function categoricalCrossentropy$2(e,t){return categoricalCrossentropy$1(e,t)}function precision$1(e,t){return precision(e,t)}function recall$1(e,t){return recall(e,t)}function cosineProximity$1(e,t){return cosineProximity(e,t)}function meanAbsoluteError$1(e,t){return meanAbsoluteError(e,t)}function meanAbsolutePercentageError$1(e,t){return meanAbsolutePercentageError(e,t)}function MAPE$2(e,t){return meanAbsolutePercentageError(e,t)}function mape$2(e,t){return meanAbsolutePercentageError(e,t)}function meanSquaredError$1(e,t){return meanSquaredError(e,t)}function MSE$2(e,t){return meanSquaredError(e,t)}function mse$2(e,t){return meanSquaredError(e,t)}var exports_metrics=Object.freeze({binaryAccuracy:binaryAccuracy$1,binaryCrossentropy:binaryCrossentropy$2,categoricalAccuracy:categoricalAccuracy$1,categoricalCrossentropy:categoricalCrossentropy$2,precision:precision$1,recall:recall$1,cosineProximity:cosineProximity$1,meanAbsoluteError:meanAbsoluteError$1,meanAbsolutePercentageError:meanAbsolutePercentageError$1,MAPE:MAPE$2,mape:mape$2,meanSquaredError:meanSquaredError$1,MSE:MSE$2,mse:mse$2});function l1l2(e){return new L1L2(e)}function l1$1(e){return l1(e)}function l2$1(e){return l2(e)}var exports_regularizers=Object.freeze({l1l2:l1l2,l1:l1$1,l2:l2$1}),Callback=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.model=null,t}return __extends(t,e),t.prototype.setModel=function(e){if(!(e instanceof Model))throw new Error("model must be a Model, not some other Container");this.model=e},t}(BaseCallback);
//# sourceMappingURL=tf-layers.esm.js.map


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export FrozenModel */
/* unused harmony export loadFrozenModel */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return version; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__ = __webpack_require__(35);
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
var __assign=Object.assign||function(e){for(var t,a=1,r=arguments.length;a<r;a++)for(var n in t=arguments[a])Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e};function __awaiter(e,t,a,r){return new(a||(a=Promise))(function(n,o){function s(e){try{p(r.next(e))}catch(e){o(e)}}function i(e){try{p(r.throw(e))}catch(e){o(e)}}function p(e){e.done?n(e.value):new a(function(t){t(e.value)}).then(s,i)}p((r=r.apply(e,t||[])).next())})}function __generator(e,t){var a,r,n,o,s={label:0,sent:function(){if(1&n[0])throw n[1];return n[1]},trys:[],ops:[]};return o={next:i(0),throw:i(1),return:i(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function i(o){return function(i){return function(o){if(a)throw new TypeError("Generator is already executing.");for(;s;)try{if(a=1,r&&(n=r[2&o[0]?"return":o[0]?"throw":"next"])&&!(n=n.call(r,o[1])).done)return n;switch(r=0,n&&(o=[0,n.value]),o[0]){case 0:case 1:n=o;break;case 4:return s.label++,{value:o[1],done:!1};case 5:s.label++,r=o[1],o=[0];continue;case 7:o=s.ops.pop(),s.trys.pop();continue;default:if(!(n=(n=s.trys).length>0&&n[n.length-1])&&(6===o[0]||2===o[0])){s=0;continue}if(3===o[0]&&(!n||o[1]>n[0]&&o[1]<n[3])){s.label=o[1];break}if(6===o[0]&&s.label<n[1]){s.label=n[1],n=o;break}if(n&&s.label<n[2]){s.label=n[2],s.ops.push(o);break}n[2]&&s.ops.pop(),s.trys.pop();continue}o=t.call(e,s)}catch(e){o=[6,e],r=0}finally{a=n=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,i])}}}var commonjsGlobal="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function createCommonjsModule(e,t){return e(t={exports:{}},t.exports),t.exports}var aspromise=asPromise;function asPromise(e,t){for(var a=new Array(arguments.length-1),r=0,n=2,o=!0;n<arguments.length;)a[r++]=arguments[n++];return new Promise(function(n,s){a[r]=function(e){if(o)if(o=!1,e)s(e);else{for(var t=new Array(arguments.length-1),a=0;a<t.length;)t[a++]=arguments[a];n.apply(null,t)}};try{e.apply(t||null,a)}catch(e){o&&(o=!1,s(e))}})}var base64_1=createCommonjsModule(function(e,t){var a=t;a.length=function(e){var t=e.length;if(!t)return 0;for(var a=0;--t%4>1&&"="===e.charAt(t);)++a;return Math.ceil(3*e.length)/4-a};for(var r=new Array(64),n=new Array(123),o=0;o<64;)n[r[o]=o<26?o+65:o<52?o+71:o<62?o-4:o-59|43]=o++;a.encode=function(e,t,a){for(var n,o=null,s=[],i=0,p=0;t<a;){var m=e[t++];switch(p){case 0:s[i++]=r[m>>2],n=(3&m)<<4,p=1;break;case 1:s[i++]=r[n|m>>4],n=(15&m)<<2,p=2;break;case 2:s[i++]=r[n|m>>6],s[i++]=r[63&m],p=0}i>8191&&((o||(o=[])).push(String.fromCharCode.apply(String,s)),i=0)}return p&&(s[i++]=r[n],s[i++]=61,1===p&&(s[i++]=61)),o?(i&&o.push(String.fromCharCode.apply(String,s.slice(0,i))),o.join("")):String.fromCharCode.apply(String,s.slice(0,i))};a.decode=function(e,t,a){for(var r,o=a,s=0,i=0;i<e.length;){var p=e.charCodeAt(i++);if(61===p&&s>1)break;if(void 0===(p=n[p]))throw Error("invalid encoding");switch(s){case 0:r=p,s=1;break;case 1:t[a++]=r<<2|(48&p)>>4,r=p,s=2;break;case 2:t[a++]=(15&r)<<4|(60&p)>>2,r=p,s=3;break;case 3:t[a++]=(3&r)<<6|p,s=0}}if(1===s)throw Error("invalid encoding");return a-o},a.test=function(e){return/^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(e)}}),eventemitter=EventEmitter;function EventEmitter(){this._listeners={}}EventEmitter.prototype.on=function(e,t,a){return(this._listeners[e]||(this._listeners[e]=[])).push({fn:t,ctx:a||this}),this},EventEmitter.prototype.off=function(e,t){if(void 0===e)this._listeners={};else if(void 0===t)this._listeners[e]=[];else for(var a=this._listeners[e],r=0;r<a.length;)a[r].fn===t?a.splice(r,1):++r;return this},EventEmitter.prototype.emit=function(e){var t=this._listeners[e];if(t){for(var a=[],r=1;r<arguments.length;)a.push(arguments[r++]);for(r=0;r<t.length;)t[r].fn.apply(t[r++].ctx,a)}return this};var float_1=factory(factory);function factory(e){return"undefined"!=typeof Float32Array?function(){var t=new Float32Array([-0]),a=new Uint8Array(t.buffer),r=128===a[3];function n(e,r,n){t[0]=e,r[n]=a[0],r[n+1]=a[1],r[n+2]=a[2],r[n+3]=a[3]}function o(e,r,n){t[0]=e,r[n]=a[3],r[n+1]=a[2],r[n+2]=a[1],r[n+3]=a[0]}function s(e,r){return a[0]=e[r],a[1]=e[r+1],a[2]=e[r+2],a[3]=e[r+3],t[0]}function i(e,r){return a[3]=e[r],a[2]=e[r+1],a[1]=e[r+2],a[0]=e[r+3],t[0]}e.writeFloatLE=r?n:o,e.writeFloatBE=r?o:n,e.readFloatLE=r?s:i,e.readFloatBE=r?i:s}():function(){function t(e,t,a,r){var n=t<0?1:0;if(n&&(t=-t),0===t)e(1/t>0?0:2147483648,a,r);else if(isNaN(t))e(2143289344,a,r);else if(t>3.4028234663852886e38)e((n<<31|2139095040)>>>0,a,r);else if(t<1.1754943508222875e-38)e((n<<31|Math.round(t/1.401298464324817e-45))>>>0,a,r);else{var o=Math.floor(Math.log(t)/Math.LN2);e((n<<31|o+127<<23|8388607&Math.round(t*Math.pow(2,-o)*8388608))>>>0,a,r)}}function a(e,t,a){var r=e(t,a),n=2*(r>>31)+1,o=r>>>23&255,s=8388607&r;return 255===o?s?NaN:n*(1/0):0===o?1.401298464324817e-45*n*s:n*Math.pow(2,o-150)*(s+8388608)}e.writeFloatLE=t.bind(null,writeUintLE),e.writeFloatBE=t.bind(null,writeUintBE),e.readFloatLE=a.bind(null,readUintLE),e.readFloatBE=a.bind(null,readUintBE)}(),"undefined"!=typeof Float64Array?function(){var t=new Float64Array([-0]),a=new Uint8Array(t.buffer),r=128===a[7];function n(e,r,n){t[0]=e,r[n]=a[0],r[n+1]=a[1],r[n+2]=a[2],r[n+3]=a[3],r[n+4]=a[4],r[n+5]=a[5],r[n+6]=a[6],r[n+7]=a[7]}function o(e,r,n){t[0]=e,r[n]=a[7],r[n+1]=a[6],r[n+2]=a[5],r[n+3]=a[4],r[n+4]=a[3],r[n+5]=a[2],r[n+6]=a[1],r[n+7]=a[0]}function s(e,r){return a[0]=e[r],a[1]=e[r+1],a[2]=e[r+2],a[3]=e[r+3],a[4]=e[r+4],a[5]=e[r+5],a[6]=e[r+6],a[7]=e[r+7],t[0]}function i(e,r){return a[7]=e[r],a[6]=e[r+1],a[5]=e[r+2],a[4]=e[r+3],a[3]=e[r+4],a[2]=e[r+5],a[1]=e[r+6],a[0]=e[r+7],t[0]}e.writeDoubleLE=r?n:o,e.writeDoubleBE=r?o:n,e.readDoubleLE=r?s:i,e.readDoubleBE=r?i:s}():function(){function t(e,t,a,r,n,o){var s=r<0?1:0;if(s&&(r=-r),0===r)e(0,n,o+t),e(1/r>0?0:2147483648,n,o+a);else if(isNaN(r))e(0,n,o+t),e(2146959360,n,o+a);else if(r>1.7976931348623157e308)e(0,n,o+t),e((s<<31|2146435072)>>>0,n,o+a);else{var i;if(r<2.2250738585072014e-308)e((i=r/5e-324)>>>0,n,o+t),e((s<<31|i/4294967296)>>>0,n,o+a);else{var p=Math.floor(Math.log(r)/Math.LN2);1024===p&&(p=1023),e(4503599627370496*(i=r*Math.pow(2,-p))>>>0,n,o+t),e((s<<31|p+1023<<20|1048576*i&1048575)>>>0,n,o+a)}}}function a(e,t,a,r,n){var o=e(r,n+t),s=e(r,n+a),i=2*(s>>31)+1,p=s>>>20&2047,m=4294967296*(1048575&s)+o;return 2047===p?m?NaN:i*(1/0):0===p?5e-324*i*m:i*Math.pow(2,p-1075)*(m+4503599627370496)}e.writeDoubleLE=t.bind(null,writeUintLE,0,4),e.writeDoubleBE=t.bind(null,writeUintBE,4,0),e.readDoubleLE=a.bind(null,readUintLE,0,4),e.readDoubleBE=a.bind(null,readUintBE,4,0)}(),e}function writeUintLE(e,t,a){t[a]=255&e,t[a+1]=e>>>8&255,t[a+2]=e>>>16&255,t[a+3]=e>>>24}function writeUintBE(e,t,a){t[a]=e>>>24,t[a+1]=e>>>16&255,t[a+2]=e>>>8&255,t[a+3]=255&e}function readUintLE(e,t){return(e[t]|e[t+1]<<8|e[t+2]<<16|e[t+3]<<24)>>>0}function readUintBE(e,t){return(e[t]<<24|e[t+1]<<16|e[t+2]<<8|e[t+3])>>>0}var inquire_1=inquire;function inquire(moduleName){try{var mod$$1=eval("quire".replace(/^/,"re"))(moduleName);if(mod$$1&&(mod$$1.length||Object.keys(mod$$1).length))return mod$$1}catch(e){}return null}var utf8_1=createCommonjsModule(function(e,t){var a=t;a.length=function(e){for(var t=0,a=0,r=0;r<e.length;++r)(a=e.charCodeAt(r))<128?t+=1:a<2048?t+=2:55296==(64512&a)&&56320==(64512&e.charCodeAt(r+1))?(++r,t+=4):t+=3;return t},a.read=function(e,t,a){if(a-t<1)return"";for(var r,n=null,o=[],s=0;t<a;)(r=e[t++])<128?o[s++]=r:r>191&&r<224?o[s++]=(31&r)<<6|63&e[t++]:r>239&&r<365?(r=((7&r)<<18|(63&e[t++])<<12|(63&e[t++])<<6|63&e[t++])-65536,o[s++]=55296+(r>>10),o[s++]=56320+(1023&r)):o[s++]=(15&r)<<12|(63&e[t++])<<6|63&e[t++],s>8191&&((n||(n=[])).push(String.fromCharCode.apply(String,o)),s=0);return n?(s&&n.push(String.fromCharCode.apply(String,o.slice(0,s))),n.join("")):String.fromCharCode.apply(String,o.slice(0,s))},a.write=function(e,t,a){for(var r,n,o=a,s=0;s<e.length;++s)(r=e.charCodeAt(s))<128?t[a++]=r:r<2048?(t[a++]=r>>6|192,t[a++]=63&r|128):55296==(64512&r)&&56320==(64512&(n=e.charCodeAt(s+1)))?(r=65536+((1023&r)<<10)+(1023&n),++s,t[a++]=r>>18|240,t[a++]=r>>12&63|128,t[a++]=r>>6&63|128,t[a++]=63&r|128):(t[a++]=r>>12|224,t[a++]=r>>6&63|128,t[a++]=63&r|128);return a-o}}),pool_1=pool;function pool(e,t,a){var r=a||8192,n=r>>>1,o=null,s=r;return function(a){if(a<1||a>n)return e(a);s+a>r&&(o=e(r),s=0);var i=t.call(o,s,s+=a);return 7&s&&(s=1+(7|s)),i}}var longbits=LongBits;function LongBits(e,t){this.lo=e>>>0,this.hi=t>>>0}var zero=LongBits.zero=new LongBits(0,0);zero.toNumber=function(){return 0},zero.zzEncode=zero.zzDecode=function(){return this},zero.length=function(){return 1};var zeroHash=LongBits.zeroHash="\0\0\0\0\0\0\0\0";LongBits.fromNumber=function(e){if(0===e)return zero;var t=e<0;t&&(e=-e);var a=e>>>0,r=(e-a)/4294967296>>>0;return t&&(r=~r>>>0,a=~a>>>0,++a>4294967295&&(a=0,++r>4294967295&&(r=0))),new LongBits(a,r)},LongBits.from=function(e){if("number"==typeof e)return LongBits.fromNumber(e);if(minimal.isString(e)){if(!minimal.Long)return LongBits.fromNumber(parseInt(e,10));e=minimal.Long.fromString(e)}return e.low||e.high?new LongBits(e.low>>>0,e.high>>>0):zero},LongBits.prototype.toNumber=function(e){if(!e&&this.hi>>>31){var t=1+~this.lo>>>0,a=~this.hi>>>0;return t||(a=a+1>>>0),-(t+4294967296*a)}return this.lo+4294967296*this.hi},LongBits.prototype.toLong=function(e){return minimal.Long?new minimal.Long(0|this.lo,0|this.hi,Boolean(e)):{low:0|this.lo,high:0|this.hi,unsigned:Boolean(e)}};var charCodeAt=String.prototype.charCodeAt;LongBits.fromHash=function(e){return e===zeroHash?zero:new LongBits((charCodeAt.call(e,0)|charCodeAt.call(e,1)<<8|charCodeAt.call(e,2)<<16|charCodeAt.call(e,3)<<24)>>>0,(charCodeAt.call(e,4)|charCodeAt.call(e,5)<<8|charCodeAt.call(e,6)<<16|charCodeAt.call(e,7)<<24)>>>0)},LongBits.prototype.toHash=function(){return String.fromCharCode(255&this.lo,this.lo>>>8&255,this.lo>>>16&255,this.lo>>>24,255&this.hi,this.hi>>>8&255,this.hi>>>16&255,this.hi>>>24)},LongBits.prototype.zzEncode=function(){var e=this.hi>>31;return this.hi=((this.hi<<1|this.lo>>>31)^e)>>>0,this.lo=(this.lo<<1^e)>>>0,this},LongBits.prototype.zzDecode=function(){var e=-(1&this.lo);return this.lo=((this.lo>>>1|this.hi<<31)^e)>>>0,this.hi=(this.hi>>>1^e)>>>0,this},LongBits.prototype.length=function(){var e=this.lo,t=(this.lo>>>28|this.hi<<4)>>>0,a=this.hi>>>24;return 0===a?0===t?e<16384?e<128?1:2:e<2097152?3:4:t<16384?t<128?5:6:t<2097152?7:8:a<128?9:10};var minimal=createCommonjsModule(function(e,t){var a=t;function r(e,t,a){for(var r=Object.keys(t),n=0;n<r.length;++n)void 0!==e[r[n]]&&a||(e[r[n]]=t[r[n]]);return e}function n(e){function t(e,a){if(!(this instanceof t))return new t(e,a);Object.defineProperty(this,"message",{get:function(){return e}}),Error.captureStackTrace?Error.captureStackTrace(this,t):Object.defineProperty(this,"stack",{value:(new Error).stack||""}),a&&r(this,a)}return(t.prototype=Object.create(Error.prototype)).constructor=t,Object.defineProperty(t.prototype,"name",{get:function(){return e}}),t.prototype.toString=function(){return this.name+": "+this.message},t}a.asPromise=aspromise,a.base64=base64_1,a.EventEmitter=eventemitter,a.float=float_1,a.inquire=inquire_1,a.utf8=utf8_1,a.pool=pool_1,a.LongBits=longbits,a.emptyArray=Object.freeze?Object.freeze([]):[],a.emptyObject=Object.freeze?Object.freeze({}):{},a.isNode=Boolean(commonjsGlobal.process&&commonjsGlobal.process.versions&&commonjsGlobal.process.versions.node),a.isInteger=Number.isInteger||function(e){return"number"==typeof e&&isFinite(e)&&Math.floor(e)===e},a.isString=function(e){return"string"==typeof e||e instanceof String},a.isObject=function(e){return e&&"object"==typeof e},a.isset=a.isSet=function(e,t){var a=e[t];return!(null==a||!e.hasOwnProperty(t))&&("object"!=typeof a||(Array.isArray(a)?a.length:Object.keys(a).length)>0)},a.Buffer=function(){try{var e=a.inquire("buffer").Buffer;return e.prototype.utf8Write?e:null}catch(e){return null}}(),a._Buffer_from=null,a._Buffer_allocUnsafe=null,a.newBuffer=function(e){return"number"==typeof e?a.Buffer?a._Buffer_allocUnsafe(e):new a.Array(e):a.Buffer?a._Buffer_from(e):"undefined"==typeof Uint8Array?e:new Uint8Array(e)},a.Array="undefined"!=typeof Uint8Array?Uint8Array:Array,a.Long=commonjsGlobal.dcodeIO&&commonjsGlobal.dcodeIO.Long||a.inquire("long"),a.key2Re=/^true|false|0|1$/,a.key32Re=/^-?(?:0|[1-9][0-9]*)$/,a.key64Re=/^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/,a.longToHash=function(e){return e?a.LongBits.from(e).toHash():a.LongBits.zeroHash},a.longFromHash=function(e,t){var r=a.LongBits.fromHash(e);return a.Long?a.Long.fromBits(r.lo,r.hi,t):r.toNumber(Boolean(t))},a.merge=r,a.lcFirst=function(e){return e.charAt(0).toLowerCase()+e.substring(1)},a.newError=n,a.ProtocolError=n("ProtocolError"),a.oneOfGetter=function(e){for(var t={},a=0;a<e.length;++a)t[e[a]]=1;return function(){for(var e=Object.keys(this),a=e.length-1;a>-1;--a)if(1===t[e[a]]&&void 0!==this[e[a]]&&null!==this[e[a]])return e[a]}},a.oneOfSetter=function(e){return function(t){for(var a=0;a<e.length;++a)e[a]!==t&&delete this[e[a]]}},a.toJSONOptions={longs:String,enums:String,bytes:String,json:!0},a._configure=function(){var e=a.Buffer;e?(a._Buffer_from=e.from!==Uint8Array.from&&e.from||function(t,a){return new e(t,a)},a._Buffer_allocUnsafe=e.allocUnsafe||function(t){return new e(t)}):a._Buffer_from=a._Buffer_allocUnsafe=null}}),writer=Writer,BufferWriter,LongBits$1=minimal.LongBits,base64=minimal.base64,utf8=minimal.utf8;function Op(e,t,a){this.fn=e,this.len=t,this.next=void 0,this.val=a}function noop(){}function State(e){this.head=e.head,this.tail=e.tail,this.len=e.len,this.next=e.states}function Writer(){this.len=0,this.head=new Op(noop,0,0),this.tail=this.head,this.states=null}function writeByte(e,t,a){t[a]=255&e}function writeVarint32(e,t,a){for(;e>127;)t[a++]=127&e|128,e>>>=7;t[a]=e}function VarintOp(e,t){this.len=e,this.next=void 0,this.val=t}function writeVarint64(e,t,a){for(;e.hi;)t[a++]=127&e.lo|128,e.lo=(e.lo>>>7|e.hi<<25)>>>0,e.hi>>>=7;for(;e.lo>127;)t[a++]=127&e.lo|128,e.lo=e.lo>>>7;t[a++]=e.lo}function writeFixed32(e,t,a){t[a]=255&e,t[a+1]=e>>>8&255,t[a+2]=e>>>16&255,t[a+3]=e>>>24}Writer.create=minimal.Buffer?function(){return(Writer.create=function(){return new BufferWriter})()}:function(){return new Writer},Writer.alloc=function(e){return new minimal.Array(e)},minimal.Array!==Array&&(Writer.alloc=minimal.pool(Writer.alloc,minimal.Array.prototype.subarray)),Writer.prototype._push=function(e,t,a){return this.tail=this.tail.next=new Op(e,t,a),this.len+=t,this},VarintOp.prototype=Object.create(Op.prototype),VarintOp.prototype.fn=writeVarint32,Writer.prototype.uint32=function(e){return this.len+=(this.tail=this.tail.next=new VarintOp((e>>>=0)<128?1:e<16384?2:e<2097152?3:e<268435456?4:5,e)).len,this},Writer.prototype.int32=function(e){return e<0?this._push(writeVarint64,10,LongBits$1.fromNumber(e)):this.uint32(e)},Writer.prototype.sint32=function(e){return this.uint32((e<<1^e>>31)>>>0)},Writer.prototype.uint64=function(e){var t=LongBits$1.from(e);return this._push(writeVarint64,t.length(),t)},Writer.prototype.int64=Writer.prototype.uint64,Writer.prototype.sint64=function(e){var t=LongBits$1.from(e).zzEncode();return this._push(writeVarint64,t.length(),t)},Writer.prototype.bool=function(e){return this._push(writeByte,1,e?1:0)},Writer.prototype.fixed32=function(e){return this._push(writeFixed32,4,e>>>0)},Writer.prototype.sfixed32=Writer.prototype.fixed32,Writer.prototype.fixed64=function(e){var t=LongBits$1.from(e);return this._push(writeFixed32,4,t.lo)._push(writeFixed32,4,t.hi)},Writer.prototype.sfixed64=Writer.prototype.fixed64,Writer.prototype.float=function(e){return this._push(minimal.float.writeFloatLE,4,e)},Writer.prototype.double=function(e){return this._push(minimal.float.writeDoubleLE,8,e)};var writeBytes=minimal.Array.prototype.set?function(e,t,a){t.set(e,a)}:function(e,t,a){for(var r=0;r<e.length;++r)t[a+r]=e[r]};Writer.prototype.bytes=function(e){var t=e.length>>>0;if(!t)return this._push(writeByte,1,0);if(minimal.isString(e)){var a=Writer.alloc(t=base64.length(e));base64.decode(e,a,0),e=a}return this.uint32(t)._push(writeBytes,t,e)},Writer.prototype.string=function(e){var t=utf8.length(e);return t?this.uint32(t)._push(utf8.write,t,e):this._push(writeByte,1,0)},Writer.prototype.fork=function(){return this.states=new State(this),this.head=this.tail=new Op(noop,0,0),this.len=0,this},Writer.prototype.reset=function(){return this.states?(this.head=this.states.head,this.tail=this.states.tail,this.len=this.states.len,this.states=this.states.next):(this.head=this.tail=new Op(noop,0,0),this.len=0),this},Writer.prototype.ldelim=function(){var e=this.head,t=this.tail,a=this.len;return this.reset().uint32(a),a&&(this.tail.next=e.next,this.tail=t,this.len+=a),this},Writer.prototype.finish=function(){for(var e=this.head.next,t=this.constructor.alloc(this.len),a=0;e;)e.fn(e.val,t,a),a+=e.len,e=e.next;return t},Writer._configure=function(e){BufferWriter=e};var writer_buffer=BufferWriter$1;(BufferWriter$1.prototype=Object.create(writer.prototype)).constructor=BufferWriter$1;var Buffer=minimal.Buffer;function BufferWriter$1(){writer.call(this)}BufferWriter$1.alloc=function(e){return(BufferWriter$1.alloc=minimal._Buffer_allocUnsafe)(e)};var writeBytesBuffer=Buffer&&Buffer.prototype instanceof Uint8Array&&"set"===Buffer.prototype.set.name?function(e,t,a){t.set(e,a)}:function(e,t,a){if(e.copy)e.copy(t,a,0,e.length);else for(var r=0;r<e.length;)t[a++]=e[r++]};function writeStringBuffer(e,t,a){e.length<40?minimal.utf8.write(e,t,a):t.utf8Write(e,a)}BufferWriter$1.prototype.bytes=function(e){minimal.isString(e)&&(e=minimal._Buffer_from(e,"base64"));var t=e.length>>>0;return this.uint32(t),t&&this._push(writeBytesBuffer,t,e),this},BufferWriter$1.prototype.string=function(e){var t=Buffer.byteLength(e);return this.uint32(t),t&&this._push(writeStringBuffer,t,e),this};var reader=Reader,BufferReader,LongBits$2=minimal.LongBits,utf8$1=minimal.utf8;function indexOutOfRange(e,t){return RangeError("index out of range: "+e.pos+" + "+(t||1)+" > "+e.len)}function Reader(e){this.buf=e,this.pos=0,this.len=e.length}var create_array="undefined"!=typeof Uint8Array?function(e){if(e instanceof Uint8Array||Array.isArray(e))return new Reader(e);throw Error("illegal buffer")}:function(e){if(Array.isArray(e))return new Reader(e);throw Error("illegal buffer")};function readLongVarint(){var e=new LongBits$2(0,0),t=0;if(!(this.len-this.pos>4)){for(;t<3;++t){if(this.pos>=this.len)throw indexOutOfRange(this);if(e.lo=(e.lo|(127&this.buf[this.pos])<<7*t)>>>0,this.buf[this.pos++]<128)return e}return e.lo=(e.lo|(127&this.buf[this.pos++])<<7*t)>>>0,e}for(;t<4;++t)if(e.lo=(e.lo|(127&this.buf[this.pos])<<7*t)>>>0,this.buf[this.pos++]<128)return e;if(e.lo=(e.lo|(127&this.buf[this.pos])<<28)>>>0,e.hi=(e.hi|(127&this.buf[this.pos])>>4)>>>0,this.buf[this.pos++]<128)return e;if(t=0,this.len-this.pos>4){for(;t<5;++t)if(e.hi=(e.hi|(127&this.buf[this.pos])<<7*t+3)>>>0,this.buf[this.pos++]<128)return e}else for(;t<5;++t){if(this.pos>=this.len)throw indexOutOfRange(this);if(e.hi=(e.hi|(127&this.buf[this.pos])<<7*t+3)>>>0,this.buf[this.pos++]<128)return e}throw Error("invalid varint encoding")}function readFixed32_end(e,t){return(e[t-4]|e[t-3]<<8|e[t-2]<<16|e[t-1]<<24)>>>0}function readFixed64(){if(this.pos+8>this.len)throw indexOutOfRange(this,8);return new LongBits$2(readFixed32_end(this.buf,this.pos+=4),readFixed32_end(this.buf,this.pos+=4))}Reader.create=minimal.Buffer?function(e){return(Reader.create=function(e){return minimal.Buffer.isBuffer(e)?new BufferReader(e):create_array(e)})(e)}:create_array,Reader.prototype._slice=minimal.Array.prototype.subarray||minimal.Array.prototype.slice,Reader.prototype.uint32=function(){var e=4294967295;return function(){if(e=(127&this.buf[this.pos])>>>0,this.buf[this.pos++]<128)return e;if(e=(e|(127&this.buf[this.pos])<<7)>>>0,this.buf[this.pos++]<128)return e;if(e=(e|(127&this.buf[this.pos])<<14)>>>0,this.buf[this.pos++]<128)return e;if(e=(e|(127&this.buf[this.pos])<<21)>>>0,this.buf[this.pos++]<128)return e;if(e=(e|(15&this.buf[this.pos])<<28)>>>0,this.buf[this.pos++]<128)return e;if((this.pos+=5)>this.len)throw this.pos=this.len,indexOutOfRange(this,10);return e}}(),Reader.prototype.int32=function(){return 0|this.uint32()},Reader.prototype.sint32=function(){var e=this.uint32();return e>>>1^-(1&e)|0},Reader.prototype.bool=function(){return 0!==this.uint32()},Reader.prototype.fixed32=function(){if(this.pos+4>this.len)throw indexOutOfRange(this,4);return readFixed32_end(this.buf,this.pos+=4)},Reader.prototype.sfixed32=function(){if(this.pos+4>this.len)throw indexOutOfRange(this,4);return 0|readFixed32_end(this.buf,this.pos+=4)},Reader.prototype.float=function(){if(this.pos+4>this.len)throw indexOutOfRange(this,4);var e=minimal.float.readFloatLE(this.buf,this.pos);return this.pos+=4,e},Reader.prototype.double=function(){if(this.pos+8>this.len)throw indexOutOfRange(this,4);var e=minimal.float.readDoubleLE(this.buf,this.pos);return this.pos+=8,e},Reader.prototype.bytes=function(){var e=this.uint32(),t=this.pos,a=this.pos+e;if(a>this.len)throw indexOutOfRange(this,e);return this.pos+=e,Array.isArray(this.buf)?this.buf.slice(t,a):t===a?new this.buf.constructor(0):this._slice.call(this.buf,t,a)},Reader.prototype.string=function(){var e=this.bytes();return utf8$1.read(e,0,e.length)},Reader.prototype.skip=function(e){if("number"==typeof e){if(this.pos+e>this.len)throw indexOutOfRange(this,e);this.pos+=e}else do{if(this.pos>=this.len)throw indexOutOfRange(this)}while(128&this.buf[this.pos++]);return this},Reader.prototype.skipType=function(e){switch(e){case 0:this.skip();break;case 1:this.skip(8);break;case 2:this.skip(this.uint32());break;case 3:for(;;){if(4==(e=7&this.uint32()))break;this.skipType(e)}break;case 5:this.skip(4);break;default:throw Error("invalid wire type "+e+" at offset "+this.pos)}return this},Reader._configure=function(e){BufferReader=e;var t=minimal.Long?"toLong":"toNumber";minimal.merge(Reader.prototype,{int64:function(){return readLongVarint.call(this)[t](!1)},uint64:function(){return readLongVarint.call(this)[t](!0)},sint64:function(){return readLongVarint.call(this).zzDecode()[t](!1)},fixed64:function(){return readFixed64.call(this)[t](!0)},sfixed64:function(){return readFixed64.call(this)[t](!1)}})};var reader_buffer=BufferReader$1;function BufferReader$1(e){reader.call(this,e)}(BufferReader$1.prototype=Object.create(reader.prototype)).constructor=BufferReader$1,minimal.Buffer&&(BufferReader$1.prototype._slice=minimal.Buffer.prototype.slice),BufferReader$1.prototype.string=function(){var e=this.uint32();return this.buf.utf8Slice(this.pos,this.pos=Math.min(this.pos+e,this.len))};var service=Service;function Service(e,t,a){if("function"!=typeof e)throw TypeError("rpcImpl must be a function");minimal.EventEmitter.call(this),this.rpcImpl=e,this.requestDelimited=Boolean(t),this.responseDelimited=Boolean(a)}(Service.prototype=Object.create(minimal.EventEmitter.prototype)).constructor=Service,Service.prototype.rpcCall=function e(t,a,r,n,o){if(!n)throw TypeError("request must be specified");var s=this;if(!o)return minimal.asPromise(e,s,t,a,r,n);if(s.rpcImpl)try{return s.rpcImpl(t,a[s.requestDelimited?"encodeDelimited":"encode"](n).finish(),function(e,a){if(e)return s.emit("error",e,t),o(e);if(null!==a){if(!(a instanceof r))try{a=r[s.responseDelimited?"decodeDelimited":"decode"](a)}catch(e){return s.emit("error",e,t),o(e)}return s.emit("data",a,t),o(null,a)}s.end(!0)})}catch(e){return s.emit("error",e,t),void setTimeout(function(){o(e)},0)}else setTimeout(function(){o(Error("already ended"))},0)},Service.prototype.end=function(e){return this.rpcImpl&&(e||this.rpcImpl(null,null,null),this.rpcImpl=null,this.emit("end").off()),this};var rpc_1=createCommonjsModule(function(e,t){t.Service=service}),roots={},indexMinimal=createCommonjsModule(function(e,t){var a=t;function r(){a.Reader._configure(a.BufferReader),a.util._configure()}a.build="minimal",a.Writer=writer,a.BufferWriter=writer_buffer,a.Reader=reader,a.BufferReader=reader_buffer,a.util=minimal,a.rpc=rpc_1,a.roots=roots,a.configure=r,a.Writer._configure(a.BufferWriter),r()}),minimal$1=indexMinimal,minimal_1=minimal$1.roots,minimal_2=minimal$1.Reader,minimal_3=minimal$1.util,$Reader=minimal$1.Reader,$util=minimal$1.util,$root=minimal$1.roots.default||(minimal$1.roots.default={});$root.tensorflow=function(){var e,t,a={};return a.Any=function(){function e(e){if(e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.typeUrl="",e.prototype.value=$util.newBuffer([]),e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.Any;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:r.typeUrl=e.string();break;case 2:r.value=e.bytes();break;default:e.skipType(7&n)}}return r},e}(),a.DataType=(e={},(t=Object.create(e))[e[0]="DT_INVALID"]=0,t[e[1]="DT_FLOAT"]=1,t[e[2]="DT_DOUBLE"]=2,t[e[3]="DT_INT32"]=3,t[e[4]="DT_UINT8"]=4,t[e[5]="DT_INT16"]=5,t[e[6]="DT_INT8"]=6,t[e[7]="DT_STRING"]=7,t[e[8]="DT_COMPLEX64"]=8,t[e[9]="DT_INT64"]=9,t[e[10]="DT_BOOL"]=10,t[e[11]="DT_QINT8"]=11,t[e[12]="DT_QUINT8"]=12,t[e[13]="DT_QINT32"]=13,t[e[14]="DT_BFLOAT16"]=14,t[e[101]="DT_FLOAT_REF"]=101,t[e[102]="DT_DOUBLE_REF"]=102,t[e[103]="DT_INT32_REF"]=103,t[e[104]="DT_UINT8_REF"]=104,t[e[105]="DT_INT16_REF"]=105,t[e[106]="DT_INT8_REF"]=106,t[e[107]="DT_STRING_REF"]=107,t[e[108]="DT_COMPLEX64_REF"]=108,t[e[109]="DT_INT64_REF"]=109,t[e[110]="DT_BOOL_REF"]=110,t[e[111]="DT_QINT8_REF"]=111,t[e[112]="DT_QUINT8_REF"]=112,t[e[113]="DT_QINT32_REF"]=113,t[e[114]="DT_BFLOAT16_REF"]=114,t),a.TensorShape=function(){function e(e){if(this.dim=[],e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.dim=$util.emptyArray,e.prototype.unknownRank=!1,e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.TensorShape;e.pos<a;){var n=e.uint32();switch(n>>>3){case 2:r.dim&&r.dim.length||(r.dim=[]),r.dim.push($root.tensorflow.TensorShape.Dim.decode(e,e.uint32()));break;case 3:r.unknownRank=e.bool();break;default:e.skipType(7&n)}}return r},e.Dim=function(){function e(e){if(e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.size=$util.Long?$util.Long.fromBits(0,0,!1):0,e.prototype.name="",e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.TensorShape.Dim;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:r.size=e.int64();break;case 2:r.name=e.string();break;default:e.skipType(7&n)}}return r},e}(),e}(),a.Tensor=function(){function e(e){if(this.floatVal=[],this.doubleVal=[],this.intVal=[],this.stringVal=[],this.scomplexVal=[],this.int64Val=[],this.boolVal=[],this.uint32Val=[],this.uint64Val=[],e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.dtype=0,e.prototype.tensorShape=null,e.prototype.versionNumber=0,e.prototype.tensorContent=$util.newBuffer([]),e.prototype.floatVal=$util.emptyArray,e.prototype.doubleVal=$util.emptyArray,e.prototype.intVal=$util.emptyArray,e.prototype.stringVal=$util.emptyArray,e.prototype.scomplexVal=$util.emptyArray,e.prototype.int64Val=$util.emptyArray,e.prototype.boolVal=$util.emptyArray,e.prototype.uint32Val=$util.emptyArray,e.prototype.uint64Val=$util.emptyArray,e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.Tensor;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:r.dtype=e.int32();break;case 2:r.tensorShape=$root.tensorflow.TensorShape.decode(e,e.uint32());break;case 3:r.versionNumber=e.int32();break;case 4:r.tensorContent=e.bytes();break;case 5:if(r.floatVal&&r.floatVal.length||(r.floatVal=[]),2==(7&n))for(var o=e.uint32()+e.pos;e.pos<o;)r.floatVal.push(e.float());else r.floatVal.push(e.float());break;case 6:if(r.doubleVal&&r.doubleVal.length||(r.doubleVal=[]),2==(7&n))for(o=e.uint32()+e.pos;e.pos<o;)r.doubleVal.push(e.double());else r.doubleVal.push(e.double());break;case 7:if(r.intVal&&r.intVal.length||(r.intVal=[]),2==(7&n))for(o=e.uint32()+e.pos;e.pos<o;)r.intVal.push(e.int32());else r.intVal.push(e.int32());break;case 8:r.stringVal&&r.stringVal.length||(r.stringVal=[]),r.stringVal.push(e.bytes());break;case 9:if(r.scomplexVal&&r.scomplexVal.length||(r.scomplexVal=[]),2==(7&n))for(o=e.uint32()+e.pos;e.pos<o;)r.scomplexVal.push(e.float());else r.scomplexVal.push(e.float());break;case 10:if(r.int64Val&&r.int64Val.length||(r.int64Val=[]),2==(7&n))for(o=e.uint32()+e.pos;e.pos<o;)r.int64Val.push(e.int64());else r.int64Val.push(e.int64());break;case 11:if(r.boolVal&&r.boolVal.length||(r.boolVal=[]),2==(7&n))for(o=e.uint32()+e.pos;e.pos<o;)r.boolVal.push(e.bool());else r.boolVal.push(e.bool());break;case 16:if(r.uint32Val&&r.uint32Val.length||(r.uint32Val=[]),2==(7&n))for(o=e.uint32()+e.pos;e.pos<o;)r.uint32Val.push(e.uint32());else r.uint32Val.push(e.uint32());break;case 17:if(r.uint64Val&&r.uint64Val.length||(r.uint64Val=[]),2==(7&n))for(o=e.uint32()+e.pos;e.pos<o;)r.uint64Val.push(e.uint64());else r.uint64Val.push(e.uint64());break;default:e.skipType(7&n)}}return r},e}(),a.AttrValue=function(){function e(e){if(e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}var t;return e.prototype.list=null,e.prototype.s=$util.newBuffer([]),e.prototype.i=$util.Long?$util.Long.fromBits(0,0,!1):0,e.prototype.f=0,e.prototype.b=!1,e.prototype.type=0,e.prototype.shape=null,e.prototype.tensor=null,e.prototype.placeholder="",e.prototype.func=null,Object.defineProperty(e.prototype,"value",{get:$util.oneOfGetter(t=["list","s","i","f","b","type","shape","tensor","placeholder","func"]),set:$util.oneOfSetter(t)}),e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.AttrValue;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:r.list=$root.tensorflow.AttrValue.ListValue.decode(e,e.uint32());break;case 2:r.s=e.bytes();break;case 3:r.i=e.int64();break;case 4:r.f=e.float();break;case 5:r.b=e.bool();break;case 6:r.type=e.int32();break;case 7:r.shape=$root.tensorflow.TensorShape.decode(e,e.uint32());break;case 8:r.tensor=$root.tensorflow.Tensor.decode(e,e.uint32());break;case 9:r.placeholder=e.string();break;case 10:r.func=$root.tensorflow.NameAttrList.decode(e,e.uint32());break;default:e.skipType(7&n)}}return r},e.ListValue=function(){function e(e){if(this.s=[],this.i=[],this.f=[],this.b=[],this.type=[],this.shape=[],this.tensor=[],this.func=[],e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.s=$util.emptyArray,e.prototype.i=$util.emptyArray,e.prototype.f=$util.emptyArray,e.prototype.b=$util.emptyArray,e.prototype.type=$util.emptyArray,e.prototype.shape=$util.emptyArray,e.prototype.tensor=$util.emptyArray,e.prototype.func=$util.emptyArray,e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.AttrValue.ListValue;e.pos<a;){var n=e.uint32();switch(n>>>3){case 2:r.s&&r.s.length||(r.s=[]),r.s.push(e.bytes());break;case 3:if(r.i&&r.i.length||(r.i=[]),2==(7&n))for(var o=e.uint32()+e.pos;e.pos<o;)r.i.push(e.int64());else r.i.push(e.int64());break;case 4:if(r.f&&r.f.length||(r.f=[]),2==(7&n))for(o=e.uint32()+e.pos;e.pos<o;)r.f.push(e.float());else r.f.push(e.float());break;case 5:if(r.b&&r.b.length||(r.b=[]),2==(7&n))for(o=e.uint32()+e.pos;e.pos<o;)r.b.push(e.bool());else r.b.push(e.bool());break;case 6:if(r.type&&r.type.length||(r.type=[]),2==(7&n))for(o=e.uint32()+e.pos;e.pos<o;)r.type.push(e.int32());else r.type.push(e.int32());break;case 7:r.shape&&r.shape.length||(r.shape=[]),r.shape.push($root.tensorflow.TensorShape.decode(e,e.uint32()));break;case 8:r.tensor&&r.tensor.length||(r.tensor=[]),r.tensor.push($root.tensorflow.Tensor.decode(e,e.uint32()));break;case 9:r.func&&r.func.length||(r.func=[]),r.func.push($root.tensorflow.NameAttrList.decode(e,e.uint32()));break;default:e.skipType(7&n)}}return r},e}(),e}(),a.NameAttrList=function(){function e(e){if(this.attr={},e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.name="",e.prototype.attr=$util.emptyObject,e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a,r=void 0===t?e.len:e.pos+t,n=new $root.tensorflow.NameAttrList;e.pos<r;){var o=e.uint32();switch(o>>>3){case 1:n.name=e.string();break;case 2:e.skip().pos++,n.attr===$util.emptyObject&&(n.attr={}),a=e.string(),e.pos++,n.attr[a]=$root.tensorflow.AttrValue.decode(e,e.uint32());break;default:e.skipType(7&o)}}return n},e}(),a.NodeDef=function(){function e(e){if(this.input=[],this.attr={},e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.name="",e.prototype.op="",e.prototype.input=$util.emptyArray,e.prototype.device="",e.prototype.attr=$util.emptyObject,e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a,r=void 0===t?e.len:e.pos+t,n=new $root.tensorflow.NodeDef;e.pos<r;){var o=e.uint32();switch(o>>>3){case 1:n.name=e.string();break;case 2:n.op=e.string();break;case 3:n.input&&n.input.length||(n.input=[]),n.input.push(e.string());break;case 4:n.device=e.string();break;case 5:e.skip().pos++,n.attr===$util.emptyObject&&(n.attr={}),a=e.string(),e.pos++,n.attr[a]=$root.tensorflow.AttrValue.decode(e,e.uint32());break;default:e.skipType(7&o)}}return n},e}(),a.VersionDef=function(){function e(e){if(this.badConsumers=[],e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.producer=0,e.prototype.minConsumer=0,e.prototype.badConsumers=$util.emptyArray,e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.VersionDef;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:r.producer=e.int32();break;case 2:r.minConsumer=e.int32();break;case 3:if(r.badConsumers&&r.badConsumers.length||(r.badConsumers=[]),2==(7&n))for(var o=e.uint32()+e.pos;e.pos<o;)r.badConsumers.push(e.int32());else r.badConsumers.push(e.int32());break;default:e.skipType(7&n)}}return r},e}(),a.GraphDef=function(){function e(e){if(this.node=[],e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.node=$util.emptyArray,e.prototype.versions=null,e.prototype.library=null,e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.GraphDef;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:r.node&&r.node.length||(r.node=[]),r.node.push($root.tensorflow.NodeDef.decode(e,e.uint32()));break;case 4:r.versions=$root.tensorflow.VersionDef.decode(e,e.uint32());break;case 2:r.library=$root.tensorflow.FunctionDefLibrary.decode(e,e.uint32());break;default:e.skipType(7&n)}}return r},e}(),a.CollectionDef=function(){function e(e){if(e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}var t;return e.prototype.nodeList=null,e.prototype.bytesList=null,e.prototype.int64List=null,e.prototype.floatList=null,e.prototype.anyList=null,Object.defineProperty(e.prototype,"kind",{get:$util.oneOfGetter(t=["nodeList","bytesList","int64List","floatList","anyList"]),set:$util.oneOfSetter(t)}),e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.CollectionDef;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:r.nodeList=$root.tensorflow.CollectionDef.NodeList.decode(e,e.uint32());break;case 2:r.bytesList=$root.tensorflow.CollectionDef.BytesList.decode(e,e.uint32());break;case 3:r.int64List=$root.tensorflow.CollectionDef.Int64List.decode(e,e.uint32());break;case 4:r.floatList=$root.tensorflow.CollectionDef.FloatList.decode(e,e.uint32());break;case 5:r.anyList=$root.tensorflow.CollectionDef.AnyList.decode(e,e.uint32());break;default:e.skipType(7&n)}}return r},e.NodeList=function(){function e(e){if(this.value=[],e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.value=$util.emptyArray,e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.CollectionDef.NodeList;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:r.value&&r.value.length||(r.value=[]),r.value.push(e.string());break;default:e.skipType(7&n)}}return r},e}(),e.BytesList=function(){function e(e){if(this.value=[],e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.value=$util.emptyArray,e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.CollectionDef.BytesList;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:r.value&&r.value.length||(r.value=[]),r.value.push(e.bytes());break;default:e.skipType(7&n)}}return r},e}(),e.Int64List=function(){function e(e){if(this.value=[],e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.value=$util.emptyArray,e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.CollectionDef.Int64List;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:if(r.value&&r.value.length||(r.value=[]),2==(7&n))for(var o=e.uint32()+e.pos;e.pos<o;)r.value.push(e.int64());else r.value.push(e.int64());break;default:e.skipType(7&n)}}return r},e}(),e.FloatList=function(){function e(e){if(this.value=[],e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.value=$util.emptyArray,e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.CollectionDef.FloatList;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:if(r.value&&r.value.length||(r.value=[]),2==(7&n))for(var o=e.uint32()+e.pos;e.pos<o;)r.value.push(e.float());else r.value.push(e.float());break;default:e.skipType(7&n)}}return r},e}(),e.AnyList=function(){function e(e){if(this.value=[],e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.value=$util.emptyArray,e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.CollectionDef.AnyList;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:r.value&&r.value.length||(r.value=[]),r.value.push($root.tensorflow.Any.decode(e,e.uint32()));break;default:e.skipType(7&n)}}return r},e}(),e}(),a.SaverDef=function(){function e(e){if(e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}var t,a;return e.prototype.filenameTensorName="",e.prototype.saveTensorName="",e.prototype.restoreOpName="",e.prototype.maxToKeep=0,e.prototype.sharded=!1,e.prototype.keepCheckpointEveryNHours=0,e.prototype.version=0,e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.SaverDef;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:r.filenameTensorName=e.string();break;case 2:r.saveTensorName=e.string();break;case 3:r.restoreOpName=e.string();break;case 4:r.maxToKeep=e.int32();break;case 5:r.sharded=e.bool();break;case 6:r.keepCheckpointEveryNHours=e.float();break;case 7:r.version=e.int32();break;default:e.skipType(7&n)}}return r},e.CheckpointFormatVersion=(t={},(a=Object.create(t))[t[0]="LEGACY"]=0,a[t[1]="V1"]=1,a[t[2]="V2"]=2,a),e}(),a.TensorInfo=function(){function e(e){if(e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}var t;return e.prototype.name="",e.prototype.cooSparse=null,e.prototype.dtype=0,e.prototype.tensorShape=null,Object.defineProperty(e.prototype,"encoding",{get:$util.oneOfGetter(t=["name","cooSparse"]),set:$util.oneOfSetter(t)}),e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.TensorInfo;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:r.name=e.string();break;case 4:r.cooSparse=$root.tensorflow.TensorInfo.CooSparse.decode(e,e.uint32());break;case 2:r.dtype=e.int32();break;case 3:r.tensorShape=$root.tensorflow.TensorShape.decode(e,e.uint32());break;default:e.skipType(7&n)}}return r},e.CooSparse=function(){function e(e){if(e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.valuesTensorName="",e.prototype.indicesTensorName="",e.prototype.denseShapeTensorName="",e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.TensorInfo.CooSparse;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:r.valuesTensorName=e.string();break;case 2:r.indicesTensorName=e.string();break;case 3:r.denseShapeTensorName=e.string();break;default:e.skipType(7&n)}}return r},e}(),e}(),a.SignatureDef=function(){function e(e){if(this.inputs={},this.outputs={},e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.inputs=$util.emptyObject,e.prototype.outputs=$util.emptyObject,e.prototype.methodName="",e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a,r=void 0===t?e.len:e.pos+t,n=new $root.tensorflow.SignatureDef;e.pos<r;){var o=e.uint32();switch(o>>>3){case 1:e.skip().pos++,n.inputs===$util.emptyObject&&(n.inputs={}),a=e.string(),e.pos++,n.inputs[a]=$root.tensorflow.TensorInfo.decode(e,e.uint32());break;case 2:e.skip().pos++,n.outputs===$util.emptyObject&&(n.outputs={}),a=e.string(),e.pos++,n.outputs[a]=$root.tensorflow.TensorInfo.decode(e,e.uint32());break;case 3:n.methodName=e.string();break;default:e.skipType(7&o)}}return n},e}(),a.AssetFileDef=function(){function e(e){if(e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.tensorInfo=null,e.prototype.filename="",e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.AssetFileDef;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:r.tensorInfo=$root.tensorflow.TensorInfo.decode(e,e.uint32());break;case 2:r.filename=e.string();break;default:e.skipType(7&n)}}return r},e}(),a.OpDef=function(){function e(e){if(this.inputArg=[],this.outputArg=[],this.attr=[],e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.name="",e.prototype.inputArg=$util.emptyArray,e.prototype.outputArg=$util.emptyArray,e.prototype.attr=$util.emptyArray,e.prototype.deprecation=null,e.prototype.summary="",e.prototype.description="",e.prototype.isCommutative=!1,e.prototype.isAggregate=!1,e.prototype.isStateful=!1,e.prototype.allowsUninitializedInput=!1,e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.OpDef;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:r.name=e.string();break;case 2:r.inputArg&&r.inputArg.length||(r.inputArg=[]),r.inputArg.push($root.tensorflow.OpDef.ArgDef.decode(e,e.uint32()));break;case 3:r.outputArg&&r.outputArg.length||(r.outputArg=[]),r.outputArg.push($root.tensorflow.OpDef.ArgDef.decode(e,e.uint32()));break;case 4:r.attr&&r.attr.length||(r.attr=[]),r.attr.push($root.tensorflow.OpDef.AttrDef.decode(e,e.uint32()));break;case 8:r.deprecation=$root.tensorflow.OpDef.OpDeprecation.decode(e,e.uint32());break;case 5:r.summary=e.string();break;case 6:r.description=e.string();break;case 18:r.isCommutative=e.bool();break;case 16:r.isAggregate=e.bool();break;case 17:r.isStateful=e.bool();break;case 19:r.allowsUninitializedInput=e.bool();break;default:e.skipType(7&n)}}return r},e.ArgDef=function(){function e(e){if(e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.name="",e.prototype.description="",e.prototype.type=0,e.prototype.typeAttr="",e.prototype.numberAttr="",e.prototype.typeListAttr="",e.prototype.isRef=!1,e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.OpDef.ArgDef;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:r.name=e.string();break;case 2:r.description=e.string();break;case 3:r.type=e.int32();break;case 4:r.typeAttr=e.string();break;case 5:r.numberAttr=e.string();break;case 6:r.typeListAttr=e.string();break;case 16:r.isRef=e.bool();break;default:e.skipType(7&n)}}return r},e}(),e.AttrDef=function(){function e(e){if(e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.name="",e.prototype.type="",e.prototype.defaultValue=null,e.prototype.description="",e.prototype.hasMinimum=!1,e.prototype.minimum=$util.Long?$util.Long.fromBits(0,0,!1):0,e.prototype.allowedValues=null,e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.OpDef.AttrDef;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:r.name=e.string();break;case 2:r.type=e.string();break;case 3:r.defaultValue=$root.tensorflow.AttrValue.decode(e,e.uint32());break;case 4:r.description=e.string();break;case 5:r.hasMinimum=e.bool();break;case 6:r.minimum=e.int64();break;case 7:r.allowedValues=$root.tensorflow.AttrValue.decode(e,e.uint32());break;default:e.skipType(7&n)}}return r},e}(),e.OpDeprecation=function(){function e(e){if(e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.version=0,e.prototype.explanation="",e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.OpDef.OpDeprecation;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:r.version=e.int32();break;case 2:r.explanation=e.string();break;default:e.skipType(7&n)}}return r},e}(),e}(),a.OpList=function(){function e(e){if(this.op=[],e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.op=$util.emptyArray,e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.OpList;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:r.op&&r.op.length||(r.op=[]),r.op.push($root.tensorflow.OpDef.decode(e,e.uint32()));break;default:e.skipType(7&n)}}return r},e}(),a.MetaGraphDef=function(){function e(e){if(this.collectionDef={},this.signatureDef={},this.assetFileDef=[],e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.metaInfoDef=null,e.prototype.graphDef=null,e.prototype.saverDef=null,e.prototype.collectionDef=$util.emptyObject,e.prototype.signatureDef=$util.emptyObject,e.prototype.assetFileDef=$util.emptyArray,e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a,r=void 0===t?e.len:e.pos+t,n=new $root.tensorflow.MetaGraphDef;e.pos<r;){var o=e.uint32();switch(o>>>3){case 1:n.metaInfoDef=$root.tensorflow.MetaGraphDef.MetaInfoDef.decode(e,e.uint32());break;case 2:n.graphDef=$root.tensorflow.GraphDef.decode(e,e.uint32());break;case 3:n.saverDef=$root.tensorflow.SaverDef.decode(e,e.uint32());break;case 4:e.skip().pos++,n.collectionDef===$util.emptyObject&&(n.collectionDef={}),a=e.string(),e.pos++,n.collectionDef[a]=$root.tensorflow.CollectionDef.decode(e,e.uint32());break;case 5:e.skip().pos++,n.signatureDef===$util.emptyObject&&(n.signatureDef={}),a=e.string(),e.pos++,n.signatureDef[a]=$root.tensorflow.SignatureDef.decode(e,e.uint32());break;case 6:n.assetFileDef&&n.assetFileDef.length||(n.assetFileDef=[]),n.assetFileDef.push($root.tensorflow.AssetFileDef.decode(e,e.uint32()));break;default:e.skipType(7&o)}}return n},e.MetaInfoDef=function(){function e(e){if(this.tags=[],e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.metaGraphVersion="",e.prototype.strippedOpList=null,e.prototype.anyInfo=null,e.prototype.tags=$util.emptyArray,e.prototype.tensorflowVersion="",e.prototype.tensorflowGitVersion="",e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.MetaGraphDef.MetaInfoDef;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:r.metaGraphVersion=e.string();break;case 2:r.strippedOpList=$root.tensorflow.OpList.decode(e,e.uint32());break;case 3:r.anyInfo=$root.tensorflow.Any.decode(e,e.uint32());break;case 4:r.tags&&r.tags.length||(r.tags=[]),r.tags.push(e.string());break;case 5:r.tensorflowVersion=e.string();break;case 6:r.tensorflowGitVersion=e.string();break;default:e.skipType(7&n)}}return r},e}(),e}(),a.SavedModel=function(){function e(e){if(this.metaGraphs=[],e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.savedModelSchemaVersion=$util.Long?$util.Long.fromBits(0,0,!1):0,e.prototype.metaGraphs=$util.emptyArray,e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.SavedModel;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:r.savedModelSchemaVersion=e.int64();break;case 2:r.metaGraphs&&r.metaGraphs.length||(r.metaGraphs=[]),r.metaGraphs.push($root.tensorflow.MetaGraphDef.decode(e,e.uint32()));break;default:e.skipType(7&n)}}return r},e}(),a.FunctionDefLibrary=function(){function e(e){if(this.function=[],this.gradient=[],e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.function=$util.emptyArray,e.prototype.gradient=$util.emptyArray,e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.FunctionDefLibrary;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:r.function&&r.function.length||(r.function=[]),r.function.push($root.tensorflow.FunctionDef.decode(e,e.uint32()));break;case 2:r.gradient&&r.gradient.length||(r.gradient=[]),r.gradient.push($root.tensorflow.GradientDef.decode(e,e.uint32()));break;default:e.skipType(7&n)}}return r},e}(),a.FunctionDef=function(){function e(e){if(this.attr={},this.nodeDef=[],this.ret={},e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.signature=null,e.prototype.attr=$util.emptyObject,e.prototype.nodeDef=$util.emptyArray,e.prototype.ret=$util.emptyObject,e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a,r=void 0===t?e.len:e.pos+t,n=new $root.tensorflow.FunctionDef;e.pos<r;){var o=e.uint32();switch(o>>>3){case 1:n.signature=$root.tensorflow.OpDef.decode(e,e.uint32());break;case 5:e.skip().pos++,n.attr===$util.emptyObject&&(n.attr={}),a=e.string(),e.pos++,n.attr[a]=$root.tensorflow.AttrValue.decode(e,e.uint32());break;case 3:n.nodeDef&&n.nodeDef.length||(n.nodeDef=[]),n.nodeDef.push($root.tensorflow.NodeDef.decode(e,e.uint32()));break;case 4:e.skip().pos++,n.ret===$util.emptyObject&&(n.ret={}),a=e.string(),e.pos++,n.ret[a]=e.string();break;default:e.skipType(7&o)}}return n},e}(),a.GradientDef=function(){function e(e){if(e)for(var t=Object.keys(e),a=0;a<t.length;++a)null!=e[t[a]]&&(this[t[a]]=e[t[a]])}return e.prototype.functionName="",e.prototype.gradientFunc="",e.decode=function(e,t){e instanceof $Reader||(e=$Reader.create(e));for(var a=void 0===t?e.len:e.pos+t,r=new $root.tensorflow.GradientDef;e.pos<a;){var n=e.uint32();switch(n>>>3){case 1:r.functionName=e.string();break;case 2:r.gradientFunc=e.string();break;default:e.skipType(7&n)}}return r},e}(),a}();var compiled_api=$root,compiled_api_1=compiled_api.tensorflow;function getParamValue(e,t,a,r){var n=t.params[e];if(n&&void 0!==n.inputIndex){if("tensor"===n.type)return getTensor(t.inputNames[n.inputIndex],a,r);if("tensors"===n.type)return(0===n.inputIndex?0===n.inputParamLength?t.inputNames:t.inputNames.slice(n.inputIndex,-n.inputParamLength):t.inputNames.splice(n.inputIndex)).map(function(e){return getTensor(e,a,r)});var o=Array.prototype.slice.call(getTensor(t.inputNames.slice(n.inputIndex)[0],a,r).dataSync());return"number"===n.type?o[0]:o}return n&&n.value}function getTensor(e,t,a){var r=parseNodeName(e),n=r[0],o=r[1],s=a.currentContextIds.find(function(e){return!!t[getNodeNameWithContextId(n,e)]});return void 0!==s?t[getNodeNameWithContextId(n,s)][o]:void 0}function getTensorsForCurrentContenxt(e,t,a){return t[getNodeNameWithContextId(e,a.currentContextId)]}function getNodeNameAndIndex(e,t){var a=parseNodeName(e),r=a[0],n=a[1];return[getNodeNameWithContextId(r,t&&t.currentContextId),n]}function getNodeNameWithContextId(e,t){return t?e+"-"+t:e}function parseNodeName(e){var t=e.lastIndexOf(":");return-1===t?[e,0]:[e.substring(0,t),Number(e.substring(t+1))]}function split$1(e,t){for(var a=[],r=0;r<e.length;r+=t)a.push(e.slice(r,r+t));return a}var json=[{tfOpName:"Add",dlOpName:"add",category:"arithmetic",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfInputIndex:1,dlParamName:"b",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"AddN",dlOpName:"addN",category:"arithmetic",params:[{tfInputIndex:0,tfInputParamLength:0,dlParamName:"tensors",type:"tensors"}]},{tfOpName:"BiasAdd",dlOpName:"add",category:"arithmetic",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfInputIndex:1,dlParamName:"b",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Sub",dlOpName:"sub",category:"arithmetic",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfInputIndex:1,dlParamName:"b",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"RealDiv",dlOpName:"div",category:"arithmetic",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfInputIndex:1,dlParamName:"b",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Div",dlOpName:"div",category:"arithmetic",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfInputIndex:1,dlParamName:"b",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"FloorDiv",dlOpName:"floorDiv",category:"arithmetic",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfInputIndex:1,dlParamName:"b",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Mul",dlOpName:"mul",category:"arithmetic",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfInputIndex:1,dlParamName:"b",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Maximum",dlOpName:"maximum",category:"arithmetic",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfInputIndex:1,dlParamName:"b",type:"tensor"}]},{tfOpName:"Minimum",dlOpName:"minimum",category:"arithmetic",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfInputIndex:1,dlParamName:"b",type:"tensor"}]},{tfOpName:"Pow",dlOpName:"pow",category:"arithmetic",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfInputIndex:1,dlParamName:"b",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"SquaredDifference",dlOpName:"squaredDifference",category:"arithmetic",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfInputIndex:1,dlParamName:"b",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Mod",dlOpName:"mod",category:"arithmetic",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfInputIndex:1,dlParamName:"b",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"FloorMod",dlOpName:"mod",category:"arithmetic",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfInputIndex:1,dlParamName:"b",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]}],arithmetic=Object.freeze({json:json}),json$1=[{tfOpName:"Abs",dlOpName:"abs",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Acos",dlOpName:"acos",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Asin",dlOpName:"asin",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Atan",dlOpName:"atan",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Atan2",dlOpName:"atan2",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"y",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Ceil",dlOpName:"ceil",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"ClipByValue",dlOpName:"clipByValue",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"clip_value_min",dlParamName:"clipValueMin",type:"number"},{tfParamName:"clip_value_max",dlParamName:"clipValueMax",type:"number"}]},{tfOpName:"Cos",dlOpName:"cos",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Cosh",dlOpName:"cosh",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Elu",dlOpName:"elu",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Exp",dlOpName:"exp",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Floor",dlOpName:"floor",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Log",dlOpName:"log",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Neg",dlOpName:"neg",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Relu",dlOpName:"relu",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Relu6",dlOpName:"clipByValue",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0},{dlParamName:"clipValueMin",type:"number",defaultValue:0},{dlParamName:"clipValueMax",type:"number",defaultValue:6}]},{tfOpName:"Selu",dlOpName:"selu",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Sigmoid",dlOpName:"sigmoid",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Sin",dlOpName:"sin",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Sinh",dlOpName:"sinh",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Sqrt",dlOpName:"sqrt",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Rsqrt",dlOpName:"rsqrt",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Square",dlOpName:"square",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Tan",dlOpName:"tan",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Tanh",dlOpName:"tanh",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Sign",dlOpName:"sign",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Round",dlOpName:"round",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Expm1",dlOpName:"expm1",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Log1p",dlOpName:"log1p",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Reciprocal",dlOpName:"reciprocal",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Reciprocal",dlOpName:"reciprocal",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Softplus",dlOpName:"softplus",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Asinh",dlOpName:"asinh",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Acosh",dlOpName:"acosh",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Atanh",dlOpName:"atanh",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Erf",dlOpName:"erf",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Prod",dlOpName:"prod",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"axes",type:"number[]"},{tfParamName:"keep_dims",dlParamName:"keepDims",type:"bool",notSupported:!0},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"LeakyRelu",dlOpName:"leakyRelu",category:"basic_math",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"alpha",dlParamName:"alpha",type:"number",defaultValue:.2},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]}],basicMath=Object.freeze({json:json$1}),json$2=[{tfOpName:"LoopCond",dlOpName:"loopCond",category:"control",params:[{tfInputIndex:0,dlParamName:"pred",type:"tensor"}]},{tfOpName:"Switch",dlOpName:"switch",category:"control",params:[{tfInputIndex:0,dlParamName:"data",type:"tensor"},{tfInputIndex:1,dlParamName:"pred",type:"tensor"}]},{tfOpName:"Merge",dlOpName:"merge",category:"control",params:[{tfInputIndex:0,tfInputParamLength:0,dlParamName:"tensors",type:"tensors"}]},{tfOpName:"Enter",dlOpName:"enter",category:"control",params:[{tfInputIndex:0,dlParamName:"tensor",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0},{tfParamName:"frame_name",dlParamName:"frameName",type:"string"},{tfParamName:"is_constant",dlParamName:"isConstant",type:"bool"}]},{tfOpName:"Exit",dlOpName:"exit",category:"control",params:[{tfInputIndex:0,dlParamName:"tensor",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"NextIteration",dlOpName:"nextIteration",category:"control",params:[{tfInputIndex:0,dlParamName:"tensor",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"TensorArrayV3",dlOpName:"tensorArray",category:"control",params:[{tfInputIndex:0,dlParamName:"size",type:"number"},{tfParamName:"dtype",dlParamName:"dtype",type:"dtype"},{tfParamName:"element_shape",dlParamName:"elementShape",type:"shape"},{tfParamName:"dynamic_size",dlParamName:"dynamicSize",type:"bool"},{tfParamName:"clear_after_read",dlParamName:"clearAfterRead",type:"bool"},{tfParamName:"identical_element_shapes",dlParamName:"identicalElementShapes",type:"bool"},{tfParamName:"tensor_array_name",dlParamName:"name",type:"string"}]},{tfOpName:"TensorArrayWriteV3",dlOpName:"tensorArrayWrite",category:"control",params:[{tfInputIndex:0,dlParamName:"tensorArrayId",type:"number"},{tfInputIndex:1,dlParamName:"index",type:"number"},{tfInputIndex:2,dlParamName:"tensor",type:"tensor"},{tfInputIndex:3,dlParamName:"flowIn",type:"number"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"TensorArrayReadV3",dlOpName:"tensorArrayRead",category:"control",params:[{tfInputIndex:0,dlParamName:"tensorArrayId",type:"number"},{tfInputIndex:1,dlParamName:"index",type:"number"},{tfInputIndex:2,dlParamName:"flowIn",type:"number"},{tfParamName:"dtype",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"TensorArrayGatherV3",dlOpName:"tensorArrayGather",category:"control",params:[{tfInputIndex:0,dlParamName:"tensorArrayId",type:"number"},{tfInputIndex:1,dlParamName:"indices",type:"number[]"},{tfInputIndex:2,dlParamName:"flowIn",type:"number"},{tfParamName:"dtype",dlParamName:"dtype",type:"dtype"},{tfParamName:"element_shape",dlParamName:"elementShape",type:"shape"}]},{tfOpName:"TensorArrayScatterV3",dlOpName:"tensorArrayScatter",category:"control",params:[{tfInputIndex:0,dlParamName:"tensorArrayId",type:"number"},{tfInputIndex:1,dlParamName:"indices",type:"number[]"},{tfInputIndex:2,dlParamName:"tensor",type:"tensor"},{tfInputIndex:3,dlParamName:"flowIn",type:"number"},{tfParamName:"T",dlParamName:"dtype",type:"dtype"}]},{tfOpName:"TensorArrayConcatV3",dlOpName:"tensorArrayConcat",category:"control",params:[{tfInputIndex:0,dlParamName:"tensorArrayId",type:"number"},{tfInputIndex:1,dlParamName:"flowIn",type:"number"},{tfParamName:"dtype",dlParamName:"dtype",type:"dtype"},{tfParamName:"element_shape_except0",dlParamName:"elementShapeExcept0",type:"shape",notSupported:!0}]},{tfOpName:"TensorArraySplitV3",dlOpName:"tensorArraySplit",category:"control",params:[{tfInputIndex:0,dlParamName:"tensorArrayId",type:"number"},{tfInputIndex:1,dlParamName:"tensor",type:"tensor"},{tfInputIndex:2,dlParamName:"lengths",type:"number[]"},{tfInputIndex:3,dlParamName:"flowIn",type:"number"},{tfParamName:"T",dlParamName:"dtype",type:"dtype"}]},{tfOpName:"TensorArraySizeV3",dlOpName:"tensorArraySize",category:"control",params:[{tfInputIndex:0,dlParamName:"tensorArrayId",type:"number"},{tfInputIndex:1,dlParamName:"flowIn",type:"number"}]},{tfOpName:"TensorArrayCloseV3",dlOpName:"tensorArrayClose",category:"control",params:[{tfInputIndex:0,dlParamName:"tensorArrayId",type:"number"}]}],control=Object.freeze({json:json$2}),json$3=[{tfOpName:"AvgPool",dlOpName:"avgPool",category:"convolution",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"strides",dlParamName:"strides",type:"number[]"},{tfParamName:"padding",dlParamName:"pad",type:"string"},{tfParamName:"data_format",dlParamName:"dataFormat",type:"string",notSupported:!0},{tfParamName:"ksize",dlParamName:"kernelSize",type:"number[]"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"MaxPool",dlOpName:"maxPool",category:"convolution",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"strides",dlParamName:"strides",type:"number[]"},{tfParamName:"padding",dlParamName:"pad",type:"string"},{tfParamName:"data_format",dlParamName:"dataFormat",type:"string",notSupported:!0},{tfParamName:"ksize",dlParamName:"kernelSize",type:"number[]"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Conv1D",dlOpName:"conv1d",category:"convolution",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"filter",type:"tensor"},{tfParamName:"stride",dlParamName:"stride",type:"number"},{tfParamName:"padding",dlParamName:"pad",type:"string"},{tfParamName:"data_format",dlParamName:"dataFormat",type:"string",defaultValue:"NWC"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0},{tfParamName:"dilation",dlParamName:"dilation",type:"number",defaultValue:1}]},{tfOpName:"Conv2D",dlOpName:"conv2d",category:"convolution",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"filter",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0},{tfParamName:"strides",dlParamName:"strides",type:"number[]"},{tfParamName:"padding",dlParamName:"pad",type:"string"},{tfParamName:"useCudnnOnGpu",dlParamName:"useCudnnOnGpu",type:"bool"},{tfParamName:"data_format",dlParamName:"dataFormat",type:"string",defaultValue:"NHWC"},{tfParamName:"dilations",dlParamName:"dilations",type:"number[]"}]},{tfOpName:"Conv2DBackpropInput",dlOpName:"conv2dTranspose",category:"convolution",params:[{tfInputIndex:2,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"filter",type:"tensor"},{tfInputIndex:0,dlParamName:"outputShape",type:"number[]"},{tfParamName:"strides",dlParamName:"strides",type:"number[]"},{tfParamName:"padding",dlParamName:"pad",type:"string"},{tfParamName:"data_format",dlParamName:"dataFormat",type:"string",notSupported:!0}]},{tfOpName:"DepthwiseConv2d",dlOpName:"depthwiseConv2d",category:"convolution",params:[{tfInputIndex:0,dlParamName:"input",type:"tensor"},{tfInputIndex:1,dlParamName:"filter",type:"tensor"},{tfParamName:"strides",dlParamName:"strides",type:"number[]"},{tfParamName:"padding",dlParamName:"pad",type:"string"},{tfParamName:"data_format",dlParamName:"dataFormat",type:"string",defaultValue:"NHWC"},{tfParamName:"dilations",dlParamName:"dilations",type:"number[]"}]},{tfOpName:"DepthwiseConv2dNative",dlOpName:"depthwiseConv2d",category:"convolution",params:[{tfInputIndex:0,dlParamName:"input",type:"tensor"},{tfInputIndex:1,dlParamName:"filter",type:"tensor"},{tfParamName:"strides",dlParamName:"strides",type:"number[]"},{tfParamName:"padding",dlParamName:"pad",type:"string"},{tfParamName:"data_format",dlParamName:"dataFormat",type:"string",defaultValue:"NHWC"},{tfParamName:"dilations",dlParamName:"dilations",type:"number[]"}]}],convolution=Object.freeze({json:json$3}),json$4=[{tfOpName:"Fill",dlOpName:"fill",category:"creation",params:[{tfInputIndex:0,dlParamName:"shape",type:"number[]"},{tfInputIndex:1,dlParamName:"value",type:"number"},{tfParamName:"T",dlParamName:"dtype",type:"dtype"}]},{tfOpName:"LinSpace",dlOpName:"linspace",category:"creation",params:[{tfInputIndex:0,dlParamName:"start",type:"number"},{tfInputIndex:1,dlParamName:"stop",type:"number"},{tfInputIndex:2,dlParamName:"num",type:"number"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"OneHot",dlOpName:"oneHot",category:"creation",params:[{tfInputIndex:0,dlParamName:"indices",type:"tensor"},{tfInputIndex:1,dlParamName:"depth",type:"number"},{tfInputIndex:2,dlParamName:"onValue",type:"number",defaultValue:1},{tfInputIndex:3,dlParamName:"offValue",type:"number",defaultValue:0},{tfParamName:"axis",dlParamName:"axis",type:"number",notSupported:!0},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Ones",dlOpName:"ones",category:"creation",params:[{tfInputIndex:0,dlParamName:"shape",type:"number[]"},{tfParamName:"T",dlParamName:"dtype",type:"dtype"}]},{tfOpName:"OnesLike",dlOpName:"onesLike",category:"creation",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"dtype",dlParamName:"dtype",type:"dtype"}]},{tfOpName:"RandomUniform",dlOpName:"randomUniform",category:"creation",params:[{tfInputIndex:0,dlParamName:"shape",type:"number[]"},{tfParamName:"minval",dlParamName:"minval",type:"number",defaultValue:0},{tfParamName:"maxval",dlParamName:"maxval",type:"number",defaultValue:1},{tfParamName:"dtype",dlParamName:"dtype",type:"dtype"},{tfParamName:"seed",dlParamName:"seed",type:"number",defaultValue:0},{tfParamName:"seed2",dlParamName:"seed2",type:"number",defaultValue:0,notSupported:!0},{tfParamName:"T",dlParamName:"T",type:"number",notSupported:!0}]},{tfOpName:"Range",dlOpName:"range",category:"creation",params:[{tfInputIndex:0,dlParamName:"start",type:"number"},{tfInputIndex:1,dlParamName:"stop",type:"number"},{tfInputIndex:2,dlParamName:"step",type:"number",defaultValue:0},{tfParamName:"Tidx",dlParamName:"dtype",type:"dtype"}]},{tfOpName:"truncatedNormal",dlOpName:"truncatedNormal",category:"creation",params:[{tfInputIndex:0,dlParamName:"shape",type:"number[]"},{tfParamName:"means",dlParamName:"mean",type:"number",defaultValue:0},{tfParamName:"stddev",dlParamName:"stdDev",type:"number",defaultValue:1},{tfParamName:"seed",dlParamName:"seed",type:"number"},{tfParamName:"seed2",dlParamName:"seed2",type:"number",defaultValue:0,notSupported:!0},{tfParamName:"dtype",dlParamName:"dtype",type:"dtype"},{tfParamName:"T",dlParamName:"T",type:"number",notSupported:!0}]},{tfOpName:"Zeros",dlOpName:"zeros",category:"creation",params:[{tfInputIndex:0,dlParamName:"shape",type:"number[]"},{tfParamName:"T",dlParamName:"dtype",type:"dtype"}]},{tfOpName:"ZerosLike",dlOpName:"zerosLike",category:"creation",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype"}]}],creation=Object.freeze({json:json$4}),json$5=[{tfOpName:"NonMaxSuppressionV2",dlOpName:"nonMaxSuppression",category:"dynamic",params:[{tfInputIndex:0,dlParamName:"boxes",type:"tensor"},{tfInputIndex:1,dlParamName:"scores",type:"tensor"},{tfInputIndex:2,dlParamName:"maxOutputSize",type:"number"},{tfInputIndex:3,dlParamName:"iouThreshold",type:"number"}]},{tfOpName:"NonMaxSuppressionV3",dlOpName:"nonMaxSuppression",category:"dynamic",params:[{tfInputIndex:0,dlParamName:"boxes",type:"tensor"},{tfInputIndex:1,dlParamName:"scores",type:"tensor"},{tfInputIndex:2,dlParamName:"maxOutputSize",type:"number"},{tfInputIndex:3,dlParamName:"iouThreshold",type:"number"},{tfInputIndex:4,dlParamName:"scoreThreshold",type:"number"}]},{tfOpName:"Where",dlOpName:"whereAsync",category:"dynamic",params:[{tfInputIndex:0,dlParamName:"condition",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"ListDiff",dlOpName:"setdiff1dAsync",category:"dynamic",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"y",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]}],dynamic=Object.freeze({json:json$5}),json$6=[{tfOpName:"TopKV2",dlOpName:"topK",category:"evaluation",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"k",type:"number"},{tfParamName:"sorted",dlParamName:"sorted",type:"bool"}]}],evaluation=Object.freeze({json:json$6}),json$7=[{tfOpName:"PlaceholderWithDefault",dlOpName:"placeholder",category:"graph",params:[{tfInputIndex:0,dlParamName:"default",type:"tensor"},{tfParamName:"shape",dlParamName:"shape",type:"shape"},{tfParamName:"dtype",dlParamName:"dtype",type:"dtype"}]},{tfOpName:"Placeholder",dlOpName:"placeholder",category:"graph",params:[{tfParamName:"shape",dlParamName:"shape",type:"shape"},{tfParamName:"dtype",dlParamName:"dtype",type:"dtype"}]},{tfOpName:"Const",dlOpName:"const",category:"graph"},{tfOpName:"Identity",dlOpName:"identity",category:"graph",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"}]},{tfOpName:"Snapshot",dlOpName:"snapshot",category:"graph",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"}]},{tfOpName:"Rank",dlOpName:"rank",category:"graph",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"}]},{tfOpName:"Size",dlOpName:"size",category:"graph",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"}]},{tfOpName:"Shape",dlOpName:"shape",category:"graph",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"}]},{tfOpName:"ShapeN",dlOpName:"shapeN",category:"graph",params:[{tfInputIndex:0,tfInputParamLength:0,dlParamName:"x",type:"tensors"}]},{tfOpName:"Print",dlOpName:"print",category:"graph",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,tfInputParamLength:1,dlParamName:"data",type:"tensors"},{tfParamName:"message",dlParamName:"message",type:"string"},{tfParamName:"first_n",dlParamName:"firstN",type:"number",notSupprted:!0},{tfParamName:"summarize",dlParamName:"summarize",type:"number",defaultValue:3}]},{tfOpName:"NoOp",dlOpName:"noop",category:"graph",params:[]},{tfOpName:"StopGradient",dlOpName:"stopGradient",category:"graph",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"}]},{tfOpName:"FakeQuantWithMinMaxVars",dlOpName:"fakeQuantWithMinMaxVars",category:"graph",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"min",dlParamName:"min",type:"number"},{tfParamName:"max",dlParamName:"max",type:"number"}]}],graph=Object.freeze({json:json$7}),json$8=[{tfOpName:"ResizeBilinear",dlOpName:"resizeBilinear",category:"image",params:[{tfInputIndex:0,dlParamName:"images",type:"tensor"},{tfInputIndex:1,dlParamName:"size",type:"number[]"},{tfParamName:"align_corners",dlParamName:"alignCorners",type:"bool"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"ResizeNearestNeighbor",dlOpName:"resizeNearestNeighbor",category:"image",params:[{tfInputIndex:0,dlParamName:"images",type:"tensor"},{tfInputIndex:1,dlParamName:"size",type:"number[]"},{tfParamName:"align_corners",dlParamName:"alignCorners",type:"bool"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"CropAndResize",dlOpName:"cropAndResize",category:"image",params:[{tfInputIndex:0,dlParamName:"image",type:"tensor"},{tfInputIndex:1,dlParamName:"boxes",type:"tensor"},{tfInputIndex:2,dlParamName:"boxInd",type:"tensor"},{tfInputIndex:3,dlParamName:"cropSize",type:"number[]"},{tfParamName:"method",dlParamName:"method",type:"string"},{tfParamName:"extrapolation_value",dlParamName:"extrapolationValue",type:"number"}]}],image$1=Object.freeze({json:json$8}),json$9=[{tfOpName:"Equal",dlOpName:"equal",category:"logical",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfInputIndex:1,dlParamName:"b",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"NotEqual",dlOpName:"notEqual",category:"logical",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfInputIndex:1,dlParamName:"b",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Greater",dlOpName:"greater",category:"logical",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfInputIndex:1,dlParamName:"b",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"GreaterEqual",dlOpName:"greaterEqual",category:"logical",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfInputIndex:1,dlParamName:"b",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Less",dlOpName:"less",category:"logical",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfInputIndex:1,dlParamName:"b",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"LessEqual",dlOpName:"lessEqual",category:"logical",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfInputIndex:1,dlParamName:"b",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"LogicalAnd",dlOpName:"logicalAnd",category:"logical",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfInputIndex:1,dlParamName:"b",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"LogicalNot",dlOpName:"logicalNot",category:"logical",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"LogicalOr",dlOpName:"logicalOr",category:"logical",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfInputIndex:1,dlParamName:"b",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Select",dlOpName:"where",category:"logical",params:[{tfInputIndex:0,dlParamName:"condition",type:"tensor"},{tfInputIndex:1,dlParamName:"a",type:"tensor"},{tfInputIndex:2,dlParamName:"b",type:"tensor"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]}],logical=Object.freeze({json:json$9}),json$10=[{tfOpName:"MatMul",dlOpName:"matMul",category:"matrices",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfInputIndex:1,dlParamName:"b",type:"tensor"},{tfParamName:"transpose_a",dlParamName:"transposeA",type:"bool",defaultValue:!1},{tfParamName:"transpose_b",dlParamName:"transposeB",type:"bool",defaultValue:!1},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"BatchMatMul",dlOpName:"matMul",category:"matrices",params:[{tfInputIndex:0,dlParamName:"a",type:"tensor"},{tfInputIndex:1,dlParamName:"b",type:"tensor"},{tfParamName:"adj_x",dlParamName:"transposeA",type:"bool",defaultValue:!1},{tfParamName:"adj_y",dlParamName:"transposeB",type:"bool",defaultValue:!1},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]},{tfOpName:"Transpose",dlOpName:"transpose",category:"matrices",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"perm",type:"number[]"},{tfParamName:"T",dlParamName:"dtype",type:"dtype",notSupported:!0}]}],matrices=Object.freeze({json:json$10}),json$11=[{tfOpName:"FusedBatchNorm",dlOpName:"batchNormalization",category:"normalization",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"scale",type:"tensor"},{tfInputIndex:2,dlParamName:"offset",type:"tensor"},{tfInputIndex:3,dlParamName:"mean",type:"tensor"},{tfInputIndex:4,dlParamName:"variance",type:"tensor"},{tfParamName:"epsilon",dlParamName:"epsilon",type:"number",defaultValue:.001},{tfParamName:"data_format",dlParamName:"dataFormat",type:"string",notSupported:!0}]},{tfOpName:"FusedBatchNormV2",dlOpName:"batchNormalization",category:"normalization",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"scale",type:"tensor"},{tfInputIndex:2,dlParamName:"offset",type:"tensor"},{tfInputIndex:3,dlParamName:"mean",type:"tensor"},{tfInputIndex:4,dlParamName:"variance",type:"tensor"},{tfParamName:"epsilon",dlParamName:"epsilon",type:"number",defaultValue:.001},{tfParamName:"data_format",dlParamName:"dataFormat",type:"string",notSupported:!0}]},{tfOpName:"LRN",dlOpName:"localResponseNormalization",category:"normalization",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"depth_radius",dlParamName:"radius",type:"number",defaultValue:5},{tfParamName:"bias",dlParamName:"bias",type:"number",defaultValue:1},{tfParamName:"alpha",dlParamName:"alpha",type:"number",defaultValue:1},{tfParamName:"beta",dlParamName:"beta",type:"number",defaultValue:.5}]},{tfOpName:"Softmax",dlOpName:"softmax",category:"normalization",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"}]},{tfOpName:"LogSoftmax",dlOpName:"logSoftmax",category:"normalization",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"}]},{tfOpName:"SparseToDense",dlOpName:"sparseToDense",category:"normalization",params:[{tfInputIndex:0,dlParamName:"sparseIndices",type:"tensor"},{tfInputIndex:1,dlParamName:"outputShape",type:"number[]"},{tfInputIndex:2,dlParamName:"sparseValues",type:"tensor"},{tfInputIndex:3,dlParamName:"defaultValue",type:"tensor"},{tfParamName:"validate_indices",dlParamName:"validateIndices",type:"bool",defaultValue:!0,notSupported:!0}]}],normalization=Object.freeze({json:json$11}),json$12=[{tfOpName:"Max",dlOpName:"max",category:"reduction",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"axis",type:"number[]"},{tfParamName:"keep_dims",dlParamName:"keepDims",type:"bool"}]},{tfOpName:"Mean",dlOpName:"mean",category:"reduction",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"axis",type:"number[]"},{tfParamName:"keep_dims",dlParamName:"keepDims",type:"bool"}]},{tfOpName:"Min",dlOpName:"min",category:"reduction",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"axis",type:"number[]"},{tfParamName:"keep_dims",dlParamName:"keepDims",type:"bool"}]},{tfOpName:"Sum",dlOpName:"sum",category:"reduction",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"axis",type:"number[]"},{tfParamName:"keep_dims",dlParamName:"keepDims",type:"bool"}]},{tfOpName:"All",dlOpName:"all",category:"reduction",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"axis",type:"number[]"},{tfParamName:"keep_dims",dlParamName:"keepDims",type:"bool"}]},{tfOpName:"Any",dlOpName:"any",category:"reduction",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"axis",type:"number[]"},{tfParamName:"keep_dims",dlParamName:"keepDims",type:"bool"}]},{tfOpName:"ArgMax",dlOpName:"argMax",category:"reduction",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"axis",type:"number"}]},{tfOpName:"ArgMin",dlOpName:"argMin",category:"reduction",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"axis",type:"number"}]},{tfOpName:"Prod",dlOpName:"prod",category:"reduction",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"axis",type:"number[]"},{tfParamName:"keep_dims",dlParamName:"keepDims",type:"bool"}]}],reduction=Object.freeze({json:json$12}),json$13=[{tfOpName:"ConcatV2",dlOpName:"concat",category:"slice_join",params:[{tfInputIndex:0,tfInputParamLength:1,dlParamName:"tensors",type:"tensors"},{tfInputIndex:-1,dlParamName:"axis",type:"number"}]},{tfOpName:"Concat",dlOpName:"concat",category:"slice_join",params:[{tfInputIndex:1,tfInputParamLength:1,dlParamName:"tensors",type:"tensors"},{tfInputIndex:0,dlParamName:"axis",type:"number"}]},{tfOpName:"GatherV2",dlOpName:"gather",category:"slice_join",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"indices",type:"tensor"},{tfInputIndex:2,dlParamName:"axis",type:"number",defaultValue:0}]},{tfOpName:"Gather",dlOpName:"gather",category:"slice_join",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"indices",type:"tensor"},{tfParamName:"axis",dlParamName:"axis",type:"number",defaultValue:0},{tfParamName:"validate_indices",dlParamName:"validateIndices",type:"bool",notSupported:!0}]},{tfOpName:"Reverse",dlOpName:"reverse",category:"slice_join",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"dims",type:"bool",notSupported:!0}]},{tfOpName:"ReverseV2",dlOpName:"reverse",category:"slice_join",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"axis",type:"number[]"}]},{tfOpName:"Slice",dlOpName:"slice",category:"slice_join",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"begin",type:"number[]"},{tfInputIndex:2,dlParamName:"size",type:"number[]"}]},{tfOpName:"StridedSlice",dlOpName:"stridedSlice",category:"slice_join",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"begin",type:"number[]"},{tfInputIndex:2,dlParamName:"end",type:"number[]"},{tfInputIndex:3,dlParamName:"strides",type:"number[]"},{tfParamName:"begin_mask",dlParamName:"beginMask",type:"number",defaultValue:0},{tfParamName:"end_mask",dlParamName:"endMask",type:"number",defaultValue:0},{tfParamName:"new_axis_mask",dlParamName:"newAxisMask",type:"number",defaultValue:0},{tfParamName:"ellipsis_mask",dlParamName:"ellipsisMask",type:"number",defaultValue:0},{tfParamName:"shrink_axis_mask",dlParamName:"shrinkAxisMask",type:"number",defaultValue:0}]},{tfOpName:"Pack",dlOpName:"stack",category:"slice_join",params:[{tfInputIndex:0,tfInputParamLength:0,dlParamName:"tensors",type:"tensors"},{tfParamName:"axis",dlParamName:"axis",type:"number",defaultValue:0}]},{tfOpName:"Unpack",dlOpName:"unstack",category:"slice_join",params:[{tfInputIndex:0,tfInputParamLength:0,dlParamName:"tensor",type:"tensor"},{tfParamName:"axis",dlParamName:"axis",type:"number",defaultValue:0},{tfParamName:"num",dlParamName:"num",type:"number",defaultValue:0,notSupported:!0}]},{tfOpName:"Tile",dlOpName:"tile",category:"slice_join",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"reps",type:"number[]"}]},{tfOpName:"Split",dlOpName:"split",category:"slice_join",params:[{tfInputIndex:0,dlParamName:"axis",type:"number",defaultValue:0},{tfInputIndex:1,dlParamName:"x",type:"tensor"},{tfParamName:"num_split",dlParamName:"numOrSizeSplits",type:"number",defaultValue:1}]},{tfOpName:"SplitV",dlOpName:"split",category:"slice_join",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"numOrSizeSplits",type:"number[]"},{tfInputIndex:2,dlParamName:"axis",type:"number",defaultValue:0}]},{tfOpName:"ScatterNd",dlOpName:"scatterNd",category:"slice_join",params:[{tfInputIndex:0,dlParamName:"indices",type:"tensor"},{tfInputIndex:1,dlParamName:"values",type:"tensor"},{tfInputIndex:2,dlParamName:"shape",type:"number[]"}]},{tfOpName:"GatherNd",dlOpName:"gatherNd",category:"slice_join",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"indices",type:"tensor"}]},{tfOpName:"SparseToDense",dlOpName:"sparseToDense",category:"slice_join",params:[{tfInputIndex:0,dlParamName:"sparseIndices",type:"tensor"},{tfInputIndex:1,dlParamName:"outputShape",type:"number[]"},{tfInputIndex:2,dlParamName:"sparseValues",type:"tensor"},{tfInputIndex:3,dlParamName:"defaultValue",type:"tensor"},{tfParamName:"validate_indices",dlParamName:"validateIndices",type:"bool",defaultValue:!1,notSupported:!0}]}],sliceJoin=Object.freeze({json:json$13}),json$14=[{tfOpName:"Cast",dlOpName:"cast",category:"transformation",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"SrcT",dlParamName:"sdtype",type:"dtype",notSupported:!0},{tfParamName:"DstT",dlParamName:"dtype",type:"dtype"}]},{tfOpName:"ExpandDims",dlOpName:"expandDims",category:"transformation",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,tfParamNameDeprecated:"dim",dlParamName:"axis",type:"number"}]},{tfOpName:"Pad",dlOpName:"pad",category:"transformation",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"padding",type:"number[]"},{tfParamName:"constant_value",dlParamName:"constantValue",type:"number",defaultValue:0}]},{tfOpName:"PadV2",dlOpName:"pad",category:"transformation",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"padding",type:"number[]"},{tfInputIndex:2,dlParamName:"constantValue",type:"number",defaultValue:0}]},{tfOpName:"Reshape",dlOpName:"reshape",category:"transformation",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"shape",type:"number[]"}]},{tfOpName:"Squeeze",dlOpName:"squeeze",category:"transformation",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"axis",tfParamNameDeprecated:"squeeze_dims",dlParamName:"axis",type:"number[]"}]},{tfOpName:"SpaceToBatchND",dlOpName:"spaceToBatchND",category:"transformation",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"blockShape",type:"number[]"},{tfInputIndex:2,dlParamName:"paddings",type:"number[]"}]},{tfOpName:"BatchToSpaceND",dlOpName:"batchToSpaceND",category:"transformation",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfInputIndex:1,dlParamName:"blockShape",type:"number[]"},{tfInputIndex:2,dlParamName:"crops",type:"number[]"}]},{tfOpName:"DepthToSpace",dlOpName:"depthToSpace",category:"transformation",params:[{tfInputIndex:0,dlParamName:"x",type:"tensor"},{tfParamName:"block_size",dlParamName:"blockSize",type:"number"},{tfParamName:"data_format",dlParamName:"dataFormat",type:"string"}]}],transformation=Object.freeze({json:json$14}),CONTROL_FLOW_OPS=["Switch","Merge","Enter","Exit","NextIteration"],DYNAMIC_SHAPE_OPS=["NonMaxSuppressionV2","NonMaxSuppressionV3","Where"],OperationMapper=function(){function e(){var e=[arithmetic,basicMath,control,convolution,creation,dynamic,evaluation,logical,image$1,graph,matrices,normalization,reduction,sliceJoin,transformation],t=[].concat.apply([],e.map(function(e){return e.json}));this.opMappers=t.reduce(function(e,t){return e[t.tfOpName]=t,e},{})}return Object.defineProperty(e,"Instance",{get:function(){return this._instance||(this._instance=new this)},enumerable:!0,configurable:!0}),e.prototype.isControlFlow=function(e){return CONTROL_FLOW_OPS.some(function(t){return t===e.op})},e.prototype.isDynamicShape=function(e){return DYNAMIC_SHAPE_OPS.some(function(t){return t===e.op})},e.prototype.transformGraph=function(e){var t=this,a=!1,r=!1,n=[],o=[],s=e.node.reduce(function(e,s){return e[s.name]=t.mapNode(s),t.isControlFlow(s)&&(a=!0),t.isDynamicShape(s)&&(r=!0),"Placeholder"===s.op&&n.push(e[s.name]),"Const"===s.op&&o.push(e[s.name]),e},{}),i=[],p=[];return Object.keys(s).forEach(function(e){var t=s[e];t.inputNames.forEach(function(e){var a=getNodeNameAndIndex(e)[0];t.inputs.push(s[a]),s[a].children.push(t)}),0===t.inputs.length&&i.push(t)}),Object.keys(s).forEach(function(e){var t=s[e];0===t.children.length&&p.push(t)}),{nodes:s,inputs:i,outputs:p,weights:o,placeholders:n,withControlFlow:a,withDynamicShape:r}},e.prototype.mapNode=function(e){var t=this,a=this.opMappers[e.op];if(void 0===a)throw new Error("Tensorflow Op is not supported: "+e.op);var r={name:e.name,op:a.dlOpName,category:a.category,inputNames:(e.input||[]).map(function(e){return e.startsWith("^")?e.substr(1):e}),inputs:[],children:[],params:{}};return a.params&&(r.params=a.params.reduce(function(a,r){var n=r.tfInputIndex,o=r.tfInputParamLength,s=r.type,i=void 0;if(void 0===n)switch(r.type){case"string":void 0===(i=t.getStringParam(e.attr,r.tfParamName,r.defaultValue))&&r.tfParamNameDeprecated&&(i=t.getStringParam(e.attr,r.tfParamNameDeprecated,r.defaultValue));break;case"number":void 0===(i=t.getNumberParam(e.attr,r.tfParamName,r.defaultValue))&&r.tfParamNameDeprecated&&(i=t.getNumberParam(e.attr,r.tfParamNameDeprecated,r.defaultValue));break;case"number[]":void 0===(i=t.getNumericArrayParam(e.attr,r.tfParamName,r.defaultValue))&&r.tfParamNameDeprecated&&(i=t.getNumericArrayParam(e.attr,r.tfParamNameDeprecated,r.defaultValue));break;case"bool":void 0===(i=t.getBoolParam(e.attr,r.tfParamName,r.defaultValue))&&r.tfParamNameDeprecated&&(i=t.getBoolParam(e.attr,r.tfParamNameDeprecated,r.defaultValue));break;case"shape":void 0===(i=t.getTensorShapeParam(e.attr,r.tfParamName,r.defaultValue))&&r.tfParamNameDeprecated&&(i=t.getTensorShapeParam(e.attr,r.tfParamNameDeprecated,r.defaultValue));break;case"dtype":void 0===(i=t.getDtypeParam(e.attr,r.tfParamName,r.defaultValue))&&r.tfParamNameDeprecated&&(i=t.getDtypeParam(e.attr,r.tfParamNameDeprecated,r.defaultValue));break;case"tensor":case"tensors":break;default:throw new Error("Unsupported param type: "+r.type+" for op: "+e.op)}return a[r.dlParamName]={value:i,inputIndex:n,type:s,inputParamLength:o},a},{})),r},e.prototype.getStringParam=function(e,t,a,r){void 0===r&&(r=!1);var n=e[t];if(void 0!==n){var o=String.fromCharCode.apply(null,n.s);return r?o:o.toLowerCase()}return a},e.prototype.getBoolParam=function(e,t,a){var r=e[t];return r?r.b:a},e.prototype.getNumberParam=function(e,t,a){var r=e[t],n=r?r[r.value]:a;return"number"==typeof n?n:n.toInt()},e.prototype.getDtypeParam=function(e,t,a){var r=e[t];if(r&&r.type)switch(r.type){case compiled_api_1.DataType.DT_FLOAT:return"float32";case compiled_api_1.DataType.DT_INT32:return"int32";case compiled_api_1.DataType.DT_BOOL:return"bool";default:return a}return a},e.prototype.getTensorShapeParam=function(e,t,a){var r=e[t];return r&&r.shape?r.shape.dim.map(function(e){return"number"==typeof e.size?e.size:e.size.toInt()}):a},e.prototype.getNumericArrayParam=function(e,t,a){var r=e[t];return r?(r.list.f&&r.list.f.length?r.list.f:r.list.i).map(function(e){return"number"==typeof e?e:e.toInt()}):a},e}(),executeOp=function(e,t,a){switch(e.op){case"add":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["g" /* add */])(getParamValue("a",e,t,a),getParamValue("b",e,t,a))];case"addN":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["h" /* addN */])(getParamValue("tensors",e,t,a))];case"mod":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_24" /* mod */])(getParamValue("a",e,t,a),getParamValue("b",e,t,a))];case"mul":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_27" /* mul */])(getParamValue("a",e,t,a),getParamValue("b",e,t,a))];case"div":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["N" /* div */])(getParamValue("a",e,t,a),getParamValue("b",e,t,a))];case"floorDiv":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["X" /* floorDiv */])(getParamValue("a",e,t,a),getParamValue("b",e,t,a))];case"sub":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_73" /* sub */])(getParamValue("a",e,t,a),getParamValue("b",e,t,a))];case"minimum":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_23" /* minimum */])(getParamValue("a",e,t,a),getParamValue("b",e,t,a))];case"maximum":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_20" /* maximum */])(getParamValue("a",e,t,a),getParamValue("b",e,t,a))];case"pow":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_36" /* pow */])(getParamValue("a",e,t,a),getParamValue("b",e,t,a))];case"squaredDifference":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_68" /* squaredDifference */])(getParamValue("a",e,t,a),getParamValue("b",e,t,a))];default:throw TypeError("Node type "+e.op+" is not implemented")}},executeOp$1=function(e,t,a){switch(e.op){case"abs":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["d" /* abs */])(getParamValue("x",e,t,a))];case"acos":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["e" /* acos */])(getParamValue("x",e,t,a))];case"acosh":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["f" /* acosh */])(getParamValue("x",e,t,a))];case"asin":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["m" /* asin */])(getParamValue("x",e,t,a))];case"asinh":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["n" /* asinh */])(getParamValue("x",e,t,a))];case"atan":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["o" /* atan */])(getParamValue("x",e,t,a))];case"atan2":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["p" /* atan2 */])(getParamValue("x",e,t,a),getParamValue("y",e,t,a))];case"atanh":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["q" /* atanh */])(getParamValue("x",e,t,a))];case"ceil":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["y" /* ceil */])(getParamValue("x",e,t,a))];case"cos":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["I" /* cos */])(getParamValue("x",e,t,a))];case"cosh":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["J" /* cosh */])(getParamValue("x",e,t,a))];case"elu":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["O" /* elu */])(getParamValue("x",e,t,a))];case"erf":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["Q" /* erf */])(getParamValue("x",e,t,a))];case"exp":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["R" /* exp */])(getParamValue("x",e,t,a))];case"expm1":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["T" /* expm1 */])(getParamValue("x",e,t,a))];case"floor":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["W" /* floor */])(getParamValue("x",e,t,a))];case"log":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_11" /* log */])(getParamValue("x",e,t,a))];case"log1p":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_12" /* log1p */])(getParamValue("x",e,t,a))];case"neg":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_29" /* neg */])(getParamValue("x",e,t,a))];case"reciprocal":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_41" /* reciprocal */])(getParamValue("x",e,t,a))];case"relu":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_42" /* relu */])(getParamValue("x",e,t,a))];case"round":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_45" /* round */])(getParamValue("x",e,t,a))];case"selu":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_48" /* selu */])(getParamValue("x",e,t,a))];case"sigmoid":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_52" /* sigmoid */])(getParamValue("x",e,t,a))];case"sin":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_54" /* sin */])(getParamValue("x",e,t,a))];case"sign":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_53" /* sign */])(getParamValue("x",e,t,a))];case"sinh":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_55" /* sinh */])(getParamValue("x",e,t,a))];case"softplus":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_62" /* softplus */])(getParamValue("x",e,t,a))];case"sqrt":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_66" /* sqrt */])(getParamValue("x",e,t,a))];case"square":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_67" /* square */])(getParamValue("x",e,t,a))];case"tanh":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_76" /* tanh */])(getParamValue("x",e,t,a))];case"tan":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_75" /* tan */])(getParamValue("x",e,t,a))];case"clipByValue":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["z" /* clipByValue */])(getParamValue("x",e,t,a),getParamValue("clipValueMin",e,t,a),getParamValue("clipValueMax",e,t,a))];case"rsqrt":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["N" /* div */])(Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_46" /* scalar */])(1,"float32"),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_66" /* sqrt */])(getTensor(e.inputNames[0],t,a)))];case"prod":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_37" /* prod */])(getParamValue("x",e,t,a),getParamValue("axes",e,t,a))];case"leakyRelu":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_5" /* leakyRelu */])(getParamValue("x",e,t,a),getParamValue("alpha",e,t,a))];default:throw TypeError("Node type "+e.op+" is not implemented")}},TensorArray=function(){function e(t,a,r,n,o,s,i){this.name=t,this.dtype=a,this.maxSize=r,this.elementShape=n,this.identicalElementShapes=o,this.dynamicSize=s,this.clearAfterRead=i,this.tensors=[],this.closed_=!1,this.id=e.nextId++}return Object.defineProperty(e.prototype,"closed",{get:function(){return this.closed_},enumerable:!0,configurable:!0}),e.prototype.clearAndClose=function(){this.tensors.forEach(function(e){return e.tensor.dispose()}),this.tensors=[],this.closed_=!0},e.prototype.size=function(){return this.tensors.length},e.prototype.read=function(e){if(this.closed_)throw new Error("TensorArray "+this.name+" has already been closed.");if(e<0||e>=this.tensors.length)throw new Error("Tried to read from index "+e+", but array size is: "+this.tensors.length);var t=this.tensors[e];if(t.cleared)throw new Error("TensorArray "+this.name+": Could not read index "+e+" twice because it was cleared after a previous read (perhaps try setting clear_after_read = false?).");return this.clearAfterRead&&(t.cleared=!0),t.read=!0,t.tensor},e.prototype.readMany=function(e){var t=this;return e.map(function(e){return t.read(e)})},e.prototype.write=function(e,t){if(this.closed_)throw new Error("TensorArray "+this.name+" has already been closed.");if(e<0||!this.dynamicSize&&e>=this.maxSize)throw new Error("Tried to write to index "+e+", but array is not resizeable and size is: "+this.maxSize);var a=this.tensors[e]||{};if(t.dtype!==this.dtype)throw new Error("TensorArray "+this.name+": Could not write to TensorArray index "+e+",\n          because the value dtype is "+t.dtype+", but TensorArray dtype is "+this.dtype+".");if(0===this.size()&&0===this.elementShape.length&&(this.elementShape=t.shape),this.assertShapesMatch(this.elementShape,t.shape,"TensorArray "+this.name+": Could not write to TensorArray index "+e+"."),a&&a.read)throw new Error("TensorArray "+this.name+": Could not write to TensorArray index "+e+", because it has already been read.");if(a&&a.written)throw new Error("TensorArray "+this.name+": Could not write to TensorArray index "+e+", because it has already been written.");a.tensor=t,a.written=!0,this.tensors[e]=a},e.prototype.writeMany=function(e,t){var a=this;if(e.length!==t.length)throw new Error("TensorArray "+this.name+": could not write multiple tensors,because the index size: "+e.length+" is not the same as tensors size: "+t.length+".");e.forEach(function(e,r){return a.write(e,t[r])})},e.prototype.gather=function(e,t){if(t&&t!==this.dtype)throw new Error("TensorArray dtype is "+this.dtype+" but gather requested dtype "+t);if(!e){e=[];for(var a=0;a<this.size();a++)e.push(a)}if(0===e.length)return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_77" /* tensor */])([],[0].concat(this.elementShape));var r=this.readMany(e);return this.assertShapesMatch(this.elementShape,r[0].shape,"TensorArray shape mismatch: "),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_70" /* stack */])(r,0)},e.prototype.concat=function(e){if(e&&e!==this.dtype)throw new Error("TensorArray dtype is "+this.dtype+" but concat requested dtype "+e);if(0===this.size())return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_77" /* tensor */])([],[0].concat(this.elementShape));for(var t=[],a=0;a<this.size();a++)t.push(a);var r=this.readMany(t);return this.assertShapesMatch(this.elementShape,r[0].shape,"TensorArray shape mismatch: tensor array shape ("+this.elementShape+") vs first tensor shape ("+r[0].shape+")"),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["A" /* concat */])(r,0)},e.prototype.scatter=function(e,t){if(t.dtype!==this.dtype)throw new Error("TensorArray dtype is "+this.dtype+" but tensor has dtype "+t.dtype);if(e.length!==t.shape[0])throw new Error("Expected len(indices) == tensor.shape[0], but saw: "+e.length+" vs. "+t.shape[0]);var a=Math.max.apply(Math,e);if(!this.dynamicSize&&a>=this.maxSize)throw new Error("Max index must be < array size ("+a+"  vs. "+this.maxSize+")");this.writeMany(e,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_85" /* unstack */])(t,0))},e.prototype.split=function(e,t){var a=this;if(t.dtype!==this.dtype)throw new Error("TensorArray dtype is "+this.dtype+" but tensor has dtype "+t.dtype);var r=0,n=e.map(function(e){return r+=e});if(r!==t.shape[0])throw new Error("Expected sum of lengths to be equal to\n          tensor.shape[0], but sum of lengths is\n        "+r+", and tensor's shape is: "+t.shape);if(!this.dynamicSize&&e.length!==this.maxSize)throw new Error("TensorArray's size is not equal to the size of lengths ("+this.maxSize+" vs. "+e.length+"), and the TensorArray is not marked as dynamically resizeable");var o=0===r?0:t.size/r,s=[];Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){t=t.reshape([1,r,o]);for(var i=0;i<e.length;++i){var p=[0,0===i?0:n[i-1],0],m=[1,e[i],o];s[i]=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_56" /* slice */])(t,p,m).reshape(a.elementShape)}return s});for(var i=[],p=0;p<e.length;p++)i[p]=p;this.writeMany(i,s)},e.prototype.assertShapesMatch=function(e,t,a){void 0===a&&(a=""),__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].assert(this.arraysEqual(e,t),a+" Shapes "+e+" and "+t+" must match")},e.prototype.arraysEqual=function(e,t){if(e.length!==t.length)return!1;for(var a=0;a<e.length;a++)if(-1!==e[a]&&-1!==t[a]&&e[a]!==t[a])return!1;return!0},e.nextId=0,e}();function executeOp$2(e,t,a){return __awaiter(this,void 0,void 0,function(){var r,n,o,s,i,p,m,u,l,d,c,f,y,h,g,N,P,x,b,I,v,O,V,w,T,k,S,$,_,A,D,j,E,C,R;return __generator(this,function(L){switch(L.label){case 0:switch(e.op){case"loopCond":return[3,1];case"switch":return[3,2];case"merge":return[3,4];case"enter":return[3,5];case"exit":return[3,6];case"nextIteration":return[3,7];case"tensorArray":return[3,8];case"tensorArrayWrite":return[3,9];case"tensorArrayRead":return[3,10];case"tensorArrayGather":return[3,11];case"tensorArrayScatter":return[3,12];case"tensorArrayConcat":return[3,13];case"tensorArraySplit":return[3,14];case"tensorArraySize":return[3,15];case"tensorArrayClose":return[3,16]}return[3,17];case 1:return[2,[getParamValue("pred",e,t,a).clone()]];case 2:return r=getParamValue("pred",e,t,a),n=getParamValue("data",e,t,a),[4,r.data()];case 3:return[2,L.sent()[0]?[void 0,n.clone()]:[n.clone(),void 0]];case 4:return[2,(o=e.inputNames.find(function(e){return void 0!==getTensor(e,t,a)}))?[getTensor(o,t,a).clone()]:void 0];case 5:return s=getParamValue("frameName",e,t,a),i=getParamValue("tensor",e,t,a),a.enterFrame(s),[2,[i.clone()]];case 6:return p=getParamValue("tensor",e,t,a),a.exitFrame(),[2,[p.clone()]];case 7:return m=getParamValue("tensor",e,t,a),a.nextIteration(),[2,[m.clone()]];case 8:return u=getParamValue("size",e,t,a),l=getParamValue("dtype",e,t,a),d=getParamValue("elementShape",e,t,a),c=getParamValue("dynamicSize",e,t,a),f=getParamValue("clearAfterRead",e,t,a),y=getParamValue("identicalElementShapes",e,t,a),h=getParamValue("name",e,t,a),g=new TensorArray(h,l,u,d,y,c,f),a.addTensorArray(g),[2,[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_46" /* scalar */])(g.id),Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_46" /* scalar */])(1)]];case 9:return N=getParamValue("tensorArrayId",e,t,a),P=getParamValue("index",e,t,a),x=getParamValue("tensor",e,t,a),a.getTensorArray(N).write(P,x),[2,[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_46" /* scalar */])(1)]];case 10:return b=getParamValue("tensorArrayId",e,t,a),I=getParamValue("index",e,t,a),[2,[a.getTensorArray(b).read(I)]];case 11:return v=getParamValue("tensorArrayId",e,t,a),O=getParamValue("indices",e,t,a),V=getParamValue("dtype",e,t,a),[2,[a.getTensorArray(v).gather(O,V)]];case 12:return w=getParamValue("tensorArrayId",e,t,a),T=getParamValue("indices",e,t,a),k=getParamValue("tensor",e,t,a),a.getTensorArray(w).scatter(T,k),[2,[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_46" /* scalar */])(1)]];case 13:return S=getParamValue("tensorArrayId",e,t,a),$=a.getTensorArray(S),_=getParamValue("dtype",e,t,a),[2,[$.concat(_)]];case 14:return A=getParamValue("tensorArrayId",e,t,a),D=getParamValue("tensor",e,t,a),j=getParamValue("lengths",e,t,a),a.getTensorArray(A).split(j,D),[2,[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_46" /* scalar */])(1)]];case 15:return E=getParamValue("tensorArrayId",e,t,a),C=a.getTensorArray(E),[2,[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_46" /* scalar */])(C.size(),"int32")]];case 16:return R=getParamValue("tensorArrayId",e,t,a),a.getTensorArray(R).clearAndClose(),[2,[]];case 17:throw TypeError("Node type "+e.op+" is not implemented")}})})}var executeOp$3=function(e,t,a){switch(e.op){case"conv1d":var r=getParamValue("stride",e,t,a),n=getParamValue("pad",e,t,a),o=getParamValue("dataFormat",e,t,a).toUpperCase(),s=getParamValue("dilation",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["F" /* conv1d */])(getParamValue("x",e,t,a),getParamValue("filter",e,t,a),r,n,o,s)];case"conv2d":r=getParamValue("strides",e,t,a),n=getParamValue("pad",e,t,a),o=getParamValue("dataFormat",e,t,a).toUpperCase();var i=getParamValue("dilations",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["G" /* conv2d */])(getParamValue("x",e,t,a),getParamValue("filter",e,t,a),[r[1],r[2]],n,o,[i[0],i[1]])];case"conv2dTranspose":var p=getParamValue("outputShape",e,t,a);r=getParamValue("strides",e,t,a),n=getParamValue("pad",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["H" /* conv2dTranspose */])(getParamValue("x",e,t,a),getParamValue("filter",e,t,a),p,[r[1],r[2]],n)];case"depthwiseConv2d":r=getParamValue("strides",e,t,a),n=getParamValue("pad",e,t,a),i=getParamValue("dilations",e,t,a),o=getParamValue("dataFormat",e,t,a).toUpperCase();return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["L" /* depthwiseConv2d */])(getParamValue("input",e,t,a),getParamValue("filter",e,t,a),[r[1],r[2]],n,o,[i[0],i[1]])];case"avgPool":r=getParamValue("strides",e,t,a),n=getParamValue("pad",e,t,a);var m=getParamValue("kernelSize",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["r" /* avgPool */])(getParamValue("x",e,t,a),[m[1],m[2]],[r[1],r[2]],n)];case"maxPool":r=getParamValue("strides",e,t,a),n=getParamValue("pad",e,t,a),m=getParamValue("kernelSize",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_19" /* maxPool */])(getParamValue("x",e,t,a),[m[1],m[2]],[r[1],r[2]],n)];default:throw TypeError("Node type "+e.op+" is not implemented")}},executeOp$4=function(e,t,a){switch(e.op){case"fill":var r=getParamValue("shape",e,t,a),n=getParamValue("dtype",e,t,a),o=getParamValue("value",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["V" /* fill */])(r,o,n)];case"linspace":var s=getParamValue("start",e,t,a),i=getParamValue("stop",e,t,a),p=getParamValue("num",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_9" /* linspace */])(s,i,p)];case"oneHot":var m=getParamValue("indices",e,t,a),u=getParamValue("depth",e,t,a),l=getParamValue("onValue",e,t,a),d=getParamValue("offValue",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_32" /* oneHot */])(m,u,l,d)];case"ones":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_33" /* ones */])(getParamValue("shape",e,t,a),getParamValue("dtype",e,t,a))];case"onesLike":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_34" /* onesLike */])(getParamValue("x",e,t,a))];case"randomUniform":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_39" /* randomUniform */])(getParamValue("shape",e,t,a),getParamValue("minval",e,t,a),getParamValue("maxval",e,t,a),getParamValue("dtype",e,t,a))];case"range":s=getParamValue("start",e,t,a);var c=getParamValue("stop",e,t,a),f=getParamValue("step",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_40" /* range */])(s,c,f,getParamValue("dtype",e,t,a))];case"truncatedNormal":r=getParamValue("shape",e,t,a);var y=getParamValue("mean",e,t,a),h=getParamValue("stdDev",e,t,a),g=getParamValue("seed",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_84" /* truncatedNormal */])(r,y,h,getParamValue("dtype",e,t,a),g)];case"zeros":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_91" /* zeros */])(getParamValue("shape",e,t,a),getParamValue("dtype",e,t,a))];case"zerosLike":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_92" /* zerosLike */])(getParamValue("x",e,t,a))];default:throw TypeError("Node type "+e.op+" is not implemented")}};function executeOp$5(e,t,a){return __awaiter(this,void 0,void 0,function(){var r,n,o,s,i;return __generator(this,function(p){switch(p.label){case 0:switch(e.op){case"nonMaxSuppression":return[3,1];case"whereAsync":return[3,3];case"setdiff1dAsync":return[3,5]}return[3,7];case 1:return r=getParamValue("boxes",e,t,a),n=getParamValue("scores",e,t,a),o=getParamValue("maxOutputSize",e,t,a),s=getParamValue("iouThreshold",e,t,a),i=getParamValue("scoreThreshold",e,t,a),[4,__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_2" /* image */].nonMaxSuppressionAsync(r,n,o,s,i)];case 2:return[2,[p.sent()]];case 3:return[4,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_90" /* whereAsync */])(getParamValue("condition",e,t,a))];case 4:return[2,[p.sent()]];case 5:return[4,Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_51" /* setdiff1dAsync */])(getParamValue("x",e,t,a),getParamValue("y",e,t,a))];case 6:return[2,p.sent()];case 7:throw TypeError("Node type "+e.op+" is not implemented")}})})}var executeOp$6=function(e,t,a){switch(e.op){case"topK":var r=getParamValue("x",e,t,a),n=getParamValue("k",e,t,a),o=getParamValue("sorted",e,t,a),s=Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_81" /* topk */])(r,n,o);return[s.values,s.indices];default:throw TypeError("Node type "+e.op+" is not implemented")}},executeOp$7=function(e,t,a){switch(e.op){case"const":return t[e.name];case"placeholder":var r=getParamValue("default",e,t,a);return[getTensor(e.name,t,a)||r];case"identity":case"stopGradient":case"fakeQuantWithMinMaxVars":return[getParamValue("x",e,t,a).clone()];case"snapshot":return[getParamValue("x",e,t,a).clone()];case"shape":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_78" /* tensor1d */])(getParamValue("x",e,t,a).shape,"int32")];case"shapeN":return getParamValue("x",e,t,a).map(function(e){return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_78" /* tensor1d */])(e.shape)});case"size":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_46" /* scalar */])(getParamValue("x",e,t,a).size,"int32")];case"rank":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_46" /* scalar */])(getParamValue("x",e,t,a).rank,"int32")];case"noop":return[];case"print":var n=getParamValue("x",e,t,a),o=getParamValue("data",e,t,a),s=getParamValue("message",e,t,a),i=getParamValue("summarize",e,t,a);console.warn("The graph has a tf.print() operation,usually used for debugging, which slows down performance."),console.log(s);for(var p=0;p<o.length;p++)console.log(Array.prototype.slice.call(o[0].dataSync()).slice(0,i));return[n];default:throw TypeError("Node type "+e.op+" is not implemented")}},executeOp$8=function(e,t,a){switch(e.op){case"resizeBilinear":var r=getParamValue("images",e,t,a),n=getParamValue("size",e,t,a),o=getParamValue("alignCorners",e,t,a);return[__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_2" /* image */].resizeBilinear(r,[n[0],n[1]],o)];case"resizeNearestNeighbor":r=getParamValue("images",e,t,a),n=getParamValue("size",e,t,a),o=getParamValue("alignCorners",e,t,a);return[__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_2" /* image */].resizeNearestNeighbor(r,[n[0],n[1]],o)];case"cropAndResize":var s=getParamValue("image",e,t,a),i=getParamValue("boxes",e,t,a),p=getParamValue("boxInd",e,t,a),m=getParamValue("cropSize",e,t,a),u=getParamValue("method",e,t,a),l=getParamValue("extrapolationValue",e,t,a);return[__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_2" /* image */].cropAndResize(s,i,p,m,u,l)];default:throw TypeError("Node type "+e.op+" is not implemented")}},executeOp$9=function(e,t,a){switch(e.op){case"equal":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["P" /* equal */])(getParamValue("a",e,t,a),getParamValue("b",e,t,a))];case"notEqual":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_31" /* notEqual */])(getParamValue("a",e,t,a),getParamValue("b",e,t,a))];case"greater":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_0" /* greater */])(getParamValue("a",e,t,a),getParamValue("b",e,t,a))];case"greaterEqual":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_1" /* greaterEqual */])(getParamValue("a",e,t,a),getParamValue("b",e,t,a))];case"less":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_6" /* less */])(getParamValue("a",e,t,a),getParamValue("b",e,t,a))];case"lessEqual":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_7" /* lessEqual */])(getParamValue("a",e,t,a),getParamValue("b",e,t,a))];case"logicalAnd":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_14" /* logicalAnd */])(getParamValue("a",e,t,a),getParamValue("b",e,t,a))];case"logicalNot":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_15" /* logicalNot */])(getParamValue("a",e,t,a))];case"logicalOr":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_16" /* logicalOr */])(getParamValue("a",e,t,a),getParamValue("b",e,t,a))];case"where":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_89" /* where */])(getParamValue("condition",e,t,a),getParamValue("a",e,t,a),getParamValue("b",e,t,a))];default:throw TypeError("Node type "+e.op+" is not implemented")}},executeOp$10=function(e,t,a){switch(e.op){case"matMul":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_17" /* matMul */])(getParamValue("a",e,t,a),getParamValue("b",e,t,a),getParamValue("transposeA",e,t,a),getParamValue("transposeB",e,t,a))];case"transpose":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_83" /* transpose */])(getParamValue("x",e,t,a),getParamValue("perm",e,t,a))];default:throw TypeError("Node type "+e.op+" is not implemented")}},executeOp$11=function(e,t,a){switch(e.op){case"batchNormalization":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["s" /* batchNormalization */])(getParamValue("x",e,t,a),getParamValue("mean",e,t,a),getParamValue("variance",e,t,a),getParamValue("epsilon",e,t,a),getParamValue("scale",e,t,a),getParamValue("offset",e,t,a))];case"localResponseNormalization":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_10" /* localResponseNormalization */])(getParamValue("x",e,t,a),getParamValue("radius",e,t,a),getParamValue("bias",e,t,a),getParamValue("alpha",e,t,a),getParamValue("beta",e,t,a))];case"softmax":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_61" /* softmax */])(getParamValue("x",e,t,a))];case"logSoftmax":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_13" /* logSoftmax */])(getParamValue("x",e,t,a))];case"sparseToDense":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_64" /* sparseToDense */])(getParamValue("sparseIndices",e,t,a),getParamValue("outputShape",e,t,a),getParamValue("sparseValues",e,t,a),getParamValue("defaultValue",e,t,a))];default:throw TypeError("Node type "+e.op+" is not implemented")}},executeOp$12=function(e,t,a){switch(e.op){case"max":var r=getParamValue("axis",e,t,a),n=getParamValue("keepDims",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_18" /* max */])(getParamValue("x",e,t,a),r,n)];case"mean":r=getParamValue("axis",e,t,a),n=getParamValue("keepDims",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_21" /* mean */])(getParamValue("x",e,t,a),r,n)];case"min":r=getParamValue("axis",e,t,a),n=getParamValue("keepDims",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_22" /* min */])(getParamValue("x",e,t,a),r,n)];case"sum":r=getParamValue("axis",e,t,a),n=getParamValue("keepDims",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_74" /* sum */])(getParamValue("x",e,t,a),r,n)];case"all":r=getParamValue("axis",e,t,a),n=getParamValue("keepDims",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["i" /* all */])(getParamValue("x",e,t,a),r,n)];case"any":r=getParamValue("axis",e,t,a),n=getParamValue("keepDims",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["j" /* any */])(getParamValue("x",e,t,a),r,n)];case"argMax":r=getParamValue("axis",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["k" /* argMax */])(getParamValue("x",e,t,a),r)];case"argMin":r=getParamValue("axis",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["l" /* argMin */])(getParamValue("x",e,t,a),r)];case"prod":r=getParamValue("axis",e,t,a),n=getParamValue("keepDims",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_37" /* prod */])(getParamValue("x",e,t,a),r,n)];default:throw TypeError("Node type "+e.op+" is not implemented")}},executeOp$13=function(e,t,a){switch(e.op){case"concat":var r=getParamValue("axis",e,t,a),n=getParamValue("tensors",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["A" /* concat */])(n,r)];case"gather":r=getParamValue("axis",e,t,a);var o=getParamValue("x",e,t,a),s=getParamValue("indices",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["Y" /* gather */])(o,s,r)];case"reverse":r=getParamValue("axis",e,t,a),o=getParamValue("x",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_44" /* reverse */])(o,r)];case"slice":var i=getParamValue("begin",e,t,a),p=getParamValue("size",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_56" /* slice */])(getParamValue("x",e,t,a),i,p)];case"stridedSlice":i=getParamValue("begin",e,t,a);var m=getParamValue("end",e,t,a),u=getParamValue("strides",e,t,a),l=getParamValue("beginMask",e,t,a),d=getParamValue("endMask",e,t,a),c=getParamValue("ellipsisMask",e,t,a),f=getParamValue("newAxisMask",e,t,a),y=getParamValue("shrinkAxisMask",e,t,a),h=getParamValue("x",e,t,a);if(1===i.length&&h.shape.length>1)for(var g=1;g<h.shape.length;g++)i.push(0),m.push(h.shape[g]),u.push(u[0]);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_72" /* stridedSlice */])(h,i,m,u,l,d,c,f,y)];case"stack":return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var r=getParamValue("axis",e,t,a),n=getParamValue("tensors",e,t,a),o=n[0].shape,s=n[0].squeeze().shape,i=n.map(function(e){var t=__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].arraysEqual(e.shape,o);if(!t&&!__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].arraysEqual(e.squeeze().shape,s))throw new Error("the input tensors shape does not match");return t?e:e.reshape(o)});return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_70" /* stack */])(i,r)]});case"unstack":return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){var r=getParamValue("axis",e,t,a),n=getParamValue("tensor",e,t,a);return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_85" /* unstack */])(n,r)});case"tile":var N=getParamValue("reps",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_80" /* tile */])(getParamValue("x",e,t,a),N)];case"split":r=getParamValue("axis",e,t,a);var P=getParamValue("numOrSizeSplits",e,t,a);return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_65" /* split */])(getParamValue("x",e,t,a),P,r);case"scatterNd":s=getParamValue("indices",e,t,a);var x=getParamValue("values",e,t,a),b=getParamValue("shape",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_47" /* scatterND */])(s,x,b)];case"gatherNd":var I=getParamValue("x",e,t,a);s=getParamValue("indices",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["Z" /* gatherND */])(I,s)];case"sparseToDense":s=getParamValue("sparseIndices",e,t,a),b=getParamValue("outputShape",e,t,a);var v=getParamValue("sparseValues",e,t,a),O=getParamValue("defaultValue",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_64" /* sparseToDense */])(s,v,b,O)];default:throw TypeError("Node type "+e.op+" is not implemented")}},executeOp$14=function(e,t,a){switch(e.op){case"cast":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["x" /* cast */])(getParamValue("x",e,t,a),getParamValue("dtype",e,t,a))];case"expandDims":var r=getParamValue("axis",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["S" /* expandDims */])(getParamValue("x",e,t,a),r)];case"squeeze":r=getParamValue("axis",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_69" /* squeeze */])(getParamValue("x",e,t,a),r)];case"reshape":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_43" /* reshape */])(getParamValue("x",e,t,a),getParamValue("shape",e,t,a))];case"pad":return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_35" /* pad */])(getParamValue("x",e,t,a),split$1(getParamValue("padding",e,t,a),2),getParamValue("constantValue",e,t,a))];case"spaceToBatchND":var n=getParamValue("blockShape",e,t,a),o=split$1(getParamValue("paddings",e,t,a),2);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_63" /* spaceToBatchND */])(getParamValue("x",e,t,a),n,o)];case"batchToSpaceND":n=getParamValue("blockShape",e,t,a);var s=split$1(getParamValue("crops",e,t,a),2);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["w" /* batchToSpaceND */])(getParamValue("x",e,t,a),n,s)];case"depthToSpace":var i=getParamValue("blockSize",e,t,a),p=getParamValue("dataFormat",e,t,a);return[Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["K" /* depthToSpace */])(getParamValue("x",e,t,a),i,p)];default:throw TypeError("Node type "+e.op+" is not implemented")}};function executeOp$15(e,t,a){switch(e.category){case"arithmetic":return executeOp(e,t,a);case"basic_math":return executeOp$1(e,t,a);case"control":return executeOp$2(e,t,a);case"convolution":return executeOp$3(e,t,a);case"creation":return executeOp$4(e,t,a);case"dynamic":return executeOp$5(e,t,a);case"evaluation":return executeOp$6(e,t,a);case"image":return executeOp$8(e,t,a);case"graph":return executeOp$7(e,t,a);case"logical":return executeOp$9(e,t,a);case"matrices":return executeOp$10(e,t,a);case"normalization":return executeOp$11(e,t,a);case"reduction":return executeOp$12(e,t,a);case"slice_join":return executeOp$13(e,t,a);case"transformation":return executeOp$14(e,t,a);default:throw TypeError("Node type "+e.op+" is not implemented")}}var ExecutionContext=function(){function e(e,t){this.weightMap=e,this.tensorArrayMap=t,this.rootContext={id:0,frameName:"",iterationId:0},this.contexts=[this.rootContext],this.lastId=0,this.generateCurrentContextIds()}return e.prototype.newFrame=function(e,t){return{id:e,frameName:t,iterationId:0}},Object.defineProperty(e.prototype,"currentContext",{get:function(){return this.contexts},set:function(e){this.contexts!==e&&(this.contexts=e,this.generateCurrentContextIds())},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"currentContextId",{get:function(){return this._currentContextIds[0]},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"currentContextIds",{get:function(){return this._currentContextIds},enumerable:!0,configurable:!0}),e.prototype.generateCurrentContextIds=function(){for(var e=[],t=0;t<this.contexts.length-1;t++){var a=this.contexts.slice(0,this.contexts.length-t);e.push(this.contextIdforContexts(a))}e.push(""),this._currentContextIds=e},e.prototype.contextIdforContexts=function(e){return e?e.map(function(e){return 0===e.id&&0===e.iterationId?"":e.frameName+"-"+e.iterationId}).join("/"):""},e.prototype.enterFrame=function(e){this.contexts&&(this.lastId++,this.contexts=this.contexts.slice(),this.contexts.push(this.newFrame(this.lastId,e)),this._currentContextIds.unshift(this.contextIdforContexts(this.contexts)))},e.prototype.exitFrame=function(){if(!(this.contexts&&this.contexts.length>1))throw new Error("Cannot exit frame, the context is empty");this.contexts=this.contexts.slice(),this.contexts.splice(-1),this.currentContextIds.shift()},e.prototype.nextIteration=function(){if(!(this.contexts&&this.contexts.length>0))throw new Error("Cannot increase frame iteration, the context is empty");this.contexts=this.contexts.slice(),this.lastId++;var e=Object.assign({},this.contexts[this.contexts.length-1]);e.iterationId+=1,e.id=this.lastId,this.contexts.splice(-1,1,e),this._currentContextIds.splice(0,1,this.contextIdforContexts(this.contexts))},e.prototype.getWeight=function(e){return this.weightMap[e]},e.prototype.addTensorArray=function(e){this.tensorArrayMap[e.id]=e},e.prototype.getTensorArray=function(e){return this.tensorArrayMap[e]},e}(),GraphExecutor=function(){function e(e){this.graph=e,this.compiledMap=new Map,this._weightMap={},this.SEPERATOR=",",this.placeholders=e.placeholders,this._outputs=e.outputs,this.compile()}return Object.defineProperty(e.prototype,"weightMap",{get:function(){return this._weightMap},set:function(e){var t=Object.keys(e).map(function(t){return e[t].map(function(e){return e.id})});this.weightIds=[].concat.apply([],t),this._weightMap=e},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"inputs",{get:function(){return this.placeholders.map(function(e){return{name:e.name,shape:e.params.shape?e.params.shape.value:void 0,dtype:e.params.dtype?e.params.dtype.value:void 0}})},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"outputs",{get:function(){return this._outputs.map(function(e){return{name:e.name,shape:e.params.shape?e.params.shape.value:void 0,dtype:e.params.dtype?e.params.dtype.value:void 0}})},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"inputNodes",{get:function(){return this.placeholders.map(function(e){return e.name})},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"outputNodes",{get:function(){return this.outputs.map(function(e){return e.name})},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"isControlFlowModel",{get:function(){return this.graph.withControlFlow},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"isDynamicShapeModel",{get:function(){return this.graph.withDynamicShape},enumerable:!0,configurable:!0}),e.prototype.compile=function(e){if(!this.graph.withControlFlow&&!this.graph.withDynamicShape){var t=[],a=e||this.graph.placeholders,r=a.map(function(e){return e.name}).sort().join(this.SEPERATOR);if(!this.compiledMap.get(r)){for(var n=a.concat(this.graph.weights),o={};n.length>0;){var s=n.pop();o[s.name]=!0,t.push(s),s.children.forEach(function(e){!o[e.name]&&e.inputNames.every(function(e){var t=getNodeNameAndIndex(e)[0];return o[t]})&&n.push(e)})}this.compiledMap.set(r,t)}}},e.prototype.execute=function(e,t,a){var r=this;void 0===t&&(t=!0);var n=Object.keys(e).sort();this.checkInput(e,t),this.checkInputShapeAndType(e,t),this.compile(n.map(function(e){return r.graph.nodes[e]}));var o=this.calculateOutputs(a);this.checkOutput(this.compiledMap.get(n.join(this.SEPERATOR)),o);var s={};return Object(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_79" /* tidy */])(function(){for(var t=new ExecutionContext(r._weightMap,s),a=__assign({},r.weightMap,e),i=r.getFrozenTensorIds(a),p={},m=r.compiledMap.get(n.join(r.SEPERATOR)),u=0;u<m.length;u++){var l=m[u];if(a[l.name]||(a[l.name]=executeOp$15(l,a,t),r.checkTensorForDisposal(l.name,l,a,t,i,p)),o.every(function(e){return!!a[e]}))break}return r.findOutputs(a,t,o)})},e.prototype.getFrozenTensorIds=function(e){var t=[].concat.apply([],Object.keys(e).map(function(t){return e[t]}).map(function(e){return e.map(function(e){return e.id})}));return new Set(t)},e.prototype.checkTensorForDisposal=function(e,t,a,r,n,o){"control"!==t.category&&(a[e].forEach(function(e){null!=e&&(o[e.id]=(o[e.id]||0)+t.children.length)}),t.inputs.forEach(function(e){if("control"!==e.category){var t=getTensorsForCurrentContenxt(e.name,a,r);null!=t&&t.forEach(function(e){if(e&&!n.has(e.id)){var t=o[e.id];1===t?(e.dispose(),delete o[e.id]):null!=t&&o[e.id]--}})}}))},e.prototype.executeAsync=function(e,t){return __awaiter(this,void 0,void 0,function(){var a,r,n,o,s,i,p,m=this;return __generator(this,function(u){switch(u.label){case 0:return this.checkInput(e,!1),this.checkInputShapeAndType(e,!1),a={},r=new ExecutionContext(this._weightMap,a),[4,this.executeWithControlFlow(e,r)];case 1:return n=u.sent(),o=this.findOutputs(n,r,t),s=Object.keys(o).map(function(e){return o[e].id}),i=Object.keys(e).map(function(t){return e[t].map(function(e){return e.id})}),p=[].concat.apply([],i),Object.keys(n).forEach(function(e){n[e].forEach(function(e){e&&-1===s.indexOf(e.id)&&-1===p.indexOf(e.id)&&-1===m.weightIds.indexOf(e.id)&&e.dispose()})}),[2,o]}})})},e.prototype.executeWithControlFlow=function(e,t){return __awaiter(this,void 0,void 0,function(){var a,r,n,o,s,i,p,m,u=this;return __generator(this,function(l){switch(l.label){case 0:a=Object.keys(e),r=a.map(function(e){return u.graph.nodes[e]}),n=r.concat(this.graph.weights).map(function(e){return{node:e,contexts:t.currentContext}}),o=__assign({},this.weightMap,e),s={},i=this.getFrozenTensorIds(o),p={},l.label=1;case 1:return n.length>0?(m=this.processStack(r,n,t,o,p,i,s),[4,Promise.all(m)]):[3,3];case 2:return l.sent(),[3,1];case 3:return[2,o]}})})},e.prototype.processStack=function(e,t,a,r,n,o,s){for(var i=this,p=[],m=function(){var m=t.pop();a.currentContext=m.contexts;var l="";if("enter"===m.node.op&&getParamValue("isConstant",m.node,r,a)&&(l=getNodeNameAndIndex(m.node.name,a)[0]),-1===e.indexOf(m.node)){var d=executeOp$15(m.node,r,a);l||(l=getNodeNameAndIndex(m.node.name,a)[0]);var c=a.currentContext;d instanceof Promise?p.push(d.then(function(e){return r[l]=e,a.currentContext=c,i.checkTensorForDisposal(l,m.node,r,a,o,s),i.processChildNodes(m.node,t,a,r,n),e})):(r[l]=d,u.checkTensorForDisposal(l,m.node,r,a,o,s),u.processChildNodes(m.node,t,a,r,n))}else u.processChildNodes(m.node,t,a,r,n)},u=this;t.length>0;)m();return p},e.prototype.processChildNodes=function(e,t,a,r,n){e.children.forEach(function(e){var o=getNodeNameAndIndex(e.name,a)[0];n[o]||("merge"===e.op?e.inputNames.some(function(e){return!!getTensor(e,r,a)})&&(n[o]=!0,t.push({contexts:a.currentContext,node:e})):e.inputNames.every(function(e){return!!getTensor(e,r,a)})&&(n[o]=!0,t.push({contexts:a.currentContext,node:e})))})},e.prototype.calculateOutputs=function(e){return!e||e instanceof Array||(e=[e]),e||this.graph.outputs.map(function(e){return e.name})},e.prototype.findOutputs=function(e,t,a){return this.calculateOutputs(a).reduce(function(a,r){return a[r]=getTensor(r,e,t),a},{})},e.prototype.dispose=function(){var e=this;Object.keys(this.weightMap).forEach(function(t){return e.weightMap[t].forEach(function(e){return e.dispose()})})},e.prototype.checkInputShapeAndType=function(e,t){void 0===t&&(t=!0),this.placeholders.forEach(function(a){var r=e[a.name];if(t||r){var n=r[0];if(a.params.shape&&a.params.shape.value){var o=a.params.shape.value,s=o.length===n.shape.length&&n.shape.every(function(e,t){return-1===o[t]||o[t]===e});__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].assert(s,"The shape of dict['"+a.name+"'] provided in model.execute(dict) must be ["+o+"], but was ["+n.shape+"]")}a.params.dtype&&a.params.dtype.value&&__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_86" /* util */].assert(n.dtype===a.params.dtype.value,"The dtype of dict['"+a.name+"'] provided in model.execute(dict) must be "+a.params.dtype.value+", but was "+n.dtype)}})},e.prototype.checkInput=function(e,t){var a=this;void 0===t&&(t=!0);var r=Object.keys(e),n=[],o=[];this.inputNodes.forEach(function(e){-1===r.indexOf(e)&&n.push(e)}),r.forEach(function(e){-1===a.inputNodes.indexOf(e)&&o.push(e)});var s=o.filter(function(e){return!a.graph.nodes[e]});if(n.length>0&&t)throw new Error("The dict provided in model.execute(dict) has the keys ["+r+"], but is missing the required keys: ["+n+"].");if(o.length>0&&t)throw new Error("The dict provided in model.execute(dict) has unused keys: ["+o+"]. Please provide only the following keys: ["+this.inputNodes+"].");if(s.length>0)throw new Error("The dict provided in model.execute(dict) has keys: ["+s+"] not part of model graph.")},e.prototype.checkOutput=function(e,t){var a=e.map(function(e){return e.name}),r=[];if(t.forEach(function(e){-1===a.indexOf(e)&&r.push(e)}),r.length>0)throw new Error("The following outputs are not be generated by the execution: ["+r+"].")},e}(),FrozenModel=function(){function e(e,t,a){this.modelUrl=e,this.weightManifestUrl=t,this.requestOption=a,this.version="n/a"}return Object.defineProperty(e.prototype,"modelVersion",{get:function(){return this.version},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"inputNodes",{get:function(){return this.executor.inputNodes},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"outputNodes",{get:function(){return this.executor.outputNodes},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"inputs",{get:function(){return this.executor.inputs},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"outputs",{get:function(){return this.executor.outputs},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"weights",{get:function(){return this.executor.weightMap},enumerable:!0,configurable:!0}),e.prototype.findIOHandler=function(){var e=[this.modelUrl,this.weightManifestUrl];if(this.requestOption)this.handler=__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_3" /* io */].browserHTTPRequest(e,this.requestOption);else{var t=__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_3" /* io */].getLoadHandlers(e);if(0===t.length)t.push(__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_3" /* io */].browserHTTPRequest(e,this.requestOption));else if(t.length>1)throw new Error("Found more than one ("+t.length+") load handlers for URL '"+[e]+"'");this.handler=t[0]}},e.prototype.load=function(){return __awaiter(this,void 0,void 0,function(){var e,t,a;return __generator(this,function(r){switch(r.label){case 0:if(this.findIOHandler(),null==this.handler.load)throw new Error("Cannot proceed with model loading because the IOHandler provided does not have the `load` method implemented.");return[4,this.handler.load()];case 1:return e=r.sent(),t=compiled_api_1.GraphDef.decode(new Uint8Array(e.modelTopology)),this.version=t.versions.producer+"."+t.versions.minConsumer,a=__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_3" /* io */].decodeWeights(e.weightData,e.weightSpecs),this.executor=new GraphExecutor(OperationMapper.Instance.transformGraph(t)),this.executor.weightMap=this.convertTensorMapToTensorsMap(a),[2,!0]}})})},e.prototype.predict=function(e,t){return this.execute_(e,!0,this.outputNodes)},e.prototype.constructTensorMap=function(e){var t=e instanceof __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["c" /* Tensor */]?[e]:e;if(t.length!==this.inputNodes.length)throw new Error("Input tensor count mismatch,the frozen model has "+this.inputNodes.length+" placeholders, while there are "+t.length+" input tensors.");return this.inputNodes.reduce(function(e,a,r){return e[a]=t[r],e},{})},e.prototype.execute=function(e,t){return this.execute_(e,!1,t)},e.prototype.execute_=function(e,t,a){if(void 0===t&&(t=!0),a=a||this.outputNodes,(e instanceof __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["c" /* Tensor */]||Array.isArray(e))&&(e=this.constructTensorMap(e)),this.executor.isControlFlowModel||this.executor.isDynamicShapeModel)throw new Error("The model contains control flow or dynamic shape ops, please use executeAsync method");var r=this.executor.execute(this.convertTensorMapToTensorsMap(e),t,a),n=Object.keys(r);return Array.isArray(a)&&a.length>1?a.map(function(e){return r[e]}):r[n[0]]},e.prototype.executeAsync=function(e,t){return __awaiter(this,void 0,void 0,function(){var a,r;return __generator(this,function(n){switch(n.label){case 0:if(!this.executor.isControlFlowModel&&!this.executor.isDynamicShapeModel)throw new Error("The model does not contain control flow or dynamic shape ops, please use execute method for better performance.");return t=t||this.outputNodes,(e instanceof __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["c" /* Tensor */]||Array.isArray(e))&&(e=this.constructTensorMap(e)),[4,this.executor.executeAsync(this.convertTensorMapToTensorsMap(e),t)];case 1:return a=n.sent(),r=Object.keys(a),[2,Array.isArray(t)&&t.length>1?t.map(function(e){return a[e]}):a[r[0]]]}})})},e.prototype.convertTensorMapToTensorsMap=function(e){return Object.keys(e).reduce(function(t,a){return t[a]=[e[a]],t},{})},e.prototype.dispose=function(){this.executor.dispose()},e}();function loadFrozenModel(e,t,a){return __awaiter(this,void 0,void 0,function(){var r;return __generator(this,function(n){switch(n.label){case 0:return[4,(r=new FrozenModel(e,t,a)).load()];case 1:return n.sent(),[2,r]}})})}var version="0.6.7";
//# sourceMappingURL=tf-converter.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(125);
module.exports = __webpack_require__(130);


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(126).enable();
  window.Promise = __webpack_require__(128);
}

// fetch() polyfill for making API calls.
__webpack_require__(129);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(41);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(62);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(62);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 129 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_map__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es6_set__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vkontakte_vkui_connect__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vkontakte_vkui_connect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__vkontakte_vkui_connect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sw__ = __webpack_require__(261);
// Init VK App
__WEBPACK_IMPORTED_MODULE_4__vkontakte_vkui_connect___default.a.send('VKWebAppInit',{});// Service Worker For Cache
Object(__WEBPACK_IMPORTED_MODULE_6__sw__["a" /* default */])();__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */],null),document.getElementById('root'));

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(63);
__webpack_require__(71);
__webpack_require__(77);
__webpack_require__(145);
module.exports = __webpack_require__(15).Map;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(43);
var defined = __webpack_require__(44);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(73);
var descriptor = __webpack_require__(42);
var setToStringTag = __webpack_require__(47);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(17)(IteratorPrototype, __webpack_require__(7)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(18);
var anObject = __webpack_require__(19);
var getKeys = __webpack_require__(74);

module.exports = __webpack_require__(13) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(20);
var toIObject = __webpack_require__(33);
var arrayIndexOf = __webpack_require__(138)(false);
var IE_PROTO = __webpack_require__(46)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(65);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(33);
var toLength = __webpack_require__(75);
var toAbsoluteIndex = __webpack_require__(139);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(43);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(9).document;
module.exports = document && document.documentElement;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(20);
var toObject = __webpack_require__(142);
var IE_PROTO = __webpack_require__(46)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(44);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(144);
var step = __webpack_require__(78);
var Iterators = __webpack_require__(23);
var toIObject = __webpack_require__(33);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(45)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(7)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(17)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(79);
var validate = __webpack_require__(48);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(84)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(19);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(23);
var ITERATOR = __webpack_require__(7)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(64);
var ITERATOR = __webpack_require__(7)('iterator');
var Iterators = __webpack_require__(23);
module.exports = __webpack_require__(15).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(9);
var dP = __webpack_require__(18);
var DESCRIPTORS = __webpack_require__(13);
var SPECIES = __webpack_require__(7)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(7)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(11);
var setPrototypeOf = __webpack_require__(152).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(11);
var anObject = __webpack_require__(19);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(32)(Function.call, __webpack_require__(153).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(154);
var createDesc = __webpack_require__(42);
var toIObject = __webpack_require__(33);
var toPrimitive = __webpack_require__(70);
var has = __webpack_require__(20);
var IE8_DOM_DEFINE = __webpack_require__(68);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(13) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 154 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(63);
__webpack_require__(71);
__webpack_require__(77);
__webpack_require__(156);
module.exports = __webpack_require__(15).Set;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(79);
var validate = __webpack_require__(48);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(84)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(41),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,A=n?Symbol.for("react.memo"):
60115,B=n?Symbol.for("react.lazy"):60116,C="function"===typeof Symbol&&Symbol.iterator;function aa(a,b,e,c,d,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[e,c,d,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},F={};
function G(a,b,e){this.props=a;this.context=b;this.refs=F;this.updater=e||E}G.prototype.isReactComponent={};G.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};G.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function H(){}H.prototype=G.prototype;function I(a,b,e){this.props=a;this.context=b;this.refs=F;this.updater=e||E}var J=I.prototype=new H;
J.constructor=I;k(J,G.prototype);J.isPureReactComponent=!0;var K={current:null,currentDispatcher:null},L=Object.prototype.hasOwnProperty,M={key:!0,ref:!0,__self:!0,__source:!0};
function N(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)L.call(b,c)&&!M.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:d,_owner:K.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,e,c){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return e(c,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+U(d,h);g+=T(d,f,e,c)}else if(null===a||"object"!==typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,h++),g+=T(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function V(a,b,e){return null==a?0:T(a,"",b,e)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,function(a){return a}):null!=a&&(O(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+e)),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(P,"$&/")+"/");b=R(b,g,c,d);V(a,da,b);S(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=R(null,null,b,e);V(a,ca,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];W(a,b,null,function(a){return a});return b},only:function(a){O(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:G,PureComponent:I,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:B,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:A,type:a,compare:void 0===b?null:b}},Fragment:r,StrictMode:t,Suspense:z,createElement:N,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;
if(null!=b){void 0!==b.ref&&(h=b.ref,f=K.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)L.call(b,c)&&!M.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=N.bind(null,a);b.type=a;return b},isValidElement:O,version:"16.6.3",
__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:K,assign:k}};X.unstable_ConcurrentMode=x;X.unstable_Profiler=u;var Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(34),n=__webpack_require__(41),ba=__webpack_require__(159);function ca(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var k=[c,d,e,f,g,h],l=0;a=Error(b.replace(/%s/g,function(){return k[l++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function t(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:t("227");function da(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}
var ea=!1,fa=null,ha=!1,ia=null,ja={onError:function(a){ea=!0;fa=a}};function ka(a,b,c,d,e,f,g,h,k){ea=!1;fa=null;da.apply(ja,arguments)}function la(a,b,c,d,e,f,g,h,k){ka.apply(this,arguments);if(ea){if(ea){var l=fa;ea=!1;fa=null}else t("198"),l=void 0;ha||(ha=!0,ia=l)}}var ma=null,na={};
function oa(){if(ma)for(var a in na){var b=na[a],c=ma.indexOf(a);-1<c?void 0:t("96",a);if(!pa[c]){b.extractEvents?void 0:t("97",a);pa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;qa.hasOwnProperty(h)?t("99",h):void 0;qa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ra(k[e],g,h);e=!0}else f.registrationName?(ra(f.registrationName,g,h),e=!0):e=!1;e?void 0:t("98",d,a)}}}}
function ra(a,b,c){sa[a]?t("100",a):void 0;sa[a]=b;ta[a]=b.eventTypes[c].dependencies}var pa=[],qa={},sa={},ta={},ua=null,va=null,wa=null;function xa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=wa(c);la(d,b,void 0,a);a.currentTarget=null}function ya(a,b){null==b?t("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function za(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Aa=null;function Ba(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)xa(a,b[d],c[d]);else b&&xa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
var Ca={injectEventPluginOrder:function(a){ma?t("101"):void 0;ma=Array.prototype.slice.call(a);oa()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];na.hasOwnProperty(c)&&na[c]===d||(na[c]?t("102",c):void 0,na[c]=d,b=!0)}b&&oa()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=ua(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?t("231",b,typeof c):void 0;
return c}function Ea(a){null!==a&&(Aa=ya(Aa,a));a=Aa;Aa=null;if(a&&(za(a,Ba),Aa?t("95"):void 0,ha))throw a=ia,ha=!1,ia=null,a;}var Fa=Math.random().toString(36).slice(2),Ga="__reactInternalInstance$"+Fa,Ha="__reactEventHandlers$"+Fa;function Ia(a){if(a[Ga])return a[Ga];for(;!a[Ga];)if(a.parentNode)a=a.parentNode;else return null;a=a[Ga];return 5===a.tag||6===a.tag?a:null}function Ja(a){a=a[Ga];return!a||5!==a.tag&&6!==a.tag?null:a}
function Ka(a){if(5===a.tag||6===a.tag)return a.stateNode;t("33")}function La(a){return a[Ha]||null}function Ma(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Na(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ya(c._dispatchListeners,b),c._dispatchInstances=ya(c._dispatchInstances,a)}
function Oa(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Ma(b);for(b=c.length;0<b--;)Na(c[b],"captured",a);for(b=0;b<c.length;b++)Na(c[b],"bubbled",a)}}function Pa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ya(c._dispatchListeners,b),c._dispatchInstances=ya(c._dispatchInstances,a))}function Qa(a){a&&a.dispatchConfig.registrationName&&Pa(a._targetInst,null,a)}
function Ra(a){za(a,Oa)}var Sa=!("undefined"===typeof window||!window.document||!window.document.createElement);function Ta(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ua={animationend:Ta("Animation","AnimationEnd"),animationiteration:Ta("Animation","AnimationIteration"),animationstart:Ta("Animation","AnimationStart"),transitionend:Ta("Transition","TransitionEnd")},Va={},Wa={};
Sa&&(Wa=document.createElement("div").style,"AnimationEvent"in window||(delete Ua.animationend.animation,delete Ua.animationiteration.animation,delete Ua.animationstart.animation),"TransitionEvent"in window||delete Ua.transitionend.transition);function Xa(a){if(Va[a])return Va[a];if(!Ua[a])return a;var b=Ua[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Wa)return Va[a]=b[c];return a}
var Ya=Xa("animationend"),Za=Xa("animationiteration"),$a=Xa("animationstart"),ab=Xa("transitionend"),bb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),cb=null,eb=null,fb=null;
function gb(){if(fb)return fb;var a,b=eb,c=b.length,d,e="value"in cb?cb.value:cb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return fb=e.slice(a,1<d?1-d:void 0)}function hb(){return!0}function ib(){return!1}
function A(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?hb:ib;this.isPropagationStopped=ib;return this}
n(A.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=hb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=hb)},persist:function(){this.isPersistent=hb},isPersistent:ib,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ib;this._dispatchInstances=this._dispatchListeners=null}});A.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
A.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;jb(c);return c};jb(A);function kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function lb(a){a instanceof this?void 0:t("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function jb(a){a.eventPool=[];a.getPooled=kb;a.release=lb}var mb=A.extend({data:null}),nb=A.extend({data:null}),ob=[9,13,27,32],pb=Sa&&"CompositionEvent"in window,qb=null;Sa&&"documentMode"in document&&(qb=document.documentMode);
var rb=Sa&&"TextEvent"in window&&!qb,sb=Sa&&(!pb||qb&&8<qb&&11>=qb),tb=String.fromCharCode(32),ub={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},vb=!1;
function wb(a,b){switch(a){case "keyup":return-1!==ob.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function xb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var yb=!1;function zb(a,b){switch(a){case "compositionend":return xb(b);case "keypress":if(32!==b.which)return null;vb=!0;return tb;case "textInput":return a=b.data,a===tb&&vb?null:a;default:return null}}
function Ab(a,b){if(yb)return"compositionend"===a||!pb&&wb(a,b)?(a=gb(),fb=eb=cb=null,yb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return sb&&"ko"!==b.locale?null:b.data;default:return null}}
var Bb={eventTypes:ub,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(pb)b:{switch(a){case "compositionstart":e=ub.compositionStart;break b;case "compositionend":e=ub.compositionEnd;break b;case "compositionupdate":e=ub.compositionUpdate;break b}e=void 0}else yb?wb(a,c)&&(e=ub.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=ub.compositionStart);e?(sb&&"ko"!==c.locale&&(yb||e!==ub.compositionStart?e===ub.compositionEnd&&yb&&(f=gb()):(cb=d,eb="value"in cb?cb.value:cb.textContent,yb=
!0)),e=mb.getPooled(e,b,c,d),f?e.data=f:(f=xb(c),null!==f&&(e.data=f)),Ra(e),f=e):f=null;(a=rb?zb(a,c):Ab(a,c))?(b=nb.getPooled(ub.beforeInput,b,c,d),b.data=a,Ra(b)):b=null;return null===f?b:null===b?f:[f,b]}},Cb=null,Db=null,Eb=null;function Hb(a){if(a=va(a)){"function"!==typeof Cb?t("280"):void 0;var b=ua(a.stateNode);Cb(a.stateNode,a.type,b)}}function Ib(a){Db?Eb?Eb.push(a):Eb=[a]:Db=a}function Jb(){if(Db){var a=Db,b=Eb;Eb=Db=null;Hb(a);if(b)for(a=0;a<b.length;a++)Hb(b[a])}}
function Kb(a,b){return a(b)}function Lb(a,b,c){return a(b,c)}function Mb(){}var Nb=!1;function Ob(a,b){if(Nb)return a(b);Nb=!0;try{return Kb(a,b)}finally{if(Nb=!1,null!==Db||null!==Eb)Mb(),Jb()}}var Pb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Qb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Pb[a.type]:"textarea"===b?!0:!1}
function Rb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Sb(a){if(!Sa)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Tb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ub(a){var b=Tb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Vb(a){a._valueTracker||(a._valueTracker=Ub(a))}function Wb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Tb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var Xb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,Yb=/^(.*)[\\\/]/,D="function"===typeof Symbol&&Symbol.for,Zb=D?Symbol.for("react.element"):60103,$b=D?Symbol.for("react.portal"):60106,ac=D?Symbol.for("react.fragment"):60107,bc=D?Symbol.for("react.strict_mode"):60108,cc=D?Symbol.for("react.profiler"):60114,dc=D?Symbol.for("react.provider"):60109,ec=D?Symbol.for("react.context"):60110,fc=D?Symbol.for("react.concurrent_mode"):60111,gc=D?Symbol.for("react.forward_ref"):60112,hc=D?Symbol.for("react.suspense"):
60113,ic=D?Symbol.for("react.memo"):60115,jc=D?Symbol.for("react.lazy"):60116,kc="function"===typeof Symbol&&Symbol.iterator;function lc(a){if(null===a||"object"!==typeof a)return null;a=kc&&a[kc]||a["@@iterator"];return"function"===typeof a?a:null}
function mc(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case fc:return"ConcurrentMode";case ac:return"Fragment";case $b:return"Portal";case cc:return"Profiler";case bc:return"StrictMode";case hc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ec:return"Context.Consumer";case dc:return"Context.Provider";case gc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
")":"ForwardRef");case ic:return mc(a.type);case jc:if(a=1===a._status?a._result:null)return mc(a)}return null}function nc(a){var b="";do{a:switch(a.tag){case 2:case 16:case 0:case 1:case 5:case 8:case 13:var c=a._debugOwner,d=a._debugSource,e=mc(a.type);var f=null;c&&(f=mc(c.type));c=e;e="";d?e=" (at "+d.fileName.replace(Yb,"")+":"+d.lineNumber+")":f&&(e=" (created by "+f+")");f="\n    in "+(c||"Unknown")+e;break a;default:f=""}b+=f;a=a.return}while(a);return b}
var oc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,pc=Object.prototype.hasOwnProperty,qc={},rc={};
function sc(a){if(pc.call(rc,a))return!0;if(pc.call(qc,a))return!1;if(oc.test(a))return rc[a]=!0;qc[a]=!0;return!1}function tc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function uc(a,b,c,d){if(null===b||"undefined"===typeof b||tc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function E(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var F={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){F[a]=new E(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];F[b]=new E(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){F[a]=new E(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){F[a]=new E(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){F[a]=new E(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){F[a]=new E(a,3,!0,a,null)});
["capture","download"].forEach(function(a){F[a]=new E(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){F[a]=new E(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){F[a]=new E(a,5,!1,a.toLowerCase(),null)});var vc=/[\-:]([a-z])/g;function xc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(vc,
xc);F[b]=new E(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(vc,xc);F[b]=new E(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(vc,xc);F[b]=new E(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});F.tabIndex=new E("tabIndex",1,!1,"tabindex",null);
function yc(a,b,c,d){var e=F.hasOwnProperty(b)?F[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(uc(b,c,e,d)&&(c=null),d||null===e?sc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function zc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function Ac(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Bc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=zc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cc(a,b){b=b.checked;null!=b&&yc(a,"checked",b,!1)}
function Dc(a,b){Cc(a,b);var c=zc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Ec(a,b.type,c):b.hasOwnProperty("defaultValue")&&Ec(a,b.type,zc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Fc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Ec(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Gc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Hc(a,b,c){a=A.getPooled(Gc.change,a,b,c);a.type="change";Ib(c);Ra(a);return a}var Jc=null,Kc=null;function Lc(a){Ea(a)}
function Mc(a){var b=Ka(a);if(Wb(b))return a}function Nc(a,b){if("change"===a)return b}var Oc=!1;Sa&&(Oc=Sb("input")&&(!document.documentMode||9<document.documentMode));function Pc(){Jc&&(Jc.detachEvent("onpropertychange",Qc),Kc=Jc=null)}function Qc(a){"value"===a.propertyName&&Mc(Kc)&&(a=Hc(Kc,a,Rb(a)),Ob(Lc,a))}function Rc(a,b,c){"focus"===a?(Pc(),Jc=b,Kc=c,Jc.attachEvent("onpropertychange",Qc)):"blur"===a&&Pc()}function Sc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Mc(Kc)}
function Tc(a,b){if("click"===a)return Mc(b)}function Uc(a,b){if("input"===a||"change"===a)return Mc(b)}
var Vc={eventTypes:Gc,_isInputEventSupported:Oc,extractEvents:function(a,b,c,d){var e=b?Ka(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Nc:Qb(e)?Oc?f=Uc:(f=Sc,g=Rc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Tc);if(f&&(f=f(a,b)))return Hc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Ec(e,"number",e.value)}},Wc=A.extend({view:null,detail:null}),Xc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Yc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Xc[a])?!!b[a]:!1}function Zc(){return Yc}
var $c=0,ad=0,bd=!1,cd=!1,dd=Wc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Zc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=$c;$c=a.screenX;return bd?"mousemove"===a.type?a.screenX-b:0:(bd=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=ad;ad=a.screenY;return cd?"mousemove"===a.type?a.screenY-b:0:(cd=!0,0)}}),ed=dd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),fd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},gd={eventTypes:fd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ia(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,l=void 0;if("mouseout"===a||"mouseover"===a)g=dd,h=fd.mouseLeave,k=fd.mouseEnter,l="mouse";
else if("pointerout"===a||"pointerover"===a)g=ed,h=fd.pointerLeave,k=fd.pointerEnter,l="pointer";var m=null==f?e:Ka(f);e=null==b?e:Ka(b);a=g.getPooled(h,f,c,d);a.type=l+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=l+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;l=0;for(g=b;g;g=Ma(g))l++;g=0;for(k=e;k;k=Ma(k))g++;for(;0<l-g;)b=Ma(b),l--;for(;0<g-l;)e=Ma(e),g--;for(;l--;){if(b===e||b===e.alternate)break a;b=Ma(b);e=Ma(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){l=
f.alternate;if(null!==l&&l===e)break;b.push(f);f=Ma(f)}for(f=[];d&&d!==e;){l=d.alternate;if(null!==l&&l===e)break;f.push(d);d=Ma(d)}for(d=0;d<b.length;d++)Pa(b[d],"bubbled",a);for(d=f.length;0<d--;)Pa(f[d],"captured",c);return[a,c]}},hd=Object.prototype.hasOwnProperty;function id(a,b){return a===b?0!==a||0!==b||1/a===1/b:a!==a&&b!==b}
function jd(a,b){if(id(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!hd.call(b,c[d])||!id(a[c[d]],b[c[d]]))return!1;return!0}function kd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){2!==kd(a)?t("188"):void 0}
function md(a){var b=a.alternate;if(!b)return b=kd(a),3===b?t("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return ld(e),a;if(g===d)return ld(e),b;g=g.sibling}t("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:t("189")}}c.alternate!==d?t("190"):void 0}3!==c.tag?t("188"):void 0;return c.stateNode.current===c?a:b}function nd(a){a=md(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var od=A.extend({animationName:null,elapsedTime:null,pseudoElement:null}),pd=A.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),qd=Wc.extend({relatedTarget:null});function rd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var sd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},td={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ud=Wc.extend({key:function(a){if(a.key){var b=sd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=rd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?td[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Zc,charCode:function(a){return"keypress"===
a.type?rd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?rd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),vd=dd.extend({dataTransfer:null}),wd=Wc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Zc}),xd=A.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),yd=dd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),zd=[["abort","abort"],[Ya,"animationEnd"],[Za,"animationIteration"],[$a,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ab,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Ad={},Bd={};function Cd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Ad[a]=b;Bd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Cd(a,!0)});zd.forEach(function(a){Cd(a,!1)});
var Dd={eventTypes:Ad,isInteractiveTopLevelEventType:function(a){a=Bd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Bd[a];if(!e)return null;switch(a){case "keypress":if(0===rd(c))return null;case "keydown":case "keyup":a=ud;break;case "blur":case "focus":a=qd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=dd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
vd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=wd;break;case Ya:case Za:case $a:a=od;break;case ab:a=xd;break;case "scroll":a=Wc;break;case "wheel":a=yd;break;case "copy":case "cut":case "paste":a=pd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=ed;break;default:a=A}b=a.getPooled(e,b,c,d);Ra(b);return b}},Ed=Dd.isInteractiveTopLevelEventType,
Fd=[];function Gd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ia(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Rb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<pa.length;h++){var k=pa[h];k&&(k=k.extractEvents(d,b,f,e))&&(g=ya(g,k))}Ea(g)}}var Hd=!0;
function G(a,b){if(!b)return null;var c=(Ed(a)?Id:Jd).bind(null,a);b.addEventListener(a,c,!1)}function Kd(a,b){if(!b)return null;var c=(Ed(a)?Id:Jd).bind(null,a);b.addEventListener(a,c,!0)}function Id(a,b){Lb(Jd,a,b)}
function Jd(a,b){if(Hd){var c=Rb(b);c=Ia(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(Fd.length){var d=Fd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Ob(Gd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Fd.length&&Fd.push(a)}}}var Ld={},Md=0,Nd="_reactListenersID"+(""+Math.random()).slice(2);
function Od(a){Object.prototype.hasOwnProperty.call(a,Nd)||(a[Nd]=Md++,Ld[a[Nd]]={});return Ld[a[Nd]]}function Pd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Qd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Rd(a,b){var c=Qd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Qd(c)}}function Sd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Sd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Td(){for(var a=window,b=Pd();b instanceof a.HTMLIFrameElement;){try{a=b.contentDocument.defaultView}catch(c){break}b=Pd(a.document)}return b}function Ud(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Vd=Sa&&"documentMode"in document&&11>=document.documentMode,Wd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Xd=null,Yd=null,Zd=null,$d=!1;
function ae(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if($d||null==Xd||Xd!==Pd(c))return null;c=Xd;"selectionStart"in c&&Ud(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Zd&&jd(Zd,c)?null:(Zd=c,a=A.getPooled(Wd.select,Yd,a,b),a.type="select",a.target=Xd,Ra(a),a)}
var be={eventTypes:Wd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Od(e);f=ta.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ka(b):window;switch(a){case "focus":if(Qb(e)||"true"===e.contentEditable)Xd=e,Yd=b,Zd=null;break;case "blur":Zd=Yd=Xd=null;break;case "mousedown":$d=!0;break;case "contextmenu":case "mouseup":case "dragend":return $d=!1,ae(c,d);case "selectionchange":if(Vd)break;
case "keydown":case "keyup":return ae(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ua=La;va=Ja;wa=Ka;Ca.injectEventPluginsByName({SimpleEventPlugin:Dd,EnterLeaveEventPlugin:gd,ChangeEventPlugin:Vc,SelectEventPlugin:be,BeforeInputEventPlugin:Bb});function de(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function ee(a,b){a=n({children:void 0},b);if(b=de(b.children))a.children=b;return a}function fe(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+zc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function ge(a,b){null!=b.dangerouslySetInnerHTML?t("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function he(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?t("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:t("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:zc(c)}}
function ie(a,b){var c=zc(b.value),d=zc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function je(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var ke={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function le(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function me(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?le(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ne=void 0,oe=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==ke.svg||"innerHTML"in a)a.innerHTML=b;else{ne=ne||document.createElement("div");ne.innerHTML="<svg>"+b+"</svg>";for(b=ne.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function pe(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var qe={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},re=["Webkit","ms","Moz","O"];Object.keys(qe).forEach(function(a){re.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);qe[b]=qe[a]})});function se(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||qe.hasOwnProperty(a)&&qe[a]?(""+b).trim():b+"px"}
function te(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=se(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var ue=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function ve(a,b){b&&(ue[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?t("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?t("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:t("61")),null!=b.style&&"object"!==typeof b.style?t("62",""):void 0)}
function we(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function xe(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Od(a);b=ta[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Kd("scroll",a);break;case "focus":case "blur":Kd("focus",a);Kd("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Sb(e)&&Kd(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===bb.indexOf(e)&&G(e,a)}c[e]=!0}}}function ye(){}var ze=null,Ae=null;
function Be(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function Ce(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var De="function"===typeof setTimeout?setTimeout:void 0,Ee="function"===typeof clearTimeout?clearTimeout:void 0;
function Fe(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ge(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var He=[],Ie=-1;function H(a){0>Ie||(a.current=He[Ie],He[Ie]=null,Ie--)}function I(a,b){Ie++;He[Ie]=a.current;a.current=b}var Je={},J={current:Je},K={current:!1},Ke=Je;
function Le(a,b){var c=a.type.contextTypes;if(!c)return Je;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Me(a){H(K,a);H(J,a)}function Ne(a){H(K,a);H(J,a)}
function Oe(a,b,c){J.current!==Je?t("168"):void 0;I(J,b,a);I(K,c,a)}function Pe(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:t("108",mc(b)||"Unknown",e);return n({},c,d)}function Qe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Je;Ke=J.current;I(J,b,a);I(K,K.current,a);return!0}
function Re(a,b,c){var d=a.stateNode;d?void 0:t("169");c?(b=Pe(a,b,Ke),d.__reactInternalMemoizedMergedChildContext=b,H(K,a),H(J,a),I(J,b,a)):H(K,a);I(K,c,a)}var Se=null,Te=null;function Ue(a){return function(b){try{return a(b)}catch(c){}}}
function Ve(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Se=Ue(function(a){return b.onCommitFiberRoot(c,a)});Te=Ue(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function We(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.firstContextDependency=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function M(a,b,c,d){return new We(a,b,c,d)}
function Xe(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Ye(a){if("function"===typeof a)return Xe(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gc)return 11;if(a===ic)return 14}return 2}
function Ze(a,b){var c=a.alternate;null===c?(c=M(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.firstContextDependency=a.firstContextDependency;c.sibling=a.sibling;
c.index=a.index;c.ref=a.ref;return c}
function $e(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Xe(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ac:return af(c.children,e,f,b);case fc:return bf(c,e|3,f,b);case bc:return bf(c,e|2,f,b);case cc:return a=M(12,c,b,e|4),a.elementType=cc,a.type=cc,a.expirationTime=f,a;case hc:return a=M(13,c,b,e),a.elementType=hc,a.type=hc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case dc:g=10;break a;case ec:g=9;break a;case gc:g=11;break a;case ic:g=
14;break a;case jc:g=16;d=null;break a}t("130",null==a?a:typeof a,"")}b=M(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function af(a,b,c,d){a=M(7,a,d,b);a.expirationTime=c;return a}function bf(a,b,c,d){a=M(8,a,d,b);b=0===(b&1)?bc:fc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function cf(a,b,c){a=M(6,a,null,b);a.expirationTime=c;return a}
function df(a,b,c){b=M(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function ef(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);ff(b,a)}
function gf(a,b){a.didError=!1;var c=a.latestPingedTime;0!==c&&c>=b&&(a.latestPingedTime=0);c=a.earliestPendingTime;var d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);ff(b,a)}
function hf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}function ff(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}var jf=!1;
function kf(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function lf(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function mf(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function nf(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function of(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=kf(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=kf(a.memoizedState),e=c.updateQueue=kf(c.memoizedState)):d=a.updateQueue=lf(e):null===e&&(e=c.updateQueue=lf(d));null===e||d===e?nf(d,b):null===d.lastUpdate||null===e.lastUpdate?(nf(d,b),nf(e,b)):(nf(d,b),e.lastUpdate=b)}
function pf(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=kf(a.memoizedState):qf(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function qf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=lf(b));return b}
function rf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-2049|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:jf=!0}return d}
function sf(a,b,c,d,e){jf=!1;b=qf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(l=rf(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var q=k.expirationTime;q<e?(null===m&&(m=k,null===g&&(f=l)),h<q&&(h=q)):(l=rf(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=
32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=l}
function tf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);uf(b.firstEffect,c);b.firstEffect=b.lastEffect=null;uf(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function uf(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?t("191",c):void 0;c.call(d)}a=a.nextEffect}}
function vf(a,b){return{value:a,source:b,stack:nc(b)}}var wf={current:null},xf=null,yf=null,zf=null;function Af(a,b){var c=a.type._context;I(wf,c._currentValue,a);c._currentValue=b}function Bf(a){var b=wf.current;H(wf,a);a.type._context._currentValue=b}function Cf(a){xf=a;zf=yf=null;a.firstContextDependency=null}
function Df(a,b){if(zf!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)zf=a,b=1073741823;b={context:a,observedBits:b,next:null};null===yf?(null===xf?t("293"):void 0,xf.firstContextDependency=yf=b):yf=yf.next=b}return a._currentValue}var Ef={},N={current:Ef},Ff={current:Ef},Gf={current:Ef};function Hf(a){a===Ef?t("174"):void 0;return a}
function If(a,b){I(Gf,b,a);I(Ff,a,a);I(N,Ef,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:me(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=me(b,c)}H(N,a);I(N,b,a)}function Jf(a){H(N,a);H(Ff,a);H(Gf,a)}function Kf(a){Hf(Gf.current);var b=Hf(N.current);var c=me(b,a.type);b!==c&&(I(Ff,a,a),I(N,c,a))}function Lf(a){Ff.current===a&&(H(N,a),H(Ff,a))}
function O(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}function Mf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:throw a._status=0,b=a._ctor,b=b(),b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)}),a._result=b,b;}}var Nf=Xb.ReactCurrentOwner,Of=(new aa.Component).refs;
function Pf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Uf={isMounted:function(a){return(a=a._reactInternalFiber)?2===kd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Qf();d=Rf(d,a);var e=mf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Sf();of(a,e);Tf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Qf();d=Rf(d,a);var e=mf(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Sf();of(a,e);Tf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Qf();c=Rf(c,a);var d=mf(c);d.tag=
2;void 0!==b&&null!==b&&(d.callback=b);Sf();of(a,d);Tf(a,c)}};function Vf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!jd(c,d)||!jd(e,f):!0}
function Wf(a,b,c){var d=!1,e=Je;var f=b.contextType;"object"===typeof f&&null!==f?f=Nf.currentDispatcher.readContext(f):(e=L(b)?Ke:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Le(a,e):Je);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Uf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Xf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Uf.enqueueReplaceState(b,b.state,null)}
function Yf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Of;var f=b.contextType;"object"===typeof f&&null!==f?e.context=Nf.currentDispatcher.readContext(f):(f=L(b)?Ke:J.current,e.context=Le(a,f));f=a.updateQueue;null!==f&&(sf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Pf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&
"function"!==typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Uf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(sf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Zf=Array.isArray;
function $f(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?t("289"):void 0,d=c.stateNode);d?void 0:t("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Of&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?t("284"):void 0;c._owner?void 0:t("290",a)}return a}
function ag(a,b){"textarea"!==a.type&&t("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function bg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Ze(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=cf(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=$f(a,b,c),d.return=a,d;d=$e(c.type,c.key,c.props,null,a.mode,d);d.ref=$f(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=df(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,g){if(null===b||7!==b.tag)return b=af(c,a.mode,d,g),b.return=a,b;b=e(b,c,d);b.return=a;return b}function q(a,b,c){if("string"===typeof b||"number"===typeof b)return b=cf(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Zb:return c=$e(b.type,b.key,b.props,null,a.mode,c),c.ref=$f(a,null,b),c.return=a,c;case $b:return b=df(b,a.mode,c),b.return=a,b}if(Zf(b)||
lc(b))return b=af(b,a.mode,c,null),b.return=a,b;ag(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Zb:return c.key===e?c.type===ac?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $b:return c.key===e?l(a,b,c,d):null}if(Zf(c)||lc(c))return null!==e?null:m(a,b,c,d,null);ag(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Zb:return a=a.get(null===d.key?c:d.key)||null,d.type===ac?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $b:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Zf(d)||lc(d))return a=a.get(c)||null,m(b,a,d,e,null);ag(b,d)}return null}function B(e,g,h,k){for(var l=null,r=null,m=g,u=g=0,p=null;null!==m&&u<h.length;u++){m.index>u?(p=m,m=null):p=m.sibling;var v=x(e,m,h[u],k);if(null===v){null===m&&(m=p);break}a&&
m&&null===v.alternate&&b(e,m);g=f(v,g,u);null===r?l=v:r.sibling=v;r=v;m=p}if(u===h.length)return c(e,m),l;if(null===m){for(;u<h.length;u++)if(m=q(e,h[u],k))g=f(m,g,u),null===r?l=m:r.sibling=m,r=m;return l}for(m=d(e,m);u<h.length;u++)if(p=z(m,e,u,h[u],k))a&&null!==p.alternate&&m.delete(null===p.key?u:p.key),g=f(p,g,u),null===r?l=p:r.sibling=p,r=p;a&&m.forEach(function(a){return b(e,a)});return l}function Q(e,g,h,k){var l=lc(h);"function"!==typeof l?t("150"):void 0;h=l.call(h);null==h?t("151"):void 0;
for(var m=l=null,r=g,u=g=0,p=null,v=h.next();null!==r&&!v.done;u++,v=h.next()){r.index>u?(p=r,r=null):p=r.sibling;var y=x(e,r,v.value,k);if(null===y){r||(r=p);break}a&&r&&null===y.alternate&&b(e,r);g=f(y,g,u);null===m?l=y:m.sibling=y;m=y;r=p}if(v.done)return c(e,r),l;if(null===r){for(;!v.done;u++,v=h.next())v=q(e,v.value,k),null!==v&&(g=f(v,g,u),null===m?l=v:m.sibling=v,m=v);return l}for(r=d(e,r);!v.done;u++,v=h.next())v=z(r,e,u,v.value,k),null!==v&&(a&&null!==v.alternate&&r.delete(null===v.key?u:
v.key),g=f(v,g,u),null===m?l=v:m.sibling=v,m=v);a&&r.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ac&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Zb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===ac:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===ac?f.props.children:f.props,h);d.ref=$f(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
k.sibling}f.type===ac?(d=af(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=$e(f.type,f.key,f.props,null,a.mode,h),h.ref=$f(a,d,f),h.return=a,a=h)}return g(a);case $b:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=df(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=cf(f,a.mode,h),d.return=a,a=d),g(a);if(Zf(f))return B(a,d,f,h);if(lc(f))return Q(a,d,f,h);l&&ag(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,t("152",h.displayName||h.name||"Component")}return c(a,d)}}var cg=bg(!0),dg=bg(!1),eg=null,fg=null,gg=!1;
function hg(a,b){var c=M(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function ig(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}
function jg(a){if(gg){var b=fg;if(b){var c=b;if(!ig(a,b)){b=Fe(c);if(!b||!ig(a,b)){a.effectTag|=2;gg=!1;eg=a;return}hg(eg,c)}eg=a;fg=Ge(b)}else a.effectTag|=2,gg=!1,eg=a}}function kg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;eg=a}function lg(a){if(a!==eg)return!1;if(!gg)return kg(a),gg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Ce(b,a.memoizedProps))for(b=fg;b;)hg(a,b),b=Fe(b);kg(a);fg=eg?Fe(a.stateNode):null;return!0}function mg(){fg=eg=null;gg=!1}var ng=Xb.ReactCurrentOwner;
function P(a,b,c,d){b.child=null===a?dg(b,null,c,d):cg(b,a.child,c,d)}function og(a,b,c,d,e){c=c.render;var f=b.ref;Cf(b,e);d=c(d,f);b.effectTag|=1;P(a,b,d,e);return b.child}
function pg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Xe(g)&&void 0===g.defaultProps&&null===c.compare)return b.tag=15,b.type=g,qg(a,b,g,d,e,f);a=$e(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:jd,c(e,d)&&a.ref===b.ref))return rg(a,b,f);b.effectTag|=1;a=Ze(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function qg(a,b,c,d,e,f){return null!==a&&e<f&&jd(a.memoizedProps,d)&&a.ref===b.ref?rg(a,b,f):sg(a,b,c,d,f)}function tg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function sg(a,b,c,d,e){var f=L(c)?Ke:J.current;f=Le(b,f);Cf(b,e);c=c(d,f);b.effectTag|=1;P(a,b,c,e);return b.child}
function ug(a,b,c,d,e){if(L(c)){var f=!0;Qe(b)}else f=!1;Cf(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Wf(b,c,d,e),Yf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=Nf.currentDispatcher.readContext(l):(l=L(c)?Ke:J.current,l=Le(b,l));var m=c.getDerivedStateFromProps,q="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;q||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Xf(b,g,d,l);jf=!1;var x=b.memoizedState;k=g.state=x;var z=b.updateQueue;null!==z&&(sf(b,z,d,g,e),k=b.memoizedState);h!==d||x!==k||K.current||jf?("function"===typeof m&&(Pf(b,c,m,d),k=b.memoizedState),(h=jf||Vf(b,c,h,d,x,k,l))?(q||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:O(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=Nf.currentDispatcher.readContext(l):(l=L(c)?Ke:J.current,l=Le(b,l)),m=c.getDerivedStateFromProps,
(q="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Xf(b,g,d,l),jf=!1,k=b.memoizedState,x=g.state=k,z=b.updateQueue,null!==z&&(sf(b,z,d,g,e),x=b.memoizedState),h!==d||k!==x||K.current||jf?("function"===typeof m&&(Pf(b,c,m,d),x=b.memoizedState),(m=jf||Vf(b,c,h,d,k,x,l))?(q||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return vg(a,b,c,d,f,e)}
function vg(a,b,c,d,e,f){tg(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Re(b,c,!1),rg(a,b,f);d=b.stateNode;ng.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=cg(b,a.child,null,f),b.child=cg(b,null,h,f)):P(a,b,h,f);b.memoizedState=d.state;e&&Re(b,c,!0);return b.child}function wg(a){var b=a.stateNode;b.pendingContext?Oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Oe(a,b.context,!1);If(a,b.containerInfo)}
function xg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;null===a?g?(g=e.fallback,e=af(null,d,0,null),0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=af(g,d,c,null),e.sibling=d,c=e,c.return=d.return=b):c=d=dg(b,null,e.children,c):null!==a.memoizedState?(d=a.child,a=d.sibling,g?(c=e.fallback,e=Ze(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==b.memoizedState?
b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=Ze(a,c,a.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=cg(b,d.child,e.children,c)):(a=a.child,g?(g=e.fallback,e=af(null,d,0,null),e.child=a,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=af(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=cg(b,a,e.children,c));b.memoizedState=f;b.child=c;return d}
function rg(a,b,c){null!==a&&(b.firstContextDependency=a.firstContextDependency);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?t("153"):void 0;if(null!==b.child){a=b.child;c=Ze(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Ze(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function yg(a,b,c){var d=b.expirationTime;if(null!==a&&a.memoizedProps===b.pendingProps&&!K.current&&d<c){switch(b.tag){case 3:wg(b);mg();break;case 5:Kf(b);break;case 1:L(b.type)&&Qe(b);break;case 4:If(b,b.stateNode.containerInfo);break;case 10:Af(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return xg(a,b,c);b=rg(a,b,c);return null!==b?b.sibling:null}}return rg(a,b,c)}b.expirationTime=0;switch(b.tag){case 2:d=b.elementType;null!==
a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Le(b,J.current);Cf(b,c);e=d(a,e);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;if(L(d)){var f=!0;Qe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Pf(b,d,g,a);e.updater=Uf;b.stateNode=e;e._reactInternalFiber=b;Yf(b,d,a,c);b=vg(null,b,d,!0,f,c)}else b.tag=0,P(null,b,e,c),b=b.child;
return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=Mf(e);b.type=a;e=b.tag=Ye(a);f=O(a,f);g=void 0;switch(e){case 0:g=sg(null,b,a,f,c);break;case 1:g=ug(null,b,a,f,c);break;case 11:g=og(null,b,a,f,c);break;case 14:g=pg(null,b,a,O(a.type,f),d,c);break;default:t("283",a)}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:O(d,e),sg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:O(d,e),ug(a,b,d,
e,c);case 3:wg(b);d=b.updateQueue;null===d?t("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;sf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)mg(),b=rg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)fg=Ge(b.stateNode.containerInfo),eg=b,e=gg=!0;e?(b.effectTag|=2,b.child=dg(b,null,d,c)):(P(a,b,d,c),mg());b=b.child}return b;case 5:return Kf(b),null===a&&jg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,Ce(d,e)?g=null:null!==
f&&Ce(d,f)&&(b.effectTag|=16),tg(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=1,b=null):(P(a,b,g,c),b=b.child),b;case 6:return null===a&&jg(b),null;case 13:return xg(a,b,c);case 4:return If(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=cg(b,null,d,c):P(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:O(d,e),og(a,b,d,e,c);case 7:return P(a,b,b.pendingProps,c),b.child;case 8:return P(a,b,b.pendingProps.children,c),b.child;case 12:return P(a,b,b.pendingProps.children,
c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Af(b,f);if(null!==g){var h=g.value;f=h===f&&(0!==h||1/h===1/f)||h!==h&&f!==f?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!K.current){b=rg(a,b,c);break a}}else for(g=b.child,null!==g&&(g.return=b);null!==g;){h=g.firstContextDependency;if(null!==h){do{if(h.context===d&&0!==(h.observedBits&f)){if(1===g.tag){var k=mf(c);k.tag=2;of(g,k)}g.expirationTime<
c&&(g.expirationTime=c);k=g.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);for(var l=g.return;null!==l;){k=l.alternate;if(l.childExpirationTime<c)l.childExpirationTime=c,null!==k&&k.childExpirationTime<c&&(k.childExpirationTime=c);else if(null!==k&&k.childExpirationTime<c)k.childExpirationTime=c;else break;l=l.return}}k=g.child;h=h.next}while(null!==h)}else k=10===g.tag?g.type===b.type?null:g.child:g.child;if(null!==k)k.return=g;else for(k=g;null!==k;){if(k===b){k=null;break}g=k.sibling;
if(null!==g){g.return=k.return;k=g;break}k=k.return}g=k}}P(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Cf(b,c),e=Df(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,P(a,b,d,c),b.child;case 14:return e=b.type,f=O(e.type,b.pendingProps),pg(a,b,e,f,d,c);case 15:return qg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:O(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Qe(b)):
a=!1,Cf(b,c),Wf(b,d,e,c),Yf(b,d,e,c),vg(null,b,d,!0,a,c);default:t("156")}}function zg(a){a.effectTag|=4}var Ag=void 0,Bg=void 0,Fg=void 0,Gg=void 0;Ag=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Bg=function(){};
Fg=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;Hf(N.current);a=null;switch(c){case "input":f=Ac(g,f);d=Ac(g,d);a=[];break;case "option":f=ee(g,f);d=ee(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=ge(g,f);d=ge(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ye)}ve(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var k=f[c];for(g in k)k.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(sa.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var l=d[c];k=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&l!==k&&(null!=l||null!=k))if("style"===c)if(k){for(g in k)!k.hasOwnProperty(g)||l&&l.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in l)l.hasOwnProperty(g)&&k[g]!==l[g]&&(h||
(h={}),h[g]=l[g])}else h||(a||(a=[]),a.push(c,h)),h=l;else"dangerouslySetInnerHTML"===c?(l=l?l.__html:void 0,k=k?k.__html:void 0,null!=l&&k!==l&&(a=a||[]).push(c,""+l)):"children"===c?k===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(c,""+l):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(sa.hasOwnProperty(c)?(null!=l&&xe(e,c),a||k===l||(a=[])):(a=a||[]).push(c,l))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&zg(b)}};Gg=function(a,b,c,d){c!==d&&zg(b)};
function Hg(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=nc(c));null!==c&&mc(c.type);b=b.value;null!==a&&1===a.tag&&mc(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Ig(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Jg(a,c)}else b.current=null}
function Kg(a){"function"===typeof Te&&Te(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(null!==d){var e=a;try{d()}catch(f){Jg(e,f)}}c=c.next}while(c!==b)}break;case 1:Ig(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){Jg(a,f)}break;case 5:Ig(a);break;case 4:Lg(a)}}
function Mg(a){return 5===a.tag||3===a.tag||4===a.tag}
function Ng(a){a:{for(var b=a.return;null!==b;){if(Mg(b)){var c=b;break a}b=b.return}t("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:t("161")}c.effectTag&16&&(pe(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Mg(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=ye)):b.appendChild(e.stateNode);
else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Lg(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?t("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(Kg(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?(d=b.stateNode.containerInfo,e=!0):Kg(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function Og(a,b){switch(b.tag){case 0:case 11:case 14:case 15:break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Ha]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cc(c,d);we(a,e);b=we(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?te(c,h):"dangerouslySetInnerHTML"===g?oe(c,h):"children"===g?pe(c,h):yc(c,g,h,b)}switch(a){case "input":Dc(c,d);break;case "textarea":ie(c,
d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?fe(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?fe(c,!!d.multiple,d.defaultValue,!0):fe(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:null===b.stateNode?t("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=Qf()));if(null!==a)a:for(b=c=a;;){if(5===
b.tag)a=b.stateNode,d?a.style.display="none":(a=b.stateNode,f=b.memoizedProps.style,f=void 0!==f&&null!==f&&f.hasOwnProperty("display")?f.display:null,a.style.display=se("display",f));else if(6===b.tag)b.stateNode.nodeValue=d?"":b.memoizedProps;else if(13===b.tag&&null!==b.memoizedState){a=b.child.sibling;a.return=b;b=a;continue}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===c)break a;for(;null===b.sibling;){if(null===b.return||b.return===c)break a;b=b.return}b.sibling.return=
b.return;b=b.sibling}break;case 17:break;default:t("163")}}function Pg(a,b,c){c=mf(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Qg(d);Hg(a,b)};return c}
function Rg(a,b,c){c=mf(c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Sg?Sg=new Set([this]):Sg.add(this));var c=b.value,e=b.stack;Hg(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
function Tg(a){switch(a.tag){case 1:L(a.type)&&Me(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Jf(a),Ne(a),b=a.effectTag,0!==(b&64)?t("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Lf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 4:return Jf(a),null;case 10:return Bf(a),null;default:return null}}
var Ug={readContext:Df},Vg=Xb.ReactCurrentOwner,Wg=1073741822,Xg=0,Yg=!1,R=null,S=null,T=0,Zg=-1,$g=!1,U=null,ah=!1,bh=null,ch=null,Sg=null;function dh(){if(null!==R)for(var a=R.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Me(b);break;case 3:Jf(b);Ne(b);break;case 5:Lf(b);break;case 4:Jf(b);break;case 10:Bf(b)}a=a.return}S=null;T=0;Zg=-1;$g=!1;R=null}function Sf(){null!==ch&&(ba.unstable_cancelCallback(bh),ch())}
function eh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){R=a;a:{var e=b;b=a;var f=T;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:L(b.type)&&Me(b);break;case 3:Jf(b);Ne(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)lg(b),b.effectTag&=-3;Bg(b);break;case 5:Lf(b);var h=Hf(Gf.current);f=b.type;if(null!==e&&null!=b.stateNode)Fg(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
128);else if(g){var k=Hf(N.current);if(lg(b)){g=b;e=g.stateNode;var l=g.type,m=g.memoizedProps,q=h;e[Ga]=g;e[Ha]=m;f=void 0;h=l;switch(h){case "iframe":case "object":G("load",e);break;case "video":case "audio":for(l=0;l<bb.length;l++)G(bb[l],e);break;case "source":G("error",e);break;case "img":case "image":case "link":G("error",e);G("load",e);break;case "form":G("reset",e);G("submit",e);break;case "details":G("toggle",e);break;case "input":Bc(e,m);G("invalid",e);xe(q,"onChange");break;case "select":e._wrapperState=
{wasMultiple:!!m.multiple};G("invalid",e);xe(q,"onChange");break;case "textarea":he(e,m),G("invalid",e),xe(q,"onChange")}ve(h,m);l=null;for(f in m)m.hasOwnProperty(f)&&(k=m[f],"children"===f?"string"===typeof k?e.textContent!==k&&(l=["children",k]):"number"===typeof k&&e.textContent!==""+k&&(l=["children",""+k]):sa.hasOwnProperty(f)&&null!=k&&xe(q,f));switch(h){case "input":Vb(e);Fc(e,m,!0);break;case "textarea":Vb(e);je(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
(e.onclick=ye)}f=l;g.updateQueue=f;g=null!==f?!0:!1;g&&zg(b)}else{m=b;e=f;q=g;l=9===h.nodeType?h:h.ownerDocument;k===ke.html&&(k=le(e));k===ke.html?"script"===e?(e=l.createElement("div"),e.innerHTML="<script>\x3c/script>",l=e.removeChild(e.firstChild)):"string"===typeof q.is?l=l.createElement(e,{is:q.is}):(l=l.createElement(e),"select"===e&&q.multiple&&(l.multiple=!0)):l=l.createElementNS(k,e);e=l;e[Ga]=m;e[Ha]=g;Ag(e,b,!1,!1);q=e;l=f;m=g;var x=h,z=we(l,m);switch(l){case "iframe":case "object":G("load",
q);h=m;break;case "video":case "audio":for(h=0;h<bb.length;h++)G(bb[h],q);h=m;break;case "source":G("error",q);h=m;break;case "img":case "image":case "link":G("error",q);G("load",q);h=m;break;case "form":G("reset",q);G("submit",q);h=m;break;case "details":G("toggle",q);h=m;break;case "input":Bc(q,m);h=Ac(q,m);G("invalid",q);xe(x,"onChange");break;case "option":h=ee(q,m);break;case "select":q._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});G("invalid",q);xe(x,"onChange");break;case "textarea":he(q,
m);h=ge(q,m);G("invalid",q);xe(x,"onChange");break;default:h=m}ve(l,h);k=void 0;var B=l,Q=q,v=h;for(k in v)if(v.hasOwnProperty(k)){var r=v[k];"style"===k?te(Q,r):"dangerouslySetInnerHTML"===k?(r=r?r.__html:void 0,null!=r&&oe(Q,r)):"children"===k?"string"===typeof r?("textarea"!==B||""!==r)&&pe(Q,r):"number"===typeof r&&pe(Q,""+r):"suppressContentEditableWarning"!==k&&"suppressHydrationWarning"!==k&&"autoFocus"!==k&&(sa.hasOwnProperty(k)?null!=r&&xe(x,k):null!=r&&yc(Q,k,r,z))}switch(l){case "input":Vb(q);
Fc(q,m,!1);break;case "textarea":Vb(q);je(q,m);break;case "option":null!=m.value&&q.setAttribute("value",""+zc(m.value));break;case "select":h=q;h.multiple=!!m.multiple;q=m.value;null!=q?fe(h,!!m.multiple,q,!1):null!=m.defaultValue&&fe(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(q.onclick=ye)}(g=Be(f,g))&&zg(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?t("166"):void 0;break;case 6:e&&null!=b.stateNode?Gg(e,b,e.memoizedProps,g):("string"!==
typeof g&&(null===b.stateNode?t("166"):void 0),e=Hf(Gf.current),Hf(N.current),lg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Ga]=g,(g=f.nodeValue!==e)&&zg(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Ga]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;R=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g!==f||0===(b.effectTag&1)&&g)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Jf(b);Bg(b);break;case 10:Bf(b);break;case 9:break;case 14:break;case 17:L(b.type)&&Me(b);break;default:t("156")}R=null}b=a;if(1===T||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==R)return R;null!==c&&0===(c.effectTag&1024)&&(null===
c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Tg(a,T);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
function fh(a){var b=yg(a.alternate,a,T);a.memoizedProps=a.pendingProps;null===b&&(b=eh(a));Vg.current=null;return b}
function gh(a,b){Yg?t("243"):void 0;Sf();Yg=!0;Vg.currentDispatcher=Ug;var c=a.nextExpirationTimeToWorkOn;if(c!==T||a!==S||null===R)dh(),S=a,T=c,R=Ze(S.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;do{try{if(b)for(;null!==R&&!hh();)R=fh(R);else for(;null!==R;)R=fh(R)}catch(B){if(zf=yf=xf=null,null===R)d=!0,Qg(B);else{null===R?t("271"):void 0;var e=R,f=e.return;if(null===f)d=!0,Qg(B);else{a:{var g=a,h=f,k=e,l=B;f=T;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==l&&"object"===
typeof l&&"function"===typeof l.then){var m=l;l=h;var q=-1,x=-1;do{if(13===l.tag){var z=l.alternate;if(null!==z&&(z=z.memoizedState,null!==z)){x=10*(1073741822-z.timedOutAt);break}z=l.pendingProps.maxDuration;if("number"===typeof z)if(0>=z)q=0;else if(-1===q||z<q)q=z}l=l.return}while(null!==l);l=h;do{if(z=13===l.tag)z=void 0===l.memoizedProps.fallback?!1:null===l.memoizedState;if(z){h=ih.bind(null,g,l,k,0===(l.mode&1)?1073741823:f);m.then(h,h);if(0===(l.mode&1)){l.effectTag|=64;k.effectTag&=-1957;
1===k.tag&&null===k.alternate&&(k.tag=17);k.expirationTime=f;break a}-1===q?g=1073741823:(-1===x&&(x=10*(1073741822-hf(g,f))-5E3),g=x+q);0<=g&&Zg<g&&(Zg=g);l.effectTag|=2048;l.expirationTime=f;break a}l=l.return}while(null!==l);l=Error((mc(k.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+nc(k))}$g=!0;l=vf(l,k);g=h;do{switch(g.tag){case 3:k=
l;g.effectTag|=2048;g.expirationTime=f;f=Pg(g,k,f);pf(g,f);break a;case 1:if(k=l,h=g.type,m=g.stateNode,0===(g.effectTag&64)&&("function"===typeof h.getDerivedStateFromError||null!==m&&"function"===typeof m.componentDidCatch&&(null===Sg||!Sg.has(m)))){g.effectTag|=2048;g.expirationTime=f;f=Rg(g,k,f);pf(g,f);break a}}g=g.return}while(null!==g)}R=eh(e);continue}}}break}while(1);Yg=!1;zf=yf=xf=Vg.currentDispatcher=null;if(d)S=null,a.finishedWork=null;else if(null!==R)a.finishedWork=null;else{d=a.current.alternate;
null===d?t("281"):void 0;S=null;if($g){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<c||0!==f&&f<c||0!==g&&g<c){gf(a,c);jh(a,d,c,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;c=a.nextExpirationTimeToWorkOn=c;b=a.expirationTime=1073741823;jh(a,d,c,b,-1);return}}b&&-1!==Zg?(gf(a,c),b=10*(1073741822-hf(a,c)),b<Zg&&(Zg=b),b=10*(1073741822-Qf()),b=Zg-b,jh(a,d,c,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=c,a.finishedWork=d)}}
function Jg(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Sg||!Sg.has(d))){a=vf(b,a);a=Rg(c,a,1073741823);of(c,a);Tf(c,1073741823);return}break;case 3:a=vf(b,a);a=Pg(c,a,1073741823);of(c,a);Tf(c,1073741823);return}c=c.return}3===a.tag&&(c=vf(b,a),c=Pg(a,c,1073741823),of(a,c),Tf(a,1073741823))}
function Rf(a,b){0!==Xg?a=Xg:Yg?a=ah?1073741823:T:b.mode&1?(a=kh?1073741822-10*(((1073741822-a+15)/10|0)+1):1073741822-25*(((1073741822-a+500)/25|0)+1),null!==S&&a===T&&--a):a=1073741823;kh&&(0===lh||a<lh)&&(lh=a);return a}
function ih(a,b,c,d){var e=a.earliestSuspendedTime;var f=a.latestSuspendedTime;if(0!==e&&d<=e&&d>=f){f=e=d;a.didError=!1;var g=a.latestPingedTime;if(0===g||g>f)a.latestPingedTime=f;ff(f,a)}else e=Qf(),e=Rf(e,b),ef(a,e);0!==(b.mode&1)&&a===S&&T===d&&(S=null);mh(b,e);0===(b.mode&1)&&(mh(c,e),1===c.tag&&null!==c.stateNode&&(b=mf(e),b.tag=2,of(c,b)));c=a.expirationTime;0!==c&&nh(a,c)}
function mh(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
function Tf(a,b){a=mh(a,b);null!==a&&(!Yg&&0!==T&&b>T&&dh(),ef(a,b),Yg&&!ah&&S===a||nh(a,a.expirationTime),oh>ph&&(oh=0,t("185")))}function qh(a,b,c,d,e){var f=Xg;Xg=1073741823;try{return a(b,c,d,e)}finally{Xg=f}}var rh=null,V=null,sh=0,th=void 0,W=!1,uh=null,X=0,lh=0,vh=!1,wh=null,Z=!1,xh=!1,kh=!1,yh=null,zh=ba.unstable_now(),Ah=1073741822-(zh/10|0),Bh=Ah,ph=50,oh=0,Ch=null;function Dh(){Ah=1073741822-((ba.unstable_now()-zh)/10|0)}
function Eh(a,b){if(0!==sh){if(b<sh)return;null!==th&&ba.unstable_cancelCallback(th)}sh=b;a=ba.unstable_now()-zh;th=ba.unstable_scheduleCallback(Fh,{timeout:10*(1073741822-b)-a})}function jh(a,b,c,d,e){a.expirationTime=d;0!==e||hh()?0<e&&(a.timeoutHandle=De(Gh.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Gh(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;Dh();Bh=Ah;Hh(a,c)}function Qf(){if(W)return Bh;Ih();if(0===X||1===X)Dh(),Bh=Ah;return Bh}
function nh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===V?(rh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=rh)):b>a.expirationTime&&(a.expirationTime=b);W||(Z?xh&&(uh=a,X=1073741823,Jh(a,1073741823,!1)):1073741823===b?Kh(1073741823,!1):Eh(a,b))}
function Ih(){var a=0,b=null;if(null!==V)for(var c=V,d=rh;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===V?t("244"):void 0;if(d===d.nextScheduledRoot){rh=V=d.nextScheduledRoot=null;break}else if(d===rh)rh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=rh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===V)break;if(1073741823===
a)break;c=d;d=d.nextScheduledRoot}}uh=b;X=a}var Lh=!1;function hh(){return Lh?!0:ba.unstable_shouldYield()?Lh=!0:!1}function Fh(){try{if(!hh()&&null!==rh){Dh();var a=rh;do{var b=a.expirationTime;0!==b&&Ah<=b&&(a.nextExpirationTimeToWorkOn=Ah);a=a.nextScheduledRoot}while(a!==rh)}Kh(0,!0)}finally{Lh=!1}}
function Kh(a,b){Ih();if(b)for(Dh(),Bh=Ah;null!==uh&&0!==X&&a<=X&&!(Lh&&Ah>X);)Jh(uh,X,Ah>X),Ih(),Dh(),Bh=Ah;else for(;null!==uh&&0!==X&&a<=X;)Jh(uh,X,!1),Ih();b&&(sh=0,th=null);0!==X&&Eh(uh,X);oh=0;Ch=null;if(null!==yh)for(a=yh,yh=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){vh||(vh=!0,wh=d)}}if(vh)throw a=wh,wh=null,vh=!1,a;}function Hh(a,b){W?t("253"):void 0;uh=a;X=b;Jh(a,b,!1);Kh(1073741823,!1)}
function Jh(a,b,c){W?t("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Mh(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,Ee(d)),gh(a,c),d=a.finishedWork,null!==d&&(hh()?a.finishedWork=d:Mh(a,d,b)))}else d=a.finishedWork,null!==d?Mh(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,Ee(d)),gh(a,c),d=a.finishedWork,null!==d&&Mh(a,d,b));W=!1}
function Mh(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===yh?yh=[d]:yh.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===Ch?oh++:(Ch=a,oh=0);ah=Yg=!0;a.current===b?t("177"):void 0;c=a.pendingCommitExpirationTime;0===c?t("261"):void 0;a.pendingCommitExpirationTime=0;d=b.expirationTime;var e=b.childExpirationTime;d=e>d?e:d;a.didError=!1;0===d?(a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=
0):(e=a.latestPendingTime,0!==e&&(e>d?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>d&&(a.earliestPendingTime=a.latestPendingTime)),e=a.earliestSuspendedTime,0===e?ef(a,d):d<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,ef(a,d)):d>e&&ef(a,d));ff(0,a);Vg.current=null;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ze=Hd;e=Td();if(Ud(e)){if("selectionStart"in e)var f={start:e.selectionStart,
end:e.selectionEnd};else a:{f=(f=e.ownerDocument)&&f.defaultView||window;var g=f.getSelection&&f.getSelection();if(g&&0!==g.rangeCount){f=g.anchorNode;var h=g.anchorOffset,k=g.focusNode;g=g.focusOffset;try{f.nodeType,k.nodeType}catch(db){f=null;break a}var l=0,m=-1,q=-1,x=0,z=0,B=e,Q=null;b:for(;;){for(var v;;){B!==f||0!==h&&3!==B.nodeType||(m=l+h);B!==k||0!==g&&3!==B.nodeType||(q=l+g);3===B.nodeType&&(l+=B.nodeValue.length);if(null===(v=B.firstChild))break;Q=B;B=v}for(;;){if(B===e)break b;Q===f&&
++x===h&&(m=l);Q===k&&++z===g&&(q=l);if(null!==(v=B.nextSibling))break;B=Q;Q=B.parentNode}B=v}f=-1===m||-1===q?null:{start:m,end:q}}else f=null}f=f||{start:0,end:0}}else f=null;Ae={focusedElem:e,selectionRange:f};Hd=!1;for(U=d;null!==U;){e=!1;f=void 0;try{for(;null!==U;){if(U.effectTag&256)a:{var r=U.alternate;h=U;switch(h.tag){case 0:case 11:case 15:break a;case 1:if(h.effectTag&256&&null!==r){var u=r.memoizedProps,y=r.memoizedState,Y=h.stateNode,Th=Y.getSnapshotBeforeUpdate(h.elementType===h.type?
u:O(h.type,u),y);Y.__reactInternalSnapshotBeforeUpdate=Th}break a;case 3:case 5:case 6:case 4:case 17:break a;default:t("163")}}U=U.nextEffect}}catch(db){e=!0,f=db}e&&(null===U?t("178"):void 0,Jg(U,f),null!==U&&(U=U.nextEffect))}for(U=d;null!==U;){r=!1;u=void 0;try{for(;null!==U;){var w=U.effectTag;w&16&&pe(U.stateNode,"");if(w&128){var C=U.alternate;if(null!==C){var p=C.ref;null!==p&&("function"===typeof p?p(null):p.current=null)}}switch(w&14){case 2:Ng(U);U.effectTag&=-3;break;case 6:Ng(U);U.effectTag&=
-3;Og(U.alternate,U);break;case 4:Og(U.alternate,U);break;case 8:y=U,Lg(y),y.return=null,y.child=null,y.alternate&&(y.alternate.child=null,y.alternate.return=null)}U=U.nextEffect}}catch(db){r=!0,u=db}r&&(null===U?t("178"):void 0,Jg(U,u),null!==U&&(U=U.nextEffect))}p=Ae;C=Td();w=p.focusedElem;u=p.selectionRange;if(C!==w&&w&&w.ownerDocument&&Sd(w.ownerDocument.documentElement,w)){null!==u&&Ud(w)&&(C=u.start,p=u.end,void 0===p&&(p=C),"selectionStart"in w?(w.selectionStart=C,w.selectionEnd=Math.min(p,
w.value.length)):(p=(C=w.ownerDocument||document)&&C.defaultView||window,p.getSelection&&(p=p.getSelection(),y=w.textContent.length,r=Math.min(u.start,y),u=void 0===u.end?r:Math.min(u.end,y),!p.extend&&r>u&&(y=u,u=r,r=y),y=Rd(w,r),Y=Rd(w,u),y&&Y&&(1!==p.rangeCount||p.anchorNode!==y.node||p.anchorOffset!==y.offset||p.focusNode!==Y.node||p.focusOffset!==Y.offset)&&(C=C.createRange(),C.setStart(y.node,y.offset),p.removeAllRanges(),r>u?(p.addRange(C),p.extend(Y.node,Y.offset)):(C.setEnd(Y.node,Y.offset),
p.addRange(C))))));C=[];for(p=w;p=p.parentNode;)1===p.nodeType&&C.push({element:p,left:p.scrollLeft,top:p.scrollTop});"function"===typeof w.focus&&w.focus();for(w=0;w<C.length;w++)p=C[w],p.element.scrollLeft=p.left,p.element.scrollTop=p.top}Ae=null;Hd=!!ze;ze=null;a.current=b;for(U=d;null!==U;){d=!1;w=void 0;try{for(C=c;null!==U;){var Fb=U.effectTag;if(Fb&36){var Gb=U.alternate;p=U;r=C;switch(p.tag){case 0:case 11:case 15:break;case 1:var wc=p.stateNode;if(p.effectTag&4)if(null===Gb)wc.componentDidMount();
else{var ci=p.elementType===p.type?Gb.memoizedProps:O(p.type,Gb.memoizedProps);wc.componentDidUpdate(ci,Gb.memoizedState,wc.__reactInternalSnapshotBeforeUpdate)}var Cg=p.updateQueue;null!==Cg&&tf(p,Cg,wc,r);break;case 3:var Dg=p.updateQueue;if(null!==Dg){u=null;if(null!==p.child)switch(p.child.tag){case 5:u=p.child.stateNode;break;case 1:u=p.child.stateNode}tf(p,Dg,u,r)}break;case 5:var di=p.stateNode;null===Gb&&p.effectTag&4&&Be(p.type,p.memoizedProps)&&di.focus();break;case 6:break;case 4:break;
case 12:break;case 13:break;case 17:break;default:t("163")}}if(Fb&128){var Ic=U.ref;if(null!==Ic){var Eg=U.stateNode;switch(U.tag){case 5:var ce=Eg;break;default:ce=Eg}"function"===typeof Ic?Ic(ce):Ic.current=ce}}U=U.nextEffect}}catch(db){d=!0,w=db}d&&(null===U?t("178"):void 0,Jg(U,w),null!==U&&(U=U.nextEffect))}Yg=ah=!1;"function"===typeof Se&&Se(b.stateNode);Fb=b.expirationTime;b=b.childExpirationTime;b=b>Fb?b:Fb;0===b&&(Sg=null);a.expirationTime=b;a.finishedWork=null}
function Qg(a){null===uh?t("246"):void 0;uh.expirationTime=0;vh||(vh=!0,wh=a)}function Nh(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Kh(1073741823,!1)}}function Oh(a,b){if(Z&&!xh){xh=!0;try{return a(b)}finally{xh=!1}}return a(b)}function Ph(a,b,c){if(kh)return a(b,c);Z||W||0===lh||(Kh(lh,!1),lh=0);var d=kh,e=Z;Z=kh=!0;try{return a(b,c)}finally{kh=d,(Z=e)||W||Kh(1073741823,!1)}}
function Qh(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===kd(c)&&1===c.tag?void 0:t("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(L(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);t("171");g=void 0}if(1===c.tag){var h=c.type;if(L(h)){c=Pe(c,h,g);break a}}c=g}else c=Je;null===b.context?b.context=c:b.pendingContext=c;b=e;e=mf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
Sf();of(f,e);Tf(f,d);return d}function Rh(a,b,c,d){var e=b.current,f=Qf();e=Rf(f,e);return Qh(a,b,c,e,d)}function Sh(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Uh(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$b,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Cb=function(a,b,c){switch(b){case "input":Dc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=La(d);e?void 0:t("90");Wb(d);Dc(d,e)}}}break;case "textarea":ie(a,c);break;case "select":b=c.value,null!=b&&fe(a,!!c.multiple,b,!1)}};
function Vh(a){var b=1073741822-25*(((1073741822-Qf()+500)/25|0)+1);b>=Wg&&(b=Wg-1);this._expirationTime=Wg=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Vh.prototype.render=function(a){this._defer?void 0:t("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Wh;Qh(a,b,null,c,d._onCommit);return d};
Vh.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Vh.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:t("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?t("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Hh(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};Vh.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Wh(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Wh.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Wh.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?t("191",c):void 0;c()}}};
function Xh(a,b,c){b=M(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
Xh.prototype.render=function(a,b){var c=this._internalRoot,d=new Wh;b=void 0===b?null:b;null!==b&&d.then(b);Rh(a,c,null,d._onCommit);return d};Xh.prototype.unmount=function(a){var b=this._internalRoot,c=new Wh;a=void 0===a?null:a;null!==a&&c.then(a);Rh(null,b,null,c._onCommit);return c};Xh.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Wh;c=void 0===c?null:c;null!==c&&e.then(c);Rh(b,d,a,e._onCommit);return e};
Xh.prototype.createBatch=function(){var a=new Vh(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Yh(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Kb=Nh;Lb=Ph;Mb=function(){W||0===lh||(Kh(lh,!1),lh=0)};
function Zh(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Xh(a,!1,b)}
function $h(a,b,c,d,e){Yh(c)?void 0:t("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Sh(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Zh(c,d);if("function"===typeof e){var h=e;e=function(){var a=Sh(f._internalRoot);h.call(a)}}Oh(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Sh(f._internalRoot)}
function ai(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Yh(b)?void 0:t("200");return Uh(a,b,null,c)}
var bi={createPortal:ai,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?t("188"):t("268",Object.keys(a)));a=nd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){return $h(null,a,b,!0,c)},render:function(a,b,c){return $h(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?t("38"):void 0;return $h(a,b,c,!1,d)},unmountComponentAtNode:function(a){Yh(a)?
void 0:t("40");return a._reactRootContainer?(Oh(function(){$h(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return ai.apply(void 0,arguments)},unstable_batchedUpdates:Nh,unstable_interactiveUpdates:Ph,flushSync:function(a,b){W?t("187"):void 0;var c=Z;Z=!0;try{return qh(a,b)}finally{Z=c,Kh(1073741823,!1)}},unstable_flushControlled:function(a){var b=Z;Z=!0;try{qh(a)}finally{(Z=b)||W||Kh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ja,
Ka,La,Ca.injectEventPluginsByName,qa,Ra,function(a){za(a,Qa)},Ib,Jb,Jd,Ea]},unstable_createRoot:function(a,b){Yh(a)?void 0:t("299","unstable_createRoot");return new Xh(a,!0,null!=b&&!0===b.hydrate)}};(function(a){var b=a.findFiberByHostInstance;return Ve(n({},a,{findHostInstanceByFiber:function(a){a=nd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ia,bundleType:0,version:"16.6.3",rendererPackageName:"react-dom"});
var ei={default:bi},fi=ei&&bi||ei;module.exports=fi.default||fi;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(160);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var d=null,f=!1,h=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var e=h,Q=l;h=a;l=b;try{var g=c()}finally{h=e,l=Q}if("function"===typeof g)if(g={callback:g,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=g.next=g.previous=g;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=g,p());b=c.previous;b.next=c.previous=g;g.next=c;g.previous=
b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=f;f=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,f=b,null!==d?p():n=!1,v()}}
var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w;
if("undefined"!==typeof window&&window._schedMock){var G=window._schedMock;r=G[0];q=G[1];w=G[2]}else if("undefined"===typeof window||"function"!==typeof window.addEventListener){var H=null,I=-1,J=function(a,b){if(null!==H){var c=H;H=null;try{I=b,c(a)}finally{I=-1}}};r=function(a,b){-1!==I?setTimeout(r,0,a,b):(H=a,setTimeout(J,b,!0,b),setTimeout(J,1073741823,!1,1073741823))};q=function(){H=null};w=function(){return!1};exports.unstable_now=function(){return-1===I?0:I}}else{"undefined"!==typeof console&&
("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T="__reactIdleCallback$"+Math.random().toString(36).slice(2);
window.addEventListener("message",function(a){if(a.source===window&&a.data===T){L=!1;a=K;var b=M;K=null;M=-1;var c=exports.unstable_now(),e=!1;if(0>=P-c)if(-1!==b&&b<=c)e=!0;else{N||(N=!0,E(U));K=a;M=b;return}if(null!==a){O=!0;try{a(e)}finally{O=!1}}}},!1);var U=function(a){if(null!==K){E(U);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,window.postMessage(T,"*"))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?window.postMessage(T,"*"):N||(N=!0,E(U))};q=function(){K=null;L=!1;M=-1}}
exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=h,e=k;h=a;k=exports.unstable_now();try{return b()}finally{h=c,k=e,v()}};
exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(h){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:h,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var e=d;do{if(e.expirationTime>b){c=e;break}e=e.next}while(e!==d);null===c?c=d:c===d&&(d=a,p());
b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=h;return function(){var c=h,e=k;h=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{h=c,k=e,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return h};
exports.unstable_shouldYield=function(){return!f&&(null!==d&&d.expirationTime<l||w())};


/***/ }),
/* 161 */
/***/ (function(module, exports) {

(function(window) {
  var FUNCTION = 'function';
  var UNDEFINED = 'undefined';
  var subscribers = [];
  var isWeb = typeof window !== UNDEFINED && !window.AndroidBridge && !window.webkit;
  var eventType = isWeb ? 'message' : 'VKWebAppEvent';

  if (typeof window !== UNDEFINED) {

    //polyfill
    if (!window.CustomEvent) {
      (function() {
        function CustomEvent(event, params) {
          params = params || {bubbles: false, cancelable: false, detail: undefined};
          var evt = document.createEvent('CustomEvent');
          evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
          return evt;
        };

        CustomEvent.prototype = window.Event.prototype;

        window.CustomEvent = CustomEvent;
      })();
    }

    window.addEventListener(eventType, function() {
      var args = Array.prototype.slice.call(arguments);
      if (isWeb) {
        subscribers.forEach(function(fn) {
          fn({
            detail: args[0].data
          });
        });
      } else {
        subscribers.forEach(function(fn) {
          fn.apply(null, args);
        });
      }
    });
  }

  module.exports = {
    /**
     * Sends a message to native client
     *
     * @example
     * message.send('VKWebAppInit');
     *
     * @param {String} handler Message type
     * @param {Object} params Message data
     * @returns {void}
     */
    send: function send(handler, params) {
      if (!params) {
        params = {};
      }

      var isClient = typeof window !== UNDEFINED;
      var androidBridge = isClient && window.AndroidBridge;
      var iosBridge = isClient && window.webkit && window.webkit.messageHandlers;
      var isDesktop = !androidBridge && !iosBridge;

      if (androidBridge && typeof androidBridge[handler] == FUNCTION) {
        androidBridge[handler](JSON.stringify(params));
      }
      if (iosBridge && iosBridge[handler] && typeof iosBridge[handler].postMessage == FUNCTION) {
        iosBridge[handler].postMessage(params);
      }

      if (isDesktop) {
        parent.postMessage({
          handler: handler,
          params: params,
          type: 'vk-connect'
        }, '*');
      }
    },
    /**
     * Subscribe on VKWebAppEvent
     *
     * @param {Function} fn Event handler
     * @returns {void}
     */
    subscribe: function subscribe(fn) {
      subscribers.push(fn);
    },
    /**
     * Unsubscribe on VKWebAppEvent
     *
     * @param {Function} fn Event handler
     * @returns {void}
     */
    unsubscribe: function unsubscribe(fn) {
      var index = subscribers.indexOf(fn);

      if (index > -1) {
        subscribers.splice(index, 1);
      }
    },

    /**
     * Checks if native client supports nandler
     *
     * @param {String} handler Handler name
     * @returns {boolean}
     */
    supports: function supports(handler) {

      var isClient = typeof window !== UNDEFINED;
      var androidBridge = isClient && window.AndroidBridge;
      var iosBridge = isClient && window.webkit && window.webkit.messageHandlers;
      var desktopEvents = [
        "VKWebAppGetAuthToken",
        "VKWebAppCallAPIMethod",
        "VKWebAppGetGeodata",
        "VKWebAppGetUserInfo",
        "VKWebAppGetPhoneNumber",
        "VKWebAppGetClientVersion",
        "VKWebAppOpenPayForm",
        "VKWebAppShare",
        "VKWebAppAllowNotifications",
        "VKWebAppDenyNotifications",
        "VKWebAppShowWallPostBox",
        "VKWebAppGetEmail",
        "VKWebAppAllowMessagesFromGroup",
        "VKWebAppJoinGroup",
        "VKWebAppOpenApp",
        "VKWebAppSetLocation",
        "VKWebAppScroll",
        "VKWebAppResizeWindow",
      ];

      if (androidBridge && typeof androidBridge[handler] == FUNCTION) return true;

      if (iosBridge && iosBridge[handler] && typeof iosBridge[handler].postMessage == FUNCTION) return true;

      if (!iosBridge && !androidBridge && ~desktopEvents.indexOf(handler)) return true;

      return false;
    }
  };
})(window);


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tensorflow_tfjs__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vkontakte_vkui_dist_vkui_css__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vkontakte_vkui_dist_vkui_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__vkontakte_vkui_dist_vkui_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vocab_json__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__vocab_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__vocab_json__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_React$Component){_inherits(App,_React$Component);function App(){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this));_this.loadModel();_this.state={text:'',model:null,data:[0,//toxic
0,//severe toxic
0,//obscene
0,//threat
0,//insult
0//identity hate
]};_this.loadModel=_this.loadModel.bind(_this);_this.changeText=_this.changeText.bind(_this);_this.clearText=_this.clearText.bind(_this);_this.calculate=_this.calculate.bind(_this);_this.loadModel();return _this;}_createClass(App,[{key:'calculate',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(text){var data,tensorBuffer,parts,tIndex;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:data=[0,//toxic
0,//severe toxic
0,//obscene
0,//threat
0,//insult
0//identity hate
];if(!(text&&this.state.model)){_context.next=9;break;}tensorBuffer=__WEBPACK_IMPORTED_MODULE_2__tensorflow_tfjs__["b" /* zeros */]([1,100]).buffer();parts=text.split(' ');tIndex=0;parts.forEach(function(value){if(__WEBPACK_IMPORTED_MODULE_5__vocab_json__["hasOwnProperty"](value)){tensorBuffer.set(__WEBPACK_IMPORTED_MODULE_5__vocab_json__[value],0,tIndex);tIndex++;}});_context.next=8;return this.state.model.predict(tensorBuffer.toTensor()).data();case 8:data=_context.sent;case 9:this.setState({data:data});case 10:case'end':return _context.stop();}}},_callee,this);}));function calculate(_x){return _ref.apply(this,arguments);}return calculate;}()},{key:'changeText',value:function changeText(e){var text=e.target.value.toLowerCase();this.setState({text:text});this.calculate(text);}},{key:'clearText',value:function clearText(){this.setState({text:''});this.calculate('');}},{key:'loadModel',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var loadedModel;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return __WEBPACK_IMPORTED_MODULE_2__tensorflow_tfjs__["a" /* loadModel */]("/vk-apps-tensorflow-example"+'/model.json');case 2:loadedModel=_context2.sent;this.setState({model:loadedModel});if(this.state.text){this.calculate(this.state.text);}case 5:case'end':return _context2.stop();}}},_callee2,this);}));function loadModel(){return _ref2.apply(this,arguments);}return loadModel;}()},{key:'render',value:function render(){var content=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__["Div"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__["Spinner"],null));if(this.state.model){content=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__["List"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__["Cell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__["InfoRow"],{title:'Toxic'},App.renderScore(this.state.data[0]),' ',App.renderEmoji(this.state.data[0]))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__["Cell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__["InfoRow"],{title:'Severe Toxic'},App.renderScore(this.state.data[1]),' ',App.renderEmoji(this.state.data[1]))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__["Cell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__["InfoRow"],{title:'Obscene'},App.renderScore(this.state.data[2]),' ',App.renderEmoji(this.state.data[2]))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__["Cell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__["InfoRow"],{title:'Threat'},App.renderScore(this.state.data[3]),' ',App.renderEmoji(this.state.data[3]))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__["Cell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__["InfoRow"],{title:'Insult'},App.renderScore(this.state.data[4]),' ',App.renderEmoji(this.state.data[4]))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__["Cell"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__["InfoRow"],{title:'Identity Hate'},App.renderScore(this.state.data[5]),' ',App.renderEmoji(this.state.data[5]))));}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__["View"],{activePanel:'mainPanel'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__["Panel"],{id:'mainPanel'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__["PanelHeader"],null,'The Toxic Detector'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__["Group"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__["FormLayout"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__["Input"],{type:'text',top:'Your text',value:this.state.text,onChange:this.changeText}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__["CellButton"],{level:'danger',onClick:this.clearText},'Clear text'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__vkontakte_vkui__["Group"],{title:'Results'},content)));}}],[{key:'renderScore',value:function renderScore(score){return Math.round(score*1000)/10+'%';}},{key:'renderEmoji',value:function renderEmoji(score){if(score>=0.9){return'👿';}else if(score>=0.5){return'😡';}else if(score>=0.2){return'😳';}else{return'😀';}}}]);return App;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(164);


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(165);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 165 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export version */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__ = __webpack_require__(35);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_91"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tensorflow_tfjs_layers__ = __webpack_require__(122);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__tensorflow_tfjs_layers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tensorflow_tfjs_converter__ = __webpack_require__(123);
/* unused harmony namespace reexport */
// @tensorflow/tfjs Copyright 2018 Google
var version="0.13.5",version$1={"tfjs-core":__WEBPACK_IMPORTED_MODULE_0__tensorflow_tfjs_core__["_88" /* version_core */],"tfjs-layers":__WEBPACK_IMPORTED_MODULE_1__tensorflow_tfjs_layers__["b" /* version_layers */],"tfjs-converter":__WEBPACK_IMPORTED_MODULE_2__tensorflow_tfjs_converter__["a" /* version_converter */],tfjs:version};
//# sourceMappingURL=tf.esm.js.map


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(10)))

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  for (var i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 169 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__(21)
exports.createHash = exports.Hash = __webpack_require__(24)
exports.createHmac = exports.Hmac = __webpack_require__(95)

var algos = __webpack_require__(185)
var algoKeys = Object.keys(algos)
var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys)
exports.getHashes = function () {
  return hashes
}

var p = __webpack_require__(98)
exports.pbkdf2 = p.pbkdf2
exports.pbkdf2Sync = p.pbkdf2Sync

var aes = __webpack_require__(187)

exports.Cipher = aes.Cipher
exports.createCipher = aes.createCipher
exports.Cipheriv = aes.Cipheriv
exports.createCipheriv = aes.createCipheriv
exports.Decipher = aes.Decipher
exports.createDecipher = aes.createDecipher
exports.Decipheriv = aes.Decipheriv
exports.createDecipheriv = aes.createDecipheriv
exports.getCiphers = aes.getCiphers
exports.listCiphers = aes.listCiphers

var dh = __webpack_require__(204)

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup
exports.getDiffieHellman = dh.getDiffieHellman
exports.createDiffieHellman = dh.createDiffieHellman
exports.DiffieHellman = dh.DiffieHellman

var sign = __webpack_require__(210)

exports.createSign = sign.createSign
exports.Sign = sign.Sign
exports.createVerify = sign.createVerify
exports.Verify = sign.Verify

exports.createECDH = __webpack_require__(248)

var publicEncrypt = __webpack_require__(249)

exports.publicEncrypt = publicEncrypt.publicEncrypt
exports.privateEncrypt = publicEncrypt.privateEncrypt
exports.publicDecrypt = publicEncrypt.publicDecrypt
exports.privateDecrypt = publicEncrypt.privateDecrypt

// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })

var rf = __webpack_require__(252)

exports.randomFill = rf.randomFill
exports.randomFillSync = rf.randomFillSync

exports.createCredentials = function () {
  throw new Error([
    'sorry, createCredentials is not implemented yet',
    'we accept pull requests',
    'https://github.com/crypto-browserify/crypto-browserify'
  ].join('\n'))
}

exports.constants = {
  'DH_CHECK_P_NOT_SAFE_PRIME': 2,
  'DH_CHECK_P_NOT_PRIME': 1,
  'DH_UNABLE_TO_CHECK_GENERATOR': 4,
  'DH_NOT_SUITABLE_GENERATOR': 8,
  'NPN_ENABLED': 1,
  'ALPN_ENABLED': 1,
  'RSA_PKCS1_PADDING': 1,
  'RSA_SSLV23_PADDING': 2,
  'RSA_NO_PADDING': 3,
  'RSA_PKCS1_OAEP_PADDING': 4,
  'RSA_X931_PADDING': 5,
  'RSA_PKCS1_PSS_PADDING': 6,
  'POINT_CONVERSION_COMPRESSED': 2,
  'POINT_CONVERSION_UNCOMPRESSED': 4,
  'POINT_CONVERSION_HYBRID': 6
}


/***/ }),
/* 171 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(1).Buffer;
var util = __webpack_require__(173);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 173 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(92);

/*<replacement>*/
var util = __webpack_require__(25);
util.inherits = __webpack_require__(0);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(53);


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(14);


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(52).Transform


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(52).PassThrough


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__(0)
var Hash = __webpack_require__(22)
var Buffer = __webpack_require__(1).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__(0)
var Hash = __webpack_require__(22)
var Buffer = __webpack_require__(1).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(0)
var Sha256 = __webpack_require__(93)
var Hash = __webpack_require__(22)
var Buffer = __webpack_require__(1).Buffer

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(0)
var SHA512 = __webpack_require__(94)
var Hash = __webpack_require__(22)
var Buffer = __webpack_require__(1).Buffer

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(0)
var Buffer = __webpack_require__(1).Buffer

var Base = __webpack_require__(12)

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(97)


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {var checkParameters = __webpack_require__(99)
var defaultEncoding = __webpack_require__(100)
var sync = __webpack_require__(101)
var Buffer = __webpack_require__(1).Buffer

var ZERO_BUF
var subtle = global.crypto && global.crypto.subtle
var toBrowser = {
  'sha': 'SHA-1',
  'sha-1': 'SHA-1',
  'sha1': 'SHA-1',
  'sha256': 'SHA-256',
  'sha-256': 'SHA-256',
  'sha384': 'SHA-384',
  'sha-384': 'SHA-384',
  'sha-512': 'SHA-512',
  'sha512': 'SHA-512'
}
var checks = []
function checkNative (algo) {
  if (global.process && !global.process.browser) {
    return Promise.resolve(false)
  }
  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
    return Promise.resolve(false)
  }
  if (checks[algo] !== undefined) {
    return checks[algo]
  }
  ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
    .then(function () {
      return true
    }).catch(function () {
      return false
    })
  checks[algo] = prom
  return prom
}

function browserPbkdf2 (password, salt, iterations, length, algo) {
  return subtle.importKey(
    'raw', password, {name: 'PBKDF2'}, false, ['deriveBits']
  ).then(function (key) {
    return subtle.deriveBits({
      name: 'PBKDF2',
      salt: salt,
      iterations: iterations,
      hash: {
        name: algo
      }
    }, key, length << 3)
  }).then(function (res) {
    return Buffer.from(res)
  })
}

function resolvePromise (promise, callback) {
  promise.then(function (out) {
    process.nextTick(function () {
      callback(null, out)
    })
  }, function (e) {
    process.nextTick(function () {
      callback(e)
    })
  })
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  digest = digest || 'sha1'
  var algo = toBrowser[digest.toLowerCase()]

  if (!algo || typeof global.Promise !== 'function') {
    return process.nextTick(function () {
      var out
      try {
        out = sync(password, salt, iterations, keylen, digest)
      } catch (e) {
        return callback(e)
      }
      callback(null, out)
    })
  }

  checkParameters(password, salt, iterations, keylen)
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  resolvePromise(checkNative(algo).then(function (resp) {
    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

    return sync(password, salt, iterations, keylen, digest)
  }), callback)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(10)))

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var DES = __webpack_require__(188)
var aes = __webpack_require__(58)
var aesModes = __webpack_require__(59)
var desModes = __webpack_require__(203)
var ebtk = __webpack_require__(38)

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var CipherBase = __webpack_require__(12)
var des = __webpack_require__(57)
var inherits = __webpack_require__(0)
var Buffer = __webpack_require__(1).Buffer

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(6);

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(6);
var inherits = __webpack_require__(0);

var des = __webpack_require__(57);
var utils = des.utils;
var Cipher = des.Cipher;

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(6);
var inherits = __webpack_require__(0);

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(6);
var inherits = __webpack_require__(0);

var des = __webpack_require__(57);
var Cipher = des.Cipher;
var DES = des.DES;

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var MODES = __webpack_require__(59)
var AuthCipher = __webpack_require__(105)
var Buffer = __webpack_require__(1).Buffer
var StreamCipher = __webpack_require__(106)
var Transform = __webpack_require__(12)
var aes = __webpack_require__(37)
var ebtk = __webpack_require__(38)
var inherits = __webpack_require__(0)

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher


/***/ }),
/* 195 */
/***/ (function(module, exports) {

exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(26)

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(1).Buffer
var xor = __webpack_require__(26)

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(1).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(1).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(26)

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(1).Buffer
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var AuthCipher = __webpack_require__(105)
var Buffer = __webpack_require__(1).Buffer
var MODES = __webpack_require__(59)
var StreamCipher = __webpack_require__(106)
var Transform = __webpack_require__(12)
var aes = __webpack_require__(37)
var ebtk = __webpack_require__(38)
var inherits = __webpack_require__(0)

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv


/***/ }),
/* 203 */
/***/ (function(module, exports) {

exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var generatePrime = __webpack_require__(107)
var primes = __webpack_require__(208)

var DH = __webpack_require__(209)

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 206 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 207 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 208 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var BN = __webpack_require__(2);
var MillerRabin = __webpack_require__(108);
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = __webpack_require__(107);
var randomBytes = __webpack_require__(21);
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(24)
var stream = __webpack_require__(50)
var inherits = __webpack_require__(0)
var sign = __webpack_require__(211)
var verify = __webpack_require__(247)

var algorithms = __webpack_require__(97)
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = new Buffer(algorithms[key].id, 'hex')
  algorithms[key.toLowerCase()] = algorithms[key]
})

function Sign (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hashType = data.hash
  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Sign, stream.Writable)

Sign.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Sign.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Sign.prototype.sign = function signMethod (key, enc) {
  this.end()
  var hash = this._hash.digest()
  var sig = sign(hash, key, this._hashType, this._signType, this._tag)

  return enc ? sig.toString(enc) : sig
}

function Verify (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Verify, stream.Writable)

Verify.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Verify.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Verify.prototype.verify = function verifyMethod (key, sig, enc) {
  if (typeof sig === 'string') sig = new Buffer(sig, enc)

  this.end()
  var hash = this._hash.digest()
  return verify(sig, hash, key, this._signType, this._tag)
}

function createSign (algorithm) {
  return new Sign(algorithm)
}

function createVerify (algorithm) {
  return new Verify(algorithm)
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var createHmac = __webpack_require__(95)
var crt = __webpack_require__(60)
var EC = __webpack_require__(5).ec
var BN = __webpack_require__(2)
var parseKeys = __webpack_require__(40)
var curves = __webpack_require__(118)

function sign (hash, key, hashType, signType, tag) {
  var priv = parseKeys(key)
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
    return ecSign(hash, priv)
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong private key type')
    return dsaSign(hash, priv, hashType)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = priv.modulus.byteLength()
  var pad = [ 0, 1 ]
  while (hash.length + pad.length + 1 < len) pad.push(0xff)
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) pad.push(hash[i])

  var out = crt(pad, priv)
  return out
}

function ecSign (hash, priv) {
  var curveId = curves[priv.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))

  var curve = new EC(curveId)
  var key = curve.keyFromPrivate(priv.privateKey)
  var out = key.sign(hash)

  return new Buffer(out.toDER())
}

function dsaSign (hash, priv, algo) {
  var x = priv.params.priv_key
  var p = priv.params.p
  var q = priv.params.q
  var g = priv.params.g
  var r = new BN(0)
  var k
  var H = bits2int(hash, q).mod(q)
  var s = false
  var kv = getKey(x, q, hash, algo)
  while (s === false) {
    k = makeKey(q, kv, algo)
    r = makeR(g, k, p, q)
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
    if (s.cmpn(0) === 0) {
      s = false
      r = new BN(0)
    }
  }
  return toDER(r, s)
}

function toDER (r, s) {
  r = r.toArray()
  s = s.toArray()

  // Pad values
  if (r[0] & 0x80) r = [ 0 ].concat(r)
  if (s[0] & 0x80) s = [ 0 ].concat(s)

  var total = r.length + s.length + 4
  var res = [ 0x30, total, 0x02, r.length ]
  res = res.concat(r, [ 0x02, s.length ], s)
  return new Buffer(res)
}

function getKey (x, q, hash, algo) {
  x = new Buffer(x.toArray())
  if (x.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - x.length)
    zeros.fill(0)
    x = Buffer.concat([ zeros, x ])
  }
  var hlen = hash.length
  var hbits = bits2octets(hash, q)
  var v = new Buffer(hlen)
  v.fill(1)
  var k = new Buffer(hlen)
  k.fill(0)
  k = createHmac(algo, k).update(v).update(new Buffer([ 0 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  k = createHmac(algo, k).update(v).update(new Buffer([ 1 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  return { k: k, v: v }
}

function bits2int (obits, q) {
  var bits = new BN(obits)
  var shift = (obits.length << 3) - q.bitLength()
  if (shift > 0) bits.ishrn(shift)
  return bits
}

function bits2octets (bits, q) {
  bits = bits2int(bits, q)
  bits = bits.mod(q)
  var out = new Buffer(bits.toArray())
  if (out.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - out.length)
    zeros.fill(0)
    out = Buffer.concat([ zeros, out ])
  }
  return out
}

function makeKey (q, kv, algo) {
  var t
  var k

  do {
    t = new Buffer(0)

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest()
      t = Buffer.concat([ t, kv.v ])
    }

    k = bits2int(t, q)
    kv.k = createHmac(algo, kv.k).update(kv.v).update(new Buffer([ 0 ])).digest()
    kv.v = createHmac(algo, kv.k).update(kv.v).digest()
  } while (k.cmp(q) !== -1)

  return k
}

function makeR (g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
}

module.exports = sign
module.exports.getKey = getKey
module.exports.makeKey = makeKey

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ }),
/* 212 */
/***/ (function(module, exports) {

module.exports = {"_from":"elliptic@^6.0.0","_id":"elliptic@6.4.1","_inBundle":false,"_integrity":"sha512-BsXLz5sqX8OHcsh7CqBMztyXARmGQ3LWPtGjJi6DiJHq5C/qvi9P3OqgswKSDftbu8+IoI/QDTAm2fFnQ9SZSQ==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"elliptic@^6.0.0","name":"elliptic","escapedName":"elliptic","rawSpec":"^6.0.0","saveSpec":null,"fetchSpec":"^6.0.0"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.1.tgz","_shasum":"c2d0b7776911b86722c632c3c06c60f2f819939a","_spec":"elliptic@^6.0.0","_where":"/Users/tsivarev/vk_apps/vk-apps-tensorflow-example/node_modules/browserify-sign","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"bundleDependencies":false,"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"deprecated":false,"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.1"}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;
var BN = __webpack_require__(2);
var minAssert = __webpack_require__(6);
var minUtils = __webpack_require__(110);

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w) {
  var naf = [];
  var ws = 1 << (w + 1);
  var k = num.clone();
  while (k.cmpn(1) >= 0) {
    var z;
    if (k.isOdd()) {
      var mod = k.andln(ws - 1);
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }
    naf.push(z);

    // Optimization, shift by word if possible
    var shift = (k.cmpn(0) !== 0 && k.andln(ws - 1) === 0) ? (w + 1) : 1;
    for (var i = 1; i < shift; i++)
      naf.push(0);
    k.iushrn(shift);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    []
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {

    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      var m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      var m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
           this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
                                     bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;



/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(2);
var elliptic = __webpack_require__(5);
var utils = elliptic.utils;
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  for (var j = 0; j < naf.length; j += doubles.step) {
    var nafW = 0;
    for (var k = j + doubles.step - 1; k >= j; k--)
      nafW = (nafW << 1) + naf[k];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (var j = 0; j < repr.length; j++) {
      var nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var k = 0; i >= 0 && naf[i] === 0; i--)
      k++;
    if (i >= 0)
      k++;
    acc = acc.dblp(k);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
                                                       points,
                                                       coeffs,
                                                       len,
                                                       jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  for (var i = 0; i < len; i++) {
    var p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (var i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a]);
      naf[b] = getNAF(coeffs[b], wndWidth[b]);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b] /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (var j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (var i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (var j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (var j = 0; j < len; j++) {
      var z = tmp[j];
      var p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (var i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
                          bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len)) ;
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(39);
var elliptic = __webpack_require__(5);
var BN = __webpack_require__(2);
var inherits = __webpack_require__(0);
var Base = curve.base;

var assert = elliptic.utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16)
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 }
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
  var npoints = this._endoWnafT1;
  var ncoeffs = this._endoWnafT2;
  for (var i = 0; i < points.length; i++) {
    var split = this._endoSplit(coeffs[i]);
    var p = points[i];
    var beta = p._getBeta();

    if (split.k1.negative) {
      split.k1.ineg();
      p = p.neg(true);
    }
    if (split.k2.negative) {
      split.k2.ineg();
      beta = beta.neg(true);
    }

    npoints[i * 2] = p;
    npoints[i * 2 + 1] = beta;
    ncoeffs[i * 2] = split.k1;
    ncoeffs[i * 2 + 1] = split.k2;
  }
  var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

  // Clean-up references to points and coefficients
  for (var j = 0; j < i * 2; j++) {
    npoints[j] = null;
    ncoeffs[j] = null;
  }
  return res;
};

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul)
      }
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1)
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1)
    }
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point))
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point))
    }
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);

  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate)
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate)
      }
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (var i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (var i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(39);
var BN = __webpack_require__(2);
var inherits = __webpack_require__(0);
var Base = curve.base;

var elliptic = __webpack_require__(5);
var utils = elliptic.utils;

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = __webpack_require__(39);
var elliptic = __webpack_require__(5);
var BN = __webpack_require__(2);
var inherits = __webpack_require__(0);
var Base = curve.base;

var assert = elliptic.utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.c2);
  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.fromRed().isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
    (this.y.cmp(this.z) === 0 ||
    (this.zOne && this.y.cmp(this.curve.c) === 0));
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  if (this.curve.twisted) {
    // E = a * C
    var e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      var h = this.z.redSqr();
      // J = F - 2 * H
      var j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    var e = c.redAdd(d);
    // H = (c * Z1)^2
    var h = this.curve._mulC(this.z).redSqr();
    // J = E - 2 * H
    var j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
                          this.y,
                          this.z,
                          this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curves = exports;

var hash = __webpack_require__(61);
var elliptic = __webpack_require__(5);

var assert = elliptic.utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new elliptic.curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new elliptic.curve.edwards(options);
  else
    this.curve = new elliptic.curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve
      });
      return curve;
    }
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
  ]
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
  ]
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
  ]
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f'
  ]
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650'
  ]
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9'
  ]
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658'
  ]
});

var pre;
try {
  pre = __webpack_require__(225);
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3'
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15'
    }
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre
  ]
});


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.sha1 = __webpack_require__(220);
exports.sha224 = __webpack_require__(221);
exports.sha256 = __webpack_require__(112);
exports.sha384 = __webpack_require__(222);
exports.sha512 = __webpack_require__(113);


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var common = __webpack_require__(27);
var shaCommon = __webpack_require__(111);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var SHA256 = __webpack_require__(112);

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};



/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

var SHA512 = __webpack_require__(113);

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var common = __webpack_require__(27);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var assert = __webpack_require__(6);

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};


/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
      ]
    ]
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
      ]
    ]
  }
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(2);
var HmacDRBG = __webpack_require__(227);
var elliptic = __webpack_require__(5);
var utils = elliptic.utils;
var assert = utils.assert;

var KeyPair = __webpack_require__(228);
var Signature = __webpack_require__(229);

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(elliptic.curves.hasOwnProperty(options), 'Unknown curve ' + options);

    options = elliptic.curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof elliptic.curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || elliptic.rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray()
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  do {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  } while (true);
};

EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new BN(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8'
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; true; iter++) {
    var k = options.k ?
        options.k(iter) :
        new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc) {
  msg = this._truncateToN(new BN(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);

  if (!this.curve._maxwellTrick) {
    var p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  var p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(61);
var utils = __webpack_require__(110);
var assert = __webpack_require__(6);

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(2);
var elliptic = __webpack_require__(5);
var utils = elliptic.utils;
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(2);

var elliptic = __webpack_require__(5);
var utils = elliptic.utils;
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;
  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
  }
  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0 && (r[1] & 0x80)) {
    r = r.slice(1);
  }
  if (s[0] === 0 && (s[1] & 0x80)) {
    s = s.slice(1);
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(61);
var elliptic = __webpack_require__(5);
var utils = elliptic.utils;
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = __webpack_require__(231);
var Signature = __webpack_require__(232);

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  var curve = elliptic.curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
               .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = __webpack_require__(5);
var utils = elliptic.utils;
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(2);
var elliptic = __webpack_require__(5);
var utils = elliptic.utils;
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength)
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.


var asn1 = __webpack_require__(28)

exports.certificate = __webpack_require__(244)

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('modulus').int(),
    this.key('publicExponent').int(),
    this.key('privateExponent').int(),
    this.key('prime1').int(),
    this.key('prime2').int(),
    this.key('exponent1').int(),
    this.key('exponent2').int(),
    this.key('coefficient').int()
  )
})
exports.RSAPrivateKey = RSAPrivateKey

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
  this.seq().obj(
    this.key('modulus').int(),
    this.key('publicExponent').int()
  )
})
exports.RSAPublicKey = RSAPublicKey

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})
exports.PublicKey = PublicKey

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('none').null_().optional(),
    this.key('curve').objid().optional(),
    this.key('params').seq().obj(
      this.key('p').int(),
      this.key('q').int(),
      this.key('g').int()
    ).optional()
  )
})

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPrivateKey').octstr()
  )
})
exports.PrivateKey = PrivateKeyInfo
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').seq().obj(
      this.key('id').objid(),
      this.key('decrypt').seq().obj(
        this.key('kde').seq().obj(
          this.key('id').objid(),
          this.key('kdeparams').seq().obj(
            this.key('salt').octstr(),
            this.key('iters').int()
          )
        ),
        this.key('cipher').seq().obj(
          this.key('algo').objid(),
          this.key('iv').octstr()
        )
      )
    ),
    this.key('subjectPrivateKey').octstr()
  )
})

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('p').int(),
    this.key('q').int(),
    this.key('g').int(),
    this.key('pub_key').int(),
    this.key('priv_key').int()
  )
})
exports.DSAPrivateKey = DSAPrivateKey

exports.DSAparam = asn1.define('DSAparam', function () {
  this.int()
})

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('privateKey').octstr(),
    this.key('parameters').optional().explicit(0).use(ECParameters),
    this.key('publicKey').optional().explicit(1).bitstr()
  )
})
exports.ECPrivateKey = ECPrivateKey

var ECParameters = asn1.define('ECParameters', function () {
  this.choice({
    namedCurve: this.objid()
  })
})

exports.signature = asn1.define('signature', function () {
  this.seq().obj(
    this.key('r').int(),
    this.key('s').int()
  )
})


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__(28);
var inherits = __webpack_require__(0);

var api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
};

Entity.prototype._createNamed = function createNamed(base) {
  var named;
  try {
    named = __webpack_require__(235).runInThisContext(
      '(function ' + this.name + '(entity) {\n' +
      '  this._initNamed(entity);\n' +
      '})'
    );
  } catch (e) {
    named = function (entity) {
      this._initNamed(entity);
    };
  }
  inherits(named, base);
  named.prototype._initNamed = function initnamed(entity) {
    base.call(this, entity);
  };

  return new named(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var indexOf = __webpack_require__(236);

var Object_keys = function (obj) {
    if (Object.keys) return Object.keys(obj)
    else {
        var res = [];
        for (var key in obj) res.push(key)
        return res;
    }
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

var defineProp = (function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            })
        };
    } catch(e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}());

var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript (code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};

Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }
    
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    
    document.body.appendChild(iframe);
    
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;

    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    
    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });
    
    var winKeys = Object_keys(win);

    var res = wEval.call(win, this.code);
    
    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });

    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });
    
    document.body.removeChild(iframe);
    
    return res;
};

Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);

    forEach(Object_keys(ctx), function (key) {
        context[key] = ctx[key];
    });

    return res;
};

forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});

exports.createScript = function (code) {
    return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if(typeof context === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};


/***/ }),
/* 236 */
/***/ (function(module, exports) {


var indexOf = [].indexOf;

module.exports = function(arr, obj){
  if (indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(0);

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  var state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  var state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  var state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  var state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  var state = this._reporterState;

  var prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  var state = this._reporterState;

  var now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  var err;
  var state = this._reporterState;

  var inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  var state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
};
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var Reporter = __webpack_require__(29).Reporter;
var EncoderBuffer = __webpack_require__(29).EncoderBuffer;
var DecoderBuffer = __webpack_require__(29).DecoderBuffer;
var assert = __webpack_require__(6);

// Supported tags
var tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
var methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
var overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent) {
  var state = {};
  this._baseState = state;

  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

var stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  var state = this._baseState;
  var cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  var res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  var state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      var clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  var state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  var state = this._baseState;

  // Filter children and args
  var children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      var res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        var value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    var state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  var state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  var state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  var state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  var state = this._baseState;
  var args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  var state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  var state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  var state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  var result = state['default'];
  var present = true;

  var prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    var tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      var save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  var prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      var explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    var start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      if (state.any)
        var save = input.save();
      var body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any)
      result = result;
    else if (state.choice === null)
      result = this._decodeGeneric(state.tag, input, options);
    else
      result = this._decodeChoice(input, options);

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      var data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
          ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  var state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
        ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  var state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  var state = this._baseState;
  var result = null;
  var match = false;

  Object.keys(state.choice).some(function(key) {
    var save = input.save();
    var node = state.choice[key];
    try {
      var value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  var state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  var result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  var result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default']
    else
      return;
  }

  // Encode children first
  var content = null;
  var primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      var prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      var res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      var child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        var state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  var result;
  if (!state.any && state.choice === null) {
    var tag = state.implicit !== null ? state.implicit : state.tag;
    var cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  var state = this._baseState;

  var node = state.choice[data.type];
  if (!node) {
    assert(
        false,
        data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  var state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var constants = __webpack_require__(115);

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = constants._reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = constants._reverse(exports.tag);


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var decoders = exports;

decoders.der = __webpack_require__(116);
decoders.pem = __webpack_require__(241);


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(0);
var Buffer = __webpack_require__(3).Buffer;

var DERDecoder = __webpack_require__(116);

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  var lines = data.toString().split(/[\r\n]+/g);

  var label = options.label.toUpperCase();

  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
  var start = -1;
  var end = -1;
  for (var i = 0; i < lines.length; i++) {
    var match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  var base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9\+\/=]+/gi, '');

  var input = new Buffer(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var encoders = exports;

encoders.der = __webpack_require__(117);
encoders.pem = __webpack_require__(243);


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(0);

var DEREncoder = __webpack_require__(117);

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  var buf = DEREncoder.prototype.encode.call(this, data);

  var p = buf.toString('base64');
  var out = [ '-----BEGIN ' + options.label + '-----' ];
  for (var i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen



var asn = __webpack_require__(28)

var Time = asn.define('Time', function () {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  })
})

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
  this.seq().obj(
    this.key('type').objid(),
    this.key('value').any()
  )
})

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('parameters').optional()
  )
})

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
  this.setof(AttributeTypeValue)
})

var RDNSequence = asn.define('RDNSequence', function () {
  this.seqof(RelativeDistinguishedName)
})

var Name = asn.define('Name', function () {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  })
})

var Validity = asn.define('Validity', function () {
  this.seq().obj(
    this.key('notBefore').use(Time),
    this.key('notAfter').use(Time)
  )
})

var Extension = asn.define('Extension', function () {
  this.seq().obj(
    this.key('extnID').objid(),
    this.key('critical').bool().def(false),
    this.key('extnValue').octstr()
  )
})

var TBSCertificate = asn.define('TBSCertificate', function () {
  this.seq().obj(
    this.key('version').explicit(0).int(),
    this.key('serialNumber').int(),
    this.key('signature').use(AlgorithmIdentifier),
    this.key('issuer').use(Name),
    this.key('validity').use(Validity),
    this.key('subject').use(Name),
    this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
    this.key('issuerUniqueID').implicit(1).bitstr().optional(),
    this.key('subjectUniqueID').implicit(2).bitstr().optional(),
    this.key('extensions').explicit(3).seqof(Extension).optional()
  )
})

var X509Certificate = asn.define('X509Certificate', function () {
  this.seq().obj(
    this.key('tbsCertificate').use(TBSCertificate),
    this.key('signatureAlgorithm').use(AlgorithmIdentifier),
    this.key('signatureValue').bitstr()
  )
})

module.exports = X509Certificate


/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m
var startRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----/m
var fullRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m
var evp = __webpack_require__(38)
var ciphers = __webpack_require__(58)
module.exports = function (okey, password) {
  var key = okey.toString()
  var match = key.match(findProc)
  var decrypted
  if (!match) {
    var match2 = key.match(fullRegex)
    decrypted = new Buffer(match2[2].replace(/[\r\n]/g, ''), 'base64')
  } else {
    var suite = 'aes' + match[1]
    var iv = new Buffer(match[2], 'hex')
    var cipherText = new Buffer(match[3].replace(/[\r\n]/g, ''), 'base64')
    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
    var out = []
    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
    out.push(cipher.update(cipherText))
    out.push(cipher.final())
    decrypted = Buffer.concat(out)
  }
  var tag = key.match(startRegex)[1]
  return {
    tag: tag,
    data: decrypted
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var BN = __webpack_require__(2)
var EC = __webpack_require__(5).ec
var parseKeys = __webpack_require__(40)
var curves = __webpack_require__(118)

function verify (sig, hash, key, signType, tag) {
  var pub = parseKeys(key)
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
    return ecVerify(sig, hash, pub)
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong public key type')
    return dsaVerify(sig, hash, pub)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = pub.modulus.byteLength()
  var pad = [ 1 ]
  var padNum = 0
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff)
    padNum++
  }
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) {
    pad.push(hash[i])
  }
  pad = new Buffer(pad)
  var red = BN.mont(pub.modulus)
  sig = new BN(sig).toRed(red)

  sig = sig.redPow(new BN(pub.publicExponent))
  sig = new Buffer(sig.fromRed().toArray())
  var out = padNum < 8 ? 1 : 0
  len = Math.min(sig.length, pad.length)
  if (sig.length !== pad.length) out = 1

  i = -1
  while (++i < len) out |= sig[i] ^ pad[i]
  return out === 0
}

function ecVerify (sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))

  var curve = new EC(curveId)
  var pubkey = pub.data.subjectPrivateKey.data

  return curve.verify(hash, sig, pubkey)
}

function dsaVerify (sig, hash, pub) {
  var p = pub.data.p
  var q = pub.data.q
  var g = pub.data.g
  var y = pub.data.pub_key
  var unpacked = parseKeys.signature.decode(sig, 'der')
  var s = unpacked.s
  var r = unpacked.r
  checkValue(s, q)
  checkValue(r, q)
  var montp = BN.mont(p)
  var w = s.invm(q)
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q)
  return v.cmp(r) === 0
}

function checkValue (b, q) {
  if (b.cmpn(0) <= 0) throw new Error('invalid sig')
  if (b.cmp(q) >= q) throw new Error('invalid sig')
}

module.exports = verify

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var elliptic = __webpack_require__(5)
var BN = __webpack_require__(2)

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3).Buffer))

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

exports.publicEncrypt = __webpack_require__(250)
exports.privateDecrypt = __webpack_require__(251)

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(40)
var randomBytes = __webpack_require__(21)
var createHash = __webpack_require__(24)
var mgf = __webpack_require__(119)
var xor = __webpack_require__(120)
var BN = __webpack_require__(2)
var withPublic = __webpack_require__(121)
var crt = __webpack_require__(60)
var Buffer = __webpack_require__(1).Buffer

module.exports = function publicEncrypt (publicKey, msg, reverse) {
  var padding
  if (publicKey.padding) {
    padding = publicKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }
  var key = parseKeys(publicKey)
  var paddedMsg
  if (padding === 4) {
    paddedMsg = oaep(key, msg)
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    paddedMsg = new BN(msg)
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus')
    }
  } else {
    throw new Error('unknown padding')
  }
  if (reverse) {
    return crt(paddedMsg, key)
  } else {
    return withPublic(paddedMsg, key)
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var mLen = msg.length
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  var hLen2 = 2 * hLen
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long')
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2)
  var dblen = k - hLen - 1
  var seed = randomBytes(hLen)
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
  var maskedSeed = xor(seed, mgf(maskedDb, hLen))
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
}
function pkcs1 (key, msg, reverse) {
  var mLen = msg.length
  var k = key.modulus.byteLength()
  if (mLen > k - 11) {
    throw new Error('message too long')
  }
  var ps
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff)
  } else {
    ps = nonZero(k - mLen - 3)
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
}
function nonZero (len) {
  var out = Buffer.allocUnsafe(len)
  var i = 0
  var cache = randomBytes(len * 2)
  var cur = 0
  var num
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2)
      cur = 0
    }
    num = cache[cur++]
    if (num) {
      out[i++] = num
    }
  }
  return out
}


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(40)
var mgf = __webpack_require__(119)
var xor = __webpack_require__(120)
var BN = __webpack_require__(2)
var crt = __webpack_require__(60)
var createHash = __webpack_require__(24)
var withPublic = __webpack_require__(121)
var Buffer = __webpack_require__(1).Buffer

module.exports = function privateDecrypt (privateKey, enc, reverse) {
  var padding
  if (privateKey.padding) {
    padding = privateKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }

  var key = parseKeys(privateKey)
  var k = key.modulus.byteLength()
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error')
  }
  var msg
  if (reverse) {
    msg = withPublic(new BN(enc), key)
  } else {
    msg = crt(enc, key)
  }
  var zBuffer = Buffer.alloc(k - msg.length)
  msg = Buffer.concat([zBuffer, msg], k)
  if (padding === 4) {
    return oaep(key, msg)
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    return msg
  } else {
    throw new Error('unknown padding')
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  if (msg[0] !== 0) {
    throw new Error('decryption error')
  }
  var maskedSeed = msg.slice(1, hLen + 1)
  var maskedDb = msg.slice(hLen + 1)
  var seed = xor(maskedSeed, mgf(maskedDb, hLen))
  var db = xor(maskedDb, mgf(seed, k - hLen - 1))
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error')
  }
  var i = hLen
  while (db[i] === 0) {
    i++
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error')
  }
  return db.slice(i)
}

function pkcs1 (key, msg, reverse) {
  var p1 = msg.slice(0, 2)
  var i = 2
  var status = 0
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++
      break
    }
  }
  var ps = msg.slice(2, i - 1)

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
    status++
  }
  if (ps.length < 8) {
    status++
  }
  if (status) {
    throw new Error('decryption error')
  }
  return msg.slice(i)
}
function compare (a, b) {
  a = Buffer.from(a)
  b = Buffer.from(b)
  var dif = 0
  var len = a.length
  if (a.length !== b.length) {
    dif++
    len = Math.min(a.length, b.length)
  }
  var i = -1
  while (++i < len) {
    dif += (a[i] ^ b[i])
  }
  return dif
}


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = __webpack_require__(1)
var randombytes = __webpack_require__(21)
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = global.crypto || global.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !process.browser) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(10)))

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(34), __webpack_require__(254), __webpack_require__(257), __webpack_require__(258), __webpack_require__(85));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "svg-baker-runtime/browser-symbol", "svg-sprite-loader/runtime/browser-sprite.build", "react-dom"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("prop-types"), require("svg-baker-runtime/browser-symbol"), require("svg-sprite-loader/runtime/browser-sprite.build"), require("react-dom")) : factory(root["react"], root["prop-types"], root["svg-baker-runtime/browser-symbol"], root["svg-sprite-loader/runtime/browser-sprite.build"], root["react-dom"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__6__, __WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__34__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 92);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = classNames;
function classNames() {
  var result = [];

  [].concat(Array.prototype.slice.call(arguments)).forEach(function (item) {
    if (!item) {
      return;
    }
    switch (typeof item === 'undefined' ? 'undefined' : _typeof(item)) {
      case 'string':
        result.push(item);
        break;
      case 'object':
        Object.keys(item).forEach(function (key) {
          if (item[key]) {
            result.push(key);
          }
        });
        break;
      default:
        result.push('' + item);
    }
  });

  return result.join(' ');
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getClassname;

var _platform = __webpack_require__(4);

var _classnames2 = __webpack_require__(2);

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var osname = (0, _platform.platform)();

function getClassname(base) {
  var _classnames;

  return (0, _classnames3.default)(base, (_classnames = {}, _defineProperty(_classnames, base + '--ios', osname === _platform.IOS), _defineProperty(_classnames, base + '--android', osname === _platform.ANDROID), _classnames));
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.platform = platform;
var ANDROID = exports.ANDROID = 'android';
var IOS = exports.IOS = 'ios';

var ua = void 0;
var platformName = void 0;

function platform(useragent) {
  if (!ua) {
    ua = useragent || navigator && navigator.userAgent || '';
  }
  if (!platformName) {
    platformName = /android/i.test(ua) ? ANDROID : IOS;
  }

  return platformName;
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACTIVE_EFFECT_DELAY = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Touch = __webpack_require__(8);

var _Touch2 = _interopRequireDefault(_Touch);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _platform = __webpack_require__(4);

var _offset = __webpack_require__(31);

var _touch = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ts = function ts() {
  return +Date.now();
};
var baseClassNames = (0, _getClassName2.default)('Tappable');
var osname = (0, _platform.platform)();

var ACTIVE_DELAY = 70;
var ACTIVE_EFFECT_DELAY = exports.ACTIVE_EFFECT_DELAY = 600;

var storage = {};

/**
 * Очищает таймауты и хранилище для всех экземпляров компонента, кроме переданного
 *
 * @param {String} exclude ID экземпляра-исключения
 * @returns {void}
 */
function deactivateOtherInstances(exclude) {
  Object.keys(storage).filter(function (id) {
    return id !== exclude;
  }).forEach(function (id) {
    clearTimeout(storage[id].activeTimeout);
    clearTimeout(storage[id].timeout);
    storage[id].stop();

    delete storage[id];
  });
}

var Tappable = function (_Component) {
  _inherits(Tappable, _Component);

  function Tappable(props) {
    _classCallCheck(this, Tappable);

    var _this = _possibleConstructorReturn(this, (Tappable.__proto__ || Object.getPrototypeOf(Tappable)).call(this, props));

    _this.isSlide = false;

    _this.onStart = function (_ref) {
      var originalEvent = _ref.originalEvent;

      _this.props.stopPropagation && originalEvent.stopPropagation();
      if (originalEvent.touches && originalEvent.touches.length > 1) {
        return deactivateOtherInstances();
      }

      if (osname === _platform.ANDROID) {
        _this.onDown(originalEvent);
      }

      storage[_this.id] = {};
      _this.getStorage().stop = _this.stop;
      _this.getStorage().activeTimeout = setTimeout(_this.start, ACTIVE_DELAY);
    };

    _this.onMove = function (_ref2) {
      var originalEvent = _ref2.originalEvent,
          shiftXAbs = _ref2.shiftXAbs,
          shiftYAbs = _ref2.shiftYAbs;

      _this.props.stopPropagation && originalEvent.stopPropagation();
      if (shiftXAbs > 20 || shiftYAbs > 20) {
        _this.isSlide = true;
        _this.stop();
      }
    };

    _this.onEnd = function (_ref3) {
      var originalEvent = _ref3.originalEvent;

      _this.props.stopPropagation && originalEvent.stopPropagation();
      var now = ts();

      if (originalEvent.touches && originalEvent.touches.length > 0) {
        _this.isSlide = false;
        return;
      }

      if (_this.state.active) {
        if (now - _this.state.ts >= 100) {
          // Долгий тап, выключаем подсветку
          _this.stop();
        } else {
          // Короткий тап, оставляем подсветку
          var timeout = setTimeout(_this.stop, _this.props.activeEffectDelay - now + _this.state.ts);
          var store = _this.getStorage();

          if (store) {
            store.timeout = timeout;
          }
        }
      } else if (!_this.isSlide) {
        // Очень короткий тап, включаем подсветку
        _this.start();

        var _timeout = setTimeout(_this.stop, _this.props.activeEffectDelay);

        if (_this.getStorage()) {
          clearTimeout(_this.getStorage().activeTimeout);
          _this.getStorage().timeout = _timeout;
        } else {
          _this.timeout = _timeout;
        }
      }

      _this.isSlide = false;
    };

    _this.onDown = function (e) {
      if (osname === _platform.ANDROID) {
        var _getOffsetRect = (0, _offset.getOffsetRect)(_this.container),
            top = _getOffsetRect.top,
            left = _getOffsetRect.left;

        var x = (0, _touch.coordX)(e);
        var y = (0, _touch.coordY)(e);
        var key = 'wave' + Date.now().toString();

        _this.setState(function (state) {
          return {
            clicks: Object.assign({}, state.clicks, _defineProperty({}, key, {
              x: Math.round(x - left),
              y: Math.round(y - top)
            }))
          };
        });

        _this.wavesTimeout = setTimeout(function () {
          _this.setState(function (state) {
            var clicks = Object.assign({}, state.clicks);
            delete clicks[key];
            return { clicks: clicks };
          });
        }, 225);
      }
    };

    _this.start = function () {
      if (!_this.state.active) {
        _this.setState({
          active: true,
          ts: ts()
        });
      }
      deactivateOtherInstances(_this.id);
    };

    _this.stop = function () {
      if (_this.state.active) {
        _this.setState({
          active: false,
          ts: null
        });
      }
      if (_this.getStorage()) {
        clearTimeout(_this.getStorage().activeTimeout);
        delete storage[_this.id];
      }
    };

    _this.getStorage = function () {
      return storage[_this.id];
    };

    _this.getRef = function (container) {
      _this.container = container;
      _this.props.getRootRef && _this.props.getRootRef(container);
    };

    _this.id = Math.round(Math.random() * 1e8).toString(16);
    _this.state = {
      clicks: {},
      active: false,
      ts: null
    };
    return _this;
  }

  /**
   * Обрабатывает событие touchstart
   *
   * @returns {void}
   */


  /**
   * Обрабатывает событие touchmove
   *
   * @returns {void}
   */


  /**
   * Обрабатывает событие touchend
   *
   * @returns {void}
   */


  /**
   * Реализует эффект при тапе для Андроида
   *
   * @returns {void}
   */


  /**
   * Устанавливает активное выделение
   *
   * @returns {void}
   */


  /**
   * Снимает активное выделение
   *
   * @returns {void}
   */


  /**
   * Возвращает хранилище для экземпляра компонента
   *
   * @returns {Object} Хранилище для текущего экземпляра компонента
   */


  /**
   * Берет ref на DOM-ноду из экземпляра Touch
   *
   * @param {React.Component} container Touch component instance
   */


  _createClass(Tappable, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (storage[this.id]) {
        clearTimeout(storage[this.id].timeout);
        clearTimeout(storage[this.id].activeTimeout);

        delete storage[this.id];
      }

      clearTimeout(this.wavesTimeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          clicks = _state.clicks,
          active = _state.active;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          component = _props.component,
          activeEffectDelay = _props.activeEffectDelay,
          stopPropagation = _props.stopPropagation,
          getRootRef = _props.getRootRef,
          restProps = _objectWithoutProperties(_props, ['children', 'className', 'component', 'activeEffectDelay', 'stopPropagation', 'getRootRef']);

      var Component = !restProps.disabled ? _Touch2.default : component;
      var classes = (0, _classnames2.default)(baseClassNames, className, {
        'Tappable--active': active,
        'Tappable--inactive': !active
      });

      var props = {};

      if (!restProps.disabled) {
        props.component = component;
        props.onStart = this.onStart;
        props.onMove = this.onMove;
        props.onEnd = this.onEnd;
      }

      if (typeof Component === 'string') {
        props.ref = this.getRef;
      } else {
        props.getRootRef = this.getRef;
      }

      return _react2.default.createElement(
        Component,
        _extends({}, restProps, { className: classes }, props),
        osname === _platform.ANDROID && _react2.default.createElement(
          'span',
          { className: 'Tappable__waves' },
          Object.keys(clicks).map(function (k) {
            return _react2.default.createElement('span', { className: 'Tappable__wave', style: { top: clicks[k].y, left: clicks[k].x }, key: k });
          })
        ),
        children
      );
    }
  }]);

  return Tappable;
}(_react.Component);

Tappable.propTypes = {
  onClick: _propTypes2.default.func,
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  role: _propTypes2.default.string,
  activeEffectDelay: _propTypes2.default.number,
  stopPropagation: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  getRootRef: _propTypes2.default.func
};
Tappable.defaultProps = {
  component: 'div',
  role: 'button',
  stopPropagation: false,
  disabled: false,
  activeEffectDelay: ACTIVE_EFFECT_DELAY
};
exports.default = Tappable;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__6__;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7__;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _touch = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = (0, _touch.getSupportedEvents)();

var Touch = function (_Component) {
  _inherits(Touch, _Component);

  function Touch() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Touch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Touch.__proto__ || Object.getPrototypeOf(Touch)).call.apply(_ref, [this].concat(args))), _this), _this.cancelClick = false, _this.gesture = {}, _this.onStart = function (e) {
      _this.gesture = {
        startX: (0, _touch.coordX)(e),
        startY: (0, _touch.coordY)(e),
        startT: new Date(),
        isPressed: true
      };

      // Вызываем нужные колбеки из props
      var outputEvent = Object.assign({}, _this.gesture, {
        originalEvent: e
      });

      if (_this.props.onStart) {
        _this.props.onStart(outputEvent);
      }

      if (_this.props.onStartX) {
        _this.props.onStartX(outputEvent);
      }

      if (_this.props.onStartY) {
        _this.props.onStartY(outputEvent);
      }

      !_touch.touchEnabled && _this.subscribe(_this.document);
    }, _this.onMove = function (e) {
      var _this$gesture = _this.gesture,
          isPressed = _this$gesture.isPressed,
          isX = _this$gesture.isX,
          isY = _this$gesture.isY,
          startX = _this$gesture.startX,
          startY = _this$gesture.startY;


      if (isPressed) {
        // смещения
        var shiftX = (0, _touch.coordX)(e) - startX;
        var shiftY = (0, _touch.coordY)(e) - startY;

        // абсолютные значения смещений
        var shiftXAbs = Math.abs(shiftX);
        var shiftYAbs = Math.abs(shiftY);

        // Если определяем мультитач, то прерываем жест
        if (!!e.touches && e.touches.length > 1) {
          return _this.onEnd(e);
        }

        // если мы ещё не определились
        if (!isX && !isY) {
          var willBeX = shiftXAbs >= 5 && shiftXAbs > shiftYAbs;
          var willBeY = shiftYAbs >= 5 && shiftYAbs > shiftXAbs;
          var willBeSlidedX = willBeX && !!_this.props.onMoveX || !!_this.props.onMove;
          var willBeSlidedY = willBeY && !!_this.props.onMoveY || !!_this.props.onMove;

          _this.gesture.isY = willBeY;
          _this.gesture.isX = willBeX;
          _this.gesture.isSlideX = willBeSlidedX;
          _this.gesture.isSlideY = willBeSlidedY;
          _this.gesture.isSlide = willBeSlidedX || willBeSlidedY;
        }

        if (_this.gesture.isSlide) {
          _this.gesture.shiftX = shiftX;
          _this.gesture.shiftY = shiftY;
          _this.gesture.shiftXAbs = shiftXAbs;
          _this.gesture.shiftYAbs = shiftYAbs;

          // Вызываем нужные колбеки из props
          var outputEvent = Object.assign({}, _this.gesture, {
            originalEvent: e
          });

          if (_this.props.onMove) {
            _this.props.onMove(outputEvent);
          }

          if (_this.gesture.isSlideX && _this.props.onMoveX) {
            _this.props.onMoveX(outputEvent);
          }

          if (_this.gesture.isSlideY && _this.props.onMoveY) {
            _this.props.onMoveY(outputEvent);
          }
        }
      }
    }, _this.onEnd = function (e) {
      var _this$gesture2 = _this.gesture,
          isPressed = _this$gesture2.isPressed,
          isSlide = _this$gesture2.isSlide,
          isSlideX = _this$gesture2.isSlideX,
          isSlideY = _this$gesture2.isSlideY;


      if (isPressed) {
        // Вызываем нужные колбеки из props
        var outputEvent = Object.assign({}, _this.gesture, {
          originalEvent: e
        });

        if (_this.props.onEnd) {
          _this.props.onEnd(outputEvent);
        }

        if (isSlideY && _this.props.onEndY) {
          _this.props.onEndY(outputEvent);
        }

        if (isSlideX && _this.props.onEndX) {
          _this.props.onEndX(outputEvent);
        }
      }

      // Если закончили жест на ссылке, выставляем флаг для отмены перехода
      _this.cancelClick = e.target.tagName === 'A' && isSlide;
      _this.gesture = {};

      !_touch.touchEnabled && _this.unsubscribe(_this.document);
    }, _this.onDragStart = function (e) {
      if (e.target.tagName === 'A' || e.target.tagName === 'IMG') {
        e.preventDefault();
      }
    }, _this.onClick = function (e) {
      if (_this.cancelClick) {
        _this.cancelClick = false;
        e.preventDefault();
      }
      _this.props.onClick && _this.props.onClick(e);
    }, _this.getRef = function (container) {
      _this.container = container;
      _this.props.getRootRef && _this.props.getRootRef(container);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Touch, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.container.addEventListener(events[0], this.onStart, { capture: this.props.useCapture, passive: false });
      _touch.touchEnabled && this.subscribe(this.container);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.container.removeEventListener(events[0], this.onStart, { capture: this.props.useCapture, passive: false });
      _touch.touchEnabled && this.unsubscribe(this.container);
    }

    /**
     * Обработчик событий touchstart
     *
     * @param {Object} e Браузерное событие
     * @returns {void}
     */


    /**
     * Обработчик событий touchmove
     *
     * @param {Object} e Браузерное событие
     * @returns {void}
     */


    /**
     * Обработчик событий touchend, touchcancel
     *
     * @param {Object} e Браузерное событие
     * @returns {void}
     */

  }, {
    key: 'subscribe',
    value: function subscribe(element) {
      element.addEventListener(events[1], this.onMove, { capture: this.props.useCapture, passive: false });
      element.addEventListener(events[2], this.onEnd, { capture: this.props.useCapture, passive: false });
      element.addEventListener(events[3], this.onEnd, { capture: this.props.useCapture, passive: false });
    }
  }, {
    key: 'unsubscribe',
    value: function unsubscribe(element) {
      element.removeEventListener(events[1], this.onMove, { capture: this.props.useCapture, passive: false });
      element.removeEventListener(events[2], this.onEnd, { capture: this.props.useCapture, passive: false });
      element.removeEventListener(events[3], this.onEnd, { capture: this.props.useCapture, passive: false });
    }

    /**
     * Обработчик событий dragstart
     * Отменяет нативное браузерное поведение для вложенных ссылок и изображений
     *
     * @param {Object} e Браузерное событие
     * @returns {void}
     */


    /**
     * Обработчик клика по компоненту
     * Отменяет переход по вложенной ссылке, если был зафиксирован свайп
     *
     * @param {Object} e Браузерное событие
     * @returns {void}
     */

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          onStart = _props.onStart,
          onStartX = _props.onStartX,
          onStartY = _props.onStartY,
          onMove = _props.onMove,
          onMoveX = _props.onMoveX,
          onMoveY = _props.onMoveY,
          onEnd = _props.onEnd,
          onEndX = _props.onEndX,
          onEndY = _props.onEndY,
          useCapture = _props.useCapture,
          component = _props.component,
          getRootRef = _props.getRootRef,
          restProps = _objectWithoutProperties(_props, ['onStart', 'onStartX', 'onStartY', 'onMove', 'onMoveX', 'onMoveY', 'onEnd', 'onEndX', 'onEndY', 'useCapture', 'component', 'getRootRef']);

      var ComponentName = component;

      return _react2.default.createElement(
        ComponentName,
        _extends({}, restProps, { onDragStart: this.onDragStart, onClick: this.onClick, ref: this.getRef }),
        this.props.children
      );
    }
  }, {
    key: 'document',
    get: function get() {
      return this.context.document || document;
    }
  }]);

  return Touch;
}(_react.Component);

Touch.propTypes = {
  onStart: _propTypes2.default.func,
  onStartX: _propTypes2.default.func,
  onStartY: _propTypes2.default.func,
  onMove: _propTypes2.default.func,
  onMoveX: _propTypes2.default.func,
  onMoveY: _propTypes2.default.func,
  onEnd: _propTypes2.default.func,
  onEndX: _propTypes2.default.func,
  onEndY: _propTypes2.default.func,
  useCapture: _propTypes2.default.bool,
  component: _propTypes2.default.string,
  children: _propTypes2.default.node,
  onClick: _propTypes2.default.func,
  getRootRef: _propTypes2.default.func
};
Touch.defaultProps = {
  component: 'div',
  children: '',
  useCapture: false
};
Touch.contextTypes = {
  document: _propTypes2.default.any
};
exports.default = Touch;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var supported = void 0,
    prefix = void 0;

if (typeof document !== 'undefined' && document.createElement) {
  var d = document.createElement('div');

  for (var i in d.style) {
    var m = i.match(/^(moz|webkit|ms|)(transition|animation)$/i);
    if (m) supported = true;
    if (m && m[1]) {
      // согласно спецификации, префиксы к событиям должны быть в нижнем регистре
      // https://www.w3schools.com/jsref/event_transitionend.asp
      prefix = m[1].toLowerCase();
    }
  }
}

exports.default = { supported: supported, prefix: prefix };

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames2 = __webpack_require__(2);

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _platform = __webpack_require__(4);

var _transitionEvents = __webpack_require__(9);

var _transitionEvents2 = _interopRequireDefault(_transitionEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var osname = (0, _platform.platform)();

var baseClassNames = (0, _getClassName2.default)('PopoutWrapper');

var PopoutWrapper = function (_React$Component) {
  _inherits(PopoutWrapper, _React$Component);

  function PopoutWrapper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PopoutWrapper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PopoutWrapper.__proto__ || Object.getPrototypeOf(PopoutWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      opened: false
    }, _this.onFadeInEnd = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { manual: true };

      if (e.animationName === 'animation-full-fade-in' || e.manual) {
        _this.setState({ opened: true });
      }
    }, _this.preventTouch = function (e) {
      return e.preventDefault();
    }, _this.onClick = function (e) {
      return _this.state.opened && _this.props.onClick && _this.props.onClick(e);
    }, _this.getRef = function (el) {
      return _this.el = el;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PopoutWrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('touchmove', this.preventTouch, { passive: false });
      this.waitAnimationFinish(this.el, this.onFadeInEnd);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('touchmove', this.preventTouch, { passive: false });
      clearTimeout(this.animationFinishTimeout);
    }
  }, {
    key: 'waitAnimationFinish',
    value: function waitAnimationFinish(elem, eventHandler) {
      if (_transitionEvents2.default.supported) {
        var eventName = _transitionEvents2.default.prefix ? _transitionEvents2.default.prefix + 'AnimationEnd' : 'animationend';
        elem.removeEventListener(eventName, eventHandler);
        elem.addEventListener(eventName, eventHandler);
      } else {
        this.animationFinishTimeout = setTimeout(eventHandler.bind(this), osname === _platform.ANDROID ? 300 : 600);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          v = _props.v,
          h = _props.h,
          closing = _props.closing,
          children = _props.children,
          hasMask = _props.hasMask,
          onClick = _props.onClick,
          className = _props.className,
          restProps = _objectWithoutProperties(_props, ['v', 'h', 'closing', 'children', 'hasMask', 'onClick', 'className']);

      return _react2.default.createElement(
        'div',
        _extends({}, restProps, { className: (0, _classnames3.default)(baseClassNames, (_classnames = {}, _defineProperty(_classnames, 'PopoutWrapper--v-' + v, v), _defineProperty(_classnames, 'PopoutWrapper--h-' + h, h), _defineProperty(_classnames, 'PopoutWrapper--closing', closing), _classnames), className), onClick: this.onClick, ref: this.getRef }),
        hasMask && _react2.default.createElement('div', { className: 'PopoutWrapper__mask' }),
        _react2.default.createElement(
          'div',
          { className: 'PopoutWrapper__container' },
          children
        )
      );
    }
  }]);

  return PopoutWrapper;
}(_react2.default.Component);

PopoutWrapper.propTypes = {
  hasMask: _propTypes2.default.bool,
  v: _propTypes2.default.oneOf(['top', 'center', 'bottom']),
  h: _propTypes2.default.oneOf(['left', 'center', 'right']),
  closing: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  style: _propTypes2.default.object,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string
};
PopoutWrapper.defaultProps = {
  hasMask: true,
  v: 'center',
  h: 'center',
  closing: false
};
exports.default = PopoutWrapper;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var requestAnimationFrame = typeof window !== 'undefined' && window.requestAnimationFrame ? window.requestAnimationFrame : function (cb) {
  return setTimeout(cb, 1000 / 60);
};

exports.default = requestAnimationFrame;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(2);

var _classnames3 = _interopRequireDefault(_classnames2);

var _View = __webpack_require__(37);

var _constants = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var baseClassNames = (0, _getClassName2.default)('FixedLayout');

var FixedLayout = function (_React$Component) {
  _inherits(FixedLayout, _React$Component);

  function FixedLayout() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FixedLayout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FixedLayout.__proto__ || Object.getPrototypeOf(FixedLayout)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      position: null,
      top: null
    }, _this.onViewTransitionStart = function (e) {
      var panelScroll = e.detail.scrolls[_this.context.panel] || 0;
      _this.setState({
        position: 'absolute',
        top: _this.el.offsetTop + panelScroll
      });
    }, _this.onViewTransitionEnd = function () {
      _this.setState({
        position: null,
        top: null
      });
    }, _this.getRef = function (el) {
      return _this.el = el;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FixedLayout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.document.addEventListener(_View.transitionStartEventName, this.onViewTransitionStart);
      this.document.addEventListener(_View.transitionEndEventName, this.onViewTransitionEnd);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.document.removeEventListener(_View.transitionStartEventName, this.onViewTransitionStart);
      this.document.removeEventListener(_View.transitionEndEventName, this.onViewTransitionEnd);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          style = _props.style,
          vertical = _props.vertical,
          restProps = _objectWithoutProperties(_props, ['className', 'children', 'style', 'vertical']);

      var tabbarPadding = this.context.hasTabbar ? _constants.tabbarHeight : 0;
      var paddingBottom = vertical === 'bottom' && this.context.insets && this.context.insets.bottom ? this.context.insets.bottom + tabbarPadding : null;

      return _react2.default.createElement(
        'div',
        _extends({}, restProps, {
          ref: this.getRef,
          className: (0, _classnames3.default)(baseClassNames, _defineProperty({}, 'FixedLayout--' + vertical, vertical), className),
          style: _extends({}, style, this.state, { paddingBottom: paddingBottom })
        }),
        _react2.default.createElement(
          'div',
          { className: 'FixedLayout__in' },
          children
        )
      );
    }
  }, {
    key: 'document',
    get: function get() {
      return this.context.document || document;
    }
  }]);

  return FixedLayout;
}(_react2.default.Component);

FixedLayout.propTypes = {
  children: _propTypes2.default.node,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  vertical: _propTypes2.default.oneOf(['top', 'bottom'])
};
FixedLayout.contextTypes = {
  insets: _propTypes2.default.shape({
    bottom: _propTypes2.default.number
  }),
  panel: _propTypes2.default.string,
  document: _propTypes2.default.any,
  hasTabbar: _propTypes2.default.bool
};
exports.default = FixedLayout;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeObjectKeys;
function removeObjectKeys() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var newObj = Object.assign({}, obj);

  keys.forEach(function (key) {
    return delete newObj[key];
  });

  return newObj;
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var querystring = {
  parse: function parse() {
    var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    if (typeof string !== 'string') return {};

    var matches = /\?(.+)$/ig.exec(string);
    var str = matches ? matches[1] : string;

    return str.split('&').reduce(function (acc, item) {
      var param = item.split('=');

      if (param[1]) {
        acc[param[0]] = decodeURIComponent(param[1]);
      }

      return acc;
    }, {});
  },
  create: function create() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var opts = arguments[1];

    if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object' || data === null) return '';

    var options = _extends({ encode: true }, opts);

    return Object.keys(data).reduce(function (acc, item) {
      var type = _typeof(data[item]);

      if (type === 'string' || type === 'number' || type === 'boolean') {
        acc.push(item + '=' + (options.encode ? encodeURIComponent(data[item]) : data[item]));
      }

      if (Array.isArray(data[item])) {
        data[item].forEach(function (value) {
          acc.push(item + '[]=' + (options.encode ? encodeURIComponent(value) : value));
        });
      }

      return acc;
    }, []).join('&');
  }
};

exports.default = querystring;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isWebView = undefined;

var _vkuiConnect = __webpack_require__(43);

var _vkuiConnect2 = _interopRequireDefault(_vkuiConnect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isWebView = exports.isWebView = _vkuiConnect2.default.supports('VKWebAppInit');

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(7), __webpack_require__(6));
	else { var i, a; }
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 193);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _browserSymbol = __webpack_require__(2);

var _browserSymbol2 = _interopRequireDefault(_browserSymbol);

var _browserSprite = __webpack_require__(1);

var _browserSprite2 = _interopRequireDefault(_browserSprite);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var symbol = new _browserSymbol2.default({
  "id": "dropdown_24",
  "use": "dropdown_24-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"dropdown_24\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><path d=\"M12 14.198L6.64 9.732a1 1 0 1 0-1.28 1.536l6 5a1 1 0 0 0 1.28 0l6-5a1 1 0 1 0-1.28-1.536L12 14.198z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = _browserSprite2.default.add(symbol);

var width = symbol.viewBox.split(' ')[2];
var height = symbol.viewBox.split(' ')[3];
var size = Math.max(width, height);

function SvgIcon(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ["className", "fill", "style", "getRootRef"]);

  return _react2.default.createElement(
    "div",
    _extends({}, restProps, {
      ref: getRootRef,
      className: 'Icon' + ' Icon--' + size + ' Icon--' + symbol.id + ' ' + (className || ''),
      style: _extends({}, style, { width: width + 'px', height: height + 'px' })
    }),
    _react2.default.createElement(
      "svg",
      { viewBox: symbol.viewBox, width: width, height: height, style: { display: 'block' } },
      _react2.default.createElement("use", { xlinkHref: '#' + symbol.id, style: { fill: 'currentColor', color: fill } })
    )
  );
}
exports.default = SvgIcon;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ })

/******/ });
});

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Touch = __webpack_require__(8);

var _Touch2 = _interopRequireDefault(_Touch);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var baseClassNames = (0, _getClassName2.default)('Slider');

function precisionRound(number, precision) {
  var factor = Math.pow(10, precision || 1);
  return Math.round(number * factor) / factor;
}

var Slider = function (_Component) {
  _inherits(Slider, _Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

    _this.onStart = function (e) {
      var absolutePosition = _this.validateAbsolute(e.startX - _this.state.containerLeft);
      var percentPosition = _this.absoluteToPecent(absolutePosition);

      _this.onChange(_this.percentToValue(percentPosition));

      if (_this.isControlledOutside) {
        _this.setState({ startX: absolutePosition });
      } else {
        _this.setState({
          startX: absolutePosition,
          percentPosition: percentPosition
        });
      }

      _this.setState({ active: !!e.originalEvent.target.closest('.Slider__thumb') });
    };

    _this.onMoveX = function (e) {
      var absolutePosition = _this.validateAbsolute(_this.state.startX + (e.shiftX || 0));
      var percentPosition = _this.absoluteToPecent(absolutePosition);

      _this.onChange(_this.percentToValue(percentPosition));

      if (!_this.isControlledOutside) {
        _this.setState({ percentPosition: percentPosition });
      }

      e.originalEvent.preventDefault();
    };

    _this.onEnd = function () {
      _this.setState({
        active: false
      });
    };

    _this.onResize = function (callback) {
      _this.setState({
        containerLeft: _this.container.offsetLeft,
        containerWidth: _this.container.offsetWidth
      }, function () {
        typeof callback === 'function' && callback();
      });
    };

    _this.getRef = function (container) {
      _this.container = container;
      _this.props.getRootRef && _this.props.getRootRef(container);
    };

    _this.state = {
      startX: 0
    };
    _this.isControlledOutside = _this.props.hasOwnProperty('value');
    return _this;
  }

  _createClass(Slider, [{
    key: 'onChange',
    value: function onChange(value) {
      this.props.onChange && this.props.onChange(value);
    }
  }, {
    key: 'validateAbsolute',
    value: function validateAbsolute(absolute) {
      var res = Math.max(0, Math.min(absolute, this.state.containerWidth));

      if (this.props.step > 0) {
        var stepCount = (this.props.max - this.props.min) / this.props.step;
        var absStep = this.state.containerWidth / stepCount;

        res = Math.round(res / absStep) * absStep;
      }

      return res;
    }
  }, {
    key: 'validatePercent',
    value: function validatePercent(percent) {
      return Math.max(0, Math.min(percent, 100));
    }
  }, {
    key: 'absoluteToPecent',
    value: function absoluteToPecent(absolute) {
      return absolute * 100 / this.state.containerWidth;
    }
  }, {
    key: 'percentToValue',
    value: function percentToValue(percent) {
      var res = percent * (this.props.max - this.props.min) / 100 + this.props.min;
      if (this.props.step > 0) {
        var stepFloatPart = ('' + this.props.step).split('.')[1] || '';
        return precisionRound(res, stepFloatPart.length);
      }
      return res;
    }
  }, {
    key: 'valueToPercent',
    value: function valueToPercent(value) {
      return (value - this.props.min) * 100 / (this.props.max - this.props.min);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('resize', this.onResize);
      this.onResize(function () {
        _this2.setState({ percentPosition: _this2.validatePercent(_this2.valueToPercent(_this2.value)) });
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.isControlledOutside && nextProps.value !== this.props.value) {
        this.setState({ percentPosition: this.validatePercent(this.valueToPercent(nextProps.value)) });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          min = _props.min,
          max = _props.max,
          step = _props.step,
          value = _props.value,
          defaultValue = _props.defaultValue,
          onChange = _props.onChange,
          getRootRef = _props.getRootRef,
          restProps = _objectWithoutProperties(_props, ['className', 'min', 'max', 'step', 'value', 'defaultValue', 'onChange', 'getRootRef']);

      return _react2.default.createElement(
        'div',
        _extends({}, restProps, { className: (0, _classnames2.default)(baseClassNames, className), ref: this.getRef }),
        _react2.default.createElement(
          _Touch2.default,
          { onStart: this.onStart, onMoveX: this.onMoveX, onEnd: this.onEnd, className: 'Slider__in' },
          _react2.default.createElement(
            'div',
            { className: 'Slider__dragger', style: { width: this.state.percentPosition + '%' } },
            _react2.default.createElement('span', {
              className: (0, _classnames2.default)('Slider__thumb', 'Slider__thumb--end', {
                'Slider__thumb--active': this.state.active
              })
            })
          )
        )
      );
    }
  }, {
    key: 'value',
    get: function get() {
      if (this.isControlledOutside) {
        return this.props.value;
      } else if (this.props.hasOwnProperty('defaultValue')) {
        return this.props.defaultValue;
      } else {
        return this.props.min;
      }
    }
  }]);

  return Slider;
}(_react.Component);

Slider.propTypes = {
  min: _propTypes2.default.number,
  max: _propTypes2.default.number,
  value: _propTypes2.default.number,
  step: _propTypes2.default.number,
  onChange: _propTypes2.default.func,
  defaultValue: _propTypes2.default.number,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  getRootRef: _propTypes2.default.func
};
Slider.defaultProps = {
  min: 0,
  max: 100,
  step: 0
};
exports.default = Slider;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames2 = __webpack_require__(2);

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var baseClassName = (0, _getClassName2.default)('Tabs');

var Tabs = function (_React$Component) {
  _inherits(Tabs, _React$Component);

  function Tabs() {
    _classCallCheck(this, Tabs);

    return _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).apply(this, arguments));
  }

  _createClass(Tabs, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          children = _props.children,
          theme = _props.theme,
          style = _props.style,
          type = _props.type,
          getRootRef = _props.getRootRef,
          restProps = _objectWithoutProperties(_props, ['className', 'children', 'theme', 'style', 'type', 'getRootRef']);

      return _react2.default.createElement(
        'div',
        _extends({}, restProps, { ref: getRootRef, className: (0, _classnames3.default)(baseClassName, (_classnames = {}, _defineProperty(_classnames, 'Tabs--' + this.theme, true), _defineProperty(_classnames, 'Tabs--' + type, true), _classnames), className), style: style }),
        children
      );
    }
  }, {
    key: 'theme',


    /**
     * Метод нужен для маппинга устаревших значений theme на новые
     * @returns {string}
     */
    get: function get() {
      switch (this.props.theme) {
        case 'white':
          return 'header';
        case 'gray':
          return 'light';
        default:
          return this.props.theme;
      }
    }
  }]);

  return Tabs;
}(_react2.default.Component);

Tabs.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  /**
   * Значения white и gray устарели. Они будут удалены в следующей мажорной версии
   */
  theme: _propTypes2.default.oneOf(['light', 'header']),
  /**
   * Свойство отвечает за растягивание табов
   */
  type: _propTypes2.default.oneOf(['default', 'buttons']),
  style: _propTypes2.default.object,
  getRootRef: _propTypes2.default.func
};
Tabs.defaultProps = {
  theme: 'light',
  type: 'default'
};
exports.default = Tabs;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames2 = __webpack_require__(2);

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var baseClassName = (0, _getClassName2.default)('Avatar');

var Avatar = function Avatar(_ref) {
  var src = _ref.src,
      size = _ref.size,
      type = _ref.type,
      style = _ref.style,
      className = _ref.className,
      children = _ref.children,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ['src', 'size', 'type', 'style', 'className', 'children', 'getRootRef']);

  var Component = src ? 'img' : 'div';
  var borderRadius = void 0;

  switch (type) {
    case 'default':
      borderRadius = '50%';
      break;
    case 'image':
      borderRadius = 4;
      break;
    case 'app':
      borderRadius = Math.floor(size * 10 / 48);
      break;
  }

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames3.default)(baseClassName, className, _defineProperty({}, 'Avatar--type-' + type, true)), ref: getRootRef },
    _react2.default.createElement(
      'div',
      { className: 'Avatar__in' },
      _react2.default.createElement(Component, _extends({}, restProps, {
        className: 'Avatar__img',
        src: src,
        style: _extends({}, style, { width: size, height: size, borderRadius: borderRadius })
      })),
      children && _react2.default.createElement(
        'div',
        { className: 'Avatar__children', style: { width: size, height: size, borderRadius: borderRadius } },
        children
      )
    )
  );
};

Avatar.propTypes = {
  size: _propTypes2.default.oneOf([80, 72, 64, 56, 48, 40, 36, 32, 28]),
  src: _propTypes2.default.string,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  type: _propTypes2.default.oneOf(['default', 'image', 'app']),
  children: _propTypes2.default.node,
  getRootRef: _propTypes2.default.func
};

Avatar.defaultProps = {
  size: 48,
  type: 'default'
};

exports.default = Avatar;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Div;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var baseClassNames = (0, _getClassName2.default)('Div');

function Div(_ref) {
  var className = _ref.className,
      children = _ref.children,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ['className', 'children', 'getRootRef']);

  return _react2.default.createElement(
    'div',
    _extends({}, restProps, { ref: getRootRef, className: (0, _classnames2.default)(baseClassNames, className) }),
    children
  );
}

Div.propTypes = {
  style: _propTypes2.default.object,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  getRootRef: _propTypes2.default.func
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(7), __webpack_require__(6));
	else { var i, a; }
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 206);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _browserSymbol = __webpack_require__(2);

var _browserSymbol2 = _interopRequireDefault(_browserSymbol);

var _browserSprite = __webpack_require__(1);

var _browserSprite2 = _interopRequireDefault(_browserSprite);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var symbol = new _browserSymbol2.default({
  "id": "cancel_24",
  "use": "cancel_24-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"cancel_24\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><path d=\"M18.3 5.7a.99.99 0 0 0-1.4 0L12 10.6 7.1 5.7a.99.99 0 0 0-1.4 1.4l4.9 4.9-4.9 4.9a.99.99 0 0 0 1.4 1.4l4.9-4.9 4.9 4.9a.99.99 0 0 0 1.4-1.4L13.4 12l4.9-4.9a.99.99 0 0 0 0-1.4z\" fill=\"currentColor\" /></g></symbol>"
});
var result = _browserSprite2.default.add(symbol);

var width = symbol.viewBox.split(' ')[2];
var height = symbol.viewBox.split(' ')[3];
var size = Math.max(width, height);

function SvgIcon(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ["className", "fill", "style", "getRootRef"]);

  return _react2.default.createElement(
    "div",
    _extends({}, restProps, {
      ref: getRootRef,
      className: 'Icon' + ' Icon--' + size + ' Icon--' + symbol.id + ' ' + (className || ''),
      style: _extends({}, style, { width: width + 'px', height: height + 'px' })
    }),
    _react2.default.createElement(
      "svg",
      { viewBox: symbol.viewBox, width: width, height: height, style: { display: 'block' } },
      _react2.default.createElement("use", { xlinkHref: '#' + symbol.id, style: { fill: 'currentColor', color: fill } })
    )
  );
}
exports.default = SvgIcon;

/***/ })

/******/ });
});

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(7), __webpack_require__(6));
	else { var i, a; }
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 243);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _browserSymbol = __webpack_require__(2);

var _browserSymbol2 = _interopRequireDefault(_browserSymbol);

var _browserSprite = __webpack_require__(1);

var _browserSprite2 = _interopRequireDefault(_browserSprite);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var symbol = new _browserSymbol2.default({
  "id": "done_16",
  "use": "done_16-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"done_16\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path d=\"M6 10.2L3.5 7.7a.99.99 0 1 0-1.4 1.4l3.193 3.193a1 1 0 0 0 1.414 0L14.3 4.7a.99.99 0 0 0-1.4-1.4L6 10.2z\" fill=\"currentColor\" /></g></symbol>"
});
var result = _browserSprite2.default.add(symbol);

var width = symbol.viewBox.split(' ')[2];
var height = symbol.viewBox.split(' ')[3];
var size = Math.max(width, height);

function SvgIcon(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ["className", "fill", "style", "getRootRef"]);

  return _react2.default.createElement(
    "div",
    _extends({}, restProps, {
      ref: getRootRef,
      className: 'Icon' + ' Icon--' + size + ' Icon--' + symbol.id + ' ' + (className || ''),
      style: _extends({}, style, { width: width + 'px', height: height + 'px' })
    }),
    _react2.default.createElement(
      "svg",
      { viewBox: symbol.viewBox, width: width, height: height, style: { display: 'block' } },
      _react2.default.createElement("use", { xlinkHref: '#' + symbol.id, style: { fill: 'currentColor', color: fill } })
    )
  );
}
exports.default = SvgIcon;

/***/ })

/******/ });
});

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames2 = __webpack_require__(2);

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var baseClassNames = (0, _getClassName2.default)('Header');

var Header = function Header(_ref) {
  var className = _ref.className,
      level = _ref.level,
      children = _ref.children,
      aside = _ref.aside,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ['className', 'level', 'children', 'aside', 'getRootRef']);

  return _react2.default.createElement(
    'div',
    _extends({}, restProps, {
      ref: getRootRef,
      className: (0, _classnames3.default)(baseClassNames, className, _defineProperty({}, 'Header--level-' + level, true))
    }),
    _react2.default.createElement(
      'div',
      { className: 'Header__in' },
      _react2.default.createElement(
        'div',
        { className: 'Header__content' },
        children
      ),
      aside && _react2.default.createElement(
        'div',
        { className: 'Header__aside' },
        aside
      )
    )
  );
};

Header.propTypes = {
  className: _propTypes2.default.string,
  level: _propTypes2.default.oneOf(['1', '2']),
  aside: _propTypes2.default.node,
  children: _propTypes2.default.node,
  style: _propTypes2.default.object,
  getRootRef: _propTypes2.default.func
};

Header.defaultProps = {
  level: '1'
};

exports.default = Header;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Tappable = __webpack_require__(5);

var _Tappable2 = _interopRequireDefault(_Tappable);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(2);

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var baseClassName = (0, _getClassName2.default)('CellButton');

var CellButton = function CellButton(_ref) {
  var _classnames;

  var className = _ref.className,
      align = _ref.align,
      level = _ref.level,
      before = _ref.before,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ['className', 'align', 'level', 'before', 'children']);

  return _react2.default.createElement(
    _Tappable2.default,
    _extends({}, restProps, { className: (0, _classnames3.default)(baseClassName, className, (_classnames = {}, _defineProperty(_classnames, 'CellButton--lvl-' + level, level), _defineProperty(_classnames, 'CellButton--aln-' + align, align), _classnames)), stopPropagation: true }),
    _react2.default.createElement(
      'div',
      { className: 'CellButton__in' },
      before && _react2.default.createElement(
        'div',
        { className: 'CellButton__before' },
        before
      ),
      children && _react2.default.createElement(
        'div',
        { className: 'CellButton__content' },
        children
      )
    )
  );
};

CellButton.propTypes = {
  level: _propTypes2.default.oneOf(['primary', 'danger']),
  align: _propTypes2.default.oneOf(['left', 'center', 'right']),
  before: _propTypes2.default.node,
  children: _propTypes2.default.node,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  component: _propTypes2.default.any
};

CellButton.defaultProps = {
  level: 'primary',
  align: 'left'
};

exports.default = CellButton;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Tappable = __webpack_require__(5);

var _Tappable2 = _interopRequireDefault(_Tappable);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(2);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CellButton = __webpack_require__(24);

var _CellButton2 = _interopRequireDefault(_CellButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var baseClassName = (0, _getClassName2.default)('Button');

var Button = function (_React$Component) {
  _inherits(Button, _React$Component);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }

  _createClass(Button, [{
    key: 'render',
    value: function render() {
      if (this.props.type === 'cell') {
        var _props = this.props,
            stretched = _props.stretched,
            size = _props.size,
            restProps = _objectWithoutProperties(_props, ['stretched', 'size']);

        return _react2.default.createElement(_CellButton2.default, restProps);
      } else {
        var _classnames;

        var _props2 = this.props,
            className = _props2.className,
            _size = _props2.size,
            level = _props2.level,
            _stretched = _props2.stretched,
            align = _props2.align,
            children = _props2.children,
            before = _props2.before,
            _restProps = _objectWithoutProperties(_props2, ['className', 'size', 'level', 'stretched', 'align', 'children', 'before']);

        return _react2.default.createElement(
          _Tappable2.default,
          _extends({}, _restProps, { className: (0, _classnames3.default)(baseClassName, className, (_classnames = {}, _defineProperty(_classnames, 'Button--sz-' + _size, true), _defineProperty(_classnames, 'Button--lvl-' + Button.mapOldLevel(level), true), _defineProperty(_classnames, 'Button--aln-' + (align || 'center'), true), _defineProperty(_classnames, 'Button--str', _stretched), _classnames)), stopPropagation: true }),
          _react2.default.createElement(
            'div',
            { className: 'Button__in' },
            before && _react2.default.createElement(
              'div',
              { className: 'Button__before' },
              before
            ),
            children && _react2.default.createElement(
              'div',
              { className: 'Button__content' },
              children
            )
          )
        );
      }
    }
  }], [{
    key: 'mapOldLevel',
    value: function mapOldLevel(level) {
      switch (level) {
        case '1':
          return 'primary';
        case '2':
          return 'secondary';
        case '3':
          return 'tertiary';
        case 'sell':
          return 'outline';
        case 'buy':
          return 'commerce';
        default:
          return level;
      }
    }
  }]);

  return Button;
}(_react2.default.Component);

Button.propTypes = {
  /**
   * Значения `1`, `2`, `3`, `sell`, `buy` устарели. Маппинг на новые значения находится в
   * статическом методе `Button.mapOldLevel(level)`. Старые значения будут удалены в
   * следующей мажлорной версии.
   */
  level: _propTypes2.default.oneOf(['primary', 'secondary', 'tertiary', 'outline', 'commerce', '1', '2', '3', 'sell', 'buy']),
  size: _propTypes2.default.oneOf(['m', 'l', 'xl']),
  /**
   * @deprecated Кнопки-ячейки `<Button type="cell" />` переехали в отдельный компонент: `<CellButton />`.
   * Свойство `type` будет удалено в следующей мажорной версии.
   */
  type: _propTypes2.default.oneOf(['default', 'cell']),
  align: _propTypes2.default.oneOf(['left', 'center', 'right']),
  stretched: _propTypes2.default.bool,
  before: _propTypes2.default.node,
  children: _propTypes2.default.node,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  component: _propTypes2.default.any
};
Button.defaultProps = {
  level: 'primary',
  type: 'default',
  component: 'button',
  size: 'm',
  stretched: false
};
exports.default = Button;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = keyframes;
function keyframes(name, obj) {
  if (!name || !obj) {
    return '';
  }

  var selectors = Object.keys(obj).map(function (key) {
    return key + ' {' + Object.keys(obj[key]).map(function (k) {
      return k + ':' + obj[key][k];
    }).join(';') + '}';
  }).join('');

  return '@-webkit-keyframes ' + name + ' {' + selectors + '} @keyframes ' + name + ' {' + selectors + '}';
}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _platform = __webpack_require__(4);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _AndroidSpinner = __webpack_require__(78);

var _AndroidSpinner2 = _interopRequireDefault(_AndroidSpinner);

var _IosSpinner = __webpack_require__(77);

var _IosSpinner2 = _interopRequireDefault(_IosSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var osname = (0, _platform.platform)();
var baseClassNames = (0, _getClassName2.default)('Spinner');

var Spinner = function (_Component) {
  _inherits(Spinner, _Component);

  function Spinner() {
    _classCallCheck(this, Spinner);

    return _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).apply(this, arguments));
  }

  _createClass(Spinner, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          on = _props.on,
          progress = _props.progress,
          className = _props.className,
          restProps = _objectWithoutProperties(_props, ['on', 'progress', 'className']);

      var Component = osname === _platform.IOS ? _IosSpinner2.default : _AndroidSpinner2.default;
      var size = this.props.size || Component.defaultProps.size;

      return _react2.default.createElement(
        'div',
        _extends({}, restProps, { className: (0, _classnames2.default)(baseClassNames, {
            'Spinner--on': on && progress === null
          }, className) }),
        _react2.default.createElement(
          'svg',
          {
            className: 'Spinner__self',
            style: { width: size, height: size },
            viewBox: '0 0 ' + size + ' ' + size,
            xmlns: 'http://www.w3.org/2000/svg'
          },
          _react2.default.createElement(Component, this.props)
        )
      );
    }
  }]);

  return Spinner;
}(_react.Component);

Spinner.propTypes = {
  style: _propTypes2.default.object,
  size: _propTypes2.default.number,
  /**
   * Толщина линии в Android версии
   */
  strokeWidth: _propTypes2.default.number,
  /**
   * @ignore
   */
  on: _propTypes2.default.bool,
  /**
   * @ignore
   */
  progress: _propTypes2.default.number,
  className: _propTypes2.default.string
};
Spinner.defaultProps = {
  strokeWidth: 4,
  on: true,
  progress: null
};
exports.default = Spinner;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(2);

var _classnames3 = _interopRequireDefault(_classnames2);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _Tappable = __webpack_require__(5);

var _Tappable2 = _interopRequireDefault(_Tappable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var baseClassNames = (0, _getClassName2.default)('ActionSheetItem');

var ActionSheetItem = function ActionSheetItem(_ref) {
  var className = _ref.className,
      children = _ref.children,
      autoclose = _ref.autoclose,
      theme = _ref.theme,
      restProps = _objectWithoutProperties(_ref, ['className', 'children', 'autoclose', 'theme']);

  return _react2.default.createElement(
    _Tappable2.default,
    _extends({}, restProps, {
      className: (0, _classnames3.default)(baseClassNames, className, _defineProperty({}, 'ActionSheetItem--' + theme, true)),
      component: theme === 'cancel' ? 'span' : 'div'
    }),
    _react2.default.createElement(
      'span',
      { className: 'ActionSheetItem__in' },
      children
    )
  );
};

ActionSheetItem.propTypes = {
  theme: _propTypes2.default.oneOf(['default', 'destructive', 'cancel']),
  children: _propTypes2.default.node,
  style: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  className: _propTypes2.default.string,
  autoclose: _propTypes2.default.bool
};

ActionSheetItem.defaultProps = {
  theme: 'default'
};

exports.default = ActionSheetItem;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PopoutWrapper = __webpack_require__(10);

var _PopoutWrapper2 = _interopRequireDefault(_PopoutWrapper);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _platform = __webpack_require__(4);

var _transitionEvents = __webpack_require__(9);

var _transitionEvents2 = _interopRequireDefault(_transitionEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var osname = (0, _platform.platform)();

var baseClassNames = (0, _getClassName2.default)('ActionSheet');

var ActionSheet = function (_React$Component) {
  _inherits(ActionSheet, _React$Component);

  function ActionSheet() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ActionSheet);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActionSheet.__proto__ || Object.getPrototypeOf(ActionSheet)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      closing: false
    }, _this.onClose = function () {
      _this.setState({ closing: true });
      _this.waitTransitionFinish(_this.props.onClose);
    }, _this.onItemClick = function (action, autoclose) {
      return function () {
        if (autoclose) {
          _this.setState({ closing: true });
          _this.waitTransitionFinish(function () {
            autoclose && _this.props.onClose();
            action && action();
          });
        } else {
          action && action();
        }
      };
    }, _this.getRef = function (el) {
      return _this.el = el;
    }, _this.stopPropagation = function (e) {
      return e.stopPropagation();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ActionSheet, [{
    key: 'waitTransitionFinish',
    value: function waitTransitionFinish(eventHandler) {
      if (_transitionEvents2.default.supported) {
        var eventName = _transitionEvents2.default.prefix ? _transitionEvents2.default.prefix + 'TransitionEnd' : 'transitionend';

        this.el.removeEventListener(eventName, eventHandler);
        this.el.addEventListener(eventName, eventHandler);
      } else {
        setTimeout(eventHandler.bind(this), osname === _platform.ANDROID ? 200 : 300);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          title = _props.title,
          text = _props.text,
          style = _props.style,
          restProps = _objectWithoutProperties(_props, ['children', 'className', 'title', 'text', 'style']);

      return _react2.default.createElement(
        _PopoutWrapper2.default,
        {
          closing: this.state.closing,
          v: osname === _platform.IOS ? 'bottom' : 'center',
          h: 'center',
          className: className,
          style: style,
          onClick: this.onClose
        },
        _react2.default.createElement(
          'div',
          _extends({}, restProps, { ref: this.getRef, onClick: this.stopPropagation, className: (0, _classnames2.default)(baseClassNames, {
              'ActionSheet--closing': this.state.closing
            }) }),
          osname === _platform.IOS && _react2.default.createElement(
            'header',
            { className: 'ActionSheet__header' },
            title && _react2.default.createElement(
              'div',
              { className: 'ActionSheet__title' },
              title
            ),
            text && _react2.default.createElement(
              'div',
              { className: 'ActionSheet__text' },
              text
            )
          ),
          _react2.default.Children.map(children, function (Child) {
            return Child && _react2.default.cloneElement(Child, {
              onClick: _this2.onItemClick(Child.props.onClick, Child.props.autoclose)
            });
          }, null)
        )
      );
    }
  }]);

  return ActionSheet;
}(_react2.default.Component);

ActionSheet.propTypes = {
  /**
   * iOS only
   */
  title: _propTypes2.default.node,
  /**
   * iOS only
   */
  text: _propTypes2.default.node,
  onClose: _propTypes2.default.func.isRequired,
  style: _propTypes2.default.object,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string
};
exports.default = ActionSheet;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Tappable = __webpack_require__(5);

var _Tappable2 = _interopRequireDefault(_Tappable);

var _PopoutWrapper = __webpack_require__(10);

var _PopoutWrapper2 = _interopRequireDefault(_PopoutWrapper);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames2 = __webpack_require__(2);

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var baseClassNames = (0, _getClassName2.default)('Alert');

var Alert = function (_Component) {
  _inherits(Alert, _Component);

  function Alert() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Alert);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Alert.__proto__ || Object.getPrototypeOf(Alert)).call.apply(_ref, [this].concat(args))), _this), _this.onItemClick = function (item) {
      return function () {
        item.autoclose && _this.props.onClose();
        item.action && item.action();
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Alert, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          actions = _props.actions,
          actionsLayout = _props.actionsLayout,
          children = _props.children,
          className = _props.className,
          style = _props.style,
          restProps = _objectWithoutProperties(_props, ['actions', 'actionsLayout', 'children', 'className', 'style']);

      return _react2.default.createElement(
        _PopoutWrapper2.default,
        { className: className, style: style },
        _react2.default.createElement(
          'div',
          _extends({}, restProps, { className: (0, _classnames3.default)(baseClassNames, {
              'Alert--v': actionsLayout === 'vertical',
              'Alert--h': actionsLayout === 'horizontal'
            }) }),
          _react2.default.createElement(
            'div',
            { className: 'Alert__content' },
            children
          ),
          _react2.default.createElement(
            'footer',
            { className: 'Alert__footer' },
            actions.map(function (button, i) {
              return _react2.default.createElement(
                _Tappable2.default,
                {
                  component: 'button',
                  className: (0, _classnames3.default)('Alert__btn', _defineProperty({}, 'Alert__btn--' + button.style, true)),
                  onClick: _this2.onItemClick(button),
                  key: 'alert-action-' + i
                },
                _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: button.title } })
              );
            })
          )
        )
      );
    }
  }]);

  return Alert;
}(_react.Component);

Alert.propTypes = {
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  actionsLayout: _propTypes2.default.oneOf(['vertical', 'horizontal']),
  actions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    title: _propTypes2.default.string,
    action: _propTypes2.default.func,
    style: _propTypes2.default.oneOf(['primary', 'cancel', 'destructive', 'default'])
  })),
  onClose: _propTypes2.default.func
};
Alert.defaultProps = {
  actionsLayout: 'horizontal',
  actions: []
};
exports.default = Alert;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOffsetRect = getOffsetRect;
function getOffsetRect(elem) {
  var box = elem.getBoundingClientRect();
  var body = document.body;
  var doc = document.documentElement;
  var scrollTop = window.pageYOffset || doc.scrollTop || body.scrollTop;
  var scrollLeft = window.pageXOffset || doc.scrollLeft || body.scrollLeft;
  var clientTop = doc.clientTop || body.clientTop || 0;
  var clientLeft = doc.clientLeft || body.clientLeft || 0;

  return {
    top: Math.round(box.top + scrollTop - clientTop),
    left: Math.round(box.left + scrollLeft - clientLeft),
    width: elem.offsetWidth,
    height: elem.offsetHeight
  };
}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Tappable = __webpack_require__(5);

var _Tappable2 = _interopRequireDefault(_Tappable);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var baseClassName = (0, _getClassName2.default)('HeaderButton');

var HeaderButton = function HeaderButton(_ref) {
  var className = _ref.className,
      children = _ref.children,
      primary = _ref.primary,
      restProps = _objectWithoutProperties(_ref, ['className', 'children', 'primary']);

  var isPrimitive = typeof children === 'string' || typeof children === 'number';
  var component = restProps.href ? 'a' : 'button';

  return _react2.default.createElement(
    _Tappable2.default,
    _extends({}, restProps, {
      component: component,
      activeEffectDelay: 200,
      className: (0, _classnames2.default)(baseClassName, className, { 'HeaderButton--primary': primary })
    }),
    isPrimitive ? _react2.default.createElement(
      'span',
      { className: 'HeaderButton__primitive' },
      children
    ) : children
  );
};

HeaderButton.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  primary: _propTypes2.default.bool,
  /**
   * Делает из кнопки ссылку
   */
  href: _propTypes2.default.string
};

HeaderButton.defaultProps = {
  primary: false
};

exports.default = HeaderButton;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  tabbarHeight: 48,
  /* Цветовые схемы */
  CLIENT_DARK: 'client_dark',
  CLIENT_LIGHT: 'client_light'
};

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__34__;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseClassNames = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(34);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames6 = __webpack_require__(2);

var _classnames7 = _interopRequireDefault(_classnames6);

var _platform = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var osname = (0, _platform.platform)();

var baseClassNames = exports.baseClassNames = (0, _getClassName2.default)('PanelHeader');

var PanelHeader = function (_React$Component) {
  _inherits(PanelHeader, _React$Component);

  function PanelHeader() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PanelHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PanelHeader.__proto__ || Object.getPrototypeOf(PanelHeader)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      ready: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PanelHeader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.leftNode = this.document.getElementById('header-left-' + this.context.panel);
      this.addonNode = this.document.getElementById('header-addon-' + this.context.panel);
      this.titleNode = this.document.getElementById('header-title-' + this.context.panel);
      this.rightNode = this.document.getElementById('header-right-' + this.context.panel);
      this.bgNode = this.document.getElementById('header-bg-' + this.context.panel);
      this.props.getRef && this.props.getRef(this.document.getElementById('panel-header-' + this.context.panel));
      this.setState({ ready: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames, _classnames2, _classnames3, _classnames4, _classnames5;

      var _props = this.props,
          left = _props.left,
          addon = _props.addon,
          children = _props.children,
          right = _props.right,
          theme = _props.theme,
          noShadow = _props.noShadow,
          transparent = _props.transparent;

      var isPrimitive = typeof children === 'string' || typeof children === 'number';

      return this.state.ready ? [_reactDom2.default.createPortal(_react2.default.createElement('div', { className: (0, _classnames7.default)('PanelHeader-bg', (_classnames = {}, _defineProperty(_classnames, 'PanelHeader-bg--' + theme, true), _defineProperty(_classnames, 'PanelHeader-bg--tp', transparent), _defineProperty(_classnames, 'PanelHeader-bg--no-shadow', noShadow), _classnames)) }), this.bgNode), _reactDom2.default.createPortal(_react2.default.createElement(
        'div',
        { className: (0, _classnames7.default)('PanelHeader-left-in', (_classnames2 = {}, _defineProperty(_classnames2, 'PanelHeader-left-in--' + theme, true), _defineProperty(_classnames2, 'PanelHeader-left-in--tp', transparent), _classnames2)) },
        left
      ), this.leftNode), osname === _platform.IOS && _reactDom2.default.createPortal(_react2.default.createElement(
        'div',
        { className: (0, _classnames7.default)('PanelHeader-addon', (_classnames3 = {}, _defineProperty(_classnames3, 'PanelHeader-addon--' + theme, true), _defineProperty(_classnames3, 'PanelHeader-addon--tp', transparent), _classnames3)) },
        addon
      ), this.addonNode), _reactDom2.default.createPortal(_react2.default.createElement(
        'div',
        { className: (0, _classnames7.default)('PanelHeader-content', (_classnames4 = {}, _defineProperty(_classnames4, 'PanelHeader-content--' + theme, true), _defineProperty(_classnames4, 'PanelHeader-content--tp', transparent), _classnames4)) },
        isPrimitive ? _react2.default.createElement(
          'span',
          null,
          children
        ) : children
      ), this.titleNode), _reactDom2.default.createPortal(_react2.default.createElement(
        'div',
        { className: (0, _classnames7.default)('PanelHeader-right', (_classnames5 = {}, _defineProperty(_classnames5, 'PanelHeader-right--' + theme, true), _defineProperty(_classnames5, 'PanelHeader-right--tp', transparent), _defineProperty(_classnames5, 'PanelHeader-right--vkapps', this.webviewType === 'vkapps'), _classnames5)) },
        this.webviewType === 'internal' ? right : null
      ), this.rightNode)] : null;
    }
  }, {
    key: 'document',
    get: function get() {
      return this.context.document || document;
    }
  }, {
    key: 'webviewType',
    get: function get() {
      return this.context.webviewType || 'vkapps';
    }
  }]);

  return PanelHeader;
}(_react2.default.Component);

PanelHeader.propTypes = {
  left: _propTypes2.default.node,
  /**
   * iOS only
   */
  addon: _propTypes2.default.node,
  right: _propTypes2.default.node,
  children: _propTypes2.default.node,
  /**
   * Вместо `light` используйте `alternate`. Значение `light` устарело и будет удалено в следующей
   * мажорной версии.
   */
  theme: _propTypes2.default.oneOf(['light', 'alternate', 'brand']),
  /**
   * @ignore
   */
  transparent: _propTypes2.default.bool,
  noShadow: _propTypes2.default.bool,
  getRef: _propTypes2.default.func
};
PanelHeader.defaultProps = {
  theme: 'brand',
  transparent: false,
  noShadow: false
};
PanelHeader.contextTypes = {
  panel: _propTypes2.default.string,
  document: _propTypes2.default.any,
  webviewType: _propTypes2.default.oneOf(['vkapps', 'internal'])
};
exports.default = PanelHeader;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * Получает кординату по оси абсцисс из touch- или mouse-события
 *
 * @param {Object} e Бразуерное событие
 * @returns {Number} Координата взаимодействия по оси абсцисс
 */
var coordX = function coordX(e) {
  return e.clientX || e.touches && e.touches[0].clientX;
};

/**
 * Получает кординату по оси ординат из touch- или mouse-события
 *
 * @param {Object} e Бразуерное событие
 * @returns {Number} Координата взаимодействия по оси ординат
 */
var coordY = function coordY(e) {
  return e.clientY || e.touches && e.touches[0].clientY;
};

var isClient = typeof window !== 'undefined';
var touchEnabled = isClient && 'ontouchstart' in window;

/**
 * Возвращает массив поддерживаемых событий
 * Если браузер поддерживает pointer events или подключена handjs, вернет события указателя.
 * Если нет, используем события мыши
 *
 * @returns {Array} Массив с названиями событий
 */
function getSupportedEvents() {
  if (touchEnabled) {
    return ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
  }

  return ['mousedown', 'mousemove', 'mouseup', 'mouseleave'];
}

exports.getSupportedEvents = getSupportedEvents;
exports.coordX = coordX;
exports.coordY = coordY;
exports.touchEnabled = touchEnabled;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transitionEndEventName = exports.transitionStartEventName = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _animate = __webpack_require__(90);

var _animate2 = _interopRequireDefault(_animate);

var _transitionEvents = __webpack_require__(9);

var _transitionEvents2 = _interopRequireDefault(_transitionEvents);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _platform = __webpack_require__(4);

var _Touch = __webpack_require__(8);

var _Touch2 = _interopRequireDefault(_Touch);

var _removeObjectKeys = __webpack_require__(13);

var _removeObjectKeys2 = _interopRequireDefault(_removeObjectKeys);

var _PanelHeader = __webpack_require__(35);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var osname = (0, _platform.platform)();
var baseClassNames = (0, _getClassName2.default)('View');

var transitionStartEventName = exports.transitionStartEventName = 'VKUI:View:transition-start';
var transitionEndEventName = exports.transitionEndEventName = 'VKUI:View:transition-end';

var View = function (_Component) {
  _inherits(View, _Component);

  function View(props) {
    _classCallCheck(this, View);

    var _this = _possibleConstructorReturn(this, (View.__proto__ || Object.getPrototypeOf(View)).call(this, props));

    _this.refsStore = {};

    _this.transitionEndHandler = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { manual: true };

      if (['animation-ios-next-forward', 'animation-ios-next-back', 'animation-ios-prev-forward', 'animation-ios-prev-back', 'animation-android-next-forward', 'animation-android-prev-back'].indexOf(e.animationName) > -1 || e.manual) {
        var activePanel = _this.props.activePanel;
        var isBack = _this.state.isBack;
        var prevPanel = _this.state.prevPanel;
        _this.document.dispatchEvent(new _this.window.CustomEvent(transitionEndEventName));
        _this.setState({
          prevPanel: null,
          nextPanel: null,
          visiblePanels: [activePanel],
          activePanel: activePanel,
          animated: false,
          isBack: undefined,
          scrolls: isBack ? (0, _removeObjectKeys2.default)(_this.state.scrolls, [prevPanel]) : _this.state.scrolls
        }, function () {
          isBack && this.window.scrollTo(0, this.state.scrolls[activePanel]);
          this.props.onTransition && this.props.onTransition({ isBack: isBack, from: prevPanel, to: activePanel });
        });
      }
    };

    _this.swipingBackTransitionEndHandler = function (e) {
      // indexOf because of vendor prefixes in old browsers
      if (e.propertyName.indexOf('transform') >= 0 && e.target.classList.contains('View__panel--swipe-back-next')) {
        _this.state.swipingBackFinish ? _this.onSwipeBackSuccess() : _this.onSwipeBackCancel();
      }
    };

    _this.onScrollTop = function () {
      var activePanel = _this.state.activePanel;


      if (activePanel) {
        var scrollTop = _this.document.body.scrollTop || _this.document.this.documentElement.scrollTop;

        if (scrollTop) {
          (0, _animate2.default)({
            duration: 200,
            timing: function timing(n) {
              return Math.sqrt(n);
            },
            draw: function draw(val) {
              _this.window.scrollTo(0, scrollTop - val * scrollTop);
            }
          });
        }
      }
    };

    _this.onMoveX = function (e) {
      if (osname === _platform.IOS && !_this.context.isWebView && (e.startX <= 70 || e.startX >= _this.window.innerWidth - 70) && !_this.state.browserSwipe) {
        _this.setState({ browserSwipe: true });
      }

      if (osname === _platform.IOS && _this.context.isWebView && _this.props.onSwipeBack) {
        if (_this.state.animated && e.startX <= 70) {
          return;
        }

        if (e.startX <= 70 && !_this.state.swipingBack && _this.props.history.length > 1) {
          _this.setState({
            swipingBack: true,
            swipebackStartX: e.startX,
            startT: e.startT,
            swipeBackPrevPanel: _this.state.activePanel,
            swipeBackNextPanel: _this.props.history.slice(-2)[0],
            scrolls: Object.assign({}, _this.state.scrolls, _defineProperty({}, _this.state.activePanel, _this.window.pageYOffset))
          });
        }
        if (_this.state.swipingBack) {
          var swipeBackShift = void 0;
          if (e.shiftX < 0) {
            swipeBackShift = 0;
          } else if (e.shiftX > _this.window.innerWidth - _this.state.swipebackStartX) {
            swipeBackShift = _this.window.innerWidth;
          } else {
            swipeBackShift = e.shiftX;
          }
          _this.setState({ swipeBackShift: swipeBackShift });
        }
      }
    };

    _this.onEnd = function () {
      if (_this.state.swipingBack) {
        var speed = _this.state.swipeBackShift / (new Date() - _this.state.startT) * 1000;
        if (_this.state.swipeBackShift === 0) {
          _this.onSwipeBackCancel();
        } else if (_this.state.swipeBackShift >= _this.window.innerWidth) {
          _this.onSwipeBackSuccess();
        } else {
          _this.setState({ swipingBackFinish: speed > 250 || _this.state.swipebackStartX + _this.state.swipeBackShift > _this.window.innerWidth / 2 });
        }
      }
    };

    _this.getRef = function (c) {
      if (c && c.container && c.id) {
        var el = c;

        while (el.container) {
          el = el.container;
        }

        _this.refsStore[c.id] = el;
      }
    };

    _this.state = {
      scrolls: {},

      visiblePanels: [props.activePanel],
      activePanel: props.activePanel,
      isBack: undefined,
      prevPanel: null,
      nextPanel: null,

      swipingBack: false,
      swipebackStartX: 0,
      swipeBackShift: 0,
      swipeBackNextPanel: null,
      swipeBackPrevPanel: null,
      swipingBackFinish: null,

      browserSwipe: false
    };
    return _this;
  }

  _createClass(View, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      nextProps.popout && !this.props.popout && this.blurActiveElement();

      // Нужен переход
      if (this.props.activePanel !== nextProps.activePanel && !this.state.swipingBack && !this.state.browserSwipe) {
        var firstLayer = this.panels.find(function (panel) {
          return panel.props.id === _this2.props.activePanel || panel.props.id === nextProps.activePanel;
        });

        var isBack = firstLayer && firstLayer.props.id === nextProps.activePanel;

        this.blurActiveElement();

        this.setState({
          visiblePanels: [this.props.activePanel, nextProps.activePanel],
          prevPanel: this.props.activePanel,
          nextPanel: nextProps.activePanel,
          activePanel: null,
          animated: true,
          scrolls: Object.assign({}, this.state.scrolls, _defineProperty({}, this.props.activePanel, this.window.pageYOffset)),
          isBack: isBack
        });
      }

      // Закончилась анимация свайпа назад
      if (this.props.activePanel !== nextProps.activePanel && this.state.swipingBack) {
        var nextPanel = nextProps.activePanel;
        var prevPanel = this.props.activePanel;
        this.setState({
          swipeBackPrevPanel: null,
          swipeBackNextPanel: null,
          swipingBack: false,
          swipingBackFinish: null,
          swipebackStartX: 0,
          swipeBackShift: 0,
          activePanel: nextPanel,
          visiblePanels: [nextPanel],
          scrolls: (0, _removeObjectKeys2.default)(this.state.scrolls, [this.state.swipeBackPrevPanel])
        }, function () {
          _this2.document.dispatchEvent(new _this2.window.CustomEvent(transitionEndEventName));
          window.scrollTo(0, _this2.state.scrolls[_this2.state.activePanel]);
          _this2.props.onTransition && _this2.props.onTransition({ isBack: true, from: prevPanel, to: nextPanel });
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var scrolls = this.state.scrolls;

      // Начался переход
      if (!prevState.animated && this.state.animated) {
        this.document.dispatchEvent(new this.window.CustomEvent(transitionStartEventName, { detail: { scrolls: scrolls } }));
        var nextPanelElement = this.pickPanel(this.state.nextPanel);
        var prevPanelElement = this.pickPanel(this.state.prevPanel);

        prevPanelElement.scrollTop = scrolls[this.state.prevPanel];
        if (this.state.isBack) {
          nextPanelElement.scrollTop = scrolls[this.state.nextPanel];
        }
        this.waitAnimationFinish(this.pickPanel(this.state.isBack ? this.state.prevPanel : this.state.nextPanel), this.transitionEndHandler);
      }

      // Начался свайп назад
      if (!prevState.swipingBack && this.state.swipingBack) {
        this.document.dispatchEvent(new this.window.CustomEvent(transitionStartEventName, { detail: { scrolls: scrolls } }));
        this.props.onSwipeBackStart && this.props.onSwipeBackStart();
        var _nextPanelElement = this.pickPanel(this.state.swipeBackNextPanel);
        var _prevPanelElement = this.pickPanel(this.state.swipeBackPrevPanel);

        _nextPanelElement.scrollTop = scrolls[this.state.swipeBackNextPanel];
        _prevPanelElement.scrollTop = scrolls[this.state.swipeBackPrevPanel];
      }

      // Началась анимация завершения свайпа назад.
      if (prevState.swipingBackFinish === null && this.state.swipingBackFinish !== null) {
        this.waitTransitionFinish(this.pickPanel(this.state.swipeBackNextPanel), this.swipingBackTransitionEndHandler);
      }

      // Если свайп назад отменился (когда пользователь недостаточно сильно свайпнул)
      if (prevState.swipingBackFinish === false && this.state.swipingBackFinish === null) {
        this.window.scrollTo(0, scrolls[this.state.activePanel]);
      }

      // Закончился Safari свайп
      if (prevProps.activePanel !== this.props.activePanel && this.state.browserSwipe) {
        this.setState({
          browserSwipe: false,
          nextPanel: null,
          prevPanel: null,
          animated: false,
          visiblePanels: [this.props.activePanel],
          activePanel: this.props.activePanel
        });
      }
    }
  }, {
    key: 'waitTransitionFinish',
    value: function waitTransitionFinish(elem, eventHandler) {
      if (_transitionEvents2.default.supported) {
        var eventName = _transitionEvents2.default.prefix ? _transitionEvents2.default.prefix + 'TransitionEnd' : 'transitionend';

        elem.removeEventListener(eventName, eventHandler);
        elem.addEventListener(eventName, eventHandler);
      } else {
        setTimeout(eventHandler.bind(this), osname === _platform.ANDROID ? 300 : 600);
      }
    }
  }, {
    key: 'waitAnimationFinish',
    value: function waitAnimationFinish(elem, eventHandler) {
      if (_transitionEvents2.default.supported) {
        var eventName = _transitionEvents2.default.prefix ? _transitionEvents2.default.prefix + 'AnimationEnd' : 'animationend';

        elem.removeEventListener(eventName, eventHandler);
        elem.addEventListener(eventName, eventHandler);
      } else {
        setTimeout(eventHandler.bind(this), osname === _platform.ANDROID ? 300 : 600);
      }
    }
  }, {
    key: 'blurActiveElement',
    value: function blurActiveElement() {
      if (typeof this.window !== 'undefined' && this.document.activeElement) {
        this.document.activeElement.blur();
      }
    }
  }, {
    key: 'pickPanel',
    value: function pickPanel(id) {
      var elem = this.document.getElementById(id);

      if (!elem) {
        console.warn('Element #' + id + ' not found');
      }

      return elem && elem.parentNode.parentNode;
    }
  }, {
    key: 'onSwipeBackSuccess',
    value: function onSwipeBackSuccess() {
      this.props.onSwipeBack && this.props.onSwipeBack();
    }
  }, {
    key: 'onSwipeBackCancel',
    value: function onSwipeBackCancel() {
      var _this3 = this;

      this.setState({
        swipeBackPrevPanel: null,
        swipeBackNextPanel: null,
        swipingBack: false,
        swipingBackFinish: null,
        swipebackStartX: 0,
        swipeBackShift: 0
      }, function () {
        _this3.document.dispatchEvent(new _this3.window.CustomEvent(transitionEndEventName));
      });
    }
  }, {
    key: 'calcPanelSwipeStyles',
    value: function calcPanelSwipeStyles(panelId) {
      var isPrev = panelId === this.state.swipeBackPrevPanel;
      var isNext = panelId === this.state.swipeBackNextPanel;

      if (!isPrev && !isNext || this.state.swipingBackFinish !== null) {
        return {};
      }

      var prevPanelTranslate = this.state.swipeBackShift + 'px';
      var nextPanelTranslate = -50 + this.state.swipeBackShift * 100 / this.window.innerWidth / 2 + '%';
      var prevPanelShadow = 0.3 * (this.window.innerWidth - this.state.swipeBackShift) / this.window.innerWidth;

      if (this.state.swipingBackFinish !== null) {
        return isPrev ? { boxShadow: '-2px 0 12px rgba(0, 0, 0, ' + prevPanelShadow + ')' } : {};
      }

      if (isNext) {
        return {
          transform: 'translate3d(' + nextPanelTranslate + ', 0, 0)',
          WebkitTransform: 'translate3d(' + nextPanelTranslate + ', 0, 0)'
        };
      }
      if (isPrev) {
        return {
          transform: 'translate3d(' + prevPanelTranslate + ', 0, 0)',
          WebkitTransform: 'translate3d(' + prevPanelTranslate + ', 0, 0)',
          boxShadow: '-2px 0 12px rgba(0, 0, 0, ' + prevPanelShadow + ')'
        };
      }

      return {};
    }
  }, {
    key: 'calcHeaderSwipeStyles',
    value: function calcHeaderSwipeStyles(panelId) {
      var isPrev = panelId === this.state.swipeBackPrevPanel;
      var isNext = panelId === this.state.swipeBackNextPanel;

      if (!isPrev && !isNext || this.state.swipingBackFinish !== null) {
        return {
          title: {},
          bg: {},
          left: {},
          addon: {},
          right: {}
        };
      }

      var opacity = this.state.swipeBackShift / this.window.innerWidth;
      var titleTransform = this.state.swipeBackShift / this.window.innerWidth * 30;
      var leftTransform = this.state.swipeBackShift / this.window.innerWidth * 30;

      if (isNext) {
        return {
          title: {
            transform: 'translate3d(' + (-30 + titleTransform) + 'vw, 0, 0)',
            WebkitTransform: 'translate3d(' + (-30 + titleTransform) + 'vw, 0, 0)',
            opacity: opacity
          },
          left: { opacity: opacity },
          addon: {
            opacity: 1,
            transform: 'translate3d(' + (-30 + leftTransform) + 'vw, 0, 0)',
            WebkitTransform: 'translate3d(' + (-30 + leftTransform) + 'vw, 0, 0)'
          },
          right: { opacity: opacity }
        };
      }
      if (isPrev) {
        return {
          title: {
            transform: 'translate3d(' + titleTransform + 'vw, 0, 0)',
            WebkitTransform: 'translate3d(' + titleTransform + 'vw, 0, 0)',
            opacity: 1 - opacity
          },
          bg: { opacity: 1 - opacity },
          left: { opacity: 1 - opacity },
          addon: {
            transform: 'translate3d(' + leftTransform + 'vw, 0, 0)',
            WebkitTransform: 'translate3d(' + leftTransform + 'vw, 0, 0)',
            opacity: 1 - opacity
          }
        };
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(_ref) {
      var inRoot = _ref.inRoot,
          isNext = _ref.isNext,
          isPrev = _ref.isPrev;

      return inRoot ? !isNext && !isPrev : true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          style = _props.style,
          popout = _props.popout,
          header = _props.header;
      var _state = this.state,
          prevPanel = _state.prevPanel,
          nextPanel = _state.nextPanel,
          activePanel = _state.activePanel,
          swipeBackPrevPanel = _state.swipeBackPrevPanel,
          swipeBackNextPanel = _state.swipeBackNextPanel;

      var hasPopout = !!popout;
      var panels = this.panels.filter(function (panel) {
        return _this4.state.visiblePanels.indexOf(panel.props.id) > -1 || panel.props.id === _this4.state.swipeBackPrevPanel || panel.props.id === _this4.state.swipeBackNextPanel;
      });

      var modifiers = {
        'View--header': header,
        'View--animated': this.state.animated,
        'View--swiping-back': this.state.swipingBack
      };

      return _react2.default.createElement(
        _Touch2.default,
        {
          component: 'section',
          className: (0, _classnames2.default)(baseClassNames, modifiers),
          style: style,
          onMoveX: this.onMoveX,
          onEnd: this.onEnd
        },
        header && _react2.default.createElement(
          'div',
          { className: 'View__header' },
          osname === _platform.IOS && _react2.default.createElement('div', { className: 'View__header-scrolltop', onClick: this.onScrollTop }),
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(_PanelHeader.baseClassNames) },
            panels.map(function (panel) {
              return _react2.default.createElement(
                'div',
                {
                  className: (0, _classnames2.default)('PanelHeader__in', {
                    'PanelHeader__in--active': panel.props.id === activePanel,
                    'PanelHeader__in--prev': panel.props.id === prevPanel,
                    'PanelHeader__in--next': panel.props.id === nextPanel,
                    'PanelHeader__in--swipe-back-prev': panel.props.id === _this4.state.swipeBackPrevPanel,
                    'PanelHeader__in--swipe-back-next': panel.props.id === _this4.state.swipeBackNextPanel,
                    'PanelHeader__in--swipe-back-success': _this4.state.swipingBackFinish === true,
                    'PanelHeader__in--swipe-back-failed': _this4.state.swipingBackFinish === false
                  }),
                  key: panel.props.id,
                  id: 'panel-header-' + panel.props.id
                },
                _react2.default.createElement('div', {
                  className: 'PanelHeader__bg',
                  key: panel.props.id,
                  id: 'header-bg-' + panel.props.id,
                  style: _this4.calcHeaderSwipeStyles(panel.props.id).bg
                }),
                _react2.default.createElement(
                  'div',
                  { className: 'PanelHeader__container' },
                  _react2.default.createElement(
                    'div',
                    { className: 'PanelHeader__left' },
                    _react2.default.createElement('div', {
                      className: 'PanelHeader__left-in',
                      id: 'header-left-' + panel.props.id,
                      style: _this4.calcHeaderSwipeStyles(panel.props.id).left
                    }),
                    osname === _platform.IOS && _react2.default.createElement('div', {
                      className: 'PanelHeader__addon',
                      id: 'header-addon-' + panel.props.id,
                      style: _this4.calcHeaderSwipeStyles(panel.props.id).icon
                    })
                  ),
                  _react2.default.createElement('div', {
                    className: 'PanelHeader__content',
                    style: _this4.calcHeaderSwipeStyles(panel.props.id).title,
                    id: 'header-title-' + panel.props.id
                  }),
                  _react2.default.createElement('div', {
                    className: 'PanelHeader__right',
                    id: 'header-right-' + panel.props.id,
                    style: _this4.calcHeaderSwipeStyles(panel.props.id).right
                  })
                )
              );
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'View__panels' },
          panels.map(function (panel) {
            return _react2.default.createElement(
              'div',
              {
                className: (0, _classnames2.default)('View__panel', {
                  'View__panel--active': panel.props.id === activePanel,
                  'View__panel--prev': panel.props.id === prevPanel,
                  'View__panel--next': panel.props.id === nextPanel,
                  'View__panel--swipe-back-prev': panel.props.id === _this4.state.swipeBackPrevPanel,
                  'View__panel--swipe-back-next': panel.props.id === _this4.state.swipeBackNextPanel,
                  'View__panel--swipe-back-success': _this4.state.swipingBackFinish === true,
                  'View__panel--swipe-back-failed': _this4.state.swipingBackFinish === false
                }),
                style: _this4.calcPanelSwipeStyles(panel.props.id),
                key: panel.props.id
              },
              _react2.default.createElement(
                'div',
                { className: 'View__panel-in' },
                _react2.default.cloneElement(panel, {
                  isNext: panel.props.id === nextPanel || panel.props.id === swipeBackNextPanel,
                  isPrev: panel.props.id === prevPanel || panel.props.id === swipeBackPrevPanel
                })
              )
            );
          })
        ),
        hasPopout && _react2.default.createElement(
          'div',
          { className: 'View__popout' },
          popout
        )
      );
    }
  }, {
    key: 'document',
    get: function get() {
      return this.context.document || document;
    }
  }, {
    key: 'window',
    get: function get() {
      return this.context.window || window;
    }
  }, {
    key: 'panels',
    get: function get() {
      return [].concat(this.props.children);
    }
  }]);

  return View;
}(_react.Component);

View.propTypes = {
  style: _propTypes2.default.object,
  activePanel: _propTypes2.default.string,
  header: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.bool]),
  children: _propTypes2.default.node,
  popout: _propTypes2.default.node,
  onTransition: _propTypes2.default.func,
  /**
   * @ignore
   */
  onSwipeBack: _propTypes2.default.func,
  /**
   * @ignore
   */
  onSwipeBackStart: _propTypes2.default.func,
  /**
   * @ignore
   */
  history: _propTypes2.default.arrayOf(_propTypes2.default.string),

  /**
   * @ignore
   */
  isNext: _propTypes2.default.bool,
  /**
   * @ignore
   */
  isPrev: _propTypes2.default.bool,
  /**
   * @ignore
   */
  inRoot: _propTypes2.default.bool
};
View.defaultProps = {
  style: {},
  children: null,
  popout: null,
  header: true,
  history: []
};
View.contextTypes = {
  isWebView: _propTypes2.default.bool,
  window: _propTypes2.default.any,
  document: _propTypes2.default.any
};
exports.default = View;

/***/ }),
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// CustomEvent
if (window && !window.CustomEvent) {
  var CustomEvent = function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  };

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
}

// Element.prototype.closest
if (window) {
  window.Element.prototype.closest = window.Element.prototype.closest || function (css) {
    var node = this;
    while (node) {
      if (node.matches(css)) return node;else node = node.parentElement;
    }
    return null;
  };
}

// Array.prototype.find
Array.prototype.find = Array.prototype.find || function (callback) {
  if (this === null) {
    throw new TypeError('Array.prototype.find called on null or undefined');
  } else if (typeof callback !== 'function') {
    throw new TypeError('callback must be a function');
  }

  var list = Object(this);
  var length = list.length >>> 0;
  var thisArg = arguments[1];

  for (var i = 0; i < length; i++) {
    var element = list[i];
    if (callback.call(thisArg, element, i, list)) {
      return element;
    }
  }
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _querystring = __webpack_require__(14);

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultOptions = {
  method: 'GET',
  data: null
};

function getXMLHttpRequest() {
  if (typeof XMLHttpRequest !== 'undefined') {
    // eslint-disable-next-line
    return new XMLHttpRequest();
  }
}

function makeRequest(url, options) {
  var isCanceled = void 0;

  var error = new Error('Request was aborted');
  var request = getXMLHttpRequest();
  var opts = Object.assign({}, defaultOptions, options);

  if (opts.data && opts.method.toLowerCase() === 'get') {
    url += '?' + _querystring2.default.create(opts.data);
  }

  var requestPromise = new Promise(function (resolve, reject) {
    if (!request) {
      reject(new Error('XMLHttpRequest not supported'));
    }

    if (opts.timeout) {
      request.timeout = opts.timeout;
    }

    request.open(opts.method, url, true);

    if (opts.headers) {
      Object.keys(opts.headers).forEach(function (key) {
        request.setRequestHeader(key, opts.headers[key]);
      });
    }

    request.onreadystatechange = function () {
      if (request.readyState === 4) {
        if (request.status === 200) {
          resolve(request.responseText);
        } else {
          reject(new Error(request.status));
        }
      }
    };

    request.ontimeout = function () {
      reject(new Error('XMLHttpRequest timeout expires'));
    };

    request.send(opts.data);
  });

  return {

    promise: new Promise(function (resolve, reject) {
      requestPromise.then(function (res) {
        return isCanceled ? reject(error) : resolve(res);
      }).catch(function (e) {
        return isCanceled ? console.log(error) || reject(error) : reject(e);
      });
    }),

    abort: function abort() {
      isCanceled = true;
      if (request) {
        request.abort();
      }
    }
  };
}

exports.default = function (url, options) {
  return makeRequest(url, options);
};

/***/ }),
/* 42 */
/***/ (function(module) {

module.exports = {"name":"@vkontakte/vkui","version":"2.14.1","main":"dist/vkui.js","license":"MIT","description":"VKUI library","repository":"https://github.com/VKCOM/VKUI","homepage":"https://vkcom.github.io/vkui-styleguide","defaultSchemeId":"client_light","devDependencies":{"jest":"^23.1.0","loader-utils":"^1.1.0","mini-css-extract-plugin":"^0.4.0","mini-html-webpack-plugin":"^0.2.3","pre-commit":"^1.2.2","prop-types":"^15.6.1","react":"^16.4.0","react-docgen":"^2.20.0","react-dom":"^16.4.0","react-frame-component":"^3.0.0","react-styleguidist":"^7.0.17","schema-utils":"^0.4.3","webpack":"^4.12.0","webpack-bundle-analyzer":"^2.9.2","webpack-cli":"^3.0.3","webpack-merge":"^4.0.0","webpack-stats-plugin":"^0.1.4","@vkontakte/vkui-connect":"^1.1.2"},"peerDependencies":{"react-dom":"^16.4.0","react":"^16.4.0","@vkontakte/vkui-connect":"^1.1.2","prop-types":"^15.6.1"},"dependencies":{"@vkontakte/icons":"^1.2.1","postcss":"^7.0.2","postcss-custom-properties":"^5.0.2","postcss-import":"^9.1.0","postcss-loader":"^2.1.5","autoprefixer":"^7.2.3","babel-core":"^6.23.1","babel-eslint":"^8.2.3","babel-loader":"^7.1.3","babel-plugin-transform-class-properties":"^6.23.0","babel-plugin-transform-object-rest-spread":"^6.26.0","babel-preset-env":"^1.7.0","babel-preset-react":"^6.23.0","css-loader":"^0.27.1","eslint":"^4.19.1","eslint-config-semistandard":"^7.0.0","eslint-config-standard":"^6.0.1","eslint-plugin-promise":"^3.3.0","eslint-plugin-react":"^7.9.1","eslint-plugin-standard":"^2.0.0","style-loader":"^0.13.2","stylelint":"^9.3.0","stylelint-config-standard":"^16.0.0"},"scripts":{"prepublishOnly":"npm run clear && npm run build","styleguide":"NODE_ENV=development styleguidist server --config=styleguide/config.js","dev":"NODE_ENV=development webpack --watch","styleguide:build":"NODE_ENV=production styleguidist build --config=styleguide/config.js","build":"NODE_ENV=production webpack","clear":"rm -rf dist/*","test":"eslint . && stylelint './src/**/*.css' && jest"},"pre-commit":["test"]};

/***/ }),
/* 43 */
/***/ (function(module, exports) {

(function(window) {
  var FUNCTION = 'function';
  var UNDEFINED = 'undefined';
  var subscribers = [];
  var isWeb = typeof window !== UNDEFINED && !window.AndroidBridge && !window.webkit;
  var eventType = isWeb ? 'message' : 'VKWebAppEvent';

  if (typeof window !== UNDEFINED) {

    //polyfill
    if (!window.CustomEvent) {
      (function() {
        function CustomEvent(event, params) {
          params = params || {bubbles: false, cancelable: false, detail: undefined};
          var evt = document.createEvent('CustomEvent');
          evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
          return evt;
        };

        CustomEvent.prototype = window.Event.prototype;

        window.CustomEvent = CustomEvent;
      })();
    }

    window.addEventListener(eventType, function() {
      var args = Array.prototype.slice.call(arguments);
      if (isWeb) {
        subscribers.forEach(function(fn) {
          fn({
            detail: args[0].data
          });
        });
      } else {
        subscribers.forEach(function(fn) {
          fn.apply(null, args);
        });
      }
    });
  }

  module.exports = {
    /**
     * Sends a message to native client
     *
     * @example
     * message.send('VKWebAppInit');
     *
     * @param {String} handler Message type
     * @param {Object} params Message data
     * @returns {void}
     */
    send: function send(handler, params) {
      if (!params) {
        params = {};
      }

      var isClient = typeof window !== UNDEFINED;
      var androidBridge = isClient && window.AndroidBridge;
      var iosBridge = isClient && window.webkit && window.webkit.messageHandlers;
      var isDesktop = !androidBridge && !iosBridge;

      if (androidBridge && typeof androidBridge[handler] == FUNCTION) {
        androidBridge[handler](JSON.stringify(params));
      }
      if (iosBridge && iosBridge[handler] && typeof iosBridge[handler].postMessage == FUNCTION) {
        iosBridge[handler].postMessage(params);
      }

      if (isDesktop) {
        parent.postMessage({
          handler: handler,
          params: params,
          type: 'vk-connect'
        }, '*');
      }
    },
    /**
     * Subscribe on VKWebAppEvent
     *
     * @param {Function} fn Event handler
     * @returns {void}
     */
    subscribe: function subscribe(fn) {
      subscribers.push(fn);
    },
    /**
     * Unsubscribe on VKWebAppEvent
     *
     * @param {Function} fn Event handler
     * @returns {void}
     */
    unsubscribe: function unsubscribe(fn) {
      var index = subscribers.indexOf(fn);

      if (index > -1) {
        subscribers.splice(index, 1);
      }
    },

    /**
     * Checks if native client supports nandler
     *
     * @param {String} handler Handler name
     * @returns {boolean}
     */
    supports: function supports(handler) {

      var isClient = typeof window !== UNDEFINED;
      var androidBridge = isClient && window.AndroidBridge;
      var iosBridge = isClient && window.webkit && window.webkit.messageHandlers;
      var desktopEvents = [
        "VKWebAppGetAuthToken",
        "VKWebAppCallAPIMethod",
        "VKWebAppGetGeodata",
        "VKWebAppGetUserInfo",
        "VKWebAppGetPhoneNumber",
        "VKWebAppGetClientVersion",
        "VKWebAppOpenPayForm",
        "VKWebAppShare",
        "VKWebAppAllowNotifications",
        "VKWebAppDenyNotifications",
        "VKWebAppShowWallPostBox",
        "VKWebAppGetEmail",
        "VKWebAppAllowMessagesFromGroup",
        "VKWebAppJoinGroup",
        "VKWebAppOpenApp",
        "VKWebAppSetLocation",
        "VKWebAppScroll",
        "VKWebAppResizeWindow",
      ];

      if (androidBridge && typeof androidBridge[handler] == FUNCTION) return true;

      if (iosBridge && iosBridge[handler] && typeof iosBridge[handler].postMessage == FUNCTION) return true;

      if (!iosBridge && !androidBridge && ~desktopEvents.indexOf(handler)) return true;

      return false;
    }
  };
})(window);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _webview = __webpack_require__(15);

var _package = __webpack_require__(42);

var _package2 = _interopRequireDefault(_package);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConfigProvider = function (_React$Component) {
  _inherits(ConfigProvider, _React$Component);

  function ConfigProvider(props) {
    _classCallCheck(this, ConfigProvider);

    var _this = _possibleConstructorReturn(this, (ConfigProvider.__proto__ || Object.getPrototypeOf(ConfigProvider)).call(this, props));

    _this.state = {
      bottomInset: props.insets.bottom > 100 ? 0 : props.insets.bottom
    };
    return _this;
  }

  _createClass(ConfigProvider, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.document.body.setAttribute('scheme', this.props.scheme);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.scheme !== this.props.scheme) {
        this.document.body.setAttribute('scheme', nextProps.scheme);
      }
      if (nextProps.insets.bottom !== this.props.insets.bottom) {
        this.setState({ bottomInset: nextProps.insets.bottom > 100 ? this.props.insets.bottom : nextProps.insets.bottom });
      }
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        insets: _extends({}, this.props.insets, { bottom: this.state.bottomInset }),
        isWebView: this.props.isWebView,
        webviewType: this.props.webviewType,
        scheme: this.props.scheme
      };
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }, {
    key: 'document',
    get: function get() {
      return this.context.document || window.document;
    }
  }]);

  return ConfigProvider;
}(_react2.default.Component);

ConfigProvider.childContextTypes = {
  insets: _propTypes2.default.shape({
    top: _propTypes2.default.number,
    right: _propTypes2.default.number,
    bottom: _propTypes2.default.number,
    left: _propTypes2.default.number
  }),
  isWebView: _propTypes2.default.bool,
  scheme: _propTypes2.default.string,
  webviewType: _propTypes2.default.oneOf(['vkapps', 'internal'])
};
ConfigProvider.propTypes = {
  insets: _propTypes2.default.shape({
    top: _propTypes2.default.number,
    right: _propTypes2.default.number,
    bottom: _propTypes2.default.number,
    left: _propTypes2.default.number
  }),
  scheme: _propTypes2.default.string,
  isWebView: _propTypes2.default.bool,
  webviewType: _propTypes2.default.oneOf(['vkapps', 'internal']),
  children: _propTypes2.default.node
};
ConfigProvider.defaultProps = {
  webviewType: 'internal',
  isWebView: _webview.isWebView,
  scheme: _package2.default.defaultSchemeId,
  insets: {}
};
ConfigProvider.contextTypes = {
  document: _propTypes2.default.object
};
exports.default = ConfigProvider;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames2 = __webpack_require__(2);

var _classnames3 = _interopRequireDefault(_classnames2);

var _dropdown = __webpack_require__(16);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _platform = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var osname = (0, _platform.platform)();
var baseClassName = (0, _getClassName2.default)('Select');

var SelectMimicry = function (_Component) {
  _inherits(SelectMimicry, _Component);

  function SelectMimicry() {
    _classCallCheck(this, SelectMimicry);

    return _possibleConstructorReturn(this, (SelectMimicry.__proto__ || Object.getPrototypeOf(SelectMimicry)).apply(this, arguments));
  }

  _createClass(SelectMimicry, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          placeholder = _props.placeholder,
          children = _props.children,
          alignment = _props.alignment,
          getRootRef = _props.getRootRef,
          restProps = _objectWithoutProperties(_props, ['className', 'placeholder', 'children', 'alignment', 'getRootRef']);

      return _react2.default.createElement(
        'div',
        _extends({}, restProps, {
          className: (0, _classnames3.default)(baseClassName, _defineProperty({
            'Select--not-selected': !children,
            'Select--mimicry': true
          }, 'Select--align-' + alignment, alignment), className),
          ref: getRootRef
        }),
        _react2.default.createElement(
          'div',
          { className: 'Select__container' },
          _react2.default.createElement(
            'div',
            { className: 'Select__title' },
            children || placeholder
          ),
          _react2.default.createElement(_dropdown2.default, null)
        ),
        osname === _platform.ANDROID && _react2.default.createElement('div', { className: 'Select-underline' })
      );
    }
  }]);

  return SelectMimicry;
}(_react.Component);

SelectMimicry.propTypes = {
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  tabIndex: _propTypes2.default.number,
  placeholder: _propTypes2.default.string,
  alignment: _propTypes2.default.oneOf(['left', 'center', 'top']),
  getRootRef: _propTypes2.default.func
};
SelectMimicry.defaultProps = {
  tabIndex: 0,
  alignment: 'left'
};
exports.default = SelectMimicry;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames2 = __webpack_require__(2);

var _classnames3 = _interopRequireDefault(_classnames2);

var _dropdown = __webpack_require__(16);

var _dropdown2 = _interopRequireDefault(_dropdown);

var _platform = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var osname = (0, _platform.platform)();
var baseClassName = (0, _getClassName2.default)('Select');

var Select = function (_Component) {
  _inherits(Select, _Component);

  function Select(props) {
    _classCallCheck(this, Select);

    var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

    _this.onChange = function (e) {
      _this.setTitle();
      if (!_this.isControlledOutside) {
        _this.setState({ value: e.target.value });
      }
      if (_this.props.onChange) {
        _this.props.onChange(e);
      }
    };

    _this.setTitle = function () {
      var selectedOption = _this.selectEl.options[_this.selectEl.selectedIndex];
      selectedOption && _this.setState({
        title: selectedOption.text,
        notSelected: selectedOption.value === '' && _this.props.hasOwnProperty('placeholder')
      });
    };

    _this.getRef = function (el) {
      _this.selectEl = el;
      _this.props.getRef && _this.props.getRef(el);
    };

    var state = {
      title: '',
      notSelected: false
    };
    if (typeof props.value !== 'undefined') {
      _this.isControlledOutside = true;
    } else {
      state.value = props.defaultValue || '';
    }
    _this.state = state;
    return _this;
  }

  _createClass(Select, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value || prevProps.children !== this.props.children) {
        this.setTitle();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setTitle();
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          style = _props.style,
          label = _props.label,
          value = _props.value,
          defaultValue = _props.defaultValue,
          onChange = _props.onChange,
          alignment = _props.alignment,
          placeholder = _props.placeholder,
          children = _props.children,
          className = _props.className,
          getRef = _props.getRef,
          getRootRef = _props.getRootRef,
          restProps = _objectWithoutProperties(_props, ['style', 'label', 'value', 'defaultValue', 'onChange', 'alignment', 'placeholder', 'children', 'className', 'getRef', 'getRootRef']);

      return _react2.default.createElement(
        'label',
        {
          className: (0, _classnames3.default)(baseClassName, (_classnames = {}, _defineProperty(_classnames, 'Select--not-selected', this.state.notSelected), _defineProperty(_classnames, 'Select--align-' + alignment, alignment), _classnames), className),
          style: style,
          ref: getRootRef
        },
        _react2.default.createElement(
          'select',
          _extends({
            onChange: this.onChange,
            value: this.value,
            ref: this.getRef
          }, restProps),
          placeholder && _react2.default.createElement(
            'option',
            { value: '' },
            placeholder
          ),
          children
        ),
        _react2.default.createElement(
          'div',
          { className: 'Select__container' },
          _react2.default.createElement(
            'div',
            { className: 'Select__title' },
            this.state.title
          ),
          _react2.default.createElement(_dropdown2.default, null)
        ),
        osname === _platform.ANDROID && _react2.default.createElement('div', { className: 'Select-underline' })
      );
    }
  }, {
    key: 'value',
    get: function get() {
      return this.isControlledOutside ? this.props.value : this.state.value;
    }
  }]);

  return Select;
}(_react.Component);

Select.propTypes = {
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  label: _propTypes2.default.string,
  name: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  value: _propTypes2.default.any,
  defaultValue: _propTypes2.default.any,
  children: _propTypes2.default.node,
  placeholder: _propTypes2.default.string,
  getRef: _propTypes2.default.func,
  getRootRef: _propTypes2.default.func,
  alignment: _propTypes2.default.oneOf(['left', 'center', 'top'])
};
Select.defaultProps = {
  alignment: 'left'
};
exports.default = Select;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Tappable = __webpack_require__(5);

var _Tappable2 = _interopRequireDefault(_Tappable);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _platform = __webpack_require__(4);

var _done = __webpack_require__(22);

var _done2 = _interopRequireDefault(_done);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var osname = (0, _platform.platform)();
var baseClassName = (0, _getClassName2.default)('Checkbox');

var Checkbox = function Checkbox(_ref) {
  var children = _ref.children,
      className = _ref.className,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ['children', 'className', 'style', 'getRootRef']);

  return _react2.default.createElement(
    _Tappable2.default,
    {
      component: 'label',
      className: (0, _classnames2.default)(baseClassName, className),
      style: style,
      disabled: restProps.disabled,
      activeEffectDelay: osname === _platform.IOS ? 100 : _Tappable.ACTIVE_EFFECT_DELAY,
      getRootRef: getRootRef
    },
    _react2.default.createElement('input', _extends({}, restProps, { type: 'checkbox', className: 'Checkbox__input' })),
    _react2.default.createElement(
      'div',
      { className: 'Checkbox__container' },
      _react2.default.createElement(
        'div',
        { className: 'Checkbox__icon' },
        _react2.default.createElement(_done2.default, null)
      ),
      _react2.default.createElement(
        'div',
        { className: 'Checkbox__content' },
        children
      )
    )
  );
};

Checkbox.propTypes = {
  children: _propTypes2.default.node,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  getRootRef: _propTypes2.default.func
};

exports.default = Checkbox;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Tappable = __webpack_require__(5);

var _Tappable2 = _interopRequireDefault(_Tappable);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _platform = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var osname = (0, _platform.platform)();
var baseClassName = (0, _getClassName2.default)('Radio');

var Radio = function Radio(_ref) {
  var children = _ref.children,
      description = _ref.description,
      style = _ref.style,
      className = _ref.className,
      getRef = _ref.getRef,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ['children', 'description', 'style', 'className', 'getRef', 'getRootRef']);

  return _react2.default.createElement(
    _Tappable2.default,
    {
      component: 'label',
      style: style,
      className: (0, _classnames2.default)(baseClassName, className),
      activeEffectDelay: osname === _platform.IOS ? 100 : _Tappable.ACTIVE_EFFECT_DELAY,
      disabled: restProps.disabled,
      getRootRef: getRootRef
    },
    _react2.default.createElement('input', _extends({}, restProps, { type: 'radio', className: 'Radio__input', ref: getRef })),
    _react2.default.createElement(
      'div',
      { className: 'Radio__container' },
      _react2.default.createElement('div', { className: 'Radio__icon' }),
      _react2.default.createElement(
        'div',
        { className: 'Radio__content' },
        children,
        _react2.default.createElement(
          'div',
          { className: 'Radio__description' },
          description
        )
      )
    )
  );
};

Radio.propTypes = {
  children: _propTypes2.default.node,
  description: _propTypes2.default.node,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  getRef: _propTypes2.default.func,
  getRootRef: _propTypes2.default.func
};

exports.default = Radio;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _requestAnimationFrame = __webpack_require__(11);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _platform = __webpack_require__(4);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var osname = (0, _platform.platform)();
var baseClassName = (0, _getClassName2.default)('Textarea');

var Textarea = function (_Component) {
  _inherits(Textarea, _Component);

  function Textarea(props) {
    _classCallCheck(this, Textarea);

    var _this = _possibleConstructorReturn(this, (Textarea.__proto__ || Object.getPrototypeOf(Textarea)).call(this, props));

    _this.getRef = function (element) {
      _this.element = element;
      _this.props.getRef && _this.props.getRef(element);
    };

    _this.resize = function () {
      var el = _this.element;

      if (el) {
        var offsetHeight = el.offsetHeight,
            scrollHeight = el.scrollHeight;

        var style = window.getComputedStyle(el);
        var paddingTop = parseInt(style.paddingTop);
        var paddingBottom = parseInt(style.paddingBottom);

        var diff = paddingTop + paddingBottom;

        if (scrollHeight + diff <= offsetHeight) {
          diff = 0;
        }

        if (el.value) {
          _this.setState({ height: scrollHeight - diff });
        }

        _this.setState({ height: 0 }, function () {
          var height = el.scrollHeight - diff;

          _this.setState({ height: height });

          _this.props.onResize(el);
        });
      }
    };

    _this.onChange = function (e) {
      if (_this.props.grow) {
        _this.resize();
      }

      if (!_this.isControlledOutside) {
        _this.setState({ value: e.target.value });
      }

      if (_this.props.onChange) {
        _this.props.onChange(e);
      }
    };

    if (typeof props.value !== 'undefined') {
      _this.isControlledOutside = true;
      _this.state = {};
    } else {
      _this.state = {
        value: props.defaultValue || ''
      };
    }
    return _this;
  }

  _createClass(Textarea, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.grow) {
        this.resize();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (prevProps.value && this.props.value === '') {
        // Fix iOS extra indent on removing content
        (0, _requestAnimationFrame2.default)(function () {
          _this2.element.value = '';
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          defaultValue = _props.defaultValue,
          value = _props.value,
          onChange = _props.onChange,
          grow = _props.grow,
          style = _props.style,
          onResize = _props.onResize,
          className = _props.className,
          getRootRef = _props.getRootRef,
          restProps = _objectWithoutProperties(_props, ['defaultValue', 'value', 'onChange', 'grow', 'style', 'onResize', 'className', 'getRootRef']);

      var height = this.state.height || style.height || 66;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(baseClassName, className), style: style, ref: getRootRef },
        _react2.default.createElement('textarea', _extends({}, restProps, {
          value: this.value,
          onChange: this.onChange,
          ref: this.getRef,
          style: { height: height }
        })),
        osname === _platform.ANDROID && _react2.default.createElement('div', { className: 'Textarea-underline' })
      );
    }
  }, {
    key: 'value',
    get: function get() {
      return this.isControlledOutside ? this.props.value : this.state.value;
    }
  }]);

  return Textarea;
}(_react.Component);

Textarea.propTypes = {
  style: _propTypes2.default.object,
  value: _propTypes2.default.string,
  defaultValue: _propTypes2.default.string,
  grow: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  onResize: _propTypes2.default.func,
  className: _propTypes2.default.string,
  getRef: _propTypes2.default.func,
  getRootRef: _propTypes2.default.func
};
Textarea.defaultProps = {
  style: {},
  defaultValue: '',
  grow: true,
  onResize: function onResize() {}
};
exports.default = Textarea;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Touch = __webpack_require__(8);

var _Touch2 = _interopRequireDefault(_Touch);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _Slider2 = __webpack_require__(17);

var _Slider3 = _interopRequireDefault(_Slider2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var baseClassNames = (0, _getClassName2.default)('Slider');

var RangeSlider = function (_Slider) {
  _inherits(RangeSlider, _Slider);

  function RangeSlider() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RangeSlider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RangeSlider.__proto__ || Object.getPrototypeOf(RangeSlider)).call.apply(_ref, [this].concat(args))), _this), _this.onStart = function (e) {
      var absolutePosition = _this.validateAbsolute(e.startX - _this.state.containerLeft);
      var percentPosition = _this.absoluteToPecent(absolutePosition);
      var percentRange = _this.calcPercentRange(percentPosition);

      _this.onChange(_this.percentToValue(percentRange));

      if (_this.isControlledOutside) {
        _this.setState({ startX: absolutePosition });
      } else {
        _this.setState(_extends({
          startX: absolutePosition
        }, percentRange));
      }

      var thumb = e.originalEvent.target.closest('.Slider__thumb');

      if (thumb === _this.thumbStart) {
        _this.setState({ active: 'start' });
      } else if (thumb === _this.thumbEnd) {
        _this.setState({ active: 'end' });
      }
    }, _this.onMoveX = function (e) {
      var absolutePosition = _this.validateAbsolute(_this.state.startX + (e.shiftX || 0));
      var percentPosition = _this.absoluteToPecent(absolutePosition);
      var percentRange = _this.calcPercentRange(percentPosition);

      _this.onChange(_this.percentToValue(percentRange));

      if (!_this.isControlledOutside) {
        _this.setState(percentRange);
      }

      e.originalEvent.preventDefault();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RangeSlider, [{
    key: 'calcPercentRange',
    value: function calcPercentRange(percent) {
      var _state = this.state,
          percentStart = _state.percentStart,
          percentEnd = _state.percentEnd;


      if (percentStart === 100) {
        return { percentStart: percent, percentEnd: percentEnd };
      } else if (percentEnd === 0) {
        return { percentEnd: percent, percentStart: percentStart };
      } else if (Math.abs(percentStart - percent) <= Math.abs(percentEnd - percent)) {
        return { percentStart: percent, percentEnd: percentEnd };
      } else {
        return { percentEnd: percent, percentStart: percentStart };
      }
    }
  }, {
    key: 'validatePercent',
    value: function validatePercent(_ref2) {
      var percentStart = _ref2.percentStart,
          percentEnd = _ref2.percentEnd;

      return {
        percentStart: _get(RangeSlider.prototype.__proto__ || Object.getPrototypeOf(RangeSlider.prototype), 'validatePercent', this).call(this, percentStart),
        percentEnd: _get(RangeSlider.prototype.__proto__ || Object.getPrototypeOf(RangeSlider.prototype), 'validatePercent', this).call(this, percentEnd)
      };
    }
  }, {
    key: 'percentToValue',
    value: function percentToValue(_ref3) {
      var percentStart = _ref3.percentStart,
          percentEnd = _ref3.percentEnd;

      return [_get(RangeSlider.prototype.__proto__ || Object.getPrototypeOf(RangeSlider.prototype), 'percentToValue', this).call(this, percentStart), _get(RangeSlider.prototype.__proto__ || Object.getPrototypeOf(RangeSlider.prototype), 'percentToValue', this).call(this, percentEnd)];
    }
  }, {
    key: 'valueToPercent',
    value: function valueToPercent(_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
          valueStart = _ref5[0],
          valueEnd = _ref5[1];

      return {
        percentStart: _get(RangeSlider.prototype.__proto__ || Object.getPrototypeOf(RangeSlider.prototype), 'valueToPercent', this).call(this, valueStart),
        percentEnd: _get(RangeSlider.prototype.__proto__ || Object.getPrototypeOf(RangeSlider.prototype), 'valueToPercent', this).call(this, valueEnd)
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('resize', this.onResize);
      this.onResize(function () {
        _this2.setState(_this2.validatePercent(_this2.valueToPercent(_this2.value)));
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.isControlledOutside && nextProps.value !== this.props.value) {
        this.setState(this.validatePercent(this.valueToPercent(nextProps.value)));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          className = _props.className,
          min = _props.min,
          max = _props.max,
          step = _props.step,
          value = _props.value,
          defaultValue = _props.defaultValue,
          onChange = _props.onChange,
          getRootRef = _props.getRootRef,
          restProps = _objectWithoutProperties(_props, ['className', 'min', 'max', 'step', 'value', 'defaultValue', 'onChange', 'getRootRef']);

      return _react2.default.createElement(
        'div',
        _extends({}, restProps, { className: (0, _classnames2.default)(baseClassNames, className), ref: this.getRef }),
        _react2.default.createElement(
          _Touch2.default,
          { onStart: this.onStart, onMoveX: this.onMoveX, onEnd: this.onEnd, className: 'Slider__in' },
          _react2.default.createElement(
            'div',
            {
              className: 'Slider__dragger',
              style: {
                width: this.state.percentEnd - this.state.percentStart + '%',
                left: this.state.percentStart + '%'
              }
            },
            _react2.default.createElement('span', {
              className: (0, _classnames2.default)('Slider__thumb', 'Slider__thumb--start', {
                'Slider__thumb--active': this.state.active === 'start'
              }),
              ref: function ref(el) {
                return _this3.thumbStart = el;
              }
            }),
            _react2.default.createElement('span', {
              className: (0, _classnames2.default)('Slider__thumb', 'Slider__thumb--end', {
                'Slider__thumb--active': this.state.active === 'end'
              }),
              ref: function ref(el) {
                return _this3.thumbEnd = el;
              }
            })
          )
        )
      );
    }
  }, {
    key: 'value',
    get: function get() {
      if (this.isControlledOutside) {
        return this.props.value;
      } else if (this.props.hasOwnProperty('defaultValue')) {
        return this.props.defaultValue;
      } else {
        return [this.props.min, this.props.max];
      }
    }
  }]);

  return RangeSlider;
}(_Slider3.default);

RangeSlider.propTypes = _extends({}, _Slider3.default.propTypes, {
  value: _propTypes2.default.arrayOf(_propTypes2.default.number),
  defaultValue: _propTypes2.default.arrayOf(_propTypes2.default.number)
});
RangeSlider.defaultProps = _Slider3.default.defaultProps;
exports.default = RangeSlider;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _platform = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var osname = (0, _platform.platform)();
var baseClassName = (0, _getClassName2.default)('Input');

var Input = function (_Component) {
  _inherits(Input, _Component);

  function Input() {
    _classCallCheck(this, Input);

    return _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
  }

  _createClass(Input, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          alignment = _props.alignment,
          placeholder = _props.placeholder,
          status = _props.status,
          getRef = _props.getRef,
          className = _props.className,
          getRootRef = _props.getRootRef,
          restProps = _objectWithoutProperties(_props, ['alignment', 'placeholder', 'status', 'getRef', 'className', 'getRootRef']);

      var modifiers = _defineProperty({
        'Input--left': alignment === 'left',
        'Input--center': alignment === 'center',
        'Input--right': alignment === 'right'
      }, 'Input--s-' + this.props.status, true);

      var customPlaceolder = ['date', 'datetime-local', 'time', 'month'].indexOf(this.props.type) > -1 && this.context.isWebView ? this.props.placeholder : null;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(baseClassName, modifiers, className), ref: getRootRef },
        _react2.default.createElement('input', _extends({}, restProps, {
          className: 'Input__el',
          ref: getRef,
          placeholder: customPlaceolder ? null : this.props.placeholder
        })),
        osname === _platform.ANDROID && _react2.default.createElement('div', { className: 'Input-underline' }),
        customPlaceolder && !this.value && _react2.default.createElement(
          'div',
          { className: 'Input__placeholder' },
          this.props.placeholder
        )
      );
    }
  }]);

  return Input;
}(_react.Component);

Input.propTypes = {
  type: _propTypes2.default.oneOf(['text', 'password', 'date', 'datetime-local', 'time', 'month', 'email', 'number', 'tel', 'url']),
  alignment: _propTypes2.default.oneOf(['left', 'center', 'right']),
  value: _propTypes2.default.string,
  defaultValue: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  status: _propTypes2.default.oneOf(['default', 'error', 'verified']),
  getRef: _propTypes2.default.func,
  getRootRef: _propTypes2.default.func,
  className: _propTypes2.default.string
};
Input.defaultProps = {
  type: 'text',
  alignment: 'left',
  status: 'default'
};
Input.contextTypes = {
  isWebView: _propTypes2.default.bool
};
exports.default = Input;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _Button = __webpack_require__(25);

var _Button2 = _interopRequireDefault(_Button);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var baseClassNames = (0, _getClassName2.default)('File');

var File = function (_Component) {
  _inherits(File, _Component);

  function File(props) {
    _classCallCheck(this, File);

    var _this = _possibleConstructorReturn(this, (File.__proto__ || Object.getPrototypeOf(File)).call(this, props));

    _this.state = {
      value: null
    };
    return _this;
  }

  _createClass(File, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          label = _props.label,
          alignment = _props.alignment,
          align = _props.align,
          size = _props.size,
          level = _props.level,
          type = _props.type,
          stretched = _props.stretched,
          before = _props.before,
          className = _props.className,
          style = _props.style,
          getRef = _props.getRef,
          getRootRef = _props.getRootRef,
          restProps = _objectWithoutProperties(_props, ['children', 'label', 'alignment', 'align', 'size', 'level', 'type', 'stretched', 'before', 'className', 'style', 'getRef', 'getRootRef']);

      return _react2.default.createElement(
        _Button2.default,
        {
          align: align || alignment,
          className: (0, _classnames2.default)(baseClassNames, className),
          component: 'label',
          type: type,
          stretched: stretched,
          level: level,
          size: size,
          before: before,
          style: style,
          getRootRef: getRootRef
        },
        _react2.default.createElement('input', _extends({}, restProps, { className: 'File__input', type: 'file', ref: getRef })),
        children || label
      );
    }
  }]);

  return File;
}(_react.Component);

File.propTypes = {
  style: _propTypes2.default.object,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  /**
   * @ignore
   */
  level: _propTypes2.default.any,
  /**
   * @ignore
   */
  size: _propTypes2.default.any,
  /**
   * @ignore
   */
  type: _propTypes2.default.any,
  /**
   * @ignore
   */
  align: _propTypes2.default.any,
  /**
   * @ignore
   */
  stretched: _propTypes2.default.any,
  /**
   * @ignore
   */
  before: _propTypes2.default.any,
  getRef: _propTypes2.default.func,
  getRootRef: _propTypes2.default.func,
  /**
   * @deprecated Используйте `children`. Свойство `label` будет удалено в следующей мажорной версии.
   */
  label: _propTypes2.default.string,
  /**
   * @deprecated Используйте `align`. Свойство `alignment` будет удалено в следующей мажорной версии.
   */
  alignment: _propTypes2.default.oneOf(['left', 'center', 'right'])
};
File.defaultProps = {
  label: 'Выберите файл',
  children: 'Выберите файл',
  alignment: 'left',
  align: 'left'
};
exports.default = File;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var baseClassNames = (0, _getClassName2.default)('Switch');

var Switch = function Switch(_ref) {
  var style = _ref.style,
      className = _ref.className,
      getRef = _ref.getRef,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ['style', 'className', 'getRef', 'getRootRef']);

  return _react2.default.createElement(
    'label',
    { className: (0, _classnames2.default)(baseClassNames, className), style: style, ref: getRootRef },
    _react2.default.createElement('input', _extends({}, restProps, { type: 'checkbox', className: 'Switch__self', ref: getRef })),
    _react2.default.createElement('span', { className: 'Switch__pseudo' })
  );
};

Switch.propTypes = {
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  getRef: _propTypes2.default.func,
  getRootRef: _propTypes2.default.func
};

exports.default = Switch;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var baseClassNames = (0, _getClassName2.default)('FormLayoutGroup');

var FormLayoutGroup = function FormLayoutGroup(_ref) {
  var children = _ref.children,
      top = _ref.top,
      bottom = _ref.bottom,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, ['children', 'top', 'bottom', 'className']);

  return _react2.default.createElement(
    'div',
    _extends({ className: (0, _classnames2.default)(baseClassNames, className) }, restProps),
    children
  );
};

FormLayoutGroup.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  top: _propTypes2.default.node,
  bottom: _propTypes2.default.node
};

exports.default = FormLayoutGroup;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var baseClassName = (0, _getClassName2.default)('FormLayout');

var FormLayout = function (_React$Component) {
  _inherits(FormLayout, _React$Component);

  function FormLayout() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FormLayout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FormLayout.__proto__ || Object.getPrototypeOf(FormLayout)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (e) {
      return _this.props.onSubmit ? _this.props.onSubmit(e) : e.preventDefault();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FormLayout, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          TagName = _props.TagName,
          className = _props.className,
          getRef = _props.getRef,
          restProps = _objectWithoutProperties(_props, ['children', 'TagName', 'className', 'getRef']);

      var arrayChildren = Array.isArray(children) ? children : [children];

      return _react2.default.createElement(
        TagName,
        _extends({}, restProps, {
          className: (0, _classnames2.default)(baseClassName, className),
          onSubmit: this.onSubmit,
          ref: getRef
        }),
        _react2.default.createElement(
          'div',
          { className: 'FormLayout__container' },
          arrayChildren.map(function (field, i) {
            return field ? _react2.default.createElement(
              'div',
              { className: 'FormLayout__row', key: field.key || 'row-' + i },
              field.props.top && _react2.default.createElement(
                'div',
                { className: 'FormLayout__row-top' },
                field.props.top
              ),
              _react2.default.createElement(
                'div',
                { className: 'FormLayout__field' },
                field
              ),
              field.props.bottom && _react2.default.createElement(
                'div',
                { className: 'FormLayout__row-bottom' },
                field.props.bottom
              )
            ) : null;
          })
        ),
        TagName === 'form' && _react2.default.createElement('input', { type: 'submit', className: 'FormLayout__submit', value: '' })
      );
    }
  }]);

  return FormLayout;
}(_react2.default.Component);

FormLayout.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  TagName: _propTypes2.default.string,
  onSubmit: _propTypes2.default.func,
  getRef: _propTypes2.default.func
};
FormLayout.defaultProps = {
  status: 'default',
  TagName: 'form'
};
exports.default = FormLayout;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(2);

var _classnames3 = _interopRequireDefault(_classnames2);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _reactDom = __webpack_require__(34);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isElement = function isElement(element) {
  return _react2.default.isValidElement(element);
};
var isDOMTypeElement = function isDOMTypeElement(element) {
  return isElement(element) && typeof element.type === 'string';
};
var baseClassName = (0, _getClassName2.default)('Tooltip');

var TooltipPortal = function (_React$Component) {
  _inherits(TooltipPortal, _React$Component);

  function TooltipPortal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TooltipPortal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TooltipPortal.__proto__ || Object.getPrototypeOf(TooltipPortal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      x: 0,
      y: 0
    }, _this.fixedPortal = false, _this.getRef = function (el) {
      return _this.el = el;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TooltipPortal, [{
    key: 'findPortalTarget',
    value: function findPortalTarget() {
      var target = this.props.target;

      var closestFixed = target.closest('.FixedLayout');
      var closestHeader = target.closest('.PanelHeader__in');
      var closestPanel = this.document.getElementById(this.context.panel).childNodes[0];

      if (closestFixed || closestHeader) {
        this.fixedPortal = true;
      }

      return closestFixed || closestHeader || closestPanel;
    }
  }, {
    key: 'getBoundingTargetRect',
    value: function getBoundingTargetRect() {
      var target = this.props.target;

      var targetBounds = target.getBoundingClientRect();
      var portalBounds = this.portalTarget.getBoundingClientRect();

      return {
        width: targetBounds.width,
        height: targetBounds.height,
        x: targetBounds.x - portalBounds.x,
        y: targetBounds.y - portalBounds.y
      };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.portalTarget = this.findPortalTarget();
      this.document.addEventListener('click', this.props.onClose);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.document.removeEventListener('click', this.props.onClose);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          offsetY = _props.offsetY,
          offsetX = _props.offsetX,
          alignX = _props.alignX,
          alignY = _props.alignY;

      var coords = this.getBoundingTargetRect();

      this.setState({
        x: coords.x + offsetX + (alignX === 'right' ? coords.width - this.el.offsetWidth : 0),
        y: coords.y + (alignY === 'top' ? -this.el.offsetHeight - offsetY : coords.height + offsetY)
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var _props2 = this.props,
          title = _props2.title,
          text = _props2.text,
          alignX = _props2.alignX,
          alignY = _props2.alignY,
          cornerOffset = _props2.cornerOffset;


      return _reactDom2.default.createPortal(_react2.default.createElement(
        'div',
        { className: (0, _classnames3.default)(baseClassName, (_classnames = {}, _defineProperty(_classnames, 'Tooltip--x-' + alignX, true), _defineProperty(_classnames, 'Tooltip--y-' + alignY, true), _defineProperty(_classnames, 'Tooltip--fixed', this.fixedPortal), _classnames)) },
        _react2.default.createElement(
          'div',
          { className: 'Tooltip__container', style: { top: this.state.y, left: this.state.x }, ref: this.getRef },
          _react2.default.createElement('div', { className: 'Tooltip__corner', style: _defineProperty({}, alignX, 20 + cornerOffset) }),
          _react2.default.createElement(
            'div',
            { className: 'Tooltip__content' },
            title && _react2.default.createElement(
              'div',
              { className: 'Tooltip__title' },
              title
            ),
            text && _react2.default.createElement(
              'div',
              { className: 'Tooltip__text' },
              text
            )
          )
        )
      ), this.portalTarget);
    }
  }, {
    key: 'document',
    get: function get() {
      return this.context.document || document;
    }
  }]);

  return TooltipPortal;
}(_react2.default.Component);

TooltipPortal.propTypes = {
  target: _propTypes2.default.object,
  text: _propTypes2.default.node,
  title: _propTypes2.default.node,
  alignX: _propTypes2.default.oneOf(['left', 'right']),
  alignY: _propTypes2.default.oneOf(['top', 'bottom']),
  offsetX: _propTypes2.default.number,
  offsetY: _propTypes2.default.number,
  cornerOffset: _propTypes2.default.number,
  onClose: _propTypes2.default.func.isRequired
};
TooltipPortal.contextTypes = {
  document: _propTypes2.default.any,
  panel: _propTypes2.default.string
};

var Tooltip = function (_React$Component2) {
  _inherits(Tooltip, _React$Component2);

  function Tooltip() {
    var _ref3;

    var _temp2, _this2, _ret2;

    _classCallCheck(this, Tooltip);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref3 = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref3, [this].concat(args))), _this2), _this2.state = {
      ready: false
    }, _this2.getRef = function (el) {
      return _this2.targetEl = el;
    }, _temp2), _possibleConstructorReturn(_this2, _ret2);
  }

  _createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.targetEl && this.setState({ ready: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var _React$cloneElement;

      var _props3 = this.props,
          children = _props3.children,
          isShown = _props3.isShown,
          portalProps = _objectWithoutProperties(_props3, ['children', 'isShown']);

      var child = _react2.default.cloneElement(children, (_React$cloneElement = {}, _defineProperty(_React$cloneElement, isDOMTypeElement(children) ? 'ref' : 'getRootRef', this.getRef), _defineProperty(_React$cloneElement, 'key', 'c'), _React$cloneElement));

      if (!isShown || !this.state.ready) {
        return child;
      }

      return [child, _react2.default.createElement(TooltipPortal, _extends({}, portalProps, { target: this.targetEl, key: 't' }))];
    }
  }]);

  return Tooltip;
}(_react2.default.Component);

Tooltip.propTypes = {
  /**
   * **Важно**: если в `children` передан React-компонент, то необходимо убедиться в том, что он поддерживает
   * свойство `getRootRef`, которое должно возвращаться ссылку на корневой DOM-элемент компонента,
   * иначе тултип показан не будет. Если передан React-element, то такой проблемы нет.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * Если передан `false`, то рисуется просто `children`.
   */
  isShown: _propTypes2.default.bool.isRequired,
  /**
   * Текст тултипа.
   */
  text: _propTypes2.default.node,
  /**
   * Заголовок тултипа.
   */
  title: _propTypes2.default.node,
  /**
   * Положение по горизонтали (прижатие к левому или правому краю `children`).
   */
  alignX: _propTypes2.default.oneOf(['left', 'right']),
  /**
   * Положение по вертикали (расположение над или под `children`).
   */
  alignY: _propTypes2.default.oneOf(['top', 'bottom']),
  /**
   * Сдвиг по горизонтали (относительно портала, в котором рисуется тултип).
   */
  offsetX: _propTypes2.default.number,
  /**
   * Сдвиг по вертикали (относительно портала, в котором рисуется тултип).
   */
  offsetY: _propTypes2.default.number,
  /**
   * Сдвиг треугольника (относительно ширины тултипа).
   */
  cornerOffset: _propTypes2.default.number,
  /**
   * Callback, который вызывается при клике по любому месту в пределах экрана.
   */
  onClose: _propTypes2.default.func.isRequired
};
Tooltip.defaultProps = {
  offsetX: 0,
  offsetY: 15,
  alignX: 'left',
  alignY: 'bottom',
  cornerOffset: 0,
  isShown: true
};
exports.default = Tooltip;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var baseClassName = (0, _getClassName2.default)('Link');

var Link = function Link(_ref) {
  var children = _ref.children,
      className = _ref.className,
      Component = _ref.Component,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ['children', 'className', 'Component', 'getRootRef']);

  return _react2.default.createElement(
    Component,
    _extends({}, restProps, { ref: getRootRef, className: (0, _classnames2.default)(baseClassName, className) }),
    children
  );
};

Link.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  Component: _propTypes2.default.any,
  getRootRef: _propTypes2.default.func
};

Link.defaultProps = {
  Component: 'a'
};

exports.default = Link;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FixedLayout = __webpack_require__(12);

var _FixedLayout2 = _interopRequireDefault(_FixedLayout);

var _Tabs = __webpack_require__(18);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _platform = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var osname = (0, _platform.platform)();

/**
 * @deprecated этот компонент устарел и будет удален в следующей мажорной версии.
 * Для отрисовки фиксированных табов используйте связку `Tabs` и `FixedLayout`.
 */

var FixedTabs = function (_React$Component) {
  _inherits(FixedTabs, _React$Component);

  function FixedTabs() {
    _classCallCheck(this, FixedTabs);

    return _possibleConstructorReturn(this, (FixedTabs.__proto__ || Object.getPrototypeOf(FixedTabs)).apply(this, arguments));
  }

  _createClass(FixedTabs, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          vertical = _props.vertical,
          className = _props.className,
          style = _props.style,
          theme = _props.theme,
          children = _props.children;


      return _react2.default.createElement(
        _FixedLayout2.default,
        { vertical: vertical, className: className, style: style },
        _react2.default.createElement(
          _Tabs2.default,
          { theme: theme },
          children
        )
      );
    }
  }]);

  return FixedTabs;
}(_react2.default.Component);

FixedTabs.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  vertical: _propTypes2.default.oneOf(['top', 'bottom']),
  style: _propTypes2.default.object,
  /**
   * Значения white и gray устарели. Они будут удалены в следующей мажорной версии.
   * Для Android актуален только header
   */
  theme: _propTypes2.default.oneOf(['light', 'header']),
  /**
   * iOS only
   */
  type: _propTypes2.default.oneOf(['default', 'buttons'])
};
FixedTabs.defaultProps = {
  theme: osname === _platform.IOS ? 'light' : 'header',
  vertical: 'top'
};
exports.default = FixedTabs;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _Tappable = __webpack_require__(5);

var _Tappable2 = _interopRequireDefault(_Tappable);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _platform = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var osname = (0, _platform.platform)();
var baseClassName = (0, _getClassName2.default)('TabsItem');

var TabsItem = function (_React$Component) {
  _inherits(TabsItem, _React$Component);

  function TabsItem() {
    _classCallCheck(this, TabsItem);

    return _possibleConstructorReturn(this, (TabsItem.__proto__ || Object.getPrototypeOf(TabsItem)).apply(this, arguments));
  }

  _createClass(TabsItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          selected = _props.selected,
          className = _props.className,
          restProps = _objectWithoutProperties(_props, ['children', 'selected', 'className']);

      return _react2.default.createElement(
        _Tappable2.default,
        _extends({}, restProps, {
          className: (0, _classnames2.default)(baseClassName, { 'TabsItem--selected': selected }, className),
          activeEffectDelay: osname === _platform.IOS ? 0 : _Tappable.ACTIVE_EFFECT_DELAY
        }),
        _react2.default.createElement(
          'span',
          { className: 'TabsItem__in' },
          children
        )
      );
    }
  }]);

  return TabsItem;
}(_react2.default.Component);

TabsItem.propTypes = {
  children: _propTypes2.default.node,
  selected: _propTypes2.default.bool,
  className: _propTypes2.default.string
};
TabsItem.defaultProps = {
  selected: false
};
exports.default = TabsItem;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(7), __webpack_require__(6));
	else { var i, a; }
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 116);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _browserSymbol = __webpack_require__(2);

var _browserSymbol2 = _interopRequireDefault(_browserSymbol);

var _browserSprite = __webpack_require__(1);

var _browserSprite2 = _interopRequireDefault(_browserSprite);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var symbol = new _browserSymbol2.default({
  "id": "search_24",
  "use": "search_24-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"search_24\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><path d=\"M16.535 15.12l4.172 4.173a1 1 0 0 1-1.414 1.414l-4.172-4.172a7.25 7.25 0 1 1 1.414-1.414zM10.75 16a5.25 5.25 0 1 0 0-10.5 5.25 5.25 0 0 0 0 10.5z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = _browserSprite2.default.add(symbol);

var width = symbol.viewBox.split(' ')[2];
var height = symbol.viewBox.split(' ')[3];
var size = Math.max(width, height);

function SvgIcon(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ["className", "fill", "style", "getRootRef"]);

  return _react2.default.createElement(
    "div",
    _extends({}, restProps, {
      ref: getRootRef,
      className: 'Icon' + ' Icon--' + size + ' Icon--' + symbol.id + ' ' + (className || ''),
      style: _extends({}, style, { width: width + 'px', height: height + 'px' })
    }),
    _react2.default.createElement(
      "svg",
      { viewBox: symbol.viewBox, width: width, height: height, style: { display: 'block' } },
      _react2.default.createElement("use", { xlinkHref: '#' + symbol.id, style: { fill: 'currentColor', color: fill } })
    )
  );
}
exports.default = SvgIcon;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ })

/******/ });
});

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(7), __webpack_require__(6));
	else { var i, a; }
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 211);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _browserSymbol = __webpack_require__(2);

var _browserSymbol2 = _interopRequireDefault(_browserSymbol);

var _browserSprite = __webpack_require__(1);

var _browserSprite2 = _interopRequireDefault(_browserSprite);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var symbol = new _browserSymbol2.default({
  "id": "back_24",
  "use": "back_24-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"back_24\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M24 0H0v24h24z\" /><path d=\"M7.8 11l4.9-4.9a.99.99 0 0 0-1.4-1.4l-6.593 6.593a1 1 0 0 0 0 1.414L11.3 19.3a.99.99 0 0 0 1.4-1.4L7.8 13H20a1 1 0 0 0 0-2H7.8z\" fill=\"currentColor\" /></g></symbol>"
});
var result = _browserSprite2.default.add(symbol);

var width = symbol.viewBox.split(' ')[2];
var height = symbol.viewBox.split(' ')[3];
var size = Math.max(width, height);

function SvgIcon(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ["className", "fill", "style", "getRootRef"]);

  return _react2.default.createElement(
    "div",
    _extends({}, restProps, {
      ref: getRootRef,
      className: 'Icon' + ' Icon--' + size + ' Icon--' + symbol.id + ' ' + (className || ''),
      style: _extends({}, style, { width: width + 'px', height: height + 'px' })
    }),
    _react2.default.createElement(
      "svg",
      { viewBox: symbol.viewBox, width: width, height: height, style: { display: 'block' } },
      _react2.default.createElement("use", { xlinkHref: '#' + symbol.id, style: { fill: 'currentColor', color: fill } })
    )
  );
}
exports.default = SvgIcon;

/***/ })

/******/ });
});

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames2 = __webpack_require__(2);

var _classnames3 = _interopRequireDefault(_classnames2);

var _HeaderButton = __webpack_require__(32);

var _HeaderButton2 = _interopRequireDefault(_HeaderButton);

var _back = __webpack_require__(61);

var _back2 = _interopRequireDefault(_back);

var _cancel = __webpack_require__(21);

var _cancel2 = _interopRequireDefault(_cancel);

var _search = __webpack_require__(60);

var _search2 = _interopRequireDefault(_search);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var baseClassName = (0, _getClassName2.default)('Search');

var SearchAndroid = function (_React$Component) {
  _inherits(SearchAndroid, _React$Component);

  function SearchAndroid(props) {
    _classCallCheck(this, SearchAndroid);

    var _this = _possibleConstructorReturn(this, (SearchAndroid.__proto__ || Object.getPrototypeOf(SearchAndroid)).call(this, props));

    _this.onCancel = function () {
      if (!_this.isControlledOutside) {
        _this.setState({ value: '' });
      }
      if (_this.props.onChange) {
        _this.props.onChange('');
      }
      _this.inputEl.focus();
    };

    _this.onChange = function (e) {
      if (!_this.isControlledOutside) {
        _this.setState({ value: e.target.value });
      }
      if (_this.props.onChange) {
        _this.props.onChange(e.target.value, e);
      }
    };

    _this.inputRef = function (el) {
      _this.inputEl = el;
      _this.props.getRef && _this.props.getRef(el);
    };

    var state = {};

    if (props.hasOwnProperty('value')) {
      _this.isControlledOutside = true;
    } else {
      state.value = props.defaultValue || '';
    }

    _this.state = state;
    return _this;
  }

  _createClass(SearchAndroid, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.theme === 'header' && this.inputEl.focus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          getRef = _props.getRef,
          value = _props.value,
          defaultValue = _props.defaultValue,
          onChange = _props.onChange,
          onClose = _props.onClose,
          theme = _props.theme,
          inputProps = _objectWithoutProperties(_props, ['getRef', 'value', 'defaultValue', 'onChange', 'onClose', 'theme']);

      var className = (0, _classnames3.default)(baseClassName, (_classnames = {}, _defineProperty(_classnames, 'Search--' + theme, true), _defineProperty(_classnames, 'Search--focused', this.state.focused), _defineProperty(_classnames, 'Search--has-value', !!this.value), _classnames), this.props.className);

      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          'div',
          { className: 'Search__container' },
          _react2.default.createElement(
            'div',
            { className: 'Search__before' },
            theme === 'default' && _react2.default.createElement(_search2.default, null),
            theme === 'header' && _react2.default.createElement(
              _HeaderButton2.default,
              { onClick: onClose },
              _react2.default.createElement(_back2.default, null)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'Search__control' },
            _react2.default.createElement('input', _extends({}, inputProps, {
              className: 'Search__input',
              ref: this.inputRef,
              value: this.value,
              onChange: this.onChange
            }))
          ),
          !!this.value && _react2.default.createElement(
            'div',
            { className: 'Search__after' },
            theme === 'default' && _react2.default.createElement(_cancel2.default, { onClick: this.onCancel }),
            theme === 'header' && _react2.default.createElement(
              _HeaderButton2.default,
              { onClick: this.onCancel },
              _react2.default.createElement(_cancel2.default, null)
            )
          )
        )
      );
    }
  }, {
    key: 'value',
    get: function get() {
      return this.isControlledOutside ? this.props.value : this.state.value;
    }
  }]);

  return SearchAndroid;
}(_react2.default.Component);

SearchAndroid.propTypes = {
  className: _propTypes2.default.string,
  defaultValue: _propTypes2.default.string,
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onClose: _propTypes2.default.func,
  placeholder: _propTypes2.default.node,
  theme: _propTypes2.default.oneOf(['header', 'default']),
  getRef: _propTypes2.default.func
};
SearchAndroid.defaultProps = {
  placeholder: 'Поиск',
  theme: 'default'
};
exports.default = SearchAndroid;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(7), __webpack_require__(6));
	else { var i, a; }
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 225);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _browserSymbol = __webpack_require__(2);

var _browserSymbol2 = _interopRequireDefault(_browserSymbol);

var _browserSprite = __webpack_require__(1);

var _browserSprite2 = _interopRequireDefault(_browserSprite);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var symbol = new _browserSymbol2.default({
  "id": "search_16",
  "use": "search_16-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"search_16\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path d=\"M14.743 13.574L10.91 9.74a5.426 5.426 0 0 0 1.05-3.232A5.532 5.532 0 0 0 6.46 1 5.436 5.436 0 0 0 1 6.468a5.532 5.532 0 0 0 5.5 5.508 5.408 5.408 0 0 0 3.242-1.061l.004-.003 3.83 3.831a.826.826 0 1 0 1.167-1.169zm-8.247-2.696a4.425 4.425 0 0 1-4.4-4.406 4.35 4.35 0 0 1 4.368-4.374 4.426 4.426 0 0 1 4.4 4.406 4.35 4.35 0 0 1-4.368 4.374z\" fill=\"currentColor\" /></g></symbol>"
});
var result = _browserSprite2.default.add(symbol);

var width = symbol.viewBox.split(' ')[2];
var height = symbol.viewBox.split(' ')[3];
var size = Math.max(width, height);

function SvgIcon(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ["className", "fill", "style", "getRootRef"]);

  return _react2.default.createElement(
    "div",
    _extends({}, restProps, {
      ref: getRootRef,
      className: 'Icon' + ' Icon--' + size + ' Icon--' + symbol.id + ' ' + (className || ''),
      style: _extends({}, style, { width: width + 'px', height: height + 'px' })
    }),
    _react2.default.createElement(
      "svg",
      { viewBox: symbol.viewBox, width: width, height: height, style: { display: 'block' } },
      _react2.default.createElement("use", { xlinkHref: '#' + symbol.id, style: { fill: 'currentColor', color: fill } })
    )
  );
}
exports.default = SvgIcon;

/***/ })

/******/ });
});

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames2 = __webpack_require__(2);

var _classnames3 = _interopRequireDefault(_classnames2);

var _search = __webpack_require__(63);

var _search2 = _interopRequireDefault(_search);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var baseClassName = (0, _getClassName2.default)('Search');

var searchId = 0;

var SearchIOS = function (_React$Component) {
  _inherits(SearchIOS, _React$Component);

  function SearchIOS(props) {
    _classCallCheck(this, SearchIOS);

    var _this = _possibleConstructorReturn(this, (SearchIOS.__proto__ || Object.getPrototypeOf(SearchIOS)).call(this, props));

    _this.onFocus = function (e) {
      _this.setState({ focused: true });
      _this.props.onFocus && _this.props.onFocus(e);
    };

    _this.onBlur = function (e) {
      _this.setState({ focused: false });
      _this.props.onBlur && _this.props.onBlur(e);
    };

    _this.onChange = function (e) {
      if (!_this.isControlledOutside) {
        _this.setState({ value: e.target.value });
      }
      if (_this.props.onChange) {
        _this.props.onChange(e.target.value, e);
      }
    };

    _this.onCancel = function () {
      if (!_this.isControlledOutside) {
        _this.setState({ value: '' });
      }
      if (_this.props.onChange) {
        _this.props.onChange('');
      }
    };

    _this.inputRef = function (el) {
      return _this.props.getRef && _this.props.getRef(el);
    };

    var state = {
      showAfter: false,
      focused: false,
      placeholderOffset: null,
      afterWidth: null
    };

    if (props.hasOwnProperty('value')) {
      _this.isControlledOutside = true;
    } else {
      state.value = props.defaultValue || '';
    }
    searchId++;
    _this.state = state;
    return _this;
  }

  _createClass(SearchIOS, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          theme = _props.theme,
          onFocus = _props.onFocus,
          onBlur = _props.onBlur,
          onChange = _props.onChange,
          defaultValue = _props.defaultValue,
          value = _props.value,
          placeholder = _props.placeholder,
          after = _props.after,
          getRef = _props.getRef,
          inputProps = _objectWithoutProperties(_props, ['className', 'theme', 'onFocus', 'onBlur', 'onChange', 'defaultValue', 'value', 'placeholder', 'after', 'getRef']);

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames3.default)(baseClassName, (_classnames = {}, _defineProperty(_classnames, 'Search--' + theme, true), _defineProperty(_classnames, 'Search--focused', this.state.focused), _defineProperty(_classnames, 'Search--has-value', this.value), _defineProperty(_classnames, 'Search--has-after', after), _classnames), className) },
        _react2.default.createElement(
          'div',
          { className: 'Search__in' },
          _react2.default.createElement('div', { className: 'Search__width' }),
          _react2.default.createElement(
            'div',
            { className: 'Search__control' },
            _react2.default.createElement('input', _extends({}, inputProps, {
              id: 'search-' + searchId,
              ref: this.inputRef,
              type: 'text',
              className: 'Search__input',
              onFocus: this.onFocus,
              onBlur: this.onBlur,
              onChange: this.onChange,
              value: this.value
            })),
            after && _react2.default.createElement(
              'div',
              { className: 'Search__after-width' },
              after
            ),
            _react2.default.createElement(
              'label',
              {
                className: 'Search__placeholder',
                htmlFor: 'search-' + searchId
              },
              _react2.default.createElement(
                'div',
                { className: 'Search__placeholder-in' },
                _react2.default.createElement(_search2.default, null),
                _react2.default.createElement('div', { className: 'Search__placeholder-text', dangerouslySetInnerHTML: { __html: placeholder } })
              )
            )
          ),
          after && _react2.default.createElement(
            'div',
            { className: 'Search__after', onClick: this.onCancel },
            _react2.default.createElement(
              'div',
              { className: 'Search__after-in' },
              after
            )
          )
        )
      );
    }
  }, {
    key: 'value',
    get: function get() {
      return this.isControlledOutside ? this.props.value : this.state.value;
    }
  }]);

  return SearchIOS;
}(_react2.default.Component);

SearchIOS.propTypes = {
  className: _propTypes2.default.string,
  after: _propTypes2.default.node,
  defaultValue: _propTypes2.default.string,
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  placeholder: _propTypes2.default.node,
  theme: _propTypes2.default.oneOf(['header', 'default']),
  getRef: _propTypes2.default.func
};
SearchIOS.defaultProps = {
  after: 'Отменить',
  theme: 'default',
  placeholder: 'Поиск'
};
exports.default = SearchIOS;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _platform = __webpack_require__(4);

var _SearchIOS = __webpack_require__(64);

var _SearchIOS2 = _interopRequireDefault(_SearchIOS);

var _SearchAndroid = __webpack_require__(62);

var _SearchAndroid2 = _interopRequireDefault(_SearchAndroid);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var osname = (0, _platform.platform)();

var Search = function (_React$Component) {
  _inherits(Search, _React$Component);

  function Search() {
    _classCallCheck(this, Search);

    return _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).apply(this, arguments));
  }

  _createClass(Search, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onClose = _props.onClose,
          iosProps = _objectWithoutProperties(_props, ['onClose']);

      var _props2 = this.props,
          after = _props2.after,
          before = _props2.before,
          androidProps = _objectWithoutProperties(_props2, ['after', 'before']);

      if (osname === _platform.IOS) {
        return _react2.default.createElement(_SearchIOS2.default, iosProps);
      } else {
        return _react2.default.createElement(_SearchAndroid2.default, androidProps);
      }
    }
  }]);

  return Search;
}(_react2.default.Component);

Search.propTypes = {
  className: _propTypes2.default.string,
  getRef: _propTypes2.default.func,
  /**
   * iOS only. Текст кнопки "отмена", которая чистит текстовое поле и убирает фокус.
   */
  after: _propTypes2.default.node,
  /**
   * iOS only
   */
  before: _propTypes2.default.node,
  theme: _propTypes2.default.oneOf(['header', 'default']),

  /**
   * Android only. Вызывается при клике по стрелке (слева). Этот контрол служит для выхода из режима поиска.
   */
  onClose: _propTypes2.default.func,

  /**
   * **Важно:** в коллбэк первым аргументом прилетает *значение* текстового поля.
   * Объект события передается вторым аргументом.
   */
  onChange: _propTypes2.default.func,
  autoComplete: _propTypes2.default.string
};
Search.defaultProps = {
  theme: 'default',
  autoComplete: 'off'
};
exports.default = Search;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var baseClassName = (0, _getClassName2.default)('Progress');

var Progress = function Progress(_ref) {
  var value = _ref.value,
      className = _ref.className,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ['value', 'className', 'getRootRef']);

  return _react2.default.createElement(
    'div',
    _extends({}, restProps, { ref: getRootRef, className: (0, _classnames2.default)(baseClassName, className) }),
    _react2.default.createElement('div', { className: 'Progress__bg' }),
    _react2.default.createElement('div', { className: 'Progress__in', style: { width: value + '%' } })
  );
};

Progress.propTypes = {
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,
  value: _propTypes2.default.number,
  getRootRef: _propTypes2.default.func
};

Progress.defaultProps = {
  value: 0
};

exports.default = Progress;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _Touch = __webpack_require__(8);

var _Touch2 = _interopRequireDefault(_Touch);

var _classnames3 = __webpack_require__(2);

var _classnames4 = _interopRequireDefault(_classnames3);

var _requestAnimationFrame = __webpack_require__(11);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var baseClassNames = (0, _getClassName2.default)('Gallery');

var Gallery = function (_Component) {
  _inherits(Gallery, _Component);

  function Gallery(props) {
    _classCallCheck(this, Gallery);

    var _this = _possibleConstructorReturn(this, (Gallery.__proto__ || Object.getPrototypeOf(Gallery)).call(this, props));

    _initialiseProps.call(_this);

    var current = typeof props.slideIndex === 'number' ? props.slideIndex : props.initialSlideIndex;

    _this.state = {
      containerWidth: 0,
      current: current,
      deltaX: 0,
      shiftX: 0,
      slides: [],
      animation: false,
      duration: 0.24
    };

    _this.slides = _this.getChildren(props.children);
    return _this;
  }

  _createClass(Gallery, [{
    key: 'initializeSlides',
    value: function initializeSlides() {
      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

      var slides = this.getSlidesCoords();
      var containerWidth = this.container.offsetWidth;
      var viewportWidth = this.viewport.offsetWidth;
      var layerWidth = slides.reduce(function (val, slide) {
        return slide.width + val;
      }, 0);
      var min = this.calcMin({ containerWidth: containerWidth, layerWidth: layerWidth, viewportWidth: viewportWidth });
      var max = 0;

      this.setState({ min: min, max: max, layerWidth: layerWidth, containerWidth: containerWidth, slides: slides }, callback);
    }
  }, {
    key: 'calcMin',
    value: function calcMin(_ref) {
      var containerWidth = _ref.containerWidth,
          layerWidth = _ref.layerWidth,
          viewportWidth = _ref.viewportWidth;

      switch (this.props.align) {
        case 'left':
          return containerWidth - layerWidth;
        case 'right':
          return viewportWidth - layerWidth;
        case 'center':
          return viewportWidth - (containerWidth - viewportWidth) / 2 - layerWidth;
      }
    }

    /**
     * Получает координаты и размеры каждого слайда
      * @returns {Array} Массив с объектами, описывающими габариты слайда
     */

  }, {
    key: 'getSlidesCoords',
    value: function getSlidesCoords() {
      var _this2 = this;

      return [].concat(this.props.children).reduce(function (acc, item, i) {
        if (item) {
          var elem = _this2.slidesStore['slide-' + i];
          var res = {
            coordX: elem.offsetLeft,
            width: elem.offsetWidth,
            id: item.props.id
          };

          acc.push(res);
        }

        return acc;
      }, []);
    }

    /**
     * Считает отступ слоя галереи во время драга
     *
     * @returns {Number} Значения отступа
     */

  }, {
    key: 'calculateDragIndent',
    value: function calculateDragIndent() {
      var _state = this.state,
          shiftX = _state.shiftX,
          deltaX = _state.deltaX,
          min = _state.min,
          max = _state.max;

      var indent = shiftX + deltaX;
      if (indent > max) {
        return max + Number((indent - max) / 3);
      } else if (indent < min) {
        return min + Number((indent - min) / 3);
      }

      return indent;
    }

    /**
     * Считает отступ слоя галереи
     *
     * @param {Number} targetIndex ID целевого слайда
     * @returns {Number} Значения отступа
     */

  }, {
    key: 'calculateIndent',
    value: function calculateIndent(targetIndex) {
      var slides = this.state.slides;


      if (!this.isDraggable()) {
        return 0;
      }

      var coordX = slides.length ? slides[targetIndex].coordX : 0;
      return this.validateIndent(-1 * coordX);
    }
  }, {
    key: 'validateIndent',
    value: function validateIndent(value) {
      var _state2 = this.state,
          min = _state2.min,
          max = _state2.max;


      if (value < min) {
        return min;
      } else if (value > max) {
        return max;
      }

      return value;
    }
  }, {
    key: 'isDraggable',
    value: function isDraggable() {
      return this.state.layerWidth > this.state.containerWidth;
    }

    /**
     * Получает индекс слайда, к которому будет осуществлен переход
     *
     * @returns {Number} Индекс слайда
     */

  }, {
    key: 'getTarget',
    value: function getTarget() {
      var _state3 = this.state,
          slides = _state3.slides,
          current = _state3.current,
          deltaX = _state3.deltaX,
          shiftX = _state3.shiftX,
          startT = _state3.startT;

      var expectDeltaX = deltaX / (new Date() - startT) * 240 * 0.6;
      var shift = shiftX + deltaX + expectDeltaX;
      var direction = deltaX < 0 ? 1 : -1;

      // Находим ближайшую границу слайда к текущему отступу
      var targetIndex = slides.reduce(function (val, item, index) {
        var previousValue = Math.abs(slides[val].coordX + shift);
        var currentValue = Math.abs(item.coordX + shift);

        return previousValue < currentValue ? val : index;
      }, current);

      if (targetIndex === current) {
        var targetSlide = current + direction;

        if (targetSlide >= 0 && targetSlide < slides.length) {
          if (Math.abs(deltaX) > slides[targetSlide].width * 0.05) {
            targetIndex = targetSlide;
          }
        }
      }

      return targetIndex;
    }
  }, {
    key: 'getChildren',
    value: function getChildren(children) {
      return [].concat(children || this.props.children).reduce(this.reduceChildren, []);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      this.initializeSlides(function () {
        _this3.setState({
          shiftX: _this3.calculateIndent(_this3.state.current)
        });
      });
      window.addEventListener('resize', this.onResize);

      if (this.props.autoplay) {
        this.setTimeout(this.props.autoplay);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.isChildrenDirty) {
        this.isChildrenDirty = false;
        this.initializeSlides();
      }
      if (prevState.current !== this.state.current && this.props.onChange) {
        this.props.onChange(this.state.current);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.slides = this.getChildren(nextProps.children);
      this.isChildrenDirty = true;

      if (nextProps.autoplay && !this.props.autoplay) {
        if (nextProps.autoplay) {
          this.setTimeout(nextProps.autoplay);
        }
      }
      if (!nextProps.autoplay && this.props.autoplay) {
        this.clearTimeout();
      }
      if (nextProps.slideIndex !== this.props.slideIndex && typeof nextProps.slideIndex === 'number') {
        this.go(nextProps.slideIndex);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
      this.clearTimeout();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state4 = this.state,
          animation = _state4.animation,
          duration = _state4.duration,
          current = _state4.current,
          dragging = _state4.dragging;

      var _props = this.props,
          children = _props.children,
          slideWidth = _props.slideWidth,
          autoplay = _props.autoplay,
          initialSlideIndex = _props.initialSlideIndex,
          slideIndex = _props.slideIndex,
          onDragStart = _props.onDragStart,
          onDragEnd = _props.onDragEnd,
          onChange = _props.onChange,
          onEnd = _props.onEnd,
          align = _props.align,
          bullets = _props.bullets,
          className = _props.className,
          restProps = _objectWithoutProperties(_props, ['children', 'slideWidth', 'autoplay', 'initialSlideIndex', 'slideIndex', 'onDragStart', 'onDragEnd', 'onChange', 'onEnd', 'align', 'bullets', 'className']);

      var indent = dragging ? this.calculateDragIndent() : this.calculateIndent(current);
      var layerStyle = {
        WebkitTransform: 'translateX(' + indent + 'px)',
        transform: 'translateX(' + indent + 'px)',
        WebkitTransition: animation ? '-webkit-transform ' + duration + 's cubic-bezier(.1, 0, .25, 1)' : 'none',
        transition: animation ? 'transform ' + duration + 's cubic-bezier(.1, 0, .25, 1)' : 'none'
      };

      return _react2.default.createElement(
        'div',
        _extends({}, restProps, { className: (0, _classnames4.default)(baseClassNames, className, _defineProperty({
            'Gallery--dragging': dragging
          }, 'Gallery--' + this.props.align, true)), ref: this.getContainerRef }),
        _react2.default.createElement(
          _Touch2.default,
          {
            className: 'Gallery__viewport',
            onStartX: this.onStart,
            onMoveX: this.onMoveX,
            onEnd: this.onEnd,
            style: { width: slideWidth },
            ref: this.getViewportRef
          },
          _react2.default.createElement(
            'div',
            { className: 'Gallery__layer', style: layerStyle },
            this.slides
          )
        ),
        this.props.bullets && _react2.default.createElement(
          'div',
          { className: (0, _classnames4.default)('Gallery__bullets', _defineProperty({}, 'Gallery__bullets--' + this.props.bullets, true)) },
          this.slides.map(function (item, index) {
            return _react2.default.createElement('div', { className: (0, _classnames4.default)('Gallery__bullet', { 'Gallery__bullet--active': index === current }), key: index });
          })
        )
      );
    }
  }]);

  return Gallery;
}(_react.Component);

Gallery.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  slideWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  autoplay: _propTypes2.default.number,
  initialSlideIndex: _propTypes2.default.number,
  slideIndex: _propTypes2.default.number,
  onDragStart: _propTypes2.default.func,
  onDragEnd: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onEnd: _propTypes2.default.func,
  align: _propTypes2.default.oneOf(['left', 'center', 'right']),
  bullets: _propTypes2.default.oneOf(['dark', 'light', false])
};
Gallery.defaultProps = {
  slideWidth: '100%',
  children: '',
  autoplay: 0,
  initialSlideIndex: 0,
  align: 'left',
  bullets: false
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.slidesStore = {};

  this.go = function (targetIndex) {
    _this4.setState({
      animation: true,
      shiftX: _this4.calculateIndent(targetIndex),
      current: targetIndex
    });

    if (_this4.timeout) {
      _this4.clearTimeout();
      _this4.setTimeout(_this4.props.autoplay);
    }
  };

  this.onStart = function (e) {
    _this4.setState({
      animation: false,
      startT: e.startT
    });
  };

  this.onMoveX = function (e) {
    if (!_this4.isDraggable()) {
      return;
    }

    e.originalEvent.preventDefault();

    if (e.isSlideX) {
      _this4.props.onDragStart && _this4.props.onDragStart();
      if (_this4.state.deltaX !== e.shiftX || _this4.state.dragging !== e.isSlideX) {
        _this4.setState({
          deltaX: e.shiftX,
          dragging: e.isSlideX
        });
      }

      return true;
    }
  };

  this.onEnd = function (e) {
    var targetIndex = e.isSlide ? _this4.getTarget() : _this4.state.current;
    _this4.props.onDragEnd && _this4.props.onDragEnd();

    _this4.setState({
      shiftX: _this4.calculateIndent(targetIndex),
      deltaX: 0,
      animation: true,
      current: targetIndex,
      duration: '.24'
    });

    if (_this4.props.onEnd) {
      _this4.props.onEnd({
        targetIndex: targetIndex
      });
    }

    if (_this4.timeout) {
      _this4.clearTimeout();
      _this4.setTimeout(_this4.props.autoplay);
    }

    return true;
  };

  this.onResize = function () {
    _this4.initializeSlides();

    var layerWidth = _this4.state.layerWidth;

    var containerWidth = _this4.container.offsetWidth;
    var viewportWidth = _this4.viewport.offsetWidth;

    _this4.setState({
      shiftX: _this4.calculateIndent(_this4.state.current),
      containerWidth: containerWidth,
      min: _this4.calcMin({ layerWidth: layerWidth, containerWidth: containerWidth, viewportWidth: viewportWidth }),
      animation: false
    }, function () {
      (0, _requestAnimationFrame2.default)(function () {
        return _this4.setState({ animation: true });
      });
    });
  };

  this.setTimeout = function (duration) {
    _this4.timeout = setTimeout(function () {
      var _state5 = _this4.state,
          slides = _state5.slides,
          current = _state5.current;

      var targetIndex = current < slides.length - 1 ? current + 1 : 0;

      _this4.go(targetIndex);
    }, duration);
  };

  this.clearTimeout = function () {
    clearTimeout(_this4.timeout);
  };

  this.reduceChildren = function (acc, item, i) {
    if (item) {
      var ref = _this4.getSlideRef(i);
      acc.push(_react2.default.createElement(
        'div',
        { className: 'Gallery__slide', key: 'slide-' + i, ref: ref },
        item
      ));
    }

    return acc;
  };

  this.getContainerRef = function (container) {
    _this4.container = container;
  };

  this.getViewportRef = function (viewport) {
    _this4.viewport = viewport ? viewport.container : {};
  };

  this.getSlideRef = function (id) {
    return function (slide) {
      _this4.slidesStore['slide-' + id] = slide;
    };
  };
};

exports.default = Gallery;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _Avatar = __webpack_require__(19);

var _Avatar2 = _interopRequireDefault(_Avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var baseClassNames = (0, _getClassName2.default)('Entity');

// @TODO Try to load photo
/**
 * @deprecated этот компонент устарел и будет удален в следующей мажорной версии.
 * Используйте `Cell`.
 */

var Entity = function (_Component) {
  _inherits(Entity, _Component);

  function Entity() {
    _classCallCheck(this, Entity);

    return _possibleConstructorReturn(this, (Entity.__proto__ || Object.getPrototypeOf(Entity)).apply(this, arguments));
  }

  _createClass(Entity, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          style = _props.style,
          photo = _props.photo,
          title = _props.title,
          description = _props.description,
          avatarProps = _props.avatarProps,
          children = _props.children;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(baseClassNames, className), style: style },
        _react2.default.createElement(
          'div',
          { className: 'Entity__aside' },
          _react2.default.createElement(_Avatar2.default, _extends({ src: photo, alt: title, size: this.avatarSize }, avatarProps))
        ),
        _react2.default.createElement(
          'div',
          { className: 'Entity__main' },
          title && _react2.default.createElement(
            'div',
            { className: 'Entity__title' },
            title
          ),
          description && _react2.default.createElement(
            'div',
            { className: 'Entity__description' },
            description
          ),
          children && _react2.default.createElement(
            'div',
            { className: 'Entity__content' },
            children
          )
        )
      );
    }
  }, {
    key: 'avatarSize',
    get: function get() {
      switch (this.props.size) {
        case 'm':
          return 64;
        case 's':
          return 48;
        default:
          return this.props.size;
      }
    }
  }]);

  return Entity;
}(_react.Component);

Entity.propTypes = {
  style: _propTypes2.default.object,
  /**
   * @deprecated
   * Use avatarProps.size instead
   */
  size: _propTypes2.default.oneOf(['m', 's', 80, 72, 64, 56, 48, 40, 36, 32, 28]),
  photo: _propTypes2.default.string,
  title: _propTypes2.default.node,
  description: _propTypes2.default.node,
  className: _propTypes2.default.string,
  avatarProps: _propTypes2.default.shape(_Avatar2.default.propTypes),
  children: _propTypes2.default.node
};
Entity.defaultProps = {
  size: 48,
  photo: '',
  title: '',
  description: ''
};
exports.default = Entity;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var baseClassName = (0, _getClassName2.default)('InfoRow');

var InfoRow = function InfoRow(_ref) {
  var title = _ref.title,
      className = _ref.className,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ['title', 'className', 'children']);

  return _react2.default.createElement(
    'div',
    _extends({}, restProps, { className: (0, _classnames2.default)(baseClassName, className) }),
    title && _react2.default.createElement(
      'div',
      { className: 'InfoRow__title' },
      title
    ),
    children && _react2.default.createElement(
      'div',
      null,
      children
    )
  );
};

InfoRow.propTypes = {
  title: _propTypes2.default.node.isRequired,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object
};

exports.default = InfoRow;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Div = __webpack_require__(20);

var _Div2 = _interopRequireDefault(_Div);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Footer = function Footer(_ref) {
  var className = _ref.className,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ['className', 'children']);

  return _react2.default.createElement(
    _Div2.default,
    _extends({}, restProps, { className: (0, _classnames2.default)('Footer', className) }),
    children
  );
};

Footer.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object
};

exports.default = Footer;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(7), __webpack_require__(6));
	else { var i, a; }
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 125);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _browserSymbol = __webpack_require__(2);

var _browserSymbol2 = _interopRequireDefault(_browserSymbol);

var _browserSprite = __webpack_require__(1);

var _browserSprite2 = _interopRequireDefault(_browserSprite);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var symbol = new _browserSymbol2.default({
  "id": "reorder_ios_24",
  "use": "reorder_ios_24-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"reorder_ios_24\"><g fill=\"none\" fill-rule=\"evenodd\"><path opacity=\".1\" d=\"M0 0h24v24H0z\" /><path d=\"M2.75 7h18.5a.75.75 0 1 1 0 1.5H2.75a.75.75 0 0 1 0-1.5zm0 4h18.5a.75.75 0 1 1 0 1.5H2.75a.75.75 0 1 1 0-1.5zm0 4h18.5a.75.75 0 1 1 0 1.5H2.75a.75.75 0 1 1 0-1.5z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = _browserSprite2.default.add(symbol);

var width = symbol.viewBox.split(' ')[2];
var height = symbol.viewBox.split(' ')[3];
var size = Math.max(width, height);

function SvgIcon(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ["className", "fill", "style", "getRootRef"]);

  return _react2.default.createElement(
    "div",
    _extends({}, restProps, {
      ref: getRootRef,
      className: 'Icon' + ' Icon--' + size + ' Icon--' + symbol.id + ' ' + (className || ''),
      style: _extends({}, style, { width: width + 'px', height: height + 'px' })
    }),
    _react2.default.createElement(
      "svg",
      { viewBox: symbol.viewBox, width: width, height: height, style: { display: 'block' } },
      _react2.default.createElement("use", { xlinkHref: '#' + symbol.id, style: { fill: 'currentColor', color: fill } })
    )
  );
}
exports.default = SvgIcon;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ })

/******/ });
});

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(7), __webpack_require__(6));
	else { var i, a; }
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 126);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _browserSymbol = __webpack_require__(2);

var _browserSymbol2 = _interopRequireDefault(_browserSymbol);

var _browserSprite = __webpack_require__(1);

var _browserSprite2 = _interopRequireDefault(_browserSprite);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var symbol = new _browserSymbol2.default({
  "id": "reorder_24",
  "use": "reorder_24-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"reorder_24\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h24v24H0z\" /><path d=\"M21 18a1 1 0 0 1-1 1H4a1 1 0 0 1 0-2h16a1 1 0 0 1 1 1zm0-4a1 1 0 0 1-1 1H4a1 1 0 0 1 0-2h16a1 1 0 0 1 1 1zm0-4a1 1 0 0 1-1 1H4a1 1 0 0 1 0-2h16a1 1 0 0 1 1 1zM3 6a1 1 0 0 1 1-1h16a1 1 0 0 1 0 2H4a1 1 0 0 1-1-1z\" fill=\"currentColor\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = _browserSprite2.default.add(symbol);

var width = symbol.viewBox.split(' ')[2];
var height = symbol.viewBox.split(' ')[3];
var size = Math.max(width, height);

function SvgIcon(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ["className", "fill", "style", "getRootRef"]);

  return _react2.default.createElement(
    "div",
    _extends({}, restProps, {
      ref: getRootRef,
      className: 'Icon' + ' Icon--' + size + ' Icon--' + symbol.id + ' ' + (className || ''),
      style: _extends({}, style, { width: width + 'px', height: height + 'px' })
    }),
    _react2.default.createElement(
      "svg",
      { viewBox: symbol.viewBox, width: width, height: height, style: { display: 'block' } },
      _react2.default.createElement("use", { xlinkHref: '#' + symbol.id, style: { fill: 'currentColor', color: fill } })
    )
  );
}
exports.default = SvgIcon;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ })

/******/ });
});

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(7), __webpack_require__(6));
	else { var i, a; }
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 205);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _browserSymbol = __webpack_require__(2);

var _browserSymbol2 = _interopRequireDefault(_browserSymbol);

var _browserSprite = __webpack_require__(1);

var _browserSprite2 = _interopRequireDefault(_browserSprite);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var symbol = new _browserSymbol2.default({
  "id": "chevron_24",
  "use": "chevron_24-usage",
  "viewBox": "0 0 16 24",
  "content": "<symbol viewBox=\"0 0 16 24\" id=\"chevron_24\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v24H0z\" /><path d=\"M4.706 7.706a1 1 0 0 1 0-1.412l.088-.088a.997.997 0 0 1 1.414.002l5.084 5.084a.998.998 0 0 1 0 1.416l-5.084 5.084a1.002 1.002 0 0 1-1.414.002l-.088-.088a.995.995 0 0 1 0-1.412L9 12 4.706 7.706z\" fill=\"currentColor\" /></g></symbol>"
});
var result = _browserSprite2.default.add(symbol);

var width = symbol.viewBox.split(' ')[2];
var height = symbol.viewBox.split(' ')[3];
var size = Math.max(width, height);

function SvgIcon(_ref) {
  var className = _ref.className,
      fill = _ref.fill,
      style = _ref.style,
      getRootRef = _ref.getRootRef,
      restProps = _objectWithoutProperties(_ref, ["className", "fill", "style", "getRootRef"]);

  return _react2.default.createElement(
    "div",
    _extends({}, restProps, {
      ref: getRootRef,
      className: 'Icon' + ' Icon--' + size + ' Icon--' + symbol.id + ' ' + (className || ''),
      style: _extends({}, style, { width: width + 'px', height: height + 'px' })
    }),
    _react2.default.createElement(
      "svg",
      { viewBox: symbol.viewBox, width: width, height: height, style: { display: 'block' } },
      _react2.default.createElement("use", { xlinkHref: '#' + symbol.id, style: { fill: 'currentColor', color: fill } })
    )
  );
}
exports.default = SvgIcon;

/***/ })

/******/ });
});

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(2);

var _classnames3 = _interopRequireDefault(_classnames2);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _Tappable = __webpack_require__(5);

var _Tappable2 = _interopRequireDefault(_Tappable);

var _Touch = __webpack_require__(8);

var _Touch2 = _interopRequireDefault(_Touch);

var _platform = __webpack_require__(4);

var _chevron = __webpack_require__(73);

var _chevron2 = _interopRequireDefault(_chevron);

var _done = __webpack_require__(22);

var _done2 = _interopRequireDefault(_done);

var _cancel = __webpack_require__(21);

var _cancel2 = _interopRequireDefault(_cancel);

var _reorder = __webpack_require__(72);

var _reorder2 = _interopRequireDefault(_reorder);

var _reorder_ios = __webpack_require__(71);

var _reorder_ios2 = _interopRequireDefault(_reorder_ios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var osname = (0, _platform.platform)();
var baseClassNames = (0, _getClassName2.default)('Cell');

var Cell = function (_Component) {
  _inherits(Cell, _Component);

  function Cell() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Cell);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Cell.__proto__ || Object.getPrototypeOf(Cell)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isRemoveActivated: false,
      removeOffset: 0,
      dragging: false
    }, _this.onClick = function (e) {
      var _this$props = _this.props,
          removable = _this$props.removable,
          onClick = _this$props.onClick;

      if (e.target.tagName.toLowerCase() === 'input') {
        e.stopPropagation();
      } else if (removable) {
        return null;
      } else {
        onClick && onClick(e);
      }
    }, _this.activateRemove = function () {
      _this.setState({ isRemoveActivated: true });
      _this.document.addEventListener('click', _this.deactivateRemove);
    }, _this.deactivateRemove = function () {
      _this.setState({ isRemoveActivated: false, removeOffset: 0 });
      _this.document.removeEventListener('click', _this.deactivateRemove);
    }, _this.onRemoveClick = function (e) {
      e.nativeEvent.stopImmediatePropagation();
      e.preventDefault();
      _this.props.onRemove && _this.props.onRemove(e, _this.rootEl);
    }, _this.getRemoveRef = function (el) {
      return _this.removeButton = el;
    }, _this.getRootRef = function (el) {
      _this.rootEl = el;
      _this.props.getRootRef && _this.props.getRootRef(el);
    }, _this.onDragStart = function () {
      _this.setState({ dragging: true });
      _this.dragShift = 0;
      _this.listEl = _this.rootEl.closest('.List');
      _this.listEl && _this.listEl.classList.add('List--dragging');
      _this.siblings = Array.prototype.slice.call(_this.rootEl.parentElement.childNodes);
      _this.dragStartIndex = _this.siblings.indexOf(_this.rootEl);
    }, _this.onDragMove = function (e) {
      e.originalEvent.preventDefault();
      _this.rootEl.style.transform = 'translateY(' + e.shiftY + 'px)';
      var rootGesture = _this.rootEl.getBoundingClientRect();
      _this.dragDirection = _this.dragShift - e.shiftY < 0 ? 'down' : 'up';
      _this.dragShift = e.shiftY;
      _this.dragEndIndex = _this.dragStartIndex;

      _this.siblings.forEach(function (sibling, siblingIndex) {
        var siblingGesture = sibling.getBoundingClientRect();
        if (_this.dragStartIndex < siblingIndex) {
          if (rootGesture.bottom > siblingGesture.top + siblingGesture.height / 2) {
            if (_this.dragDirection === 'down') sibling.style.transform = 'translateY(-100%)';
            _this.dragEndIndex++;
          }
          if (rootGesture.top < siblingGesture.bottom - siblingGesture.height / 2 && _this.dragDirection === 'up') {
            sibling.style.transform = 'translateY(0)';
          }
        } else if (_this.dragStartIndex > siblingIndex) {
          if (rootGesture.top < siblingGesture.bottom - siblingGesture.height / 2) {
            if (_this.dragDirection === 'up') sibling.style.transform = 'translateY(100%)';
            _this.dragEndIndex--;
          }
          if (rootGesture.bottom > siblingGesture.top + siblingGesture.height / 2 && _this.dragDirection === 'down') {
            sibling.style.transform = 'translateY(0)';
          }
        }
      });
    }, _this.onDragEnd = function () {
      _this.setState({ dragging: false });
      _this.listEl && _this.listEl.classList.remove('List--dragging');
      _this.props.onDragFinish && _this.props.onDragFinish({ from: _this.dragStartIndex, to: _this.dragEndIndex });
      _this.siblings.forEach(function (sibling) {
        return sibling.style.transform = null;
      });
      delete _this.dragShift;
      delete _this.listEl;
      delete _this.siblings;
      delete _this.dragStartIndex;
      delete _this.dragEndIndex;
      delete _this.dragDirection;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Cell, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.document.removeEventListener('click', this.deactivateRemove);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.isRemoveActivated !== this.state.isRemoveActivated && this.state.isRemoveActivated) {
        this.setState({ removeOffset: this.removeButton.offsetWidth });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          before = _props.before,
          indicator = _props.indicator,
          asideContent = _props.asideContent,
          expandable = _props.expandable,
          onClick = _props.onClick,
          children = _props.children,
          getRootRef = _props.getRootRef,
          description = _props.description,
          selectable = _props.selectable,
          multiline = _props.multiline,
          className = _props.className,
          onRemove = _props.onRemove,
          removable = _props.removable,
          removePlaceholder = _props.removePlaceholder,
          draggable = _props.draggable,
          onDragFinish = _props.onDragFinish,
          href = _props.href,
          size = _props.size,
          bottomContent = _props.bottomContent,
          restProps = _objectWithoutProperties(_props, ['before', 'indicator', 'asideContent', 'expandable', 'onClick', 'children', 'getRootRef', 'description', 'selectable', 'multiline', 'className', 'onRemove', 'removable', 'removePlaceholder', 'draggable', 'onDragFinish', 'href', 'size', 'bottomContent']);

      selectable = selectable && !draggable;

      var rootProps = selectable ? {} : restProps;
      var inputProps = selectable ? restProps : {};
      var linkProps = href ? restProps : {};

      return _react2.default.createElement(
        'div',
        _extends({}, rootProps, {
          onClick: href || draggable ? null : this.onClick,
          className: (0, _classnames3.default)(baseClassNames, (_classnames = {
            'Cell--expandable': expandable,
            'Cell--multiline': multiline
          }, _defineProperty(_classnames, 'Cell--' + size, size), _defineProperty(_classnames, 'Cell--dragging', this.state.dragging), _defineProperty(_classnames, 'Cell--draggable', draggable), _classnames), className),
          ref: this.getRootRef
        }),
        _react2.default.createElement(
          _Tappable2.default,
          _extends({}, linkProps, {
            onClick: href ? this.onClick : null,
            component: selectable ? 'label' : href ? 'a' : 'div',
            className: 'Cell__in',
            href: href,
            disabled: !selectable && !onClick && !href || removable || draggable,
            style: removable ? { transform: 'translateX(-' + this.state.removeOffset + 'px)' } : null
          }),
          selectable && _react2.default.createElement('input', _extends({}, inputProps, { type: 'checkbox', className: 'Cell__checkbox' })),
          _react2.default.createElement(
            'div',
            { className: 'Cell__before' },
            selectable && osname === _platform.IOS && _react2.default.createElement(
              'div',
              { className: 'Cell__checkbox-marker' },
              _react2.default.createElement(_done2.default, null)
            ),
            removable && osname === _platform.IOS && _react2.default.createElement('div', { className: 'Cell__remove-marker', onClick: this.activateRemove }),
            osname === _platform.ANDROID && draggable && _react2.default.createElement(
              _Touch2.default,
              {
                onStart: this.onDragStart,
                onMoveY: this.onDragMove,
                onEnd: this.onDragEnd,
                className: 'Cell__dragger'
              },
              _react2.default.createElement(_reorder2.default, null)
            ),
            before && _react2.default.createElement(
              'div',
              { className: 'Cell__before-in' },
              before
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'Cell__main' },
            _react2.default.createElement(
              'div',
              { className: 'Cell__children' },
              children
            ),
            description && _react2.default.createElement(
              'div',
              { className: 'Cell__description' },
              description
            ),
            size === 'l' && bottomContent && _react2.default.createElement(
              'div',
              { className: 'Cell__bottom' },
              bottomContent
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'Cell__indicator' },
            indicator
          ),
          _react2.default.createElement(
            'div',
            { className: 'Cell__aside' },
            asideContent,
            selectable && osname === _platform.ANDROID && _react2.default.createElement(
              'div',
              { className: 'Cell__checkbox-marker' },
              _react2.default.createElement(_done2.default, null)
            ),
            removable && osname === _platform.ANDROID && _react2.default.createElement(
              'div',
              { className: 'Cell__remove-marker', onClick: this.onRemoveClick },
              _react2.default.createElement(_cancel2.default, null)
            ),
            osname === _platform.IOS && expandable && !draggable && _react2.default.createElement(_chevron2.default, { className: 'Cell__chevron' }),
            osname === _platform.IOS && draggable && _react2.default.createElement(
              _Touch2.default,
              {
                className: 'Cell__dragger',
                onStart: this.onDragStart,
                onMoveY: this.onDragMove,
                onEnd: this.onDragEnd
              },
              _react2.default.createElement(_reorder_ios2.default, null)
            )
          )
        ),
        removable && osname === _platform.IOS && _react2.default.createElement(
          'div',
          {
            ref: this.getRemoveRef,
            className: 'Cell__remove',
            onClick: this.onRemoveClick,
            style: removable ? { transform: 'translateX(-' + this.state.removeOffset + 'px)' } : null
          },
          _react2.default.createElement(
            'span',
            { className: 'Cell__remove-in' },
            removePlaceholder
          )
        )
      );
    }
  }, {
    key: 'document',
    get: function get() {
      return this.context.document || document;
    }

    /**
     * предотвращает двойное срабатывание в случае с input
     * (https://github.com/vuejs/vue/issues/3699#issuecomment-247957931)
     * предотвращает клик в случае, когда включен режим removable
     * @param e
     */

  }]);

  return Cell;
}(_react.Component);

Cell.propTypes = {
  /**
   * Контейнер для контента от `children`.
   */
  before: _propTypes2.default.node,
  /**
   * Контейнер для текста справа от `children`.
   */
  indicator: _propTypes2.default.node,
  /**
   * Контейнер для контента справа от `children` и `indicator`.
   */
  asideContent: _propTypes2.default.node,
  /**
   * Выставляйте этот флаг, если клик по ячейке вызывает переход на другую панель. Флаг нужен для корректной
   * стилизации такой ячейки.
   */
  expandable: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  onClick: _propTypes2.default.func,
  /**
   * Добавляет возможность переноса содержимого `children` и `description`. Без этого флага текст будет уходить
   * в троеточие.
   */
  multiline: _propTypes2.default.bool,
  /**
   * Контейнер для дополнительного содержимого под `children`.
   */
  description: _propTypes2.default.node,
  getRootRef: _propTypes2.default.func,
  /**
   * Контейнер для произвольного содержимого под `description`. Рисуется только если передать `size="l"`.
   */
  bottomContent: _propTypes2.default.node,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  /**
   * Размер влияет на выравнивание блоков по вертикали, вид сепаратора (iOS) и возможность вставлять `bottomContent`.
   */
  size: _propTypes2.default.oneOf(['m', 'l']),
  /**
   * Флаг для перехода в режим ячеек-чекбоксов.
   * **Важно:** в этом режиме обработчик `onClick` вызываться не будет.
   * **Важно:** этот режим несовместим с `draggable`. В случае истинности двух этих флагов, приоритет отдается
   * `draggable`.
   */
  selectable: _propTypes2.default.bool,
  /**
   * Флаг для перехода в режим удаляемых ячеек. **Важно:** в этом режиме обработчик `onClick` вызываться не будет.
   */
  removable: _propTypes2.default.bool,
  /**
   * Коллбэк срабатывает при клике на контрол удаления.
   */
  onRemove: _propTypes2.default.func,
  /**
   * iOS only. Текст в выезжаеющей кнопке для удаления ячейки.
   */
  removePlaceholder: _propTypes2.default.node,
  /**
   * Флаг для перехода в режим перетаскивания. **Важно:** в этом режиме обработчик `onClick` вызываться не будет.
   */
  draggable: _propTypes2.default.bool,
  /**
   * Коллбэк срабатывает при завершении перетаскивания.
   * **Важно:** режим перетаскивания не меняет порядок ячеек в DOM. В коллбэке есть объект с полями `from` и `to`.
   * Эти числа нужны для того, чтобы разработчик понимал, с какого индекса на какой произошел переход. В песочнице
   * есть рабочий пример с обработкой этих чисел и перерисовкой списка.
   */
  onDragFinish: _propTypes2.default.func,
  /**
   * При передаче `href`, ячейка становится полноценной ссылкой. Поддерживаются все валидные для этого элемента
   * атрибуты (`target`, `rel` и т.д.).
   */
  href: _propTypes2.default.string
};
Cell.defaultProps = {
  before: null,
  indicator: '',
  asideContent: '',
  bottomContent: null,
  expandable: false,
  children: '',
  selectable: false,
  multiline: false,
  removable: false,
  size: 'm',
  removePlaceholder: 'Удалить'
};
Cell.contextTypes = {
  document: _propTypes2.default.any
};
exports.default = Cell;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var baseClassNames = (0, _getClassName2.default)('List');

var List = function List(_ref) {
  var className = _ref.className,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ['className', 'children']);

  return _react2.default.createElement(
    'div',
    _extends({}, restProps, { className: (0, _classnames2.default)(baseClassNames, className) }),
    children
  );
};

List.propTypes = {
  style: _propTypes2.default.object,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string
};
List.defaultProps = {
  style: {},
  children: ''
};

exports.default = List;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Header = __webpack_require__(23);

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var baseClassNames = (0, _getClassName2.default)('Group');

var Group = function (_Component) {
  _inherits(Group, _Component);

  function Group() {
    _classCallCheck(this, Group);

    return _possibleConstructorReturn(this, (Group.__proto__ || Object.getPrototypeOf(Group)).apply(this, arguments));
  }

  _createClass(Group, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          description = _props.description,
          className = _props.className,
          children = _props.children,
          getRootRef = _props.getRootRef,
          restProps = _objectWithoutProperties(_props, ['title', 'description', 'className', 'children', 'getRootRef']);

      return _react2.default.createElement(
        'div',
        _extends({}, restProps, { ref: getRootRef, className: (0, _classnames2.default)(baseClassNames, className) }),
        title && _react2.default.createElement(
          _Header2.default,
          { level: '2' },
          title
        ),
        children && _react2.default.createElement(
          'div',
          { className: 'Group__content' },
          children
        ),
        description && _react2.default.createElement(
          'div',
          { className: 'Group__description' },
          description
        )
      );
    }
  }]);

  return Group;
}(_react.Component);

Group.propTypes = {
  style: _propTypes2.default.object,
  title: _propTypes2.default.node,
  description: _propTypes2.default.node,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  getRootRef: _propTypes2.default.func
};
Group.defaultProps = {
  title: null,
  description: null
};
exports.default = Group;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IOS_PART_HEIGHT = 0.275;

var IosSpinner = function (_Component) {
  _inherits(IosSpinner, _Component);

  function IosSpinner(props) {
    _classCallCheck(this, IosSpinner);

    var _this = _possibleConstructorReturn(this, (IosSpinner.__proto__ || Object.getPrototypeOf(IosSpinner)).call(this, props));

    var c = 0.5 * props.size;
    var r = Math.max(Math.floor(props.size * 0.075), 2);
    var ty = Math.ceil(-0.5 * (1 - IOS_PART_HEIGHT) * props.size);

    var iosStyles = [];

    for (var i = 0; i < 12; i++) {
      iosStyles.push({
        transform: 'rotate(' + i * 30 + ', ' + c + ', ' + c + ') translate(0 ' + ty + ')',
        rx: r,
        ry: r,
        style: {
          animationDelay: Math.round(props.duration / 12 * 100 * (-11 + i)) / 100 + 's'
        }
      });
    }

    _this.state = { iosStyles: iosStyles };
    return _this;
  }

  _createClass(IosSpinner, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          on = _props.on,
          progress = _props.progress;
      var iosStyles = this.state.iosStyles;


      var parts = iosStyles;

      if (!on) {
        parts = iosStyles.slice(0, Math.round(progress / (100 / 12)));
      }

      return parts.map(function (item, i) {
        return _react2.default.createElement('rect', _extends({
          x: '46.25%',
          y: '36.25%',
          width: '7.5%',
          height: '27.5%',
          className: 'Spinner__part'
        }, item, {
          key: 'spinner-part-' + i
        }));
      });
    }
  }]);

  return IosSpinner;
}(_react.Component);

IosSpinner.propTypes = {
  size: _propTypes2.default.number,
  duration: _propTypes2.default.number,
  on: _propTypes2.default.bool,
  progress: _propTypes2.default.number
};
IosSpinner.defaultProps = {
  size: 20,
  duration: 1.4,
  on: true,
  progress: null
};
exports.default = IosSpinner;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _keyframes = __webpack_require__(26);

var _keyframes2 = _interopRequireDefault(_keyframes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AndroidSpinner = function (_Component) {
  _inherits(AndroidSpinner, _Component);

  function AndroidSpinner(props) {
    _classCallCheck(this, AndroidSpinner);

    var _this = _possibleConstructorReturn(this, (AndroidSpinner.__proto__ || Object.getPrototypeOf(AndroidSpinner)).call(this, props));

    var id = Math.round(Math.random() * 1e6).toString(16);
    var offset = Math.round(Math.PI * props.size);
    var c = 0.5 * props.size;

    _this.state = {
      c: c,
      id: id,
      offset: offset,
      animation: (0, _keyframes2.default)('dash' + id, {
        '0%': {
          'stroke-dashoffset': offset
        },
        '50%': {
          'stroke-dashoffset': Math.round(0.25 * offset),
          'transform': 'rotate(135deg)'
        },
        '100%': {
          'stroke-dashoffset': offset,
          'transform': 'rotate(360deg)'
        }
      })
    };
    return _this;
  }

  _createClass(AndroidSpinner, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          size = _props.size,
          on = _props.on,
          progress = _props.progress,
          duration = _props.duration,
          strokeWidth = _props.strokeWidth;
      var _state = this.state,
          id = _state.id,
          offset = _state.offset,
          animation = _state.animation;


      var dashoffset = offset;
      var transform = '';

      if (!on) {
        dashoffset = Math.abs(0.02 * (progress - 50) * 0.75 * offset) + 0.25 * offset;

        if (progress <= 50) {
          transform = 'rotate(' + Math.round(progress * 135 / 50) + 'deg)';
        } else {
          transform = 'rotate(' + (135 + Math.round((progress - 50) * 360 / 50)) + 'deg)';
        }
      }

      return _react2.default.createElement(
        'g',
        {
          style: {
            width: size,
            height: size,
            transformOrigin: 0.5 * size + 'px ' + 0.5 * size + 'px',
            transform: transform
          }
        },
        _react2.default.createElement('style', { dangerouslySetInnerHTML: { __html: animation } }),
        _react2.default.createElement('circle', {
          className: 'Spinner__path',
          fill: 'none',
          strokeDasharray: offset,
          strokeDashoffset: dashoffset,
          strokeWidth: strokeWidth,
          style: {
            animationName: on ? 'dash' + id : 'none',
            animationTimingFunction: 'ease-in-out',
            animationDuration: duration + 's',
            animationIterationCount: 'infinite'
          },
          cx: 0.5 * size,
          cy: 0.5 * size,
          r: 0.5 * size - 0.5 * strokeWidth
        })
      );
    }
  }]);

  return AndroidSpinner;
}(_react.Component);

AndroidSpinner.propTypes = {
  size: _propTypes2.default.number,
  strokeWidth: _propTypes2.default.number,
  duration: _propTypes2.default.number,
  on: _propTypes2.default.bool,
  progress: _propTypes2.default.number
};
AndroidSpinner.defaultProps = {
  size: 38,
  strokeWidth: 4,
  duration: 1.4,
  on: true,
  progress: null
};
exports.default = AndroidSpinner;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ScreenSpinner;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Spinner = __webpack_require__(27);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _PopoutWrapper = __webpack_require__(10);

var _PopoutWrapper2 = _interopRequireDefault(_PopoutWrapper);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var baseClassName = (0, _getClassName2.default)('ScreenSpinner');

function ScreenSpinner(_ref) {
  var style = _ref.style,
      className = _ref.className,
      restProps = _objectWithoutProperties(_ref, ['style', 'className']);

  return _react2.default.createElement(
    _PopoutWrapper2.default,
    { className: (0, _classnames2.default)(baseClassName, className), style: style },
    _react2.default.createElement(_Spinner2.default, restProps)
  );
}

ScreenSpinner.propTypes = {
  className: _propTypes2.default.string,
  style: _propTypes2.default.object
};

ScreenSpinner.defaultProps = {};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.brToNl = brToNl;
function brToNl() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var regex = /<br\s*\/?>/gi;

  return str.replace(regex, '\n');
}

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _removeObjectKeys = __webpack_require__(13);

var _removeObjectKeys2 = _interopRequireDefault(_removeObjectKeys);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Alert = __webpack_require__(30);

var _Alert2 = _interopRequireDefault(_Alert);

var _ActionSheet = __webpack_require__(29);

var _ActionSheet2 = _interopRequireDefault(_ActionSheet);

var _ActionSheetItem = __webpack_require__(28);

var _ActionSheetItem2 = _interopRequireDefault(_ActionSheetItem);

var _string = __webpack_require__(80);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var actionId = 1;

var NativePopouts = function (_React$Component) {
  _inherits(NativePopouts, _React$Component);

  function NativePopouts() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NativePopouts);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NativePopouts.__proto__ || Object.getPrototypeOf(NativePopouts)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      popout: null
    }, _this.actions = [], _this.actionsStore = {}, _this.vkuiListener = function (e) {
      if (e.type === 'VKWebAppEvent' && e.detail && e.detail.action) {
        if (_this.actionsStore.hasOwnProperty(e.detail.action)) {
          _this.actionsStore[e.detail.action](e.detail);
          _this.props.popout && _this.props.popout.onClose && _this.props.popout.onClose();
        }
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NativePopouts, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.vkuiConnect.subscribe(this.vkuiListener);
      if (this.props.popout) {
        this.renderPopout(this.props);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.vkuiConnect.unsubscribe(this.vkuiListener);
    }
  }, {
    key: 'renderNativeAlert',
    value: function renderNativeAlert(popout) {
      var style = popout.style,
          title = popout.title,
          message = popout.text;

      this.props.vkuiConnect.send('VKWebAppAlert', {
        style: style,
        title: (0, _string.brToNl)(title),
        message: (0, _string.brToNl)(message),
        actions: this.actions.map(function (item) {
          return (0, _removeObjectKeys2.default)(item, ['action']);
        })
      });
    }
  }, {
    key: 'renderUIAlert',
    value: function renderUIAlert(popout) {
      var title = popout.title,
          text = popout.text,
          onClose = popout.onClose,
          actionsLayout = popout.actionsLayout;

      this.setState({
        popout: _react2.default.createElement(
          _Alert2.default,
          {
            actions: this.actions.map(function (item) {
              return (0, _removeObjectKeys2.default)(item, ['params']);
            }),
            onClose: onClose,
            actionsLayout: actionsLayout
          },
          title && _react2.default.createElement(
            'h2',
            null,
            title
          ),
          text && _react2.default.createElement(
            'p',
            null,
            text
          )
        )
      });
    }
  }, {
    key: 'renderNativeSheet',
    value: function renderNativeSheet(popout) {
      var style = popout.style;

      this.props.vkuiConnect.send('VKWebAppAlert', {
        style: style,
        actions: this.actions.map(function (item) {
          return (0, _removeObjectKeys2.default)(item, ['action']);
        })
      });
    }
  }, {
    key: 'renderUISheet',
    value: function renderUISheet(popout) {
      var title = popout.title,
          text = popout.text,
          onClose = popout.onClose;

      this.setState({
        popout: _react2.default.createElement(
          _ActionSheet2.default,
          { title: title, text: text, onClose: onClose },
          this.actions.map(function (item, index) {
            return _react2.default.createElement(
              _ActionSheetItem2.default,
              { autoclose: item.autoclose, theme: item.style, onClick: item.action, key: '' + index },
              item.title
            );
          })
        )
      });
    }
  }, {
    key: 'closeUIPopout',
    value: function closeUIPopout() {
      this.setState({ popout: null });
    }
  }, {
    key: 'renderPopout',
    value: function renderPopout(props) {
      if (props.popout.style) {
        this.actions = props.popout.actions.map(function (item) {
          return Object.assign({}, item, {
            autoclose: item.hasOwnProperty('autoclose') ? item.autoclose : true,
            action: item.action || props.popout.onClose,
            handler: Object.assign({}, item.params, { action: 'action-' + actionId++ })
          });
        });

        this.actionsStore = this.actions.reduce(function (res, item) {
          res[item.handler.action] = item.action;return res;
        }, {});

        switch (props.popout.style) {
          case 'alert':
            this.context.isWebView ? this.renderNativeAlert(props.popout) : this.renderUIAlert(props.popout);
            break;
          case 'actionSheet':
            this.context.isWebView ? this.renderNativeSheet(props.popout) : this.renderUISheet(props.popout);
            break;
        }
      } else {
        this.setState({ popout: props.popout });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!nextProps.popout && this.props.popout) {
        this.closeUIPopout();
      }
      if (nextProps.popout && nextProps.popout !== this.props.popout) {
        this.context.isWebView && this.closeUIPopout();
        this.renderPopout(nextProps);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var Component = this.props.component;
      return _react2.default.createElement(Component, _extends({}, (0, _removeObjectKeys2.default)(this.props, ['popout']), { popout: this.state.popout }));
    }
  }]);

  return NativePopouts;
}(_react2.default.Component);

NativePopouts.propTypes = {
  popout: _propTypes2.default.oneOfType([_propTypes2.default.shape({
    style: _propTypes2.default.oneOf(['alert', 'actionSheet']).isRequired,
    title: _propTypes2.default.string,
    text: _propTypes2.default.string,
    onClose: _propTypes2.default.func.isRequired,
    actions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      style: _propTypes2.default.oneOf(['cancel', 'default', 'destructive']),
      title: _propTypes2.default.string,
      action: _propTypes2.default.func
    }))
  }), _propTypes2.default.element]),
  vkuiConnect: _propTypes2.default.object.isRequired,
  /**
   * Root or View
   */
  component: _propTypes2.default.func.isRequired
};
NativePopouts.contextTypes = {
  isWebView: _propTypes2.default.bool
};
exports.default = NativePopouts;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HorizontalScroll = function (_React$Component) {
  _inherits(HorizontalScroll, _React$Component);

  function HorizontalScroll() {
    _classCallCheck(this, HorizontalScroll);

    return _possibleConstructorReturn(this, (HorizontalScroll.__proto__ || Object.getPrototypeOf(HorizontalScroll)).apply(this, arguments));
  }

  _createClass(HorizontalScroll, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          restProps = _objectWithoutProperties(_props, ['children', 'className']);

      return _react2.default.createElement(
        'div',
        _extends({}, restProps, { className: (0, _classnames2.default)('HorizontalScroll', className) }),
        _react2.default.createElement(
          'div',
          { className: 'HorizontalScroll__in' },
          children
        )
      );
    }
  }]);

  return HorizontalScroll;
}(_react2.default.Component);

HorizontalScroll.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object
};
exports.default = HorizontalScroll;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var baseClassName = (0, _getClassName2.default)('InnerScroll');

var InnerScroll = function (_React$Component) {
  _inherits(InnerScroll, _React$Component);

  function InnerScroll() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InnerScroll);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InnerScroll.__proto__ || Object.getPrototypeOf(InnerScroll)).call.apply(_ref, [this].concat(args))), _this), _this.onScroll = function (e) {
      if (_this.el.scrollTop <= 0) {
        _this.el.scrollTop = 1;
      } else if (_this.el.scrollTop >= _this.el.scrollHeight - _this.el.offsetHeight) {
        _this.el.scrollTop = _this.el.scrollHeight - _this.el.offsetHeight - 1;
      }

      _this.props.onScroll && _this.props.onScroll(e);
    }, _this.ref = function (el) {
      return _this.el = el;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InnerScroll, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.el.scrollTop = 1;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          onScroll = _props.onScroll,
          restProps = _objectWithoutProperties(_props, ['className', 'children', 'onScroll']);

      return _react2.default.createElement(
        'div',
        _extends({}, restProps, {
          className: (0, _classnames2.default)(baseClassName, className),
          onScroll: this.onScroll,
          ref: this.getRef
        }),
        children
      );
    }
  }]);

  return InnerScroll;
}(_react2.default.Component);

InnerScroll.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  style: _propTypes2.default.object,
  onScroll: _propTypes2.default.func
};
exports.default = InnerScroll;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var baseClassName = (0, _getClassName2.default)('TabbarItem');

var TabbarItem = function (_React$Component) {
  _inherits(TabbarItem, _React$Component);

  function TabbarItem() {
    _classCallCheck(this, TabbarItem);

    return _possibleConstructorReturn(this, (TabbarItem.__proto__ || Object.getPrototypeOf(TabbarItem)).apply(this, arguments));
  }

  _createClass(TabbarItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          selected = _props.selected,
          label = _props.label,
          restProps = _objectWithoutProperties(_props, ['className', 'children', 'selected', 'label']);

      return _react2.default.createElement(
        'div',
        _extends({}, restProps, { className: (0, _classnames2.default)(baseClassName, className, {
            'TabbarItem--selected': selected
          }) }),
        _react2.default.createElement(
          'div',
          { className: 'TabbarItem__in' },
          children,
          label && _react2.default.createElement(
            'span',
            { className: 'TabbarItem__label' },
            label
          )
        )
      );
    }
  }]);

  return TabbarItem;
}(_react2.default.Component);

TabbarItem.propTypes = {
  className: _propTypes2.default.string,
  selected: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  label: _propTypes2.default.node
};
exports.default = TabbarItem;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var baseClassName = (0, _getClassName2.default)('Tabbar');

var Tabbar = function (_React$Component) {
  _inherits(Tabbar, _React$Component);

  function Tabbar() {
    _classCallCheck(this, Tabbar);

    return _possibleConstructorReturn(this, (Tabbar.__proto__ || Object.getPrototypeOf(Tabbar)).apply(this, arguments));
  }

  _createClass(Tabbar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          shadow = _props.shadow;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(baseClassName, className, {
            'Tabbar--shadow': shadow
          }), style: { paddingBottom: this.context.insets && this.context.insets.bottom || null } },
        children
      );
    }
  }]);

  return Tabbar;
}(_react2.default.Component);

Tabbar.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  /**
   * флаг для показа/скрытия верхней тени (Android) или границы (iOS)
   */
  shadow: _propTypes2.default.bool
};
Tabbar.defaultProps = {
  shadow: true
};
Tabbar.contextTypes = {
  insets: _propTypes2.default.shape({
    bottom: _propTypes2.default.number
  })
};
exports.default = Tabbar;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var baseClassName = (0, _getClassName2.default)('Epic');

var Epic = function (_React$Component) {
  _inherits(Epic, _React$Component);

  function Epic() {
    _classCallCheck(this, Epic);

    return _possibleConstructorReturn(this, (Epic.__proto__ || Object.getPrototypeOf(Epic)).apply(this, arguments));
  }

  _createClass(Epic, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        hasTabbar: this.props.hasOwnProperty('tabbar')
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          activeStory = _props.activeStory,
          tabbar = _props.tabbar,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['className', 'activeStory', 'tabbar', 'children']);

      return _react2.default.createElement(
        'div',
        _extends({}, restProps, { className: (0, _classnames2.default)(baseClassName, className) }),
        _react2.default.Children.toArray(children).find(function (item) {
          return item.props.id === activeStory;
        }),
        tabbar
      );
    }
  }]);

  return Epic;
}(_react2.default.Component);

Epic.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  tabbar: _propTypes2.default.node.isRequired,
  activeStory: _propTypes2.default.string.isRequired
};
Epic.childContextTypes = {
  hasTabbar: _propTypes2.default.bool
};
exports.default = Epic;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _FixedLayout = __webpack_require__(12);

var _FixedLayout2 = _interopRequireDefault(_FixedLayout);

var _transitionEvents = __webpack_require__(9);

var _transitionEvents2 = _interopRequireDefault(_transitionEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var baseClassNames = (0, _getClassName2.default)('HeaderContext');

var HeaderContext = function (_React$Component) {
  _inherits(HeaderContext, _React$Component);

  function HeaderContext() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HeaderContext);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HeaderContext.__proto__ || Object.getPrototypeOf(HeaderContext)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      closing: false
    }, _this.onAnimationFinish = function () {
      return _this.setState({ closing: false });
    }, _this.getRef = function (el) {
      return _this.el = el;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HeaderContext, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.opened !== this.props.opened) {
        if (nextProps.opened === false) {
          this.setState({ closing: true });
          this.waitAnimationFinish(this.onAnimationFinish);
        } else {
          clearTimeout(this.closeAnimationTimeiout);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.closeAnimationTimeiout);
    }
  }, {
    key: 'waitAnimationFinish',
    value: function waitAnimationFinish(eventHandler) {
      if (_transitionEvents2.default.supported) {
        var eventName = _transitionEvents2.default.prefix ? _transitionEvents2.default.prefix + 'AnimationEnd' : 'animationend';
        this.el.removeEventListener(eventName, eventHandler);
        this.el.addEventListener(eventName, eventHandler);
      } else {
        this.closeAnimationTimeiout = setTimeout(eventHandler.bind(this), 200);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          opened = _props.opened,
          onClose = _props.onClose,
          restProps = _objectWithoutProperties(_props, ['children', 'className', 'opened', 'onClose']);

      return _react2.default.createElement(
        _FixedLayout2.default,
        _extends({}, restProps, { className: (0, _classnames2.default)(baseClassNames, {
            'HeaderContext--opened': opened,
            'HeaderContext--closing': this.state.closing
          }, className), vertical: 'top' }),
        _react2.default.createElement(
          'div',
          { className: 'HeaderContext__in', ref: this.getRef },
          (opened || this.state.closing) && children
        ),
        (opened || this.state.closing) && _react2.default.createElement('div', { onClick: onClose, className: 'HeaderContext__fade' })
      );
    }
  }]);

  return HeaderContext;
}(_react2.default.Component);

HeaderContext.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  onClose: _propTypes2.default.func.isRequired,
  opened: _propTypes2.default.bool.isRequired
};
HeaderContext.defaultProps = {
  opened: false
};
exports.default = HeaderContext;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _platform = __webpack_require__(4);

var _Tappable = __webpack_require__(5);

var _Tappable2 = _interopRequireDefault(_Tappable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var osname = (0, _platform.platform)();
var baseClassNames = (0, _getClassName2.default)('PanelHeaderContent');

var PanelHeaderContent = function PanelHeaderContent(_ref) {
  var className = _ref.className,
      style = _ref.style,
      aside = _ref.aside,
      status = _ref.status,
      before = _ref.before,
      children = _ref.children,
      onClick = _ref.onClick,
      restProps = _objectWithoutProperties(_ref, ['className', 'style', 'aside', 'status', 'before', 'children', 'onClick']);

  var InComponent = onClick ? _Tappable2.default : 'div';
  var rootProps = onClick ? {} : restProps;
  var inProps = onClick ? _extends({}, restProps, { activeEffectDelay: 200 }) : {};

  return _react2.default.createElement(
    'div',
    _extends({}, rootProps, { className: (0, _classnames2.default)(baseClassNames, className), style: style }),
    osname === _platform.ANDROID && before && _react2.default.createElement(
      'div',
      { className: 'PanelHeaderContent__before' },
      before
    ),
    _react2.default.createElement(
      InComponent,
      _extends({}, inProps, { className: 'PanelHeaderContent__in', onClick: onClick }),
      status && _react2.default.createElement(
        'div',
        { className: 'PanelHeaderContent__status' },
        status
      ),
      _react2.default.createElement(
        'div',
        { className: 'PanelHeaderContent__children' },
        _react2.default.createElement(
          'span',
          null,
          children
        ),
        aside && _react2.default.createElement(
          'div',
          { className: 'PanelHeaderContent__aside' },
          aside
        )
      )
    )
  );
};

PanelHeaderContent.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  aside: _propTypes2.default.node,
  status: _propTypes2.default.node,
  onClick: _propTypes2.default.func,
  /**
   * Android only
   */
  before: _propTypes2.default.node
};

exports.default = PanelHeaderContent;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _classnames2 = __webpack_require__(2);

var _classnames3 = _interopRequireDefault(_classnames2);

var _constants = __webpack_require__(33);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var baseClassNames = (0, _getClassName2.default)('Panel');

var Panel = function (_Component) {
  _inherits(Panel, _Component);

  function Panel() {
    _classCallCheck(this, Panel);

    return _possibleConstructorReturn(this, (Panel.__proto__ || Object.getPrototypeOf(Panel)).apply(this, arguments));
  }

  _createClass(Panel, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        panel: this.props.id
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(_ref) {
      var optimized = _ref.optimized,
          isNext = _ref.isNext,
          isPrev = _ref.isPrev;

      return optimized ? !isNext && !isPrev : true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          centered = _props.centered,
          children = _props.children,
          isPrev = _props.isPrev,
          isNext = _props.isNext,
          theme = _props.theme,
          optimized = _props.optimized,
          restProps = _objectWithoutProperties(_props, ['className', 'centered', 'children', 'isPrev', 'isNext', 'theme', 'optimized']);

      var tabbarPadding = this.context.hasTabbar ? _constants.tabbarHeight : 0;

      return _react2.default.createElement(
        'div',
        _extends({}, restProps, { className: (0, _classnames3.default)(baseClassNames, className, _defineProperty({
            'Panel--centered': centered
          }, 'Panel--tm-' + theme, theme)) }),
        _react2.default.createElement(
          'div',
          { className: 'Panel__in', style: {
              paddingBottom: this.context.insets && this.context.insets.bottom ? this.context.insets.bottom + tabbarPadding : null
            } },
          _react2.default.createElement('div', { className: 'Panel__in-before' }),
          children,
          _react2.default.createElement('div', { className: 'Panel__in-after' })
        )
      );
    }
  }, {
    key: 'insets',
    get: function get() {
      return this.context.insets || {};
    }
  }]);

  return Panel;
}(_react.Component);

Panel.childContextTypes = {
  panel: _propTypes2.default.string
};
Panel.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  theme: _propTypes2.default.oneOf(['white', 'gray']),
  id: _propTypes2.default.string.isRequired,
  optimized: _propTypes2.default.bool,
  centered: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  /**
   * @ignore
   */
  isPrev: _propTypes2.default.bool,
  /**
   * @ignore
   */
  isNext: _propTypes2.default.bool
};
Panel.defaultProps = {
  children: '',
  theme: 'gray',
  centered: false,
  optimized: true
};
Panel.contextTypes = {
  insets: _propTypes2.default.shape({
    top: _propTypes2.default.number,
    right: _propTypes2.default.number,
    bottom: _propTypes2.default.number,
    left: _propTypes2.default.number
  }),
  hasTabbar: _propTypes2.default.bool
};
exports.default = Panel;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = animate;

var _requestAnimationFrame = __webpack_require__(11);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function animate(options) {
  if (typeof window === 'undefined') {
    return;
  }

  var start = window.performance.now();

  (0, _requestAnimationFrame2.default)(function animate(time) {
    var timeFraction = (time - start) / options.duration;

    if (timeFraction > 1) {
      timeFraction = 1;
    }

    var progress = options.timing(timeFraction);

    options.draw(progress);

    if (timeFraction < 1) {
      (0, _requestAnimationFrame2.default)(animate);
    }
  });
}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _getClassName = __webpack_require__(3);

var _getClassName2 = _interopRequireDefault(_getClassName);

var _transitionEvents = __webpack_require__(9);

var _transitionEvents2 = _interopRequireDefault(_transitionEvents);

var _platform = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var osname = (0, _platform.platform)();
var baseClassName = (0, _getClassName2.default)('Root');

var Root = function (_React$Component) {
  _inherits(Root, _React$Component);

  function Root(props) {
    _classCallCheck(this, Root);

    var _this = _possibleConstructorReturn(this, (Root.__proto__ || Object.getPrototypeOf(Root)).call(this));

    _this.onAnimationEnd = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { manual: true };

      if (['root-android-animation-hide-back', 'root-android-animation-show-forward', 'root-ios-animation-hide-back', 'root-ios-animation-show-forward'].indexOf(e.animationName) > -1 || e.manual) {
        var isBack = _this.state.isBack;
        var prevView = _this.state.prevView;
        var nextView = _this.state.nextView;
        _this.setState({
          activeView: nextView,
          prevView: null,
          nextView: null,
          visibleViews: [nextView],
          transition: false,
          isBack: undefined
        }, function () {
          isBack ? _this.window.scrollTo(0, _this.state.scrolls[_this.state.activeView]) : _this.window.scrollTo(0, 0);
          _this.props.onTransition && _this.props.onTransition({ isBack: isBack, from: prevView, to: nextView });
        });
      }
    };

    _this.state = {
      activeView: props.activeView,
      prevView: null,
      nextView: null,
      visibleViews: [props.activeView],
      isBack: undefined,
      scrolls: {}
    };

    _this.arrayChildren = _react2.default.Children.toArray(props.children);
    return _this;
  }

  _createClass(Root, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.popout && !this.props.popout) {
        this.blurActiveElement();
      }

      if (nextProps.children !== this.props.children) {
        this.arrayChildren = _react2.default.Children.toArray(nextProps.children);
      }

      if (nextProps.activeView !== this.props.activeView) {
        var pageYOffset = this.window.pageYOffset;
        var firstLayerId = this.props.children.find(function (view) {
          return view.props.id === _this2.props.activeView || view.props.id === nextProps.activeView;
        }).props.id;
        var isBack = firstLayerId === nextProps.activeView;

        this.blurActiveElement();

        var nextView = nextProps.activeView;
        var prevView = this.props.activeView;

        this.setState({
          scrolls: Object.assign({}, this.state.scrolls, _defineProperty({}, this.props.activeView, pageYOffset)),
          transition: true,
          activeView: null,
          nextView: nextView,
          prevView: prevView,
          visibleViews: [nextView, prevView],
          isBack: isBack
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevState.transition && this.state.transition) {
        var prevViewElement = this.document.getElementById('view-' + this.state.prevView);
        var nextViewElement = this.document.getElementById('view-' + this.state.nextView);

        prevViewElement.querySelector('.View__panel').scrollTop = this.state.scrolls[this.state.prevView];

        if (this.state.isBack) {
          nextViewElement.querySelector('.View__panel').scrollTop = this.state.scrolls[this.state.nextView];
        }
        this.waitAnimationFinish(this.state.isBack ? prevViewElement : nextViewElement, this.onAnimationEnd);
      }
    }
  }, {
    key: 'waitAnimationFinish',
    value: function waitAnimationFinish(elem, eventHandler) {
      if (_transitionEvents2.default.supported) {
        var eventName = _transitionEvents2.default.prefix ? _transitionEvents2.default.prefix + 'AnimationEnd' : 'animationend';

        elem.removeEventListener(eventName, eventHandler);
        elem.addEventListener(eventName, eventHandler);
      } else {
        setTimeout(eventHandler.bind(this), osname === _platform.ANDROID ? 300 : 600);
      }
    }
  }, {
    key: 'blurActiveElement',
    value: function blurActiveElement() {
      if (typeof this.window !== 'undefined' && this.document.activeElement) {
        this.document.activeElement.blur();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var Views = this.arrayChildren.filter(function (View) {
        return _this3.state.visibleViews.indexOf(View.props.id) >= 0;
      });
      var _state = this.state,
          transition = _state.transition,
          isBack = _state.isBack,
          prevView = _state.prevView,
          activeView = _state.activeView,
          nextView = _state.nextView;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(baseClassName, { 'Root--transition': transition }) },
        Views.map(function (View) {
          return _react2.default.createElement(
            'div',
            { key: View.props.id, id: 'view-' + View.props.id, className: (0, _classnames2.default)('Root__view', {
                'Root__view--hide-back': View.props.id === prevView && isBack,
                'Root__view--hide-forward': View.props.id === prevView && !isBack,
                'Root__view--show-back': View.props.id === nextView && isBack,
                'Root__view--show-forward': View.props.id === nextView && !isBack,
                'Root__view--active': View.props.id === activeView
              }) },
            _react2.default.cloneElement(View, {
              inRoot: true,
              isNext: View.props.id === nextView,
              isPrev: View.props.id === prevView
            })
          );
        }),
        this.props.popout && _react2.default.createElement(
          'div',
          { className: 'Root__popout' },
          this.props.popout
        )
      );
    }
  }, {
    key: 'document',
    get: function get() {
      return this.context.document || document;
    }
  }, {
    key: 'window',
    get: function get() {
      return this.context.window || window;
    }
  }]);

  return Root;
}(_react2.default.Component);

Root.propTypes = {
  activeView: _propTypes2.default.string.isRequired,
  popout: _propTypes2.default.node,
  onTransition: _propTypes2.default.func,
  children: _propTypes2.default.node
};
Root.defaultProps = {
  popout: null
};
Root.contextTypes = {
  window: _propTypes2.default.any,
  document: _propTypes2.default.any
};
exports.default = Root;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.v = exports.colors = exports.isWebView = exports.requestAnimationFrame = exports.getClassName = exports.querystring = exports.request = exports.removeObjectKeys = exports.IOS = exports.ANDROID = exports.platform = exports.getOffsetRect = exports.keyframes = exports.classnames = exports.ConfigProvider = exports.Touch = exports.Tappable = exports.Div = exports.SelectMimicry = exports.Select = exports.Checkbox = exports.Radio = exports.Textarea = exports.RangeSlider = exports.Slider = exports.Input = exports.File = exports.Switch = exports.FormLayoutGroup = exports.FormLayout = exports.Tooltip = exports.Link = exports.Spinner = exports.FixedTabs = exports.TabsItem = exports.Tabs = exports.Search = exports.Progress = exports.Avatar = exports.Gallery = exports.Entity = exports.InfoRow = exports.Footer = exports.ListItem = exports.Cell = exports.List = exports.Group = exports.Header = exports.CellButton = exports.Button = exports.ScreenSpinner = exports.ActionSheetItem = exports.ActionSheet = exports.Alert = exports.PopoutWrapper = exports.NativePopouts = exports.FixedLayout = exports.HorizontalScroll = exports.InnerScroll = exports.TabbarItem = exports.Tabbar = exports.Epic = exports.HeaderContext = exports.PanelHeaderContent = exports.PanelHeader = exports.HeaderButton = exports.Panel = exports.View = exports.Root = undefined;

var _Root = __webpack_require__(91);

Object.defineProperty(exports, 'Root', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Root).default;
  }
});

var _View = __webpack_require__(37);

Object.defineProperty(exports, 'View', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_View).default;
  }
});

var _Panel = __webpack_require__(89);

Object.defineProperty(exports, 'Panel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Panel).default;
  }
});

var _HeaderButton = __webpack_require__(32);

Object.defineProperty(exports, 'HeaderButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_HeaderButton).default;
  }
});

var _PanelHeader = __webpack_require__(35);

Object.defineProperty(exports, 'PanelHeader', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PanelHeader).default;
  }
});

var _PanelHeaderContent = __webpack_require__(88);

Object.defineProperty(exports, 'PanelHeaderContent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PanelHeaderContent).default;
  }
});

var _HeaderContext = __webpack_require__(87);

Object.defineProperty(exports, 'HeaderContext', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_HeaderContext).default;
  }
});

var _Epic = __webpack_require__(86);

Object.defineProperty(exports, 'Epic', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Epic).default;
  }
});

var _Tabbar = __webpack_require__(85);

Object.defineProperty(exports, 'Tabbar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tabbar).default;
  }
});

var _TabbarItem = __webpack_require__(84);

Object.defineProperty(exports, 'TabbarItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TabbarItem).default;
  }
});

var _InnerScroll = __webpack_require__(83);

Object.defineProperty(exports, 'InnerScroll', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InnerScroll).default;
  }
});

var _HorizontalScroll = __webpack_require__(82);

Object.defineProperty(exports, 'HorizontalScroll', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_HorizontalScroll).default;
  }
});

var _FixedLayout = __webpack_require__(12);

Object.defineProperty(exports, 'FixedLayout', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FixedLayout).default;
  }
});

var _NativePopouts = __webpack_require__(81);

Object.defineProperty(exports, 'NativePopouts', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_NativePopouts).default;
  }
});

var _PopoutWrapper = __webpack_require__(10);

Object.defineProperty(exports, 'PopoutWrapper', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PopoutWrapper).default;
  }
});

var _Alert = __webpack_require__(30);

Object.defineProperty(exports, 'Alert', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alert).default;
  }
});

var _ActionSheet = __webpack_require__(29);

Object.defineProperty(exports, 'ActionSheet', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ActionSheet).default;
  }
});

var _ActionSheetItem = __webpack_require__(28);

Object.defineProperty(exports, 'ActionSheetItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ActionSheetItem).default;
  }
});

var _ScreenSpinner = __webpack_require__(79);

Object.defineProperty(exports, 'ScreenSpinner', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ScreenSpinner).default;
  }
});

var _Button = __webpack_require__(25);

Object.defineProperty(exports, 'Button', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Button).default;
  }
});

var _CellButton = __webpack_require__(24);

Object.defineProperty(exports, 'CellButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CellButton).default;
  }
});

var _Header = __webpack_require__(23);

Object.defineProperty(exports, 'Header', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Header).default;
  }
});

var _Group = __webpack_require__(76);

Object.defineProperty(exports, 'Group', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Group).default;
  }
});

var _List = __webpack_require__(75);

Object.defineProperty(exports, 'List', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_List).default;
  }
});

var _Cell = __webpack_require__(74);

Object.defineProperty(exports, 'Cell', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Cell).default;
  }
});
Object.defineProperty(exports, 'ListItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Cell).default;
  }
});

var _Footer = __webpack_require__(70);

Object.defineProperty(exports, 'Footer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Footer).default;
  }
});

var _InfoRow = __webpack_require__(69);

Object.defineProperty(exports, 'InfoRow', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InfoRow).default;
  }
});

var _Entity = __webpack_require__(68);

Object.defineProperty(exports, 'Entity', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Entity).default;
  }
});

var _Gallery = __webpack_require__(67);

Object.defineProperty(exports, 'Gallery', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Gallery).default;
  }
});

var _Avatar = __webpack_require__(19);

Object.defineProperty(exports, 'Avatar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Avatar).default;
  }
});

var _Progress = __webpack_require__(66);

Object.defineProperty(exports, 'Progress', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Progress).default;
  }
});

var _Search = __webpack_require__(65);

Object.defineProperty(exports, 'Search', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Search).default;
  }
});

var _Tabs = __webpack_require__(18);

Object.defineProperty(exports, 'Tabs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tabs).default;
  }
});

var _TabsItem = __webpack_require__(59);

Object.defineProperty(exports, 'TabsItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TabsItem).default;
  }
});

var _FixedTabs = __webpack_require__(58);

Object.defineProperty(exports, 'FixedTabs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FixedTabs).default;
  }
});

var _Spinner = __webpack_require__(27);

Object.defineProperty(exports, 'Spinner', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Spinner).default;
  }
});

var _Link = __webpack_require__(57);

Object.defineProperty(exports, 'Link', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Link).default;
  }
});

var _Tooltip = __webpack_require__(56);

Object.defineProperty(exports, 'Tooltip', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tooltip).default;
  }
});

var _FormLayout = __webpack_require__(55);

Object.defineProperty(exports, 'FormLayout', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormLayout).default;
  }
});

var _FormLayoutGroup = __webpack_require__(54);

Object.defineProperty(exports, 'FormLayoutGroup', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FormLayoutGroup).default;
  }
});

var _Switch = __webpack_require__(53);

Object.defineProperty(exports, 'Switch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Switch).default;
  }
});

var _File = __webpack_require__(52);

Object.defineProperty(exports, 'File', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_File).default;
  }
});

var _Input = __webpack_require__(51);

Object.defineProperty(exports, 'Input', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Input).default;
  }
});

var _Slider = __webpack_require__(17);

Object.defineProperty(exports, 'Slider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Slider).default;
  }
});

var _RangeSlider = __webpack_require__(50);

Object.defineProperty(exports, 'RangeSlider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RangeSlider).default;
  }
});

var _Textarea = __webpack_require__(49);

Object.defineProperty(exports, 'Textarea', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Textarea).default;
  }
});

var _Radio = __webpack_require__(48);

Object.defineProperty(exports, 'Radio', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Radio).default;
  }
});

var _Checkbox = __webpack_require__(47);

Object.defineProperty(exports, 'Checkbox', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Checkbox).default;
  }
});

var _Select = __webpack_require__(46);

Object.defineProperty(exports, 'Select', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Select).default;
  }
});

var _SelectMimicry = __webpack_require__(45);

Object.defineProperty(exports, 'SelectMimicry', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SelectMimicry).default;
  }
});

var _Div = __webpack_require__(20);

Object.defineProperty(exports, 'Div', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Div).default;
  }
});

var _Tappable = __webpack_require__(5);

Object.defineProperty(exports, 'Tappable', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tappable).default;
  }
});

var _Touch = __webpack_require__(8);

Object.defineProperty(exports, 'Touch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Touch).default;
  }
});

var _ConfigProvider = __webpack_require__(44);

Object.defineProperty(exports, 'ConfigProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ConfigProvider).default;
  }
});

var _classnames = __webpack_require__(2);

Object.defineProperty(exports, 'classnames', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_classnames).default;
  }
});

var _keyframes = __webpack_require__(26);

Object.defineProperty(exports, 'keyframes', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_keyframes).default;
  }
});

var _offset = __webpack_require__(31);

Object.defineProperty(exports, 'getOffsetRect', {
  enumerable: true,
  get: function get() {
    return _offset.getOffsetRect;
  }
});

var _platform = __webpack_require__(4);

Object.defineProperty(exports, 'platform', {
  enumerable: true,
  get: function get() {
    return _platform.platform;
  }
});
Object.defineProperty(exports, 'ANDROID', {
  enumerable: true,
  get: function get() {
    return _platform.ANDROID;
  }
});
Object.defineProperty(exports, 'IOS', {
  enumerable: true,
  get: function get() {
    return _platform.IOS;
  }
});

var _removeObjectKeys = __webpack_require__(13);

Object.defineProperty(exports, 'removeObjectKeys', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_removeObjectKeys).default;
  }
});

var _request = __webpack_require__(41);

Object.defineProperty(exports, 'request', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_request).default;
  }
});

var _querystring = __webpack_require__(14);

Object.defineProperty(exports, 'querystring', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_querystring).default;
  }
});

var _getClassName = __webpack_require__(3);

Object.defineProperty(exports, 'getClassName', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getClassName).default;
  }
});

var _requestAnimationFrame = __webpack_require__(11);

Object.defineProperty(exports, 'requestAnimationFrame', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_requestAnimationFrame).default;
  }
});

var _webview = __webpack_require__(15);

Object.defineProperty(exports, 'isWebView', {
  enumerable: true,
  get: function get() {
    return _webview.isWebView;
  }
});

__webpack_require__(40);

__webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var colors = exports.colors = {};

var v = exports.v = "2.14.1";

/***/ })
/******/ ]);
});
//# sourceMappingURL=vkui.js.map

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(255)();
}


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(256);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.BrowserSpriteSymbol = factory());
}(this, (function () { 'use strict';

var SpriteSymbol = function SpriteSymbol(ref) {
  var id = ref.id;
  var viewBox = ref.viewBox;
  var content = ref.content;

  this.id = id;
  this.viewBox = viewBox;
  this.content = content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.stringify = function stringify () {
  return this.content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.toString = function toString () {
  return this.stringify();
};

SpriteSymbol.prototype.destroy = function destroy () {
    var this$1 = this;

  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
};

/**
 * @param {string} content
 * @return {Element}
 */
var parse = function (content) {
  var hasImportNode = !!document.importNode;
  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;

  /**
   * Fix for browser which are throwing WrongDocumentError
   * if you insert an element which is not part of the document
   * @see http://stackoverflow.com/a/7986519/4624403
   */
  if (hasImportNode) {
    return document.importNode(doc, true);
  }

  return doc;
};

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};





function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var deepmerge = createCommonjsModule(function (module, exports) {
(function (root, factory) {
    if (false) {
        undefined(factory);
    } else {
        module.exports = factory();
    }
}(commonjsGlobal, function () {

function isMergeableObject(val) {
    var nonNullObject = val && typeof val === 'object';

    return nonNullObject
        && Object.prototype.toString.call(val) !== '[object RegExp]'
        && Object.prototype.toString.call(val) !== '[object Date]'
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {}
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function (key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function (key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination
}

function deepmerge(target, source, optionsArgument) {
    var array = Array.isArray(source);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var arrayMerge = options.arrayMerge || defaultArrayMerge;

    if (array) {
        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
    } else {
        return mergeObject(target, source, optionsArgument)
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements')
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, optionsArgument)
    })
};

return deepmerge

}));
});

var namespaces_1 = createCommonjsModule(function (module, exports) {
var namespaces = {
  svg: {
    name: 'xmlns',
    uri: 'http://www.w3.org/2000/svg'
  },
  xlink: {
    name: 'xmlns:xlink',
    uri: 'http://www.w3.org/1999/xlink'
  }
};

exports.default = namespaces;
module.exports = exports.default;
});

/**
 * @param {Object} attrs
 * @return {string}
 */
var objectToAttrsString = function (attrs) {
  return Object.keys(attrs).map(function (attr) {
    var value = attrs[attr].toString().replace(/"/g, '&quot;');
    return (attr + "=\"" + value + "\"");
  }).join(' ');
};

var svg = namespaces_1.svg;
var xlink = namespaces_1.xlink;

var defaultAttrs = {};
defaultAttrs[svg.name] = svg.uri;
defaultAttrs[xlink.name] = xlink.uri;

/**
 * @param {string} [content]
 * @param {Object} [attributes]
 * @return {string}
 */
var wrapInSvgString = function (content, attributes) {
  if ( content === void 0 ) content = '';

  var attrs = deepmerge(defaultAttrs, attributes || {});
  var attrsRendered = objectToAttrsString(attrs);
  return ("<svg " + attrsRendered + ">" + content + "</svg>");
};

var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
  function BrowserSpriteSymbol () {
    SpriteSymbol$$1.apply(this, arguments);
  }

  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;

  var prototypeAccessors = { isMounted: {} };

  prototypeAccessors.isMounted.get = function () {
    return !!this.node;
  };

  /**
   * @param {Element} node
   * @return {BrowserSpriteSymbol}
   */
  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
    return new BrowserSpriteSymbol({
      id: node.getAttribute('id'),
      viewBox: node.getAttribute('viewBox'),
      content: node.outerHTML
    });
  };

  BrowserSpriteSymbol.prototype.destroy = function destroy () {
    if (this.isMounted) {
      this.unmount();
    }
    SpriteSymbol$$1.prototype.destroy.call(this);
  };

  /**
   * @param {Element|string} target
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.mount = function mount (target) {
    if (this.isMounted) {
      return this.node;
    }

    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
    var node = this.render();
    this.node = node;

    mountTarget.appendChild(node);

    return node;
  };

  /**
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.render = function render () {
    var content = this.stringify();
    return parse(wrapInSvgString(content)).childNodes[0];
  };

  BrowserSpriteSymbol.prototype.unmount = function unmount () {
    this.node.parentNode.removeChild(this.node);
  };

  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );

  return BrowserSpriteSymbol;
}(SpriteSymbol));

return BrowserSpriteSymbol;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.BrowserSprite = factory());
}(this, (function () { 'use strict';

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};





function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var deepmerge = createCommonjsModule(function (module, exports) {
(function (root, factory) {
    if (false) {
        undefined(factory);
    } else {
        module.exports = factory();
    }
}(commonjsGlobal, function () {

function isMergeableObject(val) {
    var nonNullObject = val && typeof val === 'object';

    return nonNullObject
        && Object.prototype.toString.call(val) !== '[object RegExp]'
        && Object.prototype.toString.call(val) !== '[object Date]'
}

function emptyTarget(val) {
    return Array.isArray(val) ? [] : {}
}

function cloneIfNecessary(value, optionsArgument) {
    var clone = optionsArgument && optionsArgument.clone === true;
    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
}

function defaultArrayMerge(target, source, optionsArgument) {
    var destination = target.slice();
    source.forEach(function(e, i) {
        if (typeof destination[i] === 'undefined') {
            destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
            destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
            destination.push(cloneIfNecessary(e, optionsArgument));
        }
    });
    return destination
}

function mergeObject(target, source, optionsArgument) {
    var destination = {};
    if (isMergeableObject(target)) {
        Object.keys(target).forEach(function (key) {
            destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
    }
    Object.keys(source).forEach(function (key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
            destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
            destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
    });
    return destination
}

function deepmerge(target, source, optionsArgument) {
    var array = Array.isArray(source);
    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
    var arrayMerge = options.arrayMerge || defaultArrayMerge;

    if (array) {
        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument)
    } else {
        return mergeObject(target, source, optionsArgument)
    }
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
    if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements')
    }

    // we are sure there are at least 2 values, so it is safe to have no initial value
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, optionsArgument)
    })
};

return deepmerge

}));
});

//      
// An event handler can take an optional event argument
// and should not return a value
                                          
// An array of all currently registered event handlers for a type
                                            
// A map of event types and their corresponding event handlers.
                        
                                   
  

/** Mitt: Tiny (~200b) functional event emitter / pubsub.
 *  @name mitt
 *  @returns {Mitt}
 */
function mitt(all                 ) {
	all = all || Object.create(null);

	return {
		/**
		 * Register an event handler for the given type.
		 *
		 * @param  {String} type	Type of event to listen for, or `"*"` for all events
		 * @param  {Function} handler Function to call in response to given event
		 * @memberOf mitt
		 */
		on: function on(type        , handler              ) {
			(all[type] || (all[type] = [])).push(handler);
		},

		/**
		 * Remove an event handler for the given type.
		 *
		 * @param  {String} type	Type of event to unregister `handler` from, or `"*"`
		 * @param  {Function} handler Handler function to remove
		 * @memberOf mitt
		 */
		off: function off(type        , handler              ) {
			if (all[type]) {
				all[type].splice(all[type].indexOf(handler) >>> 0, 1);
			}
		},

		/**
		 * Invoke all handlers for the given type.
		 * If present, `"*"` handlers are invoked after type-matched handlers.
		 *
		 * @param {String} type  The event type to invoke
		 * @param {Any} [evt]  Any value (object is recommended and powerful), passed to each handler
		 * @memberof mitt
		 */
		emit: function emit(type        , evt     ) {
			(all[type] || []).map(function (handler) { handler(evt); });
			(all['*'] || []).map(function (handler) { handler(type, evt); });
		}
	};
}

var namespaces_1 = createCommonjsModule(function (module, exports) {
var namespaces = {
  svg: {
    name: 'xmlns',
    uri: 'http://www.w3.org/2000/svg'
  },
  xlink: {
    name: 'xmlns:xlink',
    uri: 'http://www.w3.org/1999/xlink'
  }
};

exports.default = namespaces;
module.exports = exports.default;
});

/**
 * @param {Object} attrs
 * @return {string}
 */
var objectToAttrsString = function (attrs) {
  return Object.keys(attrs).map(function (attr) {
    var value = attrs[attr].toString().replace(/"/g, '&quot;');
    return (attr + "=\"" + value + "\"");
  }).join(' ');
};

var svg = namespaces_1.svg;
var xlink = namespaces_1.xlink;

var defaultAttrs = {};
defaultAttrs[svg.name] = svg.uri;
defaultAttrs[xlink.name] = xlink.uri;

/**
 * @param {string} [content]
 * @param {Object} [attributes]
 * @return {string}
 */
var wrapInSvgString = function (content, attributes) {
  if ( content === void 0 ) content = '';

  var attrs = deepmerge(defaultAttrs, attributes || {});
  var attrsRendered = objectToAttrsString(attrs);
  return ("<svg " + attrsRendered + ">" + content + "</svg>");
};

var svg$1 = namespaces_1.svg;
var xlink$1 = namespaces_1.xlink;

var defaultConfig = {
  attrs: ( obj = {
    style: ['position: absolute', 'width: 0', 'height: 0'].join('; ')
  }, obj[svg$1.name] = svg$1.uri, obj[xlink$1.name] = xlink$1.uri, obj )
};
var obj;

var Sprite = function Sprite(config) {
  this.config = deepmerge(defaultConfig, config || {});
  this.symbols = [];
};

/**
 * Add new symbol. If symbol with the same id exists it will be replaced.
 * @param {SpriteSymbol} symbol
 * @return {boolean} `true` - symbol was added, `false` - replaced
 */
Sprite.prototype.add = function add (symbol) {
  var ref = this;
    var symbols = ref.symbols;
  var existing = this.find(symbol.id);

  if (existing) {
    symbols[symbols.indexOf(existing)] = symbol;
    return false;
  }

  symbols.push(symbol);
  return true;
};

/**
 * Remove symbol & destroy it
 * @param {string} id
 * @return {boolean} `true` - symbol was found & successfully destroyed, `false` - otherwise
 */
Sprite.prototype.remove = function remove (id) {
  var ref = this;
    var symbols = ref.symbols;
  var symbol = this.find(id);

  if (symbol) {
    symbols.splice(symbols.indexOf(symbol), 1);
    symbol.destroy();
    return true;
  }

  return false;
};

/**
 * @param {string} id
 * @return {SpriteSymbol|null}
 */
Sprite.prototype.find = function find (id) {
  return this.symbols.filter(function (s) { return s.id === id; })[0] || null;
};

/**
 * @param {string} id
 * @return {boolean}
 */
Sprite.prototype.has = function has (id) {
  return this.find(id) !== null;
};

/**
 * @return {string}
 */
Sprite.prototype.stringify = function stringify () {
  var ref = this.config;
    var attrs = ref.attrs;
  var stringifiedSymbols = this.symbols.map(function (s) { return s.stringify(); }).join('');
  return wrapInSvgString(stringifiedSymbols, attrs);
};

/**
 * @return {string}
 */
Sprite.prototype.toString = function toString () {
  return this.stringify();
};

Sprite.prototype.destroy = function destroy () {
  this.symbols.forEach(function (s) { return s.destroy(); });
};

var SpriteSymbol = function SpriteSymbol(ref) {
  var id = ref.id;
  var viewBox = ref.viewBox;
  var content = ref.content;

  this.id = id;
  this.viewBox = viewBox;
  this.content = content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.stringify = function stringify () {
  return this.content;
};

/**
 * @return {string}
 */
SpriteSymbol.prototype.toString = function toString () {
  return this.stringify();
};

SpriteSymbol.prototype.destroy = function destroy () {
    var this$1 = this;

  ['id', 'viewBox', 'content'].forEach(function (prop) { return delete this$1[prop]; });
};

/**
 * @param {string} content
 * @return {Element}
 */
var parse = function (content) {
  var hasImportNode = !!document.importNode;
  var doc = new DOMParser().parseFromString(content, 'image/svg+xml').documentElement;

  /**
   * Fix for browser which are throwing WrongDocumentError
   * if you insert an element which is not part of the document
   * @see http://stackoverflow.com/a/7986519/4624403
   */
  if (hasImportNode) {
    return document.importNode(doc, true);
  }

  return doc;
};

var BrowserSpriteSymbol = (function (SpriteSymbol$$1) {
  function BrowserSpriteSymbol () {
    SpriteSymbol$$1.apply(this, arguments);
  }

  if ( SpriteSymbol$$1 ) BrowserSpriteSymbol.__proto__ = SpriteSymbol$$1;
  BrowserSpriteSymbol.prototype = Object.create( SpriteSymbol$$1 && SpriteSymbol$$1.prototype );
  BrowserSpriteSymbol.prototype.constructor = BrowserSpriteSymbol;

  var prototypeAccessors = { isMounted: {} };

  prototypeAccessors.isMounted.get = function () {
    return !!this.node;
  };

  /**
   * @param {Element} node
   * @return {BrowserSpriteSymbol}
   */
  BrowserSpriteSymbol.createFromExistingNode = function createFromExistingNode (node) {
    return new BrowserSpriteSymbol({
      id: node.getAttribute('id'),
      viewBox: node.getAttribute('viewBox'),
      content: node.outerHTML
    });
  };

  BrowserSpriteSymbol.prototype.destroy = function destroy () {
    if (this.isMounted) {
      this.unmount();
    }
    SpriteSymbol$$1.prototype.destroy.call(this);
  };

  /**
   * @param {Element|string} target
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.mount = function mount (target) {
    if (this.isMounted) {
      return this.node;
    }

    var mountTarget = typeof target === 'string' ? document.querySelector(target) : target;
    var node = this.render();
    this.node = node;

    mountTarget.appendChild(node);

    return node;
  };

  /**
   * @return {Element}
   */
  BrowserSpriteSymbol.prototype.render = function render () {
    var content = this.stringify();
    return parse(wrapInSvgString(content)).childNodes[0];
  };

  BrowserSpriteSymbol.prototype.unmount = function unmount () {
    this.node.parentNode.removeChild(this.node);
  };

  Object.defineProperties( BrowserSpriteSymbol.prototype, prototypeAccessors );

  return BrowserSpriteSymbol;
}(SpriteSymbol));

var defaultConfig$1 = {
  /**
   * Should following options be automatically configured:
   * - `syncUrlsWithBaseTag`
   * - `locationChangeAngularEmitter`
   * - `moveGradientsOutsideSymbol`
   * @type {boolean}
   */
  autoConfigure: true,

  /**
   * Default mounting selector
   * @type {string}
   */
  mountTo: 'body',

  /**
   * Fix disappearing SVG elements when <base href> exists.
   * Executes when sprite mounted.
   * @see http://stackoverflow.com/a/18265336/796152
   * @see https://github.com/everdimension/angular-svg-base-fix
   * @see https://github.com/angular/angular.js/issues/8934#issuecomment-56568466
   * @type {boolean}
   */
  syncUrlsWithBaseTag: false,

  /**
   * Should sprite listen custom location change event
   * @type {boolean}
   */
  listenLocationChangeEvent: true,

  /**
   * Custom window event name which should be emitted to update sprite urls
   * @type {string}
   */
  locationChangeEvent: 'locationChange',

  /**
   * Emit location change event in Angular automatically
   * @type {boolean}
   */
  locationChangeAngularEmitter: false,

  /**
   * Selector to find symbols usages when updating sprite urls
   * @type {string}
   */
  usagesToUpdate: 'use[*|href]',

  /**
   * Fix Firefox bug when gradients and patterns don't work if they are within a symbol.
   * Executes when sprite is rendered, but not mounted.
   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=306674
   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=353575
   * @see https://bugzilla.mozilla.org/show_bug.cgi?id=1235364
   * @type {boolean}
   */
  moveGradientsOutsideSymbol: false
};

/**
 * @param {*} arrayLike
 * @return {Array}
 */
var arrayFrom = function (arrayLike) {
  return Array.prototype.slice.call(arrayLike, 0);
};

var ua = navigator.userAgent;

var browser = {
  isChrome: /chrome/i.test(ua),
  isFirefox: /firefox/i.test(ua),

  // https://msdn.microsoft.com/en-us/library/ms537503(v=vs.85).aspx
  isIE: /msie/i.test(ua) || /trident/i.test(ua),
  isEdge: /edge/i.test(ua)
};

/**
 * @param {string} name
 * @param {*} data
 */
var dispatchEvent = function (name, data) {
  var event = document.createEvent('CustomEvent');
  event.initCustomEvent(name, false, false, data);
  window.dispatchEvent(event);
};

/**
 * IE doesn't evaluate <style> tags in SVGs that are dynamically added to the page.
 * This trick will trigger IE to read and use any existing SVG <style> tags.
 * @see https://github.com/iconic/SVGInjector/issues/23
 * @see https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/10898469/
 *
 * @param {Element} node DOM Element to search <style> tags in
 * @return {Array<HTMLStyleElement>}
 */
var evalStylesIEWorkaround = function (node) {
  var updatedNodes = [];

  arrayFrom(node.querySelectorAll('style'))
    .forEach(function (style) {
      style.textContent += '';
      updatedNodes.push(style);
    });

  return updatedNodes;
};

/**
 * @param {string} [url] If not provided - current URL will be used
 * @return {string}
 */
var getUrlWithoutFragment = function (url) {
  return (url || window.location.href).split('#')[0];
};

/* global angular */
/**
 * @param {string} eventName
 */
var locationChangeAngularEmitter = function (eventName) {
  angular.module('ng').run(['$rootScope', function ($rootScope) {
    $rootScope.$on('$locationChangeSuccess', function (e, newUrl, oldUrl) {
      dispatchEvent(eventName, { oldUrl: oldUrl, newUrl: newUrl });
    });
  }]);
};

var defaultSelector = 'linearGradient, radialGradient, pattern';

/**
 * @param {Element} svg
 * @param {string} [selector]
 * @return {Element}
 */
var moveGradientsOutsideSymbol = function (svg, selector) {
  if ( selector === void 0 ) selector = defaultSelector;

  arrayFrom(svg.querySelectorAll('symbol')).forEach(function (symbol) {
    arrayFrom(symbol.querySelectorAll(selector)).forEach(function (node) {
      symbol.parentNode.insertBefore(node, symbol);
    });
  });
  return svg;
};

/**
 * @param {NodeList} nodes
 * @param {Function} [matcher]
 * @return {Attr[]}
 */
function selectAttributes(nodes, matcher) {
  var attrs = arrayFrom(nodes).reduce(function (acc, node) {
    if (!node.attributes) {
      return acc;
    }

    var arrayfied = arrayFrom(node.attributes);
    var matched = matcher ? arrayfied.filter(matcher) : arrayfied;
    return acc.concat(matched);
  }, []);

  return attrs;
}

/**
 * @param {NodeList|Node} nodes
 * @param {boolean} [clone=true]
 * @return {string}
 */

var xLinkNS = namespaces_1.xlink.uri;
var xLinkAttrName = 'xlink:href';

// eslint-disable-next-line no-useless-escape
var specialUrlCharsPattern = /[{}|\\\^\[\]`"<>]/g;

function encoder(url) {
  return url.replace(specialUrlCharsPattern, function (match) {
    return ("%" + (match[0].charCodeAt(0).toString(16).toUpperCase()));
  });
}

/**
 * @param {NodeList} nodes
 * @param {string} startsWith
 * @param {string} replaceWith
 * @return {NodeList}
 */
function updateReferences(nodes, startsWith, replaceWith) {
  arrayFrom(nodes).forEach(function (node) {
    var href = node.getAttribute(xLinkAttrName);
    if (href && href.indexOf(startsWith) === 0) {
      var newUrl = href.replace(startsWith, replaceWith);
      node.setAttributeNS(xLinkNS, xLinkAttrName, newUrl);
    }
  });

  return nodes;
}

/**
 * List of SVG attributes to update url() target in them
 */
var attList = [
  'clipPath',
  'colorProfile',
  'src',
  'cursor',
  'fill',
  'filter',
  'marker',
  'markerStart',
  'markerMid',
  'markerEnd',
  'mask',
  'stroke',
  'style'
];

var attSelector = attList.map(function (attr) { return ("[" + attr + "]"); }).join(',');

/**
 * Update URLs in svg image (like `fill="url(...)"`) and update referencing elements
 * @param {Element} svg
 * @param {NodeList} references
 * @param {string|RegExp} startsWith
 * @param {string} replaceWith
 * @return {void}
 *
 * @example
 * const sprite = document.querySelector('svg.sprite');
 * const usages = document.querySelectorAll('use');
 * updateUrls(sprite, usages, '#', 'prefix#');
 */
var updateUrls = function (svg, references, startsWith, replaceWith) {
  var startsWithEncoded = encoder(startsWith);
  var replaceWithEncoded = encoder(replaceWith);

  var nodes = svg.querySelectorAll(attSelector);
  var attrs = selectAttributes(nodes, function (ref) {
    var localName = ref.localName;
    var value = ref.value;

    return attList.indexOf(localName) !== -1 && value.indexOf(("url(" + startsWithEncoded)) !== -1;
  });

  attrs.forEach(function (attr) { return attr.value = attr.value.replace(startsWithEncoded, replaceWithEncoded); });
  updateReferences(references, startsWithEncoded, replaceWithEncoded);
};

/**
 * Internal emitter events
 * @enum
 * @private
 */
var Events = {
  MOUNT: 'mount',
  SYMBOL_MOUNT: 'symbol_mount'
};

var BrowserSprite = (function (Sprite$$1) {
  function BrowserSprite(cfg) {
    var this$1 = this;
    if ( cfg === void 0 ) cfg = {};

    Sprite$$1.call(this, deepmerge(defaultConfig$1, cfg));

    var emitter = mitt();
    this._emitter = emitter;
    this.node = null;

    var ref = this;
    var config = ref.config;

    if (config.autoConfigure) {
      this._autoConfigure(cfg);
    }

    if (config.syncUrlsWithBaseTag) {
      var baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
      emitter.on(Events.MOUNT, function () { return this$1.updateUrls('#', baseUrl); });
    }

    var handleLocationChange = this._handleLocationChange.bind(this);
    this._handleLocationChange = handleLocationChange;

    // Provide way to update sprite urls externally via dispatching custom window event
    if (config.listenLocationChangeEvent) {
      window.addEventListener(config.locationChangeEvent, handleLocationChange);
    }

    // Emit location change event in Angular automatically
    if (config.locationChangeAngularEmitter) {
      locationChangeAngularEmitter(config.locationChangeEvent);
    }

    // After sprite mounted
    emitter.on(Events.MOUNT, function (spriteNode) {
      if (config.moveGradientsOutsideSymbol) {
        moveGradientsOutsideSymbol(spriteNode);
      }
    });

    // After symbol mounted into sprite
    emitter.on(Events.SYMBOL_MOUNT, function (symbolNode) {
      if (config.moveGradientsOutsideSymbol) {
        moveGradientsOutsideSymbol(symbolNode.parentNode);
      }

      if (browser.isIE || browser.isEdge) {
        evalStylesIEWorkaround(symbolNode);
      }
    });
  }

  if ( Sprite$$1 ) BrowserSprite.__proto__ = Sprite$$1;
  BrowserSprite.prototype = Object.create( Sprite$$1 && Sprite$$1.prototype );
  BrowserSprite.prototype.constructor = BrowserSprite;

  var prototypeAccessors = { isMounted: {} };

  /**
   * @return {boolean}
   */
  prototypeAccessors.isMounted.get = function () {
    return !!this.node;
  };

  /**
   * Automatically configure following options
   * - `syncUrlsWithBaseTag`
   * - `locationChangeAngularEmitter`
   * - `moveGradientsOutsideSymbol`
   * @param {Object} cfg
   * @private
   */
  BrowserSprite.prototype._autoConfigure = function _autoConfigure (cfg) {
    var ref = this;
    var config = ref.config;

    if (typeof cfg.syncUrlsWithBaseTag === 'undefined') {
      config.syncUrlsWithBaseTag = typeof document.getElementsByTagName('base')[0] !== 'undefined';
    }

    if (typeof cfg.locationChangeAngularEmitter === 'undefined') {
      config.locationChangeAngularEmitter = 'angular' in window;
    }

    if (typeof cfg.moveGradientsOutsideSymbol === 'undefined') {
      config.moveGradientsOutsideSymbol = browser.isFirefox;
    }
  };

  /**
   * @param {Event} event
   * @param {Object} event.detail
   * @param {string} event.detail.oldUrl
   * @param {string} event.detail.newUrl
   * @private
   */
  BrowserSprite.prototype._handleLocationChange = function _handleLocationChange (event) {
    var ref = event.detail;
    var oldUrl = ref.oldUrl;
    var newUrl = ref.newUrl;
    this.updateUrls(oldUrl, newUrl);
  };

  /**
   * Add new symbol. If symbol with the same id exists it will be replaced.
   * If sprite already mounted - `symbol.mount(sprite.node)` will be called.
   * @fires Events#SYMBOL_MOUNT
   * @param {BrowserSpriteSymbol} symbol
   * @return {boolean} `true` - symbol was added, `false` - replaced
   */
  BrowserSprite.prototype.add = function add (symbol) {
    var sprite = this;
    var isNewSymbol = Sprite$$1.prototype.add.call(this, symbol);

    if (this.isMounted && isNewSymbol) {
      symbol.mount(sprite.node);
      this._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
    }

    return isNewSymbol;
  };

  /**
   * Attach to existing DOM node
   * @param {string|Element} target
   * @return {Element|null} attached DOM Element. null if node to attach not found.
   */
  BrowserSprite.prototype.attach = function attach (target) {
    var this$1 = this;

    var sprite = this;

    if (sprite.isMounted) {
      return sprite.node;
    }

    /** @type Element */
    var node = typeof target === 'string' ? document.querySelector(target) : target;
    sprite.node = node;

    // Already added symbols needs to be mounted
    this.symbols.forEach(function (symbol) {
      symbol.mount(sprite.node);
      this$1._emitter.emit(Events.SYMBOL_MOUNT, symbol.node);
    });

    // Create symbols from existing DOM nodes, add and mount them
    arrayFrom(node.querySelectorAll('symbol'))
      .forEach(function (symbolNode) {
        var symbol = BrowserSpriteSymbol.createFromExistingNode(symbolNode);
        symbol.node = symbolNode; // hack to prevent symbol mounting to sprite when adding
        sprite.add(symbol);
      });

    this._emitter.emit(Events.MOUNT, node);

    return node;
  };

  BrowserSprite.prototype.destroy = function destroy () {
    var ref = this;
    var config = ref.config;
    var symbols = ref.symbols;
    var _emitter = ref._emitter;

    symbols.forEach(function (s) { return s.destroy(); });

    _emitter.off('*');
    window.removeEventListener(config.locationChangeEvent, this._handleLocationChange);

    if (this.isMounted) {
      this.unmount();
    }
  };

  /**
   * @fires Events#MOUNT
   * @param {string|Element} [target]
   * @param {boolean} [prepend=false]
   * @return {Element|null} rendered sprite node. null if mount node not found.
   */
  BrowserSprite.prototype.mount = function mount (target, prepend) {
    if ( target === void 0 ) target = this.config.mountTo;
    if ( prepend === void 0 ) prepend = false;

    var sprite = this;

    if (sprite.isMounted) {
      return sprite.node;
    }

    var mountNode = typeof target === 'string' ? document.querySelector(target) : target;
    var node = sprite.render();
    this.node = node;

    if (prepend && mountNode.childNodes[0]) {
      mountNode.insertBefore(node, mountNode.childNodes[0]);
    } else {
      mountNode.appendChild(node);
    }

    this._emitter.emit(Events.MOUNT, node);

    return node;
  };

  /**
   * @return {Element}
   */
  BrowserSprite.prototype.render = function render () {
    return parse(this.stringify());
  };

  /**
   * Detach sprite from the DOM
   */
  BrowserSprite.prototype.unmount = function unmount () {
    this.node.parentNode.removeChild(this.node);
  };

  /**
   * Update URLs in sprite and usage elements
   * @param {string} oldUrl
   * @param {string} newUrl
   * @return {boolean} `true` - URLs was updated, `false` - sprite is not mounted
   */
  BrowserSprite.prototype.updateUrls = function updateUrls$1 (oldUrl, newUrl) {
    if (!this.isMounted) {
      return false;
    }

    var usages = document.querySelectorAll(this.config.usagesToUpdate);

    updateUrls(
      this.node,
      usages,
      ((getUrlWithoutFragment(oldUrl)) + "#"),
      ((getUrlWithoutFragment(newUrl)) + "#")
    );

    return true;
  };

  Object.defineProperties( BrowserSprite.prototype, prototypeAccessors );

  return BrowserSprite;
}(Sprite));

var ready$1 = createCommonjsModule(function (module) {
/*!
  * domready (c) Dustin Diaz 2014 - License MIT
  */
!function (name, definition) {

  { module.exports = definition(); }

}('domready', function () {

  var fns = [], listener
    , doc = document
    , hack = doc.documentElement.doScroll
    , domContentLoaded = 'DOMContentLoaded'
    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState);


  if (!loaded)
  { doc.addEventListener(domContentLoaded, listener = function () {
    doc.removeEventListener(domContentLoaded, listener);
    loaded = 1;
    while (listener = fns.shift()) { listener(); }
  }); }

  return function (fn) {
    loaded ? setTimeout(fn, 0) : fns.push(fn);
  }

});
});

var spriteNodeId = '__SVG_SPRITE_NODE__';
var spriteGlobalVarName = '__SVG_SPRITE__';
var isSpriteExists = !!window[spriteGlobalVarName];

// eslint-disable-next-line import/no-mutable-exports
var sprite;

if (isSpriteExists) {
  sprite = window[spriteGlobalVarName];
} else {
  sprite = new BrowserSprite({ attrs: { id: spriteNodeId } });
  window[spriteGlobalVarName] = sprite;
}

var loadSprite = function () {
  /**
   * Check for page already contains sprite node
   * If found - attach to and reuse it's content
   * If not - render and mount the new sprite
   */
  var existing = document.getElementById(spriteNodeId);

  if (existing) {
    sprite.attach(existing);
  } else {
    sprite.mount(document.body, true);
  }
};

if (document.body) {
  loadSprite();
} else {
  ready$1(loadSprite);
}

var sprite$1 = sprite;

return sprite$1;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports = {"0":522,"1":170,"2":171,"3":232,"4":374,"5":373,"6":531,"7":566,"8":613,"9":674,"10":439,"11":589,"12":627,"13":792,"14":704,"15":653,"16":740,"17":782,"18":775,"19":798,"20":544,"21":803,"22":828,"23":815,"24":571,"25":934,"26":1195,"27":985,"28":1216,"29":1259,"30":848,"31":1348,"32":2274,"33":2164,"34":2309,"35":2012,"36":2042,"37":2494,"38":2273,"39":2348,"40":1342,"41":2449,"42":2148,"43":2916,"44":2428,"45":1981,"46":2358,"47":2740,"48":1784,"49":2859,"50":946,"51":2679,"52":2547,"53":2768,"54":2397,"55":1575,"56":2431,"57":2503,"58":2329,"59":2496,"60":2176,"61":3624,"62":3197,"63":3636,"64":2393,"65":2604,"66":2360,"67":2345,"68":1634,"69":1928,"70":1751,"71":1633,"72":1945,"73":3393,"74":2615,"75":1787,"76":1754,"77":3609,"78":2978,"79":3213,"80":1947,"81":2591,"82":2370,"83":3121,"84":2862,"85":2575,"86":1530,"87":3103,"88":3229,"89":3085,"90":1866,"91":3301,"92":2692,"93":3439,"94":2799,"95":2994,"96":2915,"97":2971,"98":2155,"99":1672,"100":585,"101":3364,"102":4775,"103":3718,"104":4080,"105":4176,"106":4833,"107":3890,"108":3662,"109":3967,"110":3695,"111":4282,"112":4232,"113":5626,"114":3665,"115":4796,"116":5529,"117":5290,"118":3927,"119":4870,"120":3641,"121":4131,"122":3702,"123":3881,"124":4577,"125":4934,"126":5984,"127":4250,"128":3482,"129":3052,"130":3247,"131":4575,"132":4774,"133":4075,"134":4253,"135":4756,"136":5456,"137":4343,"138":4002,"139":3892,"140":4407,"141":3249,"142":3261,"143":5472,"144":3149,"145":4597,"146":3720,"147":4214,"148":5634,"149":4060,"150":3442,"151":5484,"152":6197,"153":4940,"154":5169,"155":4818,"156":4715,"157":5201,"158":5817,"159":3956,"160":4799,"161":4584,"162":3864,"163":5323,"164":4951,"165":5534,"166":4042,"167":6456,"168":3548,"169":4851,"170":4736,"171":4757,"172":4030,"173":3396,"174":3595,"175":5666,"176":4094,"177":3587,"178":4483,"179":4954,"180":4225,"181":4806,"182":4496,"183":5052,"184":4341,"185":4728,"186":4079,"187":4828,"188":4681,"189":5030,"190":3693,"191":4852,"192":3131,"193":4213,"194":4273,"195":3492,"196":5159,"197":5665,"198":4614,"199":4689,"200":1943,"201":4306,"202":5087,"203":4921,"204":4035,"205":4583,"206":4688,"207":3562,"208":4421,"209":3354,"210":3668,"211":4522,"212":3321,"213":4423,"214":4881,"215":4945,"216":3087,"217":4248,"218":5158,"219":5479,"220":4277,"221":4995,"222":4487,"223":4461,"224":5256,"225":5727,"226":4107,"227":4180,"228":4979,"229":4305,"230":5420,"231":5434,"232":4664,"233":6754,"234":5690,"235":4971,"236":5887,"237":5219,"238":6071,"239":6580,"240":4687,"241":5203,"242":4602,"243":6152,"244":4612,"245":6028,"246":5615,"247":4997,"248":4666,"249":5613,"250":3188,"251":4003,"252":5077,"253":6788,"254":4351,"255":4557,"256":20884,"257":40641,"259":29020,"260":17082,"261":37662,"262":29975,"263":29327,"264":33193,"265":41098,"266":21785,"267":40195,"269":39149,"270":18433,"271":29587,"272":35990,"273":29483,"274":30944,"275":22689,"276":34050,"277":19027,"278":35686,"279":49987,"280":16781,"281":35477,"282":21854,"283":21973,"284":46500,"285":32210,"286":33382,"287":28470,"288":44515,"289":29058,"290":20706,"291":24905,"292":28480,"293":39901,"294":34652,"295":35683,"296":27218,"297":39357,"298":37476,"299":22062,"300":3068,"301":24064,"302":26215,"303":10171,"304":22860,"305":28001,"306":13354,"307":28650,"308":32737,"309":39654,"310":22312,"311":22794,"312":30540,"313":40635,"314":43089,"315":21462,"316":33776,"317":35289,"319":40958,"320":18604,"321":23538,"322":38531,"323":38503,"324":27176,"325":23303,"326":32445,"328":32014,"330":19946,"331":30723,"333":23312,"334":31355,"335":31777,"336":33762,"337":20837,"338":32228,"339":42275,"340":23428,"341":31128,"342":26369,"343":30743,"345":23625,"346":31989,"347":28083,"350":10383,"351":26502,"352":35028,"353":36403,"354":37581,"355":35947,"356":37462,"357":21742,"358":31585,"359":29636,"360":7883,"361":42270,"364":46007,"365":14414,"366":35796,"367":40947,"368":30918,"369":32064,"370":26085,"375":19335,"376":49516,"377":41324,"379":42279,"380":22527,"382":29816,"383":26661,"384":24809,"385":27941,"386":32844,"388":38062,"390":26084,"391":44830,"393":31137,"394":27764,"395":32856,"396":39791,"397":44952,"398":48517,"399":27674,"400":4501,"401":25020,"403":23754,"404":13635,"405":29125,"406":47923,"407":32843,"409":34169,"410":24672,"411":28798,"412":47244,"413":43247,"414":31696,"415":19633,"416":30753,"418":47839,"419":30672,"420":10352,"421":43892,"422":22212,"423":39479,"424":29844,"425":25037,"427":35015,"428":32075,"429":20578,"430":38469,"431":37402,"432":33608,"434":49268,"437":37041,"438":33186,"439":44884,"440":21841,"442":48600,"444":44856,"445":46730,"447":41151,"448":30627,"450":16407,"455":27021,"456":36239,"457":29970,"459":48401,"461":38599,"465":24389,"466":18836,"467":34395,"468":33246,"475":30022,"476":41714,"478":42710,"480":45672,"481":48782,"482":41772,"485":47512,"486":38051,"488":32697,"490":28424,"491":45673,"499":41155,"500":2534,"501":14021,"502":33175,"505":28796,"506":40131,"507":35089,"508":34449,"510":25979,"512":28797,"513":38442,"515":38054,"517":48438,"518":32957,"520":21297,"521":29084,"526":37360,"529":35797,"530":46053,"531":48276,"533":47491,"534":45972,"537":41821,"538":40701,"539":33609,"540":31257,"542":28845,"544":43042,"547":37435,"550":22670,"553":41467,"554":48709,"555":36714,"556":30003,"558":21080,"559":43189,"561":48021,"565":44954,"566":41041,"567":31092,"570":25503,"571":40286,"573":41673,"574":33777,"575":37798,"577":44660,"578":25031,"580":42830,"581":24758,"582":34552,"585":40773,"586":33041,"592":49478,"595":29707,"600":6948,"604":35991,"605":25939,"607":26506,"609":43400,"610":32507,"611":48210,"612":42274,"613":25417,"616":32606,"617":30065,"620":30773,"622":26726,"623":30333,"624":44968,"625":42438,"626":33850,"628":47933,"630":46108,"632":44519,"633":36600,"634":48574,"635":42890,"636":39586,"638":42860,"639":15992,"642":49603,"643":45215,"644":39670,"645":34562,"647":48025,"648":44372,"650":18723,"651":38297,"655":40034,"660":33348,"661":46028,"666":17201,"668":49110,"670":32178,"672":47034,"678":10211,"679":32225,"680":24411,"684":49613,"685":34561,"693":47490,"699":24508,"700":7328,"703":47960,"704":29626,"708":40548,"711":30549,"717":39869,"718":23420,"720":46830,"722":47109,"725":29952,"727":38429,"730":29215,"737":22323,"742":41079,"744":41749,"745":47936,"746":42472,"747":24355,"749":33238,"750":14135,"755":41822,"757":33857,"758":39870,"764":39096,"767":20561,"771":41900,"775":48998,"777":5625,"780":47941,"787":21990,"790":40868,"792":40867,"800":5222,"801":49000,"802":29729,"808":23752,"810":46881,"812":45469,"813":36482,"818":35109,"819":42685,"820":40067,"823":34531,"831":37514,"836":30307,"839":32574,"843":38716,"844":33332,"845":30043,"846":34290,"847":32045,"850":17858,"858":48601,"860":25232,"861":43359,"865":39783,"870":24248,"875":33191,"876":49503,"878":36483,"880":49269,"882":33366,"888":30478,"890":41040,"895":35795,"897":32465,"900":11027,"905":33199,"909":44973,"910":25957,"911":13378,"912":38395,"917":42809,"920":46247,"921":43479,"927":45171,"928":36659,"929":38186,"930":30803,"940":40305,"947":47840,"950":23573,"955":45470,"956":32167,"960":28390,"966":45441,"968":46681,"969":40154,"972":39480,"978":9641,"980":29241,"986":44537,"992":31717,"995":39257,"997":48771,"998":39455,"999":7990,"1000":3859,"1003":30439,"1005":28707,"1006":42025,"1007":37515,"1010":48304,"1016":49888,"1017":40353,"1024":22265,"1034":35311,"1066":41016,"1075":46291,"1080":26079,"1091":19976,"1100":21786,"1101":48182,"1111":31947,"1117":48602,"1124":46573,"1133":40097,"1157":38686,"1160":49469,"1185":27978,"1189":41528,"1191":39761,"1192":41970,"1200":16493,"1204":39376,"1215":43828,"1216":45172,"1229":46579,"1234":33985,"1241":42857,"1244":41174,"1270":35070,"1279":27979,"1280":23576,"1285":46746,"1286":48060,"1300":18635,"1334":40723,"1337":40849,"1360":40942,"1389":47173,"1400":14060,"1402":48333,"1415":29024,"1416":29039,"1450":30453,"1453":41240,"1455":48332,"1481":48906,"1484":48627,"1488":49349,"1492":36885,"1500":8575,"1501":36579,"1510":39370,"1518":36660,"1525":41747,"1526":30526,"1530":46175,"1534":30611,"1536":38001,"1541":40882,"1542":34730,"1555":44301,"1559":36787,"1577":44838,"1580":41748,"1581":43467,"1599":34482,"1600":17003,"1603":25971,"1605":43650,"1611":49528,"1620":46813,"1623":39831,"1630":31828,"1631":42893,"1634":48769,"1640":32973,"1641":33622,"1647":35668,"1650":46872,"1660":41198,"1689":39221,"1691":46951,"1700":26073,"1704":39240,"1707":22142,"1711":49267,"1718":36548,"1722":35260,"1732":46286,"1735":47060,"1736":46835,"1742":36131,"1745":35261,"1750":26855,"1751":44965,"1758":33349,"1760":36070,"1763":20863,"1764":37268,"1765":46287,"1766":40758,"1767":47470,"1768":43697,"1770":40812,"1773":30885,"1775":42823,"1776":27719,"1777":48318,"1780":37408,"1783":36417,"1785":26901,"1787":25422,"1788":40813,"1789":23963,"1790":22484,"1791":20982,"1792":28511,"1793":47059,"1794":35268,"1795":49027,"1796":40814,"1797":19413,"1798":39191,"1799":23890,"1800":14891,"1801":23102,"1802":30684,"1803":28584,"1804":33200,"1806":27741,"1807":26100,"1808":34891,"1809":24541,"1810":33253,"1811":35604,"1812":17597,"1813":43916,"1814":23213,"1815":29128,"1816":38931,"1817":38314,"1818":27425,"1819":25463,"1820":33994,"1821":34574,"1822":40821,"1823":35267,"1824":26296,"1825":30869,"1826":34583,"1827":43419,"1828":26475,"1829":35674,"1830":16241,"1831":32503,"1832":24904,"1833":34445,"1834":25593,"1836":27747,"1837":22694,"1838":31076,"1839":28983,"1840":18110,"1841":29003,"1842":29131,"1843":27773,"1844":34887,"1845":21368,"1846":48897,"1847":48040,"1848":17406,"1849":24716,"1850":14971,"1851":24892,"1852":23626,"1853":27921,"1854":32874,"1855":24132,"1856":24193,"1857":18556,"1858":19284,"1859":16230,"1860":17423,"1861":19624,"1862":20018,"1863":25784,"1864":22778,"1865":24196,"1866":24795,"1867":9835,"1868":24191,"1869":24431,"1870":13838,"1871":14121,"1872":12154,"1873":38315,"1874":20395,"1875":27447,"1876":20565,"1877":21464,"1878":20717,"1879":31699,"1880":13690,"1881":26210,"1882":27955,"1883":19887,"1884":17710,"1885":17281,"1886":27069,"1887":18977,"1888":16762,"1889":29993,"1890":18720,"1891":24354,"1892":14010,"1893":29377,"1894":16675,"1895":15331,"1896":14263,"1897":27127,"1898":16938,"1899":10904,"1900":8176,"1901":11699,"1902":16399,"1903":11047,"1904":13337,"1905":11453,"1906":15334,"1907":13298,"1908":11778,"1909":15115,"1910":8218,"1911":7740,"1912":9135,"1913":9948,"1914":9500,"1915":7242,"1916":10459,"1917":9074,"1918":7424,"1919":10389,"1920":8507,"1921":11008,"1922":11737,"1923":9740,"1924":13484,"1925":10595,"1926":13607,"1927":12348,"1928":11878,"1929":10046,"1930":8732,"1931":13040,"1932":14574,"1933":13404,"1934":12472,"1935":11195,"1936":11042,"1937":8609,"1938":10294,"1939":6832,"1940":7333,"1941":7816,"1942":8495,"1943":8697,"1944":5681,"1945":4312,"1946":9557,"1947":8194,"1948":6911,"1949":9425,"1950":6926,"1951":11442,"1952":10522,"1953":7598,"1954":11407,"1955":8525,"1956":7934,"1957":11824,"1958":7822,"1959":10128,"1960":7986,"1961":8698,"1962":8404,"1963":7004,"1964":9689,"1965":6978,"1966":7829,"1967":3031,"1968":6703,"1969":5959,"1970":6048,"1971":6687,"1972":6856,"1973":5908,"1974":5730,"1975":5205,"1976":6087,"1977":7035,"1978":6107,"1979":5353,"1980":5349,"1981":6281,"1982":5109,"1983":6244,"1984":4505,"1985":5847,"1986":4469,"1987":5179,"1988":4274,"1989":4298,"1990":3902,"1991":3711,"1992":3895,"1993":3722,"1994":3891,"1995":3703,"1996":3971,"1997":3779,"1998":3394,"1999":2985,"2000":2050,"2001":2180,"2002":2307,"2003":1710,"2004":721,"2005":469,"2006":538,"2007":625,"2008":639,"2009":819,"2010":840,"2011":1043,"2012":997,"2013":1332,"2014":1452,"2015":1742,"2016":8377,"2017":41078,"2018":41023,"2020":20126,"2022":48123,"2027":46580,"2030":41573,"2048":31749,"2050":41672,"2100":28117,"2200":43205,"2400":48664,"2500":11401,"2526":46861,"2600":17381,"2601":17497,"2602":13084,"2607":42167,"2700":49780,"2790":44346,"2933":37327,"3000":8750,"3500":31388,"4000":12247,"4653":32423,"4654":48805,"5000":9924,"5191":34090,"5462":43008,"5800":44527,"6000":14560,"6007":38547,"6026":34331,"6794":39474,"6885":45347,"7000":21357,"7500":37734,"7992":38548,"8000":25161,"8301":39682,"8320":32583,"8621":23978,"9000":4720,"9001":36596,"9807":11278,"9999":47139,"10000":15663,"14625":39469,"15000":36554,"15978":37423,"27510":35790,"37169":37591,"60000":46347,"80913":47680,"94709":45330,"99999":48940,"100000":24428,"178070":39193,"894840":38493,"1000000":45280,"5636765":39467,"7940701":43118,"13843046":28022,"1015392289":35615,"1234567890":38465,"divert":16282,"martyrdom":20391,"pretexts":48019,"khels":47879,"habitation":42057,"averaged":37895,"selected":3024,"facilities":7037,"hawk":11822,"uncut":28799,"analytical":16449,"recalled":14080,"curators":37007,"hillside":43362,"famitsu":34041,"donates":38035,"dramatically":11077,"progeny":42108,"rapture":23277,"wikipedian's":23580,"centennial":32237,"brew":38675,"oecd":27872,"dogg":29624,"underscore":49200,"castes":7256,"mp3s":44427,"a1":5547,"dutch":2960,"blm":35143,"satisfy":2680,"latvian":12715,"kahn's":48528,"seaweed":24325,"xy":20380,"accusers":15542,"pléigh":43258,"bullied":8243,"uscg":37192,"erected":16838,"espresso":21171,"sabha":30720,"breathless":45477,"centrifugal":8685,"life's":15199,"'big":28523,"capitalised":14641,"nearby":6930,"nascar":13456,"disbarred":35900,"trades":14489,"wo":15873,"reinstatement":19406,"huguenot":47162,"eldest":27776,"palmer":10156,"there's":415,"universal's":35421,"rein":18811,"30pm":33802,"negativity":16674,"litigants":24458,"riemann":19296,"yoninah":39560,"protections":12702,"cure":7471,"listserv":48104,"jacqueline":30278,"solemnly":37073,"ad":1499,"9th":7445,"cellar":45707,"mma":7568,"wield":17218,"scaring":25396,"stacy":31641,"quest":7058,"14th":6319,"marcil":43382,"comms☛":40877,"heritability":35612,"guy'":38052,"impression":2149,"tanolis":25589,"assumptions":4278,"greenie":32658,"eyed":9905,"redeemed":46111,"actualy":15699,"burp":36046,"sensibly":27982,"officers":4551,"second":427,"jungle":10393,"depriving":24276,"pmid":14778,"ireland'":43303,"lawl":35040,"parathyroid":29339,"calms":42015,"completes":28746,"references":277,"therefor":8860,"down":334,"m16":26762,"arranged":7823,"remembers":15718,"qwyrxian":15010,"affect":3933,"beneath":8474,"dembski's":40254,"showthread":14115,"athletic":11086,"hooligans":23879,"sexists":48285,"thuringowa":17509,"inserter":40804,"jbs":39322,"cups":19622,"christs":40084,"accumulating":29918,"decisive":12862,"bill":1877,"rotates":28414,"depot":19422,"terrorise":47129,"shithole":5328,"coincide":14743,"fffff":6283,"jacket":13376,"palmetto":46643,"kiosk":36037,"sarek":11850,"a520":48945,"coachella":44025,"janet":10321,"navigator":43691,"pills":19778,"notebook":36929,"outlined":6539,"brainstorm":45309,"vellala":20987,"scolded":27252,"asteroid":14356,"yea":5915,"beeing":18865,"technopolis":39101,"artisans":41604,"fugly":44641,"fruity":25112,"hr":9912,"gwaii":39667,"italy":3143,"automate":33187,"shovel":42081,"serials":35794,"somthing":14632,"sloped":37330,"rajendra":18764,"ino":35222,"war":314,"zohar":35589,"beardo":41508,"recruiter":45028,"onorem":27326,"andreasjs":40250,"discography":4073,"ast":42125,"dispicable":44540,"ignoratio":46138,"puzzle":11326,"hire":9777,"10k":26568,"boomage":38132,"jaffrey":45539,"folly":20456,"andemu":10102,"derisive":33216,"let´s":33651,"vojvodina":22216,"baas":28782,"interests":2332,"serf":40166,"indianexpress":39406,"prolog":42945,"rashly":23928,"attending":9155,"burst":13525,"neutrality":1804,"botanist":23957,"sucks":790,"moth":20817,"protester":30610,"mumble":20463,"fujimura":38775,"erwin":18221,"deflower":28685,"flyupload":44217,"doggy":29559,"perceptions":12007,"doppler":20887,"racheal":29245,"kiss":5104,"georgie":29862,"lame":4493,"monroe":11121,"capitalists":15773,"y'all":11459,"peder":33266,"agriculturists":37785,"aveling":42520,"hysteria":13998,"teleological":20339,"subways":45635,"gender":2843,"boswell":38230,"fowler's":31819,"educators":16780,"patroling":42681,"roanoke":46340,"transmitter":25277,"wayne's":33974,"facts":429,"reconsidering":31293,"totallydisputed":31930,"flashing":30642,"russified":41426,"andromedean":38133,"openings":24270,"wipo":39452,"skin":3383,"bennett's":40569,"neuroscience":34190,"mp's":24516,"kennedy":5186,"delibrately":39186,"ginger":19957,"hertz":27192,"coups":37841,"mayhem":23238,"injecting":25930,"veronica":24240,"theorize":34859,"apersonal":47342,"sexual":1465,"defenses":20080,"addict":14072,"oxfordshire":45748,"christened":45341,"drive":2100,"handily":40985,"light":1057,"pgk":33640,"won":1779,"thales":37060,"abrams":18032,"slrubenstein":14582,"wikignome":47538,"tracker":28938,"pronto":30656,"knockout":20740,"citated":26197,"placing":3328,"tim":4174,"eton":23127,"separating":11512,"nikola":14386,"'article":25922,"religioustolerance":42673,"stine":37915,"galilean":31407,"oldarticles":31012,"coin":4759,"banhammer":27672,"wikinews":5370,"antonin":34851,"novosti":36032,"registered":2300,"argentinian":31946,"majid":31941,"obscuring":25355,"trophy":10368,"shelf":13578,"maha":25320,"biggus":47449,"poland's":20867,"streaks":49685,"dissuade":24152,"specifies":2732,"nicknames":8559,"waldorf":10099,"occam's":28382,"worthy":2315,"boldness":30437,"nina":10168,"kenny":10543,"syrup":31258,"“only":44723,"bathroom":15241,"slinging":42432,"shakira's":48849,"15th":7001,"naveen":25881,"kogan":41787,"veritas":18479,"hardware":7326,"mavericks":43729,"surrealism":14493,"enterstageright":38398,"garth":32771,"roddy":35218,"superficially":20589,"nhl":8802,"hutton":30952,"forbid":9441,"uncalled":8324,"nigh":29029,"ae":5369,"visas":30312,"suspected":3035,"dynamics":10627,"fertility":22874,"off":212,"valbanera":34772,"accessdates":28435,"meta":4204,"shared":1455,"spectroscopy":47395,"creationary":23294,"shawarma":38774,"opps":30849,"dhahran":38864,"lumber":33172,"osli":25390,"vertebrobasilar":30799,"contact":730,"brb":40053,"survivor":10565,"américa":45072,"respond":1041,"biscuits":35678,"undertaking":13943,"shelter":14298,"fend":28121,"reprinting":32099,"quister4040":49081,"succesfully":30499,"hello":302,"subsume":48663,"accusing":2126,"holla":13593,"puts":3981,"chivalry":44036,"notably":5642,"laugh":2838,"works'":32253,"dawkins'":35828,"learned":2235,"permanent":3534,"specify":2066,"incidents":2616,"insisted":6730,"nominee":12856,"neighborhoods":12162,"townshend":38310,"offering":4391,"npcs":40678,"shemale":47219,"radiative":42788,"oppenheimer":24876,"particulary":29854,"smacks":12919,"parkinson's":20015,"hieroglyphs":37464,"yarn":44458,"fricken":29688,"mathmatical":42502,"mare":21500,"explosives":13150,"trash":4646,"watts":11486,"serendipodous":27669,"packer":32194,"exchanges":10001,"blockquote":44015,"beth":8207,"prayers":14556,"tennyson":27619,"delicate":14461,"somme":42773,"agains't":37293,"'lao'":34809,"blueboy":25773,"trevor":15447,"consuming":8469,"illustrious":19687,"mike":2839,"wickets":33408,"coloring":18698,"redpen":29998,"machowicz":42506,"happens":1417,"casual":5606,"wether":11368,"npa":3443,"gibbs":19907,"reprise":45501,"selfishness":43634,"macinnis":28760,"everlasting":24958,"organized":3761,"arbitrators":8583,"philharmonic":21090,"overheard":33835,"gurdjieff":45697,"exegetes":45233,"rjanag":36853,"loyalists":15220,"pan":5876,"bestest":49817,"supergroup":19952,"dome":12194,"plagiarizing":26237,"expensive":6043,"feats":23532,"podiatric":46365,"pretence":26798,"dungeons":10312,"r1a":44528,"namibia":15582,"khz":46937,"addings":48864,"husbandry":32667,"mountain5":35649,"queensland":13529,"rna":24272,"acharya's":40267,"mrs":5163,"siempre":39883,"joachimsthaler":20608,"gallipoli":30402,"prep":12331,"boymamas":3305,"mustache":33260,"swiftboat":49121,"talk'''":16236,"spellings":6989,"thomson's":42769,"'discussion'":30614,"shaving":32804,"gilmore":32479,"redacting":36056,"tactful":28929,"condescension":25184,"poor's":41332,"distrusted":44480,"rumours":9478,"joystick":23953,"corruption":4635,"antelope":17695,"xman":21666,"projected":12624,"granularity":47963,"nicole":11060,"lorraine":35055,"ott":28031,"beat":2532,"load":3827,"buren":37290,"nusatsum":38846,"ditched":35020,"flexing":28076,"longevity":19442,"harshly":18133,"inconsistant":35452,"mumbled":45003,"whiny":16123,"seminal":15859,"design":1889,"pgp":42437,"inaugurate":46963,"fannish":23020,"transfered":27146,"buttons":7225,"grandpa":33578,"makeing":33080,"oit":26513,"constituencies":29497,"omnibenevolence":49672,"moulton":18613,"assuredly":42197,"ana":12421,"postmodernist":44675,"milhist":11222,"expel":22077,"omission":8355,"belong":1379,"race":1384,"afterall":13620,"d5":31316,"adming":33772,"gba":39003,"£20":49986,"useres":46884,"waterproof":34450,"throats":16213,"pa's":34520,"forfeit":35442,"practices":3376,"curb":18396,"š":29453,"screwy":37935,"austen":27601,"cappuccino":44865,"fetzer":34701,"runways":29408,"ensembles":31602,"cass":24126,"pozdrowienia":44239,"blanket":7908,"folklore":12254,"gym":13381,"musicals":33936,"vigilant":12775,"nahome":46594,"•talk":45834,"eminently":17475,"gibbon":32645,"mba":19118,"seater":37605,"biasness":33127,"thrindel":48810,"decimals":48912,"unearthed":28932,"echoing":22281,"carrier":8544,"scratch":6052,"rich's":36631,"safeguards":41840,"answer":505,"aether":24952,"susceptible":25525,"reactor":12675,"abbottabad":24347,"flashback":24202,"morphine":29846,"skinny":20668,"nfcc":8345,"о":27416,"recognizing":12108,"own":165,"vaishnava":19742,"decorate":41056,"pi":8142,"bonfire":26550,"canary":17375,"weeds":29447,"nicolum":25747,"slain":23984,"shark":11037,"roma":8844,"cntrbtns":26344,"appoint":14410,"racial":2728,"wipe":8334,"alexei":26505,"dmorpheus":37332,"interoperability":48232,"bleating":33315,"ਸੁਖ":31387,"compromising":11498,"morell":22035,"work—whether":34305,"logan":11205,"pledge2":22026,"5a":43319,"wrestlers":11994,"reread":8958,"woodland":41871,"pot":7051,"pinktulip":48892,"unborn":21891,"divided":4743,"baha'i":21031,"recused":25989,"persecute":22894,"ignoring":2417,"hoard":29108,"polynesia":33518,"leland":47763,"airbag":34045,"enable":7591,"nefarious":12834,"catch":3116,"negroid":24113,"krannert":31904,"fray":19554,"from'":48259,"rat's":22774,"summarises":27780,"dmcdevit":17308,"condemnation":15670,"orig":29258,"gregerson":45988,"pickett":42075,"1967fan":8543,"sentry":15594,"psychiatry":11259,"slapping":14096,"vcs":43616,"puck":34875,"editorialize":44879,"bust":9116,"marx’s":48039,"durova":13061,"orgname":32693,"renominated":20441,"targeted":5062,"discusion":18905,"worthwhile":5532,"specialy":34525,"forwards":13846,"guinea":11674,"diplomats":31906,"fable":40290,"71b2":37105,"goddamn":7856,"availible":32618,"nicaraguans":34461,"sts":35348,"polled":26455,"elevate":26227,"lifebaka":28728,"cappetta":37562,"hubbard":12722,"eht":48626,"sensations":36463,"politis":27456,"sp":8680,"“comfort":36349,"nisarkand":12765,"48th":45741,"responders":28270,"calvin":13901,"brake":14679,"apothécure":36038,"burr":27237,"autism":6858,"lunchables":9545,"cso":36364,"flight":2894,"drowning":28326,"tectonic":29044,"finder":26212,"demerits":48857,"42nd":44450,"only'":47662,"puru":40170,"sunderland":31498,"permanently":3621,"berth":35365,"selective":4850,"change":239,"circus":8327,"magnus":23023,"strikingly":25097,"measured":5823,"silverhill":49619,"appear":722,"benito":29772,"chinatown":23956,"subcategory":12389,"samael":20637,"faded":23620,"honorably":34946,"ballance":42944,"originating":9779,"tito's":29903,"philological":45235,"0918":32748,"northpark":16993,"tom":2514,"carly":20191,"showcasing":44702,"vault":19288,"cornwell":14427,"wise":3162,"imprint":24553,"gaps":9420,"libertas":40018,"contacting":4679,"archeologists":35838,"genio":39519,"kari":46190,"there’s":13152,"unadulterated":47009,"brilliant":4969,"hodgepodge":31178,"recursive":20750,"canines":40993,"shit":333,"exagerated":49341,"boldly":10761,"finn":20812,"students":1490,"unwillingness":14601,"maker":6831,"zhang":16262,"immaterial":14374,"dipterous":47050,"air":1312,"warfare":5916,"outburst":12167,"other's":5996,"celebrex":42625,"barbed":30053,"elizium23's":45952,"diverge":23361,"casually":11959,"oppression":9443,"vandalised":4342,"bliss":16511,"doright":38572,"mbenga":46903,"boa":33548,"“b”":38086,"regulations":5951,"charms":29691,"doghouseboxing":34725,"time's":31340,"0000z":21675,"ok":460,"novorossiya":43480,"recoverable":49358,"they":51,"goddess":10736,"patronise":33679,"fate":6036,"skimming":20698,"time—counts":37871,"starting":1418,"dsp":42446,"mehdi":47667,"viriditas":11562,"templatename":12692,"scorpion":24038,"packages":13063,"wikify":8975,"vituzzu":27392,"bidding":17589,"“harassing":41643,"kc":14152,"cyclones":17425,"sunnis":13946,"minister":2770,"mnemonic":16844,"accomplishments":8804,"penal":15302,"welcoming":7103,"unblocking":4663,"erick":46588,"interventionist":47846,"crusader":16647,"hobgoblin":47239,"recived":30781,"fusiliers":32787,"reflinks":23337,"newberry":49609,"grigorian":41097,"fond":9343,"sharpened":34428,"helps":1822,"jeongol":44017,"pinpointed":36215,"encyclopedically":31488,"shelled":35937,"importing":22274,"limestone":43620,"yadava":31890,"citadel":17779,"lewinsky":47473,"melon":12441,"qoutes":41662,"conquering":18306,"gonzález":49002,"rioters":25093,"dipute":46883,"universes":19015,"nba":7572,"educations":37079,"kinetic":17277,"attributions":18880,"circumcise":39432,"evidences":8535,"preceeded":33557,"marussia":49959,"laughed":9592,"yoghurt":20908,"assclown":24034,"jason":5683,"lvf":43505,"gleason":36745,"friendid":32398,"creation":1007,"scrutiny":5913,"deathly":19797,"montecarlo":39732,"art":1394,"disce":17977,"retreating":38576,"sax":24091,"ridiculed":10912,"unbelievably":15393,"cfe0":47021,"2tr2yst":48924,"wikistalked":28431,"wash":7958,"lola":26747,"weekends":33060,"distillation":15149,"lassie":29062,"mailer":32779,"holdings":13813,"stalked":11745,"violation":852,"parkinsonism":34648,"eurocentric":20978,"tvc":47867,"'go":40229,"spiders":27495,"alternate":3679,"candle":19950,"broom":24452,"tumult":39694,"genders":19755,"blastocyst":43369,"icty":19666,"pavelić":43227,"federally":22587,"ebaumsworld":44634,"centimeters":40976,"dethroned":45769,"mischievous":31060,"superbowl":27785,"bsf":19443,"itinerant":45690,"worries":4504,"oreskes'":47637,"bends":44423,"maduro's":47968,"biota":43327,"floro":44438,"quotas":24834,"unsound":30847,"stowe":21812,"mildly":11904,"kode9":45615,"evandrix":49377,"peta":11167,"rockpocket":21239,"otter":14723,"gustafson":21612,"kept":1315,"fairness":4927,"uniformity":19967,"alamo":31992,"ambassador":6591,"sauce":11609,"argov":44646,"seeded":49569,"ckc":41779,"fugue":38195,"signaled":33088,"jehova":41046,"chapters'":45476,"salute":3646,"contacted":3910,"wondering":1235,"outlaw":29620,"imdaking":28002,"i'm":73,"ireland":1628,"monstrous":17701,"brainstorming":33304,"simulated":23514,"flimsy":12627,"gori":33197,"mi5":24594,"contaminants":49932,"flawless":27967,"mini":6877,"izmir":49502,"cyde":12691,"5mm":9658,"sames":37690,"hanks":27534,"smallest":13385,"'''triplestop'''":46864,"snobby":39220,"randomness":28372,"libeled":22482,"guinness":13661,"linga":23141,"batty":28918,"nelson":7468,"mux":38625,"grizzly":38749,"incredulous":31108,"documenting":9665,"mediocrity":29059,"ropes":12537,"repeatable":26346,"measly":33675,"rus'":41909,"tyrol":14458,"trenton":19860,"copulation":36739,"skit":32411,"celine":25548,"fainting":39296,"priorend":42050,"weighted":15897,"multiply":13751,"tulsa":30734,"и":18142,"tiananmen":35540,"borrowed":4734,"gab":25225,"there'":28552,"entwistle":13774,"roudný":27230,"rd232":26537,"smtp":38789,"lights":8237,"merv":30222,"folow":49198,"commitments":22787,"canard":23089,"jvl":34378,"fec":23779,"namely":3957,"copyvios":10044,"proccess":41560,"ventures":17271,"neurologists":48125,"recipient":11207,"hamburglar":37989,"resnum":14454,"mech":31392,"pictish":35913,"implementations":16589,"numbers":988,"various":751,"elonka's":21608,"poetry":6214,"dozen":3410,"   discuß  ":44791,"dielectric":29396,"specialties":33249,"accademic":39665,"paul":1725,"thorne":36103,"dynastic":23459,"mull":26223,"faces":6908,"bespoke":46532,"lost":1029,"ear":5864,"traded":14368,"complimenting":35677,"ft2":16596,"stout":34218,"fluffy":24537,"nicolaus":28856,"manpower":42208,"icrc":35928,"awadewit":30094,"infringement":5066,"this'll":37356,"—'":24792,"effect":1201,"fir":18137,"intruder":31397,"melanosis":31652,"purdue":12986,"chile":8212,"raise":2657,"referred":1539,"matches":2635,"nevar":48725,"opossum":35314,"seventeenth":20436,"echoes":26521,"austro":24092,"answered":2656,"goalposts":30874,"west":1237,"podgorica":25788,"recruiters":33554,"mosquito":18657,"reiterated":22170,"comm":19359,"encountering":19714,"flood":6728,"quantum":4659,"edition":2169,"howes":43129,"salem":22386,"belgian":10190,"directive":17633,"oprahwasontv":49511,"poyner":47172,"longitude":14137,"diaper":23335,"da's":46670,"puppet'":37400,"coherent":8287,"dismiss":5739,"trompenaars":29418,"indon":33371,"rabies":45510,"rama's":29289,"☯":17812,"jindal":41113,"leaders":3201,"ahonteways":47984,"felipe":28375,"pogroms":17348,"sure":193,"tint":43774,"pavel":22624,"printing":6755,"franconia":44593,"messianic":10863,"abiding":16272,"“vandals”":47745,"basicly":19485,"amped":49297,"grossman":23817,"nft":32078,"testify":14606,"bhushan":34681,"tcp":15892,"assume":857,"tdsb":43752,"freindly":44966,"rested":24893,"disturb":17257,"crewer":29110,"negatively":8836,"kennel":12157,"titled":2834,"wackos":44599,"yugoslavia":4929,"highlander":30197,"student's":22304,"➨":17470,"misquoting":19325,"hades":36819," talkedits":49612,"sequel":9715,"injury":6290,"liszt's":36849,"emission":18214,"lexical":29255,"glock":16519,"goon":13262,"described":948,"vertebrates":49149,"nippon":39027,"6a":46988,"experiments":4540,"wec":40199,"coherently":35077,"cnbc":27758,"marrying":16950,"kelly's":33013,"shortage":15137,"distribute":10737,"alphabetic":18597,"others'":4552,"perinçek":13429,"upwards":20857,"flagicons":49426,"baba":7786,"verde":17490,"wikifun":49876,"newtons":39911,"misspelling":11902,"period":907,"worshipped":18935,"princes":11951,"torsion":19825,"lima":16706,"dic":33064,"miyamoto":33458,"nimitz":35224,"mines":13679,"shallow":10621,"sockpuppeter":39066,"day's":18856,"wafulz":19938,"pinoy":25836,"defining":4254,"insatiable":32611,"frania":40846,"pornographic":11208,"camino":25792,"seasonal":19392,"jeremy's":33257,"jokingly":29829,"linkedin":22673,"loom":49555,"garrison":9748,"uhm":23011,"progressivism":16696,"democracies":20033,"gland":22840,"firefox":6298,"nitrate":48238,"parodies":15234,"cindamuse":45027,"officials":5092,"millenium":12576,"rnw":47326,"though":241,"hamsun's":26469,"drini":32141,"attacks'":33464,"covet":38120,"match":1697,"plaque":18889,"chappell":31475,"tonight":3372,"powerful":2927,"disjointed":22202,"gan":6564,"ahold":38147,"rossp":26430,"ucking":46558,"carter's":28016,"funny":1294,"smt":33386,"jarring":24147,"automation":17785,"door":3523,"adverts":28851,"adverb":25083,"avicenna":41626,"visits":7272,"jet":7043,"subfamily":37805,"duel":14083,"interrupting":28025,"trayvon":16676,"jaundice":44067,"investment":6271,"professionally":12264,"contrived":18887,"525th":41864,"everything":567,"safer":10317,"connolley":7509,"emeraude":47271,"jg":21907,"richelieu":44226,"tern":34154,"nambla":13755,"mangled":20844,"sf":10167,"abb":43596,"saedon's":49024,"interrelated":24139,"shape":3746,"republics":7978,"adding":294,"catalina":34168,"greatings":29121,"stuff":536,"martin":3020,"inserts":12581,"blanche":18295,"prisons":16892,"absolutist":35032,"uniquely":15056,"itsmejudith":29251,"meshed":46315,"mentoring":14703,"bilbo":41976,"ache":47381,"persuade":9291,"raw":4191,"duckworth":14095,"gaara":38595,"flared":31305,"apology":2237,"picture's":47800,"bilecik":49521,"benefiting":41977,"cmc":48213,"israelis":7567,"ascencio":39992,"destiny's":48396,"dink":33433,"righteousness":18541,"phylogenies":39122,"kookiness":37274,"canonicity":38947,"snowball":22802,"ekajati":37335,"mores":37535,"compleete":34758,"boyfriends":26571,"jingle":26610,"wider":4399,"screwed":7075,"margarine":27723,"spine":17457,"kammas":43163,"17th":7601,"verdun":34650,"speculates":48329,"scavenger":41140,"tehsil":20177,"samoan":11279,"shabby":37741,"chocolate":9506,"generaly":38289,"fruits":11098,"web":541,"intermittent":27957,"recombination":15182,"cemetery":10944,"encompassed":32050,"upmanship":49195,"craft":12006,"quirky":26765,"tattoo":20427,"nature":1143,"pressures":20010,"brickell":46636,"netural":41783,"stripped":8986,"moves":2892,"yogurt":17397,"retaliation":8566,"ethical":6070,"briefest":31973,"voyages":28462,"catus":20686,"takis":46727,"osman":18861,"diaphragm":39596,"shutting":13079,"neautrality":49577,"alabama":8530,"willow":23776,"stripes":19892,"lubricant":37353,"bikini":26163,"unacceptible":28235,"university's":11467,"leyte":42617,"buda":35700,"learning":2094,"bird":5541,"states'":19830,"recentism":11567,"exceedingly":15876,"roubles":48118,"presense":49393,"ego's":43719,"impress":14617,"scrapbook":34999,"oddity":33653,"human's":39705,"antithetical":49387,"recieve":12622,"counterintuitive":33978,"church's":15084,"mongolian":11126,"qutbuddin's":43778,"marginalisation":47732,"archangel":44267,"zscout370":33996,"previously":1281,"outnumbered":14887,"paracetamol":32297,"herbert":9125,"hardhead":48854,"lyons":29388,"yopu":25053,"ludicrious":47336,"ironduke":38709,"babaji":17506,"gambler":46917,"lighten":12674,"acids":13896,"bargain":23760,"overlap":6881,"shale":18071,"collects":29194,"storm":4617,"feb":2280,"rebirth":18010,"dangerous":3604,"professes":35255,"willoww":47106,"leprechaun":47277,"turkified":41450,"partisan":3546,"pearson":14011,"dogmas":30259,"kercher":16648,"rotation":9610,"yellowcake":37787,"breached":11117,"eric's":20497,"collegiate":12871,"divas":49380,"gaon":33421,"polis":39971,"obdurate":34076,"alienus":31753,"ornaments":43410,"heretofore":23793,"curtail":31518,"retroactively":20834,"jrb":45009,"geraldine":23282,"crores":36448,"taunts":23806,"lenr":35154,"horologium":48265,"ahve":16598,"dante":21685,"rls":23799,"zard":43875,"label":2007,"hazara":8220,"kingston":17670,"trite":19560,"autobots":38094,"kipling":34699,"mentaly":44969,"37th":33322,"woefully":16928,"imagining":16550,"occurances":42950,"rhs":45566,"pythagorean":26280,"grossed":34372,"couldn":48951,"wrongdoings":21833,"emailuser":22378,"smallville":39342,"▪":44177,"rubella":37197,"delusions":11722,"copyeditor's":45095,"inflation":6634,"cancerous":42578,"counterpoints":30733,"nature's":40094,"nonetheless":4579,"tongan":30451,"promptly":6774,"uncompromising":22174,"ignoramus":18938,"bent":6323,"merges":11418,"fetishism":44741,"nake":47078,"wakelin":29592,"overwhelms":46305,"norberg":40171,"folds":28959,"violin":11803,"reassured":30568,"milli":36684,"electromagnetism":32084,"coli":27204,"gateway":12970,"backdrop":30116,"dipshit":5430,"craftyminion":48414,"δ's":41722,"bringing":2804,"haworth":49837,"illness":6190,"protector":13999,"kanaan":43677,"corps":4181,"usfullness":44309,"reblock":17839,"docu":26218,"•´":31055,"detected":9977,"kowalski":38333,"andre":12575,"nl":7190,"afghans":11968,"tangents":41927,"arabic":2703,"gaurishankar":35429,"video's":42118,"efficient":6717,"county's":19819,"xenophrenic":21518,"exciting":9268,"duchies":33506,"realm":6874,"empathize":29695,"saget":4160,"¶":19478,"dominions":24848,"preparations":17120,"sweetheart":30914,"quagga":44105,"efficiently":16160,"fraudsters":47183,"fiat":15484,"cisobox1":44202,"wayne":7475,"rim":14519,"canvasing":21035,"shalt":21993,"illegitimately":33400,"evidenced":7079,"tumor":17181,"quondum":45322,"pompeo":37218,"uspto":38233,"exception":2550,"pullback":38338,"phrase":1405,"f8":35370,"caliphate":23823,"makeup":13713,"100k":27884,"undefined":16355,"ribbons":27718,"kingsley":24844,"tock":20967,"bagel":34211,"breasts":10886,"mcmanus":32801,"rayon":40525,"komenda":27388,"thyroid":24021,"fancy":6597,"filtering":16188,"cristo":34490,"himslef":36080,"cfr":18165,"geting":42482,"harassing":2817,"effortlessly":38138,"glamorous":42561,"scarcity":22108,"redaction":25659,"potassium":23463,"dorian":42454,"traceable":40528,"surfed":45147,"poop":1946,"disdain":12392,"link":164,"oap's":40573,"rotate":19151,"300px":17925,"decimated":39805,"homoeopathy":29664,"irom":19242,"contextual":8515,"paranoia":8400,"guestbook":28821,"tharkuncoll":20804,"dwelling":13195,"jobsworth":36344,"renovation":42205,"vaginoplasty":29342,"kemah":38737,"zealotry":43639,"liddell":34084,"messiah":9438,"showcase":15770,"minesweeper":46971,"bulgaria":5992,"delhi":5354,"abides":33407,"modeste":47964,"caller":16867,"cbd":20156,"executing":28544,"disciplines":11068,"rawat's":18300,"jerome":12351,"yukon":28421,"feature":2187,"lehman":24177,"writers":2683,"correspondence":9292,"annoys":14376,"radiate":48200,"mayors":26828,"holman":39532,"attendant":46922,"quranic":31146,"relavant":37217,"modify":3847,"teitelbaum":38088,"levine":36917,"embarrasing":29124,"khattab":43626,"dole":20711,"blanchardb":21202,"amplifier":44988,"prom":42178,"greenwald":19669,"imstillhere":27358,"electromatetic":47562,"superheroes":23057,"cavendish":40716,"term's":34073,"sanchez's":17153,"demarcation":23905,"progressed":15319,"•✗":43141,"britannica":4384,"assertive":37099,"birmingham":10670,"hadleigh":38971,"wirestory":41762,"coincidentally":12909,"tectonics":28598,"prefect":24925,"discussed":1032,"iasb´s":44116,"transfer":4709,"substituting":21465,"equitable":21377,"smelled":23936,"handbooks":42610,"excess":8801,"— carl":17154,"employer":6486,"crit":47914,"collars":36489,"mistrust":36789,"disc":8628,"benevolent":17321,"substances":12433,"orifice":36491,"nimrod":43656,"pentecostal":30834,"neutralize":20810,"kucinich":28820,"chinese":1243,"3h":41080,"capaldi":40543,"number":367,"socal":40934,"admissions":18533,"ell":33261,"decay":14444,"ported":30502,"connery":35360,"eby":47352,"anonimu":33761,"bryant":10224,"refference":34185,"oils":23826,"fisheries":19648,"niggling":46188,"gould":17474,"refer":889,"adn":23411,"euphoria":46673,"diva":11152,"aura":32475,"describing":2530,"bulgarian":3284,"germanic":5010,"rulez":42688,"lithuania":9322,"dirac":32142,"condor":26173,"historiographical":37966,"obiter":39351,"milner":36976,"adition":49416,"toho":47833,"fantasies":9939,"sidetrack":40183,"farrow":40210,"ʝ":38908,"dill":47019,"spanking":33450,"succinct":13633,"gracefully":27620,"jen":46700,"capriciously":38009,"oasis":20039,"plenary":37687,"fuhghettaboutit":45427,"batter":35102,"mannequin":44740,"vilified":29788,"zayzayem":38202,"justifications":13183,"―œ":18429,"ageist":49310,"corset":33367,"obliged":9516,"fcken":41534,"pratchett":28689,"consultancy":30344,"skimmed":24825,"vanu":14503,"olbermann's":49864,"drag":7275,"wikilinked":12198,"dail":42177,"revolt":10037,"pseudonyms":26083,"flexibility":15158,"jammer":29369,"epidermal":42471,"hamiltonian":38070,"hadiths":23644,"murphy":8443,"vaults":43826,"ohh":20038,"definatly":19388,"snitching":40841,"trio":9965,"deleon":48605,"isn’t":8135,"toolkit":37296,"weapon":4466,"inbred":20900,"backlash":10185,"blunder":18247,"isms":39288,"cozette":43574,"vets":16749,"hakkari":38521,"anabolic":29361,"springfield":18882,"surrey":17334,"ibm":10259,"pfortuny":42613,"nazis'":34274,"acolytes":36564,"wnd":20085,"oppositions":40205,"beds":19047,"excising":26310,"undergone":15521,"armorial":46890,"uah":38454,"enthusiasts":13301,"crikey":30264,"declarative":45875,"aipac":16433,"punishes":30617,"agitators":48033,"michigan":4629,"fraud":3210,"mongering":16718,"gadhafi":25497,"boxer's":42573,"excepted":25425,"intents":18598,"sergeants":43838,"gisma":44258,"elders":12158,"webcomic":19407,"aleta":30824,"salvia":36286,"anthony":2866,"hungry":7738,"movement":1190,"substantially":3012,"belatedly":32124,"interwiki":6919,"shivaji":41553,"daring":15017,"quagmire":21549,"twelver's":46834,"designation":6143,"mackay":32891,"zona":43775,"ruddy":32865,"nationalities":8101,"superflous":27691,"ug":25562,"website's":3939,"increasing":4513,"'external":36224,"apron":49117,"resisting":15858,"iran's":15226,"kudos":9222,"republish":30892,"pitched":16586,"sch":36543,"meatball":24872,"generalised":27226,"insignias":41085,"advertise":7991,"rosen":21005,"assemble":20639,"hand":769,"influenza":33059,"reluctant":9069,"wilt":21822,"mammal":30124," chat ":10065,"brookwood":24187,"misuse":4808,"nobuaki":44160,"vensatry":36466,"dagger":25964,"caturday":30403,"priyadarshivishal23":30183,"veering":32277,"boner":25608,"outskirts":32201,"festivities":31964,"numeration":37819,"unnoteworthy":37415,"―":33984,"3px":11786,"gulf":6716,"separatism":21592,"quad":24712,"providers":15855,"necessarily":2010,"researching":5255,"workshops":18945,"nerds":8755,"affectionately":48838,"miniscule":24873,"sizing":35682,"'block'":43690,"——''''''":40712,"rightfully":11115,"chrucky":44834,"transgendered":21310,"irania":43426,"liberia":41014,"ernesto":28048,"favre":14141,"crammed":25898,"remembrance":29153,"gaddafi's":41201,"fee":8662,"licensing":3165,"meier":25117,"inaugural":25301,"sounders":35511,"armenians":4554,"uck":18054,"comatose":49325,"invents":36026,"■5":42609,"homos":18940,"cemented":30236,"astonishingly":22345,"romanticism":35697,"reappearance":49178,"kafkaesque":29794,"un":1531,"conservationism":45365,"losers":6794,"reliance":12521,"4x":31789,"rushdie":23642,"moderators":6457,"assemblies":17693,"durova's":39074,"'em":7260,"finlay":32494,"moondyne":25807,"capcom":15857,"infants":11779,"bhagavata":20219,"forex":39085,"compile":10939,"failepic":8538,"backward":8015,"cunt":762," spill":46389,"vfds":45795,"ezhava":28028,"representation":3535,"ori":47499,"tna":7875,"organizers":19692,"cunning":17609,"tandem":10496,"happiness":8918,"tunguska":27001,"nucleus":23520,"baal":47929,"nk":14965,"ewww":45432,"drn":8051,"stinky":17929,"regurgitate":24469,"dutton":45238,"donkey":5890,"robson":29759,"haves":39459,"objectivist":19185,"prolonged":11746,"ottawa":10013,"marnetted":41181,"climatology":47246,"wit":6933,"came":587,"odyssey":19189,"hovercraft":32610,"linkspamming":34167,"wooden":14792,"tent":25142,"work'":28837,"underway":10849,"rajasthan":12326,"gma":21969,"wikitree":48825,"dragunov":49512,"rab":33029,"firefighters":23668,"♫":11862,"angry":2492,"barns":42590,"steiner's":33957,"jist":40076,"peacock":8644,"summerslam":28401,"tok":38758,"wikiworld":21138,"laughable":5875,"format":1257,"sorin":21451,"'oh":27438,"wither":46498,"lifeless":24634,"quota":12914,"heir":13692,"nonfree":22315,"counterpunch":15901,"discusson":45922,"indulgence":30126,"om":10277,"r1a1":35915,"hinduonnet":42273,"cultivated":25647,"incorporating":10463,"close":917,"circiut":41521,"cfd":6129,"roesgen":29394,"marshalled":45346,"razin":49905,"dietz":40135,"affraid":34086,"greene":18950,"fascism":4744,"improperly":7860,"slut":8524,"carr's":37842,"stalin":4717,"binomial":21043,"paxequilibrium":39794,"peking":22961,"embodied":32439,"hughes":9954,"howcome":48209,"extraordinary":7136,"cheapest":31916," ·":13229,"concealed":13631,"hampshire":9933,"megan":14774,"o'clock":18941,"carta":22910,"approximately":5042,"usurp":19035,"rajbeer":35016,"domestically":40874,"cloth":20443,"sup":6668,"pled":26771,"alphabetically":19940,"connor":22121,"petit":24073,"dawned":39522,"hobo":21487,"essential":3867,"brilliantly":24988,"assassinate":23192,"strawberry":18388,"holing":32657,"kizzle":39526,"clean":1496,"nauseating":40830,"geer":38667,"instate":27167,"maroun":38862,"schiffer":48738,"melbournestar":25257,"footers":36093,"peck":30009,"aeamh":31850,"ruby":15102,"genuinely":4933,"philosophers":9445,"plebs":36204,"frankl":48188,"dhivehi":18734,"australian":2097,"parasites":19531,"anto":49893,"ola":32143,"interprets":18140,"alleging":11553,"lindsay":15133,"tribe":4155,"wolverines":34087,"hicks":22780,"scrutinise":40932,"racers":28132,"merciless":18972,"cotw":12290,"complexities":28848,"fuck's":24806,"badassness":16995,"injunction":16874,"breastfeeding":48524,"blame":3037,"upi":39527,"practicing":8699,"orphanbot":21905,"neither":1052,"spas":18854,"signalled":32252,"pla":36004,"dragonfly67":49591,"saiyans":47306,"renounced":16640,"giambi":23808,"webster's":16871,"scraped":43043,"competition":3775,"malafide":31216,"deceit":12803,"ganon":33293,"contrib":5051,"heartless":25594,"appease":13830,"deductions":31255,"dedication":10624,"banning":3424,"historie":40704,"leap":8422,"sed":23856,"roc":7588,"altough":34917,"rosetta":33347,"violating":2156,"it's":78,"rondo":49912,"flowery":22994,"picasso":14274,"feloniousmonk":16886,"fwiw":7430,"minutia":21068,"adoptme":33793,"month's":19613,"jclemens":28888,"scrubbing":22683,"detention":19722,"hun":19075,"historicaly":44507,"mahavatar":21923,"mentions":1747,"romanised":30814,"acousmatic":29900,"holinshed":35219,"reed":13254,"dollars":4634,"ruing":41890,"tetragrammaton":25981,"invective":43893,"registers":16461,"intolerance":14053,"spiegel":20922,"comprehensiveness":18547,"referrence":28543,"krishnan":41719,"✍":11024,"ol'":13916,"consciously":14880,"clame":46865,"jfk":9599,"thanos":42879,"jess":17835,"uranium":11403,"esquire":23235,"bloomington":43957,"deficit":19216,"atmosphere":5462,"assemblage":38433,"denialist":13879,"cwalk":31797,"sil":38720,"movment":49189,"“fans”":45107,"ester":22116,"candid":14501,"censure":13724,"skepticalraptor":35037,"pebble":41630,"wage":8948,"priest":7470,"stiller":21863,"onto":2306,"finalizing":46156,"fk":15721,"nangparbat":32792,"mana":27123,"restriction":6418,"thegone":43372,"restricted":4914,"coworker":39686,"symbolically":22413,"neh":47701,"aids":1173,"wikiprojects":5436,"leviticus":30996,"menendez":30620,"sensibility":22104,"president's":20108,"gaddafi":11034,"waal":25054,"madame":19373,"depraved":23596,"lifers":44977,"predilection":43158,"backbiting":45315,"repulsive":18586,"decorated":16721,"devout":10908,"hurrah":36586,"maghasito":29065,"df":20337,"shore":13614,"tomato":22711,"ha'aretz":42937,"vanishing":24277,"deleated":21208,"kamelot":31751,"famicom":36881,"acknowledgment":15905,"artery":25041,"lavergne":43748,"corrigan":27257,"eusebeus":44920,"overused":22837,"shri":12656,"opens":8743,"peril":22779,"stands":1940,"brittanica":13680,"kapoor's":33418,"misrepresents":14251,"taxpayer":21240,"f5fffa":1512,"james":1445,"yomiel":33170,"liability":14530,"bozen":28469,"teaching":3937,"yup":7245,"sahrawi":12476,"zelda":13970,"oxidation":49350,"rand":8572,"myra":35961,"canadian":2009,"jeff":4648,"fixtures":31242,"kant":13586,"tribute":6303,"r3":45302,"puffy":31589,"loops":28750,"finally":1025,"indie":9260,"valentine":38128,"gmc'":48894,"auditor":32499,"abundance":12165,"coroner":20856,"grutness":42888,"livre":47248,"employed":4710,"lebprofiler":48163,"molten":24181,"mosquitoes":31889,"employer's":36763,"elderly":14791,"pagename":16549,"watchlisted":12827,"chickens":15962,"mythology":4766,"headbomb's":33946,"yerevan":20256,"disambiguating":19334,"ingredient":18209,"concepts":3253,"lyon":14917,"instructive":35240,"consecutive":10679,"chronicle":8603,"pardo":32558,"critiqued":40397,"gms":44804,"2ch":44192,"ado":25933,"wto":48962,"greatly":2672,"divorce":7064,"puerto":5380,"patty":24755,"university":758,"minaj":23400,"hunter":5638,"didier":46902,"celtic":4703,"selimovic":47095,"defeat":4805,"editors":183,"feeds":17320,"unchanging":30392,"established":1197,"tireless":7943,"geographical":5329,"fathom":18926,"sahiwal":31640,"maintaining":4900,"udi":47140,"economically":11372,"phraseology":31158,"seaside":35047,"henrik":21484,"sorted":5531,"averaging":30334,"repressive":19968,"karadžić's":41541,"jamaican":13433,"noviceuser":47291,"ernie":13772,"something":167,"geometry":7646,"ariel♥gold":15971,"tualatin":38684,"badge":6077,"cries":13891,"jedp":44365,"exclusively":3907,"hesitant":11325,"moor":24262,"effected":13437,"mukim":49929,"katy":13315,"garnered":19590,"numerals":8897,"travellingcari":40769,"judging":4272,"lakh":32198,"mans":14939,"gakhar":42597,"parthian":23454,"vuvuzelas":8075,"huh":3015,"blam":42467,"fetish":12546,"modalities":25615,"socialistmedia":38517,"hemorrhaging":37222,"serers":22882,"sexsex":2755,"arcayne":12253,"theoldjacobite":13490,"ftp":29840,"coyote":21216,"deco":43151,"tertiary":6696,"suggest":463,"solar":5162,"monday":5342,"presumptive":24919,"airplanes":20022,"haplogroup":15193,"femme":24678,"ferdinand":10347,"竜龙":14169,"vinnikov":33770,"“wikipedia":36517,"platter":40312,"parenthetically":47722,"plurals":17867,"borges":35225,"romania's":34538,"radio":1911,"complainant":20234,"lászló":47519,"disam":28702,"dcu":33859,"haywire":34858,"metapedia":31313,"aramco":38484,"sven":19255,"oghuz":25868,"romance":8306,"google's":15086,"vegan":8969,"rwanda":22635,"xian":32690,"gl":23000,"lasker":45869,"blogged":48500,"clothed":22987,"might":187,"bah":16805,"cquote":49916,"grinding":19096,"inlet":26119,"rawat":8330,"herrgoebbles":40297,"keepcalmandcarryon":47672,"nonsence":25044,"barbados":21801,"solitary":14456,"scattering":16342,"paris'":44721,"disconnected":20889,"torchwood":46894,"panzer":23036,"alberta":9278,"finish":3163,"predjudice":39822,"deposition":25872,"23rd":13944,"qualifiers":17565,"devastated":24955,"commodore":17420,"albany":15269,"aerith":34953,"swung":39349,"ishte":49457,"planing":47431,"yandman":17388,"gusle":15204,"solving":9046,"kimimaro":33733,"djibouti":34429,"querying":39339,"dutt":45758,"unlawful":14303,"defray":44815,"tract":13782,"unsuitable":9285,"amply":26485,"halim":31893,"utter":4619,"columnists":24751,"january":992,"astral":29370,"nra":22747,"triple":4804,"nicer":9543,"filters":14593,"zogby":44942,"reloading":40848,"nana":35433,"gt":13322,"rastafari":31256,"furthering":21167,"dunch":42842,"seasoned":18217,"ncdc":25268,"businessinsider":22331,"kumamoto":46273,"gilmour":30413,"debuts":42045,"sanders":15725,"music":660,"slows":26700,"bragging":15071,"wikipaedia":15539,"checked":1517,"trolling":2019,"nwa":33587,"wobbs":25653,"abdominal":47709,"rko":43153,"barneca":28309,"consolidating":37383,"adidam":35775,"helens":26605,"payers":45960,"ominous":49016,"lfi12":44030,"humperdink":37526,"insistently":40357,"neighbour":17247,"sponsor":12350,"mood":6385,"vie":26563,"cobb":20813,"attached":3835,"hehe":9163,"inspect":33346,"ploy":17258,"demonise":34263,"vapour":41380,"inadequacy":28534,"rundown":37847,"🍌":32298,"'two":47845,"ttp":36365,"wandsworth":48590,"antagonists":39289,"mustang":16004,"jackass":6339,"thigh":24699,"btw":1187,"gardiner":29514,"anton":11973,"idle":10276,"akradeckispeaketh":39317,"deoria":38843,"doctor's":17384,"notion":3543,"plantations":20546,"everytime":6674,"oddball":41091,"unserious":42619,"angolan":34763,"accustomed":17312,"laurent":12990,"hippo":21495,"tafsir":32345,"indirect":9559,"candidature":22263,"els":35049,"testified":10084,"processor":9162,"inquirer":17583,"soiled":48470,"rgds":41185,"unless":560,"spp":47402,"defendent":30432,"fap":32798,"norton":12336,"criticize":5742,"guns":4216,"beatable":31384,"vulgarity":21617,"fetal":12528,"spoofs":31687,"hh":30317,"vellore":48145,"cereals":48372,"lesbian":6434,"mullen":43149,"customs":7920,"fabrications":15784,"tissues":26671,"reuploaded":49021,"reeling":47590,"inducted":17766,"faizan":40780,"inhabit":31854,"fresnel":41387,"conservatism":10877,"deterring":49670,"kwanzaa":25737,"hesitancy":29712,"rationalized":39483,"wolfe":16444,"undetected":30371,"msuspokesman":35363,"jonas":14258,"sampras":44630,"ncr":41361,"citeref":31354,"mainline":29492,"cowards":11092,"affiliation":6611,"overwrite":17915,"sidebar":8395,"mcgreevey":37896,"vit":23159,"disparaging":12235,"punishment":4095,"marc":7297,"log":1240,"drink":2863,"hahahahahah":40826,"labourers":39764,"chill":7147,"jason47":43636,"she'd":15072,"gameon":48678,"emendations":43236,"choppers":23719,"expressway":13803,"dajjal":33098,"meaningfull":47612,"pronunciations":14691,"edits":126,"girlfriend's":35375,"slide":8594,"estrada":44801,"jul":5306,"awp":44108,"bathory":32122,"bitola":29716,"mirko":49218,"bingham":37579,"numb":35137,"imports":19796,"rattling":33595,"dankal":44889,"constraints":13442,"enrolled":23395,"roe":23234,"pineapple":37125,"regaining":32412,"congregation":13706,"must":251,"karoonga":46335,"slides":24563,"jollies":33105,"treasure":9273,"tudors":48291,"ancestries":28512,"hasbro":43692,"lat":19508,"batista":12028,"pioneered":23016,"polytheistic":44115,"housemate":45547,"aerobic":34099,"mountainwhiskey":27798,"metroid":27440,"conscious":10125,"myst":23743,"bulgars":24416,"radiopathy":35168,"rod":7755,"elan":33633,"templating":21098,"cures":21692,"unsafe":25717,"antun":44914,"aldrich":38317,"asher196":49587,"yor":22520,"mourn":42468,"damage":2229,"boi":13612,"jpg'":33753,"thusly":19851,"promoters":15537,"starblind":32182,"faheyusmc":44135,"sho":14407,"wiradjuri":24808,"temperament":21294,"artcle":20049,"   talk ":24197,"landes":44569,"lingus":39593,"impediment":32343,"misc":17921,"ettiquette":43440,"unlicensed":5768,"theistic":16520,"«":14909,"restoring":3620,"oversights":46800,"reynolds":15028,"strenght":28200,"irredentism":32947,"diatribes":21448,"diffraction":38374,"typewriter":20981,"repetative":39091,"historicity":11933,"runoff":40530,"this":13,"gastrich":14139,"austere":33561,"δbutler•":21839,"intro":2030,"raided":37994,"balen":34176,"trajectory":22279,"isl":46204,"dismay":25002,"sheltered":30758,"loreto":32452,"faction":12518,"concessions":15363,"middleham":43549,"nationale":28953,"abkhaz":43600,"meats":36816,"transatlantic":44818,"co":1178,"cholera":41425,"year’s":25240,"ayodhya":21505,"commit":5711,"fluent":10778,"epo":26617,"timtrent":45494,"occasionally":4124,"tip":4618,"davies":12482,"esl":28106,"absurd":2827,"retroflex":48836,"primates":25378,"medvedev":26695,"final":1065,"robtex":21104,"appart":43855,"erode":48144,"coal":6342,"busy":1896,"mammalian":40782,"new":117,"fortitude":44425,"postponed":20707,"adrenergic":34978,"p2p":25510,"faddle":17246,"kindly":2372,"brock":11917,"aggression":8199,"solidly":17846,"subak":34743,"stability":10448,"omitting":11118,"mothers":8785,"housing":7124,"stiffness":34987,"kahlen":43502,"remarking":27915,"christianization":46957,"gona":25308,"differentiated":23939,"reds":21084,"jonny":37853,"constance":31495,"dost":45101,"faq":4405,"nate":7385,"ranch":17777,"rebuke":24475,"ctr":35250,"woohookitty":22247,"hosting":7319,"beback":13260,"shortsightedness":39840,"iryna":29365,"ru":7481,"25freehuman":36062,"sigh":5428,"chibuike":37022,"iamunknown":25279,"jaws":17138,"journalist":3751,"trained":5116,"quasi":10433,"estonians":18311,"profitable":19246,"tartar":44163,"cg":10864,"neotarf":45561,"imslp":48947,"السلام":45827,"annotation":28137,"ssl":36017,"currents":14470,"dopamine":14373,"incharge":38946,"unchangeable":47096,"´":16079,"escapes":16205,"outlandish":18492,"fluoxetine":36918,"munthe":25743,"nastiness":23195,"reflist":9433,"consummation":38669,"infantry":7930,"salacious":27671,"shaman":21856,"espousing":32238,"mothjer":2047,"strenghts":38919,"tcw":44722,"oedipa":44113,"jari":45596,"keepers":20925,"wrongfully":12411,"im":808,"fitness":10456,"remarkably":13480,"syracuse":17628,"qaida":28657,"anya":49250,"wedgie":49473,"offender":9934,"amateurs":16116,"grandiose":26716,"tied":5517,"soap":5871,"crunch":13675,"decoded":49403,"''''''the":16016,"aroung":43021,"likes":2272,"tabthere":49354,"ether":17084,"fees":11588,"jimmy's":40740,"planters":45234,"everyking":27855,"partial":4463,"worn":8532,"attitide":49696,"spoiling":15756,"bathing":39415,"ronaldinho":33309,"intoxicated":20956,"regurgitated":32739,"move":473,"triggered":11579,"cortez":15844,"wd":40859,"scrip":36649,"untrained":34355,"jacobs":20689,"herut":27523,"explanations":2990,"mtv":7642,"owning":10792,"puritan":30860,"klf":46693,"wlaj":35539,"andover":40972,"meatspace":47737,"prolific":12315,"altair":43965,"ellipsis":27130,"mitch":18150,"sans":14687,"age":1119,"manifests":25987,"susceptibility":43788,"seam":30446,"stalk":4572,"hackles":28362,"joyce":14598,"c's":34063,"rama":10589,"uulyn":49389,"cornea":13498,"displeases":40369,"salah":24318,"theoretical":5697,"medrs":9594,"mauco":17899,"matted":43209,"butterfly":15870,"mirpur":43297,"downtrodden":36504,"mintsoftware":38573,"checklist":16354,"2014‎":10932,"goldwater":28472,"composite":15106,"ashcroft":38777,"exept":32840,"hopi":46625,"sparc":42012,"jeffersonian":34028,"guitars":11898,"alteration":12027,"manuals":15798,"billings":46229,"fullmetal":31509,"allergy":22115,"gathering":7708,"goth":9383,"lightening":31168,"nested":20860,"covert":11395,"rowena":47255,"astounding":17340,"occidentalis":39899,"citrix":44909,"wiesenthal":19465,"iec":25695,"shepherds":17228,"mpaa":28607,"shill":12504,"editor's":3447,"humbly":13964,"lackeys":41575,"wolfhart":27318,"discussions":1144,"downwards":21616,"obi2canibe":41329,"offers":4677,"camels":28781,"dat":8099,"mypage":49915,"opining":28718,"dieter":42117,"tunisia":16402,"medial":48611,"jocular":42172,"leds":29961,"po":9160,"subpar":43642,"training":2652,"delist":19903,"hyperbola":37084,"formations":22370,"defence":4156,"asswhole":16013,"finacial":39142,"ivins":39738,"shrewd":42805,"attack":443,"gilt":41453,"mischaracterization":32906,"locale":34709,"centralized":10827,"burgeoning":42919,"olympus":28922,"location":1820,"labelling":11013,"dum":22371,"jakob":37946,"selfless":28064,"maury":34018,"gawker":22330,"fil":36432,"road":2113,"apprentices":44614,"parapsychologists":45962,"dora":27544,"toto's":38592,"52talk":40133,"polls":6469,"brokaw":18773,"uon":48442,"notices":2749,"len":22524,"chinooks":39534,"deleting":643,"reediting":42907,"tomb":10464,"interacts":23427,"schoolchildren":45628,"brazilian":6220,"pashtuns":6251,"range":1589,"forking":18256,"anesthetics":44195,"listings":5700,"dearest":18717,"furg":47382,"smsarmad":33360,"socialistic":44271,"egads":42284,"footnoted":14235,"crystal":5217,"wikipedialies":17869,"''''''love":27699,"reset":8772,"completion":12129,"statewide":32342,"reproduce":9638,"dynamic":4464,"starcevic":39121,"affront":21667,"barry":6777,"gideon":31654,"terminated":12308,"complement":16254,"terminological":32934,"colossus":26509,"cddl":48423,"universe":2251,"spiraling":31279,"endangered":19091,"rym":25094,"risking":16495,"rework":13975,"influences":5670,"anc":25398,"geshe":31196,"garment":23722,"propagandistic":22776,"emc":44558,"gounder":21106,"don´t":8690,"constraint":33621,"gaylord":24266,"archos":39968,"gutenberg":25042,"protonk":27201,"charity":6812,"crypto":11112,"ceasefire":32565,"hickman":37158,"lyoto's":49298,"smerdyakov":37791,"pitching":32980,"risk":2830,"jjl":41564,"topple":49049,"feathered":35292,"repeatedly":1314,"hereditary":22607,"drawbacks":32760,"yod":39235,"mz":33184,"math":3545,"fuckfuckfuckfuckfuckfuckfuckfuckfuckfuckfuckfuckfuckfuckfuckfuckfuckfuckfuckfuckfuckfuckfuckfuck":17996," not":45569,"communes":18906,"scandalously":48687,"starfire777":23586,"chillout":35449,"blooded":18560,"'how":21318,"ryulong":7341,"disrepectful":47083,"fightmetric":30320,"characteristics":4854,"about":36,"buttface":43864,"modulate":47439,"065":35470,"elamite":46913,"greil":47852,"contravened":41182,"rescuing":28068,"armament":28723,"winfrey":29632,"berg":17398,"packers":31024,"raceway":37170,"momma":17656,"participate":1689,"kat":14369,"asp":5398,"atomic49er":38149,"'vote'":45449,"deeptrivia":34776,"womb":30787,"goyim":24864,"juli":37447,"milošević":32590,"wallaby":31298,"reunification":23444,"oven":18543,"yves":36524,"inhabiting":38040,"weeklystandard":48223,"youve":11342,"geometrical":28498,"piles":23343,"borg":20051,"newsmedia":39113,"dem":9894,"controversies":3906,"insomnia":19311,"admittedly":5756,"peole":32741,"yobmod":29541,"northwoods":46935,"suppliers":26335,"stimulate":23947,"fibre":39097,"hornswoggle":30052,"seize":17017,"clergy":11751,"pupils":15990,"offence":4781,"vandercken":39610,"summarize":4609,"grains":26178,"valve":21332,"eliot":22401,"station":1992,"eagleton":33014,"paulwicks":38629,"so":37,"shrine":12337,"mecklenburg":42834,"pinkadelica":33114,"military":910,"humanistic":25416,"synthesize":20882,"lexicon":15823,"joel":10101,"incur":26206,"society'":38079,"mischief":15340,"settlers":9798,"domains":12072,"westernmost":44917,"contents":1597,"nixer":24028,"usurping":35912,"navigate":10481,"trekphiler":30998,"underdeveloped":25034,"contains":1690,"obi":19752,"aliasing":31803,"1m":34146,"demote":48557,"realiable":24035,"c3":9328,"sightings":19380,"recent":512,"multicam":38640,"civilised":14540,"fractionation":40975,"claimant":18435,"loved":4977,"cest":17935,"barnstars":7666,"ricans":14025,"gud":40898,"ville":25896,"''''''87":17342,"omaha":21065,"radiological":35190,"conversing":30747,"hon":19418,"lowercase":11930,"hunts":23678,"positively":6756,"katefan":41412,"shaykh":35159,"are":19,"mosed":45324,"vandelism":18307,"bolsheviks":19732,"your'e":36639,"duklja":17510,"bulacan":42737,"heraclius":34113,"naughton":46083,"denigrating":21403,"lol'd":27520,"qs":19017,"inkscape":21134,"qutbuddin":16983,"guede":48900,"hamashea":33643,"canon":5873,"scholasticism":48667,"gvnayr":21574,"arbiters":27590,"enraged":37058,"fatality":33427,"inexpensive":31282,"progressing":18282,"rvdocsum":38346,"methanol":38336,"tac":33192,"wiseman":33229,"patrol":5501,"wikisyntax":35128,"xenophobia":16602,"volkswagen":36136,"strawman":10397,"pals":16486,"neutralhomer":16864,"micheli":38525,"nuclearwarfare":42606,"ragan":34843,"liberate":21331,"mastering":24460,"davien":43669,"interpretative":30725,"ic":17990,"dicklyon":13306,"rectangle":26728,"cogden":39592,"butts":17337,"steadfastly":39933,"fined":21352,"disturbed":7123,"hunger":10060,"commonname":10709,"rodríguez":29835,"greenwich":36582,"ilya":44820,"synonymy":49217,"spewage":33365,"emphasizes":14711,"wheels":8678,"eliminate":4871,"booklet":20745,"engagement":10236,"drops":10412,"witness":5440,"exude":45145,"44af":34332,"isil":18298,"adige":16469,"poles":6086,"enhancements":29758,"linkspam":16419,"substitutes":34202,"kobres":29230,"distro":24700,"consumer":8789,"yuga":28708,"á":31920,"fifa":8059,"debbie":33167,"aspartame":49395,"aquinas":22278,"centro":37872,"dhillon":36208,"nishidani":16921,"suresh":27498,"od":9494,"behavioral":10901,"mam":21541,"immortality":26186,"dartmouth":14248,"kotaku":36791,"bachelor":14583,"frequency":5250,"probs":18695,"wartime":15727,"theocracy":25884,"heaped":41231,"messaging":13870,"dori":27067,"titlemedia":45512,"citelead":44658,"tylas":15595,"legitamately":48370,"ordinarily":14465,"tiberian":44938,"owes":16882,"promblem":40542,"adrienne":34462,"sexualities":39087,"bums":36963,"whe":32820,"intrigue":30079,"shah's":24690,"'evolution'":46655,"ale":20533,"africa's":37956,"badaga":29417,"mmmmmmm":46137,"participants":3495,"safeguarding":44628,"melbourne":7348,"unnotable":15063,"rjecina":28542,"becase":29148,"favorite":3430,"meier's":34314,"muay":22437,"hacer":37639,"bail":8910,"mortem":41398,"ogle":42285,"grouping":10872,"dollar":5946,"fiesta":44681,"baking":43640,"quarterbacks":29133,"backtrack":36913,"ani":1346,"mase":37329,"received":1318,"avril":17330,"ia":9805,"euromyth":49525,"pxe":21924,"woodzing":35532,"proclaim":12668,"—15":43717,"exploded":20846,"relativistic":16947,"asbestos":17119,"templars":21956,"haploidavey":40538,"saskatoon":35564,"determines":10845,"barefoot":24309,"pa388":49800,"buried":5514,"oaks":29668,"wikians":27775,"pancreas":38960,"apparant":48269,"management":2924,"florence":15013,"transcend":45918,"mandir":29385,"indoaryan":49878,"'please":37205,"calculating":18203,"serv":48003,"demolishing":37491,"anther":28939,"sums":10143,"mesh":19635,"vandalistic":16702,"cz":34191,"johntex":44211,"yulia":28177,"ralph":10844,"евлекис":35932,"gripen":46151,"nla":18382,"fasri":48888,"recieved":7855,"brazil":4517,"geologic":22112,"xp":10875,"colts":28844,"fouling":48405,"someone":159,"hoe":15841,"hypertension":19155,"sa":3016,"taxpayers":22739,"tiles":48988,"counterterrorism":49898,"johnny":6111,"disqualify":18251,"monaghan":37708,"aggie":22424,"pearl":8452,"democracy":3099,"midst":10657,"everthing":21231,"murrow":47356,"woody":15230,"tesla":9079,"confidence":4831,"ontology":24081,"copyediting":6882,"scapegoat":23278,"needles":27108,"karwynn":20462,"rune":48357,"mosflag":47207,"laredo":42485,"benben":30075,"larry":5593,"conley":27109,"sensless":49080,"koot":28428,"wart":39022,"transport":4901,"borić":32818,"rodney":17066,"dui":41194,"matrices":24706,"curent":45312,"upholds":33160,"colli":44494,"behaving":7139,"drafting":12124,"doomsday":27961,"proselytizing":26517,"insulin":28852,"confederate":8887,"impaled":32404,"vest":29006,"kinematics":46459,"measurements":8364,"supersede":33274,"shave":18134,"tonal":35940,"tl":15007,"alittle":34980,"russia's":16873,"noahide":43597,"del":5640,"sceptre":19338,"monastery":17200,"notthem":37128,"testing":2877,"undo":2119,"ideas":1231,"bay":3735,"enjoyable":12333,"marcovitz":22982,"ration":42329,"nadu":9962,"frequently":1760,"statics":46849,"ıs":26520,"uluru":44845,"organ":8031,"satisfied":4594,"awf":36781,"''this":44311,"disliked":14929,"rihanna's":27115,"metrology":29287,"110th":46718,"usaa":46943,"you've":516,"jatia":48979,"has":43,"conjure":40431,"sorbs":34164,"hom":28170,"allegro":39011,"ac":4966,"call":459,"iaru":47603,"grunt":41277,"eeekster":37632,"unsolved":17743,"corrie":11268,"viruses":13218,"picture":496,"cuntliz":5955,"coordinated":11226,"berlin":6473,"burnley":38729,"listened":8625,"posed":8664,"hijacking":16253,"marx":7627,"jujube":22790,"mire":45911,"dmitri":33028,"cabot":47037,"rove's":46463,"critters":33961,"prima":13790,"organizer":21903,"curl":26962,"tactic":6531,"performer":13415,"lsd":16478,"piled":31966,"graces":40129,"cowboys":13348,"nagpur":29563,"steals":25587,"fission":14138,"alumnus":17221,"injuries":9205,"confuse":4105,"bosna":39369,"disqualified":18113,"η":44286,"sabbath":17736,"colonialists":40409,"childs":26479,"anarchists":11573,"pertinence":41684,"inconvenience":7632,"elf":13349,"tanker":21596,"clog":29652,"libels":40109,"walkers":35422,"matchbox":36703,"metal":1457,"ofa":28579,"correcting":3343,"init":32209,"radiokirk":30533,"karaman":46950,"bdi":45650,"rescue":5948,"ngo":10718,"bulldozed":33066,"shower":11603,"johnson's":14663,"fledgling":43235,"structural":8054,"malaka":48839,"l21":38767,"exponents":34803,"tripping":17938,"oireachtas":47704,"mes":43619,"kali":23094,"repeal":18019,"abolition":33879,"franchi":32185,"materialscientist":14602,"guess":645,"albeit":5347,"biographical":3297,"harav":39493,"deferring":42412,"videt":36087,"on'":36036,"“if":19815,"border":1000,"rance":44592,"singularly":26546,"malakas":48837,"motorboat":45517,"'talk'":34005,"dit":35966,"fceb92":32557,"bears":6264,"immunization":37656,"helvetica":44496,"hollywoods":46549,"dprk":38281,"desease":49051,"turban":36169,"ciccone":41950,"loch":20014,"rudder":40786,"formalizing":38969,"boor":27083,"londonderry":18625,"fort":5171,"syllabus":36858,"tenstringguitar":29534,"bandwagon":16389,"fundamentalism":17669,"witnessing":24407,"harangue":49072,"pedro":9602,"evo":27342,"azeri":6012,"iteration":16968,"philo":25447,"leicestershire":36812,"trotsky":26988,"thereof":7078,"bighaz":44868,"friends'":26081,"linguistical":46052,"ssris":43790,"tune":8509,"imprimatur":28790,"haley":18872,"pairings":38655,"felice":31911,"voce":43915,"een":38639,"klenk":35535,"andric":30233,"bruins":44629,"nuked":28947,"violations":2080,"goebel":46419,"bråten":31732,"intriguing":14068,"royalist":19640,"hopefuly":47204,"megali":22306,"emulates":45135,"tiffany":17489,"schoolyard":34943,"ø":15600,"placeholder":16117,"subgroup":21266,"malbolge":46775,"latakia":40096,"governments":4361,"already":229,"remeber":18835,"pages":116,"smiling":8107,"nota":44058,"noticing":6834,"insurance":6484,"brr":26501,"continuum":15820,"toba":38144,"keller's":32887,"clause'":23930,"dissents":40588,"bases":7384,"delusion":11557,"thou":7171,"mergefrom":46687,"okie":28450,"muze":27734,"bhagavad":17368,"redid":41166,"infidel":27303,"alreayd":42908,"mario":4425,"doctored":27552,"uncountable":28977,"agood":46162,"pathology":22720,"lucy":10039,"desiegel":46018,"logbook":48350,"booyaka":37040,"vanilla":15397,"inactivity":16301,"victimhood":39266,"syriac":7590,"dei":18026,"coerce":29732,"ohp":19453,"mikael":38285,"each":425,"dealers":28436,"treats":8826,"idht":20416,"america’s":29053,"bitchmattythewhite":5141,"masters":5291,"mtdna":15494,"describe":1228,"resistive":41882,"“we":18135,"greece":2413,"msjapan":41021,"ragusa":20814,"cwru":47925,"die":504,"disagrees":4025,"viewtopic":35892,"datetime":38711,"malay":13733,"absurdity":11637,"whit":20794,"hussain":18900,"additivity":45146,"unanimously":18104,"vulva":41836,"immense":11149,"aditude":48175,"aitias":38445,"harmankaya":23101,"aricia":35841,"marathonios":47712,"adil's":30487,"jessie":24176,"urartian":30658,"lucifugum":34646,"goodbye":4206,"pioneer":13989,"ë":44283,"buggered":47725,"zee":36503,"weakest":16171,"accurately":3158,"ethics":4479,"yout":33134,"mw":11836,"antifreeze":21914,"advertised":12325,"starfleet":34724,"adf":38188,"nigel":21151,"maher":8152,"invovled":39955,"ts":7540,"graceful":14321,"someting":27760,"transporter":24887,"hell":850,"paramithy":48058,"smack":14775,"imbecilic":39863,"trickier":43214,"onscreen":21707,"possessed":12095,"trusting":15390,"vines":39263,"region'":45588,"igloo":47323,"assertions":3619,"iverson":47077,"indexes":19037,"greer's":38136,"vandel":42024,"sql":15449,"disks":24657,"overtones":24142,"ramona":23320,"tanner":24499,"notch":18904,"protocol":5785,"wikithanks":42652,"byob":44228,"unending":36259,"accrued":49150,"defacing":13178,"ali":3645,"name":111,"degreed":39672,"jessica's":47357,"proclaims":27616,"inclusionism":32188,"they'll":4381,"ambi":36225,"darnell":34194,"rfcu":12904,"bats":12664,"ignore":1210,"mykungfu":43687,"enviroknot":43561,"devil's":14516,"customsig":44600,"deceitful":18804,"situations":4230,"oscarthecat":42416,"gibbering":49877,"serpent":13744,"unquestioned":35463,"dramatica":13422,"klu":47913,"aces":16222,"satisfaction":6547,"guerilla":17569,"benzos":35893,"izzy":27762,"mongols":11308,"eviction":25457,"hayes":11961,"acusing":40918,"pete's":27614,"charge":2227,"johns":14903,"almond":36285,"quoted":1847,"cubit":49164,"robes":30702,"peyton":28860,"trolleys":43485,"alansohn":33413,"jaobar":34761,"gorbachev":40791,"friendship":8723,"rozz":21275,"michel":13284,"furs":46306,"assimilated":14542,"dam":8632,"endless":4595,"lowers":39226,"p's":30621,"organism":16441,"extratropical":31707,"presidential":4502,"mikhail":20107,"''''''wordsdeeds":39010,"swp":23071,"talk ·":7144,"vicarious":46846,"intensive":19385,"campo":29383,"minister's":25860,"southwick":48135,"indo":4813,"characterised":23718,"cannister":38868,"busch":34879,"invisibility":39032,"1800z":16361,"prishtina":34625,"ravi":22176,"ghazni":49115,"amp":32057,"manufactured":9938,"chambrun":38345,"dan":3448,"skills":2471,"navy":3980,"canning":41152,"primality":38508,"unsavory":32997,"nasl":43941,"beltway":47401,"bombarded":36030,"formality":34870,"unauthorized":13368,"locally":11982,"ddcef2":19375,"eines":44570,"baybayin":30133,"infos":16232,"bengaliidae":34658,"illogical":6695,"notice'":44543,"classicism":46413,"tenpoundhammer":25434,"autoformatting”":37904,"templated":16791,"mack":26774,"malkin":38986,"theorizing":30391,"worm":10468,"yey":49493,"fop":28467,"hagee":24567,"presidents":6443,"sega":10740,"tokushima":16998,"scant":17998,"meiji":29182,"traitors":17720,"accout":43169,"lemmey":23188,"sphincter":42395,"''''''''":33749,"unstable":8905,"sooo":13307,"evenings":35338,"person’s":38496,"f'":43376,"boyd's":45468,"cripple":31416,"estimation":11906,"whispers":30225,"despotism":40031,"prerequisite":20823,"ephesians":32593,"horny":16022,"exit":7880,"association's":37077,"notcensored":19553,"suk":35403,"sudras":49791,"nuts":5870,"powerpc":27600,"→toth":47942,"bfb1a3":28729,"nosense":22952,"callsign":23345,"plase":31390,"accommodation":13581,"subcats":26542,"plural":5110,"prefer":1487,"turkmenistan":25963,"trumpet":15112,"apologise":3485,"kenya":12738,"reinforces":14720,"overdone":33150,"ed17":48555,"warez":40608,"exiled":18292,"disposed":26601,"basketball110":36416,"brookgreen":34760,"'key":33993,"ignorantly":28726,"organisations":5330,"habitat":16764,"ndh":17352,"ceramic":25505,"unshakable":42267,"clothing":8042,"manoeuvre":39250,"terminate":17616,"supporter":5389,"harding":17851,"weakening":22204,"commonwealth":4448,"coating":29158,"gigs":33001,"pronuciation":44132,"henrique":48645,"goodmorningworld":46782,"prosperous":17319,"blanco":35706,"dexter":35160,"visa":10826,"dianna":46442,"trivially":19565,"height":3411,"ihope":47542,"atc":36302,"tirana":41694,"negitive":47754,"namibian":47831,"unreviewed":17772,"antibody":48014,"hailing":17729,"corrupt":4422,"panda":12580,"fenni":47209,"dilbar":48675,"bushell":46135,"clogged":40051,"tremendous":10105,"civilisations":27791,"dependency":21945,"gallon":26399,"hack":4670,"pst":13285,"deign":28617,"shopkeeper":20132,"nrdg":31440,"critiquing":23313,"someplace":15486,"guarantees":17336,"revamping":39913,"craftsman":47040,"libeling":34322,"neck":5775,"opponent":6833,"meddate":26897,"analogs":27139,"candidacy":13890,"gina":16839,"regt":48704,"woodville":40057,"ranges":7062,"bowlers":46915,"epica":24185,"grudgingly":48813,"pinochet":19192,"wylam":38566,"hq":14393,"attributing":10967,"simpleref":37587,"gentleman":8605,"babloo":49515,"comrade":17394,"conlimited":39608,"maldivians":32908,"balrog":43609,"swastikanews":38512,"pickled":39147,"psychiatrists":33416,"dustbin":18706,"lega":42102,"nappy":49671,"oxcart":46001,"barriers":14416,"incoherent":5535,"pornography":6857,"desolate":29091,"plo":21245,"allophones":33143,"charger":44511,"hopped":42085,"indexof":36570,"neblett's":40177,"derision":25906,"marean":20607,"innocents":23467,"goths":18225,"knowlege":17634,"aix":39598,"marella":38809,"furious":15903,"traveller":23773,"ifeq":27116,"regulatory":17564,"pwc":29176,"washingtonpost":22479,"jeopardize":47755,"damon":16317,"supervillain":41989,"contentment":49342,"hampton":24271,"unterm":48785,"royle":45214,"benny":15090,"bosnians":21970,"geo":7300,"ainsworth":38995,"broadsheet":35704,"mevlana":49586,"exploitation":12145,"vanu”":25452,"'out":27003,"saddled":45407,"perfecting":33933,"nobel":4785,"esq":28979,"tower's":37215,"resonate":14622,"brenda":24697,"cultist":30147,"emitter":20425,"worshipper":41646,"brandon":10676,"communication":2871,"suny":41469,"ronz":13670,"edge":4537,"humphrey":22733,"forks":18257,"insolent":33909,"coup":5895,"windsor":10686,"j2":13698,"you’ve":16203,"issue'":49056,"stacks":30297,"pander":42326,"amir":18169,"mexicans":2376,"peoples'":10544,"deor":24225,"aimed":5331,"kisser":46091,"saturated":18397,"congenital":37521,"unfolds":42036,"seth":10157,"fix":890,"brosnan":30164,"wednesdays":37033,"graphics":7111,"п":44292,"sorority":36707,"chua":43831,"tonite":45761,"rush":4242,"accounting":8165,"emphatic":18724,"lyk":43191,"transmitted":13520,"chew":15200,"arabism":33668,"kyle's":37909,"denali":45866,"fidesz":43160,"genre":2132,"aorta":48624,"kathman":45121,"bus":4620,"bpm":28831,"foolhardy":39849,"realms":9530,"exaggerate":19159,"welterweight":39334,"deliberate":4378,"ruud":26641,"stinking":17408,"lexvacpac3":35169,"puny":22680,"unnatural":22098,"drawn":4014,"cute":5720,"accelerations":25364,"glick":29390,"wikiland":17298,"benefit":1872,"mickie":37688,"rousseff":39746,"schumacher":17369,"frowned":8585,"hercule":36630,"sanction":5419,"spawned":13893,"tp":12152,"maneuvers":25298,"stages":9396,"ips":2340,"foresters":23174,"arbmac":16717,"kambojas":30484,"busily":40324,"kaplan":35588,"africa":2222,"mahal":19943,"queued":48909,"inverted":13557,"nov":2881,"plot":1855,"photoshop":8721,"afford":7704,"mentuhotep":43966,"entanglements":42038,"quoting":2846,"severely":7906,"orgid":43352,"absentee":32096,"nccam":43202,"junta":21158,"orchestra":8909,"oa":18647,"oligarchs":37594,"catalan":8304,"arrive":7028,"robo":22195,"besmirched":39410,"jamming":23600,"physicq210":24771,"judd":34157,"it´s":7525,"tintin":34468,"ineptitude":43100,"gram":21242,"damn":1194,"lohan":27322,"diss":19612,"ranger":11154,"crowns":22494,"orthographic":27782,"conqueror":46321,"northwest":9757,"utterances":28371,"abolish":19537,"tapper":41032,"denoting":22049,"shaker":37010,"sullivan":16017,"malabar":16977,"mineral":17010,"bronstein":36977,"ec2":39083,"pascal's":43653,"republican":2699,"'m":15604,"thorough":3903,"attendees":21382,"flute":23034," —":10189,"thwarting":35814,"vigilante":17073,"hahn":33823,"hopeless":10884,"wayward":23522,"valign":7254,"hada":39692,"epa's":46581,"complained":4771,"sheriff":14569,"wholly":5315,"sar":28706,"alowed":37429,"neturality":46017,"lowly":17053,"klm":29466,"avec":21880,"likened":21264,"bosendorfer":21003,"doubters":36862,"helium":19333,"metohija":37085,"pscyhology":43046,"enantiomer":47479,"curlingbox":37363,"information'":27670,"haahhahahah":5416,"aspirations":22054,"haunts":43743,"reduce":3223,"esperanto":33666,"familier":43514,"railroads":31462,"orgin":30004,"delusional":7987,"adherent":28663,"trivial":2867,"omits":18793,"weibel":29393,"soc":14066,"massacres":6633,"hula":26985,"claudio":32136,"embellishments":33822,"o'neal":33056,"cair":23339,"zealander":28695,"л":38906,"☻":19808,"gunpowder":27985,"countess":14947,"battlefield":9384,"playable":12582,"blp1e":36211,"neutralise":36536,"concerts":12293,"transcript":8394,"kellerman":49981,"capitalized":5990,"babak":23133,"articile":46296,"transhumanism":39615,"'london'":46157,"acre":20825,"bowled":28301,"allingham":47293,"uninteresting":21132,"spectator":34273,"vedic":10975,"respiratory":41360,"artices":48531,"parasitic":30216,"rana":17622,"foreman":46774,"evlekis":45765,"viewer":10058,"bhubaneswar":19989,"seige":33725,"bell'":20789,"mercilessly":14646,"analects":42572,"sabotage":11381,"upto":20034,"septembre":42574,"ringleader":45610,"precedents":13011,"countenance":39018,"hoefler":43999,"moot":5780,"library":1806,"3ds":39248,"harness":34654,"wielding":22584,"sheila":19254,"electriceye":39643,"foxnews":13053,"fkpcascais":44686,"flouting":33794,"overrated":22129,"tendency":4992,"bum":3123,"descendant":8577,"associate":5442,"symphony":11612,"boothy":36384,"flagicon":42634,"xenu":24604,"strives":21723,"fadia":15593,"grating":31042,"formalities":30915,"froze":30390,"•do":38866,"fi":7157,"danke":24910,"conversely":10871,"banjo":27641,"wifes":30030,"aguilera":23499,"gearing":41315,"1830s":33877,"stroke":9177,"logogram":48646,"algebra":9360,"league":1694,"turnpike":46200,"jackman":36732,"white's":18511,"denier":10910,"keetoowah":42054,"igf":25527,"argument":621,"fretted":26152,"ballistics":29051,"mast":17126,"crashes":21560,"reordering":45486,"tasty":16917,"terrifying":22664,"systemic":7565,"critiques":11006,"10c":25455,"roering's":37477,"decker":32316,"sicilian":19394,"moderated":18073,"dali":35165,"christianity":2207,"theroy":41160,"flaunt":34472,"political":615,"steffans":37709,"josé":10968,"cern":36602,"overdrive":48562,"zlykinskyja":19382,"km2":25573,"slovaks":30081,"hercules":22960,"tcf":38243,"outcasts":31926,"tru":24478,"ramdasi":42870,"fairies":46105,"virtuoso":46933,"lashley":31747,"gauge":10287,"dating":4470,"sistan":44700,"addison":27576,"activism":8983,"function":2460,"aztec":17647,"handed":4449,"reassess":34114,"lecen":22238,"resuming":26307,"ramdasia":8088,"correspondance":25839,"iberia":26497,"overlaps":24108,"practises":27836,"potus":29169,"retardedyour":15184,"chameria's":31164,"fantasia":30041,"attendee":41180,"‎":2778,"nawlinwiki":12440,"html5":32349,"droop":39970,"cluebot":10883,"breakaway":20188,"outriggr":48846,"monies":42912,"allmusic":9904,"arp":40636,"satanist":30329,"boyhood":47488,"barnard":37725,"attention":744,"vibrations":32137,"sui":23505,"progression":11795,"hims":42458,"martyrs":14039,"rocketdyne":31876,"sudoghost":34259,"ace":7301,"fur":9395,"recognizes":10027,"married":2947,"attentions":36180,"sag":47875,"exaggeration":11492,"fl":6442,"aqui":30019,"kan":32876,"unrelenting":28581,"allegation":4284,"enjoys":6199,"luxurious":22190,"siblings":9164,"tums":24370,"tow":29614,"pacifist":36003,"sculptures":28568,"repair":7454,"candidates'":42658,"ge":10995,"york":1221,"sketchy":18528,"sunnat":41695,"favourites":29711,"opinoso":30516,"india's":11147,"mcdowell":22199,"superstars":21219,"fastily":21629,"reinvent":32961,"complied":14706,"phoenicians":40705,"unquestionably":12523,"subjecting":42819,"nucleotide":36400,"30k":34548,"registrant":28865,"hostility":6972,"entire":694,"postcards":43358,"jose":7315,"commitee":20932,"tamer":45913,"halliday":43286,"speechless":22851,"differentiation":20996,"tornado":10338,"statistical":5401,"neccessary":14109,"putonghua":43964,"readiness":49718,"postalcode":43354,"exclusives":30509,"doesen't":47309,"panda's":46066,"druids":34517,"clothes":7409,"virtual":4853,"hel":34296,"religious":1112,"bottled":42310,"idea's":48399,"verbs":15405,"hannibal":10846,"imperative":12422,"soccerway":32062,"charlie":7661,"primaries":16421,"i’ve":8175,"cell":3251,"i´ve":29667,"ely":37902,"vapor":22816,"gillingham":42519,"fradulent":31928,"circularity":47362,"bartholomew":38159,"pathans":24649,"mosque":6158,"asturias":22352,"cie":41968,"nell":47262,"screaming":7884,"aucrt":45753,"coor":28573,"remade":32216,"hildasholm":43938,"institution":4324,"permeated":47654,"alaskan":36971,"resolution":1489,"classifies":16126,"knowing":2147,"blabbering":35153,"fst":46739,"roses":11229,"contentions":42611,"tswana":41993,"forged":15700,"loretta":33078,"proudly":11188,"fasting":34385,"port":5008,"payback":21719,"carthagian":42263,"rosogolla":21959,"universalists":43557,"adore":47349," — ":15943,"suggestive":15355,"sinks":26655,"che":7066,"weaken":20296,"pictured":12399,"moa":29137,"smokey":30524,"scibaby":27423,"waterfalls":18705,"russia":1755,"kuchis":44341,"birds":6435,"claptrap":25389,"seattle":6652,"opposition":2403,"“you":27864,"stony":24292,"denegrate":37907,"lilith":42198,"analyzes":33712,"hick":26523,"contemplation":19603,"meme":9080,"accountants":22292,"proletariat":31153,"bardrick":28854,"chandler":27974,"couples":11750,"cringe":17283,"doubled":23511,"private":1624,"tower":4431,"belo":44991,"literate":11127,"rubbish":3559,"lobster":31748,"jive":21506,"transmissions":21168,"masturbate":17114,"coldplay's":47687,"crybaby":16571,"district":2205,"lot's":31348,"avail":9830,"disgraced":18143,"scientology":4627,"sampler":37882,"argentines":37757,"silently":15506,"nineteenth":13688," ► ":7841,"dinesh":14022,"tub":20300,"enables":10911,"sanjay":32474,"equazcion":41431,"newcomers":2613,"unsettled":33543,"boarded":37993,"disabuse":45500,"prelude":23980,"northeast":10842,"gita":14078,"pertain":14093,"probabilities":22047,"hooves":49366,"tiptoey":49348,"gadgets":22167,"edu":3558,"kermit":38543,"dumbing":24526,"bde":40090,"charitably":37432,"undertake":10925,"posibility":41849,"ontheissues":42900,"weighing":12305,"afghanistani":34060,"obliterate":46238,"hecht":38555,"20kshatriyas":49802,"nike":16868,"amuse":13860,"conviced":43469,"disruptions":12929,"bitterly":33012,"northamptonshire":45742,"mpa":21846,"hieroglyphic":37463,"ishihara":27587,"phoned":40916,"erm":12161,"diliberately":49730,"excessively":11028,"pjacobi":36560,"extremes":17931,"iskapoo":35749,"ruthless":14954,"commission's":30608,"touchstone":43952,"☥":14212,"symbolics":34825,"mummies":42531,"timorese":39583,"short":702,"condorcet":44085,"staunton":49038,"bovine":41230,"padded":26907,"starring":9731,"arkjedi10":28358,"unsuccessfully":14370,"sylvester":20023,"stewie's":41661,"tusk":45422,"regarding":435,"header":3504,"organisation's":28057,"php3":44506,"responds":9734,"neglected":8808,"unfettered":31338,"unfit":13069,"violinist":44745,"ire":23860,"aeneid":42053,"tribes":4043,"custer":37449,"yadda":15547,"india’s":35861,"sera":27058,"venkaiah":39476,"caint":30283,"plastic":9305,"plentiful":30467,"moonshine":13228,"shedding":21698,"handouts":32215,"briffa":41583,"tikal":46359,"eugene":13652,"layouts":23314,"orwellian":23870,"resistor":32351,"objector":37413,"lara":11360,"anonymity":9708,"rel":41111,"premeditated":22558,"truman":9573,"king’s":31502,"antennas":41939,"bălţi":41070,"natureboymd":49429,"haramein's":46740,"archuleta":23137,"hugging":29512,"bravely":30989,"ottomans":13256,"gandhi's":32263,"…☎":40263,"representational":37796,"cynefin":22735,"transportation":9413,"respectively":6706,"crj":21040,"qsl":45990,"oreo":35942,"depend":7305,"oru":34753,"archont":21069,"hariakhan":34294,"pupettry":48933,"viewership":34284,"teh":4013,"tengri":44888,"layoffs":46221,"intricate":20768,"exhaust":14785,"receiving":3456,"empiric":27372,"muhajirs":42421,"ebook":30767,"shitface":26339,"sandygeorgia":19011,"hearings":16275,"wading":35239,"okanagan":42571,"panties":16711,"youngest":10217,"mtking":38606,"computational":17109,"games":1131,"bait":9408,"claim":392,"mme":42575,"leve":28876,"reminiscences":39215,"conductors":38071,"irrelevancies":39311,"bilson":46968,"kurland":43990,"bruno":10729,"syoped":46051,"rfas":13314,"labored":32002,"zfc":34985,"clearing":7680,"thompson":6899,"knitting":42744,"umn":39171,"sincerely":2463,"lever":24989,"furthest":27588,"mahabharata":18062,"baroque":14590,"grotesquely":47802,"inaction":21510,"accelerated":20688,"strap":29291,"disregarded":10630,"china":1151,"tabled":43946,"warms":40864,"conclusion":1717,"navarro":39990,"assessing":9418,"discerning":47966,"transistor":14196,"symbology":42140,"phi":7418,"s3":14430,"coordination":14187,"referees":25394,"infiltration":31005,"greektab":45915,"ishmael":36088,"voicing":17175,"collude":27746,"reaganomics":40855,"americas":7993,"bribes":35123,"exited":29720,"metros":20431,"aec":33672,"residency":19265,"meek":39707,"decades":3458,"inclusive":9651,"afrocentrism":26741,"theory’s":48346,"constitue":48755,"john":763,"cyphoidbomb":38249,"section'":28167,"constitution":2298,"mello":22081,"congenial":49099,"freely":2395,"pretender":23768,"mary":3159,"frown":33927,"regression":14371,"lunsford":30950,"korsentry":18443,"martyr":14131,"rider":10315,"hoop":19072,"baby":2659,"installations":34413,"nobs":29301,"portraying":13259,"dihydrous":49687,"retardation":30881,"“whoville”":17753,"conspicuously":27278,"friends":1028,"believe":216,"apoligise":37397,"marton":38587,"trump":8974,"clowns":10335,"dixie":14372,"defid":43117,"commissioners":35745,"ridership":47520,"paparazzi":40438,"irene":21191,"peeking":46031,"bernabe":35373,"saith":47102,"turin":23408,"simulation":14024,"omitted":6097,"reparations":34890,"hypothetical":7194,"briefer":36326,"image":118,"skeptical":7946,"moz":21100,"boring":4880,"interpretive":20007,"readability":9392,"iloveminun":47211,"eugenics":13824,"lain":43863,"abce2":44196,"truculent":36107,"astrotrain":29345,"medication":11434,"scorecard":25495,"geber":47943,"cobalt":27039,"decadent":24713,"loa":34038,"nav":15776,"lim":34093,"infuriating":19725,"thye":38935,"bhasa":25223,"wikipedia'":26800,"domer":28589,"pinto":20185,"nawaz":34204,"village":1893,"kelsey":32459,"nuetral":18159,"performances":11069,"bread":10506,"fff":26068,"congratulating":38236,"rathlef":43070,"admissible":23097,"slava":42239,"singh's":31786,"lutheran":16207,"leif":42497,"maternal":17903,"billinghurst":45368,"suki":24617,"ascii":18510,"enrichment":35957,"es":5914,"group’s":33970,"northumberland":23215,"shoreman":44949,"£":23168,"mask":7707,"handling":5744,"browtown":40571,"umich":49124,"repulsion":18023,"billing":15883,"laz":19902,"bongwarrior":11339,"uncontrolled":32001,"portugal":6337,"seamus":32983,"intel64":24558,"kissed":22224,"recycled":17272,"columbanus":38341,"geodata":48712,"aides":38641,"immigrate":40308,"ezra":21531,"barelvi":17403,"bukhari":19023,"epiphanes":22561,"scenic":36485,"division":2457,"fans'":36027,"abhishek":24501,"flickr":6924,"unofficial":6148,"janitor":16327,"fares":23481,"risch":44042,"ooops":19219,"loiseleur":44029,"savers":48731,"wills":27920,"emptiness":46736,"proclivities":49564,"newscientist":41536,"nulth":43243,"foc":32121,"eleanor":21791,"enrich":21977,"tasmanian":23993,"cristiano":31676,"otherwords":14237,"nervous":10576,"witches":17682,"turnout":24588,"opposes":7699,"jog":34990,"somethin'":49214,"country’s":26574,"decide":718,"turley":34833,"misinformed":12530,"discogs":15100,"martens":42309,"wikisource":8593,"moldavians":47901,"anselm":24662,"adversely":29149,"dorms":33103,"ravens":40811,"royboycrashfan":49388,"maus":43662,"dinners":35971,"dame":11164,"iba":46954,"öomie":37179,"lifeforms":40847,"masters'":42660,"marvin":23187,"fraternities":13119,"metacritic":12448,"overrule":17333,"lorde":49814,"billytfried":27352,"estimating":25488,"riddance":17399,"istanbul":8862,"clicked":6935,"antivman":7848,"episode":1199," t ":33682,"expunged":17060,"vlachs":15984,"conference":3306,"vomited":49249,"denotes":19389,"passports":16605,"resistant":14955,"techniques":4705,"inform":2407,"plead":17344,"catalyst":16613,"competitiveness":45041,"indeterminate":21402,"pamela":21964,"tougher":27819,"kmt":21962,"disruptiveness":40317,"witnessed":8083,"tierney":48226,"rba":34454,"quash":41323,"tetra":38087,"disappearing":16067,"gdańsk":36730,"accomodate":17833,"explained":1186,"squadron":9060,"authored":8863,"keene":48441,"storylines":13518,"apropriate":26739,"phallus":23350,"wonky":42724,"multiregional":31881,"fancies":27172,"freaked":31997,"bivector":43428,"hyphens":17020,"gönül":22861,"wpp":44141,"'richard":48719,"talktome":43022,"bnf":46428,"bookmarks":32339,"zealot":21351,"hesitated":37005,"outdoors":40153,"truthful":6910,"putin's":38019,"dining":25077,"diggers":38818,"geniuses":22462,"headings":5079,"evolved":6440,"hoogstraten":34707,"urkel":38815,"raiders":13882,"yamhill":30980,"eccentricities":36515,"thomas'":41404,"iced":37765,"villainous":42741,"shan":29799,"transforming":19917,"provocateurs":39733,"hezbollah":6367,"rem":44379,"smiles":10888,"best":222,"hawkinghttp":8076,"zealand":4654,"artsakh":33046,"crusaders":12229,"atherosclerosis":45307,"airplane":10092,"rpc":29272,"uniting":33434,"hornblower":43225,"architect":10634,"bluntness":35234,"photographic":10626,"montage":14866,"slamming":26047,"tutored":45631,"camp":3649,"mong":46268,"judges'":42655,"brahma":29066,"fb":17630,"horror":7257,"combinations":15779,"karachi":12321,"rc":10758,"grumman":33141,"undoes":27885,"ahmed":9387,"disposal":13662,"mclay1":42699,"reply":665,"sse":48484,"piston":14830,"triunism":36420,"cenandor":40337,"btl":39641,"ethnogenesis":25493,"accounted":17887,"amature":31349,"koromon":42316,"rockero":38746,"latibeaudiere":42920,"avaliable":38060,"dohn":49368,"chalk":11977,"mistranslated":32322,"exploring":17438,"nuu":38204,"nautical":16264,"cove":21932,"ripoff":37479,"inediblehulk":35950,"mackensen":38925,"sathya":27891,"endorsing":12314,"phentermine":49334,"transitioned":39314,"rothbard":15469,"animals":2691,"vienna":10530,"stalker":5150,"indymedia":35480,"threaten":3507,"hoy":23553,"irresistible":40794,"sanger":12018,"tunecrank":49394,"overshadowed":22459,"melrose":42984,"bigoted":8092,"marginalize":22017,"delicious":9072,"devilman":28623,"thnx":17183,"peed":49783,"cliche":23017,"consesus":30428,"arizona":8978,"futper":35000,"fractal":21032,"sivas":41089,"nonjew":47280,"numbing":48343,"brookfield":42226,"banquet":29802,"calif":25465,"fragmentation":49632,"ma'am":12885,"we'll":2174,"goalkeeper":33511,"insolence":41443,"fyrom":5339,"hip":3935,"stateprov":43353,"possessing":22395,"electing":31568,"godlike":46253,"slovak":9335,"extrapolated":34602,"lci":45810,"southofwatford":34883,"acton":44821,"away":506,"stevebaker":33370,"arf":21306,"crete":20957,"swoger":47226,"afrocentric":13219,"rebuilt":16796,"somewhere'":35514,"macbeth":30717,"rhodesian":24233,"suckling":49105,"hoaxes":8108,"madchen":16440,"compete":7676,"partido":38545,"dietary":17237,"neuro":24682,"special":916,"scouts":8549,"agne":48355,"validating":22727,"s1000rr":43277,"carver":19546,"intervening":11329,"dewsbury":31329,"mcjakeqcool":48331,"phythian":47863,"litres":35712,"macmillan":15264,"clues":11465,"tmb":43553,"peasants":14048,"wyrdlight":40299,"bellinghaus":36469,"parade":9529,"anarchist":7574,"modeling":12793,"lefèvre":36028,"52nd":36681,"consolidated":13852,"factored":37003,"industries":8278,"lulzy":44525,"seaphoto":48159,"corpse":12164,"forgiven":14300,"djathinkimacowboy":27168,"tetrachord":43430,"biff":13281,"nydahl":43114,"uplifting":35264,"khali":47749,"wikipediocracy":14594,"involvement":1835,"fedex":43040,"antisemetic":47866,"impersonate":20989,"kong's":46759,"predict":7979,"devote":7370,"restrictions":4763,"xxiv":34932,"voter":12220,"suspending":29100,"advise":2538,"banjeboi":18059,"suffix":12713,"malvinas":31506,"lacrosse":11945,"abhorrent":20376,"hotspur":19795,"experimentally":26333,"texts":3115,"alexandrovich":10633,"reema":41665,"fortiori":47750,"senna":49060,"resume":7054,"dnb":15677,"sanity":10377,"alcoholism":11248,"manic":16102,"amirite":23200,"soundly":25066,"rotateq":38046,"inhumane":30848,"supremacists":17373,"shadowing":48109,"soaked":28335,"misinformative":36043,"shire":24854,"religios":37011,"starcraft":19310,"9eb8":37107,"leftist":7177,"curved":17443,"repetitive":8734,"satisfies":5530,"restatement":6672,"preferable":6410,"withdrawing":14070," –":15803,"harrington":44437,"lfdder":23326,"talkblp":46836,"elimination":8692,"mehr":42982,"soapboxing":10405,"apologize":1611,"matty":29933,"skagitriverqueen":49306,"injure":34512,"improvements":3071,"flue":44504,"communications":4477,"victim's":19282,"boulevard":15751,"jetstreamer":41763,"patrons":22796,"aboutmovies":42761,"conformed":14608,"cocoon":37180,"policy's":40923,"madeleine":24743,"utopian":27250,"adoptive":33607,"milo":19509,"liters":25956,"etc":319,"compulsive":12381,"forthcoming":8682,"classifications":14446,"pedia":8070,"012":34451,"mongol":9650,"magic":4456,"transfermarkt":41459,"perceived":3729,"rightist":36790,"arrays":41336,"chicken":2160,"glad":1339,"palin":6446,"sysop":4834,"daisuke":33949,"dreamguy's":33280,"trent":16431,"again":125,"beta":6451,"toning":28185,"clannad":43644,"colspan":8375,"avoided":3732,"wrt":10255,"aphrodite":40436,"instantaneous":20572,"unmik":28191,"joliet":33428,"sulfide":44608,"infamey":46024,"dio":21183,"puppetry'":46469,"maharishi":15665,"slacks":35506,"wikipe":30745,"melmac":15035,"britt":35772,"doris":20262,"remarks":2091,"restarted":18226,"xv":24635,"ooh":11340,"scratching":23300,"queda":40816,"pde's":31838,"kobe":20676,"thrills":42375,"rodriguez":18048,"physique":23648,"'prove'":34628,"determinism":19412,"space":881,"schiff":37321,"autographs":36951,"returned":3151,"aided":15301,"radiant":12475,"lancashire":12208,"lopez":9918,"marmite":46578,"trubetskoy":34799,"belly":14174,"regrettably":17099,"kendall":37981,"ip's":4669,"eveidence":48128,"cosby":36768,"suchlike":28176,"gokdel":40396,"manufacturer's":39687,"sharlto":48278,"va":10482,"lore":31746,"feet":3593,"cuz":4363,"cmt":32372,"collaborated":10648,"referendums":29838,"simpletons":39062,"raises":7030,"linnwood":48640,"suleyman":43700,"flip":9172,"participating":4109,"constabulary":36411,"hominen":35572,"unsolicited":11853,"taille":36066,"narrations":48207,"creek":7133,"university’s":42451,"theaters":16121,"swaziland":25508,"election":1892,"eurasian":20593,"hoagland":44622,"argument'":33204,"accussations":44885,"'''please":47924,"crying":5486,"tamar":40837,"invitation":3705,"anis":43340,"alliance":5045,"kellers":27248,"mackey":46169,"wigdor":14181,"mccoy":17952,"recounts":45357,"theravada":34423,"indefinitely":3265,"garfield":18669,"manny":22630,"wikisoo":39104,"kow":31032,"slaughter":13905,"dardania":31934,"islamophobic":20422,"humps":45617,"brewed":32532,"trails":18168,"jza84":16405,"noone":7620,"fagot":35134,"exposes":14689,"loyalty":12807,"publ":40644,"usenet":8927,"yakłtalk":43081,"righted":47871,"genaic":30542,"milowent":40584,"wives":10144,"harrods":43323,"judgment":3517,"haredi":24067,"intl":15834,"booted":24884,"species":2223,"mathematica":49346,"furnished":19283,"roderick":40176,"indiscriminate":9858,"lpg":11667,"cobra":17595,"anthropology":8116,"burden":4733,"heidegger's":22926,"fornicate":44987,"cisoroot":44201,"palestinians":4840,"craigs":27269,"welsh":4300,"idioms":32789,"redefinition":27768,"uv":15423,"modifying":8946,"comprehensively":24997,"credibilty":47639,"chezzy":40574,"tailed":28905,"haydn":45721,"exist":822,"wheres":23908,"soonest":31455,"gnu":4036,"redone":22203,"jn":31976,"parachute":21942,"barons":22604,"advertiser":35213,"libstar":41518,"ethnical":33995,"pledge's":38510,"anaheim":37287,"administers":35647,"pastel":47222,"presentation":4726,"unicorns":26386,"y1":43108,"coms2":47170,"effendi":31995,"deformable":38872,"civilly":16291,"darwinek":44847,"litany":24602,"ying":36687,"dentist":20067,"electro":15313,"insulated":25861,"precisely":2997,"benedictus":41841,"cats":4684,"yeh":17305,"imbalanced":28473,"mild":7218,"ahontoay":28936,"heterosexuals":30107,"flashy":33494,"migrated":10513,"attracts":12201,"anatolian":16182,"cline":6669,"turgid":39138,"imposes":25380,"betacommand's":47383,"bass":5060,"just":50,"milwaukee":9752,"pedagogical":41224,"converter":19621,"21st":6253,"yawn":13342,"aug":3832,"stat":12887,"redirecting":5637,"optical":11125,"malta":12937,"ourmed":31864,"mele":26211,"overrides":23247,"kup's":40788,"advised":3914,"gran":23544,"stp":28306,"rave":15921,"anesthesia":26308,"girl":1994,"boyle":24203,"cheek":9102,"jlatondre":30458,"proviso":41344,"degraded":17704,"green's":24103,"csp":31335,"demonization":40108,"accessable":30153,"holi":40637,"earp":29226,"linked":983,"viciously":25645,"clemente":38193,"cherry":6368,"summarily":11849,"unconvincing":18527,"uncollaborative":41073,"brangifer":27814,"flores":17989,"orbit":7178,"visuddha":49786,"changed":483,"beneficiaries":47720,"flows":11957,"arya":17533,"deportation":16145,"communism":3429,"italicised":35035,"implementing":9152,"bye":2203,"edible":36591,"apri":37189,"analysed":17142,"newburgh":39796,"housewives":21405,"replicating":40518,"armoured":20202,"imus":34267,"otis":28230,"inherited":10423,"flynn":13628,"meivazhi":44303,"resonance":8857,"fornvännen":19289,"propensity":21198,"petra":36632,"ţo":47388,"cons":10804,"coveted":19322,"celebrated":9729,"h8":36158,"fuchs":32115,"basin":11449,"mechanism":4680,"yellowmonkey":19500,"viral":16294,"2a":15058,"sediments":25795,"demonstrates":5068,"fatwa":16978,"blackworm":25671,"temperance":26997,"picking":3853,"multan":20550,"stipe":38795,"gavin":14065,"titanic":9535,"digitalcollections":38834,"fquadron":21115,"kaya":38084,"gossipy":43608,"nigger":400,"shudder":26018,"oblique":25651,"spreading":5147,"love":477,"recruitment":12112,"weeks":1175,"imperfect":21058,"rudolf":25322,"warts":24432,"g":708,"winning":3344,"limiting":9198,"carry":2650,"dev":13360,"leased":24796,"wmflabs":28484,"kameez":29368,"slips":22444,"ales":47815,"gretel":49045,"missed":1902,"open":695,"dodgy":12515,"misidentification":33250,"cause":883,"congo":11697,"vindictiveness":26597,"stamaty":44169,"particles":10362,"allegorical":29340,"ballz":31983,"wranglers":37878,"on":15,"harjo":48342,"puddle":38244,"carrie":16249,"wabash":48142,"yoy":20003,"orel":35598,"appeasement":44411,"friendless":37471,"lease":16137,"cults":11752,"donot":20660,"shamans":41226,"truthers":27064,"adv":26104,"callie":31584,"jayg":41720,"cocksucker":1873,"categorical":20724,"theage":40192,"edouard":27693,"weeden":31671,"mbw":23751,"methodist":22286,"ocd":14681,"50k":32362,"khorasani":39942,"endocrine":31151,"barron":47350,"figuring":10529,"r1":25121,"ljl":48231,"yours":1152,"commandeer":49109,"staticvapor":33300,"lupus":20764,"exporting":28430,"brewers":48221,"scaled":17808,"worldcat":22526,"snp":21603,"assyrian":4920,"tony1":42701,"rulebook":21197,"manly":32400,"injures":49861,"deliver":7966,"tidied":13610,"perception":4503,"nary":46364,"kaye":29566,"fs":18202,"justly":24866,"honorific":15427,"quaeda":40302,"foot":4307,"lopez's":48824,"sao":22605,"waffle":22314,"kagome":29655,"blade":10417,"pennyseven":44049,"eastenders":14966,"conclude":4638,"frege":30811,"brusque":31965,"yonsei":21494,"ashur":47578,"tabin":33954,"oldham":29112,"encarta":14613,"jerkoff":30290,"deem":7944,"turks":3033,"syria's":44447,"seventies":18593,"redirection":9827,"interfaces":26488,"drugbox":34299,"mason's":39648,"disloyal":33983,"4kids":35642,"day":297,"devanagari":19839,"bono's":46624,"mathews":29073,"interventions":13591,"crossmr":12869,"cantopop":25060,"famines":36966,"arsed":18363,"preserves":25234,"accordingly":3241,"modesty":21746,"trojans":26187,"hrvatska":38473,"insanely":26170,"willows":44696,"belongs":1825,"jf":29237,"bfi":41561,"aerial":12960,"inspirational":32110,"paulo":17437,"wanders":49946,"presse":26819,"sniping":14294,"bruggen":46216,"somalians":38355,"elias":18636,"nos":20215,"flawed":4498,"deconstruction":28886,"otoh":18049,"aircrafts":34884,"corporation":4779,"potatoes":16745,"crumbs":47300,"engd":25752,"glaspie":41121,"commemorate":28319,"surnames":7532,"exams":11240,"stereotyping":21855,"goto":31382,"strenuously":28972,"science":778,"serviced":42342,"ger":18287,"rearrange":19100,"maritime":12273,"simon":5183,"neccessarily":35986,"underground":6541,"supermarket":13941,"bree":44417,"cola":11105,"luxembourg":17602,"duck":4824,"networked":28506,"weeping":24901,"lewis":5556,"sailor":10813,"haslett":45664,"pretext":9358,"squeaky":30629,"reductio":31333,"peice":13238,"vanalism":49196,"hphpc":44129,"sage":13965,"nicotine":36202,"evade":7392,"bayareaintactivists":35617,"abominable":30665,"sobre":32522,"contesting":12212,"philistine":40547,"hu12's":32591,"alder":28927,"fundy":48642,"forensic":9320,"indistinct":30964,"indexed":13367,"exposé":26175,"vidya":32363,"delineated":35461,"pros":12291,"uhhhhh":36306,"'ebay'":39706,"sidaway's":46838,"apologetic":18371,"readding":24101,"dts":37908,"influencing":18372,"antique":20675,"chadbryant":16127,"dusti":46480,"briton":23083,"ludwigs2":13188,"reportedly":10890,"mg":11302,"bressman":41159,"export":11734,"academics":4377,"motogp":49574,"strict":3875,"tos":19935,"akkad":47159,"merkava":29435,"seniority":21343,"souvenirs":42441,"tory":14217,"snunɐɯ·":33869,"bestiality":38755,"nonsensical":6767,"concordant":38732,"rp":16743,"methodologies":24525,"mysteries":13128,"suspended":6237,"unusual":4044,"08t":31769,"casket":42105,"ascribing":30713,"ninja":10413,"cencorship":39577,"scramble":23887,"great":283,"linnaeus":16009,"québec":21554,"licks":6525,"ireland's":48858,"shocker":18551,"pretensions":35178,"digits":10110,"camille":23256,"rjensen":25866,"outback":29493,"dans":25972,"combatting":36514,"beggars":32314,"contraversial":29151,"corr":34544,"churchill's":19789,"ussr":5229,"vf":26532,"dibs":37206,"msa":20426,"allocation":17982,"clandestine":18087,"goodwill":14870,"orthomolecular":32221,"happend":12079,"onward":18367,"utilization":33800,"fud":22456,"impulse":12451,"into":140,"steven":5910,"harrassment":5226,"celebs":25815,"browbeat":48015,"yamuna":23199,"neptune":18439,"d7":23246,"commissioned":12531,"rituals":13873,"veropedia":40459,"nycs":40145,"without":175,"redraft":46377,"govern":14385,"farted":7520,"bristol":9339,"fuckstick":42757,"23°":49808,"comments":223,"feud":9680,"reputable":2700,"tagore":19484,"tattling":47247,"davy":22911,"ejanev":27479,"trouted":14009,"aggrandizing":26347,"circuits":12276,"bambu":40792,"refreshing":15247,"macintyre":43510,"pgagnon999":24587,"shitlol":31900,"discounting":47279,"reentrant":45550,"dubstep":23663,"dependencies":33351,"cauldron":40451,"indictment":12913,"gangsters":23895,"anonmoos":44729,"ncaa":10248,"embellished":31188,"jarlaxle":42510,"cheshire":11427,"responses":2938,"mj's":29628,"nestorian":27756,"dealership":36220,"agnostic":10286,"crises":23316,"heralds":38603,"soften":27036,"ess":22169,"verifications":25661," – ":24041,"snack":26143,"pilgrims":26278,"grammy":15708,"concerns":1013,"'black'":39216,"pathways":39177,"unnamed":11931,"asap":5776,"india":901,"pixar":26945,"favoring":14481,"vegetarians":20545,"haunted":13288,"extracurriculur":40572,"scolaire":42911,"wikiseek":34359,"tomlin":41440,"'scientific":47848,"voy":45864,"bangles":33948,"gin":40580,"calling":842,"spacerocktrading":48002,"silent":5779,"situ":30311,"crowe":19696,"plenty":1926,"tempe":40708,"truce":13365,"theorist":11171,"believes":2688,"boothroyd":46906,"event":1128,"nairs":8444,"readings":13134,"concisely":18601,"iot":42256,"indicates":2649,"testimony":6027,"contract":3852,"dal":23382,"matsuda":44361,"biri":43543,"reproducing":10678,"neccesary":19912,"environment":3280,"strife":25991,"witherspoon":46412,"woudl":30763,"editsummary":49763,"cric":45868,"linearly":36051,"lamps":26123,"ponies":24785,"lounge":20622,"nepal":9853,"touchy":15341,"fantasy":3726,"said":166,"take":154,"organisation":2752,"similarly":3118,"norte":18344,"gigabit":45179,"si":6988,"couldn’t":21512,"wknight94":41484,"'g'":47910,"diction":33397,"≈talk≈":18171,"morphology":23012,"foiled":40612,"cheap":5023,"perihelion":34802,"beverley":31670,"iconography":31615,"articulated":15470,"annon":25682,"harte":34262,"judgemental":20393,"embody":36729,"goodfaith17":30813,"enhances":35528,"letterism":48950,"centric":7608,"greenhouse":14004,"userpage":1758,"yuku":42704,"kenney":42187,"evangelion":36622,"critically":12486,"overstating":32560,"toccata":45598,"sensical":37307,"ppe":25530,"views'":38742,"crooks":35719,"formed":2922,"searched":5284,"await":9648,"generalising":49874,"laps":27830,"sens":25296,"chanel":37086,"friggin":19403,"appended":17575,"indiana":7836,"κυπατζήδες":40239,"ccf":49466,"concordia":32564,"beast":7229,"croydon":22980,"tbo":22392,"008000":45820,"soap—":17440,"wack":26457,"molesters":31122,"cock":1168,"cozumel":35475,"coolie":42653,"rats":11357,"scarian":36901,"amalgamate":46385,"reviewed":1375,"legal":906,"gren":43349,"chairperson":33420,"readymades":49827,"dove":24289,"arzel":22193,"nick's":20653,"pathetically":22248,"moslems":28640,"kershaw":15050,"dogma":7769,"olympiad":46744,"handwriting":18350,"coward":4112,"flee":16671,"choking":28869,"quigley's":40307,"traitor":12282,"politburo":36936,"bortle":41341,"ict":44476,"obfuscation":22705,"reservoir":19400,"suede":30726,"witless":27928,"ripe":14056,"contemptuously":39393,"satellites":9755,"paroles":45458,"aspire":29778,"diagonally":35369,"rutan":49858,"distracts":26894,"tombstone":24042,"bounties":35147,"dislikes":12172,"amanda":7945,"1lol":9656,"wilder":37583,"lovers'":30925,"question's":31231,"scheduling":20082,"conveys":11869,"photobucket":18116,"legislative":9247,"frank":2899,"lookalike":32681,"tourists":9990,"recoome":45195,"hellor":9214,"infection":11810,"corpses":19632,"chugging":40112,"cutting":4937,"contributors'":3611,"tolls":40011,"tempers":26357,"15s":47234,"haggard":20516,"tranny":28816,"2015–16":29239,"aqsa":15907,"ararat":25793,"controversy”":47973,"—''''''t":19770,"zinta":33011,"racially":10232,"lament":45507,"wikireader41":44391,"mtf":27729,"interstate":11640,"松涛":49755,"oy":23562,"hotter":20359,"latitude":10478,"melody":19620,"jstor":12524,"squawk":41112,"chamberlain":26148,"persina":38745,"unpredictable":28899,"polling":10253,"refusing":5115,"wich":9470,"agm":43994,"ku":10279,"beaner":40828,"£2":25727,"eastwards":45316,"enzyme":26560,"inc":3095,"douglass":38226,"circulate":45965,"kadesh":47524,"sought":4388,"netbooks":38379,"cousin":6430,"afraid":1729,"blair":12206,"idontlikeit":19137,"grinder":34287,"approximations":22751,"quarrel":17955,"obliquely":39386,"thuggish":30926,"its":107,"occurrences":15840,"ozzie":39513,"pinch":22810,"unreal":14876,"chesler":44443,"boards":5733,"vikramsingh":35750,"scrapie":49690,"sensed":40065,"bandy":35974,"480p":37271,"folkestone":40718,"csn":46479,"sparks'":46717,"paradigms":30261,"yiouyrhjo":47835,"absentia":47399,"scotia":16750,"embryo":23132,"reminding":9514,"finns":15826,"loving":5557,"pundits":21315,"125cc":49571,"jeffro":29211,"demonstrate":2977,"proactive":18219,"oceans":16459,"joshbuddy":34422,"diamond":8746,"gelato":31628,"nephew":11511,"32kb":47121,"defendant":14463,"pumpkin":16815,"arrogantly":20088,"abbey":10647,"contravening":34133,"disservice":9799,"courthouse":14688,"montevideo":29634,"zords":41433,"litte":41831,"noah":10879,"observations":4859,"vices":36443,"discourteous":42037,"scorn":24410,"impose":4894,"starčević":41540,"whined":38976,"'this":15395,"blowers":44471,"mortal":11075,"presents":4374,"bode":25603,"sometime":3152,"1d":39808,"ding":16406,"thugs":12298,"warrer":32365,"ffa":34215,"gunnar":36316,"resumé":41321,"butters":35453,"peple":34627,"submarines":26025,"unelected":46596,"cracking":15346,"breast":9845,"foxton":43365,"singaporean":27341,"handing":13854,"enablers":36241,"authentication":24523,"licenses":7089,"elusive":19481,"explosive":11886,"central":1429,"singlet":31835,"preposition":17370,"deteriorated":25595,"mastermind":39948,"rub":14938,"teenagers":9033,"jeffrey":9646,"bets":23708,"flourishing":39927,"tending":17552,"acoustics":38480,"ose":33525,"erectus":38663,"bans":5795,"einne":37495,"exhibited":10982,"voldemort":19798,"marshall":9124,"bsz":44639,"rosters":20488,"censoring":4369,"evaporation":28774,"accept":843,"forte":39997,"reedy":26160,"manifestation":16092,"magyarization":45033,"quist":49659,"unto":10152,"clay":9000,"drank":26116,"purple":6212,"attends":23721,"recommending":14934,"institut":22418,"mesopotamia":12281,"blockchain":44250,"theorists":11571,"✄tab":24870,"purge":9577,"kicks":11161,"beintus":44150,"billionaire":21861,"pmk1":40735,"impacted":23583,"shoving":31939,"nose":4187,"legalese":16931,"popularize":48447,"hovered":46680,"electromagnetic":15143,"alleged":2256,"discontent":28863,"yasser":25885,"tabyou":45461,"r2":22543,"prose":2522,"→references":47959,"impact":2292,"jacking":24154,"bgn":41765,"prologue":42591,"singer's":20500,"nto":25056,"ior":44088,"contractor":20448,"innuendos":37941,"yields":14014,"britons":12413,"uterus":37252,"roblox":19956,"inaccurate":2105,"misterwiki":7508,"magnum":16435,"truncated":15354,"jared":15053,"tunisian":40798,"endicott":43357,"decrypting":44812,"hallows":23594,"telephones":38999,"demanding":6653,"org's":34220,"services":2398,"prince":3053,"like":49,"codicil":44473,"equivalents":23945,"cetainly":42272,"leg":6644,"bugs":5133,"retarder":43542,"inclusionist":14475,"testers":47911,"gray's":24621,"grey's":19450,"manipulator":40400,"confined":10510,"mccready":32650,"atop":25945,"ballon":30916,"aust":30949,"havn't":19990,"chartered":29079,"freeway":22006,"wired":10228,"president’s":49402,"limey":30411,"adaptations":22935,"6f01":37106,"implausible":15706,"obsession":6147,"dogmatically":36662,"treatments":11249,"cbc":13343,"masculism":44205,"bisexuals":31236,"nhs":21016,"guatemalans":43105,"rained":49919,"diwan":11142,"isaiah":16818,"allstar":36807,"renomination":40114,"argumentative":14595,"retention":12214,"jennings":24205,"sms":15625,"jiggly":46812,"columnist":11799,"pedagogy":36767,"hassling":47873,"husond":20332,"investor":23252,"oddness":41916,"unmoved":46282,"reverters":29238,"pejoratively":22978,"sophistication":34214,"newsid":30683,"manufacture":14432,"poli":39860,"cravings":30393,"imperialism":13696,"lebedev":43635,"systems":2035,"commenced":22124,"anu":49620,"impingement":25750,"noteworthiness":27181,"bolshevik":17144,"baichung":37986,"gods":4424,"beavers":41958,"else's":4267,"joan":11504,"traitorous":41605,"fundie":32551,"man":437,"committee's":20382,"churchill":8193,"bir":24026,"algohar":45821,"probably":292,"celebrate":7622,"wala":27938,"cannot":416,"misquote":18340,"appreciative":16933,"muppet":26782,"dialogue":4364,"daniels":15402,"pulse":12741,"dank55":44055,"haw":26345,"riordan":46122,"ymca":36713,"ideologically":13423,"coil":17435,"fractionally":47485,"escaped":11370,"fáil":34458,"bubbling":34346,"madagascar":23100,"fat":576,"kick":4753,"habsburg":22295,"queef":46710,"enumerates":46004,"sicily":15018,"dunkleosteus":25478,"5'10":45736,"sharlto's":49743,"firepower":33913,"scientologist":18420,"rediscovery":35509,"stump":25841,"— • ":17064,"竜龍":32373,"garland":30943,"primal":11552,"harold":8024,"led":1913,"tigerdirect":39581,"levitra":42742,"relates":5099,"dependant":26442,"thine":25685,"hoffmann's":44873,"bise":43398,"pro2pro":38837,"echelon":29880,"once":396,"meno25":46470,"conway":16428,"cabaye":42092,"bowman":32140,"world":257,"legolas":37671,"arawak":29242,"lightly":9917,"truest":35911,"toonami":34399,"sonny":17417,"delineate":27728,"mangojuice":28189,"comparison":2326,"rotational":26567,"mao":9404,"mt":9822,"ppi":37314,"elit":40249,"fractional":12565,"juve":47126,"petition":5978,"condemns":24409,"⇒✉":15652,"bolt":21662,"june":971,"mess":1714,"juniors":41951,"cerone":41292,"social":1179,"yom":19199,"raison":37239,"fucks":6684,"wilde":26815,"cover":1070,"villain":9580,"phois":47993,"wsc":38363,"chronology":5813,"spunk":45326,"eichmann":29302,"'on":22766,"bunksteve":3124,"relating":3073,"rulings":12010,"prof02":29956,"feeder":25230,"congolese":45285,"recapitulation":46336,"foolishly":18405,"refernce":12956,"unhindered":35955,"'official":47315,"clara":42877,"sambe":37243,"assamese":38129,"clippings":23232,"niece":26255,"fucker":1468,"austronesian":38527,"advocating":6811,"bridget":29697,"spewed":30089,"chris'":44970,"groupthink":24040,"mcgeddon":15717,"zanpakuto":35994,"insignia":11696,"pains":13489,"sexy":6764,"dissidents":27467,"nai":42069,"neurotic":21020,"seizure":19026,"actress":4896,"howell":26412,"owls":29415,"emory":38990,"virgins":20111,"catty":45808,"'expert'":40350,"ambrose":15286,"bohra":12724,"examinations":27096,"accomplishing":23245,"i'll":236,"defunct":8211,"guests":10694,"cbn":23060,"encompasses":11877,"∴":41996,"deviate":24944,"baha'is":31214,"insisting":5375,"cavity":27701,"blinkered":36508,"brackenridge":42046,"products":2427,"grasshopper":49968,"davenport":27309,"numbnuts":45046,"70s":10378,"severe":4440,"awnser":47007,"rise":3531,"cialis":28090,"schaefer":44484,"versed":11635,"perk":32987,"gerda":19549,"tops":13657,"salaries":29739,"bolo":41785,"hof":24161,"wishy":27963,"swamped":22313,"titles":1547,"adamant":19616,"sargis":37480,"deletion'":40738,"saxo":36315,"fys":17796,"hag":39926,"spec":14925,"tweet":19179,"nuclear":3250,"concentrating":18172,"mu":15573,"underwood":15375,"unquestionable":30751,"redlinks":8419,"centered":6734,"euro":7342,"digest":9482,"loudspeaker":46494,"gulp":45590,"hamsun":20580,"patronizing":15847,"gendered":31537,"likelihood":10455,"naive":7270,"leanings":14758,"linguistics":5899,"rullan":29134,"munim":40592,"funkyfly":33632,"leppard":46622,"colourings":38832,"socially":8576,"alarming":19048,"loremaster":32854,"inset":33889,"apples":9629,"nonviolent":31998,"0em":26870,"doorkeeper":17539,"unstoppable":40309,"wheel":6310,"scathing":21276,"haha":3189,"bullsh":28608,"pronounces":25588,"standalone":11023,"ibo":41975,"bruised":28738,"mohkam":20146,"metrics":19837,"recanted":29442,"waisting":27972,"acting":1610,"rotting":23210,"programmer":11224,"demonstrations":13233,"slaughterhouse":49074,"unhelpful":4964,"amuses":35761,"'our":41355,"firsfron":38098,"dances":16500,"avowed":27573,"localities":26319,"nahi":49386,"traditional":2539,"baiting":7016,"rex":6506,"mcqueen":32925,"impersonated":33533,"inaccuracies":5954,"o'reilly's":31307,"unethical":7120,"sendero":49340,"scaling":22890,"error":965,"exploiting":19339,"scales":9517,"simplicity":15819,"zyklon":41655,"liberati":29433,"nbn":27427,"ted":7223,"haber":43739,"conservapedia":10066,"sandbox":588,"pattaya":45343,"toothbrush":47324,"keeper76":46929,"understandable":5210,"squeeze":18614,"fueled":21556,"tep":35883,"frivilous":27419,"facto":5409,"pessimistic":20501,"salting":29607,"immutable":42294,"vanadalism":38436,"airfield":29475,"devrimci":31544,"zedong":24726,"jc":19358,"kannadiga":17951,"story":696,"amer":34715,"bhg":32193,"hippolytus":26453,"selimovic's":44709,"unperson":47332,"gunn":29917,"argentinean":40927,"fanboyism":30070,"ihave":35720,"adventurer":38153,"biscuit":22010,"bao":34193,"m18":37866,"recap":12867,"geoscheme":22246,"roster":5303,"teen":7410,"yummy":23021,"weekday":25418,"stool":33276,"linksearch":31770,"barbershop":37095,"ones":779,"brave":7107,"comprehend":6582,"feudalist":24425,"filll":21649,"mta":12407,"slump":48948,"fram":16972,"iona":44704,"commodities":26266,"jolly":16029,"surplus":13676,"straightaway":37315,"zoning":27370,"metal'":48122,"mutilate":37546,"digested":38431,"watershed":16672,"radicalism":23961,"supportive":8807,"strikers":24359,"mildred":37789,"seinfeld":34009,"ci":11343,"morrell":13761,"anab":45858,"lfp":38222,"initiating":21711,"cuter":44941,"administators":35167,"orkhon":43033,"austerlitz":37753,"catagory":23162,"ghost":6046,"solos":31574,"santo":19724,"h's":22753,"modernist":17015,"higher":1526,"packs":15407,"regan":34023,"blessing":13406,"brooks":11277,"deprecating":37685,"deletetion":32022,"persue":27571,"excruciatingly":45473,"carried":3518,"militarism":30180,"anxiously":44383,"congratulations":2671,"auckland":17135,"bulgarians":8146,"trainers":16575,"hasbara":17574,"11's":48891,"arc":10822,"straightened":22245,"complete":894,"unwieldy":14439,"varian":40978,"brutally":16020,"george's":21653,"kieth":46218,"chancellor":13272,"anecdotal":13129,"bitten":18153,"recurrence":36532,"dispatch":17570,"bakatalk":21597,"ferrari":22130,"bikash":30876,"friendships":40203,"focussing":20250,"khoisan":48263,"muboshgu":26494,"lisbon":20663,"courcelles":24742,"five":644,"cyberstalker":48168,"admirer":15005,"tories":44726,"toponymy":49882,"mehmet":30862,"share":1514,"murray":6970,"rfar":8137,"payload":14845,"vjmlhds":39601,"clash":9601,"fugitive":16768,"exploratory":48116,"fav":30589,"sidekick":24858,"that'd":9770,"crossbow":42965,"eugenie":37534,"writes":2895,"jeh":32272,"pitchforks":34908,"candidates":2239,"strained":25217,"books'":40933,"warning":509,"wil":12271,"indianapolis":25873,"aggregate":16760,"advertising":1330,"diligent":12429,"anarchopedia":48915,"contrary":1815,"mite":43589,"5em":17721,"makin":28364,"hollerith":34840,"mos":2458,"encyclopedia's":17778,"er":4592,"telephony":27145,"affection":15626,"themsleves":40211,"nhc":16859,"hearbeat":49317,"street":1770,"adulthood":26306,"batswana":48262,"boyz":17310,"suing":20721,"mandarin":9242,"supervisory":44683,"augment":32217,"circularly":45160,"booth":16084,"cue":14228,"nolan":17067,"avert":31107,"nightclub":18809,"butcher's":43765,"ranged":21967,"myopic":22241,"impart":23938,"hore":27940,"ramdasias":24306,"nut":6479,"instructing":25526,"5px":26261,"yournumbertwofan":44832,"commun":42880,"substratum":49507,"livy":46630,"electronic":4433,"shopping":6181,"betray":21201,"darwin":4988,"roller":18989,"auspicious":29853,"tony's":27256,"its'":20742,"blueboy's":46553,"indiatimes":45240,"rewarded":15754,"                     ":33478,"antimicrob":47353,"exclusionist":35822,"franamax":44538,"carlile":44474,"swd316":40943,"inflicted":15045,"televised":14429,"majorities":44068,"parkway":14749,"dumbshit":30185,"restate":17631,"tyrenius":22429,"polemics":37186,"precursors":39422,"nassau":30571,"infomercials":48917,"subsects":47241,"rafah":22469,"voters":6715,"jivesh":30293,"davidson's":40227,"bff":48843,"coordinators":15417,"autobiography":6458,"arbuthnot":18118,"prosperity":15378,"influx":18333,"clayface":45162,"talkstalk":30382,"accolades":16883,"timbaland":46366,"rendering":9022,"sniff":18258,"astrology":6373,"sgt":17856,"anjou":31549,"snaps":38003,"rnr":47585,"astrologers":21503,"'d'":42059,"vill":40486,"gynecomastia":27265,"ses":17043,"futile":7539,"article'":18043,"jehovah":15980,"firth":44703,"tucson":18520,"chuckling":48174,"gigantic":11936,"caltlas":14835,"dictators":11547,"kwamikagam":40269,"aeon1006":20112,"humourous":18587,"deming":48375,"repsect":47623,"pierodic":17535,"aritlce":45232,"highking":10643,"investigate":5136,"cynically":28769,"wkrc":48079,"yated":39093,"mutilating":39846,"bord":46310,"mogul":41901,"nonverbal":40025,"aragonese":44749,"livermore":46131,"clarification":2385,"manages":15152,"mansukhani":37837,"uncomfortable":8198,"russias":36293,"ve":9422,"alive":3286,"castle":5035,"anchors":28680,"buckley":15321,"duplicate":3959,"quo":6278,"tulip":35023,"wee":7735,"halloweentown":28065,"predominate":35670,"retorted":31217,"newsworthy":14231,"david":1177,"scoured":39572,"recycling":20183,"praised":10701,"gregorian":15830,"remini":43991,"spanner":32326,"polemic":12479,"riled":32965,"dred":30942,"criticized":5102,"delta":7800,"furthur":44479,"warmer":20087,"processed":10749,"taxed":30505,"definite":5664,"acutely":49708,"fold":10573,"knight":5608,"spyware":14682,"milboreone":43921,"counterfeiting":47484,"scouring":28228,"omfg":29719,"mor":23774,"panels":22151,"bartholomeus":48059,"glacier":27877,"país":22059,"corroborating":24078,"optimum":17862,"kolyma":43803,"avoid":795,"quan":37342,"utmost":11318,"roast":14342,"до":47842,"anthropic":25155,"pasa":28627,"carrots→":7717,"germanus":33687,"waking":16583,"blueboy96":25774,"hume":11709,"editings":23095,"ef":31152,"metamorphism":48992,"warkosign":36956,"amorphous":30616,"cameron's":41499,"collar":18064,"nightstallion":43006,"yount":46724,"quotations":3623,"awhile":6545,"bare":4958,"touch":2076,"earth's":9571,"elements":2593,"gama":42417,"scepter":41607,"o'loughlin":32112,"keating":30695,"stable":3626,"flack":38623,"glorified":16386,"cavalry":8966,"cef2e0":23172,"ecosystems":25555,"supportable":22348,"uli":27251,"disagreeable":26779,"wolfnix":36911,"multitrack":41828,"ashraf":35170,"shortly":1669,"malcolm's":32794,"responsible":1985,"basques":23924,"'republic":36655,"deciding":5153,"timestamps":22585,"sara":14443,"pricewaterhousecoopers":45384,"alfonso":17097,"pharma":19436,"nadav":22032,"albion":26600,"humanfemalewithamberiris":43763,"element":3205,"©™":32458,"wikipedist":33926,"seljuk":22513,"petitions":21508,"antipsychotics":40568,"'true'":46763,"rite":13267,"wide":2081,"gilbert's":42409,"veda":20933,"unknown":2476,"semper":20678,"kris":27078,"konno":36060,"jehochman's":37762,"inductive":30768,"timurid":49798,"wrong":240,"weathering":22677,"repetitions":27716,"dave's":19955,"texans":42189,"neckbreaker":35333,"'other":21691,"bosniak":12800,"empirical":9216,"talk ":7809,"mistake":1034,"nowhere":2633,"seminars":21624,"religiously":15195,"mat":19693,"divulged":36393,"luis":9407,"georgia's":28583,"tabdianne":35494,"coloured":11036,"foxtrot":42928,"editor’s":42334,"plains":13794,"lightgrey":4989,"poppers":12344,"gently":15597,"feel":214,"limerick":18648,"kosh":47937,"who're":28015,"hellas":47052,"ostrich":40760,"confronted":8865,"gabrielle":25500,"restrictive":13695,"haters":10617,"rourkela":29928,"palmyra":38181,"remnant":29537,"infested":24000,"lightgreen":42353,"diana's":45385,"thanked":11545,"xandar":24731,"webpages":7654,"hook":5166,"maralia":44961,"disciplined":19975,"stretch":6579,"pico":25735,"indonesian":9054,"freeza":26793,"biasutti":39384,"piont":44000,"hobson":41923,"gave":982,"nfc":16460,"ditto":7192,"smacked":26548,"pnas":33113,"vindicated":23968,"apostate":34982,"arutz":30269,"albert":4978,"  talk ":33728,"puzzled":9094,"alvirne":43013,"collectible":36648,"ethan":18453,"them":88,"abducting":46492,"bunny":12708,"sherlock":13161,"shaw":11474,"spikes":29744,"barometer":39772,"safesubst":13714,"fading":28770,"wthr":44208," ⚇♔":35997,"eli's":47696,"paucity":36511,"breaker":21805,"arod":43854,"scrap":12310,"vermont":9197,"dispersed":25233,"bks":17233,"europe":1353,"checkout":27977,"agrees":3715,"korea":2835,"kanshi":49290,"rector":18982,"dorians":39636,"impatience":23616,"menchel":38808,"lemon":18446,"pigman":46824,"particulars":15283,"irregular":14842,"surpasses":30332,"sharpen":35703,"aau":29372,"beheaded":22888,"sings":11796,"unraveling":46245,"teetering":45553,"goethean":15464,"hermes":33339,"disqualifies":25168,"ludus":39776,"deals":4543,"crocodiles":31065,"bombard":36627,"peredur":43466,"infidelity":32232,"syed":20009,"facet":20408,"islamophobia":9719,"het":27213,"merridew":18458,"dumbed":21493,"changi":39489,"aspergers":11271,"rocket":7428,"polices":8430,"crook":14266,"15k":39637,"nastro":43242,"brightest":21129,"demeaning":11309,"entirely":1047,"revolved":37898,"homeworld":44520,"fbi's":37984,"waster":36157,"otp":36967,"stopped":2344,"tur":48845,"portsmouth":19346,"viet":15581,"integrated":6528,"nativist":46060,"coulter":11564,"lancaster's":49595,"crum375":26198,"nicktoons":47682,"becoming":2186,"bette":42988,"esters":42373,"disappears":16070,"marlow":14098,"clare":21534,"thru":6252,"gardner":12022,"allergies":24406,"pompus":32154,"investigator":17004,"300er":43031,"thurman":41430,"attendants":34016,"closed":1598,"appology":27837,"clutch":22675,"identified":2506,"martina":35972,"golfers":36481,"composed":5999,"bobs":48752,"intelligibility":21175,"burning":6018,"embarrass":20534,"shoemaker":40561,"mmfa":46107,"city's":11970,"'p'":49581,"hypothesis":3632,"comedies":19263,"06":1571,"realist":22999,"nord":24658,"proquest":26527,"defacement":25099,"heroine":30366,"hee":12808,"dogshit":23539,"quantification":38411,"nautilus":35946,"kaczyński":37506,"speller":42548,"fuse":19758,"booger":38962,"silicone":35751,"tropes":24909,"croatia's":32816,"wite":36451,"pace":8258,"cartoons":8725,"tidy":8731,"terabyte":48717,"carbohydrate":41572,"industrially":34897,"ribs":37055,"malevolent":28809,"naturalist":30385,"referring":1264,"premiers":24180,"bender176":48809,"cushing":43443,"screwing":9563,"'real'":22690,"sobs":45225,"bitchy":19194,"bkonrad":45485,"mixed":2709,"pedal":23667,"osho":30137,"reno":32100,"withhold":45076,"pouting":47108,"dribble":39745,"galveston":25435,"shelbyyoung":28474,"prime's":47018,"abused":4357,"o'hara":28546,"eastern":2067,"capetians":47535,"asala":26788,"prostituted":45379,"canterbury":12296,"backyard":22408,"frinds":46765,"controled":33376,"sip":22431,"hummus":31486,"nonacademic":45196,"state":289,"yuck":29751,"bizarre":4167,"lavelle":46869,"lavey":16804,"beyond":1262,"portable":18469,"reall":36937,"valencian":22707,"bateson":49651,"nyanpire":49059,"conflict":754,"metaphorically":32488,"sunsets":36199,"guettarda":18268,"monsters":11773,"crossthets":44397,"coworkers":42391,"iowa":8934,"f7":32266,"northeastern":17171,"exempts":39674,"battered":24584,"disparage":11889,"bastun":38068,"advertorial":40468,"pads":29726,"fascinating":6026,"vacant":16299,"hilarious":5707,"twelfth":22293,"interest":507,"moors":18088,"oldreviewedpages":32393,"microbiology":49847,"1970s":6504,"piers":28395,"yakovlev":43534,"overall":2193,"xerxes'":45701,"talkin'":18651,"mickey":15516,"accounting4taste":42767,"rainbow":9857,"separately":6203,"trinitarian":25614,"hte":18301,"agnistus":32742,"parler":27264,"karmosin":25384,"tolerated":4601,"tay":27934,"overreaction":33176,"јуни":48468,"orbiter":26264,"kashmiri":23811,"apu":33911,"board's":22964,"bhadva":43925,"franz":9130,"violated":2673,"hitlers":18038,"compared":2166,"lockheed":17584,"movement”":31611,"supermajority":48696,"endorsement":7134,"possible":432,"roob323":39782,"finance":10301,"auburnpilot":15009,"vandalizes":15002,"hipparchus":37059,"wardship":31492,"backs":7236,"kkk":8629,"glover":36981,"powerlifting":49480,"encircling":46794,"lennon":10077,"albemarle":45063,"syntax":4335,"inflection":29096,"twitch":41764,"millennia":26093,"misbehavior":20861,"ronhjones":49215,"pajamas":46753,"crib":39295,"needy":19776,"independents":27461,"pixel":16411,"saini":14737,"carson":11616,"gein":42332,"means":428,"was":24,"neuromancer":33743,"acalamari":20184,"mosaic":17513,"cladists":33845,"expire":8903,"presbyterian":22973,"faisal":24529,"pricing":15214,"howlin'":47825,"sockmaster":22514,"g5":34528,"alchemy":41698,"syrians":17052,"earthly":17361,"homophobia":10226,"↕":38585,"owens":43393,"hungarians":12562,"soverign":33536,"sedans":33174,"lesotho":31166,"profited":36539,"precinct":45613,"chatroom":35963,"excommunication":23790,"rhd":38561,"nbc":8627,"gurion":20779,"summoned":18842,"breech":38621,"dbz":16244,"umayyad":31016,"consternation":32207,"macguffin":43090,"pronounced":4491,"knowlegde":39838,"andalus":47665,"connolly":20761,"clown":6094,"merchandise":12178,"yaaa":5381,"janov's":35241,"celebrity's":48682,"rasmussen":44325,"dukljans":46300,"kerry's":21940,"pasha":17415,"dicaprio":49643,"debut":6330,"fifteenth":27740,"primetech":37852,"inconsistent":4500,"wikipolice":42386,"incase":15499,"multiplied":22033,"cristian":49725,"neutrons":17557,"transpired":27196,"alls":21341,"explictly":39799,"anglicans":31000,"sandford":41881,"rip":8428,"density":7455,"chatme":16554,"fargo":45976,"fsm":33813,"entry":603,"prejudice":4489,"cid":14207,"'the'":21135,"sopher99":43240,"og":15070,"toddst1":10402,"falling":5047,"fellow":1827,"becuse":23363,"oe":20671,"inspiration":7899,"frauenburg":47656,"anphicle":39472,"hospitable":44501,"ranjit":14134,"nonprofit":15562,"upheld":11144,"edl":18415,"ylee":48680,"pregnancy":8586,"geology":8431,"consul":48901,"dominion":10805,"contributed":2172,"standby":34057,"motifs":35010,"rtinp23":35080,"marvel":8013,"guys'":33181,"amicus":31874,"love's":45199,"misinterprets":40056,"rumania":35897,"tyrants":21898,"pattani":43420,"langston":38148,"movies":2581,"sighs":30419,"kemp":32161,"firsts":32688,"lifeguard":43437,"cung":35401,"interfere":7140,"chums":43299,"valtrex":49331,"pyramidal":28981,"georgi":34502,"chopper":33108,"virtually":3338,"bionic":42656,"weekly":4772,"mqm":39170,"rumble":20279,"baghdad":14265,"haramein":28565,"bernie":15324,"swamigal":14508,"johnson":4310,"1920's":47386,"digitized":24441,"pedophilia":9318,"parma":33768,"boy":1222,"yo":2665,"loopholes":22571,"zimmer":35368,"paglia's":44524,"himmler":23705,"tt":11139,"substantiates":30548,"cognizant":26146,"mea":18526,"statments":18331,"climategate":17516,"momentarily":26167,"observation":4099,"checkers":17746,"huggle":8438,"permissable":39321,"sanchez":5853,"ethernet":21664,"cusp":44840,"impartial":5351,"sephy":49694,"fcs":48563,"danube":19658,"school'":37461,"regenhard":45685,"especialy":36014,"townsville":13492,"peruse":16246,"imaginations":33592,"trento":43852,"refdesk":18471,"limp":24269,"lcc":31052,"ohhhhh":44883,"neighbor's":41260,"gamut":29266,"hiragana":49991,"ensemble":15965,"nlp":11791,"archimedes":28767,"dedalo":37628,"irreducible":36896,"''''''''''talk":40030,"impossibly":30470,"chemical":4490,"arid":41756,"arduous":34019,"khoi":12916,"jaeger":38978,"pranks":17261,"roommate":33488,"containers":27206,"dmy":29583,"politico":19211,"alexander's":27188,"healed":42942,"relate":4588,"refusal":6321,"mather":40122,"detectable":28561,"gaelanclark":39903,"winky":44461,"ennisa":36018,"cenabee":30397,"verifiable":1122,"dauphin":36173,"bray":28468,"continental":6178,"tomorrow's":25521,"capricious":17362,"determinable":39300,"possiblity":42528,"alan's":25667,"technorati":43506,"shemuwel":39895,"clusterfuck":46783,"sued":6538,"ridiculous":1396,"readable":6421,"gkif":21999,"puente":39391,"exchanging":25626,"soxwon":28171,"saharan":11738,"while":213,"melungeon":18594,"expression":3227,"censusindia":45311,"ordinations":48579,"swept":16792,"demoralizing":26435,"brocq":43960,"gregor":43612,"partitions":36930,"debunking":13439,"htmlhttp":40807,"outrage":11331,"beckjord":9618,"centuries":3333,"choices":6302,"dishonest":4359,"npovn":46767,"chimera":19446,"eternal":7974,"unaccounted":40553,"zed":41411,"opposit":49650,"arniep":45456,"ard":13622,"plagiarism":3511,"memri":30227,"excellence":12370,"asked":599,"ponder":12822,"wep":38208,"ti":12572,"frats":42324,"britney":9176,"appetit":42130,"lourdes":13760,"volumetric":48024,"southeast":7778,"pigheaded":28715,"steyr":46039,"sleepers":45614,"musician":5728,"bananabucket":23916,"skipping":22277,"prepared":3423,"fignal":29422,"trout":14175,"fontaine":36941,"soulja":49336,"abbr":43405,"book1a1contents":18083,"grg":35120,"schumin":13451,"empathy":28232,"decorating":47065,"slovensko":45436,"naturalised":46807,"pmanderson":10390,"ama":11494,"lonelyboy":32988,"polite":3194,"broadly":7119,"alterior":41726,"extinguished":25821,"price":3345,"concernthanks":3798,"kenneth":8912,"life'":25763,"lecturers":41613,"barb":33568,"finland":5598,"ballast":33327,"wt":4711,"flew":9667,"takeshima":26883,"medical":1572,"gwernol":8048,"snocrates":38540,"speculations":8861,"dangerouspanda":35545,"plateau":16744,"cybercrime":49159,"break":1433,"funerals":24345,"kids'":37045,"prohibits":7199,"lightblue":44310,"scepticism":19872,"wikipedian":928,"agglutinative":49131,"nassim":21773,"ratified":17654,"naacp":38981,"scrabble":39448,"cladistic":28925,"kaikolars":48852,"pius":21921,"ray":4188,"rebuilding":22233,"naming":1557,"hackathon":46451,"protestantism":22155,"regionalism":37918,"snowysusan":37340,"bwilkins":9605,"scrutinize":25238,"conceal":10453,"would":47,"constant":2730,"colloquial":10073,"contreversy":49191,"woodlands":36484,"volcanic":32068,"narrowly":13928,"us":198,"disputes":1988,"confirmations":48747,"joanne":36438,"jays":46002,"collaborate":5563,"gundam":26350,"thryduulf":38038,"allowance":24729,"css":7788,"quantify":19101,"reposting":12574,"idiom":13116,"baleen":39675,"deactivate":41488,"gentiles":18718,"endured":19207,"coram":42491,"fnc":29531,"gora":33586,"shannon":3996,"shunt":45867,"probaly":20801,"spam1":28763,"aires":23477,"posits":22825,"benifit":33328,"overthrew":48970,"russel":24920,"spared":22507,"alaska's":47649,"etiquette":4392,"debated":6711,"vinnycee":38146,"riley":16537,"eskimos":30324,"dunin":27770,"mio":46966,"depopulate":40818,"pests":37198,"humorously":44708,"anachronisms":26076,"roosh":47779,"beingsshepherd":20700,"urge":3930,"50d":46505,"institute":3191,"voyeurism":42419,"bricks":20058,"exarchate":38324,"silence":4020,"templates'":48085,"telstra":23104,"yet":329,"gedolim":41300,"petifile":39453,"yuk":30066,"obar":14795,"donald":7117,"chula":6049,"viktor":17409,"bike":11581,"annotations":21271,"renames":22709,"rhyme":19055,"nfl":6313,"glogower":46132,"wikitables":47135,"youcaltlas":10957,"glassfet":35376,"evaded":25961,"batted":27622,"island":1840,"addicts":24673,"catchy":27659,"aan":48124,"lukas":39854,"nicosia":8702,"ramblings":17081,"historicism":38213,"someone's":3331,"nominations":3542,"churches":4251,"grin":13101,"npr":13088,"internship":49880,"russavia":18379,"allows":2510,"sabor":43050,"transition":6510,"includes":1470,"alters":34309,"urgent":7239,"impotence":49972,"impertinence":43547,"lnp":48298,"kaysing":27501,"evasion":8055,"oldafdfull":33556,"reggae":16811,"contracting":29485,"levying":42577,"favor":1850,"production":2262,"vivien":33224,"patented":15171,"lossless":33231,"downfall":13899,"prescribed":18351,"gostick":27678,"headquartered":24495,"null":10537,"mujahideen":25585,"levis":26919,"practice":1365,"listening":4515,"soory":32491,"axiata":49935,"excerpt":8424,"ripper":29781,"propogate":38961,"reside":12532,"deviation":16341,"hooked":16180,"precipitated":34166,"teabag":1698,"jugoslav":46311,"oscar":7982,"wapo":35391,"againt":36300,"pericles":27846,"harriet":25696,"sh":7135,"effeminate":40960,"joaquin":44862,"snott":28644,"rudloe":27275,"weakened":17356,"linguist":10548,"dt":17482,"discharged":23257,"he'll":5384,"informaiton":33123,"skookum1":39551,"sci":7732,"nast":42865,"lash":22289,"attribution":3323,"utilize":13743,"rydberg's":24614,"harrow":40567,"totalitarianism":17139,"injustices":33664,"washy":22442,"tekst":36900,"exhibitions":16049,"hostname":39726,"sux":29593,"harramein's":46742,"voluntary":7208,"hoaxer":13729,"advancement":20924,"tracking":6254,"thirty":6183,"kurds":4048,"gneiss":19383,"field":954,"spitting":22269,"petroleum":9495,"resembled":37995,"berri":22968,"deceptively":26202,"explode":14877,"mimic":21229,"fedor":36076,"polyols":43951,"deleate":24245,"oliver's":48279,"mantras":36910,"pedo":12721,"ranked":6537,"wits":20771,"mems":46433,"bitty":45559,"cleans":49412,"tomoi":20192,"googie":25947,"'no":14415,"potw":40311,"stops":6760,"organharvestinvestigation":43447,"entangled":26285,"tweed":28749,"wikiepedia":27652,"satify":48910,"traditionalists":39549,"politics":1703,"bozo":30981,"skis":22762,"gaudiya":45185,"b9":32635,"authoritarian":7498,"callous":19308,"irishmen":46845,"antibiotics":38491,"badgujjars":31724,"luzon":41219,"ambivalence":48653,"panthers":27800,"aviators":33208,"beckett":22002,"smiley":13535,"droves":32641,"helsinki":18096,"name'":34347,"levelling":45019,"impudence":49536,"wvbailey":48012,"atrocious":10727,"beresowski":43956,"retarted":18410,"fingertips":29052,"albania":4460,"nusra":31783,"mocks":39627,"caselaw":42473,"wiping":13402,"dd2k":43164,"untruthful":32671,"eta":17016,"sie":25950,"census":2643,"ontological":26751,"overcoming":30979,"jewranger":34011,"acquaint":36156,"cancellation":16163,"ervin":27355,"karaikal":49716,"nand":42233,"mp3":9017,"crowley":25496,"parishan":33515,"imma":8425,"rename":3627,"technics":38693,"visit":1816,"gage's":24891,"copula":48178,"academy":3868,"bestowed":21421,"paedo":44013,"otherstuff":39388,"yucatan":36372,"intemperate":35596,"bmp":37658,"these":112,"decides":5236,"nominated":1313,"disconcerting":35769,"dates":1626,"trademarks":23958,"nop's":37980,"quarterback":21097,"crossin":38106,"captain":4528,"whitman":10292,"detailed":1829,"obfuscated":37202,"annie":19045,"bacteriological":49930,"voyagers":48054,"ahmadi":43503,"prize":3771,"'list":24791,"auditory":49753,"illyrian":10922,"trunks":41061,"ggtf":42023,"alb":46421,"tempo":19858,"fattyjwoods":43509,"glasgow":13168,"taxpayer's":48299,"stronghold":25565,"helpdesk":25643,"novell":32705,"marxists":16576,"treasured":41363,"wnba":35856,"neutron":18517,"kamma":16300,"foggiest":43318,"rulers":7207,"mkil":26069,"8a":48511,"spitsbergen":29416,"speculative":5842,"stl":44979,"pawan":47464,"fired":2637,"copley":26843,"phobias":23545,"declaration":5612,"mystified":24086,"consoles":17357,"what's":814,"nutcases":35303,"locality":24190,"transformers":10538,"broadcaster":18105,"trendy":32793,"slavery":4347,"authoring":24217,"conservatist":35659,"dreadfully":34391,"top":301,"skunk":15414,"rubin":11863,"spanish":1316,"ravin":47829,"jusdafax":34013,"loses":8491,"http":179,"dallas":6818,"montenegro":6872,"blemish":34970,"islington":37019,"milions":42297,"subheaders":46668,"ineffectiveness":41949,"wadsworth":48165,"babylon":11984,"reverses":23666,"extremists”":45831,"subordinates":29500,"gaa":14408,"mediacoverup":38515,"ridiculousness":41248,"methyl":45475,"fitted":19049,"wifi":12764,"conor":37039,"bordered":42076,"exclusiveness":35263,"indict":48652,"wikistalkers":40104,"icon":6420,"gehrig":27400,"skating":17128,"banter":14777,"trigonometric":33962,"existant":16547,"round":2230,"aboriginal":10978,"hostages":24298,"show'":40454,"recounting":43377,"xmwsn":35616,"chernobyl":23931,"lotus":10465,"feed":5507,"unfamiliarity":30388,"plaza":13163,"poving":36607,"10km":46249,"ambedkar":18964,"taufiqtoki":49168,"gellhorn":24235,"centre":3554,"spanks":45676,"nananac'mon":28452,"rabbis":11218,"london's":27894,"lingustic":46997,"wop":48742,"pls":5633,"salty":18680,"diminished":18245,"•discussion•":24451,"haq":35084,"‘we":31263,"ock":46526,"33333333333333333333333333333333333333333333333333333333333333333333333333333":28995,"implementation":7438,"elen":17167,"stockton":29679,"narod":43518,"honour":7180,"34s":41960,"chhe":47619,"somebody":1266,"contradictory":5101,"lic":40276,"umlaut":25982,"krakow":42643,"maintain":2317,"melt":18430,"infoboxflag":40283,"palm":8140,"spaceship":21818,"quiero":34746,"useage":33606,"anjem":42252,"titans":29346,"overlords":46565,"towns":3756,"wag":39731,"grandchildren":19061,"spl":22099,"quackguru":15557,"sunk":18933," – scent":18611,"disseminate":28104,"sarsa":49971,"modules":13391,"interpolation":45800,"altercations":35287,"geared":14442,"vornamen":38823,"anomalous":17390,"pervasive":15265,"cherished":27546,"bearers":31144,"sexes":19052,"'incident'":43483,"scmods":42136,"tennant":48195,"aggressors":27863,"disgusts":48811,"vanderbilt":29777,"invader":27502,"streamlined":25553,"antisemite":19512,"‘an":44486,"meals":27056,"hesitation":20399,"antipope":42894,"complaints":3007,"'one":17095,"youd":27636,"beersheba":43492,"willi":39383,"atabeks":49162,"myo":31849,"strung":39412,"traffic":4656,"reflexive":32348,"destroying":5418,"xbox's":45378,"force":966,"cheapness":45627,"lettering":30752,"tendentious":6225,"postpone":30897,"creditable":20336,"galilee":32286,"methane":27539,"poopie":24405,"urbandictionary":29666,"melchoir":23652,"choosing":5869,"brahmans":41526,"mikenorton":39861,"disgrace":5639,"watched":3843,"malaysian":11185,"berlet":9862,"theology":5017,"comprimise":26651,"sorces":36708,"organisers":26873,"zuckerbergs":39466,"game":595,"profesional":35417,"authentically":35575,"pee":10322,"rios":43735,"lengths":9084,"ftutocdg":23081,"proximity":13601,"conversions":17947,"caption":3310,"banishment":20756,"invent":8742,"jordan":5251,"browne's":47302,"essam":40140,"als":19145,"drvs":49811,"intellectual":3082,"percentage":5218,"pandit":41064,"royals":14190,"wilkerson":39743,"uscgc":45536,"newgrounds":48996,"alagoas":38570,"guerrero":17878,"slagging":41732,"outnumber":26010,"roth":20160,"verison":41298,"shamir":26715,"sensationalist":20322,"buggy":26957,"weirdo":16057,"cummings":21269,"quibbling":31001,"signers":13866,"cna":29580,"rays":15092,"mendacious":36848,"interbreed":28676,"bureaucracy":9821,"misogyny":26460,"manumission":18869,"abandon":9346,"unrealistic":15384,"unscholarly":42154,"brighton":20171,"respect":821,"'dodo'":42817,"friggin'":36467,"kinzer":35273,"embellish":36629,"municipal":9834,"powwow":20127,"horizons":28933,"yearbook":11940,"alongside":5862,"whiff":33285,"maimonides":36518,"alpes":39222,"specials":23455,"lexington":23861,"incitement":21256,"haitians":31093,"transformed":10874,"inaccuracy":11683,"pictorial":37681,"dn":47351,"ralf":35688,"—the":6354,"20s":29306,"footsteps":26528,"engineered":18235,"clashing":45246,"jameson":23380,"stunts":21777,"defcon":31432,"plots":8870,"transliterated":17345,"cards":5906,"peter's":16135,"carr":15255,"stumped":33821,"expectation":11212,"oficial":32623,"archaelogical":35395,"nastel":49420,"dft":29060,"asghar":34705,"glare":30444,"humiliate":24663,"awaits":21808,"srich32977":28169,"swallowed":21148,"izmit":39980,"data":893,"anglican":9005,"select":5221,"'english'":24855,"blairs":41595,"kannambadi":12404,"cleanup":2584,"forensics":19353,"wings":8232,"poorer":18156,"godfray":40677,"starship":26424,"subjects":1581,"sine":10061,"hami":45029,"buggers":31958,"jabba":32359,"jail":6875,"september":1130,"glick's":34729,"pym":34006,"katherine":15209,"lasers":26039,"vientiane":34503,"inhabited":11186,"janamejaya":39305,"reclaiming":41156,"brent":22645,"redskin":34678,"bri":49967,"strand":18259,"codswallop":49832,"itsuck":6317,"domingo":23493,"blink":12418,"hippo43":31809,"deception":9229,"lyfe":45253,"ostensible":34362,"tawny":40753,"suharto":26088,"exporter":40478,"britney's":35423,"readded":12891,"spamlist":27834,"preeclampsia":38827,"interior":7865,"editing》'''":30314,"santorum's":45759,"ncis":31617,"retagged":46828,"switzerland":6782,"reassert":46619,"juelz":38873,"'98":39829,"domicile":38240,"joint":4898,"redir":34124,"cylon":32468,"industrialization":30708,"contribuition":49604,"frye":25195,"ukc":27049,"'only'":40332,"andrew's":37511,"persuaded":12245,"aesthetics":13867,"referenced":1212,"sifting":42039,"longed":49901,"identifies":7112,"minds":3846,"dahn":12946,"broth":39232,"loanword":48107,"tallinn":29991,"diglossia":25571,"goaded":22082,"roh":28377,"bom":32042,"karanacs":29848,"chesterfield":43874,"powerpuff":41169,"moose":24157,"protracted":21690,"absence":3940,"celcius":37693,"writen":12969,"gsd":40214,"nationalist":2840,"clocks":17022,"outlines":8362,"hampstead":41582,"disassociate":41894,"proposals":4302,"blankings":24953,"summons":20390,"frigates":34792,"blogspot":5455,"begala":30337,"does":103,"basket":12732,"civilizations":15223,"transcribing":48835,"'jim":21679,"":18380,"dns":18903,"alsf":38718,"classified":4699,"heigl":44353,"consistently":3929,"ask":209,"sadness":28803,"redistribution":23525,"significant":953,"ry":33443,"esteban":33042,"batteries":12829,"lucien":20179,"calculus":10447,"mb":11457,"avnoj":47892,"eurasia":17901,"vikramaditya":31021,"roundly":31036,"doign":48588,"occasions":4748,"frodesiak":28483,"type":711,"regard":1670,"narrower":16866,"killswitch":35925,"chili":15682,"je":8197,"contribs''":23579,"invention":6123,"uthersrg":37987,"kingturtle":35101,"stereo":33861,"kasargod":40009,"takrur":26851,"mgtow":43560,"receptor":13707,"egalitarian":21998,"clutters":28154,"romanesque":29367,"breakfast":9457,"на":23637,"conclusive":11396,"sensuality":45853,"afp":19433,"lecturing":13537,"lebensraum":45103,"tossing":23364,"measles":43093,"artículo":49673,"morley":43064,"homage":22191,"noobs":2137,"constructing":14984,"cylinders":23690,"stockholm":15997,"evolutionistic":46493,"battery":8635,"labs":14200,"intensa":38712,"abstraction":18910,"harcourt":30192,"amused":11390,"smalls":45540,"unknowable":26572,"venona":49875,"beirut":22770,"rummel's":49885,"oxyhydrogen":34485,"cagan´s":29423,"histoire":17911,"parivar":39973,"followers'":45837,"kazakh":22696,"nik":27916,"tiny":3501,"spew":16186,"zimbabwe":16852,"expounding":29594,"junie":49957,"jobe":45081,"platonic":20470,"athletics":12760,"certificate":6557,"buster":15085,"loath":35708,"virgina":42207,"dark":2154,"artifacts":13200,"christina's":48108,"logics":40168,"phu":42301,"objected":5595,"ahmad":10677,"krabs":34061,"applying":4695,"airship":42223,"reincarnation":12711,"intruders":44943,"bummer":30014,"lipstadt":34940,"imbeciles":17442,"izak":15428,"scream":9498,"tthe":38579,"edjohnston":12159,"complicates":31949,"20uses":47570,"ct":5466,"agile":40038,"scrape":22287,"seemingly":4556,"aw":13609,"hated":5641,"zacharias":35290,"®":27646,"considerate":11841,"firearms":11690,"oppressing":35503,"jumped":5801,"sirens":28054,"wehrmacht":25636,"kozlov":49870,"goddard":21062,"tyrannosaurus":31124,"all the best":33566,"belanger":38723,"jagex":27205,"republicanjacobite":33849,"reps":26017,"arrogance":5759,"ngr":31308,"mitigation":24302,"bram":44618,"louie":37427,"hán":33884,"interruption":28026,"cancel":11377,"mods":5225,"battista":26666,"bd61":32579,"hibernian":25522,"cote":32072,"care":434,"individualistic":45727,"casanova":49829,"rhodes":16297,"impeachment":28945,"spurs":32157,"croatisation":44364,"eaters":18253,"hazards":24189,"m6":47014,"purification":48904,"ieee":18220,"pasted":4308,"eisenhower":18979,"louisa":42980,"walkthrough":35890,"artifact":17774,"cailil":18117,"stealth":13630,"tig":39750,"questionnaire":21588,"hdayejr":27445,"negatives":14524,"emphasise":16502,"forked":23735,"greenberg":29686,"jdwolff":30078,"frightening":19981,"aulahehelalelalala":17538,"cci":24148,"imposing":8790,"garra's":38246,"carcharoth":45167,"rajputs":6642,"reactivated":42566,"univeristy":30056,"ewing":44775,"vented":46059,"“please":42765,"immigrants":7459,"gorillazfan":21579,"streamlining":36567,"express":2138,"clamshells":26334,"yankee":13721,"stately":40334,"jamie":10341,"gags":38016,"beatles'":35098,"business'":15350,"egos":12120,"gn":42902,"recoil":22179,"adds":2917,"waldemar":48451,"prisoner":10994,"zeno's":21922,"kthxbye":35758,"sourse":41742,"surgeries":22525,"quotable":41510,"pilgrimage":17102,"intervene":8505,"jousting":21678,"lover":6304,"fooling":12426,"disclosures":28289,"dennis":5293,"shona":43342,"timur":27455,"parentage":20992,"rfdtuunvqlqc":49799,"charters":24823,"fuckhole":33798,"shyam":33163,"elaborating":26729,"boxed":25722,"disallowed":14154,"freiherr":40222,"amount":1252,"heros":17555,"shithead":5091,"cunnilingus":34285,"muster":12684,"ainm":46432,"unblocked":1812,"samanta":37097,"fewest":37080,"merely":1051,"makin'":46711,"watercraft":27362,"prison":3544,"falsifiers":31637,"kidsco":40945,"tenor":18867,"arose":9018,"adjusting":15579,"msdn":41609,"khwarizm":28690,"aligarh":45301,"hooper":40850,"cubes":32074,"turkic":3822,"indelible":29380,"imaginary":7108,"alphachimp":23451,"cambrian":32391,"yorkers":27579,"wachovia":38601,"phat":29298,"yesterday":2257,"director's":36304,"stepped":7114,"skinwalker":29199,"constructed":5296,"site's":10121,"hollow":10349,"lute":16489,"concerned":1261,"deputy":9607,"delldot":20909,"ngawang":41910,"zambo":17939,"tr":10284,"tom's":24739,"lott":29841,"looted":35762,"pinchas":30058,"significance":1839,"neologisms":16028,"chemist":13775,"shillings":46302,"musicologists":41768,"arbitron":26871,"disprove":8182,"protection":1265,"mole":11989,"beehives":34635,"toughest":48406,"band":716,"safed":44921,"sexist":8782,"remediation":24668,"saxe":29843,"pettiness":26713,"jackasses":22515,"champions":5717,"curious":2018,"skilled":10854,"niesen":41057,"ravidasia":41712,"missorted":45221,"hoaxing":23032,"connotations":9537,"copernicus":13800,"b1":14843,"dfw":42626,"gabriel":11190,"landed":9449,"technologically":36129,"chapter":2521,"tps":33415,"hackneyed":24012,"won’t":11817,"newyorker":45325,"thom":35689,"clemency":40630,"culminated":33151,"xml":14696,"peaceful":6828,"daishocon":48549,"freitas":36594,"ter":29869,"zodiacal":48459,"thesis":5555,"mainstream":1643,"vandalizm":26259,"nalwa":19425,"retype":35536,"movement'":38145,"runes":33681,"symbiotic":39106,"peer":1495,"rannṗáirtí":49041,"s1038":49486,"gaelic":10559,"digging":6916,"winn":34586,"slowly":4755,"retraction":11754,"serpents":48496,"word's":28631,"loudspeakers":41548,"artefacts":43084,"tracklisting":18932,"obama":2071,"circlejerk":47847,"— martin":26416,"what'll":48795,"abstinence":22563,"rigveda":21145,"messagelabs":47956,"provence":32044,"urbanization":44338,"spontaneously":17987,"glyph":32254,"reproductions":46381,"agha":35988,"subtitles":21045,"finkelstein":16858,"progesterone":48008,"surrender":9567,"slave":4812,"learnt":8786,"huge":930,"tuesday":7284,"paraphrase":6195,"jeffro77":11275,"length":1886,"imperator":44076,"nude":13513,"testicle":33375,"oktar":49499,"revolve":16166,"chanology":26708,"elected":3804,"   ":29642,"stefano":13482,"miracle":12383,"geography":4633,"cretins":23922,"wolverine":25212,"emu":33482,"taxman":35191,"sangam":33704,"imaging":19281,"enacting":26872,"hose":34054,"paganism":17069,"summarizing":9401,"''''''the'fortyfive'":23421,"britain's":15094,"apparitions":45804,"rw":12918,"ky":18186,"gwynedd":34814,"engine":2527,"cements":46570,"cloned":27681,"cng":29196,"unsuspecting":25859,"stair":47089,"derrida":42423,"gratis":39561,"fascists":6870,"unappreciated":36893,"desired":5656,"monticello":49044,"afoul":16132,"serial":6712,"novel":2893,"angular":16564,"detroit":7813,"convection":25513,"typhoid":33389,"calhoun":33202,"dolphin":21221,"sonja":15096,"pole":6489,"city'":40926,"obviously":580,"hmg":43187,"sherwood":25485,"webmaster":9825,"biro":47345,"jamal":18662,"smelly":12987,"triumph":13020,"mc2":42998,"arn't":24135,"faulkner":28504,"ikip":37967,"croatia":3707,"foo":9926,"congress'":48921,"sally":18484,"jeske":48063,"anode":30521,"nepean":38653,"tejas":32258,"patriarchate":39426,"pooper":48267,"—khoi":35943,"blackstar":42715,"mccrae":34685,"major":649,"lasse":35073,"misrepresented":8433,"absolutism":42217,"phaedriel's":45824,"countable":25746,"infancy":29001,"indoeuropean":39567,"rowspan":7535,"slavs":8008,"morrissey":25777,"economies":16195,"subjective":2890,"adl":10437,"pyramids":19826,"gleefully":45452,"hilo":38221,"marathi":18670,"tring":23846,"smu":26057,"strictest":23917,"sounding":6415,"reconciliation":16734,"000ft":46546,"pygmy":17834,"hiking":33626,"ezhavar":38485,"abbreviations":9792,"colby":33618,"meyer":10945,"pose":10550,"mcwhinney":21215,"increments":28466,"freplyspang":17827,"encyclopediac":31025,"reciprocated":37714,"mcporpington":44552,"rok":34665,"stint":22502,"docs":10711,"gibson":7039,"lecher":48974,"barbarism":33644,"surat":18498,"weatherman":44418,"baked":13955,"wikipadia":30119,"ω":12248,"jati":26958,"sinclair":21860,"rationale":911,"taylor's":28846,"ravinder121":34779,"embarking":39988,"niekerk":49252,"squad":5400,"rink":26087,"slope":11452,"lemesurier":41199,"feeney":39310,"bedfordshire":39779,"dmc":24756,"diana":10951,"ecb":16572,"sul":19195,"earthling":39515,"worshipping":23439,"shipments":25995,"ai":8030,"undesirable":13617,"blaze":34279,"moment":1192,"approaching":9104,"consequent":19535,"motorcycle":10905,"roleplaying":31405,"getty":34197,"defect":15896,"preponderance":18884,"gratefully":29400,"aspersions":15444,"differs":7473,"safest":20447,"amber":17041,"mer":33831,"proposition":7057,"rental":22094,"psts":34657,"pierre":10122,"stacey":25158,"wedded":28998,"lancet":15959,"rognes":24362,"jack":2178,"vaccination":20176,"trashy":20466,"dwarfs":24961,"parlemus":35952,"nac":42228,"obit":18807,"morroco":21832,"scruples":48006,"muriel":31138,"meaningfully":41458,"sylvia":24822,"accumulation":24720,"recreated":7665,"δt":48750,"boarders":28717,"bacterial":22009,"fanning":31796,"pariah":28906,"ots":12101,"liabilities":43368,"integrals":42875,"eruption":32069,"wp's":8949,"multiverse":41474,"knott":29007,"göran":38710,"curtisnaito's":44869,"ine":41693,"islamization":41304,"turntable":35447,"ionized":29966,"youtube":1607,"insinuation":17586,"expiring":24622,"andreas":12136,"bulls":12303,"cruise":10856,"loo":30049,"prominence":6771,"ngrams":49970,"purveyors":34748,"unconvinced":19003,"wilber's":48552,"ture":49291,"neftohimik":38073,"rox":47532,"partying":32604,"gangs":9802,"hla":36396,"muhammad's":12787,"—''''":33149,"sebastien":34954,"nguyen1310":46863,"​—":45209,"mayan":40298,"comrades":15046,"pcs":19828,"spiteful":17547,"osceola":42379,"bashed":38488,"purse":18532,"errata":30168,"brothers":3186,"barc":41031,"actionable":10681,"tina":16248,"assange":12038,"huron":46855,"sepp":49005,"tyrell":44360,"nepali":19143,"pointing":1793,"poptropica":38714,"enderle":38783,"teleology":48337,"yaaaa":5417,"lydia":27460,"concubine":43284,"else'":46956,"gullible":14809,"disappeared":6153,"lotr":27808,"accuracy":2293,"simmer":42459,"shed":7472,"jecob88888":47786,"meaner":41936,"monthly":7464,"insulator":38679,"regenerate":33853,"inject":14198,"europe's":23702,"saucer":24002,"☼":8552,"korea's":35258,"khalifa":21584,"tmbox":32173,"aluminium":24179,"talbot":16597,"bellatrix":47252,"nurture":36461,"waldensians":31794,"hilary":23656,"erupted":31160,"hinges":32105,"suffokate":47429,"securities":17304,"mayday":34307,"taphonomy":34863,"instructional":23376,"nx":27120,"bernadette":48986,"crops":17892,"petitt":42445,"antidepressant":47438,"senter":33497,"ved":8730,"harlem":24702,"friday":4530,"fingered":35729,"'73":45838,"reported":999,"papphase":43383,"belvedere":45111,"vaz":31103,"shipyard":35948,"bethune":47041,"benutzer":21873,"al's":25523,"chiang":32305,"wikicities":41738,"romero":19409,"fulfills":24691,"fires":9484,"coursed":31556,"circumvent":9980,"foresee":25878,"understable":49037,"schools'":45993,"jaffna":16356,"peanuts":29271,"prime":2353,"aromanian":20449,"roger's":48090,"arabs":3237,"encyclopaedias":27347,"chandragupta":46027,"coolkatt":44009,"specialization":31742,"sparingly":18090,"sunic":42152,"spooked":36534,"karrine":42511,"alessandro":21095,"adequate":5188,"equates":19166,"cheese":2787,"rajnikanth":49314,"diner":39684,"decrepit":44605,"mcgill":32091,"–":677,"einhorn":39668,"hpp":21847,"becouse":17943,"sirfozzie":40442,"⇔":20902,"scan":5254,"cpi":34111,"pecher":28242,"tupac":22636,"za":11644,"officious":18708,"—'''''' ":47296,"sangh":28089,"odessa":20008,"proto":5491,"childish":3309,"t•c":13035,"manipur":16981,"giuliano":32674,"analytic":15450,"siv":47851,"energy":1519,"turd":11703,"frontier":10327,"reclusive":41805,"ney":30431,"overlinked":40020,"improbable":14148,"samsung":15545,"prussians":24633,"nob":30224,"countermeasures":33210,"seer":29704,"stamped":23588,"mccarthy's":28609,"lorenz":36261,"watermarks":31954,"otc":48323,"diminishing":20389,"80m":47397,"mckinley":40954,"kinks":29577,"monarchies":37194,"airs":13460,"entered":3991,"break'":44896,"beebe":30655,"jizzul":43325,"milky":19773,"roof":11914,"cautionary":29769,"—αἰτίας":24450,"paying":4473,"noam":19270,"enslaved":13424,"bonafide":45056,"troops":4135,"xal":23007,"court's":15551,"weinberger":32492,"usui":47303,"columns":6085,"backstage":16774,"rf":14089,"bradley":10756,"weapons":4145,"foundation":1921,"andrija":38932,"rages":41126,"arsehole":14471,"muslims":1894,"headquarters":9609,"conforms":9763,"mercy":7815,"spinoff":12719,"jk":16394,"manninen":46346,"amar":21961,"zionists":9683,"charlatans":42064,"sargon":41229,"rey":15686,"olga":21430,"vert":45849,"sergecross":35187,"usability":23025,"б":38903,"em":6117,"cobbled":35103,"ftc":32426,"tbl":43889,"opened":2831,"collegehumor":43868,"illumination":34158,"ealdgyth":31521,"semester":12878,"teacher":3395,"snowball's":45256,"cyberbullying":21339,"swallow":11712,"walker's":38407,"stone's":33423,"asl":23004,"lovers":7469,"guesses":11860,"'mainstream'":49818,"authorize":20388,"andpieces":18265,"midsummer":49462,"orientations":28647,"wftx":49578,"dalglish":46868,"wisden":39640,"intransigence":27952,"sleepy":24186,"santino":45705,"juggalo":47082,"narrating":43499,"pressurized":48369,"says":287,"wavefront":27381,"automatic":5495,"alien":4765,"talmudic":35741,"doh":20600,"republicanism":21654,"matador":25064,"occupy":7552,"unofficially":20440,"blnguyen":13156,"sweetest":16919,"cartridges":27143,"dream":3945,"aggregated":37027,"'re":36081,"sclerosis":23259,"inevitable":6626,"eventhough":28864,"propagating":21743,"imdb":3107,"defensible":26189,"sponsors":18008,"principal":5195,"drchrissy":24835,"strapping":41734,"herod":20498,"entitlement":18666,"captures":14551,"reconnection":18098,"remarriage":30336,"installed":7351,"struck":5781,"usefullness":47931,"detail":1233,"hub":5600,"service":1126,"strasbourg":28830,"sympathize":12955,"camaro":48395,"conceive":24721,"decked":47816,"resurrect":21252,"wi":12362,"uploading":1366,"harrassers":49990,"outbound":30430,"freshwater":26038,"mordechai":46962,"herodotus":16169,"restorations":47534,"ghmyrtle":48869,"lozano":43453,"rewording":9826,"paz":32706,"evans":7636,"dp":9013,"extraction":12184,"quitting":13595,"develop":2014,"usuario":40352,"evening":4138,"unapologetic":30974,"philosophies":12064,"discredited":7955,"qos":48119,"vickie":46323,"seigenthaler":19329,"antisemites":24638,"grabbed":16856,"milf":32480,"compatibly":13316,"newfoundland":17104,"paradigm":12410,"robots":10416,"dilution":41843,"deliveries":40604,"contemporaneous":36620,"chacor":33220,"councillors":22228,"pelasgians":44640,"'contribution'":47849,"2b":17940,"patriots":11065,"phrased":8276,"euclid":30380,"implemented":5867,"ie":2153,"statment":13868,"bible's":34590,"tuberculosis":25883,"tings":38335,"polly":25474,"eø":45373,"sensei":10777,"corgi":29257,"irondome":36246,"preachers":27221,"eponymous":24001,"occasional":6898,"'one'":28447,"ions":19064,"fog":17392,"archivedate":31088,"raising":4516,"min":10818,"poi":30280,"applicant":18494,"indirectly":7555,"unequal":26898,"m2":30305,"paleolithic":21270,"bank":2695,"coppermine":24373,"ohl":32476,"dismissing":10525,"skype":14123,"delineating":38194,"mosh":38278,"resilient":44500,"yoru":34959,"unruly":47420,"disengagement":41281,"dalai":13398,"minded":3390,"trifle":48997,"roots":4150,"cte":48219,"coyotes":26830,"wycombe":46258,"certificates":12967,"recycle":24023,"mai":17711,"racists":6868,"ninth":12645,"leans":26802,"seminary":19114,"correctness":7146,"skater":35964,"regine":34702,"directv":23797,"mellon":30442,"incapacitated":41373,"vetoed":42424,"firm'":16980,"rhode":16913,"blundering":47286,"unremarkable":21207,"rants":7312,"interscope":46585,"tulane":36673,"boredom":22165,"entailment":43818,"forsyth":19921,"charles":2387,"childrentab5":35499,"´¯":17494,"psychiatric":9643,"sinusoids":37380,"hdd":38768,"dying":5708,"politik":45497,"crawl":12285,"κ":27415,"one’s":16204,"akron":34341,"khamenei's":32845,"slt":34723,"nt":8516,"discursive":40648,"esoglou":18102,"thematic":20913,"around":324,"pledged":19340,"necessarly":48426,"heart's":30156,"definitional":34312,"subscriptions":44795,"leep":47738,"hounds":49750,"sporadically":35125,"adoption":5003,"spore":15881,"forming":7720,"joppa":20862,"'round":25576,"wee's":36595,"wilma":27926,"utilitarianism":42650,"baby's":39294,"swearing":10649,"draconian":16910,"penchant":18897,"auslondonder":45032,"synonyms":10119,"when":82,"sloat":46382,"subwoofer":47220,"nums":24369,"sortkey":28638,"hu12":13148,"malt":31059,"fakes":22663,"extrasolar":33642,"constituency":18953,"px":30896,"bugging":13672,"categorize":9587,"— ":7205,"tripartite":47238,"signals":8465,"oldlady":18199,"houghton":43975,"balanced":2771,"pm":3436,"legit":5448,"bernanke":20976,"american'":35243,"canid":40994,"ann's":43231,"imax80":44766,"trey":15135,"reword":8460,"stemonitis":36719,"wiki's":3953,"creates":4283,"donner":20114,"roundhouse":43880,"putera":47790,"prophetic":32284,"smuggled":29677,"tackling":22951,"venetian":20458,"studing":46420,"subs":37000,"soliciting":12759,"kahn":33058,"sinning":43878,"chabad":11912,"amandajm":34710,"moore's":15243,"fontana":49788,"a4":13587,"awakens":45682,"similar":616,"alton":35927,"valencia":19694,"buddhahood":46261,"monumental":16704,"lanes":27300,"isarig":48592,"cont":6925,"leper":48662,"gene's":46331,"tov":34275,"tbm":14005,"avoiding":4349,"canai":42641,"uncle":5309,"ð":38902,"schubert":22443,"pwnage":44060,"wolfson":45191,"freezes":36907,"aiding":17580,"oni":37564,"finbar":48978,"session":6128,"changing":918,"tee":18700,"server":3422,"zakaria":45829,"wikipedia”":37888,"region":1482,"claude":18649,"archive3":36289,"arrested":5435,"intermediate":8877,"bish":32977,"interpretation":1762,"spventi":45491,"spur":15431,"shabazz's":15596,"ai009":14036,"elton":16942,"x1":45931,"drummer":10274,"flipped":20892,"deface":17649,"egoistic":30498,"zillion":25412,"blackberry":20499,"asiana":27913,"bullard":30561,"mainspace":5661,"czechs":18482,"sic":5808,"dewan":42298,"meager":29874,"reinforcement":36258,"ruleset":7040,"wordsdeeds":32596,"greasy":23568,"mutatis":46112,"furanka":41679,"everyday":4265,"scenario":6623,"artilce":20602,"issued":3184,"keepin'":22014,"added":181,"gloriously":41752,"seashell":8004,"gray":5609,"canker":46733,"wigan":21542,"wikilinks":6890,"johannesburg":20216,"family":723,"beautiful":3069,"fewer":5797,"translation":1681,"subdued":24104,"parameter":5952,"dias":40626,"rense":21152,"tires":20123,"transwikied":48689,"–patois":46298,"sayers":33344,"fansub":31183,"tails":16212,"until":386,"pecker":20057,"towed":41707,"merrill":23569,"overdose":28294,"lucifer":32821,"crowding":28143,"implanted":41208,"infer":10023,"dilbarjan":31345,"forms":2336,"vat":40342,"recalling":33932,"beethoven":18278,"dosen't":16323,"qatar":14044,"distilled":34588,"deltasim":34694,"fukin":18703,"shambles":19896,"relayed":22053,"miffed":26274,"asserting":6501,"fdf":46525,"bv":37976,"raves":23877,"hawkeye":49467,"techcrunch":37145,"arvanitic":19598,"pushy":42642,"gallifrey":49579,"tchaikovsky":48452,"genomes":46851,"prix":12716,"tá":41929,"groping":29330,"technocratic":37699,"yousafzai":43311,"ameng":41902,"granny":38020,"bec":36572,"stewards":21358,"violates":2545,"tweak":12063,"mediacorp":40268,"insured":29198,"ashame":48649,"positing":29997," 5":45577,"mets":25832,"partakes":32315,"submissions":8049,"trunk":19775,"icelandic":15856,"orthogonal":26603,"commonsnotificationbot":34620,"interpol":19018,"meds":19099,"nets":18898,"stranger":9510,"helena":21350,"valleys":23318,"degenerating":29940,"nevis":29338,"lad":14665,"mufti":27099,"·✆":42705,"in":10,"sprang":36174,"degrees":4121,"disregard":4827,"horseshit":25154,"solicitors":41295,"e7":35577,"enola":49194,"attaching":35908,"stating":1438,"fills":15422,"carew":44248,"disadvantaged":39646,"desire":2626,"woc":26965,"aptly":17816,"lhvu":39394,"validate":9382,"wholesale":6233,"norfolk":19519,"negro":7500,"poisons":33003,"mizoram":37391,"terry":8187,"calvert":27900,"aprox":45930,"equally":2455,"grichka":38692,"aeronautical":43995,"inertial":12638,"renderings":39234,"intellectually":8956,"avl":38187,"hump":28897,"rope":11320,"iţ":36891,"plastering":42906,"stalinism":21410,"über":42820,"stifle":9071,"gey":47494,"fick":37013,"rea":37771,"googol":42286,"siam":48632,"verma":27353,"dcs":22801,"wmata":44179,"gained":4476,"grooves":29050,"meru":42796,"billboard":6006,"pentrez":29351,"expunge":26098,"ira":5196,"sme":41175,"embedded":7935,"60mins":34905,"buddies":7041,"lapita":38526,"entirety":6817,"crave":29085,"drilling":26816,"refined":13386,"consonants":16229,"unimaginable":34036,"caine":33436,"ttfn":22516,"cake":8429,"pronounce":7357,"alstair":16483,"somethin":28440,"blackburn":35469,"ipcc":12632,"ambigous":29710,"kindle":46391,"keept":47378,"icc":17300,"hyperreal":44247,"numbering":9800,"altruistic":34244,"biochemistry":21857,"ark":10016,"thyself":37955,"lika":16311,"agnew":43136,"hollyoaks":25071,"olson":34488,"perusing":24685,"extensively":4996,"taurus":32361,"faulted":33053,"alertpay":42212,"commemorative":43211,"gamaliel":5007,"eef":22011,"hermione":30921,"pleasing":15339,"clairsentient":41559,"uzi":41369,"servers":5488,"punjab":6276,"ardenn":43732,"shabazz":17174,"madoff":25285,"dabomb87":45426,"placenames":24862,"fluri":48713,"generalist":46322,"rosemary":25776,"grandeur":27656,"manhood":20567,"cooperative":10201,"sharingan":43196,"magnanimous":42033,"vandalyzing":46447,"acknowledged":3252,"reorganizing":20459,"peeve":36127,"iranica":10767,"lua":13781,"rangers":4998,"shah":6176,"jumping":5596,"tries":3573,"recheck":25895,"elven6":26367,"multiculturalism":18489,"seriousness":11741,"nutjobs":43252,"ouţ":47392,"mauling":43823,"itub":27254,"irc":3214,"belies":35786,"dolls":15190,"held":1606,"vowels":8880,"vetted":14898,"storyteller":40915,"delay":2024,"30am":36473,"dragonflysixtyseven":29106,"unpleasantness":30736,"1000's":46990,"senegambia":32408,"palestine":3506,"phantasy":35139,"omnipresent":29837,"eritrea":19344,"fright":31130,"softcore":36207,"ludicrous":6915,"sergius":33734,"roy":4811,"denounces":34022,"mythbusters":37736,"assessors":38972,"risker":22617,"approachable":37855,"crashing":14426,"bubble":8847,"clarinet":33760,"mitb":35512,"duty":4437,"markings":19807,"vishal1976":30842,"telemundo":29635,"monk":14255,"possess":8441,"cathy":16337,"personnaly":27969,"saver":29543,"johann":14163,"warren's":23733,"saskatchewan":10406,"exhausting":14670,"rhetorical":8878,"28th":16604,"ecology":14023,"potter":6134,"monarchs":11576,"collected":6590,"corners":15496,"coached":32955,"endnotes":39930,"statistic":10604,"james's":22923,"glary":48821,"pantone":30559,"postive":24815,"shojo":35456,"cs":7965,"fence":10540,"feebleminded":48229,"sidaway":8915,"crichton":39129,"disambig":6454,"≈talk":15154,"coord":17991,"dahiya":21249,"literaly":43067,"domesday":31360,"stick":1472,"bbh":44245,"agent's":44420,"fal":35849,"catalytic":38479,"kaluga":43958,"provocateur":27923,"tabdefine":37802,"eroded":49190,"congressman":12166,"revising":9437,"accussed":28263,"beverly":19348,"tke":37406,"enc":30805,"thf":13182,"veryverser":24057,"coeur":44612,"zintl":29430,"vendetta":6867,"fotos":31398,"projective":35238,"ottava":24546,"bridgestone":48416,"arenas":18394,"braking":37764,"physic":17905,"emergence":15079,"noobie":44399,"redlinked":16148,"rarevogel":48467,"garcía":45392,"enticing":27946,"tapered":46497,"assesment":20927,"debt":6149,"gpv":44560,"stir":11176,"nineties":33394,"galling":12487,"cordoba":31764,"deliberately":2675,"luck":1359,"administered":10562,"occupied":3934,"grease":17824,"counselling":45182,"sported":45159,"c5":23044,"cole":8415,"perpetually":32211,"silver":5404,"glossed":28272,"zetterling":38920,"whitelisting":33454,"indefinite":4416,"lenin":9679,"pesky":24256,"speciation":24094,"wpus":21083,"bassists":43536,"flower":9861,"accomplishes":30091,"dedicates":35709,"gilded":36404,"priestly":38933,"swinging":17558,"catharines":46214,"reinsertion":42671,"here'":33269,"bloodrayne":47810,"north":1021,"illustration":5920,"leiden":42623,"subpage":4538,"'when":36290,"overwhelming":4385,"mutilated":22273,"permissible":12586,"widespread":4668,"nowadays":6291,"jossi":8671,"sabine":36798,"controversial":1146,"camarines":29427,"cucumber":27623,"invite":2973,"rationalwiki":34173,"maharaja":25599,"disorders":7956,"epistles":25838,"chesapeake":49224,"oz":10049,"lengthen":25164,"gardeners":46314,"publicised":26438,"percieved":17748,"dist":20208,"rom":11510,"offened":49934,"falkland":13158,"bishonen's":24902,"okinawa":16593,"intertoto":42683,"hotly":21209,"align":1030,"hopes":5445,"coolant":43228,"cheeks":22448,"railing":26778,"nutrition":13693,"variety":3023,"faster":4623,"readership":9467,"baggage":19582,"mahmoud":18179,"blitzers":26886,"rickk":9851,"happy":464,"ran":3238,"absolutley":49009,"grammar":1884,"seemed":1620,"fermented":43683,"ufo":9406,"colossal":21082,"dialogues":22272,"zap2it":42251,"haplogroups":27406,"irrelevant":1058,"abundant":13762,"freddie's":37284,"bromwich":37810,"critisim":39747,"oui":17601,"goodluck":30569,"christgau":31649,"originals":17642,"contextualized":32759,"mist":30809,"equivocal":45816,"ritter's":45363,"assured":6719,"usless":31271,"corresponds":11163,"mechanics":5825,"cbw":31374,"fuckhead":14433,"'notable'":29297,"hvo":21659,"o’neill":45447,"keeping":1480,"outlaws":26575,"staffer":19897,"franjo":32859,"tamil":4261,"coalition":8643,"beginners":11202,"wsi":42365,"perpetuate":11093,"facade":20244,"conquest":7220,"ltd":6888,"stalinists":44690,"stooge":29750,"filesystem":34486,"plasma":10093,"addictive":18631,"nohat":45134,"boolean":12599,"'97":32962,"fortress":17837,"tired":2529,"pcarbonn":48004,"squares":12598,"packaging":15270,"sanctity":35312,"slams":28872,"reapply":41799,"mendez’s":46351,"philippe":12107,"microphone":34253,"disbanded":15515,"vaishyas":44462,"engender":37510,"chink":6403,"hooks":10669,"mil":11108,"stambuk":29382,"germans":3058,"quale":37466,"soundboard":43932,"carnegie":24977,"plumbing":36001,"kanin":34852,"corroborated":12541,"ajmer":44738,"sandman":45661,"laws":1880,"taliban's":48943,"dynamical":40656,"pio":38077,"donuts":30463,"fiefdoms":49895,"kernel":11626,"head's":48802,"amusing":4888,"lyle":22029,"pakhtun":21054,"ubx":36009,"vandalization":23990,"endo":47916,"dieu":42891,"brakes":28231,"cretaceous":40843,"walpole":34579,"flagged":5318,"adversity":35377,"'had":49185,"isu":20195,"demonstrating":7736,"cluttering":16201,"conditional":12573,"exploit":12540,"esperanza":7361,"distance":3607,"maniacs":25046,"propagates":36376,"correlations":47496,"'so":46708,"countersteering":45604,"grave":5938,"hank’s":45979,"…":6713,"spokane":42684,"assembled":14448,"└''''''":44367,"overthrow":17054,"fifth":5937,"newpaper":37308,"collage":11872,"outlook":8339,"platanogenius":34689,"preached":29307,"undemocratic":29494,"babysitting":34046,"remitted":42132,"07772550782":36558,"newl":35094,"sparks":13978,"enquire":18352,"6ft":41011,"chronologically":13350,"jab":29701,"formation":5824,"wreck":10202,"drprinceton":28291,"airliner":23297,"isp":5967,"noise":6340,"evs":40185,"enthiran":27815,"bosniaks":10394,"mmc":37877,"3o":15654,"shakur":38109,"handicap":18995,"frozen":8647,"somali":16071,"hamas":5230,"series":809,"⊕":28700,"kidnapped":13991,"ncc":25263,"oriented":6409,"hkelkar":21131,"nxe4":48444,"shoulders":11022,"neurofeedback":27334,"lozer":39293,"e5":30851,"whoever":2375,"ensure":2233,"wales'":13533,"general":431,"anasazi":38661,"cross":2001,"treatment":2136,"somena":45110,"rough":5611,"bradaigh":30274,"merchants":19762,"100's":30396,"brazil's":22320,"arb":9279,"arterial":41601,"oto":38349,"sidestepping":40415,"dune":41386,"van":2833,"exceptional":6267,"median":17137,"incomplete":3999,"intros":18629,"meteorite":43939,"distroy":44809,"something's":15040,"gets":931,"potentially":3141,"nother":39628,"elizabethan":34619,"archbishops":45520,"mentorship":14797,"m":876,"frend":40854,"title's":37087,"chromatic":28097,"washtington":47778,"succes":45293,"prescriptive":21870,"schools":1942,"caveats":20346,"picturesque":44335,"baa":48417,"portland":9611,"blp":1385,"channelled":46707,"hominem":4162,"hotmail":7757,"hereafter":22847,"tex":12121,"greatness":18249,"suffered":5470,"gatekeepers":34501,"fellates":48450,"conventions":2661,"dragonlance":24803,"haunt":16450,"carib":31546,"imputed":46508,"reproduction":9756,"algebraic":17279,"unleashed":19969,"✰✰":44312,"blpprod":26740,"arbs":13180,"booker":19868,"renata":33894,"predators":16050,"adult":3670,"equivalence":14272,"v8":20135,"acheive":30866,"shu":30790,"loprieno":37450,"linksto":49621,"isbn":3110,"orders":4196,"progressively":26418,"specialized":9459,"jance":48863,"flamed":48465,"cia":2972,"oi":5020,"citizendium":24134,"nominators":22117,"plagued":20893,"adheres":20073,"112th":44373,"champloo":48113,"dbiel":31682,"imacowboy":17032,"sot":17512,"respectfully":5338,"sorting":4986,"playlist":33921,"coles":47456,"havnt":22681,"protein":7962,"vere":41477,"practically":5685,"lra":43747,"placeholders":35819,"editing—especially":49318,"'against":46784,"previews":18716,"inordinate":35581,"noneng":35818,"infringment":26059,"allive":49073,"cuteness":29018,"nrhp":7456,"editors'":6522,"wikibreak":6338,"catedral":39271,"purportedly":16242,"shrug":15939,"president":1272,"reserach":29896,"psychosis":25986,"x2":23065,"sesame":22255,"ruhrfisch":25610,"bcn":37002,"colbert's":43007,"mysore":42060,"axxo":48550,"retract":6907,"titling":14337,"civilization":5710,"forces":1964,"pitfalls":26583,"echoed":23627,"crazy":2729,"avruch":42927,"ontario":4800,"vessel":12932,"shia":8367,"subcommittee":34142,"adventist":26867,"muller":27194,"unhistorical":44316,"campaign":1464,"nw":11608,"tabid":43124,"aggravate":38885,"pelasgian":31373,"unanswered":13338,"notoriety":12437,"overhauled":28920,"redraw":37204,"commune":21951,"breeder":18346,"jplag":48211,"containment":39857,"gimmick":22599,"queer":6825,"unbanned":14156,"wah":21059,"egyptologists":31111,"defination":36263,"dagnabbit":48818,"gemara":38326,"maybe":357,"wetlands":40274,"active":1289,"bergen":23925,"eventual":10502,"mfa":28951,"bakr":40956,"pon":26581,"smp":36249,"hills":7795,"redesign":15799,"praising":13240,"'you'":41125,"niv":30342,"dude":1789,"indefblocked":21355,"disagreements":4546,"bombings":11949,"exclude":5149,"groom":37615,"generalities":24886,"interstates":47409,"cede":41409,"hurling":26808,"opium":26746,"podcast":14367,"castlevania":34026,"cavalier":33256,"td's":47002,"pastoral":26288,"deniers":10659,"unreferenced":3721,"klt":38613,"piotr":21909,"valerie":27466,"kia":23671,"georgianjorjadze":44904,"interacting":12202,"finished":2437,"witchcraft":14544,"struggle":5214,"fans":2140,"—chris":38139,"boogeyman":43328,"cst":29901,"technologist":38205,"reznor":46586,"trot":34447,"vociferous":30316,"harmed":18833,"saturdays":19140,"enquirer":17782,"eminence":30102,"lawsuits":9774,"gurley":40959,"clover":39961,"retaliating":37276,"jacobson":25353,"mary's":21949,"ich":19931,"papers":2432,"action1result":30240,"hobos":44755,"motivate":21730,"gopher":34662,"lodge":8029,"sz":39837,"msm":9411,"sim":29859,"millard":49019,"kosovska":49135,"drk":36240,"table":967,"lee":3508,"titties":27605,"ji":12511,"spews":40966,"santa":6108,"should":56,"cfs":11140,"derail":23398,"mannerisms":42164,"biotechnology":18123,"baptist":5924,"megamanzero":33477,"slog":44022,"www2":23737,"rensselaer":23604,"adamantly":49261,"agressive":15429,"blindly":5974,"airmen":29972,"vajrasattva":45047,"gory":34059,"yaw":31618,"adoring":40741,"gilgamesh":18559,"forties":48759,"™":11736,"borda":33722,"skulls":34081,"temperate":32763,"seduction":35416,"wolfenstein":45445,"pilots":7457,"boca":35460,"flaps":25146,"–''''":42333,"snivelling":20220,"turns":3245,"healy":34584,"°c":20158,"xyz":15833,"typefaces":37572,"kitchener":44878,"depart":24024,"noxious":30651,"someguy":46054,"lukep913my":42936,"fok":49335,"wand":24072,"'be":35195,"comprised":11695,"curation":8714,"illnesses":19782,"bastardised":44689,"magdalen":33720,"homosexuals":8548,"vehement":18713,"christian1985":39554,"variability":21626,"basseley":31733,"soft":6685,"mccain's":27610,"pontiff":37220,"rectifying":36502,"gunned":35474,"americans'":41908,"djs":24836,"wikpeida":43885,"muh":42722,"subprime":29290,"interred":34310,"reese":26141,"docket":33562,"obtuse":10078,"openness":14982,"maimonides'":31830,"cetera":17980,"clar":40161,"penalty":8169,"scorers":26530,"algo":28549,"clang":46888,"directs":11100,"fcuk":23807,"turned":1982,"wm5200":45382,"muir":32261,"buav":45738,"gli":49995,"intelligentsia":21647,"heretic":23091,"rooted":12679,"hitch":29785,"heidi":36184,"yikes":18623,"antiquity":13515,"boxes":3697,"29th":15483,"rebuked":46921,"isles":4203,"fathers":7771,"motto":7298,"ir":9405,"rogue":7747,"iran":2038,"connecticut":7492,"£3":43607,"trenches":31276,"inequalities":32300,"weirdos":46194,"mentioning":1771,"sharjah":49871,"checklinks":42124,"mudali":42413,"exercise":4062,"ntfs":21975,"growled":40414,"abolitionist":49825,"lez":28709,"lubos":49036,"unforgiven":40575,"paley":41729,"indicators":21210,"elliskev":40559,"mann's":46294,"devaluation":39552,"twaddle":40609,"hints":9089,"official":543,"dissimilar":23441,"purana":34228,"proscribed":25769,"kodori":48146,"believable":18503,"pleading":13414,"manipulative":13212,"kola":41879,"nishidami":48164,"mathsci":19405,"cathedral's":42277,"sprint":32966,"wikipeida's":47080,"unfriendly":12382,"furniture":15477,"folders":45005,"hearing":2957,"bishonen":5821,"bruce":5432,"kj":45793,"opel":43988,"bugatti":38983,"consented":27496,"correctly":1773,"scjessey":15275,"finely":29223,"shoulder":9171,"obtainable":29994,"lozenges":33610,"effort":1227,"disinclined":48339,"stc":36347,"hobbies":14746,"ancestory":24299,"chatted":37923,"containing":4553,"crossfire":22530,"'personal":12480,"crock":16683,"'blatant":49662,"hase":41396,"caplan":44081,"language":362,"dividends":35443,"hamaha":48772,"markus":25271,"graffic":47264,"ehrman":34902,"apatosaurus":48162,"lesser":5481,"stefani's":46649,"keller":11625,"microscopic":18419,"nong":49015,"mailings":31520,"landscapes":26797,"euryalus":49006,"years":268,"fits":3982,"didn´t":25245,"grinds":36934,"recklessly":21889,"sunić":48490,"untraceable":41393,"malice":10942,"evhs":27285,"kasper":36369,"playwrights":49592,"disruptively":11840,"nonsense":777,"bleckter":36634,"animosity":16162,"¡talk":41365,"glossy":46445,"''spielchequers''":19625,"repay":27951,"macphail":42740,"mastodon":37138,"messing":5065,"blargh":45901,"kael":33950,"linh":43685,"drishtipat":21828,"parrot":10446,"warmongering":40365,"screenshot":5763,"vita":21947,"andy":4724,"whois":6705,"ifa":34416,"abortion":3995,"dispatcher":46431,"deformed":26500,"voila":28894,"revived":12864,"trotha":33388,"knighthood":28616,"webspace":19121,"orchard":43850,"frat":10473,"pilsudski":26253,"discovered":2694,"psuedo":22455,"δ":25760,"guildford":46544,"brief":1925,"maestro":35630,"fruit":6207,"reorganización":42764,"bacteria":10646,"contacts":9936,"replaceable":2815,"septic":39336,"hypothetically":17429,"measure":3260,"oath":7258,"asthma":18846,"uganda":17335,"enyclopedia":7496,"taint":25069,"ankles":44359,"heaven":4696,"abomination":21180,"barrio":44610,"nice":547,"schindler":49157,"gazing":41287,"colonialist":34149,"beth's":39701,"helpful":825,"jeppiz":18345,"qualifier":14208,"icd":19444,"peaces":37934,"likelakers2":26941,"scintilla":48781,"irrespective":12155,"mfd":5835,"aas":31162,"gaffe":48832,"kri":41364,"leeching":45857,"ξ":29455,"bennie":47344,"unbroken":42220,"'user":24928,"isabelle":29409,"rikara":44395,"crispy":43544,"overcrowded":42179,"turds":30176,"summation":18891,"buk":15138,"octagon":49011,"weigh":5834,"logos":7486,"hangs":14900,"inland":10876,"valuation":40105,"heraldsun":31404,"primitive":8383,"epirus":16403,"illustrated":8285,"pavillion":43582,"juden":31653,"queen":2599,"tons":4907,"factiva":42113,"hindi":4532,"myrtle":31147,"covered":1696,"hating":6865,"→talk":45574,"procure":31247,"flattering":13353,"pronoun":10638,"addon":36052,"hockfield":46802,"mashichist":26956,"horizontal":10753,"connectivity":25940,"lane's":46946,"shatner":24837,"spams":37219,"rohit":47787,"fromm":44780,"cook's":41635,"standardize":18984,"briefly":3785,"clergyman":49773,"auditing":32498,"kathryn":36778,"pmdrive":35643,"merle":31285,"extortion":30418,"sesotho":23602,"strike":3336,"bleed":16328,"unchecked":23082,"simplifications":41681,"brokers":36628,"airbags":29048,"dickless":46239,"horses":6035,"paypal":15824,"wool":10748,"contrasted":19760,"dicdef":42158,"mistaken":2737,"hindustani":23781,"graf":19699,"resort":5019,"babylonians":31022,"polanski":17325,"cfds":24503,"migration":7927,"ids":13466,"lipstick":30647,"hits":2342,"lyme":37373,"rewrite":2056,"raul":6054,"csi":20326,"spot":3322,"vowel":7561,"disrespectful":7408,"bury":9323,"formalization":38199,"atlantic":5274,"1'":27277,"anma":46255,"trickery":28588,"assed":14077,"reruns":33480,"seperatist":44819,"tú":41930,"italics":7231,"yelled":17907,"coutinho":33435,"aricle":14799,"attendances":33213,"kissinger":30871,"bleep":36689,"jeffy":28824,"naudin":41867,"entities":5300,"'source'":36733,"werieth":17879,"volkswagens":47775,"vin":38318,"consultant":13351,"leading":2335,"weaker":11484,"citable":11865,"cleveland":9856,"falsetto":14526,"faceted":40797,"policymakers":42013,"cluster":13780,"monotonous":49202,"ideation":48984,"duped":42453,"archibald":31510,"bedrock":39639,"joey":11748,"hilton":13683,"amassed":28300,"usav":38470,"gautier":43024,"sufi":14392,"solicitation":23075,"braiding":46036,"rooney":22211,"pissant":35179,"flagrantly":21545,"maligned":27696,"sends":10429,"vandalzing":38464,"adapted":10425,"desai":33899,"masyaf":37336,"'see":19174,"independence":3134,"gracie":26875,"rally":9174,"perpetuated":20429,"strip":5579,"ellie":42507,"subpages":7522,"gusac":20232,"singapore":5738,"lolol":47843,"blinking":21362,"sages":28318,"completed":3349,"twin":7501,"ftw":43745,"lacked":10418,"vukovar":23885,"3po":49337,"polity":20370,"virginia's":33614,"lobe":49924,"matras":47208,"outspoken":19290,"toys":8799,"ghulam":27018,"armand":42135,"hey":412,"hosted":6380,"distruptive":25616,"thumbnail":10479,"orphan":9269,"reverte":48379,"toned":12896,"corvette":33706,"closing":3259,"marsupial":49956,"months":856,"spn":35413,"shamelessly":21437,"jyllands":21694,"lush":47073,"conservation":8536,"guerrilla":20334,"fandom":12378,"hutt":33357,"intention":1944,"midterm":27357,"administrator":619,"irrelavent":37635,"wiktionary":6678,"flori":48993,"‘":44280,"gift":7317,"tabmode":39862,"aryanem":29431,"socialist":2774,"deportations":22144,"vreti":38650,"normal":1616,"bowl":7038,"lapses":43347,"keyboard":5965,"denying":4413,"giambigarchy":38627,"hindrance":21384,"goble":19117,"wiccan":20648,"ears":6335,"sparing":30635,"1878–1918":16996,"delving":24839,"caucasoid":17477,"welt":49506,"wgfinley":32356,"spewing":15221,"deleted":136,"helpfully":22564,"afro":10192,"heterochromia":29309,"farting":24605,"mooted":47809,"’”":46477,"acknowledge":2909,"chaste":44455,"abolitionists":37622,"rabbinical":20555,"inclinations":31402,"forgiveness":14874,"novinite":32718,"assortment":29450,"uva":44186,"versailles":34344,"grader":19836,"cherokee":9666,"prophets":11554,"replacing":3888,"insist":2472,"organization's":15043,"subsequently":4622,"spouses":22087,"orchestre":37806,"master":2602,"tetrad":45702,"videography":26791,"stupid":604,"autodidact":28677,"brow":31463,"sqrt":27122,"stalinist":14750,"yamla's":34226,"kalaripayattu":44663,"reduced":3657,"forum":1488,"trhat":47903,"'''cheers":27271,"babble":18236,"'movement'":32552,"attrition":22950,"swedes":17113,"marx's":21417,"cord":23728,"submerged":32919,"ecstasy":24922,"candice":34759,"leviathan":25770,"macedonia":2525,"zayd":41437,"fiddle":15016,"endemic":33168,"swamp":24308,"chuq":28921,"cancels":33523,"equine":22260,"gouw":38757,"qf":27241,"plump":46504,"insinuations":14769,"100th":20784,"gassed":23378,"vacuous":25967,"shakespeare's":19743,"'star":47521,"nikolai":37558,"greenspan":32738,"deadend":40284,"rural":7310,"rhee":27457,"seely":28836,"pairs":11650,"hertfordshire":32786,"marmot":32307,"bhardwaj":34302,"osint":17242,"orientation":5686,"dive":6316,"displeased":42855,"indignant":39909,"jan€₣":42747,"sorcery":42139,"namboothiris":25697,"rescind":42195,"returning":5175,"guardians":18449,"moya":48677,"nwo":41645,"defamed":14339,"tingle":40258,"gives":1094,"newswire":23796,"livestock":21640,"bennett":19148,"protectorate":25061,"amnesty":13097,"abject":21327,"janes":34916,"wasn't":600,"newby":28392,"dawnseeker2000":30167,"recherche":38701,"jagged":22991,"declarations":27011,"contending":23417,"smoke":6211,"elohim":35628,"¡":38896,"bedroom":14748,"neuropsychological":37299,"praying":16404,"broadcasted":30797,"solves":15836,"shankar":28148,"mitrovica":37790,"depreciating":47119,"messed":4960,"machida":12651,"gearbox":22669,"unceremoniously":45723,"farrell":22946,"altitudes":44695,"overmans":40673,"characterising":37028,"nemo":38390,"kievan":39224,"luther":9178,"boorish":40968,"axiom":15566,"freakin":17400,"dissatisfaction":22579,"programme":6722,"kristin":25336,"r1b":23761,"diaknoff":49274,"denton":40023,"angelmaru":42190,"maximal":27321,"lisa":8016,"charlton":23265,"loomis":45997,"exemple":26365,"tightly":17762,"bs":4007,"generalize":18860,"lumped":15584,"certify":19639,"iota":17152,"fringes":40756,"patterns":6320,"preview":5757,"complacent":49550,"tenmei":39804,"sachem":36183,"abortions":13125,"derives":10512,"tipline":31008,"hetchy":24353,"ubeda":44117,"waited":7980,"canis":14409,"catholic":1453,"thumping":30541,"dickens":20641,"gas":2756,"dubbing":34920,"wizardry":46125,"buisness":15638,"hypocritical":5026,"vax":23276,"peel":11264,"abpw10":47736,"unfolding":19785,"mhz":27220,"wy":43127,"cardiff":18320,"pakistan":2466,"freakofnurture":41859,"postulate":22420,"lecter":39148,"cayra":38581,"goons":21912,"benedict":11409,"faizunnesa":37936,"darlings":49242,"karim":34534,"snapshots":47957,"ncmvocalist":43497,"blazon":14472,"catalonia":15051,"lakshman":46094,"pars":32280,"columbus's":39219,"issuing":7931,"rudd":21680,"investigations":3911,"contended":25928,"overreact":48648,"pinola":40200,"fenton":29070,"definitive":5724,"idiotic":4671,"kf":31148,"surveyed":34345,"vacancy":43709,"cark":47198,"wordy":10726,"hafspajen":32126,"aux":21273,"brochures":34686,"khan":3083,"diego":3938,"reality":1349,"sludge":32148,"antiochian":31677,"ioc":11371,"rescued":15278,"med":8063,"mistakes":1811,"preventative":14664,"compilation":8940,"  t • c":47278,"championship":3781,"divers":41416,"chorus":10047,"astroturfing":30117,"rubbed":36605,"serve":2356,"oxford's":21987,"irishpunktom":39543,"expressions":7745,"rolls":7904,"cans":21770,"implements":25921,"asha":28406,"certainty":9634,"ime":30605,"atual":40410,"mahalo":32004,"route":3157,"dunun":38121,"purdue's":40963,"pine":16607,"callers":32538,"disney":3211,"roughshod":27506,"saffron":25178,"g6":20968,"thumb":6341,"haneʼ":31418,"dlohcierekim":17322,"cope":10797,"blackkite":34165,"uglyness":45152,"pere":47812,"strands":24817,"faber":38917,"homer":12179,"denigration":33267,"esteemed":15815,"formal":2268,"letras":45533,"vidal":41039,"kwh":17817,"bhikkhu":48167,"'all":22757,"ctrb":41246,"gathers":35337,"dissipated":39898,"vuia":23881,"imperfection":45776,"prefaced":32080,"knowledgable":13073,"sphilbrick":33190,"unconstitutional":13836,"olivieri":36102,"returner":39695,"you're":173,"shyamalan":36265,"1960s":6408,"oceanic":28489,"obsidian":35183,"hijacked":12232,"golf":9281,"fundamentals":16032,"posh":28403,"voigt":44128,"epidemiology":19551,"exclamation":19695,"wikiproj":46038,"lay":4000,"bodhi":37291,"wit'":14324,"leszczyńska":33852,"mizrahi":32113,"combines":17141,"omer":25566,"zeroes":31527,"aq":13454,"kw":20770,"bloom's":42760,"controvertial":25657,"consist":7533,"ceiling":11793," •":25014,"gramatically":31755,"français":22956,"valencians":47008,"concidering":48177,"doped":45031,"revertin":39421,"staples":46324,"directly":920,"letters":2426,"shun":24797,"vorox":33801,"tipped":33214,"transitioning":47201,"mo'":34969,"tide":10133,"sattelite":36566,"rangeblock":17891,"squadrons":31737,"lineages":14844,"wikieditors":31100,"temp":9004,"bounds":10776,"nonnotable":39818,"minutes":1518,"yuezhi":23429,"rearing":32571,"reigned":45022,"skyscrapers":30118,"circumflex":38391,"bahrain":28720,"endorsements":14585,"hungary":5265,"voices":6169,"gamepad":34637,"mecca":13139,"amalgam":31210,"'his":38602,"acres":12081,"jadoon":12974,"illustrations":14225,"sequitur":14568,"kennith":44007,"surmised":17703,"succint":44624,"undiscussed":18497,"backlogged":30719,"aback":39923,"ascribe":21036,"zigz0gger":46541,"casino":13668,"rests":15491,"packaged":34614,"abyss":30590,"flavors":33538,"ted's":42514,"warehouse":18377,"kong":4943,"dyes":40398,"goad":37270,"suitable":2161,"dod":16221,"counterargument":21727,"parenthood":33219,"anniversaries":26461,"principles":2948,"charities":15846,"ethylene":22028,"creations":13034,"bounty":25115,"ttcd":35331,"greedy":14153,"lovecraft":32855,"duke's":32369,"antagonist":13263,"diffs":3041,"laye":47137,"filming":10196,"drinking":6895,"funded":6783,"weburiedoursecretsinthegarden":49184,"makeshift":37054,"overlay":29817,"diagonal":49680,"subtitle":16174,"verification":3708,"elicit":22477,"jarrett":43881,"falk":18509,"rascals":33476,"eli":14125,"admonishment":49949,"catholicism":6542,"ey":33398,"resisted":16841,"lys":34820,"patronize":24500,"gautam":46948,"family'":48270,"mocan":41088,"maudlin":40768,"10th":6275,"karaite":44460,"fats":24840,"entertainers":27112,"women”":40749,"ganja":46226,"stalingrad":36274,"blackburne":41931,"mead's":41327,"association":1719,"websters":33836,"brick":8595,"shovels":38991,"nomers":28356,"today's":4400,"esophagus":43528,"dorchester":49052,"blaise":36380,"smokers":33787,"weblinks":19992,"kata":29645,"groupies":22485,"disturbances":34605,"presumes":23311,"“lessheard":25451,"5c":24321,"thirteenth":27666,"hodgson":33432,"fossilization":31918,"funk":8405,"dashiel":37996,"westerners":16661,"platforms":9259,"laplace":27446,"esb":44178,"hyperlink":15734,"corona":25058,"wagga":33492,"occupancy":48092,"gai":44711,"biographies":1268,"mahawiki":20166,"preferrably":35174,"deluded":12529,"germany":1504,"jovian":47029,"bashar":29486,"alas":6784,"yellowstone":20173,"unacknowledged":34947,"afghanistan":3051,"consent":4835,"sandwiched":48896,"willingly":16314,"rings":7296,"achieve":3226,"benefits":2526,"immune":9270,"goo":16865,"jtdirl":37244,"ogre":36498,"rss":6397,"shout":8710,"livelikemusic":40799,"compute":23911,"tel":11575,"bellator":23672,"pounder":24800,"noire":49792,"technicality":18848,"marketed":17897,"grad":12591,"she's":2225,"souce":23606,"birthplace":10303,"definition":703,"webscriptions":36324,"conjugations":43651,"egyptology":36519,"tuna":32038,"ruth's":26649,"thankless":20793,"francophone":47962,"spammy":14605,"purports":14910,"arbitrarily":6697,"ʎ":38909,"exile":7527,"photovoltaic":43200,"exposures":30711,"peggy":35884,"hirsi":43920,"designates":33009,"salvaged":40364,"wipes":22855,"opine":16930,"moncton":43699,"sakes":22760,"underdog":44321,"tickle":39742,"rtd":42361,"fish":950,"olivero":47113,"figures":1769,"taco":18615,"weissus":47698,"ras":26071,"raving":30958,"subsidy":29740,"dosent":13361,"scompton":48478,"bhotes":46751,"generalizations":15352,"alos":39661,"moarrikh":36082,"footown":37589,"bows":28287,"blotto":16348,"discriminatory":10825,"circulated":18091,"sneaking":23854,"reconstruction":10177,"woodwork":22396,"parti":49738,"wrapping":19926,"espically":39545,"subsuming":44304,"paraphrases":26769,"recast":43075,"ostensibly":12534,"stomp":18546,"supervisors":22018,"tuscany":39385,"occupational":12706,"amending":24221,"champaign":47426,"pubes":48572,"trustworthy":9356,"mcgregor":25701,"regrouping":48388,"canaanites":46276,"galatasaray":28312,"millan":27399,"brazzaville":38828,"environmentally":28792,"bouts":20165,"mills'":41205,"nothings":27841,"oldenburg":36125,"'god'":32813,"objectives":11045,"povcheck":42821,"accusations":1308,"∇∆∇∆":12174,"►":12070,"biharis":46612,"asda":39318,"sleight":45645,"bias":770,"tremendously":15832,"y'see":49660,"experimentation":19126,"françois":15674,"paddle":35186,"dahlia":21037,"a635":48619,"1's":49629,"block":176,"oftentimes":37226,"strelchick":41232,"unthinkable":27007,"steyn":23029,"​":39647,"slashdot":19924,"permissive":33245,"faithfully":17870,"vomit":3475,"štambuk":33669,"altavista":47148,"connors":28602,"rb":19401,"lords":11400,"crazed":26939,"dye":19643,"bbq":23160,"betrays":23815,"facebook":2606,"lofty":40175,"tropic":29273,"charlatan":18483,"capacity":3425,"state'":30604,"f4":36697,"hitchhikers":45713,"thatcher":9677,"neurons":23685,"simplifies":32719,"soaw":34132,"crawler":39719,"banknotes":22942,"eth01":48454,"attacks":520,"crackers":22574,"beekeeping":40806,"inthe":30750,"utilities":14006,"innocent":2766,"landmass":46656,"rica":16322,"dwelt":44902,"skinhead":24390,"narcissist":37707,"champagne":24903,"streamline":32358,"laos":13508,"legalization":25246,"inflected":33459,"naked":5752,"outweighs":28597,"rochester":20947,"janev":15232,"investments":17942,"039":34184,"wasserman":32453,"rsk":42779,"consciousness":6613,"my":29,"michelle's":46197,"9pm":43830,"emerging":8676,"harris'":25328,"preformed":38295,"dim":15415,"gatineau":18645,"punishing":15640,"affordable":18157,"plug":9362,"fella":17540,"jtp":44939,"kennedy's":19944,"salgado":43052,"fan":1116,"automagically":31425,"rick":5735,"applicants":25998,"wave":3825,"blackpearl14":14132,"trillions":42647,"ridiculously":8803,"detainees":30894,"porsche's":43341,"lostpedia":28778,"soweto":48723,"tartars":43241,"senate":4895,"impunity":17192,"intentions":3094,"santin":21699,"mendel":24402,"logins":33584,"medically":22505,"fallacies":13062,"pillow":18565,"pamphlets":29571,"beauties":29978,"crazies":40977,"mirrors":9906,"reseach":48946,"2em":21638,"tacoma":38425,"isn":17205,"banished":17241,"murry":42867,"jesus's":19067,"emmy":13597,"bellamy":8050,"cronies":17343,"sedan":46414,"tacky":20321,"happen":1012,"afif":41117,"fuller":11284,"laden":6507,"removed":185,"mass":1516,"suzanne":24768,"amicably":24943,"pontifical":48274,"snooker":16956,"cookies":6746,"baz":28566,"sophia":17750,"furnishing":41099,"complex":2139,"thraco":37399,"douchebag":6042,"suppresses":45208,"adjectival":23848,"kv":15687,"wc":15619,"promo":7063,"freelancer":20098,"arises":9430,"cared":8590,"sinai":16432,"creep":10533,"hayford":46435,"long":250,"recognition":3209,"o'er":46233,"irritate":19066,"anger22":48722,"men's":6029,"restraining":22809,"patel":28858,"a470":49487,"bankers":37660,"kpop":23902,"holywood":47998,"ridgefield":42905,"groupings":17260,"irked":38474,"pic":2929,"giving":1016,"umberto":35127,"mcgraw":22730,"mating":32478,"gallery":3381,"whql":43461,"reboot":25311,"hassan":9562,"ammend":39141,"lifer":35777,"precipitation":27301,"fuk":12994,"great's":48290,"syndicate":28197,"soooooo":43996,"brianna":39040,"icp":16006,"andrewbolt":48936,"geometrodynamics":38869,"disaffected":39553,"canr":39251,"listens":21607,"patriotism":14680,"rotterdam":39348,"ferris":43537,"shaken":28194,"lal":21265,"detractors":13615,"ibs":37831,"separatist":16382,"hispanic":5223,"demonyita":43026,"'carry":40500,"recovered":10752,"ahle":21553,"expeditions":26904,"cleanly":30360,"bone":7314,"rapping":26559,"silicate":36100,"roseanne":30159,"bureau's":35524,"fallen":7431,"smriti":46396,"summary":511,"peiser's":36538,"exhibiting":17913,"indentify":43668,"thing":231,"tigris":35542,"benz":22746,"programming":5038,"banna":31887,"painted":8511,"traces":10816,"6'1":35806,"precludes":32766,"trials":6593,"amends":20729,"armenian":2533,"accommodations":43513,"nytimes":12146,"'standard'":46568,"narayan":35799,"lange's":42648,"chipmunkdavis":37851,"arsenal":9764,"disorderly":40997,"rust":20355,"lumping":25900,"whosoever":40803,"latinos":15982,"pays":10907,"boggs":39836,"jointly":18674,"embarrassing":7426,"limb":18794,"fraudulently":22105,"defying":28914,"curiously":14199,"amateur":5657,"untruth":22858,"arvanite":36825,"three":405,"cheney":15752,"hatnote":8368,"lurker":39834,"giga":34370,"nothingness":35815,"spotts":38867,"hayabusa":46440,"dynasties":10578,"militaries":43144,"entertainer":25289,"dissera":48383,"deist":23381,"archivist":31487,"reconstructing":45833,"spirit":2412,"holiday":4576,"suc":49841,"wikipedea":43627,"preferably":7395,"wik":8989,"deeming":36879,"pakapshem":48907,"happiest":28434,"overrepresented":42935,"persia":7165,"squashing":43294,"eduard":23186,"mahayana":29159,"deutschland":20583,"guarded":17974,"revoked":7321,"callahan":41376,"disrupt":4939,"julio":22761,"exe":31442,"'edit'":33825,"disagreeing":6861,"horcrux":28736,"joshua":7277,"judaic":24494,"–projectors–":23624,"routed":30025,"bailing":46944,"flys":40266,"minorities":3836,"eng":11805,"tao":12677,"aristocracy":20464,"op":4293,"sharply":33303,"herring":11687,"transferring":17195,"strtok":44188,"2up":42869,"theory":727,"percentile":33405,"bribed":47560,"workload":21053,"'race'":27890,"eating":3871,"mce":47039,"eden":13189,"bavaria":19486,"kaufman":22719,"b1link82":32662,"starfish":46140,"cocoa":27293,"photons":18627,"nietzsche's":32212,"complicating":42142,"ouster":44705,"bummed":33605,"intermarriages":50000,"pistol":12498,"socks":3790,"alasdair":34717,"intercourse":12658,"bulge":26005,"headsup":47997,"sahyouni":31824,"dougweller":9753,"wiki":158,"contributory":22542,"inflicting":28675,"comprehending":31351,"woes":33630,"—  ":11470,"ibrahim":17040,"mahmud":28751,"goalscorer":44994,"althoug":48905,"imply":2667,"'supporters'":42442,"mapped":30165,"hams":49076,"oup":49231,"aggresive":35359,"kepler":38538,"culpability":26829,"whitest":47442,"abounds":42814,"specified":1972,"burmese":23415,"hater":9749,"s2":23955,"pda":37123,"bought":4462,"compromise":1927,"commemorating":30295,"livery":28053,"inflamatory":31453,"degenerate":11026,"carpet":12330,"ilan":47385,"ellen":14811,"cairns":28178,"stinks":11145,"saloon":16475,"bradshaw":23567,"swapped":19881,"logically":6532,"augustus":17098,"feticide":42605,"whitewater":47949,"dah":27222,"titlelink":31090,"appaloosa":20872,"smashing":19059,"provides":1777,"protrusion":46591,"inexorable":41612,"chanted":39098,"dcgeist":47978,"skywalker":19367,"equus":20894,"campaigning":10494,"imperialistic":26125,"lynn":11183,"prowess":22725,"mugen":34092,"vegas":8716,"disamiguation":46955,"epistle":27338,"weir":42636,"maurice":13335,"sion":23697,"transphobic":22207,"icq":49424,"glory":8337,"cessation":41988,"consultation":11728,"columbian":26473,"з":44290,"daytime":19733,"media":369,"armstrong":9572,"pedantry":23175,"natal":24979,"dreamstate":45126,"shady":16534,"underage":14284,"melting":15125,"bipm":31731,"stabilized":42969,"isle":10712,"destroyed":3208,"nightclubs":45543,"ls":17419,"rezaei":37498,"hetch":24352,"pompeii":22221,"becaue":29939,"jama":22871,"spratly":40005,"milder":36685,"ica":45508,"footwear":38377,"las":8442,"pbs":6920,"antichrist":17920,"00am":31044,"slant":9246,"eric":4016,"babe":10795,"qemant":42955,"explosion":9417,"sourceable":27166,"presumption":11559,"rsssf":20986,"oxymoronic":38260,"misinterpret":18850,"jamesmlane":38544,"tools":2228,"lawrencekhoo":16949,"beatles":4480,"seamount":41104,"reassigning":45129,"mlauba":46037,"awards":2267,"macedonian":2758,"tragically":31410,"dowry":32757,"illud":49677,"conviction":7169,"bending":16569,"pathogens":42088,"proofreading":25213,"timely":12054,"reappraisal":48281,"salman":19324,"gar":10163,"kisumu":49383,"unreservedly":28563,"visitor's":39928,"'why":34505,"volta":30358,"tighter":32355,"poof":22476,"río":27942,"hyksos":41745,"lenny":26209,"instagram":31364,"pinout":43936,"thrash":10195,"handedly":13953,"swoop":24518,"seine":37963,"airing":9432,"cockney":21852,"snopake":31037,"cirt":16623,"perl":13130,"remains":1969,"clerics":29670,"sargodha":34479,"gasping":43682,"accidents":9762,"stringently":47620,"medicine":2727,"lausd":39201,"argon":35173,"founded":2849,"balances":17914,"sgg":29247,"posit":16391,"6ad0":32582,"receipt":16662,"g11":7967,"trialed":49484,"mawlid":47145,"vauxhall":41994,"territorial":8391,"there":41,"class'":49181,"natured":27918,"sheiks":45632,"graduates":15044,"nod":14273,"knit":20569,"laundry":15012,"boom":11354,"wghn":43890,"foolish":5543,"disrespectfully":41320,"ghazal":29353,"barelvis":38850,"pregnant":8233,"hendra":33764,"bussiness":22743,"deficits":25055,"sensibilities":13293,"hectorian":23766,"records":1761,"preconceptions":40160,"wmd's":41850,"redact":17284,"auerbach":37823,"linguafranc":37109,"cited":705,"diabetes":15392,"gerő":34137,"adversarial":28980,"gibnews":22271,"tbsdy":49172,"hw":21321,"hashish":38524,"kendrick":21893,"bc's":45098,"legitimizing":44314,"pagemove":29548,"potential":1865,"tisdale":27751,"walmart":8302,"factual":1286,"ritter":24688,"parekh":40591,"insect":19285,"school's":7291,"subprojects":37334,"quickfail":39819,"shōnen":27263,"sculpture":11461,"gus":18788,"starwars1955":43533,"eg":3597,"write":330,"collectivism":33811,"vocational":27547,"insufferable":33343,"suppourting":48932,"anoymous":46013,"subculture":10007,"sponsered":26231,"arbiter":16072,"banks":5925,"hth":22460,"usurpation":14201,"gossiping":39827,"spouting":18996,"nonbelievers":36314,"stooping":34155,"peaked":24579,"qw":35692,"dorje":35871,"ed's":28793,"khwarizmi":19300,"balkan":7255,"tuition":17765,"way":110,"let’s":15500,"dispatches":28875,"mcclellan":31963,"double":1552,"veiw":30129,"mustn't":27448,"sunray":31659,"raigar":49556,"magically":13585,"harping":22154,"values":3418,"importent":37585,"categorisation":11920,"motherf":25220,"ryder":26632,"pus":46689,"therfore":26349,"arundhati":43527,"butler's":40346,"dynasty":3949,"epona":38101,"builders":21644,"action4":48777,"it'a":46694,"♪":15069,"morgana":39757,"samaj":21826,"gest":38861,"rumors":5391,"softly":32530,"chakra":46049,"qr":49538,"indicating":4446,"belongings":40432,"mangalore":23536,"tumblr":22551,"hadley":22875,"blocked":169,"shameless":11614,"renata3":48800,"lyrical":29232,"correspondences":47032,"argument's":46519,"rico":7764,"thriller":13029,"crippling":25561,"wherever":5653,"anonymously":7516,"lasts":11087,"doherty":35211,"kirk":10514,"inevitably":8705,"direktor":9367,"nnpov":31142,"his":66,"athority":45511,"inconclusive":19577,"hanukkah":23358,"recruit":12342,"barrie":19965,"kahan":42811,"yur":37578,"curtis":18687,"shafted":39463,"dimitri":40017,"instructs":30638,"pig":854,"prior":1402,"parker":7308,"proportional":11896,"ron":4507,"pharlap":43837,"infringing":12663,"80's":11460,"illuminati":19116,"fiji":15325,"talent":6441,"nothign":40973,"salutations":38954,"tindouf":38029,"ergonomics":40394,"harold's":48887,"sims":11954,"winningest":28950,"back":157,"mst":45712,"'panel":43694,"matched":10791,"laurens":40455,"storing":23251,"celibacy":22841,"reorganised":43409,"gordian":30827,"parte":41759,"trusts":22232,"thieving":40363,"worried":4925,"nih":9942,"aidsaids":4963,"propsal":42758,"abruptly":21594,"terri":9031,"jmlk17":39894,"snowy":31701,"underwent":22356,"debate":862,"unquestioningly":48641,"userpages":7912,"ensuring":9507,"passages":5837,"espcially":49307,"wikipédia":28593,"pooped":40696,"newsroom":16697,"morrow":23030,"koran":12948,"loans":13576,"incomparable":39243,"cheatsheet":4968,"vultures":33520,"dread":19910,"adhered":15294,"thrive":20869,"consecutively":36700,"didn’t":7885,"contraception":32000,"airline":8043,"douchebags":21225,"subheadings":13486,"apostasy":27505,"baited":18192,"abdication":33880,"voted":2937,"⁄":32242,"chords":20507,"categorically":16292,"hahahihihoho":39427,"janeiro":24088,"admires":47982,"'minor'":42532,"defines":4219,"divergent":15377,"psychotronics":31194,"tripling":35733,"þ":31922,"'semi":32762,"implicitly":10086,"sacrosanct":35716,"least":308,"screening":14538,"heaping":49940,"inconsequential":15198,"thailand":8160,"trumped":21396,"armin":30778,"282nd":45865,"rocker":28874,"larp":34409,"7'''":31331,"undermining":12366,"over":152,"bogus":4428,"monolithic":29623,"wqa":8810,"kurunduwatte":31567,"canonical":9995,"secessionist":32655,"degradation":22205,"sleazy":23933,"tallin":41706,"mukherjee":30452,"assorted":18927,"kanji":10260,"swear":4676,"specifically":955,"dropouts":45472,"cognates":26314,"reddish":31409,"bugzilla":25638,"specialists":8587,"sayin":16370,"calvinism":24644,"semites":10881,"tiger":5982,"schoolboys":34236,"ne'er":35056,"bickering":10683,"accuracy'":33185,"catalonian":46380,"inappropiate":40041,"unnacceptable":31048,"mediapledge":38516,"really":134,"alerted":12906,"psychodynamic":37110,"passion":6305,"beatport":35523,"namboothiri":49978,"paranoid":6656,"patil":26533,"notaforum":49793,"indicator":10005,"syriza":41379,"centrism":45518,"sawyer":17347,"hardest":13548,"reunite":45263,"netherlandic":41251,"mealy":40928,"astray":29567,"kaikolar":24264,"å":23169,"caucasion":41494,"teeny":42460,"luv":15359,"trying":249,"meddle":28224,"concerto":24512,"stadiums":15162,"w3c":45538,"−tab":20363,"profess":18037,"iow":21378,"visible":3768,"pulpit":47403,"rebuild":13435,"au93":35019,"consummate":49127,"plate":6099,"environmental":5245,"duallicensewithcc":20204,"never":195,"criminals":6647,"rothenberg":49681,"jayly":43125,"gits":46029,"that":9,"mousavi":27262,"smatse":47887,"sophist":47436,"nsiah":46685,"'other'":34136,"felon":16501,"sentiment":6262,"attainable":31913,"descend":14144,"linda":8932,"dateline":48302,"expanse":41136,"09":1715,"wolfowitz's":45116,"hyde":16979,"alawite":48876,"quicker":9637,"jolie":22657,"virgin":4184,"sears":32640,"marcel":26053,"stephanie":12907,"six":1617,"breeze":16594,"disagreed":5037,"roskam's":39023,"train":3451,"steinberg":40033,"ʃ":44298,"censor":2588,"morbid":31157,"singularity":18853,"plato's":26586,"legibility":46370,"involed":45734,"thereby":5773,"key's":45016,"shawl":45964,"lawyers":5571,"movie":1183,"candles":26248,"puri":37970,"animation":5856,"permitted":3314,"aviv":20138,"hoping":2571,"heath":16063,"telecommunications":25937,"unkind":21397,"known":447,"pharaohs":31110,"tamilnadu":33886,"transcribed":13840,"amps":27476,"whovians":27299,"archtransit":44693,"denis":21213,"undiplomatic":46567,"orthodox":2873,"alawi":29420,"radiated":42339,"dili":45142,"uttarakhand":33091,"baffled":12851,"ssdca":26748,"office":1502,"nsc":17524,"indictments":48774,"nerd":4821,"mish":28432,"disney's":22738,"smoothed":41254,"seats":6461,"provokes":29017,"alfa":42499,"ning":48631,"nishkid64":26273,"inches":9024,"banknote":29596,"documentation":2646,"ride":5333,"agreeableness":38529,"adjusted":8564,"skirt":17245,"reformatted":23135,"buckshot06":47518,"poon":40281,"wale":47878,"jewellers":49153,"rj":28884,"unprotected":6934,"ó":27411,"40px":10958,"pappé":45811,"okina":27393,"institutes":15083,"radial":11651,"co2":9645,"snapping":20824,"mosaddeq":44256,"omp":23384,"writers'":35003,"pernicious":32196,"logs":4913,"pulses":25611,"emboldened":26452,"obl":42862,"fernando":16617,"'u":5415,"secularist":36146,"imbecile":13251,"snippet":12173,"intensely":18339,"tight":6698,"baathist":44446,"zombies":17217,"hurrians":49805,"quinn":12880,"tourettes":21767,"ravenloft":48732,"wikitricks":27225,"manufactures":28559,"bolts":33953,"harrased":28014,"layperson":32282,"xie":45320,"keratin":48391,"speedied":13973,"mbp":29173,"drinker":39770,"butch":23070,"invade":10442,"intractable":25145,"seated":16531,"nyu":19707,"crocus":30480,"shelley":30040,"lack":905,"amanda's":31047,"remember":579,"hordes":39850,"careless":10674,"hera":33851,"punjabis":25825,"confines":22457,"arg":36251,"disregards":26837,"neighbourhood":16955,"damm":32691,"voltairine":46632,"cancelled":8335,"modernism":29462,"changlc":47118,"saifuddin":42612,"pagan":8574,"1840s":42120,"skyhooks":29445,"antonia":36193,"eminems":44725,"participant":8019,"2over0":34939,"fatass":23851,"erlang":47418,"fucka":25236,"sneak":11454,"strikethrough":34321,"francesco":19890,"sept":6829,"rs's":23757,"'german":44928,"pretermination":44136,"embassy":9348,"translators":13356,"ratzinger":24582,"gilles":23698,"frogs":19220,"vey":21567,"sourcedomain":45097,"ezzie":29424,"bitey":29633,"croft":28292,"libelous":6150,"fulfil":23090,"commissioner":13849,"attorney":5176,"broken":2078,"'dark":42368,"intrinsic":15994,"warped":15730,"patronized":41866,"energia":38494,"browns":31429,"oozing":35066,"commenters":31984,"acr":27052,"dharmic":25340,"simliar":45123,"ars":18766,"abotu":46789,"249er":35481,"refernced":36188,"intimidations":48429,"judaism's":30271,"cda":24505,"tense":5311,"jest":17299,"extant":14069,"crossover":17235,"premium":14736,"trawling":22481,"hijack":14773,"walden":49892,"humbard":29428,"amoruso":36726,"weighting":28074,"jellyfish":29270,"gildas":45030,"assurances":27711,"defended":5819,"passenger":10891,"snows":46242,"hounding":7323,"remixes":25607,"romanianlies":33090,"pakistani":5040,"expires":4825,"usher":17520,"renegade":23409,"prostitute":9044,"leczinska":37238,"extracts":22716,"lucasbfr":35780,"pir":27290,"storyid":37467,"wikipedia's":476,"assuming":1778,"o'donnell":36506,"cornerstone":18224,"hola":16336,"implications":5605,"footer":26731,"puzzles":18907,"indy":23608,"year's":9261,"buyer":25244,"ethnocentric":24586,"grek":41309,"'''rolls'''":11046,"ifs":26714,"eighth":10024,"amaze":19474,"slacker":43009,"fisted":33316,"eastwood":21012,"mph":13483,"perpendicular":42958,"slums":35299,"tlaking":44720,"orthonormal":47761,"subject's":1704,"cocksuckers":30464,"ongaku":43566,"articleonly":42111,"pressure":2888,"confusion":1914,"consequences":4077,"organizational":12853,"und":9329,"juno":24127,"mounds":21915,"exhausted":11503,"gw":8228,"managed":2987,"cultivate":48320,"weston":20762,"weiner":19475,"inn":24468,"deathcore":14787,"francesca":32430,"sovereigns":42567,"orphanage":19386,"exterior":16173,"50's":18678,"tempundelete":46206,"helpme":1446,"dilemma":13705,"frustrated":4497,"'cause":8248,"people”":43482,"thrill":24046,"erases":28603,"eskog":31494,"bosom":40081,"assaulting":42381,"familiarise":19106,"enriched":21774,"freestylefrappe":17900,"ringo":21735,"vasco":17702,"muruga":44191,"persisted":14597,"specializes":24282,"nijdam":46464,"synnerholm":47185,"delaying":22351,"tugging":45438,"multics":29299,"theatrical":17198,"rodgarton":35256,"minors":15869,"cygnis":28935,"pleasure":4103,"naturalization":45109,"mccain":6013,"meritocracy":41116,"armenia":4567,"dokdo":28753,"censured":26781,"heleen":19937,"plantard":43768,"method":1929,"tunes":18857,"outrageous":5676,"yeshu":28325,"subspecies":11892,"·t·c·m":42065,"shorthand":10620,"wombat":46488,"doin'":40913,"zagreb":22066,"bhutto":22791,"briefed":44002,"vid":20076,"doesn":22367,"deprod":36079,"deplorable":16330,"sullivan's":44062,"sarcastic":5909,"goten":47307,"densities":34397,"heads":2486,"abn":44273,"camping":25189,"bosnia":5618,"fabricated":7611,"oj":28419,"ツ":28912,"osnabrück":45950,"ruben":25559,"tracy":16119,"derogatory":5234,"kolkata":8489,"bodhidharma":39330,"hoped":6905,"gujjars":27363,"darwinist":39800,"hale":18883,"subcultures":27518,"anthony's":46307,"prosecutor's":47200,"wears":10857,"deceitfully":48152,"accessories":23432,"billion":4631,"unles":44451,"dy":38267,"davis":4345,"peachy":48161,"nakoula":31734,"exported":23498,"interchangeable":15300,"volunteering":15924,"garros":43598,"lobby":6952,"language's":47097,"decisively":39848,"sock":896,"wellesley":45542,"cheung":43860,"bloc":12065,"oq":15642,"historically":3586,"jurists":27404,"newli":34537,"8d":35229,"baskets":36577,"vinci":19435,"decline":2493,"char":24206,"brooker":46427,"ministerial":22388,"expansive":21173,"bracketbot":19505,"nag":31113,"accepting":5117,"opening":1867,"tradition":3202,"rishi":42196,"manifesting":47827,"bereft":33844,"fanfare":33279,"ledrush":36008,"find":139,"coibot":13501,"bravest":37031,"sycophants":31058,"carell":28302,"juan":8964,"unwary":38097,"charts":4027,"conciliation":49630,"appletrees":16430,"tricking":33502,"elsevier":24527,"emblem":12943,"fred's":28822,"afg":48866,"isai":38197,"cunts":3174,"foreseeable":21899,"alluded":15713,"departmental":35082,"all":42,"indulgent":41461,"miscellaneous":9109,"defiance":15246,"mounted":13730,"necklace":27738,"luminous":39851,"ramp":26385,"lottery":22798,"yards":13030,"flds":24295,"islamists":18212,"kitty":16427,"smiljan":34478,"golbez":45975,"stereoscopic":37716,"birthed":31953,"darwinism":10227,"teal":36219,"choppy":21807,"unflattering":20864,"wahabism":48756,"postion":28439,"illegally":8784,"apparent":2422,"kilograms":23201,"molest":21346,"'it'":45629,"slighty":47946,"tottenhamhotspurs":44224,"weeding":35554,"craigslist":31612,"watermark":23194,"classifier":43245,"teapot":35764,"akon":48584,"reffering":23347,"nsfw":35724,"exeption":43142,"phil":4891,"ia32e":29076,"arawaks":45375,"ilr":39486,"5d":26669,"voltaire":24167,"lrt":27022,"depersonalized":49498,"des":6301,"eccentric":13510,"calculators":36250,"collector":13732,"hazardous":34398,"shahpur":34777,"lowland":43152,"testical":49371,"stranded":39562,"expelled":6573,"heresay":36345,"cigar":24871,"conspiratorial":27581,"nephilim":32873,"thursdays":47681,"tic":28508,"leaders'":35485,"parliament's":45772,"overdoing":35614,"stored":8202,"interval":9037,"clarifies":10518,"ludacris":24646,"objecting":7450,"“it":27545,"boeing":7929,"anice":46012,"applauded":37650,"'wikipedia":32726,"steadily":26613,"libby":42115,"bashing":8499,"carrots":22834,"characterise":32998," contribs":24509,"conner":35728,"steamed":37433,"oak":10401,"caving":45017,"monckton's":40940,"cody":5929,"phrases":3681,"hahahahhaa":43633,"concedes":20949,"ops":10873,"stationed":18901,"zimmerman's":42289,"fellows":8873,"hashed":22091,"→smackdown":38380,"musicpvm":34673,"crystalline":46130,"dyson":42966,"tangible":13255,"wiking":32929,"oden":40219,"maniac":19357,"prizes":15049,"recursion":32952,"humanity":5152,"appendage":36561,"plotlines":46404,"chillin":46098,"'controversy'":37932,"sjid":24513,"victors":23880,"volcano":13276,"neopagan":28613,"shakespeare":7098,"preliminary":11787,"naam":31614,"'''''' • talk":36235,"facsist":46373,"…”":41138,"qing":12417,"subnet":26767,"afghani":23046,"privatized":45004,"zootalk":26258,"tats":35383,"outsourcingandbangladesh":27403,"gratitude":13556,"resounding":41652,"wormhole":41966,"listener":21224,"saying":371,"anou":43216,"yadav":10365,"reincarnated":45484,"salvio":8972,"tilted":30812,"opus":16458,"barge":32960,"evokes":37258,"fundraising":12605,"arrowhead":34473,"receipts":26317,"testimonials":28168,"''''''":1181,"sn":19128,"lessen":28086,"maturity":9447,"bois":45254,"scrapping":37921,"wolves":8990,"rarer":27822,"roland":13044,"helo":31277,"baths":48935,"dropdown":3362,"speciality":29484,"deprived":13624,"chauvinists":32383,"belfort":36447,"preferring":14161,"seder":36234,"suspense":41197,"affiliations":10637,"hollweg":38847,"impersonation":15941,"unconnected":20320,"ochlarchical":42933,"nukes":35145,"wees":36410,"mcveigh":21044,"masm":35318,"fatherland":33649,"demon":8296,"judaea":35344,"wsm":41345,"symmetrical":24387,"blasts":25830,"geese":29136,"catherine":9566,"spelt":8578,"crew":4738,"kayfabe":36522,"screams":15361,"lea's":44078,"serbia's":37386,"'socialism'":47157,"kimberly":26394,"corporate":3941,"inamaka":45914,"memeber":27464,"contr":9021,"parenting":42721,"glowing":15923,"prabhupada":27208,"overriding":18050,"formulas":16567,"expedition":9706,"uvf":23228,"dimwit":35323,"explorers":25023,"you’re":9193,"daunting":20539,"items":2560,"scientizzle":28397,"weld":24074,"prog":16366,"crickets":45286,"adjuchas":49812,"spino":46072,"equivalently":44445,"vuk":39795,"flamboyant":33901,"xvi":13539,"hill":3232,"ever":356,"huntington's":43408,"nasrallah":34613,"taxobox":14500,"pallavas":34533,"puke":16915,"fairmount":43791,"obtaining":12318,"swine":12056,"consensual":13541,"astor":23385,"nooob":13823,"ira's":28575,"furthers":30181,"negligently":39202,"overturn":11109,"panic":8343,"wikiwomen":35658,"engulfed":27882,"irgun":25081,"marwat":18664,"harrass":10034,"centipede":37748,"rebelled":46644,"exec":33708,"sofia":18819,"bias'":34177,"rejected":2853,"clumsy":11781,"worcestershire":45749,"histories":4739,"abstaining":37532,"nist":17013,"hasty":8822,"pseudovector":42739,"clinical":7166,"extraordinarily":15358,"friendlies":41813,"woof":26015,"st47":30510,"«»":38898,"photoshopped":18308,"buddha's":42529,"darcy":27267,"owu":44174,"kaushik":34632,"icky":49055,"kars":35330,"artlice":17537,"block'":36272,"greek":875,"everton":13960,"demonstrated":3525,"bongwarrior's":31937,"checkuser":3084,"intervention":3454,"pira":10230,"queers":22655,"crosses":11029,"lelated":40237,"wilkins":32434,"gupta":25962,"birkenhead":49590,"respective":3966,"idaho":16580,"soem":33754,"sacrifices":18864,"monterrey":31225,"shorne":41173,"hbo":11106,"dade":47079,"sleep":3887,"junction":12516,"sudhan":26410,"quiet":4930,"mitt":3164,"disapproved":27532,"left":422,"overcome":7759,"linnean":36979,"attribute":5629,"fool":1819,"solicit":14926,"gaels":32889,"resembles":10432,"lytton":48236,"olyeller":16179,"nixon's":23271,"fianna":28670,"chipper":25538,"slots":19330,"tractatus":40235,"giuseppe":32727,"contribs":490,"wasting":2865,"protege":33620,"scented":48634,"congregations":25218,"homo":1636,"milking":34497,"sdf":47710,"flowchart":46866,"ethnologue":13253,"palatable":45756,"joule":36989,"lieing":26323,"quit":2232,"refund":22227,"nanodiamond":33814,"yy":42157,"landmark":9791,"dickheads":20506,"wouldn’t":16685,"mundi":14547,"jaw":19043,"singled":12143,"whistleblower":22957,"nikosilver":25048,"enemies":4157,"cape":10288,"irishguy":18213,"discoveries":8352,"andrew":3457,"bas":45515,"reiterating":36647,"isn't":291,"approval":3789,"marginalization":47053,"kumioko":24749,"heard":886,"transnistrian":32796,"insufficient":7036,"account's":25819,"colonization":12031,"interchangeably":14894,"pullman":33805,"leaned":24660,"diagnose":24689,"weren't":2278,"ldc":45266,"telly":31278,"windmills":25511,"scythia":41497,"artcile":12075,"hapa":38067,"expanding":3819,"alternative":1485,"→external":48963,"except":940,"rfa's":28832,"lawless":28221,"lols":35244,"needless":7377,"possibly":987,"dos":6955,"parent's":19146,"headway":32750,"stadium":6312,"nah":8872,"expressing":4787,"pinyin":19164,"pietru":46345,"narrated":26042,"maryse":48746,"velvet":19599,"interrogated":34967,"cascadia":45282,"databases":12061,"representative":3326,"hominems":18558,"ho":4686,"eu":3063,"tiniest":39975,"angel":5459,"diy":20099,"nope":5143,"dropout":42392,"simplify":11501,"optimal":15778,"seeking":3274,"airborne":30300,"mayanists":36488,"melanin":11832,"encylopedic":15436,"mediation":1814,"kip":46798,"arctic":9027,"maryland":8148,"chloride":26777,"vas":27197,"rofl":13399,"accede":43648,"kleenex":29935,"mushroom":13289,"pics":3976,"barangays":37962,"isis":8993,"ç":29452,"sl93":47766,"taliban":9528,"rms":11319,"hemisphere":9515,"wie":39116,"essentially":2402,"spill":13358,"dictating":26459,"babbaq":42357,"answerable":35713,"adopters":30199,"corrupting":20362,"blind":3077,"yoshi":26718,"cologne":22166,"substituted":8554,"fraggle81":44817,"mauled":46747,"cabal":3943,"recipients":10070,"prankster":43477,"nightmare":7893,"riga":30901,"titus":35440,"duncan":10742,"calculates":35987,"interpreters":37465,"signage":24227,"bobobo's":43900,"raft":26686,"offical":7940,"d'etat":44712,"itn":7763,"sneaky":10319,"usefulness":8795,"interim":9386,"hereford":44432,"evolutionist":15974,"lazlo":40082,"ß":20239,"mafia":7094,"prompts":27749,"trnc":12160,"mart's":37285,"frameworks":45623,"aticle":30076,"existence":1653,"buckner":36117,"surround":25383,"additive":45630,"chatty":14172,"syrthiss":38643,"ringtv":47552,"simplest":10270,"resultspanel":29352,"leebo":30142,"efron":39397,"evaluations":17613,"susan":7679,"baker's":26795,"arcamax":49464,"jpeg":8979,"lugnuts":47471,"differed":23229,"drivel":10348,"supremely":35304,"mori":46023,"doj":23528,"lk's":37817,"machinery":20197,"proficiency":19759,"spastic":13574,"romac":39071,"hospitals":9410,"disscussion":22963,"premies":26372,"rm994":47686,"spotteddogsdotorg":31068,"adriana":39917,"scars":18762,"rossrs":42729,"auction":14116,"tyson":23209,"trips":10651,"wikifan12345":30104,"perilously":49666,"executions":25260,"textsmall":41691,"catchpole":42645,"kasreyn":27232,"ascended":47781,"連絡":15205,"hydrino":24175,"wdhv":36198,"fw":37134,"congratulation":34356,"tattoos":32805,"winking":39051,"nueva":32733,"suitably":18553,"operetta":38628,"“do":39550,"jeb":32296,"elsewhere":1594,"provider":7156,"dandy":19996,"calls":1936,"captainsurrey":29639,"mustard":20378,"promised":6355,"nws":32034,"masdar":43404,"libelled":38247,"substubs":48415,"coma":20790,"sonia♫":38926,"asymmetry":34181,"colt":18180,"gadugi":41301,"kedah":31386,"optimism":43239,"correspond":7886,"manifolds":37732,"cimicifugia":28883,"locking":10645,"vinny":34481,"pais":29471,"i’ll":11757,"untermensch":44598,"xx":8118,"annonymous":23847,"comair":29077,"redneck":15861,"habits":8125,"blabber":42420,"hormonal":39012,"learns":15409,"gaines":38807,"proportion":6003,"manifold":13778,"pujan":43886,"news’":31633,"breath":5754,"hahnemann":47584,"happenings":19607,"bint":44318,"ramirez":15316,"kindof":43563,"preceded":10545,"tilde":15731,"shudra":25466,"dissident":9867,"serbians":37411,"attila":30399,"raced":30368,"aiden2009":37754,"urging":16771,"animals'":40265,"moscow":6675,"trust":1592,"exceeded":15740,"satirist":49537,"joins":17196,"battled":20199,"pray":6016,"jorge":15348,"engadget":40132,"transcendent":46170,"maneuverability":40417,"outdated":4773,"commandments":9192,"simcopter":43973,"spencer":11412,"austen's":44070,"yosemite":37529,"anagram":40657,"serer":8351,"perm":28282,"nitrogen":18013,"uninterested":20739,"millions":2716,"followers":4338,"horribly":10983,"viagra":27169,"somewhat":1550,"blum":29745,"reflective":17170,"fracas":32421,"mink":45406,"dissertation":12419,"islander":17255,"books":564,"buchanan":23732,"sierra":9692,"ethno":13002,"prune":25550,"bemused":39844,"liaison":25856,"gucci":30256,"toolbar":13166,"darkening":45924,"arameans":15750,"tanawalis":31272,"sociology":9832,"tolstoy":27178,"arrangements":12118,"christos":46518,"practiced":7287,"germane":12447,"fulton":20213,"scrambled":21593,"collins":7113,"odnb":18885,"150px":48335,"indenting":37174,"pursues":45313,"kos":20270,"budd":44827,"dimensions":8701,"legitimate":1406,"shtml":10313,"scam":8736,"fuk1ng":45052,"glyphs":44323,"jpgsuck":15188,"sensory":20753,"iii's":40924,"ronnie":22848,"flat":3988,"individuality":46030,"populate":25414,"henderson":20931,"توفان":37117,"record'":47638,"tvrtko":35058,"1998–present":35498,"arresting":25874,"andrews":11404,"levites":38392,"thomas":2354,"moldovan":8203,"systemics":34822,"sentences":1735,"panonian":24204,"conversation":2068,"tone":1497,"difficult":1180,"franchise":6598,"sidious":21199,"introducing":4353,"andersen":28411,"kidnap":22070,"israeli":1868,"stay":593,"k6ka":35483,"forefather":47311,"burn":4086,"fellatio":20012,"walters":26008,"equality":5892,"cider":30321,"eaglestorm":30707,"awfully":11473,"gobble":34817,"southeastern":18784,"malformed":25660,"shiot":18771,"splash":18201,"wheeler":15661,"honey":7915,"canyon":16490,"shafts":36083,"lir":27066,"weirdest":30596,"lbf":36106,"bein":30685,"tearing":17023,"symbolize":45568,"pe":16560,"truly":1577,"stuarts":21150,"railway":4028,"classy":22178,"bana":40010,"deletin":33043,"crystals":38878,"harley":26182,"evil”":47259,"printline":44155,"geneva":14464,"johncd":26297,"baned":43475,"ensue":20413,"criss":33201,"roosevelt":11440,"apple":4208,"promotions":12109,"eelam":42638,"hartman":19998,"diagnosed":9796,"funy":49926,"pounds":8321,"dionysian":45549,"zone":5056,"hypno":47699,"riddle":26454,"defame":10095,"más":24877,"futher":21697,"07":1824,"formalism":32648,"smolensk":31095,"contamination":18021,"arer":44625,"zoophilia":31785,"ivo":20342,"willy":8463,"bikes":19448,"aot":18121,"cured":16129,"typhoon":15710,"upheaval":43379,"dun":19439,"meps":35274,"ye":6524,"reconsidered":24388,"compendium":19713,"tavernor":31716,"khamenei":13802,"landings":23800,"belbo":47952,"refrences":17655,"boxofficeindia":31149,"changon":40876,"gunna":23263,"barrier":8633,"designer":7130,"everythign":40201,"brigadier":18328,"compliment":7364,"modality":49271,"futhermore":24794,"cromwell":20751,"reliable":265,"attracted":8227,"diving":14223,"reacting":11993,"ayurveda":24577,"absent":6363,"biological":4807,"contributer":15755,"20gerson":47571,"και":40999,"factoid":14488,"dnschanger":43894,"pamd":45203,"walton":19879,"sandals":39679,"implies":2481,"defuse":29177,"transferred":5502,"misinterpretations":19489,"tram":25534,"humility":19738,"ross":6229,"massoud":33560,"hahahah":26380,"wilhelm":12705,"atheism":5691,"goat":9319,"defined":1799,"ohconfucius":29892,"delineation":29399,"acute":16539,"weblogs":45064,"euthymios":22611,"arson":19861,"might've":25790,"berserk":48519,"–muzemike":29312,"anecdotes":19761,"'they":42667,"streaming":15412,"impending":17522,"progressive":4339,"implying":4153,"comae":46313,"cinemas":37674,"hawking's":36150,"beep":14485,"london":1711,"levelled":32169,"eagle":6509,"distributive":42116,"subservient":48392,"unbeknownst":35285,"confusingly":21312,"anil":33314,"miserable":8514,"providing":1726,"sails":23274,"inmate":35249,"jade":13187,"alamos":37488,"intersecting":36574,"scandinavian":14883,"shampoo":49963,"doable":28288,"davis's":36651,"continual":10115,"scumbags":18252,"iah":46275,"relatively":2837,"sausage":16076,"amalgamation":26498,"guillaume":46555,"demonic":35033,"bani":24358,"disease":2754,"dyer":13719,"funky":20066,"shrieking":39140,"safeguard":30908,"amicable":18997,"tho":7683,"racism":2341,"technology":2291,"rg":36780,"what":39,"geffen":43097,"t":494,"scopes":28987,"caliph":29285,"tissue":10570,"boyband":45354,"orbitals":27337,"talentless":42307,"racking":47358,"balochistan":38223,"aloud":14856,"braces":21394,"severed":18325,"cru":23388,"shioty":18767,"ok's":34557,"thickens":39308,"plunging":32526,"wateva":41991,"discog":33233,"keel":34974,"poly":20178,"wuz":40391,"♦":5515,"lynx":24223,"neolithic":16018,"rpge":47989,"shyt":13789,"renamed":3064,"val":15716,"irrevocable":47453,"biennial":43322,"hilly":27654,"endgame":30853,"sop":20954,"rooting":25702,"hernandez":22501,"demise":9347,"hearst":38421,"ain't":3766,"vineyard":42411,"leech":24856,"caffeine":30241,"✉":6308,"tbilisi":19183,"decentralized":46507,"resolve":2115,"concealing":25143,"missile":8707,"prizren":25628,"cautioned":16197,"honda":12628,"neuter":22118,"viii":10474,"feldman":40189,"ctrl":11624,"smee":43576,"oates":32811,"braun":29123,"assures":29913,"wallet":22147,"queen's":9879,"ideally":7686,"lorenzo":23831,"slow":3173,"pity":5220,"survives":17797,"aristocrats":34945,"fermi":42569,"patroller":19600,"englebert":32861,"charley":23093,"duchamp":37273,"conquer":15129,"devoid":12307,"conceptual":12004,"adminhelp":48765,"squamish":27527,"jetix":28481,"bloat":21944,"vulnerability":28532,"extremely":1372,"hbk":35122,"–™":31808,"sola":44079,"aha":11544,"riddens":45255,"devour":45806,"christain":30310,"azerbaijani":6906,"nicecupofteaandasitdown":37586,"outweigh":15712,"gandydancer":46154,"sonic":7299,"corrupts":49869,"toying":30838,"wasted":5997,"defied":30514,"misrepresenting":8417,"mechanized":39620,"poster":3671,"invented":3010,"squish":42772,"talmud":9979,"suryoyo":32323,"highlands":20480,"primarytopic":21195,"1876–1938":16997,"ahatallah":44102,"crisco":31597,"flaws":6375,"forgery":11333,"irrevocably":33350,"princeton":11295,"withheld":31186,"amazons":30098,"ty":12021,"umpteen":36772,"freaks":10843,"pharisees":30143,"judo":12189,"modernised":35339,"lolita":35768,"mesopotamian":31740,"captain's":38928,"lesbians":12673,"knwo":36887,"defy":16105,"alignment":10960,"hrvatski":41647,"vigo":45175,"gerrard":42670,"funniest":14963,"judea":14434,"famousdog":40101,"cockroach":24890,"interchanges":43590,"realism":13915,"japan's":17576,"glas":45534,"chaim":34623,"transclude":27005,"traditionally":8450,"hemodialysis":44897,"mdi":49063,"subgroups":32219,"rewrites":10811,"priština":38797,"michaelisgreat":22887,"socialize":26379,"parcel":24063,"corwin":45223,"termed":10980,"attentive":30699,"towers":10098,"cho":28862,"webquest":49064,"endings":17450,"doubtlessly":37828,"meltzer":21093,"wentworth":42527,"horsefleet":47529,"whilst":3025,"cdm4":44197,"unfairly":6299,"belldandy":29373,"autobio":25017,"deva":29129,"bernstein":20343,"daily's":49062,"uncivility":19502,"communicating":7791,"hodge":32414,"pitcher":18610,"malicious":4585,"congressional":7514,"reopening":21886,"obscures":34417,"parlez":13737,"improprieties":49691,"birkin":47430,"dover":21953,"mariah's":36957,"teacup":46803,"'cos":26423,"sheva":19094,"sculptor":27424,"selector":35652,"é":21126,"psychological":6017,"cracka":30433,"yuri":24946,"shelters":19201,"spanked":33374,"dirk":19257,"media's":23241,"timothy":9435,"gutters":45618,"jiang":20096,"constraining":40618,"liquids":25955,"rapper":7551,"draws":9345,"appointees":47417,"lewis'":37814,"cellular":13862,"foster":8951,"socking":8245,"bangkok":20684,"ehud":19863,"travelers":18739,"dramas":31791,"gaijin42":49305,"danzig":17485,"rev":6995,"unjustified":5597,"envelope":15963,"reasonableness":29558,"tend":2125,"kasparov":29925,"jody":44687,"ltte":14592,"acronyms":12997,"demiurge's":45986,"franklin's":39067,"brotherly":28153,"falsity":27107,"margherita":49078,"debilitating":38330,"excrement":27662,"bluerasberry":47527,"ptta":34835,"legalised":45222,"privatised":38542,"emir":39996,"grammatical":5519,"worsens":40336,"modus":13895,"programmed":19168,"out":79,"namesake":17880,"clair":41055,"mikewazowski":18737,"zoupan":30704,"stars":3496,"romanisation":40761,"glagolitic":33083,"bomba":49688,"ollie":27745,"ideology":3540,"defaced":26637,"contain":1709,"heymid":31281,"ice":3180,"makers":8745,"entrants":45560,"touched":5770,"tomsguide":39473,"ъ":44296,"rac":33673,"accompli":31479,"besmirching":35567,"fsb":26940,"indefinetly":40159,"animated":7977,"'current":37232,"discernable":28088,"iamnotsteve":35198,"visitation":33916,"dsc":39439,"mediated":16849,"kay":13413,"dd":13331,"bled":30495,"katie":12828,"russkie":39925,"userfy":12544,"reich":9499,"monique":42498,"muhammad":3078,"noteworthy":4241,"bigelow":26328,"div":16723,"personhood":34196,"aforementioned":6293,"tarred":39411,"washing":11561,"christ":2955,"xenophobic":14245,"remembering":11759,"tottenham":20613,"brands":11688,"0286":47171,"obedience":25714,"cache":7448,"tapae":34402,"alibi":31606,"necro":34209,"englishmen":28354,"sod":19004,"clarence":18132,"tobias":20404,"firstborn":38291,"piet":27752,"murdered":5199,"8k":40123,"soundscan":23058,"heli":34794,"nograles":27391,"issues":450,"artical":9315,"meera":31756,"suprise":18164,"digha":44858,"ethiopia":9409,"50th":22376,"cocktails":32666,"genghis":15578,"dashboard":19276,"bracketed":36132,"ukrainians":10699,"overhauling":39128,"cutter":24993,"cheeses":39072,"moldova":9952,"bb3":48577,"targeting":7859,"taxis":36124,"coatracking":33089,"unjustice":45805,"spammer":10345,"monkeys":8928,"zhongnanhai":44203,"papen":34804,"statutory":21046,"ro":10731,"brava":47143,"apocalypse":14864,"allemande":11643,"cheetah":18774,"changin":36228,"ebert":26841,"fusion":5025,"burk":32347,"tfd":7128,"genetic":3231,"wannabe":8457,"lousy":8687,"poojary":38451,"engaged":2516,"sapphire":47977,"lice":47770,"amb'dor":33330,"weed":10257,"surprises":14899,"wanking":25267,"bsa":16035,"oblige":18663,"labov":46563,"chris's":47782,"o'brien":17742,"3dd9":34335,"phtml":40167,"amb":43058,"stm":13647,"bulldog":20299,"lai":26656,"wht":29861,"deployments":42693,"tau":13884,"consumers":12917,"arsath":43044,"nez":41641,"recentchanges":41983,"carnage":46401,"breathe":12078,"overboard":12323,"balzac":37924,"distraction":12861,"me":35,"literature":1970,"milch's":41814,"representatives":5662,"inspires":39537,"untitled":11507,"cleansed":17890,"drunken":16722,"actaully":39200,"underestimate":22451,"amadeus":28857,"metres":13918,"db":1621,"pervades":34971,"ethos":13123,"ipas":38031,"robby":25153,"¦":10250,"freaking":7483,"sayings":15704,"tast":18310,"“sinanoglu":44240,"tarnish":36005,"contextually":46714,"implore":18507,"outdent":16551,"rails":39112,"nostradamus":11128,"shots":6171,"investigating":8105,"atticus":22944,"advice":1068,"sensitivities":21251,"mccabe":31159,"volume":3135,"punitively":40072,"glossary":9628,"none":900,"calton":12481,"stumbleupon":43308,"eritrean":31507,"mrx":19804,"kentucky's":41423,"wating":48856,"720p":48380,"feeling":2120,"trousers":25846,"sedation":45328,"jesus’":46478,"メール":33944,"‘allies’":29054,"0waldo":30172,"accesses":32985,"substantiated":9398,"retained":6218,"underscores":27147,"beaker":49781,"graemeleggett":40564,"neckline":39699,"reclassified":31197,"spices":42230,"hales":35075,"frequent":6288,"static":6893,"guitar":3268,"mace":21885,"galileo":17267,"ship":2944,"excercise":48038,"'conspiracy":25329,"cybersmart":34784,"mroe":30194,"luddite":41441,"xena":30598,"lovemonkey":20005,"atle":39728,"neutralizing":28261,"java":9287,"eurofighter":41408,"mang":30581,"fragile":19172,"accessibility":13145,"probe":15977,"apathy":26780,"deletionists":10370,"draughts":19712,"embryonic":40904,"answersingenesis":35574,"memoir":20692,"salford":27081,"tenets":14804,"skins":18196,"appleby":33252,"marksman":31665,"hannukah":34565,"blacks":5139,"satisfactory":8470,"har":14810,"fronts":13373,"ranks":5745,"unintended":10606,"rutherford":16732,"spite":4782,"apo":38940,"planck":13642,"braille":24144,"đ":38901,"knife":9025,"cosmology":9402,"jfj":23143,"inoffensive":33785,"juries":26034,"designed":2377,"opinons":42723,"adhd":14553,"hendrix":20876,"antics":10609,"knighted":34949,"snowspinner":19814,"paedophiles":42975,"l34419cdd0000":37422,"berry's":40825,"scotland":3329,"counterbalance":45424,"nicks":38137,"ancients":47498,"innocence":7332,"researches":11770,"lenin's":18832,"piffle":42119,"'blis":41255,"californiadreamlings":24044,"jerking":27051,"home":989,"cost":3002,"lowell":14578,"verbal":5732,"ˉˉ╦╩":31399,"occidental":46799,"heart":2074,"abusively":14057,"thinks":1578,"tighten":18605,"geordie":26276,"clap":25309,"gaulish":24285,"jedi":10743,"insinuate":16372,"jpost":23248,"spots":10056,"hill'":49477,"misrepresent":8039,"carries":6515,"envy":10553,"ahmedabad":36747,"prospered":45342,"continous":22189,"ninety":22814,"tear":10869,"blixx":24275,"fuckyourself":47631,"sex'":49999,"schooler":37720,"crane":13441,"writings":3791,"bunjevac":43524,"marxuach":40774,"sixty":13832,"pile":7465,"grounds":2423,"delicately":42719,"disobeyed":36731,"abrievenbus":45817,"lawdy":2875,"nap":19198,"unaccommodating":48657,"depictions":14061,"'opinion'":27870,"eternally":25347,"dalmatia":12740,"applies":2107,"blueboar's":31378,"frances":14619,"phuq":6159,"knocking":15091,"awsome":24969,"refactoring":13234,"dots":12525,"stubbing":47407,"jihadists":30560,"cooper":9309,"meal":12886,"rounded":12554,"pestering":22535,"haven’t":14384,"cramer":26672,"giza":35842,"mariano":29470,"phyllis":23805,"pmc":25408,"audiences":13291,"skeletal":28446,"nlm":13495,"liquidation":34311,"physicists":11166,"upped":35397,"sailer":49363,"jalapenos":45532,"guidlines":13543,"wipro":44546,"establishing":6227,"'british'":37862,"striped":18069,"avalon":47860,"pty":42576,"robs":43174,"cultish":38082,"darby":48691,"x's":45729,"discussion":137,"scarborough":18018,"accent":5424,"cthulhu":37355,"paralysis":33920,"preachy":36693,"caprices":49392,"monitor":4097,"manifesto":14660,"associations":8487,"ofthe":33456,"rubberband":46787,"stays":4406,"aap's":31804,"appraised":47134,"anxiety":11083,"progess":39017,"costume":10613,"outloud":35868,"diligently":14779,"opaque":39143,"westfield":24320,"andré":20347,"trine":39080,"demolitions":23869,"croats":6871,"neatly":13471,"mince":39173,"penetrate":19660,"nadiatalent":45252,"infinite":4698,"mises":21279,"unbearable":32335,"shamed":26022,"redundent":39514,"casliber":32097,"roommates":27945,"birth":1772,"honor":3739,"wad":32106,"parsed":46945,"syndrome":4315,"seealso":40021,"boing":14819,"peppers":17639,"disruptive":952,"reinsert":8992,"feewings":47058,"up":76,"dickhead":1423,"gustave":24482,"islambol":45450,"contextflexed":38418,"nu":5357,"id's":23435,"responding":2362,"ekman":14709,"posthumous":23581,"akshardham":41374,"grades":10407,"usa's":29253,"“all":22226,"nobles":32489,"despise":14652,"ming":15782,"flake":32117,"producers":7219,"okay":888,"transfering":48829,"'fair":39575,"knives":17683,"elon":25597,"sofos":31811,"lyoto":35593,"metro":5477,"yobol":44926,"visualise":42608,"priors":36718,"hottest":39429,"retrieved":4333,"atrophy":40710,"berry":7528,"reg":18107,"according":561,"'claims'":48784,"sourcewatch":28437,"perrin":49941,"chassis":22749,"eagles":19076,"ahirs":39280,"informs":15314,"behing":33164,"continent":6677,"skirting":26492,"freeman":10948,"masterbate":49208,"fac":2825,"arafat":17621,"fraudster":33573,"babes":26286,"keepable":46628,"ppps":48660,"innit":22891,"sacha":25125,"cas":20559,"madison":10140,"dialects":5911,"algeria":11010,"georgewilliamherbert":32626,"connects":18332,"homeopathic":16884,"karla":43061,"reedited":48449,"ordained":14480,"rightful":15439,"comprise":19597,"ja":8849,"tpirfansteve":45411,"atm":14113,"simon's":37036,"saxony":17738,"army's":18499,"robert's":36782,"conjunction":9414,"nigeria":8622,"frantic":37865,"compeitition":38810,"bohemian":20252,"estonian":11934,"ban":700,"patriarch":24215,"grekomans":40244,"lingual":35486,"vigour":41941,"'96":37233,"articleid":27999,"9b1e":34334,"conservatory":38134,"dreyfus":42524,"depp":22417,"flowers":8344,"globalsecurity":44808,"misdirection":19877,"symmetry":17002,"armistice":35515,"describes":2779,"mond":47199,"cracked":16538,"granddaughter's":46910,"equated":18918,"juniper":39207,"wiener":29902,"despot":29354,"neuteral":41703,"mv":18335,"kreis":34751,"apparition":37264,"disallowing":40002,"disobedience":35829,"blunderson":47642,"revisionism":9963,"adminstration":44329,"wording":1258,"oliver":8068,"oregon":4524,"bhati":22058,"showered":37624,"sustained":11162,"electronica":34649,"rebuttle":38259,"bhadani":26636,"flattery":30109,"departs":32862,"coverage":1623,"bloodline":18319,"groceries":37090,"mygalomorph":43755,"originality":16553,"merits":3569,"morgan":8387,"liberation":6235,"duplications":31517,"userspace":4266,"institutional":9325,"embarrassingly":27726,"pannenberg":31686,"sbc":30308,"mater":15309,"day349":45681,"up":48539,"assassinated":15081,"experimenting":1637,"tube":7437,"yang":13627,"rov":48491,"caught":2717,"howitt":21489,"jains":22900,"kmp":49913,"rdns":16992,"played":1471,"nofollow":10081,"thay":26576,"sahih":23483,"stronger":5041,"mh17":42505,"cargo":15119,"mistagged":48393,"cesspit":42306,"inexperienced":10139,"sequences":16217,"identifiable":10267,"irresponsibly":30660,"terowie":49007,"selects":35357,"erroneous":4382,"fiction":2546,"resent":10757,"philistines":19286,"speedily":1198,"lets":2200,"trademarked":20479,"offfuck":2583,"jesuit":24653,"isps":18416,"slanders":38956,"transcriptions":23827,"tibet":6797,"helga":33467,"qg":44806,"bal537":23179,"cleaned":3947,"intends":13552,"camacho":48046,"petar":13243,"theseus":32833,"kovac":33843,"ehsan":43388,"arnold's":47497,"ns":18204,"girlfriends":19345,"staunchly":29821,"disappear":6629,"verifies":20797,"materials":2371,"consistency":3923,"picnic":27683,"fusing":48540,"rodrigo":39546,"orginal":14859,"lister":42415,"ardent":21726,"magnitude":7406,"ssm":38987,"inequality":12735,"orgasmic":47120,"interfering":10069,"snowspinnertab":45460,"dinks":40361,"vr":39301,"presumptuous":16802,"photoshopping":45809,"additions":1491,"woth":41225,"earhart’s":37390,"troublemakers":40856,"antarctica":16139,"fighters":4887,"omissions":15726,"incompetents":45874,"conspiracies":15371,"catastrophic":25758,"fearing":22470,"tongo":34836,"“the":5503,"stratfordian":37856,"structure":1834,"contrarian":37083,"tenditious":42726,"zapata":48987,"'v'":49431,"baseline":31161,"misleads":24491,"holland":9381,"lbj":33967,"perspicacite":31233,"wormy":16988,"worse":1612,"stinkin'":46660,"kargil":36442,"revertions":34371,"gordon":7889,"penis":895,"parked":21676,"tol":34139,"busta":48479,"whitey":31536,"sachs":19947,"legislators":33119,"tht":18871,"insofar":16592,"overlook":15956,"laura":12224,"condoned":22141,"queries":4899,"misnomer":12882,"produced":2441,"babelfish":15282,"impetus":20360,"welch":17678,"materialistic":30301,"eleazar":35586,"prompting":22615,"hydao":27199,"vibrating":40147,"misspellings":18959,"overstate":46914,"words'":44472,"nwt":30624,"flail":34733,"alphabet":5249,"drummer's":40416,"caucasians":26927,"comedians":34030,"claimed":1340,"compatible":5651,"discontinuing":31558,"disclaim":39450,"assimilating":35958,"permitting":9055,"slowed":17251,"gallagher":29736,"chutzpah":37516,"maniacal":47545,"needing":4694,"投稿":32870,"ronn":49850,"'''i":45819,"brando03":44012,"jigsaw":36589,"amok":23308,"expért":16496,"ra1":29303,"rigid":13313,"advising":15711,"carriage":19369,"barn":13699,"christ's":14712,"commenting":3242,"epbr123":25699,"gesca":44123,"brush":10555,"umbridge":39164,"consort":23084,"reflections":22622,"pushers":7548,"spat":17663,"caretaker":21488,"cerejota":46806,"between":327,"networking":7691,"outsiders":12156,"brett":12629,"38th":39564,"piggy":7354,"copyleft":23731,"dispute":642,"shutdown":17264,"favour":3318,"colourful":25375,"envision":28336,"functioning":8553,"dnt":23088,"installment":35590,"masturbator":35444,"front":1462,"1700s":35931,"sb":14343,"megalonyx":48275,"jyotiba":21814,"capacitors":22893,"massei":37570,"dil":17206,"summarised":19274,"autonomous":9947,"turismo":46005,"asi":45605,"telephone":6391,"dlx":33603,"1900's":43909,"folken":33539,"counties":6095,"don’t":2983,"devised":14236,"interact":7083,"tahoe":46970,"kony":23607,"via":1408,"keeper":9736,"housed":20374,"agencies":6113,"rinpoche":13752,"gdansk":17492,"globe":8117,"scandalous":16183,"futility":25620,"motivation":4210,"wuhwuzdat":47069,"sill":33227,"lovegame":49344,"eunice":42296,"accordance":3145,"bourbon":21788,"refimprove":23711,"noclador":13584,"profession":5726,"searches":5587,"malke's":25007,"panspermia":44621,"use":81,"unike":28003,"paina":44215,"suppositions":31291,"incendiary":18544,"practicality":34508,"astro":35717,"kettle":11344,"kevin's":36145,"wesleyan":20923,"save":1631,"sow":24932,"transsexualism":26860,"flaborpains01":34374,"warring—even":42735,"appropriated":23554,"reacts":32424,"easy":1142,"burroughs":28264,"theosophy":38460,"metric":6932,"shylock":30929,"consulting":8091,"hover":24014,"deteriorating":24714,"jassy":43068,"biographers":20994,"miskin":23767,"cascade":21336,"stuffs":24753,"faintest":26554,"gospels":12615,"'''fuck":49367,"providence":18993,"protective":12693,"characterization":6958,"instead":363,"dyke":14246,"testimonial":29578,"college":1169,"nitschke":43927,"deserves":2287,"sufis":25583,"darn":9873,"gusts":40509,"fisrt":42931,"confront":14677," aa":41888,"pivotal":18145,"pristine":25552,"bytecode":38849,"hardcover":30836,"option":2216,"dunderheads":49219,"occupationtabactor":35492,"unhinged":33275,"stomped":34906,"itc":42770,"scrolls":18028,"putz":31788,"clifford":15660,"oust":47719,"michael's":13674,"oooo":25462,"okinawan":20371,"g1":6351,"wordsworth":41919,"cereal":26451,"bangalore":17604,"parties":1844,"electricity":7892,"wsd":37988,"leki":35993,"falsehoods":9710,"ofcurse":46911,"2010s":24707,"vergina":21878,"holroyd":22687,"eban":33846,"admins":597,"socket":15155,"dacian":15837,"lc":14945,"presentable":40555,"diffrence":40310,"punjabi":10449,"bhojpuri":28448,"inferred":18512,"scatter":33452,"tampa":13805,"skolnick":41417,"communal":24242,"034":43387,"junk":5971,"hindu":2282,"rollingstone":34922,"tskhinvali":32151,"caldwell":15268,"wellbeing":40764,"unique":2324,"onboard":28835,"byrd":23494,"azmi":32087,"tormenting":48374,"bootleg":14296,"clancy":47325,"variant":5688,"stripe":29288,"salma":48326,"trending":44843,"iat":49658,"diaries":20577,"20apokryltaros":43116,"nikko":2614,"bhote":25273,"hamlets":31182,"sobran":27195,"priestley":33392,"zoom":12425,"nikon":27630,"journalism":4932,"administrators":1001,"admirers":41362,"zzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzzz":12976,"diverting":34230,"zealously":33680,"kung":11988,"'punishment'":42986,"colonies":7984,"waters":5900,"lie":1541,"newbie's":48673,"evenly":19038,"hitting":7639,"khorasan":11855,"geometric":16216,"ads":6002,"botany":15434,"unambiguous":7262,"vince":10504,"afghanistan's":23546,"metropolis":25817,"mishap":34549,"alban":33617,"articles":80,"unlike":2188,"outpost":36636,"pulp":18820,"usertalk":11943,"omm":25736,"quetta":43186,"impumozhi":35487,"turko":32933,"correlation":9282,"cutoff":33512,"manifest":10147,"friend":959,"kyr":42600,"sadistic":16891,"unnecessary":2055,"flooding":12806,"studds":45733,"siebert":37155,"singh":3119,"duke":3570,"billiards":20265,"jealousy":14533,"originates":14075,"coupling":17632,"disorganized":20556,"gook":21050,"copyrighted":1544,"oswald":8373,"yuffie":48471,"avery":22717,"reforms":12858,"itemid":19670,"suspention":46776,"grotesque":16827,"flagella":44275,"ebony":31309,"avant":18197,"fuentes":39205,"fein":17149,"squatting":48258,"crowds":13898,"nibbling":37173,"azarbaijan":32281,"brady":15548,"abound":18190,"magnesium":19010,"coasts":26612,"curvature":23789,"billard":48546,"chip":6566,"omit":8889,"recall":2373,"wound":9997,"isles'":49883,"moxon":34195,"pointlessness":43672,"revs":37042,"advocated":9306,"sennen":28744,"echidna":48827,"glamour":37906,"'wiki'":49216,"yiff":48071,"'some":29909,"bd":11425,"would've":8270,"thong":28928,"buddha":6753,"visualizing":41922,"psyche":25258,"egyptians":7173,"achievable":29444,"qurayza":21170,"where":128,"attraction":8145,"biassed":26165,"refraining":20877,"that'":41812,"fibonacci":34349,"enactment":32831,"commuter":20912,"xt":45006,"pgs":30242,"neves":46592,"fict":26309,"sanctification":32380,"horowitz":29356,"seniors":26702,"vendor":16952,"b8":22870,"sergeant":24949,"gger":22400,"cadiz":38695,"bulling":44876,"googleusercontent":48899,"majo":47885,"evaluative":30597,"evaluates":45193,"isn´t":27992,"premiership":14985,"troll's":40327,"surveillance":14401,"'united":40479,"dotted":44826,"bureaucrats":9040,"thrice":28109,"snk":38760,"raper":41600,"kruger":46867,"":43705,"sink":12661,"11th":7783,"dumbest":15632,"relent":26566,"square":3130,"crows":25242,"leroy":33054,"cristina":47884,"lila":38252,"marshals":39285,"procedures":4451,"warships":23707,"comma":7420,"soldier":5850,"province's":41150,"eggs":7846,"stimulants":45877,"howcheng":24050,"mhaw":49693,"dozens":4005,"fetched":14793,"wahhabi":22468,"inflated":13221,"viewpoint":2807,"討論":23038,"fernandez":46545,"linuxbeak":29823,"vlore":44535,"uranus":18274,"proves":2836,"portmanteau":20524,"notnews":21524,"outta":12762,"hearsay":8653,"referanced":46426,"class":710,"soundtracks":26099,"dissociate":30924,"ţhe":36890,"basque":7919,"yelling":12269,"arcs":23268,"drawers":39912,"north8000":15399,"gaimhreadhan":40441,"bursting":37008,"informal":6787,"regev":42323,"garner":11621,"edie":6766,"tatas":40679,"commute":29334,"uśe":47389,"messager":26749,"organizes":46177,"mithras":32025,"essentialy":45187,"irons":43292,"bantering":49627,"wilderness":15930,"plagiarist":36909,"yuan":20597,"mwalla":18039,"authoritive":36926,"explination":40853,"fulfill":8141,"dhoni":23243,"looie496":40228,"flyer":18072,"menstrual":36279,"stuck":2706,"pithom":38617,"nation":1649,"ashkenazi":16603,"penistown":27198,"cocaine":9008,"herrings":23841,"hogeschool":26051,"hermoine":30818,"chauvinist":15222,"withdrew":11838,"discretionary":8235,"borgdorff":21858,"familicide":41525,"ch":6928,"douches":27712,"marzia":34233,"fisk":33700,"unequivocally":14695,"scandal":5410,"superman":7751,"verging":29847,"akira":33403,"divine":6604,"chu":20836,"minsk":23116,"displeasure":22368,"remedial":25091,"oxbridge":32969,"snitch":15262,"kenta":48018,"herbal":18682,"isetta":36319,"download":3936,"judged":6404,"excavations":29883,"yid":40117,"noi":16477,"slighted":39478,"picky":12199,"deactivated":30136,"obsolete":7705,"expecting":5729,"wiped":7768,"crime":1922,"bok":40721,"bpi":47594,"knows":1127,"geschichte":29603,"krivit":42330,"quarries":39887,"pnac":25335,"detects":24696,"reorder":43451,"angell":46511,"inexplicable":22327,"nominally":21792,"imperial":4414,"fenced":36163,"encilhamento":37807,"hausa":37140,"lagos":24165,"illegible":44467,"ore":21901,"nabil's":22820,"italo":21913,"radius":7951,"dynamically":22136,"flipping":16660,"prospects":19642,"editwarring":15696,"—preceding":1890,"colosseum":39820,"deliberation":26764,"proff":40748,"liberal":1990,"sukhoi":40795,"consign":47604,"laguage":49902,"rowdy":39914,"mysterio":27596,"models":4066,"politic":21190,"balkhi":42696,"identities":7288,"archer":29897,"dolly":23328,"clearly":347,"forced":2308,"heterogeneous":36592,"stop":172,"pidgin":25406,"weeaboo":21086,"pits":27076,"gilbert":14205,"blending":33037,"fantasize":34600,"stood":5190,"eupator":29648,"enthralled":44602,"arachnol":38567,"cement":15172,"ashma":31807,"ethiopians":32875,"a320":31658,"harpeth":29276,"correctionperson":45151,"biog":23852,"relative":3350,"cdn":28035,"wiknic":31353,"debunked":14801,"notifications":10763,"extreme":2087,"awkwardly":27094,"converts":9617,"hornets":32849,"g13":10091,"plurality":16540,"nsdap":30322,"irrationally":34929,"schlesinger":32945,"klondike":31459,"rosenthal":35008,"attest":12623,"deviantart":21888,"herostratus":49747,"talk•email":20673,"mut":37867,"renee":23985,"bede's":41865,"bubbles":33097,"naval":6157,"tammany":40639,"mp4":42213,"resulting":4837,"circumstance":12037,"stun":39360,"respectful":6762,"samter":45665,"neruda":44898,"blob":27787,"timeframe":17885,"portion":3399,"dilutes":39364,"cheesedreams":24339,"recognitions":25016,"hagar":42304,"strain":10785,"change'":45695,"pageants":19522,"prod":2576,"ftr":34691,"emphasises":33759,"rolled":10020,"prepares":40439,"←":5790,"afflicted":30976,"critizing":35111,"reward":8467,"actor's":21761,"monitored":12211,"egregiously":29032,"where'd":35237,"locative":29331,"complexion":22434,"saxons":15831,"prejudiced":10955,"i'l":32094,"scrapiron":45781,"syedna":20865,"léon":46574,"giver's":22852,"coaster":23426,"bol":33808,"sharper":29033,"inherently":5344,"bernardino":37278,"executor":24489,"birthday":4070,"cogently":49309,"uncommon":8916,"proliferate":45565,"pm800":24301,"jealouslyfavonian":11648,"manipulates":30021,"replay":16845,"cant":1632,"demands":6115,"maj":34021,"pib":17896,"magluta'":40654,"dosn't":30748,"bin":3990,"corresponded":23434,"deserved":5129,"tufts":27676,"premature":7776,"publish":3218,"pastures":43001,"2pm":48435,"intimacy":23558,"sinn":6993,"klitschko":36920,"fearless":30095,"existing":929,"morocco's":39131,"everyone":552,"henry's":29638,"imminent":18277,"“that":44816,"meatpuppeting":38320,"released":1303,"phoneme":32764,"dictatorships":24109,"missing":1141,"resource":3028,"animate":16964,"mispelled":39798,"centrally":19844,"area":725,"burlington":30718,"gouging":48261,"speek":35371,"5'":25305,"paedophile":11367,"inauthentic":45015,"tentinator":41142,"friend's":11760,"lorne":35435,"mdpi":23157,"lok":42400,"forestgarden":36724,"egocentric":43301,"vital":5833,"uuuuuu":6242,"timeshifter":41839,"skews":35661,"momentum":9188,"'self":19948,"billionaires":24929,"affirmation":15280,"cruelty":15703,"periphery":41000,"rene":43751,"vaccum":44018,"scholastic":15683,"cuckoo":28056,"odd":1950,"sfn":37210,"haben":44210,"twenty":5358,"steroid":17874,"onstage":49482,"case":194,"patrollers":19416,"coming":1009,"conn":28234,"cabin":17641,"pog":33553,"scans":11428,"congrats":5343,"midnight":7581,"butcher":14128,"atom":12294,"naidu":39477,"rumination":35280,"constable":43345,"sam":4123,"berlet's":25288,"recognise":3043,"zan":40660,"ordinator":47075,"homicides":48034,"reconsideration":23462,"saya":42048,"liam":16779,"piloted":41351,"badass":15616,"arvanites":11908,"beign":45667,"anti":554,"liar":2702,"criticism":838,"bitchmother":14094,"msi":29072,"nudity":14449,"phage":37845,"1940's":35687,"talk•":9201,"swahili":30249,"recount":28456,"tortures":35085,"judy":12695,"•t":36227,"architects":13470,"gangster":21717,"collider":46280,"primes":20757,"myth":3040,"elliot":19082,"disparity":17737,"masonry":24168,"rapcore":30493,"construction":3407,"anticipating":31318,"samhain":41676,"haddad":28731,"coherency":46623,"venice":11515,"massa":39408,"lifter":46387,"seven":2039,"coatrack":11419,"permanente":48492,"volleyball":15261,"gingrich":28696,"maría":42943,"reconciled":40367,"philosophus":38955,"khastriyas":21079,"'editors'":43673,"sneakily":40180,"kittens":15947,"verify":1674,"yogananda":28973,"chode":43386,"mel's":36990,"rare":3203,"nauseum":19697,"funnily":24778,"dervish":43929,"misrata":28775,"judeo":17263,"iit":28495,"cwc":29479,"urbanized":39315,"negroes":26885,"roychowdhuri":38502,"somehow":1646,"aree":44685,"quack":14399,"deads":45787,"people's":1826,"fabrication":8021,"werewolf":31844,"standardising":44326,"ginsberg":44183,"uppercase":35231,"history'":26113,"asks":5444,"'main":34453,"charcters":40693,"suggestions":1436,"oversight":6136,"dealings":10985,"superdeng":37347,"exposing":8506,"eventually":1818,"facetious":29457,"jutland":33636,"doosh":17314,"john's":8501,"carolla":41817,"cairo":13992,"winner":5145,"denomination":12883,"authors'":20512,"intestinal":42948,"fdd":38157,"biomedical":26896,"agw":13878,"tortoise":20229,"proclamation":14026,"swansea":30186,"eleonora":47111,"wrecked":27478,"siteban":44764,"appearence":17006,"fece":35519,"kultury":44276,"nationalistic":4076,"welcome":188,"horton's":47596,"eye":1564,"marth":36927,"xlinkbot":41271,"gauss":46281,"soar":37777,"maple":16426,"dismissive":12654,"grim":24821,"competitors":9935,"rhine":29556,"larousse":30347,"montel":38253,"fanatics":9720,"dedicated":2931,"bates":16585,"novels":5383,"specfic":48064,"wikiafrica":27402,"sending":3600,"squabble":49653,"pewter":49152,"retitled":18255,"retailer":27060,"clones":16724,"underwater":23995,"sailors":18188,"acharya":28590,"livejournal":19251,"keeps":1738,"naylor":36818,"vandalism":199,"tele":46443,"freedman":48957,"reactionary":14657,"achilles":23367,"loose":4862,"arin":24575,"unseen":18448,"searchterm":42337,"swing":9606,"nodes":23275,"spiritualism":26504,"prompt":8072,"ispy1981":40727,"dosage":22918,"20px":21775,"penaltykillah":41741,"tournesol":49442,"ipod":9994,"kades":47523,"orden":45562,"subtopics":26824,"ashlee":12725,"motherfucker":4558,"“they":26905,"capitalise":35887,"hellfire":44707,"concurrent":25591,"kits":12812,"capability":8711,"unresolved":10075,"bunchofgrapes":16066,"timber":21521,"teamed":19790,"ref's":33915,"auspices":21836,"recusing":36884,"uq":44406,"keegan":44468,"slaying":44268,"engels":40174,"musk":34112,"canoe":24636,"terms":686,"afa":20971,"irrefutable":17009,"compassion":13024,"stubs":3288,"orion":15080,"opera":4478,"store":3880,"taido":33002,"overstepped":25366,"formating":21800,"krichell":38824,"tirade":10607,"noun":5132,"dart":26895,"arbcoms":42552,"priestess":38966,"turmoil":17596,"scary":8291,"madcoverboy":48153,"kelantan":42426,"diacritical":34711,"anderson's":26951,"chatting":11192,"opponents'":32958,"freaks'":36338,"mover":21185,"lem":38998,"ephraim":36874,"lily":15126,"dima":49761,"pali":26045,"'problem'":36340,"disturbs":30587,"dheyward":27093,"ponce":20515,"zara":28686,"flatlist":29036,"revival":9399,"notebooks":39792,"pint":19372,"sinan":48228,"critized":47074,"incrementally":44004,"hasnt":15920,"associates":9219,"gotham":26181,"ims":24724,"inappropriate":1067,"incorrect":949,"thuja":28059,"mordern":39327,"campfire":31631,"prevents":7155,"frost":19203,"reckon":9133,"inversely":42327,"printer":26226,"merope":32981,"completly":12647,"tell":359,"dirt":8312,"salmon":16047,"verboten":42503,"ebay":7799,"oppinion":20175,"wazir":39241,"ghazi":29109,"unbending":48656,"gila":41086,"aubert":41444,"radios":21291,"palsy":17963,"probabaly":39963,"spence":25572,"revolting":30969,"fischer":14318,"parenthetical":12347,"ulysses":40881,"spark":11864,"grammys":39964,"authorisation":31074,"rosy":46078,"conflation":29625,"vladimir":12815,"fredrick":34286,"outlying":30997,"strongly":1537,"disussion":32852,"51st":41349,"azerbaijanis":14868,"tracts":31714,"blank":1659,"n277":32556,"irataba":49029,"samev":23832,"devalue":41577,"gazeta":44463,"archetypal":43380,"horrifying":30756,"li":9117,"rrs":44643,"toronto":4569,"hardened":36828,"monicasdude":36823,"davidwilton":28020,"hmv":39569,"mislead":6752,"stones":7624,"hue":34103,"ethnically":7022,"lougheed":45926,"♫♦♫":39178,"chump":16673,"nepotism":43750,"coat":4801,"registering":8260,"fairbairn":36366,"noah's":17923,"basingstoke":33960,"migrations":17266,"piv":43731,"loudoun":34051,"troller101":48176,"emperor":5018,"painful":7921,"owner":2296,"propagated":18151,"kmk":34832,"editied":47468,"rbs":41784,"swim":17276,"°":25622,"baburam":29011,"isomorphic":22089,"seattletimes":35439,"♥♥vampire♥heart♥":32450,"strategy":4396,"mestizos":28134,"csa":33144,"ulster":9471,"gamer":16277,"yep":4632,"aside":2046,"astronomer":19397,"macroscopic":36149,"timezone":30888,"cockroaches":43489,"roux's":48206,"intersted":36452,"tenofalltrades":34122,"dursun":48244,"failed":1419,"poonam":40595,"b12":14504,"chrisb":46087,"role":1389,"maxarchivesize":33299,"premeditation":47514,"array":13902,"ustaša":40184,"purohit":34752,"doublethink":44674,"basically":1229,"stylistically":35189,"chamkaur":16614,"rajarata":16010,"catches":16289,"boltzmann":48173,"booey":18129,"reviled":28030,"wikipediareview":25441,"kamm":48293,"stimulation":23717,"cater":16424,"mainpagebg":2930,"informing":6004,"owns":4091,"abdul":9956,"actuators":45349,"bracket":11120,"horse's":21443,"fabricate":23919,"delisted":14970,"gunners":34025,"sharma":13275,"penelope":37580,"fortean":47301,"underlining":32825,"axon":44331,"carlos":8331,"dues":28219,"deshmukh":43575,"mates":11475,"lionelt":38518,"terrific":17966,"googlebooks":27543,"provocatively":42240,"tactics":3533,"deletions":2844,"harrison's":40169,"recipe":13308,"chappelle":47850,"hormones":15318,"ninjutsu":41272,"substantial":2351,"oct":3319,"kelvin":21477,"niominka":38410,"realistic":7702,"hallo":16056,"•tabis":31460,"replica":21610,"msw3":40781,"authorities":3128,"inexplicably":25535,"prerogative":14566,"heels":15031,"use'":45137,"scythian":19111,"theodor":41310,"leno's":37792,"distributors":23692,"pannonian":38455,"poland":2723,"primo":41264,"bulk":6383,"staffers":28140,"cb":24049,"pdf":2168,"binienda":38048,"bygones":18290,"utilitarian":35342,"smoker":14989,"automated":4362,"tpg":21061,"toppled":36031,"nub":37752,"boasting":24496,"delaney":29878,"bernard":8589,"bizzare":37705,"aout":49988,"chan":11209,"chalmers":44073,"discusses":4650,"philosophy":2143,"hoo":5582,"suprised":12320,"tuskegee":49719,"sandoval":36292,"topgun":30777,"ud":14280,"seal":5542,"dogmatic":11299,"commentaries":12938,"febuary":28849,"☭":29144,"repent":24528,"schopenhauer":36455,"raj":10557,"yot":27697,"constellations":18114,"messages":899,"defensively":26609,"ravana":24349,"culmination":31428,"deluxe":23468,"80s":9816,"tasked":19637,"interrupts":44343,"cruel":7349,"vos":26906,"einar":30254,"pluck":43230,"recurring":8354,"gomez":20325,"supplement":11692,"restated":19715,"vicodin":36478,"liberals":4643,"concludes":15020,"undergraduate":10691,"yall":10868,"jjonz":49280,"dardian":35559,"relive":35322,"nelson's":21926,"nobleman":46598,"spears":10410,"gage":16269,"divinely":36328,"002":27431,"marching":16193,"fame":3755,"lout":39172,"layton":43057,"conradi":32204,"unclean":36295,"cong":24079,"“an":40969,"tat":11771,"abe":14241,"threat":1878,"supplemented":37190,"dravidians":27995,"antiquities":23552,"pony":13809,"qaeda":6802,"corinth":40127,"agreement":1905,"rodeo":8619,"gerry":11546,"tauris":30527,"beginning":1370,"fps":15649,"siad":35830,"futures":31252,"epsilon":14565,"streak":15764,"misconception":6407,"comfortable":5575,"gallantry":39133,"exercized":35852,"johannis":38741,"sidekicks":29141,"sd":9023,"reichstag":25693,"orbiting":24392,"diverse":6497,"belmont":34536,"want":105,"mladic":48991,"skill":6773,"test":733,"'tis":23612,"scoring":10673,"responsive":18966,"sandboxing":33474,"sunshine":12670,"tech":4403,"laver":17788,"pragmatism":36368,"oblast":17448,"atmospheric":14147,"spelling":1317,"superstructure":44381,"bribing":49859,"'falcon":36262,"unattractive":29437,"obituary":9991,"dismisses":20021,"watergate":15875,"forbidden":5211,"pele":48378,"walsh":9897,"overuse":17787,"members'":20455,"condensed":10779,"uneditable":43676,"goodness":6144,"nazi":1189,"weierstrass":49228,"danced":38973,"unwatched":49865,"brawl":12222,"renders":16924,"tought":38375,"sama":37448,"algebras":38475,"bash":7730,"sucessful":36040,"football":1374,"pdp":25720,"superscript":23330,"'not":14675,"au":4415,"lauderdale":25407,"paternal":18109,"virus":5893,"saif":38523,"rugby":5465,"normalized":40829,"lifestyles":43931,"fuckin'":6583,"surface":3652,"aristocratic":20313,"tinge":41649,"supernova":35315,"wpa":36428,"does'nt":46761,"solicited":20276,"sordid":25917,"cisoop1":44198,"kerner":49227,"bullock":26313,"digital":3591,"michele":24413,"textbold":32669,"amon":26850,"exapmle":48971,"workers'":7216,"azari":34873,"thank's":27031,"sibiu":35327,"sharia":25386,"multifaceted":46602,"hobart":45679,"cptnono":33582,"ashley's":49258,"zion":12505,"supplementary":24361,"povtitle":46333,"becuase":6083,"tidbit":17317,"inductees":26183,"quincy":22974,"reprinted":15828,"dine":30575,"bystanders":33334,"froman":44319,"nolans":46070,"devine":19540,"afrikaans":43715,"rudimentary":21802,"partially":5157,"courtly":37769,"arima":44554,"metacritic's":49676,"obscured":21648,"slurs":9108,"psychics":37843,"haer":49201,"performed":3706,"backstreet":23677,"wh":13436,"revan":46363,"oyster":28402,"sufferings":39539,"faire":16271,"showers":25988,"cézanne":38065,"fife":26230,"3c":47922,"nihil":38251,"infatuated":40982,"faithed":39713,"deltion":33444,"endeavours":23059,"olde":19987,"archeology":22958,"responsable":41519,"outreach":15603,"hangingcurve":32497,"evolve":10952,"greatful":25975,"radical":4012,"hahahahahaha":21656,"slug":17224,"thang":29725,"sthenelaidas":29779,"tree":2812,"pashtun":7857,"eratosthenes":30407,"surely":1569,"progresses":18144,"northrop":23910,"mellow":48913,"hm":6982,"railroad":7948,"medes":18655,"edgerton":47150,"tinfoil":31981,"carroll":20609,"audrey":28567,"observed":3918,"trembling":35625,"ig":28475,"soekarno":47288,"shouted":16276,"priests":9619,"shitty":5304,"trivium":31096,"staging":30276,"prohibit":8242,"belisarius":44953,"lek":38218,"orang":48840,"versatile":42981,"cfork":46467,"lowlife":27481,"ga's":34881,"resell":41584,"dildos":33498,"accumulate":21009,"subspace":16302,"trimmed":7881,"annual":4868,"marwats":46960,"clerk":7150,"'history":37092,"repeat":1722,"creed":14017,"boosting":28785,"laddie":39650,"boson":30496,"sixteen":14893,"greg's":30740,"transitional":14293,"bolted":36500,"competes":36390,"20m":35207,"replicate":22826,"islami":36625,"subservience":38939,"houston":7186,"talker":46854,"spectrum":6009,"lukewarm":48240,"pristina":39632,"oeuvre":44459,"syncretism":43846,"ks":19683,"dlm":28600,"eep":38209,"mutation":12648,"identifying":4475,"corner":4615,"starboard":45947,"crosby":20384,"cdu":30816,"ahh":8313,"longs":46815,"snippets":19009,"bucharest":15772,"retrograde":39892,"sikhs":5980,"churning":34470,"characterizing":15273,"banda":27869,"bull":4908,"fukkin":22152,"publicizing":38685,"findings":4777,"suez":20840,"embodiment":29281,"puff":11708,"gold's":46409,"chattel":32484,"scurry":47715,"econ":28682,"asimov":34277,"bung":38633,"blush":21161,"anticommuting":44260,"gilliam":26608,"moto":20672,"lagrangian":36283,"spiel":40661,"altaic":13096,"unskilled":48321,"mots":15888,"feels":2939,"paradoxical":33034,"spreti":34842,"styx":34161,"posible":36223,"cones":34477,"english":270,"kota":31892,"flaw":7985,"notts":44182,"thucydides":45025,"individual":1084,"moret":33162,"uyghur":27452,"it":11,"lenneth":46967,"focusing":5936,"beatings":31358,"mo":6401,"unreleased":13192,"medici":39255,"integers":14114,"hippie":13769,"''italic":44339,"defiantly":30960,"substub":34008,"processors":18895,"unitarian":22662,"hoinga":38813,"europhiles":44567,"preparation":10297,"kmccoy":43096,"axial":38034,"splice":40045,"remit":29074,"sensationalism":33353,"05":1680,"mentored":7092,"obstinate":22531,"maol":34738,"hidey":28391,"qur'an":11059,"chliorine":18131,"babysit":35580,"philknight":40699,"shqiptare":49458,"glycol":23825,"roux":11489,"dillard":47363,"'massacre'":43484,"vettel":27889,"exercises":13986,"gripes":39441,"tonnage":31029,"liber":23491,"'original":25050,"control":986,"taged":36474,"fe":15489,"distressing":24639,"gamergate":7954,"apologizing":14645,"attorney's":30328,"gawd":24337,"image's":5977,"shahrukh":41001,"populous":16670,"daphne":43476,"narcissism":25969,"blackpearll4":35468,"loudness":39614,"generalization":11684,"dividing":10597,"mitochondria":44575,"adijapan":30819,"epipelagic":24114,"amuca":24376,"charter":7307,"expiry":11347,"oggmedia":12237,"buddism":37957,"amos":17147,"logged":1608,"slimy":16044,"overturned":9426,"cranial":36397,"phonetically":35291,"noeticatea":41250,"pineal":43394,"incompatibility":21214,"referes":40115,"redundant":2905,"adopter":14912,"amazes":19318,"5k":31184,"steadfast":30426,"clients":6707,"“a":13703,"chesdovi":29798,"manipulations":21689,"whoo":46512,"should've":9184,"¢":29451,"warlords":27209,"pianos":21112,"anybody":1662,"paras":19445,"sti":24159,"carriers":17091,"100s":26725,"specious":10142,"empower":40998,"❤":17999,"oif":41214,"equalization":21418,"unaccepted":42429,"reminders":22445,"ordinates":39228,"infections":16806,"evelyn":41390,"populist":21816,"masculinism":31800,"cloak":15777,"theism":24290,"another's":13295,"rei":34406,"pbuh":32569,"approaches":7187,"ched":23813,"ohms":37057,"hooliganism":33947,"vain":10112,"midwestern":27578,"filthy":7074,"reforming":37249,"bournemouth":29228,"wud":43538,"bargaining":28867,"rises":9113,"vandilization":45823,"acquaintances":33112,"loosen":43972,"torres":17207,"reflect":1665,"miners":32550,"apparantly":20691,"proportionate":25446,"dacia":23110,"scray":39509,"interviews":3403,"vaguely":8776,"itch":31347,"iulius":41771,"begets":37165,"militia":10936,"liers":42243,"cohesive":24747,"plated":48764,"eps":14271,"nintendo's":27462,"solution":1734,"suffixed":40875,"militarily":23003,"ashura":29944,"fifty":9288,"investigated":6770,"oob":45104,"schism":13514,"'in":12402,"frb":32680,"pastor":11257,"हिन्दी":39403,"definetely":29042,"elsberry":41420,"prop":12555,"vehicles":6104,"ball":3018,"zuma":35078,"angioplasty":48789,"worldwide":3434,"muslim":1506,"movin'":46760,"fernández":33904,"dumbfounded":33384,"lauded":24548,"tore":40418,"composers":10430,"scribbles":41853,"vercetti":30188,"fagget":20242,"img":9888,"q":2060,"shown":1153,"teaser":20579,"pruned":29094,"aoc":45921,"antivirus":39766,"revolted":41578,"bearcat's":45777,"incoherence":45687,"hypotheticals":29262,"permanantly":47151,"millionaire":22777,"paraded":47030,"bosses":16517,"formulating":26046,"countdown":18327,"thickness":19914,"d348":44800,"configurations":24391,"hatched":35050,"bann":26486,"pinney":43500,"skat":49129,"ceo":6576,"jhu":31852,"scanning":15353,"tipler":12177,"frontiers":25372,"tapped":28628,"peiser":29464,"interpreted":3950,"individually":9342,"duo":15127,"zur":37240,"travelling":8550,"app":9614,"krusty":40628,"crust":22185,"rocking":33310,"·t":19115,"sonata":20903,"chrissake":48623,"marry":7689," – talk":39303,"secretly":11214,"kate's":47045,"mcrae":46785,"closet":11937,"tortured":14405,"marya":31799,"livingstone":30228,"traveler":28303,"burch":29107,"fire":1566,"alter":3723,"factoids":32814,"steiner":19552,"distinction":2618,"psychoanalysis":21435,"societies":6637,"hiv":5327,"teasers":41580,"dunmanway":39162,"stoning":25798,"objections":2241,"uk's":16260,"moldovans":21412,"reddys":49790,"wells's":25600,"infinitely":16113,"require":1654,"zulu":21325,"teutonic":22236,"fourteen":11820,"sonjay":45757,"lil":8386,"unitech":39102,"relatives":6349,"guyok":37835,"week's":9909,"pertained":49047,"month":1174,"could":104,"interchangably":33870,"nutral":41008,"resolutions":10205,"moving":1426,"travancore":34526,"patient":4113,"mammoth":24198,"bona":17186,"chez":35869,"cooper's":49668,"toponyms":42032,"yates":22428,"sire":26078,"datanet":42559,"uncommitted":41192,"nyttend":20806,"ohio":5009,"continuance":37250,"albums":2517,"gohar":23724,"indent":12384,"slopes":35117,"forseeable":34143,"endocinal":41058,"conscript":40288,"thnk":29756,"flux":10089,"husseini":29598,"agreeded":41538,"signified":12225,"fallacious":10930,"'''the":32425,"belligerent":10906,"qoute":21124,"enciclopedia":35591,"liberally":14509,"seller":16075,"reassignment":37549,"toucher":47820,"palestinian":2943,"poincaré":29179,"itil":44039,"plata":24813,"cube":12338,"macman202":42797,"petter":47304,"guy":626,"award":1451,"norms":9235,"pueblo":23714,"tantrum":25191,"impugn":44604,"pamphlet":18878,"elves":26596,"stormed":46355,"overy":36784,"resettlement":49175,"draft":2098,"listpeople":45885,"jurist":39307,"carte":17692,"explicated":49263,"anachronistically":47853,"statute":9256,"fitzgerald":18459,"asymmetrical":27405,"flustered":49760,"documented":2248,"rhoads":47035,"firearm":18947,"pschemp":31131,"particularly":979,"r97":34621,"distracted":13982,"perfect":1683,"sue":4639,"nevermind":7479,"'white":22180,"depletion":34351,"luckily":10840,"ohm":26414,"neopets":40557,"knoe":40476,"whizz":49580,"cognate":25118,"shouldnt":7805,"gates":9782,"progress":2359,"familiarized":31473,"conflated":18045,"preferred":2792,"spicy":40851,"algiers":34315,"routine":7476,"degrades":43197,"reston":40221,"converse":9698,"cvs":32918,"rahman":20669,"sapiens":11789,"fora":20504,"dabs":38389,"swift":7997,"samuel":5799,"wikiproject":662,"expedient":29671,"striving":15296,"amidst":24580,"munir":23944,"delve":19594,"toxic":7733,"indignation":26000,"surveys":10188,"bamma":23392,"harrassing":7497,"whew":33439,"crossword":29662,"dax":27966,"winkle":42876,"kamon":16999,"normans":17820,"abel":22981,"science'":33840,"farc":18154,"atabek":32728,"baker":7491,"gtl":45991,"tread":13043,"gamers":13162,"stanley":8011,"thus":760,"food":2260,"idw":38593,"rochelle":31795,"ignacio":38968,"changeling":38680,"j":1129,"hubris":21459,"genealogy":11406,"factbook":11116,"canadians":8510,"mahendra":35525,"abrupt":16285,"jones'":5508,"ihardlythinkso":45691,"synopsis":6331,"halaqah":44436,"townships":32176,"ceylon":40902,"tem":49397,"aztecs":32577,"hogwarts":22902,"copenhagen":14634,"palin's":22706,"linotype":47735,"mount":6189,"be":16,"knicks":38751,"misplaced":7820,"strangle":45987,"appalachian":30546,"ardvark87":44097,"vigor":19883,"prolly":17387,"leniency":31009,"snoop":17638,"almaty":24259,"dear":1050,"supervision":15511,"farther":12936,"methodology":8592,"xtra":35694,"noida":24324,"apprently":49273,"sabotaged":36608,"bowls":23340,"pregnancies":37880,"taking":675,"sass":47153,"anime":3622,"mutually":8005,"rais":45638,"devise":29028,"breakout":44584,"spider":7196,"determined":2555,"nbc's":32456,"ego":4411,"lyrics":3919," talk ":6466,"superstitious":24031,"determinant":21409,"prophecies":11408,"pekoe":31220,"sack":10161,"mosques":14534,"notes":1398,"herbicides":37069,"informer":28829,"wikipages":37149,"transcripts":8963,"osiris":24675,"wrapper":31821,"uefa":10079,"ambulances":39847,"misnomers":32546,"phoney":34189,"celibate":26631,"predating":37784,"aspergian":45244,"ailments":48690,"jeopardy":15648,"gurus":13807,"identify":2059,"tornados":44040,"b2":13825,"famous":1602,"sayin'":27698,"network's":26272,"aig":16250,"bilby":28645,"transit":7933,"pwi":24058,"pimp":15544,"stirred":21934,"technocracy":8526,"cages":36690,"restrained":14676,"stadia":40651,"surviving":8037,"discharge":14520,"freight":18291,"affordability":45207,"vegans":34466,"rasberry":41367,"bradbury":4069,"conceiving":42408,"cultivar":29849,"anorak":43605,"drum":9317,"molecular":10954,"umd":30640,"painfully":12542,"dammit":16467,"demeanor":21364,"conflicted":13104,"colonial":5891,"computer":970,"cameo":16147,"→bloqued":41432,"dafax":45850,"prudence":36236,"lambeth":38605,"initially":3397,"recompense":49758,"statistics":2502,"defintely":27548,"who'd":15495,"ledger":22290,"decrying":47440,"dorks":32463,"buck":9048,"wildfire":46926,"andy's":9725,"kirkuk":47366,"nomen":48937,"boys'":34498,"bretons":47714,"amputated":33033,"couse":48625,"rougher":49679,"haile":37075,"howe":18519,"scottsdale":27904,"cyber":5580,"kol":29015,"firestar":39428,"blacklisted":14418,"mcclintock":46158,"shift":6000,"possessions":20040,"ramsquire":44223,"turbines":28560,"sprinkle":36525,"predominantly":8729,"liberators":28298,"hittites":41682,"ovid":27313,"0k":45797,"flotation":38558,"inescapable":30686,"ncse":33667,"mandatory":8384,"savvy":14674,"sailed":26585,"remus":20972,"2's":34418,"which":53,"spook":47193,"honestly":1859,"souza":23769," →":28161,"nev1":22885,"siva":38049,"unassessed":30599,"oscillations":35420,"advocacy":5374,"career":1716,"adi":13731,"slew":20071,"nn":12533,"gotten":2743,"mekhael":23147,"ptolemy's":43603,"hannan":47773,"kamat":27068,"savagery":24917,"furthered":46572,"haik":42526,"suffice":5792,"veterans":9730,"prv":43794,"galleon":34930,"anoshirawan":45591,"businessman":12428,"siddiqui":32986,"blurry":15068,"grime":41478,"sighted":16508,"porto":26810,"q's":46912,"kadis":30801,"t2me":45122,"fellowship":11338,"timed":10526,"advertisment":19764,"afspa":43179,"tropical":5362,"unsatisfied":32377,"bollox":47374,"steak":19602,"entries":1790,"riddled":11670,"mvp":30681,"grasp":4764,"anchored":32436,"qa":26848,"curated":25341,"hunza":43708,"littlejohn":45684,"smarter":9817,"morman":46978,"heine":30461,"singe":47272,"gm":10385,"wacl":17518,"ies":42884,"fireworks":20528,"pituitary":43395,"sourced":741,"exuse":40499,"slime":18991,"grapevine":43137,"côte":29936,"dangers":12279,"helms":25684,"keyboards":16907,"italic":9167,"babbling":20603,"fpas":36137,"rashad":20453,"amended":6481,"excommunicated":33295,"attained":15103,"hafez":29529,"steve":2872,"whip":13190,"gamestop":31283,"broly":37468,"elk":34714,"adaptation":13734,"coyle":25287,"sat":6666,"plagarism":24129,"binoculars":44742,"exploited":14580,"logistics":25391,"cornwell's":40368,"cc":4658,"locke":15908,"superlatives":40124,"anfield":28890,"eduardo":10017,"harsh":4259,"ballenstedt":31845,"chomhairle":29738,"productively":14878,"fest":14555,"cahr":20225,"unger":37143,"gibraltarpedia":27236,"motors":13740,"theater":8162,"ummmmmmm":10350,"sucked":9672,"zmaj":27375,"vive":48334,"hang":4566,"stabilizers":36878,"fucktard":15343,"reclaim":37596,"watches":11481,"galicia":23471,"minh":33288,"newish":47338,"limited":1416,"treble":28091,"yan":27111,"rounds":9424,"lybia":38353,"television":2192,"nodding":46384,"victimised":34222,"subdivide":44770,"spaghetti":15228,"motorcycling":22895,"graduation":9390,"diwali":17422,"allegience":44752,"janice":32589,"moderate":6879,"landslide":31501,"wiser":10894,"ramifications":19832,"aditya":43679,"goodyear":44784,"mariage":40234,"mao's":29814,"'the":3777,"hideyoshi":45492,"c'''":45420,"animal":2697,"canola":29300,"£1":20222,"chuckle":13551,"apt":10472,"nirvana":14628,"smooth":8259,"rankings":4560,"required":1191,"produce":963,"xenobot":38439,"northumbria":35126,"graduating":14341,"woooo":47182,"drmargi":38013,"chatonline":46886,"mcdonald":13505,"surrounding":4128,"thyssagetae":27765,"continued":1730,"kg":11298,"nullified":33514,"vessels":11998,"flak":18642,"ironholds":15408,"山本一郎":46626,"descended":7318,"qworty":21837,"reigns":29104,"shifted":10829,"prominent":2500,"f2":26002,"’s":43233,"curently":37230,"socialization":47555,"cassidy":24084,"scalar":17383,"rsvp":21026,"boiler":26021,"pz":29347,"excell":44718,"drat":47702,"hovering":17466,"thier":8086,"burial":10097,"wang":14214,"choir":15480,"phobic":48639,"payments":11300,"crackpot":12900,"toothed":20119,"m€§§åg€":49256,"messageboard":26096,"satusuro":17770,"elvira":34716,"distancing":46246,"sk":14826,"baja":40388,"priviledges":32129,"nrl":21674,"pedos":35802,"archiving":4409,"jock":29588,"bloodiest":40043,"theologians":12964,"lactose":42436,"sadder":24473,"discrediting":13065,"haphazardly":30405,"vaudeville":44421,"confluence":47811,"tournaments":13102,"frank's":38616,"jerk":3038,"1980's":12857,"frightened":24750,"karaoke":31986,"resubmitted":27487,"wats":22646,"jinxmchue":39824,"nashville":17273,"persuasive":12810,"scribes":27754,"wwe's":31758,"ashnard":34250,"measures":5320,"fukcing":40885,"assets":7580,"hold":1299,"nth":30090,"everyones":22838,"even":95,"uncharacteristic":31943,"viz":12452,"arses":20249,"kristina":35199,"aware":707,"indira":44086,"bombs":7748,"earl":7797,"conflicts":3315,"doc":3161,"macedonians":4372,"apk":30972,"reminds":6803,"paddies":47265,"'''''":13777,"npc":25640,"allocations":32800,"leaflet":38115,"kaká":45544,"climatologists":49833,"compares":14732,"set":713,"presenters":22849,"constellation":15991,"disadvantage":13881,"sodom":29649,"green":1727,"clapping":40929,"jafferlot":48151,"vandalist":20542,"blue's":27703,"linkin":23249,"tajiks":9276,"  ":6001,"ŷour":20113,"la":1795,"instinctive":35517,"weimar":21244,"persecuting":23222,"donations":7378,"kindness":6635,"spend":1991,"jain":19303,"connolly's":46461,"urim":48098,"extraterrestrial":28129,"deeper":6366,"dabomb":34973,"werner":19328,"0rr":29676,"absolutely":1039,"—bol":38161,"hector":48340,"law":651,"dentists":21883,"bungled":49465,"engage":2226,"tees":25974,"paticular":32595,"igor":8328,"homie":16015,"citys":43098,"engineering":3293,"bethlehem":19399,"integer":17585,"megalomania":25438,"reasonings":31908,"rubric":39542,"amistad":49955,"yuber's":48622,"wikitruth":37242,"grande's":45073,"edgar":13083,"husbands":20596,"freenode":22347,"invades":41862,"handiwork":31381,"start":438,"vir":47042,"nouvelle":30880,"group":421,"mofo":22078,"commencement":21824,"disk":11054,"meaningless":3493,"bio":1846,"syndromes":30696,"accommodating":31456,"hos":16720,"reilly":33473,"tendencies":12577,"kool":20423,"walter":6231,"stoner":20196,"continuing":2552,"lawyer":3602,"reland":29358,"sarat":49846,"unchanged":10823,"familiaris":28492,"concurred":29680,"proving":4108,"sinanoglu":14143,"inferring":35705,"zool":43753,"broo":48078,"mornington":48476,"ambiguities":26375,"apiece":33039,"frog":12180,"remakes":26383,"dolores":39163,"mindset":11241,"filmmakers":22876,"fades":31530,"refine":15769,"numerical":9049,"manifestly":19750,"unleash":24632,"coulter's":43922,"bridging":40457,"rate":1949,"himara":42455,"unsentimental":34431,"declaring":7502,"hash":13087,"grandsons":32293,"reusable":31912,"marek":17165,"skanderbeg":21025,"uploaded":689,"lyndon":22440,"domain":1748,"verifying":7209,"misconduct":7499,"jane":6702,"matt ":48312,"vague":2842,"recovery":9275,"stillborn":38296,"destinations":10542,"seo":36529,"talkpage":1923,"title":348,"mib":44516,"civilisation":12749,"fios":26987,"valiant":33070,"blud":42589,"alt":6277,"o":1024,"edites":48115,"tripalda":42810,"brill":30044,"lifetime":4328,"larger":2177,"isotope":25625,"timecop":24867,"bute":34580,"etymological":18376,"bicycling":44157,"ferry":11972,"spyros":35358,"show's":13962,"correspondent":14581,"sophomore":20109,"quibbles":42063,"rioting":24777,"aboutus":15104,"gorgani":34771,"roulette":23356,"hotspot":24830,"'''slam'''":39633,"enmity":24331,"homs":24908,"hours":773,"lair":33577,"stepanakert":46225,"downsize":42746,"convinces":26243,"ba":8149,"definately":7681,"joking":8033,"underneath":6851,"levi":18683,"mercenaries":18839,"labyrinth":27621,"sensationalistic":30534,"jesanj":34816,"discreetly":48420,"espinola":19905,"contect":42214,"pffff":47752,"dimension":9243,"cherishing":48041,"acct":37443,"sweets":33535,"opposite":2134,"york's":24828,"uglier":46117,"whereas":2483,"flotilla":24656,"rediculous":12609,"sandahl":30928,"steam":7618,"manner":1323,"fci":31232,"discussing":1232,"mm":7249,"longer":787,"doug":6991,"amaury's":38368,"meg":20752,"prevented":6842,"modesto":43053,"don'":32477,"australia":1801,"hitter":15181,"bucket":12114,"railways":12432,"tocino":30211,"synthpop":38116,"savant":27563,"frederick":11965,"edmund":18622,"inhabitants":6950,"lesnar":21989,"soulful":42672,"ga":1196,"tobby72":43165,"scarlet":15788,"wikihow":33860,"humidity":33670,"gs":9150,"airport":3954,"undergoes":29231,"portrayal":10363,"kidney":18973,"fairway":38836,"inscriptions":9082,"knapp":48753,"paginated":47406,"off2riorob":16525,"bukhara":39943,"mcgee":29304,"induced":8398,"differentiate":7478,"rote":36185,"advantages":9552,"forgets":24524,"poster's":32842,"erpert":32769,"toure":44435,"helper":18467,"wesker":30175,"yoke":37021,"dissemination":17591,"generalizes":31023,"dyslexic":31414,"gazetteer":25427,"bibliotheca":41920,"perks":27735,"vick":34377,"malleus's":45164,"dalek":31810,"wikiepdia":19089,"framing":15396,"hight":31768,"markers":12876,"‘a":41207,"meetings":7404,"división":35001,"arbcom's":18540,"cambria":36426,"combustion":15639,"discontinued":14305,"kara":19452,"slander":4931,"tran":21665,"rationalize":23190,"neurosci":48608,"mote":47224,"'abbas":44232,"vaild":41406,"jews'":46118,"enclaves":45190,"balakian":30042,"mastered":22438,"minigame":35046,"dorm":19006,"id":1344,"relied":11223,"kristi":39814,"hydrinos":20154,"desperately":7879,"saratoga":49776,"dominating":18506,"setanta":34935,"stoopid":37756,"rambo":46976,"fawlty":38557,"irenaeus":25574,"picks":11355,"layout":3874,"side's":27287,"2012–13":37905,"tamed":45653,"protectors":21006,"precise":3598,"lisak":44269,"mahatma":20687,"males":6245,"beings":5454,"knobs":40695,"proc":29014,"ks0stm":45212,"prosecute":15684,"winterberg":24940,"rosa":14626,"germantown":45541,"amg":12200,"caf":46241,"strictly":3532,"polyandry":17646,"how":70,"sands":15927,"alan":4604,"montana":8115,"royce":17441,"filings":23448,"3m":32756,"yearning":48308,"bender":25808,"climax":22606,"face":1078,"welcomes":13669,"rewardsforjustice":46699,"bicker":27953,"magneto":22943,"franziska":41550,"columbia":4340,"miller":6154,"outline":4022,"crystallized":46063,"verifiability":1682,"admixture":15160,"toponym":29833,"'objects":44576,"60s":10850,"bbb":9123,"plain":2152,"raimi":49729,"ineffectual":37822,"freemail":47067,"hizbollah":33333,"begun":4767,"molotov":23487,"erich":27029,"oughta":46043,"semantics":8446,"speeding":40474,"laughs":13728,"commencing":23709,"verily":39591,"lending":17644,"philosophically":37229," ☎":16847,"fifteen":8805,"electra":29942,"ensuing":13388,"mash":19997,"huff":21633,"erikson":49259,"noradrenergic":42229,"rockford":44996,"dorset":16708,"fouls":35851,"nicely":4281,"acne":36237,"specifially":46326,"democrat":7142,"jayron":21466,"natalie":14491,"verbally":16492,"sinhalese":12805,"pcgn":47955,"swiftboating":28155,"subtract":25907,"phoenixreporter":28739,"gscshoyru":30764,"iupac":31039,"turkmen":29507,"immeasurable":32053,"wolfkeeper":11593,"auditions":38279,"notwithstanding":9365,"beans":13028,"exits":25274,"philosopher":6452,"misfit":41212,"stuart":9885,"induce":16908,"filling":5713,"toxicology":31028,"plagiarised":25092,"cruz":9032,"diagree":29611,"polluting":20289,"nuance":19305,"rupee":34669,"illyria":30473,"tommy2010":3596,"tonyukuk":28290,"pornstar":39781,"discern":14378,"hopeful":14957,"pahari":44011,"maas":42186,"tapping":23495,"franca":16362,"mindrolling":35336,"anakin":19437,"qc":31026,"hellenization":32905,"ias":45516,"yamiking":45448,"lander":40256,"mutilation":13858,"reckoning":22493,"rpg":9579,"paulista":34264,"concise":4402,"fcytravis":47624,"”":1561,"smugmug":28021,"plausible":6822,"configured":24246,"lunatic":11020,"wormer":44426,"wire":7489,"babukishan":24976,"rebutal":43658,"cheerleading":39158,"toaster":45783,"aiken":33910,"handicapped":17038,"victorian":9696,"lurking":18620,"tedder":34188,"severity":17645,"vandalizim":42311,"joke":1302,"shahab":41435,"lata":41238,"ape":9539,"dru":28304,"kannada":6554,"diffusion":19856,"clouded":26351,"izetbegovic":48651,"banded":35685,"elevation":11292,"jumble":31203,"excalibur":31531,"cyril":10340,"nullifies":42143,"kph":40508,"rowdies":29403,"ref'd":40232,"zhuge":41284,"mrt":18101,"tit":10062,"rajus":11487,"attacker":14672,"cathode":26607,"giganotosaurus":46073,"duke53":47695,"altitude":11438,"counterexample":37573,"downtown":8406,"france's":24039,"tethers":34855,"ransom":35361,"passes":5382,"hisotry":46847,"ken":5778,"discontinue":15835,"try":279,"fuck":129,"köse":20210,"'do":31711,"renown":23855,"tonne":32588,"coercion":22601,"foi":36982,"libre":30727,"rantmedia":22080,"simonp":40726,"design'":49101,"vasconia":41471,"bud":9893,"fails":2544,"deacon":20387,"upanishads":31959,"probly":32385,"sharon":8906,"electrified":42687,"photojournalist":47441,"squabbles":37288,"deviant":14713,"episodes":2036,"counterarguments":33841,"jurisdiction":7025,"garage":10625,"glaciation":44706,"colonists":15749,"connie":22510,"sacked":22575,"practicable":38085,"prologues":37489,"vigorous":18334,"policy because":32939,"histroy":26881,"buttocks":27200,"fuelled":26242,"aldan":43593,"disallows":32033,"roundup":42271,"catechism":23660,"siyapaa":19245,"submitter":29225,"easton":34642,"bano":44143,"honesty":6272,"spitzer":34278,"privcapid":39437,"billcj":12050,"harvard":4721,"licking":11678,"fury":20615,"galactus":49381,"“svtcobra”":17752,"permit":7449,"acquaintance":20781,"ancestryfuck":3855,"practising":25849,"kincaid":29220,"damp":42490,"vandalized":2381,"maba":22883,"buddy":3585,"colonized":17071,"skits":27824,"living":832,"moar":20258,"summarized":7888,"goi":33045,"adjectives":12069,"mimi":30006,"scorpio":25730,"arbroath":44495,"sponsorship":24860,"oink":33268,"broaden":21511,"goddesses":20920,"ps2":14417,"torito":31205,"pentagon":13951,"noleander":40434,"ellis":15131,"hotels":17481,"jd":16415,"greyhound":24128,"patricia":11265,"derk":43981,"didactic":41414,"forefathers":25387,"disconnection":37150,"defaming":15383,"dentistry":22741,"revisions":3648,"pondered":36545,"overrun":25401,"indicate":845,"contenders":26842,"akram":48305,"shows":698,"dbachmann":14001,"alevi":42896,"slung":39951,"limbs":25133,"pushing":1676,"virulent":25377,"stimuli":44756,"ix":10794,"deviants":39520,"bigfoot":9321,"☺":8952,"identifiers":47236,"cadr":49819,"boggling":26930,"olympics":6286,"surrendered":17612,"ann":5822,"collins'":34145,"extract":8816,"imp":23236,"francais":28269,"das":8257,"reciprocity":18374,"spinster":39036,"liberated":14953,"sequels":26674,"kart":19834,"thermopylae":45700,"segregated":28004,"dalmatians":49067,"——":15854,"originate":9626,"bys":48708,"allways":15852,"speech":1568,"migrating":32914,"videogame":19292,"sunday":4386,"hasteur":48081,"img236":30472,"prohibition":8832,"auto":4024,"drinks":7250,"purchased":9211,"barged":46198,"wireless":8293,"pnrs's":46650,"mal":13851,"snapped":21686,"lazily":42174,"bridges":7132,"ē":44285,"pathoschild":37618,"gfw":33952,"swede":19234,"nett":37212,"restores":14783,"carolyn":22307,"apl":36748,"vacated":32990,"budva":38215,"stench":28163,"finest":15520,"esp":5777,"righteous":6921,"0100":49187,"nmate":30556,"snotty":21140,"inconceivable":22076,"czechoslovak":43422,"energies":14220,"bangladeshi":15093,"noticeably":19073,"now":89,"bhaisaab":22015,"sects":10605,"anandgarh":35150,"extending":9508,"glorifying":28777,"hopeseekr":42029,"calculated":8256,"headlines":9428,"76k":44477,"splendid":24533,"incidentally":4120,"nickelback":39730,"phoenix":8971,"'fuck":2861,"rinus":49122,"practical":4116,"ple":45144,"alimony":42101,"sidestep":49132,"stains":31441,"mikka":21092,"predicts":44118,"wardrobe":44583,"scaredy":46152,"infectious":16263,"une":23051,"ripping":20548,"illustrative":12779,"functionary":32123,"philadelphia":6801,"suparco":45118,"indef":5334,"scarf":46058,"grammer":13077,"highway":5885,"profane":15465,"kinu":18531,"direct":1093,"pin":11104,"bloomfield":22648,"pseudoscientific":15527,"nosy":44387,"terse":19641,"paxton":35006,"enormously":30891,"arms":2462,"underprivileged":41141,"moxham":49406,"anyone's":5743,"blpn":12897,"karen":9993,"sean":5122,"india'":39355,"halp":30793,"duchy":15723,"recurrent":32312,"odb":45558,"mi":8046,"rajyaमहाराष्ट्र":33179,"deinonychus":47944,"irresponsibility":41857,"tammy":28216,"ahahahahahahahahahahahahahahahahahahaha":7461,"stardom":40402,"sturm":38397,"announcers":31274,"mestizo":15904,"spokes":39623,"crews":16710,"derailing":30456,"phoning":47006,"2013–14":41776,"encounter":7197,"recaps":36569,"control'":47507,"offhand":21172,"relieved":16268,"envisaged":43733,"pain":2677,"butchering":24992,"uzbekistan":23896,"whole":445,"bake":40260,"bush":1307,"phaedriel":28553,"bounced":36537,"pinkbeast":38028,"inconvenient":11228,"charcoal":32292,"html":932,"consequently":7012,"friedmann":44151,"beleive":8796,"documentary":3844,"tc's":44849,"jennifer":8617,"asquith":42999,"samanids":44100,"linguistic":4021,"cirumstances":39456,"transparency":13329,"our":180," vesey":44374,"funeral":8950,"inu":37891,"riff":21163,"pretentious":13715,"dependence":11843,"sprung":21320,"britifh":38780,"vancouver":7506,"aussies":22056,"sufficient":1763,"haryana":18988,"bloated":13596,"polo":16562,"breggin":41223,"vanbrugh":47015,"enlightening":14330,"mitterrand":18742,"lehrer":25578,"foreknowledge":47992,"watchers":15768,"ido":40890,"imprecision":38970,"engaging":3550,"falsifier":41982,"visionary":39607,"2010w18":34373,"defaults":27667,"norwegian":6609,"cod":19691,"russo":18501,"lst":49282," ":791,"standardizing":48050,"metamaterial":46713,"gdp":7451,"½":38897,"chips":9391,"soprano":30697,"f3":29026,"sais":24761,"'encyclopedia":43623,"meditate":49928,"marathas":24310,"flavour":15456,"microsoft":3944,"provision":10334,"finer":20396,"sutton":22905,"campaignbox":27306,"terpenes":45732,"webhost":29983,"justinian's":39425,"pia":30114,"seminar":19112,"messaged":19482,"densely":42614,"pakis":15176,"blantant":38152,"nickname":4183,"intent":2185,"tiring":16622,"arass":34965,"musical":3079,"uppsok":38941,"murshidabad":38762,"newer":4791,"contributions ·":25827,"bronte":43594,"podge":45089,"friction":12257,"caesarea":27207,"ebionite":46079,"ensures":21864,"orbital":11451,"biographer":14084,"plr":38731,"elude":42780,"daylighting":37933,"huckabee":22355,"wikproject":48551,"et":2276,"reporting":2096,"schilling":49998,"trimble":43998,"genes":7850,"elhaik":37267,"marlborough":49012,"grenadines":39209,"pings":48301,"scribble":12714,"danes":14975,"innuendo":14074,"semetic":13534,"國":36238,"aorangi":49933,"assaults":19368,"larson":19736,"sharif":24595,"infighting":49727,"meanings":4661,"jaxl":41773,"paki":19824,"uncivilised":40617,"neil":7801,"basics":6638,"4meter4":20264,"°°":15559,"m151":37120,"amazon":3356,"gent":46353,"diminishes":20818,"filmographies":43023,"bombing":5622,"biosynthesis":40078,"broached":32147,"reconsider":4212,"yolo":33963,"brothers'":40118,"they’re":17303,"masterson":42583,"contributes":8672,"nomadic":12465,"dastardly":33646,"beforehand":9272,"piano":5011,"devastating":24752,"frontline":25707,"inauguration":26723,"sayyed":34308,"deceptions":39245,"irrationality":20604,"scotsman1745":49488,"dez":25646,"unwashed":33968,"aethelmaer":34217,"existential":27528,"degrassi":27103,"graphs":11663,"me'":17832,"magnetism":21776,"manning":8720,"elm":27986,"camel":16316,"chiro":35740,"triggering":23621,"093":29343,"masses":7176,"3rds":35347,"sinneed":14550,"refocus":32275,"bumps":45310,"commander":5377,"flyer22":15360,"metabolism":39274,"fervent":28662,"spacing":7594,"proxy":3481,"incineration":38263,"satirized":27970,"contender":22877,"apostates":27032,"tape":5646,"crzrussian":40383,"dad":4227,"horse":2906,"zaidi":37670,"emailing":12275,"favourably":36392,"gleaned":20735,"recommendation":7099,"gutting":27184,"attorneys":17717,"nemanjić":47808,"gamest":48189,"uralic":39755,"fecal":26312,"couch":13613,"screen":2515,"repugnant":28249,"hunjan":19525,"ezras":34651,"ну":25297,"bests":35989,"letterman":33615,"reflex":28087,"overtone":33881,"lenght":41628,"richardson":17146,"impala":39024,"incline":37600,"boatman":18056,"adoni":30409,"sins":8937,"enclosed":16319,"undoing":3616,"populace":16851,"silkski":45917,"damnit":28114,"delegation":18119,"porky":35270,"roadside":47522,"hospital":4151,"levavasseur":33226,"comprende":47869,"afoot":32184,"baised":33100,"nuisance":11219,"bigk":42006,"capone":36035,"touche":49626,"gyrofrog":39669,"paul's":10244,"subsumed":25822,"sweeps":15027,"discrepancy":9064,"chilcotin":31662,"herp":49495,"confectionery":42839,"thessaloniki":36222,"haji":40471,"alto":14216,"assembling":28916,"dishonestly":21348,"''''''speaketh":38102,"acquiring":22600,"mccarthyism":42750,"wikipdia":35881,"vaughn":19483,"gale’s":44261,"laziness":12999,"loadee":18370,"aleksander":47758,"tosser":14840,"rembrandt":44585,"intentional":5001,"rankin":36706,"sonora":33481,"distress":11929,"dreamguy":9314,"capisce":45268,"entailed":48127,"wallin":25778,"wiederspahn":44148,"imprisonment":16128,"hassim":46741,"wikidata":17463,"graciously":22913,"munitions":32199,"alexf":34159,"essay":2874,"improvisation":39524,"nonesense":22988,"overkill":11072,"trace":5093,"montenegrin":9636,"crips":22612,"giantsnowman":30023,"nick":3330,"rockstar":25095,"spacetime":27434,"payne":20100,"proof":806,"chapel":11671,"representations":14937,"capitalising":40724,"feces":9644,"alternates":32684,"bertone":38945,"«talk»":12306,"clyde":16125,"supplanted":39929,"parsing":22731,"sufficent":46044,"predicated":34668,"cfif":26932,"judaism":3243,"scientifically":7494,"desires":9526,"undo's":46342,"demographic":8407,"chilling":15623,"egypt's":28853,"gesture":8842,"ie8":44744,"review":385,"daedalus969":5140,"accidently":16279,"weller":13089,"prefixes":13796,"pneis":6164,"detector":20838,"everyting":26648,"establishments":26701,"proven":1807,"psych":16922,"precis":36327,"liechtenstein":20873,"testosterone":19428,"esther":23315,"peace":1802,"trigger":6381,"sociologists":23353,"aggressor":11900,"foolishness":14450,"mainly":2127,"latimer":26996,"mabuska":31914,"iconic":11014,"bryan":8281,"greak":44607,"shitting":17571,"falls":3465,"sparrow":23950,"emulator":31555,"gibraltarians":32159,"bypassed":42021,"inline":3270,"vagina":3672,"woul":39070,"prank":11062,"svenska":31706,"bog":21768,"someguy1221":27876,"lieberman":17767,"spacemanspiff":42242,"►talk":26067,"predicament":42607,"soni":35462,"disbelief":15218,"shockley":49539,"i":7,"sumerian":34957,"nebuchadnezzar":49454,"wyneken":37275,"allen":5940,"ow":21286,"backronym":39111,"pigsonthewing":10897,"jza84's":39751,"neurodevelopmental":43621,"cynthia":22582,"startrek":42007,"defense":2634,"gypsies":19364,"obc":29863,"grandmothers":27141,"balinese":35464,"kraut":37697,"scribd":29000,"scuttling":40374,"erudite":20490,"irreligion":22299,"hoyland":24968,"harassed":5628,"regulating":24609,"pastry":28355,"tagger":36551,"malis":24939,"dxraw":38988,"delistings":49777,"du":6843,"townsend":40304,"kawasaki":25544,"greekish":32897,"uncontructive":45725,"subnational":34597,"summery":22697,"cheer":9344,"slavishly":36717,"amdo":30489,"sterling":12578,"degree":1817,"bicth":21117,"youthful":27517,"johnston":17712,"anyting":44925,"عليكم":41705,"shaun":30804,"tag":247,"¤":18141,"administering":24704,"hammers":20852,"centrist":22863,"blur":13472,"burton":10241,"lucian":37979,"ankhmorpork":45387,"molyneux":31970,"curiosity":6491,"rove":12277,"diameter":11221,"academically":12781,"shitted":39152,"andorra":22869,"bulgari":37799,"rspeer":39151,"superseded":22740,"enacted":11522,"hg":21789,"osbourne":45572,"src":49958,"kronecker":46372,"sit":2801,"enuff":30700,"rumour":9974,"rathlin":43861,"swatjester":10103,"begotten":27444,"momentary":33242,"sonofabitch":36373,"—→talk •":29315,"victor":7995,"congratulate":12355,"replete":21189,"belgrade":15722,"future":583,"composer":7650,"lynched":47312,"disbelieve":25038,"niagara":15913,"generating":10485,"mixtures":33157,"toxins":25733,"capitalize":11356,"rookie":12852,"encompass":12780,"friendlier":25247,"hexane":31592,"rear":10238,"forty":9660,"brigham":31660,"browsing":8890,"ang":12600,"indicted":20344,"tenuous":13564,"ayo":48214,"xoxo":48016,"migraine":22186,"ec":8498,"subscribes":32067,"demeans":40483,"pok":48919,"earler":39631,"cfers":49931,"maroon":23492,"zx":46235,"fisher":13897,"ragnarok":31950,"latour":27788,"alexander":3700,"insulted":4193,"allende":37652,"worldly":26325,"sean's":48386,"psychopathic":30992,"josh":7576,"writer's":12786,"deceptive":9232,"interpersonal":17883,"ame":37672,"parapsychology":14988,"hum":13968,"etc…":46930,"arjo":47664,"evolving":13131,"sweatshirt":47940,"extensive":2869,"dari":21552,"expects":16303,"allan":16810,"↔↔":44094,"story's":35651,"robertissimo":34819,"sword":5904,"ck":5433,"cw":14807,"d1":15968,"ladislav":27174,"chromosome":17331,"louise":12396,"repertory":44016,"westview":45059,"kosher":12941,"absolutdan":46731,"liebman":41144,"backside":26952,"elliott":14716,"cigarettes":14222,"hudson":12420,"outset":15000,"polisario":21218,"'bold":35090,"matereal":22937,"vma":46520,"bak":36177,"►''''''holla":14015,"odin":26923,"pillage":45980,"causality":30632,"lovato":25564,"baber":36721,"frequented":25186,"disguises":47254,"willing":1242,"puppets":3392,"kurukshetra":44225,"clique":8962,"10px":27330,"retracted":13268,"usps":23128,"barbara":9685,"parody":8320,"medicare":28877,"molecule":18441,"aribtrator":44997,"starve":22488,"mugshot":19224,"dundee":49292,"hearted":14052,"yielded":27931,"shits":18913,"—spiff":21530,"massachusetts":7507,"slabs":46191,"osce":34424,"pedant":27795,"parishad":49853,"principality":15975,"distruption":32585,"foley":28050,"hartford":24557,"luthor":43320,"warring":937,"folic":36800,"rig":16100,"carrick":43495,"terma":45050,"airbus":20517,"raised":1615,"yule":30047,"pro's":48799,"mongolians":40340,"rgb":14495,"vogue":14164,"yworo":28445,"karnataka":11080,"fiancee":32308,"skorecki":45389,"pr":3829,"leeds":11253,"reason":200,"hym'any'u":37527,"papacy":33311,"corrupted":10536,"diplomacy":11421,"northbysouthbaranof":40551,"lolololol":25598,"aspects":2198,"chunk":9554,"ring":3509," b":49954,"genealogies":35083,"salted":17360,"annoying":2698,"monitors":11189,"whant":33730,"unbound":38369,"wikinews'":45106,"owners":4740,"bund":41568,"wager":27091,"creditability":46374,"verse":5845,"alcoholics":30932,"carlton":22523,"puharich":28550,"mutandis":46113,"help":115,"phishing":42622,"ginny":47256,"tobymac":45243,"stripper":34213,"teams":2860,"seric2":26103,"jerzy":35272,"prabhupāda":44901,"plese":25847,"saws":40941,"eth":17919,"pepsi":22262,"rest":869,"transplantation":20068,"robertson":12925,"inflamed":49947,"bahai":16664,"privilege":6255,"artciles":28408,"sani":39594,"manson":9497,"blackout":26060,"arabized":47976,"spun":13432,"tick":14110,"bewafai":33101,"“his":32418,"aggrandizement":32751,"'christian'":43348,"primordial":26642,"situation":882,"salts":17944,"participated":4055,"premier":7027,"nz":7433,"turco":43155,"obstinacy":42813,"yakutia":40293,"cordially":14316,"keynes":26270,"feminism":6884,"cutie":34283,"registrations":43384,"dryer":40632,"nudes":36507,"amadou":40731,"concerning":1595,"natures":36643,"zambia":36777,"spellbound":40861,"brennan":29120,"3pm":49116,"wretched":32469,"49th":35810,"☎":5429,"engraving":28039,"npp":25229,"colder":29174,"refurbishment":46257,"maronite":13222,"unionist":15950,"ryde":35691,"knoledge":26737,"archipelago":25755,"gagging":43433,"equator":23946,"dishonesty":7804,"defend":1955,"filipacchi":29101,"reportage":23436,"cookie":5095,"probability":4645,"billie":24973,"solstice":18185,"disheartened":21374,"weasel":3539,"petty":3471,"footnote":3004,"trip":3013,"bear":2629,"ece":38486,"chinky":40181,"wikidrama":32202,"fisherqueen":11290,"survival":9224,"buyers":21784,"continues":2037,"hypocrite":4935,"النقل":28196,"kissinger's":41203,"props":22495,"refernces":15739,"faroe":32970,"saris":43406,"janitors":20189,"corrects":21317,"hts":48330,"avro":22652,"spectacularly":30986,"exposure":6191,"aggiebean":33547,"projects":2062,"unfortunately":1077,"provided":659,"strickland":40047,"senseless":11602,"edict":20906,"slur":7969,"dudley":12071,"montoya":29118,"telescopes":30701,"wikimail":47550,"rusyn":39044,"cary":36322,"writer":1987,"contravene":49509,"colbert":11254,"racing":6544,"toontown":31598,"arbitrage":43554,"vpp":41531,"armanji":36679,"juche":40638,"unimpressive":46003,"localization":38982,"artist":2088,"hmmm":5373,"castles":15148,"reformists":47415,"grierson":22111,"feild":45065,"upsilon":44728,"headbomb":23006,"webcast":43943,"daria":30187,"zinc":10685,"kinda":3519,"uncooperative":16239,"interlink":41617,"actor":3225,"eliphas":31792,"caesar":11903,"contemporary":3036,"nm":17813,"montessori":44541,"heinlein":28755,"speedies":33437,"sped":40156,"stupider":43336,"graft":26902,"gruesome":27165,"forma":34152,"generational":39645,"lecture":5675,"blindness":21605,"“conflict":19719,"monoxide":24985,"credible":2065,"30s":26138,"proton":24465,"010":37820,"hayek":25404,"adaptive":16914,"jon":6273,"wore":8976,"kafka":18470,"hemingway":22896,"nations":2057,"poses":12696,"investigates":28838,"arrangement":8181,"circumcised":14717,"amplify":27868,"gestapo":13929,"dharma":19012,"kai200995":45876,"germany's":13639,"properties":5317,"dyk":2002,"chair":5932,"warranting":29957,"ftl":30977,"tildas":23401,"tenacity":32812,"healing":9521,"tradename":49548,"007":18875,"stipulations":40448,"shay":24456,"radh":21300,"israelites":16393,"akc":17803,"divides":23354,"ahem":12777,"bath":10022,"holders":9400,"rtp":47890,"inordinately":37396,"ladder":18115,"stickler":31566,"booze":36553,"proofing":48505,"giornale":49248,"hatting":30829,"checker":20513,"osirisv":42585,"photosynthesis":45352,"satish":40622,"delong":43771,"localzuk":41967,"benning":37751,"sustainability":12387,"profiling":26176,"activity":2162,"ml":11842,"paraphyletic":41832,"cheventogne":42713,"gap":5969,"gündüz":35007,"recognize":2446,"colignatus":25913,"hoboken":33472,"apartment":8381,"catiline":43786,"macron":42932,"irish":1523,"beethoven's":44746,"coincidences":18305,"loosing":13244,"powell":18735,"cuttings":32311,"fulbright":42299,"obscurity":17714,"novelist":17421,"tcc":36354,"branching":22158,"hre":31326,"romney":2962,"visibility":14829,"trunkarchive":35048,"heal":18075,"meatpuppetry":13093,"“god’s":40248,"writing":525,"rouen":46985,"thrives":41124,"committed":2851,"ko":16228,"observational":23617,"mihaiam":20787,"atp":30086,"tempt":37065,"alliances":16054,"cochrane":15173,"bonding":27897,"dispell":40106,"eretz":32309,"wikipedi":29056,"spicuzza":45498,"humans":3219,"buaidh":42679,"glocc":48964,"leipzig":33049,"parlament":49339,"semantically":26804,"'n":19526,"ohg":46502,"trucks":14604,"barnstar":1108,"druid":30454,"cooling":10326,"conventional":5786,"conductivity":32810,"ripped":11353,"oculi":33004,"msb":47318,"porch":21851,"votes":2075,"harmonica":34764,"sonia":19291,"trusilver":17528,"'intransigent'":48655,"lyric":21157,"shaped":8768,"2u":25781,"hazelnut":18728,"duane":30132,"byzantium":14310,"unusually":14532,"graceland":39038,"baldwin":14160,"suitability":15403,"passable":24874,"sieve":17379,"shock":5888,"ello":32190,"credance":49900,"lutherans":37251,"dl":12374,"eschatology":21954,"bce":6740,"domaintools":26254,"betacommand":8854,"alka":44337,"sannse":8221,"ghandi":25008,"cheetahs":30858,"regionally":43018,"haines":26773,"jihadist":23898,"team":909,"lamar":24544,"'article'":39578,"preserving":9695,"zeal":15790,"taw":43283,"prozac":40050,"tokens":32520,"creatures":7129,"tucker":16903,"chairs":16793,"grindcore":18015,"offends":11691,"hunt":5192,"amman":33867,"permanant":46754,"ogden":48422,"irretrievably":48720,"puncharoo":24735,"frankie":18873,"prove":913,"1k":35894,"hydroelectric":18760,"da":2818,"telescope":14611,"dmoz":11506,"avatar":8777," fan":45404,"apropos":22763,"reload":18280,"goofs":21750,"patiently":13375,"darkcore":38748,"effectiveness":8410,"piped":14033,"loons":41050,"tut":16436,"era":2518,"schneider":19130,"opsens":44230,"gfe":40348,"scientists'":47606,"external":731,"precedes":20624,"xd":7781,"subgenre":19258,"matsumoto":48614,"m1":13874,"guano":47511,"npia":27356,"salim":26092,"atmc":38702,"yak":15986,"belt":5714,"squads":23970,"dishes":15514,"mus":22284,"bleak":32191,"tractor":41244,"propagandize":28236,"pipeline":21683,"megadeth":19971,"devadasi":37659,"adopted":3170,"events":1066,"omsi":43997,"threshold":8012,"areas":1520,"knickers":37262,"replaces":16527,"buenos":20503,"nosing":42776,"harun":41006,"church’s":40691,"remote":6873,"axis":5806,"freeenglishsite":38835,"धर्म":36921,"'cause'":49323,"baliunas":42479,"empty":3733,"contributers":20356,"refrence":20089,"kunihiko":27132,"sami":18232,"motions":14239,"liza":27268,"item":2252,"tamas":33082,"youth":3568,"dhaka":36892,"poison":10375,"begin":1980,"misappropriation":49715,"'you":16801,"thunderbolt":39828,"enlarged":19662,"voegelin":45944,"commits":18017,"morrison":13220,"elkevbo's":31359,"downloadable":23610,"wikiadmins":35770,"blackash":45356,"persist":6110,"flex":24112,"vile":7664,"gum":13479,"becoz":49624,"patience":3640,"whacked":40946,"yuo":22591,"mexico's":35352,"harris":6146,"carbine":34320,"cartagena":30808,"technicalities":17502,"logarithm":42078,"mongo":2404,"eubulides'":46009,"gloating":20952,"boxing":6776,"yad":47174,"christo":49166,"arbitrary":3993,"tapestry":38272,"sticky":16816,"fijian":24300,"rerum":47184,"nestle":42276,"dickwad":23989,"ngo's":34918,"imprecise":20335,"edith":30460,"kuru":13321,"serveral":35640,"glorify":20988,"unworkable":30588,"underlined":18679,"kalju":38167,"abbreviated":14107,"cogent":13739,"player's":13300,"masterka":40381,"il":6390,"bertine":38697,"lonnie":41278,"venue":5880,"imagined":9790,"cubs":23028,"puting":20104,"vilnius":26252,"ral315":39756,"lays":15983,"angering":43459,"neiln":5033,"kobayashi":41132,"nadar":25604,"tcl":40686,"hanoun":41794,"evergreenfir":49054,"morgellons":17173,"eyeballing":47071,"cart":23716,"mortgages":39134,"differentiable":27485,"zig":26436,"namedref":37590,"wondrous":46672,"hoyt":39400,"imformation":36471,"haze":24151,"libel":3402,"o'connor":19153,"wrights":24220,"cmyk":25644,"quantified":36189,"spitfire":22358,"multilicensepd":42745,"rowling":25482,"bounce":18411,"chaplin":25627,"escobar":40611,"handcuffs":36618,"trampled":25670,"thriving":26732,"perpetrated":12083,"ps":1986,"sae":23043,"harlan":21119,"flogging":25539,"malinke":38122,"mania":15673,"fnd":41937,"userboxes":4114,"gmt":6586,"impure":31084,"disuse":32041,"lightbreather":37052,"kremlin":16965,"sniperz11":47087,"grandfather":5453,"becaus":30195,"enquiry":16599,"tiens":43840,"alhazen's":37474,"plight":31320,"whine":8439,"multitude":10123,"rationales":7259,"anyways":2641,"somehting":48798,"''''''thefortyfive":44931,"remotely":5599,"grapple":27651,"conjoined":42602,"softblock":41237,"horn":11480,"hae":28198,"mariachi":42686,"tribe's":43604,"reacted":9525,"aaronsw":48542,"baconfat":49415,"finishing":9127,"branched":21538,"commonalities":33486,"anthrax":26602,"relieve":17414,"immorality":32088,"strong's":25983,"cherrypicking":48985,"oracle":22997,"may's":49527,"stalwart":47707,"posing":10920,"ofcoarse":46848,"orb":27316,"competence":8040,"decomposition":22641,"migrate":18358,"touring":11721,"acheived":23927,"gayest":41629,"excited":7760,"vulnerabilities":46666,"overbearing":25204,"•tabsmiljan":21116,"continously":17661,"prosecutor":16353,"helpless":16133,"curps":9427,"winners":5316,"wesley":13169,"hellen":27105,"lived":2131,"murals":31847,"inspite":29692,"minorsky":29189,"1880s":19767,"teacher's":41114,"tennis":6523,"voorst":40421,"klerk":41154,"editnotices":31622,"mcfly":29244,"slr":39740,"quote":598,"empirically":20815,"ethically":17090,"zula":46901,"thrusting":42692,"bloodied":46034,"responsiveness":45693,"subgenres":23121,"artivist":46399,"ctjf83":30272,"diluted":30352,"elites":31936,"undid":4148,"theri":41378,"propaganda'":34186,"rsl":26770,"deflation":19510,"skala":19461,"unified":7971,"kharkiv":41457,"abducted":23479,"town":1642,"communion":16953,"crusade":6382,"weavers":21008,"comunist":35520,"asia":2430,"sympathizers":22784,"july":849,"humping":36496,"greeting":10045,"conniving":48674,"tim's":32736,"leafs":33596,"personage":25852,"noindex":37507,"reviewers":5704,"specialised":17122,"mah":12017,"leninism":26943,"wikipediaweekly":37004,"messenger":9059,"tall":7214,"thakker":48273,"nerf":48650,"very":101,"swirling":35399,"brewing":19120,"aircraft":2554,"school":480," λόγοςπράξις":25293,"mexican":4432,"presently":5366,"inch":6886,"ganser":48973,"alameda":46263,"shamanism":31438,"adjustable":29922,"dof":29190,"citeable":33694,"gilabrand":30232,"thak":33663,"hobbits":37803,"canopy":38237,"demolition":13213,"solace":20134,"bozmo":26823,"toilet":7583,"categorization":6423,"solon":40110,"dissagree":37960,"dominionism":17965,"creator":2499,"pissed":4322,"newadvent":43724,"samson":27560,"issn":28145,"maiden":9534,"predatory":18210,"hazard":14609,"dissent":7668,"farts":23372,"persuasions":30063,"bismarck":21614,"xm":27939,"manat":23079,"enlarging":43641,"civil":936,"curly":13911,"4he":46129,"westerner":29496,"wye":48106,"accelerate":21476,"elockid":44678,"qrz":37303,"—yes":48545,"mingle":32902,"d2x":37196,"morgellon":43983,"chronicles":8980,"hamsters":47751,"phony":12278,"omnipotent":23068,"handled":4132,"rafiq":46205,"phillip":12753,"mavi":38477,"consitution":31952,"chainsaw":28078,"mohd":44127,"'official'":22063,"forecasting":26986,"excluded":5678,"mccormick":37162,"pharos":38111,"ilk":12122,"mastcell":11560,"'direct":33222,"meticulously":25546,"sarmizegetusa":49713,"approached":9255,"incontrovertible":24879,"whoops":10431,"relinquish":32807,"easily":1149,"montréal":46659,"zindabad":44485,"meh":11883,"dumb":1753,"dithering":36155,"philippines":6333,"chow":27493,"saunders":25294,"4wd":38765,"rcn":28847,"lev":29157,"unorthodox":16757,"archieves":17893,"lap":10622,"māori":38434,"camps":6228,"energetically":49345,"payed":16748,"barber":11641,"denver":10598,"psychohistory":45058,"srivastava":36668,"cph":15952,"elder":9093,"fine":676,"backstabbing":28526,"boil":12456,"hahahaha":9869,"ronaldo":19677,"inadvertently":8925,"merciful":16615,"temperatures":10213,"transformation":9361,"stirling":21628,"solvent":31542,"tank's":32790,"steering":16898,"reckless":9166,"whichever":8846,"vividly":40270,"grove":9910,"eiffel":18047,"badges":17826,"wilyd":39516,"cage":9806,"bandwidth":14523,"embarrassed":10145,"manageable":16610,"frivolous":10207,"doosan":33499,"advertizing":25721,"we":58,"swimming":10135,"damning":17924,"yacc":46425,"pipermail":42766,"weave":33018,"mortally":49976,"skew":16111,"thought":338,"libya":8670,"bletch":44465,"28result":33591,"permanetly":42504,"fenwick":43217,"ironclad":28585,"provied":48762,"messes":12602,"undeleting":20508,"actions":768,"joining":3712,"concrete":5385,"totality":31119,"rich":3417,"certain":681,"genseiryū":42185,"embassies":21139,"kyoto":26320,"swann":45321,"smite":41876,"silva":19086,"unwarrented":37696,"materialism":32838,"toy":8288,"gazi":22140,"indoctrinated":23291,"subvert":23634,"third":772,"softpedia":19766,"douche":3787,"lestrade":22057,"coutry":45067,"cardboard":29640,"seaboard":48847,"neutrals":34545,"hemings":47340,"total":1204,"elbows":37393,"csdwarnbot":48593,"“":9016,"ethnology":47003,"robotic":30071,"comet":20564,"volk":30083,"siu":45822,"pacheco":35355,"curriculum":13494,"paired":22242,"messgae":39291,"python":9489,"validated":13046,"passing":3408,"configuration":10915,"coincides":30835,"resoundingly":44581,"laurence's":47474,"travian":37599,"othercrapexists":40674,"punchline":24896,"tacked":19681,"shyster":41299,"thunderstorm":49299,"savannah":27597,"blue":1548,"either":305,"audie":40351,"buttock":26944,"parents":2029,"“this":18916,"docjames":46999,"priori":16975,"warrior's":49921,"attests":27509,"caressed":39704,"laguna":21815,"defeating":17556,"inference":10511,"shells":13453,"uttar":16497,"justice":2083,"movie's":20638,"auf":20045,"wikipedias":5643,"babs":41049,"polished":18958,"takedowns":35889,"wikipage":13885,"hispanics":11350,"huntley":34904,"princely":21760,"disconnect":21305,"mod":5242,"°talk":23260,"we're":1086,"novice":9716,"nathaniel":20775,"abdullah":16149,"1960's":17735,"winery":39528,"midway":12796,"repress":41848,"crude":10242,"unemployment":11918,"−tabtab":25925,"vicinity":19184,"adresses":23407,"rooms":10672,"≈":20168,"costello":37779,"predominately":26341,"newyorkbrad":30359,"occupiers":30440,"falsify":17372,"wrath":11556,"greens":14252,"torontopolice":27394,"gulfton":48241,"anaiṫnid":49042,"relaxing":31031,"jamesjjames":38482,"071":33820,"whopping":22971,"geeks":10943,"mainz":40456,"chitchat":23306,"coursework":34773,"einstein":4981,"forests":12811,"ouzelwell":14831,"successful":2638,"betacommandbot":22914,"littlemountain5":30909,"criterium":38953,"trapping":39309,"landi":39815,"agarwal":48767,"wikipiedia":39269,"tn":21741,"letterbox":40981,"mommy":11011,"connection":1481,"artifical":47099,"enigma":25816,"userification":44419,"adams":5396,"primeval":34734,"seregain":28151,"deserve":1800,"citevar":30296,"interbreeding":24263,"subjunctive":26730,"breakbeat":31718,"appologise":43761,"seperate":3639,"psychotherapy":19646,"hapless":24464,"deities":10914,"criterion":1712,"monty":13217,"“people":49474,"hows":11101,"falafel":31474,"rec":19421,"bombay":16438,"  talk":17184,"sur":10703,"pita":35863,"calzaghe":19995,"argyle":38423,"fn":18956,"pilot":5655,"appearences":44306,"honest":1601,"djembe":38123,"ramsey":23772,"thugstep":44433,"deceive":12947,"lynne":46228,"darwin's":14358,"epilogue":26031,"stil":19820,"suport":35854,"pounce":28113,"scala":29264,"beers":31223,"devotional":19167,"cloning":18250,"thesaurus":42083,"delink":27170,"chose":2501,"jihad":7712,"wikihounding":11813,"involuntary":24667,"intifada":11587,"chung":37338,"activist":5034,"hydra":29187,"unequivocal":22629,"apex":31123,"bloodshed":22659,"abandoning":17988,"won´t":43637,"unaltered":32350,"troll":1562,"tolerant":14071,"sadr":13282,"discourses":21333,"laborer":45487,"stared":27531,"woodroffe":43877,"harrassed":12040,"midgley":49264,"purity":17945,"redirected":3234,"brianboulton":47155,"am":72,"olbermann":19036,"dunkin'":46499,"disaster":5567,"anni":46289,"elaine":24740,"dent":25196,"priviliges":31234,"releases":3633,"farrakhan":35112,"parentacide":43822,"adu":35680,"willoughby":42651,"monograph":25459,"vows":30863,"confinement":21722,"fluency":30340,"crucified":20870,"classics":9625,"pull":3973,"stupidest":22631,"c":410,"graveyard":32878,"hubbard's":32659,"mistakenly":7264,"reactive":17278,"environments":13153,"enzuru":42434,"journalistic":9480,"yenice":42854,"cactuswriter":49992,"unprecedented":14355,"someday":6263,"khanewal":49993,"biotech":31481,"lifecycle":33842,"familar":29476,"firing":8601,"anf":49468,"pontic":14483,"redundancies":26984,"jenny":17094,"≤":23464,"syllables":18733,"materna":44149,"flavor":11031,"compare":2424,"pups":33338,"trs":39663,"phone":2857,"filmography":9541,"forster":34976,"legally":3904,"punishments":19022,"kumanovo":14851,"pronounciation":17194,"ricardo":13722,"inductance":34704,"thurstan":22230,"ukrainian":3391,"mediaeval":26722,"coded":14764,"bhopal":41653,"minimise":32823,"dissecting":29733,"undocumented":17404,"aqal":24241,"laity":32278,"lt1":49391,"evading":9330,"terrorize":47128,"personalities":7358,"gop":11589,"eat":1006,"geneticist":22772,"picts":23322,"meng":37692,"grilled":39932,"nun":27333,"travel":3658,"sprouse":35100,"rfj":38254,"​​​​​​​​ ​​don't":46958,"litigated":44557,"khazar":29536,"reverend":12817,"ionian":26821,"timers":34493,"inactive":6433,"devotees":12153,"mammals":11324,"smith's":12982,"zionist":4458,"cdr":43535,"prevent":1381,"told":743,"strippers":32055,"telemarketing":41820,"vlach":16973,"crafts":35882,"insiders":17248,"arrived":4596,"probally":32871,"orpheus":34044,"apprentice":19717,"andygreenberg":39465,"critic":5131,"bullets":9217,"opression":40732,"whitewash":8209,"robbers":28997,"problemo":36728,"blamed":9639,"corsican":31766,"niles":26214,"koi":33312,"anyhting":32093,"glc":27297,"deliberations":28902,"hmc":37460,"quirk":40360,"libray":47918,"microfilm":48688,"universities":4330,"dioceses":28346,"nwfp":26463,"deep":2603,"chaff":38231,"understated":26348,"saturn's":49984,"brainwash":26415,"webapp":41823,"obsessions":35402,"mercedes":17992,"turtles":26975,"unity":9234,"jimini":40894,"suite":12908,"soon":712,"geostationary":40533,"trouble":1335,"provoking":12678,"accomplices":40900,"bleeds":46244,"outed":13068,"append":19573,"hunnic":25419,"teeth":6073,"scuderia":38659,"dismissal":10835,"conclusively":14469,"pinged":21048,"bu":9586,"drying":39525,"'fact'":23510,"nps":20140,"aspires":32145,"harshest":48193,"o's":49804,"hahahahaha":14833,"lizards":39678,"el":2440,"roby":42216,"chains":11096,"nothere":47192,"mitsubishi":35129,"frac":34444,"spits":43681,"disallow":25814,"tends":5301,"recuse":13522,"twentieth":12131,"cis":20748,"borders":4816,"p53":47149,"nl33ersi":13788,"commands":10593,"firewalls":40179,"srb":29305,"athough":45339,"interviewing":26627,"victorious":14865,"monsanto":21587,"prussian":11499,"garry":23466,"remorseful":47938,"advanced":3801,"orignal":29934,"novelty":21449,"filler":17725,"implement":5082,"basketball":4751,"guam":45652,"hearty":28656,"eleland":11509,"kinsler":44670,"adiant":26590,"superiority":10629,"wendy":14019,"pang":23112,"1980s":5569,"kshatriya":8674,"researched":4565,"baseball's":49400,"requested":1291,"mameda":45471,"depths":16902,"hanoverian":31969,"10am":43793,"proprietor":41829,"yaduvanshi":46804,"hostile":3826,"simulations":18731,"plzz":47876,"kandy":46142,"noeditsection":31866,"cuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcuntcunti":39136,"bandai":38957,"persib":23014,"giles":22329,"roll":4205,"98dumb":39470,"rosalie":32104,"disneyland":22446,"foxy":37669,"minnesota":6503,"club's":15351,"supplant":33209,"candace":42922,"gypsy":18086,"buspar":12975,"ansi":48295,"tenant":45656,"prso's":31582,"'nazi'":40589,"ser":24814,"soir":44715,"hennessy":40470,"topeka":23031,"lungs":21066,"brushed":21457,"preaching":11595,"by78":30246,"assult":43143,"webcite":29914,"kardashian":47508,"making":272,"cour":39884,"montanabw":19909,"mudaliar":27171,"managers":9200,"approriate":39088,"transmitting":39000,"sew":22022,"samus":47020,"chriso's":22023,"urgently":18851,"uncategorized":22972,"disruption":2487,"jas":42807,"ked":45528,"bizarro":32138,"‎more":39905,"salvation":11909,"cv":8461,"incriminating":21803,"shellfish":30374,"torossian":39576,"taping":37691,"staple":20905,"computers":4078,"b4":11987,"admin":336,"'kingdom":36179,"floodgates":46723,"certian":30625,"olds":10343,"honoured":16168,"amanat":35281,"rapidly":6081,"bebop":27642,"bangs":23973,"paleontologist":30245,"popartpete":37870,"wif":42265,"biologically":15211,"compilers":17296,"oka":47163,"rjii":41883,"hemp":28107,"benzeneformic":44098,"mistook":19735,"microwave":18177,"resources":2175,"epitome":26271,"contemporaries":17262,"accident":3505,"nato":6565,"qualified":3610,"verbatim":6285,"eucharist":15853,"belittling":17997,"riyadh":36171,"ultron":45434,"kt":43401,"comings":38150,"reinforced":15676,"opal":46319,"moravian":37740,"suffolk":23450,"diseases":7586,"warwick":21604,"sentenced":13041,"eine":44573,"epeefleche's":45774,"liek":19908,"roychowdhury":48204,"breaching":10552,"ease":7994,"transnistria":14744,"truths":9028,"bloke":17579,"agi":47348,"24hours":48169,"caliber":14993,"suryaye":42049,"psychical":35320,"roundtable":41065,"angola":16853,"here’s":21709,"useing":29328,"horde":20024,"hypertensive":43222,"parrots":34914,"sunny":16730,"iamandrewrice":40899,"niggertard":27329,"hells":21014,"hir":39710,"person'":32120,"quip":28222,"sealed":15552,"unef":26991,"caldron":37420,"sweepers":43442,"indies":10781,"lewd":40778,"levitate":41591,"dosnt":35736,"allstarecho":41465,"grill":24507,"luster":41964,"unresponsive":46554,"wray":29311,"raf":12865,"pizza":10026,"wannabee":31999,"heru":26158,"mamba":38671,"pork":11986,"pd":5014,"wgkf":18761,"incentives":26719,"brunt":27895,"isenberg":34655,"controllers":21042,"broz":18934,"cooked":13346,"detachment":24869,"earners":45174,"eyebrow":25690,"aku":44214,"kanagawa":30887,"'60s":28210,"holding":3224,"march":924,"fae":38535,"cobber":40770,"supplies":13208,"have":18,"biochemical":44874,"ally":10311,"talkheader":43250,"diaz":23673,"recommended":3820,"antonio":7071,"boycott":11939,"qxb4":48445,"addressed":1724,"narrowed":24267,"suspension":12610,"tonybot":29407,"interchange":20241,"damages":8965,"feynman":20536,"whacking":48464,"n64":32473,"a930913":25105,"tge":47895,"fitting":8126,"pinewood":43470,"hobbs":40801,"appropiate":19515,"gains":6628,"honed":32409,"nagging":21434,"silvio":45959,"gemini":41340,"awol":42283,"rots":14050,"xinjiang":32639,"downloads":12978,"occasion":5798,"reinserting":12881,"vivian":26356,"wwf":11542,"contemptuous":21156,"linguists":10170,"simulate":42523,"gratuitous":11854,"hunches":37536,"pleae":33286,"anglosphere":34257,"runs":3351,"alrighty":38364,"filiqurian":32352,"sectioneer''":17866,"merged":1797,"christie":30729,"flatulence":42949,"linearity":42952,"steve's":34742,"sedition":28239,"brough":42317,"akaoui":49154,"mechanistic":41545,"assocates":38156,"catalogs":48952,"waf":30085,"cooperatively":18896,"justifying":9090,"hamas'":35592,"checkbox":49472,"socratic":40315,"bores":40935,"rebellious":26691,"sampled":22043,"favored":11165,"duplicates":13933,"aldershot":29146,"behaviours":16331,"emails":4844,"translator":9616,"bub":37881,"issacharoff":49130,"lennart":14120,"outsider":11429,"clockwise":27858,"gary":6038,"fostering":31011,"hong":5187,"gendarmerie":38248,"wisconsin":6859,"alchemist":20030,"resorts":21277,"remedied":15564,"lafayette":26920,"rewrited":49697,"mitigate":20853,"nimh":29760,"cousteau":32747,"rearranged":16061,"add":149,"hashing":36104,"bolshevism":26687,"manning's":24826,"iaaasi":43399,"indians":4452,"wink":13644,"cumbey":23759,"mile":6643,"afterward":15122,"katrina":10895,"concomitant":39375,"hideous":15457,"icao":25719,"sneakers":16429,"kao":47413,"freebase":47317,"luigi":21153,"untimely":48197,"usuage":44559,"follows":2343,"montalban":44175,"moments":6940,"miller's":19704,"screenshots":8147,"bisexuality":42791,"destroyers":38192,"facie":18029,"ultrasonics":21809,"diffuse":23239,"cranky":20406,"complexes":24093,"ridicilous":43814,"blacklisting":22995,"lookin'":25172,"juliet":17758,"assent":17289,"lille":39341,"25em":26536,"chopra":14232,"roskam":10924,"heather":14983,"incurred":17521,"dint":36542,"nukeh":40255,"lobbying":11466,"varies":9297,"convict":26201,"modi":13033,"langan":9915,"polygons":47331,"smells":1731,"bananas":18000,"firestorm":34229,"nader":21525,"celled":37711,"shanghai":14505,"geos":48786,"wasp":26340,"romanized":17280,"ethereal":25680,"upfront":17188,"bounded":20445,"alp":22511,"sectioning":27724,"diffrent":16879,"outcrossing":41878,"occurred":2976,"australians":9794,"michael":1570,"trait":11410,"mackintosh":32890,"22nd":13312,"tensors":42973,"imagination":6384,"ta":5964,"dymond":25751,"grob":41565,"newtonian":19440,"agitated":28913,"rayleigh":28764,"pogrom":26462,"helped":2551,"helmand":41148,"mac":5413,"harry":3112,"prolapse":35904,"bungie":32881,"administrators'":3404,"coeliac":44093," • xaяabиam":27433,"incursions":28571,"idiosyncratic":15732,"refinery":26693,"be'er":38361,"rivera":22210,"symbol":3190,"ч":34868,"resorting":9898,"yuber":19447,"husky":38274,"ife":47626,"emptied":34138,"bednarek":24745,"colloquialism":32847,"elegantly":30815,"accusation":2215,"zea":41403,"atkins":25241,"hurl":25348,"will's":35379,"sentence":475,"resurgence":21585,"kosta":45264,"assasinated":41827,"infrequent":30592,"affliation":47434,"entitled":2488,"creators":7640,"tiocfaidh":44985,"blend":12520,"proceeds":14535,"warsaw":10439,"accrue":47837,"sturgeon":24089,"looting":29651,"clerking":31704,"planet":2541,"unexpected":13118,"navigational":12128,"clipping":25575,"uploads":9359,"resigns":35886,"disable":12510,"isbns":24504,"inning":30494,"colored":8215,"chipping":26366,"eliko":42378,"hiccups":47655,"resistivity":43935,"bargit":48300,"nona":35956,"lighthearted":45397,"typography":24727,"¯":24140,"bollyjeff":35068,"serenc":27796,"pickelbarrel":46406,"heb":40371,"vengeance":13589,"incorporation":15448,"xxx":9204,"lurid":33816,"mehta":34647,"beluga":42475,"angr":23971,"cheeky":20833,"'94":31721,"movements":4745,"marshal":18230,"scams":33342,"'any":48131,"diop":32407,"wellington's":41452,"“new":43869,"synonymous":7513,"reuse":13797,"cowardice":25450,"с":22052,"contries":33298,"bootcamp":18837,"ward":8192,"ash":10903,"sexism":14276,"enroll":27932,"adaptability":42077,"'christian":47872,"doublespeak":26134,"appalling":8845,"dumbness":40440,"neal":20962,"hike":19994,"precarious":48855,"khuzaima":14834,"wintour":39436,"gut":12830,"jisc":41948,"'top":36912,"vandalsim":25032,"employers":17204,"marine":4472,"sumac":21918,"hv":27582,"unmasked":30148,"overlapping":13949,"count":1321,"thirteen":12939,"duress":25169,"bearcat":20693,"dyslexia":20645,"oft":14379,"israelism":43630,"breakdowns":21359,"donetsk":19393,"knees":12032,"checking":1347,"ability":1666,"bryn":36143,"purotu":38435,"angelina":22656,"endowment":36585,"exploding":24530,"immature":4752,"illiteracy":28034,"neelix":30899,"faisalabad":43238,"obec":38852,"disappointing":8200,"angelique":30864,"megalopolis":45983,"offspring":11668,"licked":33702,"wallonia":47717,"casualties":5127,"awful":4418,"moratorium":23334,"calculations":9809,"meat":3353,"toolbox":16281,"homosexuality":4011,"retake":27310,"stockport":42994,"rides":14171,"repeater":38492,"booklets":31062,"14c":37103,"efil4tselaer":45888,"revamped":26247,"deserted":31154,"ruy":36233,"onr":34252,"bringit":26481,"gecko":47379,"exclusions":36845,"kiruv":42431,"demonyms":48141,"mismatch":29446,"fulltext":28618,"drzewiecki":38830,"carp":37364,"rendition":21714,"parameters":6139,"robespierre":27366,"ucucha":21583,"inkling":32009,"alternatives":4129,"shipwrecks":46485,"nagasaki":26971,"cleric":42913,"renewal":22850,"deceived":18923,"kaiju":44164,"relevence":45138,"commenter":25799,"depicting":9999,"gnosticism":25051,"explicity":27522,"nipple":1326,"uri":22071,"evenhandedness":44825,"vaginas":20254,"decadal":43351,"simms":40684,"acquired":7425,"02":1648,"lands":5335,"humming":47526,"entomology":43210,"evasive":20271,"liturgy":19241,"fruitless":15741,"caregivers":36694,"stakeholders":28976,"asteroids":18408,"cheri":34434,"dogwood":34207,"estadunidense":45013,"sugest":39059,"bengal":9203,"ahhhh":26947,"arr":49584,"nostrils":38959,"dubrovnik":13842,"pb":33241,"idries":42374,"befitting":30406,"extermination":20510,"suv":30465,"operation":2392,"brigitte":36741,"examination":6332,"corpsefucking":39501,"chatham":19110,"beams":26763,"yen":25150,"humorous":8638,"parts":1319,"attainder":22737,"biopsy":27046,"candidate":2636,"operator":7746,"circum":39839,"roti":24291,"complaining":3749,"renewed":11868,"adsense":33721,"straight":1574,"dealing":1848,"hamza":37223,"diagram":6007,"hyperion":39966,"professor's":30931,"ecoles":43435,"fullest":28497,"protagonists":24326,"sandpit":36015,"erp":23397,"electrostatic":33077,"mutiny":21941,"alpa":33195,"—a":46124,"piketty":37565,"visualeditor":21200,"trudgill":36826,"sanctimonious":18183,"adequately":5918,"transsexuals":30235,"pauline":12047,"willies":47855,"hidiyaat":49447,"chara":46213,"german":801,"wth":19848,"sway":10714,"reals":25851,"defendants":14879,"comprises":16959,"lhasa":32505,"reallycan":32664,"masculine":14192,"toland":39811,"mohamed":19449,"brainless":17349,"pleasantly":29519,"users":343,"business":969,"robot":5898,"acuse":32721,"recite":22067,"3rv":40238,"renominate":27408,"ministers":8621,"feather":15238,"appreciation":6878,"smirk":47086,"aspberger":29283,"literalist":27591,"admi":13266,"innaccuracy":48860,"passage":3019,"interlaced":28966,"coupled":2331,"supermodels":49143,"palpatine":16545,"annexing":45291,"vist":40744,"guilt":5623,"erased":4189,"conversations":6432,"asgardian":34095,"rife":16835,"grazie":36612,"timing":7863,"farms":12091,"ultramarine":35600,"catid":39404,"immigrant":7726,"smarty":44413,"'rule'":31688,"parentheses":9684,"tolerate":5706,"baines":36212,"reconciling":44265,"tire":14669,"afd'd":28599,"requisite":17076,"ruined":7350,"banach":43531,"corey":22598,"tokyo":8739,"archiveurl":31087,"apa":14805,"eligibility":14686,"halal":45807,"recollection":13976,"nehrams":46403,"affords":38342,"passover":39225,"penguin":11719,"hephthalites":38634,"mimansa":34775,"krishna":10004,"worth":1022,"stevonmfl":47886,"rhaworth":15656,"rock":1336,"mags":26796,"bono":18639,"alleviate":17230,"risks":9134,"reasoned":6600,"abhor":27128,"ants":13726,"men’s":34585,"clipped":28075,"tinyurl":19362,"hedge":19247,"mgm":25073,"reminder":5180,"intestine":33254,"kook":16106,"postage":22291,"chrishatch1973":42377,"crossrail":48647,"ford":6289,"restrict":7644,"doves":34363,"lunch":10358,"cleansing":7294,"soil":8188,"sascha":35866,"nikita":28361,"clawx":41616,"habs":38302,"bandit":30220,"bulletin":11382,"buys":18534,"tunnel":9185,"howling":23712,"vigorously":15146,"haas":49262,"memorized":48149,"championships":8319,"cantonese":8272,"norwegians":19090,"ν":44287,"retirement":6896,"predictive":32746,"transmits":32616,"atta":30825,"reinforce":16487,"fran":29742,"ada":19302,"acs":15426,"poised":30179,"mermaid":18285,"marge":25317,"terra":15292,"prost":38646,"collisions":31079,"innacuracies":29921,"obamacare":20719,"employing":14915,"trading":6976,"area's":46556,"satori":41755,"genera":14659,"begged":19093,"appellations":30938,"trilobite":42232,"hyperactive":35005,"inculcate":48463,"packard":25134,"cussing":21259,"mirroring":29831,"cum":6463,"1s":32264,"girlfriend":5584,"babur":29040,"ashore":41163,"overtly":11879,"maharashtra":20025,"bulbs":35205,"juro":48716,"blinders":35602,"taira":37942,"raptors":25515,"d'azur":44544,"obey":10316,"zwarte":38424,"suro":11500,"putting":1035,"circumventing":32073,"totoro":18709,"overseas":7864,"equalled":39447,"blandly":45663,"afresh":44099,"descriptor":21794,"vartan":40000,"quartered":32376,"agree":264,"gatherer":30457,"desat":49838,"yong":40113,"healthier":28794,"gaiden":39324,"vigilance":20164,"¿":14149,"intersting":33818,"masquerading":16807,"cay":46964,"'mixed":35809,"chant":23262,"luton":28813,"dyukov":41020,"runny":40362,"senator":6137,"resourceful":27224,"freeways":32637,"ghirlandajo":29323,"center":1588,"producing":5877,"analyzed":13126,"ledoux":38007,"interwar":42422,"marino":11317,"clements":29539,"compound":6866,"respects":7818,"thompson's":46583,"distinguishable":28716,"frau":34448,"dg":20907,"power":581,"penultimate":39211,"reception":3498,"burck":36412,"'''support'''":23541,"cinema":6347,"goes":811,"cataluña":43712,"pike":22171,"searchable":26835,"chronologies":33021,"receptive":21446,"manually":6047,"yesterday's":19272,"many":131,"shears":26089,"7d":21734,"bk":19417,"alouf":49156,"consider":391,"polish":1685,"thanks":94,"garcia":13524,"metre":16767,"clone":10130,"evanescence":19765,"hubble":20535,"mccully":42557,"omnibus":26978,"csds":33156,"misdeeds":30705,"diploma":14431,"grail":17932,"dice":17629,"prioritized":36042,"conservatively":35521,"gardener":36915,"eastlake":43695,"scylla":14142,"hardly":1695,"disciples":12163,"tips":2773,"warm":6389,"concentration":7566,"ramones":12041,"outfielder":23909,"coon's":43866,"replace":1509,"txc3j0n":48923,"hallways":44867,"dc43":32581,"morph":25811,"leeway":15662,"gutfeld":35321,"nuff":30033,"buzz":9786,"topped":26646,"harrisburg":48529,"employs":16181,"online":904,"unconsciousness":47005,"apocalyptic":22222,"filat":48061,"whiston":46278,"tx":8556,"gluten":48488,"irishlass":37317,"however":190,"singers":7161,"esoglou's":32200,"saga":9705,"sanshonest":41744,"sonee":22845,"links'":46362,"mangum":22237,"グレン":32043,"cumberland":24841,"hygiene":15617,"cyprus":3556,"primordiality":22012,"laypeople":35252,"skate":33182,"referendum":10114,"surrealist":18273,"pharmacy":19313,"polio":19391,"stummfilm":47101,"retorts":29637,"walmarts":42165,"console":9604,"wicked":9244,"ajax":17519,"hallmark":14699,"lena":20632,"energetic":20649,"players":2000,"sueing":34778,"mandæans":38739,"jasenovac":27161,"cla68":28275,"concede":6594,"client's":35242,"tijuana":42020,"majin":31018,"regardless":1420,"refactor":11956,"geonotice":42043,"kdkatpir2":30282,"undefeated":23351,"barlow's":41123,"historysubmit":17209,"hes":5796,"ragib":19188,"ent":13759,"'''''g":24280,"justanother":21526,"climatologist":46764,"saturday":4295,"remind":3340,"“national":40240,"vacuum":7201,"o'reilly":10564,"discordia":27035,"lift":5549,"thereto":29161,"designers":11358,"slayer":23264,"gayreek":27383,"oleg":34053,"rotor":28339,"pictures":981,"pashto":12147,"oceania":15140,"eminent":10689,"parole":12846,"alerting":14517,"mehmed":17021,"series'":20308,"emeritus":17859,"caucuses":27685,"knw":36453,"functional":7871,"acorah":40646,"unecessary":21737,"cgi":8303,"convenience":7779,"curve":8436,"supercar":23670,"doesnt":2814,"mdot":47046,"børk":48328,"placenta":41869,"habeas":20950,"aren":31319,"hsoit":19455,"collision":11780,"rohan":39629,"maxima":35638,"shoots":19787,"spartucused":16481,"squid":32077,"sengunthar":31383,"zealous":12957,"reusing":40920,"delete":309,"denni":47038,"astronauts":18828,"bathwater":32205,"realities":15802,"crossings":23987,"buffer":17651,"dcm":35836,"administratorship":34288,"islamist":8159,"surreal":16705,"byte":18855,"walked":9379,"squiddy":49544,"microbrewery":40615,"battleships":23373,"godane":24015,"amsterdam":14697,"paper's":24122,"repect":39691,"sor":43126,"periyar":41581,"host":3406,"opinon":24118,"camden":35210,"moderator":5067,"yrs":13894,"comment":202,"aar":43285,"corroborate":18067,"millar":42680,"anyone":255,"vu":17985,"projecting":24261,"unclear":2189,"vertebrate":34861,"roskilde":44056,"les":7553,"thrilling":44327,"fungi":26044,"chogyal":45048,"branch":4084,"bigotry":7602,"fully":1230,"dortmund":42564,"garbage":3216,"redefine":23502,"soros":28438,"fought":3489,"hve":33908,"nesting":37224,"leopard":14757,"oversee":27612,"comcast":19874,"wintersun":45595,"neilson":24004,"educate":6124,"ballad":22803,"surfaces":12795,"dross":29771,"guiding":11857,"emancipation":21845,"copied":1749,"bright":6196,"atlético":31825,"overt":14729,"brethren":10632,"charmed":16369,"another":184,"weev":35663,"file'":36024,"painter":13237,"x64":21238,"chữ":48138,"“alternative":49562,"tatiana":38373,"proofs":7529,"ooooh":21176,"frequentist":47048,"sevco":32236,"marketable":28524,"rushed":12181,"adultery":19327,"safavids":12266,"kher's":33417,"straightening":40355,"eternity":10730,"ufo's":46193,"bryce":21650,"rpp":18603,"rascist":35385,"ssb":18009,"uncover":20588,"breathtaking":45766,"centos":39092,"chit":16202,"corensearchbot":24334,"wisest":32432,"jsmith":38687,"foreground":34961,"unpopulated":46697,"kaganovich":20206,"phased":23641,"cnn's":27340,"publicise":29992,"leighton":31944,"classes":3882,"domer48":24083,"sofa":21456,"'o":36863,"preference":3797,"beech":38660,"latterly":39050,"kursk":13837,"pinned":24399,"rightly":6068,"alma":12818,"probing":44561,"install":8886,"serious":872,"investors":15647,"smaller":2891,"yell":12376,"fmt":47447,"pedigree":14724,"tangentially":20294,"rubaiyat":44181,"francia":37604,"vicente":39991,"demand":2685,"hellenic":18685,"borrows":40320,"kickboxing":18103,"viewable":14662,"compensated":18162,"afd2":47127,"rhineland":44499,"tiberias":44892,"comin":36257,"tal":19002,"jip":36760,"undecided":20411,"wedlock":31286,"britishers":47047,"journals":3527,"overtake":29675,"debunks":46704,"superhead":42512,"presentations":11888,"fm":6852,"nad":19959,"defecation":21703,"pashtu":33368,"screamo":23986,"zero's":46515,"camptown":30639,"halibutt":35737,"knower":49327,"censorship":1852,"ejaculation":22712,"haven't":690,"mmmmm":30927,"giveaway":26854,"kurt":6353,"reading":592,"teachers":5178,"stiff":16578,"franksanello":26983,"divisional":49744,"uninformative":29235,"pawns":33460,"metal's":48084,"hamburg":20306,"quackery":15825,"protesters":10865,"wikilings":22985,"opponent's":23284,"socalled":44344,"horizontally":21572," tc":33790,"bonds":9589,"yes":312,"import":8875,"jenn":28646,"ind":38453,"bowlby":41303,"crufty":34231,"poopy":47090,"adversary":17307,"travels":9776,"defected":36167,"levounion":31848,"taekkyeon":31515,"anthropologist":16031,"writs":30895,"oik":48347,"initiation":9907,"chand":9709,"protestant":5071,"gagged":33146,"idf":6806,"fa":2008,"apes":14304,"benjiboi":15879,"sicilians":30953,"verges":45898,"neocatechumenal":33075,"glbt":47650,"soundbite":49822,"transitive":20224,"frontpage":25374,"worldview":13412,"foucault's":33703,"mark's":26593,"mirror":4621,"youy":47104,"nam":10263,"lighted":34895,"shield":7824,"caricature":17168,"dota":38839,"forcefully":17176,"furnishings":48669,"stock":4518,"sooner":4434,"edwards":8848,"secretaries":35491,"pal":5970,"imre":47235,"scientism":48482,"35mm":46400,"iq":4032,"colloquially":20554,"''''''頭":42790,"dispersal":28487,"malusia":13227,"gastroenterology":49100,"dividend":33612,"noted":1162,"burglary":33976,"osteopathic":41671,"nąz1":45870,"employee's":47917,"brussels":15248,"dullard":46827,"catering":22758,"darlington":35653,"mignini":32675,"slade":38914,"edgy":34944,"footy":13925,"thrax":40986,"pless":43968,"americanism":12601,"gamsakhurdia":29774,"chiropractic":5406,"aspect":2719,"neoliberal":33218,"arch":9474,"identity":1764,"motives":3838,"howland":12872,"spearheaded":44488,"feat":13410,"cached":19615,"'make":33140,"joints":23216,"paraphrasing":7109,"merlin":26933,"mix":4346,"craxy":45090,"magath":45841,"sollog":22539,"karel":17956,"verified":1953,"tosa":15508,"conceded":14760,"netto":32725,"tale":6741,"shaking":23564,"wll":35465,"'history'":19007,"traceroute":18125,"ton":6689,"kash":32682,"consumption":8254,"mmmmmmbo":47467,"earths":33665,"hadith":8770,"ferromagnetic":46077,"admission":6505,"argyll":45750,"staunch":22827,"josh3580":49396,"qua":40953,"scources":44536,"moreso":14390,"adjacent":12837,"lemur":37419,"analysis'":47187,"sith":16552,"solid":1165,"theres":5208,"lives":1879,"dykdate":49843,"authorization":13798,"infecting":39858,"matt":3615,"recur":34509,"chastity":41062,"nithyananda":46821,"awfull":48191,"cylindrical":36546,"clutter":7179,"usd":11905,"burried":46801,"wayback":21440,"llc":11361,"locus":25265,"centripetal":17508,"vagueness":24426,"jets":11764,"rao":9465,"despite":1123,"skinheads":32085,"pows":17902,"leveled":16840,"frickative":34004,"preoccupied":21636,"romano":23715,"gryffindor":33569,"deletes":4783,"appalled":15976,"ö":31921,"opinion ":35414,"sieg":26126,"revenue":6610,"eighties":32734,"stiki":20611,"berndd":41245,"chomsky's":43655,"robbed":14360,"elections":3032,"naughton's":42266,"rose":4352,"2channel":43710,"shortcut":10273,"compliance":4303,"nh":23744,"mysteriously":17818,"avignon":29915,"csm":36860,"defaulted":38276,"powered":11107,"hundreds":2184,"durable":37780,"paleo":27648,"astonishment":47690,"gobbledy":37958,"qualify":2712,"kleargear":13763,"pursuits":25880,"berliner":44571,"bw":20883,"stoped":33907,"mice":9823,"clock":6059,"star's":41337,"midland":26790,"libertarianism":7869,"kenyon":41200,"creator's":8301,"internationals":29095,"milligan":46837,"sourceid":30353,"a2":10962,"wiggum":45637,"ize":46295,"subsidies":19756,"fellas":19729,"gustav":15999,"maya":10918,"liable":8973,"unyielding":36811,"franciscan":22294,"preexisting":43134,"duplication":8191,"calmly":12845,"stereotypes":9221,"phenomenon":4104,"landmarks":16897,"traditions":4884,"wishful":18493,"dupe":36831,"caro":40872,"238px":30401,"usmc":19749,"den":11704,"recognized":2283,"resting":15818,"distinguishing":11016,"ned":12060,"unethically":35771,"thw":29621,"belgaum":48599,"pre":1999,"wikitext":37093,"eaton":43718,"rae":16465,"assad":2245,"britain":2433,"receivers":26353,"semantic":9746,"vulnerable":10331,"jones":3153,"unaccredited":21881,"shepard":24340,"italians":7460,"nawlins":34527,"wordnet":48220,"personalised":41463,"parens":32419,"inward":17686,"schlafly":12205,"schroeder":24278,"aol":5081,"guru":4171,"paradise":12190,"ordo":36153,"cryptography":32888,"calamba":46176,"dragged":9943,"busby":19626,"hear":1226,"book'":48049,"sante":12243,"deterministic":30507,"puyo":47556,"shall":1002,"tailored":18863,"4px":27097,"transmission":9785,"winger":29824,"meantime":3453,"wpmilhist":40292,"spoil":15312,"fta":40767,"telenet":39859,"seekers":22580,"click":1386,"grumpy":13764,"rehman":38306,"conscientious":28449,"gambling":11897,"gorf":44483,"deadly":9546,"iliad":30395,"musicians":5005,"examining":10654,"boogie":18732,"ultimatum":20424,"bicycle":10746,"fundraiser":18986,"redundantly":46270,"cladism":35034,"bravesfan2006":35824,"disclosed":15196,"conductor":13428,"coprolalia":48959,"steadman":41507,"mpeg":31206,"nicholson":20351,"20japanese":47568,"reluctantly":20955,"residence":7151,"bolsters":49732,"pillai":40513,"barret":34518,"moon":3661,"party's":11661,"sundostund":43263,"rlevse":12221,"constrained":18222,"impacts":12089,"remixed":43573,"viability":26909,"24th":12863,"neoplatonism":42836,"lashkar":42345,"misjudgment":35879,"urbina's":42637,"franck":48961,"gollin":28410,"reminded":7067,"negotiations":11073,"supoporter":44998,"infraction":18845,"citzenship":37133,"declassified":22088,"filth":10501,"'''oppose'''":23542,"odinga":34889,"devolution":37006,"h1n1":35644,"rowe":33356,"dunning":41010,"weakling":43787,"deteriorate":37035,"vectors":15555,"mushrooms":25634,"triton":28873,"mmm":15482,"barest":44990,"walnut":44315,"flopped":44793,"absoutely":34854,"infinitesimal":18778,"identification":6219,"interwoven":43546,"maxx":49448,"dislike":3812,"impersonator":14855,"kidd":27998,"mede":34506,"sentances":29530,"kiddie":20348,"specimen":16172,"damned":6720,"eighty":31917,"sidewalk":29166,"comitted":28000,"vassyana":36323,"spin":3824,"warthog":44676,"3d":6620,"boooom":24008,"comedic":19209,"médical":45955,"battlestar":18366,"yeas":47380,"mccartney":14923,"nationmaster":41307,"homicide":15928,"tvs":27559,"molestation":20482,"eyewitnesses":12727,"ghosts":13372,"ministries":16413,"decreed":35817,"27th":13113,"leonidas":42987,"cooks":24485,"aliyah":38447,"2c":5749,"nikumaroro":13497,"desu":36476,"builds":17673,"hops":31230,"regimes":10154,"saedon":43182,"hannan's":47772,"supplying":18619,"cellpadding":2505,"₪—":20257,"shoudn't":37302,"rcanderlori":37475,"porcupine":40328,"adapter":46715,"supremacy":10246,"propaganda":1184,"fraught":27019,"cousins":8735,"cames":39936,"xenocidic":48791,"mislabed":45044,"mudkips":49709,"fahrenheit":24564,"community's":11090,"corticopia":49266,"moroccan":13245,"professionalism":21444,"frustration":5128,"misdirected":27113,"moreno":31300,"censuses":18279,"figurehead":37074,"thesprotia":22976,"harmonizer":41716,"often":658,"gamesmanship":38305,"buckets":36135,"gsm":27475,"communicate":3561,"climate":2932,"wikifan":33196,"compose":12343,"ydna":35914,"unusable":18797,"muscular":27089,"maxtor":44139,"imperialist":14051,"ee6a":38551,"whomever":12603,"strength":4395,"bam":16514,"misfits":44652,"proficient":18879,"othello":32576,"clarendon":28160,"blip":28660,"jew":742,"blossom":16456,"baden":19686,"routes":7936,"controvery":25468,"sugar":7224,"patna":43180,"phases":11433,"parent":4580,"cur":6724,"skillful":48256,"dla":20261,"setups":41717,"hebrews":18082,"collating":37136,"liberalism":7784,"better":204,"seha":47178,"kamensky":37082,"billj":8222,"lexis":31832,"armors":30479,"reassurance":32976,"punctuation":6240,"thongs":41087,"mais":32668,"extremism":12133,"england'":47583,"daan":36457,"steeply":40401,"wedding":7894,"sortable":15513,"tether":13506,"seasons":5310,"backing":5154,"shining":13095,"ein":18877,"rotary":19319," ™":41512,"armagh":28070,"catalyzed":47607,"remnants":14403,"mondays":41588,"éireann":24322,"terrorists":2714,"bosworth":34570,"indented":17044,"aged":9081,"discs":15967,"frustrating":5031,"faiths":14721,"smoked":20654,"bleeding":12449,"sees":3931,"logging":3638,"marion":15917,"taksim":44948,"whould":24506,"tnxman307":26785,"hab":45709,"offend":5402,"wonder":1203,"aftermath":7292,"scanned":9170,"yhwh":27649,"maintaing":48744,"weirdly":46777,"josef":13561,"silverdale":42897,"gordy":47194,"paramilitary":15533,"orangemarlin":16096,"requires":1661,"obliterated":32644,"chuan":43707,"pacific":4119,"crunchyroll":43374,"kuomintang":25551,"chronological":6688,"transjordan":31869,"salud":45843,"catching":7152,"compromised":7902,"parallel":4965,"preemptive":19927,"ammount":22559,"judith":16138,"aaaaa":47753,"berkowitz":35152,"avgn":44189,"economistbr":49427,"oss":13392,"desinicization":35746,"pedestal":20385,"𒁳":11634,"delirium":39582,"'king":34736,"errol":43361,"mucked":26378,"devotion":13363,"mall":7503,"saps":48594,"bg":12655,"buro":47506,"hunting":6679,"didn":19829,"mitchell":9718,"unproved":37301,"rebellions":22959,"biologists":12431,"harpercollins":31323,"festering":24568,"'outed'":49103,"section":123,"displayed":3503,"peppered":23640,"confine":16755,"khorshid":49616,"falun":8130,"works":776,"plank":12446,"selassie":29895,"allegory":23120,"computations":49533,"lads":32619,"summing":41918,"biw":17780,"occitan":39559,"sulfate":30948,"newzionshilohs":28578,"replied":2418,"moria":35409,"wasilla":27345,"literalism":41944,"wear":4297,"taran":26129,"wikipeia":41640,"facilitates":49505,"clashed":32885,"subsets":21787,"astute":24454,"'fuck'":28180,"oedipus":39659,"disproving":18829,"legendary":9653,"elisabeth":20381,"blooming":36851,"dyn":22592,"mississippi":10344,"bondeson":34412,"drc":49675,"fro":16714,"emphatically":23921,"torch":17799,"justin's":36702,"weblink":26162,"shooters":22668,"centering":30905,"dqa1":27401,"par":5939,"songo":39265,"rachel":8078,"algorithm":6840,"zerg":29337,"tricky":7228,"ideas—for":45038,"bard":16351,"lucic":39371,"pans":18011,"routing":19142,"galleria":35907,"qualifies":4071,"counting":4874,"hemoglobin":34107,"disagreement":3484,"shaping":11856,"dux's":23988,"inexcusable":19186,"sthenelaos":43532,"homelands":39718,"emily":11605,"shrew":37543,"template":365,"nous":34199,"desmond":15935,"obtained":3440,"marquis":43278,"resetting":28529,"acronym":7493,"bobo":43859,"concentrate":6376,"aquaman":26787,"reaching":4970,"gentleman's":42515,"partizan":35177,"horace":27238,"nas":19567,"wtc":4149,"handshake":49648,"ostn":40144,"croatians":38386,"setback":42073,"cram":20268,"pemberton":34535,"encyclopedists":47870,"microsoft's":32646,"hamburger":34048,"ghouta":20181,"behavioural":17107,"samaria":16434,"siegenthaler":49911,"rossio":42720,"cyan":45889,"waivers":45751,"johannes":19700,"paragroup":42962,"obssessed":42743,"guerre":32773,"cooker":49322,"dictum":37686,"redflag":38559,"btng":15208,"boutwell":44385,"proverbs":21326,"thandi":32949,"contemplated":28722,"hastol":38886,"baculum":47422,"detroit's":29696,"stabbed":16619,"defraud":38727,"linguistically":20505,"purported":9103,"remix":12011,"conspiracy":1752,"shef":16769,"aramean":16985,"janjua":15569,"rnc":38075,"mono":23585,"rednecks":28103,"lethbridge":35833,"vent":16649,"ki":10475,"influence":1845,"scorecards":27182,"rrie":47329,"overlord":28256,"leery":46688,"unexpectedly":27778,"socialistwar":38514,"hijo":39600,"why'd":17159,"orthodoxy":11132,"meaghan":45143,"twp":49674,"painting":4878,"maharaj":25011,"elgin":29021,"scares":25903,"slapped":10403,"prophesy":34896,"♫♫give":37376,"gov":2731,"satchel":43713,"crushing":25862,"author's":6300,"enshrined":25509,"florian":35976,"avila":34708,"arboretum":46595,"bertie":41907,"headache":11514,"24hrs":46797,"chopin":13750,"olin":46690,"b":601,"cvu":21388,"saami":24096,"conceding":19134,"instruments":8610,"bloomex":49980,"robberies":28859,"triv":43343,"irak":46375,"smush":46703,"irani":34933,"isaf":43234,"commodity":20741,"'correct'":27686,"kd":17906,"reciting":36654,"ste":34492,"doubts":5235,"dect":34951,"shading":41625,"conformation":37893,"cuchullian":31722,"supervisor":16093,"confessed":12261,"subset":7713,"popping":11215,"compact":13207,"assess":6177,"yajurveda":23054,"prodigy":33455,"hadas":39693,"commiting":31957,"infractions":19586,"king":1133,"moviefan":31726,"counterclockwise":31443,"epokolo":44263,"voice":1856,"pinky":38992,"multidimensional":33244,"aquiline":43579,"ren":18147,"confederation":14388,"malleus":6949,"sister's":20235,"normalcy":30105,"sol":11159,"youtuber":38626,"phallic":35459,"clutching":32723,"loanwords":23884,"multiplying":24833,"markstreet":46417,"the welshbuzzard":47026,"deliso":26004,"louisville":11598,"critisizing":45505,"crockett":49372,"macao":43602,"pna":43591,"adrift":15501,"thoroughly":3932,"plotting":22235,"bloodless":30097,"beckon":45859,"arithmetic":12849,"system's":41815,"guaranteed":11477,"model's":44490,"ua":18002,"later":513,"awesomeness":49823,"tagging":1609,"initiator":27566,"bazooka":35057,"pickles":41495,"showed":2305,"tonic":40492,"mongolic":34200,"fgw":31639,"foundations":7369,"slanting":34995,"morphological":22867,"custody":13317,"saladin":46434,"allmovie":30215,"buckinghamshire":35811,"obtain":5161,"jurassic":24312,"floating":8852,"legacy":4599,"giggles":39856,"sources":109,"pies":27133,"adjust":8164,"abtract":21992,"gargantuan":47221,"motive":6206,"toriyama":33404,"phoebe":18317,"ngos":19794,"vh1":13983,"deviations":25283,"grievance":15972,"undertaken":11203,"sulfur":28810,"hanna":30544,"c ":41596,"rejoin":27159,"mgs4":37677,"fiefdom":40142,"damac's":36993,"nehru":26426,"citet":39316,"suffrage":30112,"blogging":13745,"suggestion":1213,"drumming":22250,"alexandria":14218,"nonito":49083,"doesn’t":6757,"longstanding":11807,"gallons":21260,"sharukh":42312,"crusades":13127,"amoebas":39768,"wha":9364,"favorites":16252,"oceansplash":41313,"catalin":46928,"limbaugh":11064,"skank":31624,"arvn":38030,"talkcontributions":17794,"ncpa":38863,"injustice":7519,"relation":2425,"eliminates":13136,"medi":47001,"eminem's":40865,"tak":39611,"looping":45413,"consensus":306,"senior":3851,"warn":2841,"anecdote":12729,"segue":43045,"humanitarian":10786,"lenticular":45662,"ahhh":17326,"amphetamine":27140,"footprint":25160,"stipulated":19962,"abo":29597,"dependent":7511,"devon":21844,"comodo":38394,"3a":13303,"shocking":8084,"centauri":21849,"cuss":29520,"vascular":24173,"ofshalott":19835,"varsovian":16782,"orginally":20518,"promoter":14145,"lastest":30971,"asterisks":45247,"janjuas":23026,"accuses":8158,"sura":26094,"microevolution":38466,"multiplies":31816,"hometown":13691,"boutique":38413,"dicuss":35223,"presides":28255,"kvenland":34375,"upenn":31780,"aero":27276,"tricked":17035,"mjpresson":17707,"attitude":1788,"linger":21381,"maltese":12023,"keele":48477,"annatar":42219,"innate":17358,"ulrich":30031,"fhips":38779,"appetite":22198,"geforce":31106,"discord":26040,"kolisevski":23122,"lanier":48911,"ophiuchus":26887,"spooks":46006,"manchus":19676,"constructions":15794,"speck":33571,"freiteg":31264,"'warnings'":42369,"esc":16638,"ashkenazim":26999,"talk•contribs":11844,"output":6192,"hs2":49699,"marr":38015,"petulant":22132,"habitually":30965,"comprising":15215,"beliefs":2084,"unwarranted":5388,"milstein":49964,"rethink":12090,"displace":37442,"deleteing":17936,"rnb":43858,"medalist":41978,"breather":29506,"subscription":12251,"caragounis":43817,"unsalvageably":8113,"tracer":43961,"vega":19103,"biblical":5359,"unscrupulous":22126,"brute":14848,"dreadful":13546,"consistence":44390,"inspire":12773,"josif":47064,"substantiation":17100,"earnestly":43464,"ans":11727,"chanute":38831,"adverse":10148,"saska":34827,"unbelievable":7564,"sale":5953,"messy":7774,"upset":2721,"vance":17416,"gist":11619,"vikipedia":47437,"sweat":11444,"shocked":5829,"divorcing":35067,"spawn":21631,"jms":41326,"owner's":20666,"gloss":14563,"ingredients":12391,"stearns":27328,"frankness":41492,"quill":32003,"contribs •":15785,"overhead":18799,"'informer'":40301,"cyborg":23803,"trains":5827,"nailing":39711,"inca":41434,"wanderer":33399,"guangzhouese":38325,"conditioning":31105,"blended":28055,"erasure":42759,"mapping":14610,"unbelieveable":32555,"'neutral":48154,"ordnance":22048,"assyrianism":43898,"deposit":19360,"replaced":1660,"wahabis":34128,"envoy":28601,"purporting":25177,"autonomy":10940,"badoglio's":45442,"inverse":19862,"vw":41658,"noms":12850,"vandalistically":42079,"contrasts":21798,"relegated":20477,"footnotes":3675,"chased":17958,"reqphoto":34609,"superiors":20767,"conde":31635,"quality":892,"misspelled":10690,"ansel":43977,"deez":47343,"dino":16574,"jordanian":18960,"roosevelt's":31945,"booed":32758,"utf8":15932,"stall":19564,"noq":46134,"keenyah":38371,"phenomenal":20929,"shetty":47314,"flushed":28868,"revolution":3264,"colective":30483,"akal":44736,"lusignan":35916,"treacherous":49145,"buffalo":8815,"conspirator":39237,"annihilating":41940,"aired":5972,"dormant":19377,"bra":30101,"sanford":21749,"knut":41217,"inside":2206,"possibilities":7749,"referrals":35251,"masturbates":41043,"falsifies":44578,"allin":48413,"morons":5950,"newbies":8823,"konstantin":31470,"common":558,"mikan":36669,"derivation":9050,"relationships":4860,"boosters":35014,"reviving":30584,"rl":11702,"honored":10064,"obsessive":7623,"reconstructionist":46334,"courteously":31960,"famously":15332,"009":42094,"bleh":29554,"fawkes":15748,"splcenter":49245,"liner":13109,"bgwhite":20774,"quicklight":40596,"neurological":19873,"banksia":32180,"wenger":35079,"skittles":30099,"realization":11711,"pejorative":7675,"remove":244,"politcal":7521,"msu":13223,"renaissance":7593,"sarmaşık":43982,"hesperian":8929,"selma":40403,"roz":47995,"intonarumori":32378,"shepherd":10382,"loathed":31163,"scherer":41685,"sights":24942,"loves":2504,"monotheistic":18980,"surname":4202,"labour":5044,"webpage":4873,"empires":8850,"chickasaw":42175,"bakasuprman":33634,"sockpuppet":1413,"taiwan":4485,"professional":1524,"bengalski":48403,"malign":17687,"graves":9839,"vendettas":25775,"hinckley":39570,"motivational":37235,"instantaneously":29836,"treaties":11852,"lennox":48679,"libertatia":44242,"distanced":26720,"postdlf":41407,"disrepute":23943,"mandela":27154,"priority":5364,"70's":13987,"computer's":26149,"fg":21296,"richie":11416,"restless":27533,"implicate":49766,"differential":13886,"leuven":24374,"valentine's":18868,"'false'":25409,"jzg":12087,"wallis":24131,"grow":2316,"retard":4606,"jayasimha":27374,"losses":5015,"icj":20116,"bestow":29850,"included":491,"johnfos":41448,"txt":13845,"confident":5840,"opportunity":2454,"hanuman":23150,"involving":3172,"grp":36861,"jawaharlal":45730,"druze":26465,"naively":33599,"masada":32999,"elitists":34144,"joyful":49529,"virtualization":46791,"clamshell":43928,"pioneering":27739,"hawking":15022,"ananda":35430,"saudi":6400,"varieties":9308,"halting":46085,"turing":26752,"unbiased":3473,"snicker":34338,"governorates":49960,"drafts":10295,"tourist":9149,"nasaspaceflight":38024,"mygalomorphae":45335,"origin'":43381,"society":1369,"fallandspringolympics":27397,"јун":37445,"slowing":24666,"soccerguy1039":42541,"houlding":33758,"healthy":5751,"freewebs":32895,"bharatanatyam":38045,"ganna":26534,"hammersoft":25887,"mouthed":16082,"apple's":28757,"ihts":42789,"statement":446,"jefferson's":25149,"openstreetmap":37062,"tried":667,"whatnot":16855,"geog":43727,"elephants":18690,"dhe":35108,"consultations":27833,"“for":30055,"auschwitz":14492,"corect":48914,"sorrow":16690,"plundered":34105,"aritcle":25084,"mediator":6553,"approves":15337,"intestines":42702,"fled":9970,"poisoned":18641,"aloft":27893,"directories":21916,"disasters":17062,"conducting":7963,"regulator":32379,"'full":45825,"arrogant":3217,"srebrenica":9850,"ashbery":23982,"coll":24687,"vitamin":11179,"kainaw":49294,"rushton":19561,"appeasing":35905,"funimation":31762,"maps":2382,"whaling":19227,"successes":19273,"adder":33409,"sloane":32052,"gracias":23482,"publishers":6592,"copyrightable":25472,"barrels":17108,"cleverly":19557,"redhead":40511,"rehabilitate":42071,"exhaustively":32851,"satmar":25000,"shirol":44130,"allusions":17351,"launchers":45394,"indochina":24400,"technician":27095,"againist":36472,"fared":44623,"lambert":22326,"octave":12135,"guys":726,"seals":10164,"approve":5680,"incessant":16218,"nutters":32561,"ankara":20938,"calmer":44396,"simplifying":30443,"hirst":47510,"alison":9169,"roper":30054,"abt":17001,"bumper":26331,"travesty":19566,"uneducated":7753,"gayness":29762,"richard":2408,"watchtower":14514,"cabals":24665,"ibanez":40802,"unfermented":34266,"c0c0c0":44401,"caretakers":40026,"polk":37788,"professions":15367,"periodization":49514,"newbie":4904,"analyze":10220,"betta":25951,"locks":16304,"surrounds":27009,"push":2171,"granger":47273,"ri":12558,"primate":30122,"endowed":19356,"0ºw":46147,"hammond":19381,"amplified":26082,"barak":30985,"hipocrite":14301,"enabler":43571,"attended":5160,"neuromusculoskeletal":40895,"disclosure":9352,"beneficial":5794,"namespace":5861,"success":2958,"whipping":22650,"fastest":10151,"coexist":38114,"wingspan":48077,"jingoistic":33369,"bile":19202,"abdulla":45128,"khalid":26062,"winded":12799,"ironies":32937,"wallachian":40469,"tropics":12736,"itching":22969,"roflmao":28962,"holiest":38201,"eff":19410,"incarceration":32809,"bhot":40921,"action4link":42363,"sobriquet":31499,"ukranians":45770,"meltdown":22021,"egotistical":14091,"lodging":36705,"devin":37978,"quickie":44647,"c7":41270,"redo":12893,"expand":1958,"copyrights":2935,"circa":8793,"docking":15942,"merci":22296,"mecir":27175,"ŵill":24098,"deen":28963,"policy":224,"pianists":18902,"tabular":48430,"amoral":28800,"hk":12933,"εαίδεια":32612,"glastonbury":33771,"hamper":27710,"american":436,"antitrust":40285,"ker":19769,"hourly":33198,"kiddies":24446,"brewery":22083,"spurred":27991,"transcluded":5839,"mfg":44762,"cornish":8255,"aviod":47063,"kl":26269,"compiled":7097,"impersonal":19653,"stratification":28396,"daniele":48609,"socio":14333,"rags":23674,"obscurantism":38321,"superhamster":49588,"apps":13684,"ossetians":27594,"gunman":41083,"villa":22001,"pharmacology":32994,"scopus":38456,"inflatable":45934,"racialists":47909,"instructor":11231,"decidedly":13081,"heretical":25980,"kreider":46146,"blatant":1809,"striking":8122,"donated":10337,"keen":5782,"nga":34337,"hartley":35309,"aip":27680,"urbina":39868,"retry":47678,"carlo":14690,"profits":9883,"simultaneous":25400,"julfa":27312,"impeding":30121,"floods":13443,"icarus":30138,"honduras":16716,"styletabchun":35501,"empire":1533,"typos":7446,"similarity":6853,"sla":11620,"soaking":49731,"akiva":41171,"overheating":33336,"dykstats":30822,"wordpress":11478,"bursa":42852,"staking":26468,"stolen":5271,"pow":12430,"plait":29527,"promising":9724,"acquitted":25632,"horton":23049,"spins":27497,"tpo":27704,"incarnation":12042,"illegitimate":7789,"billions":8060,"clause":4924,"spamming":3074,"poor":1106,"apache":24670,"faux":13619,"consisting":9286,"usrd":18576,"bolivar":41273,"vengi":31020,"morison":20223,"deployed":10265,"siting":34910,"observing":10764,"inability":7076,"bad":344,"goods":8388,"flown":18588,"caitlin":33323,"hawkins":30551,"afghanis":29974,"zeus":10882,"clustering":38169,"evasio":44350,"represent":2286,"fragmenting":39353,"greer":20167,"depiction":10029,"squash":20911,"matchday":34225,"grey":5376,"hungarian":4056,"uptown":47734,"hadn’t":39589,"america's":9366,"edicts":28605,"outputs":18003,"guards":7253,"fremantle":35319,"jar":13806,"dzierzon":14889,"crusading":24664,"sherpa":43172,"moe":13111,"driver's":24852,"yeast":36801,"noises":26540,"smartest":24453,"1990s":6412,"blanking":2965,"z":3039,"d702":38550,"rong":48537,"miscounted":35201,"folding":29364,"spate":41837,"singer":3555,"qst":43812,"eisfbnore":30005,"unintelligible":20452,"obeys":28127,"perp":27810,"surf":16155,"inherit":28455,"são":22782,"creative":3034,"intrude":23452,"appriciate":27217,"parents'":17124,"plagiarized":13583,"resupply":46965,"savages":26564,"appreciate":646,"unacceptably":29564,"coinciding":38047,"problematical":28909,"samaleks":33517,"tri":16600,"bibliographic":22759,"mislabeled":35472,"thrace":14423,"oda":25275,"echo":7723,"unrelated":3171,"tripper":41614,"graph":5632,"albrecht":25823,"textsuperscript":31089,"よ":49824,"uzbeks":29508,"sketches":16247,"adolescence":27909,"alleviating":48080,"qui":20253,"ohrid":29261,"datas":33778,"silenced":11827,"varying":7872,"trauma":14513,"ratings":5307,"canal":9652,"chrome":14278,"archdiocese":32357,"msnbccbsnbcnprpbsabcreuters":49532,"vids":38224,"fake":2337,"wheelchair":21820,"opnion":35407,"hypotheses":11785,"sth":37900,"theyre":16785,"crackhead":35184,"summon":16587,"thorn":17190,"smug":10661,"drags":28156,"abi":21149,"comparing":4290,"jatt":19105,"moron":634,"crop":7873,"rti":39167,"nominate":2887,"newpage":35936,"nitpick":30586,"kamenica":49404,"ssn":32917,"virgil":36904,"bitcoin":8997,"exicornt":42864,"depts":39655,"ultrasonic":22436,"parenthesis":10635,"wolfmother":44044,"spokesman":12103,"panorama":22131,"careful":1686,"parish":10787,"hatchet":13565,"rumored":13598,"nonfiction":40672,"ys":30354,"alll":46339,"zadar":38934,"cremo’s":36298,"john254":43545,"coins":7334,"promiscuous":46285,"enclose":46615,"luxury":12088,"challenge":2548,"std":17953,"mischaracterizing":31623,"titular":22122,"cornered":36218,"acount":19492,"psp":13458,"moniker":14186,"anointed":15504,"euler":19555,"yadavs":9228,"sultanate":16982,"platypus":27500,"prt":15592,"çukurova":43462,"litvinenko":27137,"reproduced":11227,"nab":47232,"kbe":46980,"bebo":42210,"homelessness":37076,"probes":25334,"joined":3045,"leninist":41262,"baka":28789,"seq":25958,"historians'":46168,"warrants":7621,"flour":17465,"swt":42801,"thnaks":33093,"césar":37689,"yashoda":31560,"emigrated":16081,"frickin'":26041,"nothing":238,"soley":23962,"unsigned":1049,"glint":36200,"leibniz":20101,"californian":22829,"robotics":29402,"editions":5260,"heaters":38706,"davey":26400,"pt":7649,"berating":40073,"karadzic":36737,"buchanan's":46605,"sinatra":24960,"donbass":40971,"swastikamedia":38513,"blaxthos":18571,"dike":30530,"combing":40107,"incessantly":33495,"dude's":29689,"clapton":48977,"ps3":9846,"damascus":21623,"vardar":17675,"ń":44282,"carrying":5760,"sita":31865,"knesset":27557,"wnri":44037,"wifione":33627,"chattan":30341,"politicans":36775,"secondarily":32924,"hired":7939,"distilling":46793,"bulgak":47528,"bang":4723,"wahabi":16752,"googlepages":42978,"buns":48394,"luanda":46712,"kww":11197,"totally":1031,"mbw's":45883,"realizations":44903,"longing":27463,"intrest":24786,"deja":19268,"anthropomorphic":33827,"jethro":41372,"mutliple":42676,"handful":5559,"sift":25001,"begining":16738,"collegial":14589,"arkansas":11232,"don't":59,"squishy":45153,"bmi":25448,"commoner":33385,"velasquez":38577,"schmuckola":43232,"governor":4366,"tab":1821,"sune":36092,"hormone":26959,"vane":37473,"everest":14224,"imatthew":36559,"himalayas":39954,"gastric":46618,"hsca":29208,"sphere":6969,"dreaming":15404,"vulgar":12535,"groupe":42427,"boon":19783,"trustworthiness":29820,"induction":15546,"bauder":9440,"predator":13147,"proceso":37887,"organist":42501,"governs":16177,"author":759,"'first":25905,"cambridge":5340,"blackeyedfool12":44635,"unwitting":31296,"affirmative":11405,"categorised":13906,"woohoo":20523,"napster":31173,"brook":16794,"rhymes":14788,"garrigues":38370,"pressed":9355,"recover":10074,"steady":11713,"volts":26065,"giardia":49220,"chicago":2490,"marcus":10307,"slovenia":11919,"varsity":28923,"malibu":33111,"cpa":37702,"system'":38036,"storyline":9132,"fisto":22065,"publicize":19127,"collective":5820,"confessing":21546,"exquisite":44320,"choctaw":44124,"vandelize":45680,"speculated":10212,"romansch":48724,"aerodynamic":49842,"punishable":21257,"sate":42227,"iullus":47958,"sánchez":44589,"moronhi":44043,"sodomite":25673,"genocides":15618,"creatively":28808,"bulldogs":31275,"dripping":34342,"madness":10021,"chosen":2666,"peabody":27772,"'consensus":33779,"ft2 ":40620,"synod":33377,"msds":42833,"cerro":42716,"dominique":38707,"economical":14288,"imos":22915,"reviewing":2474,"floyd":8778,"diagrams":9950,"bjaodn":23151,"guangzhou":24401,"geocentric":40016,"photograph":3834,"minaj's":41451,"treaty":4427,"login":6997,"popularised":42244,"seperating":28871,"ios":19823,"namings":36954,"pedofile":45576,"01":1440,"ds":8608,"guevara":12873,"0m":46248,"craving":36832,"ustashe":17724,"lama":11948,"anybody's":18942,"fatty":10440,"performance":3175,"aaa":28503,"mía":41997,"trivialities":35038,"charybdis":44251,"demagoguery":43396,"reactivate":34800,"utc350":34568,"'a'":15583,"'world":47587,"plugging":23196,"shops":12517,"slutty":23833,"warmest":30879,"degenerated":22619,"pps":16107,"brahmos":21778,"neatness":44724,"wind":3373,"sturt":28937,"signifies":18401,"talk":38,"reserached":35793,"scheming":43742,"hogbin":48404,"initally":49197,"malls":21937,"them'":39156,"mummy":13405,"look":151,"insight":5075,"neville":21166,"ardently":44666,"wing'":47813,"expulsions":25810,"trillion":13611,"eh":3129,"mcu":41330,"smoker´s":43188,"piedmont":17916,"firms":8661,"deletionism":25973,"neural":14351,"“covenant":35792,"escalated":15118,"fainites":32731,"phrasing":5933,"early":925,"vanadium":47531,"skinnerian":43047,"reciprocate":49754,"passengers":11272,"important":370,"paradox":8464,"objects":3583,"throughout":1743,"growing":3432,"wrestler":8358,"mead":18665,"jakew":21827,"rockets":11915,"stylish":49526,"time":84,"uproar":20879,"mbt":30223,"borsoka":24171,"hindered":30770,"normandy":20934,"astroturf":46720,"yechi":25744,"lasted":7283,"hentai":24640,"assam":36170,"brutal":8136,"lin":19491,"ousted":40734,"watchlisting":42147,"existent":6796,"rolex":42008,"relist":23745,"075":42885,"perceives":30732,"disliking":30146,"scourge":35516,"atonement":24006,"loverofart":15813,"pun":8959,"victimizing":47517,"arianism":44978,"barbie":30389,"behooves":39918,"excusing":24247,"industrialists":41436,"criticizes":14377,"began":1808,"radiance":31925,"2'":41667,"bonn":35858,"coa":14763,"consortium":18445,"1950's":17269,"lineage":7355,"toward":2491,"extreemly":43065,"mindfulness":35505,"tyranny":10283,"'d":33701,"minefield":41187,"féin":8427,"tibbit":16783,"desk":2040,"register":3160,"dontcha":47072,"khalkha":49752,"odett":28787,"publicist":16108,"dodge":15373,"respectability":34634,"bilge":37417,"belives":24804,"harebag":47154,"modular":46762,"grandmaster":13135,"cemeteries":25621,"pts":32007,"wilderland":34747,"isabella":20047,"archives":1959,"absences":48730,"nutcase":15789,"crowd":5191,"runaway":26299,"statues":17031,"ata":25393,"narendra":25179,"wait":1004,"kemant":42956,"youssef":29113,"mdy":32063,"sparked":13271,"vibration":26298,"shadow":6234,"navarre":27324,"relevent":8562,"ghg":47394,"b6":32857,"rates":5931,"kryesore":39195,"persecution":6067,"orthography":17226,"vladimirovich":10959,"policys":22857,"yourcousin":24613,"docile":44514,"coldplay":9769,"frenchman":26556,"pillar":11074,"impeach":27473,"sanderson":27937,"farooq":22831,"fordham":34573,"cumin":32863,"killed":1427,"evula":28029,"sheeple":40852,"rum":14554,"temporarily":4443,"airdates":23703,"t101":45923,"nau":39417,"fund":6977,"fuji":43411,"noticable":41235,"jfdwolff":25264,"pavelic":22013,"cet":18659,"nrc":36943,"psychiatrist":16842,"phylum":27874,"wet":7558,"fertile":22596,"largely":2347,"merchant":11966,"orthopedics":36597,"backwards":6574,"arousal":36462,"ingestion":49795,"shabaab":27082,"hargeisa":37912,"vio":13904,"s's":41657,"azul":41227,"bucks":15075,"mattisse":16045,"coven":36924,"applauding":39916,"spoilers":8295,"forcing":5983,"oic":40376,"flashlight":35484,"chargers":46367,"piotrus":15445,"pablo":11935,"pencil":19605,"tbma":20375,"deigned":32633,"nil":15229,"dock":30823,"lineups":37078,"hitchens":21705,"controlled":2942,"hadrian":36059,"herb's":38812,"parochial":23414,"iffy":23750,"rus":14932,"pkk":11677,"kitab":43491,"xbox":5692,"sibi":49233,"wondered":6024,"maxim":17680,"worsening":48556,"engineers":7398,"svc":47448,"sky":4380,"pandering":17456,"wmf":6513,"porn":3748,"bludgeoning":41131,"cabal's":27541,"busiest":37722,"varna":17112,"raining":26336,"protestors":25985,"fist":10404,"saxon":8186,"psychotherapist":33462,"dir":20650,"templates":1113,"predominant":14511,"“as":32599,"rattle":34080,"acceptance":5426,"natural":1930,"tae":32153,"tour":3285,"daddy's":46832,"different":271,"dinner":7033,"instantnood":48062,"fodor":38644,"erectile":31366,"disinterested":16663,"tyou":43551,"petrodollars":37500,"personalize":30381,"legionnaires":37050,"parades":21591,"macmillan's":39888,"opportunist":33104,"chad's":41598,"strengths":14146,"orwell":24062,"humbled":23344,"legitamate":42899,"tsr":47028,"sciences":5789,"gloom":40491,"morning":2368,"conditions":2767,"diverted":22639,"heyday":35959,"webhamster":31437,"obligations":10198,"layed":32048,"milly":33183,"overlinking":18792,"stakes":20295,"thank":127,"perpetuating":13766,"laughingstock":45519,"jude":18847,"relisted":12836,"organize":7595,"unsubscribe":7647,"overseeing":41382,"underlines":34326,"striker":21071,"racemic":43764,"owain":45417,"aikido":25135,"earth'":42665,"wut":15576,"naca":48066,"form":640,"scsi":28245,"kṛṣṇa":39366,"mage":20859,"berkley":32963,"cashed":40378,"decorative":18888,"vandalise":3577,"nordic":9574,"demarce":38200,"monkey":5182,"chastised":28203,"slogan":11386,"ignored":1885,"sin":5446,"chennai":18042,"depots":45771,"madman":29064,"beaver":18981,"hangul":18457,"sledge":31643,"organization":1046,"julien":39267,"unintelligent":22537,"cursor":22593,"rob":5393,"hamilton":9266,"zereshk":21000,"gene":5746,"dapi89":28005,"domestic":5457,"lars":23458,"yogi":20329,"kannangara":46410,"depends":3917,"gayfrozen":6671,"zay":48324,"spreadsheet":38553,"fatally":30609,"quadrate":45423,"frigging":30882,"committe":43260,"fry":9766,"worded":4642,"chemtrail":36846,"popes":14794,"understand":252,"judge's":24169,"transwiki":36727,"tourney":34986,"clintons":44776,"victorians":49560,"edit":71,"treating":5096,"moreover":2421,"model":1828,"commendable":17967,"demotion":33551,"gung":19204,"copywritten":35721,"·ʍaunus·snunɐw·":20599,"shroud":18316,"findlaw":30984,"heston":48102,"nigga":4010,"debrett's":46178,"notoriously":14292,"poll":2519,"i'":20658,"mcleod":42035,"acorn's":39105,"illini":25423,"inalienable":22684,"collect":5585,"larf":42535,"sake":2202,"tacitus":30906,"d0":8637,"graffiti":9693,"bdsm":29568,"simple":724,"also'":26440,"smell":5762,"bro":5805,"bullrangifer":39320,"diodes":35888,"creditors":37370,"overlooked":7145,"suffer":4784,"name's":18990,"onwards":10035,"anatomy":11084,"promote":1671,"propellers":34012,"britanniphobic":42849,"myanmar":9241,"alves":30954,"jami":30173,"virtue":7992,"ppv":16408,"physicality":45688,"grounded":12631,"maxwell's":28712,"somalia":8504,"из":47841,"moslem":24810,"uav":35446,"furtado":40539,"abnormalities":35848,"homosexual":3279,"bite":4953,"griffith":14847,"davenbelle":36352,"died":1603,"anthologies":37056,"whatsoever":2243,"faustian":44347,"phil's":40449,"supercouple":43130,"fool's":22573,"jong":16053,"people'":19572,"reserve":5088,"beefed":35738,"irpin":37728,"shaved":23770,"sudhans":37538,"decimal":10808,"witzeman":17544,"snap":13076,"contibutions":40988,"1em":9145,"kof":28507,"anorexia":20420,"chefs":37438,"theo":28463,"kaithal":38652,"regrettable":18840,"territories":3962,"toros":40565,"misunderstand":8871,"managerial":46106,"favors":12359,"novoselov":38790,"leclanché":49088,"mei":35552,"bothers":8163,"huon":22686,"vortex":33942,"mchale":43109,"carriages":30652,"blcok":36148,"manx":32466,"how's":7442,"grandstanding":24994,"gillespie":12238,"contribstalk":16154,"'english":41585,"fenian":16019,"buddhist":6014,"shy":11508,"abusers":23526,"dey":46805,"hilarity":39268,"inspector":28651,"playful":26807,"tekir":44114,"scandals":11129,"copyedited":16725,"haplotype":31588,"edokter":49764,"contributing":729,"planned":3942,"jostein":43901,"blow":4009,"discrepancies":13362,"maintenance":4348,"plonker":46737,"dani":37772,"archive":961,"jajce":48017,"dammed":41631,"interference":8811,"marie":6808,"semitic":3491,"expound":26124,"toll":9955,"referee":13980,"semblance":16577,"belay":36256,"ambivalent":20623,"pao":31222,"leaking":17863,"unprotect":6295,"lapsed":21544,"sysopped":43159,"putnam":37899,"steampunk":42700,"levels":3384,"sentiments":8943,"accursed":39503,"inhibited":41109,"antagonize":29013,"ragan's":44259,"rachavaru":39028,"selection":4316,"exterminated":16832,"metabolic":34781,"rationing":31434,"postulated":27925,"delivers":22231,"timiras":18743,"richard's":26595,"barker":19634,"peppering":39765,"osteen":34892,"head":941,"savagely":45156,"ceasing":21234,"prestigious":7578,"mums":24570,"stephens":21475,"capitalizing":19240,"rogers":10165,"supposes":36743,"reveled":35508,"gauged":49289,"wages":13204,"cyr":39874,"craven":40909,"bereans":36456,"biol":48036,"hoax":2886,"crept":28528,"moderately":17039,"tianchi":26063,"aromanians":26408,"nicolae":35121,"yolmos":40922,"joseon":19214,"allergic":25395,"levin":13749,"''''":3256,"isd":48013,"oc":15540,"perdition":16395,"shitfuck":4235,"derive":10282,"nationalpost":45300,"collaborator":11387,"wavy":39227,"ullmann":4161," 雲‍水":18041,"lead":556,"cooperate":9483,"colony":7711,"shabazz ":36379,"pundit":23379,"fragment":14854,"lindbergh":18721,"slit":12895,"merited":17048,"gayer":41718,"bodies":4217,"discriminated":16639,"jeffpw":42235,"roger":4902,"picked":3466,"greg":6799,"straining":40087,"grateful":4072,"musikanimal":35017,"manoj":38622,"adhere":6076,"bassist":23771,"knee":9236,"atlas":9704,"marlon":48247,"intellectuals":13026,"lupin":42887,"biggest":2524,"melvin":30601,"amritsar":31565," the":44061,"cypriots":8372,"misinterpreted":9527,"coltrane":44864,"whalers":23859,"entrepreneur":25803,"sheer":7444,"profiles":7585,"jaime":25316,"yanks":18661,"magistrate":22391,"stephen":3298,"''talk":14357,"capsule":26282,"ii's":19833,"solely":3369,"howarth":49513,"rehash":16257,"wasn´t":43041,"jurisdictions":11296,"borntabcarlos":32525,"ukraine's":31127,"mixtape":21285,"cave":9091,"slippery":16255,"infect":18578,"blu":9469,"'contributions'":46468,"mock":9759,"mccreedy":47899,"enclave":32603,"stagnant":29082,"abbas":14571,"mountain":4376,"afr":41730,"toclafanes":46584,"wikiversity":21461,"josip":31226,"vandalisms":11448,"pointless":2805,"jima":48692,"subjectivity":17615,"grip":11334,"peterklutz":33919,"sort":684,"sebastian":12182,"loot":21840,"admired":15627,"interminable":48294,"hamster":21323,"forecasts":26413,"thirsty":37811,"herero":46196,"tentatively":26735,"restrain":22819,"4pt":28286,"castro's":43779,"inept":14364,"deal":802,"mottos":28926,"used":133,"erin":18567,"solomon":10965,"paged":47152,"wikidan61":30582,"zipra":44255,"aaliyah":24037,"supported":1296,"strangers":15645,"editing":120,"issr":10200,"joão":46265,"privileges":4173,"refers":1475,"currie":21758,"contagious":34078,"elonka":6957,"tanaka":29185,"maggot":14921,"emil":20290,"chokhor":33888,"lsu":36675,"mortgage":20327,"journalists":5421,"asperger":22552,"marcos":14818,"meth":21290,"twain":15929,"erebus":42678,"μελ":15307,"pice":31664,"misaki":38388,"readme":16555,"trpod":13175,"grandson":12579,"obscenities":21398,"naturalism":26052,"pools":21910,"sveriges":45666,"santanos":41802,"t's":37378,"brazen":31260,"jus":13993,"syndrom":46535,"pérez":34661,"buzzword":41971,"giffords":42358,"horrors":15745,"imaginable":24779,"listcruft":30537,"character":980,"ideologies":10266,"disseminating":37351,"irks":27555,"overviews":27087,"intersections":25338,"wikipedidiots":46082,"'their":45075,"muslim's":44324,"phlogiston":48031,"cynicism":25768,"murphy's":29965,"nightscream":18826,"huerta":47197,"victor64":48890,"anthology":15299,"trialled":43986,"scottish":4488,"preceding":2246,"account'":37827,"unjust":8073,"dodging":26675,"roi":17057,"exp":24467,"succumbing":39651,"daniel575":45204,"paler":39700,"memorials":21334,"unoriginal":37024,"monkeywrenching":46927,"poltical":35660,"femto":37088,"armored":16736,"maintainers":37139,"aramaean":33526,"touchdown":41796,"bainso":29332,"yakushima":49784,"lens":9518,"blinky":26225,"prayed":35831,"fuckers":11520,"andrex":42398,"enchanted":37348,"weu":43879,"kerala":8596,"binding":8677,"subtractions":49541,"diplomas":42403,"origination":32111,"quran":6364,"gain":2520,"dizzy":28095,"mulattos":28960,"big":462,"releasing":8134,"mired":43086,"wheelchairi":24257,"avraham":18803,"tentative":18079,"usman":48026,"dmv":29103,"deeceevoice":49313,"thats":1328,"fullness":35844,"dde":23118,"uncategorised":40722,"stalled":18243,"smugness":27511,"motivated":3734,"meritless":49796,"fukushima":32900,"gilgal":15689,"wasteful":23456,"oversimplified":40296,"prinz":32405,"allah":5947,"oreskes":16984,"jtwc":31491,"posterity":22137,"synthesized":29503,"e2":12557,"uaa":34327,"professionals":6464,"mediate":9161,"demonstrators":20701,"discredit":5240,"bachelor's":23529,"mitsos":40252,"polygraph":29441,"defendo":43954,"humanly":29887,"obe":34765,"crantius":21109,"interracial":20975,"kitzinger":47516,"nehemiah":49270,"localized":20277,"fortunately":7026,"●":22644,"'notable":49026,"yamaguchi":23371,"jmabel":23166,"sceptical":18477,"aiv":5120,"heartbeat":26467,"ass":417,"kinkaid":48995,"educated":4288,"supplier":29183,"tk":8769,"quotes":1301,"collaborators":10755,"mechanically":21781,"drkiernan":35396,"intelligent":2623,"randolph":21033,"bruns":46220,"posters":6256,"irresponsible":9744,"enclyclopedia":39823,"bieber":14277,"☆★":38638,"encryption":13445,"woe":20696,"distinguishes":15532,"lebron":27629,"shuffled":34997,"wrigley":48457,"pseudonym":9914,"doi":10802,"tracked":14247,"plunder":36786,"staggered":42126,"reversals":26809,"psps":37482,"nora":36875,"speedway":37824,"symbols":4514,"plantagenet":25820,"mutt":25837,"masterful":41283,"judgements":10186,"hc":17434,"understandings":22949,"'national":28652,"rockwell":26893,"chileans":25331,"suspecting":24798,"ronald":7100,"animus":30982,"reversing":9598,"libido":44797,"newest":9333,"drift":10030,"requirments":29599,"celebrating":14776,"ruth":11837,"nawlin":35332,"punks":17620,"anthropologists":13753,"bromley":44810,"hawaiians":45401,"psychopathy":45881,"halton":31826,"tasks":6388,"up'":17275,"macedon":12776,"explainations":22666,"''' 《defender":30313,"unnecesary":28967,"hacks":14344,"notification":2926,"engvar":18554,"carreer":41118,"concur":5702,"layers":11526,"dusted":44415,"radicals":14852,"spotty":18727,"youngsters":36247,"announcements":10268,"monitoring":5497,"leprosy":28752,"chamar":8087,"possesion":38184,"ultima":45178,"youngster":39959,"hairs":14317,"creater":48797,"bombed":12831,"caddy":48455,"optimizing":32898,"royally":40897,"ity":40577,"krystal":36663,"chambers":11431,"flagship":11375,"hiatus":13467,"novak":42464,"homogenous":23323,"writters":45479,"gaulle":38207,"fools'":37409,"wont":2913,"aircraft's":34551,"rly":26154,"monica":13602,"bourgeoisie":38448,"clusterfucked":44831,"encyclopedic":1390,"kebron":48538,"larkin":15529,"pales":44424,"signings":47027,"ames":25801,"guid":40208,"bane":32168,"serviceable":44352,"q2":32660,"stipulates":27638,"feast":14308,"traveled":13735,"tornadoes":22583,"electors":32921,"tubes":15356,"hysterical":13115,"demented":22528,"jena":29521,"kumar":10003,"schooled":28209,"dowager":32328,"intermarriage":29946,"view":313,"jats":14468,"ahoy":27229,"canvassed":14421,"assurance":13671,"devo":35998,"dasa":32403,"booty":34674,"pope":3667,"phillipinos":47897,"mesothelioma":22031,"leadbeater":24417,"shipping":12460,"imitation":18074,"obama's":7122,"fanon":46243,"nitrite":34452,"ul":20366,"accented":29463,"end":448,"blockage":20297,"descendents":18939,"sockpuppeteering":44905,"rake":36809,"outbreak":12514,"caylee":49942,"wj":41358,"plethora":12539,"bari":43198,"tfl":32070,"leaked":10610,"spotted":7170,"peterson":16857,"debating":5644,"penelopism":22093,"kthxbai":40838,"arrows":16134,"units":3049,"ntsb":20575,"inundated":39708,"immediatly":17970,"catapult":31372,"gestation":32508,"transitions":21906,"frieser":40295,"apparel":41107,"diverged":31761,"impartiality":10015,"kernell":46217,"explainable":29605,"khanna":12944,"establishes":10760,"borrowings":41777,"miraculously":27892,"attract":5073,"saakashvili":45177,"infringe":10667,"sams":30676,"coefficient":33263,"departing":29025,"nest":13446,"quer":43268,"voiceless":28350,"proud":2934,"booking":22545,"replacement":3567,"“get":34846,"else":310,"revolving":33475,"cleaver":35845,"consistency's":41637,"fitz":49417,"woman's":11714,"bayard":43839,"canine":26588,"chek":32899,"childishness":28471,"aspx":5617,"prefix":11061,"tallest":11580,"rhino":29292,"drago":42173,"rerasons":37168,"thyroxine":31038,"signed":2020,"vein":11158,"qualms":19805,"toni":23843,"liken":32735,"bowling":14591,"vaslui":38404,"tweets":18395,"raymond":7167,"hears":18353,"mishra":34977,"alums":32224,"betterment":17815,"knin":30229,"'something":48867,"laer":45124,"nascent":36925,"actuall":32128,"haplotypes":22464,"burgess":36175,"lucrative":46069,"wikiwomen's":28058,"edd":15064,"ut":12329,"droite":32026,"comics":3592,"sizable":19191,"bobby":9153,"plea":8984,"carrer":39290,"cadre":18892,"nimmo":41405,"skene's":40225,"offit":41767,"hyphenate":43445,"available":823,"smth":33574,"wrists":26036,"priory":27339,"sandwich":12444,"glaciers":34675,"strikeforce":31238,"operate":6023,"dougbiznatch":44082,"gnostic":15780,"terror":4691,"gallup":25473,"ghastly":43906,"warp":24545,"bourne":42096,"chef":18795,"wentz":19354,"waterloo":14412,"alexandra":21010,"lancaster":11867,"carnival":21514,"regional":2708,"indue":33683,"tyrannical":21720,"christianity's":42940,"cvg":25203,"suckers":25502,"sharpton's":48156,"destitute":39013,"gannon":17353,"fluffernutter":40472,"sardarapat":40965,"−":10493,"fumbled":46144,"preparedness":44020,"manifestos":32144,"perverts":22354,"tricolour":19223,"trajectories":40503,"codec":39423,"if":22,"§§§§":25028,"depsite":45514,"hellenized":33829,"rotc":41106,"staff":2725,"adorable":28500,"serbs":3582,"permantly":46032,"neuromelanin":27331,"csd":2632,"deleters":38495,"jammu":18078,"deriving":25592,"schiavo":12274,"fax":14349,"horseshoe":26354,"attitudes":6241,"goku":15809,"emico":36441,"straps":24816,"fatah":23853,"sidedness":44891,"explorations":36187,"impasse":25655,"blackhawks":27379,"deservedly":32991,"antisocial":21688,"tiff":30125,"thejps":38658,"coupon":44550,"canceling":45803,"sepsis":15180,"criticises":37861,"spoof":17143,"valenciano":38537,"paltry":29722,"commons":1367,"concurrently":22343,"de":824,"costumes":18194,"medias":32749,"maltose":29172,"cites":2907,"casing":25953,"perf":22107,"mitanni":31421,"annoy":8408,"rashid":26023,"msn":7345,"olivia":25315,"zeraeph":40162,"workprint":43947,"perogative":37452,"prohibido":43782,"marin":37676,"demiurge":15765,"fungus":19277,"matters":1656,"'revert'":36339,"50s":25330,"megistias":41053,"opposed":1782,"answers":2465,"parroting":40430,"attachment":11880,"insertions":22581,"misbehaviour":28530,"cheyenne":28268,"advisement":27593,"journalist's":27521,"rcmp":44611,"bastin":36902,"native":1739,"malaysians":34276,"explores":29504,"pleases":38323,"totals":17937,"walt":6348,"shouldn’t":21501,"rotten":8109,"ecc":43856,"superhuman":26510,"sjones23":46344,"rigby's":35722,"democratization":36505,"exaggerating":16742,"''''''thor":31310,"yelp":45202,"vetting":15394,"expansions":13689,"torrents":45900,"andalusian":42624,"tvnewstalk":41638,"fascistic":21520,"gadhimai":46905,"chllorine":17536,"perpetual":13859,"edison":13850,"verbal's":26928,"gelman":38609,"tablet":16848,"misandry":42694,"detailing":9136,"soured":36045,"briefness":31465,"boulder":36980,"gamaliel's":46589,"pedophile":6315,"billy":6520,"minnie":32214,"pane":29951,"bison":35778,"mh":17454,"redwolf":34365,"injured":8853,"unionism":33766,"hopping":13092,"outings":31739,"thumbnails":24619,"increment":39696,"furries":28533,"pena":39043,"vaishnavism":31033,"rime":26912,"immensely":11005,"huskies":24514,"ferocious":39939,"isotopes":28879,"grievous":32609,"latvia":16325,"neanderthals":45884,"biggy":47859,"ganges":30961,"6'":32916,"pegasus":24781,"∞":20238,"thunder":16777,"saponi":43987,"sulmues":47161,"syllable":12187,"skeptic's":37530,"earn":6981,"'poor":40481,"artes":49070,"communicat":44872,"encyclopediadramatica":25857,"four":478,"sensitive":4256,"comeback":14940,"redshift":36389,"distributions":13654,"advocate":3776,"posterior":37643,"wikipeida":7505,"evaporative":46575,"dragging":13397,"paterson":10892,"rhobite":12804,"treasures":21764,"—zujine":48617,"rented":30029,"blp's":26199,"lgbt":4903,"renounce":23377,"tipping":23654,"ratel":27223,"aborigines":22752,"among":935,"i’d":14974,"hy":30113,"vernoff":47261,"serialized":44441,"founders":8695,"uncivilized":21862,"thwarted":24812,"velankanni":31311,"kinney":34131,"newsman":42914,"msnbc":8902,"hancock":32270,"iterations":32329,"lbu":34376,"mounting":30923,"hydrocodone":49329,"downgrade":23765,"mohr":43738,"everlast":34964,"insightful":18480,"zephram":29366,"favoured":15347,"impairment":26327,"dominick":19275,"cities":1919,"a330":39557,"hutchison":35197,"taste":4371,"arise":7373,"wustl":47098,"sandinista":39346,"tfowr":30012,"admittance":26483,"tan":8624,"idlib":47476,"breast's":9015,"guadalajara":41833,"sacrificed":20285,"forcible":25966,"voltaire's":36650,"angeles":4325,"sigmund":29941,"gluconate":41359,"insult":1974,"chastising":41066,"anglia":26043,"duplicated":7441,"kla":17549,"juicy":8275,"exports":21013,"hague":14348,"mackenzie":17376,"solus":32331,"facets":16890,"burgundian":39019,"phys":30667,"lunacy":20251,"rin":23375,"extracting":40974,"havana":20358,"earned":5276,"oval":25910,"pu":30757,"blecker":47610,"aristotelian":27295,"deterred":46064,"bose":22372,"cinco":34942,"glove":25116,"griffin":8009,"whaaat":16693,"minotaurgirl's":45513,"angle":5021,"nominating":4836,"aussielegend":31041,"digression":46809,"benjamin":8225,"stressed":9220,"mickwest":30930,"templete":33807,"memorize":29480,"leary":35944,"instincts":23809,"fadix":21655,"postings":6297,"farcical":18178,"confronting":23183,"pettifer":46758,"charlottesville":39880,"tot":20063,"breif":35732,"'homosexuals'":18127,"autoconfirmed":10733,"pound":5084,"wyatt":19974,"scoutmaster":33803,"spillover":49794,"instigate":34553,"appropriately":4991,"forestall":34912,"action4date":42362,"magyarisation":35609,"cent":7337,"unlinked":20866,"postgraduate":43262,"blinguen":18093,"abstained":38449,"reddy":34052,"do":33,"we've":2361,"pact":11767,"asn":39182,"erikeltic":48264,"greco":14673,"cliché":33205,"reverence":23549,"uncanny":33623,"sponsoring":30377,"gondwana":46103,"mail's":45113,"robeson":16321,"scuranova":48999,"maa":25445,"eichenwald":24303,"embrace":12062,"hoppe's":44356,"stalemate":18261,"substitutions":49146,"divide":6568,"dayewalker":14435,"disscusions":45443,"verifyable":20162,"kilometer":28671,"bfts":42947,"ink":11797,"nareklm":43562,"live":545,"waz":36172,"brokerage":37152,"framed":11025,"kabul":15860,"distinctly":12478,"kulothunga":32570,"illicit":32806,"numerology":38303,"slipknot":35163,"'no'":35157,"fued":35293,"mr":719,"nexon":48582,"picketing":36676,"froth":38004,"crushed":11238,"beowulf":27631,"uncaring":36425,"unindent":33165,"acquisition":12297,"materialist":43337,"ordinals":18782,"miscreants":36282,"institute's":23518,"peplau":47806,"saves":9047,"real":328,"copiously":45035,"powerline":42718,"beyonce":13793,"internode":31426,"postulates":37253,"austin":7716,"diminish":10031,"barnea":47525,"laver's":41029,"thati":46330,"packed":12935,"gmaxwell":37297,"muds":35053,"entertained":14561,"sororities":29871,"foundational":22544,"mentioned":441,"icdiss":46418,"ethel":28693,"policing":10819,"deutschen":39398,"modifications":7645,"majors":15175,"ave":9781,"bolognese":26619,"hydrogen":10014,"vijay":29201,"reintroducing":33152,"sucrose":40581,"lear":34121,"mojave":35212,"claire":18466,"delphi":20061,"capacitance":30036,"hornet":17511,"spaceflight":32448,"celebrities":6640,"stab":7604,"philly":20749,"talkie":11464,"assertion":2253,"attaining":28118,"interplay":43206,"ringing":25021,"sonnet":27832,"next":493,"sever":30387,"pg13":49251,"animations":42951,"sidetracked":25354,"angie":38198,"yehudi":45001,"kepa":34828,"wikiusers":49989,"litigant":33660,"delinked":47298,"lowlands":42835,"akhilleus":40694,"categorise":19592,"medics":34831,"nicolson":46616,"nemonic":43606,"vassals":30212,"q4":45977,"sv":13653,"deaf":10519,"filepile":24600,"randomly":6471,"achieves":22688,"doubleday":49446,"ah":1908,"twit":12283,"promotional":2266,"everone":37068,"flc":10762,"lehi":25440,"velar":45715,"cartan":26330,"nuetrality":45270,"ayurvedic":25941,"telenovela":21985,"pac":15242,"computation":16759,"midterms":47444,"squabbling":30937,"dignify":32274,"yu":9115,"citigroup":48700,"grinning":40419,"buff":16455,"exceed":10487,"lunar":10870,"overthrowing":31477,"danko":38552,"'vandalism'":14460,"yr":9919,"excesses":35859,"socialite":41483,"'x'":46256,"usf":49209,"nayar":40485,"cygnus":43595,"sulphur":28779,"stradbroke":44404,"authorised":19298,"sliding":17994,"summit":13149,"lópez":29867,"maine":10866,"dominated":6761,"davis'":23748,"wattenberger":16476,"mythical":15636,"exchange":3455,"timespan":48091,"appologize":21395,"doolittle":27189,"hails":37157,"kudzu1":44512,"dk":16338,"writed":49326,"logistical":31522,"spacecraft":10652,"convoluted":12401,"volt":20928,"father’s":39660,"chauvinism":23113,"free":191,"shrila":34806,"weasely":33440,"isbn's":27215,"ffs":17523,"novaseminary":18775,"tvm":43316,"tali":36216,"thoughtlessly":41558,"discipline":5787,"photostream":36806,"244m":49618,"puffery":11246,"boomerang":16259,"mouthing":26482,"smallpox":33223,"empire's":30221,"eve":7671,"vries":47282,"watford":36955,"englishman":21963,"noticeable":13070,"offshoot":26207,"advisory":8733,"transform":9630,"ahbash":27243,"liancourt":20965,"inconvenienced":48828,"saviour":20097,"goebbels":23287,"contraction":18031,"suspects":10675,"awami":31250,"yugoslavs":36196,"lepers":46734,"ak":10601,"drake":10057,"barking":15839,"headed":5170,"fell":3978,"keyword":14890,"nasa":6395,"koov":46820,"year'":37566,"newcomer":7918,"broadcasts":14494,"pretty":565,"cmm":49923,"hacking":8688,"shanes":38948,"fateh":32401,"columbus":8756,"cuny":33130,"'citation":24547,"destructive":5509,"dooyar":37484,"“big":25676,"offended":2735,"ašo":31249,"sahaja":45855,"refused":3111,"circumference":23033,"boston":4106,"vanished":14656,"fisting":34909,"commando":18160,"guild":7235,"nominates":27092,"mined":26664,"spotify":43883,"suddenly":3719,"kashmir":6090,"shervink":49724,"lau":25806,"heisenberg":44890,"snipers":24611,"starch":32265,"lobbyist":17854,"esoteric":10247,"barracks":17214,"extremists":8924,"rabidly":36294,"halfway":11216,"cream":8241,"gifted":11551,"kidnapping":15697,"i's":30501,"rau":47371,"ambit":36609,"must've":30068,"continents":10215,"superpowers":12464,"bel":27604,"swastikas":27679,"invasion":3876,"intrusion":18364,"reculver":43910,"stats":3460,"bench":12587,"trans":10261,"quacking":45226,"bewildering":42964,"distorts":20333,"unsubstantiated":5674,"programing":35296,"sceptic":30035,"devils":11352,"observances":32181,"koresh":49568,"wally":23527,"resonable":30279,"rebutted":25916,"sakura":42787,"game's":12653,"governance":10585,"winchester":21485,"handwritten":29513,"admitted":3179,"wasn’t":13106,"smiths":23286,"dank":13248,"pndapetzim":42910,"magazine":1511,"convenient":6127,"adressing":49635,"morgue":42470,"manual":831,"allison":15811,"circumcision":3796,"peas":39192,"pier":25333,"building":1614,"refuted":6947,"mindlessly":19499,"exploration":11436,"localised":31972,"theory's":34206,"straussian":46161,"republic":1357,"paterno":49589,"ze":12207,"appropriateness":11675,"romanian":3628,"swami":14476,"abiogenesis":31049,"generate":6089,"tumble":29355,"skål":45150,"woods":8642,"blurred":24911,"kultur":36427,"sitush's":41851,"enforcers":32023,"exemplifies":23952,"comply":3946,"arlington":34369,"fd":23063,"ju":20353,"barakat":42777,"osama":7573,"sahrawis":31590,"araneae":22030,"pointy":10588,"veiled":10719,"stores":6091,"homeless":12641,"delegating":36804,"convince":3433,"aviation":4761,"trudeau":46215,"libs":32700,"articel":17909,"miniature":29043,"bmj":34459,"tongue":5238,"siheung":44084,"arles":47410,"fing":35161,"alarmist":33735,"categorizes":29465,"internet":734,"carman":41892,"halved":47980,"extension":5078,"crimp":37030,"prescribing":41294,"orleans":9186,"golden":3654,"judah":21177,"also":65,"st":1792,"roundabout":23403,"oakland":8353,"anonymiss":16439,"rowland":26643,"ancestor":8250,"coffin":17231,"factor":3166,"pict":49692,"improves":10810,"cιτγ":49352,"crculver":38504,"sheds":24555,"harder":4110,"pretending":4541,"shrapnel":29426,"prweb":45499,"curry's":18465,"maplestory":42211,"dissection":36611,"doer":30945,"dash":8286,"sharmila's":37948,"childers":38822,"bun":37863,"yupigo":29093,"bypassing":27707,"mustafa":17653,"assistants":30890,"knowingly":9375,"combatant":26857,"dug":13939,"poisoning":9812,"zad68":39401,"obake":47579,"nabi":47540,"handy":6986,"rachael":28996,"cfred":49756,"webhp":42754,"astronomy":9523,"dire":14162,"hideout":49807,"butchers":29155,"stayed":5985,"nhtsa":48560,"instances":3690,"hurtful":14352,"bruker":20722,"astrophysics":24099,"puranas":36556,"dioclea":44912,"reelection":35404,"userrights":40912,"ameer":41094,"interspersed":22060,"pointed":1559,"sergei":21830,"mystery":5698,"meteorology":31513,"polygyny":44650,"moaning":18968,"ravindra":34679,"“blackpearl14":17751,"joey's":34741,"gov't":16579,"unopposed":48729,"trax":49414,"legged":36360,"à":9444,"zeno":28606,"specially":6324,"france":2079,"objective":1903,"ya":2048,"heat":3764,"sighting":20747,"archive1":9253,"goguryeo":27901,"wikikpedia":37544,"predicted":8069,"''the":15380,"comercial":28060,"archbishopric":47559,"teahouse":6033,"'''' ''":36348,"chooses":7153,"working":623,"bukharans":37122,"леесуда":37216,"kapital":40967,"rowing":42934,"penthouse":33109,"supermarkets":30653,"mcsweeney":43555,"polygamy":21247,"myths":5510,"geocentrism":37712,"fansites":13694,"scandinavia":9675,"timbuktu":49542,"rumi":30919,"sparxent":43586,"rap":6269,"gena":22430,"antebellum":30547,"hefty":35701,"martin's":14183,"nandesuka":18297,"malke":18515,"schuminweb":36353,"perfer":42799,"pleasures":29499,"clarity":4762,"tjf":37744,"mosnum":20092,"takers":22929,"copper":8819,"duct":25901,"distant":8666,"cleverer":46506,"didnot":48629," t c":39876,"forest":5341,"prσud":25370,"portray":7091,"winters":19430,"dissolution":16503,"miliband":32932,"observable":12657,"rubashkin":43530,"soho":47425,"binaries":45169,"technical":1998,"malayalam":12731,"hahahahahahahahahahahahaha":13211,"macphersons":45910,"rediff":43085,"inla":25831,"malke2010":14714,"crohnie":37531,"harmonious":26514,"undergoing":12148,"seeing":1211,"infoboxes":4317,"inflating":23473,"000000":4864,"process":572,"swan":15629,"dresser":45767,"floors":25345,"elementary":6287,"silicon":26614,"whites":5414,"spinout":49721,"belli":22742,"repentance":40873,"electricrepairs":45332,"hoppe":29490,"aave":27028,"donors":17841,"stds":40765,"kellogg":18248,"indigenous":5897,"abridged":20558,"gassing":30648,"cobaltbluetony":37241,"sophomoric":40182,"bald":6622,"gregjackp":38764,"eyal":44345,"agreeing":5138,"lois":23173,"registry's":36528,"charting":17995,"rain":7044,"bernadotte":35629,"holby":38286,"'now":42659,"knss":23139,"consorts":41527,"sinful":32542,"chum":19901,"whirl":31940,"byrne":18660,"kotor":32303,"mfi":34596,"diaspora":9663,"kfc":29263,"subcat":16446,"miguel":10138,"heya":20694,"wilkinson":23073,"quod":42967,"fleeing":14382,"wilber":19314,"hasspoken":30110,"giggling":40413,"ag":14397,"conjugation":39082,"modern":945,"toro":35718,"jacques":13900,"slip":7549,"unreadable":10132,"questioned":4420,"meteorological":26262,"maxwell":17140,"swift's":42581,"anoying":49211,"superfriends":47669,"myers":14715,"buffoons":35004,"interfaith":30376,"windmill":45020,"parliamentarians":34919,"expounded":35655,"dimaggio":46684,"rule":656,"contaminated":25314,"tng":31619,"voltages":25456,"howl":18167,"jump":2898,"dojo":25052,"event's":42389,"–''''''":42579,"subluxation":19261,"gobbledygook":42551,"bioresonance":27131,"hilariously":26724,"directives":20349,"synagogues":21155,"strokes":19317,"tolerance":6729,"urs":36494,"citrus":28179,"father":1549,"mortified":49965,"congress":3308,"sabrina":27564,"winans":24060,"council's":42042,"inversion":30191,"h":1701,"machine":2594,"dictatorship":7265,"listed":424,"alpinist":25200,"mef":42778,"yielding":41157,"cried":15607,"keep":230,"facism":47411,"lectured":20540,"splc's":31483,"veer":19986,"indifferent":16828,"'edit":26245,"crank":9585,"tagline":20273,"successfully":4941,"fights":6748,"knox":7273,"revitalization":38044,"7x":41265,"yt":20474,"chelsea":9533,"trentino":23125,"blocker":17855,"wimpy":28092,"mohammed":6965,"sassanid":23453,"roles":5345,"terrace":21179,"pantheism":43438,"alight":33155,"duffy's":46844,"hazy":29873,"gilberto":42097,"repudiate":31886,"rfc's":25734,"nouveau":30663,"mantanmoreland":23862,"walter's":42901,"kyle":7575,"upgrades":28592,"page":27,"putza":21118,"project's":9702,"cheka":34688,"nuclei":22489,"huldra":35441,"n'":13945,"theyve":45061,"please":45,"news":481,"sorce":43132,"yanggongju":36350,"miles":3572,"cuyamaca":29359,"citiation":35527,"direktor's":39931,"rdos":41242,"window":3513,"alike":6786,"arcade":11815,"amcom":32133,"mistreated":20367,"harasses":32206,"donnelly":38275,"zondervan":29858,"ect":9416,"unlucky":32155,"appellate":21165,"ilo":23523,"scat":38487,"fathered":28811,"primacy":25086,"pepole":30073,"toolserver":13452,"scout":4050,"unavailable":15410,"newsletter":2338,"inteligent":49374,"balts":42917,"fundamentalist":8239,"1890s":21523,"diplomatically":34108,"impairments":39889,"papa":27789,"porter":22567,"persistent":3560,"plates":12910,"imitate":38426,"pedophiles":10521,"dioxide":15279,"'míkka":17223,"naomi":38185,"baroness":24789,"doo":12003,"deviates":33945,"welfare":7198,"svoboda":41135,"halil":33393,"glacial":30365,"sinha":34598,"✓":30416,"aston":31066,"olympic":6589,"national":641,"during":539,"irritable":49169,"government's":9451,"tigran":42525,"enlargement":25299,"ariana":21102,"delves":33748,"pn":27311,"raking":44534,"contaminate":36205,"egypt":3710,"insular":23010,"messianism":37937,"czech":4682,"blackpool":24926,"dra":25491,"hussien":36973,"grenade":21829,"ought":2311,"mds":17413,"abram":47757,"preschool":43219,"schlechtendal":34141,"shaft":13636,"inpure":38801,"rasa":32302,"vito":41669,"abstract":5539,"dhudhi":15186,"maguire":45670,"cws":49401,"women's":5282,"ditty":41743,"marvelous":33875,"transsexual":15365,"catalán":38536,"wasteland":22339,"intoxication":47260,"shipwreck":25356,"ferries":43741,"critisized":40125,"eudaimonic":45928,"premieres":41170,"gong":8057,"boyfriend":7877,"gem":21701,"obfuscate":21147,"sessions":10524,"tax":2821,"languedoc":49171,"memorable":11088,"smacking":41811,"prepare":7584,"loserqueen":28828,"wordimagesoundplay":34496,"flooded":14043,"sites":766,"prety":33876,"instigators":41868,"yosef":35731,"kms":39979,"warmth":23547,"rcp":33534,"offically":29955,"bids":17424,"scientists":2365,"pravda":20307,"wehwalt":20484,"quarreling":41505,"beats":9083,"confirm":1469,"arre":40889,"stephan":17030,"sony":7403,"dalmatian":15611,"slavic":4221,"dunce":31626,"rasche":38665,"refinement":25894,"godfrey":22704,"diversion":16699,"inciting":21747,"arjun":11925,"schizophrenics":30346,"mp5":48848,"therapists":15945,"ps4":27949,"λαβέ":46560,"tdyk":39068,"denvilles":36509,"talkpages":9687,"vanishingly":45133,"done":197,"weaponry":17160,"anneke":43123,"franciscans":38232,"narragansett":31905,"bore":7052,"ministeriales":38817,"observant":39681,"intelligents":47756,"nadal":32131,"zoroastrianism":22016,"sheehan":32944,"heathenlovegod":48780,"negetive":49547,"skips":41074,"jewboy":33544,"“are":42155,"tinker":23681,"1930s":8089,"pondering":28924,"yourselfs":44548,"partitioning":49206,"iniquity":31759,"industry":2130,"denise":22830,"brincknell":37869,"intrigued":13450,"homies":31145,"beckham":15389,"beginnings":16164,"vani":25239,"orderinchaos":12300,"precincts":30174,"jour":47697,"socialogical":37012,"och":25532,"jc37":47907,"noe":37747,"trader":18899,"practised":19918,"shoud":19178,"conrad":13779,"plans":3579,"pleasant":8014,"debuting":30955,"propagandazing":40236,"rectified":16735,"maitland":22397,"mention":404,"disputed":1652,"acutally":28226,"ava":32306,"intelligently":23418,"baklava":17045,"victims":3054,"bound":4647,"organising":19721,"mpla":16470,"revocation":25049,"croatia'":46292,"holliday":25711,"anticipated":14728,"bureau":7605,"randi":13146,"wingman":41700,"prevailed":17078,"environmentalist":23630,"underwear":17688,"postions":44983,"spear":22674,"glosses":29192,"origin":1486,"yeshuwa":15981,"jackson":3387,"blockers":25479,"popullsis":39197,"squashed":28429,"mitzvah":43804,"august":903,"aristotle":9353,"rifle":5884,"alone":699,"chechnya":24572,"feudal":17433,"pronouncements":22085,"sooooo":19579,"create":452,"sabah":29375,"fears":10997,"implicates":45551,"pushkin":27173,"labled":24549,"schmidt":15038,"intently":42122,"triglyceride":37020,"prince's":32059,"learners":23207,"gnothi":34692,"insinuating":17486,"consistantly":20716,"wiafa":40062,"spectacle":27865,"puede":42372,"schooling":25332,"nitty":33645,"salesman":40625,"motd":32936,"manipulation":5881,"blackmail":39306,"sweep":5649,"abode":25524,"revises":45376,"'content'":39325,"your's":23974,"scenes":6226,"mcconville":35622,"deadliest":26287,"irwin":15757,"photoelectric":49126,"authorizes":38228,"txmaster":46149,"stipulate":44774,"whenever":2601,"having":346,"beefcake":27880,"loop":7268,"bumbling":37072,"sitapur":25174,"sells":11606,"walsall":41973,"charted":13047,"racket":39685,"straddles":49471,"geaves'":30302,"bride":15475,"stirring":15827,"storage":7830,"bowing":28812,"noaa":14112,"hexagon":29286,"shoudl":25181,"pk":17401,"gayvn":15189,"elaborate":4561,"ofcourse":11543,"euthanasia":31304,"merit":2736,"rio":10187,"midi":16994,"filibuster":39652,"reluctance":14888,"misused":11297,"strangest":31535,"pimps":23874,"recalls":22628,"haldol":47308,"noir":30219,"hrh":24923,"soaps":36953,"exhortation":49748,"carltotta":44069,"conceived":13191,"vulpes":21876,"juvenile":8229,"sled":40445,"transparently":24070,"advertisers":24281,"bulbasaur":46885,"lanicoya":43203,"phils":45060,"arse":3244,"herald":7490,"competency":35069,"—this":42313,"instill":39261,"midget":28476,"meld":32923,"nanny":22813,"themselves":753,"mueller":21203,"ack":32011,"gaia":19703,"ala":21241,"got":288,"headaches":25915,"unabashedly":37387,"postscript":28010,"adele":45586,"tasting":25580,"writting":15715,"reformers":22055,"owners'":40681,"norm":7006,"canada’s":35565,"reptile":33010,"enrollment":26216,"partner":5803,"judicious":22602,"lyn":33891,"patey":24357,"newscasts":45818,"wailing":35448,"angels":7897,"noli":42762,"offensiveness":30115,"ahead":1154,"grandparents":15116,"toulmin":41422,"olsen":33306,"campus":4984,"fox's":27823,"muddied":44620,"protecting":3317,"marvel's":41861,"middlesbrough":38636,"hooff":29425,"mother":1111,"spends":8271,"vj":47384,"cosmological":21186,"archie":26277,"faggotry":36903,"representing":4875,"rfd":12140,"mainstay":49565,"harper's":35582,"underhill":35009,"apostolic":15113,"bouley":36078,"rudely":11831,"dhcp":27499,"caution":5029,"essex":12219,"subscribing":41030,"someone’s":39584,"usb":21473,"wankstain":49481,"technocrats":29222,"lo":7866,"ontario's":49815,"sotomayor":41293,"battle":1293,"rms125a":26478,"british":628,"monarchical":29776,"larouche":7976,"melton":23374,"in'":31979,"honorary":9831,"serge":23281,"geelong":23369,"ufc":5378,"heisenberg's":35254,"f2p":18128,"lifton":42331,"conduction":34065,"warranted":5868,"miniatures":39630,"superior":4111,"consideration":2664,"he's":605,"item's":44957,"kafziel":19113,"pipelines":41552,"unwritten":23488,"untidy":19664,"siobhanhansa":34343,"snatch":22393,"smoky":37729,"mundo":20243,"ob":30798,"lyricwiki":32968,"archaeologist":22109,"snowmobile":42930,"mesa":26760,"doen't":49128,"stagnate":41886,"saleem":31524,"undoubted":40858,"township":12912,"originally":1667,"fuming":33023,"briggs":34360,"grazia":38174,"routinely":8657,"bbc":2224,"pwt":31790,"technica":43876,"chucky":39634,"uphill":28711,"baekje":35436,"unincorporated":17807,"resized":21601,"johnleemk":41956,"urself":17722,"trawl":28199,"latitudes":36374,"inferences":15678,"vintagekits":19812,"ceus":29411,"meredith":15733,"piccolo":17315,"sling":27055,"sacramento":14857,"disorganization":30378,"'club":49360,"externally":24669,"urbanates":31444,"curricular":43078,"wieght":47969,"authenticate":29595,"threatened":3426,"luckylouie":37582,"tattle":23220,"loyola":35235,"nationalists":5121,"birch":12466,"cliched":40793,"narodu":38860,"vaughanwatch":45778,"meow":11450,"ideologie":32819,"humorless":44955,"robin":8185,"perturbed":42308,"forfeited":31379,"riviera":49610,"ganesh":26397,"bonaparte":24230,"syncline":38419,"pw":9886,"alleles":34280,"zoroaster":39354,"coals":33461,"peltier":41880,"runnymede":27279,"hero's":41746,"★☆":38637,"ambiguous":4041,"rango":26827,"christendom":36544,"lengthy":4294,"shouting":8961,"restored":1691,"gojniković":34203,"asterisk":18914,"white'":40515,"thick":6607,"mgs":29246,"fishy":14930,"interview":2053,"opinion":321,"cheerfully":44794,"coax":30020,"farce":9376,"lordship":37358,"'professional'":45896,"hardcopy":28576,"adolescent":13013,"gpl":17756,"itachi":34495,"asylums":44302,"makecat":32382,"shilohshepherds":40213,"fiance":40046,"fundamental":3254,"sitcom":20953,"narcisist":49238,"regentspark":48266,"pandiyans":39759,"interruptions":24596," if":49649,"benon":31663,"assassin":16051,"aziz":22336,"aiden":30209,"limitation":16870,"unfailingly":46472,"entity":3313,"kingdom'":35548,"incomprehensible":12940,"docks":35873,"eggman":39352,"meeting":2988,"hypocrit":33792,"3f":9250,"mental":2989,"prooved":39758,"officially":2390,"finishes":16261,"brahmins":9784,"impede":23725,"connotes":39625,"grady":44783,"cpu":12151,"handles":15418,"protests":5482,"scorer":41952,"chopin's":44091,"gravrand":33513,"petitioning":39821,"was'nt":36270,"macarthur":19205,"votestacking":33305,"diversified":30436,"refuses":5112,"rosicrucian":30579,"wicca":14400,"sows":41334,"maronites":35284,"feuds":24116,"poorest":17350,"sweetened":46856,"ignorant":1857,"napalm":35144,"today’s":22465,"obstacles":16184,"osx":28672,"andythegrump":13370,"mmanot":39333,"replies":3886,"sundar":43848,"autobiographical":13709,"ofc":40502,"defiant":20457,"firsthand":22623,"unsuited":33126,"smiled":10422,"fremont":24365,"nb":11529,"fictitious":14219,"compulsion":42203,"objection":2557,"yamamoto":40261,"јул":37446,"clitoris":20065,"girl's":20553,"plays":3631,"pervert":12497,"printable":35230,"quaker":23937,"ej":18758,"unlocking":27618,"hitler":1275,"cabinet":8656,"dhu":45355,"nations'":32692,"lockout":30015,"snowden":21354,"ramana":25484,"wouldnt":7541,"brings":3873,"pluto":15657,"brendon":49443,"kib":47947,"knoxville":32911,"sensor":12639,"adoptee":23535,"cartoon":5699,"restaurant":7213,"sarfatti":10085,"tamilnet":40389,"squarely":26080,"income":4356,"rangeblocks":43897,"venomous":39801,"sialkot":35821,"images":340,"subhuman":26694,"outer":9313,"foliage":36942,"bitch":655,"grows":9671,"intertwined":25879,"pooh":22244,"convo":29322,"crowded":16703,"germ":15145,"aer":37698,"virtues":18688,"paleontology":25326,"hawaii":5928,"headmaster":19196,"jane's":18616,"zeta":19248,"yepes":8898,"songwriting":31842,"vbutt":48462,"residences":30508,"promoted":3357,"voiced":9066,"soup":9264,"felling":47452,"subsections":8236,"texteded":38300,"harlow":35650,"bizjournals":47400,"ahot":18770,"postcode":34643,"200px":32995,"veterinarian":40190,"modulated":45259,"curt":20485,"sheik":25718,"einstien":47563,"slavish":46542,"deed":12958,"relish":32065,"abundantly":12681,"grew":5451,"exacerbated":36418,"chopped":17063,"shrift":49857,"levine2112":45927,"encyclopedical":36843,"voulez":37015,"verdicts":31132,"jacque":34219,"disfunctional":44656,"evangelicals":15916,"inquiring":27296,"subtropical":20056,"aft":28340,"safe":2564,"lyman":31851,"wikitime":37629,"bogged":15256,"nasty":3355,"trácht":17928,"emperors":14786,"masked":13000,"holechek":35495,"wien":47967,"vivid":28499,"divorced":10454,"confectioners":46979,"snort":33501,"morphing":37631,"reduction":6603,"morbidly":31211,"gorman":48895,"colorful":14087,"interpretations":4089,"stud":19074,"wish":529,"musically":26401,"inductor":43980,"rejection":7484,"smile":3642,"path":4052,"ne":8490,"yorkshire":11225,"dis":9568,"bribery":23679,"compensating":37519,"overloaded":23203,"improving":1591,"fuckwad":31070,"ver":22916,"dignitary":47243,"utah":10878,"leuren":46471,"decree":10583,"mugabe":31613,"portraits":12334,"deanna":37523,"ending":3419,"palatine":40745,"rearranging":20984,"purrum":16286,"contractually":40949,"brythonic":33068,"edged":28043,"from":31,"greeks":2896,"calim":45077,"copycat":39347,"mirrored":20117,"wordreference":49641,"org":366,"makedonji":33442,"overhaul":9929,"hitters":31779,"enlarge":19511,"chocobos":5658,"leprof":47091,"puppetmaster":22101,"rue":24599,"veesicle":24738,"dutifully":44964,"tawker":17210,"rallies":16991,"militancy":20778,"hindsight":13242,"b5":15492,"disgustingly":32299,"discouraged":4949,"assigned":5533,"airbender":22173,"classical":3154,"moment's":31094,"breaks":4651,"persecutions":31133,"motz":39676,"mythos":25579,"sonic's":32573,"relational":33072,"griffiths":35221,"comprehension":8333,"quintessential":43431,"enterprise":7230,"company":678,"cattle":13324,"batteryincluded":19376,"breakers":27658,"cosmos":18233,"aro":44956,"tightening":23447,"behead":35846,"referral":17577,"contflict":41522,"zeppelin":14816,"takeover":14587,"behoove":48143,"rejects":9737,"knights":10516,"ultraviolet":46729,"croc":45163,"profoundly":13249,"cooke":28011,"meanspeed":44019,"hopsonroad":40629,"schedules":12894,"squatters":38893,"climbing":17821,"suspensions":41972,"shootings":18827,"ofsted":29406,"playing":1580,"mama":12341,"talk • contribs":12196,"flaming":9713,"idiot":1005,"instructions":2288,"mundane":19165,"hugs":14182,"rambling":8939,"collecting":7543,"wald":43498,"allude":20644,"elitist":11102,"taskforce":18148,"tuðman":34664,"breweries":20318,"revue":29553,"expunging":49040,"roarr":34666,"agents":5769,"whiners":47094,"interjecting":49463,"wallpaper":27507,"formulation":9230,"огород”":48568,"'your":28610,"littering":36159,"unaccompanied":45696,"delte":37470,"rajkumar":46982,"passed":2181,"isaac":10568,"tetrads":45488,"manu":21716,"mumbo":42677,"babri":42513,"teasing":48351,"twist":6654,"misreading":13972,"hush":27873,"legality":9627,"kossler":46607,"fracking":30093,"detectives":32559,"infinitum":19587,"kipper":42325,"rephrasing":11048,"floss":46089,"sina":12046,"scammed":48020,"chriso":11316,"etzel":41611,"ar":5673,"colto":21110,"banker":18314,"sadiq":41122,"magnetic":7518,"guse":46899,"wexp":31700,"weekdays":44645,"cyrus":9620,"carts":45982,"editted":18024,"ñ":38900,"mantis":40759,"chak":31897,"'community'":44005,"functioned":34853,"webhosting":37478,"holocausts":48137,"men":1148,"konkani":15797,"goan":48053,"veni":43723,"dufus":22213,"ecoleetage":42068,"bridged":43674,"colleen":30988,"margins":22079,"icmec":31846,"askin":44785,"dumbo":26880,"redeem":25231,"explaining":887,"selves":18362,"decoder":44631,"governor's":21868,"disillusioned":19518,"parc":39223,"supress":20695,"serbian":2562,"chase":7331,"ravidasias":42872,"joao":45852,"conroy":34118,"wank":15411,"cculber007":46891,"deepak":11095,"threatening":2600,"nightmares":25253,"gac":15543,"salvador":8883,"bowe":37703,"'mass":48028,"mughals":14253,"dia":25584,"reprove":44737,"waltz":22450,"adams'":38069,"indefinitively":47822,"noc":15743,"sacred":6414,"profound":9034,"hazare":20110,"misbehaved":45509,"netball":28273,"opensxce":24375,"follies":48366,"possibl":44679,"knol":20652,"umeå":49365,"grammars":36773,"alienated":28393,"carping":39915,"incubation":49504,"antibiotic":48718,"attractions":14545,"jubachina":41059,"updated":1501,"turbo":16786,"preferences":4442,"shalit":47433,"skeletons":27163,"report":553,"world'":25193,"actully":35432,"earliest":5631,"fundamentalists":14867,"fraser":12650,"acknowledging":8686,"organisms":9128,"ilir":36523,"arm":4704,"debateable":44919,"birbhum":39737,"brilliance":18218,"hiphop":13712,"architectural":10025,"perched":29979,"circumstances":2969,"here's":1444,"admonish":32653,"hallucinations":35164,"afrocentrist":47602,"hipocrite's":47979,"voluminous":25454,"locos":26020,"italicizing":34542,"rosenberg's":39853,"odds":6938,"whedon":39774,"decried":47663,"avvocato":25738,"gc's":48382,"hotcat":39605,"shaikh":27727,"paw":25262,"ornate":39233,"eyesight":26541,"kde":30398,"profs":29875,"eminem":10664,"darth":12778,"noting":4102,"sucka":43150,"finnish":6078,"awardhttp":7849,"lava":17696,"forsee":42428,"conjunctions":47950,"communists":5526,"idoit":30690,"ammonia":33084,"leukemia":37365,"´´":47718,"sultan":11971,"foreskin":7996,"saluted":47158,"command":4074,"anh":34440,"clearinghouse":43592,"sheffield":14961,"slept":13756,"amigo":22562,"nameserver":43355,"bunch":1657,"maize":21558,"cossack":44482,"mountains":5367,"petersen":27002,"encylopedia":8513,"thoughtfully":43014,"governmental":8356,"dialog":8517,"l2":30362,"violators":10732,"refining":25129,"pointedly":30724,"exemplify":22654,"experientia":46429,"město":31902,"megatron":34049,"nocal100":32605,"español":37641,"theclownprinceofcrime":37113,"dmacks":16206,"mikeycanuck":45992,"slater":20681,"logicus":33469,"beans ":46390,"moronic":8547,"births":12892,"puppeteer":21834,"reprint":12782,"jsessionid":45350,"'as":27675,"proably":42682,"thnks":43493,"plunge":30046,"monopolized":36952,"biographic":26670,"dogo":39835,"uw":9520,"torment":24838,"cautions":27844,"acorn":11181,"saddle":12049,"bogdanov":13320,"pesticides":36398,"rte":46691,"translations":4068,"rewrote":7867,"nihonjoe":15047,"qualifications":6918,"zeros":21995,"subtracting":32903,"unspecified":6448,"source'":24424,"frist":23665,"analyst":20284,"geim":31834,"diatonic":42953,"ridden":16889,"deprive":37555,"timetable":20664,"diligence":8262,"unfamiliar":5846,"12th":7116,"mesoamerican":40772,"mvi":38791,"dedicating":34849,"lambda":21795,"behaved":10722,"integration":9747,"unprofessional":8970,"dragutin":46293,"timeless":33125,"beads":22454,"reworked":12923,"evader":33723,"galactic":11694,"chops":28149,"ers":19260,"businesspeople":37289,"publishing":2964,"munafiq":40522,"shitload":45780,"swanson":48748,"decipher":16165,"lot":352,"provisionally":33781,"uml":24565,"padua":23226,"comport":49860,"fabricating":21452,"calculation":8995,"brünn":36562,"polytechnic":18600,"ketchup":24102,"triva":38888,"pembroke":28698,"generates":12553,"exonerated":26938,"hillbilly":26480,"guggenheim":45290,"unit":2542,"organise":19652,"labeled":3952,"albanian":3066,"point'":36269,"hebephilia":42846,"kangaroos":44950,"gertrude":30545,"melts":35909,"khanate":31496,"virginian":42972,"fam":37130,"cabalism":46537,"differentiates":31193,"easier":1647,"mmorpgs":44034,"docheuh":21571,"inadvertant":40278,"colouring":42347,"mick":12669,"mywikibiz":41026,"prototypes":23876,"ships":4923,"auxiliaries":38359,"unattended":48510,"subordinate":16077,"boulton":38196,"sacrament":23810,"ost":33490,"basilica":34261,"wikinazi":17700,"half":973,"septenary":38219,"overreacted":31395,"generously":39885,"memorial":5784,"momento":34258,"mcdonald's":16033,"goals":3427,"aca":37188,"shes":11578,"winick":37649,"wikilinking":21164,"refinements":47031,"spb":49102,"creamy":46462,"vilify":27851,"tonkin":27722,"cabbage":33096,"modulation":31228,"subluxations":41546,"eloquent":20052,"patton":17386,"controvercial":44563,"shiddazi":31129,"paradoxes":15139,"personnal":20418,"hudgens":23422,"perfected":30162,"psychotronic":47804,"ranging":10320,"ahmadinejad":10209,"emblems":22594,"homes":6723,"duplicating":12794,"seyfried":33833,"skyring":33341,"solver":14445,"ketamine":30252,"prepositions":29610,"roker":38158,"rastas":37700,"goldstein":17086,"commercial":1813,"lysa":44006,"brightness":25410,"jossi's":38270,"spray":18500,"locomotives":26441,"ssrn":34769,"alludes":23675,"coherence":20904,"queues":35162,"tracing":17412,"yajna":45899,"documentaries":12168,"industrialized":28366,"fanclub":43481,"extravagant":36864,"flipora":34232,"misnamed":36160,"tibetans":16087,"utterance":46562,"palace":9419,"fingers":6496,"amy":9998,"misunderstood":4869,"lex":19053,"atzmon":28046,"posturing":20372,"poo":9460,"unitarians":43558,"earthquake":9303,"parliaments":24449,"straightforward":7204,"peres'":43780,"shalwar":23658,"disproven":13582,"the":1,"ethnic":1337,"terrilja":40475,"joy":6270,"olden":39972,"summerphd":18392,"inserting":3537,"pathway":30238,"francisco":4447,"emptive":36047,"heron":27609,"exacted":46304,"skipped":12860,"years'":25162,"sgi":24297,"internationally":6714,"user":91,"rent":12377,"adornment":43029,"federalist":20620,"thanksgiving":11063,"lond":40531,"panathinaikos":33964,"hermetic":37404,"hyman":28490,"int":8224,"deb":19084,"seamless":28207,"waya":45453,"conglomerate":33567,"yolmo":30744,"ndf":44080,"welcomed":6210,"aegean":13132,"compatriots":42319,"discouraging":12788,"prado":43567,"destined":21415,"judas":14295,"baffles":36813,"soa":22880,"dust":5441,"passions":17946,"os":5737,"resubmit":8112,"decreased":15134,"40s":24457,"shortens":31806,"breton":20031,"deduced":27119,"adolf":6314,"sensible":4544,"sparse":22569,"haematology":37778,"irredentist":23795,"bugged":29684,"darkwave":34728,"carelessness":33966,"mubarak":29386,"plane":4519,"subway":9394,"phelps'":28072,"mincing":48930,"downplay":14671,"mcdonalds":21853,"coach":6493,"spielberg":31350,"'far":31980,"bites":18176,"frickin":26220,"—gr":17768,"underscored":33698,"trojan":14436,"scandinavians":37137,"mucus":39664,"beginner":16238,"raúl":49572,"mol":34677,"ordeal":17590,"pirates":6088,"inadequately":49034,"smoking":5755,"cursed":15680,"kamen":26705,"''''let's":18051,"cultists":23550,"california's":43568,"tudjman":32860,"merkel":19923,"imf":14383,"conti":33030,"constantine":13094,"beijing":11830,"steers":45639,"smokescreen":25371,"knight's":22922,"breaking":2914,"bjp":19853,"cult":3156,"frustrate":27514,"büyük":46953,"racialist":33692,"vanessa":19402,"dictates":12768,"belive":6923,"striked":48967,"moyo":32950,"۞":36357,"automotive":17809,"ka":8709,"bohr's":49985,"atlantis":16713,"calmed":19125,"adminstrator":11742,"essentialist":48958,"spreads":14997,"zhou":33563,"pigeons":46679,"threads":4593,"retelling":41961,"mies":41537,"overwriting":36883,"vision":4509,"shiloh":11816,"'needs":39716,"channel's":35419,"ultimate":4142,"fffffffff":49097,"lao":11124,"genetically":11528,"mainframe":31651,"doll":22726,"chic":26734,"adolfo":42026,"mckee":20437,"unneccessary":25977,"krist":46120,"abs":14972,"compass":10641,"kittybrewster":40464,"kippur":28615,"goof":10483,"youtube's":43330,"persians":5363,"1930's":17459,"succeeded":6459,"glue":21568,"entrepreneurial":46658,"svd":26970,"pv":25869,"käse":48522,"doubted":16628,"unfortunatly":22249,"mocking":9298,"vertices":27365,"nihilistic":35324,"savior":21217,"enabled":7684,"preparatory":46780,"capitalism":6960,"spinningspark":23212,"repudiation":40313,"transverse":29363,"humbug":14933,"blatently":20951,"romeo":13853,"influenced":3759,"point":146,"disproportionately":32663,"meddling":18592,"rallied":39810,"onslaught":30788,"lefties":33715,"bogue":34823,"hungerford":35666,"walker":6876,"procopius":26086,"substantively":26474,"appoloboy":43948,"yec":30821,"sociological":12204,"duffy":21349,"shot":1766,"westward":48535,"warrington":22633,"taunt":24936,"condescend":30623,"martino":34991,"branden":38717,"banes":43488,"tackled":19079,"skateboard":32203,"kalimantan":49910,"redlink":8991,"solids":39852,"signature":1978,"sarıkaya":49523,"tells":2621,"digs":18461,"wroclaw":37665,"servings":48371,"intensity":9403,"filing":6502,"anders":19932,"bachmann":30234,"crack":5854,"swallowing":32839,"tiamut":18383,"quadrupel":43937,"unrecognized":17860,"bypass":10809,"kdka":25005,"jake":7964,"sobriety":41446,"muktananda":40706,"fiennes":40737,"d's":22282,"uniqueness":28802,"blanc":26948,"ducks":15076,"belinda":33912,"message''":45801,"whales":10594,"archive2":23821,"avg":28277,"spiked":42382,"hicks's":43279,"jodh":42596,"flights":9468,"milestones":17551,"bitstream":40751,"nlg":31406,"advani":45606,"јули":48469,"smoot":41874,"scruton":40359,"rigging":38256,"neo":2979,"isolation":10934,"apon":32250,"strider":47683,"scribblebook":36978,"bearded":23897,"flame":6058,"spinning":10964,"rock's":42565,"mann":6008,"fourteenth":39377,"colons":18672,"ina":18027,"disapproves":45463,"rosenberg":20537,"displaying":7766,"reasonably":2995,"incapable":6742,"afganistan":36090,"marketplace":22384,"equalizer":45173,"ealier":38099,"quintessence":41475,"←→":43821,"slashes":41806,"showcased":32318,"catwoman":27526,"captors":38672,"tritium":31798,"brushing":26011,"pluralism":44051,"ergot":48508,"wikilawyer":22541,"num":13716,"ohm's":28840,"pcap":37886,"1rr":10600,"ashamed":4652,"museums":11962,"rajdhani":38299,"herself":2933,"ryūkyū":42144,"apuleius":48654,"athenian":21586,"smeared":25266,"bowel":29783,"china's":21121,"sudanese":37377,"honcho":48280,"glucose":47640,"marginalized":20412,"merkey's":48763,"accuse":2234,"lakshas":38657,"presley":11314,"anaerobic":48714,"therapies":11907,"rules":430,"pfizer":32317,"countered":15236,"soundtrack":7276,"finalisation":46635,"polynomial":23992,"crucifixion":15589,"kemal":25946,"asx":30294,"manslaughter":36098,"chester":3022,"socceroos":45036,"fsf":20032,"finite":8537,"archival":12013,"tizoc":38769,"concering":45292,"transcontinental":30628,"instance":1410,"rodents":25096,"headline":4526,"substructure":36399,"textbook":5314,"orgy":19312,"chihuahua":27812,"photographer":5843,"wa":9661,"carved":16058,"phase":4355,"ohio's":33775,"inferiors":37246,"awwww":40939,"stradivarius":42004,"strengthens":39335,"trusted":4982,"gutted":19431,"exactly":624,"bubba":29845,"avidly":33542,"textbooks":6781,"occuring":12703,"niggas":2678,"broadcasters":23225,"vast":2713,"foregoing":23780,"gfdl":2170,"slang":5474,"carousels":38288,"kentucky":8067,"challenging":6500,"gamesworkshops":45189,"taxation":14331,"kicking":10342,"fuseaction":27811,"'british":41322,"wold":23470,"individualism":45467,"ichigo's":45754,"sopranos":23983,"statue":8475,"chickenshit":46231,"photon":14473,"sagacious":42661,"clement":20715,"artemis":41054,"bands":1560,"bipolar":16060,"compelling":7397,"tobago":31593,"average":2128,"wikibooks":13811,"burners":46267,"milage":47621,"dicta":46475,"magnet":13553,"positions":2681,"008":42646,"ra's":35151,"intern":28417,"waterfall":31006,"unalienable":34293,"concacaf":42983,"spylab":12699,"knuckle":23812,"kuhn":26108,"andranik":28101,"tg":11057,"antipathy":43071,"ustasha":38546,"titch":34513,"'nazi":39188,"repressed":19802,"scared":5588,"dicked":8636,"tvoz":18862,"evergreen":23923,"balloon":15289,"barbaro":9811,"opt":7526,"efficacy":12689,"ram":8866,"russian":1156,"slightly":2277,"rezultatet":39194,"☠":14821,"arab":1966,"numerously":40482,"orientated":29549,"crawling":31516,"congressmen":25786,"intel":9593,"petrie":33508,"sandy":7303,"hyperbolic":17480,"cya":37341,"monks":14667,"ћ":44294,"slash":8120,"spawning":48578,"тебя":45969,"tartan":49133,"unimodal":43246,"stature":12262,"“is":31262,"denunciation":40116,"courtesy":3753,"moonriddengirl":18967,"sincerly":19487,"ecclesiastical":25221,"piece":728,"‘anti":44489,"swipe":37071,"dreamed":19212,"dandridge":46548,"talkedits":28491,"elite":6065,"carlsen":47061,"skateboarding":34476,"chatnoir":34911,"unproven":11196,"avoids":9331,"arsewipe":42832,"charlottewebb":44031,"gerson":36995,"vinnie":40019,"poppaballoon''":46486,"dnieper":31894,"w00t":38100,"napoleon":8359,"we'd":4172,"readers'":15838,"truism":32607,"phonetic":12855,"indulges":32630,"leaf":13462,"lon":36852,"beggar":34120,"navidad":30776,"marked":2696,"cops":10938,"ibaranoff":44677,"destroyer":14034,"5w":32441,"lothar":28620,"misapprehension":36964,"swaminarayan":21874,"disambiguated":12008,"automobiles":23042,"printed":3196,"limelight":37485,"wikileaks":14081,"syndicated":19711,"tamils":9975,"fuckk":15526,"version":395,"manfred":35052,"karatas":48245,"astra":38811,"windows":2901,"renfrew":40790,"summarization":31215,"wrestling":3291,"devices":5693,"settings":7634,"bill's":20260,"foetus":34877,"anally":24429,"troubled":11288,"unconditional":20629,"nlu":26037,"westchester":40845,"diskussion":28974,"grande":14478,"bulleted":15620,"unproductive":10950,"asus":45545,"mitochondrial":34439,"elses":9473,"thie":46386,"bombarding":35619,"entails":14614,"idiomatic":22075,"mathworld":23255,"contours":46611,"nostalgia":41650,"yalova":46438,"foss":30633,"ε":17011,"vesther":30867,"buckeyes":49873,"fissile":34392,"standoff":42522,"iscid":37657,"district'":43615,"proudhon":19235,"ayin":38343,"cannibalistic":32720,"dien":42300,"kvens":24311,"anthing":37890,"opionion":28081,"involve":3752,"dismantled":22927,"hedgehog":19034,"midlands":20727,"spaces":6041,"投稿記録":33943,"mmmm":16185,"250px":37913,"ethic":13907,"ambitious":17608,"countrys":31136,"λ":18787,"jules":17256,"falwell":40204,"adana":37938,"aching":36475,"theodore7":49751,"chlorine":13265,"banal":30552,"republicans":5076,"hydro":27047,"enza":30956,"regrets":14991,"lucid":22586,"pious":24055,"impinge":36186,"prefaces":48928,"attractors":33136,"anonymous":990,"pensnsnniensnsn":6165,"kwami":17132,"relies":7118,"conforming":24059,"gtc":48739,"homepage":6072,"vh1's":42690,"calendars":12571,"percy":15865,"nuanced":16591,"artpop":34903,"woven":27043,"bl":10834,"alphabetized":35130,"self":549,"malkovich":30626,"mcneight":29682,"dresses":15059,"vanna":31648,"quarterly":17265,"uber":13203,"computed":30379,"pennant":38008,"moyer":32467,"gospel":5589,"suspend":14332,"distributed":6665,"heresy":19949,"imam":15151,"2k":35827,"recollections":26754,"cannibal":26127,"blackface":49226,"poisonous":17960,"magna":19326,"t ":24550,"loik":29016,"cladogram":46748,"puntland":37298,"rational":3821,"kubura":43806,"boasts":34726,"colors":3663,"addy":30670,"gaming":4718,"bestows":39244,"trench":20036,"curator":23056,"‡":44278,"felled":48826,"evaporates":33065,"panwar":38848,"lep":47974,"deutsch":12723,"griot":25596,"leetspeak":33044,"injection":16400,"conclusionary":45008,"hides":12538,"rohdendorf":43213,"wadi":31710,"weighed":13632,"fused":23383,"meagan":31587,"prediction":10532,"utilizing":17227,"n":998,"lessens":39599,"harrison":9062,"thunderbird":34607,"nickel":17382,"cron":35743,"belovedfreak":44667,"connotation":9788,"natalya":48681,"metaphorical":18149,"meryl":43631,"wilfully":26049,"cartman":22385,"kraven":31454,"monologue":31241,"nescio":16986,"chavez":10109,"cesspool":26321,"inked":46369,"timings":35104,"compounded":16414,"succeeds":24559,"hangon":9501,"clout":24754,"peers":7429,"picayune":29658,"lhr":25421,"kewl":28635,"cvpi":49390,"spice":16739,"eagerly":16566,"tre":34239,"betty":12175,"habibullah":47880,"athiest":24436,"armstrong's":27558,"diluting":32235,"speach":21404,"rows":18025,"kinds":3277,"unsurprisingly":26244,"statistically":12216,"jsut":15719,"shelves":24641,"necessity":7722,"king007ofrock":32255,"causing":3325,"xl":27790,"recognised":4093,"multiplicity":42587,"begum":43156,"sunrise":7363,"'mikka":36855,"pacing":49295,"circuit":7087,"degenerative":45784,"genie":32107,"textlink":27150,"4chan's":43138,"doubly":16085,"distasteful":21890,"lowered":17346,"conway's":46128,"metadata":18286,"importance":1107,"seeks":8032,"renaming":3850,"listing":1750,"shoot":3870,"shem":34928,"wcs":45296,"negligence":18063,"psychic":11150,"teresa":24433,"cervical":19576,"conversion":5272,"kauffner":27104,"ewwww":41347,"exegesis":26315,"bartender":20070,"misguided":6294,"navbox":10887,"kathmandu":43663,"hella":37793,"lichtenstein":34433,"clan":4358,"blackbeard":33387,"rid":2543,"institutionalized":24921,"fkp":47051,"moan":22986,"morals":14281,"convoys":24141,"klee":43564,"website":401,"salvage":18798,"multidisciplinary":49566,"marrow":42011,"nip":28069,"abstain":16645,"phillies":43974,"communicates":17691,"r's":32568,"jeeze":48983,"cowboy":10591,"wrongful":14269,"smokes":36437,"jbl's":47125,"regulus":49617,"taxonomy":10055,"wassup":28843,"divergence":23431,"mayor":6170," ÷ talk":33588,"adtiors":42110,"fukkers":36487,"putative":19864,"cleared":6109,"wikimapia":33873,"elaboration":14782,"demonym":29727,"drury":29619,"dreidel":20612,"iizumi":17000,"steppe":12561,"heah":27492,"fallout":15366,"'normal'":44875,"aborted":26395,"mattered":25346,"mckitrick":43079,"textual":13461,"seldom":13185,"repulsed":32521,"generically":30166,"corporates":43847,"indianbio":34410,"lockhart":32652,"vernacular":9316,"closure":6864,"separation":7754,"freestyle":17861,"notifies":37063,"bollywood":11076,"responce":22357,"rada":29119,"iczn":36386,"consulted":9899,"a'":25834,"dwarves":35563,"slipshod":46455,"slated":27783,"'little":28587,"scanners":41038,"burj":23131,"mediums":23570,"boxrec":17853,"dimensioned":48493,"milankovitch":49119,"ros":45482,"articulation":42478,"snake":8825,"butokukai":36061,"chivas":38759,"lifts":14772,"occupies":18870,"ndp":10738,"nonstandard":41905,"visitors":5012,"n466":32703,"butthurt":15376,"collection":2366,"sully":29630,"trams":23669,"admin's":7538,"callin":39016,"charade":19336,"serially":45611,"irony":6179,"paula":16504,"spoken":2829,"eek":27053,"squeal":30554,"cable":7827,"niger":15062,"username":672,"nathanael":34671,"consigned":37053,"shqip":39199,"unconscious":17034,"ineligible":20544,"sopa":35086,"slum":35982,"couched":35262,"vengence":49552,"viva":10987,"cheesei":5476,"ueshiba":24378,"shack":20016,"likely":706,"minimum":3142,"comprehensive":3464,"gaijin":43314,"michig":43120,"seychelles":29205,"traumatic":23258,"julian":8252,"playhouse":33337,"sollecito":26150,"opie":28988,"knock":6223,"confederacy":16803,"tidying":13503,"suppose":1708,"flout":43914,"muzzle":27684,"satan's":36012,"usaf's":43501,"jacksons":43367,"unceasing":46647,"rudeness":6119,"abut":26361,"lied":4598,"mcknight":49453,"cluj":39484,"hiding":3650,"ummmm":37844,"bowed":36248,"amazed":8658,"philosophical":4974,"boise":47360,"reinforcements":33810,"agaisnt":36541,"loathing":41335,"sung":11689,"—  talk":10707,"waive":45602,"procuring":41660,"wre":40951,"fronting":39754,"stumps":45905,"aperture":27314,"turtle":11629,"child":1424,"participle":31014,"cardiac":25867,"strewn":49884,"tznkai":40896,"coriolis":12526,"pouring":22069,"blood":1935,"completeness":14992,"irsentience":47613,"anemia":36867,"mordor":41022,"doors":7999,"lable":23801,"rib":23365,"jws":10640,"malahide":44475,"harrasment":12339,"›":48621,"chee":43056,"combatants":13491,"rd2":18781,"poked":25379,"exceeds":16367,"poetic":15610,"cannabis":7340,"dealt":3239,"acidity":42730,"tahiti":38528,"indisputable":11568,"stigma":17505,"peak":6477,"sjo":34243,"sfacets":38722,"molly":17072,"ol":29999,"gravely":23437,"averages":20803,"yurica":46237,"conduct":2017,"snobbery":35065,"fack":3574,"moffat":37382,"awadhi":45963,"preserve":5427,"appoints":37366,"cele":47609,"alpaugh":17111,"wounded":8856,"turkestan":39865,"ure":30593,"pup":25765,"poignant":34134,"zocky":29899,"page2":42169,"iron":3837,"danski":33896,"gestures":15239,"vidyalaya":23105,"ethnicity":2751,"modestly":36931,"balls":1061,"timelines":16707,"familliar":32510,"shitstorm":38889,"raccoon":26387,"stuffed":10251,"berate":27551,"hank":14420,"diablo":23390,"biron":43989,"acceptable":1082,"bien":16976,"48px":29996,"tasc0":37016,"theory'":20758,"bloodthirsty":26159,"adapt":14455,"hound":12185,"circled":37266,"originators":41987,"proposer":19629,"大原真人":49437,"invaded":7554,"savoy":38265,"trim":8947,"stockings":22432,"supernational":49107,"arvada":45655,"bankruptcy":25469,"bloggers":11050,"cresswell":34813,"purna":45720,"mouthpiece":24087,"sanctioning":18566,"anyway":489,"litter":12115,"taraklı":31553,"specifico":41701,"nyer":33145,"lingering":21298,"aphelion":31820,"baldy":42171,"assign":12053,"etitis":15130,"nimbus":32267,"poe":22792,"lotte":45250,"gabrielf":42738,"mauritius":32740,"presume":4858,"waskett":42487,"restitution":24172,"effects":2464,"announcement":6973,"hint":4390,"wikipedai":37426,"badgering":18943,"dom":22497,"suraye":44944,"muddy":20255,"satisfactorily":21642,"significantly":3461,"miscarriage":15606,"malfunction":25845,"montpellier":27219,"'islamic":30603,"heracles":47939,"you’ll":16343,"tug":34247,"maharaji's":45836,"der":6186,"safwwefe":43249,"irritated":12662,"ups":6296,"unsourced":1219,"aerospace":22508,"plan":1741,"preventive":22947,"movable":33031,"signposts":44691,"eager":8095,"frankish":16358,"conductive":43087,"perez":18085,"disambiguation":1430,"marcolfuck":3278,"d'or":22899,"panther":19527,"mansfield":23844,"conceivably":16104,"stfu":12340,"bordering":10310,"blues":6198,"americorps":11447,"reblocked":15890,"hei":38936,"he’s":14042,"links":217,"vvvvv":41253,"cocked":30786,"©":7569,"forcibly":14013,"bj":27270,"hauling":28666,"blatent":13124,"bakharev":36535,"nebraska":14090,"nsongs":30306,"specifying":10126,"truck":7193,"overpopulation":40950,"'hispanic'":48954,"polytopes":47330,"stress":4218,"luminaries":37795,"shaka":44841,"herman":14627,"unblocks":21842,"clip":6922,"correlating":48045,"things":219,"havrå":48489,"unjustifiably":25891,"epeefleche":24991,"sleeves":24851," —jim":44539,"satirical":18275,"augusto":20832,"bologna":47798,"tiem":46788,"indications":12649,"knoll":33290,"fenway":29037,"simone":40540,"6pm":25136,"desysop":17718,"§":8829,"hattersley":45018,"gorda":47142,"hashem":35823,"womanizer":45704,"troops'":46539,"cpc":23148,"debunkers":34931,"toyota":18341,"instantly":7422,"liars":5467,"uthman":33340,"niels":42430,"britanica":30082,"lithium":16945,"ambar":49090,"cropping":22168,"się":41854,"16s":39555,"d'une":49445,"assay":31632,"dwight":30637,"parmo":49501,"sarasvati":34907,"spades":24589,"scheme":3795,"bma":38210,"associated":1673,"phonemes":27883,"“my":27042,"pair":5189,"including":466,"neighbourhoods":25909,"tenants":41688,"restaurants":12077,"confidently":23324,"stampede":42320,"bravery":30423,"wrote":524,"gratification":28834,"term":379,"swindon":46590,"hehehe":23076,"functions":4794,"leaves":3689,"flea":28714,"ossetia":8565,"client":5200,"srs":24398,"tabulating":27308,"thunderstorms":48695,"gaffes":32536,"stumbles":42336,"propaniac":44895,"bilcat":23883,"resolute":19604,"apatow":49770,"halted":25137,"theoretic":27214,"grief":9061,"gamerankings":45716,"vans":30513,"ringa":41678,"inferior":6215,"condone":13948,"visitchitradurga":48203,"brfa":37642,"geaves":25010,"perseus":23521,"acupuncture":10848,"brevity":15801,"indore":43704,"paolo":27806,"chelation":48184,"rods":18413,"unchallenged":18215,"kane's":44937,"shi'a":18581,"mihal":31552,"reiterate":8473,"boychat":39100,"capable":3685,"interest”":19029,"symmetric":22042,"defensive":6346,"repeats":10218,"develope":35984,"rsazevedo":25689,"8px":6533,"presidency":7667,"barred":9765,"barek":14584,"demanded":8231,"bots":4673,"byzantiums":43930,"concern":1361,"tryna":29674,"overdue":13625,"»":10700,"stairs":17895,"uncyclopedia":10770,"schindler's":36273,"soul":4280,"30mod":30410,"legoktm":28305,"itaqallah":15864,"insights":13847,"it”":27396,"coogan":48192,"enthusiastic":10853,"catcher":20139,"dawkins":9107,"extremly":29967,"whinsec":24255,"malware":16046,"derides":45973,"upright":15342,"‘wikipedia’":44231,"elswhere":40729,"primarily":2782,"gundagai":16733,"reef":21557,"fall":1876,"rumor":5758,"pasty":42456,"justifiable":10150,"guarnello":45812,"mate":2941,"4k":45798,"delegated":35702,"queried":19337,"cqc":31895,"gaap":23062,"authoritatively":41965,"secretary":5098,"muppets":23932,"redacted":10306,"perlman":46934,"hutchinson":19545,"crumbling":41590,"coronation":19097,"enter":2950,"elizabeth":5049,"acording":24481,"semiticism":43074,"spraying":48325,"zog":38216,"colscott":24859,"boycotted":34127,"cricketarchive":42461,"roque":37833,"lodhran":44218,"intuitively":20948,"crankish":28115,"eula":27041,"vehicular":45941,"tacitly":27769,"finessed":47844,"003":39666,"hrw":12683,"tantamount":14104,"spoils":29501,"gws":39487,"mouvement":45481,"☘☘":27037,"insubordination":22024,"pest":14290,"antonescu":22483,"img95":46174,"dimensional":10381,"wikistalker":30262,"tile":44866,"pursuivant":44106,"pea":31370,"becomes":2217,"kdbuffalo":20105,"denigrate":19182,"abedin":38160,"cberlet":22123,"ample":7474,"crescent":13702,"explodes":29516,"ex":3212,"hatred":3845,"thefinancialdaily":42558,"duality":19249,"homestead":38350,"hadn't":3098,"canvass":12826,"garde":23106,"lifted":4822,"prekmurje":34543,"puberty":27910,"flick":17784,"billiard":47549,"taller":11992,"patriarchy":29752,"solarsailor":49362,"kills":6837,"politicized":17037,"dominik":47202,"paused":42425,"twits":30339,"wedge":9212,"photographing":28648,"podous":17123,"uprising":9087,"substrate":39616,"obsessed":5408,"moustache":35489,"bells":14411,"imitating":23185,"establish":2459,"rebbe":11976,"aspirated":32695,"sausages":30248,"raz":27368,"nemesis":15025,"formatted":4255,"soto":36701,"drm":13419,"annotated":21391,"luther's":34546,"unimog":25745,"ganga":35116,"giggy":30239,"jaguar":26676,"crusio's":20560,"wed":25109,"3g":24711,"leah":23867,"nationality":2436,"toddler":36841,"liz":10799,"mitigating":34074,"harrasement":39879,"taglines":23156,"provocations":48005,"logo":1875,"sib":35835,"aquitaine":24120,"powerbasic":22984,"jay's":27474,"tiresome":9067,"delet":25157,"jéské":9121,"abd":12604,"subtly":16189,"elaborated":14165,"gone":1118,"shear":26185,"tanks":4967,"expend":40682,"dayton":20263,"merbabu":29907,"hansen":18174,"scholars":1997,"abigail":46749,"'personal'":37961,"fot":35176,"colleague":9662,"shhh":41348,"refuting":12473,"perpetrating":26382,"islamofascist":48816,"dramah":39382,"fheis":18296,"xxviii":20985,"craig's":40049,"moses":7988,"dana":11623,"genealogists":33819,"aqi":23117,"resumes":23857,"haram":27635,"disco":8001,"bhp":40372,"deadlinks":49288,"biting":11001,"explicitly":2195,"levity":32332,"male":1976,"qwerty":39127,"baboons":39326,"inserted":2587,"umeboshi":39064,"rever":35011,"node":8773,"wargame":31839,"always":375,"proceeding":9707,"delinquency":44609,"wat":8131,"joof":35353,"negative":1273,"ejected":22700,"analogy":4892,"melayu":42401,"dissolved":11676,"lacy":45745,"unknowing":46735,"smyth":25444,"flowing":15783,"cbsnews":42993,"parasite":20405,"abilities":5687,"wing":2004,"retitling":36742,"paranormal":10913,"ou":11336,"juncture":28202,"footballer":6885,"condoning":19595,"allready":13883,"gots":43220,"cliff":10258,"hostilities":17268,"tesla's":29737,"prevail":8568,"gratified":32539,"fvck":49492,"angevin":31692,"solomon's":34696,"pronouncing":25642,"miner":35105,"ano":44180,"glen":10237,"leotardo":41027,"loading":9875,"iyogi":35196,"toads":28538,"fy":32866,"whoa":10820,"booster":22405,"sapien":40191,"paragraphs":2275,"superscripted":34056,"herbeck":38441,"collateral":11851,"oldest":4792,"salafists":40560,"white":682,"mediating":21929,"belle's":9742,"balcony":21635,"cores":24930,"flashbacks":28093,"kisses":16790,"expletive":21712,"munsell's":49517,"lhd":36280,"shake":11725,"angst":30482,"blockable":11519,"acknowledges":10653,"administator":32344,"'t":34487,"eldar":28684,"indiscriminately":19945,"small":636,"morava":35269,"vanniyar":32826,"wreckers":48251,"dong":11138,"caps":5504,"garzo":49948,"sirhind":35149,"vogt":44167,"yi":19705,"goutte":25586,"judean":40490,"tribunal":12551,"nach":39117,"cofs":37046,"inclusionists":36421,"outlining":21063,"macdonald":11660,"onus":10367,"philologist":36869,"intransigent":22560,"talents":16800,"relations":2684,"hypergyny":31870,"ono":42850,"philip":6411,"loong":42822,"kramer":20969,"thieves":21038,"dane":13892,"hymn":27774,"20research":47574,"hetrick":48561,"accurate":851,"driving":4439,"terminates":33971,"7e":10330,"tj's":41731,"indiscretions":35406,"corp":9787,"selling":3811,"kraljević":44334,"dass":27561,"object":1640,"obscene":9190,"emirates":18746,"offensive":1476,"pediatrics":44089,"tomwsulcer":38690,"apr":2580,"phnom":32081,"notablity":38055,"consumed":14969,"fortson":45974,"sa'd":23223,"ga2":28747,"‘the":16541,"supreme":3091,"pimping":29612,"synopses":19363,"clasico":45281,"truthfully":15006,"warriors":7697,"oun":38179,"black's":26914," 雲水":23507,"kuban":25783,"adminitis":32628,"adidas":33496,"amid":18521,"public's":26889,"twitchy":48218,"claimants":32817,"fragmented":20585,"oaf":43416,"cyde's":34864,"god's":5280,"penalize":23704,"lb":15416,"murders":7677,"sastri":18582,"thornton":16862,"stoping":27906,"widely":1732,"bailey":6863,"plague":11041,"romanians":10688,"finalists":26292,"awsites":31695,"thickest":45360,"antagonistic":12754,"ondo":47857,"doubles":19323,"downing":23040,"volition":22127,"necessary":841,"boss":4999,"link'":43334,"standardized":11058,"allopathic":34031,"mighty":6912,"utility":11476,"danielcd":42604,"rossville":39125,"wright's":28173,"popups":11666,"tf":20960,"rfk":30730,"peacefully":15192,"untrustworthy":17636,"bogdan":22253,"needful":24895,"inferiority":13758,"dickface":13768,"publically":12593,"crabs":30204,"courtyard":26877,"deductive":33724,"effeminacy":41342,"flint":22337,"pascal":14100,"commoners":46995,"interferometer":33629,"alun":24551,"proportions":16584,"heights":8294,"typographical":21438,"domineering":22547,"dunk":27973,"residential":11979,"bouncing":23035,"sagging":48833,"philosopher's":30001,"chalukya":12405,"bennelong":43905,"of":3,"render":2724,"5th":5308,"compressing":37675,"jehochman":9818,"similiar":16233,"empowerment":29851,"decently":33020,"marlene":44498,"aggressively":10556,"incidently":20037,"completley":38063,"accommodate":10289,"throwing":3984,"diesel":9538,"enforcement":3614,"inadmissible":24843,"internet's":33329,"decison":46772,"sinhala":41339,"frenchmen":40779,"話して下さい":24965,"spurious":5511,"insignificant":6378,"bertil":28344,"gsnguy":29702,"legible":26316,"stickied":42580,"gamecenter":43967,"djathinkimacowboy's":11280,"venezuelan":16701,"sephiroth":45057,"numerically":25927,"middle":1159,"montreal":8379,"mkultra":35595,"daytona":33602,"undertaker":10149,"saddens":34874,"com's":17220,"nme":24681,"accessdate":11814,"peek":15021,"000th":40300,"ergo":9964,"expiration":24158,"calculator":16251,"tyke":47543,"tong":25237,"merry":5193,"identical":3549,"realizing":10043,"rapid":5583,"mexico":3520,"vincent":7690,"schoolers":36704,"polymorphism":39039,"incompatible":9332,"admited":30754,"inception":19229,"caballus":36531,"agreements":9154,"truth":586,"robb":28649,"1970's":13701,"poseidon":24192,"willard":36682,"unanimity":25012,"beit":26976,"detect":8316,"avon":26192,"citing":1450,"moldopodo":32679,"confirmation":3862,"untrue":3669,"succumbed":29713,"jamaica":10784,"chandra":17431,"abf":28795,"inhibit":48194,"screens":11310,"“police":38620,"agf":3257,"loco":23290,"pavement":39110,"hog":12059,"wannabes":23840,"feminine":9957,"competetive":48292,"rating":4190,"honourable":16812,"smithsonian":12930,"lynch":8020,"creationist":7814,"genocidal":18552,"beecher":45616,"✔tea":16834,"broadening":38915,"gloomy":36039,"mistyped":46831,"approximate":13006,"ameen":49418,"swarms":41984,"embroiled":28730,"muni":35533,"reservations":12116,"californication":32515,"koavf":25897,"immolation":29855,"alm":44771,"overwhelmingly":8044,"verlag":36961,"endorsed":8034,"assesses":45451,"wikipeidia":19129,"slobs":46743,"quarrels":33052,"breathing":9659,"purgatory":41013,"gringotts":47253,"nar":18356,"artillery":7989,"denialism":13555,"query":4408,"poorly":2663,"provocative":8170,"richly":21772,"bolzano":18518,"targets":6567,"maududi":32634,"younus":35839,"modernists":29461,"damianides":48823,"scientifc":42533,"mbc":21228,"rfp":48288,"wel":32058,"skinned":8706,"v3":32330,"customize":14770,"yellowish":35060,"reservation":16581,"tarc":28036,"koeckritz":49265,"believed":2565,"schoolboy":46811,"seymour":19462,"'selected":48706,"ballots":22534,"barrow":18969,"convicts":31668,"pushes":12819,"wikilove":4247,"keenly":41942,"demolished":17875,"convergent":36050,"sfa":27486,"experts":2597,"misinform":26101,"project":482,"fave":31982,"populations":5168,"softer":21988,"prescribe":27628,"attire":25914,"acuman":32802,"'pop":46252,"todd":8047,"bethesda":34559,"hamlet":13225,"roswell":34270,"bachelors":32049,"tainted":11876,"macon":20143,"substantive":6075,"schemes":10153,"endanger":26525,"subarticles":14573,"starred":13286,"leverage":33959,"bittorrent":36114,"raine":31745,"steele":16036,"academic":1309,"dismissals":35059,"milion":25269,"airports":10059,"ruling":3818,"validly":22595,"pass":1776,"reformer":33773,"jersey":4234,"outcry":25843,"conjures":46645,"olympians":31165,"dreams":7010,"goatse":28383,"ri¢h":36785,"alway":43333,"elastic":39073,"rubinstein":46654,"utilizes":28762,"willmcw":18702,"gpu":28911,"militants":14028,"questionnable":28241,"prospect":14438,"retroactive":24421,"disingenous":42145,"reeve":38497,"beryllium":23087,"ssr":22458,"alasdairgreen27":32896,"exclusive":4336,"endangering":40698,"raged":48516,"ment":12477,"pseudoscience":5106,"daimian":43463,"lazarus":36939,"mozambique":28146,"smackbot":14168,"thinktank":41044,"quandary":37319,"meters":7008,"pwinsider":46870,"instigating":28172,"discernible":30319,"lower":2003,"humiliation":23443,"jvm":31736,"chilean":17234,"utm":38108,"zeit":28556,"temporary":3833,"vermin":30072,"malheur":45920,"imperialists":24150,"sensational":20788,"wetman":32696,"borneo":30506,"kylu":22729,"humiliated":20532,"laramie":48431,"naik":16727,"loser":1510,"populism":21041,"emphasize":6606,"cuntbag":3643,"user's":2822,"ħ":22050,"extrapolate":21002,"hullo":45336,"barrelled":46667,"rastafarian":38619,"kickoff":45275,"extended":3334,"lakshmana":44010,"hardy":8923,"disregarding":10919,"chicagoland":32353,"defender":7311,"bac":39841,"tournament":5269,"wrongness":49475,"sligo":39204,"western":1278,"adherents":11097,"webtrends":36161,"farm":5090,"scrubbed":24554,"causative":49772,"body's":27569,"believers":7845,"ther":9558,"arriving":11792,"admonished":16740,"jockeys":44588,"abhiras":18759,"oprah":13057,"wronged":20207,"appendix":20899,"shoplifting":37644,"uneven":20581,"newbyguesses":44412,"existed":2294,"• ":32054,"retardmongo":27247,"penises":12584,"skelter":25675,"tubers":36268,"emergency":6476,"drpizza":37710,"geological":12493,"illinois":6488,"transmutation":28940,"harming":14906,"massage":14195,"spectra":27101,"paging":26290,"determine":2028,"aunt":12506,"address":418,"zervas":13645,"😜":19568,"titleitalic":35675,"ordinary":4194,"wizardman":48745,"cannibalism":16904,"advisers":39987,"—❤t☮c☺m☯":16401,"instant":6259,"configure":30975,"sources”":43955,"urban":4152,"poking":15602,"sodium":20489,"universal":3653,"lindy":35282,"explanation":688,"laude":29105,"ceremony":7678,"lmao":4015,"condominium":27106,"nvvchar":21146,"stink":11349,"worng":47294,"sheldon":23578,"brotherhood":9463,"extremist":5490,"hark":47144,"snatched":39715,"furry":11835,"unfounded":4512,"cilia":47891,"singly":32046,"overarching":29654,"detection":12215,"doubting":16630,"accepts":7798,"institutions":4564,"weber's":37874,"peter":2111,"liang":33564,"scot":12608,"'pov'":31172,"revealed":3920,"vern":43028,"eur":49899,"rouvas":38833,"etymologies":23512,"organised":8157,"amory":45525,"freinds":25300,"songs":1995,"“criticism”":33228,"aleksandr":28412,"transcends":44487,"ustaše":28217,"behring":47263,"refactored":16765,"gentler":46473,"mockery":12125,"individual's":15008,"basements":24996,"gauges":22257,"lubavitch":38787,"moshiach":17829,"restructure":26515,"svalbard":43872,"unduly":15659,"manche":41618,"binds":49075,"invert":43223,"autoblock":8858,"entrepreneurs":36116,"spouted":27286,"robinson":7530,"drugs":4140,"pres":19581,"bones":7765,"disqualification":33194,"offer":1500,"submitting":6188,"spiritus":37911,"intrested":25323,"notable":316,"kaff":13812,"upload":1409,"testable":19150,"curricula":35876,"explored":13283,"cradle":18849,"homeontherange":36888,"grubby":45643,"layman's":32240,"roadrunner":42399,"stevenson":15637,"hens":40495,"hydrocarbon":46792,"sparta":16808,"wikipedians":1214,"150th":39126,"inarguably":47948,"cnet":20562,"'people'":44761,"4g":47648,"roads":6125,"graphically":26171,"dichotomy":18016,"leisure":19793,"guided":10346,"viewers":6869,"fixated":32797,"pledging":45603,"gliding":24880,"marred":35805,"в":16026,"'t'":27673,"stances":15571,"acted":3913,"traumatized":44380,"constitutionality":28882,"pulled":4980,"nss":43680,"grievances":17295,"waaaaay":36446,"fabio":32388,"alexa":11758,"morris'":39390,"cetaceans":33579,"iom":38467,"jr":4542,"daicaregos":48870,"christian":993,"iata":29209,"edo":29856,"compositional":29135,"jensen":14576,"peacent":39405,"humour":5957,"favours":13571,"nl33ers":6282,"clearance":18313,"pretend":3363,"an":30,"voter's":45880,"activetab1968–present":35493,"googled":12150,"heaviest":48286,"adultvest":43135,"shiva":9985,"concert":5602,"dumping":15364,"monster":4789,"zappa's":41800,"disabled":4948,"salamurai":48499,"mainland":7777,"history's":25170,"spoon":25291,"sectional":24036,"posited":27908,"bolton":11801,"dustin":27136,"needlessly":8843,"fun":1163,"throw":2648,"kunduz":34888,"vfd":5750,"jonathan":5403,"cardinals":18994,"pneumonia":20211,"capital":1993,"serif":27305,"stagnation":45873,"o'hare":40504,"pacman":46728,"tatars":12752,"accents":10234,"flesh":7396,"naconkantari":27608,"gah":42476,"luta":38977,"edited":573,"twirled":39702,"michelle":9673,"abort":46184,"she'll":16069,"gotland":30694,"levitation":41045,"amnesia":47533,"'retired'":40063,"denys":47618,"soda":19262,"warzone":33463,"minimally":23713,"widen":22433,"yahoo":3472,"franco's":33273,"fliers":34104,"taulant":33903,"yngvadottir":47370,"☮ღ☺":26814,"explicit":4101,"croat":8588,"banja":41593,"liga":24677,"underpants":36670,"irregularities":19786,"macd":44126,"width":871,"quieter":43020,"geologist":30846,"hyperlinks":18955,"bennet":33122,"pilgrim":30837,"pah":47275,"xiv":22261,"foxworth":27315,"modernized":35657,"acid":7007,"prices":6200,"librarians":26955,"pic's":12789,"wk":20937,"berlusconi":35611,"panicked":36318,"d'alene":44613,"there´s":35394,"guessed":9336,"pottery":12192,"ciao":10182,"kuwait":20079,"mays":49455,"finitely":33900,"likewise":3951,"worldnet":44221,"mercia":39213,"hateful":8851,"motorrad":39063,"ntsc":36880,"phosphate":35326,"snake's":35606,"artid":49654,"pulling":7121,"dunc":14902,"witney":39949,"font":3409,"kierkegaard":41946,"defends":12513,"southerner":36492,"payton":44104,"lifes":21939,"bush's":11455,"kidneys":29789,"pse":49951,"sammy":13554,"imput":20769,"rfb":22145,"moderates":29274,"hugo":9992,"orlowski":36490,"“original":39284,"termini":47475,"britannia":35895,"incredibly":4238,"points":687,"hermit":16098,"mails":9257,"fleischmann":35155,"aeroflot":43844,"think":67,"latham":47206,"thurston":31043,"pancreatic":35584,"scrutinized":18999,"hypothesized":28758,"inhibits":47580,"moldavia":24174,"estimate":5590,"maynard":36657,"alphabets":18359,"tw":8646,"grovel":27700,"swivel":48495,"closes":12016,"humanoid":30566,"unsc":20921,"denied":3262,"burned":6897,"subst'd":40460,"harrassement":41068,"notre":13174,"aruna":48525,"aboriginals":32032,"dyed":48793,"williams":4383,"cliffs":32832,"caster":45012,"squeezed":32390,"tryin'":33471,"sob":14167,"guitarists":14312,"beckenham":47788,"retain":5350,"tommorow":19423,"afc":4973,"satanists":21052,"descartes":43273,"phonemic":28734,"distinctive":10725,"savoir":37801,"investigation":2151,"kozima":44138,"crea":34388,"intercity":31669,"dekker":35306,"fastidious":46825,"families":3497,"hart":12353,"withdrawl":42712,"misusing":14404,"survey":2824,"landing":6743,"bludgeon":32220,"passionately":20590,"temasek":44854,"glued":35271,"accessed":8061,"fucked":4397,"borderline":6732,"snip":35877,"truncation":38923,"theological":8555,"description":691,"straights":42236,"disobeying":32271,"lick":2856,"serum":27102,"miladin":20930,"governorship":49232,"interpreting":9691,"avgi":40243,"everything2":42878,"introduce":3072,"colin":9723,"clings":35632,"doubtful":7417,"holder":2073,"there'll":20942,"daemon":38125,"cite":717,"brigades":23838,"autor":42709,"amine":40514,"britains":46527,"deference":18393,"lyoko":34998,"meaney":47677,"autoblocked":11170,"quantities":11397,"relocating":43781,"pride":4122,"iranian":2135,"specialize":23517,"blagoevgrad":32946,"classify":7812,"karlovy":44626,"mutter":33767,"environs":44911,"conformity":21125,"bitchass":33628,"alum":22977,"katonah":44168,"tempting":14311,"spartans":26892,"×talk":33132,"disappearance":12619,"chk":26960,"bullshido":22672,"marley":16809,"politician's":41338,"inshanee":42783,"paraphysics":46133,"implied":4531,"support":350,"intake":15957,"andrey":36948,"longcat":44050,"laureate":43665,"redesigned":33619,"ramón":33262,"laptops":26538,"shitbag":27801,"joshuanios":37525,"obese":15909,"bulletins":37486,"fries":11921,"ortiz":22161,"coddling":22970,"scholar":2760,"hive":22821,"backlinks":27442,"dynamite":18452,"allegiances":36335,"xeeron":39179,"wat's":31561,"grocer":32223,"bishops":9051,"pki":39419,"confucius":37763,"runtime":31401,"inanimate":39723,"trance":10208,"var":21479,"seeming":11213,"em64t":24111,"realpolitik":32535,"anhalt":41072,"reach":2013,"contemplating":21756,"bobjoebob":38362,"na":5498,"reversed":5324,"decendents":27567,"whiteness":33716,"harding's":38776,"photogenic":49284,"informalism":47466,"prestonwood":41566,"tripe":15936,"dipshits":30024,"creat":15512,"fatigue":15969,"started":485,"pc2":36580,"roering":11143,"middlesex":26433,"unaffiliated":23753,"followed":1556,"crazyaces489":41385,"zines":24842,"baur":47081,"tangerine":37187,"falklands":15065,"initiate":8560,"espoused":25128,"bret":15720,"sing":5050,"pris":20392,"bypasses":39442,"nominal":12450,"hantavirus":38414,"—talk":17760,"decission":37522,"landis":30069,"onverzettelijk":48658,"debase":33741,"wdefcon":44852,"estimations":25202,"majored":28637,"glee":14032,"fibers":13727,"ucsd":40428,"darkness":7463,"attachments":29329,"stein":16561,"faa":20576,"savile":40742,"theoria":29071,"enzymes":32777,"guide":1215,"gerber":42654,"goofball":34163,"juni":42146,"philosophic":33438,"tempted":7368,"winston":10574,"losing":4228,"butthead":12470,"departures":34245,"chi":10415,"babu":26425,"ultimania":42996,"hmmmm":13926,"dubios":35965,"processing":8217,"abcmonster":48361,"delaware":15518,"weary":14176,"assyrians":8201,"bet":2566,"kjv":22608,"rifleman":29413,"approving":14948,"blitzkrieg":35967,"cottage":23798,"trg":40730,"sorts":3514,"resolves":18228,"antwerp":33081,"lowest":7203,"system":618,"istria":35266,"newborn":32822,"countries":942,"cchr":48533,"persian":2114,"baktun":41721,"stiffening":35507,"cowardly":8855,"bb":9182,"physical":2103,"27t":36388,"tony":2828,"favonian":14600,"seauton":38588,"forthwith":17850,"probed":44782,"pelham":43934,"tekken":19751,"friesland":44698,"kidding":4401,"adjudicate":33546,"corby":36947,"2013‎":32394,"ip":307,"lakers":22836,"introductions":16861,"make":97,"times'":26838,"uyvsdi":44823,"dvdm":22175,"mesic":43051,"paved":25151,"cambridgebayweather":28667,"thirst":47217,"amputations":49642,"cruising":24974,"calvin's":47970,"tablets":17313,"pauli":35934,"offences":14599,"buddy's":48643,"clearer":3724,"passive":6530,"flowed":22435,"lookup":18858,"breaths":30578,"clearcut":23734,"arun":23661,"cicero":34427,"editorial":2409,"seconded":18014,"probated":30348,"plantation":17922,"doen":42246,"pennies":36010,"ooxml":46093,"absolut":43269,"bunnies":24598,"leet":25590,"delted":20674,"stringent":19033,"embarassing":16946,"vernon":18454,"courtroom":23755,"likeable":44466,"constructivism":49373,"katana":35945,"northumbrian":27634,"pov":372,"ramgarhia":42843,"hellish":36101,"lviv":28604,"rfpp":12335,"mud":3808,"nonsenseferret":48966,"viking":8448,"reprocessing":38462,"trail":7327,"connected":3089,"hanover":16270,"elvis":8385,"thinking":1011,"establishment":5548,"ahmet":46952,"lest":9053,"molay":27603,"hazel":4304,"bomb":4166,"stretched":13001,"walkie":34963,"misconceptions":10221,"questia":44963,"♠♣♥♦™№1185©♪♫®":14188,"tributes":25339,"lag":17515,"arjuna":42592,"biophys":34660,"criticisms":2389,"userreq":36796,"hectorine":37381,"doubt":873,"liberator":37394,"tfa":9393,"bundy":22846,"tea":3772,"gee":7226,"loudly":15330,"opportunities":7911,"sakarya":42853,"aguri":43917,"cryptic":13114,"viewprofile":32397,"detract":16821,"'american":26863,"quake":20050,"courier":25687,"sbr":43899,"fearful":25255,"pandey":27645,"bakugan":37089,"paid":1775,"drown":18136,"mistranslation":20635,"preventing":6187,"two":155,"search":632,"denmark":7366,"chemists":16371,"cheque":38610,"berbers":12954,"unthinking":29735,"dishonourable":47398,"siding":18818,"brandenburg":15675,"specializing":22183,"heed":10571,"μολὼν":46559,"raja":6990,"robotoid":23140,"nuremberg":14537,"shame":2259,"postdoctoral":33729,"impropriety":26091,"u're":43796,"bullshit":919,"mouthful":43773,"absolute":2954,"mobs":17792,"tenet":19690,"gyula":41932,"abandoned":6142,"hu":10783,"radar":10706,"cailil's":26801,"cosmicemperor":40835,"arround":38498,"albright's":39380,"sylar":31270,"erection":20763,"dickinson":18432,"involves":4039,"nighttime":48926,"ozone":25103,"generalisations":38234,"despots":49321,"budapest":18675,"wagons":26200,"nosey":33050,"hade":30037,"previous":771,"jerm729":48341,"brutish":46019,"relisting":25420,"chola":6807,"childcare":45372,"slovakization":39482,"global":1651,"bluntly":17087,"nonlinear":29832,"flagspot":44038,"quips":39298,"piper":18155,"angus":37625,"say's":46102,"germania":29181,"recruits":23129,"albinism":42540,"clades":26654,"valid":799,"giver":25211,"punished":4741,"meowy":27233,"car's":40709,"headcheese":32587,"'c":43949,"inadmissable":40058,"delanoy":3926,"pursuant":15277,"fortune":9056,"flagrant":16040,"shatterhand":42163,"dogged":24744,"kelly":4993,"bon":12455,"iranic":18570,"unsatisfactory":16170,"flock":15531,"socializing":48099,"smallish":41263,"malarkey":40831,"mccoy's":31822,"мessage♣":45429,"scumbag":9688,"medicaid":24642,"nifty":30255,"disastrous":20377,"style":275,"interferometry":45996,"inner":6249,"youhave":48349,"sysopping":36672,"satyrtn":42061,"follower":10355,"patently":8761,"bh":16776,"incarnate":29801,"homemade":25942,"illusions":25842,"metatheory":37800,"upper":3630,"copypaste":36091,"cigarette":12642,"sabre":31681,"ombudsman":26799,"abcde":45337,"incarcerated":26429,"cob":27730,"motherboard":34706,"reflexes":25022,"000":652,"subcategories":9976,"overshadow":39734,"anonymouseditor":47727,"california":1934,"rockies":23237,"kpjas":48547,"inbreeding":31177,"nicaragua":10269,"soviet":1675,"increased":4441,"cropped":8985,"mockingbird":49384,"schedule":5181,"aut":8818,"damemk":23217,"stepping":8881,"yourself":206,"soo":13010,"saraiki":20217,"31st":19171,"decent":2884,"vbe":43540,"heeded":28130,"manuscripts":14313,"rory":25325,"appointments":23366,"understatement":15884,"allama":23593,"mdma":23788,"proverbial":19024,"outflow":48610,"obstructing":19411,"notables":20161,"gwh":35026,"eurozone":47991,"sabotaging":22692,"mobile":4857,"assassinations":18244,"ifps":44075,"perch":32643,"theses":14862,"wast":43256,"chiswick":18866,"bolivia":13667,"bagration":35088,"verge":13250,"batman":5281,"franklin":6511,"bangin":30351,"bootlegs":19951,"polemicist":43076,"hoops":17323,"eusebius":23399,"virtualsteve":42463,"tbr":47551,"powerfully":36341,"seafood":46329,"begat":49144,"macpherson":38327,"quarter":6615,"davidgerard":38670,"convex":13085,"b1tch":39498,"larsen":49275,"centres":12750,"ymblanter":21576,"cameos":23777,"invitations":26818,"talking":611,"culprits":47795,"executioner":23603,"vet's":45327,"djun":24327,"articles'":13297,"eleland's":46651,"reeks":19193,"an3":18293,"build":2006,"transylvania":16296,"whereupon":44899,"athon":42062,"carl":7086,"testicles":16524,"bain":24314,"placebo":18496,"bmk":14759,"desicion":48903,"hahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahahaha":35044,"savory":42728,"permutations":48111,"survivors":8719,"childrens'":42418,"duarte":42193,"thracian":17047,"affecting":9959,"'nation'":42495,"malala":43312,"myles":40980,"spm":48284,"regret":4962,"'i":7600,"behaves":20093,"snottygobble":44710,"sleeve":19031,"“death":31061,"purebred":16410,"commie":10116,"warlike":33902,"seating":19307,"blackpearl14's":28881,"ready":1960,"arendt":47062,"markup":8689,"inventor":8649,"cfl":28669,"rockin":30459,"vag":31185,"shai":32035,"sewerage":44857,"commments":44933,"spain":3120,"difference":923,"rita":49324,"perpetrator":18714,"signa":13655,"inefficient":15746,"aileron":42916,"lite":24434,"sleeping":9207,"coincidental":21682,"interactive":14668,"we’ll":46182,"aloha":34071,"granitethighs":48171,"beacause":32638,"celia":14130,"coolidge":27831,"fbi":3928,"send":1425,"sommer":25130,"bey":16941,"vip":22208,"pigment":40832,"adduce":40884,"playground":8824,"peruvian":17715,"miranda":17600,"overheated":49192,"egalitarianism":33131,"forcefullness":46350,"airforce":24208,"peculiar":11413,"clears":12316,"antagonizing":24486,"engagements":26673,"criterias":35784,"primarly":44333,"notoreity":49450,"facilitated":27692,"y":1618,"heartening":33402,"betting":16453,"stricter":17567,"nasa's":21178,"cantor's":33746,"recorder":28111,"biker":28416,"stretches":24143,"diacritics":8066,"unification":10387,"freshly":40462,"canonized":49496,"adarsh":39512,"cd's":14045,"mcintosh":31115,"hamishmacbeth":43552,"medals":7534,"pulleys":34594,"phrasings":49920,"duckies":48501,"ib":16923,"speer":22817,"subtests":39842,"delved":49001,"tawhid":38715,"widest":28826,"bronze":10523,"initiated":5319,"adil":19964,"bearer":18092,"usual":2321,"basepagename":24918,"detrimental":9615,"rehabilitation":19541,"raider":33203,"cann":45718,"kurd":17561,"scratched":27793,"wallop":49118,"td":13009,"goldentony111":37951,"dhok":31896,"carelessly":19107,"popper":13107,"tsk":10210,"sarekofvulcan":11655,"rook":31667,"joker":13550,"thankful":9928,"oldprodfull":46587,"a’la":45462,"blowing":8613,"ramadan":29526,"melodramas":40590,"regex":26236,"niu":37840,"melancholic":48150,"matey":35599,"smoothly":12899,"continuous":6202,"everybody's":10793,"jewelry":15893,"ineptly":49225,"views":720,"offense":3100,"millionth":48544,"specificity":23391,"pldd":38589,"nothin":28513,"wields":49423,"scoundrel":32716,"fons":31880,"reinterpreted":33737,"construct":7059,"arunachal":41139,"she’s":31035,"34th":45743,"actors'":35870,"militias":16332,"intentionally":4136,"dmitry":30675,"copious":18954,"drubchen":20494,"boroughs":15701,"mach":21673,"notify":4950,"romero's":42874,"agsman61":37295,"5x":20636,"accomplished":5968,"kakanias":43346,"bigot":7295,"kohl":29163,"rcc":15550,"babylonian":15082,"greece's":22843,"elapsed":17659,"quorum":36839,"rectification":47708,"purevolume":44103,"sunflower":23804,"rjaguar3":24068,"marches":21187,"lion's":35346,"jimi":36444,"graham's":26899,"david's":27757,"bst":44509,"prompted":8180,"acctually":38874,"distinguish":4292,"coulthard":48166,"opendocument":44790,"25th":12468,"fractions":15989,"broadway":10204,"lapd":46415,"videology":49028,"supergroups":30427,"brittany":16235,"hotel":5270,"salwar":26381,"nodes'":44577,"shields":13932,"relay":10815,"maneuver":39843,"blast":7362,"civility":1904,"discription":38942,"aprit":43315,"lebanese":6079,"wells":6399,"xkcd":21337,"fanciful":16766,"barrett":10469,"formats":6744,"tabib":33047,"shares":7376,"storms":9842,"born2cycle":42315,"soong":31813,"solo":7696,"facilitating":22301,"recreating":13394,"singlehandedly":47457,"nasarous":38740,"actin":33395,"semiprotected":26107,"ranking":4224,"task":2269,"eliezer":23469,"'c'":30059,"karaganda":27377,"speeches":11435,"noticeboards":15387,"mccann":29868,"suspect":1584,"16th":6819,"dismissed":5053,"stalkers":9961,"criminal":2213,"–noun":42407,"yaghmaie":29436,"sliced":25537,"viewpoints":4244,"honduran":38534,"sps":12249,"noonan":18097,"catchment":44603,"stone":3000,"alienation":33085,"pond":12086,"francois":35671,"vendors":23005,"wir":32090,"place'":40840,"revdel":43091,"gynecologist":33372,"notified":4611,"arbitration":1297,"unnecessarily":6731,"orgasms":28558,"cispa":34735,"会話":20469,"palazzo":41766,"ideologue":28385,"happening":2611,"peacocky":45737,"soviets":8859,"sanctuary":17085,"stories":2258,"suspicions":10898,"condones":37825,"hidalgo":48359,"segmentation":26935,"lends":13961,"corrosive":46457,"canton":13618,"dahl":34223,"goa":12634,"achieved":4118,"snowflake":38877,"changer":47428,"latency":39658,"minke":48044,"carolina":5694,"carwin":42753,"sunnah":25313,"behaviors":11244,"manz":47659,"pore":48661,"bio's":34599,"syriaque":44052,"secret":2461,"trend":6155,"ahunt":18750,"leitão":34700,"upl":39957,"resorted":11782,"tremble":30641,"pate":43985,"obesity":19720,"historia":28250,"chart":2411,"fling":28915,"several":406,"ulan":37228,"governement":27451,"hansa":28521,"transposed":41129,"э":44297,"able":528,"johan":33465,"overlooks":39626,"offbeat":37653,"jagdish":39919,"majestic":19548,"forge":18198,"techinc":39490,"werespielchequers":28930,"aslo":31683,"tabriz":20526,"redefined":32337,"constructively":5581,"objectivists":38163,"buuren":41621,"analgesics":40579,"climber":36337,"driverresults":47679,"you'":17005,"throughput":34313,"valor":18919,"sayo":41579,"whiney":22090,"been":55,"hal's":43101,"sora":36266,"gunner":31002,"elam":41060,"beikoku":43565,"wreaks":41289,"belfast":12096,"cilla":40429,"therapy":4199,"beauty":6037,"3'":47791,"somesuch":32156,"seizures":18442,"challenges":7088,"casey":16797,"gurkhaboy":40217,"ganondorf":42603,"selfpub":26232,"manipulating":9600,"hardships":40155,"caesar's":35529,"iphone":8522,"requester":26980,"norris":6480,"scolding":37286,"hammurabi":16926,"repression":13767,"privelages":36332,"distraught":37969,"ethnicities":12356,"epics":48969,"sucker":8728,"interlude":33583,"goosebumps":34323,"dj's":35840,"triplet":25740,"comers":23912,"th":5774,"tumut":31484,"tumbledown":26862,"crisis":3688,"doth":24474,"explaination":13863,"tightened":21559,"mani":22297,"phg":23783,"motherfuck":47819,"done'":45537,"chick":10503,"berkshire":32784,"looter":42508,"wikipedia86":18464,"drooling":27960,"receptors":21338,"baruch":18719,"abbott":17684,"admitting":6962,"penny":7278,"'public":28748,"dummies":19580,"generosity":26570,"stemmed":24119,"buzzwords":32273,"pawn":15775,"splc":8266,"camra":45386,"leaderboard":33797,"fide":14003,"allegheny":45308,"kno":21762,"fisa":31774,"o'malley":31853,"takedown":44386,"perosnal":39565,"“пустить":48566,"apoligize":21731,"arches":19069,"phenomena":6394,"tlctugger":35618,"ashol":13226,"jasper":16447,"wakopedia":19244,"night":1376,"stake":7184,"spielchequers":41699,"scotch":23693,"teleportation":39033,"mᴥuse":47000,"pulitzer":20547,"mailing":5930,"all'":47333,"doubling":22928,"book's":14452,"ouch":14683,"instinctively":35378,"fibres":43744,"till":2726,"f6e9":37104,"robin's":49279,"gasses":35776,"rasta":26508,"nig":22609,"elects":25352,"angered":13913,"gala":39137,"spotting":12672,"riverton":44095,"rabid":10996,"malfunctioning":21389,"outweighed":30210,"prso":33451,"first":113,"joehazelton":24906,"aye":14049,"colum":20122,"spinner":32108,"attempted":2415,"rebound":49142,"dacians":12972,"wn":40452,"•limit":34839,"looms":47768,"raspor":34467,"mongrel":25658,"wynton":47981,"chicanery":46665,"minneapolis":11679,"johnhistory":13290,"broad":3273,"gustavus":46393,"tangut":39877,"nsle":29022,"subdivisions":9754,"g12":17042,"boot":7700,"variation":4768,"ghettos":17445,"kura":17405,"irv":33237,"subaru":39217,"patgallacher":45205,"jumbled":31069,"rant":4323,"siddha":24967,"artwork":9388,"scifi":30299,"sincerity":14943,"fagin":47577,"elmer":37540,"styrofoam1994":45314,"murdoch":16854,"stumble":17498,"riffs":31594,"surprise":3802,"screws":22931,"pontius":42264,"ponyo":27135,"thracians":32824,"speculating":10927,"sophisticated":10357,"leila":30363,"mozilla":11113,"bind":19226,"typical":2456,"'all'":48536,"spouse":12349,"psoe":34469,"'45":14841,"saddam":7923,"grammatically":8558,"zones":12324,"irpen":13319,"ghorids":42593,"himalayan":23650,"chuck":4098,"lorentz":20152,"everybody":2209,"grandad":42633,"reams":28359,"baku":14391,"perma":20157,"chanting":17079,"contravenes":17882,"amercian":48076,"haiduc":36244,"effing":24824,"recreation":8246,"churn":34110,"ugliest":25487,"greets":30285,"ramiro":48398,"lightweight":25349,"bourgeois":25443,"cheesecake":49830,"– ":11243,"koleka":28572,"adler":14964,"irregardless":21517,"hassle":15910,"puzzling":13519,"karate":9378,"almighty":10963,"cva":49361,"reiterates":31909,"fashionably":47372,"daily":2102,"full":508,"melina":27289,"hitz”":27258,"disclaimers":22695,"anno":33396,"krs":24698,"nonpartisan":25219,"leigh":15067,"3rd":2627,"stig":25794,"coconut":21474,"senegambian":31595,"thousand":3235,"woot":31051,"nano":33092,"witkacy":36468,"revered":18478,"stillman":19521,"harts":45575,"book’s":49419,"tragedies":26968,"tatar":20657,"humiliating":20043,"natasha":19970,"datestamp":11312,"valentino":23279,"udp":26745,"exonerating":42666,"inhabitant":35862,"eb":9274,"marca":43711,"♪♫":14453,"searching":3304,"soca":37567,"underrepresented":37339,"pzfun":42224,"speaking":1241,"conflating":22439,"haunting":32451,"grandma":14832,"soothing":24941,"yavana":47177,"intimidate":8757,"dummy":10271,"evans'":46376,"king'":42657,"navboxes":27126,"thst":39763,"zero0000":27958,"schmitz":38189,"pbskids":38280,"deck":12058,"falsification":15886,"antagonized":43577,"casinos":45211,"pirated":32912,"minute":2693,"style'":38402,"century":1073,"bathe":41875,"bowser":29615,"disrespect":8570,"bindrunes":48356,"buddhas":43862,"overstatement":28265,"coined":8435,"partake":32869,"stavgard":38043,"psychopath":16522,"baudrillard":43969,"'country'":26658,"srt":38203,"recording":4905,"bong":25924,"permeate":34984,"polygon":36856,"governorate":28380,"ambiguity":5855,"perfume":27160,"elevating":33457,"threats":1535,"hard":563,"firefly":24799,"givin":46701,"perverted":12568,"remand":35012,"gru":43423,"heraldic":15885,"showing":1322,"lakes":9866,"exodus":7698,"20am":39920,"aire":37815,"tanstaafl":45237,"authorlink":29796,"biitch":47017,"sandstein":10926,"gh":17781,"sufjan":45419,"rationally":12424,"♠dil":27227,"ilovedirtbikes":26859,"highlighting":9871,"toughhead":35203,"hamsa":49369,"banging":16059,"janitorial":36309,"jibberish":35789,"tlc":22691,"gabsadds":8027,"pots":19942,"refence":30795,"deceiving":20805,"chen":17786,"unarmed":14206,"transformer":13626,"cues":26681,"epoch":20995,"leona":34644,"candies":49500,"bx":31961,"airflow":47472,"habit":5468,"desysopping":23489,"automobile":11848,"smash":8703,"moat":30270,"legitimize":30936,"curtain":24692,"kuk":17802,"serbo":12139,"wikias":32319,"uttered":14279,"errr":22881,"raped":5405,"systematics":49907,"metallic":27004,"bios":6749,"chinamanjoe":39175,"attic":28531,"apologia":48105,"facebuster":33116,"prefixed":26584,"usurped":12380,"confess":9674,"geneticists":13697,"stonewall":45642,"slipped":12067,"victimize":40739,"ground":1977,"cornwall":9302,"eichenwald's":37678,"stevens":12509,"doyle":23519,"tamper":20841,"millimeter":24100,"mercenary":29608,"lamas":37919,"biden":20842,"“40":44216,"annoyance":13157,"thinner":42087,"did":87,"flg":38408,"narrator":24170,"unanimous":10048,"radovan":49179,"faithful":10687,"gothic":5460,"oklahoma":8144,"fingerprints":21227,"underpinnings":33484,"censored":3580,"complicit":26558,"sample":4919,"loeb":36779,"terrorized":43208,"aff":32884,"genuine":3299,"missionaries":14170,"macaulay":29412,"magicians":25835,"w":898,"fever":13038,"events'":41724,"immovable":40032,"pellet":47117,"dawat":41048,"hawks":22466,"reassure":28540,"hindoos":38696,"center’s":41659,"innocuous":18834,"barely":3896,"blowjobs":36844,"prudent":16068,"angrily":29807,"surly":29672,"d9":33171,"cholan":36077,"oyu":26250,"shawn":10970,"centralist":35141,"ocarina":36552,"max":4653,"adorned":23556,"sephardi":32170,"aquatic":25026,"laden's":35626,"browne":20628,"keane":25104,"feinstein":48087,"foreigners":8864,"matrixism":20829,"smalltalk":33027,"jenna":23266,"benghazi":21748,"health":1756,"'dispute'":30710,"maharshi":15993,"berri's":41795," —  ":45552,"bobover":43671,"newspaper":1702,"napoli":47509,"madonna's":31573,"richest":19496,"naysayers":28313,"sherman":17240,"achaemenid":28135,"mathematical":4158,"khalidi":36112,"tiers":34489,"prescription":14849,"symptom":15871,"arabesque":43432,"motivator":48955,"admiral":9973,"peasantry":38562,"marital":18246,"redskins":23103,"lethal":12680,"blitz":21160,"deleterious":42554,"resarch":37044,"found":284,"interested":527,"subproject":30343,"vistula":41256,"scythians":42848,"kochi":29392,"dylan's":32770,"crowned":20095,"talktalk":29335,"posted":606,"uou":45119,"runt":41119,"sala":38461,"coop":34608,"kindest":20627,"georgetown":19158,"dickens'":33519,"keyes":30772,"microscope":22566,"wheras":41903,"frankem":31885,"marky":39168,"decoy":47703,"definitions":2850,"'bad":28941,"bullcrap":23680,"rfcn":46528,"protect":1622,"cricketers":17884,"lackey":29911,"władysław":38217,"faggots":1573,"pocketing":35061,"cisofield1":44199,"incest":10862,"accruing":46210,"ills":36974,"tanoli":15995,"fgm":17306,"comically":44615,"vested":7663,"malpractice":48170,"base":2167,"derp":43002,"bazaar":44907,"stubbornly":20808,"märsta":47186,"potent":21367,"pussies":20062,"hasten":35283,"protagonist":12643,"alexandrian":37440,"shimon":43282,"everett":27826,"nobody's":17134,"fsa":26638,"macintosh":16731,"purposeful":23651,"kamikaze":43414,"♣łeave":45428,"ejaculates":33355,"turkish":1783,"sοme":48409,"walid":21602,"ŷou":36889,"yoda":47492,"repository":8879,"everyme":19562,"heartache":48770,"patronised":46981,"cubic":13277,"demoting":36599,"poker":10491,"moran":16417,"elphinstone":46808,"time'''":17363,"unfocused":38235,"provocation":10219,"mulatto":10788,"emma":14980,"shaffer":42550,"chávez":24178,"'home":36530,"wonju":44264,"kelpie":29459,"qed":16655,"bishzilla":43331,"experience":1115,"belize":22128,"inaccurately":19840,"'ownership'":42635,"unbalance":36182,"gr":10505,"adage":40763,"sociologist":21562,"unbridled":41236,"carla":42383,"gemlik":40664,"finaly":23244,"beverages":22590,"barnes":11151,"damiens":19941,"admire":7222,"ingest":38895,"lockdown":47906,"saline":36834,"muddying":30792,"desirous":47486,"vitamins":30011,"urn":34893,"dish":9038,"reformat":17554,"liberalpedia":46501,"pretends":12097,"relegating":32079,"hubs":20218,"mediocre":11286,"custard":32496,"provost":40521,"sayed":26156,"warmonger":35428,"bovard":20221,"ramayana":28201,"talk •":27944,"''''—expert":19133,"managua":13051,"asset":8775,"omni":41391,"bettering":46732,"shebang":37560,"bicol":31636,"editorializing":11846,"zac":29705,"wain":34750,"quickest":22252,"rabble":40599,"chong":23404,"ccvi":42170,"etomcat":47066,"consolidate":28042,"diderot":34690,"expenses":13623,"'to":25959,"edmonton":15664,"blond":15329,"unilaterally":6045,"demography":22789,"“there":20582,"trung":43266,"richer":17888,"feinman":36085,"nineveh":47223,"dutchy":46571,"concoction":48387,"ra":11414,"attacking":1975,"conformance":3148,"gonzalez":18946,"adults":5731,"nowruz":30247,"blackie":48048,"tenured":42960,"'further":36287,"cx":43857,"autistic":10782,"odysseus":35864,"explication":29590,"toa":27668,"nourished":39057,"diagnostic":16152,"goanimate":45529,"annexation":12611,"executives":15761,"leicester":18824,"frs":37231,"'crat":49704,"whitby":25965,"preposterous":12223,"idiotically":42254,"friedman's":40173,"kunstler":44967,"sess":34480,"bayonet":46185,"giuliani":26937,"defaultsort":16507,"capitalist":8837,"gitam":38785,"deuteronomy":17504,"terminals":22333,"piracy":17366,"recreations":48289,"cat":2173,"nihilist":43882,"alms":34475,"chrissi":40242,"un's":28457,"revision":2033,"plotted":24959,"minimize":11798,"jza":20240,"failing":4237,"dq":5830,"engel":26033,"pdt":28841,"nurtured":44655,"commemorated":41571,"hibiscus":48699,"acm":24522,"tautology":24767,"ligature":38227,"warming":3233,"drexel":34808,"wp":114,"chances":5412,"paddybriggs":23591,"msu's":38700,"sneeze":29045,"hanged":16510,"abettors":46484,"gushing":26993,"enthuisiastic":43048,"begs":19524,"gaarder":24372,"jimbo":2220,"gel":24647,"warhammer":21387,"crisp":13173,"archaeological":8840,"flap":13663,"confrontational":11374,"ilbo":17428,"mommy's":25228,"crossley":45985,"expeditionary":21454,"carolus":33977,"mob's":39451,"cwic":33137,"temptation":14958,"caspian":7803,"marsh":20077,"seeding":41015,"rivalries":29987,"sadasivan":27919,"we’re":21442,"yngvarr":32979,"browser's":40659,"sporadic":31449,"attested":11599,"here":63,"eds":11985,"bhagat":20054,"zach":13950,"predictable":13742,"metacompilers":46424,"kotniski":35547,"alternating":30184,"→world":38381,"conceivable":18080,"samantha":19463,"tycho":47617,"explain":484,"paisley":31030,"issa":25358,"abus":40720,"revenues":23829,"pursuit":9119,"matured":30889,"handgun":37346,"there'd":19347,"atwiki":46297,"botswana":28992,"wikilawyered":44378,"imelda":47373,"faultless":41674,"gotcha":20465,"attn":25929,"torturing":24229,"diabe":48072,"brother":2045,"ohr":45521,"gautama":29341,"disappointment":19740,"criticizing":7701,"body":1136,"february":1167,"cocksucking":3030,"witht":31931,"addressing":3332,"rcts":34020,"specter":32776,"insufficiently":32438,"sufism":27085,"cultures":4861,"nyo":13502,"doctors":5872,"restricting":17679,"hummer":43302,"carey's":34640,"saloum":34403,"malawi":31754,"aginst":31368,"glean":35092,"dsl":24574,"uninterrupted":36868,"harasser":32598,"piotrus'":35968,"tampon":40093,"oxy":48250,"moravia":29809,"customized":23304,"pod":13588,"plow":35510,"snarkily":45168,"dubai":24748,"himym":43145,"inadvertent":17311,"provenance":15863,"perennial":28501,"wikiquotes":37424,"contra":6902,"speaker's":36154,"concurrency":35541,"sis":28889,"povish":37859,"grouped":11540,"springer":23892,"senators":10080,"coastal":9664,"resolved":2279,"www":326,"ufos":17395,"banners":10028,"sustaining":19855,"irvine":16298,"mythological":12141,"heroic":12993,"armor":10194,"b3":15934,"disbarment":38143,"uniforms":12704,"eberhard":48741,"oha":45186,"affliction":35488,"mandates":29086,"aris":31526,"entitles":32951,"funding":5621,"highly":1092,"weasley":35665,"gubernatorial":35561,"missiles":11569,"wikipeda":20170,"notarealword":43344,"witted":26140,"tar":15424,"bangladesh":8111,"distortion":7550,"grimes":46750,"percept":43836,"jao":48990,"compatibility":11632,"francis":5134,"barbaric":17187,"vedanta":29180,"hazrat":35171,"aforethought":47132,"pyramid":12034,"tabs":14618,"analagous":42538,"bora":24562,"footage":8602,"affair":4750,"benign":24585,"sont":34615,"directx":41269,"ò":38899,"feckin":39786,"rps":39282,"sentimental":45779,"thereafter":11910,"meso":44651,"xgustax":38509,"juste":39488,"clark's":39533,"insipid":31439,"critique":5647,"liquor":30576,"dashes":14521,"elevators":46816,"gareth":16094,"vandilism":17027,"functionality":11884,"beware":8639,"vargas":15919,"jazzy":37456,"swords":13921,"yadavas":28971,"officialy":18030,"likeness":26759,"religions":3677,"rag":11485,"rebuttal":8261,"mozart":13280,"gta4":23509,"subsidiary":15259,"readd":14441,"paralympic":46833,"oppenheim":48587,"usmil":34119,"u":233,"fleming":17290,"irishman":25302,"lübeck":49665,"assimilate":23053,"henry":3522,"theodore":17028,"oppose":1579,"lumpur":33148,"intially":49570,"wiccans":22206,"julius":15472,"elnaz":37497,"excised":16916,"divider":44989,"ephblog":40187,"priyanka":24552,"wheaton":22103,"sisters":8189,"manana":49598,"determinants":36440,"wgbh":24338,"inbound":28307,"chechen":23302,"mossad":13468,"reverted":331,"qualitative":21075,"gill":12462,"ivy":15622,"antivandalbot":46209,"can":40,"placements":43083,"maddox":21261,"vandlism":19506,"uda":23227,"idly":20106,"dorado":42465,"rifles":14944,"harvey":9439,"starved":22267,"holder's":37973,"baristarim":36044,"excessive":3958,"idc":35253,"geographically":10438,"expressed":2999,"asa":22815,"herby":28942,"cheerful":36928,"groundbreaking":31179,"holmes":10082,"monotony":43157,"separates":26151,"shepherding":39460,"numeric":19744,"encoding":13927,"revelations":11479,"strains":22148,"optic":29067,"snipped":33318,"claudius":28461,"nikkimaria":34739,"unlikely":2595,"presuppose":38074,"leinster":17148,"assault":5164,"campaigned":24708,"much":132,"subconscious":35374,"intrinsically":20827,"canucks":44354,"condition":3374,"suited":6306,"goethe":35072,"nocturnal":47084,"¬":25357,"reffered":16773,"narwhal":45165,"dajudem":49836,"jewfat":31227,"wikispecies":28691,"zionism":7957,"edonkey":49943,"reinyday":36671,"hayasa":37719,"akerans":45989,"starr":16308,"bookmarked":39998,"inflammation":37552,"gi":12240,"polytope":47565,"thevar":23416,"charlie's":38688,"implode":35954,"xxv":28827,"jasz":43721," t":10083,"ce":5505,"favouring":24963,"hyperinflation":18120,"give":261,"wikipedians'":13871,"refereed":16463,"gosh":9311,"consequence":5523,"mmol":48373,"antoine":24539,"historiography":9824,"webcomics":39749,"he":52,"bastardization":44672,"fortified":42868,"ties":4928,"algerian":17627,"city’s":46352,"torn":13969,"hug":13558,"hurley":31730,"agaist":33898,"śkin":47391,"collusion":13833,"complies":6570,"deadhorse":44513,"robinson's":41535,"forger":44522,"credential":29818,"beefheart":47339,"memes":25003,"ellsworth":34524,"specy":43686,"tisha":42098,"binksternet":9511,"turbine":20013,"penetrating":31269,"distinct":3625,"watcher":21817,"safavid":14173,"adminship":2967,"vaccinations":44046,"farmers":11282,"krivosheev":29650,"001":16506,"disabling":19929,"alredy":24629,"graduated":6846,"oblivion":20594,"warhead":48242,"challenged":3200,"burma":9793,"fascinated":16521,"''''''chatspy":21122,"examined":7835,"essentials":20246,"bur":38172,"prophet":5043,"quine":28278,"synagogue":19644,"caring":8085,"sykes":24875,"dean":7251,"gog":30995,"seljuks":27453,"epa":15057,"prophecy":8830,"komodo":37813,"tuba":36667,"dutchman":27100,"fore":31987,"kt2":48834,"reason's":43321,"su":9814,"drummers":26918,"staring":19218,"fatal":8527,"aforesaid":24488,"perimeter":42824,"excerpted":36310,"drifted":34032,"behe":33662,"flattered":13532,"magnetosphere":48400,"developer":7344,"nrhps":36405,"oktay":29405,"invincible":27231,"lying":2072,"wisconsin's":40860,"yousef":43625,"weddings":30414,"filmplot":38875,"hopelessly":15174,"taṇhā":47124,"exclusion":7811,"itv":25688,"yunshui":23002,"riana":11967,"bethmann":29434,"network":1909,"hideously":26836,"bq":31991,"malone":27477,"velociraptor":41146,"coterie":27736,"deferred":27821,"yyyy":16315,"arpad":35340,"ernest":16224,"cubans":22300,"identically":25805,"tones":13186,"dpl":14693,"fixes":7338,"continuity":6572,"launceston":46600,"9x":46388,"raleigh":23954,"transwoman":23309,"perseverance":34426,"choosed":47994,"dogsindepth":21114,"moss":18450,"lj":23050,"colligo":34606,"shade":11007,"bohr":29126,"lolololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololololol":35045,"landau":36814,"ausf":36827,"questions'''":41770,"enumerating":46195,"garlic":34024,"tanjung":31629,"thor":15738,"newman":11706,"diagnoses":29601,"uhh":21316,"atrocity":20616,"żydokomuna":42278,"'fenian'":15760,"wall":2596,"commited":10817,"federer":29631,"cpus":35714,"hiro":44222,"centrality":44842,"mishnah":46597,"aarem":45021,"kanin's":44270,"goading":21843,"folloing":46692,"perturbation":31430,"shoved":18961,"rectum":17648,"thre":22884,"agenda":1493,"provincial":10203,"airdate":24066,"incredible":5804,"dellums":31899,"–xenotalk":13511,"langauge":20144,"bomber":10739,"ably":46725,"bsc":39953,"purpose":957,"2007‎":27395,"tenure":9670,"iam":10180,"gwen":4521,"perspective":1916,"fitzroy":33022,"defamatory":4589,"turk":7082,"revisionists":30920,"phile":41296,"neutralized":24679,"taxing":27971,"digwuren":30130,"volim":38130,"climatic":22275,"tord":41218,"alam":41100,"sequence":5013,"nyhouse":47721,"wolfram":18205,"marwatt":31703,"tramway":19109,"slid":37349,"sodomy":21074,"neff":34850,"were":86,"perce":47742,"—''''''":9415,"20k":43940,"they'd":5494,"tonfa":41063,"crony":32447,"lectures":8094,"prodded":21455,"douglas":8893,"conan":14334,"ı":34865,"picket":34182,"usn":28724,"qamishli":16970,"thomson":10281,"sanctions":4223,"iqbal":16656,"antiochus":17650,"approfondir":45956,"prism":28502,"past":594,"rez":49302,"dougie":42066,"wikified":9882,"powerless":31102,"bactrian":36698,"airways":12985,"rainier":35569,"uselessness":37684,"acadians":49079,"community":498,"lefebvre":44880,"levkamensky":47759,"ins":8957,"group's":9632,"10x":28205,"malignant":33099,"reliablity":37151,"waa":33051,"forrest":15519,"pennnis":6163,"nosed":15556,"adjustment":17852,"fpc":13810,"impostor":21267,"freedom":908,"mezzo":18475,"lewes":30038,"pleadings":36886,"dictionaries":6816,"salafis":41314,"behaviour":1399,"empowering":23425,"basil":27164,"segment":6020,"carsley":46876,"tomer":33289,"wonders":10100,"outcomes":10488,"gardens":11495,"kriya":23074,"christopher":5137,"toil":40193,"'pedian":40152,"reassuring":30231,"nrm":36495,"willingness":7246,"porcelain":38963,"zeitgeist":16142,"swollen":33212,"kurgan":18548,"shetland":37323,"eddieebo":43805,"unfree":4712,"rfm":17292,"goode":35124,"competitor":13086,"ucn":31793,"nurturing":43944,"termination":15107,"'many":33258,"technique":4735,"rosoft":32904,"gentle":10118,"africans":7767,"hist":3538,"recon":39042,"jinnah":26721,"blitzer":16131,"'s'":30789,"yellow":3738,"lindzen":37694,"ogrish":46530,"whitecaps":33652,"paragragh":40523,"messi":28943,"abraham":6468,"insecurity":19977,"sang":13646,"tagalog":30134,"hepburn":21866,"afist":22187,"euphemisms":24998,"using":207,"sydney":6216,"useless":1585,"bertram":47783,"unforgivable":48160,"impeccable":24831,"chams":19102,"saab":17236,"boas":30692,"edgar181":3515,"te":7286,"polarized":22921,"noodles":25789,"poke":11653,"diseased":20340,"ecemaml":40901,"standardization":13177,"whay":33264,"cyclist":37081,"dawn":7734,"winx":46889,"dibo":17501,"launch":5252,"tilting":23024,"irritating":8171,"dearly":17588,"miley's":34564,"chakwal":42594,"sustain":11376,"rebekah":33055,"ttn":18822,"emilio":14119,"bluegrass":38645,"nouns":10361,"blogsd":33934,"velikovsky":28252,"malini":25173,"onion":21573,"dusty":21555,"nor":584,"framework":7688,"usefully":22447,"test2":31199,"bobov":26882,"intresting":34068,"disapointed":38400,"literacy":14289,"hayward":38340,"infiltrated":23218,"scored":6804,"recluse":33676,"criticising":12301,"habitual":17155,"broadcasting":8132,"swelling":37551,"floquenbeam":25437,"mariners":46126,"unprepared":42486,"doing":282,"narration":22383,"presupposes":33026,"64bit":42290,"marginally":14363,"intervened":16190,"meaning":829,"bahais":34455,"backstory":23500,"clary":39511,"cyberstalking":28819,"dh":27409,"playa":35479,"awaken":46671,"tsar":17029,"panama":14102,"municipalities":11627,"convene":49889,"linebacker":49022,"cases":974,"innovations":20896,"scientologists":12820,"caden":28895,"cocky":24774,"atkinson":28595,"bushel":38793,"catchall":45345,"mango":17795,"mentors":17563,"placate":25623,"labeling":7023,"'jewish":28903,"cranks":19685,"telex":25047,"antisemitism":6011,"umbrage":36055,"yourselves":4730,"ravings":36568,"spectre":31198,"prosecuting":28240,"collectonian ":21965,"adelaide":11911,"rancid":29898,"octopus":27542,"develops":12092,"godly":42968,"steer":11200,"efficiency":8607,"mordecai":35723,"adnan":27050,"unsavoury":35634,"19xx":33331,"editors”":47746,"roadster":38162,"memphis":22754,"acer":30273,"armedblowfish":49561,"ramone":12113,"fanboys":11038,"cpr":25004,"gurjars":35227,"misunderstandings":10780,"→return":43520,"frying":34718,"deride":36501,"sedentary":38964,"criminalwar":3117,"ohhh":34956,"accessible":4707,"understandbly":48158,"chalked":40607,"track":1931,"endurance":24125,"remington":32241,"suspiciously":15681,"leads":2991,"darian":45592,"eekster":49686,"bei":24532,"falasha":36601,"cohen's":33969,"accredited":10902,"gladly":7381,"naturally":3893,"spiral":15032,"discontinuity":40714,"bacon":8681,"helpers":33166,"insignificance":29517,"moh":44448,"obrides":34826,"perjorative":22160,"worshipers":49879,"misha":35637,"biruni":21981,"union":1721,"sumer":41228,"menace":20345,"goody":26783,"dick's":33359,"❝яedvers❞":34841,"hope":226,"folks":2442,"joshuaz":10325,"dunn":11833,"groups":1010,"farah":21136,"relaible":31045,"splinter":18065,"dictated":16175,"hmong":44109,"blanks":14552,"exclusivity":27705,"cpe":49470,"shinawatra":38021,"xmas":17623,"psychos":48360,"knots":15391,"vertical":1137,"undertones":40892,"antaeus":31533,"spakovsky":48410,"defending":2925,"chemically":31385,"destruct":34047,"bookplate":46338,"anglais":36068,"breathy":38974,"cassianto":25741,"emptively":41354,"shura":35627,"eunuch":42151,"zenanarh":34577,"concave":15333,"announcer":19746,"clarkson":13665,"rusia":41728,"merging":2911,"descript":42621,"courteous":12369,"ebu":31872,"cred":45040,"launched":5215,"pink":4459,"figurative":24017,"suckersyou":18763,"teletoon":27535,"underestimating":39283,"jm":33611,"thurmond":34529,"chiropodists":33118,"nanotechnology":30687,"moravians":39609,"adjoining":27922,"warheads":43572,"innumerable":26191,"poltergeist":37683,"jehovah’s":32279,"fists":26618,"sweaty":37135,"navigating":25089,"weekend":3578,"vandalproof":14394,"cassandra":34622,"chapline":40427,"blackstone":42539,"coerced":34064,"buckle":33979,"brags":44662,"underpinning":41003,"meucci":22038,"drones":19668,"berkeley":10318,"merge":1193,"whining":7579,"maverick":26626,"onerous":30951,"opined":30157,"janis":25708,"userbox":3894,"deprecated":11094,"substance":3905,"pnrs":25251,"moli":47414,"mtc":39464,"wnat":34966,"“most":46222,"ended":2350,"aquainted":39045,"kanai":46114,"saliva":9761,"rythm":29884,"wizards":22478,"notes'":45608,"poprzez":44238,"behold":13027,"perpetrate":35812,"slav":12527,"basis":1164,"synthesis":3589,"saraswati":23198,"guilty":2776,"hood":6529,"“consensus”":29115,"periodic":11981,"deemed":3997,"unscientific":14234,"malo":31412,"portrays":12991,"lbs":12825,"fatuous":32381,"himaupur":44219,"cefc":46919,"yabe":45277,"transclusion":24829,"wikicommons":14244,"galen":23959,"odor":40377,"aren’t":18712,"balfour":48367,"ferreira":36656,"cruz's":30682,"posession":40747,"imgur":17385,"disapprove":20677,"theorized":19051,"nay":15317,"cos":6398,"fitch":39365,"pedestrian":22220,"bosh":49180,"portman":43185,"bastardized":32841,"museo":38428,"components":7447,"tastycakes":31679,"collectively":10923,"gen":8717,"hires":29984," c":21226,"packet":17845,"personally":846,"durrah":33631,"boggles":33297,"reproducible":42881,"textbig":28626,"flurry":30145,"orangemike":9772,"trove":19063,"upgrading":25043,"solana":21076,"nuances":15568,"lowe":42238,"sociobiology":48604,"'truth'":38703,"laveol":17046,"subhash":41804,"approximating":47131,"fatima":25771,"precondition":35935,"improper":5070,"ust":10577,"rash":12813,"obrigado":32540,"descending":16737,"rotimi":47641,"hers":10663,"publishes":11662,"chiropractors":22710,"licensure":40487,"naqvi":49061,"olteanu":34755,"precaution":28745,"sool":44553,"paths":9179,"moneybomb":18748,"bering":34968,"rv":5889,"island's":47796,"bolak":44595,"monastic":29852,"illusion":7937,"scuba":40815,"francistyers":35181,"ndash":25716,"offtopic":31713,"beter":25127,"ipso":28426,"dvds":11769,"indentured":31235,"'''if":40669,"aurobindo":37774,"red":956,"wrongdoing":13700,"senile":32416,"abusiveness":41750,"ratification":33731,"reprisal":33795,"vacate":26405,"servile":29004,"oaths":21281,"laudare":45657,"butthole":30196,"rizvi":42494,"mathura":44803,"chess":4708,"signifying":41855,"hurdles":18315,"bach's":33006,"cameroon":28955,"company's":8914,"marking":9148,"jurors":23099,"bards":35214,"outcome":3634,"registrar":22200,"uviller":38316,"speakin":44786,"sloan's":42234,"inclined":5197,"semiotics":42302,"nsw":10710,"followup":13826,"yasin":39008,"vindication":24455,"wrangling":38994,"israel’s":33067,"latch":40805,"blackbody":35621,"melodramatic":43841,"willem":34405,"mormons":7615,"90's":12659,"midpoint":36992,"pledge1":38511,"playoff":19708,"brink":21439,"keaton":41735,"selina":33505,"initial":2414,"fith":44502,"iraq":2592,"matrix":7271,"reads":1933,"fluorine":37983,"publications":2416,"bosnian":5701,"edwin":15042,"naught":24624,"telegraph":7882,"enjoying":7261,"internationalist":39825,"clogging":33142,"condolences":27529,"bienvenue":38376,"ethiopian":10356,"erasmus":23092,"thighs":27947,"koni":40443,"aleppo":13197,"pad":7546,"bayonets":46264,"mend":24121,"guiness":31702,"tiscali":45446,"coincidence":4855,"expedite":46450,"asshole":1044,"loopy":49300,"text'bold":18745,"dzasta":35679,"tehran":15702,"ritual":9584,"especially":526,"pepper":14735,"warner":10136,"entrance":8249,"supposition":14097,"clinic":17309,"gtbacchus":29203,"choudary":27725,"padmini":49785,"designs":9953,"procedural":10384,"facebook's":43204,"'beliefs'":36935,"unimpressed":32708,"jahan":44778,"'03":47335,"peridon":24732,"klaus":20352,"activate":18843,"niggaz":11537,"dr":1283,"comte":27494,"duet":30364,"avestan":43115,"le":4329,"temporal":15714,"clegg":21307,"buick":31174,"25px":17889,"platinum":10072,"shultzii":34798,"forceful":28984,"jupiter":14642,"genseiryu":11131,"forth":2470,"preclude":10812,"wladimir":27875,"outdoor":13512,"weiss":13816,"barkley":49452,"clubhouse":47267,"cq":48960,"domes":41846,"poet's":48808,"onih":26531,"hippocratic":45439,"blueprint":27713,"massacre":3206,"michulec":41959,"lg":37623,"u2":16196,"frontal":22225,"undisputed":9932,"lady":2823,"exists":1333,"feeding":9848,"lately":3986,"bulldozer":12024,"cena's":37755,"brown":1871,"consensuses":48336,"rage":7619,"''''''004":24105,"9am":47988,"mala":45216,"josephson":28328,"raff":42123,"oligarchy":33270,"ordinate":33559,"trads":48129,"pontificate":27006,"hmmmmm":20878,"cfp":44072,"jill":14946,"swings":22162,"stho002":41183,"visibly":17614,"proceeded":8659,"extinguish":24461,"playboy":13409,"huntzsch":38656,"haphazard":30325,"50px":44549,"infromation":41025,"sw":19058,"lesbianism":28878,"toodles":39420,"manhattan":9982,"picard's":43490,"woah":20141,"prometheus":14282,"sns":32367,"hunted":14666,"davisjune":46062,"memorabilia":36821,"sequined":39698,"a9":22799,"zak":31532,"secession":16027,"chippenham":44243,"'reliable":29919,"strange":1973,"foremost":10353,"stew":29542,"condensation":30448,"dessert":36305,"brighter":21757,"desert":7487,"verses":6005,"brokeback":35466,"simmons":16936,"briefings":30205,"same":138,"decoding":35753,"elaborately":40098,"collectonian":19495,"wikimedia":1542,"jello":34237,"trial":2569,"wb":11960,"mudslinging":34955,"gang":3714,"stanford's":46163,"schizophrenia":11596,"recliner":26239,"mangle":35715,"gif":3594,"torpedo":28192,"gladstone":30127,"'08":14073,"bow":6284,"others":260,"musician's":38979,"zoomed":36105,"verbage":40964,"hattis":31879,"amanbir":34926,"ham":10650,"parliamentary":7407,"stigmatize":36084,"replying":4088,"naw":27690,"unprovoked":26470,"pigeon":15001,"sinus":49221,"satire":11049,"marcellus":49347,"captivity":18495,"objectively":6648,"pancake":39343,"irrelevent":12093,"arvanitas":42106,"fixation":17934,"nixon":7353,"play":839,"rdt":42255,"syria":3972,"zakusage":37175,"regurgitation":43199,"erecting":35804,"jumbo":29202,"grandmother":10541,"relgion":31523,"manufacturer":9372,"lizzie":37254,"mentality":7217,"lions":13430,"unemployed":9280,"glands":23929,"considers":4685,"censusit":39196,"daylight":14079,"v1":22653,"wikicup":11735,"1up":28994,"distributes":45651,"batch":11991,"perjury":35025,"deserts":38091,"amaral":45087,"nalchik":43281,"officer":3283,"harwood":42837,"contradicted":8002,"fed":4956,"ismaili":48889,"bribe":17984,"kirkconnell":31856,"standardisation":24363,"cunningly":49311,"26th":13839,"policies":515,"barlas":30810,"cardiovascular":24244,"ten":1888,"formulate":14918,"turrets":28982,"studios":7739,"japanese":1360,"shastri":36969,"experiance":27065,"treason":11845,"anywhere":1527,"waste":1655,"mx":49631,"ididnthearthat":36540,"unfortuantely":45946,"appallingly":31302,"simultaneously":7316,"sumner":27640,"wrap":14522,"breeds":8521,"announce":7248,"exalted":38023,"reconition":36096,"speculation":2480,"emits":33317,"limitless":36013,"intersect":30760,"radiating":42570,"mindful":16772,"juris":45464,"traction":14653,"autograph":16700,"rambled":46179,"herat":22068,"bais":21972,"davidson":12890,"timid":37259,"corporations":8264,"openpara":49032,"downplaying":35364,"'we":19264,"victims'":35538,"cease":3683,"clarified":4164,"rarities":44407,"str":33189,"naturists":40700,"feher":41164,"nikki":19243,"zaolzie":49247,"heritable":38530,"invasions":15244,"vecia":31689,"bold":1532,"upside":12772,"extensions":15843,"cheesy":22073,"shankbone":9488,"swore":16565,"shud":26615," gb fan":42084,"burying":23631,"characterizes":21015,"birthdate":13292,"multilingual":20286,"potato":10411,"pansy":19304,"apperance":36521,"people":74,"elstree":49854,"'''''' talk":14751,"desperate":5960,"jams":38892,"'may":49722,"feuding":32978,"trp":34035,"bump":13364,"thiruvananthapuram":36754,"marched":28365,"entendre":46642,"kandahar":40463,"setting":3889,"relax":9446,"device":4045,"forums":3021,"madre":40917,"saddest":40027,"whc":30841,"radically":14631,"pasternak":46652,"perhaps":384,"augusta":43629,"crush":10009,"'have":38283,"audacity":11270,"szentivanyi":38313,"coburg":23460,"terminal":9070,"expansion":2791,"leopold":32370,"arrivals":24764,"reagan":9206,"sinebot":15558,"ours":7421,"praise":5279,"descendants":5368,"grays":34303,"a3":11548,"flewis":21739,"waka":35949,"proportionally":33411,"alba":19154,"fiber":11808,"ony":30384,"downloader":48583,"fu":5527,"petronius":38591,"oceanlab":41622,"decausa":22349,"argue":1306,"bmw":10830,"bonnet":34002,"scratchpad":49851,"annum":43458,"sena":24645,"whisky":29721,"stomping":37603,"uhbsirtubgyihihlkjngkjbnkgjnbkjfgnbknfgjkbnkfjgnbjkfnjbkfnjbkjbnfkjnbkjnbkjnfbfkjbnknlkshubnsutybnisueynboiserubnsiunybiosubnioseubnoitybnosiubnosriutbynsoitubnosiubnsoiubni":15178,"nowitzki":34067,"cyrus'":45219,"disheartening":21329,"locator":16901,"whiskey":20041,"trashed":13569,"affirms":26611,"electron":6844,"that'll":9324,"strut":30913,"hoeness":31554,"disarm":40824,"facepalm":30304,"unlinking":42440,"goe":28214,"complimented":25344,"instrument":6213,"undermines":15111,"'people":32883,"schengen":15650,"machinations":20461,"intermittently":42162,"aql":24328,"muddle":29195,"mps":11922,"airplaneman":48147,"htm":2182,"gordo":43569,"durand":37834,"escape":5766,"antioch":40130,"curid":28047,"humanist":15487,"celeb":28611,"instruction":8280,"triviality":29467,"elle":23824,"badly":3181,"governing":6894,"concholepas":19454,"earthers":34941,"pechenegs":34756,"mongoliensis":47945,"habitats":46379,"nit":12927,"regiment":6945,"medal":4890,"shutup":22406,"suppression":8751,"naresh":34636,"moons":19332,"bugle":27632,"imbd":25489,"accompany":21634,"stimulant":46327,"cow":7210,"dragonball":26338,"cfb":25713,"spokesperson":15479,"powhatan":37746,"что":45970,"juarez":35681,"cystic":26545,"oaxaca":31156,"ruggero":37718,"sting":12015,"delinking":24763,"anthropological":12507,"méxico":40984,"colonel":9519,"expended":20438,"racer":17495,"junior":5492,"zombie":12026,"perusal":25015,"professing":46100,"manure":31155,"lobotomy":37776,"magnolia":38604,"bullshits":42346,"reorganisation":26677,"20of":30947,"kana":37713,"seperately":21687,"3x":36820,"sulaiman":39356,"overseen":26678,"ekiti":41708,"collin":21196,"tidbits":20631,"agian":22143,"realised":5896,"glaze":42396,"cursing":16746,"exercised":11946,"dylan":7687,"manipulated":8774,"meet":1079,"idiocy":9870,"allegedly":5660,"mandated":20807,"lehmann":39812,"annan":37735,"namecalling":34913,"terrorism":2145,"collegiality":25197,"impressed":4610,"mrmacman":42509,"facility":7648,"az":13538,"ojha":15420,"outrageously":25102,"santilak":25796,"coordinate":8289,"girth":47635,"bebe":46332,"gaping":21372,"coupe":37554,"dives":31971,"taxonomic":20791,"kissing":11527,"proactively":32617,"maribor":47645,"backlog":5956,"referent":26869,"outages":40507,"implication":6132,"goodison":47814,"cal":13704,"mysticism":17254,"belief":1962,"lévi":34782,"characterized":7796,"boarding":16048,"dwarf":10419,"迷惑":15207,"franc":44054,"spiritism":38771,"innings":27040,"harras":40688,"wikipolicy":19343,"heap":13427,"eagerness":28817,"aleem":24003,"sajjad":40752,"bhai":23301,"semitism":5198,"exonerate":41656,"pezzi":44071,"jpgordon's":33755,"pollute":25886,"proved":3096,"settling":17823,"fuss":9227,"goodday":13247,"actually":210,"stoned":27090,"integrating":17619,"dool's":44835,"bureaucomité":45954,"yusuf":20809,"hulk":13167,"lamest":32959,"hasan":18231,"nixon’s":37501,"né":44714,"endlessly":10713,"legalized":34491,"organic":8545,"twinned":36621,"baffling":26879,"tattled":48934,"precursor":17179,"groin":25824,"guzzling":44654,"axle":35918,"photo's":16625,"idonije":48425,"instructed":9676,"comic":3552,"ead":39787,"paramilitaries":28079," boomer":14905,"virginia":4600,"ancestry":3608,"nagorno":12193,"sahoni":45454,"makings":28898,"foreseen":37481,"fantastic":5461,"informatoin":44680,"mytalk":46974,"eleven":7141,"transforms":19429,"yoruba":17365,"events”":32768,"creating":796,"scarring":44053,"religous":38309,"addicted":11747,"deborah":25809,"star":1494,"myself":474,"hologram":39680,"brno":46814,"jackets":18152,"ferrylodge":33856,"e":311,"leslie":14380,"forgive":3220,"hinged":49066,"weasle":32410,"stain":21621,"arrives":15951,"affiliates":13660,"concentrates":20468,"spherical":14802,"churchs":44478,"string":2970,"guest":4625,"gandalf":42305,"linux":4545,"croatian":2809,"pines":47123,"reponse":27491,"hen":19678,"arent":9057,"reliably":4975,"activepol":49210,"staten":16570,"ronnotel":26343,"griphook":41288,"internazionale":45085,"decompression":29143,"fyromian":36793,"lithgow":46010,"overly":4179,"coastline":42356,"poofter":40908,"copts":29171,"combining":8226,"pressing":7015,"resigning":42402,"chandigarh":31738,"downgraded":23368," jan→ ":20078,"worst":1952,"spretti":43218,"signaling":18068,"theweek":39468,"restraint":13979,"textitalic":34091,"poulton":43212,"emanating":26697,"teugels":42204,"col":13594,"herb":11978,"carpets":29473,"mrg":30193,"lexicographer":45099,"experimented":31261,"stewie":37094,"confetti":39433,"grrr":44833,"tlx":29723,"pontiac":27606,"becky":21533,"personalized":19092,"precepts":28404,"yankees76":29830,"dss":38107,"psycho":13252,"ab":6901,"afshar":39969,"info":468,"servicing":25672,"tart":32360,"'free":28465,"traditionalist":21400,"promises":8600,"silk":11488,"af":12415,"number'":45848,"hardness":49742,"scimd":27465,"irrelevance":21182,"brainer":21622,"vegetation":32175,"comp":13530,"upa":14863,"njgw":7402,"konoha":47634,"kirsten":16601,"pitch":7557,"obscura":38699,"admirable":16176,"malignacy":40245,"upstate":27577,"coi":2352,"geopolitically":40783,"borrow":15349,"rohl":43959,"thinker":20272,"yank":9896,"berger":18569,"harry's":18058,"torque":23842,"hanoi":26934,"stryder's":42335,"fleur":34295,"latimes":35522,"questionably":37292,"sentinel":33406,"plasmic":29114,"intercontinental":22302,"concluded":4944,"unify":26295,"assaulted":13302,"dropping":5069,"electrodynamics":28541,"seen":451,"saduj":47830,"rhetoric":5627,"killer":5860,"kushwaha":14928,"positioned":15933,"acroterion":17075,"systematic":6953,"mucho":38127,"arborsculpture":20875,"caw":46080,"c'est":20316,"crackdown":23577,"mkd":43215,"bich":32208,"penned":25076,"failings":20409,"rocked":40014,"pissing":8831,"inaccessible":18810,"almight":45699,"hampering":40600,"8c":44855,"klein":15488,"timestamp":9803,"arrow":7837,"historic":2619,"teas":31603,"slack":14654,"aphorism":42041,"andranikpasha":35999,"zajti":43054,"brahman":25944,"vedas":11601,"masonic":7832,"surfaced":17830,"bergen's":40343,"theologically":34901,"letting":2367,"'control":16396,"author’s":25542,"jauerback":37721,"starter":15078,"revamp":16927,"wake":4252,"pederast":30281,"aja":38264,"snapper":24251,"sensu":45289,"uninvolved":4863,"sfry":47451,"unrepentant":29876,"turnitin":31218,"bf":20004,"drakhan":47212,"adrian":11402,"lw":25686,"ultimately":3659,"fdny":29766,"0422":18084,"leaping":41677,"mogadishu":40066,"dobson's":31356,"meetups":23816,"gees":32295,"quantity":6798,"tabthe":16245,"cee":31644,"arguements":12989,"ventured":25635,"christina":13996,"wife":2281,"giovanni":13664,"washington":2191,"halstead":47463,"narciso":20514,"paralympiakos":34575,"caff":43611,"awww":14031,"patients":5097,"ih":39139,"ambient":22119,"coo":43904,"sahaba":36836,"loud":5135,"vale":32060,"bird's":17377,"breakdown":9642,"teens":12500,"ubc":35354,"beagle":30657,"prc":8486,"isolating":27185,"bidgee":35891,"impressing":49139,"imposters":27556,"globes":39150,"avengers":17185,"goggles":49600,"rovoam":20798,"theis":41981,"shi":15781,"goingbatty":27014,"payment":7714,"hast":19889,"iskcon":37733,"sternberg":31861,"wma":42808,"monde":21407,"kayla":31341,"helicopters":15132,"willa":46411,"indefensible":33074,"newly":4693,"hoover's":31072,"surfing":25486,"gamble":16618,"hairsplitting":49826,"souls":13682,"hobbes":34522,"聖やや":16627,"wikipedians—as":41501,"formative":31627,"内jinnai":39004,"sycophantic":21658,"incense":42496,"bronco":43259,"mees":10631,"fascist":3370,"schofield":36615,"cartridge":13325,"spiro":22807,"rajahs":46896,"indexing":22649,"insecticide":34510,"seem":361,"jl":25712,"raven":8718,"wrist":15421,"map's":32547,"bolded":9921,"donaldson":40044,"esa":26913,"predictor":43675,"athaenara":39276,"purged":14637,"wikifeed":43649,"'''' talk":31191,"littell":41547,"repercussions":13396,"sweet":3865,"mysterons":45862,"tj":15054,"definitively":12963,"ancestral":13117,"pooltown":38844,"moveset":43077,"finding":1267,"alfrem":29419,"libris":25780,"whore":2852,"avowedly":39048,"fagan":40387,"difontaine":26305,"hooknose":27387,"indus":13523,"majority":1014,"george":1378,"operational":7928,"sentense":34414,"charlotte":10515,"majesty's":36333,"cleanse":25541,"corinthians":29381,"'alleged'":45218,"drain":12106,"investigators":14702,"eva":15985,"justified":2568,"strenghten":47092,"ceop":39934,"k's":27761,"calvary":35437,"interfered":17801,"fujimori":37879,"futperf":34898,"beside":6217,"welcomebotresearch":22473,"galaxies":36176,"pigments":43392,"trademark":7195,"orderly":25759,"pardon":6841,"rudest":36049,"ives":21869,"diary":9492,"enhancement":19221,"evident":4017,"motorola":44035,"dissenters":16021,"elemental":28211,"anorexic":35513,"arsten":19982,"remake":14108,"utcs":41350,"j's":48636,"delennart":26844,"staffordshire":22149,"khyber":31572,"bcyf":41597,"amarnath":43364,"starm":28182,"neologism":8519,"unrequited":45353,"unratified":47741,"twain's":38698,"sales":2795,"duly":8679,"enquiries":28062,"piss":3476,"ugh":9813,"blessings":13985,"pahlavi":21406,"jesuits":33854,"fixing":2655,"£€åv€":49254,"oral":6736,"abd's":36769,"orr":31219,"leveling":22471,"acim":22114,"longhair":26184,"samoans":25731,"greeted":30698,"depressive":31466,"whipped":29663,"areaseven":35226,"minderbinder":49575,"encourage":2374,"gravity":5325,"hersfold":21996,"bagramyan":47874,"fia":47674,"whitespace":20755,"verb":6352,"libraries":7014,"jesus'":14502,"rebranding":36367,"daniel":2984,"coventry":28989,"designate":13133,"beacon":22421,"local":1155,"reginald":46301,"newsbank":47446,"blpsps":43472,"transvestite":21311,"zaladonis":40209,"anchor":10071,"satyasraya":22025,"extraterrestrials":36072,"lifelong":23746,"syndicalism":28964,"превод":27583,"stronge":35695,"spilled":18550,"dob":12345,"†":7853,"aquarium":24243,"faggoty":23967,"manipulate":6889,"jalisco":36565,"counted":4820,"kieran":49710,"dares":13954,"winick's":37651,"provinces":7485,"sds":41847,"glasses":11266,"kappa":9829,"brookwood’s":38214,"sounded":8269,"kit":9493,"severly":32745,"champs":28754,"docid":37547,"rely":3861,"'political":42414,"insurgency":19170,"rat":9456,"avenge":40614,"aran":24766,"harem":37048,"necessitate":36938,"shatila":30636,"pasties":46840,"grab":9548,"based":397,"tassler":45935,"cretin":14771,"hijackers":19838,"newport":21570,"harmful":5177,"psa":25543,"tod":11958,"doings":40676,"electrolysis":16611,"worship":5346,"este":26301,"'for":26257,"instituto":45251,"ware":25101,"hegemony":25850,"electronics":9969,"intensively":33425,"referential":29509,"novel's":41500,"murky":18817,"translated":3059,"suzuki":29761,"coats":12868,"pf":16787,"arseholes":34419,"student":1938,"pds":32172,"sarfatti's":30450,"matthew":5566,"obeying":34421,"formulations":19688,"storey":45786,"espouse":24542,"whoopee":28348,"coliseum":26352,"frankfurt":19661,"tomaxer":21911,"sweating":31284,"contrition":42904,"muñoz":33804,"flrw":38806,"kerfuffle":36123,"charmer":49661,"emd":39210,"administrate":32661,"yemen":11744,"olly":45409,"behind":1114,"untagged":4417,"apartheid":7401,"siegel":27244,"abstention":38339,"binksternet's":44906,"rail":5407,"churlish":28564,"farley":33826,"peg":14824,"delightful":27827,"ammo":20159,"symbolism":11518,"ist":12085,"strongest":8363,"beheading":30558,"pressent":44456,"liberating":29973,"crushes":44416,"vulcans":33087,"tarom":28823,"tirelessly":26846,"illegal":2112,"premiere":11932,"'who":36677,"squirm":40510,"nearly":1744,"ma":5604,"atkin":34837,"nableezy":7761,"propably":41675,"horrid":11260,"potted":37492,"whiner":32103,"shell":5292,"transliterate":25757,"jabs":27490,"cooperating":17759,"openlibrary":33736,"patched":29528,"gettysburg":31841,"macho":27965,"asylum":15267,"byt":41852,"risen":18191,"vanadlism":48114,"2nd":2106,"practitioners":8077,"blake":13440,"kurt's":30445,"sell":3529,"witty":16425,"breach":5089,"beck's":24080,"ruthlessly":22251,"martians":26582,"is":8,"swath":34075,"column":3421,"mughal":13920,"conquered":7641,"excitable":48721,"cham":11380,"darkest":47824,"famers":34684,"credited":4539,"mahesh":27536,"partaking":35294,"'from":42979,"hummel":35534,"shugden":40158,"government’s":45571,"soldier's":46726,"furthermore":1644,"techca":37437,"autosigned":25994,"tibetan":8214,"unseemly":31497,"michalczewski":37255,"asleep":12824,"cantrell":36833,"winkler":27689,"nately":46356,"politically":3155,"gayfag":6809,"dura":41215,"polarization":35597,"rereading":24972,"geopolitical":22769,"freddy":17197,"proceed":3612,"doctor":3006,"multimedia":21144,"hostel":34795,"siamese":21064,"collectivist":45037,"figuratively":28112,"eubulides":14754,"gunning":49296,"mhp":14101,"wba":47367,"depressants":33824,"kahane":23027,"contracts":10581,"throne":9721,"abbasid":33690,"giants":11916,"dershowitz":21919,"badmachine":26003,"fictionalized":44429,"timberlake":35063,"whitaker":24975,"inadvisable":30709,"vandalisim":19748,"paddy":28740,"serbophobia":26900,"challengers":37569,"blpcat":40323,"unreasonable":4220,"vellalas":40069,"nussle":32724,"colombo":9168,"shapes":15690,"hughesnet":34789,"wtshymanski":29197,"blizzard":29765,"theories":1699,"lincoln":5949,"newsgroups":46250,"underestimated":37200,"cortex":24007,"mechanisms":8365,"teammate":39962,"wanted":540,"forgot":2117,"installing":17191,"'06":16387,"'free'":41115,"unfortunate":4246,"eclipse":15169,"rogan":31993,"incorrectly":3963,"analogue":21751,"abhira":16967,"factcheck":49405,"╫":35878,"earnest":19278,"disciplinary":10839,"wap":46551,"winter":5036,"impaired":16223,"leftwing":26647,"lefty":17699,"maxbrowne":30250,"foe":26616,"ordering":10183,"program":1421,"supra":31975,"ethnonym":42957,"andhra":9147,"popish":48916,"remarked":17212,"sbharris":41599,"anachronism":21278,"atoll":37388,"freed":11636,"marlow's":31135,"straightforwardly":36899,"æ":27412,"resided":18034,"fountain":18052,"chaudhary":46947,"hostage":13064,"expected":2310,"addictions":32482,"icecream":40282,"binswanger":45919,"twenties":24019,"wacko":17541,"lips":10599,"dictatorial":16187,"chaotic":12501,"titillating":36642,"contracted":14226,"harass":3704,"linkage":13120,"mins":12636,"synthetic":12312,"invest":10993,"deadlock":41757,"wan't":26302,"speakers":3026,"sixteenth":29797,"nicknamed":19726,"absorbing":36758,"eleventh":21255,"georgia":3725,"undos":24717,"sinister":11729,"thumbing":36998,"respondent":23130,"superhero":14701,"yehovah":12471,"stalins":36738,"aiders":46483,"reasserting":49087,"guesswork":31559,"‎read":32665,"reyes":33230,"don'y":40048,"dreadstar":11441,"photographer's":40386,"season's":18998,"paraphrased":10076,"hammered":15880,"locomotive":13914,"print":2704,"tzvi":47213,"brion's":46219,"mint":13681,"trick":5105,"gorilla":13475,"skeptic":11359,"world’s":18414,"cato":27471,"sht":15987,"vehicle":3388,"daft":11053,"likeliness":46487,"pokémon":13112,"whereever":31938,"calamitybrook":36588,"blackjack":26491,"haste":13718,"suzy":47671,"24mati":46127,"furse":43799,"son":1431,"stressing":17694,"caliphs":40550,"hazing":31932,"tabwe":46860,"ovw":23289,"unfavorable":15887,"franks":12228,"relaying":43103,"ceyockey":22736,"wikitable":10660,"wildhartlivie":12951,"duran":28661,"guillermo":45391,"rockefeller":30674,"ongoing":2391,"jayjg":6951,"peters":18676,"quantization":37727,"troy":13509,"mlb":9808,"hablame":33782,"unconstructive":2625,"♠♣♥♦1185♪♫™":46318,"newsweek":13542,"across":1099,"foucault":43749,"jihād":19466,"dissected":48938,"bomis":39387,"loony":21599,"cerebral":15476,"looses":43871,"downed":37548,"burnett":13855,"conscription":45936,"casting":6984,"goverment":10332,"chimpanzees":47359,"militaristic":39047,"bautista":30151,"complying":18020,"resolutely":49717,"niteshift":23613,"goldfish":25248,"'policy'":41523,"display":2790,"everyman":25531,"justin":4649,"sep":4209,"dubiously":44916,"domestication":29200,"unconditionally":25631,"daddy":7440,"haiti":14459,"nairobi":41933,"v88":31500,"4ever":27584,"verdy":27183,"hurled":29792,"strengthened":21509,"  talk":44851,"intimidating":10861,"wealth":5550,"streams":12467,"tweaking":11802,"template's":13216,"dilation":27348,"moralistic":32304,"propagandist":11895,"squared":30292,"undetermined":37451,"salvageable":23688,"use—":30904,"rotating":8378,"deflect":21272,"omniscient":24757,"loathsome":29532,"anyplace":36313,"detested":47821,"sentance":12737,"mutha":17410,"afternoon":6575,"taivo":20291,"causes":2734,"unwanted":8093,"trestle":41370,"provisions":9466,"allowed":752,"tokerdesigner":16472,"dịch":44601,"separate":879,"televisions":35018,"img153":46173,"mannered":32183,"textsubscript":46683,"nath":34130,"awaiting":7682,"tatpurush":48861,"protestants":9300,"hull":12792,"grips":26709,"touting":39922,"acceleration":7048,"bcm":27319,"controller":13814,"study":1161," circumcision":45437,"razor":11887,"hrm":21469,"amortias":38450,"carom":41687,"princess":4915,"substantiating":35217,"bars":9334,"indents":31212,"differnet":35382,"whims":19008,"chance":1069,"cmh":24863,"baptism":16817,"boxer":11497,"puta":26772,"variables":9191,"pulaski":45790,"viscous":31616,"morten":34745,"supervise":22362,"discarding":22640,"farmbrough":12188,"putin":7692,"hitchhiker's":29256,"agains":18373,"dillon":21237,"usurpations":16498,"smegma":37132,"bhatt":31857,"supershadow":38766,"intending":9215,"publication":2109,"organiser":41282,"mbz1":18573,"overflew":48345,"pomaks":24984,"mckenzie":32795,"zooming":37389,"hp":8520,"warren":6055,"animeking237":34992,"francophonie":48309,"kitzmiller":29063,"voodoo":23325,"ecliptic":40990,"dignified":33858,"beause":41297,"disambiguate":10837,"availability":11656,"gallo":41803,"cecil":21486,"leifern":28040,"privatization":21984,"deir":16346,"gallant":24811,"'peer":32964,"kilobytes":29923,"sheet":8184,"margin":5386,"modeled":25889,"surrogate":25993,"osmotically":48671,"going":168,"aggravating":17771,"d15b8":15958,"22earth":38784,"conf":34591,"sneer":23177,"condense":16747,"firm's":35438,"compels":30422,"mediterranean":7932,"très":35133,"ruins":13567,"talkcs":42090,"evaluation":6318,"prasad":14466,"newlin":39724,"devil":5061,"ajaltoun":18780,"miserably":17689,"argued":3088,"limped":8540,"semiprotection":27694,"narnia":30591,"planetary":11513,"court’s":48683,"stem":8667,"tothe":46859,"fanboi":46983,"weblog":29087,"headedness":36394,"taps":26006,"accessmylibrary":47169,"egregious":8329,"under":177,"snot":18654,"symptomatic":24693,"interconnected":42040,"propelled":41388,"terraria":45995,"worshiped":32164,"workflow":30206,"karma":9100,"incidence":11321,"redeemable":38229,"catered":30424,"vsmith":20780,"supposing":22475,"naughty":7536,"mountaineering":29379,"snes":20407,"worker":9479,"individuals":1860,"unspeakable":34871,"crown":4499,"akra":38119,"ozzy":32101,"nndb":41801,"overlooking":19933,"shonen":31988,"hoots":45943,"alternately":18800,"golfer":30253,"duties":8082,"niven":31015,"corroboration":22369,"startling":24661,"cedar":16065,"electronically":45305,"myslef":39153,"moon's":16644,"pl":6646,"henri":18591,"neglects":30900,"claudia":33308,"minimal":5536,"vps":45136,"abbreviating":42926,"immigrated":19737,"bösendorfer":22037,"taboo":12463,"befor":31246,"brainwashing":20659,"zürich":42563,"kirby":17219,"hogwash":20303,"georges":19563,"waht":20338,"chants":26884,"responsibilities":11859,"quadruple":39332,"tlt":43350,"ppp":19528,"boots":12372,"gmail":6739,"booher":43971,"sojambi":35898,"mudvayne":49816,"deforestation":49640,"regent":22441,"reflexively":33992,"cena":9458,"dwell":20880,"jessica":6759,"familiarize":8673,"openly":4258,"vinogradov":39813,"pardoned":44431,"midfielder":19293,"trappist":44277,"contestant":12981,"threading":45236,"tasmania":15621,"elwood":14828,"ceha":34383,"wikifying":19504,"pero":34324,"mcdermott":46557,"signify":10728,"branded":11491,"dps":41490,"excels":42838,"lime":18589,"evolves":44110,"rudzevicius":40450,"dodger":44886,"uuuuu":31121,"condemning":17364,"caravan":43816,"mbar":39481,"withing":36680,"40's":34210,"occupations":14596,"samples":7770,"arturo":22788,"tmz":23501,"fleeting":30190,"organizations":2255,"inviting":8483,"charming":15911,"chancellors":40202,"wasnt":4882,"heroes":7653,"sharpest":45042,"warcraft":13650,"mccorkle":36197,"consume":15771,"bamboo":28343,"barrymore":19175,"editorially":49545,"sportspeople":23332,"country's":8752,"presenting":3740,"prick":2981,"resentment":13326,"spinoza":33489,"informative":2858,"ammended":31910,"malleable":48074,"capture":6721,"i'd":389,"hornbook":41797,"kumite":40930,"repealed":20754,"fishes":21445,"azhar":16473,"timbers":39712,"grabbing":19136,"dispite":33732,"neighboring":12123,"hop":4125,"bloom":13912,"pa25":38294,"caterpillar":25208,"wright":5184,"mbo":33809,"rival":10636,"sport":3267,"treasonous":48427,"drummed":44026,"advisories":42695,"osha":37176,"magnotta":24166,"20surgeon":47569,"clumsily":39458,"nyc":6514,"gldf":31457,"nonexistent":17036,"indulging":24849,"complicated":3713,"tolerence":47728,"lexus":41145,"turret":12637,"rappers":22234,"softball":26565,"superman's":48918," rjaguar3":47215,"raspberry":31187,"breakthrough":21498,"hazelton":28673,"orson":34306,"judge":2214,"despised":19040,"naruto":11201,"openoffice":33677,"anglos":37928,"northbound":49599,"formulated":13080,"vdare":32446,"overnight":16274,"cmb":43271,"statscan":41889,"tool":1854,"pulley":16474,"batta":44170,"ryan's":16789,"rape'":48029,"issuance":37269,"hushmoney":44140,"libtard":8541,"turbulent":24637,"gb":9156,"informatics":40598,"arabist":42500,"aachen":41193,"ref":1757,"wingers":16689,"mongos":48303,"bowen":16385,"irreversible":24695,"docet":46430,"marconi":37169,"predicting":24160,"sirag":45526,"“he":22353,"crafty":25280,"multinational":19630,"castrated":27803,"province":2855,"ammonium":37770,"resonant":31415,"thumbs":14822,"lahore":14127,"hangout":42439,"'pahul'":49554,"clinton":4301,"wada":34404,"sputnik":32567,"victim":3144,"intercepted":47644,"aww":17332,"visceral":37350,"jeffery":27943,"ramesses":34721,"house's":33570,"albury":33265,"zurich":20630,"sucking":6056,"burner":36736,"withstanding":44556,"unfairness":24987,"contention":5204,"ideologues":22394,"ebyabe":36712,"meagre":35036,"felix":11199,"access":915,"unused":8318,"mustangs":23080,"edison's":23061,"modelling":28013,"axioms":16462,"deflected":42159,"tyar":49277,"blasphemy":18814,"builder":14157,"rs":1492,"newsletters":18806,"lovingly":26029,"dostoevsky":31436,"hospitalized":42691,"negotiable":10828,"thes":27162,"teritories":49714,"grace":5554,"hiya":11443,"dzierżon":48068,"dance":3029,"idols":24819,"guarding":18423,"removal":1074,"sevenfold":48668,"karel's":46143,"nationally":11204,"adoration":38092,"buhay":49863,"nebulous":27784,"workforce":32625,"ali's":32018,"bureaucrat":8675,"qm":22783,"hurrian":31781,"ths":18422,"marsden":18391,"debts":23096,"terminators":27607,"nikaya":39340,"account":341,"etcetera":18240,"undiscovered":44464,"alpine":24590,"babylonia":46941,"economic":2438,"mudurnu":49524,"shattered":18175,"daryl":32704,"bananabucket''":30000,"humus":19569,"andrea":11306,"zilla":34749,"acouple":46320,"scurvy":41266,"worry":1910,"schema":41481,"robbing":21948,"wt08t":18776,"kingfisher":43888,"laurel":41697,"eisner":34156,"christians":2146,"molar":42706,"laser":11950,"assessment":2654,"clad":24719,"cossacks":29313,"presented":1287,"psalm":30934,"rvs":42856,"senator's":26891,"misquotes":26105,"jytdog":22480,"equitably":44934,"placement":6691,"diamonds":17838,"instinct":18580,"reversions":3470,"maximizing":32872,"firs":41286,"becasue":14016,"clnk":41986,"15pm":46552,"ungrateful":37352,"serialization":25828,"shores":22745,"maryam":44165,"armada":37839,"libertarians":12403,"gears":16715,"zaloga":39180,"admiring":41627,"hui":35939,"qualification":6521,"easter":7913,"discrimination":4803,"golota":48515,"irving":10225,"notabilty":43801,"oooooh":29254,"shahnameh":45127,"gloucestershire":32785,"distrust":21983,"emphasis":2980,"fight":1355,"word":286,"pragmatic":18158,"narcissistic":24850,"ws":10018,"hesperian's":44405,"uphold":8036,"observatory":15906,"reconquest":44915,"facs":14326,"magnificent":13599,"closeness":22188,"carex":18122,"mergers":23611,"insecurities":25970,"jimfbleak":43037,"1990's":11015,"comunity":28634,"'drive":36343,"unassuming":44521,"rhythm":11399,"awlaki":31471,"mastcell's":27750,"marylanders":48710,"brando":48246,"yeshua":38271,"preemptively":42282,"pox":44760,"drool":40906,"performing":6174,"sandwiches":43689,"otto":27763,"tfas":46682,"limoges":46547,"collaborations":18055,"polar":8403,"fairer":19083,"flinging":35220,"iban":15497,"armageddon":27114,"sourcebook":32287,"spirits":11955,"probations":44981,"rbi":25952,"airhart":44146,"conferences":10734,"mankind":7163,"tripoli":36113,"herschelkrustofsky":47227,"tofaan":37116,"satellite":5966,"voluntarily":9041,"tafi":22992,"rydberg":24232,"handle":2660,"octaves":22925,"amari":48734,"bluster":27292,"rather":266,"sues":41824,"pinafore":45248,"nici":38927,"wrecking":23828,"patron":17848,"increases":7673,"declaration'":40148,"headers":8195,"freebie":31201,"permeates":32028,"surgeon":14020,"mcc":43810,"rayner":37014,"equation":5941,"specificly":33121,"weight":1351,"aspiring":23292,"tossed":15807,"emery":49134,"topography":27024,"onwiki":26120,"flocka":40287,"noble":5512,"clashes":15960,"otrs":6193,"begging":8098,"hitherto":25609,"numa":38819,"cohen":9575,"thuranx":32092,"strata":27193,"langley":32732,"✉→''''''←✎":33847,"iridology":33426,"chajecraft":26516,"intruding":29757,"occurence":19980,"indoctrination":30967,"vitro":44781,"terrified":31007,"perpetrators":11983,"dipluridae":24366,"salish":41912,"smoother":30859,"asses":10414,"steagal":48817,"tyre":27709,"goin":16634,"wangi":35002,"breslau":31169,"04":1796,"rescuable":49706,"defeated":5237,"basher":38352,"zuko":49013,"performers":12592,"gaga":10769,"–jimmy":32541,"tekleni":30349,"sheba":26026,"yazdânism":31579,"⁂":19021,"meetup":5004,"ewart":33784,"rca":40869,"chad":8754,"aviper2k7":21094,"jobber":40668,"bend":10309,"dorothea":39034,"buildings":3754,"chandravanshi":38061,"volunteers":4795,"goldstone":26839,"dismantling":25413,"standart":47689,"uninvited":40399,"where's":6682,"aum":42732,"thermodynamic":31180,"harp":18643,"pay":1833,"shtokavian":30978,"sexology":30034,"franz's":29456,"refuge":14419,"cleyre":46633,"wildly":10682,"contest":1015,"stealing":7359,"filed":3178,"strides":40719,"enlisted":19559,"'''talk":16688,"soccerbase":32654,"wrench":28636,"combat":4457,"ritchie333":41178,"silencing":14086,"goblins":36766,"lincoln's":27080,"inconsiderate":17468,"hcl":37761,"spi":4976,"hayden":22682,"johnuniq":15274,"nominees":13059," •t•c•e•":24287,"buffs":32783,"para":5816,"forehead":15598,"treadwell":49485,"nsf":17681,"person":218,"threatens":10977,"focus":1563,"busybody":20259,"gf":17453,"winds":10889,"hierarchy":8764,"uncontentious":45502,"wendell":44048,"moloch":24802,"band’s":43829,"wile":39277,"accession":26756,"ccc":30062,"screeching":37953,"kerr":22335,"garrett":15240,"sibling":22722,"reorganized":15915,"blessed":9249,"oregonian":29344,"வேண்டும்":49608,"iwp":32098,"vhp":23894,"ni":6552,"nadirali":41782,"tittle":27070,"earning":14731,"chaining":36110,"inventions":10364,"sanitised":44789,"subsection":4236,"yum":21958,"explorer":7188,"alo":28399,"featuring":6649,"vet":18404,"wished":8090,"steamboat":31815,"grope":45323,"fabergé":49155,"gino":24115,"bostwick":35232,"undergrad":29227,"did'nt":30817,"floral":28453,"pseudo":4468,"tennessee":9251,"'is'":45802,"validity":3813,"popular":1217,"sudden":6478,"down's":25165,"utf":11584,"meticulous":26526,"xavier":17626,"let":267,"triad":46279,"derelict":44694,"shold":30373,"daimler":33686,"contructive":26074,"puss":38238,"falcon":9301,"'we'":43581,"claudian":32333,"doce":17978,"latent":48514,"absorbed":10991,"9mm":33234,"nitpicking":14307,"fudge":17665,"credence":12903,"von":4373,"deity":10380,"congestion":42394,"alighieri":46227,"starčević's":33696,"causeway":27407,"realise":3221,"pcmag":42484,"stereotype":10998,"proper":786,"goldberg":17560,"vic":11490,"rsa":25882,"shea":27888,"trough":21133,"kolzene":34015,"don":3803,"boyce":46000,"lincolnshire":43110,"dreamt":26267,"predimir":49456,"tou":27899,"terrain":14784,"lines":1645,"burt":34442,"ackoz":18816,"kindergarten":15608,"perchance":36391,"immortal":18692,"glow":19071,"bis":37421,"magog":26634,"thruster":19259,"eyeserene":47953,"destinies":48630,"justify":1895,"proposing":3770,"uspensky":49430,"purport":18053,"examine":4910,"any":54,"fides":35298,"endorse":5058,"habsburgs":41018,"emissions":11394,"ǀ":34869,"joe":2739,"sized":9245,"diatribe":13199,"chai":44692,"emotionally":8740,"tighar":22660,"amusingly":33522,"lossy":36048,"musicbio":33106,"credability":38649,"lucille":36401,"kelli":34672,"wsj":16918,"cyclical":46909,"southerners":29894,"trainer":23686,"otherwise":685,"uhhh":22933,"provide":470,"dinky":38719,"darker":9686,"damac":20091,"spy":8749,"lovelace":33528,"wišnasp":41455,"unearthly":20850,"neda":32008,"derailed":43035,"williamson":14685,"consult":5671,"rossitano":45886,"fairing":49938,"vaccines":15322,"hegel":30532,"entwistle's":27335,"yeah":847,"filmfare":37354,"marginal":10304,"dissapointed":22679,"d3":10451,"averse":29968,"decreasing":14323,"nayef":37701,"chameleon":15805,"expecially":47168,"crossed":6184,"jut":33401,"inorganic":28316,"countering":19157,"rezko":45785,"pageant":19978,"haitian":21710,"innapropriate":19925,"impatiently":47881,"afaik":8876,"kylie":37201,"pared":24069,"inuse":34007,"macroevolution":18545,"channeled":34151,"outposts":41149,"savage's":30855,"sikh":3694,"sent":1124,"'power'":34192,"whalley":39777,"ecw":8411,"lawson":25902,"leuchter":34500,"nudge":14850,"minuscule":23039,"proprietary":10723,"foreskins":30084,"cleavage":32527,"ffi":37533,"circulation":8834,"filename":17843,"merkle":36192,"peeps":19050,"malpensa":47593,"articals":32016,"talented":11000,"hemisphere's":49438,"nichiren":19460,"visited":4296,"liver":10087,"multiplayer":18146,"theironminer":31396,"proove":15786,"covariance":41692,"shgit":18769,"bnp's":39094,"african":1565,"asymmetric":31673,"goal":1957,"discede":17979,"bhutanese":42556,"dingle":29140,"served":2936,"dissect":27715,"satan":6145,"excludes":10551,"admirably":47636,"flags":3526,"hz":17529,"rafe":27008,"resin":27216,"shirley":14704,"spectators":36512,"colluding":28080,"pertaining":5285,"tas":13457,"mystic":16532,"coding":7387,"fagots":31339,"survive":5469,"precision":7833,"geller":25120,"∈":34670,"protons":25787,"ascension":38406,"ucmma":17158,"edc":49092,"quid":22004,"techno":10173,"subscribed":30691,"slashing":33871,"thug":10539,"comment's":49733,"stray":14960,"member":991,"kidman":49540,"pioneers":15898,"fking":27924,"godspeed":26145,"causation":21089,"kar":19866,"sahib":10042,"assigning":14267,"plastics":29410,"amity":42618,"contras":12973,"66k":37265,"benighted":40907,"acc":11913,"camera":4130,"badger":19854,"roman":1619,"vibe":24561,"conditioned":19544,"invaluable":15235,"santos":10947,"ybms'":37367,"mari":26743,"comb":13179,"treelo":36109,"dedeeireidwedededijkkvir":47836,"bender's":36876,"setbacks":30476,"execution":6535,"constantinople":15655,"dispositive":39882,"untold":24224,"'just":23457,"although":499,"infamy":30108,"pedigrees":37257,"flyable":45241,"cpl":37282,"integrate":9138,"mütze":21895,"victimized":33128,"devotee":25362,"shielding":45678,"entrezsystem2":29350,"san":1961,"offices":6325,"eject":40534,"1000americorps":38399,"arabia's":49543,"wcw":13171,"nir":44836,"improvement":2133,"kitchen":8813,"razed":28136,"removes":5130,"imaginative":19542,"metta":29763,"subst":4866,"pinging":20744,"ish":9327,"gifts":15257,"zx81":41926,"hugely":11245,"evidencies":36563,"features":2523,"iraqi":6581,"protested":13773,"gamefaqs":21646,"homonym":47233,"basterds":30421,"camara":33419,"southwestern":20432,"causally":40354,"seek":2219,"mona":23285,"impostors":28825,"ludwig":17117,"conceptually":26139,"dominican":8284,"flog":40754,"czechoslovakia":12068,"sanctionable":45416,"interferes":42281,"plucks":36557,"crs":23078,"generis":45288,"interface":7336,"baltimore":11538,"boracay":28266,"code":1377,"law's":26792,"sei":27562,"compensate":18365,"babel":17461,"ॐ":27125,"✄":16256,"defacto":15895,"···":16266,"shiraz":27266,"expulsion":10803,"anatomically":29647,"tila":37749,"sentencing":20017,"gore":9131,"cold":2788,"consilium":24382,"kessler":40422,"welding":19228,"box":926,"jacobin":47692,"emanuel":26784,"mascot":11642,"insecure":14261,"assigns":21212,"'net":35194,"affirmed":16124,"fuking":21563,"aram":28705,"chronicled":46771,"wilfried":49106,"overweight":13829,"handlers":31063,"antiquated":21700,"wigwam":46392,"character's":12132,"flo":20075,"venda":38778,"deneid":2764,"'05":48612,"kamu":44213,"i8":46192,"zine":28125,"prague":11103,"myspace":3717,"socioeconomic":26219,"genitals":18368,"goliath":28482,"ragnarök":47546,"awb":6543,"klptyzm":19575,"badvista":24356,"swedish":3664,"harbour":19077,"canada":1447,"fluctuations":33555,"ќ":44291,"independant":15055,"charismatic":29665,"lunatics":21258,"those":142,"editer":25948,"whereabouts":23571,"mornings":43757,"palatalization":37998,"mzilikazi":17969,"university'":37964,"latin":2049,"bolster":19780,"regency":30833,"ric":17658,"hongkongese":46949,"cantonal":44796,"cassette":30155,"appending":33025,"humor":4379,"regalia":46984,"as":17,"medicines":30539,"stealers":43698,"publicized":14497,"lm":30064,"084080":5848,"heiemo":43439,"rood":41462,"khan's":27350,"c2":23167,"metion":41036,"apologising":23742,"themistius":35288,"madrid":7562,"beyoncé":21077,"choi":33248,"hillsborough":32017,"conjugate":47858,"slight":5155,"flynn's":41476,"renato":32310,"kumarrao":32283,"bigdunc":26389,"nantwich":47337,"idwatchdog":49768,"colo":19419,"undermine":7482,"signatures":6968,"dominant":6462,"recognizable":12302,"cholas":9849,"keri":23396,"jschnur":21101,"squarepants":15524,"vehemently":13956,"encyclopedist":39590,"confiscated":20574,"layered":42946,"renewable":16682,"pareto":24350,"factors":3857,"inst":29035,"ricky":11160,"confederates":25912,"outside":975,"personnel":6096,"masquerade":35566,"maccabean":45731,"win":1759,"tjive":40197,"conflate":16629,"lessened":40392,"schulz":26995,"exalt":42941,"prosecution":8459,"franco":10893,"sandbox2":47495,"'ya":46172,"hoses":48942,"aims":6453,"mobility":28742,"consensus'":23749,"worcester":23614,"spills":31280,"group'":36449,"coud":42003,"blunt":7290,"wanderers":20214,"alarmed":22377,"abureem":48134,"h2o":25679,"nontrivial":33707,"cossde":17151,"newari":41485,"efe":40289,"macro":9863,"mountainous":22767,"tristan":31877,"specialist":6066,"admiralty":37571,"kannadigas":27742,"wanna":2919,"donut":35341,"ivanov":33745,"medation":46081,"peasant":14158,"overtaken":45984,"senor":38420,"disguise":11923,"lakshmi":35204,"inheritors":38103,"'using":49583,"orangutan":34950,"metalanguage":37726,"ghits":47501,"unmentioned":34117,"authors":1965,"'image'":2295,"shat":31332,"pakhtunkhwa":37999,"peoples":2265,"wonderland":16909,"ces":28719,"morphed":23331,"bless":6917,"homocide":47365,"skewing":28433,"habitability":29749," farmbrough":18057,"surfer":25560,"introduction":1170,"spuriousness":29775,"sneering":25812,"svwp":37977,"nevada":12354,"wherefore":37873,"any1":31389,"software":1765,"foreword":24897,"initiative":7523,"oboe":38943,"freemason":24097,"inhibitors":35335,"dumbasses":24519,"tzu":35929,"recruiting":13241,"campbell's":37850,"cecilia":32714,"motif":25480,"rigor":25864,"abide":4946,"hindutva":16144,"shan't":20330,"simpson":5788,"trade'":40501,"patriot":9623,"ssri":30661,"desperation":18375,"ousd":13493,"halle":37322,"defective":12519,"regulate":21194,"motel":38005,"armed":4482,"prestige":10131,"roadway":49071,"fridays":27459,"mn":22699,"attack'":18830,"usages":12879,"singles":3731,"ship's":21630,"hind":30182,"freeman's":33589,"reincarnations":46357,"rabbinic":15580,"proliferation":19801,"pathological":14629,"polski":39187,"concentric":41860,"gertler":39281,"wyeth":46283,"knm":34055,"electrons":7938,"euphemism":14962,"akhtar":24999,"bache":37312,"smuggling":20029,"authority":1352,"repairing":26544,"severus":39683,"veinor":42889,"planks":42562,"ganesha":29950,"“why":29055,"isotope23":43201,"28bytes":32239,"partner's":25259,"masking":35302,"transplanted":24990,"bastard":1407,"epf":25654,"warmly":23758,"birthdays":26456,"abuses":5923,"annulment":47478,"scarlett":23022,"starving":14885,"fractured":26263,"disproved":18046,"truesdell":41186,"mimsy":36450,"traversal":34040,"suburb":9099,"shoehorn":43825,"marketting":47930,"tweedle":35388,"practitioner":15098,"steganography":46251,"xxxxx":41816,"bravo":16284,"obsess":37164,"markedly":21582,"wikimedia's":37361,"posten":21695,"fergus":34358,"cheerio":30369,"ferrell":35247,"sundays":30016,"scriptural":19709,"schematic":38788,"chastisement":45496,"bermuda":23891,"simulator":19827,"holiness":17662,"afforded":17804,"thief":11572,"label's":45978,"hobbit":47666,"rabbi":9006,"pudding":22939,"talks":2956,"comit":47566,"hollywood":4731,"frail":47868,"prequel":38308,"mir":19659,"д":38904,"dickbutt":12728,"oscillator":30447,"matthews":13600,"member’s":43824,"münchen":39816,"motherfucking":8161,"masm32":45904,"cdrkit":28246,"exceptionalism":46110,"zydeco":42328,"y'know":15759,"commissions":40380,"synchronous":42182,"oldip":47334,"nclc":44253,"cotton":11496,"license":1087,"dummett":41047,"removals":9139,"familiar":1463,"most":135,"allowable":25059,"abnormal":17716,"shoehorned":47377,"hyderabad":25123,"results":1135,"youreallycan":26466,"gascony":40164,"barresi":35412,"indigneous":37209,"reprimanded":14306,"watkins":19954,"adipex":49330,"koalorka":48112,"encyclopædia":19501,"raffaele":42450,"hiss":37557,"quartet":26132,"seevote":37384,"finnaly":47557,"realising":21718,"ceres":35556,"botanical":13634,"ταλκ":36970,"phenotypes":43049,"unites":31563,"2008–09":24250,"inala":38721,"'hate":48042,"unc":19000,"comity":29545,"eradicate":21887,"soad":19456,"fangio":40291,"glorious":10750,"'troll'":32389,"lookin":28067,"cleverness":40198,"calgary":6280,"decended":32774,"disrupting":5902,"fonda":33999,"dhar":37916,"citations":765,"advertises":21250,"penguins":21565,"besant":13417,"hayley":30263,"36th":16479,"puns":26806,"doughnuthead":49223,"'keep'":34633,"unsurprising":43734,"nocal":39644,"sentience":45298,"malfeasance":25840,"iceland":10063,"humber":27633,"appears":542,"karl":5882,"rudolph":25997,"ensured":21471,"chang's":29694,"nearest":10359,"introspection":45120,"rk":34400,"nail":8268,"fawning":25934,"highways":11267,"2d":11039,"blight":35921,"hhh":22610,"eliyak":40322,"tm":6292,"inks":28525,"leonardo":23723,"nyscholar":20323,"heavier":15574,"mariner":25070,"infront":43173,"personification":34126,"'save":37610,"koenig":36231,"playwright":41158,"fly":4063,"usher's":45863,"paige":39989,"promoting":2741,"jtf":44156,"stu":28105,"immersion":32029,"outlookindia":35755,"busking":34265,"dipterocarpaceae":36147,"retrieve":8100,"oversensitive":39414,"twister":34507,"mum's":19961,"giant":4838,"flair":24397,"iasi":27802,"spaceman":33817,"availabe":40149,"ambiguously":28548,"d6":28451,"dunfermline":39029,"béla":40003,"key":1830,"kurdish":5194,"aunva6talk":45953,"cuntfranks":6904,"cruft":10172,"m4a":43104,"sleaze":23858,"expatriate":36762,"dilute":24445,"biasing":27540,"durant":33446,"rʨanaɢ ":41195,"groundwork":22553,"treacle":35938,"vehari":43147,"text's":40655,"cool":1157,"you'r":41715,"centurion":38354,"stylistic":11182,"farmer":13934,"leftover":44422,"derhexer":36430,"disfavor":47548,"harut":41096,"coy":26204,"krill":38242,"schwarz":28653,"engineer":5703,"widdle":47057,"oldid":2312,"pittsburg":46437,"called":323,"motionless":43465,"proposed":745,"pat":6772,"contradict":4886,"judgments":9509,"beggining":32953,"prasi90":47894,"codename":21128,"herr":32449,"concordance":35142,"belittles":36122,"clinically":27156,"indispensable":26998,"guise":10554,"handler":27950,"harmony":9727,"fulfilled":14166,"heading":2254,"miscellanea":46932,"kerry":7843,"pagedelete":2876,"ubisoft":37236,"asserts":7556,"opengl":24937,"dpp":45908,"finasteride":21736,"cad":11021,"connexion":49193,"feds":19702,"legends":7838,"acoustic":12720,"gritty":30973,"gangsta":14707,"dicklyon's":43454,"sarkozy":39499,"spotlight":16091,"currently":523,"hrothulf":35317,"defer":10933,"undersand":45228,"countries'":26265,"coṁrá":49043,"stanford":8727,"supporting":1786,"reborn":20541,"faith":517,"australia's":15442,"finalized":21663,"belligerents":31512,"anomalies":21677,"postcard":38041,"modest":10534,"venous":37458,"aei":41333,"possibility":2579,"damian":30275,"uno":42435,"version's":37965,"edinburgh":13710,"recieving":17130,"ictu":28324,"laid":4195,"lean":10240,"dispense":28218,"highs":46924,"·":1225,"devolved":17849,"lori":33292,"action4result":42364,"disrupted":11818,"mohajir":46892,"anticipation":12094,"trish":31067,"gematria":24194,"killerchihuahua's":33973,"serb":4279,"fæ":20730,"airlines":5689,"tenth":12585,"strangely":11012,"goodies":31244,"cares":2631,"knowledge'":40570,"osvetnik":37818,"suffers":9771,"scott's":19608,"snow":5518,"omani":38630,"ammendment":22786,"pockets":15954,"admiration":14861,"microfiber":32755,"freak'":20847,"mohan":30746,"parr":46918,"kollection":45961,"sonatas":29083,"bhagawan":48558,"pinnacle":23077,"brackets":5886,"peripheral":11657,"jurisprudence":16073,"hay":13651,"insulating":44551,"intelligence":2090,"tackle":10395,"activated":18460,"copa":26529,"iv":4486,"arguable":12821,"doomed":11731,"wikhead":27439,"bridgnorth":29389,"delays":19384,"revels":29576,"interrogation":21174,"rts":35286,"thermodynamics":17177,"eulogy":27805,"leadership":4641,"az86556":32354,"6'5":36725,"arguement":8106,"suprisingly":41689,"twilight":10175,"gathered":6800,"retired":3462,"20in":45393,"nigerian":15463,"wins":5540,"patch":11681,"psychotic":15019,"grant":3699,"dna":4058,"tyler":8626,"'three":47012,"characterizations":19979,"budding":31435,"biodiversity":22499,"accomodating":45229,"absorption":20737,"excerpts":12328,"cartel":25797,"vow":16258,"falsehood":10421,"xeno":14203,"aerodynamics":38076,"convention":2786,"animes":28519,"dyks":13270,"deans":35328,"misapplied":36991,"ascending":28259,"sheppey":46878,"dodd":23563,"stallman":19060,"memoriae":31646,"reubens":33890,"shreveport":47599,"artificially":15323,"incivilty":42261,"circles":5268,"mark":1311,"acknowledgement":10981,"irs":7061,"resignation":8528,"johansson":21024,"rounding":21222,"euros":23839,"4ths":48760,"eluded":47627,"adressed":18975,"livingston":28144,"unimportant":8238,"saeed":20549,"hippy":29653,"thursday":7168,"venezuelans":44932,"arian":39881,"nigerians":49140,"culinary":30739,"conquests":25669,"wikidemon":25556,"cambodia":13877,"hundred":3512,"hander":40746,"bloch":30355,"ubuntu":12770,"verne":20665,"days":472,"stargate":13844,"olympia":26598,"overclaiming":43842,"pga":35901,"jiu":18386,"pederastic":25426,"seeley":47575,"wanting":3292,"drieakko":34240,"hone":29139,"emotions":7652,"cit":12566,"profit":4008,"gdr":35275,"avoidance":13052,"wrc":36431,"a6":32647,"isi":15502,"contextualizing":34208,"breadth":14624,"prestigous":42318,"throated":26193,"tome":16451,"scrapironiv":43521,"dano":49449,"iain":23683,"zu":15263,"originated":5119,"maori":22328,"vives":41945,"gaining":8471,"negate":12280,"metamorphosis":45582,"willis":18354,"semiprotect":46533,"happier":11535,"ommitted":48157,"pointers":9010,"cpoys":49410,"für":19672,"professors":6516,"asshats":39938,"goddamned":25949,"browning":31170,"dickus":47450,"infringer":46056,"“on":46756,"techies":47651,"verisimilitude":40338,"shameful":7953,"‹":48620,"assholery":30564,"paragraph's":31600,"βcommand":13959,"elance":33510,"penwhale":42433,"ruining":4573,"certifications":15245,"highlighted":7013,"espouses":30826,"therm":40467,"triage":48908,"geneology":39304,"henchman":31433,"orchid":41202,"adviced":36291,"alphabetization":45070,"ctmu":12111,"costs":4229,"guthrie":31505,"whereby":10832,"rejecting":7790,"fossils":15284,"frey":46752,"'comfort":36351,"iac":18881,"stewart":8748,"booboo":49213,"vandalizer":32040,"thankyou":5243,"nasal":10497,"beer":4959,"demo":7606,"sills":39523,"challenger":24957,"dinosaurs":13942,"talabani":44403,"discriminates":40484,"notorious":7093,"quark":46088,"enemy's":26967,"regular":2085,"peninsular":36245,"relocated":16681,"hyperbole":11392,"societal":14092,"side":638,"less":457,"waiting":2199,"temples":12033,"debian":11426,"paul’s":29709,"relativism":18195,"gundulić":48972,"gimmetrow":17193,"frankly":2289,"superlative":49235,"consistent":1912,"gogh":33324,"lumps":32775,"carousel":30886,"lei":47270,"wisdom":5361,"mas":16378,"tarita":31237,"morocco":8496,"confrontations":26766,"stingy":42861,"named":1076,"hahaha":5261,"rationalisation":32285,"bongomatic":29233,"regulation":9199,"additionally":2549,"midtown":27432,"galbraith":45239,"amarth":42019,"epir":31213,"eroticism":39086,"cash":5397,"phylogeny":25890,"against":227,"eons":44369,"grsz":47289,"thatcher131":28206,"palpable":39544,"truely":11739,"essays":7542,"dose":9267,"desks":23394,"britpop":34569,"paulh":29795,"guantanamo":17754,"juggalos":28349,"julie":11952,"winamp":49182,"jealously":36331,"evidence":354,"lovely":5832,"'loser'":42452,"shouldn't":830,"matilda":23996,"kite":8539,"uh":4662,"sha":39236,"attacked":2179,"minx":28367,"current":420,"gloves":17447,"chrisch":28969,"husnock":29165,"irelands":38010,"gatherings":22415,"antilles":20102,"orchestrated":18502,"fanatic":8797,"diarrhea":16344,"talk••":48543,"farming":12774,"ithink":44648,"whitewashing":9971,"enumerated":16445,"hurra":47986,"sight":4240,"foment":33211,"cowan":25512,"thebes":31417,"controversal":27138,"dehydration":27917,"italiano":43487,"korean":2285,"answering":4289,"lodges":22007,"dared":13545,"roam":26403,"malays":29116,"pitchers":28184,"excirial":32554,"hallway":29333,"bookshop":43128,"peripherally":44999,"lawmakers":49039,"exo":20709,"ezekiel":19054,"aversion":24110,"gaogouli":31645,"bigzmma":48875,"giorgio":29111,"recognising":35097,"pong":22410,"hcard":40605,"duk":24933,"admits":6693,"betwen":40810,"assisted":9513,"allocated":16920,"uncertainty":11030,"artworks":28842,"formless":32197,"inuyasha":46405,"copying":3900,"signing":4067,"brazilians":16418,"england":1456,"windy":29780,"killings":6268,"smcs":35983,"abdomen":36164,"tolerates":47489,"before":147,"groves":34037,"berezovsky":26449,"guti":39409,"aint":6657,"mixer":41325,"implicit":10520,"jobs":4061,"insidious":17727,"gunfire":28515,"cheat":8412,"i4":34150,"chadic":29730,"eels":37185,"hypocrisy":5570,"peep":27088,"riding":9635,"dispatched":23785,"coelacan":33613,"worldviews":35550,"vitriolic":23999,"fullerton":16464,"première":48094,"whitehouse":19810,"prequels":49563,"righting":46705,"epi":35434,"showings":44305,"slate":12252,"shahrbanoo":35698,"pa36":37454,"argumentation":12905,"waver":48352,"ly":27766,"glaad":31376,"encompassing":16728,"spells":9412,"medium":5387,"jacobolus":41009,"convey":5111,"destiny":9357,"summarizes":12217,"sipping":26238,"thread":1733,"criticised":9158,"cleopatra":29748,"barring":10992,"expenditure":24683,"imported":13323,"fidelity":44636,"mistress":14525,"cooler":13045,"depending":3840,"presbyterians":44894,"mena":38177,"cdt":25876,"meanwhile":4049,"charlene":35027,"hampered":36776,"evacuate":39076,"detractor":32877,"lenghty":30067,"gator":36916,"highlights":8177,"captioned":25215,"burchard":48886,"crate":46187,"hahahahahahahaha":22533,"pandas":23307,"analog":15634,"canderra":41680,"artice":18951,"fenriswolf":46035,"moveon":45220,"gerontology":43356,"stubborness":42537,"valdez":29012,"waits":26471,"modernization":46065,"afi":28376,"equidistant":48865,"spongebob":8366,"socrates":14106,"wimp":21130,"dynasty's":47322,"constables":24383,"revolves":19498,"jdl":46269,"klux":13485,"03":1583,"interviewer":19507,"switch":4770,"dawning":46550,"bolding":13328,"terbounia":44910,"goood":36297,"livable":45105,"cabrera":38078,"secrecy":16161,"diazepam":49332,"liverpool":6032,"ooo":25074,"monkees":41533,"cambridgeshire":45746,"stopping":5450,"urdu":6765,"bluesmobile":31295,"westernciv":45231,"metzger":38396,"nguyễn":43583,"corresponding":6151,"mason":8454,"highinbc":41576,"greta":48198,"nicola":18044,"unquote":39638,"gail":17764,"physiological":19014,"pastes":37826,"primrose":32534,"baseless":5064,"became":1292,"highlight":5858,"marshalling":39260,"poppy":23699,"pursued":10896,"ɰ":27417,"smarmy":30737,"masturbating":14846,"docku":43298,"misbehaving":35579,"siege":8938,"gloria":14767,"catastrophes":41569,"dschinghis":34624,"x86":12319,"faggotmongo":17526,"revealing":7834,"strive":8216,"disperse":34316,"barrack":18974,"scotsman":22873,"ousting":48749,"eleemosynary":27886,"follwing":34937,"gale's":33414,"privy":18357,"rehab":25813,"orange":3358,"prized":49966,"firm":3828,"ahad":37647,"nrms":48230,"fuels":16966,"mastery":21539,"jasmine":37925,"humid":18106,"warnings":1205,"gravitation":10929,"persistant":15287,"advices":31297,"fortran":32940,"stanely":47591,"sirs":48526,"taken":530,"e3":23619,"hydrolysis":45418,"vindictive":8478,"andrewa":37577,"wana":29657,"yelldg":45333,"walrus":22512,"infringes":32247,"westside":19609,"legislature":10602,"garb":34058,"meriting":33107,"communist":2150,"responsibilty":45115,"beady":47926,"backstabber":49765,"offliner":33924,"frigate":37616,"amputation":47493,"printers":40373,"cellspacing":4085,"heresies":27717,"sombody":37147,"newpages":19614,"fiend":29669,"rendezvous":35553,"taxi":15468,"specification":11586,"caravaggio":27360,"whores":18917,"charging":13379,"tier":10366,"seed":9175,"dorothy":13330,"strategic":6830,"operators":8466,"enders":49398,"explains":2435,"focal":19065,"worsened":46260,"skycable":28577,"stealer":48581,"fox":2783,"gujjar":34367,"closest":7252,"wwe":3080,"thirdly":8244,"indeed":715,"dakota":9431,"winkelvi":39908,"measuring":10193,"paramount":10974,"won't":578,"membership":3792,"oed":8794,"gizmo":41147,"culprit":20776,"pent":46582,"jyoti":27644,"artciel":48096,"трёп":21532,"   velella":36898,"thames":22504,"amend":8121,"wtf":3799,"unabated":42370,"rosewall":28624,"excise":21867,"eddie":8267,"eachother":14649,"navigation":5772,"lisp":20831,"dissing":36108,"expert":1508,"dems":16612,"masthead":38891,"ebusiness":49594,"amib":21547,"cali":29988,"ccgpp":38168,"keynesian":38293,"tryed":27879,"—  hellknowz  ▎talk":47748,"intersection":11258,"belittled":36121,"scarface":47164,"hepatitis":34787,"ochlarchist":49657,"titan":18206,"cincinnati":10592,"gnome":16666,"aramaic":10214,"novus":36152,"opec":25577,"initiatives":17286,"removasl":47614,"bukkake":27525,"declining":9202,"functionally":20083,"teached":28993,"bm":47355,"oshwah":49904,"riot":8437,"xu":42100,"hands":2032,"spectral":17483,"disillusionment":42961,"fallacy":5917,"menu":9002,"flips":36699,"assignment":8045,"silverwhistle":45815,"lawyering":17101,"wti":36408,"flamewar":39203,"pew":26477,"penalizing":36799,"racist":1207,"cocktail":11009,"amazing":2816,"uncles":44340,"part":225,"anathema":39108,"ranting":10134,"horatii":45600,"olaf":21994,"dvd":3341,"endeavor":11311,"inverness":42798,"mj":10563,"profiled":26168,"offered":2558,"nccc":8531,"orkney":41487,"merck":26916,"discrete":12385,"oversized":32289,"bat":6074,"suppress":5059,"decrees":39540,"tbd":45640,"copyedit":6429,"wax":14897,"markets":6122,"gustavo":44861,"fervently":36381,"allowing":2974,"behest":20946,"mocked":15914,"izoom":41872,"atheistic":16442,"davidwr":48820,"manookian":24304,"dpeterson":32020,"misunderstanding":3302,"loaf":23048,"mantra":17282,"unrestricted":32301,"grassroots":22133,"nihon":48616,"valence":38292,"nullify":35233,"yooh":26794,"technologies":7851,"conversational":35754,"watchdog":21353,"baloch":35624,"krakatoakatie":23346,"collapses":27881,"booked":26221,"rawr":21540,"lesions":24319,"shaq":43066,"multiples":6494,"shapeshifting":44470,"supersonic":37846,"fingering":27839,"— dorftrottel⁠":25992,"nyt":7237,"pelt":30832,"bb6":42127,"interpret":4692,"filter":3897,"í":44281,"sabaeans":44813,"library's":23386,"spellcast":32462,"compromises":10376,"nablus":45403,"isla":49698,"qpr":26439,"thot":41574,"copywrite":23402,"internally":12443,"chariots":36960,"achive":36983,"fabregas":31464,"rousing":40099,"lulz":11351,"nerves":10129,"jim's":46033,"filibustering":45587,"helix":22844,"20publishes":47573,"halfshadow":37102,"eppstein":14506,"renal":29600,"nacional":27242,"supremacism":42153,"trimester":31878,"osborne":22139,"heavens":16616,"herein":18264,"baptized":14008,"implicated":23599,"deitcher":31604,"goody's":41028,"prehistoric":11283,"lipoic":44249,"jay":4321,"aide":17910,"mora":28733,"threatend":43529,"achieving":8874,"patrolled":14340,"declines":20522,"parthenon":42112,"antiwar":35726,"murrumbidgee":32517,"nan":26075,"fc":3553,"barren":40196,"salam":14425,"freedoms":12076,"colliery":31288,"nutritionist":37868,"stern":8314,"representive":44533,"cataloging":42689,"teeline":34815,"tighar’s":29009,"sheep":7162,"danfs":48509,"symbolic":10628,"persons":1439,"bulb":17232,"stanza":37171,"ffea":44799,"apparatus":24323,"god'":31490,"snuff":17444,"tulloch":38586,"hierarchical":21047,"quinolone":38816,"instituted":14766,"chriss":39054,"ribbentrop":39538,"lense":40015,"miracles":13311,"brat":15114,"mouse":5818,"strontium":46398,"'nuff":17819,"theatre":5679,"accusatory":19520,"taser":42222,"kitten":7658,"rivalry":8892,"birther":32013,"asperger's":17259,"stoke":29815,"wolf":5055,"kansas":5558,"gallus":36923,"televison":33278,"eno":45692,"lauder":33572,"carioca":34915,"plaid":24631,"patsy":24623,"club":1098,"reich1":43950,"premise":6733,"reiteration":32146,"diocese":13352,"polonium":38444,"wards":14499,"analyzer":42536,"femininity":48868,"bloody":2561,"drawing":5576,"unfitness":41511,"kristian":36409,"wasters":46895,"distracting":10104,"mangala":47180,"households":28248,"veganism":15326,"whitney":15217,"natively":37324,"apologized":6120,"insh'allah":42802,"verdict":7998,"peaks":14287,"populating":27767,"subdivided":32218,"transcendence":47691,"margarito":29164,"crapsey":38522,"william":1971,"predate":26812,"ѓ":44288,"jak":19041,"wikiquote":9613,"antecedent":40375,"tucked":26294,"programmes":12256,"irritates":31071,"anon's":17229,"extent":2653,"concluding":13504,"actively":4170,"srnec":44750,"potty":30032,"paragon":28331,"largo":35042,"protestations":30677,"jamaica's":47733,"filled":3061,"fickle":46826,"verbose":14541,"aren't":784,"riverina":33491,"newsreader":48766,"incivil":7045,"almohades":48598,"τ":25761,"harms":18921,"kingpin":33095,"prabash":47138,"vasto":49813,"neighbours":13994,"benin":38124,"regulators":28253,"zheng":19617,"hebrew":2992,"topical":9841,"unencyclopaedic":20618,"kashi":34129,"polemical":18170,"thicker":20245,"advisor":11391,"s'pose":45380,"doc9871":42727,"driven":4444,"predictably":24430,"qantas":29489,"copyedits":25075,"comedian":13447,"panned":45728,"incongruous":43378,"triangular":24238,"fraudulent":7374,"matrimony":43478,"anand":19741,"noon":18790,"ohhhh":37503,"middayexpress":34604,"avalible":43317,"sumerians":36317,"capnzapp":44065,"alphanumerics":35896,"duchess":13008,"perkovic":43585,"reclassification":48011,"slideshow":26251,"gimme":15097,"stunned":30318,"ponzi":35633,"looser":14741,"reprimand":23784,"cate":36334,"lp":11756,"angles":12902,"conserning":45194,"reference":273,"mutual":5610,"module":8551,"awa":45660,"keulen":38734,"splitting":5094,"shikoku":10768,"60th":45744,"bursts":25156,"embedding":34382,"morass":36710,"stryder":22532,"graduate":5475,"mearly":34576,"unreasoned":40489,"repost":5447,"luce":44134,"unban":10088,"nutty":22095,"flatter":23406,"authenticated":15792,"relics":23729,"baugh":25570,"itis":18633,"motoring":34003,"hacked":8722,"audacious":34255,"october":1103,"o32":34072,"focussed":18006,"assumption":3150,"graphite":23098,"apologists":14567,"classed":10658,"ami":19141,"gardening":33635,"blown":7365,"doki":42191,"tiki":17517,"kailash":45396,"carcass":32592,"prg":47675,"abu":7613,"ducking":26856,"repetitious":22909,"gregory":11458,"isiah":48976,"scotus":22182,"vietnam":4535,"lone":7961,"wombats":47630,"unilateral":7279,"puebla":41258,"artur":38648,"cull":26097,"who":62,"sewer":19784,"presuming":17115,"drifting":32543,"translates":8809,"weights":11766,"angelfire":29099,"enhanced":11281,"topps":47321,"mel":6436,"cm":8340,"rodhullandemu":14895,"cupboard":30201,"focuses":8104,"asswipe":14299,"livonia":38432,"formatting":2394,"rehashed":38212,"untoward":22270,"digestive":49614,"family's":13924,"khazars":27454,"mlpearc":26982,"fancruft":10499,"discourse":6425,"verbiage":15747,"cuddle":49656,"greater":1842,"loc":14262,"lahs":30939,"rye":28866,"clips":11175,"padding":3195,"brazenly":44848,"incentive":14577,"outlier":43962,"lotle":47723,"ignatius":25256,"bengalis":40776,"bahadur":31091,"spoiler":7703,"unranked":30303,"plucky":37875,"contempt":6793,"etim":37539,"diet":5392,"dpr":25185,"propulsion":20685,"woodstock":24710,"2¢":11693,"reduces":8401,"michelangelo":38262,"b237":37108,"sweetness":49723,"10a":47838,"repaired":13685,"boleyn":31985,"urgency":17213,"presence":2912,"conciseness":31268,"hesitate":1395,"krazy":43926,"machinima":24219,"wrapped":10323,"revolution'":41037,"narayana":23153,"harper":12626,"pentateuch":40633,"garan":25753,"retort":17927,"twelvers":38287,"texas":2765,"stables":39130,"hotep":29734,"calming":26587,"operandi":15810,"ggot":10351,"berber":13194,"housemates":22519,"action1oldid":34153,"¢ ≽ʌⱷ҅ᴥⱷʌ≼ ":34720,"darius":26911,"masem":23537,"provoked":9265,"rai":22906,"dies":6426,"publicity":6039,"angoras":43992,"2011‎":45245,"zabuza":40384,"or":25,"hackers":14062,"gravitational":9240,"child's":13935,"herzegovina":12848,"tek":43106,"waves":7629,"drivers":8634,"eyewitness":18060,"stale":13032,"unesco":11525,"linking":2163,"broadest":25292,"nom":4877,"ytmnd":3379,"tum":21108,"toya":42816,"confucian":30100,"journal's":25871,"buss":30843,"heel":12988,"selfishly":41644,"spade":6605,"tisk":46669,"polonnaruwa":32195,"footbal":43512,"primary":939,"stonehenge":38042,"nokia":20193,"park":1883,"bulldoze":39872,"reasonable":1182,"negros":33363,"arisen":23269,"islands":3048,"relegate":42939,"cladding":42184,"concocted":21220,"wars'":42010,"turkey":2197,"baselessly":44947,"soldiers":3147,"deploy":26487,"attain":13984,"wikieditor9999":34256,"chapman":14038,"ewtn":26990,"deletings":39521,"“third":47908,"dumbhead":41128,"infringed":20454,"glenn's":34268,"pleaded":20690,"germain":33580,"'yes'":41252,"shabana":40593,"cara":30828,"bhattacharya":48705,"marvellous":26512,"niigata":33918,"jackie":11303,"1280x1024":46040,"d'souza":38175,"condoms":15485,"landforms":31763,"transwomen":43617,"voip":21960,"personaly":17216,"residue":39135,"prevalent":8263,"garden":5741,"ot":6519,"evaluated":12246,"indicative":12633,"pets":16103,"edmondson":37633,"bilateral":29439,"montgomery":13421,"vampire":11566,"cadfael":34595,"terdag":39494,"amaury":18747,"palms":24784,"ordination":24254,"blocking":867,"50a6c2":41279,"emperor's":34325,"plaintiff":30991,"moti":29260,"freeq":40218,"alpha":4059,"reinhard":29931,"reorganization":15128,"stove":29562,"colour":3809,"patrolling":8393,"convinced":3113,"venerated":45093,"sly":22702,"moved":747,"nevertheless":3467,"whig":23205,"intellect":11536,"drill":15948,"def":11274,"meaningful":3346,"revertion":26054,"unrecognised":35765,"lion":4285,"kekeke":26712,"clerk's":48862,"albans":30511,"derivative":7477,"larouche's":47805,"dramatic":7090,"romani":9872,"gandhi":8781,"martínez":41739,"minotaurgirl":20646,"envelopes":41947,"perugia":36795,"capabilities":11772,"affirming":23497,"intergrated":32010,"pleased":4990,"ideals":8765,"undisturbed":49922,"musa":19667,"topological":18652,"coverup":26805,"khomeini":24052,"enhance":8416,"mostly":1260,"slab":48140,"liberos":38471,"companion":8503,"captives":37812,"beating":6101,"skull":8933,"mann”":32429,"despair":24065,"applause":22373,"supposed":938,"unconsciously":39159,"glance":6374,"shucks":36454,"perso":23149,"radiocarbon":41870,"ncbi":12697,"shogi":49409,"neocon":33541,"pollution":10111,"complimentary":30277,"father's":7862,"reveal":4264,"hair":2897,"takin":42082,"prescriptions":35236,"transports":37584,"ocean":5326,"stated":671,"coronary":37326,"obstruct":23893,"ticked":16729,"19th":3565,"seminole":35855,"unmarked":28009,"trample":34291,"gurevich":49669,"antartica":28681,"distort":8103,"amiss":20651,"o'dwyer":49199,"yooo":7773,"e036":47023,"gpa":35467,"bewildered":37512,"jasenm222":7462,"sakmer":30268,"chr":37508,"bravado":41220,"hidden":2870,"atlases":47459,"nayaks":39176,"tsunami":14457,"rollbacker":27468,"polynesian":20935,"royalark":49605,"arminianism":47694,"emotion":10721,"advent":15877,"stuffing":18189,"thin":4640,"coanda's":48527,"kerouac":25558,"secretariat":19459,"belated":8079,"historical":860,"aspie":22416,"patrick's":24820,"wittgenstein":16412,"getúlio":34740,"iw":18876,"hinterland":44336,"rajput":7617,"procedure":3055,"menachem":33000,"handbook":11177,"tandry":39056,"sj":20415,"campbell":7020,"bauer":18812,"markov":38022,"consisted":8913,"sours":36362,"swiss":7211,"operates":8253,"g4techtv":43017,"earthbound":45398,"aspirin":36201,"zaman":31290,"territory":2386,"arawakan":42844,"ahaha":48523,"makin'bacon":21099,"lateral":20885,"punters":43578,"ensued":19236,"directors":6745,"panjab":49113,"dravidian":13401,"checkusers":13050,"bar":2212,"shelby":15530,"zorzi":44003,"bishop":4957,"mon":16668,"motorway":15671,"legend":4215,"’’":45299,"vocabulary":8665,"zealanders":33537,"productive":3070,"011":49186,"mag":11665,"caloric":32974,"distrowatch":41624,"tacit":27234,"geeky":22661,"msk":31469,"apparently":914,"felons":46531,"monarch":8325,"networks":6587,"gillian":38006,"committing":8869,"blogs":2864,"sockpuppeting":11953,"symbiosis":41556,"switzer":49652,"refutes":13659,"feck":39785,"festivals":9450,"huma":27657,"ipa":6208,"maui":35518,"chowbok":31472,"grunge":10614,"snippy":31719,"☸dutta":37954,"notations":15388,"papal":12286,"homoerotic":29703,"buddhism":5206,"bunker":19792,"edification":26890,"lolooolbootstoots":8223,"mbisanz":18725,"it'":16523,"disarming":46303,"rated":5545,"salon":11082,"ekantik":26190,"nark":38170,"agnosticism":29505,"brand":3290,"lindt":44119,"nauseam":26443,"castro":7792,"classic":3062,"lining":27246,"benchmarks":46841,"couldnt":9576,"council":2141,"gyroscopic":30898,"":33139,"natchez":29277,"autobot":35690,"pettersen":28281,"newsday":38565,"sizes":8074,"dhs":36232,"guo":41780,"skeptics":9487,"rmv":39231,"thrilled":19843,"amounts":3730,"hasn’t":41502,"eighteenth":21799,"bestselling":37889,"instructors":21928,"wanton":18583,"diabetic":41858,"concorde":32186,"deported":16595,"carleton":27086,"cords":24982,"osb":31511,"ardabil":32177,"h5n1":30150,"—gamer":33830,"franconian":39060,"susskind":30449,"'07":29041,"met":1932,"starbucks":14155,"qualifying":10336,"ukranian":27513,"transference":43072,"ap":6053,"zad":38446,"status":664,"kwon":25943,"desktop":13834,"shorter":4245,"majorly":16200,"fairly":1522,"persists":10807,"ruckus":30893,"bisexual":10490,"pupil":22256,"combined":3786,"eclipsed":20993,"coptic":20180,"armchair":20373,"boar":37455,"perished":20802,"spinal":16326,"parkin":26524,"stefani":26711,"annihilation":24715,"champion":4053,"chonji":29787,"wandering":15320,"dimensionless":42918,"altho":30488,"antenna":18825,"controversey":41914,"revoking":29678,"dictionary":1948,"'death":35872,"v2":19673,"grass":9304,"tavernor's":34563,"thc":14327,"bektashi":13469,"anschluss":45102,"m49":39278,"jim":2330,"integrifolia":48842,"uploaders":48801,"molding":42150,"scriptures":8523,"upscale":47404,"kochba":40405,"characteristically":40035,"ministry":4608,"axe":7399,"armchairvexillologistdon":38290,"compacted":48027,"columbine":29782,"bc":2498,"kupcinet":15534,"regs":32119,"randomenigma":35316,"blas":47921,"çuţ":47390,"feminists":15767,"gujarat":11829,"suicidal":15605,"illythr":45157,"filioque":37300,"hurried":31543,"allied":6821,"chunks":11293,"overdo":35310,"strategist":30917,"melungeons":15523,"melodic":12915,"nicaraguan":34463,"zappaz":44152,"mayr":45010,"outwardly":41925,"reassigned":36162,"jun":1956,"analogous":11420,"appreciating":24471,"sewage":26519,"swiped":48711,"tarnishing":39037,"unwise":13995,"vharris44":21575,"beastiality":42209,"revolutionized":41234,"railed":48376,"p":568,"tdi":38575,"property":2810,"jamaat":32471,"asshat":23329,"mode":3564,"badcharts":25729,"distorted":6979,"ghetto":13474,"noteable":14956,"dodona":18099,"sucessor":37037,"bangor":24348,"coase":48132,"calories":26118,"'last":29879,"martha":14498,"medications":16877,"jforget":8006,"harv":33838,"deems":17592,"interdisciplinary":34125,"shackles":29743,"machines":6617,"rumsfeld":24051,"hamasaki":45278,"comparable":6667,"persons'":36765,"sense":461,"kinect":13444,"recensions":41517,"agony":20964,"saddleback":27845,"zoos":31125,"sadly":3842,"bombers":12436,"fictional":2711,"propagandizing":48179,"niggers":5146,"fatboy":49625,"laughing":6359,"ultrasound":33016,"alarm":12438,"ibc":28783,"condensing":20939,"durrani":24560,"3rr":1304,"spilt":46116,"podcasts":31642,"mawr":46234,"roving":36307,"holden":26050,"goldsworthy":34639,"decision":1019,"weaselly":26179,"polarity":27929,"intransigeant":42268,"surprising":4889,"aspiration":19390,"sperm":15628,"scox":33688,"javascript":10937,"teadrinker":40024,"sociable":43324,"artie":29448,"tact":15336,"jego":38857,"dense":9807,"forwarded":10398,"wildcats":43570,"wikimedians":23609,"bigissue":17789,"yourslef":45625,"masks":15197,"einstein's":13039,"martyn":39890,"disputing":6527,"peacocks":43332,"thresholds":33321,"purrum's":29295,"aroman":42639,"bing":15554,"vandalising":3050,"crash":4555,"bonghan":36435,"“one":25227,"iss":26840,"inspiring":18418,"parse":18568,"subtype":40498,"standing":2482,"balancing":12250,"pontificalis":39548,"gilan":35118,"intead":44307,"eurovelo":49112,"trice":45125,"mickmacnee":25284,"dol":32636,"conception":9105,"moldavian":20845,"stage":2439,"aggressiveness":42812,"cartoonist":40606,"lenient":16293,"transgression":35301,"vol":4570,"talk┐":44368,"lufthansa":21536,"coordinates":5841,"cahill":21806,"scanner":20592,"copy":739,"unsupervised":40914,"gasoline":15285,"resize":29947,"portia":40545,"epithet":12688,"patronage":23503,"traps":18485,"1a":17822,"katsarelas":45937,"cocker":42387,"betraying":25498,"beaumont":24195,"shortening":12962,"marxist":6795,"orgs":32256,"priveleges":46514,"misstep":46150,"nejm":28243,"bleach":12921,"faggotkikeniggermongo":49434,"gujarati":25826,"footing":16153,"zoey":45276,"cns":19876,"buu's":45399,"“georgian":45648,"kwan":44398,"'it":13967,"ww":10708,"kralizec":43300,"fms":46025,"cooperated":34085,"source":119,"devlin":25286,"blurbs":21441,"erica":31620,"prominant":44562,"protocols":7744,"amusement":10249,"087209":49379,"dead":1071,"grounding":29498,"convicted":4168,"depth":3169,"uptake":37034,"studies":1593," talk ┐":48216,"flicks":47927,"gabirro":31292,"needle":14291,"capita":13783,"aricles":36774,"spineless":20483,"temple's":41856,"abstracts":12549,"dedicate":14639,"airstrike":45395,"allure":40725,"dodo's":40857,"weeny":44734,"reserved":6419,"impatient":19768,"evaluating":10458,"besieged":41052,"hodges":37502,"flu":12057,"architectures":26936,"walloon":29511,"dump":8361,"doom":5513,"persecuted":8399,"syngman":44252,"disposition":18539,"chubby":37119,"webkit":34612,"tragic":9903,"crybabies":45132,"porsche":23126,"banish":22365,"hitman":24947,"reorganize":19649,"della":22965,"shadowy":26876,"berated":34170,"sociopath":22651,"approach":1507,"userfication":38401,"sham":9908,"bed":4175,"stand":1140,"nova":8579,"chiefly":15061,"cullen":37368,"coterminous":32511,"telenovelas":46232,"sarah777":44637,"times":399,"trafford":37695,"tonga":26942,"stamps":11611,"andromeda":31609,"zorro":27054,"yugoslav":6571,"kooks":20155,"usa":1613,"jagger":46288,"vocation":41793,"amplifiable":38096,"tabfor":46822,"marcelo":34328,"neanderthal":19197,"vt":11715,"hirohito":42598,"bedford":18254,"specs":13387,"huts":39006,"kilgarvan":40658,"unsightly":42262,"imho":4165,"iuphar":38673,"srsly":33470,"'''''' τ":43415,"hunters":15525,"ahmadiyya":24313,"9f":39065,"exponential":20970,"soapbox":6737,"lively":17056,"anupam":22842,"loyal":8942,"yearbooks":26503,"charm":17096,"hero":3516,"believer":8896,"bibliographies":25039,"outgrowth":33057,"mandate":9844,"but":26,"macdui":42755,"capacitor":19958,"responsibly":14462,"undercut":41383,"consistant":24718,"busting":17562,"crudely":46702,"azerbaijan":4819,"independent":1038,"nooses":34812,"laudable":33765,"ginn":42803,"west's":23991," • talk":41075,"copyvio":3289,"alain":23280,"text":276,"katakana":20125,"unfortunetly":44863,"shuki":37931,"infantile":18650,"minigames":44597,"forestry":25152,"husband's":29265,"fb90":48504,"produces":5719,"coalitions":32233,"hahah":19415,"nightshift36":28569,"slc":43580,"jonah":19911,"vilna":38631,"heirs":14529,"condemned":8669,"contradiction":5072,"entre":30802,"shallowness":43184,"pershing":27142,"jesse":9086,"“truck":48569,"priceless":25935,"hooligan":24162,"additional":1383,"bloods":19610,"wobble":25167,"exposed":3758,"flattened":40506,"prefs":49151,"promotion":2247,"pierce":15979,"crucial":5332,"evey":28957,"shupe":32244,"southpark":38110,"organological":41769,"vedder":40566,"nurse":13575,"side'''":42280,"twink":47482,"timer":18089,"robertg":37121,"algorithms":9271,"occassions":22398,"georgievna":42707,"veil":15401,"halakha":26742,"advertized":49767,"auxiliary":16420,"walks":12757,"agricultural":10019,"beacuse":19650,"eustace":42800,"alerts":10495,"offending":5767,"deseret":36486,"formula":4268,"sumo":48715,"run":891,"reardon":43808,"person's":3450,"limbo":26847,"cheaters":41514,"chemistry":4701,"mayer":25908,"klose":44993,"mailman":44653,"likud":34558,"getae":23430,"tycoon":27688,"ganz":48364,"could'nt":42703,"violator":21468,"traced":8766,"beh":18463,"swaths":47249,"facsimile":28162,"checks":6827,"widening":36395,"ironed":42774,"jens":33581,"telegram":35188,"moldy":45170,"carrio":30722,"sicko":26203,"gals":37619,"delivery":6345,"black":757,"independance":27720,"enough":317,"tie":5277,"precluded":45297,"ooty":44120,"revolutions":17959,"mab":46460,"vitali":35410,"nino":34457,"uncouth":42001,"educational":3674,"liberties":10508,"departed":14588,"single":534,"finale":13144,"along":668,"reid":12564,"raps":39784,"zeitung":36940,"donkeys":33837,"sherrod":32366,"lotd":25602,"fermat":29572,"ugg":43305,"goblin":21206,"vexed":41447,"canons":29326,"desysoped":32549,"fletcher":18606,"regularly":3469,"tensor":17527,"neurosurgical":43756,"password":3823,"unlock":10531,"axel":19253,"struggled":21670,"intolerable":20566,"comfortably":22092,"adminstrative":38050,"stallone":36358,"erasing":6983,"edt":19030,"aknowledge":37668,"manners":6616,"iin":45717,"mjroots":37783,"founder's":40645,"adress":8292,"generous":9815,"inflate":26032," email":40621,"frieza":29927,"one's":2920,"choosen":39504,"categorising":30645,"esta":43207,"instigator":25373,"ippages":21103,"‖":32130,"unqualified":10615,"balti":43293,"nonstop":40257,"slaughterhouses":37760,"bajrang":35216,"reconstructions":37838,"unable":2061,"forthright":25477,"spirited":16360,"nuns":21429,"wikiped":30455,"cartier":24043,"retag":43016,"jewry":28991,"coke":11133,"misled":16795,"commandment":15758,"tears":9678,"ntnood":34070,"pretzel":44430,"cab":13464,"fashionable":33206,"rm":3964,"fiveaa":43684,"willie":14359,"hoover":11743,"di":3412,"zachary":28509,"administrations":22399,"twats":15728,"yearly":14922,"annouced":49903,"examiner":13604,"whats":3222,"suzerainty":39120,"fluoride":26228,"drought":27744,"slovene":34297,"shahid":23338,"coaches":11482,"floppy":25327,"drudge":36255,"burgers":27210,"mina":28908,"spirituality":12512,"famed":27643,"gabrielkat":35558,"intuitive":5553,"historian":2658,"troopers":14798,"mailed":11040,"appropriation":26599,"aman":38072,"brendan":15912,"palmdale":29741,"conant":49020,"occurance":33590,"granting":12127,"detective":9984,"jayant":47112,"andries":21422,"xiang":46994,"typographic":37518,"accountable":9743,"unharmed":48456,"fom":25766,"aeropagitica":12739,"mulling":47716,"sank":19387,"yul":36968,"politicians":4481,"strom":23250,"dicono":15585,"numbered":7452,"eragon":31239,"arrests":15066,"revisit":9254,"madden":16043,"diakhou":30884,"kevin":4065,"neutrino":39485,"bringer":43820,"relavent":16876,"championing":41424,"palatal":28351,"envious":19922,"sallary":40188,"an'":39956,"regulars":7861,"superstition":26822,"nanodiamonds":24422,"vowed":21497,"brother's":11432,"secondary":1428,"taped":22750,"anomaly":15011,"stingray":44185,"beaucoup":47561,"ceoil":14395,"pasadena":24351,"realty":27896,"differentiating":20361,"flagging":20713,"enact":28283,"ndaa":44440,"holler":39020,"3r":19213,"wild":3276,"carmel":25536,"flushing":36603,"disgusting":3524,"magnate":30202,"wikid":32005,"sermon":19222,"firmware":17471,"wiht":39123,"monarchy":7183,"sprite":28274,"courage":6130,"protoscience":29718,"pra":34352,"graders":38358,"barack":5865,"cleophas":27398,"incivility":3769,"–talk":38890,"posture":23949,"ht":30654,"patriarchs":28368,"sluts":21551,"arcangel":45775,"motherhood":31458,"möbius":42924,"dilligence":48498,"dominate":8744,"weehawken":45524,"jizz":29627,"secular":4788,"percent":4591,"indias":22832,"founder":3005,"bâ":34420,"zzzz":39021," · talk":12144,"optimality":33624,"verfiable":35906,"marcuse":36069,"athiests":45967,"awarding":14740,"desysopped":13371,"confer":14346,"dep":41418,"board":1220,"epistemology":15737,"jp":8512,"trooper":20150,"neutral":486,"accuser":18894,"‎nov":24317,"jo":14722,"metaphysical":11819,"haiku":12682,"founding":6114,"rager":43326,"romaji":46858,"solitaire":40138,"hussein":11826,"dragons":7914,"commanding":21566,"muddled":17327,"unhealthy":14913,"creationists":9110,"popeye":38574,"overstated":19044,"20on":43370,"osu":23775,"tho'":42202,"sabbatic":27298,"kbob":33685,"problems":650,"channels":5635,"pursuing":8022,"constants":20634,"commonsense":19488,"below":537,"servant":10254,"jargon":6839,"fashist":38929,"fighting":1882,"wichita":24316,"admins'":23480,"hocky":38826,"tieleman":39531,"manson's":47905,"bav":19745,"gronowski":24534,"depardieu":21490,"return":1461,"malaysia's":45710,"brzica":40054,"westmorland":45747,"khojaly":14781,"wiz":44792,"flicker":43264,"resists":49683,"afield":36735,"seraphimblade":31775,"numismatics":36691,"mrdarcy":37248,"agit":43025,"analyses":14959,"center's":29768,"escalates":40206,"martins":29550,"zcmi":34292,"intial":35367,"daresay":32772,"renew":21447,"somalian":28505,"reworking":16422,"reverse":3977,"alterations":11811,"unmaking":47999,"prods":19287,"astana":49077,"kubigula":29282,"portions":4394,"pag":22578,"civic":15233,"geobox":31577,"imperium":34601,"mouths":12569,"le's":45158,"compel":27570,"jollystar":49125,"sectors":15614,"critisism":23565,"slicing":40079,"tilt":17548,"tabloid":7504,"neon":17472,"large":788,"'it's":37281,"24hr":48297,"snowfall":42009,"wikification":16836,"cheering":26419,"ffffff":3420,"unconfirmed":12590,"rené":24540,"agressor":38011,"nostra":33445,"cdbaby":45230,"emerson":22325,"geologically":38689,"recession":26322,"ebonics":8305,"cheating":8010,"charlemagne":17593,"percieve":37892,"runic":30370,"cloaks":45062,"iridescent":23066,"heterosexuality":36346,"kinsey":24106,"pubs":21424,"vatican":6814,"yck":23696,"snyder":29034,"orginization":45304,"orly":45284,"gps":7891,"ehm":40866,"uniscribe":47743,"jbl":22620,"banesave":39198,"interjection":33259,"organizing":8988,"permissions":5000,"fussy":30555,"deepest":18789,"unsupportable":23878,"leaving":1320,"carol":8081,"trays":46795,"parks":6847,"planck's":42253,"age'":39748,"biz":20826,"random":1454,"aslam":41002,"saba":31884,"suggesting":1862,"scalable":37917,"rambam":34754,"fricourt":43865,"gng":8127,"jarvis":29585,"toilets":21997,"scissors":30595,"anarchocapitalism":34438,"placed":614,"“rootless":42763,"problem":243,"hj":15251,"figured":3401,"innovative":13580,"sampi":18783,"expletives":23233,"bharat":22008,"azerbaycan":29184,"pokorny":45455,"pirate":7603,"jpl":42828,"chairman":6618,"rabbits":19936,"torah":9436,"subsiduary":32037,"baps":21938,"misimpression":33806,"thrue":42892,"inshaneee":19301,"lacroix":39396,"financing":21254,"hath":20368,"maximize":22889,"aeneas":43402,"criterea":31422,"wikzilla":16684,"castration":32487,"misinformation":4177,"misleading":1576,"singapore's":48032,"michaeldsuarez":40341,"invariant":31229,"upcoming":5224,"glaring":9700,"hari":8421,"advertisement":3854,"methinks":16225,"godfather":27079,"wimbledon":24149,"faulty":9095,"compiling":15110,"nitrites":21790,"expandism":40246,"cuban":7435,"hypnosis":34221,"'hey":36422,"czar":24016,"indonesians":36336,"lrh":37181,"zntrip":28985,"cliques":19119,"gratifying":42971,"bingo":23601,"romania":5006,"tweaks":13042,"levant":16896,"folded":20288,"destroys":13074,"tfi":38367,"ramdasia's":31935,"diety":13649,"corneal":18522,"everywhere":3146,"shaggy":41990,"america":1110,"rican":11239,"marries":38594,"ordinalpos":29348,"seventy":19934,"expense":7439,"irrc":38505,"dwpaul":43255,"deprecate":45271,"sanctified":45039,"odf":38761,"inhabitated":42245,"sorely":15452,"lebanon":4626,"vasu":48481,"endure":12838,"arthurian":42018,"reputed":12606,"tiderolls":42354,"assitance":35594,"parlance":21753,"ne2":20728,"paints":17637,"humboldt":36303,"servlet":44505,"garvey":40556,"ddt":19266,"foundation's":16687,"adviser":18516,"kombat":19210,"elkman":29217,"obstructed":33763,"sagnella":47658,"discourage":7466,"elevated":21029,"greetings":2996,"blogger":9312,"damaged":7515,"blinds":35785,"refuse":2733,"dosing":48136,"starts":3011,"alicia":23333,"temporally":36242,"gdi":35279,"lh":32943,"kircher":49567,"perish":19513,"terrorised":37505,"distractions":28174,"keys":7825,"lightning":8561,"lvr":25006,"dicks":4582,"hs":12761,"page's":3955,"sbs":38322,"niemti":36434,"highking's":38590,"srikeit":40683,"headlights":38476,"obviosly":41402,"degrading":11969,"curling":25210,"candy":7380,"complication":30716,"'if":26573,"tanzania":32502,"howie":29248,"moronmongo":49432,"progressivist":49720,"afds":6102,"soissons":47935,"suggested":1247,"wildlife":10264,"jam":10684,"katharine":38113,"bligh":24367,"barre":32910,"dredging":46109,"dicussion":17698,"iau":18859,"steamer":37369,"rpa":40444,"magi":28659,"cantata":35759,"didn't":234,"alphabetical":8123,"gunpoint":38182,"mccubbin":42974,"bede":32374,"cupcake":34238,"extra":2249,"jacks":20898,"subgenius":37207,"trivandrum":27786,"yammer":15591,"lostprophets":25027,"heathen":25848,"calf":30060,"relase":45929,"provisional":9476,"gutter":30503,"kuma":46272,"hearts":6883,"duper":34101,"rendered":8133,"kira":30504,"unreliability":20667,"ella":26363,"rbe":49820,"moesia":30870,"endorses":17581,"undeniable":10424,"holidays":5863,"partridge":37664,"gespräch":23589,"stirs":35922,"influential":5399,"remarry":48120,"insects":16150,"places":1223,"prsa":42649,"fiorina":28193,"pascherfreerunning":46211,"climates":20001,"han":7077,"constituent":11237,"prada":26622,"'41":47421,"written":376,"tributary":18808,"court":1063,"kosovar":22423,"cools":49230,"greener":28041,"guidance":3557,"dixit":28353,"heinous":24394,"região":38829,"complementary":16951,"shrugged":26114,"fouler":49950,"phonology":11134,"tripod":14150,"canuck":38950,"healthcare":9536,"washington's":39331,"conscience":8888,"beau":33239,"mill":8835,"benefited":17709,"alltogether":46119,"ucc":23370,"brained":18238,"net":1338,"physicians":11871,"ayutthaya":48872,"kayastha":21980,"ibbetson":37786,"weaving":29478,"scope":2951,"reproach":27574,"snipping":45619,"sharks":37148,"wry":38880,"department's":28633,"dropped":3584,"perry's":48047,"speed":2406,"nafta":46262,"cheated":17930,"jeans":18005,"lalu":20855,"melonbarmonster2":48503,"sobering":43140,"cj":11252,"whack":12191,"saddening":32901,"tyr":48487,"retro":25442,"predominance":42260,"cosplay":38018,"existance":9029,"colon":8787,"smith":2379,"udit":45722,"fouled":41468,"goce":18035,"freedomain":44394,"bytes":3899,"nvc":12726,"mrt3366":42489,"fairfax":15679,"content":174,"doers":44974,"fare":12949,"ypu":45303,"predicate":19894,"firewall":24805,"freeware":22941,"employment":8038,"vandaling":36094,"ends":3187,"ya'":39789,"initials":13054,"kev":30123,"detectors":47423,"visualization":28441,"obsessing":29926,"supremacist":8341,"combo":16556,"college's":22521,"notforum":30830,"crux":16665,"ga1":6257,"nhrhs2010":4031,"backdoor":28516,"conas":48185,"'consensus'":16899,"kerosene":40223,"yeats":43923,"wieki":46722,"heil":2313,"referencing":2900,"sheboygan":40329,"kleene":41012,"salvatore":39009,"birks":31760,"00pm":46271,"umpteenth":27737,"avenue":5986,"unwelcome":10462,"roche":42480,"scar":19611,"acta":25424,"evan":13021,"diets":19891,"athlete":10160,"neverwinter":48665,"hridayeshwar":37679,"eraser":28096,"fountains":43496,"entertainment":3774,"aah":26472,"steep":18741,"doubtless":16158,"delegate":14920,"joseph":3311,"allegations":2031,"shotgun":15698,"conservative":2231,"rebukes":41291,"trig":27249,"weakens":25025,"mardyks":11157,"catalog":9472,"commendation":26431,"mclaughlin":36299,"levy":11236,"prowl":40126,"cla":38924,"restarting":34872,"downstream":32189,"isnt":3127,"fanaticism":19230," inspect":35245,"malik's":37884,"dracula":32125,"romantic":9996,"usha":35478,"apolitical":36120,"employee":5080,"argues":6258,"historian's":48363,"nylon":34172,"sensitivity":11307,"chinas":27585,"indentation":31996,"engendered":47189,"randall":13333,"battleship":18948,"trailer":8480,"20obc":49801,"krimuk":46925,"more'":48735,"indefinately":20421,"raksha":41736,"europa":14126,"unnoticed":10989,"jim1138":30178,"release":960,"namaste":26396,"guntur":42493,"thx":6651,"drunk":5520,"clouds":12226,"guard":4613,"troop":20543,"kyiv":5826,"rarity":33447,"peacetime":26953,"bedouin":31772,"illuminating":26717,"abominations":36756,"phd":5063,"nat":13235,"accepted":820,"honorable":10656,"coils":26789,"grins":37607,"renault":14413,"excitement":16546,"adventures":8884,"projections":28116,"abetting":38384,"erpxe":48172,"faceless":29793,"reformation":12414,"rd1":15187,"boiled":27813,"academical":27291,"tsuki":27344,"pwn":20626,"rhyming":33597,"discovers":21543,"cuman":28388,"papua":18691,"hyphen":8347,"discoverer":46495,"abbreviate":31004,"wphelp":49982,"propecia":24253,"caduceus":18738,"pylon":42751,"jerks":10880,"dagbladet":41696,"amazon's":32015,"rites":18965,"turkeys":24124,"makes":407,"acu":46517,"ile":48703,"coast":3444,"cauchy":29387,"emigrants":31175,"hyper":9496,"tate":32114,"collingwood":25739,"celts":17129,"q1":35664,"quarters":11148,"sum1":29828,"enterprising":28037,"permenantly":40480,"misconstrude":49655,"islamism":18061,"holloway":20563,"inasmuch":22344,"pelican":42544,"tacos":1441,"monterey":26402,"nguyen":11604,"meridian":19781,"ballroom":26811,"guernsey":38728,"stifling":19674,"whiter":26157,"freeing":21902,"blablabla":46378,"blanked":4453,"radcliffe":40253,"ebola":29210,"repo":49293,"repeated":1963,"maggie":19822,"rushing":16825,"arrival":8445,"yourselfgo":1706,"unprotection":11664,"panel":6790,"lotta":33937,"meter":9213,"contingency":43194,"bengali":13966,"hagiography":22693,"napolean":34938,"wmf's":31888,"gaston":39886,"kasi":36593,"lenore":47290,"skid":36119,"subsidiaries":24077,"melodies":41375,"tiebreaker":36054,"hurd":34592,"fyrom's":29569,"concentrated":9485,"∴hello":33986,"cuthbert":40151,"lawton":46015,"stan":8298,"zelaya":45567,"signatory":46047,"transexual":48316,"confusing":1920,"buckingham":44839,"''''♪piano":36613,"belonging":6735,"celery":41356,"strauss":16037,"mailbox":12272,"rcog":15577,"pondebadgery":41808,"utrs":37260,"ledes":44173,"superfluous":9284,"bo":11710,"dukes":12327,"holomorphic":45161,"deng":17458,"enlist":20169,"gdfl":28699,"ainu":18630,"tantrums":17164,"nilliam":40137,"vengeful":28415,"daly":16381,"elkspeak":14620,"“no":18952,"continuation":7942,"miz":23178,"archaeology":8820,"8th":6431,"radiohead":23695,"adam":3599,"phillipines":29522,"vegetables":13341,"tracs":49897,"loneliness":42221,"bidatsu":49436,"partly":4523,"tora":42516,"redistribute":45555,"artile":22350,"islas":49845,"algebraist":36857,"ramdrake":26522,"doctrinal":29046,"well":100,"israel's":8882,"halves":24899,"tricolor":47888," lambiam":44545,"entropy":22003,"royalists":22229,"nominative":42903,"supervising":35725,"stooges":21408,"editorialising":22538,"hyperlinked":23515,"bart":15039,"daly's":36253,"nutjob":26630,"fars":24591,"snorting":39906,"trois":41995,"robe":25984,"psychologically":19821,"scn":27647,"sarab":37836,"parton":43769,"blender":26110,"burzynski":44922,"connections":4644,"battling":18336,"1c1rnhn":49356,"zer0faults":43237,"wikistalk":28363,"indigo":43177,"rejections":44787,"wispanow":25649,"insistent":17049,"theatres":22771,"upgrade":9299,"draining":24483,"instability":11654,"ultranationalist":39359,"opener":21627,"thesises":45362,"iterate":36526,"srk":22616,"outwards":28904,"enforcer":18355,"nailed":21671,"relying":7655,"jamboree":34366,"church":897,"rubs":40931,"holt":31723,"lamp":13566,"mbit":24329,"boyd":12567,"abuse":984,"ritchie":22324,"pleas":15459,"demi":18985,"congregational":45184,"realized":2642,"14pt":40339,"surpassed":21725,"privately":7391,"coarse":19181,"uniformly":26324,"ryulong's":20182,"sloppy":5114,"volumes":7104,"shadowclan":17189,"ait":24258,"oversighted":20682,"camelcase":36734,"vc":11963,"csicop":48365,"embargo":20772,"theoretically":9373,"itamar":32601,"lol":510,"prefering":46603,"bishop's":27818,"whippersnapper":38773,"andrei":31073,"examples":1080,"lemme":22898,"thy":7685,"lycos":35295,"rand's":24182,"missouri":7926,"xdcc":46096,"madurai":29808,"longitudinal":28398,"mullins":47245,"inarticulate":40948,"terrorizing":29881,"wr":14064,"jeffreyneave":22411,"bees":15599,"tides":27825,"sicken":39769,"conform":3193,"hiroshima":17773,"impartially":29589,"contributor's":7034,"invariably":15474,"thoth":25436,"kike":7125,"origional":36829,"sharealike":8173,"'bout":16533,"dow":16042,"extradited":45188,"fleets":26388,"contradicts":5851,"advaita":30911,"budish":38736,"inheritance":10517,"list's":29962,"hiddenstructure":30679,"objectivity":5487,"stupidities":41938,"bloomsbury":42269,"tusc":17793,"collation":38347,"minimalist":33247,"press":1037,"emerge":11755,"tanto":43148,"wikistalking":8477,"iet":40039,"oca":28554,"canada's":15419,"fraternity":9703,"nazareth":19654,"pranic":37985,"helmeted":49810,"whom":1582,"invidious":48235,"wcc":48043,"stitched":49969,"spilling":42259,"converted":4938,"anastasia":22904,"exemptions":25617,"molina":41377,"milk":8704,"allow":1017,"barley":28784,"lakeland":38304,"llawer":42898,"nakba":27059,"analysts":17872,"chronic":7221,"abolished":11079,"sysops":10053,"mckenna":20849,"geocities":9524,"iyers":26404,"i7":14839,"aristotle's":34396,"anzac":26679,"wheat":12170,"getting":402,"rzz":37305,"asterids":44769,"skewed":9690,"harvin":31859,"silverstein":35345,"artist's":9262,"trends":7793,"sprinkler":46394,"flanks":32846,"castilian":28308,"recommendations":7802,"manufacturers":9140,"witnesses":5057,"harawira":48941,"justed":44731,"geographer":34768,"abduction":19706,"chaos":6467,"impeded":36342,"uninformed":9263,"choke":16109,"reaves":20364,"bumblebee":41189,"card":3125,"masterpieces":42030,"cafe":9143,"corbett":9550,"unwittingly":25078,"contend":8900,"penetration":20886,"eras":14486,"women":1147,"foward":36757,"cheered":32533,"domino":41093,"hatcher":30120,"rosslyn":44137,"occurences":32262,"creationism":5537,"mandelbrot":38854,"touches":12801,"brass":10642,"screamed":15509,"portrayed":8715,"confused":1458,"rebublic":30345,"bardstown":47319,"violate":1954,"suggests":2201,"menus":36716,"feodorovna":38564,"scare":6057,"exterminate":26553,"pill":13012,"dumps":27033,"coleman":15507,"unveiling":41120,"polygamous":37183,"matrys":39690,"smears":16039,"findagrave":46829,"flabbergasted":31134,"herron":43867,"nursing":10067,"sec":9624,"dermatology":44526,"terminology":3435,"xxxxxx":41751,"renowned":7631,"pathophysiology":35623,"ascertain":13055,"intepretation":47883,"categorizing":13090,"everest1953":45856,"trap":8458,"perth":12138,"jb":24603,"cessna":41456,"you´re":23965,"anarcho":9338,"fang":31053,"mumbai":7672,"fijians":36873,"drastic":9491,"background":555,"bhandarkar":39767,"details":865,"layman":12445,"dlohcierekim'''":29267,"dip":16334,"ssd":41381,"morrocan":48597,"stubby":21236,"gwb":32461,"prosecutions":35297,"negates":28126,"marty":20662,"activites":39773,"sad":1521,"fibromyalgia":32276,"circling":22917,"gst":39744,"gir":45573,"daughter":3347,"sl":18535,"droppings":44668,"veto":22724,"heartily":35471,"sign":503,"mysterious":8062,"expalins":46016,"polymer":27586,"kio":34464,"chillum":14268,"messier":38922,"cricket":4271,"blacketer":34829,"barnabas":40689,"mycologists":42584,"wikimarkup":34249,"observe":6450,"negligible":15201,"collections":10108,"nurses":20868,"shrimp":26180,"horner":30154,"sanitizing":49111,"wikimegamaster":39714,"conferred":21502,"quoteboxes":43813,"informed":2497,"frontcover":37621,"default":3793,"cesc":42632,"phantom":12242,"burmy":29240,"peejay":33989,"uc":12019,"dumbfuck":22500,"theologian":13848,"yayoi":38882,"'view":48693,"strikes":5927,"shez":38781,"bi":6405,"holger":48873,"screed":22243,"spamy":44860,"conspicuous":19772,"olahus":41754,"drubbing":42341,"commonly":2346,"woo":10972,"inputs":11255,"everyone’s":35308,"pell":45155,"aggregation":40055,"katsarelas'":45939,"karataş":37939,"disguised":12102,"finger":4665,"olivier":25080,"manipulators":33917,"dressed":12260,"submitted":2811,"stochastic":41913,"spyke":16940,"shop":5278,"bert":16558,"transliterating":34860,"tabloids":15089,"inapplicable":28478,"shifting":12832,"apostles":19424,"adventure":5652,"hammer":6449,"worrying":8481,"anglo":4525,"compnay":41648,"arcane":18673,"parley":14362,"immanuel":32165,"germs":33017,"exerting":25363,"brightens":39958,"damaging":5565,"kai":16719,"tbhotch":24630,"adversaries":24200,"countryside":19842,"yassin":17374,"mid":2452,"guru's":20400,"monkey's":27677,"deficient":13828,"brunette":27470,"'beyond":43760,"'lebanese'":44531,"alaska":8485,"audience":3969,"conjecture":8025,"​​spoken":44580,"wwi":8920,"palau":33483,"draw":2429,"comparaison":40146,"reflecting":8557,"themes":6413,"pumps":24733,"nicolas":16095,"geologists":19476,"karyn":25009,"ctv":25035,"jaranda":26761,"jenkins":12209,"vista":4630,"disseminated":16097,"dms":30688,"censuring":34532,"pixels":10333,"operating":3576,"bef":44807,"citation":701,"lambs":32597,"immidiately":45431,"ramon":44748,"wholesome":33905,"burgas":23114,"tolkien":19062,"occured":6778,"'attack'":39566,"medline":48507,"azam":29646,"opportunism":49809,"rift":21600,"warns":17478,"codegear":43226,"studio":4051,"bothering":4605,"afrikan":43391,"outfield":33138,"discomfort":21375,"dawson":23582,"selfish":9895,"delhigovt":42871,"dub":8326,"incorporated":4207,"deadbeat":36006,"ogginsert":24907,"civ":12771,"tutorial":996,"cooking":11753,"poverty":6472,"terrorisim":34962,"tasteless":29791,"cuba":7453,"superceded":32594,"sheriffs":27664,"music's":40996,"probable":9481,"ped":36822,"maru":23008,"recorded":2535,"florida's":47408,"credentials":5142,"decreases":21123,"bluff":18436,"belarusian":18272,"wikiproject's":25106,"uncivil":2236,"substandard":37009,"lou's":45227,"lede":2609,"hardworking":43371,"cf":5506,"tabtabtab":21370,"baroda":49559,"transistors":28721,"question":211,"seperated":22096,"restructuring":13014,"types":1327,"straits":19774,"respondents":25802,"wikipdeia":47739,"lazenby":40736,"dm":16086,"gibraltarian":43092,"zoology":24898,"reticence":39558,"من":30287,"maze":22924,"it'd":4909,"rover":20414,"csssclll":21706,"bia":46698,"remotest":38975,"knowledgeable":4636,"felony":12686,"grandfathers":26535,"vp":8000,"cuts":8240,"occurring":7625,"luc":27568,"succumb":33705,"⊕⊗":24593,"businessmen":30644,"vexorg":38500,"patents":7069,"basterd":40796,"cavaiani":38726,"generally":692,"mantle":20520,"revised":4046,"gj":39367,"'pedia":13017,"bulletproof":43766,"hav":11363,"due":570,"1850s":36195,"bhattarai":33981,"recordings":8482,"shinto":18076,"fourthly":24970,"supports":2318,"ahmadis":37885,"smelt":42322,"bags":13544,"cebu":25278,"ss2":44351,"ghosh":29613,"natalee":37459,"reputability":48841,"challange":44594,"wikipedophile":42616,"legalism":36626,"entrenched":14122,"huntington":27575,"sickos":27653,"✈":21831,"bitter":6750,"unmanageable":26518,"pops":9733,"gravedancing":31245,"ooooo":40037,"allusion":21838,"labels":5761,"fatalities":15549,"cruisers":39249,"warrings":47504,"alleges":18321,"wallace":9859,"sadism":37026,"prat":28952,"cnt":42448,"gacy":35710,"bogazici":45082,"transcendental":19070,"eastward":28488,"medcan":37922,"ziya":40702,"styled":10426,"ashish":28099,"languages":1442,"denoted":18138,"stepan":49906,"errantx":38393,"assignments":11003,"raion":34304,"findable":29986,"saudis":39556,"americanist":48095,"tag's":36321,"primera":29570,"wessely":11638,"leaning":7973,"gu":32622,"kiernan":33158,"magical":8694,"dafa":40887,"offs":22818,"everbody":40277,"curiousity":20661,"nearer":26337,"oban":37066,"resumed":16101,"maxed":46695,"limit":2775,"impersonators":27420,"sert":44101,"sections":844,"grind":9097,"ymmv":24520,"controlling":7375,"etymology":4574,"whome":39935,"replication":23389,"punching":22159,"operative":11173,"ariel":9714,"winehouse":32158,"flanders":14396,"bregman":33744,"recitation":30531,"sleeps":21233,"brownies":43758,"astronomers":20910,"hmm":3581,"harmonic":19020,"ccp":13971,"horns":17868,"lance":10500,"nationals":16536,"lakeview":46871,"plugs":20472,"posthumously":33848,"proponent":10558,"sudhra":36788,"trib":44945,"charleston":22522,"presstv":29269,"desi":29825,"killers":8954,"tam":26355,"owned":2832,"venezuela":11081,"nydailynews":39866,"magnets":26437,"celestial":11825,"footprints":23423,"tomorrow":2271,"twofold":48225,"dickbig":24379,"dmcc48":28023,"strident":49917,"who’s":44523,"regress":44454,"prejudicial":12646,"stroopwafels":40473,"olam":46383,"jokey":45912,"holds":3747,"suicides":21859,"uu":6156,"elno":18886,"notepad":36330,"est":6194,"d'oh":26663,"consequential":26056,"issue":258,"guido":16110,"bell's":14319,"jeshua":39025,"slough":33431,"grieves":34948,"br'er":25742,"introduced":2670,"hurting":8996,"vera":22486,"lego":17432,"crafting":25365,"7b":38580,"paced":31075,"hiligaynon":45994,"beaches":24164,"giraffe":27850,"brats":26329,"presumed":9349,"journeyman":48576,"invocation":22936,"biased":805,"donfphrnqtaub":38744,"guineafowl":27369,"nes":17668,"hlp":46360,"barton":25433,"eso":41184,"comms":24414,"undermined":17635,"peirce":30335,"yau":48234,"faint":21458,"dianetics":15306,"emulating":45649,"competent":7172,"1958–88":35496,"oppurtunity":48803,"steward":16210,"expands":11720,"appealed":8953,"minted":45002,"costa":9966,"physically":6063,"mali":23662,"duh":8817,"continuously":5765,"willed":22536,"administrator's":8611,"extraordinaire":39924,"pimple":35620,"—":355,"'god":44442,"bleiburg":26657,"waned":46061,"cvua":27817,"manchu":13940,"cath":39323,"plz":5259,"burnout":20720,"coppertwig":32830,"naga":13380,"routines":36584,"crap":1435,"caitanya":26858,"grosser":32402,"ж":44289,"bring":1020,"cyclepat":45557,"30's":20820,"hacker":8691,"yapping":33076,"curry":7003,"wastes":13864,"mergeto":40925,"nutrients":20819,"skirts":27828,"spangled":41549,"pagans":18976,"predates":12373,"mister":8342,"othodox":41992,"symphonic":22426,"molobo":32504,"gorge":19591,"fyunclick":41727,"denominational":40426,"remained":3998,"indistinguishable":14579,"towards":1048,"joing":46020,"thepatientcapacitor":45141,"behemoth":35607,"lacuna":36984,"monoplane":30662,"dnc":32222,"caribbean":6344,"giorgos":39574,"reconcile":16756,"repellant":35087,"suriname":25853,"tekfurluk":49518,"godhead":47176,"borough":9741,"wickey":45703,"steps":2966,"electrometers":48103,"faced":5125,"nasrani":25677,"perpetuates":39510,"motorsport":22824,"irvington":29374,"tizzle":28807,"principle":2676,"ibn":7320,"japan":1785,"communities":3883,"infiltrate":34381,"gamed":25678,"sunni":8234,"tutor":18473,"pronunciation":3961,"ugle":18523,"█♣█":44176,"efforts":1553,"somone":13426,"pease":46593,"rodent":25453,"politeness":12025,"fuckin":3132,"shoit":12051,"koch":14366,"implant":35119,"unstressed":42161,"legs":6848,"kilometres":25911,"dsk":49961,"toed":35573,"macedonia'":41090,"dissonance":27010,"arxiv":19042,"trimming":11365,"chucknorris":35500,"telling":1305,"depressing":15087,"disamb":21537,"solutions":4961,"methuselah":42355,"south":868,"hodson":18756,"rebecca":11078,"superintendent":35110,"disambiguator":29908,"zhanzhao":26878,"puppeting":17050,"visions":17297,"international":1027,"female":2044,"document":1837,"platform":4590,"confirming":5942,"sissy":21598,"nein":45854,"mother’s":40690,"jojhutton":48133,"earnings":22676,"lee's":15848,"unsustainable":35278,"demolishes":42138,"souces":32572,"evrik":45086,"pei":30525,"cheesebot":36034,"ginyu":49622,"condescending":6676,"harmless":9767,"wim":23540,"date":426,"descriptive":5849,"lord's":19005,"occasionaly":44555,"tobi":36842,"kosovo":3263,"shackleton":43811,"unreliably":36073,"drbat":38632,"directions":7400,"gettting":40728," 🍁 ¡gobble":27617,"nyb":21246,"unauthorised":48902,"liitle":47747,"satanic":11633,"convincingly":18525,"distaste":17484,"denunciations":37808,"caffeinated":39982,"indic":17033,"demos":22000,"nitpicky":30438,"bondi":45998,"chord2":24853,"frictions":47817,"rosids":44768,"commercialism":49229,"mp":7901,"gazette":10184,"ahir":21920,"counterparts":15328,"musicological":26803,"notarized":29049,"kupcinet's":45835,"temerity":35526,"misinterpretation":10852,"ipv6":37914,"shams":34934,"dlc":31538,"nvm":39497,"higgins":17514,"opinions":833,"aparently":29916,"estranged":30214,"slakr":30477,"litre":30573,"lib":11533,"buffoon":24472,"experiment":1254,"pinski":40871,"magie":34783,"reponses":48310,"psychopaths":30327,"flourished":35206,"slp1":33294,"stipulation":31116,"spell":3295,"sarajevo":23410,"season":1263,"guttural":45054,"bartleby":40358,"donaire":29175,"mont":32781,"toe":3817,"91r":34555,"fricative":18491,"hips":36065,"edditor":47598,"goff":31034,"residing":12270,"schindlers":41899,"alvarez":29866,"sephardic":25514,"foras":49634,"anycase":40692,"warship":49212,"katich":46975,"women'":39624,"'i'm":46075,"overseer":29047,"bhoj":45272,"recognises":23204,"nederlands":47205,"soooo":14189,"watchful":24130,"foto":27512,"paraguay":27994,"badali":48881,"pedals":27084,"dave":3763,"mendez":26635,"underhanded":19882,"bowels":37743,"pchip":33503,"codes":4096,"democratically":19523,"deepwater":41102,"encyclopodia":31867,"newton's":16209,"agk":11521,"stellar":22402,"galician":27302,"skoal":33281,"quietly":9745,"man's":5562,"dab":3468,"ideographs":40905,"stark":10847,"smallness":37636,"fault":2777,"federation":5736,"adjustments":10113,"legislate":34248,"coated":21322,"anticipate":15250,"unbecoming":17749,"communicated":13108,"wong":16837,"altering":7972,"expansionist":29606,"forecastle":46810,"abandonment":18617,"8b":22953,"hyacinth":38489,"sava":39373,"chewing":20725,"worrisome":32707,"worked":807,"leo":9649,"legions":29609,"naples":17026,"rodgers":21268,"ᛏ":16198,"belcher":49243,"loathe":16310,"dionyseus":35920,"watchmen":31167,"selecting":3014,"conversant":25960,"maturing":37111,"took":629,"vamped":48389,"ike":14892,"hagos":31829,"machiavellian":41216,"refresh":9248,"editnotice":21011,"clocked":47396,"ernst":11247,"advisors":15295,"crashed":11469,"rubbing":22197,"pastors":41980,"schwarzenegger":36359,"debatable":7752,"book":332,"knowledges":29910,"unpunished":17876,"ballard":39978,"begley":44844,"dll":19806,"borrowing":19679,"frisian":28612,"pronouns":12045,"buttsecks":2023,"foes":29243,"dubious":2879,"riverside":17948,"coral":17814,"helvetia":31424,"associating":13477,"preceeding":26549,"psyop":44206,"winslet":32778,"lucretius":47586,"senshi":32384,"hi":161,"amway":42675,"scuttled":49789,"saul":14040,"folio":30309,"treasurytag":31083,"binky":33931,"registration":6700,"deficiency":15037,"nursery":28018,"veriverily":43030,"scienceapologist":15159,"jonah's":45887,"females":7635,"reconnaissance":37414,"calle":25180,"remainder":12785,"qualities":8827,"rack":19104,"bipartisan":49301,"cu":8922,"activities":2322,"ticket":7388,"nicht":38037,"lovin":45130,"mccall":49283,"compiles":30583,"pitiful":11716,"i3":46153,"vexatious":29293,"fv":34786,"invalidate":13048,"mindanao":32386,"mein":12458,"because":68,"detriment":13305,"தமிழ்":49607,"livered":48853,"category":465,"ramps":33585,"prashant":26692,"shintoist":36996,"inflexible":18704,"dresden":10178,"horrific":17449,"orientalist":34390,"wednesday":9073,"loitongbam":37947,"lier":25072,"swell":19361,"alpena":42663,"æµ§œš¹":28934,"categorized":8683,"exemption":12840,"jah":47250,"zorn":43693,"grenada":37940,"watt":17582,"synthesised":45871,"infidels":36356,"designing":13903,"bailed":38081,"installation":11066,"dreads":43448,"patrols":31120,"boobies":26849,"privileged":13140,"drums":11761,"tiptoety":18407,"brothers’":42134,"briefcase":20573,"surprisingly":8563,"tourette's":34300,"nf":22453,"boiling":11462,"wpcleaner":44014,"'rules'":47160,"britian":23261,"childrens":18323,"mccarthy":11263,"wimps":45659,"sceptics":24443,"desc":35707,"nutter":27706,"teritory":30189,"rampant":9958,"overturning":21564,"latchkey":48412,"redundancy":10801,"wavelengths":32627,"e6":23584,"subdivision":17672,"terrestrial":20502,"wordsmith":48520,"austrians":22572,"created":299,"ems":41586,"lukashenko":37910,"position":533,"aeon":37444,"foibe":27857,"punched":17080,"downright":9621,"payroll":19225,"questions":235,"gamespot":13496,"lingua":15121,"salt":3378,"'and":29092,"ajith":31489,"hugh":11327,"chat":2104,"brah":19173,"kern":22266,"sellers":15142,"sentient":20495,"cannes":23296,"beige":27317,"ounce":20006,"ilikeit":44971,"leon":11577,"gil":17162,"bengalia":27351,"careers":12492,"shure":32730,"royalty":9096,"agression":32230,"embed":31306,"counterpart":14159,"boscovich":42818,"vocal":6820,"infobox":1081,"undercover":21752,"sas":13420,"arbcomm":21366,"mixers":41863,"azad":17791,"graphical":16934,"treachery":23926,"flourish":25858,"disruptor":35418,"corrected":2043,"invoked":13988,"deletionist":8299,"wagging":30634,"tinga":29421,"hovercontrol":28632,"carter":6854,"urartu":15123,"6de5":47025,"investigative":14808,"retrospective":21192,"hersh":24330,"hanım":27384,"devi":18369,"greet":23419,"pruning":19016,"checkusered":34100,"malcolm":8967,"ennasis":44936,"perspectives":6585,"tyco":35390,"administration's":37493,"sold":2705,"collapse":5144,"venerable":24741,"gladiators":48939,"lacking":2508,"demised":27981,"discarded":15814,"cor":23836,"pretenses":16287,"nawab":20401,"compilations":18400,"up®":29145,"receive":2574,"yacht":33110,"ramone's":43903,"supernatural":9293,"invisible":7592,"kamal":36959,"br":10492,"disused":36510,"tunisians":28370,"enwiki":15291,"exemplars":48779,"yugo":18694,"sensitively":34988,"extracted":12100,"irrelavant":32935,"mauser":31150,"aba":16526,"origins":2720,"spanned":42752,"indignantly":49606,"favorable":9840,"masjid":23069,"pension":16199,"midday":29384,"chaldeans":25723,"disability":11323,"aaron":7206,"prehaps":42492,"hexagonal":37331,"emo":4185,"weighty":38993,"rassinier":48644,"recreational":20525,"20th":3294,"atlanta":10608,"uzbek":44730,"negotiated":23706,"maintained":4510,"summers":24459,"confessions":14950,"loyalist":13138,"duesberg":29812,"hangover":19539,"factual80man":38268,"quaint":41274,"'b'":33719,"personel":29560,"director":2690,"romantics":44414,"reminiscent":15867,"securing":21796,"ekadashi":32460,"underaged":41445,"classroom":16167,"hatted":46959,"sweaters":42074,"patriotic":9760,"baltic":8357,"draught":41503,"αnd":25369,"particularities":48010,"maunus":13507,"söğüt":49522,"factually":3258,"h2g2":38331,"unfactual":29078,"ox":17008,"cosmetics":41005,"aj":19583,"remain":1324,"homunculus":19371,"systematically":7227,"subordinated":32894,"inconsistently":25870,"wrestlinglover420":29279,"prapaganda":40247,"mangina":6243,"refugees":9570,"haku":46086,"civilized":7870,"minder":42247,"hysteresis":49585,"aaryanrajput":39055,"exact":1460,"unix":10671,"vous":12965,"ridding":38301,"beetle":32586,"cnn":3478,"nomination's":16887,"whith":19753,"legitimately":10917,"wherein":11680,"bnp":5912,"byzantines":37154,"achievements":5165,"profanities":28520,"malik":6943,"macy":28320,"mama's":24155,"kieferskunk":31539,"todd's":36753,"survived":5836,"churchofscientology":41602,"reshaped":49881,"qworty's":47975,"ncram":15014,"rabbinate":37345,"pesher":46755,"uncensored":17371,"jerusalem":3872,"accompanied":7854,"battleground":6785,"earthlink":38183,"μ":16025,"pratt":24671,"rsmc":20782,"wagner":11812,"subscribe":9553,"chineese":45117,"travis":13309,"budge":19297,"subcaste":30088,"undoubtably":42388,"tongues":16345,"virginity":19087,"sweetie":21159,"memo":10773,"'good'":23975,"spending":4033,"hermann":28352,"churchgoers":43446,"diapers":29618,"gyn":44032,"secs":39502,"blazing":28545,"g3":16971,"sarkisian":38131,"idiosyncrasies":30096,"duncharris":20773,"nonzero":45489,"weyl":40597,"battletech":27373,"archbishop":12616,"overwritten":32972,"counter":2211,"miscellany":6680,"'golden":45361,"preeminent":40649,"quickly":1688,"crucially":44984,"cpt":41353,"kilometers":14817,"wars":1449,"sitting":3757,"bowie":21162,"annoyingly":32642,"grockl":37832,"dalip":49597,"ascertaining":35646,"wjbscribe":31812,"macs":29891,"tute":38647,"cy":25367,"mateo":27964,"madam":14796,"ptc":27211,"8m":42748,"sohr":27354,"muzemike":16954,"headley":35756,"newark":24900,"suppressive":29822,"demons":10744,"deet":23124,"incidental":16650,"transmit":22506,"chest":9461,"gravestone":24212,"rotated":19550,"hinted":15052,"bbhs":37542,"optimizer":39995,"pompous":6540,"signal":5438,"dict":44754,"bothersome":24931,"craic":24188,"brahmin":13952,"outward":13562,"noob":9981,"naturopathy":17507,"writeup":27458,"gogo":10798,"dc's":21925,"compelled":8598,"gorgeous":27503,"deduce":21073,"20's":42292,"cooled":15735,"reciprocal":49797,"alexios":34830,"ibid":15978,"vandal's":25411,"duggan":21779,"deprodded":43643,"posses":36007,"fricatives":27259,"hanging":6031,"missions":8760,"satirize":44735,"may":85,"hunch":17572,"everything's":26169,"meets":1244,"sahi":24385,"nc":8738,"mlk":18671,"gums":43039,"dissenter":32444,"gold":2889,"infomation":18488,"legitimacy":7434,"enlistment":47216,"sect":6492,"rv'd":31569,"switched":6779,"cumulus":24654,"cade":26121,"conduit":41498,"prairie":18924,"alr":18403,"tempered":13269,"album":1040,"dot":3773,"captaincy":35757,"lawson ":38140,"mulher":38713,"sarujo":32290,"dataset":24249,"stream":6561,"cms":24650,"feathers":17244,"egged":46875,"diddly":48121,"aljazeera":34317,"palladium":28384,"deleeted":27504,"evn":27794,"perle":46629,"schizophrenic":30330,"kittang":39729,"unwilling":6512,"pharaoh":18715,"merkey":14658,"locked":3017,"darin":40085,"snowed":40558,"affix":8409,"sundry":21319,"vitaly":41134,"italicize":29284,"hyperskyhook":34857,"bureaucratic":10162,"lds":7706,"attractive":8346,"tramp":19085,"innacurate":18289,"him":153,"internment":29068,"locate":7149,"semirings":24294,"noticeboard":1625,"hipi":39937,"lattice":40888,"hipster":47765,"cursory":8747,"mussolini":15194,"sonisona":25222,"fuckwit":14059,"folder":19013,"pinter":31610,"veyron":38984," contrib":36720,"dnis":44172,"gob":36499,"adoptees":43272,"mstopeka":35923,"zapped":32083,"merest":39392,"snide":9804,"retrospect":13801,"pillars":958,"nr":18211,"tara":19341,"andrzej":49312,"shareholder":27253,"encyclopedia":345,"bulky":25290,"becaues":43667,"rehashing":20341,"celebration":10245,"surgeons":18462,"smh":22859,"handelsblad":33655,"dad's":16568,"beavis":12469,"abovementioned":38165,"devoted":4262,"banno":43274,"gems":22318,"misrepresentation":6106,"darned":32229,"com":237,"lithuanian":7360,"redoing":29081,"optics":10775,"spanning":21420,"webcitation":25392,"wbo":31010,"ivory":15024,"pape":38452,"succession":6999,"balling":21432,"abrasive":15357,"mirage":28454,"nidhiki05":39081,"mun":49852,"donohue":22671,"nostril":32529,"comanche":16906,"policemen":19845,"ballet":17103,"dapi":20703,"apotheosis":41789,"bits":3536,"asiento":49726,"advises":18040,"illegaly":44428,"sioux":41317,"preform":49188,"liquidated":42291,"gradually":9189,"melted":22403,"potd":12488,"scroll":6437,"ecosystem":18412,"borat":30794,"ttyl":45711,"solidarity":12295,"argumented":38206,"necessitated":23741,"rivers":7909,"mansion":15498,"prosecuted":13637,"sq":17806,"paraphernalia":40385,"krim":45981,"insure":12931,"erotic":14756,"chun":15438,"bhagavatam":29429,"cohort":15667,"psychology":3839,"freisler":46721,"aussie":8323,"importation":32066,"recipes":26561,"article":23,"younas":34844,"dc101":37975,"mervyn":35350,"consecrated":21661,"'wiki":34556,"sry":23164,"drowned":15432,"subcontinent":12766,"georgian":7266,"ph":6663,"muselimi":48056,"combination":4587,"jeeny":47044,"shumate":38053,"boilerplate":7775,"blatantly":3794,"nys":38220,"sangha":24736,"ranktab":35502,"napoleonic":21335,"legislated":28297,"pvs":41898,"o2":26579,"horsepower":21745,"itunes":8376,"pendulum":13465,"viewing":5489,"gabemc":25243,"kuan":44893,"nakon":23739,"dominic":28073,"hannity":15953,"mostar":47685,"fatuorum":4983,"retires":39264,"mug":20298,"randian":41711,"unga":47368,"score":4327,"asparagus":40349,"hardball":41419,"bullion":40623,"ravages":48082,"spelled":3687,"affluent":21968,"hereinsert":25013,"experiences":4389,"rewriting":4778,"subterfuge":25385,"saved":3673,"libyan":15315,"therapeutic":11364,"animalfucker":46167,"nair":7887,"complain":2536,"vegetarian":8693,"centers":7432,"mitterrand’s":31675,"forwarding":20926,"corral":41480,"grunts":36000,"pistorius":48728,"signup":29010,"laertes":42921,"sadasivan's":45242,"ilike2beanonymous":49839,"pretended":18701,"customers":7244,"hockey":4883,"desperado":33887,"inns":37199,"roberts":9503,"cop":6913,"reaffirming":41543,"sub":1897,"order":501,"guinnog":40042,"knowable":35996,"phinchas":35587,"wta":26256,"discriminating":15303,"phuck":36002,"hathate":27842,"bbc's":25613,"gettin":45762,"feasible":10486,"intense":9151,"kilowatts":40532,"kiwiexile":15266,"fashioned":10489,"rothschild":26012,"robert":1713,"odious":23273,"kven":16398,"rexcurry":5546,"nsa":9210,"embarrassment":12313,"cladistics":19558,"labrador":30612,"stenger":43963,"carnildo":22634,"discordant":35978,"boosterism":28322,"rome's":35951,"tempest":29160,"tata":37112,"portals":12322,"haye":35411,"n'est":41389,"supercilious":31369,"hamtaro":27191,"almost":669,"jed":41034,"delivering":14249,"halo":9751,"designer's":36378,"tenses":25319,"fests":39689,"permalink":25999,"spanglej":48421,"subject":242,"generative":28551,"condecending":48130,"suit":3510,"shogun":41896,"ayn":13122,"ladin":12859,"templatedata":36371,"'''talktome":48397,"cheeseburger":23657,"joe's":17426,"microcosm":41807,"kalashnikov":38642,"arte":46361,"mmy":39095,"writhing":47700,"sanitized":19916,"warrented":46916,"lobbied":27989,"voivodeship":39809,"rectal":40215,"responded":2124,"russification":30420,"stringer":23115,"stubbornness":22164,"malvern":30669,"distances":10702,"stlye":47615,"narrows":41276,"pistons":37945,"ria":40366,"arvanit":47285,"understanding":1085,"line":487,"mc":8371,"input":1525,"disrespected":20914,"schwartz":21314,"'racist'":39190,"specialty":11531,"selena":16653,"baton":17462,"market":2718,"domesticated":15153,"hikaru":44452,"movement's":36575,"sacks":28027,"murder":1861,"hedges":23295,"inborn":45895,"graemel":37673,"sarcastically":26768,"unacceptable":2477,"refutation":9075,"persistence":12536,"clubs":4495,"pliny":49615,"snooping":42793,"1px":1693,"e2bf":34333,"versions":1900,"disassociation":40465,"celebrations":17274,"guttyboy3d":36126,"carbide":33086,"punches":18036,"passionate":9967,"throwaway":19320,"scale":2410,"theme":4222,"amphibious":29207,"foray":40685,"obscure":3248,"colonize":37730,"direction":2401,"nonlinearity":40586,"nights":8783,"km²":15362,"chemicals":12393,"workplace":14180,"trustee":25715,"mridul":45014,"“discussion”":35209,"majesty":13066,"provoke":7728,"secluded":24790,"security":2250,"shaansoft":46436,"supply":3474,"odp":35880,"reeducation":41438,"momentous":32834,"'non":21871,"scrapped":15276,"electoral":7609,"racehorse":40961,"amateurish":12701,"choose":1479,"verizon":9941,"deliberatly":33874,"saunas":33747,"unpolished":49866,"switching":8026,"characters'":22954,"tended":12241,"rabbit":10735,"sockpuppets":3136,"material":342,"statuses":42017,"arranging":26155,"baptiste":49593,"natioanalistic":25045,"firmly":7232,"clicks":14002,"granite":45599,"characteristic":7024,"rebel":8166,"lettered":41924,"supressed":36168,"chooserr":37160,"privilages":26744,"shaded":33364,"bulbapedia":49775,"layla":42992,"— talk":22334,"vahakn":21105,"songwriters":31098,"hartmann":39976,"lose":2399,"hellenistic":16457,"rybkin":34762,"possessive":12746,"mayo":18644,"c'mon":14105,"craig":7055,"houses":5499,"jacksonville":19818,"precious":4412,"jung":11686,"stile":32948,"alec":16034,"topalov":29924,"creeping":16778,"groening":44153,"ethnography":37794,"flonight":37982,"sheriff's":27843,"litmus":32257,"alexikoua":10858,"owl":10445,"bhir":42595,"nangnang":46540,"rewards":14977,"choice":1505,"cydebot":26750,"convoy":21287,"bencherlite":40616,"kinship":28142,"mohawk":32956,"echelons":33727,"bleachanhero":4918,"mutated":30902,"conmigo":21957,"communicator":29839,"branding":10575,"fucky":9989,"exhibit":8941,"doritos":38417,"vote":976,"nye":44229,"yaoi":27364,"villians":39166,"dysfunction":18456,"arafat's":47105,"trafalgar":24419,"salaried":44657,"nunavut":44158,"tfm":46538,"whigs":44393,"f":818,"heathrow":33284,"shamefully":41826,"turf":20643,"falsifications":30774,"preparing":7970,"counterexamples":46569,"herati":42180,"shoddy":17487,"landscape":10859,"lull":28012,"ashida":20314,"rantings":21783,"ejfetters":45942,"halliburton":27639,"normative":15944,"intergalactic":35857,"tramadol":31362,"some":60,"denegrating":47056,"devoting":19898,"unicef":24759,"timbouctou":42338,"cruciani":49304,"google":610,"vaughan":14853,"work's":24878,"utilised":29005,"nutritional":19841,"mound":14901,"fleshing":23182,"broke":3324,"garments":29912,"reconized":47114,"christy":29872,"billinge":46277,"ejaculate":36847,"khalsa":13310,"plumbers":45055,"ron's":43290,"lifting":11700,"greenwood":34582,"biblio":39115,"slo":44092,"earrings":17250,"sovereign":4742,"substitution":12234,"themselfs":42977,"whisper":14942,"argumentum":16654,"frame":3806,"arnold":8812,"mechanical":7352,"preserved":6247,"geitner":34653,"manacles":41606,"bialy":31251,"vfu":38337,"venting":21481,"covenant":12258,"spooky":40554,"tatpurusha":37663,"granth":16231,"shin":18514,"ska":25490,"anal":2016,"general's":24769,"youi":37159,"ohnoitsjamie":13407,"gott":37256,"widr":37738,"spans":15672,"splatter":20496,"invalidated":32127,"squeezing":40325,"lane":7817,"08":1736,"overblown":20304,"castalian":35903,"elliptical":28986,"todo":17012,"silvia":48659,"mckay":14952,"inert":43166,"inexperience":28341,"void":9549,"bilingual":14995,"siberia":20275,"cracker":16089,"ravidasi":49557,"naïve":29557,"socialists":7405,"hats":12667,"thrasher":42056,"genitalia":15615,"fighter's":32713,"«i":45968,"arguing":2064,"empress":17178,"despicable":9728,"treasurer":27708,"lightbulb":36419,"templateuserinfo":38255,"mabdul":20736,"formerly":5645,"7pm":46212,"dweller":24971,"ferrets":42321,"everyone's":5802,"grapes":18707,"misuses":36276,"islamabad":32486,"tu":8219,"periodical":15572,"burger":14747,"adjective":5894,"erika":33441,"chamars":10800,"boldface":21515,"coordinating":22962,"dams":26229,"constructor":45708,"bylaws":40335,"pluribus":34160,"latter":1874,"bandits":20958,"assumptive":33839,"morality":11137,"nundah":33862,"politicised":48030,"detriments":33272,"taker":22621,"danged":44671,"gases":14213,"slot":10572,"obsessively":17730,"baul":20683,"noujaim":24368,"holly":14678,"optimistic":16878,"00":1397,"morally":13296,"res":11172,"zealots":15074,"appies":44121,"indoors":35457,"intransitive":31735,"respected":2780,"raven's":39871,"omsjpjm":48922,"kuiper":48502,"buddhists":19180,"veteran":8533,"nile":21882,"tommy":9120,"britches":36382,"anamorphosis":42517,"subtle":5313,"cognitive":11206,"eror":38747,"wikepedia":11613,"ο":31923,"sucess":48075,"knox's":19404,"mats":27038,"proverb":21892,"reenter":25040,"locations":4260,"centralised":31413,"butchered":21232,"calender":27975,"shaky":20598,"git":16846,"transmutations":43622,"section's":16505,"regularity":19771,"expressiveness":32744,"tha":8696,"1600s":32993,"convincing":5715,"leobold":32501,"lynching":38093,"beholder":26374,"remount":38825,"gridiron":35825,"hut":16758,"christian's":23888,"vandalisation":42804,"m25":39169,"indeffed":27421,"exaggerated":8332,"qiyamah":26888,"oer":28727,"redress":20640,"rollout":48573,"aap":14559,"karyn's":40789,"blames":26205,"moynihan":43789,"futurism":29316,"dalit":13334,"giano":9819,"dale":12966,"read":150,"dismal":26667,"reverts":1415,"agency’s":23154,"main":433,"inventors":13708,"gisin":31698,"database":3563,"texture":23886,"elucidate":17761,"boleslaw":29219,"editathon":18077,"lowering":16194,"specific":497,"vojsava":34336,"orbits":20746,"barrister":32082,"gaetjens's":34845,"partnership":11996,"euler's":28591,"hillarious":26820,"cdvf":44358,"labor":4559,"cathedrals":23015,"chron":44946,"oppressed":12844,"ashok":40717,"letter":1723,"massive":2495,"dcandeto":27124,"prisoners":7907,"clickable":22163,"closers":28337,"nobelprize":47803,"katyn":23727,"classification":4450,"photographs":4006,"characterize":8338,"nisbett":39124,"kaikola":24117,"advertisements":12210,"assumes":8196,"maggots":26217,"emerged":8479,"foreigner":21433,"'zilla":38483,"gun":2511,"abouth":45079,"denouncing":19046,"durham":11600,"'bertiebasset'":48989,"ricky81682":40330,"genesis":5241,"hurt":2577,"ashleigh":34539,"highschool":20822,"memos":18241,"typing":3185,"passwords":19588,"destruction":4034,"roach":35788,"rape":1246,"yorkshirian":48254,"tests":1276,"plainlinks":20871,"spaniard":26222,"zain":38273,"outgoing":27212,"sanjiv":34805,"kate":9778,"wikipedia’s":8208,"laboring":42466,"undeserved":22785,"tmorton166":46609,"vicious":6954,"visual":4713,"'65":39418,"'nonsense'":34847,"successors":18575,"override":10693,"leftists":14924,"atricle":44673,"master’s":45444,"interwikis":27848,"saad":47305,"uji":49165,"bennifer":47799,"logical":2122,"women’s":21738,"whimsical":27304,"incident":1678,"launcher":41069,"adjunct":19869,"babywhat":6903,"imgsize":41243,"philogo":38490,"intricacies":24556,"disassociated":35041,"departments":9101,"deducion":45331,"davkal":39014,"busters":22268,"basing":9239,"leftie":42547,"blinding":37637,"liu":19057,"sindhi":39001,"b0":30873,"amyas":47229,"ed":2380,"jeremiah":15705,"thuggery":24772,"même":35132,"asuka":46900,"sher":34329,"nonconstructive":12660,"impressions":12287,"ouzelwellian":37528,"30th":10692,"german's":45381,"alcohol":5619,"striver":29989,"esrb":45181,"gradual":16329,"minimised":45495,"mis":5336,"parental":17058,"agitating":34116,"unveiled":39974,"''''''mundo":36815,"rolling":4760,"yopie":24964,"opting":31243,"worthless":3296,"lukeno94":33015,"biases":6161,"moxy":33987,"volunteered":18184,"undead":23646,"powerpoint":28190,"wine":6180,"elevator":11839,"nerdy":16631,"hadji":39518,"nordicist":43027,"fruitful":13025,"controls":7101,"bundesliga":29582,"msp":37894,"upsetting":13629,"annexed":10582,"banu":18181,"playoffs":15335,"v":880,"srq":29458,"deeds":10169,"hindus":5544,"kid's":21293,"tutors":46617,"umpire":41524,"parishes":21877,"faculty":7234,"monarchists":45306,"compliments":13573,"granada":36865,"shearer":28839,"collapsing":21797,"juices":45088,"b'tselem":34732,"ethanol":32941,"transported":18409,"troubling":11055,"assist":3590,"incidences":22540,"death":780,"infant":7694,"juts":42027,"rouge":9583,"particle":7000,"hed":34034,"thaksin":49667,"sinaitic":42851,"aggrandising":36513,"paycheck":29724,"awareness":6692,"guzman":48460,"immunoreactivity":44262,"danielle":15998,"shias":23977,"signpost":3644,"finalroscoe":38519,"supertr0ll":4849,"mitchel":37403,"magnifying":23636,"routledge":16646,"commentators":8440,"secularity":43112,"mathew":23802,"thumperward":30735,"queens":10549,"steel":6350,"verifable":26048,"apollonian":45548,"toggle":45474,"tdc":28537,"sequentially":35343,"swag":29216,"scarab":41563,"prospective":13678,"pavilion":39363,"entertain":11607,"customizing":33671,"prohibited":5027,"cuddly":28357,"expose":6232,"crappy":7339,"allowances":26422,"fuckup":45878,"2012‎":15177,"cyclothymia":38853,"segmental":26235,"century’s":48344,"ringerfan23":42530,"irvine22":24013,"wouldn't":794,"shades":16157,"dunces":41221,"negligent":24510,"appearing":4004,"photo":947,"shirulashem":48433,"wordplay":33424,"ilegal":45714,"bahram":31564,"typically":3416,"haute":40139,"slgr":48512,"aethelric":42543,"ignores":5943,"jafar":20460,"commerce":9380,"bahá'í":23107,"muskoka":21028,"anyones":20331,"polymorphisms":32019,"lump":13336,"fcuking":36016,"derived":3575,"jfd":24156,"bach":13531,"worshippers":29319,"convened":39999,"subscribers":16494,"heck":4054,"brothels":40750,"oxide":20081,"contractual":23516,"conceptualization":29604,"solvents":35138,"jaakobou":39174,"emacs":39671,"nectar":27948,"antigua":30135,"ingres":31858,"younger":4922,"sluggish":33914,"georg":13400,"tariff":25569,"9's":42995,"donny":22214,"toured":16214,"sweeping":9972,"guides":6377,"recovering":28220,"buri":32174,"panadura":24607,"faked":14752,"“i":9603,"dmsg":37457,"wikipedos":32334,"criticise":8336,"organisational":34687,"dissolve":23206,"wikipediatrix":28327,"bombardier":25748,"haaretz":12299,"misjudged":37064,"homer's":30080,"valmiki":14140,"cassie":41261,"clam":33657,"drawback":36759,"wellness":39946,"miquonranger03":43412,"wii":7280,"glitches":28008,"rjwilmsi":48268,"shrines":20131,"contibution":43171,"masood":45483,"roy's":35850,"step":1363,"equilibrium":10796,"vellalars":38556,"editting":6959,"kazak":49576,"reachable":37897,"stitch":34246,"guardian":4182,"unmitigated":34148,"mentor":6849,"limbaugh's":33335,"embraces":40212,"limitations":9165,"fill":1841,"mega":7383,"sich":23272,"original":290,"homogeneous":18805,"anglicanism":27057,"shrewsbury":39035,"indicated":3204,"webiste":42444,"methodical":48792,"assholes":6064,"effin":30703,"rains":27245,"giggs":43193,"rudzevecuis":36095,"ideal":4291,"insistence":7372,"annually":18537,"serie":25295,"countless":4239,"money":1138,"compartment":42137,"chieftain":21927,"a":5,"miami":7072,"orwell's":29469,"tancred":20130,"brigade":6659,"declensions":49204,"echr":11111,"apologist":10386,"pool":5828,"｡◕‿◕｡":18599,"e0f0":32580,"uhura":30646,"iranians":5538,"dxc6":48443,"jw":10324,"wid":22102,"blueboar":32848,"ineffective":13181,"ln":25829,"springfield's":39579,"narratives":23496,"snipes":36994,"twisted":6356,"lodged":16516,"mastic":24737,"sinner":26868,"racepacket":24053,"isfahan":27443,"aleem's":33354,"jag":37667,"bab":37483,"ossetian":42093,"unkown":37401,"queue":9111,"hindenburg":34339,"rebalancing":39741,"fortunate":17169,"critics'":27327,"yells":47004,"wilhelmina":41143,"tailoring":35051,"diacritic":16637,"bradford":13981,"acclaim":17578,"wayamba":44732,"oxfordian":40318,"gyan":43306,"economists":10765,"ungrammatical":22074,"ya'll":18693,"fei":47502,"netscott":40119,"rebels":7607,"langage":45739,"commies":16335,"straws":16642,"n00b":11287,"overwhelm":20647,"rectify":9226,"chemisty":41520,"cremation":29515,"ara":28931,"scheduled":6343,"maveric149":30957,"thanking":11821,"uruguay":10579,"consultants":28954,"parallels":11294,"uppsala":36165,"caucasus":10966,"mysoginist":47777,"prioryman":34271,"redvers":17302,"sophie":11385,"dabble":47458,"isabel":25342,"computing":7159,"bonadea":28407,"wales's":31482,"cleaners":40150,"alright":2949,"quackwatch":12769,"lphant":16466,"derbyshire":21425,"reversible":38064,"s":358,"academy's":42629,"fag":1102,"overland":48787,"afgan":44444,"masala":47797,"l":1641,"tariq":25397,"newman's":30983,"sfgate":48065,"seventh":10409,"finnished":48575,"justifies":9068,"wpf1":42107,"inappropriately":8930,"hagiographic":41101,"moroccans":36407,"warthogdemon":24032,"rainer":43403,"classmates":29296,"abetted":44682,"stack":7412,"branches":6578,"talk→  ←track":14919,"activision":39952,"garratts":44798,"fla":49069,"holy":2607,"glitch":11974,"browsed":33928,"nominator":5962,"meena":43190,"semicolons":38770,"wavefunction":43539,"albino":22932,"blockbuster":25698,"noticed":633,"relationship":1979,"spring":3994,"daisy":20945,"elsa":45585,"jezz":29804,"resurrection":10435,"roxy":47776,"gunshot":35693,"yahya":27020,"surinder":49596,"factuality":33035,"erivan":37860,"grassy":48485,"atoms":15658,"counterproductive":11379,"feasibility":29278,"east718":28741,"demoted":18686,"terrier":19152,"dailymail":28413,"escalation":13517,"equivalent":2882,"suspicious":4780,"insertion":7200,"connolley's":29819,"replacements":25629,"customer":8071,"distortions":12317,"assad's":15237,"irri":38506,"impersonating":13151,"guidelines":393,"brides":31019,"jitsu":20568,"unintentional":12612,"penalized":22425,"mishae":47505,"dweeb":37283,"declared":3199,"ratifying":49891,"dull":12365,"throttle":46745,"complications":18425,"generator":11550,"deputies":21470,"wife's":15374,"newspapers":2769,"littered":15937,"electrolyte":26117,"interrupt":17546,"muddling":46407,"watchdogs":28946,"transcription":12066,"higgs":36130,"encountered":5295,"dvr":38730,"custodial":47500,"diametrically":31427,"flashes":45906,"ru's":47432,"calcium":23349,"arbitrate":31990,"not''":40519,"400px":44976,"nin":42206,"donovan":24927,"zia":42128,"invoke":12236,"beaked":31267,"passport":7670,"burhanuddin":27367,"doggie":42072,"unreasonably":17208,"ntc":43280,"operatives":23485,"outstanding":6823,"prevention":10068,"prefered":21184,"meenas":31725,"nonexistant":39878,"jackofoz":31528,"hhvm":24381,"cook":7794,"preaches":45108,"lockerbie":34656,"prp":43776,"distinguished":7102,"misread":8310,"tanjore":43884,"goddessy":32620,"shrinking":20011,"livelihood":26580,"spats":39587,"а":34867,"christaphobic":30820,"dueling":29586,"milano":26137,"singing":5994,"multiplication":16515,"uniformed":26832,"respectable":6040,"rememberance":36355,"imputing":39568,"katz":22387,"hoot":25663,"★★★★":16237,"insider":11276,"morton":14896,"guangdong":22492,"axed":43800,"zillions":29214,"maoririder":43541,"milestone":16770,"bodyguard":36329,"bht":46325,"ridicule":12992,"gnaa":13003,"sex":834,"cozy":18387,"elwood’s":19420,"ticks":32392,"iirc":8618,"theists":33177,"cactus":31728,"rlz":35933,"oscars":36755,"best's":44162,"gaba":32481,"fermionic":38870,"chem":15510,"difficulty":4529,"spartan":20444,"pipes":14648,"update":1400,"jerky":27637,"jubilee":24226,"honolulu":27993,"cryonics":49636,"catastrophe":14603,"holmia":34818,"antecedents":35742,"manage":4769,"quacks":30966,"poured":20312,"addiction":7828,"fishing":10328,"euphemistic":23476,"doppelganger":28582,"unhappy":6887,"fetus":14076,"catholics":5002,"imperious":28655,"puppetry":3046,"eadric":34216,"willfully":13332,"pathan":24648,"indecisive":33812,"sg":12490,"hnpcc":37018,"gracious":13603,"shifts":14230,"rui":34017,"beheadings":40757,"catan":41051,"hatch":24913,"avoidable":35115,"☆":43287,"taxa":20467,"uyghurs":19817,"fetchcomms":43767,"promise":2589,"gotha":23461,"peregrine":28805,"companies":1422,"evangelical":8724,"nits":43133,"gabe":30780,"yous":30518,"accross":16881,"vibrant":32056,"mithraism":42086,"goroshi":34348,"mythologies":36678,"related":458,"carrot":23820,"marshall's":47990,"jack's":21619,"undergarment":42410,"bestfrozen":8064,"hullaballoo":25439,"separated":5564,"mongers":28619,"subsidized":26786,"aa":7941,"keywords":16333,"eire":33786,"golly":27155,"moriori":41954,"flagships":36606,"ennis":24783,"country":551,"nonmuslims":36089,"somaliland":10179,"burglar":49137,"censors":9196,"pvo":42089,"planners":32152,"clade":20530,"banned":657,"dion":21744,"colombia":11345,"fixture":23336,"fred":3528,"genus":6555,"pietruczuk":43795,"sothis":37025,"conceited":23710,"david873":32226,"generated":4810,"drove":9612,"forgotten":3863,"cyclone":9012,"resolving":5852,"how'd":22332,"cumming":41318,"gibbons":26547,"bonkers":36945,"stills":32984,"sucksfrozen":18124,"refferences":49241,"'new":19885,"spadework":48796,"adament":42882,"gujrat":34757,"bcs":16471,"jealous":6967,"commonality":22756,"inferno":21001,"insensitivity":42352,"suits":7096,"gramatical":31720,"chained":35875,"bb's":44828,"terhune":43908,"signatories":25272,"strips":24847,"ummm":14927,"teenage":9564,"bewteen":45148,"t3":16443,"vertically":23691,"withdrawn":7659,"pick":2264,"achievement":7029,"gfaj":41592,"decalogue":33780,"jeanne":12386,"fig":17059,"vedique":34801,"popup":21668,"paso":37061,"uses":951,"pitches":42545,"fossil":8380,"furtherance":35362,"backers":39145,"proposes":14886,"level":816,"dunphy":48757,"redlinking":39350,"nuggets":30562,"request":318,"wretch":30883,"github":14082,"locales":45210,"toast":16324,"cccccc":6495,"“chris":32428,"liquidity":41076,"robbie":15406,"amplitude":37758,"cypriot":12874,"'real":47165,"dig":4309,"refrigerator":48052,"ff":12690,"dwm":45140,"tin":9088,"freud's":21436,"erratic":24305,"listeners":15955,"rhinoceros":48701,"''talkstalk''":13403,"polluted":25224,"thermometer":25108,"eläkeläiset":31693,"witch":5975,"infringements":17708,"budweiser":38921,"fags":8981,"undeniably":17182,"brion":20203,"yin":21309,"kates":43785,"arthur":4368,"blok":36604,"wmv":27759,"unmarried":22833,"silvestris":26688,"inquisitions":38012,"improve":738,"urantia":9194,"fcb":27859,"licences":26421,"coments":29641,"mochi":49553,"— preceding":6639,"longterm":31139,"seeker":27695,"furore":41222,"canute":47146,"odometer":49399,"precede":28999,"awoke":29981,"keats":42380,"politely":5352,"falsly":24684,"entanglement":26710,"propol":17732,"attributable":20048,"protest":4198,"easterns":49974,"widow":16784,"complexity":7095,"pesticide":34511,"zarove":28066,"threw":8615,"niceties":41133,"revolutionaries":22734,"lobbyists":26963,"stubborn":6482,"franchises":17957,"yfa":40446,"defeats":14402,"gross":3741,"manchuria":26706,"recess":40271,"sageworks":47660,"captained":41934,"dup":39344,"fuckedy":45763,"talkback":4790,"staged":15862,"properly":1132,"iguana":40303,"bowles":42954,"saju":49973,"evaluate":7009,"inflame":23633,"excercises":44131,"somerset":12457,"opposers":22177,"—←t":36988,"prostitution":8167,"enwp":23994,"1st":2467,"judicial":6914,"basij":46577,"municipality":6619,"—innotata":47628,"pg":3042,"deafness":36835,"→  ₪ ":16499,"optimized":41167,"hilda":41371,"dynamo":22498,"gibraltar":6964,"stub":1368,"withdrawal":9855,"brains":6810,"pigs":7868,"ascribes":34456,"heretics":27508,"linder":30039,"revolts":28427,"kathleen":21120,"basses":29877,"okey":32506,"dev920":28017,"scooby":27469,"phineas":36571,"leno":16023,"prettier":30741,"act":836,"culminating":29482,"sauber":47904,"adopt":4776,"fergie":40878,"js":8418,"tender":9864,"constitute":3365,"penetrated":23530,"bathtub":40601,"wreak":21483,"kludged":48794,"salut":34115,"genome":10705,"honors":10790,"tucky":41168,"mensa":29321,"aryans":12084,"stacked":16636,"land":1546,"helter":25674,"surfacing":45948,"dre":28948,"acmeman":34683,"foie":27323,"why's":30728,"afd's":16829,"pitbull":21933,"prehistory":28970,"unhcr":40279,"profitability":37098,"cip":34821,"strait":12080,"saint":3816,"burns":10392,"deadlines":26109,"morris":7750,"closely":2400,"barrage":17121,"philanthropy":21499,"leonard":11804,"cling":21019,"kibbutz":49633,"gaze":35752,"bollocks":2507,"population":1054,"conservationist":39793,"baronet":21390,"zagano":43338,"planets":7512,"dildo":10339,"tangential":9223,"overflowing":48726,"halt":13876,"iid":49068,"zaphod":49222,"mileage":24493,"oesau":44837,"tourette":30659,"denounce":15808,"editorials":14607,"caprice":31519,"aiming":10821,"awarded":4690,"haliburton":33897,"devadasis":40068,"ascot":46543,"shrink":14549,"grade":3709,"moles":37247,"retailers":28658,"weald":43291,"gta":13577,"ign":9238,"browsers":11417,"pederasty":17873,"miss":2469,"turabian":39709,"injected":24515,"adjudicated":33975,"misgivings":28900,"見学":15206,"fascia":45000,"relentless":13155,"reject":4144,"fast":2357,"tyrant":11366,"premises":12884,"groundhog":42371,"magazine's":20236,"ashermadan":48702,"granholm":29889,"urine":13098,"takes":1018,"include":449,"moshe":15288,"donno":43253,"ettlinger":45261,"bbb23":5267,"breivik":49745,"numbskull":41979,"hindustan":19238,"injects":48475,"ʕ":31924,"asher":19267,"rode":16830,"nico":33466,"nie":48070,"latter's":33301,"defects":22064,"tanakh":12388,"hitler's":9397,"risible":37114,"bafta":46189,"ssba":33940,"phoenician":26668,"dealer":14018,"packets":25187,"infected":11032,"recension":34617,"fondness":42827,"bainuu":23357,"excitation":48830,"khamis":33616,"smita":40594,"300k":39621,"carey":8926,"magiranger":38958,"thate":32687,"ethnics":26019,"ain":24479,"solihull":49611,"pune":22310,"ownership":2902,"postal":8110,"bons":16833,"governors":14000,"bearly":45523,"mobster":33647,"surreptitiously":37576,"enforce":4257,"gnan":25516,"retreated":23018,"aborigine":30515,"disagree":761,"illuminate":22419,"brewer":27627,"particular":647,"afghan":7185,"simpsons":7031,"abbot":37804,"mechanic":26289,"fantastically":41921,"lindsey":27071,"instigation":30160,"lil'":20174,"instated":22550,"clever":5844,"wants":1059,"photography":5874,"savage":8839,"diagnosis":8612,"shushi":30356,"ageing":46857,"redirections":40012,"frequenting":44713,"usg":34425,"combs":15517,"pythagoras":38025,"arthritis":36866,"pilot's":40666,"amoeba":48981,"todays":14467,"'cool":47536,"predetermined":39845,"sasuke":18288,"gratia":39873,"coercive":39185,"whose":1371,"basotho":45907,"lemma":28279,"ionic":48733,"planet's":27450,"reclassify":40546,"xasha":45197,"bullet":5305,"dress":5747,"judaica":39431,"information":102,"fussing":42295,"omg":5213,"russ":21411,"abbreviation":9114,"sickens":28374,"fringe":2069,"importantly":3921,"thatcher's":37156,"'what":14708,"braxton":46637,"outs":13299,"peremptory":20617,"stereotypical":17355,"travilla":38750,"haven":11089,"dispensed":49089,"gastrointestinal":31480,"reptilian":35192,"wuhan":29371,"thehindu":34079,"cfm":11220,"enthusiasm":10909,"romanizations":20571,"nummersechs":45951,"anterior":38319,"creature":6599,"circumstantial":19939,"questionable":2908,"manitoba":18925,"sigma":10159,"twinkle":6549,"powers":2165,"nests":34407,"singahi":49510,"voci":34515,"ockham's":40527,"appologies":31974,"trailing":30265,"doin":16633,"sporting":9454,"roscelese":25324,"awake":17252,"segura":49084,"emitted":24286,"tangent":14211,"trmk":32922,"dipped":29980,"historians":2099,"sonoma":39529,"aggressive":3487,"financed":20301,"32k":45799,"sited":22181,"aragon":17131,"brokered":25471,"unrepresentative":34330,"compliant":7959,"webs":19763,"you’d":41211,"twinning":46898,"processes":4320,"aberrations":40390,"frustrations":17092,"disclosing":27203,"walk":3637,"shenanigans":15891,"parris":32686,"sexuality":5574,"copywright":41513,"2px":15742,"oriental":11705,"bullies":7367,"assumed":2707,"persistently":7903,"cakes":28614,"packing":16912,"one":48,"observes":25547,"subscriber":32689,"amphipolis":37184,"fines":26284,"beatty":31836,"diane":13717,"democrats":5783,"liturgical":25637,"youself":25183,"dere":49058,"fucksex":1700,"fiba":43519,"taipei":14548,"ward's":38944,"fra":29481,"✽":17908,"porno":24628,"view'":37849,"imposed":5232,"sforza's":48591,"wineland":43526,"yeti":25090,"herd":12363,"wot":15900,"psychoanalytic":35458,"pseudonymous":44587,"existentialism":47861,"j4j":29414,"legion":8206,"hosur":44530,"courtney":18813,"unaware":4637,"geek":7544,"transsexuality":41247,"requirements":2847,"alias":7715,"manned":24773,"osa":32942,"innovating":46677,"instrumentation":25533,"wpsc":49535,"conflates":38284,"zune":33352,"kingship":39254,"“so":32338,"foothold":45909,"terrorist":2063,"ordered":4037,"zawahiri":45832,"bloodofox":38913,"negotiate":10988,"misconstrued":16658,"routers":46877,"gravel":28735,"eddy":13711,"muffin":33658,"sequential":33864,"zis":25087,"“anti":45490,"waldo":45612,"laymen":26364,"upward":24934,"overzealous":11774,"onions":33711,"humble":6470,"qjhl":29401,"sahitya":39606,"remarkable":6536,"deus":35531,"aggrandizing'":47597,"safari":14242,"floor":4201,"delude":33373,"unprotecting":28071,"cornix":36377,"dusk":42469,"inscribed":26007,"oren":43843,"pepo":45480,"faggit":24807,"impoverished":25139,"directed":2405,"ddp":30615,"misinterpreting":13382,"transclusionless":34272,"coaching":9854,"flare":19233,"1r":10470,"cca":34098,"capacities":21379,"transfers":13366,"assistant":6941,"citizens":3092,"derbent":49519,"krajina":25163,"gymnasium":46923,"memory":2710,"collaborating":13176,"burritos":18796,"surreptitious":49441,"mrivera25":21793,"tension":8041,"copies":3696,"billed":19139,"slam":9631,"—no":45563,"harrasing":13431,"victories":14118,"advance":2118,"gamespot's":42560,"atf":38772,"said's":48698,"funds":6661,"broader":5156,"tout":29213,"confidential":13018,"pitty":43511,"comprehensible":15310,"supressing":16659,"creeks":36658,"munsell":34353,"propoganda":12847,"jayjg's":20766,"excuses":5709,"presided":30008,"blasting":29857,"suri":33654,"mav":20137,"aready":44328,"refresher":35136,"000kg":43522,"brandt":15666,"dea":18653,"lesion":43895,"songcover":45847,"cencoring":45609,"conservativism":38910,"disscusion":22993,"crick":44959,"incorporates":19123,"corvoe":45654,"'sea":48878,"basic":1206,"vols":35172,"iraq's":23864,"tics":43429,"wilcox":28369,"belarus":13521,"dawoodi":19438,"rida":30806,"for":12,"industrial":5246,"lygophile":19985,"boundary":7241,"avenues":15141,"modifier":16694,"nid":25996,"ybm":7233,"that´s":15202,"tribesmen":38282,"think's":45658,"internationale":43891,"whitmore":16911,"h2":23701,"site":293,"tuned":12375,"subregions":44767,"isolate":14191,"prc's":36361,"teri":37395,"fedora":27835,"ante":12483,"saxifrage":40808,"perfectionist":40497,"pending":3176,"clinton's":16974,"sarawak":24018,"nothin'":33906,"development":1558,"dung":20811,"depression":5648,"someway":33243,"uther":42909,"innappropriate":38618,"yorker":10698,"napa":30580,"divinity":15212,"waward":12743,"who've":11004,"diesels":26865,"confusions":20237,"violently":14185,"ancillary":29186,"lightsaber":42340,"atomic":8007,"banovina":29717,"fortnight":19816,"viacom":30987,"taft":26915,"jailed":18562,"shouts":46613,"deduction":15800,"porting":33507,"headless":13416,"dtv":49663,"dominates":19953,"precision123":46299,"vadalism":47807,"minecraft":28271,"philips":17842,"physician":9307,"controversially":29518,"nwsource":45198,"sealing":42644,"bhutan":18912,"mystical":15707,"police":1298,"whitehead":17061,"heaviside":36987,"beyonce's":34593,"4d":46068,"metamodeling":46534,"vida":45084,"pasta":35064,"debased":40911,"battles":5209,"superpower":8300,"entrusted":15466,"alphonse":40627,"sunlight":12952,"mich":19645,"edit's":36311,"feedbacks":41636,"deobandi":27887,"asian":2320,"algae":20145,"gays":7175,"himself":812,"bastards":7614,"maharaji":26458,"1₭":22822,"catalogues":29811,"deutsch's":31685,"quirks":44642,"gander":15753,"republished":29168,"nambuthiris":38855,"“by":42058,"spinoffs":28725,"showdown":26359,"superset":35744,"zhi":22565,"iberian":12560,"voyer":14753,"lawful":15297,"announced":3382,"i'ma":48381,"ao":23649,"terming":47214,"nipples":26368,"fyi":2784,"rapped":42351,"5m":31583,"pharmaceutical":13787,"planes":8311,"tattooed":45100,"usernames":6133,"saddo":29885,"mathematician":9187,"typo":4697,"daydream":49031,"parry":32135,"eats":4936,"pam":32938,"worthiness":21253,"ashoka":18557,"restructured":22254,"pediatric":29069,"bland":15254,"childofmidnight":43257,"louder":17573,"chloe":40937,"vocalization":49867,"quadell":28418,"tribune":12001,"napier":25107,"kane":10547,"convolution":11647,"prissy":35131,"who's":2598,"obedient":30643,"numerous":1484,"message":349,"scratches":17677,"romanization":10584,"shusha":27976,"monikers":33291,"althought":45096,"equatorial":28486,"xenomorph":48390,"gameguide":32006,"blackwood":27816,"dayz":38989,"occultism":29147,"contextualize":36808,"guilds":37412,"sunset":16226,"clinicians":30784,"embellishment":49315,"browse":8402,"commanders":11256,"running":1596,"homologous":31787,"tco":36370,"pleaze":40962,"bitterness":39904,"ardenhathaway":48083,"paulie":42768,"couriano":9014,"macbook":48319,"indifference":20435,"pinko":42031,"falsifiability":11800,"ypur":34254,"tyne":32827,"sheets":14437,"canberra":18338,"buffon":41204,"mmorpg":27611,"sieges":49803,"supporters":2940,"overruled":20961,"jerked":39338,"mentally":5614,"dave1185":11261,"pumping":21702,"holier":17396,"grocery":25068,"seat":5601,"huck":39604,"differences":2190,"marmaduke":18957,"'human":45071,"shropshire":41555,"tamilakam":39760,"ygm":42218,"today":617,"josiah":19366,"weasels":29544,"sussex":15996,"wu":11315,"caper":47481,"sons":5878,"fao":18777,"blew":10971,"poved":28458,"melkonian":38677,"vlah's":37362,"gillies":49728,"clauses":15400,"evoked":31352,"wyoming":18911,"neiln's":27410,"enin478in478":49357,"sum":4133,"analysis":1768,"omnipotence":25131,"generalisation":22359,"acquisitions":42248,"stormfront":16357,"forget":1679,"lawsuit":5253,"capriles":24184,"zip":14630,"feminist":6747,"originator":13478,"consenus":19803,"unrest":15688,"ovens":28887,"jeffro77's":22755,"totalitarian":7423,"redwood":32711,"settlement":5525,"lakhs":49890,"betsy":28688,"dux":13209,"wacky":23047,"tillman":39438,"auburn":26195,"jazeera":20619,"pale":10000,"pajama":41774,"interaction":4270,"–  ":23490,"α":14512,"mcewan":14789," — llywelynii":33600,"sandhu":43360,"architecture":4115,"destructobot":49285,"nasals":44313,"unread":49737,"mishmash":34000,"integral":6248,"instruct":15157,"hilbert":28901,"karate's":34042,"stjepan":33697,"mathematics":4536,"rockers":31967,"doe":10771,"γ":29454,"bigots":10696,"itu":33699,"seperation":20417,"sto":18066,"scholarly":2610,"relevancy":19078,"laughter":14635,"ova":21513,"kids":2355,"kingdom's":47369,"seaworld":37575,"syrian":5458,"waverly":34205,"unitary":18444,"detained":26166,"caves":17243,"tinchy":17871,"misconstrue":39612,"lerner's":47225,"ss":4520,"sodomites":35760,"cking":9987,"unicode":9181,"cardinality":27519,"immunity":15587,"alley":14882,"whisperer":24335,"rachelle":44518,"overthrown":31204,"verfied":35180,"oli":14837,"sdsu":47576,"lojban":31408,"annenberg":36830,"reporters":9452,"thérèse":31817,"beach":5048,"warman":43896,"remaining":3207,"ofstead":48788,"monarchism":45796,"kolhapur":41105,"interstellar":30962,"zamia":43845,"sofixit":27721,"demolish":31534,"singular":6518,"acurate":44923,"seaforth":38387,"venn":37638,"loss":2668,"afd":858,"emitting":29960,"wali":44759,"hwang":41482,"johnbod":30523,"bayern":13880,"lawrence":6992,"mate1":19636,"dênis":31782,"dunes":35730,"sardar":26409,"crazier":36715,"gentlemen":10293,"anythign":38651,"hasmonean":39507,"lou":11673,"defames":39258,"hvala":46882,"lubrication":36064,"amounting":27023,"turkey's":16349,"undue":2242,"misr":14129,"gadfium":19131,"warrior":5976,"strings":6892,"tamara":35426,"sits":9795,"podiatrists":40624,"luo":32678,"sync":17973,"4chan":8907,"mosdab":29584,"vesa":48740,"lord":1984,"brits":14202,"accolade":26620,"amenable":25126,"sumple":33788,"howitzers":31743,"kamath":38501,"vlah":33215,"bjcp":36871,"thousands":1798,"truer":37541,"shiv":14270,"rgle":47865,"sylheti":37645,"accords":26208,"silas":23041,"werent":19928,"schuster":35305,"congratulated":27426,"transactions":23504,"austrian":7042,"returns":5103,"settler":24209,"parted":28477,"boats":14447,"fiscal":18513,"ramble":28284,"denelson83":45459,"militar":25725,"dungeon":19884,"islanders":25351,"lofton":29929,"ignited":37001,"talk··advise":33379,"anglophile":43516,"priesthood":14546,"forever":2159,"succinctly":17690,"liquid":8606,"declares":12358,"deficiencies":18628,"happily":7115,"taprobanus":49771,"kalpas":33531,"neisse":41737,"fanboyish":47076,"lurk":26738,"former":1109,"house":1003,"relic":23914,"boat":5866,"wlu":15095,"luke":6393,"urinate":28833,"skyline":11941,"deepen":39379,"amd64":25920,"nee":23486,"clerical":25312,"brag":16695,"paulson":27325,"haskell":38135,"protrayed":45601,"clawed":46706,"stringed":21392,"ashes":17618,"fences":25936,"glitter":24033,"adobe":15041,"covers":2639,"dumpling":46136,"strawberries":35673,"ruiz":41906,"jsp":14976,"lubbock":43584,"directional":26552,"javanese":17166,"patrick":5907,"workings":13560,"attributed":3255,"sory":33430,"following":423,"npv":23165,"begot":44402,"brown's":16626,"ford's":32371,"regal":26621,"entourage":22806,"alloy":18111,"rpgs":49239,"latinized":27809,"palmer's":24133,"focused":3215,"😉":20212,"editorship":24705,"dryas":31956,"polyurethane":26925,"schutz":44975,"theorems":30715,"chin":12747,"yippee":47900,"feared":12408,"feburary":49601,"standup":44469,"fudged":37372,"cooley":34235,"donor":13861,"zoroastrian":20481,"ik":21850,"savings":18481,"existe":37640,"farmer”":48570,"comforting":26326,"crippled":27110,"unabridged":19716,"possesses":17666,"popcorn":26188,"hasn't":1887,"matrilineal":24395,"oner":42775,"sailing":15386,"'40s":45726,"baseball":3494,"aimulti":49205,"pp":4100,"dix":39585,"tulu":14422,"rhapsody":30968,"tldr":30619,"heared":42080,"müderris":43468,"vaccine":8315,"babies":7917,"hendricks":35800,"sixstring1965the":30417,"virtuous":35148,"'90s":40370,"hessen":39031,"talk✉":16751,"jazz":6185,"newt":22878,"attractor":46423,"tellin'":44757,"martijn":46766,"ows":42225,"bling":41963,"dalits":18437,"specialises":41733,"fodder":27422,"hajj":49844,"surowiecki":47652,"bonobo3d":45440,"'new'":23191,"information's":39893,"foxes":36578,"credit":1917,"michaels":13931,"army":1277,"hitching":22305,"arma":31715,"stocks":15382,"alfredo":48419,"whcih":40064,"♠♥♦♣":38949,"professionalization":34432,"suck":403,"pebbles":28108,"  emperor ":20042,"cone":19315,"intimidation":10012,"definitely":1158,"ting":33296,"listas":6100,"fiddling":22110,"sutherland":32788,"gossip":5371,"stagflation":45074,"thrashing":41343,"mind":488,"ubiquitous":22603,"'my'":39247,"anittas":36587,"throught":29477,"diem":30712,"post's":44493,"fraction":9118,"ft":6112,"plaster":20655,"longwinded":39402,"corroborates":49746,"trusty":47996,"ballistic":17865,"oswald's":34183,"articles'''":28701,"blvd":25728,"groove":15249,"dork":14692,"backup":9522,"feigned":43688,"angelo":26373,"vaishnavite":48727,"evidential":48007,"m's":41428,"nonfreeimageremoved":30057,"fanatical":17199,"huns":11304,"otherstuffexists":23587,"homey":38356,"kagyed":45049,"manuscript":13438,"nichols":22366,"relevance":2923,"northwestern":14531,"twat":4616,"unworthy":10935,"menzies":23572,"adolescents":20633,"insert":1362,"shockingly":34519,"rhus":31898,"assure":3742,"no":46,"pvt":37750,"netanyahu":48571,"appliance":45260,"novi":19657,"enought":28773,"marketers":27260,"у":44295,"anteire":29488,"jhelum":44166,"pearls":23756,"rsad":26733,"instrumental":12119,"trouton":47877,"disgraceful":14650,"bodom":39771,"park's":30512,"osmond":19451,"options":3377,"year":411,"circulating":16606,"inuit":28629,"expertise":3566,"begins":4365,"ignorance":2444,"nd":8472,"57th":45425,"backed":3300,"not":14,"aqua":24760,"err":8630,"'good":15538,"licence":5696,"puthoff":36783,"anthem":9036,"true":377,"robber":24498,"arouse":26445,"bloomberg":16826,"barbarians":16159,"spoofing":39146,"rationals":43815,"nintendo":6371,"bark":1125,"derby":10369,"holes":6929,"songwriter":13748,"hanger":43759,"ψ":19480,"obstructionist":35389,"durga":49549,"bystander":37968,"aesthetically":19068,"invalidating":39833,"staked":35455,"heritage":3168,"gratuitously":18438,"exchanged":18536,"primer":46274,"suffices":25863,"dáil":25692,"vassal":16156,"berwick":45201,"rationality":20816,"comical":14286,"secularism":16990,"volatile":17068,"administration":2738,"organs":12707,"urination":32396,"tits":12797,"funnier":32982,"somwhere":43015,"valuable":2687,"anarchy":10759,"generators":21550,"logic":1586,"eon":26757,"phun":40224,"royalties":20890,"wood's":38911,"reunited":31200,"pittsburgh":9874,"modified":3398,"squeakbox's":25639,"captains":17215,"tellyaddict":33036,"wikip":13547,"earth’s":40273,"prescott":20118,"scholars'":20509,"measurable":20475,"voelker":31141,"economist":7968,"rushes":30284,"emerald":28321,"hate":382,"toleration":45294,"faraday":36986,"braves":31056,"tough":4019,"qu'ran":37574,"gatoclass":43139,"normally":2208,"mcneil":41397,"thee":8190,"punic":20492,"skinner":25431,"wikipeadia":48473,"scholary":22044,"copeland":26196,"scientist":3618,"staggering":21569,"confession":11250,"outlawed":23913,"blondie":38782,"tales":7762,"maria":7126,"kirill":24075,"cables":12012,"sarbajit":41331,"dipole":29152,"statehood":16582,"fade":21142,"27s":11938,"slaughtered":10275,"templar":17594,"irrigation":15503,"pertains":11685,"outbursts":27907,"metaphysics":12843,"therein":8277,"financially":12002,"leave":285,"wolff":21453,"dadrian":14838,"blocks":1663,"murderers":10090,"boost":11471,"aberforth":41290,"benoit":13572,"mmr":31933,"pit":7975,"periodicals":15281,"seaman":32673,"subliminal":30048,"peddle":31978,"roar":30520,"embark":40703,"hasidim":45792,"kiand":37949,"vocalist":16130,"— z":47465,"airspeed":32269,"faeces":40006,"thirds":14949,"starters":8780,"ecyclopedia":44582,"bastered":2196,"soundness":31767,"through":325,"dualism":34541,"meatspin":9657,"states":381,"disparate":12687,"lizard":18428,"netscape":28518,"friendly":2052,"navel":24818,"capt":27954,"rhythmic":35425,"beards":25252,"pyongyang":25188,"cliffc":44824,"stresses":21399,"rcs":40563,"mixing":6780,"undoubtedly":7053,"doctorates":27779,"hovind":29728,"orton":9860,"genetics":6021,"clive":21769,"oxygen":7839,"transgressions":19471,"dearth":23424,"reforma":48224,"iss246":20059,"drinkers":41275,"pallava":38804,"accomplice":25683,"impulsive":23903,"xii":20704,"slick":10590,"ambitions":16863,"exponentially":23632,"naima":38372,"pledgesalute":31801,"bellow":31684,"wizard":2759,"athens":10662,"xix":35656,"cough":12790,"nop":16005,"thorpe":30618,"jhtml":34269,"her":186,"essence":5561,"glatorian":37161,"internets":18283,"'most'":40707,"stereochemistry":47480,"dobson":31357,"morgause":38554,"mother's":5173,"benson":19857,"baring":36477,"honeybee":46850,"stopdroproll":49278,"disengage":16234,"stalin's":12491,"contrasting":19585,"detest":16178,"hyphenated":15695,"psychosexual":39657,"synchronised":48628,"të":41308,"announces":16632,"delight":15850,"infanticide":42782,"screened":25067,"aberration":34626,"icons":6956,"fiasco":15088,"invoking":15822,"electrical":8205,"detached":20035,"shefman":43385,"package":10855,"consonant":14935,"chore":27988,"evoke":40406,"remover":32483,"fark":31968,"athena":24643,"salient":13606,"trolls":3275,"city´s":39449,"wdw":42016,"alluding":25865,"hew":49702,"cars":4465,"wayang":24371,"acually":47726,"seams":20821,"hype":9597,"800x600":36637,"necked":24463,"laughton":29089,"manila":18841,"explosions":20699,"wkipedia":30017,"tooth":9945,"wolfowitz":9726,"wig":25141,"hot":2434,"serebii":41257,"bead":43657,"weinberg":39617,"members":750,"deadlocked":42067,"'don't":29193,"divisive":21527,"ingrained":28204,"unheard":18302,"gyllenhaal":36288,"interacted":14698,"cumulative":21821,"hnmcs":40314,"“neutral”":21401,"tinky":45890,"thinkin":44547,"occupying":13425,"wittgenstein's":34713,"grossing":18263,"hence":1551,"pensioners":42405,"incorporate":5289,"discard":18260,"apollo":7657,"payloads":34856,"rspw":40711,"awakening":23176,"alaeddin":48920,"landfall":28373,"louisiana":8273,"allot":23918,"purely":2968,"lent":24882,"hürriyet":17467,"djgolardo":42866,"paint":5989,"calloway":42133,"anymore":1290,"wolter":42406,"dreamworks":28141,"shareholders":21308,"patriarchal":25018,"shiite":19900,"randomrd":38600,"gainesville":26640,"mot":24885,"crest":10329,"failure":2567,"oo":21413,"amendments":11775,"eco":17180,"photocopy":41633,"bros":9065,"hellbent":26283,"certainly":546,"winona":25601,"williams's":35071,"thursday's":48472,"heqwm":24163,"bout":6699,"prejudices":11776,"distorting":10314,"sanctioned":5478,"scent":23559,"reddit":12171,"scenarios":14800,"mars":6601,"abby":36950,"county":1483,"usaf":23792,"inventory":16392,"serotonin":23622,"untouched":20487,"neutered":25402,"¡digame":24612,"gibson's":24047,"nancy":6560,"rovás":43034,"dysfunctional":13091,"manifested":22390,"''''''''''":7143,"baen":35076,"xvii":32651,"popularization":37545,"academe":44366,"wonderful":3603,"station's":21978,"pub":9780,"yay":8420,"beatrice":28786,"cheerleader":28293,"cheng":15940,"lavigne":22557,"thingy":10949,"badmouthing":45279,"rep":8791,"accreditation":10766,"alkaline":21979,"suckin'":40040,"comparative":9758,"narcotics":30970,"bronchitis":40995,"claims":518,"linkages":33236,"newcastle":11291,"remembered":7571,"emile":30497,"lingo":18890,"audio":3086,"crypt":32513,"anne":6595,"justine's":39697,"sinh":39727,"segregation":13990,"bihari":27959,"complicate":26428,"overridden":45522,"interject":26662,"metalcore":9011,"claiming":1382,"oblivious":22303,"puppies":10986,"'gold":49272,"ms":2797,"takeoff":27098,"faculties":24420,"wilbur":34676,"hedonism":28212,"utopia":32012,"sant":27927,"escapeorbit":32835,"rigorously":24730,"allright":26650,"neocons":40220,"wampanoag":38871,"biomass":20147,"pons":35490,"cameron":9608,"you'll":884,"malaria":14790,"choudhery":20233,"cma":25612,"credibility":2647,"naieve":45034,"replicated":16657,"govenment":37316,"realistically":17543,"core":2624,"nelly":20733,"ima":16822,"codf1977":22554,"kami":43652,"earlier":968,"absorb":18299,"aniane":45949,"yonkers":46648,"bernd":44986,"bryde's":45249,"grumbling":36581,"demean":18022,"idiots":2802,"5p":19019,"cherish":29130,"patting":37568,"embracing":25932,"islamofascism":30260,"affirm":12082,"021":41615,"vapourings":44859,"sane":9351,"eater":23964,"stole":8573,"inquiry":7202,"gough":41509,"readers":1023,"chauvinistic":21478,"gradient":23997,"paste":2210,"innovation":12767,"isolated":6499,"dehumanization":46661,"bobblewik":44023,"slag":41603,"filipino":8396,"wga":33834,"flirt":40910,"jacobite":18312,"kooky":35424,"hmmmmmm":45066,"laborers":24782,"danny":5425,"script":2848,"waring":22503,"orban":49030,"lesson":4419,"hii":31802,"uncontested":19606,"biodiesel":25618,"estuary":21782,"8chan":36740,"demonize":21345,"swartz":29616,"mutts":43099,"skyhook":13827,"reins":29985,"percussion":24288,"lineal":20172,"kilogram":22019,"kabir":46931,"maths":10191,"demagogues":47564,"tail":6274,"frowns":36141,"standings":21211,"fashion":2946,"vary":6880,"tommorrow":22382,"candidly":32892,"boswell's":41619,"dominance":10644,"solemn":30258,"claus":13563,"raids":16090,"undelete":8838,"junkie":39642,"handjob":47801,"flung":41019,"cao":17411,"oil":2093,"accompanying":12218,"victoria's":32927,"wikt":17211,"cohn":48975,"cultivation":17739,"flatly":21230,"gs1":35200,"authorized":9277,"traits":6328,"1800's":26133,"kau":27428,"contiguous":25175,"rollback":2794,"platoon":21729,"ssp":18574,"rw's":24346,"hrafn":11516,"preity":28332,"eunuchs":30769,"episcopalian":44927,"corrosion":42349,"laurence":26853,"refered":7756,"looney":19547,"kodak":25100,"let's":863,"homebrew":46101,"ski":16454,"pid":19871," 2¢ ":47646,"dignitaries":36480,"odder":39434,"tackles":34923,"uitp":44027,"yamani":48586,"brothel":26161,"inflict":23904,"cinematic":26910,"eliminating":9019,"administratively":34174,"busybodies":29138,"safety":4426,"to":2,"jcpa":44187,"jackdaw":40809,"hide":2290,"f6":43833,"christmas":2722,"contingent":18490,"awakened":47862,"night's":34393,"abbrev":25460,"biva":28791,"unfunny":26961,"rackmount":34638,"'m'":37829,"attrocities":25110,"imperatrix":17145,"dew":29790,"nonsens":35774,"ratios":19966,"vodka":15454,"bubblegum":43373,"shelly":23951,"pandyan":20625,"glass":6326,"varanasi":31571,"esque":17161,"stoking":45011,"clunky":20379,"zundel":21039,"toot":32523,"khomenie":43523,"glenelg":46977,"licker":4082,"sucky":40665,"bmt":29127,"reasoning":1823,"transient":23639,"'80s":35398,"française":29565,"ebooks":28186,"uncertain":7371,"marriages":11191,"ecthr":22556,"promos":49856,"stardust":33938,"thi":17418,"com'":26684,"nadia":40642,"wealthiest":36895,"sober":15493,"ghana":17499,"chaturanga":49408,"tupolev":22701,"aes":29061,"zinn":32578,"tadija":40316,"middletown":37617,"productivity":16143,"zazen":31868,"behalf":2993,"lieu":13887,"fab":23298,"disproportionate":12791,"freezing":16652,"regime":3974,"caya":27187,"pokemon":8390,"quite":383,"fanatically":29906,"murderous":17488,"pats":26106,"coster":33032,"whos":11502,"rajesh":15522,"infallible":13656,"conceals":36646,"mainpage":13340,"dagizza":25804,"rkitko":48260,"io":32413,"sandstein's":27781,"melech":45400,"compounding":19398,"ipods":42044,"augustine":16151,"marketing":3975,"city":602,"lung":15586,"alistair":29753,"dossier":49769,"stamp":4843,"nomex":38409,"tariffs":29038,"hundereds":46145,"extinction":9878,"japs":45589,"tda":38664,"sender":24915,"snakes":12763,"jst":37494,"accountant":32495,"mae":24095,"stroking":23310,"lahiru":36254,"professor":2319,"heaven's":23966,"andyl":43366,"greaseman":27255,"т":44293,"optional":8119,"danjel":40233,"affinity":16320,"'theory'":30323,"actual":737,"greatest":2686,"chimpanzee":33358,"spent":1937,"completing":9837,"stafford":12502,"imparted":46201,"slimvirgin's":25517,"yadav's":35648,"demographics":6166,"dαlus":10535,"pushed":4841,"delightfully":49207,"god":559,"giano's":22728,"hastings":17912,"theirs":6445,"asinine":12357,"silentresident":47794,"bushmaster":45269,"scrotum":13820,"jharkhand":21137,"mens":22491,"uk":749,"ceramics":29472,"layer":8282,"secede":28557,"taunting":15385,"fri":28496,"harshness":43102,"cheater":22172,"reel":16305,"goldmine":35636,"batting":17611,"sedimentary":27437,"unresourced":47632,"howdy":10181,"danger":4955,"cingular":16482,"dangerously":17566,"nymex":27625,"gija":38405,"anchorage":26318,"giant's":38883,"summarising":19176,"fighter":4793,"medicinal":26924,"stowarzyszenia":44236,"marsa":49849,"forecast":24210,"setup":9377,"operibus":29487,"valley":3750,"oversimplification":33251,"franken":29904,"ladies":7782,"welder":42166,"painstaking":24912,"sig":5298,"wisely":17285,"serving":3635,"pause":10166,"religion's":24966,"amucalar":39089,"european":1269,"variously":27016,"arts":3027,"incumbent":13481,"jehovah's":9937,"o'":19144,"poxy":46041,"farix":36402,"briefing":21385,"wandered":22407,"dumpster":31289,"neela":45377,"southwest":9622,"massacred":16384,"kain":46566,"treatise":16635,"candidate's":20428,"legitmate":30831,"sukecchi":33991,"neblett":29524,"see's":40587,"imams":40992,"martinez":14908,"southern":2327,"advantage":4178,"herbs":32509,"utc":182,"tssr":27017,"wes":19999,"singling":18983,"silly":1684,"peacemaker":40697,"retaining":9890,"calcutta":21342,"wholecaust":22027,"objectors":30963,"wikipdedia":41639,"observers":9502,"multi":3502,"vine":25206,"coucher":41562,"motivations":7085,"captured":5586,"whoop":22487,"sympathies":15744,"pet":5337,"abad":35384,"spammed":13608,"blechnic‎":38743,"tonnes":21900,"accelerating":28208,"bottom":1234,"retardedness":46186,"searchlight":33429,"invaders":12423,"secrets":8708,"heraldry":12875,"blockquotes":36641,"irl":13784,"dietrich":20317,"nissan":20799,"freudian":22412,"pseudomonas":42991,"chinook":34516,"cautious":9852,"prefecture":18349,"epidemic":14572,"·snunɐw·":21067,"betrayed":13004,"catalans":26736,"refs":2628,"sta":42449,"sabu":42002,"gnangarra":20895,"inconveniences":33726,"offenders":11180,"utterly":3815,"designations":15458,"both":220,"french":1053,"hookers":35645,"execute":14734,"aka":2806,"grooming":26241,"can´t":22375,"beatle":47537,"notation":6559,"violence":2612,"jutsu":25968,"exacting":41153,"textinsert":46818,"sohn":42815,"libya's":49695,"avionews":47592,"intgovforum":37309,"cariboo":38682,"little":245,"userfied":15653,"bharata":34408,"justifiably":22363,"complaint":1907,"regained":35427,"bibliographical":27151,"↑":44279,"curmudgeon":43389,"subjugate":32575,"mandy":20830,"toxicity":15077,"friedrich":11763,"burghley":42990,"aim":3571,"spirals":12694,"sweatpants":39703,"sheesh":13058,"cumbersome":14365,"translating":7106,"illyrians":10612,"experienced":1831,"bankrupt":14873,"shortcomings":14007,"illustrator":15105,"pdfs":29959,"det":31705,"promulgated":21356,"a's":18949,"tai":13141,"masterpiece":18711,"compositions":13720,"'abolish":47784,"buckley's":31784,"rainfall":32518,"savants":49962,"pomeroy":48596,"embarrasment":32440,"whistles":43449,"nva":23138,"1c":20606,"socom":40207,"'modern":41953,"seciton":48287,"barony":41017,"predecessors":18421,"aggressiv":42109,"tensile":44272,"stavros":48822,"emergent":31691,"astrological":12959,"reigning":17740,"insurgents":20028,"dobbs":30163,"const":34171,"conservatives":5926,"judgement's":47711,"doctoring":31541,"enrollments":45894,"baltics":17568,"'disruptive'":32767,"pubmed":7599,"gotta":3342,"malber":38171,"rahul":21930,"damien":29555,"flying":3698,"straw":4354,"elegant":10509,"concession":26633,"hoysalas":30026,"strengthening":26390,"adieu":23764,"moms":13536,"downloaded":8999,"pants":5372,"itin":44439,"bantu":24581,"commercially":14338,"metropolitan":5838,"modem":13648,"mentione":45669,"sectarianism":21894,"essjay":10408,"inclination":11718,"fervor":26070,"structures":6239,"mirza":16340,"shipyards":25918,"economics":3780,"chirps":19809,"specialise":47767,"laurier":37781,"defiled":35803,"amorous":45683,"pakistanis":13579,"“ypg":41137,"pimply":31112,"skeleton":16416,"ruled":3778,"freddy's":35801,"compensation":10278,"landlord":35781,"universally":5958,"pens":33390,"chain":4607,"eyesnore":46843,"notions":9363,"fridge":39688,"stuffy":40650,"shakira":32160,"skds":34610,"cantor":16485,"sunnybank":48233,"cannons":41004,"fried":10379,"vampires":17775,"dispose":23293,"killerchihuahua":18684,"insurgent":27660,"crow":9208,"towing":39090,"khatri":19408,"heartfelt":19993,"comyn":23762,"—☆talk":39462,"puerile":20055,"griffin's":28110,"006":36191,"together":789,"illustrates":5365,"kaldari":43417,"crawford":14636,"apata":24384,"felis":24980,"gao":32621,"kathy":16452,"elenchi":46139,"ckatz":16775,"drop":1639,"decisions":3044,"greenfield":36118,"trolley":28818,"blameless":36610,"reformist":23170,"upmost":33604,"thing's":39790,"mihal'in":31551,"container":15030,"post":304,"scorched":44632,"canvassing":5275,"place":192,"migrant":30469,"dirty":2420,"cochinchina":47461,"trees":5258,"tiling":37742,"oswalt":29132,"cvr":37809,"erring":34033,"bellend":28756,"rosary":25518,"horizon":10471,"yah":12839,"prodding":23270,"guadalcanal":46444,"paradoxically":42397,"blokes":32485,"vindicate":33133,"freshmen":40458,"20records":49489,"laotian":36674,"portal":2110,"waffen":22647,"fulfillment":22374,"amaechi":31040,"goright":37129,"reign":5355,"undisclosed":23009,"independantly":39252,"hariri":48272,"cadet":24448,"mendelssohn":25668,"dispel":22341,"writ":13808,"akm":43460,"earle":34389,"randroide":34882,"stalking":2328,"raza":21491,"nkt":41690,"inevitability":32260,"jokers":22930,"helpfull":27878,"samba":16280,"thoughtless":31259,"extensible":47589,"elijah":28310,"icke":44638,"على":45828,"lauren":15413,"mór":45593,"stella":22217,"к":38905,"expr":38459,"priestley's":30807,"tawkerbot2":49925,"law'":32548,"cyrillic":9983,"breeders":9801,"contentious":3452,"pennsylvania":6334,"wanta":13215,"uaf":21383,"yer":10054,"flay":48666,"aif6na3":44096,"t2":30350,"nazis":2608,"outright":3736,"floated":39275,"downers":46657,"portugese":23700,"expectations":7826,"crackpots":24492,"pressured":20069,"denote":11631,"hb":25467,"effect'":31765,"segments":10443,"memoirs":18200,"moser":34260,"uplift":28229,"grids":40536,"dodgers":38563,"successive":25192,"assistance":2299,"debris":19250,"fuzzy":12854,"shane":12427,"—n":35549,"nis":38937,"mojo":20026,"melissa":14967,"fuhrman":38357,"headlock":46446,"shuffle":22643,"nishkid":22308,"chet":41891,"wikicode":18802,"inwards":37344,"retards":8432,"veered":36029,"eee":42129,"haired":16620,"cntrb":31550,"coanda":16373,"farthest":36209,"theregister":29842,"highbeam":19414,"pind":31451,"bizarrely":24608,"dada":38365,"moths":40095,"vietnamese":5572,"refrain":1477,"hypothalamus":27332,"thinked":47115,"equipment":5039,"hypocrites":11926,"vitus":23123,"benchmark":20828,"endorphin":46674,"carrington":22718,"fluff":12508,"pare":23197,"gd":16679,"expressly":10969,"thrown":4494,"spacex":18508,"stitler":40893,"milieu":17070,"ing":5294,"gallium3d":39206,"zero":1989,"fluids":19800,"mortals":26624,"automatically":804,"cuisines":27829,"patches":19920,"hunter's":27792,"wanker":1100,"dmz":49108,"disguising":33161,"m€":49255,"superbly":34921,"'s":2475,"sharp":7547,"anyhow":4994,"stalks":21618,"trinidad":21007,"nite":21763,"theories'":34484,"kontakt":43517,"aril":48385,"ism":13869,"argumenting":49422,"quibble":18555,"positivism":24336,"chou":26776,"ifpi":22938,"mopping":35387,"kellie":36308,"genital":7285,"mute":22940,"yat":35454,"repairs":16191,"tenzin":31195,"publisher's":17065,"wrongly":4674,"methodological":14987,"'get":23941,"medscape":47826,"hasidic":45794,"rté":36854,"leach":23920,"chariot":30466,"chris":2572,"russell":6546,"diehard":28251,"janardhana":43613,"scrum":45671,"stelle":36033,"♀":20656,"campuses":23906,"ghraib":37211,"correlated":19619,"flummoxed":35767,"ordinances":39662,"maximum":5233,"program's":34014,"examines":22748,"yas":40186,"corridor":17024,"productions":7806,"index":1245,"video":826,"revolver":20292,"regiments":16000,"impressionable":44565,"d":582,"mashup":49952,"shazbot":28891,"cdrtools":14765,"venizelos":49741,"considerable":4429,"tarantino":31254,"falsifying":18330,"whittle":48199,"abc":4533,"widget":39967,"retentive":14309,"sargent":39722,"grandmother's":29945,"heres":9354,"talk2me":6838,"coon":18668,"luhansk":36752,"slobodan":30050,"winding":17706,"aranhas":43754,"mercola":42534,"signalhead":24333,"narcissists":46254,"inspection":11901,"godwin":19867,"undisputable":31027,"reinstate":6824,"brushes":31694,"broker":21804,"propagate":15878,"bute's":37766,"wartości":38858,"rfa":1411,"concept":1280,"xchanter":26507,"silesians":24497,"enoch":25662,"slammed":31666,"novelists":40755,"fulfilment":47133,"bhairava":43473,"unlabeled":46696,"bottoms":36547,"mzilikazi's":31266,"modernity":26072,"multicultural":26685,"dodo":7018,"jihadi":35300,"brian's":28885,"receiver":11995,"scientology's":30475,"dembski":16339,"clear":368,"gear":6726,"tweaked":15462,"khalil":32472,"dmca":36933,"jeep":38438,"leone":21057,"prototype":10399,"watered":24435,"prognosis":31190,"fellow's":28654,"antisemtism":36301,"arouses":36115,"psychologists":12552,"tajik":8655,"facilitate":3137,"avalanche":17105,"upshot":35667,"jury":7281,"noncompliance":38258,"mwi":40505,"overgrown":46223,"rajas":29690,"baptists":13817,"spartaz":20394,"jungian":43073,"godzilla":22319,"awesome":3380,"ammunition":11070,"lists":1096,"nails":14250,"nontheless":28919,"can’t":8138,"gadget":19321,"pename":22804,"galloway":19177,"ayer":41955,"zhao":49086,"abuser":13434,"homework":5993,"bonnie":12499,"history":178,"thos":31547,"kongu":37611,"jitterbug":36824,"wikivandal":37177,"zag":45768,"khruschev":49460,"cleary":16754,"iz":13799,"jars":35530,"gc":11332,"d'":39279,"brood":35874,"hymen":49048,"floats":32268,"howard":5473,"divisions":5185,"disgusted":9838,"neglect":10400,"mutant":19299,"overlapped":27180,"directing":9717,"jammed":40516,"ligitimate":35372,"assessments":11980,"dgg":13487,"elyes":49008,"sgyy":44112,"graced":41516,"lighthouse":24951,"waved":35735,"4'":43289,"ux":48851,"qmjhl":38676,"counterfeit":31827,"news'":26142,"stupidly":14389,"bluetooth":27665,"diario":48931,"unbalanced":6791,"corporatem":34430,"ps3's":47210,"looking":495,"bolshewik":49945,"ugly":2622,"gaj":44913,"levey":42601,"jadger":23211,"sind":43122,"becker":16860,"dreamhost":27856,"kowtow":48282,"evry":42183,"chorlton":34474,"nicholas":7633,"manuel":13527,"alden":11809,"serenity":30404,"subtopic":20936,"wessel":47898,"mening":38694,"paleontologists":38894,"steaming":23134,"wikicookie":29574,"value":1249,"assuring":36750,"badmouth":44765,"copyrighting":40583,"april":1036,"pump":3230,"adverbs":35985,"heating":12758,"gatineauparc":31400,"portuguese":3762,"jacob":7947,"hansard":26592,"ferus":26753,"polymers":31540,"mismanagement":42668,"ursa":41723,"necessitates":33124,"yannismarou":48685,"cultivars":31744,"warhol":21091,"irrational":6360,"randykitty":41035,"fof":19584,"a380":28164,"rears":32828,"emp":27283,"washer":36906,"shaming":33381,"abrahamic":13344,"idiot's":36664,"guideline":1200,"groups'":31114,"أن":35843,"forward":1208,"synoptic":40647,"torches":43000,"owl’s":45366,"shakespearean":29602,"cracks":16929,"sour":13031,"enforces":37550,"inscription":10946,"ebionites":39778,"pyprimes":16850,"subjected":8821,"refractive":30087,"jobless":32231,"caledonia":34581,"dailytimes":42662,"jenner":20486,"stationary":19757,"netherlands":5124,"thinkprogress":42938,"arran":29964,"ion":12074,"propeller":26954,"60kb":36746,"chases":47016,"sister":3097,"al":1089,"touching":8114,"johnphos":41449,"100kb":47122,"khanum":31741,"nkvd":23814,"producer's":37131,"allahabad":45317,"struggles":16140,"confrontation":10916,"52s":31750,"verifiably":14527,"counteract":20708,"workable":17055,"brutality":16513,"commission":3728,"themesotheliomasociety":38584,"ep":5748,"villages":4018,"wikimedian":26304,"simcity":47231,"wher":26758,"amigaos":31575,"hitching's":38800,"jarrah":44057,"wikiislam":32743,"at":34,"snapshot":14661,"pflp":39358,"tymoshenko":40903,"mad":2762,"rsn":9340,"mgts":31778,"precautions":27190,"menudo":40582,"retold":40517,"extinct":8308,"know":69,"gui":22546,"ccd":26699,"jud":42168,"toshiba":33832,"lga":27073,"hooray":16573,"bignole":33639,"cl2":49316,"'evidence'":35808,"mmx1":41491,"cancers":30372,"rightmost":49483,"celtics":49014,"banality":38458,"exterminator":48201,"flees":41103,"harpy":31361,"cooperatives":43827,"hannah":13067,"informally":19846,"korn":18920,"surprized":47274,"threatning":24447,"shitheads":46601,"manufacturing":8806,"teletype":42568,"nomenclature":9542,"khmer":19032,"shook":32909,"ukrainetoday":41529,"born":943,"deegan":27626,"useable":23935,"dogs":2808,"cloud":6650,"tiger's":32954,"succeeding":15668,"devolve":31447,"suites":35969,"serves":3441,"rude":1707,"stomach":11784,"wonderfully":21369,"baez":16987,"derm":39099,"horizonte":44992,"autopsies":41544,"misrepresentations":25318,"3am":29502,"brixton":17697,"piecemeal":37313,"baronets":28420,"козла":48567,"'genetic":38142,"ensues":49183,"tgbbq":33412,"smartass":22708,"nicest":24883,"yue":17719," fix":17407,"who'll":32417,"seizing":38382,"lucky":4467,"skirmish":29325,"ness":10836,"tidal":18626,"cows":12400,"media'":36019,"the'fortyfive'":16588,"pmdrive1061":37017,"rileys":44209,"tielu":43887,"einaudi":37418,"grain":8462,"communicative":26407,"marks":3744,"egrs":46014,"inmates":14297,"uakron":45830,"enforcing":6768,"rodham":17446,"literal":5522,"amerindian":22773,"'flat":42664,"bugger":15902,"embellishing":41346,"19c":36194,"aggregator":47085,"masons":14424,"metacompiler":18609,"yap":29888,"antagonism":23445,"stanton":23835,"npov":654,"streetcars":41758,"servitude":29937,"dough":36413,"wood":5151,"australianrupert":46608,"debunker":28761,"£4":29318,"evolutionism":38597,"aligned":10127,"unionists":24709,"bottle":8994,"brownie":19269,"grasping":15224,"invalidates":28147,"homophobic":6944,"tomatoes":12630,"orochimaru":31656,"cadillac":33225,"gollum":49160,"6th":4885,"reelected":49700,"crab":26946,"feedback":1858,"antisemitic":8763,"tallies":42546,"multiple":866,"perfection":10961,"'''''' ":14259,"lasting":8651,"intolerant":13022,"inventing":12550,"downside":25111,"minor":1088,"jimbo's":9144,"statist":32853,"inane":10094,"snowman":11384,"mallet":28124,"laughably":20919,"himalaya":34834,"rowan":23875,"nazif":40141,"'popular'":47460,"silesian":11881,"hurricanes":14806,"bowler":29773,"culpa":20710,"sharon's":34380,"context”":38796,"partners":9020,"melons":46474,"tracklist":26511,"versa":7322,"fp":10704,"gusuku":15183,"liking":7032,"sorties":47281,"panicking":47487,"recomend":40619,"ant":11806,"hafen":34560,"considerations":8056,"floorball":44882,"gaius":27026,"shrugs":34663,"doodle":32387,"rochdale":28423,"clifton":22034,"swapping":19379,"novices":45689,"endeavour":15590,"editcount":28258,"2ª":33750,"musing":36284,"gfy":43455,"josephus":13184,"acticle":46165,"scour":35739,"deny":2445,"presumptions":41969,"goldstein's":49246,"obelisk":36243,"schiller":33516,"gloat":29533,"assassination":5085,"arena":9560,"astronaut":18095,"other":61,"differ":4911,"guessing":4906,"sequoia":43720,"reactions":6051,"oneself":11944,"residents'":47705,"relevant":502,"sokolovsky":33713,"marco":9789,"inacurate":42599,"trabzon":49276,"payne's":37971,"garstang":47327,"illustrating":12239,"fayssalf":38980,"loosers":43740,"regulated":14996,"autofellatio":26594,"americans":1538,"pramod":38499,"crimean":23208,"gras":24342,"diode":26224,"krista":30861,"pliss":29754,"ferguson":17926,"protectionism":40004,"mattythewhite":35544,"ecological":28247,"villagers":17455,"90a":40447,"episcopal":20053,"hydraulic":30468,"permutation":48686,"§croak":34178,"fuehrer":39118,"obfuscating":28333,"coach's":46610,"mastodons":49821,"falsifiable":23868,"jewish":800,"fleshed":13279,"hysterically":35400,"benazir":44059,"wikia":5552,"notoc":40775,"unite":10841,"nasser":23850,"masterminded":37593,"carnivore":47928,"assembler":26111,"such":108,"intef":31855,"cynical":10374,"violent":4830,"endhiran":40512,"james'":17430,"'he":17964,"mekkhala":39246,"shorts":17077,"moscow's":44918,"jin":43229,"thierry":44590,"unwavering":37553,"bored":4815,"conundrum":25019,"goodfellas":42792,"tung":28536,"week":714,"districts":6322,"people’s":28267,"segal":30940,"transplant":23645,"drastically":11285,"ppb":48183,"centraliststupid":4287,"prints":12055,"fated":39389,"pique":48205,"––":35022,"watanabe":45043,"airliners":18173,"opponents":4667,"wiley":19494,"sofs":34894,"exotic":11628,"regretted":32928,"kashmiris":34446,"pietro":27430,"cutkd":46090,"disappoint":14978,"ivan":7725,"matthewfenton":43295,"ez":38332,"therapist":17163,"whale":8143,"neighbouring":20621,"stonewalling":23899,"sterile":19252,"simplistic":11383,"bug":4548,"haz":28225,"wanda":40411,"work":141,"positives":16512,"yamla":10973,"snowing":26030,"principally":20940,"punt":17831,"dongs":38674,"kkkkkk":6526,"anxious":17667,"percentages":11122,"knew":1387,"review'":46055,"sacraments":27516,"cycles":11615,"calumny":37959,"bello":31977,"caucus":17222,"connect":6250,"dabpage":49582,"acceptability":25254,"algerians":45415,"reused":25307,"hoc":11439,"workspace":41974,"sbvt":47110,"ylt":45925,"erase":3879,"calligraphy":27599,"craze":37172,"airfoil":25198,"reliant":22153,"mar":2129,"arrange":8502,"tbh":18971,"retreat":11847,"magistrates'":46989,"'50s":40074,"messagebox":15440,"needn't":17051,"unprovable":34540,"coco":36025,"gbooks":27983,"targetted":24412,"prostitutes":11885,"moi":13023,"vice":4146,"slovakia":12942,"liners":25082,"macau":13214,"entrances":31929,"realizes":16080,"showbiz":42588,"unblock":736,"cycling":13643,"multiplier":37070,"pounding":26360,"alejandro":31336,"videos":3101,"g7":13765,"limits":3490,"slanted":8982,"groundless":25567,"surgeon's":48994,"fould":48807,"questioning":4337,"talkcontribs":12665,"italia":22934,"testimonies":17798,"zappa":18689,"krabbe":36696,"partiality":39907,"dispassionate":21872,"archiveheader":48187,"tfnsw":44788,"emotional":4847,"transpose":28443,"bhakti":43614,"federal":1967,"aga":21085,"onset":14515,"introspect":44972,"saltyboatr":25648,"hganesan":23960,"reuters":8788,"fckin":40541,"ip’s":47744,"watermelon":35228,"60's":13888,"failures":10231,"ambition":18270,"softened":47316,"calvinist":20800,"oxford":3359,"anamorphism":31419,"acquainted":12995,"exile's":42786,"webmeister":46904,"gameplay":9797,"contemplate":26172,"δ♥":34289,"l's":39753,"misogynist":19514,"achievments":46095,"goddam":37237,"jimwae":38738,"elkevbo":21504,"obligated":12368,"msg":7105,"nguyenhue":38507,"lecturer":17968,"gotras":31840,"presiding":26233,"cannon":9880,"ber":49983,"immaturity":20269,"mop":8492,"aclu":15866,"royal":1901,"gomer":32880,"juice":7302,"arlagadda":48480,"randy":7597,"etymologically":28165,"plaguing":41470,"bieng":44457,"shirazi":38002,"arrest":3367,"kumari":36387,"reasons":637,"pages'''":26291,"mediae":34722,"meant":944,"connaught":45024,"lankan":11198,"malaysia":6987,"aryana":33115,"compress":36099,"nj":9750,"labelled":5814,"categories":1202,"milosevic":21431,"mercer":25159,"vastly":8741,"paraguayan":39807,"nukem":44870,"redirects":2158,"stuttering":26698,"mahdi":29250,"guttation":47889,"interpolations":35380,"psy":21078,"stereotyped":29575,"supression":36020,"punctuated":45945,"—encmstr":21660,"icr":49896,"formally":5074,"chimney":31315,"zenwhat":44733,"wmc":12816,"pangool":41209,"encourages":7537,"parliament":4154,"barranquilla":44190,"puppet":2070,"ambassadors":10206,"eludes":35482,"truthiness":28772,"scores":6080,"ambiance":43618,"araxes":46224,"tdh":39471,"blindingly":40379,"obituaries":18618,"winnie":21295,"exeter":14768,"kamboj":18577,"quantifier":41427,"muchly":30018,"krishnamurti":34780,"favorably":19631,"planting":19028,"mishehu":31468,"weber":22765,"jonesborough":27378,"kosovo's":28965,"clinging":42756,"settle":5174,"ncnm":44193,"confirms":4814,"durante":45597,"forlorn":40640,"moc":18744,"siobhan":46639,"twitter":4040,"shred":13274,"stinson":44814,"dina":34695,"trailers":13792,"agnes":15156,"astrotheology":32324,"bern":44376,"rigidly":45860,"spaced":21721,"haun":44087,"nuncio":43902,"hid":12934,"phillips":9157,"plato":11235,"avatars":40052,"qwest":41473,"skies":14243,"goers":40494,"prospectus":46046,"reposted":14103,"smirnov":30251,"creeds":20851,"jayscyyoung":48448,"shutter":38754,"kigoy":47553,"kimbrough":33061,"duplicitous":29617,"inter":7293,"trashing":16227,"byrgenwulf":27589,"seriously":813,"naturopathic":21049,"frustrates":34001,"wikepedia's":41844,"restating":27898,"approved":3003,"tsarist":34698,"aticles":39262,"teaches":9739,"constituted":8901,"lcnj":32649,"compressed":17723,"micronations":15478,"bonus":7807,"altruism":37704,"img90":23849,"“how":45092,"subhead":31303,"delayed":8178,"bot's":17339,"absolve":43507,"reader's":11017,"pecarek's":48126,"dignity":9258,"resuscitated":47611,"exemplified":18242,"adopting":10032,"realisation":31467,"vb":19723,"walking":6034,"lfc":31143,"ari":25182,"rovers":18930,"whut":49023,"propellant":45677,"cd":4023,"loloool":16480,"huac":31081,"0px":7524,"criminally":14215,"advocates":5934,"guerillas":32187,"uar":38178,"quintus":42858,"'ve":32095,"pointer":9289,"kunis":32729,"pulsatile":40344,"mva":41790,"sciam":49534,"astonished":16267,"sy":22288,"sikhism":9847,"hanssen":14836,"anglicised":37032,"agency":4314,"beef":6396,"poems":9828,"yobot":25785,"jat":17836,"pte":28814,"immediately":1331,"rubber":9654,"thrust":7419,"doncram":41798,"genoa":29023,"adoptions":35639,"suburbs":12255,"stead":20072,"disarmament":46606,"yyou":45026,"jackal":24606,"exert":13936,"youths":19880,"android":10587,"soz":44951,"betrayal":14257,"cain":13384,"physiology":12495,"kibele":44596,"monobook":10528,"appreciated":1284,"infinity":14322,"ullman":35081,"mosbio":34744,"attempts":1781,"incl":33601,"sexless":39508,"high":557,"deceased":6627,"underworld":17976,"archeological":21289,"'92":48353,"radix":40036,"marmara":43645,"demigod":38571,"flavours":39875,"chromium":43632,"artists":2674,"hinduism":5624,"usgs":27153,"whines":28195,"ural":23981,"dilemmas":37375,"scrutinizing":21835,"—aco":20354,"accidental":7394,"noisy":29002,"ryanpostlethwaite":45213,"smart":2092,"weighs":18234,"cobbler":43784,"caus":41753,"redistributed":23413,"exempt":8779,"numeral":11071,"desktops":36011,"largest":2082,"levant'":46481,"rt":10298,"zakir":16220,"you":6,"renu":46516,"wilson's":16691,"samir":25306,"upholding":14999,"capoeira":27449,"pandemic":30149,"leather":12888,"timmy":41392,"amendment":4455,"mashed":40787,"awk":36325,"wrestled":18632,"vandaliser":24894,"tsechu":45051,"carlito":23109,"approximation":14335,"premiered":18753,"excel":15460,"thiyya":31919,"misfortune":23643,"words":409,"dramatist":38916,"disrespecting":19663,"coz":11549,"ha":1540,"weebly":47387,"kach":40382,"pracę":38859,"sindh":24048,"khoikhoi":6664,"motor":7154,"wikiethics":46786,"ndtv":33307,"supplied":5654,"investing":14638,"sheriffs'":42582,"jacko":29440,"eviscerate":38996,"thankfully":9901,"cocks":2651,"talk''":19963,"ˈfɻɛ̃ⁿdˡi":46676,"dee":11583,"t • c • l":41778,"increasingly":5551,"typed":6708,"walther":29982,"xwiki":43588,"clockwork":29700,"competitions":9930,"clarify":1836,"sprawling":33955,"ratio":5247,"deter":12005,"indemnity":47661,"withered":44958,"joss":45348,"prone":8529,"reducing":7356,"appointment":11866,"freak":4798,"remiss":41233,"motivating":19754,"urls":8204,"recently":693,"ruislip":46259,"bangladeshis":37646,"supermodel":25899,"nirmal":26493,"sjakkalle":34109,"collaborative":4547,"ranasinha":34680,"abroad":6805,"bacchus":41620,"minimized":22805,"orchestras":25249,"hooker":21283,"sima":36686,"thingies":34298,"jenin":34241,"vs":1380,"theorem":5944,"molehills":39218,"prides":34301,"encylopaedia":40433,"removing":492,"butt":3807,"purchasing":13638,"chagi":43647,"interned":39345,"weatherly":49936,"brookie":43664,"agreeable":12230,"car":2221,"toh":38307,"cierekim'''":19596,"waaaay":30429,"companys":36962,"photos":1432,"authenticity":9448,"banfi":45421,"brig":48884,"ross's":37759,"iraqis":17249,"terryeo's":41394,"newtown":38334,"drawer":21819,"brit":10141,"augmentation":33593,"diggs":38881,"7da3":38549,"workaround":44066,"abysmal":21248,"jodie":37141,"heinrich":17625,"webconverger":47228,"karabakh":8998,"factory":7577,"→":3138,"whinging":27902,"footnoting":24146,"similarities":5668,"complains":9369,"lax":12494,"mikkalai":19665,"buhtz":34797,"competitive":8309,"stravinsky":45668,"hungary's":27483,"reserves":9596,"voabot":33866,"continue":281,"hokkaido":45621,"trek":7191,"sachin":35393,"browbeating":49623,"administrating":36590,"libertarian":6636,"crates":38298,"puppy":9077,"chrysler":20128,"schmitt":46452,"exasperated":30226,"ext":25171,"freemasons":20966,"wierd":16146,"thessalonians":34589,"cougar":3541,"reaper":20002,"ili":41399,"grudges":19516,"paternalistic":35837,"thios":47643,"mentionned":33540,"stainless":43275,"gq":49253,"taunted":39362,"ephemeral":29943,"farrell's":44204,"bkheera":48548,"reasearch":28766,"gall":18710,"ministre":49085,"tumors":28280,"seamlessly":48311,"wikien":28345,"qijong":43599,"ons":17857,"api":25666,"evacuated":24765,"shanty":47196,"contested":3366,"fifties":24056,"innately":40938,"24h":22276,"wbc":19618,"shunned":19370,"'well":24916,"ling":15073,"anew":21235,"bihar":13499,"appaloosas":38141,"qb":24466,"rn":23647,"neutering":34603,"uncited":4832,"sound":1097,"osi":38277,"downton":31883,"jatts":15535,"upsets":17118,"easiest":7898,"1770s":41213,"camaraderie":38083,"possum":21946,"googoosh":49095,"ultimo":36794,"lure":49739,"snopes":28215,"geographic":5107,"henrietta":29893,"mvps":46614,"goldsmith":45318,"immersed":27343,"reveals":6379,"smashed":16820,"planted":15369,"updates":4226,"afterthought":34554,"engages":13841,"submarine":10838,"fields":3459,"tonhalle":49065,"pharmacist":44045,"misbehave":46641,"acquire":14761,"bussy":39677,"styles":4786,"vivisection":32782,"documentry":47854,"plymouth":13463,"louvre":45457,"moderating":14558,"axeman":45412,"amplification":29540,"antandrus":19378,"upstairs":29938,"couture":45287,"memoires":37469,"mahā":47175,"amounted":20398,"claire's":48180,"crore":14994,"anon":2582,"antiques":34212,"nebula":41666,"supercars":26950,"stubbed":23055,"dogsoc":20121,"dissenting":10291,"certianly":25938,"mush":25119,"juxtaposed":46395,"niko":36972,"jakarta":14904,"sociocultural":31581,"velocities":39292,"uk ":21181,"chicks":15124,"entice":46266,"fundamentally":4398,"meir":40919,"lysenkoism":34460,"automata":33008,"disinformation":9556,"o'doherty":38066,"unaccountable":36633,"nations”":35919,"crass":16726,"revisionist":8580,"nudist":49413,"muncie":43131,"tours":9920,"paper":1274,"intuition":14536,"upkeep":32632,"cramped":40347,"osaka":26652,"ronny":41312,"att":13835,"reinstated":5879,"quesiton":36771,"kade's":49497,"apply":1329,"wiltshire":45503,"hubpages":37513,"sharing":4562,"openfuture":29681,"underline":22715,"fagg":46621,"judges":6205,"hanlon's":49444,"highest":2798,"metals":13568,"axes":17225,"asians":9003,"unresponsiveness":44811,"depressed":12149,"westbound":15973,"operated":5672,"vanunu":48982,"wikilink":7212,"indonesia":6562,"brews":22317,"fairuse":16312,"factions":13261,"unspoken":26464,"rfai":38151,"benfica":22264,"gambit":30852,"there're":24010,"prioritize":37731,"guarantee":5422,"mauritiusxxvii":18596,"moderation":12783,"probation":7741,"manga":4700,"mcs":23747,"cxd7":48446,"subversive":15763,"constantly":2284,"urged":21363,"seventeen":28850,"aliases":13658,"fossilized":24393,"duff":19849,"colleges":7019,"uniform":5740,"vulture":38569,"achived":42963,"tuff":27121,"kabuki":34094,"cork":13411,"browser":4568,"nus":39075,"kitson":49646,"ganging":13448,"decider":28801,"rebut":19536,"neighborhood":7049,"somethign":37407,"nhls":30243,"finds":3915,"ectopic":49975,"suprising":45265,"o'neill":16943,"fertilization":47951,"deadline":11373,"taekwondo":14570,"compassionate":36653,"grid":11056,"shelbyyoung's":46524,"springboard":28342,"uninhabitable":41172,"obeyed":29510,"crats":35504,"taunton":46408,"signs":4141,"rapists":23013,"omura's":49425,"piqued":33550,"thesweetscience":43832,"madhya":43421,"pmr":45773,"him'":39775,"revive":13160,"pur":42447,"treivas":41651,"adapting":22364,"happened":797,"5pm":47972,"hopkins":10741,"faggotjiggaboomongo":49433,"captions":6082,"pikachu":18342,"attainment":41268,"thankx":48073,"heated":8065,"naxalite":45740,"dec":2323,"gimp":14381,"cyrus's":49977,"'''talk'''·'''contribs'''":32710,"admit":1466,"dubs":32566,"mista":35962,"1950s":7626,"rascal":28159,"trade":2813,"farsi":15443,"generalizing":36877,"quebec":7240,"shoshu":42731,"executive":4263,"viceroy":31503,"micronation":19156,"negating":23219,"rfds":46887,"'did":43736,"mee":34790,"deluding":37263,"markbernstein":40524,"resigned":8767,"bertrand":22346,"shines":17253,"famouse":49734,"proxies":6387,"'notability'":29249,"correctional":26484,"'anti":14812,"managing":10498,"1870s":41642,"'high":27936,"chen7754":27489,"mounts":39921,"fanny":28804,"knot":15899,"saud":30289,"prematurely":19852,"sus":29468,"clairvoyance":14496,"runescape":10223,"indepth":25261,"turnover":25062,"zep":33319,"sole":3480,"lehigh":24861,"shell's":28378,"uncredited":17427,"solipsism":47242,"newton":7415,"dniester":41957,"splits":18399,"mahler":43251,"2000's":43807,"heirarchy":47100,"millwall":32893,"color":548,"desecration":24694,"requiring":6475,"bedtime":23605,"asue":47608,"mayweather":27013,"masturbation":8700,"brasil":25854,"per":500,"reopened":18970,"condemn":10457,"ashram":41895,"matt's":28697,"luna":10197,"“in":17744,"casimir":29234,"dont'":20439,"europeans":5032,"mckinnon":23052,"heroin":17664,"umbrella":8894,"spasms":32454,"qac":34838,"enforced":6548,"evolutionary":6402,"hooded":19682,"chrono":33718,"minus":8841,"battalions":35798,"hellinabucket":29398,"dreamcast":36949,"presenter":17810,"ccs":36617,"gowan":48585,"''i":40088,"mnt":20227,"superficial":11110,"attach":10461,"henchmen":27840,"needed":663,"couple":933,"milan":10388,"descent":3613,"standard":817,"20kb":41196,"asymptotic":49647,"ruwp":36914,"qid":20977,"havolane":41904,"butter":7662,"neglecting":27771,"swap":13357,"variants":7110,"comming":16484,"annoyed":5921,"zoe":10002,"astoria":39399,"tid":27077,"peeves":44564,"uptight":15227,"firstly":3869,"nathan":10396,"capitalization":6103,"magnagr":48927,"czechia":32754,"curing":26095,"jericho":16112,"nui":40425,"jim62sch":36217,"rvv":6162,"improved":2123,"intermediation":49328,"innermost":42863,"collaboratively":12595,"unidentified":15101,"scripting":25800,"pleanty":46879,"exoplanets":40306,"foil":19395,"aesop's":40537,"sanhedrin":28085,"sprouts":43119,"nms":30731,"“m”":46074,"spoiled":14184,"culpable":25098,"sheppard":37208,"2checkout":43154,"shove":6358,"novaranist":31712,"conspired":22568,"banking":8350,"misleadingly":30631,"children":1121,"yardie":29397,"becuz":44617,"corum":42630,"marioman":45535,"tad":9569,"ev":11341,"wolverhampton":17359,"ambush":15109,"regis":27148,"zordanlighter":35450,"ingenious":28493,"sexiest":29027,"denials":15004,"excavation":48093,"equations":5521,"wounds":13239,"content'":42055,"fangirl":28049,"dao":41401,"wilayat":14507,"rommel":29958,"evidently":4672,"simpson's":30844,"resembling":14872,"component":6201,"fabian":33742,"yvonne":33240,"regroup":40891,"≠":13369,"g2":13374,"nescio's":31562,"fielder":30585,"escort":18538,"soemthing":43335,"twigs":31891,"salafi":21482,"ams":21428,"mercury":8003,"encapsulates":44491,"tenacious":40936,"djac75":47049,"sexton":41328,"a5":32375,"eloquence":25350,"civ's":39656,"almanac":23794,"contends":32031,"cp":8265,"hojimachong":47985,"molesting":11870,"compulsory":15787,"vertigo":24490,"demonstrably":11328,"ais":47834,"colorado":6701,"ganged":18634,"sac":13455,"publicly":3727,"invited":2744,"weather":4872,"itchy":21360,"ipc":36221,"positioning":18612,"flyguy649":25481,"inaugurated":27797,"★":26989,"pickup":35826,"ee":9137,"exterminating":44348,"velde":39058,"intended":1358,"rarely":3386,"toc":8712,"warned":1746,"levied":36214,"sockpuppeteer":15565,"exclusionary":44717,"erudition":34530,"darling":14762,"represented":2796,"assasination":20403,"suffixes":21974,"andes":43434,"raman":29491,"governed":10754,"soldiers'":31776,"erkel":22040,"mahan":34631,"mongoloid":14623,"tsushima":34521,"pas":10285,"defenition":43746,"pyle":36850,"aficionado":43168,"treasury":10979,"preservation":11563,"paralegal":41077,"shoulda":27429,"flexible":9581,"thefreedictionary":26268,"cisco":24380,"tipler's":20476,"encapsulate":39855,"beaten":8449,"rocky":8597,"aging":13202,"barcelona":8397,"homepages":33717,"'hindu'":46155,"crotch":23574,"yard":11230,"scci":45788,"whim":9913,"granted":2630,"069131994":44254,"mata":40424,"fidel":15168,"neighbors":12742,"downey":36837,"armond":38735,"bogdanovs":21589,"collated":49678,"attentively":28183,"laidas":43224,"stranglehold":30878,"brainhell":46441,"∅":37118,"culturally":9295,"determinations":43525,"elena":46092,"alienate":22146,"newsgroup":22311,"np":13570,"newsflash":28664,"arana":41127,"parisian":36057,"aimless":46773,"langan's":22184,"offset":15023,"horseback":40839,"geographers":37598,"finch":33024,"genres":4332,"minimization":44274,"copyeditors":26028,"priviledge":40687,"irb":31578,"fiercely":22856,"pep":28152,"phones":13723,"detecting":30244,"stressful":16548,"netaji":27732,"puma":39506,"hod":46312,"serbianna":39272,"chimed":27034,"apostrophes":21651,"scr":41985,"gamma":12043,"stamping":39435,"oranges":17904,"spiderman":18831,"station'":31863,"caveat":11019,"imageshack":15644,"tch":23543,"serbia":2820,"regina":35807,"rampage":14029,"dang":15344,"informational":12543,"arbcom":1687,"fuhrer":22732,"kyrgyzstan":28522,"prohibitions":31773,"harmancık":49520,"soriano":14046,"repoussé":42200,"perkins":28334,"hunk":26177,"soccer":4675,"smc":41067,"autocratic":26293,"workers":5423,"monger":19503,"transgender":9711,"skier":21813,"peacekeeping":21330,"'false":41454,"rhodesia":23623,"ζ":27414,"ayatollah":17473,"hesitating":45564,"wearing":4492,"hectic":20315,"blurb":7545,"constituting":22966,"chideock":46631,"smugly":38056,"weapon's":44805,"insane":4474,"fda":12596,"highness":14719,"±":11649,"fascination":19534,"domo":21087,"marksweep":28262,"latte":49459,"innapropriately":48253,"jewellery":12048,"sinden":18638,"vabre":38457,"helmets":17294,"getaway":45139,"pax":23180,"tastes":11337,"charged":4802,"ill":2027,"ukdoctor":42121,"glam":10527,"fluoroquinolone":38803,"country'":35711,"reverter":21759,"occupation":2757,"noes":1664,"action":781,"khrushchev":33487,"veterinary":19432,"analyzing":14179,"greenland":12617,"objectivism":18004,"youll":20442,"furiously":47107,"tête":42717,"ethnographic":31334,"2015‎":29573,"electorate":29523,"preconceived":25415,"huzzah":47310,"mig":16900,"reiser4":43375,"shite":13377,"episodic":49774,"cinderella":26358,"lend":8124,"nightlife":30171,"tetrapod":44184,"succesful":16388,"nones":42314,"bella":20186,"relativity":7710,"monopoly":8500,"droit":37992,"yomangani":42847,"differnt":30678,"pov'":47622,"critism":19294,"meany":46817,"amen":15446,"rigorous":11178,"π":15601,"proponents":6727,"socked":37453,"aotearoa":43696,"angers":31548,"hem":31057,"entente":26903,"weathered":28257,"idealistic":23506,"molester":16309,"beg":6327,"tribal":7874,"paglia":22135,"out'":27553,"webber":22449,"balkans":7960,"cyberspace":19556,"lionel":15766,"bills":9076,"tomislav":33594,"vigilantes":27598,"constitutionally":32234,"resonances":14085,"blacklist":11707,"heidelberg":25458,"inhuman":26128,"jarlaxleartemis":41884,"univ":17436,"mallorca":45791,"non":280,"conspire":17136,"drepanodon":38820,"efendi":19355,"velocity":8885,"ucl":40477,"sizeable":22427,"fuelwagon":39445,"discordianism":47600,"unrwa":22775,"show":303,"riaa":16208,"charitable":13318,"unmistakable":23560,"legacies":35977,"amino":24728,"obstacle":16273,"vhs":12570,"wires":16383,"ichigo":41267,"category's":9464,"usgov":30714,"aquino":25700,"clerks":13355,"moribund":44077,"tajin":6563,"vn":45206,"now's":33710,"frenzy":21950,"surroundings":23433,"evicted":48368,"behavior":912,"beauchamp":44960,"gens":41792,"she":221,"gtfo":14738,"excuse":1599,"unambiguously":9902,"hydropower":34645,"thankspam":42241,"cleaning":3488,"wizzy":49174,"dramatists":48783,"outlet":9946,"synth":6660,"lots":1650,"harvnb":34878,"longtime":12352,"smartse":33791,"robbins":24228,"edit'":49762,"voyager":31248,"postmodern":24722,"satanism":10477,"說嗎":47724,"gutless":28510,"fowlers":44375,"brooklyn":10507,"escorts":39721,"belts":15225,"ballot":10033,"afd'ed":35093,"goodnight":21282,"upgraded":13246,"blog":1334,"poole":17525,"rosie":25205,"exam":12712,"obscenity":31140,"phelps":9722,"finno":24364,"shouldn":33872,"adhesive":25779,"affected":4001,"bordeaux":29224,"notdir":32753,"pieces":3104,"restoration":6483,"ethnocentrism":34566,"insanity":10566,"agin":39015,"phar":23146,"spics":7304,"trumps":12814,"attend":4879,"merger":3352,"permission":1412,"lana":15795,"shills":19906,"aeroplane":24415,"war'":22808,"mcelite":18801,"poc":47893,"alarms":32915,"rose's":20983,"transcaucasia":49177,"quentin":42022,"mk":8668,"escalators":42841,"doens't":26831,"venus":12548,"mysweetoldetc":21507,"superb":12928,"researchers":4127,"telekom":26427,"residents":4846,"innocently":25554,"sambo":26569,"jainism":16831,"exerted":27799,"mountolive":33326,"ugliness":26696,"tomasevich":44574,"november":1139,"sap":28082,"evacuation":17828,"band's":8414,"royale":31448,"dancers":21606,"museum":3122,"hoysala":43012,"byp":38842,"galle":46071,"streamed":41368,"vandals":2261,"quadratic":29336,"winnipeg":16283,"decorations":22576,"constitutes":2419,"saludos":40100,"academies":27228,"radiation":6160,"palaces":24576,"roaming":30169,"xiii":13686,"dell":16698,"yorks":33302,"academicians":39119,"objectionable":7876,"buu":12044,"definetly":14803,"gliese":29882,"jimmu":27376,"gini":39602,"climb":13193,"reached":1605,"chop":11585,"selectively":9237,"erstwhile":20595,"victory":3701,"dsm":12979,"mentone":45844,"jarl":36761,"lepore":34106,"worlds":5800,"shooting":3617,"when's":36723,"stroked":32531,"drv":5667,"rocco":27602,"orissa":26992,"primetime":30649,"appearance":2448,"gunmen":24868,"ryan":3067,"alienating":37203,"requirement":3337,"villian":24578,"foretold":42390,"ekman's":34810,"telangana":38383,"raptor":28555,"shoto":34415,"crankery":39238,"adj":30664,"transliteration":8080,"agitation":34401,"turbulence":26035,"cooldown":41818,"monorail":21936,"irritation":23440,"estate":6135,"maharastra":43703,"editorialized":46207,"rcanderlori's":49091,"ustase":25888,"pornographer":30693,"ppm":20990,"sampson":47088,"watson":6556,"appeared":1718,"altetendekrabbe":13819,"digit":11639,"stemming":17844,"secured":17747,"experiencing":13100,"cheerleaders":37425,"salary":12496,"stormie":18081,"kangaroo":12110,"aaron's":37410,"discus":22134,"sparkling":23557,"whoever's":38059,"sca":29080,"rfc":1185,"committees":17172,"biology":4678,"longest":6069,"1v1":49476,"scots":9052,"hersford":43457,"genocide":2540,"lamentably":48670,"thdl":36999,"iko":49451,"fret":22360,"distribution":4508,"state's":11622,"inspired":4026,"interests”":40241,"wholeheartedly":11875,"articulate":12798,"determining":6994,"unjustifiable":17545,"publics":25124,"sockpuppetry":2339,"kenosis":18757,"khalistan":37124,"muses":40822,"sponsored":7638,"reeves":14477,"emigrating":37972,"runners":20973,"anthroposophy":26135,"acquittal":24404,"adherence":11749,"innaccurate":24948,"tolkien's":26130,"tehreek":48348,"missionary":10953,"viridae":31672,"children's":7916,"'04":45414,"oppressive":17898,"wirral":31771,"hammy":46159,"behave":4714,"personality":3666,"gunboat":29932,"amd":16118,"countrymen":25506,"colvin":31814,"pacify":48589,"cunningham":13590,"pastime":29142,"asiatic":14575,"misery":11130,"'is":29178,"entail":24787,"medalists":33828,"geogre":17587,"uchiha":31570,"every":295,"meatpuppets":11289,"withstand":18486,"berets":46236,"stevie":22839,"lololol":30673,"consenses":44908,"amc":20718,"girllover":49840,"elektric":38430,"unintentionally":13516,"retardo":44453,"philippine":8251,"altenmann":37601,"defintion":16535,"houthi":30666,"ndenison talk":38000,"implants":20679,"engines":5485,"nityananda":28464,"recited":37280,"analytics":40029,"toto":24054,"kharkov":36944,"'bias'":41395,"truco":37227,"flies":9820,"a7":3060,"angika":38938,"kk":6447,"'general":49025,"pae":32672,"innerhtml":46823,"gsk":37595,"disadvantages":18564,"heh":5449,"heller":23730,"url":2745,"wen":19342,"theredpenofdoom":14745,"hurst":40272,"antidepressants":41791,"wath":40466,"tizzy":44579,"copypasted":32545,"protected":1209,"familial":41479,"insurrection":31576,"indebted":42895,"clamshells•otter":32614,"offensively":41935,"felt":1554,"waterboarding":18931,"banner":3655,"commerical":27524,"emirzâde":31862,"cryptocurrency":34630,"criminality":32118,"heightened":40862,"orlando":15729,"abou":18754,"kalpa":33532,"deploying":42457,"raging":16621,"haughty":32698,"marbles":30775,"veins":25166,"goddamit":34039,"occurs":4737,"capitalisation":10546,"conurbation":24344,"cleaner":14440,"northward":42845,"yahweh":12889,"reson":36614,"'facts'":26703,"northridge":47346,"caching":31377,"boghog":42794,"nightwish":31697,"shuffling":38104,"vecima":43798,"'e":36803,"moonlight":23655,"uncovered":14510,"sponge":24950,"wnt":38058,"molested":25923,"dragon":5299,"ukraine":3647,"ny":3760,"republic's":34082,"automaton":33007,"nabataeans":31126,"clusters":15791,"capitol":14320,"ungraceful":31064,"anion":36190,"hilo48":46779,"findarticles":24571,"1800s":14177,"intimately":21896,"extends":11456,"plunger":47166,"'":1062,"chinks":32325,"antidote":25665,"shirts":10616,"greats":34350,"pernamently":48694,"magenta":25652,"vaguer":47688,"'abad":38329,"prefers":9578,"pure":2194,"forbidding":23438,"fielded":22409,"gulag":20084,"angler":13822,"bookshelf":47771,"breitbart":24020,"newspaper's":36965,"versus":4506,"tajikistan":23787,"scrolling":18440,"musings":24686,"religion":1055,"mills":8283,"fussed":32780,"telecom":35039,"canada'":39902,"customary":12870,"envall":48035,"abhishek191288":37724,"utrecht":44701,"degrade":13390,"womans":34441,"brandy":20642,"govind":25199,"government":631,"digg":13230,"corn":11362,"adriaan":49868,"chiros":47605,"alumni":4319,"laboratory":9341,"biologist":16318,"bibles":24341,"ideological":6168,"2x":19396,"chronically":31325,"hms":14030,"positive":1443,"usage":1248,"persianized":31423,"minions":17553,"uncritically":27867,"buying":7443,"matia":35113,"insists":6460,"piping":15368,"uss":10146,"anniversary":5812,"downs":20765,"dazzling":49428,"salutes":24935,"timonia":38261,"emphasising":29995,"tens":7238,"smalljim":19001,"taints":45902,"ውይይት":16288,"concision":29362,"upon":859,"mom":3916,"fief":40549,"fortifications":19374,"micheal":30872,"rule—should":42736,"amharic":49320,"dvd's":22989,"potency":46852,"thinly":15736,"arabia":7347,"drugged":41835,"blows":12130,"winged":26659,"wikis":5322,"sampling":15164,"analogies":15029,"smokin'":47181,"film":673,"junkies":36792,"slovenian":13922,"pbx":27240,"deranged":18722,"'keep":45634,"mucking":19578,"eileen":40800,"encyclopaedia":3109,"choral":19149,"paprika":31599,"pithy":37213,"juggernaut":33815,"'under":40842,"ceremonial":15435,"blackwell":21986,"wikifriend":48761,"shadeed":42711,"notrhbysouthbanof":2903,"weakly":22414,"stimulated":33656,"hijab":38468,"continuations":43248,"sc":7949,"polytheism":35570,"ahs":27914,"custom":7243,"dog's":17156,"stance":3737,"sai":12137,"argentine":11790,"daco":37193,"pdfpdf":49736,"royboy":43494,"users'":7050,"metrolink":46908,"inuit18":36932,"mistaking":23267,"syn":11135,"wikilawyering":9892,"srpska":33153,"lachin":45405,"atitude":44881,"enormous":6336,"hippies":34437,"frawley":43111,"spui":15293,"resemblance":11168,"downhill":12841,"coca":14733,"simeon":18126,"mondo":49996,"uncritical":29561,"pomona":42141,"utcursch":21072,"institution's":16888,"summaries":1843,"senses":9085,"slice":23362,"stokely":49778,"salar":43942,"amongst":3684,"treading":19200,"rotations":47103,"shii":17763,"dreadlocks":19464,"harrier":33235,"middleweight":24652,"appreciates":14615,"doesn't":196,"siberian":21529,"scallon":42733,"gunshots":46796,"rajeev":31621,"hypocritically":33789,"cocos":48534,"spontaneous":13741,"wheeled":49017,"sociopolitical":39424,"generation":2781,"britannica's":34578,"eyesore":47582,"saltlake":21205,"sickening":13621,"shooto":41608,"wps":28580,"jpg‎":42883,"lonesome":35560,"nietzsche":17239,"60mod":30408,"ekaterinoslav":47657,"lemonade":34043,"vegeta":17918,"names":532,"mcfarlane":37626,"montrose":33855,"tally":7413,"radioactive":20309,"doses":17950,"eastman":26027,"reinventing":30486,"hinder":13019,"socialism":4817,"terminating":30013,"depicts":10831,"irate":16678,"lakoff":46561,"pinning":24954,"kumanovo’s":39270,"after":148,"denigrates":29643,"veggietales":3784,"skimpy":45478,"threating":20419,"wheter":24423,"discretion":6815,"tuple":47419,"blanchard":23872,"literary":5283,"operations":3948,"intact":6937,"kinsella":25782,"chitto":34824,"nellie":40610,"grown":5108,"tania":39622,"arling":44147,"anytime":6105,"boys":2880,"treat":2715,"deux":27336,"plainly":6439,"chevy":43161,"tying":17961,"fair":269,"balloons":21713,"overload":28314,"vertex":32907,"feci":35953,"jesus":1279,"loaded":6098,"ridgway":46991,"alva":43797,"tanning":17783,"absolutly":14621,"argentina":6238,"mahajan":43678,"finals":9283,"extras":28485,"drab":49491,"pyanda":37857,"seized":12361,"enfield":46664,"venues":11169,"cr":11762,"polyakov":43424,"steamboats":32313,"halloween":8451,"subwayjack":23283,"alert":4732,"aldrin":34972,"randomised":46781,"'11":49479,"sedative":47965,"attackers":15210,"psychonaut":41302,"libellous":13078,"polskinarodowiec1985":49257,"looked":1072,"vwp":47676,"f5":19365,"turnbull":24005,"bakutrix":29770,"villains":13273,"slightest":6427,"textile":29449,"slavonic":28157,"jou":30865,"secondly":2573,"equating":14931,"pellegrini":43413,"gol":48633,"catalogue":11085,"maris":49147,"pour":10272,"westport":40970,"orphaned":3413,"moniter":42734,"regents":49359,"carbonite":21414,"damnatio":34483,"bobrayner":20451,"dc":3361,"7th":5273,"softimage":42156,"gambia":14815,"klingon":27853,"edits'":31013,"t1":18182,"carotta":38705,"bondage":17074,"deletation":37499,"rigged":13831,"jsa":47503,"haifa":24865,"sein":32089,"madeline":27702,"ayyappan":38596,"bid":9009,"outvoted":36252,"councillor":15624,"modification":6975,"affects":7393,"cory":13210,"periods":5771,"yankees":8614,"akkadian":23221,"rafsanjani":36922,"png":2157,"collapsible":11794,"chiefs":11768,"strategically":20311,"devising":48196,"sence":14406,"isen't":48428,"fossett":47780,"lang":11733,"monaco":17316,"designated":7060,"emigrate":33863,"taught":3446,"js'":39960,"arising":14238,"mariana":35773,"favre's":42366,"banias":30875,"sore":11194,"adminned":36278,"corrective":25147,"carville":42985,"interviewed":6909,"ucr":26551,"syd":31948,"atack":27025,"deer":14936,"prussia":10586,"geeta":21708,"idealism":25085,"berksguy":45112,"revise":7382,"orignial":47740,"afding":47283,"retinal":48227,"deuterium":28517,"g's":26342,"pulls":18563,"lolcats":36226,"globally":10655,"ziua":40653,"players'":23254,"medieval":4729,"ihr":28260,"0001":17971,"indoor":15381,"withholding":28683,"fledged":16761,"juicetalk":18033,"bloggs":33965,"aquila":48778,"uneasy":20410,"assh":37318,"stateless":35158,"waving":12442,"pos":16559,"arthana":42840,"xfds":49735,"extraneous":11155,"qv":33493,"chzz":7282,"joseph2302":36840,"contemptible":24674,"bossy":20705,"coe":19904,"ciara":20386,"britton":39030,"amazonaws":23822,"matching":9142,"fucken":12717,"instat":35107,"repeating":3909,"rooster":29591,"permenant":33558,"cup":2451,"mob":5961,"finkelman":36067,"gal":19983,"water":1448,"hobby":5793,"20therapy":47572,"digi":37930,"wesite":48424,"whitelaw":46048,"juggling":41188,"punch":7925,"hotchkiss":44244,"taxes":6309,"mane":30400,"imagery":12309,"donating":8604,"blofeld":6683,"dixon":15170,"jtkiefer":20614,"duff's":45581,"negotiation":14562,"powerfulness":31529,"substantiate":7313,"j'accuse":35166,"overflow":31342,"whatamidoing":22828,"autoformatting":14088,"ptsd":18304,"vissi":23845,"salisbury":42215,"bayless":37439,"henman":40552,"carisoprodol":49333,"•talk•":16643,"penitent":31729,"epilepsy":28139,"joseph's":26446,"enjoy":783,"buckshot":35135,"audi":21034,"kanzi":23158,"ordinance":27911,"drmies":6927,"edward":3830,"appropriations":38967,"securityfuck":3629,"disapproval":16544,"lifestyle":7821,"whistling":47706,"ccm":24085,"mbork3":46199,"attractiveness":32752,"crud":32512,"magha":22039,"wikistress":21931,"lullaby":42014,"accord":8753,"unions":9565,"accounts":1145,"triplets":38478,"explicitely":36166,"succeed":6050,"vide":41082,"kesey":42785,"remarried":42989,"contestants":13865,"within":535,"triangle":9682,"voting":2772,"instigated":15219,"newsorg":37182,"surgery":5231,"sardinia":26077,"pws":45641,"expenditures":37830,"tarot":13408,"propositions":20163,"wm":15889,"races":4231,"jezhotwells":49944,"prendergast":49703,"coh":37630,"bearable":40013,"strayed":37374,"ryanair":16397,"lea":34960,"hat":4334,"twice":1794,"vm":19870,"antoinette":20027,"negima":39900,"clans":10222,"lazar":15931,"dhimmi":24626,"honours":12676,"że":48069,"carve":42199,"rearrangement":34083,"unfalsifiable":34179,"obligatory":22218,"closer":2904,"riches":48603,"coolcat":23940,"nõmme":43183,"visually":10452,"neti":46050,"vocals":8179,"companions":21724,"reba":46738,"galactica":21419,"needs":351,"administrative":2742,"russell's":39328,"bronx":13917,"granville":34994,"telepathy":24484,"highland":14398,"wmc's":36296,"fuckbags":8542,"mechwarrior":38614,"turan":40526,"moral":3389,"cedff2":38918,"jewfaggotmongo":49435,"blonde":11555,"securely":39736,"persoanl":42826,"byron":15961,"skiing":14479,"bumping":35603,"novgorod":33922,"medley":35099,"timeshifter's":41838,"vilification":35381,"applications":5113,"applicability":17617,"centred":13776,"taku":37883,"sonenshein":29221,"pertinent":4550,"rauf":42708,"barlow":23659,"vandilize":43309,"massagetae":18324,"petersburg":16219,"provokation":49421,"catt":46166,"atlan":38427,"oops":5463,"brain":2333,"conserving":45367,"blpcrime":25978,"monopolies":32920,"krsaborio":45813,"reliability":3551,"enthusiast":18322,"burnt":11610,"repute":25904,"sheldrake":21284,"glaringly":28052,"uplifted":40836,"mau":48815,"deeply":3605,"e1":35576,"acounts":35013,"kiefer":23001,"wayside":23321,"hahahahah":42091,"1920s":12203,"tolerances":48494,"arbpia":38027,"cumbria":34089,"diff":1218,"silla":33468,"caribs":21492,"murray's":45839,"reggie":19441,"dinosaur":12142,"prolong":39573,"enriching":23288,"deg":43059,"austria":7637,"profanity":7309,"bayesian":21823,"jeffs":25726,"propagation":18944,"edges":11732,"whatlinkshere":23736,"debtor":45851,"biast":48618,"infra":39026,"pov's":15561,"russians":4683,"jap":46564,"cherian":29813,"consecration":32179,"jure":17652,"river":2270,"jung's":35557,"summed":12073,"gag":13473,"namespaces":24137,"courses":6370,"breasted":39983,"yunus":38725,"havoc":13804,"adept":23019,"rot":7411,"article's":756,"llama":33120,"imdb's":48117,"vintagekit's":46171,"bunk":22713,"applied":1906,"islam":1513,"ord":35476,"capitulation":32722,"reading'":46466,"mazda":46358,"shariah":20944,"disingenuous":8652,"destroy":2682,"hermaphrodite":27510,"sanello":24145,"rr":13198,"sleeper":26213,"darood":23676,"lavender":20228,"blot":40520,"purging":18530,"accessing":17133,"lucas":7137,"atheist":2640,"flinders":36749,"zebedee":16590,"chat • rff":18431,"thsi":25282,"praises":15099,"verbals":22793,"december":1095,"woodruff":43726,"ddstretch":33048,"courts":4581,"karmafist":28425,"workout":36271,"bcoz":35356,"taxon":21681,"recreate":6444,"muscles":17606,"flawlessly":47595,"magizine":47954,"reflected":5216,"lantern":15541,"pasting":6140,"azizbekov":45636,"tor":8631,"obciously":47581,"reworded":8018,"shirt":7416,"apologies":2051,"comfort":7084,"valves":49018,"conserved":30536,"overreacting":19850,"undeleted":10774,"inadvertantly":29030,"slipping":19232,"gamer's":47823,"kainthescion":38415,"ankle":16041,"assert":1745,"outfits":23555,"wiked":28870,"gcse":38245,"holodomor":16875,"soman":49909,"kuala":33147,"dan56":15536,"liphook":37379,"yuppie":28007,"zafarnamah":39239,"evoking":44995,"v6":39077,"calculate":11273,"liked":3765,"company’s":26539,"videogames":31607,"autobiographies":26864,"realtor":30170,"erie":25138,"accessory":40231,"prudish":30074,"hitchcock":36458,"reptiles":31017,"kapampangang":41810,"reza":23689,"relocation":16788,"→2006":34616,"supplemental":32341,"unfinished":14644,"detracts":16969,"thrones":48243,"0ºs":47558,"hell's":37926,"toss":9681,"unfair":2586,"subversion":32712,"cetacean":49979,"umar":25281,"robust":14347,"regards":635,"1080p":33990,"fauna":14981,"bracelets":37051,"devious":27862,"holocaust":2468,"cat's":43094,"scott":2975,"vis":8028,"ryu":18398,"maimed":38416,"wraps":48871,"journey":7160,"atheists":6621,"islam's":42697,"wilki":42160,"wankers":15453,"wembley":27158,"circ":26489,"baron":9159,"curios":45694,"respecting":9697,"—123":38965,"stronly":45068,"scapegoats":39635,"geoff":14012,"appraisal":19124,"kh":49711,"supercritical":31403,"menacing":27731,"articled":46008,"bali":16957,"pocahontas":40602,"sia":20858,"technically":2513,"forefront":23067,"godforsaken":39312,"baird":31601,"congruent":29805,"photographers":9911,"denies":9310,"accumulated":16563,"frequencies":12233,"goin'":27987,"pensions":27903,"discount":11242,"irreligious":34774,"worships":23472,"slovenes":29715,"hefner":35747,"employees":5086,"ebsco":36436,"theresa":13746,"thon":11777,"ifrs":31393,"diachronic":47774,"aggravated":18384,"akradecki":35215,"loci":43976,"foxman":43304,"dioxin":43288,"heer":41084,"dulles":24543,"relapse":42194,"springs":10772,"decorum":23342,"dsx":44083,"mclaren":24136,"inquisition":14285,"licenced":23684,"bachrach":40356,"hotline":30471,"foot123456789":23889,"uni":12035,"headphones":32442,"tlk":11783,"gp":12186,"fear":2378,"coining":30910,"deformation":23144,"motherfuckers":16062,"disgruntled":14586,"sustenance":39242,"norman":5452,"varied":10480,"alla":21632,"guy's":7596,"azeris":9916,"abjectly":41885,"clueless":6662,"purposes":2302,"advancements":36021,"cells":5262,"sainis":15467,"periodically":15272,"hummingbird":39368,"hl":4706,"whovian":29673,"deaths":3856,"verbosity":25144,"perry":7729,"svg":3841,"songthe":21637,"murdering":13258,"enlightenment":11574,"lock":3970,"fan's":31101,"gwen's":42344,"utilized":13997,"especial":31391,"impregnated":35114,"schultz":19349,"loan":7737,"opéra":49170,"https":1918,"peach":28788,"eight":3606,"leidy":48418,"reflects":3745,"delisting":28213,"minting":28150,"mamas":3126,"camouflage":22157,"purview":19865,"rang":21755,"lemba":47010,"with'":34899,"conclusions":2878,"ppt":32132,"suryanath":29057,"sarcasm":6612,"pathetic":1810,"financial":2443,"reciprocating":48437,"ate":11146,"utc−5":22908,"fooled":11765,"fanfiction":37245,"motivates":15709,"kosova":11517,"stylized":16958,"legislatures":25520,"allthough":49094,"jews":767,"moivre's":42359,"sixties":16823,"ardmore":48565,"cleo":41179,"zyxoas":29656,"ecumenical":30257,"yeezus":36695,"margaret":9035,"zaido":38190,"biography":1403,"result":732,"gulen":31478,"thenatureboy":41504,"kirkpatrick":37142,"mideast":35054,"mabuhay":28386,"gnn":45879,"homeopaths":42070,"sanitation":32683,"intonation":33221,"angiotensin":40408,"compliation":34900,"emmons":37950,"activation":20786,"unaddressed":32500,"hwy":18269,"domination":10106,"strategies":10611,"lingam":30922,"deletion":106,"tickets":10296,"bolivian":26450,"parser":28442,"teenager":10921,"orton's":42825,"woking":36464,"infonerd2216":26300,"predictions":8413,"wrestle":18385,"discounted":16741,"sincerest":28311,"nutmeg":34712,"como":18749,"splat":49378,"dingley":23882,"circular":6182,"memy":25724,"bokmål":46456,"swaying":47760,"bsd":18602,"congregants":48314,"ea":8453,"♥":10216,"unverified":7480,"tks":27436,"switches":13559,"akbar":14651,"cohanim":12409,"gump":24268,"could've":12614,"y0u":38126,"dialect":4243,"undiagnosed":48354,"threesome":30785,"dumber":22570,"violet":15567,"klat":45840,"hatnotes":23871,"exceptions":4313,"album's":19190,"ditch":14726,"reaches":9026,"tarcisio":44349,"arguably":5126,"'verifiable'":43296,"“it’s":40216,"gsc":34364,"infamous":7458,"passively":26448,"prem":11523,"sveti":31655,"rebuffed":27613,"epstein":37320,"englewood":37613,"transliterations":15150,"mold":19160,"angrier":33217,"toad":24440,"rephrased":12823,"oldies":33094,"danish":6307,"apologetics":19984,"artistic":7660,"changes":413,"athenean":32615,"inclusions":17755,"hailed":32629,"kiwi":20916,"equity":14227,"perlmutter":42462,"bluelinks":33972,"chaldean":16055,"cfc":42303,"yardstick":32368,"8pt":28285,"misprint":43441,"quadrant":24201,"pretense":12745,"rx":36709,"gregg":48217,"currentstatus":26660,"castillo":47633,"subjectively":21302,"tc":6704,"addendum":11532,"apartments":16074,"owe":7630,"fragrance":48949,"genius":5577,"page'''":37612,"н":38907,"namco":42188,"anchorman":43011,"joplin":31690,"stunt":14814,"commissioning":44846,"conspiring":27235,"cycle":4410,"rejoice":33883,"declension":33071,"parity":22865,"nns":40879,"bowes":39826,"juveniles":37655,"thoughtful":8392,"samoa":8599,"bearings":49114,"maintainer":32563,"strenuous":30721,"hrc":36415,"facing":6260,"enlightened":13963,"comite":45958,"disclose":8868,"scene":2746,"scrolled":37325,"assimilation":12809,"adriatic":18978,"fon":46021,"rmb":45344,"zack":21516,"grape":22979,"substed":35832,"geoeg":35662,"¨¯":26974,"tables":3075,"publisher":2789,"shuba":44492,"denounced":17491,"filet":44145,"mullah":20670,"cmon":22948,"drives":7002,"algorithmic":30791,"twisting":11891,"kill":1026,"cl":14543,"sermons":25470,"line'":47203,"gbp":34796,"longview":21107,"hagin":20230,"psuedoscience":41709,"offshore":27849,"muscle":8488,"wyss":26398,"ashby":47258,"goodfaith":29268,"frighten":20120,"girls":2763,"belle":14727,"forbids":14041,"clearest":17674,"mortar":27273,"othe":36459,"owed":20734,"infallibility":28166,"truthfulness":17881,"lia":29167,"generals":7900,"dokie":33159,"router":12288,"timeout":30298,"procrustean":48000,"disputable":21535,"rephrase":8867,"evangelist":32490,"dw":37620,"carolmooredc":43192,"dare":2509,"kum":29535,"fgc":27117,"poser":30111,"beehive":25492,"screenwriter":30567,"measurement":6763,"sclient":27239,"académie":35473,"still":156,"colloquialisms":41384,"emergencies":34880,"shalom":11262,"mic":21696,"albuquerque":24618,"embraer":32415,"ld":23348,"overview":3108,"fez":29708,"huffingtonpost":30361,"◦4":49136,"root":4211,"vpn":26013,"plausibility":31452,"resident":5321,"pitbulls":37337,"handcart":48432,"correlate":16763,"subheading":11788,"spike":13154,"heavy":2578,"conceptions":24082,"upping":30650,"unneeded":12134,"hamilton's":26303,"phonies":38026,"obstruction":20726,"tiraspol":36260,"siemens":18928,"thewolfstar":35734,"nanak":24307,"reductions":29236,"noel":13856,"ive":3682,"posse":21056,"bazonka":40157,"ago":612,"solicitor":22625,"phobia":12183,"tadeusz":45940,"rooshv":24153,"thorns":40493,"ditching":47864,"learner":47218,"nichalp":16409,"prekmurian":20190,"2f":17805,"dudes":17741,"lingpa":39495,"servants":13159,"streets":6558,"emphasizing":16960,"pradesh":7785,"i'v":31833,"false":607,"wal":9655,"pumpkinsky":40028,"marduk":44887,"hohenzollern":30010,"usl":48202,"penn":9421,"turning":3858,"be——critical":37304,"remorse":24487,"audition":37496,"sergio":18751,"topics":1345,"highlanders":23405,"wealthy":10371,"juxtaposition":32192,"uniformitarianism":46416,"fit":1414,"undone":4876,"brainwashed":11251,"tif":41176,"grasped":36385,"crossroads":19919,"zimmerman":13677,"chalukyas":10603,"endlessdan":24746,"clef":44041,"kristen":30557,"preach":11393,"fembot":37864,"filmed":12833,"lerner":22338,"rajakeeya":37990,"perceiving":30207,"laptop":10252,"harland":48436,"politician":4169,"—rybec":47483,"quotient":35635,"iyer":41280,"idolatry":38568,"3's":32327,"hazaras":29827,"defenetly":35782,"ultra":5046,"sutlej":44371,"openion":48768,"vomiting":30538,"carbon":5725,"motha":21051,"secure":7081,"email":748,"restart":12597,"magazines":4360,"674ad":37524,"feelings":2537,"resellers":49908,"dailies":35885,"rubenstein":33005,"mindedness":20115,"drug":3133,"deductible":46240,"desirability":33941,"conducted":3983,"hierarchies":23037,"saaaaad":16989,"morales":22239,"ntt":45814,"leak":10450,"jitse":30565,"relaxed":14058,"eaten":11091,"discrepencies":31727,"wikitravel":21193,"pineau":38794,"direct3d":38814,"exposition":13549,"nkb":14451,"henriettapussycat":36652,"bengals":20231,"pratyya":27572,"vojislav":48411,"quartz":44822,"crouch":27390,"low":1300,"traci":32989,"observance":30600,"dickweed":38951,"cosmic":12176,"29t20":48859,"ignoramuses":26499,"popularity":4375,"islamic":2086,"observer":5811,"memebers":34201,"intimidated":12583,"litigation":8468,"α⇔ω":15651,"thr":26604,"aggro":40784,"friendliness":45183,"eidts":44355,"yolk":46328,"fcc":16114,"rennocks":47257,"tutorials":20732,"stephenson":45706,"workshop":6775,"incorrigible":40060,"zdnet":32514,"quantitative":25382,"cite'":39717,"ghirla":37146,"dancing":6084,"spiritual":5682,"tungsten":29218,"pete":6686,"cyberpunk":42549,"warmed":37876,"proceedings":6789,"aerosol":28765,"schreit":22280,"themself":12924,"airplay":16136,"einsatzgruppen":43628,"dpkg":49927,"commence":21657,"barney":14694,"incestuous":36770,"nujs":43970,"freelance":17643,"codified":29259,"chests":47141,"lovechild":34641,"sandifer":28119,"militaire":33650,"list":163,"g10":17324,"nathanr":46523,"volvo":38666,"kicked":5594,"lien":25545,"resultant":21423,"landow":44033,"ortho":41554,"strengthen":12977,"sm":11645,"crooked":20209,"frothy":45760,"mariah":9337,"santana":23161,"aoluwatoyin":18677,"anome":27935,"manager":4090,"regenerative":31591,"afloat":47668,"emigrant":22036,"priced":42488,"fallon":41177,"perplexed":20917,"jkelly":35537,"conveniently":9326,"sworn":10006,"visualize":42095,"imphal":34386,"punish":7189,"shunning":42970,"ole":20680,"weezer":4083,"baloney":12379,"colombian":20402,"pro":864,"mqs":47416,"i’m":4311,"kiddo":20901,"’":8230,"tvguide":29117,"h1":46920,"exceeding":15290,"exhaustive":12835,"attendance":9931,"donate":10176,"bitching":11672,"dado":23108,"tersely":32803,"deposited":20959,"beard":12394,"sympathise":22086,"etiology":49508,"biosphere":46290,"master's":12751,"daughter's":18821,"backbone":18276,"reconstruct":23566,"undergo":15120,"'australian'":44532,"sweater":32528,"astronomical":9209,"caleb":21361,"germaine":31221,"nellis":26874,"constructs":19206,"ite":41704,"modal":22463,"rising":6931,"lovin'":32975,"briefs":24009,"educating":12263,"leagues":8833,"christine":17607,"occult":13015,"munch":25113,"logout":38802,"ironic":5228,"bitcoins":20586,"isan":15185,"permits":9887,"screwjob":31915,"confessional":28968,"georgians":15804,"alot":3008,"homeostasis":48474,"titanium":19570,"bundles":36460,"spa":7343,"emigration":15560,"chumps":32677,"poughkeepsie":38211,"filmmaker":18874,"ke":14233,"flares":30492,"intricately":48850,"looks":574,"successor":8168,"lilley":48883,"gadaffi":39041,"prooves":28990,"fulfilling":11823,"ετητης":15308,"saturn":9925,"tabconsole":44154,"espionage":12311,"viscount":41532,"anna":4549,"idol":11233,"refb":47793,"personal":203,"jpg":453,"notdoppler":48877,"mesolithic":39214,"β":27413,"hbc":26543,"team's":19680,"war's":46341,"makeover":31371,"assassins":19295,"tokugawa":35930,"agrizoophobia":46939,"molluscs":39302,"bottles":19831,"dinaric":19490,"monopolizing":34123,"galatians":49098,"factocop":48521,"canvas":14151,"bras":26908,"oxymoron":2953,"infrastructure":8035,"deserving":8493,"busted":12898,"zuckerberg":11067,"benji":40544,"eliminated":5500,"hung":9590,"idea":414,"reaction":2605,"copacabana":20151,"esteem":9922,"fairest":39165,"wv":21096,"fact":160,"moines":35763,"ont":28187,"kwamikagami":27288,"rtf":39618,"carpenter":26917,"mourning":26234,"considered":408,"llp":34767,"heavily":3090,"administer":18455,"beginnning":45861,"prostate":17825,"py":24616,"forts":39184,"efc":33757,"⚇♔":37944,"zebra":28128,"louis":4430,"grosses":44659,"cultural":1924,"ignatieff":32613,"stung":47629,"ilchee":30550,"arritt":46203,"emancipatory":49558,"kandel":42925,"orient":38080,"fo":9595,"sandboxes":18227,"actuality":14264,"schmuck":30563,"yoshiki":33638,"glenn":8447,"aishwarya":47295,"inquires":37047,"sprotect":48819,"farewell":15641,"✎":15926,"whitehall":43195,"indica":48885,"bowden":36859,"ferocity":47832,"gauntlet":32245,"agnostics":31661,"had":99,"woolworths":27852,"town's":39181,"increase":3056,"terminus":18266,"'''":2785,"tragedy":6963,"deckard":31557,"☏":10999,"sez":24477,"confirm ":16872,"temps":47427,"humint":35329,"petrol":16211,"earthquakes":21460,"rebellion":8155,"garter":29977,"morgan's":49862,"intersex":29122,"citizen":3680,"covertly":25405,"comparision":28494,"vaporizer":37178,"galley":34029,"molehill":42997,"officialness":46057,"hairless":37768,"kirosheev":47195,"technate":24283,"bellied":32443,"errands":37343,"condescendingly":46490,"censorhip":45578,"binder":47856,"parsons":18908,"orlady":11174,"wwii":4747,"pataliputra":34227,"brash":47983,"otters":9640,"cracow":49161,"uprisings":28323,"hogmanay":49439,"learn":596,"playstation":10860,"astonishing":14329,"breedings":46768,"voyage":14474,"trollish":12364,"conveying":15570,"opioid":35182,"humanism":13500,"linear":7427,"grading":7890,"hema":22714,"williams'":28771,"mortality":12545,"scribe":18271,"km³":29324,"voat":37163,"4's":40453,"rh":46819,"referance":24260,"merseyside":23934,"yogesh":46183,"nicole's":26689,"equate":10668,"rudy":20591,"regurgitating":36086,"nottingham":18823,"synergy":33923,"fierce":17341,"clouding":35277,"tank":5172,"tourism":7182,"shinji":36623,"cascading":48408,"flemish":15203,"crc":25209,"valkyrie":26813,"woke":20610,"pix":21141,"relocate":36229,"subcastes":34361,"appearances":5227,"girly":41530,"xi":18607,"diplomat":11947,"garway":44021,"revenge":5439,"mouth":2620,"boob":18329,"informants":36097,"thakur":25235,"coatings":49684,"portfolio":13725,"commas":11505,"tekrur":47136,"digitize":47670,"folk":4276,"bactria":44566,"ensign":11415,"'belief":46972,"wavelength":25893,"patten":49319,"infers":23224,"pearse":25303,"gotra":43873,"erect":18207,"pavlicevic":30528,"anatomical":24620,"brownhairedgirl":49176,"tryin":21304,"informaton":30630,"advances":10466,"turanism":26144,"heterosexual":9865,"gripe":19628,"hsv":47693,"cuff":33180,"endpoint":40733,"jockey":21263,"surah":36958,"gwyneth":45319,"monographs":24701,"bizkit":38654,"mathematicians":9591,"jaqeli":45842,"tiberius":46465,"vadalizing":36619,"variable":5945,"machina":41464,"fer":31176,"waco":43587,"sectarian":10305,"growth":4578,"refutable":48775,"warred":11018,"ascendancy":43176,"chemother":47354,"fnarf":48758,"featured":1045,"combating":23163,"wdiff":48541,"duffield":38838,"rsi":47328,"interactions":6204,"osli73":27753,"marxism":9889,"violenciafriki":21371,"inconsistencies":10052,"propose":1881,"oddly":8968,"cn":8128,"worldnetdaily":31224,"rationalization":26115,"d'état":26420,"staffing":46104,"racked":48434,"chaitanya":16011,"william's":24480,"hindering":28776,"aisle":45465,"rolandr":33982,"interesting":735,"breen":29954,"incremental":25132,"poultry":27549,"foul":5394,"blowjob":37737,"archers":40165,"ingrid":26629,"stickers":26332,"iqs":35613,"hastily":15812,"signicance":45892,"ek":21427,"delrev":48637,"tequila":31253,"cluttered":12559,"inappropriateness":31080,"developmental":16799,"dag":36665,"inconsistency":8349,"glorification":23352,"matrimonial":31446,"pcp":35140,"cents":6030,"trampoline":35748,"authorative":26645,"thrusters":22698,"sniffer":32562,"accidentally":4865,"xxvii":40643,"dumont":36134,"embittered":36424,"envisioned":38360,"chetniks":26153,"meucci's":44241,"rsf":21060,"cholmes75":31314,"romans":6092,"sidelined":43809,"giulio":31046,"bih":13016,"ordinated":39395,"cked":40562,"uninitiated":22549,"pharmaceuticals":30761,"listen":1536,"untill":9001,"harrisonburg":34224,"and":4,"ii":1545,"toi":32493,"fresco":15685,"bambi":29746,"nether":49835,"encounters":12398,"lopsided":24703,"postwar":30946,"conceit":33287,"monument":8172,"aude":34411,"sharpe":30266,"tangled":24762,"being":90,"ged":21955,"vacation":6709,"thimerosal":34394,"mum":3985,"gymnasts":43436,"sticker":20783,"qld":22678,"can't":228,"bombastic":41663,"'lead'":31871,"parting":23524,"lita":19039,"restore":1968,"spit":9477,"modicum":19991,"priorities":13872,"blasted":27118,"mixture":8645,"elbow":25791,"för":47297,"strawmen":30517,"kp":22381,"geezer":42293,"weinstein":47653,"rock'":42615,"freeview":38752,"outing":5807,"masc":45338,"locals":10665,"ets":37333,"katara":30602,"workgroup":20552,"differing":6860,"pinball":40820,"counsel":7731,"files":1401,"homeopathy":6392,"odisha":33868,"jeez":14911,"beeswax":46453,"obvious":746,"connector":24889,"relentlessly":17288,"boating":43716,"anglophone":20743,"escaping":18237,"duplicative":48212,"looky":17532,"unchosen":40675,"licensed":2384,"hamish":29443,"lamb":18012,"strongman":45882,"homeland":2928,"samraj":31294,"wow":1473,"annoymous":47320,"cheaper":13294,"carmen":20897,"victimisation":37952,"orphans":18100,"cartwright":24888,"dupage":39945,"obtuseness":44772,"nypd":22309,"wheather":36138,"escalate":11044,"hamid":46181,"retains":16542,"rebuttals":17389,"weenie":28625,"plagiarize":14998,"km":6022,"depressurization":34807,"aesop":19973,"thoroughbred":20060,"curves":16347,"jj":14428,"republika":30594,"wallachia":36178,"brining":45358,"launching":9669,"bred":14375,"graham":7819,"tasteful":34924,"disturbing":5264,"retiring":11424,"chestnut":27861,"hallmarks":49918,"consolation":21848,"settles":20365,"foods":8374,"purchases":21347,"viable":6758,"θ":21127,"oxon":49281,"students'":24502,"4pm":45698,"pollard":22903,"khatris":17983,"inducing":22589,"stephane":31757,"militant":7922,"discographies":16122,"cramp":22990,"atl":27044,"proveit":21463,"montenegrins":14710,"alberto":21243,"analysing":23072,"blps":9561,"hellmuth":37195,"rapido":47625,"musicologist":24025,"mission":2803,"audit":13754,"darren":16491,"petal":34697,"registries":9944,"denominator":16813,"morale":20527,"inflammatory":6608,"chetnik":21303,"slowness":49203,"filibustered":44802,"blondes":29154,"decry":43714,"meanie":19350,"'like":49828,"lihaas":32537,"counterpoint":20605,"wobby":40823,"ceausescu":43004,"ca":3177,"education":1528,"fritz":18524,"hurry":7612,"steroids":12346,"americanists":41873,"they're":878,"procedurally":28181,"bolds":49531,"afar":37431,"reporter":5753,"juneau":35631,"x3":13791,"stained":29693,"obstinately":30779,"puerta":34703,"koreans":10107,"restraints":49093,"crt":38704,"glantz":12984,"totaly":19888,"maid":22812,"travelled":15816,"kimp":36576,"dysgenics":22667,"liberty":4038,"maldivian":22614,"sovereignty":6357,"ports":17917,"endal":44235,"nightscream's":34952,"zodiac":13958,"explore":5395,"crocker":23778,"rd":7842,"cristal":44122,"bre":44144,"identifier":23873,"by":32,"forelli":40613,"ironically":6551,"spencer's":41460,"sets":4126,"zora":13056,"hst":35366,"leader":2388,"taht":18361,"glancing":18962,"billcj's":16012,"frere":48307,"joys":41493,"albert's":45023,"cicada":41686,"•¸":31054,"qajar":32437,"brd":7070,"tuf":43728,"forgiving":14221,"protects":11472,"heartbreaker":25705,"zzuuzz":25359,"cohorts":16083,"token":8582,"autosomal":40226,"somewhere":1343,"historias":48055,"reap":22998,"janov":29767,"d'ivoire":24793,"vinyl":17378,"context":755,"dictator":5721,"chief":3047,"munich":12522,"discovering":15692,"course":442,"povs":7787,"distributor":25428,"frivolously":49461,"contraire":48377,"housekeeping":18584,"roberto":21766,"overstepping":31450,"playback":15966,"arcticle":37398,"mormonism":10623,"tink":37974,"sequitor":40080,"santiago":17559,"c835":47024,"reckoned":31525,"amazingly":12195,"formalized":49411,"twins":9183,"dehydrated":40578,"benevolence":27655,"colucci":41998,"pct":27274,"impossible":1915,"pocket":8497,"boils":17949,"crusio":15433,"herding":32470,"tolerable":32431,"sweden's":47147,"vouch":16390,"beseech":38166,"settlements":8129,"separable":49004,"fingernails":29976,"disscuss":49343,"uisge":29460,"pattern":3009,"northerners":35349,"diff's":27748,"coates":44400,"knocked":12877,"gorillawarfare":48965,"redevelopment":35995,"reintroduce":24237,"faith'":23976,"dingo":22866,"tigers":15851,"youvan":28238,"phonetics":14739,"woops":33714,"mia":15216,"trotskyite":48255,"pelosi":13137,"watch":921,"consolidation":18815,"scenery":36549,"brunodam":31837,"wikiscanner":33637,"sarek's":39940,"'but":44449,"chosun":15136,"smear":5809,"brought":1310,"reupload":31955,"flop":15949,"convictions":11378,"miraculous":26362,"gulliver":43339,"tra":41760,"gladys":22703,"ntl":46893,"elasticity":33740,"compiler":10618,"lashes":15925,"antithesis":30092,"nowrap":45007,"yo'":46973,"goose":11730,"delivered":4725,"hopiakuta":15455,"tarnished":24183,"peopel":24521,"enrage":40461,"tba":14825,"tranche":40827,"right'":32251,"msc":30742,"cloverfield":17531,"miriam":20888,"korolev":34587,"fuckign":37191,"swarmed":46634,"thai":6845,"vandalizations":48186,"adhika":49787,"bgcolor":22897,"barbarious":49167,"mikey":26275,"grump":24029,"signalling":26578,"coordinator":9505,"eyeballs":20094,"super":1239,"convert":4438,"hadnt":12000,"krehbiel":31818,"bootstoots":15553,"hamburgers":34368,"east":1282,"redeleted":45624,"politkovskaya":37504,"campaigns":7289,"quantifiable":42555,"size":1350,"citizens'":40321,"barber's":36638,"aldux":18542,"simplified":3849,"biotch":46099,"inflaming":41713,"coinage":29188,"xman52":45504,"mf":13974,"marijuana":10041,"disharmony":48110,"illustrate":4200,"faults":9225,"walled":22627,"lanka":6474,"leben":44568,"リンガ・フランカ":25461,"ragityman":36722,"films":1791,"weil":35029,"frazier":32879,"wreckage":27045,"bell":3783,"laced":34572,"wiggle":31208,"assoc":31823,"hamsacharya":49370,"o'riley":39492,"politicking":32420,"towel":28102,"khozyain":19467,"necks":26411,"philosophers'":45686,"then":83,"quits":28641,"—c":47987,"speaks":3271,"guiana":34989,"elephant":9551,"wells'":31805,"shti":18772,"intrusive":9876,"longworth":46084,"freemen":48190,"santorum":15669,"cosmopolitan":28806,"pissy":40412,"patterson":15461,"verona":49148,"refering":7017,"mit":8684,"research":390,"demonstrable":20998,"cofounder":30412,"transcribe":25432,"knowledge":666,"profile":2364,"allege":12412,"ui":19538,"grawp":26112,"industry's":43329,"standpoint":9701,"frisians":35562,"programs":3272,"doylestownnan":46482,"calibur":49490,"bitches":2034,"flippant":24914,"commentator":8641,"sympathy":7616,"combative":12901,"devoré":45891,"considering":1288,"micoolio101":32717,"codenames":40634,"damme":28570,"grabs":34180,"orientalism":28061,"reactors":21088,"sophistry":22194,"minerals":18139,"allahu":37561,"text'italic":35578,"jia":47477,"licensees":25619,"popped":12014,"calibre":19638,"fart":3001,"sushi":29320,"expectancy":25664,"fonts":12922,"rav":26447,"doa":31476,"berislavić":33756,"westgate":41781,"contexts":8096,"hairy":4917,"beagel":27807,"waxing":37520,"wilson":5054,"e0":31860,"sloan":17493,"stricken":15874,"corpus":14742,"hit":1555,"circle":4445,"participation":3437,"tosh":17500,"oot":36573,"scouting":8382,"donna":15643,"synchronized":38443,"mattyboy786":47902,"beevor":27997,"rer":38708,"miszabot":21262,"roadmap":47347,"ew":14275,"spree":11701,"surrounded":10174,"shiatsu":43313,"deterrence":47785,"emmanuel":24332,"persianate":16869,"steeped":30415,"effective":2959,"fork":5991,"moorish":28389,"fiery":24214,"retina":43276,"cybermen":38624,"md":7068,"collaporator":40251,"krugman":26921,"repetition":8904,"aryan":6266,"tuning":12036,"stoop":20915,"rightwing":37490,"ida":17790,"stretching":14353,"hahc21":39536,"suposed":48595,"redeeming":44090,"nazarene":49173,"cobain":21070,"manguard":30854,"impressive":5659,"accountancy":45388,"klan":8369,"streetcar":23119,"possession":10567,"sempre":48707,"transparent":4749,"gale":5995,"bukharan":27000,"juliancolton":45846,"csr":44751,"spying":27661,"linkrot":36744,"worms":10984,"falcons":43550,"indisputably":22955,"rexxs":40785,"luftwaffe":19187,"topic's":24439,"furtado's":47054,"sorghum":25749,"passerby":36797,"vivekananda":33530,"poem":5684,"gon":22907,"bertha":38266,"aina":31312,"unholy":12489,"codomain":31882,"garbled":36023,"tbs":27284,"lonely":7247,"sabra":33207,"fraternal":22864,"wictionary":47292,"empowered":16677,"fansite":8908,"mart":9122,"capturing":17745,"sociopathic":34499,"vaejo":23155,"region's":30783,"moje":41400,"perplexing":36635,"straighten":14361,"som":21581,"causal":15370,"revelant":43390,"culled":16024,"fut":19529,"ynet":28175,"helicopter":12613,"serotonergic":48613,"room":2108,"'eternity":20843,"eejit":39788,"chaplin's":47299,"equivocation":19517,"vovin":46709,"lighter":8987,"regularily":49035,"unsettling":32109,"contained":2982,"dabelstein":48953,"shankbone's":21991,"reedit":29019,"warrant":3486,"stallings":46961,"present":680,"carmine":35408,"sea":2531,"surveying":23818,"monuments":12117,"structurally":38385,"dismayed":19623,"expo":22518,"venom":9007,"1940s":12453,"railroading":37608,"constitutional":4947,"sachsen":28051,"handball":28665,"unnion":45351,"excellent":2011,"kind":444,"raping":11717,"guitarist":9927,"lifeboat":48439,"slaves":5083,"transclusions":25030,"tomte":38681,"sentai":44357,"neurology":23064,"hetfield":41442,"extrapolation":23231,"'old":14099,"swimmers":41415,"stormrider":35193,"treated":2244,"somebody's":13264,"inlinetaglist":33362,"tasted":37706,"midwest":11184,"criteria":398,"diplomatic":7011,"schrocat":47961,"xinhua":29971,"shadows":10561,"creeps":18987,"icarly":19132,"saddened":14564,"travellers":36810,"lt":12292,"victoria":5390,"woolwich":19899,"arman":24296,"armies":7267,"sniper":11035,"dito":43121,"lolz":16078,"dda":45257,"gloucester":26090,"nutshell":10931,"reek":36206,"since":143,"agriculture":9442,"hail":7924,"malleus'":28227,"corporal":27537,"whether":388,"dime":20369,"zanimum":35820,"flush":19730,"lawn":25276,"developing":4331,"aps":34523,"ballads":40275,"spam":1134,"morse":26024,"hasta":30103,"wikimania":11234,"aharon":45390,"sweeney":31346,"'my":32399,"'revert":48486,"exorcist":39595,"abkhazia":14881,"affidavit":25499,"cyanide":23590,"mulder":34886,"esposito":34731,"spies":16814,"oppress":19878,"saw":709,"alexpu":47730,"motorized":34571,"incoming":10280,"halls":20979,"alphabetize":41551,"horsemen":36075,"oneguy's":44063,"bracelet":32519,"ito":25114,"reverting":648,"cityrail":25990,"stimulus":20570,"justine":12644,"lessons":8814,"too":162,"trys":31322,"embraced":14117,"sarah's":41249,"jewels":37279,"zh":14197,"rafizadeh":23189,"favourable":18239,"imprisoned":15304,"kn":24655,"shrek":36997,"taba":38239,"cellphone":36661,"moore":6246,"selections":15258,"chs":47588,"nec":35779,"shapiro":19727,"rpj":31873,"credibly":30338,"devastation":35727,"understandably":13673,"repatriate":41845,"atrocities":8097,"pinhole":27380,"slowest":40420,"deccan":27980,"he'd":5669,"classrooms":31431,"harmon":35248,"por":12397,"bumped":20881,"unreliable":2485,"slaughtering":34567,"deleat":44529,"isar":43666,"faradays":39230,"hopefully":1354,"seoul":16099,"premie":41190,"boundaries":5620,"snape":27933,"idk":19147,"cadets":20280,"plus":1503,"prilep":36817,"entertaining":9371,"faqs":22061,"define":2585,"marriage":2961,"diannaa":20511,"freddie":18343,"stimulating":42873,"rome":4081,"approx":13236,"apocryphal":22361,"alice":8623,"stings":30935,"the7thdr":37901,"dempsey":28944,"misfortunes":47424,"c1":30990,"go":121,"rajiv":38257,"xue":46678,"encognitive":47567,"evolution":1849,"southgate":27515,"feasts":28254,"tap":14612,"directory":2753,"imparting":43244,"sejm":40143,"rossi":21472,"merritt":26281,"vickers":15451,"warbox":40001,"teased":23638,"rpm":23449,"fiona":36882,"ong":30208,"acidic":49382,"conspirators":20397,"plugin":30771,"dhimmitude":45966,"planning":3105,"vegetarianism":14616,"gatekeeper":24427,"str1977":28780,"pui":25818,"indio":31328,"article’s":39832,"lit":10596,"agendas":7695,"unhappiness":32406,"bonjour":25507,"aqu01rius":44850,"throws":11669,"geert":44497,"colville":46599,"casus":25207,"ahistorical":22529,"dissociated":40670,"dressing":19217,"dishonor":32102,"wagon":17757,"gobind":11033,"society's":21373,"imposition":23618,"backfired":36363,"humanities":9960,"finesse":27186,"triplestop":41007,"wip":33739,"checklists":27860,"indecent":17293,"loran":31605,"ghz":47230,"excluding":6010,"piercing":18389,"insistance":41092,"arkham":24011,"huang":45554,"nonsenses":42257,"1000s":27149,"jefferson":6826,"expresses":11590,"sevilla":39597,"unjustly":13857,"hdz":38930,"wreath":39079,"angelic":20702,"predecessor":12594,"entitle":19847,"rationalise":41623,"partisanship":18229,"gamecube":15271,"monet":34319,"rufus":31118,"caucasian":7743,"tiflis":40957,"provably":21740,"acquires":34242,"staying":5379,"againts":35853,"deport":46141,"sr":5493,"config":23979,"courageous":17301,"ashley":10569,"salle":29803,"amelia":15117,"laureates":11141,"located":1737,"mine":1090,"athletes":8620,"bélanger":27386,"maga":48773,"teach":3660,"fanboy":9039,"testaments":42000,"dictate":8484,"hybrid":8210,"ihantala":33102,"outpouring":48874,"'ll":25270,"cburnett":37144,"scrupulously":26591,"illogic":35684,"narc":48181,"provable":24857,"sleuth":35766,"abecedare":36041,"worthlessness":40128,"harmonies":43762,"tse":36465,"aria":15724,"varma":37602,"unpublished":10233,"denny":19457,"desist":6044,"gaul":33069,"200mg":47167,"patagonia":15425,"source's":15327,"feith":25501,"medlineplus":48089,"swistertwister":33709,"upanishad":29495,"orchestral":39993,"decrease":13747,"في":30288,"daughters":11369,"hyping":30198,"connelly":28586,"sereer":26852,"peres":34693,"keenan":21811,"backlogs":21611,"lahiri":27062,"exemplary":16364,"adam's":28861,"performs":14482,"electric":5148,"imagine":1983,"chavo":21620,"webquests":29170,"abit":15970,"luka":24138,"lans":32685,"suicide":3360,"congratulatory":32116,"preacher":21652,"fourier":14730,"ipad":31962,"unsuccessful":7758,"attracting":15191,"courthouses":45217,"tigr":35543,"spellcheck":32435,"exponent":32971,"weirdness":29097,"pettigrew":44246,"opposites":30331,"drained":29581,"nobodies":25528,"whipp":38039,"expect":1166,"misty":37487,"bbs":21765,"muse":20293,"stripping":17550,"panders":47435,"oclc":22474,"bookkeeping":39897,"j1":17270,"voceditenore":45620,"unpersuasive":44929,"bermender":25088,"commandant":41439,"articl":27157,"locating":19098,"andor":38312,"śrī":41241,"mumtaz":30543,"scholarship":4137,"shoo":25029,"persondata":18529,"scotty":20796,"snowded":15167,"britain'":40944,"estates":19915,"crum":20835,"septuagint":26055,"thew":26061,"epicgenius":37943,"preußen":42886,"autopilot":33509,"misogynistic":29660,"eloquently":23682,"ceti":34387,"controversy":1255,"taiwanese":12621,"fixed":1236,"uncorroborated":37306,"revisiting":18487,"obtains":33410,"tease":18447,"chang":11346,"obligation":6126,"pertinant":39287,"peshawar":30574,"pussycat":46842,"frei":38118,"akin":6971,"potentials":48037,"tito":10300,"toby":14336,"environmentalists":23628,"'70s":27074,"samaritan":25464,"waffling":35981,"composition":6230,"oversaw":49894,"ordinal":13815,"lan":14647,"esmail":44212,"apostle":14860,"sufflay":35030,"filtered":14858,"defenders":13605,"mulroney":27968,"stasi":36320,"geothermal":25954,"marko":24408,"semen":7488,"goedsche":47932,"managment":43456,"integrity":3240,"foam":20980,"disavowed":35386,"calm":3385,"demonising":42627,"javier":17088,"vishnu":15630,"visitor":14557,"picturing":39440,"inertia":11899,"protesting":8935,"expired":4972,"discoms":38520,"leas":38472,"honoring":27307,"lumen":43471,"thet":21908,"fuckingabf":7718,"antony":29747,"blather":30850,"goy":49385,"wasps":40844,"sys":40333,"kicker":35834,"izumi":46496,"peculiarities":43450,"unpaid":16141,"orbiston":49355,"itanium":39161,"screencap":47251,"kim":5263,"jayron32":20874,"kudpung":26628,"shukumine":16359,"classmate":23597,"with":21,"ptolemy":20103,"imran":22196,"entrapped":47764,"isotalo":21715,"angier":20090,"perform":3269,"freud":10155,"megadrive":47934,"kiev":10639,"rehearsal":36063,"humanists":38112,"conesus":30051,"overtaking":22321,"vandal":1150,"curtisnaito":21299,"zomg":25361,"soapdish":49163,"electrode":33799,"judgement":2921,"forklift":45359,"kinder":41567,"pubic":21376,"atleast":6769,"opts":39256,"jails":44342,"colonisation":27804,"recounted":26391,"scripts":7346,"mak":25376,"trafficking":23478,"breakup":22156,"disrupts":18915,"99th":40091,"enumerate":23253,"unencyclopedic":6121,"undated":17025,"devouring":39505,"canaen":18504,"que":8360,"martial":4275,"span":6534,"intimate":10715,"attacker''":48831,"debuted":16350,"psu":43945,"culling":36527,"anneliese":45583,"newar":28815,"vulcan":20248,"serbocroatian":28692,"tko":24734,"heja":36666,"wpac":47036,"ameliorate":39725,"nom's":49645,"gringo":33552,"sheikh":17496,"unplug":29699,"vitriol":17291,"inherent":7335,"sadads":43515,"overwhelmed":17110,"dan's":33648,"croix":45724,"kampf":14484,"mere":2563,"armour":13071,"backscatter":37680,"hyped":39337,"judgmental":20941,"loyalties":37225,"bastion":23184,"bandera":27346,"borne":15528,"classifying":16030,"will":44,"sector":7810,"aerials":38612,"tage":26644,"constitutions":20963,"cub":23863,"effecting":38366,"youbollocks":3743,"whitelisted":43601,"от":40294,"naji":35257,"drew":6577,"enrique":24284,"fowl":25403,"burke's":28223,"phuket":39762,"internation":37096,"correct":364,"chateau":33925,"nielsen":19427,"enemy":3449,"'most":29150,"understood":2116,"clue":2952,"conjectural":45933,"conjectures":39005,"needling":41161,"toes":10824,"snl":45893,"cohesion":27030,"summer":3114,"strikeout":30434,"misinforming":23442,"sufferers":16669,"tzm":31104,"hd":5591,"ə":22051,"invested":10619,"rescuers":17933,"kibo":34737,"breckinridge":28768,"errant":11659,"cro":24239,"researcher":6093,"i've":144,"rump":33998,"manmohan":46343,"albanians":3987,"mindy":43010,"beverage":23635,"abusive":2617,"wikipedia":28,"seb":13640,"chekava":43659,"sources'":19813,"aikijujutsu":44107,"gregalton":13919,"metropolitans":49053,"curses":37441,"principled":48554,"corm":27371,"compton":25065,"heavenly":19280,"'there":18476,"undesired":24403,"zope":28892,"prakash":33529,"england's":21643,"g'day":14254,"trinity":7772,"spain's":27061,"encyclopedias":5857,"impractical":15311,"only":77,"latino":10038,"thorny":46045,"editers":33774,"f's":34435,"rescinded":19875,"mom's":13164,"expressive":34096,"spock":33129,"loophole":17731,"disengaged":44940,"basc":37416,"chamber":7651,"mediawiki":6681,"dalrymple":44877,"rewritten":2793,"gg":6131,"nlt":26136,"jai":27027,"subjugation":32321,"dragong4":47919,"leatherhead":49602,"pirin":28276,"sudan":11423,"banana":10420,"jean":5528,"ryū":49806,"goodwin":33380,"adopts":28896,"boxers":15796,"actally":43170,"reopen":12607,"lu":13818,"vg":16192,"supercharger":39780,"infbox":45971,"facists":14990,"misses":10806,"athenians":39078,"deepu":38876,"heveller":48139,"mew":12971,"illiterates":30606,"disp":40435,"validates":27282,"iscariot":42553,"what’s":19088,"pointlessly":30856,"culminate":45826,"iglesia":38164,"alloted":39563,"asking":902,"nasheed":41316,"extrajudicial":46686,"sian":33598,"auditors":33951,"gumbel":39475,"hal":9699,"recommends":12547,"leakage":29391,"arbitrator":9374,"norse":9042,"comes":827,"ambulance":36203,"residual":21704,"universalism":36071,"jordan's":26834,"baar":49096,"latex":32457,"unbias":39580,"maurice27":45383,"scoop":19777,"tuesdays":34927,"jan":2396,"ax":14328,"diversity":7073,"weaver":13201,"flora":16819,"contibute":42249,"facebooks":24723,"conspiracism":41081,"huffington":13205,"trivia":2484,"pack":5592,"falsified":12213,"climbers":35568,"marines":8053,"barbarian":14633,"sould":19728,"specifics":5987,"litters":19698,"subterranean":36872,"sem":27554,"exhaustion":41589,"tcm":17014,"satu":26417,"intelligible":19859,"navy's":40194,"eradicated":31082,"threaded":26727,"hogan":17769,"forbade":32670,"'war'":46529,"transformations":20319,"ambuj":30519,"mpg":41825,"heals":48252,"perversions":32134,"100px":41024,"derry":11136,"structured":8052,"alfred":9063,"jelly":33283,"sirius":30128,"picker":37509,"naja":44257,"contrast":3651,"lvatt":44829,"subsequent":3228,"clicking":1534,"directorate":29905,"curse":6961,"friggen":6670,"symone":40437,"revoke":16052,"spokespeople":38532,"seva":40262,"bodily":19799,"chatter":15817,"stonewalled":44382,"unlocked":12371,"inquire":13641,"mutuality":44322,"“wikipedia”":48844,"rockall":37166,"clark":7390,"fixable":31365,"hiberno":32171,"pak":17157,"latest":1851,"taino":21081,"sizzla":33738,"hurts":6485,"mufka":24832,"burgundy":24476,"yield":9462,"rafael":23972,"pumpkins":27930,"siafu":44616,"become":661,"neopaganism":36133,"revolutionary":6362,"crossing":8569,"foeticide":48466,"barclays":32030,"summarise":11002,"truncate":46719,"latvians":49244,"peerage":16215,"lieutenant":10262,"xxxx":12020,"launches":19025,"millennium":12503,"ruse":30267,"trophies":23355,"havin":35185,"checkered":39535,"rigby":28094,"sockpuppet's":41506,"sixth":8389,"commentary":2383,"jareth":33939,"concord":31192,"letterhead":42640,"upbringing":18621,"'legal":49104,"composing":15481,"peeved":48518,"ptolemaic":29834,"batman's":24776,"astrologer":14283,"moo":22577,"kyo":24293,"ramsay":46011,"lulu":18284,"psi":11682,"kneejerk":40071,"gentlemanly":44330,"paywall":24956,"shinda":38756,"scientifical":41962,"joachim":28460,"mayoral":33865,"dashrath":33545,"earhart":9098,"mongoloids":22461,"dolphins":21055,"mutations":15253,"allophone":40121,"moncrief":35024,"shine":12360,"aid":4404,"dalton":20064,"vandalism1":45180,"jeepers":45131,"nandigram":41466,"myriad":12618,"tempos":45622,"sitush":4139,"novanova":44363,"tray":40103,"bt":15060,"capitals":9532,"0n":46371,"obviate":36439,"loro":49994,"bully":3415,"spectacular":17864,"blockings":44773,"fairfield":21018,"canaan":28317,"amiga":20124,"karzai":47971,"shipment":48277,"homesick":27733,"retrospectively":39430,"una":14968,"patent":3692,"haynes":25767,"neurologist":31189,"gonzales":19988,"hakenkreuz":25360,"replicants":43853,"'096'''":26064,"altered":2005,"misquoted":13947,"rishabhcine":44753,"cornell":10040,"sidelines":26775,"inquired":34993,"kurabu":37261,"shamrock":33448,"whist":48453,"fetch":18070,"transfusion":28713,"boo":4716,"typeface":25449,"45th":36470,"tv":964,"harassment":1635,"ping":4571,"businesses":7414,"closures":26066,"delighted":9694,"it'll":3898,"policeman":17125,"hardcore":4511,"nagas":43474,"neighbor":12454,"equal":2054,"generality":42714,"parliamentarian":43265,"substitute":5935,"paltrow":32553,"torture":5712,"nationalism":3316,"sahara":8828,"aws":21578,"exiting":23998,"jumps":11652,"führer":37405,"struct":29252,"miroslav":35307,"revert":360," — ":34719,"suffering":5831,"multiethnic":30045,"allele":25919,"reviewer":3057,"hillary":9173,"til":10976,"needed'":21223,"hackney":13476,"windsor's":48358,"plausibly":41761,"'more":31608,"macht":47469,"jewel":16380,"haya":47179,"saber":42343,"registry":6588,"matter":335,"descr":43919,"medcab":34357,"axl":37038,"pkwy":46986,"memorandum":21561,"agebraic":41877,"peterburg":40671,"product":1543,"tedious":7628,"building's":43003,"serafin":44747,"epic":4845,"resistance":4436,"member's":26164,"outfit":15946,"margarita":42474,"runway":16895,"further":380,"peterborough":42784,"willbeback":48313,"wales":1474,"currencies":17089,"contractors":27820,"meditation":10427,"hole":3192,"padmasambhava":39496,"speak":885,"festival":4269,"kanye":17464,"clint":20200,"pages'":24444,"veera":27280,"·talk":28295,"suitcase":38089,"serva":24360,"kb":8737,"afl":9968,"deutsche":24531,"solo28":48362,"vegetable":19477,"pacificwarrior101":17734,"sherurcij":28759,"palette":37517,"cbt":44900,"blume":30671,"kang":40136,"drone":26392,"huggers":38608,"impertinent":37592,"beck":9078,"purposed":44627,"cuisine":6498,"heartedly":35975,"spee":38057,"mohammad":11330,"disabilities":16925,"anthropogenic":18992,"descends":40070,"kew":28907,"wass":43082,"ridicules":32071,"gate":7858,"pythia":34682,"diyarbakır":48880,"estrogen":35313,"fock":21386,"conveyed":12169,"absurdly":22097,"tis":18561,"executed":6569,"speedy":254,"proteins":15163,"godwin's":19532,"potsdam":19095," talk":4897,"whitch":45872,"finalist":27202,"refrained":14871,"shuttle":10239,"milborneone":29949,"player":2026,"amish":20020,"talk→  ":20723,"aus":16528,"flow":3281,"sharpton":21027,"alzheimer's":40280,"perfunctory":39457,"leggett":39739,"casualty":10011,"barrel":9588,"haskalah":34629,"complicity":29090,"someones":8640,"ruhuna":38348,"physics":2058,"commonest":39053,"wikiality":20430,"'n'":15613,"clio":15894,"fairytale":32213,"formulae":24090,"earl's":46337,"seville":36281,"didnt":2478,"narrative":4350,"unpleasant":7742,"2000s":13060,"remark":3303,"salaam":32227,"kom":47188,"iar":10199,"unexplained":9141,"zajdi":43055,"map":1120,"theos":40077,"that’s":7840,"tombe":26009,"shoe":10751,"nativity":24801,"vcite":42795,"usefull":14054,"tion":48283,"conflicting":6265,"ashton":34550,"refute":6369,"tracks":5297,"civilian":5123,"sweden":4563,"simpleton":29661,"human":774,"bluelink":40022,"pedantic":8895,"need":122,"sid":13170,"iso":8584,"nervosa":25388,"veneration":37739,"vinegar":25399,"youre":5248,"napoleon's":33062,"usually":861,"anatolia":11582,"mythic":29156,"vikings":16624,"0600z":19237,"miniseries":34785,"kenyan":22613,"simpler":6641,"shabiha":31942,"mindless":8891,"surpassing":34766,"stetson":37428,"spoke":3960,"henriette":41775,"deterioration":35451,"bedini":42542,"inevercry":23653,"'09":32455,"di's":13540,"delle":49997,"germanization":48067,"phds":17894,"cascades":37723,"я":16488,"߷":35699,"swathes":32249,"quotation":2998,"deployment":14256,"'soft":41191,"hyland":37745,"jury's":37997,"insincere":24071,"kbps":30845,"yiddish":11890,"statements":853,"ustasa":29310,"yemeni":24442,"fin":18378,"outraged":12756,"dunno":6361,"qi":19886,"insignis":22967,"vika":32926,"monkeyman":16468,"reconstructed":12709,"oder":25476,"cathedral":8423,"stocky":43270,"kickstart":27261,"'sign'":25429,"compression":11594,"accountability":10899,"desirable":6942,"justification":2473,"awe":17800,"liszt":33422,"retaliated":20305,"meni":47412,"somalis":41130,"repertoire":23687,"rank":4435,"bergman":45430,"sided":3884,"dinoguy2":49364,"appeals":6738,"szigeti":46180,"“a”":34443,"isa":22150,"windley":33783,"vios":38763,"natives":9045,"unpopular":12588,"wikpedia":9884,"whitewashed":22285,"lolicon":28703,"mercaz":45045,"herzog":29864,"darryl":36445,"havelock":48317," λogosπraxis":41819,"websites":1391,"sabino":36692,"developments":6630,"crimethinc":38683,"neverending":29930,"ordu":15829,"mixes":13937,"fucking":394,"fishery":39500,"swiftly":14345,"tipu":48736,"spread":1853,"sprevjane":37277,"porus":40061,"bible":2041,"motorcycles":16307,"inquest":23901,"amami":27349,"baptised":29212,"contribution":1238,"impudent":47284,"cholesterol":13224,"colonialism":14780,"wines":25148,"allegiance":6690,"amr":33485,"bahamas":26690,"shaolin":28422,"audited":39977,"broadband":16798,"insinuates":48022,"banged":30291,"deposed":23202,"girls'":30839,"structuring":23181,"crater":29204,"senkaku":28574,"enforceable":22983,"hare":22389,"nerve":7138,"sneakernight":38560,"cam":11114,"ourcolony":43559,"nwobhm":31287,"grenades":21204,"delinquent":37816,"grilling":40603,"ise":36181,"cello":16008,"businessweek":17726,"clayton":23474,"scrub":20086,"assists":20795,"sondra":28347,"vialls":26977,"tabtab":5988,"nero":22125,"etaonsh":45433,"snuggums":39797,"ataturk":18736,"o'kelley":35497,"n0":38328,"herpes":18893,"ekograf":36688,"confederations":37929,"maratha":13821,"yada":8434,"alphabetizing":46454,"scum'":39189,"członków":44237,"supper":21548,"regretfully":9486,"reinforcing":24625,"carthage":23531,"mephedrone":38856,"posting":1064,"why":75,"realclimate":21328,"untouchable":26826,"ulterior":12730,"mrm":23214,"hoffa":40983,"utd":45149,"fa09":47022,"flats":22781,"deque":43036,"enjoyed":5480,"blass":39114,"siphon":26311,"scarcely":19306,"jeweler":30218,"androgenic":38753,"alphachump":47443,"trapper":45364,"made":130,"pearce":32837,"messengers":28562,"murderer":8494,"linkfarm":28642,"underlying":5705,"codex":11999,"mormon":4952,"lesar":33038,"coroner's":29547,"semi":1630,"excellently":43556,"burke":12416,"tossers":40111,"penalties":19675,"polishing":24273,"bonuses":32294,"chernomorets":22005,"squids":27177,"fortunes":39212,"bosniakophobia":36870,"curtains":36053,"cia's":39381,"apostrophe":11269,"garnering":22912,"chaps":19574,"kiko":28379,"cha":15849,"scattered":10036,"insulation":27320,"ruffman":31708,"wilno":34667,"betweeen":41610,"waggers":30394,"minsky":43267,"arvanitika":20383,"custodian":37153,"whistle":10120,"humane":16667,"wainer":38733,"b's":24846,"70px":32395,"finisher":24236,"epithets":18637,"therefore":577,"bot":1091,"nostalgic":47769,"caste":3438,"gods'":32967,"regarded":2854,"snacks":28917,"pistols":18163,"indian":1176,"retrieval":48440,"alia":19689,"exaggerations":39361,"ay":19811,"alf":15379,"clarifying":5973,"invasive":21952,"skool":33929,"traders":22422,"garra":22811,"woman":1780,"authoritarianism":34066,"aetherometry":28244,"feldspar":18434,"hanoverians":44392,"grudge":8154,"additionaly":42669,"sarin":36111,"durin":13736,"rolf":22744,"mathematic":42288,"kingdom":1668,"motion":3877,"traveling":10434,"kot":48676,"labongo":20198,"insinuated":29969,"colmes":18094,"m4":30007,"sufficiently":4471,"nation's":16962,"tard":16530,"chitty":42481,"discover":4829,"decade":4586,"laying":12267,"lamont":19734,"—ryūlóng":39947,"thurber":48088,"'er":39461,"occur":3400,"brisbane":11463,"freepsbane":23561,"teaming":13785,"granddaughter":49353,"keita":45916,"peddling":25844,"pleasurable":30077,"proportionately":29317,"arabian":9810,"sand":6465,"albedo":43088,"blogosphere":20133,"basement":5883,"prosecutors":20584,"kikes":42028,"琉竜":19530,"belligerence":30762,"epicenter":29622,"'95":41740,"young's":41788,"elsie":30522,"kya":42477,"outbreaks":29206,"oneguy":20226,"akins":14823,"lar":15473,"alex's":31504,"retire":8290,"monmouth":31831,"khokhars":43702,"spatial":19056,"keilana":11534,"westboro":18681,"hebron":21669,"sarah":4370,"nowyouseeme":41570,"appropriate":479,"vivaldi":43005,"resp":29784,"rayvn ":33479,"disclaimer":6141,"mature":5573,"maximus":20551,"nuking":48023,"actors":3992,"reformatting":22490,"p25":49303,"retaliate":18424,"phylogenetics":25504,"indices":22996,"contradictions":10256,"junkyard":46354,"dominicans":20201,"venture":8102,"exhibits":11740,"malthusian":34379,"canals":37991,"hellenes":45466,"defamation":6019,"populated":8017,"beeblebrox":15988,"affidavits":33661,"40th":39299,"andd":44739,"wikid77":16001,"teamwork":17886,"chap":11153,"fron":27129,"chevrons":48497,"hurdle":19472,"check":296,"few":256,"orator":37858,"olfactory":49855,"blaming":8663,"charles'":33576,"unspeakably":39413,"90s":11043,"awkward":5963,"evades":33524,"husband":5998,"temperature":4758,"allopathy":35980,"counters":30491,"oh":378,"etihad":43792,"nation'":41165,"extradition":18590,"gladio":38180,"obstructive":20731,"carbonated":42923,"hanibal911you're":2553,"chaplain":21935,"submitdraft":32709,"zapruder":29953,"reprints":23726,"purchase":6584,"warfighter":46476,"fdffe7":18187,"contests":21590,"reviewer's":19601,"semitism'":39286,"rhythms":24978,"narrow":3925,"acts":2303,"не":23782,"editorships":46509,"megrahi":38440,"distributing":23786,"k2":43162,"fuckan":46604,"troublemaker":19161,"ue":11052,"sifted":41557,"tildes":837,"fsu":28405,"specifications":13383,"sports":2301,"brad":8771,"revisited":14951,"culture":922,"explaning":38241,"anarchism":6980,"denialists":15793,"wer":15298,"crummy":30158,"mining":9129,"signification":40833,"earls":35917,"wikipidia":28679,"isp's":44619,"popovashapka":39273,"sultana":43660,"marble":15635,"webster’s":41632,"wikibullying":46993,"sorta":13616,"zuck":9833,"maintainted":41943,"kerman":44699,"punitive":9350,"upton":33988,"beloved":7563,"sina's":48635,"•myears•mymouth":17624,"unison":27075,"react":6550,"inclusion":978,"valued":9296,"discriminate":13121,"umm":7330,"sir":1677,"lubavitcher":49639,"elim":47792,"scripted":21693,"ways":1250,"monounsaturated":43307,"petr":36267,"undent":24566,"breeding":8153,"webb":22138,"unregisted":47554,"benjitheijneb":28743,"shotokan":19231,"wary":11187,"distressed":22872,"unfathomable":33892,"mongo's":23534,"–'''''' ":16824,"leaks":19108,"wakefield":26680,"sco1996":48882,"weep":22340,"latina":24218,"rees":26001,"“spam”":39588,"newyorkbrad's":44649,"aegis":35973,"blagojevich":33659,"distract":13393,"muther":40134,"ur":1898,"centenary":32836,"squat":13795,"tesco":40766,"netsnipe":43725,"note":189,"amalthea":20478,"carbuncle":11834,"burrito":25709,"drawings":11591,"fuckface":20587,"zen":13395,"vanish":9940,"kastle":24252,"burlesque":36583,"pasquier":47462,"preface":11398,"realize":1393,"hurricane":5100,"vexillology":32867,"ayers":13072,"horrendous":12842,"challanged":43654,"x":977,"sheridan":30857,"weird":2800,"aym":18381,"couplings":46067,"zeybek":48100,"zhu":19351,"pinocchio":27984,"⋅":12484,"afshin":27382,"chimps":34251,"emerges":17393,"bohm":28329,"recieves":46503,"rohingya":45755,"vantage":35813,"twelve":7148,"neutrally":6517,"snuck":45633,"tort":9923,"impugning":40762,"forgeries":33040,"aruba":26861,"jimmy":3601,"aluminum":12926,"matisse":45295,"plc":28855,"multiracial":21188,"convicting":21577,"nadir":34958,"aladdin":31445,"cliches":31321,"lies":1224,"emotive":13278,"marian":21467,"vv":27650,"freckles":42192,"useful":630,"yee":29538,"piling":13526,"carlson":41285,"preamble":22100,"receives":9843,"veracity":8571,"yanked":44434,"100m":46938,"erosion":17660,"gaga's":46646,"fürst":39517,"wikipolitics":35676,"impenetrable":41928,"wishes":1939,"immediate":4064,"progrom":42628,"jew's":47364,"developers":8591,"ferret":19122,"responsiblity":34097,"konami":43167,"rediscovered":43737,"tagged":870,"bothered":2819,"galleries":11964,"bandicoot":33063,"viewed":3167,"chime":11597,"reversal":10833,"tralala":34659,"foist":27484,"sphinx":21274,"firts":49689,"flash":6222,"aggravation":28444,"sacrifice":7831,"collaboration":3431,"throat":10814,"reprehensible":16365,"preston":15505,"cjk":26825,"zoo":8977,"imbalance":17007,"nxt":27595,"commend":10885,"helm":23575,"unsure":5516,"punk":2747,"naturalized":29890,"golan":13165,"biruitorul":37115,"inquiries":16961,"forester":39407,"resemble":11975,"bushranger":24827,"tensions":21313,"foia":27615,"romances":26625,"waged":16932,"stansfield":43770,"impeached":47313,"dardanian":42181,"raul654":14240,"fuzz":31647,"driver":5919,"riders":12039,"frederic":19533,"subarticle":20601,"fragments":10373,"cuerden":43924,"edna":35641,"kfir":40585,"disturbance":20854,"inoculation":48812,"entering":6209,"rihanna":11446,"argh":19162,"pipe":7905,"infrequently":21288,"bodhidarma":47013,"good":98,"nakhichevan":17962,"hates":4987,"lithuanians":27687,"motorhead":48980,"donation":13036,"discerned":32027,"alps":21879,"borden":15563,"late":1341,"pluie":27144,"purposely":9231,"vitalism":26949,"meatpuppet":10391,"come":274,"batshit":34465,"spd":19972,"vichy":32808,"notibility":38997,"govt":7669,"genitive":24022,"scarce":16064,"overestimate":44727,"willful":15034,"rummel":24234,"macdonald's":42959,"riaz":32829,"nooo":48249,"bandung":42047,"recommend":1864,"lvds":39965,"hai":17287,"watt's":40870,"owen":12911,"erred":21810,"flaccid":39084,"bowyer":28596,"binary":10680,"articulations":37043,"hinders":25833,"woodrow":19913,"miloš":44606,"temple":3320,"sefton":42586,"vector":7674,"wanadoo":18130,"geraci":46164,"contradicting":8759,"wp’s":46521,"angela":5859,"makedonija":44779,"teller":19788,"mokele":19493,"amo":45644,"wookipedia":46448,"submission":2447,"physicist":8174,"cker":29687,"darpa":33751,"galaxy":7808,"bavarian":17603,"freaky":18309,"computes":45078,"chemotherapy":42443,"definitly":23193,"bother":1498,"intangible":24924,"duration":7329,"paragraph":622,"extrapolating":27854,"fuselage":22768,"capped":31596,"proofreader77":36919,"rotfl":41897,"proofread":15338,"stacking":17599,"bridgeport":33079,"sos":17975,"sagan":25875,"nowiki":29075,"nomination":1172,"grainy":33232,"nightly":47055,"vox":17460,"lupo":25519,"crafted":15441,"hanson":45580,"pinakes":45435,"fortresses":22975,"cleanstart":28621,"mistreatment":28674,"netflix":26384,"8'":24030,"werden":44572,"♫♫":23830,"membrane":16753,"characters":1270,"rhetorics":42518,"otaku":47616,"dublin":7952,"tango":17733,"beliefes":46620,"lust":15231,"honorverse":28296,"rfcs":13345,"grant65":46513,"muhammed":22548,"partitionist":32246,"whitening":45546,"stealthaccess":45329,"grok":40991,"sanskrit":6422,"diferent":22113,"ucla":22920,"progressives":24027,"cancelling":35610,"harm":2556,"sleuthing":38539,"faking":23359,"embarassment":18922,"slogans":19791,"'allegations'":49141,"teriipia":48248,"revere":21982,"solve":3307,"wei":22588,"railcar":46489,"um":4147,"waiver":45752,"ŧ''''''":45374,"cnn’s":49937,"donohue's":46160,"chopping":27962,"consummated":45094,"abramoff":18360,"technocrat":49287,"jezik":48968,"php":1295,"stinging":43032,"saints":6487,"privacy":3878,"steppes":39049,"grand":2183,"sino":13099,"want's":48506,"nilly":15003,"trotting":47828,"gmo":28138,"nationwide":15845,"wlc":42176,"hinting":19779,"acad":31273,"right":145,"costly":18572,"pj":16692,"advancing":12666,"shiithead":35106,"gig":11493,"businesswoman":44389,"20and":28131,"kings":3912,"vaginal":17452,"emulation":25226,"rving":33641,"drip":28893,"throughly":33391,"g8":17479,"generations":5207,"webcache":48898,"slandering":11617,"finality":40715,"appleyard":47240,"'jews'":46653,"resist":7693,"internal":2918,"clamp":34885,"filenames":32699,"boxofficemojo":24573,"veritable":26931,"lansing":16003,"wog":28958,"educator":18267,"tobacco":9294,"wiaga":19469,"grimm":26131,"parking":12784,"sidenote":28122,"incapacity":41842,"ceremonies":17713,"resubmitting":44508,"norway":5905,"nanking":26434,"biznitch":5443,"inadequacies":39443,"cesar":19279,"recapture":37597,"anger":4484,"unregistered":6602,"figure":1056,"smoothing":48638,"hiring":16313,"doctrine":4985,"issac":48532,"bzuk":21976,"distinctions":9504,"ruff":26755,"arteries":42237,"eris":49637,"hitler”":24615,"ptolemies":39446,"nommed":36802,"roofing":40713,"noses":22240,"shoop":42631,"deposits":19352,"telugu":7325,"blackcab":33320,"covering":4197,"agni":46397,"speculator":7844,"safi":29280,"pen":5734,"paine":25214,"italicized":11592,"shakspere":43062,"ppl":7386,"doughnut":22209,"reform":4134,"pol":13592,"mlpearc's":47729,"cag":23142,"partition":12406,"vu1kan":22041,"helping":1627,"materially":32291,"bb2":30529,"rootsweb":32882,"volunteer":3922,"synonym":8426,"circuitry":45258,"speeds":10354,"ym":30749,"dubya":19656,"blades":33019,"ninjas":25494,"civillians":47731,"broadened":27624,"edits to":49308,"mortarism":37556,"minding":19731,"mail":1364,"kimes":10956,"whatever":609,"sarfati":34077,"whence":22106,"grier":43452,"logicians":47093,"turner":9180,"kwa":28381,"texan":26979,"admonition":40817,"heptane":49707,"crohn's":46458,"remedies":12625,"3lw":28668,"hypersonic":38887,"lymington":43802,"ahole":34384,"chameria":11123,"suryoye":27755,"lotm":22555,"vk":20148,"nihilism":44763,"ruhr":36128,"cisosearchall":44200,"regain":15033,"westeros":46640,"genteel":44982,"anthro":31327,"journal":1863,"familiarity":11541,"vintage":24274,"mike's":30375,"exhibition":9738,"collectors":16843,"linkt":43835,"killing":2701,"heterodox":41834,"bjj":33565,"josephine":36151,"legwork":38017,"futuristic":28006,"zapatancas":39155,"perfidy":41915,"md5":44142,"alkivar":40083,"notifying":6116,"employ":8139,"than":93,"locker":28400,"sensing":24845,"majoring":48580,"bran":35970,"audible":40120,"minthreadsleft":42521,"sticking":5524,"displays":6751,"boris":13738,"threes":40819,"osborn":49138,"theta":15575,"unwiki":48051,"tyrone":37472,"volcanoes":13196,"cuffs":49644,"aromatic":46308,"modulus":39052,"sunglasses":32346,"methods":2761,"rud":35605,"expandable":45493,"reissue":39107,"immoral":14884,"horrendously":42384,"precedent":4867,"mabel":33378,"aitken":45719,"swastika":7263,"barito":47789,"sensation":21017,"rincon":39416,"purists":26376,"1b":11927,"negotiating":28622,"tavern":30570,"tages":42976,"intend":2512,"coolest":18007,"muahahahahahahahahahahahahahahahahahaha":7847,"invading":9768,"translate":3183,"iris":24315,"tunnels":18417,"yugoslavian":29714,"legalistic":21344,"marianne":48804,"spammers":12635,"precedence":8567,"page'":13231,"buds":21943,"old":353,"inre":45069,"hakka":27012,"kilt":44935,"imprints":38105,"ymb29":35096,"frg":29800,"asserted":5411,"portrayals":27472,"webcam":32021,"geoffrey":16651,"hafiz":33997,"outnumbers":41210,"guerisons":45957,"ballbag":40989,"mara":23720,"bond":6416,"cir":46790,"m193":49782,"sprewanen":33885,"aoi":46148,"'person'":45897,"maitreya":31625,"jamesbwatson":10467,"anthems":20848,"above":253,"i'am":13105,"illiterate":7656,"cooperation":3800,"mosasaurus":38821,"fromt":39864,"pitchfork":23305,"jewishness":22597,"expressways":31630,"reputation":2528,"f5faff":25764,"barbarossa":19331,"bischoff":40529,"bookmark":28643,"beckley":46936,"vpr":45334,"fatwas":49286,"booing":47684,"welp":48806,"rug":20136,"subtypes":47375,"ŋ":44299,"vandalize":679,"genealogical":13418,"yepes's":19718,"ceased":8762,"becritical":39830,"sealand":16963,"shoes":9900,"rectangular":22854,"cry":3521,"jingoist":44664,"hill's":46907,"anderson":7047,"alternatively":4326,"reassessment":10051,"nicky":28387,"graeme":17877,"eyebrows":30607,"sasha":29008,"quida":39454,"nv":28630,"job":785,"gabrielfoto":47547,"leader's":25931,"elucidation":48697,"shania":30577,"herewith":28678,"hdtv":33154,"kilo":36683,"butting":17685,"mcdonnell":38191,"enigmaman":6936,"redux":16893,"bean":16278,"screenplay":17981,"oliveira":35910,"narrowing":30903,"discourages":14625,"brighten":36142,"statutes":19593,"breein1007":35787,"scorpions":24343,"jeannine":43181,"maligning":47268,"unobtrusive":36210,"definiton":26058,"edzard":45506,"factories":17605,"reccomend":24627,"sparsely":32320,"брайен":41725,"con":5348,"mpt":25732,"agapetos":30553,"dancer":15398,"northernmost":44125,"untenable":22496,"transaction":19080,"somethings":17671,"aardvark":17598,"shortened":6645,"buh":40008,"loosely":8960,"christchurch":18929,"harvest":14820,"sncf":23152,"brunswick":16376,"autopsy":14194,"resurrecting":35091,"thwart":19309,"rollins":49046,"depleted":23915,"tb":16709,"zap":26653,"wolof":23475,"ellicott's":44171,"completely":562,"struggling":9030,"re":337,"enjoyment":14387,"appointed":4186,"typology":28514,"anwar":29191,"regeneration":23948,"stations":3716,"batches":39069,"hematology":25633,"isch":38403,"weaponized":43427,"ugric":23145,"commonplace":15036,"cornelius":26922,"´¯¯":26973,"excused":17847,"cindy":16295,"uploader":6974,"raphael":21324,"salomon":44591,"filipinos":16686,"knack":29826,"attempting":2022,"thoughts":1459,"compounds":9106,"untreated":47287,"horus":46853,"wrestlemania":8931,"assisting":15305,"dupont":22797,"leningrad":26432,"misunderstands":40178,"barangay":20142,"manifestations":22379,"applaud":13930,"keynote":35585,"gael":42348,"mugging":39144,"gunny":45531,"cruiser":30613,"redactions":47882,"facist":10290,"fowler":15922,"aroused":22046,"laborious":24680,"troublesome":11724,"sides":1951,"million":962,"blackmailing":41542,"donnie":35095,"descriptions":3656,"byu":17338,"slovakian":40955,"monetary":7495,"tev":33449,"assessed":6025,"ruin":5286,"doctrines":10308,"♣":7721,"maoist":21519,"citd":49376,"hinton":39313,"psychologist":13005,"uncovering":29525,"constituents":24775,"enumeration":30485,"kgb":14055,"cjcurrie":23791,"gather":4660,"scum":3848,"contributors":1720,"sandra":20997,"rice":2369,"resulted":4117,"wikinfo":16007,"nation’s":33980,"websense":35265,"kulkarni":40059,"forging":18348,"sarvagnya":23045,"kapoor":26682,"operas":23533,"iup":31050,"gnp":41496,"byzantine":6694,"niue":31363,"rumoured":35867,"talibans":34848,"accomplishment":13908,"gillard":31586,"strapped":37049,"×":15048,"collier":26370,"retarded":2263,"contributor":1891,"derex":14907,"xfd":21917,"joannina":48057,"outlooks":34876,"elect":9881,"crimes":2689,"anus":8650,"oscillation":36375,"'super":48215,"espn":8297,"derek":8945,"slimvirgin":6625,"motorways":29810,"t0":29551,"cccc":37775,"alex":3831,"skopje":14193,"segmented":48086,"breaches":10580,"madonna":10010,"statesman":15694,"life":300,"lgagnon":13206,"charlemagne's":43221,"skomorokh":19960,"coheed":46627,"patronising":15026,"sparring":31650,"awaited":26972,"dodged":35601,"runner":11893,"elitism":14111,"scientific":994,"environmentalism":39891,"paramore":25194,"aagadu":40319,"ching":30177,"evil":1899,"gonzoe":34611,"ramos":35960,"upstream":24601,"millionaires":47445,"greenpeace":28299,"req":47237,"prof":4754,"a™":40743,"estimates":5167,"kraft":25079,"ferns":45647,"brahmoism":46757,"goering":42287,"cyclists":33549,"nash":12920,"feng":45903,"aliens":8899,"swarm":16377,"barbecue":49407,"wof":31951,"went":764,"opas":31638,"jacob's":49886,"addition":793,"tự":35669,"noodle":24597,"cbs":6172,"antarctic":34436,"incompetence":8944,"digress":15260,"converting":9290,"built":2218,"feller":47539,"huraira":33956,"israel":1083,"rams":25321,"analyse":17019,"estes":44510,"twists":23393,"casts":13049,"dissappointed":45556,"insulting":2349,"civilians":5022,"1200z":25122,"kshatriyas":11313,"hdmi":33575,"viola":20328,"diagnosing":43486,"solutrean":37666,"brahmo":15147,"nine":4628,"settled":3483,"daveryanshow":41042,"norwich":21393,"bunt":33882,"mcmahon":14314,"captive":26929,"neater":20267,"shocks":38884,"championed":30500,"trapped":13910,"conducts":42005,"triggers":23738,"waging":27179,"join":1404,"pms":28956,"ll":8183,"tripped":47544,"crimea":11882,"hereby":5483,"banding":45267,"attributes":8247,"spare":5636,"evolutionists":18656,"refill":47361,"dual":6224,"markmysoe":32715,"twerp":40163,"starvation":34504,"scalia":31907,"indulge":12980,"havent":4367,"skirmishes":32544,"prodego":24881,"librarian":10697,"yourname":37294,"hex":20129,"kapil":38678,"talkspace":49834,"weathermen":30755,"enters":13770,"trad":31927,"streisand":32791,"uppity":31580,"their":92,"perverting":32656,"principals":20350,"karadžić":45369,"unloved":45782,"spheres":11437,"annals":15437,"bouncer":37854,"appendices":40007,"lid":21021,"testament":6792,"downloading":18347,"wrestlecrap":38541,"grimaldi":37537,"sudra":37782,"dula":44227,"phightins":25681,"appreciable":35325,"hybrids":30868,"feliz":43261,"grover":39802,"fresh":3805,"erotica":22316,"affairs":4393,"strong":1171,"trottel":46317,"tyvm":42052,"league's":19458,"cds":12030,"itself":550,"obvioulsy":48327,"rube":32516,"northern":1629,"marskell":38225,"yanksox":23360,"lighting":9735,"snowballing":49705,"sun":2479,"gohan":24788,"litem":37272,"sympathizer":20792,"cheryl":42404,"innovate":44661,"offsite":26279,"department":1941,"chats":26102,"divulge":25176,"estimated":5922,"pats1":20310,"counts":3860,"academia":6631,"banerjee":41664,"ovation":36423,"italy's":28024,"jinx":39984,"cirrhosis":49546,"specimens":21426,"dolt":32340,"mahon":43701,"bentley":32676,"marathon":14986,"t·c":12259,"apologizes":20943,"pilger":49551,"freeze":20738,"rosina":48237,"magdalene":27359,"solzhenitsyn":37357,"teo":35583,"macleod":41594,"nuevo":45274,"monasteries":42148,"lazy":3339,"countires":49701,"archaeologists":13771,"touted":28694,"plunkett":41668,"goldman":18193,"perceive":6406,"aswell":9218,"pope's":17093,"solaris":21528,"unconventional":16948,"customarily":31265,"wan":15430,"dalbury":35865,"homegrown":43254,"metaphor":12439,"generic":3924,"invokes":37614,"yangtze":44266,"berean":35202,"technological":12304,"persuasion":17954," ajaxsmack ":39817,"egg":2986,"boy's":25033,"time'":25691,"proclaiming":18505,"gvhy":18585,"povfork":32162,"differently":3767,"gurch":18166,"imposter":16088,"tailor":32996,"achmednut321":41352,"picard":20302,"rivals":15821,"agressing":32433,"fyslee":22638,"yayue":49082,"voltage":7910,"climbed":30877,"heinegg":34788,"nieln":49236,"graded":26557,"olive":11942,"ü":44284,"eid":38724,"café":36555,"12px":34791,"hoary":12459,"anachronistic":15882,"wesley's":39530,"rcti":32886,"alexanders":38269,"grr":36383,"purges":24213,"editwar":25140,"unedited":19497,"pacemaker":48607,"bit'":48458,"printsec":29098,"last":259,"mockup":45845,"landowners":49338,"kimchi":16905,"probabilistic":27480," ":29865,"g4":12284,"sawoniuk":27389,"c4":23085,"anywho":30152,"tack":17318,"guatemala":18208,"ifd":26194,"target":2590,"plastered":24418,"wellcome":28710,"epiphany":30738,"mathematically":13232,"astounded":33135,"bandied":48530,"older":2297,"lucius":39372,"bag":3375,"condolence":44853,"soundcloud":48101,"currency":5288,"ricard":49573,"agarwals":39752,"balkanfever":24438,"downer":34979,"chballer":42250,"aik":43819,"ourselves":5016,"lindawarheads":44028,"dees":19930,"shakes":32799,"blitzer's":42674,"cypress":38351,"bob":2121,"requesting":1060,"capri":12961,"vandalises":25337,"tudor":14528,"grandfather's":42149,"hitomi":47011,"bal":24538,"belonged":8581,"r":877,"410a":32584,"reaffirm":36598,"float":14209,"violins":40423,"cox":12710,"booksellers":49260,"negation":17329,"hypersensitive":39603,"abdel":30286,"lined":19434,"apologises":41486,"middleton":47190,"diddy":26476,"♠":12474,"hrs":14979,"hosts":11156,"celebrity":5677,"radicalized":45530,"authentic":5212,"bongwarriorcongratualtions":7719,"kshatryas":40979,"clemson":19271,"skewer":39803,"pussy":2077,"pop":1996,"tang":11389,"prophylaxis":46202,"inode":44517,"soy":26623,"fishermen":46940,"ecuador":17534,"meridians":35555,"cynic":42393,"wolfgang":15166,"suds":49759,"xplicit":24076,"shortcuts":20446,"coder":43870,"they've":2945,"cosmetic":16641,"embarassed":23465,"defies":21672,"uve":44669,"mural":28639,"given":339,"asad":25772,"ottoman":4286,"practise":12733,"quashed":27777,"csis":46576,"medeis":14755,"assyria":16937,"metallica":12052,"laissez":23629,"yoo":35074,"eureka":33691,"bla":10096,"button":2325,"cymru":26845,"surprised":1803,"laundering":22618,"blunders":35043,"kaufmann":39002,"susquehanna":44697,"retribution":16880,"smearing":17439,"fait":21780,"2m":28547,"nicki":19651,"fluorescent":48407,"all's":29764,"futurama":14178,"bibliography":5471,"requests":1253,"jackson's":11411,"absently":26240,"consists":5464,"juillet":37767,"swayze":30061,"formidable":30230,"reader":1117,"dewey":29683,"jerry":7582,"dept":9126,"attempt":855,"moni":27580,"steal":4797,"prosper":22472,"declare":4624,"pigmentation":43038,"grappling":32061,"calaway":38344,"prominently":8317,"posts":1075,"contribute":927,"dangling":25892,"paton":49351,"persuading":33188,"mathbot":29404,"islamophobe":49749,"terrible":3140,"jokestress":38154,"collapsed":7306,"exceptionally":18640,"decided":1033,"heartland":39867,"poeple":21595,"popo":38805,"rallying":35979,"alcoholic":14725,"shattering":20000,"opportunistic":22764,"immigration":6725,"fluid":8713,"thyme":37091,"xviii":41305,"embarked":22223,"foggy":29357,"kin":18318,"varsovians":42367,"celebrates":17610,"expelling":31077,"facial":13172,"concentrations":26444,"themed":21733,"incite":11524,"spay":46769,"jodi":45370,"din":9112,"raus":34727,"nyhan":47818,"suppressed":7878,"habla":25581,"simplification":16379,"seiken":46115,"seperates":40883,"2pp":38250,"dairy":13449,"maxwells":33689,"perinçek's":35791,"excepting":23508,"snark":19081,"accelerator":22853,"comparisons":6372,"doesn´t":20357,"plumber":25641,"pisses":12998,"sublime":30535,"—•":27905,"spank":31086,"ddd":26495,"enterprises":20046,"tabeastern":23136,"martinphi":38583,"downgrading":20473,"stuttgart":32047,"vandalizing":1692,"crocodile":22945,"seconds":3246,"raphael1":37821,"fuel":4249,"revelation":6614,"converge":35816,"carole":45999," · ":26377,"derrick":29685,"published":569,"cj2005b":39259,"diederich":34140,"insensitive":19671,"michels":49123,"nameplate":47405,"ellison":21023,"ancestors":4809,"roughly":5202,"departure":7950,"impedance":21169,"screw":4299,"bale":26122,"notability":467,"gentile":16240,"amerindians":39806,"childishly":20287,"barbera":30462,"walls":6900,"marina":18667,"edward's":28704,"slower":12866,"fools":5695,"'social":44665,"sourceforge":24986,"budget":6175,"huddersfield":22723,"man'":36414,"lk":7643,"aboard":18729,"occurrence":9475,"ballsack":32336,"treatises":33282,"qutbi":18755,"reinserted":11570,"ermland":47920,"deadmeat":42376,"nic":12671,"pucci":14813,"carefull":21645,"enlighten":9252,"migrants":25754,"habitable":28315,"bp":9544,"condon":46663,"paperwork":18108,"empted":45340,"pluralistic":47713,"situated":11099,"transphobia":24583,"prevalence":11322,"file's":5791,"psychopat":48257,"ages":3968,"julia":11618,"hoffman":22283,"generalized":10695,"gymnastics":30941,"synthesizing":28732,"dreaded":14035,"informations":7560,"fai":30357,"kratos":26490,"debasing":37606,"'delete'":38422,"elegance":30367,"sogenal":34494,"taylor":5312,"borisoglebsk":38851,"commended":25475,"besides":1529,"see":64,"askolnick":23763,"noncontroversial":49237,"ovo":47454,"sprot":43425,"wishing":5244,"knocks":44409,"credulity":44542,"studying":4823,"pins":20839,"supplements":20324,"suppressing":9146,"accused":1515,"flag":1478,"handsome":19747,"howto":31317,"afterwards":5496,"eko":42103,"judiciary":14700,"colleagues":6891,"crat":31514,"gaza":5356,"houdini":24045,"closeup":31171,"ancient":1434,"outlets":6062,"plucked":38481,"spartacus":34318,"blower":33893,"lilly":39157,"sideaway":47130,"perverse":16265,"bbb23's":35351,"celsius":45675,"sickle":30481,"monte":17676,"d2":27565,"onepage":8546,"kamehameha":33345,"prayer":8058,"annex":21966,"nvidia":12700,"faggot":608,"shooter":18001,"text'":29552,"webster":9668,"jingiby":21301,"mcb":40264,"orsini":42385,"sick":2021,"accomplish":5810,"alfvén":48402,"diki":29102,"myatt":41410,"beam":11305,"shopper":43722,"y's":34282,"entrant":28077,"southampton":19316,"ankit":15179,"erroneously":9633,"'undo'":39941,"procurement":27538,"developed":2314,"song":1008,"afaict":40393,"reviewers'":28237,"sympathiser":37126,"methamphetamine":27530,"wordings":18937,"claymort":36645,"sciencewatcher":41587,"commitment":7531,"muddies":47068,"encrypted":30200,"offenses":12227,"eval":36264,"metaphors":21340,"lucia":37371,"richards":10137,"nummbers":31330,"greed":13257,"humankind":26866,"portrait":5650,"rog":36751,"disorder":4722,"explanatory":9043,"tenebrae":22380,"slouch":48001,"rtv":32868,"kollias":41306,"chaser":17451,"wmo":45091,"moody":19215,"evils":20493,"tampering":13687,"conciliatory":34162,"tweeted":27956,"eliza":29432,"confidentiality":22259,"narking":32150,"reintroduced":21522,"twelver":31394,"belgium":9868,"talk·edits":32608,"ponte":41108,"furnace":41206,"minimizing":20714,"terminator":15490,"debacle":17811,"tparis":28394,"alledged":23865,"spiritually":27418,"ukip":11894,"dett":46349,"feral":14315,"parkerson":43783,"unavoidable":15612,"scrupulous":34062,"fggt":2089,"participates":41095,"persona":12197,"scratchy":43912,"neoclassical":19135,"mongolia":9775,"covenantd":45527,"phrase's":45083,"it’s":3979,"rescues":43670,"mallory":33277,"katt":37920,"sail":11874,"monetarily":45674,"cheers":670,"histmerge":25624,"amren":41110,"wigger":16014,"zoological":20044,"milton":8798,"truthseekers":27015,"separatists":18608,"chichester":28123,"paintings":8213,"cher":30490,"brentwood":44161,"elective":12996,"assembly":4916,"remedy":7570,"recruited":12945,"apart":2240,"haul":23592,"bsg":39619,"certifies":35021,"romanize":40404,"pa":5437,"fables":30386,"untranslated":40230,"regions":3371,"rewarding":14027,"paris":3547,"miyokan":18730,"agent":4087,"tactical":11698,"that's":205,"theft":7436,"grants":9385,"sana":34770,"kinky":31461,"chucks":43851,"bohemia":18406,"reactos":48239,"zino":33769,"yale":8307,"counseling":18161,"signficant":42131,"maclean":34514,"document's":37609,"frets":39547,"languange":28044,"mobilized":28019,"supervised":18909,"trustees":13110,"stamina":45200,"jpgordon":10745,"tmi":47762,"vii":9512,"tofu":48384,"riots":6061,"budgets":20531,"phonological":30959,"wringing":43418,"radiotherapy":42104,"lab":5630,"maximise":40952,"fibrosis":22642,"skunked":39985,"ascribed":18936,"yeshuwa's":41429,"eschew":34354,"aquired":34981,"underconstruction":49234,"powder":14124,"eligible":6836,"discontinuation":40576,"interestingly":8518,"tanked":44719,"heidegger":16352,"enix":23819,"owb":36908,"toxicodendron":38155,"cancer":3814,"wellington":12968,"teachings":5266,"anita":18216,"party":591,"brimming":49003,"bionicle":29706,"grossly":7080,"“son":37903,"disown":39673,"commented":2750,"adios":18474,"beasts":18451,"rousseau":31097,"alyssa":27482,"kid":2334,"alexis":22452,"rationalism":33878,"pc":3588,"reputations":22084," satori":46536,"isso":41515,"jingoism":30028,"hour":1869,"concensus":5607,"unimpeachable":28158,"howstuffworks":44962,"subcutaneous":38662,"gay":456,"incensed":37214,"consulate":26926,"aggrieved":30933,"partnerships":18595,"film's":10436,"infact":7274,"rupert":17391,"sounds":1160,"blockd":41357,"vader":25540,"quiz":15964,"dreadnought":18294,"aurora":22322,"disreputable":35654,"speculate":9773,"galati":49872,"spacemusic":44234,"judge’s":48684,"defences":31674,"dickheaditalic":24386,"mla":22892,"effectively":3691,"slap":4942,"slanderous":8648,"bestseller":27550,"you'd":1105,"yl's":44001,"encyclopaedic":6710,"buts":33453,"tested":6138,"acupressure":38912,"avars":24437,"aurangzeb":12126,"memberships":30131,"barrett's":26246,"weve":29860,"baxter":28120,"poodle":24725,"preppy":36516,"trivialize":35445,"marcion":41999,"broadcast":4702,"waded":32815,"secretive":20491,"fayssal":24610,"temazepam":40631,"bork²":49240,"bessarabia":17354,"impotent":16423,"proclaimed":6655,"economy":3282,"freezer":1705,"neat":8150,"ventura":30383,"1900s":25762,"ipblocklist":33678,"kr":27912,"triplicate":47269,"nwpl":46716,"fuc":12289,"unsuccesful":49057,"jfw":27592,"uncreated":28330,"spry":34811,"sensual":30706,"witze":44300,"mule":22835,"qian":46996,"warlord":33383,"validation":10928,"weren’t":32051,"hans":7379,"x11":42360,"fleet":6946,"coexistence":39061,"bundle":12640,"squirrel":15144,"cartesian":25706,"correction":3368,"vishwanathan":40863,"suzie":31344,"markham":18262,"dial":14643,"'right":37717,"φ——":46510,"row":4842,"paintbrush":32024,"eurovision":9389,"ub":20760,"councils":10724,"stalling":25976,"fortification":31508,"creativity":10720,"plant":3782,"roran":31240,"referece":40075,"legazpi":38792,"cuntface":41319,"」":48754,"displaced":14354,"hardship":22901,"holistic":18646,"od mishehu":36022,"democratic":2453,"nexus":36058,"descussion":44758,"chingiz":44024,"countryman":48306,"bloodbath":42231,"dumbledore":28737,"redirect":471,"bangla":17328,"frames":9712,"lenses":15762,"ascent":33796,"manchester":4912,"engl":47915,"nameless":30315,"lengthened":23327,"archaic":9978,"squeak":16944,"jadeyomiel":46491,"krab":46368,"robbery":12802,"kennels":42831,"amblin":37682,"prey":13287,"licencing":28100,"sacrificing":24981,"young":1604,"bridge":2868,"secunderabad":47541,"tkd":17106,"suburban":8534,"slavonia":39374,"lifeboats":37434,"lse":45932,"depended":23171,"mcjeff":46874,"untainted":40086,"dated":3428,"cordial":20891,"shag":46880,"rocks":7724,"stupidity":4926,"clairsentience":11445,"freakin'":15609,"scharf":40652,"independentist":48672,"depicted":8508,"finances":18579,"euclidean":30766,"variance":20777,"amin":32086,"lastly":4057,"lapse":20785,"wpvg":44777,"canned":19163,"unaffected":32624,"checkpoints":47341,"sustainable":11530,"pitt":24222,"their's":26260,"individualized":49740,"unicorn":24592,"delt":33674,"glanced":23834,"çolon":47393,"restricts":32248,"arguments":995,"medcom":31343,"relief":6850,"turn":1437,"vandilising":36406,"barra":32288,"uncontroversial":8322,"flaunting":42483,"peanut":15252,"zipzer":32931,"presumably":3348,"helmet":11646,"kleagle":18765,"sourses":47276,"boycotts":38311,"gutierrez":29360,"cap":7005,"sockets":33521,"ranchi":37436,"restorative":37101,"cosmo":30994,"nomads":18468,"emulated":29031,"fck":38378,"snowolf":40092,"lmfao":16885,"globo":38578,"goodman":23341,"weaknesses":11723,"abusing":2363,"disappointed":5663,"subjugated":43913,"thereabouts":30027,"rorschach":20278,"theguardian":43397,"impolite":12748,"theist":30840,"autowikibrowser":30144,"afrika":30141,"havre":36429,"emit":23615,"cranston":45607,"smelling":32039,"0000":34187,"nazi's":13786,"readily":6438,"festive":39103,"intra":26966,"nishi":41917,"grams":27441,"fixer":34175,"saddam's":16243,"reinstall":47513,"spokesmen":46873,"donegal":35062,"f1":10476,"dai":14827,"aɪm":46675,"sincere":5118,"thinkers":10990,"hls":32864,"carefully":2025,"írísh":25368,"earth":1271,"construe":21613,"omar":13347,"costing":28975,"hissed":46121,"australia2world":34147,"darkened":36805,"omnigan":44332,"pentagram":25756,"deuce":37359,"rbis":32163,"gerard":12744,"philatelic":46998,"drs":33693,"realy":10008,"macquarie":38014,"favoritism":24983,"shlomo":23299,"happyme22":34010,"excursion":25063,"usatoday":26964,"unita":43978,"jeni":33935,"bugbear":47043,"yeager":39994,"reviews":1767,"“i”":45080,"barnett":32166,"être":43080,"clustered":46402,"sidewalks":46862,"sri":4233,"plagues":36894,"battalion":8274,"sevres":46522,"speaker":3676,"untruths":22886,"grats":39491,"aviator":31324,"buses":10900,"gerald":17503,"appliances":29378,"maintains":10444,"terryeo":22919,"glossaries":45154,"swayed":17840,"shrill":44503,"ronan":27838,"programmers":14914,"rights":835,"appellation":23446,"bee":6939,"munching":24569,"beautifully":16038,"emulate":25529,"  vesey":49628,"copyright":246,"solved":4143,"brandonyusuftoropov":46638,"dads":22298,"hewitt":23111,"medmos":40834,"alloys":37797,"demonstration":9582,"crankshaft":40777,"nextgen":44481,"shortest":13143,"erhard":26817,"disciple":22201,"guadalupe":35847,"blockade":12099,"kurdistan":8023,"flogged":30680,"tricks":6632,"destination":9836,"whistlersghost":44586,"dirtball":42201,"kubo":41033,"standardised":36497,"wcau":28880,"004":30139,"heroism":48751,"augmented":22632,"alexbrn":35672,"inseparable":37127,"corvus":26683,"cps":29579,"cardozo":38879,"financier":40345,"responsibility":3405,"abcnews":23942,"reaffirmed":36711,"infernal":25381,"absense":40172,"icing":29755,"clinics":38173,"sd's":42099,"4am":45626,"smackdown":7981,"σ":19479,"cbbc":34088,"lr":16002,"casa":39132,"thanx":7896,"unearth":28535,"teammates":35156,"klein's":25024,"'sock":25201,"mugs":34936,"racialism":41162,"daedalus":19543,"surgical":12953,"feline":45053,"dumped":12105,"topic":440,"excavated":29275,"দ":26707,"scurrilous":30689,"digitally":28687,"construed":6279,"men'":35415,"dawg":20281,"tty":44362,"emphases":41710,"childhood":6455,"offline":6173,"columbo":43310,"affiliate":16935,"trilogy":15806,"whihc":32702,"combine":7046,"maneuvre":39653,"damage⁄berate":35246,"superstar":10235,"itool":29349,"chomsky":11335,"belchfire":44633,"ukexpat":20519,"exasperation":40771,"afrinic":21113,"commanded":14684,"rosalind":48148,"giggle":27435,"krimpet":30800,"sari":43407,"mattress":46284,"'common":30907,"apologised":12620,"cockpit":25650,"hah":12367,"bullying":3500,"sourcing":2142,"xerox":33695,"linus":32427,"pescetarianism":38635,"tame":32631,"stare":17705,"reformed":12698,"advantageous":24511,"indivisible":48009,"cemetary":44408,"propriety":18624,"a340":24265,"sun's":31109,"studied":4163,"pantheon":39046,"pursue":4746,"sadie":23837,"pip":46987,"40k":43933,"experimental":6167,"linden":41634,"finalised":24938,"spout":18791,"chimp":22517,"seeds":10460,"helen":7983,"exercising":16120,"gonna":1658,"sharmila":8726,"tohei":38841,"infinitesimals":31709,"depo":29806,"salsa":13488,"ndson":48513,"av":10158,"knuckles":25606,"sutra":22342,"fourth":3106,"ashit":18768,"confiscation":34198,"narconon":31843,"snag":32600,"escalating":11301,"blithely":27743,"quick":1251,"groningen":39208,"prev":5979,"intentioned":9453,"dick":810,"panbanisha":44207,"exploits":14973,"vi":7065,"oooh":14260,"condom":18963,"critisize":30668,"personalizing":39229,"collate":46770,"disgust":10117,"jayne":43646,"infuriated":48776,"brooke":18303,"reftest":37588,"pearson's":37848,"vanuatu":28338,"oversees":32913,"ucs":29698,"famine":9092,"estonia":12435,"luciano":23242,"bassoon":46942,"seems":208,"keith":5578,"swat":11997,"repaid":38598,"sholom":34618,"chapters":6855,"newco":39007,"oneness":27990,"lashing":28032,"ben":2910,"atari":38615,"fabric":15868,"scones":41654,"cameras":9531,"to'":33178,"canceled":13977,"halen":24207,"agra":39183,"minimizes":49494,"tfc":44064,"overlink":33504,"absurdities":48564,"metalworking":49939,"falsely":4047,"harsher":27152,"acosta":24377,"pear":21865,"mcafee":45224,"loads":7269,"enslavement":27281,"glimpse":20247,"retail":10666,"reloaded":20450,"baptise":44111,"jay316":28527,"pollen":34862,"nobhead":43508,"overlong":35992,"leave'''''' talk":36479,"brace":31493,"18th":5981,"nsbr":25483,"hwa":44930,"winnings":48814,"utensils":29395,"pianist":13142,"matthias":48097,"soriano's":46662,"inglourious":46076,"drunks":41830,"forgave":41539,"propagandists":9951,"raid":5568,"raju":21480,"fluoridation":23548,"wilberian":48553,"ici":14037,"prevailing":11119,"mckinsey":38952,"cranes":44159,"bit":387,"autoblocks":12734,"preying":48606,"anyhoo":22721,"crediting":22219,"toussaint":48208,"government'":40488,"šufflay":35031,"freer":26704,"sen":15372,"ismail":14063,"garibaldi":29229,"painters":19571,"promotes":3885,"soke":38840,"record":874,"userright":17203,"newspeak":48956,"nobility":9429,"temper":6996,"extend":4826,"individualist":16609,"truth'":47116,"oslo":30435,"norris's":10789,"mean":278,"quiddity":42350,"cheats":21825,"transhumanist":16712,"micro":10372,"omega":4893,"fr":4527,"hullabaloo":43849,"magluta":46422,"'ol":43504,"nothing's":37067,"silliness":11422,"fas":8917,"shipped":22404,"sra":30999,"annihilated":38691,"targetting":32992,"correspondents":23387,"calendar":4848,"persisting":20999,"legislation":5764,"yisrael":32602,"senegal":20019,"richmond":9370,"mould":30474,"leaps":25343,"reunion":21030,"evidentiary":34793,"botanists":21416,"authoritative":3989,"credits":4318,"landon":32701,"stumbled":7559,"modes":12395,"bunts":31181,"ten's":45735,"acclaimed":17476,"amor":24279,"masatepe":37661,"photographed":14875,"gibby":23907,"recourse":10428,"dimera":33117,"horrible":3327,"krishnadevaraya":40667,"muck":17018,"urges":13389,"ingenuity":33958,"couldn't":1285,"authorship":7021,"caused":1774,"shorty":49120,"cus":14210,"sonics":42806,"saving":5024,"boze":44377,"unfold":23595,"firebombing":34234,"adhering":14655,"mediators":16557,"toynbee":36275,"flowering":23969,"cheaply":37563,"symposium":21875,"drafted":9986,"3b":32076,"variator":46097,"editable":17380,"plutonium":28978,"nepalese":18752,"disordered":30993,"bungalo":46969,"transfinancial":45402,"gilad":28045,"niche":12265,"circumspect":41893,"distros":26371,"idealist":42051,"abul":28033,"repelled":33527,"pandeist":45789,"flames":9891,"pacino":40987,"danmark":31099,"unattributed":24517,"pentium":39160,"magician":26016,"submit":2963,"darfur":40326,"oman":27996,"philology":41366,"indication":3678,"poet":7131,"autumn":15108,"constructive":1392,"endeavors":15633,"stefan":11861,"washed":9988,"cadaver":35571,"sometimes":972,"massively":11388,"personified":35146,"kautilya3":32765,"episode's":30912,"projection":10747,"insaaf":39329,"schneerson":49638,"b'nai":49050,"standards":1042,"goats":13075,"mrca":40663,"adminstrators":20153,"medina":21496,"on39m6v":48925,"carribean":30140,"unverifiable":6261,"isfdb":47515,"encouragement":8936,"mixtapes":27663,"ian":4092,"your":20,"resurrected":15015,"denial":3479,"lessheard":14136,"cafes":27488,"kingdoms":6329,"dog":1104,"philanthropic":35276,"forgetting":8455,"disambiguations":43777,"gorgan":22020,"slender":21154,"hime":24231,"souliotes":38582,"sesshomaru":20149,"declined":3198,"harami":37773,"timetables":30161,"ruler":7389,"safely":9949,"mri":41809,"chromosomes":17542,"ner":43953,"slim":6490,"incognito":43444,"navsource":41413,"ec0pave":43772,"sickness":13528,"actresses":12718,"csb":40407,"cylinder":16306,"ogg":9555,"hustler":28360,"rosiestep":31117,"frm":12685,"figment":30203,"hubert":27682,"murdock":29644,"pledge":5716,"i´m":14047,"hiram":23484,"beale":27272,"biggie":18281,"unit's":48929,"refreshed":19647,"tolerating":28133,"barr":21639,"din't":28188,"infrared":25855,"congresswoman":35924,"answere":21450,"ascertained":26496,"latinus":7174,"rapids":24462,"pairing":37559,"clarke":12563,"bazzajf":46778,"coords":21754,"opposing":3530,"davao":49848,"'special":48461,"pwned":17728,"emphasised":30213,"fen":44074,"ocr":46897,"bysa":20205,"weakness":10867,"torrent":16375,"rapes":10229,"enema":43911,"henceforth":21022,"sticks":8919,"unum":37654,"scooter":31375,"stems":9058,"dried":15213,"broil":41071,"wilkes":31207,"incompleteness":46022,"maliciously":7517,"dry":5723,"earthworms":33895,"multnomah":49440,"surge":22862,"revoir":49010,"s²":43095,"pixelated":45410,"terribly":6015,"undeletion":9547,"melchizedek":45114,"los":3908,"mabye":27866,"warden":21365,"unsupported":5360,"hounded":25568,"6m":37634,"song's":21684,"fishbase":31752,"amke":44317,"dccc":39944,"mbta":30002,"masreliez":43175,"anything":215,"badagnani":47266,"certified":7324,"alconetar":45273,"cud":31678,"dope":21280,"conventionally":25656,"magyar":28949,"brochure":8660,"melaleuca":45371,"revers":12244,"nobody":1101,"say":124,"snail":35334,"slandered":18337,"masse":16529,"minority":1838,"geez":13327,"demonizing":29659,"…stalk":34102,"prohibiting":14640,"trope":49158,"shenzhen":37430,"uae":19684,"abstentionist":35208,"colorblind":46839,"producer":4839,"honorifics":21292,"greensboro":37100,"charges":3093,"file":514,"taj":20759,"gerrymandering":26406,"purposefully":11873,"disproves":19589,"phosphorus":33313,"katelyn":44308,"eastside":44743,"t•c•":47601,"huxley":25563,"mep":34027,"500th":46026,"scrambling":26665,"funmobility":38865,"commercials":12950,"pulsar":35175,"shudras":28038,"watching":1587,"thelmadatter":45192,"se":3081,"recessions":43834,"misapplication":25190,"mhaskoba":27385,"twa":48222,"vidkun":46042,"watchlist":2669,"retcon":21971,"jps":13339,"inadequate":6862,"ryukyu":25605,"100x":30765,"mezo":23664,"cutler":23694,"skim":21143,"ww2":7589,"ninguém":24659,"perversion":18786,"rianna":35899,"debunk":20433,"buffy":17202,"nada":20697,"wikiquette":6718,"issdc":28961,"welles":36550,"bunched":36905,"allies":5302,"miley":10302,"appalachia":36213,"balloonman":41421,"moisture":24123,"wade":8758,"proposal":1388,"debates":4657,"fabulous":15161,"pinpoint":20194,"sideways":29088,"knob":5722,"charisma":22658,"trouts":33361,"pimped":40880,"stopfake":43069,"sportsman":36975,"gis":31209,"commonist":42781,"spruce":30572,"fail":1600,"lineup":20529,"believing":5431,"ridge":18726,"wikinazis":22258,"stabbing":19138,"laboratories":26606,"lester":30759,"inspirations":38095,"podiatry":41670,"fundemental":42258,"'til":10484,"seriosly":37385,"shahi":19893,"critics":2570,"confuses":8955,"wrongs":14067,"worker's":27361,"snarky":13938,"allen's":35902,"swindle":49887,"moreschi":27072,"egyptian":5028,"yoga":7158,"rhetorically":28539,"accorded":16437,"supposedly":3499,"union's":32422,"emailed":4655,"bn":22795,"visiting":5287,"syriacs":25549,"deltaquad":26589,"santilli":23900,"shiny":11658,"understands":6236,"styling":19239,"fdr":21884,"furnish":41911,"boosted":25630,"gibberish":7780,"selfs":33255,"modelled":23086,"shortness":32858,"אמר":34996,"mileena":40496,"circassian":39981,"emptying":39896,"vhdl":38799,"fx":41311,"anons":12461,"stv":45594,"approvals":30106,"discuss":519,"cast":2645,"forsake":48737,"congradulations":37715,"haruhi":44370,"advert":7727,"goofy":18112,"obnoxious":6985,"•":248,"errors":1638,"frosty":25036,"frauds":16894,"uncertainties":26981,"bigger":2885,"documents":2238,"pci":48790,"sideline":30425,"corollary":17640,"avid":14302,"sinking":12009,"rememeber":43060,"surmise":22868,"sexually":7852,"tfar":47156,"saipan":35392,"unitanode":43063,"lechmere":48322,"resign":8792,"gorlitz":48155,"backgrounds":9455,"encouraged":3477,"evola":34983,"painstakingly":20538,"materiel":41887,"invalid":4192,"relly":35546,"nickelodeon":18699,"applicable":3686,"ei":6624,"moline":21615,"expanded":2101,"foreign":1870,"florida":3810,"dx":15631,"altar":14539,"kernels":43661,"son's":20283,"naturalistic":34069,"silesia":9195,"sustrans":28594,"timurids":34925,"merriam":12231,"enhancing":16368,"stylings":45938,"rew":47033,"ng":10716,"reus":49664,"fairy":9423,"fad":20434,"certains":44716,"clarifications":10299,"harmonization":42749,"chagrin":42829,"toothpaste":35696,"sullied":46439,"jdchamp":21111,"rad":19627,"boast":18838,"mls":14350,"gacr":43178,"bob's":30622,"tinkering":23412,"aesthetic":9877,"oldwindybear":25694,"ernő":31367,"avi":16518,"problematic":3102,"raiding":21580,"application":2845,"rjb":22823,"auguste":25704,"semite":8279,"skepticism":10441,"derivatives":17972,"split":1832,"cupertino":48338,"asf":43019,"stunning":18390,"talked":3312,"pandora":44980,"pharmacological":48615,"more":57,"kalam":31634,"urblp":48743,"improv":49779,"monotheism":24676,"''":3266,"tippx":44133,"rah":43706,"champ":15938,"drama":3236,"marissa":44644,"loader":40102,"teddy":14133,"comparatively":16374,"dont":454,"melanie":18223,"'file'":18427,"philippineslong":2304,"advisable":14941,"descendent":42114,"justices":19468,"king's":8370,"simply":298,"shen":35259,"jna":45570,"sigs":24780,"pulmonary":28479,"fluently":20521,"professed":19256,"lange":19470,"carroll's":43113,"whoopsie":45764,"grandchild":26014,"hoards":32694,"critical":1805,"inbox":22192,"celticwonder":18779,"ignorants":33930,"colours":6813,"rcu":28098,"milburn":15588,"westminster":11348,"hass":33625,"slurp":39378,"redness":49682,"deskana":20557,"introductory":6673,"moist":23319,"liftoff":31657,"prevails":24216,"toeppen":20991,"scripture":8616,"afterlife":26147,"vom":45283,"alonso":19739,"4th":3788,"jhang":43146,"stifled":32761,"φ":24396,"amenities":31202,"correlates":24770,"poets":12983,"side'":46230,"symptoms":6428,"choirs":41683,"italian":2015,"lip":10717,"neumann":19169,"updating":3463,"earns":21641,"plants":5257,"intercept":29886,"glider":36985,"salad":29731,"artists'":22626,"ncsy":45166,"blantantly":40662,"rapist":9732,"backfire":32259,"jumper":39950,"munster":28459,"shrinks":32464,"illegals":27134,"blinded":13459,"coolac":28910,"competed":13875,"bwv":33169,"discreet":49530,"nuke":12589,"serena":29294,"iii":3182,"memories":6998,"talkin":18549,"emi":21728,"derided":48271,"collaborateur":37234,"maduro":20187,"introduces":11565,"perfectly":1567,"caroline":18402,"peru":9434,"identifications":42725,"redemption":12029,"persa":36624,"her's":46123,"halifax":26249,"unwelcoming":36433,"response":590,"sebenico":37648,"invites":14916,"hypnotic":36838,"fateful":39297,"peninsula":7215,"leash":22467,"hermitage":38437,"toney":29963,"misstatements":36764,"affiliated":4387,"asada":47912,"altogether":3866,"harbor":11468,"spleen":34975,"incubator":11726,"— aldebaer⁠":49831,"orgasm":14487,"ceases":19473,"sensors":18852,"landfill":29920,"reflection":6311,"boobs":2450,"unlink":28063,"radially":33500,"prodigious":39986,"weak":2559,"sidney":22215,"anyday":31994,"stabilize":42034,"footballers":13304,"cdc":11211,"mfm":29162,"presses":12104,"topology":11924,"dispersion":26555,"trotskyist":31420,"hissy":21380,"hkk":44194,"hall":3065,"pubdog":36640,"loblaws":44220,"arne":39735,"catchphrase":24211,"impossibility":17150,"nigg":47070,"thermal":11051,"globalization":14869,"intervals":12390,"cannistraro":17530,"represents":3287,"leeches":42771,"artificial":6508,"homophobe":17116,"badminton":27063,"dental":11990,"upn":30796,"insted":37167,"altenburg":43638,"biatch":24995,"sentate":42859,"difficulties":6658,"lifespan":18844,"tryptofish":31085,"alexandrite":47530,"unlimited":10851,"depopulation":24199,"singora":38032,"150k":33684,"micropolitan":31485,"partisans":8476,"discovery":4344,"owing":13889,"386th":32524,"opinionated":7056,"announcing":14705,"gurgaon":49914,"discredits":24470,"scholarships":27871,"downward":17993,"（talk）":32243,"sox":9540,"notice":419,"fuckheads":44384,"lacks":3901,"albany's":46449,"tiso":36493,"prepubescent":17469,"heavyweight":11210,"tbeatty":18658,"follow":683,"creepy":9783,"kaiser":26562,"emphasized":11217,"public":521,"buy":2662,"zzz":48483,"coping":32930," wer":47647,"neer":40331,"marilyn":12332,"en":455,"friedman":13103,"wmd":14325,"causa":26174,"rutgers":24962,"opportune":38033,"fanbase":17367,"gwern":20974,"dj":7587,"realises":35860,"stumbling":37627,"erik":10050,"ripple":25582,"scold":42620,"transporting":25703,"keyhān":49757,"helenonline":18697,"crimson":15842,"imagines":34547,"interlanguage":43548,"wounding":39720,"undertook":36140,"belittle":15693,"swears":28409,"israelite":30441,"16m":40395,"ticking":17941,"candor":37311,"adolph":19701,"winnington":31901,"pricks":13957,"gasp":19208,"pakistan's":30237,"reversion":3139,"dumbass":4454,"ahlm13":48296,"jokes":4727,"dillema":39541,"handedness":28233,"chord":16290,"cdp":18740,"benton":22120,"trm":25926,"usable":6966,"cush":29308,"trajan":48879,"convergence":14518,"vanity":5616,"koala":31301,"'a":8456,"bearing":4856,"quaid":46348,"conducive":16543,"tomica":30217,"fresno":33173,"incarnations":17776,"monarchist":34340,"castor":37310,"goings":24061,"doctorate":12434,"tampered":20712,"freshman":18785,"imo":2826,"wily":32139,"returners":41472,"lloyd":8911,"baskerville":44008,"tooltip":36074,"kuwaiti":29786,"n24":38845,"humorist":46316,"redthoreau":38668,"addhoc":38090,"vba":49033,"lina":29629,"guts":9490,"boia":38463,"arnt":36520,"sympathetic":7181,"chasing":12485,"watchlists":13909,"ghurids":35783,"20caste":38176,"channel":2095,"sketch":8921,"kthx":34135,"optimization":33271,"squeakbox":11539,"accidentaly":48944,"occupants":48559,"innovator":39154,"btu":47673,"pilate":31337,"jfk's":43993,"mewtwo":38607,"multitudes":46309,"amtrak":26994,"'an":21004,"nineteen":17986,"emerson7":45584,"displacement":13666,"leia":44684,"maldives":16608,"shopfront":39109,"tombs":23866,"addresses":2489,"nazism":6835,"womens":25557,"minutiae":22879,"kachin":44924,"insults":2883,"eighteen":22045,"unfolded":26577,"reports":1590,"•wicke":39910,"spaniards":10941,"decoration":18426,"again'":49375,"retaliatory":20471,"molecules":14718,"bloating":44410,"phillipino":47896,"tnx":32850,"dar":12755,"pie":5815,"jdorney":16448,"heaps":25430,"planner":45408,"surpass":29870,"cerin":23551,"milton's":17127,"j3mrs":35926,"wetpaint":43918,"considerably":6221,"ponging":41702,"hillman":22685,"contributions":322,"extolling":36144,"citizen's":29474,"freemasonry":8348,"satisfying":11483,"risky":19655,"part'":36230,"kalarippayattu":29376,"gmc":14204,"continually":4029,"documentingabuse":31078,"counselor":39649,"kushell":45262,"whatsindia":36139,"shrunk":28084,"canwest":29546,"brawls":44388,"cut":1325,"popularly":21732,"saiyan":27847,"melee":26833,"encouraging":5901,"marker":8800,"sarkeesian":36312,"wander":24535,"bartle":45579,"incompetent":6386,"kade":19895,"knowles":25310,"deconstructive":37392,"fragmentary":34471,"ziplocal":37328,"kelley":17402,"united":620,"tia":20266,"k":1373,"hdi":20918,"yung":35941,"trolled":16115,"naff":40089,"hawaiian":8151,"equinox":19710,"rani":22665,"connecting":9368,"fallujah":31380,"philately":29314,"seas":16363,"editor":262,"independently":6365,"vocalists":32036,"paperback":19426,"ceuta":31875,"''''''talk":15471,"citizenship":4534,"13th":7467,"caltech":29438,"favourite":5903,"brian":4159,"feign":36644,"eq":39613,"forbes":6596,"pusher":9233,"depict":10360,"world's":3445,"ronin":35431,"agreed":1256,"dubbed":13359,"bartlett":20074,"vand":38412,"sorry":263,"crucible":47376,"teng":34281,"screenname":44047,"plasmas":40535,"disarmed":24945,"humppa":25710,"carpathian":45176,"involvment":26639,"nitwit":24107,"deum":44871,"household":11858,"reproductive":13757,"enabling":11193,"sve":47455,"telia":38798,"coren":15646,"interrupted":12652,"varicella":43979,"suspicion":6060,"onka":12556,"åland":40886,"fanzine":23240,"butler":15774,"ihl":40259,"10pm":41786,"competing":7709,"samurai":18326,"theologies":41259,"pronouncement":43363,"enduring":13007,"pss":39253,"tomes":36616,"decency":7895,"eastbound":16939,"χ":34866,"research'":21625,"manor":12268,"coffee":4603,"srx":49712,"45px":22637,"reproduces":40680,"timeline":3965,"withdraw":5239,"example":320,"vendramini":43984,"revel":33325,"spic":33752,"enric":29990,"chah":31680,"equals":7127,"predated":25304,"descriptors":20282,"niggardly":26969,"prob":11828,"rusty":16680,"tapes":11558,"batangas":38786,"mindsets":48315,"childless":48893,"lake":3414,"closedmouth":25877,"messrs":32364,"bookstore":23230," talk":39319,"macaw":38611,"depreciated":49953,"orgies":44688,"usc":13037,"committee":1728,"eyes":1467,"misguide":35608,"equipped":10243,"haida":29948,"breed":4719,"pula":31903,"timor":17657,"multicast":38117,"denominations":11430,"literally":2644,"eradication":38533,"itm":41239,"graphic":5560,"meadows":23317,"asparukh":31003,"popularized":14490,"decks":39571,"offerings":15691,"barelwi":21897,"kazakhstan":15872,"uncontrollable":39444,"doctoral":12098,"iceberg":25057,"lookout":25216,"near":1356,"mikefromcanmore":43730,"cane":27048,"culver":43107,"activists":6118,"reinstating":15918,"reassessed":27714,"cricketer":16509,"kent":7610,"ostrovsky":33073,"determination":6424,"interpreter":17238,"ww1":15165,"counterfactual":31545,"resides":13923,"myboba":43610,"talk • contributions":46992,"everquest":36946,"'o'":42929,"harvesting":27294,"characterisation":21609,"bock":47191,"skip":7510,"darwinian":17083,"neoconservatives":38985,"impulses":24536,"backer":35405,"contravention":18696," blanchardb ":30782,"put":201,"ase":36533,"motherland":21771,"cardinal":10124,"confirmed":1740,"coefficients":23513,"jidf":21904,"shut":1188,"'sources'":46208,"concerted":14229,"lamm":25250,"tags":697,"redtigerxyz":20274,"get":96,"improvised":31411,"thetik":42698,"heater":26393,"balance":2204,"tzetzes":44233,"metz":41489,"princesses":22509,"archived":2748,"m8":22800,"snitty":37927,"snob":32149,"certification":11630,"involved":575,"troubles":7164,"squirrels":36897,"harald":22072,"sspx":43907,"feeble":13843,"yamal":37029,"paeonians":43624,"delegates":11928,"deleter":23740,"googling":8654,"variations":6417,"shorten":10560,"american's":24651,"waist":18472,"appealing":5603,"midnightblueowl":37023,"appeal":2144,"ribbon":15345,"blah":3076,"corrections":3335,"ubi":31299,"refugee":9647,"comedy":5718,"lace":45646,"indulged":23598,"gimbutas":37221,"paedophilia":30326,"excruciating":35551,"opted":13082,"boomer":42915,"far":315,"jeremy":8156,"aberdeen":36277}

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("/vk-apps-tensorflow-example",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl="/vk-apps-tensorflow-example"+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.d8e2288c.js